// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"ccjB4":[function(require,module,exports) {
/* eslint react/jsx-filename-extension: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactDom = require("react-dom");
var _routes = require("./routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
var _semanticLess = require("../semantic-ui/semantic.less");
(0, _reactDom.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.BrowserRouter), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _routesDefault.default), null)), document.getElementById("root"));

},{"react":"6AiW6","react-router-dom":"bzU9l","react-dom":"3q3jV","./routes":"lv8nT","../semantic-ui/semantic.less":"dEhb4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6AiW6":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"725uy"}],"725uy":[function(require,module,exports) {
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = require("f790cf940e488cc5"), n = "function" === typeof Symbol && Symbol.for, p = n ? Symbol.for("react.element") : 60103, q = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, t = n ? Symbol.for("react.strict_mode") : 60108, u = n ? Symbol.for("react.profiler") : 60114, v = n ? Symbol.for("react.provider") : 60109, w = n ? Symbol.for("react.context") : 60110, x = n ? Symbol.for("react.forward_ref") : 60112, y = n ? Symbol.for("react.suspense") : 60113, z = n ? Symbol.for("react.memo") : 60115, A = n ? Symbol.for("react.lazy") : 60116, B = "function" === typeof Symbol && Symbol.iterator;
function C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, E = {};
function F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = E;
    this.updater = c || D;
}
F.prototype.isReactComponent = {};
F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function G() {}
G.prototype = F.prototype;
function H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = E;
    this.updater = c || D;
}
var I = H.prototype = new G;
I.constructor = H;
l(I, F.prototype);
I.isPureReactComponent = !0;
var J = {
    current: null
}, K = Object.prototype.hasOwnProperty, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)K.call(b, e) && !L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: J.current
    };
}
function N(a, b) {
    return {
        $$typeof: p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === p;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g, Q = [];
function R(a, b, c, e) {
    if (Q.length) {
        var d = Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > Q.length && Q.push(a);
}
function T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case p:
                case q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + U(d, k);
        g += T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + U(d, k++), g += T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error(C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function V(a, b, c) {
    return null == a ? 0 : T(a, "", b, c);
}
function U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}
function W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? X(a, e, c, function(a) {
        return a;
    }) : null != a && (O(a) && (a = N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(P, "$&/") + "/") + c)), e.push(a));
}
function X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace(P, "$&/") + "/");
    b = R(b, g, e, d);
    V(a, aa, b);
    S(b);
}
var Y = {
    current: null
};
function Z() {
    var a = Y.current;
    if (null === a) throw Error(C(321));
    return a;
}
var ba = {
    ReactCurrentDispatcher: Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = R(null, null, b, c);
        V(a, W, b);
        S(b);
    },
    count: function(a) {
        return V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!O(a)) throw Error(C(143));
        return a;
    }
};
exports.Component = F;
exports.Fragment = r;
exports.Profiler = u;
exports.PureComponent = H;
exports.StrictMode = t;
exports.Suspense = y;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(C(267, a));
    var e = l({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)K.call(b, h) && !L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: v,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: x,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return Z().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return Z().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return Z().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return Z().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return Z().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return Z().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return Z().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return Z().useRef(a);
};
exports.useState = function(a) {
    return Z().useState(a);
};
exports.version = "16.14.0";

},{"f790cf940e488cc5":"aDLYt"}],"aDLYt":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"bzU9l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserRouter", ()=>(0, _browserRouterDefault.default));
parcelHelpers.export(exports, "HashRouter", ()=>(0, _hashRouterDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _memoryRouterDefault.default));
parcelHelpers.export(exports, "NavLink", ()=>(0, _navLinkDefault.default));
parcelHelpers.export(exports, "Prompt", ()=>(0, _promptDefault.default));
parcelHelpers.export(exports, "Redirect", ()=>(0, _redirectDefault.default));
parcelHelpers.export(exports, "Route", ()=>(0, _routeDefault.default));
parcelHelpers.export(exports, "Router", ()=>(0, _routerDefault.default));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _staticRouterDefault.default));
parcelHelpers.export(exports, "Switch", ()=>(0, _switchDefault.default));
parcelHelpers.export(exports, "generatePath", ()=>(0, _generatePathDefault.default));
parcelHelpers.export(exports, "matchPath", ()=>(0, _matchPathDefault.default));
parcelHelpers.export(exports, "withRouter", ()=>(0, _withRouterDefault.default));
var _browserRouter = require("./BrowserRouter");
var _browserRouterDefault = parcelHelpers.interopDefault(_browserRouter);
var _hashRouter = require("./HashRouter");
var _hashRouterDefault = parcelHelpers.interopDefault(_hashRouter);
var _link = require("./Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _memoryRouter = require("./MemoryRouter");
var _memoryRouterDefault = parcelHelpers.interopDefault(_memoryRouter);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _prompt = require("./Prompt");
var _promptDefault = parcelHelpers.interopDefault(_prompt);
var _redirect = require("./Redirect");
var _redirectDefault = parcelHelpers.interopDefault(_redirect);
var _route = require("./Route");
var _routeDefault = parcelHelpers.interopDefault(_route);
var _router = require("./Router");
var _routerDefault = parcelHelpers.interopDefault(_router);
var _staticRouter = require("./StaticRouter");
var _staticRouterDefault = parcelHelpers.interopDefault(_staticRouter);
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _generatePath = require("./generatePath");
var _generatePathDefault = parcelHelpers.interopDefault(_generatePath);
var _matchPath = require("./matchPath");
var _matchPathDefault = parcelHelpers.interopDefault(_matchPath);
var _withRouter = require("./withRouter");
var _withRouterDefault = parcelHelpers.interopDefault(_withRouter);

},{"./BrowserRouter":"3Ayp0","./HashRouter":false,"./Link":false,"./MemoryRouter":false,"./NavLink":false,"./Prompt":false,"./Redirect":false,"./Route":"QVfBr","./Router":false,"./StaticRouter":false,"./Switch":"ebqdV","./generatePath":false,"./matchPath":false,"./withRouter":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Ayp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _router = require("./Router");
var _routerDefault = parcelHelpers.interopDefault(_router);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = function(_React$Component) {
    _inherits(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _temp, _this, _ret;
        _classCallCheck(this, BrowserRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
    }
    BrowserRouter.prototype.componentWillMount = function componentWillMount() {
        (0, _warningDefault.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
    };
    BrowserRouter.prototype.render = function render() {
        return (0, _reactDefault.default).createElement((0, _routerDefault.default), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
BrowserRouter.propTypes = {
    basename: (0, _propTypesDefault.default).string,
    forceRefresh: (0, _propTypesDefault.default).bool,
    getUserConfirmation: (0, _propTypesDefault.default).func,
    keyLength: (0, _propTypesDefault.default).number,
    children: (0, _propTypesDefault.default).node
};
exports.default = BrowserRouter;

},{"warning":"1k6a2","react":"6AiW6","prop-types":"kKQPU","history":"9gy3E","./Router":"529Ua","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1k6a2":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"kKQPU":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"abQSW"}],"abQSW":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"k7T5U"}],"k7T5U":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"9gy3E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = stripHash(window.location.href);
        return href + "#" + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"jDQP2","resolve-pathname":"e0mBv","value-equal":"5LWi7","tiny-warning":"k7mOH","tiny-invariant":"jxX5U","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jDQP2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gGFzH":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"e0mBv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") spliceOne(fromParts, i);
        else if (part === "..") {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5LWi7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k7mOH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jxX5U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"529Ua":[function(require,module,exports) {
// Written in this round about way for babel-transform-imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _router = require("react-router/es/Router");
var _routerDefault = parcelHelpers.interopDefault(_router);
exports.default = (0, _routerDefault.default);

},{"react-router/es/Router":"aTZ9Z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aTZ9Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var Router = function(_React$Component) {
    _inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        _classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: _extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, _invariantDefault.default)(children == null || (0, _reactDefault.default).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, _warningDefault.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, _reactDefault.default).Children.only(children) : null;
    };
    return Router;
}((0, _reactDefault.default).Component);
Router.propTypes = {
    history: (0, _propTypesDefault.default).object.isRequired,
    children: (0, _propTypesDefault.default).node
};
Router.contextTypes = {
    router: (0, _propTypesDefault.default).object
};
Router.childContextTypes = {
    router: (0, _propTypesDefault.default).object.isRequired
};
exports.default = Router;

},{"warning":"1k6a2","invariant":"9iW8s","react":"6AiW6","prop-types":"kKQPU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9iW8s":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"QVfBr":[function(require,module,exports) {
// Written in this round about way for babel-transform-imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _route = require("react-router/es/Route");
var _routeDefault = parcelHelpers.interopDefault(_route);
exports.default = (0, _routeDefault.default);

},{"react-router/es/Route":"537BG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"537BG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _matchPath = require("./matchPath");
var _matchPathDefault = parcelHelpers.interopDefault(_matchPath);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var isEmptyChildren = function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var Route = function(_React$Component) {
    _inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        _classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: _extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, _invariantDefault.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, _matchPathDefault.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, _warningDefault.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, _warningDefault.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, _warningDefault.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, _warningDefault.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, _warningDefault.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, _reactDefault.default).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !isEmptyChildren(children)) return (0, _reactDefault.default).Children.only(children);
        return null;
    };
    return Route;
}((0, _reactDefault.default).Component);
Route.propTypes = {
    computedMatch: (0, _propTypesDefault.default).object,
    path: (0, _propTypesDefault.default).string,
    exact: (0, _propTypesDefault.default).bool,
    strict: (0, _propTypesDefault.default).bool,
    sensitive: (0, _propTypesDefault.default).bool,
    component: (0, _propTypesDefault.default).func,
    render: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node
    ]),
    location: (0, _propTypesDefault.default).object
};
Route.contextTypes = {
    router: (0, _propTypesDefault.default).shape({
        history: (0, _propTypesDefault.default).object.isRequired,
        route: (0, _propTypesDefault.default).object.isRequired,
        staticContext: (0, _propTypesDefault.default).object
    })
};
Route.childContextTypes = {
    router: (0, _propTypesDefault.default).object.isRequired
};
exports.default = Route;

},{"warning":"1k6a2","invariant":"9iW8s","react":"6AiW6","prop-types":"kKQPU","./matchPath":"3Hbwr","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Hbwr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;
var compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, _pathToRegexpDefault.default)(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if (cacheCount < cacheLimit) {
        cache[pattern] = compiledPattern;
        cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
exports.default = matchPath;

},{"path-to-regexp":"fupWn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fupWn":[function(require,module,exports) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : "[^" + escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"31GCU"}],"31GCU":[function(require,module,exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

},{}],"ebqdV":[function(require,module,exports) {
// Written in this round about way for babel-transform-imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _switch = require("react-router/es/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
exports.default = (0, _switchDefault.default);

},{"react-router/es/Switch":"hpT2q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hpT2q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _matchPath = require("./matchPath");
var _matchPathDefault = parcelHelpers.interopDefault(_matchPath);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = function(_React$Component) {
    _inherits(Switch, _React$Component);
    function Switch() {
        _classCallCheck(this, Switch);
        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, _invariantDefault.default)(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, _warningDefault.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, _warningDefault.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, _reactDefault.default).Children.forEach(children, function(element) {
            if (match == null && (0, _reactDefault.default).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, _matchPathDefault.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, _reactDefault.default).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, _reactDefault.default).Component);
Switch.contextTypes = {
    router: (0, _propTypesDefault.default).shape({
        route: (0, _propTypesDefault.default).object.isRequired
    }).isRequired
};
Switch.propTypes = {
    children: (0, _propTypesDefault.default).node,
    location: (0, _propTypesDefault.default).object
};
exports.default = Switch;

},{"react":"6AiW6","prop-types":"kKQPU","warning":"1k6a2","invariant":"9iW8s","./matchPath":"3Hbwr","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3q3jV":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"jqCaA"}],"jqCaA":[function(require,module,exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), n = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return n({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = n({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return n({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    r.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = n({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
n(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    n(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = n({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return n({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = r.unstable_runWithPriority, Jf = r.unstable_scheduleCallback, Kf = r.unstable_cancelCallback, Lf = r.unstable_requestPaint, Mf = r.unstable_now, Nf = r.unstable_getCurrentPriorityLevel, Of = r.unstable_ImmediatePriority, Pf = r.unstable_UserBlockingPriority, Qf = r.unstable_NormalPriority, Rf = r.unstable_LowPriority, Sf = r.unstable_IdlePriority, Tf = {}, Uf = r.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = n({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = n({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new aa.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : n({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = n({}, f, {
                    value: void 0
                });
                d = n({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = n({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj(n({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

},{"5393afc8c463ef07":"6AiW6","dc13beaf0535b548":"aDLYt","ece50e903283a22f":"3cnyl"}],"3cnyl":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"1ug47"}],"1ug47":[function(require,module,exports) {
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f, g, h, k, l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null, q = null, t = function() {
        if (null !== p) try {
            var a = exports.unstable_now();
            p(!0, a);
            p = null;
        } catch (b) {
            throw setTimeout(t, 0), b;
        }
    }, u = Date.now();
    exports.unstable_now = function() {
        return Date.now() - u;
    };
    f = function(a) {
        null !== p ? setTimeout(f, 0, a) : (p = a, setTimeout(t, 0));
    };
    g = function(a, b) {
        q = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(q);
    };
    k = function() {
        return !1;
    };
    l = exports.unstable_forceFrameRate = function() {};
} else {
    var w = window.performance, x = window.Date, y = window.setTimeout, z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof w && "function" === typeof w.now) exports.unstable_now = function() {
        return w.now();
    };
    else {
        var B = x.now();
        exports.unstable_now = function() {
            return x.now() - B;
        };
    }
    var C = !1, D = null, E = -1, F = 5, G = 0;
    k = function() {
        return exports.unstable_now() >= G;
    };
    l = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var H = new MessageChannel, I = H.port2;
    H.port1.onmessage = function() {
        if (null !== D) {
            var a = exports.unstable_now();
            G = a + F;
            try {
                D(!0, a) ? I.postMessage(null) : (C = !1, D = null);
            } catch (b) {
                throw I.postMessage(null), b;
            }
        } else C = !1;
    };
    f = function(a) {
        D = a;
        C || (C = !0, I.postMessage(null));
    };
    g = function(a, b) {
        E = y(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        z(E);
        E = -1;
    };
}
function J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > K(n, c)) void 0 !== r && 0 > K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var N = [], O = [], P = 1, Q = null, R = 3, S = !1, T = !1, U = !1;
function V(a) {
    for(var b = L(O); null !== b;){
        if (null === b.callback) M(O);
        else if (b.startTime <= a) M(O), b.sortIndex = b.expirationTime, J(N, b);
        else break;
        b = L(O);
    }
}
function W(a) {
    U = !1;
    V(a);
    if (!T) {
        if (null !== L(N)) T = !0, f(X);
        else {
            var b = L(O);
            null !== b && g(W, b.startTime - a);
        }
    }
}
function X(a, b) {
    T = !1;
    U && (U = !1, h());
    S = !0;
    var c = R;
    try {
        V(b);
        for(Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k());){
            var d = Q.callback;
            if (null !== d) {
                Q.callback = null;
                R = Q.priorityLevel;
                var e = d(Q.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? Q.callback = e : Q === L(N) && M(N);
                V(b);
            } else M(N);
            Q = L(N);
        }
        if (null !== Q) var m = !0;
        else {
            var n = L(O);
            null !== n && g(W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        Q = null, R = c, S = !1;
    }
}
function Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var Z = l;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    T || S || (T = !0, f(X));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return R;
};
exports.unstable_getFirstCallbackNode = function() {
    return L(N);
};
exports.unstable_next = function(a) {
    switch(R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = R;
    }
    var c = R;
    R = b;
    try {
        return a();
    } finally{
        R = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = Z;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = R;
    R = a;
    try {
        return b();
    } finally{
        R = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : Y(a);
    } else c = Y(a), e = d;
    c = e + c;
    a = {
        id: P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = !0, g(W, e - d))) : (a.sortIndex = c, J(N, a), T || S || (T = !0, f(X)));
    return a;
};
exports.unstable_shouldYield = function() {
    var a = exports.unstable_now();
    V(a);
    var b = L(N);
    return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
};
exports.unstable_wrapCallback = function(a) {
    var b = R;
    return function() {
        var c = R;
        R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            R = c;
        }
    };
};

},{}],"lv8nT":[function(require,module,exports) {
/* global window */ /* eslint react/jsx-filename-extension: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _amplify = require("./config/amplify");
var _amplifyDefault = parcelHelpers.interopDefault(_amplify);
var _dashboard = require("./dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
(0, _awsAmplify.Amplify).configure((0, _amplifyDefault.default));
const RoutingLogic = ()=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Switch), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Route), {
        path: "/:dashboardId",
        component: (0, _dashboardDefault.default)
    }));
};
exports.default = RoutingLogic;

},{"react":"6AiW6","aws-amplify":"aGGkJ","react-router-dom":"bzU9l","./config/amplify":"74uMJ","./dashboard":"h7n6R","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aGGkJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", ()=>(0, _core.Amplify));
parcelHelpers.export(exports, "Analytics", ()=>(0, _analytics.Analytics));
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _analytics.AWSPinpointProvider));
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>(0, _analytics.AWSKinesisProvider));
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>(0, _analytics.AWSKinesisFirehoseProvider));
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>(0, _analytics.AmazonPersonalizeProvider));
parcelHelpers.export(exports, "Auth", ()=>(0, _auth.Auth));
parcelHelpers.export(exports, "Storage", ()=>(0, _storage.Storage));
parcelHelpers.export(exports, "StorageClass", ()=>(0, _storage.StorageClass));
parcelHelpers.export(exports, "API", ()=>(0, _api.API));
parcelHelpers.export(exports, "APIClass", ()=>(0, _api.APIClass));
parcelHelpers.export(exports, "graphqlOperation", ()=>(0, _api.graphqlOperation));
parcelHelpers.export(exports, "AuthModeStrategyType", ()=>(0, _datastore.AuthModeStrategyType));
parcelHelpers.export(exports, "DataStore", ()=>(0, _datastore.DataStore));
parcelHelpers.export(exports, "Predicates", ()=>(0, _datastore.Predicates));
parcelHelpers.export(exports, "SortDirection", ()=>(0, _datastore.SortDirection));
parcelHelpers.export(exports, "syncExpression", ()=>(0, _datastore.syncExpression));
parcelHelpers.export(exports, "PubSub", ()=>(0, _pubsub.PubSub));
parcelHelpers.export(exports, "Cache", ()=>(0, _cache.Cache));
parcelHelpers.export(exports, "Interactions", ()=>(0, _interactions.Interactions));
parcelHelpers.export(exports, "Notifications", ()=>(0, _notifications.Notifications));
parcelHelpers.export(exports, "Predictions", ()=>(0, _predictions.Predictions));
parcelHelpers.export(exports, "Logger", ()=>(0, _core.ConsoleLogger));
parcelHelpers.export(exports, "Hub", ()=>(0, _core.Hub));
parcelHelpers.export(exports, "ClientDevice", ()=>(0, _core.ClientDevice));
parcelHelpers.export(exports, "Signer", ()=>(0, _core.Signer));
parcelHelpers.export(exports, "I18n", ()=>(0, _core.I18n));
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _core.ServiceWorker));
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>(0, _core.AWSCloudWatchProvider));
parcelHelpers.export(exports, "withSSRContext", ()=>(0, _withSSRContext.withSSRContext));
parcelHelpers.export(exports, "Geo", ()=>(0, _geo.Geo));
var _core = require("@aws-amplify/core");
var _analytics = require("@aws-amplify/analytics");
var _auth = require("@aws-amplify/auth");
var _storage = require("@aws-amplify/storage");
var _api = require("@aws-amplify/api");
var _datastore = require("@aws-amplify/datastore");
var _pubsub = require("@aws-amplify/pubsub");
var _cache = require("@aws-amplify/cache");
var _interactions = require("@aws-amplify/interactions");
var _notifications = require("@aws-amplify/notifications");
var _predictions = require("@aws-amplify/predictions");
var _withSSRContext = require("./withSSRContext");
var _geo = require("@aws-amplify/geo");

},{"@aws-amplify/core":"8BDOx","@aws-amplify/analytics":"174Sr","@aws-amplify/auth":"6Q2Bh","@aws-amplify/storage":"cox1w","@aws-amplify/api":"houml","@aws-amplify/datastore":"f78ey","@aws-amplify/pubsub":"13UKI","@aws-amplify/cache":"egrWR","@aws-amplify/interactions":"5ZNOP","@aws-amplify/notifications":"2txbR","@aws-amplify/predictions":"jJxJq","./withSSRContext":"hUBkl","@aws-amplify/geo":"iaWvL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8BDOx":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", ()=>(0, _amplify.Amplify));
parcelHelpers.export(exports, "AmplifyClass", ()=>(0, _amplify.AmplifyClass));
parcelHelpers.export(exports, "ClientDevice", ()=>(0, _clientDevice.ClientDevice));
parcelHelpers.export(exports, "ConsoleLogger", ()=>(0, _logger.ConsoleLogger));
parcelHelpers.export(exports, "Logger", ()=>(0, _logger.ConsoleLogger));
parcelHelpers.export(exports, "invalidParameter", ()=>(0, _errors.invalidParameter));
parcelHelpers.export(exports, "missingConfig", ()=>(0, _errors.missingConfig));
parcelHelpers.export(exports, "Hub", ()=>(0, _hub.Hub));
parcelHelpers.export(exports, "I18n", ()=>(0, _i18N.I18n));
parcelHelpers.export(exports, "browserOrNode", ()=>(0, _js.browserOrNode));
parcelHelpers.export(exports, "filenameToContentType", ()=>(0, _js.filenameToContentType));
parcelHelpers.export(exports, "generateRandomString", ()=>(0, _js.generateRandomString));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _js.isEmpty));
parcelHelpers.export(exports, "isStrictObject", ()=>(0, _js.isStrictObject));
parcelHelpers.export(exports, "isTextFile", ()=>(0, _js.isTextFile));
parcelHelpers.export(exports, "isWebWorker", ()=>(0, _js.isWebWorker));
parcelHelpers.export(exports, "makeQuerablePromise", ()=>(0, _js.makeQuerablePromise));
parcelHelpers.export(exports, "objectLessAttributes", ()=>(0, _js.objectLessAttributes));
parcelHelpers.export(exports, "sortByField", ()=>(0, _js.sortByField));
parcelHelpers.export(exports, "transferKeyToLowerCase", ()=>(0, _js.transferKeyToLowerCase));
parcelHelpers.export(exports, "transferKeyToUpperCase", ()=>(0, _js.transferKeyToUpperCase));
parcelHelpers.export(exports, "Signer", ()=>(0, _signer.Signer));
parcelHelpers.export(exports, "parseAWSExports", ()=>(0, _parseAWSExports.parseAWSExports));
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>(0, _providers.AWSCloudWatchProvider));
parcelHelpers.export(exports, "FacebookOAuth", ()=>(0, _oauthHelper.FacebookOAuth));
parcelHelpers.export(exports, "GoogleOAuth", ()=>(0, _oauthHelper.GoogleOAuth));
parcelHelpers.export(exports, "AppState", ()=>(0, _rncomponents.AppState));
parcelHelpers.export(exports, "AsyncStorage", ()=>(0, _rncomponents.AsyncStorage));
parcelHelpers.export(exports, "Linking", ()=>(0, _rncomponents.Linking));
parcelHelpers.export(exports, "Credentials", ()=>(0, _credentials.Credentials));
parcelHelpers.export(exports, "CredentialsClass", ()=>(0, _credentials.CredentialsClass));
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _serviceWorker.ServiceWorker));
parcelHelpers.export(exports, "StorageHelper", ()=>(0, _storageHelper.StorageHelper));
parcelHelpers.export(exports, "MemoryStorage", ()=>(0, _storageHelper.MemoryStorage));
parcelHelpers.export(exports, "UniversalStorage", ()=>(0, _universalStorage.UniversalStorage));
parcelHelpers.export(exports, "Platform", ()=>(0, _platform.Platform));
parcelHelpers.export(exports, "getAmplifyUserAgentObject", ()=>(0, _platform.getAmplifyUserAgentObject));
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>(0, _platform.getAmplifyUserAgent));
parcelHelpers.export(exports, "ApiAction", ()=>(0, _types.ApiAction));
parcelHelpers.export(exports, "AuthAction", ()=>(0, _types.AuthAction));
parcelHelpers.export(exports, "AnalyticsAction", ()=>(0, _types.AnalyticsAction));
parcelHelpers.export(exports, "Category", ()=>(0, _types.Category));
parcelHelpers.export(exports, "DataStoreAction", ()=>(0, _types.DataStoreAction));
parcelHelpers.export(exports, "Framework", ()=>(0, _types.Framework));
parcelHelpers.export(exports, "GeoAction", ()=>(0, _types.GeoAction));
parcelHelpers.export(exports, "InteractionsAction", ()=>(0, _types.InteractionsAction));
parcelHelpers.export(exports, "InAppMessagingAction", ()=>(0, _types.InAppMessagingAction));
parcelHelpers.export(exports, "PredictionsAction", ()=>(0, _types.PredictionsAction));
parcelHelpers.export(exports, "PubSubAction", ()=>(0, _types.PubSubAction));
parcelHelpers.export(exports, "PushNotificationAction", ()=>(0, _types.PushNotificationAction));
parcelHelpers.export(exports, "StorageAction", ()=>(0, _types.StorageAction));
parcelHelpers.export(exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", ()=>(0, _constants.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER));
parcelHelpers.export(exports, "USER_AGENT_HEADER", ()=>(0, _constants.USER_AGENT_HEADER));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", ()=>(0, _util.AWS_CLOUDWATCH_BASE_BUFFER_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>(0, _util.AWS_CLOUDWATCH_CATEGORY));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", ()=>(0, _util.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", ()=>(0, _util.AWS_CLOUDWATCH_MAX_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", ()=>(0, _util.AWS_CLOUDWATCH_PROVIDER_NAME));
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>(0, _util.BackgroundManagerNotOpenError));
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>(0, _util.BackgroundProcessManager));
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>(0, _util.BackgroundProcessManagerState));
parcelHelpers.export(exports, "DateUtils", ()=>(0, _util.DateUtils));
parcelHelpers.export(exports, "Mutex", ()=>(0, _util.Mutex));
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", ()=>(0, _util.NO_CREDS_ERROR_STRING));
parcelHelpers.export(exports, "NonRetryableError", ()=>(0, _util.NonRetryableError));
parcelHelpers.export(exports, "RETRY_ERROR_CODES", ()=>(0, _util.RETRY_ERROR_CODES));
parcelHelpers.export(exports, "Reachability", ()=>(0, _util.Reachability));
parcelHelpers.export(exports, "isNonRetryableError", ()=>(0, _util.isNonRetryableError));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _util.jitteredBackoff));
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>(0, _util.jitteredExponentialRetry));
parcelHelpers.export(exports, "retry", ()=>(0, _util.retry));
parcelHelpers.export(exports, "urlSafeDecode", ()=>(0, _util.urlSafeDecode));
parcelHelpers.export(exports, "urlSafeEncode", ()=>(0, _util.urlSafeEncode));
parcelHelpers.export(exports, "Constants", ()=>Constants);
var _amplify = require("./Amplify");
var _platform = require("./Platform");
var _clientDevice = require("./ClientDevice");
var _logger = require("./Logger");
var _errors = require("./Errors");
var _hub = require("./Hub");
var _i18N = require("./I18n");
var _js = require("./JS");
var _signer = require("./Signer");
var _parseAWSExports = require("./parseAWSExports");
var _providers = require("./Providers");
var _oauthHelper = require("./OAuthHelper");
var _rncomponents = require("./RNComponents");
var _credentials = require("./Credentials");
var _serviceWorker = require("./ServiceWorker");
var _storageHelper = require("./StorageHelper");
var _universalStorage = require("./UniversalStorage");
var _types = require("./Platform/types");
var _constants = require("./constants");
var _util = require("./Util");
var Constants = {
    userAgent: (0, _platform.Platform).userAgent
};
/**
 * @deprecated use named import
 */ exports.default = (0, _amplify.Amplify);

},{"./Amplify":"ayq1K","./Platform":"kna8f","./ClientDevice":"hkXub","./Logger":"jNW4z","./Errors":false,"./Hub":"cWAc9","./I18n":"iq9qd","./JS":"7JWuU","./Signer":"iPQUx","./parseAWSExports":"5Lf91","./Providers":"7P6WP","./OAuthHelper":false,"./RNComponents":false,"./Credentials":"jD5T8","./ServiceWorker":"9Aaan","./StorageHelper":"axKiA","./UniversalStorage":"d266z","./Platform/types":"8r55A","./constants":"e8Pvn","./Util":"4u1nR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ayq1K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyClass", ()=>AmplifyClass);
parcelHelpers.export(exports, "Amplify", ()=>Amplify);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("./Logger");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _logger.ConsoleLogger)("Amplify");
var AmplifyClass = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Notifications = null;
        this.Logger = (0, _logger.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else logger.debug("no getModuleName method for component", comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        logger.debug("amplify config", this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = __read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var Amplify = new AmplifyClass();

},{"./Logger":"jNW4z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jNW4z":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsoleLogger", ()=>(0, _consoleLogger.ConsoleLogger));
parcelHelpers.export(exports, "LOG_TYPE", ()=>(0, _consoleLogger.LOG_TYPE));
var _consoleLogger = require("./ConsoleLogger");

},{"./ConsoleLogger":"6MFok","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6MFok":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOG_TYPE", ()=>LOG_TYPE);
parcelHelpers.export(exports, "ConsoleLogger", ()=>ConsoleLogger);
var _constants = require("../Util/Constants");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var LOG_TYPE;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})(LOG_TYPE || (LOG_TYPE = {}));
var ConsoleLogger = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = LOG_TYPE.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = LOG_LEVELS[logger_level_name];
        var type_level = LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === LOG_TYPE.ERROR && console.error) log = console.error.bind(console);
        if (type === LOG_TYPE.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
        var message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = "".concat(prefix, " - ").concat(msg[0]);
            log(message);
        } else if (msg.length === 1) {
            message = "".concat(prefix, " ").concat(msg[0]);
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
            log("".concat(prefix, " - ").concat(msg[0]), obj);
        } else {
            message = "".concat(prefix, " ").concat(msg);
            log(prefix, msg);
        }
        try {
            for(var _b = __values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.INFO
        ], __read(msg), false));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.INFO
        ], __read(msg), false));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.WARN
        ], __read(msg), false));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.ERROR
        ], __read(msg), false));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.DEBUG
        ], __read(msg), false));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.VERBOSE
        ], __read(msg), false));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, _constants.AWS_CLOUDWATCH_CATEGORY)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();

},{"../Util/Constants":"2lMKs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2lMKs":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", ()=>AWS_CLOUDWATCH_BASE_BUFFER_SIZE);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>AWS_CLOUDWATCH_CATEGORY);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", ()=>AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", ()=>AWS_CLOUDWATCH_MAX_EVENT_SIZE);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", ()=>AWS_CLOUDWATCH_PROVIDER_NAME);
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", ()=>NO_CREDS_ERROR_STRING);
parcelHelpers.export(exports, "RETRY_ERROR_CODES", ()=>RETRY_ERROR_CODES);
var AWS_CLOUDWATCH_BASE_BUFFER_SIZE = 26;
var AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE = 1048576;
var AWS_CLOUDWATCH_MAX_EVENT_SIZE = 256000;
var AWS_CLOUDWATCH_CATEGORY = "Logging";
var AWS_CLOUDWATCH_PROVIDER_NAME = "AWSCloudWatch";
var NO_CREDS_ERROR_STRING = "No credentials";
var RETRY_ERROR_CODES = [
    "ResourceNotFoundException",
    "InvalidSequenceTokenException"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kna8f":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "getAmplifyUserAgentObject", ()=>getAmplifyUserAgentObject);
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>getAmplifyUserAgent);
var _types = require("./types");
var _version = require("./version");
var _detectFramework = require("./detectFramework");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var BASE_USER_AGENT = "aws-amplify";
var PlatformBuilder = /** @class */ function() {
    function PlatformBuilder() {
        this.userAgent = "".concat(BASE_USER_AGENT, "/").concat((0, _version.version));
    }
    Object.defineProperty(PlatformBuilder.prototype, "framework", {
        get: function() {
            return (0, _detectFramework.detectFramework)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformBuilder.prototype, "isReactNative", {
        get: function() {
            return this.framework === (0, _types.Framework).ReactNative || this.framework === (0, _types.Framework).Expo;
        },
        enumerable: false,
        configurable: true
    });
    PlatformBuilder.prototype.observeFrameworkChanges = function(fcn) {
        (0, _detectFramework.observeFrameworkChanges)(fcn);
    };
    return PlatformBuilder;
}();
var Platform = new PlatformBuilder();
var getAmplifyUserAgentObject = function(_a) {
    var _b = _a === void 0 ? {} : _a, category = _b.category, action = _b.action, framework = _b.framework;
    var userAgent = [
        [
            BASE_USER_AGENT,
            (0, _version.version)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, _detectFramework.detectFramework)()
    ]);
    return userAgent;
};
var getAmplifyUserAgent = function(customUserAgentDetails) {
    var userAgent = getAmplifyUserAgentObject(customUserAgentDetails);
    var userAgentString = userAgent.map(function(_a) {
        var _b = __read(_a, 2), agentKey = _b[0], agentValue = _b[1];
        return "".concat(agentKey, "/").concat(agentValue);
    }).join(" ");
    return userAgentString;
};

},{"./types":"8r55A","./version":"dMUNY","./detectFramework":"rZ1jz","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8r55A":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Framework", ()=>Framework);
parcelHelpers.export(exports, "Category", ()=>Category);
parcelHelpers.export(exports, "AnalyticsAction", ()=>AnalyticsAction);
parcelHelpers.export(exports, "ApiAction", ()=>ApiAction);
parcelHelpers.export(exports, "AuthAction", ()=>AuthAction);
parcelHelpers.export(exports, "DataStoreAction", ()=>DataStoreAction);
parcelHelpers.export(exports, "GeoAction", ()=>GeoAction);
parcelHelpers.export(exports, "InAppMessagingAction", ()=>InAppMessagingAction);
parcelHelpers.export(exports, "InteractionsAction", ()=>InteractionsAction);
parcelHelpers.export(exports, "PredictionsAction", ()=>PredictionsAction);
parcelHelpers.export(exports, "PubSubAction", ()=>PubSubAction);
parcelHelpers.export(exports, "PushNotificationAction", ()=>PushNotificationAction);
parcelHelpers.export(exports, "StorageAction", ()=>StorageAction);
var Framework;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})(Framework || (Framework = {}));
var Category;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})(Category || (Category = {}));
var AnalyticsAction;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["UpdateEndpoint"] = "2";
})(AnalyticsAction || (AnalyticsAction = {}));
var ApiAction;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})(ApiAction || (ApiAction = {}));
var AuthAction;
(function(AuthAction) {
    // SignUp = '1',
    // ConfirmSignUp = '2',
    // ResendSignUp = '3',
    // SignIn = '4',
    // GetMFAOptions = '5',
    // GetPreferredMFA = '6',
    // SetPreferredMFA = '7',
    // DisableSMS = '8',
    // EnableSMS = '9',
    // SetupTOTP = '10',
    // VerifyTotpToken = '11',
    // ConfirmSignIn = '12',
    // CompleteNewPassword = '13',
    // SendCustomChallengeAnswer = '14',
    // DeleteUserAttributes = '15',
    // DeleteUser = '16',
    // UpdateUserAttributes = '17',
    // UserAttributes = '18',
    // CurrentUserPoolUser = '19',
    // CurrentAuthenticatedUser = '20',
    // CurrentSession = '21',
    // VerifyUserAttribute = '22',
    // VerifyUserAttributeSubmit = '23',
    // VerifyCurrentUserAttribute = '24',
    // VerifyCurrentUserAttributeSubmit = '25',
    // SignOut = '26',
    // ChangePassword = '27',
    // ForgotPassword = '28',
    // ForgotPasswordSubmit = '29',
    AuthAction["FederatedSignIn"] = "30";
// CurrentUserInfo = '31',
// RememberDevice = '32',
// ForgetDevice = '33',
// FetchDevices = '34',
})(AuthAction || (AuthAction = {}));
var DataStoreAction;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})(DataStoreAction || (DataStoreAction = {}));
var GeoAction;
(function(GeoAction) {
    GeoAction["None"] = "0";
})(GeoAction || (GeoAction = {}));
var InAppMessagingAction;
(function(InAppMessagingAction) {
    InAppMessagingAction["None"] = "0";
})(InAppMessagingAction || (InAppMessagingAction = {}));
var InteractionsAction;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})(InteractionsAction || (InteractionsAction = {}));
var PredictionsAction;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})(PredictionsAction || (PredictionsAction = {}));
var PubSubAction;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})(PubSubAction || (PubSubAction = {}));
var PushNotificationAction;
(function(PushNotificationAction) {
    PushNotificationAction["None"] = "0";
})(PushNotificationAction || (PushNotificationAction = {}));
var StorageAction;
(function(StorageAction) {
    StorageAction["Put"] = "1";
    StorageAction["Get"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
})(StorageAction || (StorageAction = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dMUNY":[function(require,module,exports) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var version = "5.3.18";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"rZ1jz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameworkChangeObservers", ()=>frameworkChangeObservers);
parcelHelpers.export(exports, "detectFramework", ()=>detectFramework);
parcelHelpers.export(exports, "observeFrameworkChanges", ()=>observeFrameworkChanges);
parcelHelpers.export(exports, "clearCache", ()=>clearCache);
var _types = require("./types");
var _detection = require("./detection");
// We want to cache detection since the framework won't change
var frameworkCache;
var frameworkChangeObservers = [];
// Setup the detection reset tracking / timeout delays
var resetTriggered = false;
var SSR_RESET_TIMEOUT = 10; // ms
var WEB_RESET_TIMEOUT = 10; // ms
var PRIME_FRAMEWORK_DELAY = 1000; // ms
var detectFramework = function() {
    if (!frameworkCache) {
        frameworkCache = (0, _detection.detect)();
        if (resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while(frameworkChangeObservers.length)frameworkChangeObservers.pop()();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        frameworkChangeObservers.forEach(function(fcn) {
            return fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        resetTimeout((0, _types.Framework).ServerSideUnknown, SSR_RESET_TIMEOUT);
        resetTimeout((0, _types.Framework).WebUnknown, WEB_RESET_TIMEOUT);
    }
    return frameworkCache;
};
var observeFrameworkChanges = function(fcn) {
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if (resetTriggered) return;
    frameworkChangeObservers.push(fcn);
};
function clearCache() {
    frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function resetTimeout(framework, delay) {
    if (frameworkCache === framework && !resetTriggered) setTimeout(function() {
        clearCache();
        resetTriggered = true;
        setTimeout(detectFramework, PRIME_FRAMEWORK_DELAY);
    }, delay);
}

},{"./types":"8r55A","./detection":"1Pmeo","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Pmeo":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detect", ()=>detect);
var _types = require("../types");
var _react = require("./React");
var _vue = require("./Vue");
var _svelte = require("./Svelte");
var _next = require("./Next");
var _nuxt = require("./Nuxt");
var _angular = require("./Angular");
var _reactNative = require("./ReactNative");
var _expo = require("./Expo");
var _web = require("./Web");
// These are in the order of detection where when both are detectable, the early Framework will be reported
var detectionMap = [
    // First, detect mobile
    {
        platform: (0, _types.Framework).Expo,
        detectionMethod: (0, _expo.expoDetect)
    },
    {
        platform: (0, _types.Framework).ReactNative,
        detectionMethod: (0, _reactNative.reactNativeDetect)
    },
    // Next, detect web frameworks
    {
        platform: (0, _types.Framework).NextJs,
        detectionMethod: (0, _next.nextWebDetect)
    },
    {
        platform: (0, _types.Framework).Nuxt,
        detectionMethod: (0, _nuxt.nuxtWebDetect)
    },
    {
        platform: (0, _types.Framework).Angular,
        detectionMethod: (0, _angular.angularWebDetect)
    },
    {
        platform: (0, _types.Framework).React,
        detectionMethod: (0, _react.reactWebDetect)
    },
    {
        platform: (0, _types.Framework).VueJs,
        detectionMethod: (0, _vue.vueWebDetect)
    },
    {
        platform: (0, _types.Framework).Svelte,
        detectionMethod: (0, _svelte.svelteWebDetect)
    },
    {
        platform: (0, _types.Framework).WebUnknown,
        detectionMethod: (0, _web.webDetect)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, _types.Framework).NextJsSSR,
        detectionMethod: (0, _next.nextSSRDetect)
    },
    {
        platform: (0, _types.Framework).NuxtSSR,
        detectionMethod: (0, _nuxt.nuxtSSRDetect)
    },
    {
        platform: (0, _types.Framework).ReactSSR,
        detectionMethod: (0, _react.reactSSRDetect)
    },
    {
        platform: (0, _types.Framework).VueJsSSR,
        detectionMethod: (0, _vue.vueSSRDetect)
    },
    {
        platform: (0, _types.Framework).AngularSSR,
        detectionMethod: (0, _angular.angularSSRDetect)
    },
    {
        platform: (0, _types.Framework).SvelteSSR,
        detectionMethod: (0, _svelte.svelteSSRDetect)
    }
];
function detect() {
    var _a;
    return ((_a = detectionMap.find(function(detectionEntry) {
        return detectionEntry.detectionMethod();
    })) === null || _a === void 0 ? void 0 : _a.platform) || (0, _types.Framework).ServerSideUnknown;
}

},{"../types":"8r55A","./React":"2UMxh","./Vue":"g6J3G","./Svelte":"jpwEl","./Next":"8VC63","./Nuxt":"6nkv4","./Angular":"jZU21","./ReactNative":"7N08B","./Expo":"irXnN","./Web":"lJqDm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2UMxh":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with react 18.2 - built using Vite
parcelHelpers.export(exports, "reactWebDetect", ()=>reactWebDetect);
parcelHelpers.export(exports, "reactSSRDetect", ()=>reactSSRDetect);
var _helpers = require("./helpers");
var process = require("76821670e4d57432");
function reactWebDetect() {
    var elementKeyPrefixedWithReact = function(key) {
        return key.startsWith("_react") || key.startsWith("__react");
    };
    var elementIsReactEnabled = function(element) {
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    var allElementsWithId = function() {
        return Array.from(document.querySelectorAll("[id]"));
    };
    return (0, _helpers.documentExists)() && allElementsWithId().some(elementIsReactEnabled);
}
function reactSSRDetect() {
    return (0, _helpers.processExists)() && typeof process.env !== "undefined" && !!Object.keys(process.env).find(function(key) {
        return key.includes("react");
    });
}

},{"76821670e4d57432":"g1F5c","./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g1F5c":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"fswGq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalExists", ()=>globalExists);
parcelHelpers.export(exports, "globalThisExists", ()=>globalThisExists);
parcelHelpers.export(exports, "windowExists", ()=>windowExists);
parcelHelpers.export(exports, "documentExists", ()=>documentExists);
parcelHelpers.export(exports, "processExists", ()=>processExists);
parcelHelpers.export(exports, "keyPrefixMatch", ()=>keyPrefixMatch);
var global = arguments[3];
var process = require("c86167827cfb2a42");
var globalExists = function() {
    return typeof global !== "undefined";
};
var globalThisExists = function() {
    return typeof globalThis !== "undefined";
};
var windowExists = function() {
    return typeof window !== "undefined";
};
var documentExists = function() {
    return typeof document !== "undefined";
};
var processExists = function() {
    return typeof process !== "undefined";
};
var keyPrefixMatch = function(object, prefix) {
    return !!Object.keys(object).find(function(key) {
        return key.startsWith(prefix);
    });
};

},{"c86167827cfb2a42":"g1F5c","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g6J3G":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with vue 3.3.2
parcelHelpers.export(exports, "vueWebDetect", ()=>vueWebDetect);
parcelHelpers.export(exports, "vueSSRDetect", ()=>vueSSRDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function vueWebDetect() {
    return (0, _helpers.windowExists)() && (0, _helpers.keyPrefixMatch)(window, "__VUE");
}
function vueSSRDetect() {
    return (0, _helpers.globalExists)() && (0, _helpers.keyPrefixMatch)(global, "__VUE");
}

},{"./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jpwEl":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with svelte 3.59
parcelHelpers.export(exports, "svelteWebDetect", ()=>svelteWebDetect);
parcelHelpers.export(exports, "svelteSSRDetect", ()=>svelteSSRDetect);
var _helpers = require("./helpers");
var process = require("138f303fa47701cc");
function svelteWebDetect() {
    return (0, _helpers.windowExists)() && (0, _helpers.keyPrefixMatch)(window, "__SVELTE");
}
function svelteSSRDetect() {
    return (0, _helpers.processExists)() && typeof process.env !== "undefined" && !!Object.keys(process.env).find(function(key) {
        return key.includes("svelte");
    });
}

},{"138f303fa47701cc":"g1F5c","./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8VC63":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with next 13.4 / react 18.2
parcelHelpers.export(exports, "nextWebDetect", ()=>nextWebDetect);
parcelHelpers.export(exports, "nextSSRDetect", ()=>nextSSRDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function nextWebDetect() {
    // @ts-ignore
    return (0, _helpers.windowExists)() && window["next"] && typeof window["next"] === "object";
}
function nextSSRDetect() {
    return (0, _helpers.globalExists)() && ((0, _helpers.keyPrefixMatch)(global, "__next") || (0, _helpers.keyPrefixMatch)(global, "__NEXT"));
}

},{"./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6nkv4":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with nuxt 2.15 / vue 2.7
parcelHelpers.export(exports, "nuxtWebDetect", ()=>nuxtWebDetect);
parcelHelpers.export(exports, "nuxtSSRDetect", ()=>nuxtSSRDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function nuxtWebDetect() {
    return (0, _helpers.windowExists)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function nuxtSSRDetect() {
    // @ts-ignore
    return (0, _helpers.globalExists)() && typeof global["__NUXT_PATHS__"] !== "undefined";
}

},{"./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jZU21":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with @angular/core 16.0.0
parcelHelpers.export(exports, "angularWebDetect", ()=>angularWebDetect);
parcelHelpers.export(exports, "angularSSRDetect", ()=>angularSSRDetect);
var _helpers = require("./helpers");
var process = require("6c589ba30cc3d7d");
function angularWebDetect() {
    var angularVersionSetInDocument = Boolean((0, _helpers.documentExists)() && document.querySelector("[ng-version]"));
    var angularContentSetInWindow = Boolean(// @ts-ignore
    (0, _helpers.windowExists)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function angularSSRDetect() {
    var _a;
    return (0, _helpers.processExists)() && typeof process.env === "object" && ((_a = undefined, _a === void 0) ? void 0 : _a.startsWith("ng ")) || false;
}

},{"6c589ba30cc3d7d":"g1F5c","./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7N08B":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactNativeDetect", ()=>reactNativeDetect);
function reactNativeDetect() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"irXnN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with expo 48 / react-native 0.71.3
parcelHelpers.export(exports, "expoDetect", ()=>expoDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function expoDetect() {
    // @ts-ignore
    return (0, _helpers.globalExists)() && typeof global["expo"] !== "undefined";
}

},{"./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lJqDm":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webDetect", ()=>webDetect);
var _helpers = require("./helpers");
function webDetect() {
    return (0, _helpers.windowExists)();
}

},{"./helpers":"fswGq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hkXub":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDevice", ()=>ClientDevice);
var _browser = require("./browser");
var ClientDevice = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, _browser.clientInfo)();
    };
    ClientDevice.dimension = function() {
        return (0, _browser.dimension)();
    };
    return ClientDevice;
}();

},{"./browser":"3msSF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3msSF":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clientInfo", ()=>clientInfo);
parcelHelpers.export(exports, "dimension", ()=>dimension);
parcelHelpers.export(exports, "browserType", ()=>browserType);
var _logger = require("../Logger");
var logger = new (0, _logger.ConsoleLogger)("ClientDevice_Browser");
function clientInfo() {
    if (typeof window === "undefined") return {};
    return browserClientInfo();
}
function browserClientInfo() {
    if (typeof window === "undefined") {
        logger.warn("No window object available to get browser client info");
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        logger.warn("No navigator object available to get browser client info");
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = browserType(userAgent);
    var timezone = browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join("/"),
        language: language,
        timezone: timezone
    };
}
function dimension() {
    if (typeof window === "undefined") {
        logger.warn("No window object available to get browser client info");
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || "" : "";
}
function browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: "",
        version: ""
    };
}

},{"../Logger":"jNW4z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cWAc9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HubClass", ()=>HubClass);
parcelHelpers.export(exports, "Hub", ()=>Hub);
var _logger = require("./Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _logger.ConsoleLogger)("Hub");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var HubClass = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype._remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.patterns = __spreadArray([], __read(this.patterns.filter(function(x) {
                return x !== pattern_1;
            })), false);
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.listeners[channel] = __spreadArray([], __read(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            })), false);
        }
    };
    /**
     * @deprecated Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype.remove = function(channel, listener) {
        this._remove(channel, listener);
    };
    /**
     * Used to send a Hub event.
     *
     * @param channel - The channel on which the event will be broadcast
     * @param payload - The HubPayload
     * @param source  - The source of the event; defaults to ''
     * @param ampSymbol - Symbol used to determine if the event is dispatched internally on a protected channel
     *
     */ HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === AMPLIFY_SYMBOL;
            if (!hasAccess) logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
        var capsule = {
            channel: channel,
            payload: __assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            logger.error(e);
        }
    };
    /**
     * Used to listen for Hub events.
     *
     * @param channel - The channel on which to listen
     * @param callback - The callback to execute when an event is received on the specified channel
     * @param listenerName - The name of the listener; defaults to 'noname'
     * @returns A function which can be called to cancel the listener.
     *
     */ HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if (isLegacyCallback(callback)) {
            logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this._remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            logger.debug("Dispatching to ".concat(channel, " with "), payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = __read(match), groups = _a.slice(1);
                    var dispatchingCapsule = __assign(__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var Hub = new HubClass("__default__");

},{"./Logger":"jNW4z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iq9qd":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _i18N = require("./I18n");
var _logger = require("../Logger");
var _amplify = require("../Amplify");
var logger = new (0, _logger.ConsoleLogger)("I18n");
var _config = null;
var _i18n = null;
/**
 * Export I18n APIs
 */ var I18n = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        logger.debug("configure I18n");
        if (!config) return _config;
        _config = Object.assign({}, _config, config.I18n || config);
        I18n.createInstance();
        return _config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        logger.debug("create I18n instance");
        if (_i18n) return;
        _i18n = new (0, _i18N.I18n)(_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return _i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return _i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!_i18n) _i18n = new (0, _i18N.I18n)(_config);
        return true;
    };
    return I18n;
}();
(0, _amplify.Amplify).register(I18n);

},{"./I18n":"hyT2T","../Logger":"jNW4z","../Amplify":"ayq1K","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hyT2T":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _logger = require("../Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var logger = new (0, _logger.ConsoleLogger)("I18n");
/**
 * Language transition class
 */ var I18n = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = __assign(__assign({}, lang_dict), vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();

},{"../Logger":"jNW4z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7JWuU":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "sortByField", ()=>sortByField);
parcelHelpers.export(exports, "objectLessAttributes", ()=>objectLessAttributes);
parcelHelpers.export(exports, "filenameToContentType", ()=>filenameToContentType);
parcelHelpers.export(exports, "isTextFile", ()=>isTextFile);
parcelHelpers.export(exports, "generateRandomString", ()=>generateRandomString);
parcelHelpers.export(exports, "makeQuerablePromise", ()=>makeQuerablePromise);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "browserOrNode", ()=>browserOrNode);
parcelHelpers.export(exports, "transferKeyToLowerCase", ()=>transferKeyToLowerCase);
parcelHelpers.export(exports, "transferKeyToUpperCase", ()=>transferKeyToUpperCase);
parcelHelpers.export(exports, "isStrictObject", ()=>isStrictObject);
var process = require("6dd1111aaf1faf9b");
var MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/apng",
        ext: "apng"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/x-icon",
        ext: "cur"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/jpeg",
        ext: "jfif"
    },
    {
        type: "image/jpeg",
        ext: "pjp"
    },
    {
        type: "image/jpeg",
        ext: "pjpeg"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/webp",
        ext: "webp"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var isEmpty = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var sortByField = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === "desc" ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
        if (typeof a_val === "undefined") return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var objectLessAttributes = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === "string") delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var filenameToContentType = function(filename, defVal) {
    if (defVal === void 0) defVal = "application/octet-stream";
    var name = filename.toLowerCase();
    var filtered = MIME_MAP.filter(function(mime) {
        return name.endsWith("." + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var isTextFile = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith("text/")) return true;
    return "application/json" === type || "application/xml" === type || "application/sh" === type;
};
var generateRandomString = function() {
    var result = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var makeQuerablePromise = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var isWebWorker = function() {
    if (typeof self === "undefined") return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var browserOrNode = function() {
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    var isNode = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var transferKeyToLowerCase = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!isStrictObject(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var transferKeyToUpperCase = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!isStrictObject(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var isStrictObject = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};

},{"6dd1111aaf1faf9b":"g1F5c","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iPQUx":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Signer", ()=>Signer);
var _util = require("./Util");
var _signatureV4 = require("./clients/middleware/signing/signer/signatureV4");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var IOT_SERVICE_NAME = "iotdevicegateway";
// Best practice regex to parse the service and region from an AWS endpoint
var AWS_ENDPOINT_REGEX = /([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(.cn)?$/;
var Signer = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, accessInfo, serviceInfo) {
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        var requestToSign = __assign(__assign({}, request), {
            body: request.data,
            url: new URL(request.url)
        });
        var options = getOptions(requestToSign, accessInfo, serviceInfo);
        var signedRequest = (0, _signatureV4.signRequest)(requestToSign, options);
        // Prior to using `signRequest`, Signer accepted urls as strings and outputted urls as string. Coerce the property
        // back to a string so as not to disrupt consumers of Signer.
        signedRequest.url = signedRequest.url.toString();
        // HTTP headers should be case insensitive but, to maintain parity with the previous Signer implementation and
        // limit the impact of this implementation swap, replace lowercased headers with title cased ones.
        signedRequest.headers.Authorization = signedRequest.headers.authorization;
        signedRequest.headers["X-Amz-Security-Token"] = signedRequest.headers["x-amz-security-token"];
        delete signedRequest.headers.authorization;
        delete signedRequest.headers["x-amz-security-token"];
        return signedRequest;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === "object" ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === "object" ? urlOrRequest.method : "GET";
        var body = typeof urlOrRequest === "object" ? urlOrRequest.body : undefined;
        var presignable = {
            body: body,
            method: method,
            url: new URL(urlToSign)
        };
        var options = getOptions(presignable, accessInfo, serviceInfo, expiration);
        var signedUrl = (0, _signatureV4.presignUrl)(presignable, options);
        if (accessInfo.session_token && !sessionTokenRequiredInSigning(options.signingService)) signedUrl.searchParams.append((0, _signatureV4.TOKEN_QUERY_PARAM), accessInfo.session_token);
        return signedUrl.toString();
    };
    return Signer;
}();
var getOptions = function(request, accessInfo, serviceInfo, expiration) {
    var _a = accessInfo !== null && accessInfo !== void 0 ? accessInfo : {}, access_key = _a.access_key, secret_key = _a.secret_key, session_token = _a.session_token;
    var _b = parseServiceInfo(request.url), urlRegion = _b.region, urlService = _b.service;
    var _c = serviceInfo !== null && serviceInfo !== void 0 ? serviceInfo : {}, _d = _c.region, region = _d === void 0 ? urlRegion : _d, _e = _c.service, service = _e === void 0 ? urlService : _e;
    var credentials = __assign({
        accessKeyId: access_key,
        secretAccessKey: secret_key
    }, sessionTokenRequiredInSigning(service) ? {
        sessionToken: session_token
    } : {});
    return __assign({
        credentials: credentials,
        signingDate: (0, _util.DateUtils).getDateWithClockOffset(),
        signingRegion: region,
        signingService: service
    }, expiration && {
        expiration: expiration
    });
};
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var parseServiceInfo = function(url) {
    var _a;
    var host = url.host;
    var matched = (_a = host.match(AWS_ENDPOINT_REGEX)) !== null && _a !== void 0 ? _a : [];
    var parsed = matched.slice(1, 3);
    if (parsed[1] === "es") // Elastic Search
    parsed = parsed.reverse();
    return {
        service: parsed[0],
        region: parsed[1]
    };
};
// IoT service does not allow the session token in the canonical request
// https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var sessionTokenRequiredInSigning = function(service) {
    return service !== IOT_SERVICE_NAME;
};

},{"./Util":"4u1nR","./clients/middleware/signing/signer/signatureV4":"d82dh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4u1nR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", ()=>(0, _retry.NonRetryableError));
parcelHelpers.export(exports, "isNonRetryableError", ()=>(0, _retry.isNonRetryableError));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _retry.jitteredBackoff));
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>(0, _retry.jitteredExponentialRetry));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "Mutex", ()=>(0, _mutexDefault.default));
parcelHelpers.export(exports, "Reachability", ()=>(0, _reachabilityDefault.default));
parcelHelpers.export(exports, "DateUtils", ()=>(0, _dateUtils.DateUtils));
parcelHelpers.export(exports, "urlSafeDecode", ()=>(0, _stringUtils.urlSafeDecode));
parcelHelpers.export(exports, "urlSafeEncode", ()=>(0, _stringUtils.urlSafeEncode));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", ()=>(0, _constants.AWS_CLOUDWATCH_BASE_BUFFER_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>(0, _constants.AWS_CLOUDWATCH_CATEGORY));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", ()=>(0, _constants.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", ()=>(0, _constants.AWS_CLOUDWATCH_MAX_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", ()=>(0, _constants.AWS_CLOUDWATCH_PROVIDER_NAME));
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", ()=>(0, _constants.NO_CREDS_ERROR_STRING));
parcelHelpers.export(exports, "RETRY_ERROR_CODES", ()=>(0, _constants.RETRY_ERROR_CODES));
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>(0, _backgroundProcessManager.BackgroundProcessManager));
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>(0, _backgroundProcessManager.BackgroundManagerNotOpenError));
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>(0, _backgroundProcessManager.BackgroundProcessManagerState));
var _retry = require("./Retry");
var _mutex = require("./Mutex");
var _mutexDefault = parcelHelpers.interopDefault(_mutex);
var _reachability = require("./Reachability");
var _reachabilityDefault = parcelHelpers.interopDefault(_reachability);
var _dateUtils = require("./DateUtils");
var _stringUtils = require("./StringUtils");
var _constants = require("./Constants");
var _backgroundProcessManager = require("./BackgroundProcessManager");

},{"./Retry":"5Rixm","./Mutex":"lzzA7","./Reachability":"8fSLO","./DateUtils":"hrNOU","./StringUtils":"hl8IL","./Constants":false,"./BackgroundProcessManager":"jFMoz","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5Rixm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", ()=>NonRetryableError);
parcelHelpers.export(exports, "isNonRetryableError", ()=>isNonRetryableError);
/**
 * @private
 * Internal use of Amplify only
 */ parcelHelpers.export(exports, "retry", ()=>retry);
/**
 * @private
 * Internal use of Amplify only
 */ parcelHelpers.export(exports, "jitteredBackoff", ()=>jitteredBackoff);
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>jitteredExponentialRetry);
var _consoleLogger = require("../Logger/ConsoleLogger");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _consoleLogger.ConsoleLogger)("Util");
var NonRetryableError = /** @class */ function(_super) {
    __extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var isNonRetryableError = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, onTerminate) {
    return __awaiter(this, void 0, void 0, function() {
        var _this = this;
        return __generator(this, function(_a) {
            if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _b, _c, err_1, retryIn_1;
                                        return __generator(this, function(_d) {
                                            switch(_d.label){
                                                case 0:
                                                    attempt++;
                                                    logger.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _b = {};
                                                    _c = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, __spreadArray([], __read(args), false))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_b.value = _c.apply(void 0, [
                                                            _d.sent()
                                                        ]), _b)
                                                    ];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    lastError = err_1;
                                                    logger.debug("error on ".concat(functionToRetry.name), err_1);
                                                    if (isNonRetryableError(err_1)) {
                                                        logger.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    logger.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _d.sent();
                                                    _d.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var MAX_DELAY_MS = 300000;
function jitteredBackoff(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var jitteredExponentialRetry = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs), onTerminate);
};

},{"../Logger/ConsoleLogger":"6MFok","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lzzA7":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
exports.default = Mutex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8fSLO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, _core.browserOrNode)().isNode) return (0, _zenObservableTsDefault.default).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, _core.isWebWorker)() ? self : window;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener("online", notifyOnline);
            globalObj.addEventListener("offline", notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener("online", notifyOnline);
                globalObj.removeEventListener("offline", notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = __values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
exports.default = ReachabilityNavigator;

},{"@aws-amplify/core":"8BDOx","zen-observable-ts":"klrbV","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"klrbV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _zenObservable = require("zen-observable");
var _zenObservableDefault = parcelHelpers.interopDefault(_zenObservable);
var Observable = (0, _zenObservableDefault.default);
exports.default = Observable;

},{"zen-observable":"1s0uH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1s0uH":[function(require,module,exports) {
module.exports = require("fe6bb7da9da67ed3").Observable;

},{"fe6bb7da9da67ed3":"gkR7V"}],"gkR7V":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Observable = void 0;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var hasSymbols = function() {
    return typeof Symbol === "function";
};
var hasSymbol = function(name) {
    return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function(name) {
    return hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if (hasSymbols() && !hasSymbol("observable")) Symbol.observable = Symbol("observable");
var SymbolIterator = getSymbol("iterator");
var SymbolObservable = getSymbol("observable");
var SymbolSpecies = getSymbol("species"); // === Abstract Operations ===
function getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : Observable;
}
function isObservable(x) {
    return x instanceof Observable; // SPEC: Brand check
}
function hostReportError(e) {
    if (hostReportError.log) hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            hostReportError(e);
        }
    });
}
function cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        hostReportError(e);
    }
}
function closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        hostReportError(e);
    }
    if (subscription._state === "closed") cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        enqueue(function() {
            return flushSubscription(subscription);
        });
        return;
    }
    notifySubscription(subscription, type, value);
}
var Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        _classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    _createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    closeSubscription(this);
                    cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        _classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    _createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        _classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    _createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = getMethod(x, SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if (isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if (hasSymbol("iterator")) {
                    method = getMethod(x, SymbolIterator);
                    if (method) return new C(function(observer) {
                        enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
exports.Observable = Observable;
if (hasSymbols()) Object.defineProperty(Observable, Symbol("extensions"), {
    value: {
        symbol: SymbolObservable,
        hostReportError: hostReportError
    },
    configurable: true
});

},{}],"hrNOU":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateUtils", ()=>DateUtils);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var FIVE_MINUTES_IN_MS = 300000;
var DateUtils = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if (DateUtils.clockOffset) return new Date(new Date().getTime() + DateUtils.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return DateUtils.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = DateUtils.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    },
    getDateFromHeaderString: function(header) {
        var _a = __read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - DateUtils.getDateWithClockOffset().getTime()) >= FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean([
            "BadRequestException",
            "InvalidSignatureException"
        ].includes(headers["x-amzn-errortype"]) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        DateUtils.clockOffset = offset;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hl8IL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlSafeEncode", ()=>urlSafeEncode);
parcelHelpers.export(exports, "urlSafeDecode", ()=>urlSafeDecode);
function urlSafeEncode(str) {
    return str.split("").map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, "0");
    }).join("");
}
function urlSafeDecode(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join("");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jFMoz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>BackgroundProcessManager);
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>BackgroundManagerNotOpenError);
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>BackgroundProcessManagerState);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private For internal Amplify use.
 *
 * Creates a new scope for promises, observables, and other types of work or
 * processes that may be running in the background. This manager provides
 * an singular entrypoint to request termination and await completion.
 *
 * As work completes on its own prior to close, the manager removes them
 * from the registry to avoid holding references to completed jobs.
 */ var BackgroundProcessManager = /** @class */ function() {
    /**
     * Creates a new manager for promises, observables, and other types
     * of work that may be running in the background. This manager provides
     * a centralized mechanism to request termination and await completion.
     */ function BackgroundProcessManager() {
        /**
         * A string indicating whether the manager is accepting new work ("Open"),
         * waiting for work to complete ("Closing"), or fully done with all
         * submitted work and *not* accepting new jobs ("Closed").
         */ this._state = BackgroundProcessManagerState.Open;
        /**
         * The list of outstanding jobs we'll need to wait for upon `close()`
         */ this.jobs = new Set();
    }
    BackgroundProcessManager.prototype.add = function(jobOrDescription, optionalDescription) {
        var job;
        var description;
        if (typeof jobOrDescription === "string") {
            job = undefined;
            description = jobOrDescription;
        } else {
            job = jobOrDescription;
            description = optionalDescription;
        }
        var error = this.closedFailure(description);
        if (error) return error;
        if (job === undefined) return this.addHook(description);
        else if (typeof job === "function") return this.addFunction(job, description);
        else if (job instanceof BackgroundProcessManager) return this.addManager(job, description);
        else throw new Error("If `job` is provided, it must be an Observable, Function, or BackgroundProcessManager.");
    };
    /**
     * Adds a **cleaner** function that doesn't immediately get executed.
     * Instead, the caller gets a **terminate** function back. The *cleaner* is
     * invoked only once the mananger *closes* or the returned **terminate**
     * function is called.
     *
     * @param clean The cleanup function.
     * @param description Optional description to help identify pending jobs.
     * @returns A terminate function.
     */ BackgroundProcessManager.prototype.addCleaner = function(clean, description) {
        var _this = this;
        var _a = this.addHook(description), resolve = _a.resolve, onTerminate = _a.onTerminate;
        var proxy = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                clean()
                            ];
                        case 1:
                            _a.sent();
                            resolve();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        onTerminate.then(proxy);
        return proxy;
    };
    BackgroundProcessManager.prototype.addFunction = function(job, description) {
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolve) {
            terminate = resolve;
        });
        // finally! start the job.
        var jobResult = job(onTerminate);
        // depending on what the job gives back, register the result
        // so we can monitor for completion.
        if (typeof (jobResult === null || jobResult === void 0 ? void 0 : jobResult.then) === "function") this.registerPromise(jobResult, terminate, description);
        // At the end of the day, or you know, method call, it doesn't matter
        // what the return value is at all; we just pass it through to the
        // caller.
        return jobResult;
    };
    BackgroundProcessManager.prototype.addManager = function(manager, description) {
        var _this = this;
        this.addCleaner(function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                manager.close()
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        }, description);
    };
    /**
     * Creates and registers a fabricated job for processes that need to operate
     * with callbacks/hooks. The returned `resolve` and `reject`
     * functions can be used to signal the job is done successfully or not.
     * The returned `onTerminate` is a promise that will resolve when the
     * manager is requesting the termination of the job.
     *
     * @param description Optional description to help identify pending jobs.
     * @returns `{ resolve, reject, onTerminate }`
     */ BackgroundProcessManager.prototype.addHook = function(description) {
        // the resolve/reject functions we'll provide to the caller to signal
        // the state of the job.
        var resolve;
        var reject;
        // the underlying promise we'll use to manage it, pretty much like
        // any other promise.
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolveTerminate) {
            terminate = resolveTerminate;
        });
        this.registerPromise(promise, terminate, description);
        return {
            resolve: resolve,
            reject: reject,
            onTerminate: onTerminate
        };
    };
    /**
     * Adds a Promise based job to the list of jobs for monitoring and listens
     * for either a success or failure, upon which the job is considered "done"
     * and removed from the registry.
     *
     * @param promise A promise that is on its way to being returned to a
     * caller, which needs to be tracked as a background job.
     * @param terminate The termination function to register, which can be
     * invoked to request the job stop.
     * @param description Optional description to help identify pending jobs.
     */ BackgroundProcessManager.prototype.registerPromise = function(promise, terminate, description) {
        var _this = this;
        var jobEntry = {
            promise: promise,
            terminate: terminate,
            description: description
        };
        this.jobs.add(jobEntry);
        // in all of my testing, it is safe to multi-subscribe to a promise.
        // so, rather than create another layer of promising, we're just going
        // to hook into the promise we already have, and when it's done
        // (successfully or not), we no longer need to wait for it upon close.
        //
        // sorry this is a bit hand-wavy:
        //
        // i believe we use `.then` and `.catch` instead of `.finally` because
        // `.finally` is invoked in a different order in the sequence, and this
        // breaks assumptions throughout and causes failures.
        promise.then(function() {
            _this.jobs.delete(jobEntry);
        }).catch(function() {
            _this.jobs.delete(jobEntry);
        });
    };
    Object.defineProperty(BackgroundProcessManager.prototype, "length", {
        /**
         * The number of jobs being waited on.
         *
         * We don't use this for anything. It's just informational for the caller,
         * and can be used in logging and testing.
         *
         * @returns the number of jobs.
         */ get: function() {
            return this.jobs.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "state", {
        /**
         * The execution state of the manager. One of:
         *
         * 1. "Open" -> Accepting new jobs
         * 1. "Closing" -> Not accepting new work. Waiting for jobs to complete.
         * 1. "Closed" -> Not accepting new work. All submitted jobs are complete.
         */ get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "pending", {
        /**
         * The registered `description` of all still-pending jobs.
         *
         * @returns descriptions as an array.
         */ get: function() {
            return Array.from(this.jobs).map(function(job) {
                return job.description;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isOpen", {
        /**
         * Whether the manager is accepting new jobs.
         */ get: function() {
            return this._state === BackgroundProcessManagerState.Open;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosing", {
        /**
         * Whether the manager is rejecting new work, but still waiting for
         * submitted work to complete.
         */ get: function() {
            return this._state === BackgroundProcessManagerState.Closing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosed", {
        /**
         * Whether the manager is rejecting work and done waiting for submitted
         * work to complete.
         */ get: function() {
            return this._state === BackgroundProcessManagerState.Closed;
        },
        enumerable: false,
        configurable: true
    });
    BackgroundProcessManager.prototype.closedFailure = function(description) {
        if (!this.isOpen) return Promise.reject(new BackgroundManagerNotOpenError([
            "The manager is ".concat(this.state, "."),
            'You tried to add "'.concat(description, '".'),
            "Pending jobs: [\n".concat(this.pending.map(function(t) {
                return "    " + t;
            }).join(",\n"), "\n]")
        ].join("\n")));
    };
    /**
     * Signals jobs to stop (for those that accept interruptions) and waits
     * for confirmation that jobs have stopped.
     *
     * This immediately puts the manager into a closing state and just begins
     * to reject new work. After all work in the manager is complete, the
     * manager goes into a `Completed` state and `close()` returns.
     *
     * This call is idempotent.
     *
     * If the manager is already closing or closed, `finalCleaup` is not executed.
     *
     * @param onClosed
     * @returns The settled results of each still-running job's promise. If the
     * manager is already closed, this will contain the results as of when the
     * manager's `close()` was called in an `Open` state.
     */ BackgroundProcessManager.prototype.close = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, job;
            var e_1, _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!this.isOpen) return [
                            3 /*break*/ ,
                            2
                        ];
                        this._state = BackgroundProcessManagerState.Closing;
                        try {
                            for(_a = __values(Array.from(this.jobs)), _b = _a.next(); !_b.done; _b = _a.next()){
                                job = _b.value;
                                try {
                                    job.terminate();
                                } catch (error) {
                                    // Due to potential races with a job's natural completion, it's
                                    // reasonable to expect the termination call to fail. Hence,
                                    // not logging as an error.
                                    console.warn("Failed to send termination signal to job. Error: ".concat(error.message), job);
                                }
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        // Use `allSettled()` because we want to wait for all to finish. We do
                        // not want to stop waiting if there is a failure.
                        this._closingPromise = Promise.allSettled(Array.from(this.jobs).map(function(j) {
                            return j.promise;
                        }));
                        return [
                            4 /*yield*/ ,
                            this._closingPromise
                        ];
                    case 1:
                        _d.sent();
                        this._state = BackgroundProcessManagerState.Closed;
                        _d.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._closingPromise
                        ];
                }
            });
        });
    };
    /**
     * Signals the manager to start accepting work (again) and returns once
     * the manager is ready to do so.
     *
     * If the state is already `Open`, this call is a no-op.
     *
     * If the state is `Closed`, this call simply updates state and returns.
     *
     * If the state is `Closing`, this call waits for completion before it
     * updates the state and returns.
     */ BackgroundProcessManager.prototype.open = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isClosing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this._state = BackgroundProcessManagerState.Open;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BackgroundProcessManager;
}();
/**
 *
 */ var BackgroundManagerNotOpenError = /** @class */ function(_super) {
    __extends(BackgroundManagerNotOpenError, _super);
    function BackgroundManagerNotOpenError(message) {
        return _super.call(this, "BackgroundManagerNotOpenError: ".concat(message)) || this;
    }
    return BackgroundManagerNotOpenError;
}(Error);
var BackgroundProcessManagerState;
(function(BackgroundProcessManagerState) {
    /**
     * Accepting new jobs.
     */ BackgroundProcessManagerState["Open"] = "Open";
    /**
     * Not accepting new jobs. Waiting for submitted jobs to complete.
     */ BackgroundProcessManagerState["Closing"] = "Closing";
    /**
     * Not accepting new jobs. All submitted jobs are complete.
     */ BackgroundProcessManagerState["Closed"] = "Closed";
})(BackgroundProcessManagerState || (BackgroundProcessManagerState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d82dh":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 replace Signer
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", ()=>(0, _signRequest.signRequest));
parcelHelpers.export(exports, "presignUrl", ()=>(0, _presignUrl.presignUrl));
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>(0, _constants.TOKEN_QUERY_PARAM));
parcelHelpers.export(exports, "getHashedPayload", ()=>(0, _getHashedPayload.getHashedPayload));
var _signRequest = require("./signRequest");
var _presignUrl = require("./presignUrl");
var _constants = require("./constants");
var _getHashedPayload = require("./utils/getHashedPayload");

},{"./signRequest":"28iTH","./presignUrl":"b3p8v","./constants":"68JII","./utils/getHashedPayload":"lP0Tk","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"28iTH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", ()=>signRequest);
var _getSignedHeaders = require("./utils/getSignedHeaders");
var _getSigningValues = require("./utils/getSigningValues");
var _constants = require("./constants");
var _getSignature = require("./utils/getSignature");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var signRequest = function(request, options) {
    var signingValues = (0, _getSigningValues.getSigningValues)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    var headers = __assign({}, request.headers);
    headers[0, _constants.HOST_HEADER] = request.url.host;
    headers[0, _constants.AMZ_DATE_HEADER] = longDate;
    if (sessionToken) headers[0, _constants.TOKEN_HEADER] = sessionToken;
    var requestToSign = __assign(__assign({}, request), {
        headers: headers
    });
    // calculate and add the signature to the request
    var signature = (0, _getSignature.getSignature)(requestToSign, signingValues);
    var credentialEntry = "Credential=".concat(accessKeyId, "/").concat(credentialScope);
    var signedHeadersEntry = "SignedHeaders=".concat((0, _getSignedHeaders.getSignedHeaders)(headers));
    var signatureEntry = "Signature=".concat(signature);
    headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.SHA256_ALGORITHM_IDENTIFIER), " ").concat(credentialEntry, ", ").concat(signedHeadersEntry, ", ").concat(signatureEntry);
    return requestToSign;
};

},{"./utils/getSignedHeaders":"dp43x","./utils/getSigningValues":"cTCZO","./constants":"68JII","./utils/getSignature":"2RUOq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dp43x":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignedHeaders", ()=>getSignedHeaders);
var getSignedHeaders = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(";");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cTCZO":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningValues", ()=>getSigningValues);
var _getCredentialScope = require("./getCredentialScope");
var _getFormattedDates = require("./getFormattedDates");
var getSigningValues = function(_a) {
    var credentials = _a.credentials, _b = _a.signingDate, signingDate = _b === void 0 ? new Date() : _b, signingRegion = _a.signingRegion, signingService = _a.signingService, _c = _a.uriEscapePath, uriEscapePath = _c === void 0 ? true : _c;
    // get properties from credentials
    var accessKeyId = credentials.accessKeyId, secretAccessKey = credentials.secretAccessKey, sessionToken = credentials.sessionToken;
    // get formatted dates for signing
    var _d = (0, _getFormattedDates.getFormattedDates)(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
    // copy header and set signing properties
    var credentialScope = (0, _getCredentialScope.getCredentialScope)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};

},{"./getCredentialScope":"1Y85X","./getFormattedDates":"88sMt","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Y85X":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialScope", ()=>getCredentialScope);
var _constants = require("../constants");
var getCredentialScope = function(date, region, service) {
    return "".concat(date, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};

},{"../constants":"68JII","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"68JII":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "SHA256_ALGORITHM_IDENTIFIER", ()=>SHA256_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "SIGNATURE_IDENTIFIER", ()=>SIGNATURE_IDENTIFIER);
parcelHelpers.export(exports, "EMPTY_HASH", ()=>EMPTY_HASH);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var HOST_HEADER = "host";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var KEY_TYPE_IDENTIFIER = "aws4_request";
var SHA256_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var SIGNATURE_IDENTIFIER = "AWS4";
var EMPTY_HASH = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"88sMt":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormattedDates", ()=>getFormattedDates);
var getFormattedDates = function(date) {
    var longDate = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2RUOq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignature", ()=>getSignature);
var _dataHashHelpers = require("./dataHashHelpers");
var _getCanonicalRequest = require("./getCanonicalRequest");
var _getSigningKey = require("./getSigningKey");
var _getStringToSign = require("./getStringToSign");
var getSignature = function(request, _a) {
    var credentialScope = _a.credentialScope, longDate = _a.longDate, secretAccessKey = _a.secretAccessKey, shortDate = _a.shortDate, signingRegion = _a.signingRegion, signingService = _a.signingService, uriEscapePath = _a.uriEscapePath;
    // step 1: create a canonical request
    var canonicalRequest = (0, _getCanonicalRequest.getCanonicalRequest)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    var hashedRequest = (0, _dataHashHelpers.getHashedDataAsHex)(null, canonicalRequest);
    // step 3: create a string to sign
    var stringToSign = (0, _getStringToSign.getStringToSign)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    var signature = (0, _dataHashHelpers.getHashedDataAsHex)((0, _getSigningKey.getSigningKey)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};

},{"./dataHashHelpers":"5lmRp","./getCanonicalRequest":"5Z6ps","./getSigningKey":"7iZ00","./getStringToSign":"jwzAU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5lmRp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedData", ()=>getHashedData);
parcelHelpers.export(exports, "getHashedDataAsHex", ()=>getHashedDataAsHex);
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var getHashedData = function(key, data) {
    var sha256 = new (0, _sha256Js.Sha256)(key);
    sha256.update(data);
    // TODO: V6 flip to async digest
    var hashedData = sha256.digestSync();
    return hashedData;
};
var getHashedDataAsHex = function(key, data) {
    var hashedData = getHashedData(key, data);
    return (0, _utilHexEncoding.toHex)(hashedData);
};

},{"@aws-crypto/sha256-js":"2bZzs","@aws-sdk/util-hex-encoding":"1T3Ny","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2bZzs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("556263fdeead54b2");
(0, tslib_1.__exportStar)(require("809b6b8543cd7a8d"), exports);

},{"556263fdeead54b2":"9gMVn","809b6b8543cd7a8d":"kLNcB"}],"9gMVn":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kLNcB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("6b99f4eff6f2b4cf");
var constants_1 = require("89426012737a6746");
var RawSha256_1 = require("6d632968519e2ea2");
var util_1 = require("4f88e8308f58f86c");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"6b99f4eff6f2b4cf":"9gMVn","89426012737a6746":"iQz1W","6d632968519e2ea2":"24vSt","4f88e8308f58f86c":"7XNqb"}],"iQz1W":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"24vSt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("651c3e7bb02fb8d1");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"651c3e7bb02fb8d1":"iQz1W"}],"7XNqb":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("f76e53baefa87574");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("b2b081df9cfcf59e");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("217804d2331790b0");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("7f87ccb2271771a0");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"f76e53baefa87574":"9hVy4","b2b081df9cfcf59e":"dpov7","217804d2331790b0":"3mCrM","7f87ccb2271771a0":"j5U0I"}],"9hVy4":[function(require,module,exports) {
var Buffer = require("dae139f991f45592").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("79d72748942b2e1c");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"dae139f991f45592":"8EcTH","79d72748942b2e1c":"59GiV"}],"8EcTH":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"rFFSX","aceacb6a4531a9d2":"iAbbC"}],"rFFSX":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"iAbbC":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"59GiV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
const fromUtf8 = (input)=>typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
const toUtf8 = (input)=>typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);

},{"./pureJs":"ckwy2","./whatwgEncodingApi":"2bs5A","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ckwy2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
const fromUtf8 = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const toUtf8 = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2bs5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dpov7":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"3mCrM":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"j5U0I":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"1T3Ny":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ parcelHelpers.export(exports, "fromHex", ()=>fromHex);
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ parcelHelpers.export(exports, "toHex", ()=>toHex);
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0" + encodedByte;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5Z6ps":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalRequest", ()=>getCanonicalRequest);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQueryString = require("./getCanonicalQueryString");
var _getCanonicalUri = require("./getCanonicalUri");
var _getHashedPayload = require("./getHashedPayload");
var _getSignedHeaders = require("./getSignedHeaders");
var getCanonicalRequest = function(_a, uriEscapePath) {
    var body = _a.body, headers = _a.headers, method = _a.method, url = _a.url;
    if (uriEscapePath === void 0) uriEscapePath = true;
    return [
        method,
        (0, _getCanonicalUri.getCanonicalUri)(url.pathname, uriEscapePath),
        (0, _getCanonicalQueryString.getCanonicalQueryString)(url.searchParams),
        (0, _getCanonicalHeaders.getCanonicalHeaders)(headers),
        (0, _getSignedHeaders.getSignedHeaders)(headers),
        (0, _getHashedPayload.getHashedPayload)(body)
    ].join("\n");
};

},{"./getCanonicalHeaders":"8dDJf","./getCanonicalQueryString":"8oAcj","./getCanonicalUri":"59nej","./getHashedPayload":"lP0Tk","./getSignedHeaders":"dp43x","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8dDJf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var getCanonicalHeaders = function(headers) {
    return Object.entries(headers).map(function(_a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return {
            key: key.toLowerCase(),
            value: (_b = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, " ")) !== null && _b !== void 0 ? _b : ""
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(entry) {
        return "".concat(entry.key, ":").concat(entry.value, "\n");
    }).join("");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8oAcj":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQueryString", ()=>getCanonicalQueryString);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var getCanonicalQueryString = function(searchParams) {
    return Array.from(searchParams).sort(function(_a, _b) {
        var _c = __read(_a, 2), keyA = _c[0], valA = _c[1];
        var _d = __read(_b, 2), keyB = _d[0], valB = _d[1];
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(function(_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return "".concat(escapeUri(key), "=").concat(escapeUri(val));
    }).join("&");
};
var escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"59nej":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalUri", ()=>getCanonicalUri);
var getCanonicalUri = function(pathname, uriEscapePath) {
    if (uriEscapePath === void 0) uriEscapePath = true;
    return pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, "/") : pathname : "/";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lP0Tk":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedPayload", ()=>getHashedPayload);
var _constants = require("../constants");
var _dataHashHelpers = require("./dataHashHelpers");
var getHashedPayload = function(body) {
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, _constants.EMPTY_HASH;
    if (isSourceData(body)) {
        var hashedData = (0, _dataHashHelpers.getHashedDataAsHex)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, _constants.UNSIGNED_PAYLOAD;
};
var isSourceData = function(body) {
    return typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer(body);
};
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"../constants":"68JII","./dataHashHelpers":"5lmRp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7iZ00":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
var _constants = require("../constants");
var _dataHashHelpers = require("./dataHashHelpers");
var getSigningKey = function(secretAccessKey, date, region, service) {
    var key = "".concat((0, _constants.SIGNATURE_IDENTIFIER)).concat(secretAccessKey);
    var dateKey = (0, _dataHashHelpers.getHashedData)(key, date);
    var regionKey = (0, _dataHashHelpers.getHashedData)(dateKey, region);
    var serviceKey = (0, _dataHashHelpers.getHashedData)(regionKey, service);
    var signingKey = (0, _dataHashHelpers.getHashedData)(serviceKey, (0, _constants.KEY_TYPE_IDENTIFIER));
    return signingKey;
};

},{"../constants":"68JII","./dataHashHelpers":"5lmRp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jwzAU":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStringToSign", ()=>getStringToSign);
var _constants = require("../constants");
var getStringToSign = function(date, credentialScope, hashedRequest) {
    return [
        (0, _constants.SHA256_ALGORITHM_IDENTIFIER),
        date,
        credentialScope,
        hashedRequest
    ].join("\n");
};

},{"../constants":"68JII","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b3p8v":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presignUrl", ()=>presignUrl);
var _constants = require("./constants");
var _getSigningValues = require("./utils/getSigningValues");
var _getSignature = require("./utils/getSignature");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var presignUrl = function(_a, _b) {
    var _c, _d, _e, _f;
    var body = _a.body, _g = _a.method, method = _g === void 0 ? "GET" : _g, url = _a.url;
    var expiration = _b.expiration, options = __rest(_b, [
        "expiration"
    ]);
    var signingValues = (0, _getSigningValues.getSigningValues)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    // @ts-ignore URL constructor accepts a URL object
    var presignedUrl = new URL(url);
    Object.entries(__assign(__assign((_c = {}, _c[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.SHA256_ALGORITHM_IDENTIFIER), _c[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(accessKeyId, "/").concat(credentialScope), _c[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate, _c[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = (0, _constants.HOST_HEADER), _c), expiration && (_d = {}, _d[0, _constants.EXPIRES_QUERY_PARAM] = expiration.toString(), _d)), sessionToken && (_e = {}, _e[0, _constants.TOKEN_QUERY_PARAM] = sessionToken, _e))).forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        presignedUrl.searchParams.append(key, value);
    });
    var requestToSign = {
        body: body,
        headers: (_f = {}, _f[0, _constants.HOST_HEADER] = url.host, _f),
        method: method,
        url: presignedUrl
    };
    // calculate and add the signature to the url
    var signature = (0, _getSignature.getSignature)(requestToSign, signingValues);
    presignedUrl.searchParams.append((0, _constants.SIGNATURE_QUERY_PARAM), signature);
    return presignedUrl;
};

},{"./constants":"68JII","./utils/getSigningValues":"cTCZO","./utils/getSignature":"2RUOq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5Lf91":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAWSExports", ()=>parseAWSExports);
var _logger = require("./Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var logger = new (0, _logger.ConsoleLogger)("Parser");
var parseAWSExports = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config["aws_mobile_analytics_app_id"]) {
        var Analytics = {
            AWSPinpoint: {
                appId: config["aws_mobile_analytics_app_id"],
                region: config["aws_mobile_analytics_app_region"]
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) amplifyConfig.Auth = {
        userPoolId: config["aws_user_pools_id"],
        userPoolWebClientId: config["aws_user_pools_web_client_id"],
        region: config["aws_cognito_region"],
        identityPoolId: config["aws_cognito_identity_pool_id"],
        identityPoolRegion: config["aws_cognito_region"],
        mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
        signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
    // Storage
    var storageConfig;
    if (config["aws_user_files_s3_bucket"]) storageConfig = {
        AWSS3: {
            bucket: config["aws_user_files_s3_bucket"],
            region: config["aws_user_files_s3_bucket_region"],
            dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config["Logging"]) amplifyConfig.Logging = __assign(__assign({}, config["Logging"]), {
        region: config["aws_project_region"]
    });
    // Geo
    if (config["geo"]) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo["amazon_location_service"]) amplifyConfig.Geo = {
            AmazonLocationService: config.geo["amazon_location_service"]
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
    return amplifyConfig;
};

},{"./Logger":"jNW4z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7P6WP":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>(0, _awscloudWatchProvider.AWSCloudWatchProvider));
var _awscloudWatchProvider = require("./AWSCloudWatchProvider");

},{"./AWSCloudWatchProvider":"2lSMy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2lSMy":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>AWSCloudWatchProvider);
var _clientCloudwatchLogs = require("@aws-sdk/client-cloudwatch-logs");
var _ = require("../..");
var _logger = require("../Logger");
var _platform = require("../Platform");
var _parseAWSExports = require("../parseAWSExports");
var _constants = require("../Util/Constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _logger.ConsoleLogger)("AWSCloudWatch");
var AWSCloudWatchProvider = /** @class */ function() {
    function AWSCloudWatchProvider(config) {
        this.configure(config);
        this._dataTracker = {
            eventUploadInProgress: false,
            logEvents: []
        };
        this._currentLogBatch = [];
        this._initiateLogPushInterval();
    }
    AWSCloudWatchProvider.prototype.getProviderName = function() {
        return AWSCloudWatchProvider.PROVIDER_NAME;
    };
    AWSCloudWatchProvider.prototype.getCategoryName = function() {
        return AWSCloudWatchProvider.CATEGORY;
    };
    AWSCloudWatchProvider.prototype.getLogQueue = function() {
        return this._dataTracker.logEvents;
    };
    AWSCloudWatchProvider.prototype.configure = function(config) {
        if (!config) return this._config || {};
        var conf = Object.assign({}, this._config, (0, _parseAWSExports.parseAWSExports)(config).Logging, config);
        this._config = conf;
        return this._config;
    };
    AWSCloudWatchProvider.prototype.createLogGroup = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("creating new log group in CloudWatch - ", params.logGroupName);
                        cmd = new (0, _clientCloudwatchLogs.CreateLogGroupCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_1 = _a.sent();
                        logger.error("error creating log group - ".concat(error_1));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogGroups = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting list of log groups");
                        cmd = new (0, _clientCloudwatchLogs.DescribeLogGroupsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_2 = _a.sent();
                        logger.error("error getting log group - ".concat(error_2));
                        throw error_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.createLogStream = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_3;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("creating new log stream in CloudWatch - ", params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.CreateLogStreamCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_3 = _a.sent();
                        logger.error("error creating log stream - ".concat(error_3));
                        throw error_3;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogStreams = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_4;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting list of log streams");
                        cmd = new (0, _clientCloudwatchLogs.DescribeLogStreamsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_4 = _a.sent();
                        logger.error("error getting log stream - ".concat(error_4));
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogEvents = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_5;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting log events from stream - ", params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.GetLogEventsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_5 = _a.sent();
                        logger.error("error getting log events - ".concat(error_5));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.pushLogs = function(logs) {
        logger.debug("pushing log events to Cloudwatch...");
        this._dataTracker.logEvents = __spreadArray(__spreadArray([], __read(this._dataTracker.logEvents), false), __read(logs), false);
    };
    AWSCloudWatchProvider.prototype._validateLogGroupExistsAndCreate = function(logGroupName) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, currGroups, foundGroups, err_1, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._dataTracker.verifiedLogGroup) return [
                            2 /*return*/ ,
                            this._dataTracker.verifiedLogGroup
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        return [
                            4 /*yield*/ ,
                            this.getLogGroups({
                                logGroupNamePrefix: logGroupName
                            })
                        ];
                    case 3:
                        currGroups = _a.sent();
                        if (!(typeof currGroups === "string") && currGroups.logGroups) {
                            foundGroups = currGroups.logGroups.filter(function(group) {
                                return group.logGroupName === logGroupName;
                            });
                            if (foundGroups.length > 0) {
                                this._dataTracker.verifiedLogGroup = foundGroups[0];
                                return [
                                    2 /*return*/ ,
                                    foundGroups[0]
                                ];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */ return [
                            4 /*yield*/ ,
                            this.createLogGroup({
                                logGroupName: logGroupName
                            })
                        ];
                    case 4:
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */ _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 5:
                        err_1 = _a.sent();
                        errString = "failure during log group search: ".concat(err_1);
                        logger.error(errString);
                        throw err_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._validateLogStreamExists = function(logGroupName, logStreamName) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, currStreams, foundStreams, err_2, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        return [
                            4 /*yield*/ ,
                            this.getLogStreams({
                                logGroupName: logGroupName,
                                logStreamNamePrefix: logStreamName
                            })
                        ];
                    case 2:
                        currStreams = _a.sent();
                        if (currStreams.logStreams) {
                            foundStreams = currStreams.logStreams.filter(function(stream) {
                                return stream.logStreamName === logStreamName;
                            });
                            if (foundStreams.length > 0) {
                                this._nextSequenceToken = foundStreams[0].uploadSequenceToken;
                                return [
                                    2 /*return*/ ,
                                    foundStreams[0]
                                ];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */ return [
                            4 /*yield*/ ,
                            this.createLogStream({
                                logGroupName: logGroupName,
                                logStreamName: logStreamName
                            })
                        ];
                    case 3:
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */ _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        err_2 = _a.sent();
                        errString = "failure during log stream search: ".concat(err_2);
                        logger.error(errString);
                        throw err_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._sendLogEvents = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, cmd, client, output, err_3, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        logger.debug("sending log events to stream - ", params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.PutLogEventsCommand)(params);
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 2:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        err_3 = _a.sent();
                        errString = "failure during log push: ".concat(err_3);
                        logger.error(errString);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initCloudWatchLogs = function() {
        return new (0, _clientCloudwatchLogs.CloudWatchLogsClient)({
            region: this._config.region,
            credentials: this._config.credentials,
            customUserAgent: (0, _platform.getAmplifyUserAgentObject)(),
            endpoint: this._config.endpoint
        });
    };
    AWSCloudWatchProvider.prototype._ensureCredentials = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _.Credentials).get().then(function(credentials) {
                                if (!credentials) return false;
                                var cred = (0, _.Credentials).shear(credentials);
                                logger.debug("set credentials for logging", cred);
                                _this._config.credentials = cred;
                                return true;
                            }).catch(function(error) {
                                logger.warn("ensure credentials error", error);
                                return false;
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getNextSequenceToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            var logStream, err_4;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._nextSequenceToken && this._nextSequenceToken.length > 0) return [
                            2 /*return*/ ,
                            this._nextSequenceToken
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._validateLogGroupExistsAndCreate(this._config.logGroupName)
                        ];
                    case 2:
                        _a.sent();
                        this._nextSequenceToken = undefined;
                        return [
                            4 /*yield*/ ,
                            this._validateLogStreamExists(this._config.logGroupName, this._config.logStreamName)
                        ];
                    case 3:
                        logStream = _a.sent();
                        if (logStream) this._nextSequenceToken = logStream.uploadSequenceToken;
                        return [
                            2 /*return*/ ,
                            this._nextSequenceToken
                        ];
                    case 4:
                        err_4 = _a.sent();
                        logger.error("failure while getting next sequence token: ".concat(err_4));
                        throw err_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._safeUploadLogEvents = function() {
        return __awaiter(this, void 0, void 0, function() {
            var seqToken, logBatch, putLogsPayload, sendLogEventsResponse, err_5;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._getNextSequenceToken()
                        ];
                    case 1:
                        seqToken = _a.sent();
                        logBatch = this._currentLogBatch.length === 0 ? this._getBufferedBatchOfLogs() : this._currentLogBatch;
                        putLogsPayload = {
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName,
                            logEvents: logBatch,
                            sequenceToken: seqToken
                        };
                        this._dataTracker.eventUploadInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._sendLogEvents(putLogsPayload)
                        ];
                    case 2:
                        sendLogEventsResponse = _a.sent();
                        this._nextSequenceToken = sendLogEventsResponse.nextSequenceToken;
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [
                            2 /*return*/ ,
                            sendLogEventsResponse
                        ];
                    case 3:
                        err_5 = _a.sent();
                        logger.error("error during _safeUploadLogEvents: ".concat(err_5));
                        if ((0, _constants.RETRY_ERROR_CODES).includes(err_5.name)) this._getNewSequenceTokenAndSubmit({
                            logEvents: this._currentLogBatch,
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName
                        });
                        else {
                            this._dataTracker.eventUploadInProgress = false;
                            throw err_5;
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getBufferedBatchOfLogs = function() {
        /**
         * CloudWatch has restrictions on the size of the log events that get sent up.
         * We need to track both the size of each event and the total size of the batch
         * of logs.
         *
         * We also need to ensure that the logs in the batch are sorted in chronological order.
         * https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html
         */ var currentEventIdx = 0;
        var totalByteSize = 0;
        while(currentEventIdx < this._dataTracker.logEvents.length){
            var currentEvent = this._dataTracker.logEvents[currentEventIdx];
            var eventSize = currentEvent ? new TextEncoder().encode(currentEvent.message).length + (0, _constants.AWS_CLOUDWATCH_BASE_BUFFER_SIZE) : 0;
            if (eventSize > (0, _constants.AWS_CLOUDWATCH_MAX_EVENT_SIZE)) {
                var errString = "Log entry exceeds maximum size for CloudWatch logs. Log size: ".concat(eventSize, ". Truncating log message.");
                logger.warn(errString);
                currentEvent.message = currentEvent.message.substring(0, eventSize);
            }
            if (totalByteSize + eventSize > (0, _constants.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE)) break;
            totalByteSize += eventSize;
            currentEventIdx++;
        }
        this._currentLogBatch = this._dataTracker.logEvents.splice(0, currentEventIdx);
        return this._currentLogBatch;
    };
    AWSCloudWatchProvider.prototype._getNewSequenceTokenAndSubmit = function(payload) {
        return __awaiter(this, void 0, void 0, function() {
            var seqToken, sendLogEventsRepsonse, err_6;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        this._nextSequenceToken = undefined;
                        this._dataTracker.eventUploadInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._getNextSequenceToken()
                        ];
                    case 1:
                        seqToken = _a.sent();
                        payload.sequenceToken = seqToken;
                        return [
                            4 /*yield*/ ,
                            this._sendLogEvents(payload)
                        ];
                    case 2:
                        sendLogEventsRepsonse = _a.sent();
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [
                            2 /*return*/ ,
                            sendLogEventsRepsonse
                        ];
                    case 3:
                        err_6 = _a.sent();
                        logger.error("error when retrying log submission with new sequence token: ".concat(err_6));
                        this._dataTracker.eventUploadInProgress = false;
                        throw err_6;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initiateLogPushInterval = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        this._timer = setInterval(function() {
            return __awaiter(_this, void 0, void 0, function() {
                var err_7;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!this._getDocUploadPermissibility()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this._safeUploadLogEvents()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_7 = _a.sent();
                            logger.error("error when calling _safeUploadLogEvents in the timer interval - ".concat(err_7));
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }, 2000);
    };
    AWSCloudWatchProvider.prototype._getDocUploadPermissibility = function() {
        return (this._dataTracker.logEvents.length !== 0 || this._currentLogBatch.length !== 0) && !this._dataTracker.eventUploadInProgress;
    };
    AWSCloudWatchProvider.PROVIDER_NAME = (0, _constants.AWS_CLOUDWATCH_PROVIDER_NAME);
    AWSCloudWatchProvider.CATEGORY = (0, _constants.AWS_CLOUDWATCH_CATEGORY);
    return AWSCloudWatchProvider;
}();

},{"@aws-sdk/client-cloudwatch-logs":"cSC4E","../..":"8BDOx","../Logger":"jNW4z","../Platform":"kna8f","../parseAWSExports":"5Lf91","../Util/Constants":"2lMKs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cSC4E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloudWatchLogsClient = require("./CloudWatchLogsClient");
parcelHelpers.exportAll(_cloudWatchLogsClient, exports);
var _cloudWatchLogs = require("./CloudWatchLogs");
parcelHelpers.exportAll(_cloudWatchLogs, exports);
var _associateKmsKeyCommand = require("./commands/AssociateKmsKeyCommand");
parcelHelpers.exportAll(_associateKmsKeyCommand, exports);
var _cancelExportTaskCommand = require("./commands/CancelExportTaskCommand");
parcelHelpers.exportAll(_cancelExportTaskCommand, exports);
var _createExportTaskCommand = require("./commands/CreateExportTaskCommand");
parcelHelpers.exportAll(_createExportTaskCommand, exports);
var _createLogGroupCommand = require("./commands/CreateLogGroupCommand");
parcelHelpers.exportAll(_createLogGroupCommand, exports);
var _createLogStreamCommand = require("./commands/CreateLogStreamCommand");
parcelHelpers.exportAll(_createLogStreamCommand, exports);
var _deleteDestinationCommand = require("./commands/DeleteDestinationCommand");
parcelHelpers.exportAll(_deleteDestinationCommand, exports);
var _deleteLogGroupCommand = require("./commands/DeleteLogGroupCommand");
parcelHelpers.exportAll(_deleteLogGroupCommand, exports);
var _deleteLogStreamCommand = require("./commands/DeleteLogStreamCommand");
parcelHelpers.exportAll(_deleteLogStreamCommand, exports);
var _deleteMetricFilterCommand = require("./commands/DeleteMetricFilterCommand");
parcelHelpers.exportAll(_deleteMetricFilterCommand, exports);
var _deleteQueryDefinitionCommand = require("./commands/DeleteQueryDefinitionCommand");
parcelHelpers.exportAll(_deleteQueryDefinitionCommand, exports);
var _deleteResourcePolicyCommand = require("./commands/DeleteResourcePolicyCommand");
parcelHelpers.exportAll(_deleteResourcePolicyCommand, exports);
var _deleteRetentionPolicyCommand = require("./commands/DeleteRetentionPolicyCommand");
parcelHelpers.exportAll(_deleteRetentionPolicyCommand, exports);
var _deleteSubscriptionFilterCommand = require("./commands/DeleteSubscriptionFilterCommand");
parcelHelpers.exportAll(_deleteSubscriptionFilterCommand, exports);
var _describeDestinationsCommand = require("./commands/DescribeDestinationsCommand");
parcelHelpers.exportAll(_describeDestinationsCommand, exports);
var _describeDestinationsPaginator = require("./pagination/DescribeDestinationsPaginator");
parcelHelpers.exportAll(_describeDestinationsPaginator, exports);
var _describeExportTasksCommand = require("./commands/DescribeExportTasksCommand");
parcelHelpers.exportAll(_describeExportTasksCommand, exports);
var _describeLogGroupsCommand = require("./commands/DescribeLogGroupsCommand");
parcelHelpers.exportAll(_describeLogGroupsCommand, exports);
var _describeLogGroupsPaginator = require("./pagination/DescribeLogGroupsPaginator");
parcelHelpers.exportAll(_describeLogGroupsPaginator, exports);
var _describeLogStreamsCommand = require("./commands/DescribeLogStreamsCommand");
parcelHelpers.exportAll(_describeLogStreamsCommand, exports);
var _describeLogStreamsPaginator = require("./pagination/DescribeLogStreamsPaginator");
parcelHelpers.exportAll(_describeLogStreamsPaginator, exports);
var _describeMetricFiltersCommand = require("./commands/DescribeMetricFiltersCommand");
parcelHelpers.exportAll(_describeMetricFiltersCommand, exports);
var _describeMetricFiltersPaginator = require("./pagination/DescribeMetricFiltersPaginator");
parcelHelpers.exportAll(_describeMetricFiltersPaginator, exports);
var _describeQueriesCommand = require("./commands/DescribeQueriesCommand");
parcelHelpers.exportAll(_describeQueriesCommand, exports);
var _describeQueryDefinitionsCommand = require("./commands/DescribeQueryDefinitionsCommand");
parcelHelpers.exportAll(_describeQueryDefinitionsCommand, exports);
var _describeResourcePoliciesCommand = require("./commands/DescribeResourcePoliciesCommand");
parcelHelpers.exportAll(_describeResourcePoliciesCommand, exports);
var _describeSubscriptionFiltersCommand = require("./commands/DescribeSubscriptionFiltersCommand");
parcelHelpers.exportAll(_describeSubscriptionFiltersCommand, exports);
var _describeSubscriptionFiltersPaginator = require("./pagination/DescribeSubscriptionFiltersPaginator");
parcelHelpers.exportAll(_describeSubscriptionFiltersPaginator, exports);
var _disassociateKmsKeyCommand = require("./commands/DisassociateKmsKeyCommand");
parcelHelpers.exportAll(_disassociateKmsKeyCommand, exports);
var _filterLogEventsCommand = require("./commands/FilterLogEventsCommand");
parcelHelpers.exportAll(_filterLogEventsCommand, exports);
var _filterLogEventsPaginator = require("./pagination/FilterLogEventsPaginator");
parcelHelpers.exportAll(_filterLogEventsPaginator, exports);
var _getLogEventsCommand = require("./commands/GetLogEventsCommand");
parcelHelpers.exportAll(_getLogEventsCommand, exports);
var _getLogEventsPaginator = require("./pagination/GetLogEventsPaginator");
parcelHelpers.exportAll(_getLogEventsPaginator, exports);
var _getLogGroupFieldsCommand = require("./commands/GetLogGroupFieldsCommand");
parcelHelpers.exportAll(_getLogGroupFieldsCommand, exports);
var _getLogRecordCommand = require("./commands/GetLogRecordCommand");
parcelHelpers.exportAll(_getLogRecordCommand, exports);
var _getQueryResultsCommand = require("./commands/GetQueryResultsCommand");
parcelHelpers.exportAll(_getQueryResultsCommand, exports);
var _listTagsLogGroupCommand = require("./commands/ListTagsLogGroupCommand");
parcelHelpers.exportAll(_listTagsLogGroupCommand, exports);
var _putDestinationCommand = require("./commands/PutDestinationCommand");
parcelHelpers.exportAll(_putDestinationCommand, exports);
var _putDestinationPolicyCommand = require("./commands/PutDestinationPolicyCommand");
parcelHelpers.exportAll(_putDestinationPolicyCommand, exports);
var _putLogEventsCommand = require("./commands/PutLogEventsCommand");
parcelHelpers.exportAll(_putLogEventsCommand, exports);
var _putMetricFilterCommand = require("./commands/PutMetricFilterCommand");
parcelHelpers.exportAll(_putMetricFilterCommand, exports);
var _putQueryDefinitionCommand = require("./commands/PutQueryDefinitionCommand");
parcelHelpers.exportAll(_putQueryDefinitionCommand, exports);
var _putResourcePolicyCommand = require("./commands/PutResourcePolicyCommand");
parcelHelpers.exportAll(_putResourcePolicyCommand, exports);
var _putRetentionPolicyCommand = require("./commands/PutRetentionPolicyCommand");
parcelHelpers.exportAll(_putRetentionPolicyCommand, exports);
var _putSubscriptionFilterCommand = require("./commands/PutSubscriptionFilterCommand");
parcelHelpers.exportAll(_putSubscriptionFilterCommand, exports);
var _startQueryCommand = require("./commands/StartQueryCommand");
parcelHelpers.exportAll(_startQueryCommand, exports);
var _stopQueryCommand = require("./commands/StopQueryCommand");
parcelHelpers.exportAll(_stopQueryCommand, exports);
var _tagLogGroupCommand = require("./commands/TagLogGroupCommand");
parcelHelpers.exportAll(_tagLogGroupCommand, exports);
var _testMetricFilterCommand = require("./commands/TestMetricFilterCommand");
parcelHelpers.exportAll(_testMetricFilterCommand, exports);
var _untagLogGroupCommand = require("./commands/UntagLogGroupCommand");
parcelHelpers.exportAll(_untagLogGroupCommand, exports);
var _interfaces = require("./pagination/Interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./CloudWatchLogsClient":"kzTk0","./CloudWatchLogs":false,"./commands/AssociateKmsKeyCommand":false,"./commands/CancelExportTaskCommand":false,"./commands/CreateExportTaskCommand":false,"./commands/CreateLogGroupCommand":"6dqtq","./commands/CreateLogStreamCommand":"iTZyE","./commands/DeleteDestinationCommand":false,"./commands/DeleteLogGroupCommand":false,"./commands/DeleteLogStreamCommand":false,"./commands/DeleteMetricFilterCommand":false,"./commands/DeleteQueryDefinitionCommand":false,"./commands/DeleteResourcePolicyCommand":false,"./commands/DeleteRetentionPolicyCommand":false,"./commands/DeleteSubscriptionFilterCommand":false,"./commands/DescribeDestinationsCommand":false,"./pagination/DescribeDestinationsPaginator":false,"./commands/DescribeExportTasksCommand":false,"./commands/DescribeLogGroupsCommand":"ibALT","./pagination/DescribeLogGroupsPaginator":false,"./commands/DescribeLogStreamsCommand":"hgwcF","./pagination/DescribeLogStreamsPaginator":false,"./commands/DescribeMetricFiltersCommand":false,"./pagination/DescribeMetricFiltersPaginator":false,"./commands/DescribeQueriesCommand":false,"./commands/DescribeQueryDefinitionsCommand":false,"./commands/DescribeResourcePoliciesCommand":false,"./commands/DescribeSubscriptionFiltersCommand":false,"./pagination/DescribeSubscriptionFiltersPaginator":false,"./commands/DisassociateKmsKeyCommand":false,"./commands/FilterLogEventsCommand":false,"./pagination/FilterLogEventsPaginator":false,"./commands/GetLogEventsCommand":"2eLKw","./pagination/GetLogEventsPaginator":false,"./commands/GetLogGroupFieldsCommand":false,"./commands/GetLogRecordCommand":false,"./commands/GetQueryResultsCommand":false,"./commands/ListTagsLogGroupCommand":false,"./commands/PutDestinationCommand":false,"./commands/PutDestinationPolicyCommand":false,"./commands/PutLogEventsCommand":"6wnye","./commands/PutMetricFilterCommand":false,"./commands/PutQueryDefinitionCommand":false,"./commands/PutResourcePolicyCommand":false,"./commands/PutRetentionPolicyCommand":false,"./commands/PutSubscriptionFilterCommand":false,"./commands/StartQueryCommand":false,"./commands/StopQueryCommand":false,"./commands/TagLogGroupCommand":false,"./commands/TestMetricFilterCommand":false,"./commands/UntagLogGroupCommand":false,"./pagination/Interfaces":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kzTk0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudWatchLogsClient", ()=>CloudWatchLogsClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>You can use Amazon CloudWatch Logs to monitor, store, and access your log files from
 *       EC2 instances, AWS CloudTrail, or other sources. You can then retrieve the associated
 *       log data from CloudWatch Logs using the CloudWatch console, CloudWatch Logs commands in the
 *       AWS CLI, CloudWatch Logs API, or CloudWatch Logs SDK.</p>
 *          <p>You can use CloudWatch Logs to:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <b>Monitor logs from EC2 instances in real-time</b>: You
 *           can use CloudWatch Logs to monitor applications and systems using log data. For example,
 *           CloudWatch Logs can track the number of errors that occur in your application logs and
 *           send you a notification whenever the rate of errors exceeds a threshold that you specify.
 *           CloudWatch Logs uses your log data for monitoring so no code changes are required. For
 *           example, you can monitor application logs for specific literal terms (such as
 *           "NullReferenceException") or count the number of occurrences of a literal term at a
 *           particular position in log data (such as "404" status codes in an Apache access log). When
 *           the term you are searching for is found, CloudWatch Logs reports the data to a CloudWatch
 *           metric that you specify.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Monitor AWS CloudTrail logged events</b>: You can
 *           create alarms in CloudWatch and receive notifications of particular API activity as
 *           captured by CloudTrail. You can use the notification to perform troubleshooting.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Archive log data</b>: You can use CloudWatch Logs to
 *           store your log data in highly durable storage. You can change the log retention setting so
 *           that any log events older than this setting are automatically deleted. The CloudWatch Logs
 *           agent makes it easy to quickly send both rotated and non-rotated log data off of a host
 *           and into the log service. You can then access the raw log data when you need it.</p>
 *             </li>
 *          </ul>
 */ var CloudWatchLogsClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(CloudWatchLogsClient, _super);
    function CloudWatchLogsClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    CloudWatchLogsClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CloudWatchLogsClient;
}((0, _smithyClient.Client));

},{"tslib":"cj7CK","./runtimeConfig":"lXw2L","@aws-sdk/config-resolver":"jqbdY","@aws-sdk/middleware-content-length":"bExw4","@aws-sdk/middleware-host-header":"5wvMn","@aws-sdk/middleware-logger":"je9ji","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/middleware-signing":"9ClYY","@aws-sdk/middleware-user-agent":"eOqFR","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cj7CK":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lXw2L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"cj7CK","./package.json":"amvcR","@aws-crypto/sha256-browser":"4g7Q5","@aws-sdk/fetch-http-handler":"cl6qU","@aws-sdk/invalid-dependency":"hRSjn","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/util-base64-browser":"gYMH3","@aws-sdk/util-body-length-browser":"11eVP","@aws-sdk/util-user-agent-browser":"etRwc","@aws-sdk/util-utf8-browser":"2xVoW","./runtimeConfig.shared":"fsVMa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"amvcR":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-cloudwatch-logs","description":"AWS SDK for JavaScript Cloudwatch Logs Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cloudwatch-logs","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-cloudwatch-logs"}}');

},{}],"4g7Q5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("ffddeefb3c1b6798");
(0, tslib_1.__exportStar)(require("1dc2ac2aab2c7aa9"), exports);
var ie11Sha256_1 = require("b9a778ab2e8fa1c8");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("f466fca04aace2fa");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"ffddeefb3c1b6798":"f0NG2","1dc2ac2aab2c7aa9":"j4vqh","b9a778ab2e8fa1c8":"6cGRR","f466fca04aace2fa":"j7pqs"}],"f0NG2":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"j4vqh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("f7028ac4bd9d5dc3");
var webCryptoSha256_1 = require("f79958455a707d37");
var sha256_js_1 = require("2499c1ce736486b");
var supports_web_crypto_1 = require("2472a1e663db88b8");
var ie11_detection_1 = require("9b4b2eae3a41debf");
var util_locate_window_1 = require("2cb0f68bd2e5b593");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"f7028ac4bd9d5dc3":"6cGRR","f79958455a707d37":"j7pqs","2499c1ce736486b":"3UYhH","2472a1e663db88b8":"c1EaC","9b4b2eae3a41debf":"24fpZ","2cb0f68bd2e5b593":"iQfdF"}],"6cGRR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("4a29680bf7f23134");
var constants_1 = require("b33f4eb22ae85f98");
var util_utf8_browser_1 = require("7fbebddfaae1857a");
var util_locate_window_1 = require("931c9832f3965abb");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"4a29680bf7f23134":"kP9xV","b33f4eb22ae85f98":"2NlaI","7fbebddfaae1857a":"2xVoW","931c9832f3965abb":"iQfdF"}],"kP9xV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"2NlaI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"2xVoW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"58nLi","./whatwgEncodingApi":"ln0ba","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"58nLi":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ln0ba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iQfdF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locateWindow", ()=>locateWindow);
const fallbackWindow = {};
function locateWindow() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return fallbackWindow;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"j7pqs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("e935c98621ea7173");
var constants_1 = require("403d0bf5c8965d15");
var util_locate_window_1 = require("adbe685e46455eeb");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"e935c98621ea7173":"ksthJ","403d0bf5c8965d15":"2NlaI","adbe685e46455eeb":"iQfdF"}],"ksthJ":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("c1c9ba71784ad33b");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("ba54c5a12081cc84");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("b172a4a644bf0671");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("7e93e4fa9c65dbdb");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"c1c9ba71784ad33b":"9S9kJ","ba54c5a12081cc84":"5JmSs","b172a4a644bf0671":"9AVP8","7e93e4fa9c65dbdb":"83e7r"}],"9S9kJ":[function(require,module,exports) {
var Buffer = require("3031dae4fe8b3222").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("a45be5b700671e9f");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"3031dae4fe8b3222":"8EcTH","a45be5b700671e9f":"2xVoW"}],"5JmSs":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"9AVP8":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"83e7r":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"3UYhH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("26a86427a1bb68c0");
(0, tslib_1.__exportStar)(require("a0f1980bb68d9173"), exports);

},{"26a86427a1bb68c0":"kfkrY","a0f1980bb68d9173":"gp7qK"}],"kfkrY":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gp7qK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("2d6bd71344f384e7");
var constants_1 = require("1c5d82f3706ee2fb");
var RawSha256_1 = require("8c7072f648107769");
var util_1 = require("6b7958937a70479f");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"2d6bd71344f384e7":"kfkrY","1c5d82f3706ee2fb":"idzj6","8c7072f648107769":"6ykRH","6b7958937a70479f":"ksthJ"}],"idzj6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"6ykRH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("8c98c67d1aad38c1");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"8c98c67d1aad38c1":"idzj6"}],"c1EaC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("75096c140124b1c3");
tslib_1.__exportStar(require("71979359ad868078"), exports);

},{"75096c140124b1c3":"enGh9","71979359ad868078":"9gel6"}],"enGh9":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9gel6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("fac78aeb50a8e845");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"fac78aeb50a8e845":"enGh9"}],"24fpZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("5c07b11222d359e9");
tslib_1.__exportStar(require("269f31834990a330"), exports);
tslib_1.__exportStar(require("ca7df97a2ee59d08"), exports);
tslib_1.__exportStar(require("b943754eb1fdf492"), exports);
tslib_1.__exportStar(require("3795690736d5ac04"), exports);
tslib_1.__exportStar(require("5c1e8dedc5f2e9e7"), exports);

},{"5c07b11222d359e9":"iyYr0","269f31834990a330":"8z0ot","ca7df97a2ee59d08":"3bqeU","b943754eb1fdf492":"1pCyq","3795690736d5ac04":"c2cqY","5c1e8dedc5f2e9e7":"ic8BM"}],"iyYr0":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8z0ot":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"3bqeU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1pCyq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"c2cqY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"ic8BM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"cl6qU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"abpP9","./stream-collector":"4GELU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"abpP9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, _querystringBuilder.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, _protocolHttp.HttpResponse)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, _protocolHttp.HttpResponse)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();

},{"tslib":"9gMVn","@aws-sdk/protocol-http":"8mE6Q","@aws-sdk/querystring-builder":"i2YjS","./request-timeout":"bmqOI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8mE6Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpResponse":"9aebC","./httpRequest":"ddyzl","./httpHandler":"cuamQ","./isValidHostname":"i8rNG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9aebC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ddyzl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spread)(param) : param, _a));
    }, {});
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cuamQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i8rNG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i2YjS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, _utilUriEscape.escapeUri)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, _utilUriEscape.escapeUri)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"9gMVn","@aws-sdk/util-uri-escape":"lfLZs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lfLZs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"hXlCH","./escape-uri-path":"kj3Gr","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hXlCH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
var escapeUri = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kj3Gr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
var escapeUriPath = function(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"hXlCH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bmqOI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4GELU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"9gMVn","@aws-sdk/util-base64-browser":"gYMH3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gYMH3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a base-64 encoded string to a Uint8Array of bytes.
 *
 * @param input The base-64 encoded string
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */ parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
/**
 * Converts a Uint8Array of binary data to a base-64 encoded string.
 *
 * @param input The binary data to encode
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */ parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hRSjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"4KPaD","./invalidProvider":"7DqbE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4KPaD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", ()=>invalidFunction);
var invalidFunction = function(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7DqbE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", ()=>invalidProvider);
var invalidProvider = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bTgA6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _defaultStrategy = require("./defaultStrategy");
parcelHelpers.exportAll(_defaultStrategy, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);

},{"./retryMiddleware":"hEigm","./omitRetryHeadersMiddleware":"7YQpb","./defaultStrategy":"bu55M","./configurations":"2xDCX","./delayDecider":"Lr8am","./retryDecider":"9LiA0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hEigm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
parcelHelpers.export(exports, "retryMiddlewareOptions", ()=>retryMiddlewareOptions);
parcelHelpers.export(exports, "getRetryPlugin", ()=>getRetryPlugin);
var _tslib = require("tslib");
var retryMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode) context.userAgent = (0, _tslib.__spread)(context.userAgent || [], [
                        [
                            "cfg/retry-mode",
                            options.retryStrategy.mode
                        ]
                    ]);
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7YQpb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", ()=>omitRetryHeadersMiddleware);
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", ()=>omitRetryHeadersMiddlewareOptions);
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", ()=>getOmitRetryHeadersPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"9gMVn","@aws-sdk/protocol-http":"8mE6Q","./constants":"b0vhj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b0vhj":[function(require,module,exports) {
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", ()=>DEFAULT_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", ()=>MAXIMUM_RETRY_DELAY);
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", ()=>THROTTLING_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", ()=>INITIAL_RETRY_TOKENS);
parcelHelpers.export(exports, "RETRY_COST", ()=>RETRY_COST);
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", ()=>TIMEOUT_RETRY_COST);
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", ()=>NO_RETRY_INCREMENT);
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", ()=>INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "REQUEST_HEADER", ()=>REQUEST_HEADER);
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bu55M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", ()=>DEFAULT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", ()=>DEFAULT_RETRY_MODE);
parcelHelpers.export(exports, "StandardRetryStrategy", ()=>StandardRetryStrategy);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = "standard";
var StandardRetryStrategy = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = DEFAULT_RETRY_MODE;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = DEFAULT_MAX_ATTEMPTS;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, _tslib.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err_1) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();

},{"tslib":"9gMVn","@aws-sdk/protocol-http":"8mE6Q","@aws-sdk/service-error-classification":"kMOVC","uuid":"9dBTc","./constants":"b0vhj","./defaultRetryQuota":"4dIyn","./delayDecider":"Lr8am","./retryDecider":"9LiA0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kMOVC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", ()=>isRetryableByTrait);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
parcelHelpers.export(exports, "isThrottlingError", ()=>isThrottlingError);
parcelHelpers.export(exports, "isTransientError", ()=>isTransientError);
var _constants = require("./constants");
var isRetryableByTrait = function(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"6SKs7","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6SKs7":[function(require,module,exports) {
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", ()=>CLOCK_SKEW_ERROR_CODES);
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", ()=>THROTTLING_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", ()=>TRANSIENT_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", ()=>TRANSIENT_ERROR_STATUS_CODES);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9dBTc":[function(require,module,exports) {
var v1 = require("c6df88204e1f4299");
var v4 = require("3855f0864044f01d");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"c6df88204e1f4299":"dhDPn","3855f0864044f01d":"1Bmhi"}],"dhDPn":[function(require,module,exports) {
var rng = require("3d2d1ae5ae56a8b5");
var bytesToUuid = require("862e80dd3f0567cf");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"3d2d1ae5ae56a8b5":"b1P75","862e80dd3f0567cf":"6gEEh"}],"b1P75":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"6gEEh":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"1Bmhi":[function(require,module,exports) {
var rng = require("24932e89aef21842");
var bytesToUuid = require("5cc20217cefb381c");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"24932e89aef21842":"b1P75","5cc20217cefb381c":"6gEEh"}],"4dIyn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", ()=>getDefaultRetryQuota);
var _constants = require("./constants");
var getDefaultRetryQuota = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, _constants.TIMEOUT_RETRY_COST) : (0, _constants.RETRY_COST);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, _constants.NO_RETRY_INCREMENT);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"b0vhj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"Lr8am":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", ()=>defaultDelayDecider);
var _constants = require("./constants");
var defaultDelayDecider = function(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"b0vhj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9LiA0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", ()=>defaultRetryDecider);
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"kMOVC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2xDCX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", ()=>ENV_MAX_ATTEMPTS);
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", ()=>CONFIG_MAX_ATTEMPTS);
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", ()=>NODE_MAX_ATTEMPT_CONFIG_OPTIONS);
parcelHelpers.export(exports, "resolveRetryConfig", ()=>resolveRetryConfig);
parcelHelpers.export(exports, "ENV_RETRY_MODE", ()=>ENV_RETRY_MODE);
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", ()=>CONFIG_RETRY_MODE);
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", ()=>NODE_RETRY_MODE_CONFIG_OPTIONS);
var _tslib = require("tslib");
var _defaultStrategy = require("./defaultStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + ENV_MAX_ATTEMPTS + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + CONFIG_MAX_ATTEMPTS + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    default: (0, _defaultStrategy.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function(input) {
    var maxAttempts = normalizeMaxAttempts(input.maxAttempts);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, _defaultStrategy.StandardRetryStrategy)(maxAttempts)
    });
};
var normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, _defaultStrategy.DEFAULT_MAX_ATTEMPTS);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _defaultStrategy.DEFAULT_RETRY_MODE)
};

},{"tslib":"9gMVn","./defaultStrategy":"bu55M","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"11eVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", ()=>calculateBodyLength);
function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"etRwc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"dFIgQ","bowser":"oLvzi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dFIgQ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"oLvzi":[function(require,module,exports) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

},{}],"fsVMa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2014-03-28",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "CloudWatch Logs",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"2l68n","@aws-sdk/url-parser":"gQeEv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2l68n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "logs.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "logs.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "logs.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "logs.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "logs.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "logs.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "logs.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "logs.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "logs.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "logs.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "logs.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "logs.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "logs.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "logs.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "logs.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "logs.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "logs.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "logs.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "logs.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "logs.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "logs.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "logs-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "logs-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "logs-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "logs-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "logs.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "logs.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "logs.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "logs.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "logs.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "logs.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "logs.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "logs.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "logs.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "logs.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "logs"
    }, regionInfo));
};

},{"tslib":"cj7CK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gQeEv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"1nY1U","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1nY1U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jqbdY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./EndpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./RegionConfig");
parcelHelpers.exportAll(_regionConfig, exports);

},{"./EndpointsConfig":"ejl7q","./RegionConfig":"bQ37R","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ejl7q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", ()=>resolveEndpointsConfig);
var _tslib = require("tslib");
var resolveEndpointsConfig = function(input) {
    var _a;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? normalizeEndpoint(input) : function() {
            return getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var getEndPointFromRegion = function(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bQ37R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", ()=>REGION_ENV_NAME);
parcelHelpers.export(exports, "REGION_INI_NAME", ()=>REGION_INI_NAME);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", ()=>NODE_REGION_CONFIG_OPTIONS);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", ()=>NODE_REGION_CONFIG_FILE_OPTIONS);
parcelHelpers.export(exports, "resolveRegionConfig", ()=>resolveRegionConfig);
var _tslib = require("tslib");
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};
var resolveRegionConfig = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: normalizeRegion(input.region)
    });
};
var normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bExw4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", ()=>contentLengthMiddleware);
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", ()=>contentLengthMiddlewareOptions);
parcelHelpers.export(exports, "getContentLengthPlugin", ()=>getContentLengthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"9gMVn","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5wvMn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"3qExH","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3qExH":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"je9ji":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"kK2K8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kK2K8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"4vhpK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4vhpK":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9ClYY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"g28o1","./middleware":"cITh6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g28o1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", ()=>resolveAwsAuthConfig);
var _tslib = require("tslib");
var _signatureV4 = require("@aws-sdk/signature-v4");
function resolveAwsAuthConfig(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return normalizeProvider(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            //signing name resolving order:
            //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
            input.signingName = input.signingName || signingService || input.serviceId;
            return new (0, _signatureV4.SignatureV4)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}

},{"tslib":"9gMVn","@aws-sdk/signature-v4":"5ZSd8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5ZSd8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);

},{"./credentialDerivation":"3Tfe5","./SignatureV4":"jWQQu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Tfe5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a string describing the scope of credentials used to sign a request.
 *
 * @param shortDate The current calendar date in the form YYYYMMDD.
 * @param region    The AWS region in which the service resides.
 * @param service   The service to which the signed request is being sent.
 */ parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
/**
 * @internal
 */ parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
function createScope(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, _constants.KEY_TYPE_IDENTIFIER);
}
var getSigningKey = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, _utilHexEncoding.toHex)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in signingKeyCache) return [
                        2 /*return*/ ,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
}
function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}

},{"tslib":"9gMVn","@aws-sdk/util-hex-encoding":"1T3Ny","./constants":"WoiUL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"WoiUL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jWQQu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _hasHeader = require("./hasHeader");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = normalizeRegionProvider(region);
        this.credentialProvider = normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = credentials.accessKeyId + "/" + scope;
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _hasHeader.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = (0, _constants.ALGORITHM_IDENTIFIER) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, _getCanonicalQuery.getCanonicalQuery)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, _constants.ALGORITHM_IDENTIFIER) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, _utilHexEncoding.toHex)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var formatDate = function(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};

},{"tslib":"9gMVn","@aws-sdk/util-hex-encoding":"1T3Ny","./constants":"WoiUL","./credentialDerivation":"3Tfe5","./getCanonicalHeaders":"bbtwA","./getCanonicalQuery":"g3HjR","./getPayloadHash":"5VcEi","./hasHeader":"epz90","./moveHeadersToQuery":"hrm1r","./prepareRequest":"gti7f","./utilDate":"llJ3g","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bbtwA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _tslib = require("tslib");
var _constants = require("./constants");
function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}

},{"tslib":"9gMVn","./constants":"WoiUL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g3HjR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, _utilUriEscape.escapeUri)(key) + "=" + (0, _utilUriEscape.escapeUri)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, _utilUriEscape.escapeUri)(key) + "=" + (0, _utilUriEscape.escapeUri)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}

},{"tslib":"9gMVn","@aws-sdk/util-uri-escape":"lfLZs","./constants":"WoiUL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5VcEi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
}

},{"tslib":"9gMVn","@aws-sdk/is-array-buffer":"kRl91","@aws-sdk/util-hex-encoding":"1T3Ny","./constants":"WoiUL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kRl91":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"epz90":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
var _tslib = require("tslib");
function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hrm1r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
}

},{"tslib":"9gMVn","./cloneRequest":"ccSFb","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ccSFb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
var _tslib = require("tslib");
function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
}
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spread)(param) : param, _a));
    }, {});
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gti7f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
function prepareRequest(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}

},{"tslib":"9gMVn","./cloneRequest":"ccSFb","./constants":"WoiUL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"llJ3g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cITh6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", ()=>awsAuthMiddleware);
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", ()=>awsAuthMiddlewareOptions);
parcelHelpers.export(exports, "getAwsAuthPlugin", ()=>getAwsAuthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if (isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};

},{"tslib":"9gMVn","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eOqFR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"lFSn3","./user-agent-middleware":"h3ZGB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lFSn3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"cj7cj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cj7cj":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h3ZGB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, _constants.X_AMZ_USER_AGENT] = (0, _tslib.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, _constants.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, _constants.USER_AGENT] = headers[0, _constants.USER_AGENT] ? headers[0, _constants.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"cj7cj","@aws-sdk/protocol-http":"8mE6Q","./constants":"aSTYM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aSTYM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2tZeK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _documentType = require("./document-type");
parcelHelpers.exportAll(_documentType, exports);
var _exception = require("./exception");
parcelHelpers.exportAll(_exception, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _retryableTrait = require("./retryable-trait");
parcelHelpers.exportAll(_retryableTrait, exports);
var _sdkError = require("./sdk-error");
parcelHelpers.exportAll(_sdkError, exports);

},{"./client":"6Vule","./command":"l2ihV","./document-type":"ltol7","./exception":"6AkCr","./extended-encode-uri-component":"bBzJo","./get-array-if-single-item":"ej513","./get-value-from-text-node":"g5jg2","./lazy-json":"5juUy","./date-utils":"hzQOL","./split-every":"aWCTo","./constants":"7mp1d","./retryable-trait":"bUadz","./sdk-error":"ehSWn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6Vule":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"2zttG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2zttG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"11dMr","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"11dMr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", ()=>constructStack);
var _tslib = require("tslib");
var constructStack = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spread)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spread)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, _tslib.__spread)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"' + name + '" middleware with ' + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"' + name + '" middleware ' + toOverride.relation + ' "' + toOverride.toMiddleware + '" middleware cannot be overridden ' + ("by same-name middleware " + entry.relation + ' "' + entry.toMiddleware + '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo(constructStack());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l2ihV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"2zttG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ltol7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6AkCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bBzJo":[function(require,module,exports) {
/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ej513":[function(require,module,exports) {
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", ()=>getArrayIfSingleItem);
var getArrayIfSingleItem = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g5jg2":[function(require,module,exports) {
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", ()=>getValueFromTextNode);
var getValueFromTextNode = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5juUy":[function(require,module,exports) {
/**
 * Lazy String holder for JSON typed contents.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", ()=>StringWrapper);
parcelHelpers.export(exports, "LazyJsonString", ()=>LazyJsonString);
var _tslib = require("tslib");
var StringWrapper = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spread)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = /** @class */ function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hzQOL":[function(require,module,exports) {
/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", ()=>dateToUtcString);
var days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return days[dayOfWeek] + ", " + dayOfMonthString + " " + months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aWCTo":[function(require,module,exports) {
/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", ()=>splitEvery);
function splitEvery(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7mp1d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", ()=>SENSITIVE_STRING);
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bUadz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ehSWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6dqtq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateLogGroupCommand", ()=>CreateLogGroupCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Creates a log group with the specified name. You can create up to 20,000 log groups per account.</p>
 *          <p>You must use the following guidelines when naming a log group:</p>
 *          <ul>
 *             <li>
 *                <p>Log group names must be unique within a region for an AWS account.</p>
 *             </li>
 *             <li>
 *                <p>Log group names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>Log group names consist of the following characters: a-z, A-Z, 0-9, '_' (underscore), '-' (hyphen),
 *           '/' (forward slash), '.' (period), and '#' (number sign)</p>
 *             </li>
 *          </ul>
 *          <p>When you create a log group, by default the log events in the log group never expire. To set
 *     a retention policy so that events expire and are deleted after a specified time, use
 *       <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutRetentionPolicy.html">PutRetentionPolicy</a>.</p>
 *          <p>If you associate a AWS Key Management Service (AWS KMS) customer master key (CMK) with the log group, ingested data is encrypted using the CMK.
 *       This association is stored as long as the data encrypted with the CMK is still within Amazon CloudWatch Logs.
 *       This enables Amazon CloudWatch Logs to decrypt this data whenever it is requested.</p>
 *          <p>If you attempt to associate a CMK with the log group but the CMK does not exist or the
 *       CMK is disabled, you receive an <code>InvalidParameterException</code> error. </p>
 *          <important>
 *             <p> CloudWatch Logs supports only symmetric CMKs. Do not associate an asymmetric CMK with
 *         your log group. For more information, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/symmetric-asymmetric.html">Using Symmetric and Asymmetric
 *           Keys</a>.</p>
 *          </important>
 */ var CreateLogGroupCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(CreateLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogGroupCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateLogGroupCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.CreateLogGroupRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogGroupCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1CreateLogGroupCommand)(input, context);
    };
    CreateLogGroupCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1CreateLogGroupCommand)(output, context);
    };
    return CreateLogGroupCommand;
}((0, _smithyClient.Command));

},{"tslib":"cj7CK","../models/models_0":"c7igR","../protocols/Aws_json1_1":"1HpDx","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"c7igR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssociateKmsKeyRequest", ()=>AssociateKmsKeyRequest);
parcelHelpers.export(exports, "InvalidParameterException", ()=>InvalidParameterException);
parcelHelpers.export(exports, "OperationAbortedException", ()=>OperationAbortedException);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "ServiceUnavailableException", ()=>ServiceUnavailableException);
parcelHelpers.export(exports, "CancelExportTaskRequest", ()=>CancelExportTaskRequest);
parcelHelpers.export(exports, "InvalidOperationException", ()=>InvalidOperationException);
parcelHelpers.export(exports, "CreateExportTaskRequest", ()=>CreateExportTaskRequest);
parcelHelpers.export(exports, "CreateExportTaskResponse", ()=>CreateExportTaskResponse);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "ResourceAlreadyExistsException", ()=>ResourceAlreadyExistsException);
parcelHelpers.export(exports, "CreateLogGroupRequest", ()=>CreateLogGroupRequest);
parcelHelpers.export(exports, "CreateLogStreamRequest", ()=>CreateLogStreamRequest);
parcelHelpers.export(exports, "DataAlreadyAcceptedException", ()=>DataAlreadyAcceptedException);
parcelHelpers.export(exports, "DeleteDestinationRequest", ()=>DeleteDestinationRequest);
parcelHelpers.export(exports, "DeleteLogGroupRequest", ()=>DeleteLogGroupRequest);
parcelHelpers.export(exports, "DeleteLogStreamRequest", ()=>DeleteLogStreamRequest);
parcelHelpers.export(exports, "DeleteMetricFilterRequest", ()=>DeleteMetricFilterRequest);
parcelHelpers.export(exports, "DeleteQueryDefinitionRequest", ()=>DeleteQueryDefinitionRequest);
parcelHelpers.export(exports, "DeleteQueryDefinitionResponse", ()=>DeleteQueryDefinitionResponse);
parcelHelpers.export(exports, "DeleteResourcePolicyRequest", ()=>DeleteResourcePolicyRequest);
parcelHelpers.export(exports, "DeleteRetentionPolicyRequest", ()=>DeleteRetentionPolicyRequest);
parcelHelpers.export(exports, "DeleteSubscriptionFilterRequest", ()=>DeleteSubscriptionFilterRequest);
parcelHelpers.export(exports, "DescribeDestinationsRequest", ()=>DescribeDestinationsRequest);
parcelHelpers.export(exports, "Destination", ()=>Destination);
parcelHelpers.export(exports, "DescribeDestinationsResponse", ()=>DescribeDestinationsResponse);
parcelHelpers.export(exports, "ExportTaskStatusCode", ()=>ExportTaskStatusCode);
parcelHelpers.export(exports, "DescribeExportTasksRequest", ()=>DescribeExportTasksRequest);
parcelHelpers.export(exports, "ExportTaskExecutionInfo", ()=>ExportTaskExecutionInfo);
parcelHelpers.export(exports, "ExportTaskStatus", ()=>ExportTaskStatus);
parcelHelpers.export(exports, "ExportTask", ()=>ExportTask);
parcelHelpers.export(exports, "DescribeExportTasksResponse", ()=>DescribeExportTasksResponse);
parcelHelpers.export(exports, "DescribeLogGroupsRequest", ()=>DescribeLogGroupsRequest);
parcelHelpers.export(exports, "LogGroup", ()=>LogGroup);
parcelHelpers.export(exports, "DescribeLogGroupsResponse", ()=>DescribeLogGroupsResponse);
parcelHelpers.export(exports, "OrderBy", ()=>OrderBy);
parcelHelpers.export(exports, "DescribeLogStreamsRequest", ()=>DescribeLogStreamsRequest);
parcelHelpers.export(exports, "LogStream", ()=>LogStream);
parcelHelpers.export(exports, "DescribeLogStreamsResponse", ()=>DescribeLogStreamsResponse);
parcelHelpers.export(exports, "DescribeMetricFiltersRequest", ()=>DescribeMetricFiltersRequest);
parcelHelpers.export(exports, "MetricTransformation", ()=>MetricTransformation);
parcelHelpers.export(exports, "MetricFilter", ()=>MetricFilter);
parcelHelpers.export(exports, "DescribeMetricFiltersResponse", ()=>DescribeMetricFiltersResponse);
parcelHelpers.export(exports, "QueryStatus", ()=>QueryStatus);
parcelHelpers.export(exports, "DescribeQueriesRequest", ()=>DescribeQueriesRequest);
parcelHelpers.export(exports, "QueryInfo", ()=>QueryInfo);
parcelHelpers.export(exports, "DescribeQueriesResponse", ()=>DescribeQueriesResponse);
parcelHelpers.export(exports, "DescribeQueryDefinitionsRequest", ()=>DescribeQueryDefinitionsRequest);
parcelHelpers.export(exports, "QueryDefinition", ()=>QueryDefinition);
parcelHelpers.export(exports, "DescribeQueryDefinitionsResponse", ()=>DescribeQueryDefinitionsResponse);
parcelHelpers.export(exports, "DescribeResourcePoliciesRequest", ()=>DescribeResourcePoliciesRequest);
parcelHelpers.export(exports, "ResourcePolicy", ()=>ResourcePolicy);
parcelHelpers.export(exports, "DescribeResourcePoliciesResponse", ()=>DescribeResourcePoliciesResponse);
parcelHelpers.export(exports, "DescribeSubscriptionFiltersRequest", ()=>DescribeSubscriptionFiltersRequest);
parcelHelpers.export(exports, "Distribution", ()=>Distribution);
parcelHelpers.export(exports, "SubscriptionFilter", ()=>SubscriptionFilter);
parcelHelpers.export(exports, "DescribeSubscriptionFiltersResponse", ()=>DescribeSubscriptionFiltersResponse);
parcelHelpers.export(exports, "DisassociateKmsKeyRequest", ()=>DisassociateKmsKeyRequest);
parcelHelpers.export(exports, "FilteredLogEvent", ()=>FilteredLogEvent);
parcelHelpers.export(exports, "FilterLogEventsRequest", ()=>FilterLogEventsRequest);
parcelHelpers.export(exports, "SearchedLogStream", ()=>SearchedLogStream);
parcelHelpers.export(exports, "FilterLogEventsResponse", ()=>FilterLogEventsResponse);
parcelHelpers.export(exports, "GetLogEventsRequest", ()=>GetLogEventsRequest);
parcelHelpers.export(exports, "OutputLogEvent", ()=>OutputLogEvent);
parcelHelpers.export(exports, "GetLogEventsResponse", ()=>GetLogEventsResponse);
parcelHelpers.export(exports, "GetLogGroupFieldsRequest", ()=>GetLogGroupFieldsRequest);
parcelHelpers.export(exports, "LogGroupField", ()=>LogGroupField);
parcelHelpers.export(exports, "GetLogGroupFieldsResponse", ()=>GetLogGroupFieldsResponse);
parcelHelpers.export(exports, "GetLogRecordRequest", ()=>GetLogRecordRequest);
parcelHelpers.export(exports, "GetLogRecordResponse", ()=>GetLogRecordResponse);
parcelHelpers.export(exports, "GetQueryResultsRequest", ()=>GetQueryResultsRequest);
parcelHelpers.export(exports, "ResultField", ()=>ResultField);
parcelHelpers.export(exports, "QueryStatistics", ()=>QueryStatistics);
parcelHelpers.export(exports, "GetQueryResultsResponse", ()=>GetQueryResultsResponse);
parcelHelpers.export(exports, "InputLogEvent", ()=>InputLogEvent);
parcelHelpers.export(exports, "InvalidSequenceTokenException", ()=>InvalidSequenceTokenException);
parcelHelpers.export(exports, "ListTagsLogGroupRequest", ()=>ListTagsLogGroupRequest);
parcelHelpers.export(exports, "ListTagsLogGroupResponse", ()=>ListTagsLogGroupResponse);
parcelHelpers.export(exports, "PutDestinationRequest", ()=>PutDestinationRequest);
parcelHelpers.export(exports, "PutDestinationResponse", ()=>PutDestinationResponse);
parcelHelpers.export(exports, "PutDestinationPolicyRequest", ()=>PutDestinationPolicyRequest);
parcelHelpers.export(exports, "PutLogEventsRequest", ()=>PutLogEventsRequest);
parcelHelpers.export(exports, "RejectedLogEventsInfo", ()=>RejectedLogEventsInfo);
parcelHelpers.export(exports, "PutLogEventsResponse", ()=>PutLogEventsResponse);
parcelHelpers.export(exports, "UnrecognizedClientException", ()=>UnrecognizedClientException);
parcelHelpers.export(exports, "PutMetricFilterRequest", ()=>PutMetricFilterRequest);
parcelHelpers.export(exports, "PutQueryDefinitionRequest", ()=>PutQueryDefinitionRequest);
parcelHelpers.export(exports, "PutQueryDefinitionResponse", ()=>PutQueryDefinitionResponse);
parcelHelpers.export(exports, "PutResourcePolicyRequest", ()=>PutResourcePolicyRequest);
parcelHelpers.export(exports, "PutResourcePolicyResponse", ()=>PutResourcePolicyResponse);
parcelHelpers.export(exports, "PutRetentionPolicyRequest", ()=>PutRetentionPolicyRequest);
parcelHelpers.export(exports, "PutSubscriptionFilterRequest", ()=>PutSubscriptionFilterRequest);
parcelHelpers.export(exports, "QueryCompileErrorLocation", ()=>QueryCompileErrorLocation);
parcelHelpers.export(exports, "QueryCompileError", ()=>QueryCompileError);
parcelHelpers.export(exports, "MalformedQueryException", ()=>MalformedQueryException);
parcelHelpers.export(exports, "StartQueryRequest", ()=>StartQueryRequest);
parcelHelpers.export(exports, "StartQueryResponse", ()=>StartQueryResponse);
parcelHelpers.export(exports, "StopQueryRequest", ()=>StopQueryRequest);
parcelHelpers.export(exports, "StopQueryResponse", ()=>StopQueryResponse);
parcelHelpers.export(exports, "TagLogGroupRequest", ()=>TagLogGroupRequest);
parcelHelpers.export(exports, "TestMetricFilterRequest", ()=>TestMetricFilterRequest);
parcelHelpers.export(exports, "MetricFilterMatchRecord", ()=>MetricFilterMatchRecord);
parcelHelpers.export(exports, "TestMetricFilterResponse", ()=>TestMetricFilterResponse);
parcelHelpers.export(exports, "UntagLogGroupRequest", ()=>UntagLogGroupRequest);
var _tslib = require("tslib");
var AssociateKmsKeyRequest;
(function(AssociateKmsKeyRequest) {
    AssociateKmsKeyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(AssociateKmsKeyRequest || (AssociateKmsKeyRequest = {}));
var InvalidParameterException;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidParameterException || (InvalidParameterException = {}));
var OperationAbortedException;
(function(OperationAbortedException) {
    OperationAbortedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OperationAbortedException || (OperationAbortedException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var CancelExportTaskRequest;
(function(CancelExportTaskRequest) {
    CancelExportTaskRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CancelExportTaskRequest || (CancelExportTaskRequest = {}));
var InvalidOperationException;
(function(InvalidOperationException) {
    InvalidOperationException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidOperationException || (InvalidOperationException = {}));
var CreateExportTaskRequest;
(function(CreateExportTaskRequest) {
    CreateExportTaskRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateExportTaskRequest || (CreateExportTaskRequest = {}));
var CreateExportTaskResponse;
(function(CreateExportTaskResponse) {
    CreateExportTaskResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateExportTaskResponse || (CreateExportTaskResponse = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceAlreadyExistsException;
(function(ResourceAlreadyExistsException) {
    ResourceAlreadyExistsException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
var CreateLogGroupRequest;
(function(CreateLogGroupRequest) {
    CreateLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateLogGroupRequest || (CreateLogGroupRequest = {}));
var CreateLogStreamRequest;
(function(CreateLogStreamRequest) {
    CreateLogStreamRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateLogStreamRequest || (CreateLogStreamRequest = {}));
var DataAlreadyAcceptedException;
(function(DataAlreadyAcceptedException) {
    DataAlreadyAcceptedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DataAlreadyAcceptedException || (DataAlreadyAcceptedException = {}));
var DeleteDestinationRequest;
(function(DeleteDestinationRequest) {
    DeleteDestinationRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDestinationRequest || (DeleteDestinationRequest = {}));
var DeleteLogGroupRequest;
(function(DeleteLogGroupRequest) {
    DeleteLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteLogGroupRequest || (DeleteLogGroupRequest = {}));
var DeleteLogStreamRequest;
(function(DeleteLogStreamRequest) {
    DeleteLogStreamRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteLogStreamRequest || (DeleteLogStreamRequest = {}));
var DeleteMetricFilterRequest;
(function(DeleteMetricFilterRequest) {
    DeleteMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteMetricFilterRequest || (DeleteMetricFilterRequest = {}));
var DeleteQueryDefinitionRequest;
(function(DeleteQueryDefinitionRequest) {
    DeleteQueryDefinitionRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteQueryDefinitionRequest || (DeleteQueryDefinitionRequest = {}));
var DeleteQueryDefinitionResponse;
(function(DeleteQueryDefinitionResponse) {
    DeleteQueryDefinitionResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteQueryDefinitionResponse || (DeleteQueryDefinitionResponse = {}));
var DeleteResourcePolicyRequest;
(function(DeleteResourcePolicyRequest) {
    DeleteResourcePolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteResourcePolicyRequest || (DeleteResourcePolicyRequest = {}));
var DeleteRetentionPolicyRequest;
(function(DeleteRetentionPolicyRequest) {
    DeleteRetentionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteRetentionPolicyRequest || (DeleteRetentionPolicyRequest = {}));
var DeleteSubscriptionFilterRequest;
(function(DeleteSubscriptionFilterRequest) {
    DeleteSubscriptionFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteSubscriptionFilterRequest || (DeleteSubscriptionFilterRequest = {}));
var DescribeDestinationsRequest;
(function(DescribeDestinationsRequest) {
    DescribeDestinationsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDestinationsRequest || (DescribeDestinationsRequest = {}));
var Destination;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Destination || (Destination = {}));
var DescribeDestinationsResponse;
(function(DescribeDestinationsResponse) {
    DescribeDestinationsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDestinationsResponse || (DescribeDestinationsResponse = {}));
var ExportTaskStatusCode;
(function(ExportTaskStatusCode) {
    ExportTaskStatusCode["CANCELLED"] = "CANCELLED";
    ExportTaskStatusCode["COMPLETED"] = "COMPLETED";
    ExportTaskStatusCode["FAILED"] = "FAILED";
    ExportTaskStatusCode["PENDING"] = "PENDING";
    ExportTaskStatusCode["PENDING_CANCEL"] = "PENDING_CANCEL";
    ExportTaskStatusCode["RUNNING"] = "RUNNING";
})(ExportTaskStatusCode || (ExportTaskStatusCode = {}));
var DescribeExportTasksRequest;
(function(DescribeExportTasksRequest) {
    DescribeExportTasksRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeExportTasksRequest || (DescribeExportTasksRequest = {}));
var ExportTaskExecutionInfo;
(function(ExportTaskExecutionInfo) {
    ExportTaskExecutionInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTaskExecutionInfo || (ExportTaskExecutionInfo = {}));
var ExportTaskStatus;
(function(ExportTaskStatus) {
    ExportTaskStatus.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTaskStatus || (ExportTaskStatus = {}));
var ExportTask;
(function(ExportTask) {
    ExportTask.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTask || (ExportTask = {}));
var DescribeExportTasksResponse;
(function(DescribeExportTasksResponse) {
    DescribeExportTasksResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeExportTasksResponse || (DescribeExportTasksResponse = {}));
var DescribeLogGroupsRequest;
(function(DescribeLogGroupsRequest) {
    DescribeLogGroupsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogGroupsRequest || (DescribeLogGroupsRequest = {}));
var LogGroup;
(function(LogGroup) {
    LogGroup.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogGroup || (LogGroup = {}));
var DescribeLogGroupsResponse;
(function(DescribeLogGroupsResponse) {
    DescribeLogGroupsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogGroupsResponse || (DescribeLogGroupsResponse = {}));
var OrderBy;
(function(OrderBy) {
    OrderBy["LastEventTime"] = "LastEventTime";
    OrderBy["LogStreamName"] = "LogStreamName";
})(OrderBy || (OrderBy = {}));
var DescribeLogStreamsRequest;
(function(DescribeLogStreamsRequest) {
    DescribeLogStreamsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogStreamsRequest || (DescribeLogStreamsRequest = {}));
var LogStream;
(function(LogStream) {
    LogStream.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogStream || (LogStream = {}));
var DescribeLogStreamsResponse;
(function(DescribeLogStreamsResponse) {
    DescribeLogStreamsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogStreamsResponse || (DescribeLogStreamsResponse = {}));
var DescribeMetricFiltersRequest;
(function(DescribeMetricFiltersRequest) {
    DescribeMetricFiltersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeMetricFiltersRequest || (DescribeMetricFiltersRequest = {}));
var MetricTransformation;
(function(MetricTransformation) {
    MetricTransformation.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricTransformation || (MetricTransformation = {}));
var MetricFilter;
(function(MetricFilter) {
    MetricFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricFilter || (MetricFilter = {}));
var DescribeMetricFiltersResponse;
(function(DescribeMetricFiltersResponse) {
    DescribeMetricFiltersResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeMetricFiltersResponse || (DescribeMetricFiltersResponse = {}));
var QueryStatus;
(function(QueryStatus) {
    QueryStatus["Cancelled"] = "Cancelled";
    QueryStatus["Complete"] = "Complete";
    QueryStatus["Failed"] = "Failed";
    QueryStatus["Running"] = "Running";
    QueryStatus["Scheduled"] = "Scheduled";
})(QueryStatus || (QueryStatus = {}));
var DescribeQueriesRequest;
(function(DescribeQueriesRequest) {
    DescribeQueriesRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueriesRequest || (DescribeQueriesRequest = {}));
var QueryInfo;
(function(QueryInfo) {
    QueryInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryInfo || (QueryInfo = {}));
var DescribeQueriesResponse;
(function(DescribeQueriesResponse) {
    DescribeQueriesResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueriesResponse || (DescribeQueriesResponse = {}));
var DescribeQueryDefinitionsRequest;
(function(DescribeQueryDefinitionsRequest) {
    DescribeQueryDefinitionsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueryDefinitionsRequest || (DescribeQueryDefinitionsRequest = {}));
var QueryDefinition;
(function(QueryDefinition) {
    QueryDefinition.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryDefinition || (QueryDefinition = {}));
var DescribeQueryDefinitionsResponse;
(function(DescribeQueryDefinitionsResponse) {
    DescribeQueryDefinitionsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueryDefinitionsResponse || (DescribeQueryDefinitionsResponse = {}));
var DescribeResourcePoliciesRequest;
(function(DescribeResourcePoliciesRequest) {
    DescribeResourcePoliciesRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeResourcePoliciesRequest || (DescribeResourcePoliciesRequest = {}));
var ResourcePolicy;
(function(ResourcePolicy) {
    ResourcePolicy.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourcePolicy || (ResourcePolicy = {}));
var DescribeResourcePoliciesResponse;
(function(DescribeResourcePoliciesResponse) {
    DescribeResourcePoliciesResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeResourcePoliciesResponse || (DescribeResourcePoliciesResponse = {}));
var DescribeSubscriptionFiltersRequest;
(function(DescribeSubscriptionFiltersRequest) {
    DescribeSubscriptionFiltersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeSubscriptionFiltersRequest || (DescribeSubscriptionFiltersRequest = {}));
var Distribution;
(function(Distribution) {
    Distribution["ByLogStream"] = "ByLogStream";
    Distribution["Random"] = "Random";
})(Distribution || (Distribution = {}));
var SubscriptionFilter;
(function(SubscriptionFilter) {
    SubscriptionFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscriptionFilter || (SubscriptionFilter = {}));
var DescribeSubscriptionFiltersResponse;
(function(DescribeSubscriptionFiltersResponse) {
    DescribeSubscriptionFiltersResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeSubscriptionFiltersResponse || (DescribeSubscriptionFiltersResponse = {}));
var DisassociateKmsKeyRequest;
(function(DisassociateKmsKeyRequest) {
    DisassociateKmsKeyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DisassociateKmsKeyRequest || (DisassociateKmsKeyRequest = {}));
var FilteredLogEvent;
(function(FilteredLogEvent) {
    FilteredLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilteredLogEvent || (FilteredLogEvent = {}));
var FilterLogEventsRequest;
(function(FilterLogEventsRequest) {
    FilterLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilterLogEventsRequest || (FilterLogEventsRequest = {}));
var SearchedLogStream;
(function(SearchedLogStream) {
    SearchedLogStream.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SearchedLogStream || (SearchedLogStream = {}));
var FilterLogEventsResponse;
(function(FilterLogEventsResponse) {
    FilterLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilterLogEventsResponse || (FilterLogEventsResponse = {}));
var GetLogEventsRequest;
(function(GetLogEventsRequest) {
    GetLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogEventsRequest || (GetLogEventsRequest = {}));
var OutputLogEvent;
(function(OutputLogEvent) {
    OutputLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OutputLogEvent || (OutputLogEvent = {}));
var GetLogEventsResponse;
(function(GetLogEventsResponse) {
    GetLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogEventsResponse || (GetLogEventsResponse = {}));
var GetLogGroupFieldsRequest;
(function(GetLogGroupFieldsRequest) {
    GetLogGroupFieldsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogGroupFieldsRequest || (GetLogGroupFieldsRequest = {}));
var LogGroupField;
(function(LogGroupField) {
    LogGroupField.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogGroupField || (LogGroupField = {}));
var GetLogGroupFieldsResponse;
(function(GetLogGroupFieldsResponse) {
    GetLogGroupFieldsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogGroupFieldsResponse || (GetLogGroupFieldsResponse = {}));
var GetLogRecordRequest;
(function(GetLogRecordRequest) {
    GetLogRecordRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogRecordRequest || (GetLogRecordRequest = {}));
var GetLogRecordResponse;
(function(GetLogRecordResponse) {
    GetLogRecordResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogRecordResponse || (GetLogRecordResponse = {}));
var GetQueryResultsRequest;
(function(GetQueryResultsRequest) {
    GetQueryResultsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetQueryResultsRequest || (GetQueryResultsRequest = {}));
var ResultField;
(function(ResultField) {
    ResultField.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResultField || (ResultField = {}));
var QueryStatistics;
(function(QueryStatistics) {
    QueryStatistics.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryStatistics || (QueryStatistics = {}));
var GetQueryResultsResponse;
(function(GetQueryResultsResponse) {
    GetQueryResultsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetQueryResultsResponse || (GetQueryResultsResponse = {}));
var InputLogEvent;
(function(InputLogEvent) {
    InputLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InputLogEvent || (InputLogEvent = {}));
var InvalidSequenceTokenException;
(function(InvalidSequenceTokenException) {
    InvalidSequenceTokenException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidSequenceTokenException || (InvalidSequenceTokenException = {}));
var ListTagsLogGroupRequest;
(function(ListTagsLogGroupRequest) {
    ListTagsLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsLogGroupRequest || (ListTagsLogGroupRequest = {}));
var ListTagsLogGroupResponse;
(function(ListTagsLogGroupResponse) {
    ListTagsLogGroupResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsLogGroupResponse || (ListTagsLogGroupResponse = {}));
var PutDestinationRequest;
(function(PutDestinationRequest) {
    PutDestinationRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationRequest || (PutDestinationRequest = {}));
var PutDestinationResponse;
(function(PutDestinationResponse) {
    PutDestinationResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationResponse || (PutDestinationResponse = {}));
var PutDestinationPolicyRequest;
(function(PutDestinationPolicyRequest) {
    PutDestinationPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationPolicyRequest || (PutDestinationPolicyRequest = {}));
var PutLogEventsRequest;
(function(PutLogEventsRequest) {
    PutLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutLogEventsRequest || (PutLogEventsRequest = {}));
var RejectedLogEventsInfo;
(function(RejectedLogEventsInfo) {
    RejectedLogEventsInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RejectedLogEventsInfo || (RejectedLogEventsInfo = {}));
var PutLogEventsResponse;
(function(PutLogEventsResponse) {
    PutLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutLogEventsResponse || (PutLogEventsResponse = {}));
var UnrecognizedClientException;
(function(UnrecognizedClientException) {
    UnrecognizedClientException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UnrecognizedClientException || (UnrecognizedClientException = {}));
var PutMetricFilterRequest;
(function(PutMetricFilterRequest) {
    PutMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutMetricFilterRequest || (PutMetricFilterRequest = {}));
var PutQueryDefinitionRequest;
(function(PutQueryDefinitionRequest) {
    PutQueryDefinitionRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutQueryDefinitionRequest || (PutQueryDefinitionRequest = {}));
var PutQueryDefinitionResponse;
(function(PutQueryDefinitionResponse) {
    PutQueryDefinitionResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutQueryDefinitionResponse || (PutQueryDefinitionResponse = {}));
var PutResourcePolicyRequest;
(function(PutResourcePolicyRequest) {
    PutResourcePolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutResourcePolicyRequest || (PutResourcePolicyRequest = {}));
var PutResourcePolicyResponse;
(function(PutResourcePolicyResponse) {
    PutResourcePolicyResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutResourcePolicyResponse || (PutResourcePolicyResponse = {}));
var PutRetentionPolicyRequest;
(function(PutRetentionPolicyRequest) {
    PutRetentionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRetentionPolicyRequest || (PutRetentionPolicyRequest = {}));
var PutSubscriptionFilterRequest;
(function(PutSubscriptionFilterRequest) {
    PutSubscriptionFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutSubscriptionFilterRequest || (PutSubscriptionFilterRequest = {}));
var QueryCompileErrorLocation;
(function(QueryCompileErrorLocation) {
    QueryCompileErrorLocation.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryCompileErrorLocation || (QueryCompileErrorLocation = {}));
var QueryCompileError;
(function(QueryCompileError) {
    QueryCompileError.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryCompileError || (QueryCompileError = {}));
var MalformedQueryException;
(function(MalformedQueryException) {
    MalformedQueryException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MalformedQueryException || (MalformedQueryException = {}));
var StartQueryRequest;
(function(StartQueryRequest) {
    StartQueryRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartQueryRequest || (StartQueryRequest = {}));
var StartQueryResponse;
(function(StartQueryResponse) {
    StartQueryResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartQueryResponse || (StartQueryResponse = {}));
var StopQueryRequest;
(function(StopQueryRequest) {
    StopQueryRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopQueryRequest || (StopQueryRequest = {}));
var StopQueryResponse;
(function(StopQueryResponse) {
    StopQueryResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopQueryResponse || (StopQueryResponse = {}));
var TagLogGroupRequest;
(function(TagLogGroupRequest) {
    TagLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagLogGroupRequest || (TagLogGroupRequest = {}));
var TestMetricFilterRequest;
(function(TestMetricFilterRequest) {
    TestMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TestMetricFilterRequest || (TestMetricFilterRequest = {}));
var MetricFilterMatchRecord;
(function(MetricFilterMatchRecord) {
    MetricFilterMatchRecord.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricFilterMatchRecord || (MetricFilterMatchRecord = {}));
var TestMetricFilterResponse;
(function(TestMetricFilterResponse) {
    TestMetricFilterResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TestMetricFilterResponse || (TestMetricFilterResponse = {}));
var UntagLogGroupRequest;
(function(UntagLogGroupRequest) {
    UntagLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagLogGroupRequest || (UntagLogGroupRequest = {}));

},{"tslib":"cj7CK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1HpDx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1AssociateKmsKeyCommand", ()=>serializeAws_json1_1AssociateKmsKeyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CancelExportTaskCommand", ()=>serializeAws_json1_1CancelExportTaskCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateExportTaskCommand", ()=>serializeAws_json1_1CreateExportTaskCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateLogGroupCommand", ()=>serializeAws_json1_1CreateLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateLogStreamCommand", ()=>serializeAws_json1_1CreateLogStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteDestinationCommand", ()=>serializeAws_json1_1DeleteDestinationCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteLogGroupCommand", ()=>serializeAws_json1_1DeleteLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteLogStreamCommand", ()=>serializeAws_json1_1DeleteLogStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteMetricFilterCommand", ()=>serializeAws_json1_1DeleteMetricFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteQueryDefinitionCommand", ()=>serializeAws_json1_1DeleteQueryDefinitionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteResourcePolicyCommand", ()=>serializeAws_json1_1DeleteResourcePolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteRetentionPolicyCommand", ()=>serializeAws_json1_1DeleteRetentionPolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteSubscriptionFilterCommand", ()=>serializeAws_json1_1DeleteSubscriptionFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeDestinationsCommand", ()=>serializeAws_json1_1DescribeDestinationsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeExportTasksCommand", ()=>serializeAws_json1_1DescribeExportTasksCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLogGroupsCommand", ()=>serializeAws_json1_1DescribeLogGroupsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLogStreamsCommand", ()=>serializeAws_json1_1DescribeLogStreamsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeMetricFiltersCommand", ()=>serializeAws_json1_1DescribeMetricFiltersCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeQueriesCommand", ()=>serializeAws_json1_1DescribeQueriesCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeQueryDefinitionsCommand", ()=>serializeAws_json1_1DescribeQueryDefinitionsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeResourcePoliciesCommand", ()=>serializeAws_json1_1DescribeResourcePoliciesCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeSubscriptionFiltersCommand", ()=>serializeAws_json1_1DescribeSubscriptionFiltersCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DisassociateKmsKeyCommand", ()=>serializeAws_json1_1DisassociateKmsKeyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1FilterLogEventsCommand", ()=>serializeAws_json1_1FilterLogEventsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetLogEventsCommand", ()=>serializeAws_json1_1GetLogEventsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetLogGroupFieldsCommand", ()=>serializeAws_json1_1GetLogGroupFieldsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetLogRecordCommand", ()=>serializeAws_json1_1GetLogRecordCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetQueryResultsCommand", ()=>serializeAws_json1_1GetQueryResultsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsLogGroupCommand", ()=>serializeAws_json1_1ListTagsLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutDestinationCommand", ()=>serializeAws_json1_1PutDestinationCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutDestinationPolicyCommand", ()=>serializeAws_json1_1PutDestinationPolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutLogEventsCommand", ()=>serializeAws_json1_1PutLogEventsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutMetricFilterCommand", ()=>serializeAws_json1_1PutMetricFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutQueryDefinitionCommand", ()=>serializeAws_json1_1PutQueryDefinitionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutResourcePolicyCommand", ()=>serializeAws_json1_1PutResourcePolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRetentionPolicyCommand", ()=>serializeAws_json1_1PutRetentionPolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutSubscriptionFilterCommand", ()=>serializeAws_json1_1PutSubscriptionFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StartQueryCommand", ()=>serializeAws_json1_1StartQueryCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StopQueryCommand", ()=>serializeAws_json1_1StopQueryCommand);
parcelHelpers.export(exports, "serializeAws_json1_1TagLogGroupCommand", ()=>serializeAws_json1_1TagLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1TestMetricFilterCommand", ()=>serializeAws_json1_1TestMetricFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UntagLogGroupCommand", ()=>serializeAws_json1_1UntagLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1AssociateKmsKeyCommand", ()=>deserializeAws_json1_1AssociateKmsKeyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CancelExportTaskCommand", ()=>deserializeAws_json1_1CancelExportTaskCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateExportTaskCommand", ()=>deserializeAws_json1_1CreateExportTaskCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateLogGroupCommand", ()=>deserializeAws_json1_1CreateLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateLogStreamCommand", ()=>deserializeAws_json1_1CreateLogStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteDestinationCommand", ()=>deserializeAws_json1_1DeleteDestinationCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteLogGroupCommand", ()=>deserializeAws_json1_1DeleteLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteLogStreamCommand", ()=>deserializeAws_json1_1DeleteLogStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteMetricFilterCommand", ()=>deserializeAws_json1_1DeleteMetricFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteQueryDefinitionCommand", ()=>deserializeAws_json1_1DeleteQueryDefinitionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteResourcePolicyCommand", ()=>deserializeAws_json1_1DeleteResourcePolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteRetentionPolicyCommand", ()=>deserializeAws_json1_1DeleteRetentionPolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteSubscriptionFilterCommand", ()=>deserializeAws_json1_1DeleteSubscriptionFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeDestinationsCommand", ()=>deserializeAws_json1_1DescribeDestinationsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeExportTasksCommand", ()=>deserializeAws_json1_1DescribeExportTasksCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLogGroupsCommand", ()=>deserializeAws_json1_1DescribeLogGroupsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLogStreamsCommand", ()=>deserializeAws_json1_1DescribeLogStreamsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeMetricFiltersCommand", ()=>deserializeAws_json1_1DescribeMetricFiltersCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeQueriesCommand", ()=>deserializeAws_json1_1DescribeQueriesCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeQueryDefinitionsCommand", ()=>deserializeAws_json1_1DescribeQueryDefinitionsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeResourcePoliciesCommand", ()=>deserializeAws_json1_1DescribeResourcePoliciesCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeSubscriptionFiltersCommand", ()=>deserializeAws_json1_1DescribeSubscriptionFiltersCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DisassociateKmsKeyCommand", ()=>deserializeAws_json1_1DisassociateKmsKeyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1FilterLogEventsCommand", ()=>deserializeAws_json1_1FilterLogEventsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogEventsCommand", ()=>deserializeAws_json1_1GetLogEventsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogGroupFieldsCommand", ()=>deserializeAws_json1_1GetLogGroupFieldsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogRecordCommand", ()=>deserializeAws_json1_1GetLogRecordCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetQueryResultsCommand", ()=>deserializeAws_json1_1GetQueryResultsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsLogGroupCommand", ()=>deserializeAws_json1_1ListTagsLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutDestinationCommand", ()=>deserializeAws_json1_1PutDestinationCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutDestinationPolicyCommand", ()=>deserializeAws_json1_1PutDestinationPolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutLogEventsCommand", ()=>deserializeAws_json1_1PutLogEventsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutMetricFilterCommand", ()=>deserializeAws_json1_1PutMetricFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutQueryDefinitionCommand", ()=>deserializeAws_json1_1PutQueryDefinitionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutResourcePolicyCommand", ()=>deserializeAws_json1_1PutResourcePolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRetentionPolicyCommand", ()=>deserializeAws_json1_1PutRetentionPolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutSubscriptionFilterCommand", ()=>deserializeAws_json1_1PutSubscriptionFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StartQueryCommand", ()=>deserializeAws_json1_1StartQueryCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StopQueryCommand", ()=>deserializeAws_json1_1StopQueryCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1TagLogGroupCommand", ()=>deserializeAws_json1_1TagLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1TestMetricFilterCommand", ()=>deserializeAws_json1_1TestMetricFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UntagLogGroupCommand", ()=>deserializeAws_json1_1UntagLogGroupCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1AssociateKmsKeyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.AssociateKmsKey"
            };
            body = JSON.stringify(serializeAws_json1_1AssociateKmsKeyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CancelExportTaskCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CancelExportTask"
            };
            body = JSON.stringify(serializeAws_json1_1CancelExportTaskRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateExportTaskCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateExportTask"
            };
            body = JSON.stringify(serializeAws_json1_1CreateExportTaskRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1CreateLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateLogStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateLogStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateLogStreamRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteDestinationCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteDestination"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteDestinationRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteLogStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteLogStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteLogStreamRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteMetricFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteQueryDefinitionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteQueryDefinition"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteQueryDefinitionRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteResourcePolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteResourcePolicy"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteResourcePolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteRetentionPolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteRetentionPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteRetentionPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteSubscriptionFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteSubscriptionFilter"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteSubscriptionFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeDestinationsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeDestinations"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeDestinationsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeExportTasksCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeExportTasks"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeExportTasksRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLogGroupsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeLogGroups"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLogGroupsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLogStreamsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeLogStreams"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLogStreamsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeMetricFiltersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeMetricFilters"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeMetricFiltersRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeQueriesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeQueries"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeQueriesRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeQueryDefinitionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeQueryDefinitions"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeQueryDefinitionsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeResourcePoliciesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeResourcePolicies"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeResourcePoliciesRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeSubscriptionFiltersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeSubscriptionFilters"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeSubscriptionFiltersRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DisassociateKmsKeyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DisassociateKmsKey"
            };
            body = JSON.stringify(serializeAws_json1_1DisassociateKmsKeyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1FilterLogEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.FilterLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1FilterLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogGroupFieldsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogGroupFields"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogGroupFieldsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogRecordCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogRecord"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogRecordRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetQueryResultsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetQueryResults"
            };
            body = JSON.stringify(serializeAws_json1_1GetQueryResultsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.ListTagsLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutDestinationCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutDestination"
            };
            body = JSON.stringify(serializeAws_json1_1PutDestinationRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutDestinationPolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutDestinationPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutDestinationPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutLogEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1PutLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutMetricFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1PutMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutQueryDefinitionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutQueryDefinition"
            };
            body = JSON.stringify(serializeAws_json1_1PutQueryDefinitionRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutResourcePolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutResourcePolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutResourcePolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRetentionPolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutRetentionPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutRetentionPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutSubscriptionFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutSubscriptionFilter"
            };
            body = JSON.stringify(serializeAws_json1_1PutSubscriptionFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartQueryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.StartQuery"
            };
            body = JSON.stringify(serializeAws_json1_1StartQueryRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopQueryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.StopQuery"
            };
            body = JSON.stringify(serializeAws_json1_1StopQueryRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TagLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.TagLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1TagLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TestMetricFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.TestMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1TestMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UntagLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.UntagLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1UntagLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1AssociateKmsKeyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1AssociateKmsKeyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1AssociateKmsKeyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CancelExportTaskCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CancelExportTaskCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CancelExportTaskCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidOperationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidOperationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidOperationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateExportTaskCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateExportTaskCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1CreateExportTaskResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateExportTaskCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, _tslib.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateLogStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDestinationCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDestinationCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteLogStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteMetricFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteMetricFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteQueryDefinitionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteQueryDefinitionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DeleteQueryDefinitionResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteQueryDefinitionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteResourcePolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteResourcePolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteResourcePolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteRetentionPolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteRetentionPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteRetentionPolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteSubscriptionFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteSubscriptionFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteSubscriptionFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDestinationsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeDestinationsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeDestinationsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDestinationsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeExportTasksCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeExportTasksCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeExportTasksResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeExportTasksCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogGroupsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLogGroupsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLogGroupsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogGroupsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogStreamsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLogStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLogStreamsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogStreamsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeMetricFiltersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeMetricFiltersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeMetricFiltersResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeMetricFiltersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueriesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeQueriesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeQueriesResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueriesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueryDefinitionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeQueryDefinitionsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeQueryDefinitionsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueryDefinitionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeResourcePoliciesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeResourcePoliciesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeResourcePoliciesResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeResourcePoliciesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeSubscriptionFiltersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeSubscriptionFiltersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeSubscriptionFiltersResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeSubscriptionFiltersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisassociateKmsKeyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DisassociateKmsKeyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisassociateKmsKeyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1FilterLogEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1FilterLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1FilterLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1FilterLogEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogGroupFieldsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogGroupFieldsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogGroupFieldsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogGroupFieldsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogRecordCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogRecordResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogRecordCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetQueryResultsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetQueryResultsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetQueryResultsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetQueryResultsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsLogGroupResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutDestinationResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationPolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutDestinationPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationPolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutLogEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutLogEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, _tslib.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DataAlreadyAcceptedException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#DataAlreadyAcceptedException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidSequenceTokenException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidSequenceTokenException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "UnrecognizedClientException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cloudwatchlogs#UnrecognizedClientException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidSequenceTokenExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1UnrecognizedClientExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutMetricFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutMetricFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutQueryDefinitionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutQueryDefinitionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutQueryDefinitionResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutQueryDefinitionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutResourcePolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutResourcePolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutResourcePolicyResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutResourcePolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRetentionPolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRetentionPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRetentionPolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutSubscriptionFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutSubscriptionFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutSubscriptionFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartQueryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartQueryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StartQueryResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartQueryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "MalformedQueryException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#MalformedQueryException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1MalformedQueryExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopQueryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopQueryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StopQueryResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopQueryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TagLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TestMetricFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TestMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1TestMetricFilterResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TestMetricFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UntagLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1DataAlreadyAcceptedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "DataAlreadyAcceptedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidOperationExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidOperationException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidOperationException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidSequenceTokenExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidSequenceTokenException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidSequenceTokenException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1MalformedQueryExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1MalformedQueryException(body, context);
            contents = (0, _tslib.__assign)({
                name: "MalformedQueryException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1OperationAbortedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1OperationAbortedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "OperationAbortedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceAlreadyExistsException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceAlreadyExistsException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ServiceUnavailableException",
                $fault: "server",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1UnrecognizedClientExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1UnrecognizedClientException(body, context);
            contents = (0, _tslib.__assign)({
                name: "UnrecognizedClientException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1AssociateKmsKeyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.kmsKeyId !== undefined && input.kmsKeyId !== null && {
        kmsKeyId: input.kmsKeyId
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1CancelExportTaskRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.taskId !== undefined && input.taskId !== null && {
        taskId: input.taskId
    });
};
var serializeAws_json1_1CreateExportTaskRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destination !== undefined && input.destination !== null && {
        destination: input.destination
    }), input.destinationPrefix !== undefined && input.destinationPrefix !== null && {
        destinationPrefix: input.destinationPrefix
    }), input.from !== undefined && input.from !== null && {
        from: input.from
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.taskName !== undefined && input.taskName !== null && {
        taskName: input.taskName
    }), input.to !== undefined && input.to !== null && {
        to: input.to
    });
};
var serializeAws_json1_1CreateLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.kmsKeyId !== undefined && input.kmsKeyId !== null && {
        kmsKeyId: input.kmsKeyId
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1Tags(input.tags, context)
    });
};
var serializeAws_json1_1CreateLogStreamRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    });
};
var serializeAws_json1_1DeleteDestinationRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    });
};
var serializeAws_json1_1DeleteLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteLogStreamRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    });
};
var serializeAws_json1_1DeleteMetricFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteQueryDefinitionRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.queryDefinitionId !== undefined && input.queryDefinitionId !== null && {
        queryDefinitionId: input.queryDefinitionId
    });
};
var serializeAws_json1_1DeleteResourcePolicyRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.policyName !== undefined && input.policyName !== null && {
        policyName: input.policyName
    });
};
var serializeAws_json1_1DeleteRetentionPolicyRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteSubscriptionFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DescribeDestinationsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DestinationNamePrefix !== undefined && input.DestinationNamePrefix !== null && {
        DestinationNamePrefix: input.DestinationNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeExportTasksRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.statusCode !== undefined && input.statusCode !== null && {
        statusCode: input.statusCode
    }), input.taskId !== undefined && input.taskId !== null && {
        taskId: input.taskId
    });
};
var serializeAws_json1_1DescribeLogGroupsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupNamePrefix !== undefined && input.logGroupNamePrefix !== null && {
        logGroupNamePrefix: input.logGroupNamePrefix
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeLogStreamsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.descending !== undefined && input.descending !== null && {
        descending: input.descending
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.orderBy !== undefined && input.orderBy !== null && {
        orderBy: input.orderBy
    });
};
var serializeAws_json1_1DescribeMetricFiltersRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterNamePrefix !== undefined && input.filterNamePrefix !== null && {
        filterNamePrefix: input.filterNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.metricName !== undefined && input.metricName !== null && {
        metricName: input.metricName
    }), input.metricNamespace !== undefined && input.metricNamespace !== null && {
        metricNamespace: input.metricNamespace
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeQueriesRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.maxResults !== undefined && input.maxResults !== null && {
        maxResults: input.maxResults
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.status !== undefined && input.status !== null && {
        status: input.status
    });
};
var serializeAws_json1_1DescribeQueryDefinitionsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.maxResults !== undefined && input.maxResults !== null && {
        maxResults: input.maxResults
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.queryDefinitionNamePrefix !== undefined && input.queryDefinitionNamePrefix !== null && {
        queryDefinitionNamePrefix: input.queryDefinitionNamePrefix
    });
};
var serializeAws_json1_1DescribeResourcePoliciesRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeSubscriptionFiltersRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterNamePrefix !== undefined && input.filterNamePrefix !== null && {
        filterNamePrefix: input.filterNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DisassociateKmsKeyRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1FilterLogEventsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.interleaved !== undefined && input.interleaved !== null && {
        interleaved: input.interleaved
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.logStreamNames !== undefined && input.logStreamNames !== null && {
        logStreamNames: serializeAws_json1_1InputLogStreamNames(input.logStreamNames, context)
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1GetLogEventsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.startFromHead !== undefined && input.startFromHead !== null && {
        startFromHead: input.startFromHead
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1GetLogGroupFieldsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.time !== undefined && input.time !== null && {
        time: input.time
    });
};
var serializeAws_json1_1GetLogRecordRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logRecordPointer !== undefined && input.logRecordPointer !== null && {
        logRecordPointer: input.logRecordPointer
    });
};
var serializeAws_json1_1GetQueryResultsRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.queryId !== undefined && input.queryId !== null && {
        queryId: input.queryId
    });
};
var serializeAws_json1_1InputLogEvent = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.message !== undefined && input.message !== null && {
        message: input.message
    }), input.timestamp !== undefined && input.timestamp !== null && {
        timestamp: input.timestamp
    });
};
var serializeAws_json1_1InputLogEvents = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1InputLogEvent(entry, context);
    });
};
var serializeAws_json1_1InputLogStreamNames = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListTagsLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1LogGroupNames = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1MetricTransformation = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.defaultValue !== undefined && input.defaultValue !== null && {
        defaultValue: input.defaultValue
    }), input.metricName !== undefined && input.metricName !== null && {
        metricName: input.metricName
    }), input.metricNamespace !== undefined && input.metricNamespace !== null && {
        metricNamespace: input.metricNamespace
    }), input.metricValue !== undefined && input.metricValue !== null && {
        metricValue: input.metricValue
    });
};
var serializeAws_json1_1MetricTransformations = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1MetricTransformation(entry, context);
    });
};
var serializeAws_json1_1PutDestinationPolicyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.accessPolicy !== undefined && input.accessPolicy !== null && {
        accessPolicy: input.accessPolicy
    }), input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    });
};
var serializeAws_json1_1PutDestinationRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    }), input.roleArn !== undefined && input.roleArn !== null && {
        roleArn: input.roleArn
    }), input.targetArn !== undefined && input.targetArn !== null && {
        targetArn: input.targetArn
    });
};
var serializeAws_json1_1PutLogEventsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logEvents !== undefined && input.logEvents !== null && {
        logEvents: serializeAws_json1_1InputLogEvents(input.logEvents, context)
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    }), input.sequenceToken !== undefined && input.sequenceToken !== null && {
        sequenceToken: input.sequenceToken
    });
};
var serializeAws_json1_1PutMetricFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.metricTransformations !== undefined && input.metricTransformations !== null && {
        metricTransformations: serializeAws_json1_1MetricTransformations(input.metricTransformations, context)
    });
};
var serializeAws_json1_1PutQueryDefinitionRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupNames !== undefined && input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context)
    }), input.name !== undefined && input.name !== null && {
        name: input.name
    }), input.queryDefinitionId !== undefined && input.queryDefinitionId !== null && {
        queryDefinitionId: input.queryDefinitionId
    }), input.queryString !== undefined && input.queryString !== null && {
        queryString: input.queryString
    });
};
var serializeAws_json1_1PutResourcePolicyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.policyDocument !== undefined && input.policyDocument !== null && {
        policyDocument: input.policyDocument
    }), input.policyName !== undefined && input.policyName !== null && {
        policyName: input.policyName
    });
};
var serializeAws_json1_1PutRetentionPolicyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.retentionInDays !== undefined && input.retentionInDays !== null && {
        retentionInDays: input.retentionInDays
    });
};
var serializeAws_json1_1PutSubscriptionFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destinationArn !== undefined && input.destinationArn !== null && {
        destinationArn: input.destinationArn
    }), input.distribution !== undefined && input.distribution !== null && {
        distribution: input.distribution
    }), input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.roleArn !== undefined && input.roleArn !== null && {
        roleArn: input.roleArn
    });
};
var serializeAws_json1_1StartQueryRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logGroupNames !== undefined && input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context)
    }), input.queryString !== undefined && input.queryString !== null && {
        queryString: input.queryString
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1StopQueryRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.queryId !== undefined && input.queryId !== null && {
        queryId: input.queryId
    });
};
var serializeAws_json1_1TagList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TagLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1Tags(input.tags, context)
    });
};
var serializeAws_json1_1Tags = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1TestEventMessages = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TestMetricFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logEventMessages !== undefined && input.logEventMessages !== null && {
        logEventMessages: serializeAws_json1_1TestEventMessages(input.logEventMessages, context)
    });
};
var serializeAws_json1_1UntagLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1TagList(input.tags, context)
    });
};
var deserializeAws_json1_1CreateExportTaskResponse = function(output, context) {
    return {
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined
    };
};
var deserializeAws_json1_1DataAlreadyAcceptedException = function(output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null ? output.expectedSequenceToken : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1DeleteQueryDefinitionResponse = function(output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined
    };
};
var deserializeAws_json1_1DescribeDestinationsResponse = function(output, context) {
    return {
        destinations: output.destinations !== undefined && output.destinations !== null ? deserializeAws_json1_1Destinations(output.destinations, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeExportTasksResponse = function(output, context) {
    return {
        exportTasks: output.exportTasks !== undefined && output.exportTasks !== null ? deserializeAws_json1_1ExportTasks(output.exportTasks, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeLogGroupsResponse = function(output, context) {
    return {
        logGroups: output.logGroups !== undefined && output.logGroups !== null ? deserializeAws_json1_1LogGroups(output.logGroups, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeLogStreamsResponse = function(output, context) {
    return {
        logStreams: output.logStreams !== undefined && output.logStreams !== null ? deserializeAws_json1_1LogStreams(output.logStreams, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeMetricFiltersResponse = function(output, context) {
    return {
        metricFilters: output.metricFilters !== undefined && output.metricFilters !== null ? deserializeAws_json1_1MetricFilters(output.metricFilters, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeQueriesResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queries: output.queries !== undefined && output.queries !== null ? deserializeAws_json1_1QueryInfoList(output.queries, context) : undefined
    };
};
var deserializeAws_json1_1DescribeQueryDefinitionsResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queryDefinitions: output.queryDefinitions !== undefined && output.queryDefinitions !== null ? deserializeAws_json1_1QueryDefinitionList(output.queryDefinitions, context) : undefined
    };
};
var deserializeAws_json1_1DescribeResourcePoliciesResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        resourcePolicies: output.resourcePolicies !== undefined && output.resourcePolicies !== null ? deserializeAws_json1_1ResourcePolicies(output.resourcePolicies, context) : undefined
    };
};
var deserializeAws_json1_1DescribeSubscriptionFiltersResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        subscriptionFilters: output.subscriptionFilters !== undefined && output.subscriptionFilters !== null ? deserializeAws_json1_1SubscriptionFilters(output.subscriptionFilters, context) : undefined
    };
};
var deserializeAws_json1_1Destination = function(output, context) {
    return {
        accessPolicy: output.accessPolicy !== undefined && output.accessPolicy !== null ? output.accessPolicy : undefined,
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationName: output.destinationName !== undefined && output.destinationName !== null ? output.destinationName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined,
        targetArn: output.targetArn !== undefined && output.targetArn !== null ? output.targetArn : undefined
    };
};
var deserializeAws_json1_1Destinations = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Destination(entry, context);
    });
};
var deserializeAws_json1_1ExportTask = function(output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? output.destination : undefined,
        destinationPrefix: output.destinationPrefix !== undefined && output.destinationPrefix !== null ? output.destinationPrefix : undefined,
        executionInfo: output.executionInfo !== undefined && output.executionInfo !== null ? deserializeAws_json1_1ExportTaskExecutionInfo(output.executionInfo, context) : undefined,
        from: output.from !== undefined && output.from !== null ? output.from : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        status: output.status !== undefined && output.status !== null ? deserializeAws_json1_1ExportTaskStatus(output.status, context) : undefined,
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined,
        taskName: output.taskName !== undefined && output.taskName !== null ? output.taskName : undefined,
        to: output.to !== undefined && output.to !== null ? output.to : undefined
    };
};
var deserializeAws_json1_1ExportTaskExecutionInfo = function(output, context) {
    return {
        completionTime: output.completionTime !== undefined && output.completionTime !== null ? output.completionTime : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined
    };
};
var deserializeAws_json1_1ExportTasks = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ExportTask(entry, context);
    });
};
var deserializeAws_json1_1ExportTaskStatus = function(output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ExtractedValues = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1FilteredLogEvent = function(output, context) {
    return {
        eventId: output.eventId !== undefined && output.eventId !== null ? output.eventId : undefined,
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined
    };
};
var deserializeAws_json1_1FilteredLogEvents = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1FilteredLogEvent(entry, context);
    });
};
var deserializeAws_json1_1FilterLogEventsResponse = function(output, context) {
    return {
        events: output.events !== undefined && output.events !== null ? deserializeAws_json1_1FilteredLogEvents(output.events, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        searchedLogStreams: output.searchedLogStreams !== undefined && output.searchedLogStreams !== null ? deserializeAws_json1_1SearchedLogStreams(output.searchedLogStreams, context) : undefined
    };
};
var deserializeAws_json1_1GetLogEventsResponse = function(output, context) {
    return {
        events: output.events !== undefined && output.events !== null ? deserializeAws_json1_1OutputLogEvents(output.events, context) : undefined,
        nextBackwardToken: output.nextBackwardToken !== undefined && output.nextBackwardToken !== null ? output.nextBackwardToken : undefined,
        nextForwardToken: output.nextForwardToken !== undefined && output.nextForwardToken !== null ? output.nextForwardToken : undefined
    };
};
var deserializeAws_json1_1GetLogGroupFieldsResponse = function(output, context) {
    return {
        logGroupFields: output.logGroupFields !== undefined && output.logGroupFields !== null ? deserializeAws_json1_1LogGroupFieldList(output.logGroupFields, context) : undefined
    };
};
var deserializeAws_json1_1GetLogRecordResponse = function(output, context) {
    return {
        logRecord: output.logRecord !== undefined && output.logRecord !== null ? deserializeAws_json1_1LogRecord(output.logRecord, context) : undefined
    };
};
var deserializeAws_json1_1GetQueryResultsResponse = function(output, context) {
    return {
        results: output.results !== undefined && output.results !== null ? deserializeAws_json1_1QueryResults(output.results, context) : undefined,
        statistics: output.statistics !== undefined && output.statistics !== null ? deserializeAws_json1_1QueryStatistics(output.statistics, context) : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined
    };
};
var deserializeAws_json1_1InvalidOperationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidSequenceTokenException = function(output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null ? output.expectedSequenceToken : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListTagsLogGroupResponse = function(output, context) {
    return {
        tags: output.tags !== undefined && output.tags !== null ? deserializeAws_json1_1Tags(output.tags, context) : undefined
    };
};
var deserializeAws_json1_1LogGroup = function(output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        kmsKeyId: output.kmsKeyId !== undefined && output.kmsKeyId !== null ? output.kmsKeyId : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricFilterCount: output.metricFilterCount !== undefined && output.metricFilterCount !== null ? output.metricFilterCount : undefined,
        retentionInDays: output.retentionInDays !== undefined && output.retentionInDays !== null ? output.retentionInDays : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined
    };
};
var deserializeAws_json1_1LogGroupField = function(output, context) {
    return {
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        percent: output.percent !== undefined && output.percent !== null ? output.percent : undefined
    };
};
var deserializeAws_json1_1LogGroupFieldList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogGroupField(entry, context);
    });
};
var deserializeAws_json1_1LogGroupNames = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1LogGroups = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogGroup(entry, context);
    });
};
var deserializeAws_json1_1LogRecord = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1LogStream = function(output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        firstEventTimestamp: output.firstEventTimestamp !== undefined && output.firstEventTimestamp !== null ? output.firstEventTimestamp : undefined,
        lastEventTimestamp: output.lastEventTimestamp !== undefined && output.lastEventTimestamp !== null ? output.lastEventTimestamp : undefined,
        lastIngestionTime: output.lastIngestionTime !== undefined && output.lastIngestionTime !== null ? output.lastIngestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined,
        uploadSequenceToken: output.uploadSequenceToken !== undefined && output.uploadSequenceToken !== null ? output.uploadSequenceToken : undefined
    };
};
var deserializeAws_json1_1LogStreams = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogStream(entry, context);
    });
};
var deserializeAws_json1_1MalformedQueryException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        queryCompileError: output.queryCompileError !== undefined && output.queryCompileError !== null ? deserializeAws_json1_1QueryCompileError(output.queryCompileError, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilter = function(output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricTransformations: output.metricTransformations !== undefined && output.metricTransformations !== null ? deserializeAws_json1_1MetricTransformations(output.metricTransformations, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilterMatches = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricFilterMatchRecord(entry, context);
    });
};
var deserializeAws_json1_1MetricFilterMatchRecord = function(output, context) {
    return {
        eventMessage: output.eventMessage !== undefined && output.eventMessage !== null ? output.eventMessage : undefined,
        eventNumber: output.eventNumber !== undefined && output.eventNumber !== null ? output.eventNumber : undefined,
        extractedValues: output.extractedValues !== undefined && output.extractedValues !== null ? deserializeAws_json1_1ExtractedValues(output.extractedValues, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilters = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricFilter(entry, context);
    });
};
var deserializeAws_json1_1MetricTransformation = function(output, context) {
    return {
        defaultValue: output.defaultValue !== undefined && output.defaultValue !== null ? output.defaultValue : undefined,
        metricName: output.metricName !== undefined && output.metricName !== null ? output.metricName : undefined,
        metricNamespace: output.metricNamespace !== undefined && output.metricNamespace !== null ? output.metricNamespace : undefined,
        metricValue: output.metricValue !== undefined && output.metricValue !== null ? output.metricValue : undefined
    };
};
var deserializeAws_json1_1MetricTransformations = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricTransformation(entry, context);
    });
};
var deserializeAws_json1_1OperationAbortedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1OutputLogEvent = function(output, context) {
    return {
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined
    };
};
var deserializeAws_json1_1OutputLogEvents = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1OutputLogEvent(entry, context);
    });
};
var deserializeAws_json1_1PutDestinationResponse = function(output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? deserializeAws_json1_1Destination(output.destination, context) : undefined
    };
};
var deserializeAws_json1_1PutLogEventsResponse = function(output, context) {
    return {
        nextSequenceToken: output.nextSequenceToken !== undefined && output.nextSequenceToken !== null ? output.nextSequenceToken : undefined,
        rejectedLogEventsInfo: output.rejectedLogEventsInfo !== undefined && output.rejectedLogEventsInfo !== null ? deserializeAws_json1_1RejectedLogEventsInfo(output.rejectedLogEventsInfo, context) : undefined
    };
};
var deserializeAws_json1_1PutQueryDefinitionResponse = function(output, context) {
    return {
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null ? output.queryDefinitionId : undefined
    };
};
var deserializeAws_json1_1PutResourcePolicyResponse = function(output, context) {
    return {
        resourcePolicy: output.resourcePolicy !== undefined && output.resourcePolicy !== null ? deserializeAws_json1_1ResourcePolicy(output.resourcePolicy, context) : undefined
    };
};
var deserializeAws_json1_1QueryCompileError = function(output, context) {
    return {
        location: output.location !== undefined && output.location !== null ? deserializeAws_json1_1QueryCompileErrorLocation(output.location, context) : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1QueryCompileErrorLocation = function(output, context) {
    return {
        endCharOffset: output.endCharOffset !== undefined && output.endCharOffset !== null ? output.endCharOffset : undefined,
        startCharOffset: output.startCharOffset !== undefined && output.startCharOffset !== null ? output.startCharOffset : undefined
    };
};
var deserializeAws_json1_1QueryDefinition = function(output, context) {
    return {
        lastModified: output.lastModified !== undefined && output.lastModified !== null ? output.lastModified : undefined,
        logGroupNames: output.logGroupNames !== undefined && output.logGroupNames !== null ? deserializeAws_json1_1LogGroupNames(output.logGroupNames, context) : undefined,
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null ? output.queryDefinitionId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined
    };
};
var deserializeAws_json1_1QueryDefinitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1QueryDefinition(entry, context);
    });
};
var deserializeAws_json1_1QueryInfo = function(output, context) {
    return {
        createTime: output.createTime !== undefined && output.createTime !== null ? output.createTime : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined
    };
};
var deserializeAws_json1_1QueryInfoList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1QueryInfo(entry, context);
    });
};
var deserializeAws_json1_1QueryResults = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResultRows(entry, context);
    });
};
var deserializeAws_json1_1QueryStatistics = function(output, context) {
    return {
        bytesScanned: output.bytesScanned !== undefined && output.bytesScanned !== null ? output.bytesScanned : undefined,
        recordsMatched: output.recordsMatched !== undefined && output.recordsMatched !== null ? output.recordsMatched : undefined,
        recordsScanned: output.recordsScanned !== undefined && output.recordsScanned !== null ? output.recordsScanned : undefined
    };
};
var deserializeAws_json1_1RejectedLogEventsInfo = function(output, context) {
    return {
        expiredLogEventEndIndex: output.expiredLogEventEndIndex !== undefined && output.expiredLogEventEndIndex !== null ? output.expiredLogEventEndIndex : undefined,
        tooNewLogEventStartIndex: output.tooNewLogEventStartIndex !== undefined && output.tooNewLogEventStartIndex !== null ? output.tooNewLogEventStartIndex : undefined,
        tooOldLogEventEndIndex: output.tooOldLogEventEndIndex !== undefined && output.tooOldLogEventEndIndex !== null ? output.tooOldLogEventEndIndex : undefined
    };
};
var deserializeAws_json1_1ResourceAlreadyExistsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourcePolicies = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResourcePolicy(entry, context);
    });
};
var deserializeAws_json1_1ResourcePolicy = function(output, context) {
    return {
        lastUpdatedTime: output.lastUpdatedTime !== undefined && output.lastUpdatedTime !== null ? output.lastUpdatedTime : undefined,
        policyDocument: output.policyDocument !== undefined && output.policyDocument !== null ? output.policyDocument : undefined,
        policyName: output.policyName !== undefined && output.policyName !== null ? output.policyName : undefined
    };
};
var deserializeAws_json1_1ResultField = function(output, context) {
    return {
        field: output.field !== undefined && output.field !== null ? output.field : undefined,
        value: output.value !== undefined && output.value !== null ? output.value : undefined
    };
};
var deserializeAws_json1_1ResultRows = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResultField(entry, context);
    });
};
var deserializeAws_json1_1SearchedLogStream = function(output, context) {
    return {
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        searchedCompletely: output.searchedCompletely !== undefined && output.searchedCompletely !== null ? output.searchedCompletely : undefined
    };
};
var deserializeAws_json1_1SearchedLogStreams = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1SearchedLogStream(entry, context);
    });
};
var deserializeAws_json1_1ServiceUnavailableException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1StartQueryResponse = function(output, context) {
    return {
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined
    };
};
var deserializeAws_json1_1StopQueryResponse = function(output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined
    };
};
var deserializeAws_json1_1SubscriptionFilter = function(output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationArn: output.destinationArn !== undefined && output.destinationArn !== null ? output.destinationArn : undefined,
        distribution: output.distribution !== undefined && output.distribution !== null ? output.distribution : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined
    };
};
var deserializeAws_json1_1SubscriptionFilters = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1SubscriptionFilter(entry, context);
    });
};
var deserializeAws_json1_1Tags = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1TestMetricFilterResponse = function(output, context) {
    return {
        matches: output.matches !== undefined && output.matches !== null ? deserializeAws_json1_1MetricFilterMatches(output.matches, context) : undefined
    };
};
var deserializeAws_json1_1UnrecognizedClientException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"cj7CK","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bIoq4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);

},{"./deserializerMiddleware":"28wZK","./serializerMiddleware":"diwO5","./serdePlugin":"8vGUy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"28wZK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", ()=>deserializerMiddleware);
var _tslib = require("tslib");
var deserializerMiddleware = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"diwO5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", ()=>serializerMiddleware);
var _tslib = require("tslib");
var serializerMiddleware = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8vGUy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", ()=>deserializerMiddlewareOption);
parcelHelpers.export(exports, "serializerMiddlewareOption", ()=>serializerMiddlewareOption);
parcelHelpers.export(exports, "getSerdePlugin", ()=>getSerdePlugin);
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"28wZK","./serializerMiddleware":"diwO5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iTZyE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateLogStreamCommand", ()=>CreateLogStreamCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Creates a log stream for the specified log group. A log stream is a sequence of log events
 *       that originate from a single source, such as an application instance or a resource that is
 *       being monitored.</p>
 *          <p>There is no limit on the number of log streams that you can create for a log group. There is a limit
 *     of 50 TPS on <code>CreateLogStream</code> operations, after which transactions are throttled.</p>
 *          <p>You must use the following guidelines when naming a log stream:</p>
 *          <ul>
 *             <li>
 *                <p>Log stream names must be unique within the log group.</p>
 *             </li>
 *             <li>
 *                <p>Log stream names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>The ':' (colon) and '*' (asterisk) characters are not allowed.</p>
 *             </li>
 *          </ul>
 */ var CreateLogStreamCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(CreateLogStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogStreamCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateLogStreamCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.CreateLogStreamRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogStreamCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1CreateLogStreamCommand)(input, context);
    };
    CreateLogStreamCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1CreateLogStreamCommand)(output, context);
    };
    return CreateLogStreamCommand;
}((0, _smithyClient.Command));

},{"tslib":"cj7CK","../models/models_0":"c7igR","../protocols/Aws_json1_1":"1HpDx","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ibALT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DescribeLogGroupsCommand", ()=>DescribeLogGroupsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists the specified log groups. You can list all your log groups or filter the results by prefix.
 *       The results are ASCII-sorted by log group name.</p>
 */ var DescribeLogGroupsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(DescribeLogGroupsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogGroupsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DescribeLogGroupsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogGroupsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.DescribeLogGroupsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.DescribeLogGroupsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogGroupsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1DescribeLogGroupsCommand)(input, context);
    };
    DescribeLogGroupsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1DescribeLogGroupsCommand)(output, context);
    };
    return DescribeLogGroupsCommand;
}((0, _smithyClient.Command));

},{"tslib":"cj7CK","../models/models_0":"c7igR","../protocols/Aws_json1_1":"1HpDx","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hgwcF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DescribeLogStreamsCommand", ()=>DescribeLogStreamsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists the log streams for the specified log group.
 *       You can list all the log streams or filter the results by prefix.
 *       You can also control how the results are ordered.</p>
 *          <p>This operation has a limit of five transactions per second, after which transactions are throttled.</p>
 */ var DescribeLogStreamsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(DescribeLogStreamsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogStreamsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DescribeLogStreamsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogStreamsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.DescribeLogStreamsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.DescribeLogStreamsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogStreamsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1DescribeLogStreamsCommand)(input, context);
    };
    DescribeLogStreamsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1DescribeLogStreamsCommand)(output, context);
    };
    return DescribeLogStreamsCommand;
}((0, _smithyClient.Command));

},{"tslib":"cj7CK","../models/models_0":"c7igR","../protocols/Aws_json1_1":"1HpDx","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2eLKw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetLogEventsCommand", ()=>GetLogEventsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists log events from the specified log stream. You can list all of the log events or
 *       filter using a time range.</p>
 *
 *          <p>By default, this operation returns as many log events as can fit in a response size of 1MB (up to 10,000 log events).
 *       You can get additional log events by specifying one of the tokens in a subsequent call.
 *       This operation can return empty results while there are more log events available through the token.</p>
 */ var GetLogEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(GetLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLogEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetLogEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetLogEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.GetLogEventsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLogEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1GetLogEventsCommand)(input, context);
    };
    GetLogEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1GetLogEventsCommand)(output, context);
    };
    return GetLogEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"cj7CK","../models/models_0":"c7igR","../protocols/Aws_json1_1":"1HpDx","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6wnye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutLogEventsCommand", ()=>PutLogEventsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Uploads a batch of log events to the specified log stream.</p>
 *          <p>You must include the sequence token obtained from the response of the previous call. An
 *       upload in a newly created log stream does not require a sequence token. You can also get the
 *       sequence token in the <code>expectedSequenceToken</code> field from
 *         <code>InvalidSequenceTokenException</code>. If you call <code>PutLogEvents</code> twice
 *       within a narrow time period using the same value for <code>sequenceToken</code>, both calls
 *       might be successful or one might be rejected.</p>
 *          <p>The batch of events must satisfy the following constraints:</p>
 *          <ul>
 *             <li>
 *                <p>The maximum batch size is 1,048,576 bytes. This size is calculated as the sum of
 *           all event messages in UTF-8, plus 26 bytes for each log event.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be more than 2 hours in the future.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be older than 14 days or older than the retention
 *           period of the log group.</p>
 *             </li>
 *             <li>
 *                <p>The log events in the batch must be in chronological order by their timestamp. The
 *           timestamp is the time the event occurred, expressed as the number of milliseconds after
 *           Jan 1, 1970 00:00:00 UTC. (In AWS Tools for PowerShell and the AWS SDK for .NET, the
 *           timestamp is specified in .NET format: yyyy-mm-ddThh:mm:ss. For example,
 *           2017-09-15T13:45:30.) </p>
 *             </li>
 *             <li>
 *                <p>A batch of log events in a single request cannot span more than 24 hours. Otherwise, the operation fails.</p>
 *             </li>
 *             <li>
 *                <p>The maximum number of log events in a batch is 10,000.</p>
 *             </li>
 *             <li>
 *                <p>There is a quota of 5 requests per second per log stream. Additional requests are throttled. This quota can't be changed.</p>
 *             </li>
 *          </ul>
 *          <p>If a call to <code>PutLogEvents</code> returns "UnrecognizedClientException" the most likely cause is an invalid AWS access key ID or secret key. </p>
 */ var PutLogEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutLogEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutLogEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutLogEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutLogEventsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutLogEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutLogEventsCommand)(input, context);
    };
    PutLogEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutLogEventsCommand)(output, context);
    };
    return PutLogEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"cj7CK","../models/models_0":"c7igR","../protocols/Aws_json1_1":"1HpDx","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4xwpb":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleOAuth", ()=>GoogleOAuth);
parcelHelpers.export(exports, "FacebookOAuth", ()=>FacebookOAuth);
var _googleOAuth = require("./GoogleOAuth");
var _facebookOAuth = require("./FacebookOAuth");
var GoogleOAuth = new (0, _googleOAuth.GoogleOAuth)();
var FacebookOAuth = new (0, _facebookOAuth.FacebookOAuth)();

},{"./GoogleOAuth":"c4yi2","./FacebookOAuth":"eGwYE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"c4yi2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleOAuth", ()=>GoogleOAuth);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("../Logger");
var _js = require("../JS");
var _util = require("../Util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)("CognitoCredentials");
var waitForInit = new Promise(function(res, rej) {
    if (!(0, _js.browserOrNode)().isBrowser) {
        logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var GoogleOAuth = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, _js.browserOrNode)().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    logger.debug("google Auth undefined");
                    rej(new (0, _util.NonRetryableError)("google Auth undefined"));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === "network_error") // Not using NonRetryableError so handler will be retried
                        rej("Network error reloading google auth response");
                        else rej(new (0, _util.NonRetryableError)("Failed to reload google auth response"));
                    });
                } else rej(new (0, _util.NonRetryableError)("User is not signed in with Google"));
            }).catch(function(err) {
                logger.debug("Failed to refresh google token", err);
                rej(new (0, _util.NonRetryableError)("Failed to refresh google token"));
            });
        });
    };
    return GoogleOAuth;
}();

},{"../Logger":"jNW4z","../JS":"7JWuU","../Util":"4u1nR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eGwYE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FacebookOAuth", ()=>FacebookOAuth);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("../Logger");
var _js = require("../JS");
var _util = require("../Util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)("CognitoCredentials");
var waitForInit = new Promise(function(res, rej) {
    if (!(0, _js.browserOrNode)().isBrowser) {
        logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var FacebookOAuth = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, _js.browserOrNode)().isBrowser) fb = window["FB"];
        if (!fb) {
            var errorMessage = "no fb sdk available";
            logger.debug(errorMessage);
            return Promise.reject(new (0, _util.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = "no response from facebook when refreshing the jwt token";
                    logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, _util.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = "the jwtToken is undefined";
                        logger.debug(errorMessage);
                        rej(new (0, _util.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();

},{"../Logger":"jNW4z","../JS":"7JWuU","../Util":"4u1nR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jD5T8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsClass", ()=>CredentialsClass);
parcelHelpers.export(exports, "Credentials", ()=>Credentials);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("./Logger");
var _storageHelper = require("./StorageHelper");
var _js = require("./JS");
var _oauthHelper = require("./OAuthHelper");
var _util = require("./Util");
var _amplify = require("./Amplify");
var _cognitoIdentity = require("./AwsClients/CognitoIdentity");
var _parseAWSExports = require("./parseAWSExports");
var _hub = require("./Hub");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)("Credentials");
var CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchCredentialsEvent = function(event, data, message) {
    (0, _hub.Hub).dispatch("core", {
        event: event,
        data: data,
        message: message
    }, "Credentials", AMPLIFY_SYMBOL);
};
var CredentialsClass = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers["google"] = (0, _oauthHelper.GoogleOAuth).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, _oauthHelper.FacebookOAuth).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return "Credentials";
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = __assign(__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, _storageHelper.StorageHelper)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        dispatchCredentialsEvent("credentials_configured", null, "Credentials has been configured successfully");
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "".concat(COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            logger.debug("getting new cred promise");
            this._gettingCredPromise = (0, _js.makeQuerablePromise)(this._keepAlive());
        } else logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return __awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        logger.debug("checking if credentials exists and not expired");
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            logger.debug("credentials not changed and not expired, directly return");
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        logger.debug("need to get a new credential or refresh the existing one");
                        _a = this.Auth, Auth = _a === void 0 ? (0, _amplify.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== "function") // If Auth module is not imported, do a best effort to get guest credentials
                        return [
                            2 /*return*/ ,
                            this._setCredentialsForGuest()
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        logger.debug("ttl has passed but token is not yet expired");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        logger.debug("Error attempting to refreshing the session", err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            logger.debug("getting refreshed jwt token from federation provider");
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, _util.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            logger.debug("refresh federated token sucessfully", data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
            if (!isNetworkError) _this.clear();
            logger.debug("refresh federated token failed", e);
            return Promise.reject("refreshing federation token failed: " + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            logger.debug("no credentials for expiration check");
            return true;
        }
        logger.debug("are these credentials expired?", credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var _b, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
            var _this = this;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        logger.debug("setting credentials for guest");
                        if (!((_a = this._config) === null || _a === void 0 ? void 0 : _a.identityPoolId)) // If Credentials are not configured thru Auth module,
                        // doing best effort to check if the library was configured
                        this._config = Object.assign({}, this._config, (0, _parseAWSExports.parseAWSExports)(this._config || {}).Auth);
                        _b = this._config, identityPoolId = _b.identityPoolId, region = _b.region, mandatorySignIn = _b.mandatorySignIn, identityPoolRegion = _b.identityPoolRegion;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            logger.debug("No Cognito Identity pool provided for unauthenticated access");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Identity pool provided for unauthenticated access")
                            ];
                        }
                        if (!identityPoolRegion && !region) {
                            logger.debug("region is not configured for getting the credentials");
                            return [
                                2 /*return*/ ,
                                Promise.reject("region is not configured for getting the credentials")
                            ];
                        }
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _c._identityId = _d.sent();
                        cognitoConfig = {
                            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
                        };
                        guestCredentialsProvider = function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var IdentityId, Credentials;
                                return __generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!identityId) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                                    IdentityPoolId: identityPoolId
                                                })
                                            ];
                                        case 1:
                                            IdentityId = _a.sent().IdentityId;
                                            this._identityId = IdentityId;
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                4 /*yield*/ ,
                                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                                    IdentityId: this._identityId
                                                })
                                            ];
                                        case 3:
                                            Credentials = _a.sent().Credentials;
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    identityId: this._identityId,
                                                    accessKeyId: Credentials.AccessKeyId,
                                                    secretAccessKey: Credentials.SecretKey,
                                                    sessionToken: Credentials.SessionToken,
                                                    expiration: Credentials.Expiration
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                        credentials = guestCredentialsProvider().catch(function(err) {
                            return __awaiter(_this, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    throw err;
                                });
                            });
                        });
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var guestCredentialsProvider_1;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '".concat(identityId, "' not found."))) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                logger.debug("Failed to load guest credentials");
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                guestCredentialsProvider_1 = function() {
                                                    return __awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, Credentials;
                                                        return __generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, _cognitoIdentity.getId)(cognitoConfig, {
                                                                            IdentityPoolId: identityPoolId
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                                                            IdentityId: IdentityId
                                                                        })
                                                                    ];
                                                                case 2:
                                                                    Credentials = _a.sent().Credentials;
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        {
                                                                            identityId: IdentityId,
                                                                            accessKeyId: Credentials.AccessKeyId,
                                                                            secretAccessKey: Credentials.SecretKey,
                                                                            sessionToken: Credentials.SessionToken,
                                                                            expiration: Credentials.Expiration
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = guestCredentialsProvider_1().catch(function(err) {
                                                    return __awaiter(_this, void 0, void 0, function() {
                                                        return __generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, "guest", false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var _this = this;
        var provider = params.provider, token = params.token;
        var identity_id = params.identity_id;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        var authenticatedCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var IdentityId, Credentials;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!identity_id) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            identity_id = IdentityId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: identity_id,
                                    Logins: logins
                                })
                            ];
                        case 3:
                            Credentials = _a.sent().Credentials;
                            return [
                                2 /*return*/ ,
                                {
                                    identityId: identity_id,
                                    accessKeyId: Credentials.AccessKeyId,
                                    secretAccessKey: Credentials.SecretKey,
                                    sessionToken: Credentials.SessionToken,
                                    expiration: Credentials.Expiration
                                }
                            ];
                    }
                });
            });
        };
        var credentials = authenticatedCredentialsProvider().catch(function(err) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                })
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            logger.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                            if (guestIdentityId === primaryIdentityId) logger.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return __awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                logger.debug("Load credentials successfully", credentials);
                                if (this._identityId && !credentials.identityId) credentials["identityId"] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
                                if (source === "federated") {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        logger.debug("Failed to put federated info into auth storage", e);
                                    }
                                }
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    logger.debug("Failed to load credentials", credentials);
                    logger.debug("Error loading credentials", err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    CredentialsClass.prototype.clear = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                logger.debug("removing aws-amplify-federatedInfo from storage");
                this._storage.removeItem("aws-amplify-federatedInfo");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        logger.debug("Failed to get the cached guest identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        logger.debug("Failed to cache guest identityId", e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return __generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                logger.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var Credentials = new CredentialsClass(null);
(0, _amplify.Amplify).register(Credentials);

},{"./Logger":"jNW4z","./StorageHelper":"axKiA","./JS":"7JWuU","./OAuthHelper":"4xwpb","./Util":"4u1nR","./Amplify":"ayq1K","./AwsClients/CognitoIdentity":"6nhYo","./parseAWSExports":"5Lf91","./Hub":"cWAc9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"axKiA":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", ()=>MemoryStorage);
parcelHelpers.export(exports, "StorageHelper", ()=>StorageHelper);
var dataMemory = {};
/** @class */ var MemoryStorage = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
var StorageHelper = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6nhYo":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getId", ()=>(0, _getId.getId));
parcelHelpers.export(exports, "getCredentialsForIdentity", ()=>(0, _getCredentialsForIdentity.getCredentialsForIdentity));
var _getId = require("./getId");
var _getCredentialsForIdentity = require("./getCredentialsForIdentity");

},{"./getId":"8eAld","./getCredentialsForIdentity":"8c8JC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8eAld":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getId", ()=>getId);
var _base = require("./base");
var _clients = require("../../clients");
var _internal = require("../../clients/internal");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getIdSerializer = function(input, endpoint) {
    var headers = (0, _base.getSharedHeaders)("GetId");
    var body = JSON.stringify(input);
    return (0, _base.buildHttpRpcRequest)(endpoint, headers, body);
};
var getIdDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            $metadata: (0, _clients.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var getId = (0, _internal.composeServiceApi)((0, _base.cognitoIdentityTransferHandler), getIdSerializer, getIdDeserializer, (0, _base.defaultConfig));

},{"./base":"1z8bM","../../clients":"9kGXj","../../clients/internal":"fOplU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1z8bM":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoIdentityTransferHandler", ()=>cognitoIdentityTransferHandler);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "getSharedHeaders", ()=>getSharedHeaders);
parcelHelpers.export(exports, "buildHttpRpcRequest", ()=>buildHttpRpcRequest);
var _clients = require("../../clients");
var _composeTransferHandler = require("../../clients/internal/composeTransferHandler");
var _retry = require("../../clients/middleware/retry");
var _platform = require("../../Platform");
var _detectFramework = require("../../Platform/detectFramework");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * The service name used to sign requests if the API requires authentication.
 */ var SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://cognito-identity.".concat(region, ".").concat((0, _clients.getDnsSuffix)(region)))
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var disableCacheMiddleware = function() {
    return function(next, context) {
        return function disableCacheMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    request.headers["cache-control"] = "no-store";
                    return [
                        2 /*return*/ ,
                        next(request)
                    ];
                });
            });
        };
    };
};
var cognitoIdentityTransferHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _clients.unauthenticatedHandler), [
    disableCacheMiddleware
]);
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _retry.getRetryDecider)((0, _clients.parseJsonError)),
    computeDelay: (0, _retry.jitteredBackoff),
    userAgentValue: (0, _platform.getAmplifyUserAgent)()
};
(0, _detectFramework.observeFrameworkChanges)(function() {
    defaultConfig.userAgentValue = (0, _platform.getAmplifyUserAgent)();
});
var getSharedHeaders = function(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "AWSCognitoIdentityService.".concat(operation)
    };
};
var buildHttpRpcRequest = function(_a, headers, body) {
    var url = _a.url;
    return {
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    };
};

},{"../../clients":"9kGXj","../../clients/internal/composeTransferHandler":"g5rqG","../../clients/middleware/retry":"fImfn","../../Platform":"kna8f","../../Platform/detectFramework":"rZ1jz","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9kGXj":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>(0, _endpoints.getDnsSuffix));
parcelHelpers.export(exports, "fetchTransferHandler", ()=>(0, _fetch.fetchTransferHandler));
parcelHelpers.export(exports, "unauthenticatedHandler", ()=>(0, _unauthenticated.unauthenticatedHandler));
parcelHelpers.export(exports, "authenticatedHandler", ()=>(0, _authenticated.authenticatedHandler));
parcelHelpers.export(exports, "getHashedPayload", ()=>(0, _signatureV4.getHashedPayload));
parcelHelpers.export(exports, "presignUrl", ()=>(0, _signatureV4.presignUrl));
parcelHelpers.export(exports, "signRequest", ()=>(0, _signatureV4.signRequest));
parcelHelpers.export(exports, "EMPTY_SHA256_HASH", ()=>(0, _constants.EMPTY_HASH));
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>(0, _extendedEncodeURIComponent.extendedEncodeURIComponent));
parcelHelpers.export(exports, "signingMiddleware", ()=>(0, _signing.signingMiddleware));
parcelHelpers.export(exports, "getRetryDecider", ()=>(0, _retry.getRetryDecider));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _retry.jitteredBackoff));
parcelHelpers.export(exports, "retryMiddleware", ()=>(0, _retry.retryMiddleware));
parcelHelpers.export(exports, "userAgentMiddleware", ()=>(0, _userAgent.userAgentMiddleware));
parcelHelpers.export(exports, "parseJsonBody", ()=>(0, _serde.parseJsonBody));
parcelHelpers.export(exports, "parseJsonError", ()=>(0, _serde.parseJsonError));
parcelHelpers.export(exports, "parseMetadata", ()=>(0, _serde.parseMetadata));
parcelHelpers.export(exports, "withMemoization", ()=>(0, _memoization.withMemoization));
var _endpoints = require("./endpoints");
var _fetch = require("./handlers/fetch");
var _unauthenticated = require("./handlers/unauthenticated");
var _authenticated = require("./handlers/authenticated");
var _signatureV4 = require("./middleware/signing/signer/signatureV4");
var _constants = require("./middleware/signing/signer/signatureV4/constants");
var _extendedEncodeURIComponent = require("./middleware/signing/utils/extendedEncodeURIComponent");
var _signing = require("./middleware/signing");
var _retry = require("./middleware/retry");
var _userAgent = require("./middleware/userAgent");
var _serde = require("./serde");
var _memoization = require("./utils/memoization");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./endpoints":"ajOBW","./handlers/fetch":false,"./handlers/unauthenticated":"cz0ox","./handlers/authenticated":false,"./middleware/signing/signer/signatureV4":"d82dh","./middleware/signing/signer/signatureV4/constants":"68JII","./middleware/signing/utils/extendedEncodeURIComponent":"8baxJ","./middleware/signing":"FgmwC","./middleware/retry":"fImfn","./middleware/userAgent":"Zku6W","./serde":"kUzyl","./utils/memoization":"4ELEp","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ajOBW":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>(0, _getDnsSuffix.getDnsSuffix));
var _getDnsSuffix = require("./getDnsSuffix");

},{"./getDnsSuffix":"hKPG2","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hKPG2":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>getDnsSuffix);
var _partitions = require("./partitions");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getDnsSuffix = function(region) {
    var e_1, _a;
    var partitions = (0, _partitions.partitionsInfo).partitions;
    try {
        for(var partitions_1 = __values(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()){
            var _b = partitions_1_1.value, regions = _b.regions, outputs = _b.outputs, regionRegex = _b.regionRegex;
            var regex = new RegExp(regionRegex);
            if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (partitions_1_1 && !partitions_1_1.done && (_a = partitions_1.return)) _a.call(partitions_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _partitions.defaultPartition).outputs.dnsSuffix;
};

},{"./partitions":"4lPzc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4lPzc":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPartition", ()=>defaultPartition);
parcelHelpers.export(exports, "partitionsInfo", ()=>partitionsInfo);
var defaultPartition = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
var partitionsInfo = {
    partitions: [
        defaultPartition,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8dusd":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTransferHandler", ()=>fetchTransferHandler);
var _isomorphicUnfetch = require("isomorphic-unfetch"); // TODO: remove this dependency in v6
var _memoization = require("../utils/memoization");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var shouldSendBody = function(method) {
    return ![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
};
var fetchTransferHandler = function(_a, _b) {
    var url = _a.url, method = _a.method, headers = _a.headers, body = _a.body;
    var abortSignal = _b.abortSignal;
    return __awaiter(void 0, void 0, void 0, function() {
        var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
        var _c, _d;
        return __generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    _e.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url, {
                            method: method,
                            headers: headers,
                            body: shouldSendBody(method) ? body : undefined,
                            signal: abortSignal
                        })
                    ];
                case 1:
                    resp = _e.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_1 = _e.sent();
                    // TODO: needs to revise error handling in v6
                    // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
                    // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
                    if (e_1 instanceof TypeError) throw new Error("Network error");
                    throw e_1;
                case 3:
                    responseHeaders = {};
                    (_c = resp.headers) === null || _c === void 0 || _c.forEach(function(value, key) {
                        responseHeaders[key.toLowerCase()] = value;
                    });
                    httpResponse = {
                        statusCode: resp.status,
                        headers: responseHeaders,
                        body: null
                    };
                    bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
                        text: (0, _memoization.withMemoization)(function() {
                            return resp.text();
                        }),
                        blob: (0, _memoization.withMemoization)(function() {
                            return resp.blob();
                        }),
                        json: (0, _memoization.withMemoization)(function() {
                            return resp.json();
                        })
                    });
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, httpResponse), {
                            body: bodyWithMixin
                        })
                    ];
            }
        });
    });
};

},{"isomorphic-unfetch":"htPp0","../utils/memoization":"4ELEp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"htPp0":[function(require,module,exports) {
module.exports = self.fetch || (self.fetch = require("b3738725eb27f9ce").default || require("b3738725eb27f9ce"));

},{"b3738725eb27f9ce":"iDMyr"}],"iDMyr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(e, n) {
        return n = n || {}, new Promise(function(t, r) {
            var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
                return {
                    ok: 2 == (s.status / 100 | 0),
                    statusText: s.statusText,
                    status: s.status,
                    url: s.responseURL,
                    text: function() {
                        return Promise.resolve(s.responseText);
                    },
                    json: function() {
                        return Promise.resolve(s.responseText).then(JSON.parse);
                    },
                    blob: function() {
                        return Promise.resolve(new Blob([
                            s.response
                        ]));
                    },
                    clone: a,
                    headers: {
                        keys: function() {
                            return o;
                        },
                        entries: function() {
                            return u;
                        },
                        get: function(e) {
                            return i[e.toLowerCase()];
                        },
                        has: function(e) {
                            return e.toLowerCase() in i;
                        }
                    }
                };
            };
            for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
                s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                    o.push(n = n.toLowerCase()), u.push([
                        n,
                        t
                    ]), i[n] = i[n] ? i[n] + "," + t : t;
                }), t(a());
            }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
            s.send(n.body || null);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4ELEp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withMemoization", ()=>withMemoization);
var withMemoization = function(payloadAccessor) {
    var cached;
    return function() {
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cz0ox":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unauthenticatedHandler", ()=>unauthenticatedHandler);
var _retry = require("../middleware/retry");
var _userAgent = require("../middleware/userAgent");
var _composeTransferHandler = require("../internal/composeTransferHandler");
var _fetch = require("./fetch");
var unauthenticatedHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _fetch.fetchTransferHandler), [
    (0, _userAgent.userAgentMiddleware),
    (0, _retry.retryMiddleware)
]);

},{"../middleware/retry":"fImfn","../middleware/userAgent":"Zku6W","../internal/composeTransferHandler":"g5rqG","./fetch":"8dusd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fImfn":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>(0, _middleware.retryMiddleware));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _jitteredBackoff.jitteredBackoff));
parcelHelpers.export(exports, "getRetryDecider", ()=>(0, _defaultRetryDecider.getRetryDecider));
var _middleware = require("./middleware");
var _jitteredBackoff = require("./jitteredBackoff");
var _defaultRetryDecider = require("./defaultRetryDecider");

},{"./middleware":"bCZni","./jitteredBackoff":"5WlxN","./defaultRetryDecider":"hDM56","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bCZni":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var DEFAULT_RETRY_ATTEMPTS = 3;
var retryMiddleware = function(_a) {
    var _b = _a.maxAttempts, maxAttempts = _b === void 0 ? DEFAULT_RETRY_ATTEMPTS : _b, retryDecider = _a.retryDecider, computeDelay = _a.computeDelay, abortSignal = _a.abortSignal;
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return function(next, context) {
        return function retryMiddleware(request) {
            var _a;
            return __awaiter(this, void 0, void 0, function() {
                var error, attemptsCount, response, handleTerminalErrorOrResponse, e_1, delay;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            attemptsCount = (_a = context.attemptsCount) !== null && _a !== void 0 ? _a : 0;
                            handleTerminalErrorOrResponse = function() {
                                if (response) {
                                    addOrIncrementMetadataAttempts(response, attemptsCount);
                                    return response;
                                } else {
                                    addOrIncrementMetadataAttempts(error, attemptsCount);
                                    throw error;
                                }
                            };
                            _b.label = 1;
                        case 1:
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                11
                            ];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _b.sent();
                            error = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _b.sent();
                            error = e_1;
                            response = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                            attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
                            context.attemptsCount = attemptsCount;
                            return [
                                4 /*yield*/ ,
                                retryDecider(response, error)
                            ];
                        case 6:
                            if (!_b.sent()) return [
                                3 /*break*/ ,
                                9
                            ];
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                8
                            ];
                            delay = computeDelay(attemptsCount);
                            return [
                                4 /*yield*/ ,
                                cancellableSleep(delay, abortSignal)
                            ];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                        case 10:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 11:
                            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error("Request aborted.");
                            else return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var cancellableSleep = function(timeoutMs, abortSignal) {
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    var timeoutId;
    var sleepPromiseResolveFn;
    var sleepPromise = new Promise(function(resolve) {
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
var addOrIncrementMetadataAttempts = function(nextHandlerOutput, attempts) {
    var _a;
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = __assign(__assign({}, (_a = nextHandlerOutput["$metadata"]) !== null && _a !== void 0 ? _a : {}), {
        attempts: attempts
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5WlxN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jitteredBackoff", ()=>jitteredBackoff);
var _retry = require("../../../Util/Retry");
var DEFAULT_MAX_DELAY_MS = 300000;
var jitteredBackoff = function(attempt) {
    var delayFunction = (0, _retry.jitteredBackoff)(DEFAULT_MAX_DELAY_MS);
    var delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? DEFAULT_MAX_DELAY_MS : delay;
};

},{"../../../Util/Retry":"5Rixm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hDM56":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRetryDecider", ()=>getRetryDecider);
var _isClockSkewError = require("./isClockSkewError");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getRetryDecider = function(errorParser) {
    return function(response, error) {
        return __awaiter(void 0, void 0, void 0, function() {
            var errorCode, _a, statusCode;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(error !== null && error !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = error;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            errorParser(response)
                        ];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        errorCode = ((_b = _a) !== null && _b !== void 0 ? _b : {}).name;
                        statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
                        return [
                            2 /*return*/ ,
                            isConnectionError(error) || isThrottlingError(statusCode, errorCode) || (0, _isClockSkewError.isClockSkewError)(errorCode) || isServerSideError(statusCode, errorCode)
                        ];
                }
            });
        });
    };
};
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
var TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var isThrottlingError = function(statusCode, errorCode) {
    return statusCode === 429 || THROTTLING_ERROR_CODES.includes(errorCode);
};
var isConnectionError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "Network error";
};
var isServerSideError = function(statusCode, errorCode) {
    return [
        500,
        502,
        503,
        504
    ].includes(statusCode) || TIMEOUT_ERROR_CODES.includes(errorCode);
};

},{"./isClockSkewError":"lMYF8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lMYF8":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
var isClockSkewError = function(errorCode) {
    return CLOCK_SKEW_ERROR_CODES.includes(errorCode);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"Zku6W":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>(0, _middleware.userAgentMiddleware));
var _middleware = require("./middleware");

},{"./middleware":"5y9X1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5y9X1":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var userAgentMiddleware = function(_a) {
    var _b = _a.userAgentHeader, userAgentHeader = _b === void 0 ? "x-amz-user-agent" : _b, _c = _a.userAgentValue, userAgentValue = _c === void 0 ? "" : _c;
    return function(next) {
        return function userAgentMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var result, headerName, response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(userAgentValue.trim().length === 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 2:
                            headerName = userAgentHeader.toLowerCase();
                            request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _a.sent();
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g5rqG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeTransferHandler", ()=>composeTransferHandler);
var composeTransferHandler = function(coreHandler, middleware) {
    return function(request, options) {
        var context = {};
        var composedHandler = function(request) {
            return coreHandler(request, options);
        };
        for(var i = middleware.length - 1; i >= 0; i--){
            var m = middleware[i];
            var resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"BqrrW":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authenticatedHandler", ()=>authenticatedHandler);
var _retry = require("../middleware/retry");
var _signing = require("../middleware/signing");
var _userAgent = require("../middleware/userAgent");
var _composeTransferHandler = require("../internal/composeTransferHandler");
var _fetch = require("./fetch");
var authenticatedHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _fetch.fetchTransferHandler), [
    (0, _userAgent.userAgentMiddleware),
    (0, _retry.retryMiddleware),
    (0, _signing.signingMiddleware)
]);

},{"../middleware/retry":"fImfn","../middleware/signing":"FgmwC","../middleware/userAgent":"Zku6W","../internal/composeTransferHandler":"g5rqG","./fetch":"8dusd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"FgmwC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddleware", ()=>(0, _middleware.signingMiddleware));
var _middleware = require("./middleware");

},{"./middleware":"iZv5R","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iZv5R":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddleware", ()=>signingMiddleware);
var _signatureV4 = require("./signer/signatureV4");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var signingMiddleware = function(_a) {
    var credentials = _a.credentials, region = _a.region, service = _a.service, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
    var currentSystemClockOffset;
    return function(next) {
        return function signingMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var signRequestOptions, _a, signedRequest, response, dateString;
                var _b;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
                            _b = {};
                            if (!(typeof credentials === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                credentials()
                            ];
                        case 1:
                            _a = _c.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = credentials;
                            _c.label = 3;
                        case 3:
                            signRequestOptions = (_b.credentials = _a, _b.signingDate = (0, _getSkewCorrectedDate.getSkewCorrectedDate)(currentSystemClockOffset), _b.signingRegion = region, _b.signingService = service, _b.uriEscapePath = uriEscapePath, _b);
                            return [
                                4 /*yield*/ ,
                                (0, _signatureV4.signRequest)(request, signRequestOptions)
                            ];
                        case 4:
                            signedRequest = _c.sent();
                            return [
                                4 /*yield*/ ,
                                next(signedRequest)
                            ];
                        case 5:
                            response = _c.sent();
                            dateString = getDateHeader(response);
                            if (dateString) currentSystemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(Date.parse(dateString), currentSystemClockOffset);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function(_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, headers = _d.headers;
    return (_c = (_b = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _b !== void 0 ? _b : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _c !== void 0 ? _c : headers === null || headers === void 0 ? void 0 : headers["x-amz-date"];
};

},{"./signer/signatureV4":"d82dh","./utils/getSkewCorrectedDate":"3I8rv","./utils/getUpdatedSystemClockOffset":"9Sa1l","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3I8rv":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Sa1l":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function(clockTimeInMilliseconds, currentSystemClockOffset) {
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"bMPvu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bMPvu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
var SKEW_WINDOW = 300000;
var isClockSkewed = function(clockTimeInMilliseconds, clockOffsetInMilliseconds) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= SKEW_WINDOW;
};

},{"./getSkewCorrectedDate":"3I8rv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8baxJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Wraps encodeURIComponent to encode additional characters to fully adhere to RFC 3986.
 * @see https://github.com/aws/aws-sdk-js-v3/blob/86b432c464150069678b25ff88d57c2ca26e75a2/packages/smithy-client/src/extended-encode-uri-component.ts#L7
 *
 * @param uri URI string to encode
 * @returns RFC 3986 encoded string
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
var extendedEncodeURIComponent = function(uri) {
    // Match characters normally not encoded by `encodeURIComponent`
    var extendedCharacters = /[!'()*]/g;
    return encodeURIComponent(uri).replace(extendedCharacters, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kUzyl":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", ()=>(0, _responseInfo.parseMetadata));
parcelHelpers.export(exports, "parseJsonBody", ()=>(0, _json.parseJsonBody));
parcelHelpers.export(exports, "parseJsonError", ()=>(0, _json.parseJsonError));
var _responseInfo = require("./responseInfo");
var _json = require("./json");

},{"./responseInfo":"cIZ0q","./json":"dIYKI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cIZ0q":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", ()=>parseMetadata);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var parseMetadata = function(response) {
    var _a, _b;
    var headers = response.headers, statusCode = response.statusCode;
    return __assign(__assign({}, isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_b = (_a = headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    });
};
var isMetadataBearer = function(response) {
    return typeof (response === null || response === void 0 ? void 0 : response["$metadata"]) === "object";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dIYKI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsonError", ()=>parseJsonError);
parcelHelpers.export(exports, "parseJsonBody", ()=>parseJsonBody);
var _responseInfo = require("./responseInfo");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var parseJsonError = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var body, sanitizeErrorCode, code, message, error;
        var _a, _b, _c, _d, _e;
        return __generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    return [
                        4 /*yield*/ ,
                        parseJsonBody(response)
                    ];
                case 1:
                    body = _f.sent();
                    sanitizeErrorCode = function(rawValue) {
                        var _a = __read(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a[0];
                        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
                        return cleanValue;
                    };
                    code = sanitizeErrorCode((_c = (_b = (_a = response.headers["x-amzn-errortype"]) !== null && _a !== void 0 ? _a : body.code) !== null && _b !== void 0 ? _b : body.__type) !== null && _c !== void 0 ? _c : "UnknownError");
                    message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : "Unknown error";
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, _responseInfo.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var parseJsonBody = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var output;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) throw new Error("Missing response payload");
                    return [
                        4 /*yield*/ ,
                        response.body.json()
                    ];
                case 1:
                    output = _a.sent();
                    return [
                        2 /*return*/ ,
                        Object.assign(output, {
                            $metadata: (0, _responseInfo.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};

},{"./responseInfo":"cIZ0q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fOplU":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This index should NOT be included in the ../index.ts because the composer functions
 * here requires TypeScript >= 4. Given other scoped packages may use TypeScript < 4,
 * they should not be exposed to upper level index.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", ()=>(0, _composeServiceApi.composeServiceApi));
parcelHelpers.export(exports, "composeTransferHandler", ()=>(0, _composeTransferHandler.composeTransferHandler));
var _composeServiceApi = require("./composeServiceApi");
var _composeTransferHandler = require("./composeTransferHandler");

},{"./composeServiceApi":"6uOwS","./composeTransferHandler":"g5rqG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6uOwS":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", ()=>composeServiceApi);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var composeServiceApi = function(transferHandler, serializer, deserializer, defaultConfig) {
    return function(config, input) {
        return __awaiter(void 0, void 0, void 0, function() {
            var resolvedConfig, endpoint, request, response;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolvedConfig = __assign(__assign({}, defaultConfig), config);
                        return [
                            4 /*yield*/ ,
                            resolvedConfig.endpointResolver(resolvedConfig, input)
                        ];
                    case 1:
                        endpoint = _a.sent();
                        return [
                            4 /*yield*/ ,
                            serializer(input, endpoint)
                        ];
                    case 2:
                        request = _a.sent();
                        return [
                            4 /*yield*/ ,
                            transferHandler(request, __assign({}, resolvedConfig))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            deserializer(response)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8c8JC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialsForIdentity", ()=>getCredentialsForIdentity);
var _base = require("./base");
var _clients = require("../../clients");
var _internal = require("../../clients/internal");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getCredentialsForIdentitySerializer = function(input, endpoint) {
    var headers = (0, _base.getSharedHeaders)("GetCredentialsForIdentity");
    var body = JSON.stringify(input);
    return (0, _base.buildHttpRpcRequest)(endpoint, headers, body);
};
var getCredentialsForIdentityDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            Credentials: deserializeCredentials(body.Credentials),
                            $metadata: (0, _clients.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var deserializeCredentials = function(output) {
    if (output === void 0) output = {};
    return {
        AccessKeyId: output["AccessKeyId"],
        SecretKey: output["SecretKey"],
        SessionToken: output["SessionToken"],
        Expiration: new Date(output["Expiration"] * 1000)
    };
};
var getCredentialsForIdentity = (0, _internal.composeServiceApi)((0, _base.cognitoIdentityTransferHandler), getCredentialsForIdentitySerializer, getCredentialsForIdentityDeserializer, (0, _base.defaultConfig));

},{"./base":"1z8bM","../../clients":"9kGXj","../../clients/internal":"fOplU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Aaan":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _serviceWorker.ServiceWorkerClass));
var _serviceWorker = require("./ServiceWorker");

},{"./ServiceWorker":"6Zc6v","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6Zc6v":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorkerClass", ()=>ServiceWorkerClass);
var _logger = require("../Logger");
var _js = require("../JS");
var _amplify = require("../Amplify");
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var ServiceWorkerClass = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, _logger.ConsoleLogger)("ServiceWorker");
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = "/service-worker.js";
        if (scope === void 0) scope = "/";
        this._logger.debug("registering ".concat(filePath));
        this._logger.debug("registering service worker with scope ".concat(scope));
        return new Promise(function(resolve, reject) {
            if (navigator && "serviceWorker" in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: ".concat(registration));
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed ".concat(error));
                return reject(error);
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error("Service Worker not registered");
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, _js.browserOrNode)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: ".concat(JSON.stringify(subscription)));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: ".concat(JSON.stringify(subscription)));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = "=".repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === "object" ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener("statechange", function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: ".concat(currentState));
            if ((0, _amplify.Amplify).Analytics && typeof (0, _amplify.Amplify).Analytics.record === "function") (0, _amplify.Amplify).Analytics.record({
                name: "ServiceWorker",
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener("message", function(event) {
            _this._logger.debug("ServiceWorker message event: ".concat(event));
        });
    };
    return ServiceWorkerClass;
}();

},{"../Logger":"jNW4z","../JS":"7JWuU","../Amplify":"ayq1K","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d266z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniversalStorage", ()=>UniversalStorage);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _universalCookie = require("universal-cookie");
var _universalCookieDefault = parcelHelpers.interopDefault(_universalCookie);
var _js = require("../JS");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isBrowser = (0, _js.browserOrNode)().isBrowser;
var ONE_YEAR_IN_MS = 31536000000;
var UniversalStorage = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, _universalCookieDefault.default)();
        this.store = isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, _universalCookieDefault.default)(decodeURIComponent(context.req.headers.cookie)) : new (0, _universalCookieDefault.default)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: false,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: "/"
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split(".").pop();
        var sessionTokenTypes = [
            "LastAuthUser",
            "accessToken",
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            "refreshToken",
            // Required for CognitoUserSession
            "idToken"
        ];
        if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : "")) this.setUniversalItem(key, value, {
            expires: new Date(Date.now() + ONE_YEAR_IN_MS)
        });
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value, options) {
        if (options === void 0) options = {};
        this.cookies.set(key, value, __assign(__assign({}, options), {
            path: "/",
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: isBrowser && window.location.hostname === "localhost" ? false : true
        }));
    };
    return UniversalStorage;
}();

},{"universal-cookie":"3Otwi","../JS":"7JWuU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Otwi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cookies = require("./Cookies");
var _cookiesDefault = parcelHelpers.interopDefault(_cookies);
exports.default = (0, _cookiesDefault.default);

},{"./Cookies":"yyYIO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"yyYIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cookie = require("cookie");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, _utils.parseCookies)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = _cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, _utils.readCookie)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, _utils.readCookie)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = _cookie.serialize(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = __assign(__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = _cookie.serialize(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
exports.default = Cookies;

},{"cookie":"k1ncP","./utils":"2hzGf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k1ncP":[function(require,module,exports) {
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ exports.parse = parse;
exports.serialize = serialize;
/**
 * Module variables.
 * @private
 */ var decode = decodeURIComponent;
var encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

},{}],"2hzGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasDocumentCookie", ()=>hasDocumentCookie);
parcelHelpers.export(exports, "cleanCookies", ()=>cleanCookies);
parcelHelpers.export(exports, "parseCookies", ()=>parseCookies);
parcelHelpers.export(exports, "isParsingCookie", ()=>isParsingCookie);
parcelHelpers.export(exports, "readCookie", ()=>readCookie);
var _cookie = require("cookie");
function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function cleanCookies() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === "string") return _cookie.parse(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) options = {};
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}

},{"cookie":"k1ncP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e8Pvn":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", ()=>INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER);
parcelHelpers.export(exports, "USER_AGENT_HEADER", ()=>USER_AGENT_HEADER);
var hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER = hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var USER_AGENT_HEADER = "x-amz-user-agent";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"174Sr":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Analytics", ()=>(0, _analytics.Analytics));
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _providers.AWSPinpointProvider));
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>(0, _providers.AWSKinesisProvider));
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>(0, _providers.AWSKinesisFirehoseProvider));
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>(0, _providers.AmazonPersonalizeProvider));
var _analytics = require("./Analytics");
var _providers = require("./Providers");

},{"./Analytics":"2J8ND","./Providers":"hNmql","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2J8ND":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsClass", ()=>AnalyticsClass);
parcelHelpers.export(exports, "Analytics", ()=>Analytics);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _awspinpointProvider = require("./Providers/AWSPinpointProvider");
var _trackers = require("./trackers");
var logger = new (0, _core.ConsoleLogger)("AnalyticsClass");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAnalyticsEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("analytics", {
        event: event,
        data: data,
        message: message
    }, "Analytics", AMPLIFY_SYMBOL);
};
var trackers = {
    pageView: (0, _trackers.PageViewTracker),
    event: (0, _trackers.EventTracker),
    session: (0, _trackers.SessionTracker)
};
var _instance = null;
/**
 * Provide mobile analytics client functions
 */ var AnalyticsClass = /** @class */ function() {
    /**
     * Initialize Analtyics
     * @param config - Configuration of the Analytics
     */ function AnalyticsClass() {
        this._config = {};
        this._pluggables = [];
        this._disabled = false;
        this._trackers = {};
        _instance = this;
        this.record = this.record.bind(this);
        (0, _core.Hub).listen("auth", listener);
        (0, _core.Hub).listen("storage", listener);
        (0, _core.Hub).listen("analytics", listener);
        (0, _core.Hub).listen("core", listener);
    }
    AnalyticsClass.prototype.getModuleName = function() {
        return "Analytics";
    };
    /**
     * configure Analytics
     * @param {Object} config - Configuration of the Analytics
     */ AnalyticsClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        logger.debug("configure Analytics", config);
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Analytics, config);
        if (this._config["disabled"]) this._disabled = true;
        // turn on the autoSessionRecord if not specified
        if (this._config["autoSessionRecord"] === undefined) this._config["autoSessionRecord"] = true;
        this._pluggables.forEach(function(pluggable) {
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !_this._config["AWSPinpoint"] ? _this._config : _this._config[pluggable.getProviderName()];
            pluggable.configure((0, _tslib.__assign)({
                disabled: _this._config["disabled"],
                autoSessionRecord: _this._config["autoSessionRecord"]
            }, providerConfig));
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _awspinpointProvider.AWSPinpointProvider)());
        dispatchAnalyticsEvent("configured", null, "The Analytics category has been configured successfully");
        logger.debug("current configuration", this._config);
        return this._config;
    };
    /**
     * add plugin into Analytics category
     * @param pluggable - an instance of the plugin
     */ AnalyticsClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Analytics") {
            this._pluggables.push(pluggable);
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !this._config["AWSPinpoint"] ? this._config : this._config[pluggable.getProviderName()];
            var config = (0, _tslib.__assign)({
                disabled: this._config["disabled"]
            }, providerConfig);
            pluggable.configure(config);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the provider to be removed
     */ AnalyticsClass.prototype.getPluggable = function(providerName) {
        for(var i = 0; i < this._pluggables.length; i += 1){
            var pluggable = this._pluggables[i];
            if (pluggable.getProviderName() === providerName) return pluggable;
        }
        logger.debug("No plugin found with providerName", providerName);
        return null;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the provider to be removed
     */ AnalyticsClass.prototype.removePluggable = function(providerName) {
        var idx = 0;
        while(idx < this._pluggables.length){
            if (this._pluggables[idx].getProviderName() === providerName) break;
            idx += 1;
        }
        if (idx === this._pluggables.length) {
            logger.debug("No plugin found with providerName", providerName);
            return;
        } else {
            this._pluggables.splice(idx, idx + 1);
            return;
        }
    };
    /**
     * stop sending events
     */ AnalyticsClass.prototype.disable = function() {
        this._disabled = true;
    };
    /**
     * start sending events
     */ AnalyticsClass.prototype.enable = function() {
        this._disabled = false;
    };
    /**
     * Record Session start
     * @param [provider] - name of the provider.
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.startSession = function(provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event, params;
            return (0, _tslib.__generator)(this, function(_a) {
                event = {
                    name: "_session.start"
                };
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent("record", event, "Recording Analytics session start event");
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record Session stop
     * @param [provider] - name of the provider.
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.stopSession = function(provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event, params;
            return (0, _tslib.__generator)(this, function(_a) {
                event = {
                    name: "_session.stop"
                };
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent("record", event, "Recording Analytics session stop event");
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record one analytic event and send it to Pinpoint
     * @param event - An object with the name of the event, attributes of the event and event metrics.
     * @param [provider] - name of the provider.
     */ AnalyticsClass.prototype.record = function(event, provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params;
            return (0, _tslib.__generator)(this, function(_a) {
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent("record", params.event, "Recording Analytics event");
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    AnalyticsClass.prototype.updateEndpoint = function(attrs, provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event;
            return (0, _tslib.__generator)(this, function(_a) {
                event = (0, _tslib.__assign)((0, _tslib.__assign)({}, attrs), {
                    name: "_update_endpoint"
                });
                return [
                    2 /*return*/ ,
                    this.record(event, provider)
                ];
            });
        });
    };
    AnalyticsClass.prototype._sendEvent = function(params) {
        var _this = this;
        if (this._disabled) {
            logger.debug("Analytics has been disabled");
            return Promise.resolve();
        }
        var provider = params.provider ? params.provider : "AWSPinpoint";
        return new Promise(function(resolve, reject) {
            _this._pluggables.forEach(function(pluggable) {
                if (pluggable.getProviderName() === provider) pluggable.record(params, {
                    resolve: resolve,
                    reject: reject
                });
            });
        });
    };
    AnalyticsClass.prototype.autoTrack = function(trackerType, opts) {
        if (!trackers[trackerType]) {
            logger.debug("invalid tracker type");
            return;
        }
        // to sync up two different configuration ways of auto session tracking
        if (trackerType === "session") this._config["autoSessionRecord"] = opts["enable"];
        var tracker = this._trackers[trackerType];
        if (!tracker) this._trackers[trackerType] = new trackers[trackerType](this.record, opts);
        else tracker.configure(opts);
    };
    return AnalyticsClass;
}();
var endpointUpdated = false;
var authConfigured = false;
var analyticsConfigured = false;
var credentialsConfigured = false;
var listener = function(capsule) {
    var channel = capsule.channel, payload = capsule.payload;
    logger.debug("on hub capsule " + channel, payload);
    switch(channel){
        case "auth":
            authEvent(payload);
            break;
        case "storage":
            storageEvent(payload);
            break;
        case "analytics":
            analyticsEvent(payload);
            break;
        case "core":
            coreEvent(payload);
            break;
        default:
            break;
    }
};
var storageEvent = function(payload) {
    var _a = payload.data, attrs = _a.attrs, metrics = _a.metrics;
    if (!attrs) return;
    if (analyticsConfigured) _instance.record({
        name: "Storage",
        attributes: attrs,
        metrics: metrics
    }).catch(function(e) {
        logger.debug("Failed to send the storage event automatically", e);
    });
};
var authEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    var recordAuthEvent = function(eventName) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(authConfigured && analyticsConfigured)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            _instance.record({
                                name: "_userauth." + eventName
                            })
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        err_1 = _a.sent();
                        logger.debug("Failed to send the " + eventName + " event automatically", err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    switch(event){
        case "signIn":
            return recordAuthEvent("sign_in");
        case "signUp":
            return recordAuthEvent("sign_up");
        case "signOut":
            return recordAuthEvent("sign_out");
        case "signIn_failure":
            return recordAuthEvent("auth_fail");
        case "configured":
            authConfigured = true;
            if (analyticsConfigured) sendEvents();
            break;
    }
};
var analyticsEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case "pinpointProvider_configured":
            analyticsConfigured = true;
            if (authConfigured || credentialsConfigured) sendEvents();
            break;
    }
};
var coreEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case "credentials_configured":
            credentialsConfigured = true;
            if (analyticsConfigured) sendEvents();
            break;
    }
};
var sendEvents = function() {
    var config = _instance.configure();
    if (!endpointUpdated && config["autoSessionRecord"]) {
        _instance.updateEndpoint({
            immediate: true
        }).catch(function(e) {
            logger.debug("Failed to update the endpoint", e);
        });
        endpointUpdated = true;
    }
    _instance.autoTrack("session", {
        enable: config["autoSessionRecord"]
    });
};
var Analytics = new AnalyticsClass();
(0, _core.Amplify).register(Analytics);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./Providers/AWSPinpointProvider":"3ah5f","./trackers":"dZpTd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3ah5f":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>AWSPinpointProvider);
var _tslib = require("tslib");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _uuid = require("uuid");
var _userAgent = require("../utils/UserAgent");
var _eventBuffer = require("./EventBuffer");
var _eventBufferDefault = parcelHelpers.interopDefault(_eventBuffer);
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAnalyticsEvent = function(event, data) {
    (0, _core.Hub).dispatch("analytics", {
        event: event,
        data: data
    }, "Analytics", AMPLIFY_SYMBOL);
};
var logger = new (0, _core.ConsoleLogger)("AWSPinpointProvider");
var RETRYABLE_CODES = [
    429,
    500
];
var ACCEPTED_CODES = [
    202
];
var FORBIDDEN_CODE = 403;
var MOBILE_SERVICE_NAME = "mobiletargeting";
var EXPIRED_TOKEN_CODE = "ExpiredTokenException";
var UPDATE_ENDPOINT = "_update_endpoint";
var SESSION_START = "_session.start";
var SESSION_STOP = "_session.stop";
var BEACON_SUPPORTED = typeof navigator !== "undefined" && navigator && typeof navigator.sendBeacon === "function";
// events buffer
var BUFFER_SIZE = 1000;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5000; // 5s
var RESEND_LIMIT = 5;
// params: { event: {name: , .... }, timeStamp, config, resendLimits }
var AWSPinpointProvider = /** @class */ function() {
    function AWSPinpointProvider(config) {
        this._endpointGenerating = true;
        this._endpointUpdateInProgress = false;
        this._buffer = null;
        this._endpointBuffer = [];
        this._config = config ? config : {};
        this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
        this._clientInfo = (0, _core.ClientDevice).clientInfo();
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProvider.prototype.getCategory = function() {
        return AWSPinpointProvider.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProvider.prototype.getProviderName = function() {
        return AWSPinpointProvider.providerName;
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSPinpointProvider.prototype.configure = function(config) {
        var _this = this;
        logger.debug("configure Analytics", config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        // If autoSessionRecord is enabled, we need to wait for the endpoint to be
        // updated before sending any events. See `sendEvents` in `Analytics.ts`
        this._endpointGenerating = !!config["autoSessionRecord"];
        if (this._config.appId && !this._config.disabled) {
            if (!this._config.endpointId) {
                var cacheKey = this.getProviderName() + "_" + this._config.appId;
                this._getEndpointId(cacheKey).then(function(endpointId) {
                    logger.debug("setting endpoint id from the cache", endpointId);
                    _this._config.endpointId = endpointId;
                    dispatchAnalyticsEvent("pinpointProvider_configured", null);
                }).catch(function(err) {
                    logger.debug("Failed to generate endpointId", err);
                });
            } else dispatchAnalyticsEvent("pinpointProvider_configured", null);
        } else this._flushBuffer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSPinpointProvider.prototype.record = function(params, handlers) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, timestamp;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("_public record", params);
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials || !this._config.appId || !this._config.region) {
                            logger.debug("cannot send events without credentials, applicationId or region");
                            return [
                                2 /*return*/ ,
                                handlers.reject(new Error("No credentials, applicationId or region"))
                            ];
                        }
                        this._init(credentials);
                        timestamp = new Date().getTime();
                        // attach the session and eventId
                        this._generateSession(params);
                        params.event.eventId = (0, _uuid.v1)();
                        Object.assign(params, {
                            timestamp: timestamp,
                            config: this._config
                        });
                        if (params.event.immediate) return [
                            2 /*return*/ ,
                            this._send(params, handlers)
                        ];
                        else this._putToBuffer(params, handlers);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._sendEndpointUpdate = function(endpointObject) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var next;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._endpointUpdateInProgress) {
                            this._endpointBuffer.push(endpointObject);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._endpointUpdateInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._updateEndpoint(endpointObject)
                        ];
                    case 1:
                        _a.sent();
                        next = this._endpointBuffer.shift();
                        this._endpointUpdateInProgress = false;
                        next && this._sendEndpointUpdate(next);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     * @param params - params for event recording
     * Put events into buffer
     */ AWSPinpointProvider.prototype._putToBuffer = function(params, handlers) {
        var _a;
        if (params.event.name === UPDATE_ENDPOINT) {
            this._sendEndpointUpdate({
                params: params,
                handlers: handlers
            });
            return;
        }
        (_a = this._buffer) === null || _a === void 0 || _a.push({
            params: params,
            handlers: handlers
        });
    };
    AWSPinpointProvider.prototype._generateSession = function(params) {
        this._sessionId = this._sessionId || (0, _uuid.v1)();
        var event = params.event;
        switch(event.name){
            case SESSION_START:
                // refresh the session id and session start time
                this._sessionStartTimestamp = new Date().getTime();
                this._sessionId = (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
                break;
            case SESSION_STOP:
                var stopTimestamp = new Date().getTime();
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    Duration: stopTimestamp - this._sessionStartTimestamp,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString(),
                    StopTimestamp: new Date(stopTimestamp).toISOString()
                };
                this._sessionId = undefined;
                this._sessionStartTimestamp = undefined;
                break;
            default:
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
        }
    };
    AWSPinpointProvider.prototype._send = function(params, handlers) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event;
            return (0, _tslib.__generator)(this, function(_a) {
                event = params.event;
                switch(event.name){
                    case UPDATE_ENDPOINT:
                        return [
                            2 /*return*/ ,
                            this._updateEndpoint({
                                params: params,
                                handlers: handlers
                            })
                        ];
                    case SESSION_STOP:
                        return [
                            2 /*return*/ ,
                            this._pinpointSendStopSession(params, handlers)
                        ];
                    default:
                        return [
                            2 /*return*/ ,
                            this._pinpointPutEvents(params, handlers)
                        ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._generateBatchItemContext = function(params) {
        var _a, _b;
        var event = params.event, timestamp = params.timestamp, config = params.config;
        var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
        var appId = config.appId, endpointId = config.endpointId;
        var endpointContext = {};
        return {
            ApplicationId: appId,
            EventsRequest: {
                BatchItem: (_a = {}, _a[endpointId] = {
                    Endpoint: endpointContext,
                    Events: (_b = {}, _b[eventId] = {
                        EventType: name,
                        Timestamp: new Date(timestamp).toISOString(),
                        Attributes: attributes,
                        Metrics: metrics,
                        Session: session
                    }, _b)
                }, _a)
            }
        };
    };
    AWSPinpointProvider.prototype._pinpointPutEvents = function(params, handlers) {
        var _a, _b, _c, _d, _e;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var eventId, endpointId, eventParams, _f, credentials, region, data, _g, StatusCode, Message, err_1;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        eventId = params.event.eventId, endpointId = params.config.endpointId;
                        eventParams = this._generateBatchItemContext(params);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _f = this._config, credentials = _f.credentials, region = _f.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.putEvents)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).Record)
                            }, eventParams)
                        ];
                    case 2:
                        data = _h.sent();
                        _g = (_e = (_d = (_c = (_b = (_a = data.EventsResponse) === null || _a === void 0 ? void 0 : _a.Results) === null || _b === void 0 ? void 0 : _b[endpointId]) === null || _c === void 0 ? void 0 : _c.EventsItemResponse) === null || _d === void 0 ? void 0 : _d[eventId]) !== null && _e !== void 0 ? _e : {}, StatusCode = _g.StatusCode, Message = _g.Message;
                        if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
                            logger.debug("record event success. ", data);
                            return [
                                2 /*return*/ ,
                                handlers.resolve(data)
                            ];
                        } else if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) // TODO: v6 integrate retry to the service handler retryDecider
                        this._retry(params, handlers);
                        else {
                            logger.error("Event " + eventId + " is not accepted, the error is " + Message);
                            return [
                                2 /*return*/ ,
                                handlers.reject(data)
                            ];
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _h.sent();
                        this._eventError(err_1);
                        return [
                            2 /*return*/ ,
                            handlers.reject(err_1)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._pinpointSendStopSession = function(params, handlers) {
        if (!BEACON_SUPPORTED) {
            this._pinpointPutEvents(params, handlers);
            return;
        }
        var eventParams = this._generateBatchItemContext(params);
        var region = this._config.region;
        var ApplicationId = eventParams.ApplicationId, EventsRequest = eventParams.EventsRequest;
        var accessInfo = {
            secret_key: this._config.credentials.secretAccessKey,
            access_key: this._config.credentials.accessKeyId,
            session_token: this._config.credentials.sessionToken
        };
        var url = "https://pinpoint." + region + ".amazonaws.com/v1/apps/" + ApplicationId + "/events/legacy";
        var body = JSON.stringify(EventsRequest);
        var method = "POST";
        var request = {
            url: url,
            body: body,
            method: method
        };
        var serviceInfo = {
            region: region,
            service: MOBILE_SERVICE_NAME
        };
        var requestUrl = (0, _core.Signer).signUrl(request, accessInfo, serviceInfo);
        var success = navigator.sendBeacon(requestUrl, body);
        if (success) return handlers.resolve("sendBeacon success");
        return handlers.reject("sendBeacon failure");
    };
    AWSPinpointProvider.prototype._retry = function(params, handlers) {
        var resendLimit = params.config.resendLimit;
        // For backward compatibility
        params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            logger.debug("resending event " + params.eventName + " with " + params.resendLimit + " retry times left");
            this._pinpointPutEvents(params, handlers);
        } else logger.debug("retry times used up for event " + params.eventName);
    };
    AWSPinpointProvider.prototype._updateEndpoint = function(endpointObject) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params, handlers, config, event, appId, endpointId, request, update_params, _a, credentials, region, data, err_2, failureData;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        params = endpointObject.params, handlers = endpointObject.handlers;
                        config = params.config, event = params.event;
                        appId = config.appId, endpointId = config.endpointId;
                        request = this._endpointRequest(config, (0, _core.transferKeyToLowerCase)(event, [], [
                            "attributes",
                            "userAttributes",
                            "Attributes",
                            "UserAttributes"
                        ]));
                        update_params = {
                            ApplicationId: appId,
                            EndpointId: endpointId,
                            EndpointRequest: request
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this._config, credentials = _a.credentials, region = _a.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.updateEndpoint)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).UpdateEndpoint)
                            }, update_params)
                        ];
                    case 2:
                        data = _b.sent();
                        logger.debug("updateEndpoint success", data);
                        this._endpointGenerating = false;
                        this._resumeBuffer();
                        handlers.resolve(data);
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        err_2 = _b.sent();
                        failureData = {
                            err: err_2,
                            update_params: update_params,
                            endpointObject: endpointObject
                        };
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateFailure(failureData)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateFailure = function(failureData) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var err, endpointObject, statusCode, exponential;
            return (0, _tslib.__generator)(this, function(_a) {
                err = failureData.err, endpointObject = failureData.endpointObject;
                statusCode = err.$metadata && err.$metadata.httpStatusCode;
                logger.debug("updateEndpoint error", err);
                switch(statusCode){
                    case FORBIDDEN_CODE:
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateForbidden(failureData)
                        ];
                    default:
                        if (RETRYABLE_CODES.includes(statusCode)) {
                            exponential = true;
                            return [
                                2 /*return*/ ,
                                this._retryEndpointUpdate(endpointObject, exponential)
                            ];
                        }
                        logger.error("updateEndpoint failed", err);
                        endpointObject.handlers.reject(err);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateForbidden = function(failureData) {
        var err = failureData.err, endpointObject = failureData.endpointObject;
        var code = err.code, retryable = err.retryable;
        if (code !== EXPIRED_TOKEN_CODE && !retryable) return endpointObject.handlers.reject(err);
        this._retryEndpointUpdate(endpointObject);
    };
    AWSPinpointProvider.prototype._retryEndpointUpdate = function(endpointObject, exponential) {
        if (exponential === void 0) exponential = false;
        logger.debug("_retryEndpointUpdate", endpointObject);
        var params = endpointObject.params;
        // TODO: implement retry with exp back off once exp function is available
        var resendLimit = params.config.resendLimit;
        params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            logger.debug("resending endpoint update " + params.event.eventId + " with " + params.resendLimit + " retry attempts remaining");
            // insert at the front of endpointBuffer
            this._endpointBuffer.length ? this._endpointBuffer.unshift(endpointObject) : this._updateEndpoint(endpointObject);
            return;
        }
        logger.warn("resending endpoint update " + params.event.eventId + " failed after " + params.config.resendLimit + " attempts");
        if (this._endpointGenerating) logger.error("Initial endpoint update failed. ");
    };
    /**
     * @private
     * @param config
     * Configure credentials and init buffer
     */ AWSPinpointProvider.prototype._init = function(credentials) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var identityId;
            return (0, _tslib.__generator)(this, function(_a) {
                logger.debug("init provider");
                if (this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
                    logger.debug("no change for aws credentials, directly return from init");
                    return [
                        2 /*return*/ 
                    ];
                }
                identityId = this._config.credentials ? this._config.credentials.identityId : null;
                this._config.credentials = credentials;
                if (!this._bufferExists() || identityId !== credentials.identityId) // if the identity has changed, flush the buffer and instantiate a new one
                // this will cause the old buffer to send any remaining events
                // with the old credentials and then stop looping and shortly thereafter get picked up by GC
                this._initBuffer();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._bufferExists = function() {
        return this._buffer && this._buffer instanceof (0, _eventBufferDefault.default);
    };
    AWSPinpointProvider.prototype._initBuffer = function() {
        if (this._bufferExists()) this._flushBuffer();
        this._buffer = new (0, _eventBufferDefault.default)(this._config);
        // if the first endpoint update hasn't yet resolved pause the buffer to
        // prevent race conditions. It will be resumed as soon as that request succeeds
        if (this._endpointGenerating) this._buffer.pause();
    };
    AWSPinpointProvider.prototype._flushBuffer = function() {
        var _a;
        if (this._bufferExists()) {
            (_a = this._buffer) === null || _a === void 0 || _a.flush();
            this._buffer = null;
        }
    };
    AWSPinpointProvider.prototype._resumeBuffer = function() {
        var _a;
        if (this._bufferExists()) (_a = this._buffer) === null || _a === void 0 || _a.resume();
    };
    AWSPinpointProvider.prototype._getEndpointId = function(cacheKey) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var endpointId, ttl, expiration;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem(cacheKey)
                        ];
                    case 1:
                        endpointId = _a.sent();
                        logger.debug("endpointId from cache", endpointId, "type", typeof endpointId);
                        if (!endpointId) {
                            endpointId = (0, _uuid.v1)();
                            ttl = 3153600000000;
                            expiration = new Date().getTime() + ttl;
                            (0, _cache.Cache).setItem(cacheKey, endpointId, {
                                expires: expiration,
                                priority: 1
                            });
                        }
                        return [
                            2 /*return*/ ,
                            endpointId
                        ];
                }
            });
        });
    };
    /**
     * EndPoint request
     * @return {Object} - The request of updating endpoint
     */ AWSPinpointProvider.prototype._endpointRequest = function(config, event) {
        var credentials = config.credentials;
        var clientInfo = this._clientInfo || {};
        var clientContext = config.clientContext || {};
        // for now we have three different ways for default endpoint configurations
        // clientInfo
        // clientContext (deprecated)
        // config.endpoint
        var defaultEndpointConfig = config.endpoint || {};
        var demographicByClientInfo = {
            appVersion: clientInfo.appVersion,
            make: clientInfo.make,
            model: clientInfo.model,
            modelVersion: clientInfo.version,
            platform: clientInfo.platform
        };
        // for backward compatibility
        var clientId = clientContext.clientId, appTitle = clientContext.appTitle, appVersionName = clientContext.appVersionName, appVersionCode = clientContext.appVersionCode, appPackageName = clientContext.appPackageName, demographicByClientContext = (0, _tslib.__rest)(clientContext, [
            "clientId",
            "appTitle",
            "appVersionName",
            "appVersionCode",
            "appPackageName"
        ]);
        var channelType = event.address ? clientInfo.platform === "android" ? "GCM" : "APNS" : undefined;
        var tmp = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
            channelType: channelType,
            requestId: (0, _uuid.v1)(),
            effectiveDate: new Date().toISOString()
        }, defaultEndpointConfig), event), {
            attributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.attributes), event.attributes),
            demographic: (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, demographicByClientInfo), demographicByClientContext), defaultEndpointConfig.demographic), event.demographic),
            location: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.location), event.location),
            metrics: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.metrics), event.metrics),
            user: {
                userId: event.userId || defaultEndpointConfig.userId || credentials.identityId,
                userAttributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.userAttributes), event.userAttributes)
            }
        });
        // eliminate unnecessary params
        var userId = tmp.userId, userAttributes = tmp.userAttributes, name = tmp.name, session = tmp.session, eventId = tmp.eventId, immediate = tmp.immediate, ret = (0, _tslib.__rest)(tmp, [
            "userId",
            "userAttributes",
            "name",
            "session",
            "eventId",
            "immediate"
        ]);
        return (0, _core.transferKeyToUpperCase)(ret, [], [
            "metrics",
            "userAttributes",
            "attributes"
        ]);
    };
    AWSPinpointProvider.prototype._eventError = function(err) {
        logger.error("record event failed.", err);
        logger.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:PutEvents" in order to record events');
    };
    AWSPinpointProvider.prototype._getCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, err_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            null
                        ];
                        logger.debug("set credentials for analytics", credentials);
                        return [
                            2 /*return*/ ,
                            (0, _core.Credentials).shear(credentials)
                        ];
                    case 2:
                        err_3 = _a.sent();
                        logger.debug("ensure credentials error", err_3);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.category = "Analytics";
    AWSPinpointProvider.providerName = "AWSPinpoint";
    return AWSPinpointProvider;
}();

},{"tslib":"9gMVn","@aws-amplify/cache":"egrWR","@aws-amplify/core":"8BDOx","@aws-amplify/core/internals/aws-clients/pinpoint":"8UVd6","uuid":"9dBTc","../utils/UserAgent":"PNdyN","./EventBuffer":"1e66K","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"egrWR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorageCache", ()=>(0, _browserStorageCache.BrowserStorageCache));
parcelHelpers.export(exports, "InMemoryCache", ()=>(0, _inMemoryCache.InMemoryCache));
// Standard `Cache` export to maintain interoperability with React Native
parcelHelpers.export(exports, "Cache", ()=>(0, _browserStorageCache.BrowserStorageCache));
var _browserStorageCache = require("./BrowserStorageCache");
var _inMemoryCache = require("./InMemoryCache");

},{"./BrowserStorageCache":"6HroE","./InMemoryCache":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6HroE":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorageCacheClass", ()=>BrowserStorageCacheClass);
parcelHelpers.export(exports, "BrowserStorageCache", ()=>BrowserStorageCache);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _utils = require("./Utils");
var _storageCache = require("./StorageCache");
var logger = new (0, _core.ConsoleLogger)("Cache");
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var BrowserStorageCacheClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, _utils.defaultConfig), config) : (0, _utils.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, _utils.getCurrTime)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, _utils.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === "undefined") {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, _utils.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, "0");
            ret = "0";
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, _utils.defaultConfig).keyPrefix) {
            logger.error("invalid keyPrefix, setting keyPrefix with timeStamp");
            config.keyPrefix = (0, _utils.getCurrTime).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, _storageCache.StorageCache));
var BrowserStorageCache = new BrowserStorageCacheClass();
(0, _core.Amplify).register(BrowserStorageCache);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./Utils":"57A0i","./StorageCache":"9VMCe","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"57A0i":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheObject", ()=>(0, _cacheUtils.CacheObject));
parcelHelpers.export(exports, "defaultConfig", ()=>(0, _cacheUtils.defaultConfig));
parcelHelpers.export(exports, "getByteLength", ()=>(0, _cacheUtils.getByteLength));
parcelHelpers.export(exports, "getCurrTime", ()=>(0, _cacheUtils.getCurrTime));
parcelHelpers.export(exports, "isInteger", ()=>(0, _cacheUtils.isInteger));
parcelHelpers.export(exports, "CacheList", ()=>(0, _cacheListDefault.default));
var _cacheUtils = require("./CacheUtils");
var _cacheList = require("./CacheList");
var _cacheListDefault = parcelHelpers.interopDefault(_cacheList);

},{"./CacheUtils":"i3KyN","./CacheList":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i3KyN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
/**
 * return the byte size of the string
 * @param str
 */ parcelHelpers.export(exports, "getByteLength", ()=>getByteLength);
/**
 * get current time
 */ parcelHelpers.export(exports, "getCurrTime", ()=>getCurrTime);
/**
 * check if passed value is an integer
 */ parcelHelpers.export(exports, "isInteger", ()=>isInteger);
parcelHelpers.export(exports, "CacheObject", ()=>CacheObject);
var _core = require("@aws-amplify/core");
var defaultConfig = {
    keyPrefix: "aws-amplify-cache",
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, _core.StorageHelper)().getStorage()
};
function getByteLength(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function getCurrTime() {
    var currTime = new Date();
    return currTime.getTime();
}
function isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return _isInteger(value);
}
function _isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var store = {};
var CacheObject = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        store = {};
    };
    CacheObject.getItem = function(key) {
        return store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete store[key];
    };
    return CacheObject;
}();

},{"@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9VMCe":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageCache", ()=>StorageCache);
var _utils = require("./Utils");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("StorageCache");
/**
 * Initialization of the cache
 *
 */ var StorageCache = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + "CurSize";
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return "Cache";
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, _utils.isInteger)(this.config.capacityInBytes)) {
            logger.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.");
            this.config.capacityInBytes = (0, _utils.defaultConfig).capacityInBytes;
        }
        if (!(0, _utils.isInteger)(this.config.itemMaxSize)) {
            logger.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.");
            this.config.itemMaxSize = (0, _utils.defaultConfig).itemMaxSize;
        }
        if (!(0, _utils.isInteger)(this.config.defaultTTL)) {
            logger.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.");
            this.config.defaultTTL = (0, _utils.defaultConfig).defaultTTL;
        }
        if (!(0, _utils.isInteger)(this.config.defaultPriority)) {
            logger.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.");
            this.config.defaultPriority = (0, _utils.defaultConfig).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            logger.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.");
            this.config.itemMaxSize = (0, _utils.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            logger.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.");
            this.config.defaultPriority = (0, _utils.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            logger.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.");
            this.config.warningThreshold = (0, _utils.defaultConfig).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            logger.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.");
            this.config.capacityInBytes = (0, _utils.defaultConfig).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, _utils.getCurrTime)(),
            visitedTime: (0, _utils.getCurrTime)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, _utils.getByteLength)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, _utils.getByteLength)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();

},{"./Utils":"57A0i","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8UVd6":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInAppMessages", ()=>(0, _getInAppMessages.getInAppMessages));
parcelHelpers.export(exports, "putEvents", ()=>(0, _putEvents.putEvents));
parcelHelpers.export(exports, "updateEndpoint", ()=>(0, _updateEndpoint.updateEndpoint));
var _getInAppMessages = require("./getInAppMessages");
var _putEvents = require("./putEvents");
var _updateEndpoint = require("./updateEndpoint");

},{"./getInAppMessages":"gvRAq","./putEvents":"3xdcC","./updateEndpoint":"cowpi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gvRAq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInAppMessages", ()=>getInAppMessages);
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getInAppMessagesSerializer = function(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EndpointId = _a.EndpointId;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/endpoints/").concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(EndpointId), "/inappmessages");
    return {
        method: "GET",
        headers: headers,
        url: url
    };
};
var getInAppMessagesDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, InAppMessageCampaigns;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    InAppMessageCampaigns = _a.sent().InAppMessageCampaigns;
                    return [
                        2 /*return*/ ,
                        {
                            InAppMessagesResponse: {
                                InAppMessageCampaigns: InAppMessageCampaigns
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var getInAppMessages = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), getInAppMessagesSerializer, getInAppMessagesDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"BqrrW","../../clients/internal/composeServiceApi":"6uOwS","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"8baxJ","../../clients/serde":"kUzyl","./base":"gbOHT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gbOHT":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "getSharedHeaders", ()=>getSharedHeaders);
var _endpoints = require("../../clients/endpoints");
var _retry = require("../../clients/middleware/retry");
var _json = require("../../clients/serde/json");
var _platform = require("../../Platform");
/**
 * The service name used to sign requests if the API requires authentication.
 */ var SERVICE_NAME = "mobiletargeting";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://pinpoint.".concat(region, ".").concat((0, _endpoints.getDnsSuffix)(region)))
    };
};
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _retry.getRetryDecider)((0, _json.parseJsonError)),
    computeDelay: (0, _retry.jitteredBackoff),
    userAgentValue: (0, _platform.getAmplifyUserAgent)()
};
var getSharedHeaders = function() {
    return {
        "content-type": "application/json"
    };
};

},{"../../clients/endpoints":"ajOBW","../../clients/middleware/retry":"fImfn","../../clients/serde/json":"dIYKI","../../Platform":"kna8f","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3xdcC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putEvents", ()=>putEvents);
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var putEventsSerializer = function(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EventsRequest = _a.EventsRequest;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/events");
    var body = JSON.stringify(EventsRequest !== null && EventsRequest !== void 0 ? EventsRequest : {});
    return {
        method: "POST",
        headers: headers,
        url: url,
        body: body
    };
};
var putEventsDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, Results;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    Results = _a.sent().Results;
                    return [
                        2 /*return*/ ,
                        {
                            EventsResponse: {
                                Results: Results
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var putEvents = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), putEventsSerializer, putEventsDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"BqrrW","../../clients/internal/composeServiceApi":"6uOwS","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"8baxJ","../../clients/serde":"kUzyl","./base":"gbOHT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cowpi":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateEndpoint", ()=>updateEndpoint);
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var updateEndpointSerializer = function(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EndpointId = _a.EndpointId, EndpointRequest = _a.EndpointRequest;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/endpoints/").concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(EndpointId));
    var body = JSON.stringify(EndpointRequest !== null && EndpointRequest !== void 0 ? EndpointRequest : {});
    return {
        method: "PUT",
        headers: headers,
        url: url,
        body: body
    };
};
var updateEndpointDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, _a, Message, RequestID;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _b.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    _a = _b.sent(), Message = _a.Message, RequestID = _a.RequestID;
                    return [
                        2 /*return*/ ,
                        {
                            MessageBody: {
                                Message: Message,
                                RequestID: RequestID
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var updateEndpoint = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), updateEndpointSerializer, updateEndpointDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"BqrrW","../../clients/internal/composeServiceApi":"6uOwS","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"8baxJ","../../clients/serde":"kUzyl","./base":"gbOHT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"PNdyN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnalyticsUserAgent", ()=>getAnalyticsUserAgent);
parcelHelpers.export(exports, "getAnalyticsUserAgentString", ()=>getAnalyticsUserAgentString);
var _core = require("@aws-amplify/core");
function getAnalyticsUserAgent(action) {
    return (0, _core.getAmplifyUserAgentObject)({
        category: (0, _core.Category).Analytics,
        action: action
    });
}
function getAnalyticsUserAgentString(action) {
    return (0, _core.getAmplifyUserAgent)({
        category: (0, _core.Category).Analytics,
        action: action
    });
}

},{"@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1e66K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _appUtils = require("../utils/AppUtils");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("EventsBuffer");
var RETRYABLE_CODES = [
    429,
    500
];
var ACCEPTED_CODES = [
    202
];
var EventsBuffer = /** @class */ function() {
    function EventsBuffer(config) {
        this._pause = false;
        this._flush = false;
        logger.debug("Instantiating buffer with config:", config);
        this._buffer = [];
        this._config = config;
        this._sendBatch = this._sendBatch.bind(this);
        this._startLoop();
    }
    EventsBuffer.prototype.push = function(event) {
        var _a;
        // if the buffer is currently at the configured limit, pushing would exceed it
        if (this._buffer.length >= this._config.bufferSize) {
            logger.debug("Exceeded analytics events buffer size");
            return event.handlers.reject(new Error("Exceeded the size of analytics events buffer"));
        }
        var eventId = event.params.event.eventId;
        var bufferElement = (_a = {}, _a[eventId] = event, _a);
        this._buffer.push(bufferElement);
    };
    EventsBuffer.prototype.pause = function() {
        this._pause = true;
    };
    EventsBuffer.prototype.resume = function() {
        this._pause = false;
    };
    EventsBuffer.prototype.flush = function() {
        this._flush = true;
    };
    EventsBuffer.prototype._startLoop = function() {
        if (this._interval) clearInterval(this._interval);
        var flushInterval = this._config.flushInterval;
        this._interval = setInterval(this._sendBatch, flushInterval);
    };
    EventsBuffer.prototype._sendBatch = function() {
        var bufferLength = this._buffer.length;
        if (this._flush && !bufferLength) clearInterval(this._interval);
        // Do not send the batch of events if
        // the Buffer is paused or is empty or the App is not in the foreground
        // Apps should be in the foreground since
        // the OS may restrict access to the network in the background
        if (this._pause || !bufferLength || !(0, _appUtils.isAppInForeground)()) return;
        var flushSize = this._config.flushSize;
        var batchSize = Math.min(flushSize, bufferLength);
        var bufferSubset = this._buffer.splice(0, batchSize);
        this._putEvents(bufferSubset);
    };
    EventsBuffer.prototype._putEvents = function(buffer) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var eventMap, batchEventParams, _a, credentials, region, data, err_1;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        eventMap = this._bufferToMap(buffer);
                        batchEventParams = this._generateBatchEventParams(eventMap);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this._config, credentials = _a.credentials, region = _a.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.putEvents)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).Record)
                            }, batchEventParams)
                        ];
                    case 2:
                        data = _b.sent();
                        this._processPutEventsSuccessResponse(data, eventMap);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _b.sent();
                        return [
                            2 /*return*/ ,
                            this._handlePutEventsFailure(err_1, eventMap)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsBuffer.prototype._generateBatchEventParams = function(eventMap) {
        var batchEventParams = {
            ApplicationId: "",
            EventsRequest: {
                BatchItem: {}
            }
        };
        Object.values(eventMap).forEach(function(item) {
            var params = item.params;
            var event = params.event, timestamp = params.timestamp, config = params.config;
            var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
            var appId = config.appId, endpointId = config.endpointId;
            var batchItem = batchEventParams.EventsRequest.BatchItem;
            batchEventParams.ApplicationId = batchEventParams.ApplicationId || appId;
            if (!batchItem[endpointId]) batchItem[endpointId] = {
                Endpoint: {},
                Events: {}
            };
            batchItem[endpointId].Events[eventId] = {
                EventType: name,
                Timestamp: new Date(timestamp).toISOString(),
                Attributes: attributes,
                Metrics: metrics,
                Session: session
            };
        });
        return batchEventParams;
    };
    EventsBuffer.prototype._handlePutEventsFailure = function(err, eventMap) {
        logger.debug("_putEvents Failed: ", err);
        var statusCode = err.$metadata && err.$metadata.httpStatusCode;
        if (RETRYABLE_CODES.includes(statusCode)) {
            var retryableEvents = Object.values(eventMap);
            this._retry(retryableEvents);
            return;
        }
    };
    EventsBuffer.prototype._processPutEventsSuccessResponse = function(data, eventMap) {
        var _a;
        var _b = ((_a = data.EventsResponse) !== null && _a !== void 0 ? _a : {}).Results, Results = _b === void 0 ? {} : _b;
        var retryableEvents = [];
        Object.entries(Results).forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), endpointId = _b[0], endpointValues = _b[1];
            var _c;
            var responses = (_c = endpointValues.EventsItemResponse) !== null && _c !== void 0 ? _c : {};
            Object.entries(responses).forEach(function(_a) {
                var _b, _c;
                var _d = (0, _tslib.__read)(_a, 2), eventId = _d[0], eventValues = _d[1];
                var eventObject = eventMap[eventId];
                if (!eventObject) return;
                var _e = eventValues !== null && eventValues !== void 0 ? eventValues : {}, StatusCode = _e.StatusCode, Message = _e.Message;
                // manually crafting handlers response to keep API consistant
                var response = {
                    EventsResponse: {
                        Results: (_b = {}, _b[endpointId] = {
                            EventsItemResponse: (_c = {}, _c[eventId] = {
                                StatusCode: StatusCode,
                                Message: Message
                            }, _c)
                        }, _b)
                    }
                };
                if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
                    eventObject.handlers.resolve(response);
                    return;
                }
                if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) {
                    retryableEvents.push(eventObject);
                    return;
                }
                var name = eventObject.params.event.name;
                logger.error("event " + eventId + " : " + name + " failed with error: " + Message);
                return eventObject.handlers.reject(response);
            });
        });
        if (retryableEvents.length) this._retry(retryableEvents);
    };
    EventsBuffer.prototype._retry = function(retryableEvents) {
        var _a;
        // retryable events that haven't reached the resendLimit
        var eligibleEvents = [];
        retryableEvents.forEach(function(event) {
            var _a;
            var params = event.params;
            var _b = params.event, eventId = _b.eventId, name = _b.name;
            if (params.resendLimit-- > 0) {
                logger.debug("resending event " + eventId + " : " + name + " with " + params.resendLimit + " retry attempts remaining");
                eligibleEvents.push((_a = {}, _a[eventId] = event, _a));
                return;
            }
            logger.debug("no retry attempts remaining for event " + eventId + " : " + name);
        });
        // add the events to the front of the buffer
        (_a = this._buffer).unshift.apply(_a, (0, _tslib.__spread)(eligibleEvents));
    };
    // convert buffer to map, i.e. { eventId1: { params, handler }, eventId2: { params, handlers } }
    // this allows us to easily access the handlers after receiving a batch response
    EventsBuffer.prototype._bufferToMap = function(buffer) {
        return buffer.reduce(function(acc, curVal) {
            var _a = (0, _tslib.__read)(Object.entries(curVal), 1), _b = (0, _tslib.__read)(_a[0], 2), key = _b[0], value = _b[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    return EventsBuffer;
}();
exports.default = EventsBuffer;

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@aws-amplify/core/internals/aws-clients/pinpoint":"8UVd6","../utils/AppUtils":"5X1VJ","../utils/UserAgent":"PNdyN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5X1VJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAppInForeground", ()=>isAppInForeground);
var isAppInForeground = function() {
    return true;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dZpTd":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageViewTracker", ()=>(0, _pageViewTracker.PageViewTracker));
parcelHelpers.export(exports, "EventTracker", ()=>(0, _eventTracker.EventTracker));
parcelHelpers.export(exports, "SessionTracker", ()=>(0, _sessionTracker.SessionTracker));
var _pageViewTracker = require("./PageViewTracker");
var _eventTracker = require("./EventTracker");
var _sessionTracker = require("./SessionTracker");

},{"./PageViewTracker":"eDKOh","./EventTracker":"4mclb","./SessionTracker":"i6b0W","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eDKOh":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageViewTracker", ()=>PageViewTracker);
var _tslib = require("tslib");
var _methodEmbed = require("../utils/MethodEmbed");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("PageViewTracker");
var PREV_URL_KEY = "aws-amplify-analytics-prevUrl";
var getUrl = function() {
    if (!(0, _core.browserOrNode)().isBrowser) return "";
    else return window.location.origin + window.location.pathname;
};
var defaultOpts = {
    enable: false,
    provider: "AWSPinpoint",
    getUrl: getUrl
};
var PageViewTracker = /** @class */ function() {
    function PageViewTracker(tracker, opts) {
        logger.debug("initialize pageview tracker with opts", opts);
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        if (this._config.type === "SPA") this._pageViewTrackSPA();
        else this._pageViewTrackDefault();
    }
    PageViewTracker.prototype.configure = function(opts) {
        Object.assign(this._config, opts);
        // if spa, need to remove those listeners if disabled
        if (this._config.type === "SPA") this._pageViewTrackSPA();
        return this._config;
    };
    PageViewTracker.prototype._isSameUrl = function() {
        var prevUrl = sessionStorage.getItem(PREV_URL_KEY);
        var curUrl = this._config.getUrl();
        if (prevUrl === curUrl) {
            logger.debug("the url is same");
            return true;
        } else return false;
    };
    PageViewTracker.prototype._pageViewTrackDefault = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !window.sessionStorage) {
                            logger.debug("not in the supported web enviroment");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (this._config.enable && !this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || "pageView",
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                logger.debug("Failed to record the page view event", e);
                            });
                            sessionStorage.setItem(PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._trackFunc = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !history.pushState || !window.sessionStorage) {
                            logger.debug("not in the supported web enviroment");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (!this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || "pageView",
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                logger.debug("Failed to record the page view event", e);
                            });
                            sessionStorage.setItem(PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._pageViewTrackSPA = function() {
        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !history.pushState) {
            logger.debug("not in the supported web enviroment");
            return;
        }
        if (this._config.enable && !this._hasEnabled) {
            (0, _methodEmbed.MethodEmbed).add(history, "pushState", this._trackFunc);
            (0, _methodEmbed.MethodEmbed).add(history, "replaceState", this._trackFunc);
            window.addEventListener("popstate", this._trackFunc);
            this._trackFunc();
            this._hasEnabled = true;
        } else {
            (0, _methodEmbed.MethodEmbed).remove(history, "pushState");
            (0, _methodEmbed.MethodEmbed).remove(history, "replaceState");
            window.removeEventListener("popstate", this._trackFunc);
            this._hasEnabled = false;
        }
    };
    return PageViewTracker;
}();

},{"tslib":"9gMVn","../utils/MethodEmbed":"b7wJO","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b7wJO":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MethodEmbed", ()=>MethodEmbed);
var _tslib = require("tslib");
var lists = [];
var MethodEmbed = /** @class */ function() {
    function MethodEmbed(context, methodName) {
        this.context = context;
        this.methodName = methodName;
        this._originalMethod = context[methodName].bind(context);
    }
    MethodEmbed.add = function(context, methodName, methodOverride) {
        getInstance(context, methodName).set(methodOverride);
    };
    MethodEmbed.remove = function(context, methodName) {
        getInstance(context, methodName).remove();
    };
    MethodEmbed.prototype.set = function(methodOverride) {
        var _this = this;
        this.context[this.methodName] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return methodOverride(_this._originalMethod.apply(_this, (0, _tslib.__spread)(args)));
        };
    };
    MethodEmbed.prototype.remove = function() {
        this.context[this.methodName] = this._originalMethod;
    };
    return MethodEmbed;
}();
function getInstance(context, methodName) {
    var instance = lists.filter(function(h) {
        return h.context === context && h.methodName === methodName;
    })[0];
    if (!instance) {
        instance = new MethodEmbed(context, methodName);
        lists.push(instance);
    }
    return instance;
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4mclb":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTracker", ()=>EventTracker);
var _tslib = require("tslib");
var _domUtils = require("../vendor/dom-utils");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("EventTracker");
var defaultOpts = {
    enable: false,
    events: [
        "click"
    ],
    selectorPrefix: "data-amplify-analytics-",
    provider: "AWSPinpoint"
};
var EventTracker = /** @class */ function() {
    function EventTracker(tracker, opts) {
        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener) {
            logger.debug("not in the supported web environment");
            return;
        }
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._delegates = {};
        this._trackFunc = this._trackFunc.bind(this);
        logger.debug("initialize pageview tracker with opts", this._config);
        this.configure(this._config);
    }
    EventTracker.prototype.configure = function(opts) {
        var _this = this;
        Object.assign(this._config, opts);
        if (!this._config.enable) {
            Object.keys(this._delegates).forEach(function(key) {
                if (typeof _this._delegates[key].destroy === "function") _this._delegates[key].destroy();
            });
            this._delegates = {};
        } else if (this._config.enable && Object.keys(this._delegates).length === 0) {
            var selector_1 = "[" + this._config.selectorPrefix + "on]";
            this._config.events.forEach(function(evt) {
                _this._delegates[evt] = (0, _domUtils.delegate)(document, evt, selector_1, _this._trackFunc, {
                    composed: true,
                    useCapture: true
                });
            });
        }
        return this._config;
    };
    EventTracker.prototype._trackFunc = function(event, element) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, events, eventName, attrs, defaultAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        customAttrs = {};
                        events = element.getAttribute(this._config.selectorPrefix + "on").split(/\s*,\s*/);
                        eventName = element.getAttribute(this._config.selectorPrefix + "name");
                        attrs = element.getAttribute(this._config.selectorPrefix + "attrs");
                        if (attrs) attrs.split(/\s*,\s*/).forEach(function(attr) {
                            var tmp = attr.trim().split(/\s*:\s*/);
                            customAttrs[tmp[0]] = tmp[1];
                        });
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        defaultAttrs = _a;
                        attributes = Object.assign({
                            type: event.type,
                            target: event.target.localName + " with id " + event.target.id
                        }, defaultAttrs, customAttrs);
                        logger.debug("events needed to be recorded", events);
                        logger.debug("attributes needed to be attached", customAttrs);
                        if (events.indexOf(event.type) < 0) {
                            logger.debug("event " + event.type + " is not selected to be recorded");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._tracker({
                            name: eventName || "event",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("Failed to record the " + event.type + " event', " + e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return EventTracker;
}();

},{"tslib":"9gMVn","../vendor/dom-utils":"4wYgV","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4wYgV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closest", ()=>(0, _closest.closest));
parcelHelpers.export(exports, "delegate", ()=>(0, _delegate.delegate));
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatch.dispatch));
parcelHelpers.export(exports, "getAttributes", ()=>(0, _getAttributes.getAttributes));
parcelHelpers.export(exports, "matches", ()=>(0, _matches.matches));
parcelHelpers.export(exports, "parents", ()=>(0, _parents.parents));
parcelHelpers.export(exports, "parseUrl", ()=>(0, _parseUrl.parseUrl));
var _closest = require("./closest");
var _delegate = require("./delegate");
var _dispatch = require("./dispatch");
var _getAttributes = require("./get-attributes");
var _matches = require("./matches");
var _parents = require("./parents");
var _parseUrl = require("./parse-url");

},{"./closest":false,"./delegate":"gBBAH","./dispatch":false,"./get-attributes":false,"./matches":false,"./parents":false,"./parse-url":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ai92d":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the closest parent element that matches the passed selector.
 * @param {Element} element The element whose parents to check.
 * @param {string} selector The CSS selector to match against.
 * @param {boolean=} shouldCheckSelf True if the selector should test against
 *     the passed element itself.
 * @return {Element|undefined} The matching element or undefined.
 */ parcelHelpers.export(exports, "closest", ()=>closest);
var _matches = require("./matches");
var _parents = require("./parents");
function closest(element, selector, shouldCheckSelf) {
    if (shouldCheckSelf === void 0) shouldCheckSelf = false;
    if (!(element && element.nodeType === 1 && selector)) return;
    var parentElements = (shouldCheckSelf ? [
        element
    ] : []).concat((0, _parents.parents)(element));
    for(var i = 0, parent_1; parent_1 = parentElements[i]; i++){
        if ((0, _matches.matches)(parent_1, selector)) return parent_1;
    }
}

},{"./matches":"3tHLt","./parents":"i9zVw","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3tHLt":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tests if a DOM elements matches any of the test DOM elements or selectors.
 * @param {Element} element The DOM element to test.
 * @param {Element|string|Array<Element|string>} test A DOM element, a CSS
 *     selector, or an array of DOM elements or CSS selectors to match against.
 * @return {boolean} True of any part of the test matches.
 */ parcelHelpers.export(exports, "matches", ()=>matches);
var _core = require("@aws-amplify/core");
var proto = (0, _core.browserOrNode)().isBrowser && window["Element"] ? window["Element"].prototype : null;
var nativeMatches = proto ? proto.matches || // @ts-ignore
proto.matchesSelector || // @ts-ignore
proto.webkitMatchesSelector || // @ts-ignore
proto.mozMatchesSelector || // @ts-ignore
proto.msMatchesSelector || // @ts-ignore
proto.oMatchesSelector : null;
function matches(element, test) {
    // Validate input.
    if (element && element.nodeType === 1 && test) {
        // if test is a string or DOM element test it.
        if (typeof test === "string" || test.nodeType === 1) return element === test || matchesSelector(element, /** @type {string} */ test);
        else if ("length" in test) // if it has a length property iterate over the items
        // and return true if any match.
        for(var i = 0, item = void 0; item = test[i]; i++){
            if (element === item || matchesSelector(element, item)) return true;
        }
    }
    // Still here? Return false
    return false;
}
/**
 * Tests whether a DOM element matches a selector. This polyfills the native
 * Element.prototype.matches method across browsers.
 * @param {!Element} element The DOM element to test.
 * @param {string} selector The CSS selector to test element against.
 * @return {boolean} True if the selector matches.
 */ function matchesSelector(element, selector) {
    if (typeof selector !== "string") return false;
    if (nativeMatches) return nativeMatches.call(element, selector);
    var nodes = element.parentNode.querySelectorAll(selector);
    for(var i = 0, node = void 0; node = nodes[i]; i++){
        if (node === element) return true;
    }
    return false;
}

},{"@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i9zVw":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ /**
 * Returns an array of a DOM element's parent elements.
 * @param {!Element} element The DOM element whose parents to get.
 * @return {!Array} An array of all parent elemets, or an empty array if no
 *     parent elements are found.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parents", ()=>parents);
function parents(ele) {
    var list = [];
    var element = ele;
    while(element && element.parentNode && element.parentNode.nodeType === 1){
        element = /** @type {!Element} */ element.parentNode;
        list.push(element);
    }
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gBBAH":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Delegates the handling of events for an element matching a selector to an
 * ancestor of the matching element.
 * @param {!Node} ancestor The ancestor element to add the listener to.
 * @param {string} eventType The event type to listen to.
 * @param {string} selector A CSS selector to match against child elements.
 * @param {!Function} callback A function to run any time the event happens.
 * @param {Object=} opts A configuration options object. The available options:
 *     - useCapture<boolean>: If true, bind to the event capture phase.
 *     - deep<boolean>: If true, delegate into shadow trees.
 * @return {Object} The delegate object. It contains a destroy method.
 */ parcelHelpers.export(exports, "delegate", ()=>delegate);
var _closest = require("./closest");
var _matches = require("./matches");
function delegate(ancestor, eventType, selector, callback, opts) {
    if (opts === void 0) opts = {};
    // Defines the event listener.
    var listener = function(event) {
        var delegateTarget;
        // If opts.composed is true and the event originated from inside a Shadow
        // tree, check the composed path nodes.
        if (opts["composed"] && typeof event["composedPath"] === "function") {
            var composedPath = event.composedPath();
            for(var i = 0, node = void 0; node = composedPath[i]; i++)if (node.nodeType === 1 && (0, _matches.matches)(node, selector)) delegateTarget = node;
        } else // Otherwise check the parents.
        delegateTarget = (0, _closest.closest)(event.target, selector, true);
        if (delegateTarget) callback.call(delegateTarget, event, delegateTarget);
    };
    ancestor.addEventListener(eventType, listener, opts["useCapture"]);
    return {
        destroy: function() {
            ancestor.removeEventListener(eventType, listener, opts["useCapture"]);
        }
    };
}

},{"./closest":"ai92d","./matches":"3tHLt","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i6b0W":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTracker", ()=>SessionTracker);
var _tslib = require("tslib");
// the session tracker for web
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("SessionTracker");
var defaultOpts = {
    enable: false,
    provider: "AWSPinpoint"
};
var initialEventSent = false;
var SessionTracker = /** @class */ function() {
    function SessionTracker(tracker, opts) {
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        this._trackBeforeUnload = this._trackBeforeUnload.bind(this);
        this.configure(this._config);
    }
    SessionTracker.prototype._envCheck = function() {
        if (!(0, _core.browserOrNode)().isBrowser) return false;
        if (!document || !document.addEventListener) {
            logger.debug("not in the supported web environment");
            return false;
        }
        if (typeof document.hidden !== "undefined") {
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document["msHidden"] !== "undefined") {
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document["webkitHidden"] !== "undefined") {
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        } else {
            logger.debug("not in the supported web environment");
            return false;
        }
        return true;
    };
    SessionTracker.prototype._trackFunc = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        if (document.visibilityState === this._hidden) this._tracker({
                            name: "_session.stop",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("record session stop event failed.", e);
                        });
                        else this._tracker({
                            name: "_session.start",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("record session start event failed.", e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype._trackBeforeUnload = function(event) {
        // before unload callback cannot be async => https://github.com/aws-amplify/amplify-js/issues/2088
        var _this = this;
        var customAttrs = typeof this._config.attributes === "function" ? Promise.resolve(this._config.attributes()) : Promise.resolve(this._config.attributes);
        customAttrs.then(function(custom) {
            var attributes = Object.assign({}, custom);
            _this._tracker({
                name: "_session.stop",
                attributes: attributes,
                immediate: true
            }, _this._config.provider).catch(function(e) {
                logger.debug("record session stop event failed.", e);
            });
        });
    };
    // to keep configure a synchronized function
    SessionTracker.prototype._sendInitialEvent = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (initialEventSent) {
                            logger.debug("the start session has been sent when the page is loaded");
                            return [
                                2 /*return*/ 
                            ];
                        } else initialEventSent = true;
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        this._tracker({
                            name: "_session.start",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("record session start event failed.", e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype.configure = function(opts) {
        if (!this._envCheck()) return this._config;
        Object.assign(this._config, opts);
        if (this._config.enable && !this._hasEnabled) {
            // send a start session as soon as it's enabled
            this._sendInitialEvent();
            // listen on events
            document.addEventListener(this._visibilityChange, this._trackFunc, false);
            window.addEventListener("beforeunload", this._trackBeforeUnload, false);
            this._hasEnabled = true;
        } else if (!this._config.enable && this._hasEnabled) {
            document.removeEventListener(this._visibilityChange, this._trackFunc, false);
            window.removeEventListener("beforeunload", this._trackBeforeUnload, false);
            this._hasEnabled = false;
        }
        return this._config;
    };
    return SessionTracker;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hNmql":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _awspinpointProvider.AWSPinpointProvider));
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>(0, _awskinesisProvider.AWSKinesisProvider));
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>(0, _awskinesisFirehoseProvider.AWSKinesisFirehoseProvider));
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>(0, _amazonPersonalizeProvider.AmazonPersonalizeProvider));
var _awspinpointProvider = require("./AWSPinpointProvider");
var _awskinesisProvider = require("./AWSKinesisProvider");
var _awskinesisFirehoseProvider = require("./AWSKinesisFirehoseProvider");
var _amazonPersonalizeProvider = require("./AmazonPersonalizeProvider");

},{"./AWSPinpointProvider":"3ah5f","./AWSKinesisProvider":"ax2zg","./AWSKinesisFirehoseProvider":"7QCma","./AmazonPersonalizeProvider":"hTgdX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ax2zg":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>AWSKinesisProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _clientKinesis = require("@aws-sdk/client-kinesis");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("AWSKinesisProvider");
// events buffer
var BUFFER_SIZE = 1000;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5000; // 5s
var RESEND_LIMIT = 5;
var AWSKinesisProvider = /** @class */ function() {
    function AWSKinesisProvider(config) {
        this._buffer = [];
        this._config = config || {};
        this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
        this._setupTimer();
    }
    AWSKinesisProvider.prototype._setupTimer = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        var _a = this._config, flushSize = _a.flushSize, flushInterval = _a.flushInterval;
        this._timer = setInterval(function() {
            var size = _this._buffer.length < flushSize ? _this._buffer.length : flushSize;
            var events = [];
            for(var i = 0; i < size; i += 1){
                var params = _this._buffer.shift();
                events.push(params);
            }
            _this._sendFromBuffer(events);
        }, flushInterval);
    };
    /**
     * get the category of the plugin
     */ AWSKinesisProvider.prototype.getCategory = function() {
        return "Analytics";
    };
    /**
     * get provider name of the plugin
     */ AWSKinesisProvider.prototype.getProviderName = function() {
        return "AWSKinesis";
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSKinesisProvider.prototype.configure = function(config) {
        logger.debug("configure Analytics", config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        this._setupTimer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSKinesisProvider.prototype.record = function(params) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials
                        });
                        if ((_a = params.event) === null || _a === void 0 ? void 0 : _a.immediate) {
                            this._sendEvents([
                                params
                            ]);
                            return [
                                2 /*return*/ ,
                                Promise.resolve(true)
                            ];
                        } else return [
                            2 /*return*/ ,
                            this._putToBuffer(params)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSKinesisProvider.prototype.updateEndpoint = function() {
        logger.debug("updateEndpoint is not implemented in Kinesis provider");
        return Promise.resolve(true);
    };
    /**
     * @private
     * @param params - params for the event recording
     * Put events into buffer
     */ AWSKinesisProvider.prototype._putToBuffer = function(params) {
        if (this._buffer.length < BUFFER_SIZE) {
            this._buffer.push(params);
            return Promise.resolve(true);
        } else {
            logger.debug("exceed analytics events buffer size");
            return Promise.reject(false);
        }
    };
    AWSKinesisProvider.prototype._sendFromBuffer = function(events) {
        var _this = this;
        // collapse events by credentials
        // events = [ {params} ]
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < events.length; i += 1){
            var cred = events[i].credentials;
            if (i === 0) {
                group.push(events[i]);
                preCred = cred;
            } else if (cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                logger.debug("no change for cred, put event in the same group");
                group.push(events[i]);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(events[i]);
                preCred = cred;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(evts) {
            _this._sendEvents(evts);
        });
    };
    AWSKinesisProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // spit by streamName
            var evt = params.event;
            var streamName = evt.streamName;
            if (records[streamName] === undefined) records[streamName] = [];
            var bufferData = evt.data && typeof evt.data !== "string" ? JSON.stringify(evt.data) : evt.data;
            var Data = (0, _utilUtf8Browser.fromUtf8)(bufferData);
            var PartitionKey = evt.partitionKey || "partition-" + credentials.identityId;
            var record = {
                Data: Data,
                PartitionKey: PartitionKey
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var command, err_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger.debug("putting records to kinesis with records", records[streamName]);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            command = new (0, _clientKinesis.PutRecordsCommand)({
                                Records: records[streamName],
                                StreamName: streamName
                            });
                            return [
                                4 /*yield*/ ,
                                this._kinesis.send(command)
                            ];
                        case 2:
                            _a.sent();
                            logger.debug("Upload records to stream", streamName);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_1 = _a.sent();
                            logger.debug("Failed to upload records to Kinesis", err_1);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSKinesisProvider.prototype._init = function(config, credentials) {
        logger.debug("init clients");
        if (this._kinesis && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region, endpoint = config.endpoint;
        return this._initKinesis(region, endpoint, credentials);
    };
    AWSKinesisProvider.prototype._initKinesis = function(region, endpoint, credentials) {
        logger.debug("initialize kinesis with credentials", credentials);
        this._kinesis = new (0, _clientKinesis.KinesisClient)({
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record),
            endpoint: endpoint
        });
        return true;
    };
    /**
     * @private
     * check if current credentials exists
     */ AWSKinesisProvider.prototype._getCredentials = function() {
        var _this = this;
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return null;
            logger.debug("set credentials for analytics", _this._config.credentials);
            return (0, _core.Credentials).shear(credentials);
        }).catch(function(err) {
            logger.debug("ensure credentials error", err);
            return null;
        });
    };
    return AWSKinesisProvider;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@aws-sdk/client-kinesis":"gm4Q5","@aws-sdk/util-utf8-browser":"87Cy2","../utils/UserAgent":"PNdyN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gm4Q5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _kinesisClient = require("./KinesisClient");
parcelHelpers.exportAll(_kinesisClient, exports);
var _kinesis = require("./Kinesis");
parcelHelpers.exportAll(_kinesis, exports);
var _addTagsToStreamCommand = require("./commands/AddTagsToStreamCommand");
parcelHelpers.exportAll(_addTagsToStreamCommand, exports);
var _createStreamCommand = require("./commands/CreateStreamCommand");
parcelHelpers.exportAll(_createStreamCommand, exports);
var _decreaseStreamRetentionPeriodCommand = require("./commands/DecreaseStreamRetentionPeriodCommand");
parcelHelpers.exportAll(_decreaseStreamRetentionPeriodCommand, exports);
var _deleteStreamCommand = require("./commands/DeleteStreamCommand");
parcelHelpers.exportAll(_deleteStreamCommand, exports);
var _deregisterStreamConsumerCommand = require("./commands/DeregisterStreamConsumerCommand");
parcelHelpers.exportAll(_deregisterStreamConsumerCommand, exports);
var _describeLimitsCommand = require("./commands/DescribeLimitsCommand");
parcelHelpers.exportAll(_describeLimitsCommand, exports);
var _describeStreamCommand = require("./commands/DescribeStreamCommand");
parcelHelpers.exportAll(_describeStreamCommand, exports);
var _waitForStreamExists = require("./waiters/waitForStreamExists");
parcelHelpers.exportAll(_waitForStreamExists, exports);
var _waitForStreamNotExists = require("./waiters/waitForStreamNotExists");
parcelHelpers.exportAll(_waitForStreamNotExists, exports);
var _describeStreamConsumerCommand = require("./commands/DescribeStreamConsumerCommand");
parcelHelpers.exportAll(_describeStreamConsumerCommand, exports);
var _describeStreamSummaryCommand = require("./commands/DescribeStreamSummaryCommand");
parcelHelpers.exportAll(_describeStreamSummaryCommand, exports);
var _disableEnhancedMonitoringCommand = require("./commands/DisableEnhancedMonitoringCommand");
parcelHelpers.exportAll(_disableEnhancedMonitoringCommand, exports);
var _enableEnhancedMonitoringCommand = require("./commands/EnableEnhancedMonitoringCommand");
parcelHelpers.exportAll(_enableEnhancedMonitoringCommand, exports);
var _getRecordsCommand = require("./commands/GetRecordsCommand");
parcelHelpers.exportAll(_getRecordsCommand, exports);
var _getShardIteratorCommand = require("./commands/GetShardIteratorCommand");
parcelHelpers.exportAll(_getShardIteratorCommand, exports);
var _increaseStreamRetentionPeriodCommand = require("./commands/IncreaseStreamRetentionPeriodCommand");
parcelHelpers.exportAll(_increaseStreamRetentionPeriodCommand, exports);
var _listShardsCommand = require("./commands/ListShardsCommand");
parcelHelpers.exportAll(_listShardsCommand, exports);
var _listStreamConsumersCommand = require("./commands/ListStreamConsumersCommand");
parcelHelpers.exportAll(_listStreamConsumersCommand, exports);
var _listStreamConsumersPaginator = require("./pagination/ListStreamConsumersPaginator");
parcelHelpers.exportAll(_listStreamConsumersPaginator, exports);
var _listStreamsCommand = require("./commands/ListStreamsCommand");
parcelHelpers.exportAll(_listStreamsCommand, exports);
var _listTagsForStreamCommand = require("./commands/ListTagsForStreamCommand");
parcelHelpers.exportAll(_listTagsForStreamCommand, exports);
var _mergeShardsCommand = require("./commands/MergeShardsCommand");
parcelHelpers.exportAll(_mergeShardsCommand, exports);
var _putRecordCommand = require("./commands/PutRecordCommand");
parcelHelpers.exportAll(_putRecordCommand, exports);
var _putRecordsCommand = require("./commands/PutRecordsCommand");
parcelHelpers.exportAll(_putRecordsCommand, exports);
var _registerStreamConsumerCommand = require("./commands/RegisterStreamConsumerCommand");
parcelHelpers.exportAll(_registerStreamConsumerCommand, exports);
var _removeTagsFromStreamCommand = require("./commands/RemoveTagsFromStreamCommand");
parcelHelpers.exportAll(_removeTagsFromStreamCommand, exports);
var _splitShardCommand = require("./commands/SplitShardCommand");
parcelHelpers.exportAll(_splitShardCommand, exports);
var _startStreamEncryptionCommand = require("./commands/StartStreamEncryptionCommand");
parcelHelpers.exportAll(_startStreamEncryptionCommand, exports);
var _stopStreamEncryptionCommand = require("./commands/StopStreamEncryptionCommand");
parcelHelpers.exportAll(_stopStreamEncryptionCommand, exports);
var _subscribeToShardCommand = require("./commands/SubscribeToShardCommand");
parcelHelpers.exportAll(_subscribeToShardCommand, exports);
var _updateShardCountCommand = require("./commands/UpdateShardCountCommand");
parcelHelpers.exportAll(_updateShardCountCommand, exports);
var _interfaces = require("./pagination/Interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./KinesisClient":"lI5ip","./Kinesis":false,"./commands/AddTagsToStreamCommand":false,"./commands/CreateStreamCommand":false,"./commands/DecreaseStreamRetentionPeriodCommand":false,"./commands/DeleteStreamCommand":false,"./commands/DeregisterStreamConsumerCommand":false,"./commands/DescribeLimitsCommand":false,"./commands/DescribeStreamCommand":false,"./waiters/waitForStreamExists":false,"./waiters/waitForStreamNotExists":false,"./commands/DescribeStreamConsumerCommand":false,"./commands/DescribeStreamSummaryCommand":false,"./commands/DisableEnhancedMonitoringCommand":false,"./commands/EnableEnhancedMonitoringCommand":false,"./commands/GetRecordsCommand":false,"./commands/GetShardIteratorCommand":false,"./commands/IncreaseStreamRetentionPeriodCommand":false,"./commands/ListShardsCommand":false,"./commands/ListStreamConsumersCommand":false,"./pagination/ListStreamConsumersPaginator":false,"./commands/ListStreamsCommand":false,"./commands/ListTagsForStreamCommand":false,"./commands/MergeShardsCommand":false,"./commands/PutRecordCommand":false,"./commands/PutRecordsCommand":"dg2vx","./commands/RegisterStreamConsumerCommand":false,"./commands/RemoveTagsFromStreamCommand":false,"./commands/SplitShardCommand":false,"./commands/StartStreamEncryptionCommand":false,"./commands/StopStreamEncryptionCommand":false,"./commands/SubscribeToShardCommand":false,"./commands/UpdateShardCountCommand":false,"./pagination/Interfaces":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lI5ip":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KinesisClient", ()=>KinesisClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _eventstreamSerdeConfigResolver = require("@aws-sdk/eventstream-serde-config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <fullname>Amazon Kinesis Data Streams Service API Reference</fullname>
 *         <p>Amazon Kinesis Data Streams is a managed service that scales elastically for
 *             real-time processing of streaming big data.</p>
 */ var KinesisClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(KinesisClient, _super);
    function KinesisClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        var _config_7 = (0, _eventstreamSerdeConfigResolver.resolveEventStreamSerdeConfig)(_config_6);
        _this = _super.call(this, _config_7) || this;
        _this.config = _config_7;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    KinesisClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return KinesisClient;
}((0, _smithyClient.Client));

},{"tslib":"hXPA8","./runtimeConfig":"85x89","@aws-sdk/config-resolver":"jqbdY","@aws-sdk/eventstream-serde-config-resolver":"crFcd","@aws-sdk/middleware-content-length":"bExw4","@aws-sdk/middleware-host-header":"1lroQ","@aws-sdk/middleware-logger":"cSdRr","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/middleware-signing":"9ClYY","@aws-sdk/middleware-user-agent":"l9mVK","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hXPA8":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"85x89":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _eventstreamSerdeBrowser = require("@aws-sdk/eventstream-serde-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    eventStreamSerdeProvider: (0, _eventstreamSerdeBrowser.eventStreamSerdeProvider),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"hXPA8","./package.json":"egfKY","@aws-crypto/sha256-browser":"h9CgF","@aws-sdk/eventstream-serde-browser":"20Kkr","@aws-sdk/fetch-http-handler":"cl6qU","@aws-sdk/invalid-dependency":"hRSjn","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/util-base64-browser":"gYMH3","@aws-sdk/util-body-length-browser":"11eVP","@aws-sdk/util-user-agent-browser":"6UmM8","@aws-sdk/util-utf8-browser":"5I957","./runtimeConfig.shared":"5C45R","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"egfKY":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-kinesis","description":"AWS SDK for JavaScript Kinesis Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/eventstream-serde-browser":"3.6.1","@aws-sdk/eventstream-serde-config-resolver":"3.6.1","@aws-sdk/eventstream-serde-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","@aws-sdk/util-waiter":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-kinesis","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-kinesis"}}');

},{}],"h9CgF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("aaa7d4a6ff2e1cee");
(0, tslib_1.__exportStar)(require("67c1f12863a2347a"), exports);
var ie11Sha256_1 = require("f0effae426abd376");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("811ebc2175044a5d");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"aaa7d4a6ff2e1cee":"cLOxh","67c1f12863a2347a":"039cv","f0effae426abd376":"epb5S","811ebc2175044a5d":"3QD7E"}],"cLOxh":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"039cv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("c9a66c08defb60c3");
var webCryptoSha256_1 = require("5df9d9607ef80f46");
var sha256_js_1 = require("94e183d0096240b1");
var supports_web_crypto_1 = require("1074f0cd4f944e96");
var ie11_detection_1 = require("49a91e94221373fd");
var util_locate_window_1 = require("c0bcef2813f94b8f");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"c9a66c08defb60c3":"epb5S","5df9d9607ef80f46":"3QD7E","94e183d0096240b1":"k5SII","1074f0cd4f944e96":"1NiIB","49a91e94221373fd":"el8RN","c0bcef2813f94b8f":"iQfdF"}],"epb5S":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("a9ba6245afa404b5");
var constants_1 = require("70ab000e7aa2ff7");
var util_utf8_browser_1 = require("899493d29c388986");
var util_locate_window_1 = require("ec7f6758c000e8e7");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"a9ba6245afa404b5":"cJe7D","70ab000e7aa2ff7":"77U0i","899493d29c388986":"5I957","ec7f6758c000e8e7":"iQfdF"}],"cJe7D":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"77U0i":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"5I957":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"7BQd7","./whatwgEncodingApi":"73ynf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7BQd7":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"73ynf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3QD7E":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("f3f027e9cc5a27f8");
var constants_1 = require("6cd1080236498659");
var util_locate_window_1 = require("41064d1b2769d75c");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"f3f027e9cc5a27f8":"555gx","6cd1080236498659":"77U0i","41064d1b2769d75c":"iQfdF"}],"555gx":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("ead1b133f3d46c58");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("205afb4592b38145");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("ebde58292c2cac85");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("de2be3979bdefa97");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"ead1b133f3d46c58":"1MRaW","205afb4592b38145":"iMGt0","ebde58292c2cac85":"4kKue","de2be3979bdefa97":"8T325"}],"1MRaW":[function(require,module,exports) {
var Buffer = require("66067ceb9e0e34e0").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("b188ca4245d3fabd");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"66067ceb9e0e34e0":"8EcTH","b188ca4245d3fabd":"5I957"}],"iMGt0":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"4kKue":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"8T325":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"k5SII":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("f9aa88bbd42c725b");
(0, tslib_1.__exportStar)(require("30affb2c80a6f086"), exports);

},{"f9aa88bbd42c725b":"aBMbJ","30affb2c80a6f086":"lv27l"}],"aBMbJ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lv27l":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("40c44e09e3ab8cf7");
var constants_1 = require("e377ee84579ceba5");
var RawSha256_1 = require("46a04532f7215238");
var util_1 = require("88e6c348975e6735");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"40c44e09e3ab8cf7":"aBMbJ","e377ee84579ceba5":"aG55p","46a04532f7215238":"5wjVR","88e6c348975e6735":"555gx"}],"aG55p":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"5wjVR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("9968a7742d41246d");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"9968a7742d41246d":"aG55p"}],"1NiIB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("bd0a00071a1e077b");
tslib_1.__exportStar(require("64f58fdecb981407"), exports);

},{"bd0a00071a1e077b":"9Fj3y","64f58fdecb981407":"4aTY0"}],"9Fj3y":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4aTY0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("b8ebde4e4ccd8ebb");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"b8ebde4e4ccd8ebb":"9Fj3y"}],"el8RN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("2ea483ec76369693");
tslib_1.__exportStar(require("ac0356b754a90443"), exports);
tslib_1.__exportStar(require("d64c73f0cb413bec"), exports);
tslib_1.__exportStar(require("442085ffae14b1e8"), exports);
tslib_1.__exportStar(require("b9cf13eb10925b88"), exports);
tslib_1.__exportStar(require("3184ecd4f38f7ee3"), exports);

},{"2ea483ec76369693":"g5UzW","ac0356b754a90443":"6bsFW","d64c73f0cb413bec":"jnkRV","442085ffae14b1e8":"1pM0d","b9cf13eb10925b88":"cxvrA","3184ecd4f38f7ee3":"4r2u1"}],"g5UzW":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6bsFW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"jnkRV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1pM0d":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"cxvrA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"4r2u1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"20Kkr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./provider":"exgcw","./EventStreamMarshaller":"hOvfC","./utils":"1DRxf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"exgcw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", ()=>eventStreamSerdeProvider);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"hOvfC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hOvfC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", ()=>EventStreamMarshaller);
var _eventstreamMarshaller = require("@aws-sdk/eventstream-marshaller");
var _eventstreamSerdeUniversal = require("@aws-sdk/eventstream-serde-universal");
var _utils = require("./utils");
/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, _eventstreamMarshaller.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, _eventstreamSerdeUniversal.EventStreamMarshaller)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = isReadableStream(body) ? (0, _utils.readableStreamtoIterable)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, _utils.iterableToReadableStream)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

},{"@aws-sdk/eventstream-marshaller":"bzrqY","@aws-sdk/eventstream-serde-universal":"lJyzK","./utils":"1DRxf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bzrqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _int64 = require("./Int64");
parcelHelpers.exportAll(_int64, exports);
var _message = require("./Message");
parcelHelpers.exportAll(_message, exports);

},{"./EventStreamMarshaller":"iPhC5","./Int64":"jrK8V","./Message":"l5v4x","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iPhC5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", ()=>EventStreamMarshaller);
var _crc32 = require("@aws-crypto/crc32");
var _headerMarshaller = require("./HeaderMarshaller");
var _splitMessage = require("./splitMessage");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, _headerMarshaller.HeaderMarshaller)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, _crc32.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, _splitMessage.splitMessage)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();

},{"@aws-crypto/crc32":"8eX4r","./HeaderMarshaller":"fx5nS","./splitMessage":"3jUQK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8eX4r":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = exports.Crc32 = exports.crc32 = void 0;
var tslib_1 = require("ff93ff6885dc1cf");
var util_1 = require("c823117d943f0b79");
function crc32(data) {
    return new Crc32().update(data).digest();
}
exports.crc32 = crc32;
var Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, tslib_1.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
exports.Crc32 = Crc32;
// prettier-ignore
var a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
var aws_crc32_1 = require("584239808b1ee7cb");
Object.defineProperty(exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return aws_crc32_1.AwsCrc32;
    }
});

},{"ff93ff6885dc1cf":"9gMVn","c823117d943f0b79":"ktC9I","584239808b1ee7cb":"lPu5U"}],"ktC9I":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("6d23e61d99a6265d");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("13c1c8d30122a503");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("161dd33a10502f53");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("6982012a154add4a");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"6d23e61d99a6265d":"iEGSx","13c1c8d30122a503":"gpYNb","161dd33a10502f53":"5EcDc","6982012a154add4a":"hC7kJ"}],"iEGSx":[function(require,module,exports) {
var Buffer = require("d5ec4856aca93c4d").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("5a5d2efdf75859a7");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"d5ec4856aca93c4d":"8EcTH","5a5d2efdf75859a7":"59GiV"}],"gpYNb":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"5EcDc":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"hC7kJ":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"lPu5U":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = void 0;
var tslib_1 = require("b907f97435eccd7a");
var util_1 = require("3a796558421f7605");
var index_1 = require("3cb74d8e5af5d83d");
var AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new index_1.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash)) return;
        this.crc32.update((0, util_1.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, util_1.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
exports.AwsCrc32 = AwsCrc32;

},{"b907f97435eccd7a":"9gMVn","3a796558421f7605":"ktC9I","3cb74d8e5af5d83d":"8eX4r"}],"fx5nS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderMarshaller", ()=>HeaderMarshaller);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _int64 = require("./Int64");
/**
 * @internal
 */ var HeaderMarshaller = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, _tslib.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, _tslib.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, _int64.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, _utilHexEncoding.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: LONG_TAG,
                        value: new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: TIMESTAMP_TAG,
                        value: new Date(new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: UUID_TAG,
                        value: (0, _utilHexEncoding.toHex)(uuidBytes.subarray(0, 4)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(4, 6)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(6, 8)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(8, 10)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
var BOOLEAN_TAG = "boolean";
var BYTE_TAG = "byte";
var SHORT_TAG = "short";
var INT_TAG = "integer";
var LONG_TAG = "long";
var BINARY_TAG = "binary";
var STRING_TAG = "string";
var TIMESTAMP_TAG = "timestamp";
var UUID_TAG = "uuid";
var UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

},{"tslib":"9gMVn","@aws-sdk/util-hex-encoding":"1T3Ny","./Int64":"jrK8V","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jrK8V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Int64", ()=>Int64);
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var Int64 = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) negate(bytes);
        return parseInt((0, _utilHexEncoding.toHex)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

},{"@aws-sdk/util-hex-encoding":"1T3Ny","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3jUQK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "splitMessage", ()=>splitMessage);
var _crc32 = require("@aws-crypto/crc32");
// All prelude components are unsigned, 32-bit integers
var PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32(PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32(PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - CHECKSUM_LENGTH, false);
    var checksummer = new (0, _crc32.Crc32)().update(new Uint8Array(buffer, byteOffset, PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH, byteLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
    };
}

},{"@aws-crypto/crc32":"8eX4r","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l5v4x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lJyzK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);

},{"./provider":"cneGH","./EventStreamMarshaller":"cLy2g","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cneGH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", ()=>eventStreamSerdeProvider);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"cLy2g","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cLy2g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", ()=>EventStreamMarshaller);
var _tslib = require("tslib");
var _eventstreamMarshaller = require("@aws-sdk/eventstream-marshaller");
var _getChunkedStream = require("./getChunkedStream");
var _getUnmarshalledStream = require("./getUnmarshalledStream");
var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, _eventstreamMarshaller.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, _getChunkedStream.getChunkedStream)(body);
        var unmarshalledStream = (0, _getUnmarshalledStream.getUnmarshalledStream)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, _tslib.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, _tslib.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();

},{"tslib":"9gMVn","@aws-sdk/eventstream-marshaller":"bzrqY","./getChunkedStream":"kGEFp","./getUnmarshalledStream":"dLCm1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kGEFp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChunkedStream", ()=>getChunkedStream);
var _tslib = require("tslib");
function getChunkedStream(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dLCm1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUnmarshalledStream", ()=>getUnmarshalledStream);
var _tslib = require("tslib");
function getUnmarshalledStream(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, _tslib.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1DRxf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamtoIterable", ()=>readableStreamtoIterable);
parcelHelpers.export(exports, "iterableToReadableStream", ()=>iterableToReadableStream);
var _tslib = require("tslib");
var readableStreamtoIterable = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var iterableToReadableStream = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6UmM8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"69HkM","bowser":"oLvzi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"69HkM":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5C45R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2013-12-02",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Kinesis",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"eXETc","@aws-sdk/url-parser":"gQeEv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eXETc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "kinesis.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "kinesis.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "kinesis.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "kinesis.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "kinesis.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "kinesis.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "kinesis.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "kinesis.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "kinesis.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "kinesis.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "kinesis.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "kinesis.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "kinesis.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "kinesis.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "kinesis.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "kinesis.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "kinesis.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "kinesis.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "kinesis.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "kinesis.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "kinesis.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "kinesis-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "kinesis-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "kinesis-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "kinesis-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "kinesis.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "kinesis.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "kinesis.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "kinesis.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "kinesis.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "kinesis.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "kinesis.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "kinesis.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "kinesis.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "kinesis.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "kinesis"
    }, regionInfo));
};

},{"tslib":"hXPA8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"crFcd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamSerdeConfig = require("./EventStreamSerdeConfig");
parcelHelpers.exportAll(_eventStreamSerdeConfig, exports);

},{"./EventStreamSerdeConfig":"1gwwA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1gwwA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEventStreamSerdeConfig", ()=>resolveEventStreamSerdeConfig);
var _tslib = require("tslib");
var resolveEventStreamSerdeConfig = function(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1lroQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"QHtph","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"QHtph":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cSdRr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"c5NcD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"c5NcD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"hyrj2","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hyrj2":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l9mVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"ihG3A","./user-agent-middleware":"iFuqg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ihG3A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"4fopB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4fopB":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iFuqg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, _constants.X_AMZ_USER_AGENT] = (0, _tslib.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, _constants.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, _constants.USER_AGENT] = headers[0, _constants.USER_AGENT] ? headers[0, _constants.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"4fopB","@aws-sdk/protocol-http":"8mE6Q","./constants":"hJOW8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hJOW8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dg2vx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutRecordsCommand", ()=>PutRecordsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Writes multiple data records into a Kinesis data stream in a single call (also
 *             referred to as a <code>PutRecords</code> request). Use this operation to send data into
 *             the stream for data ingestion and processing. </p>
 *         <p>Each <code>PutRecords</code> request can support up to 500 records. Each record in
 *             the request can be as large as 1 MiB, up to a limit of 5 MiB for the entire request,
 *             including partition keys. Each shard can support writes up to 1,000 records per second,
 *             up to a maximum data write total of 1 MiB per second.</p>
 *         <p>You must specify the name of the stream that captures, stores, and transports the
 *             data; and an array of request <code>Records</code>, with each record in the array
 *             requiring a partition key and data blob. The record size limit applies to the total size
 *             of the partition key and data blob.</p>
 *         <p>The data blob can be any type of data; for example, a segment from a log file,
 *             geographic/location data, website clickstream data, and so on.</p>
 *         <p>The partition key is used by Kinesis Data Streams as input to a hash function that
 *             maps the partition key and associated data to a specific shard. An MD5 hash function is
 *             used to map partition keys to 128-bit integer values and to map associated data records
 *             to shards. As a result of this hashing mechanism, all data records with the same
 *             partition key map to the same shard within the stream. For more information, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/developing-producers-with-sdk.html#kinesis-using-sdk-java-add-data-to-stream">Adding Data to a Stream</a> in the <i>Amazon Kinesis Data Streams
 *                 Developer Guide</i>.</p>
 *         <p>Each record in the <code>Records</code> array may include an optional parameter,
 *                 <code>ExplicitHashKey</code>, which overrides the partition key to shard mapping.
 *             This parameter allows a data producer to determine explicitly the shard where the record
 *             is stored. For more information, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/developing-producers-with-sdk.html#kinesis-using-sdk-java-putrecords">Adding Multiple Records with PutRecords</a> in the <i>Amazon Kinesis
 *                 Data Streams Developer Guide</i>.</p>
 *         <p>The <code>PutRecords</code> response includes an array of response
 *                 <code>Records</code>. Each record in the response array directly correlates with a
 *             record in the request array using natural ordering, from the top to the bottom of the
 *             request and response. The response <code>Records</code> array always includes the same
 *             number of records as the request array.</p>
 *         <p>The response <code>Records</code> array includes both successfully and
 *             unsuccessfully processed records. Kinesis Data Streams attempts to process all records
 *             in each <code>PutRecords</code> request. A single record failure does not stop the
 *             processing of subsequent records. As a result, PutRecords doesn't guarantee the ordering
 *             of records. If you need to read records in the same order they are written to the
 *             stream, use <a>PutRecord</a> instead of <code>PutRecords</code>, and write to
 *             the same shard.</p>
 *         <p>A successfully processed record includes <code>ShardId</code> and
 *                 <code>SequenceNumber</code> values. The <code>ShardId</code> parameter identifies
 *             the shard in the stream where the record is stored. The <code>SequenceNumber</code>
 *             parameter is an identifier assigned to the put record, unique to all records in the
 *             stream.</p>
 *         <p>An unsuccessfully processed record includes <code>ErrorCode</code> and
 *                 <code>ErrorMessage</code> values. <code>ErrorCode</code> reflects the type of error
 *             and can be one of the following values:
 *                 <code>ProvisionedThroughputExceededException</code> or <code>InternalFailure</code>.
 *                 <code>ErrorMessage</code> provides more detailed information about the
 *                 <code>ProvisionedThroughputExceededException</code> exception including the account
 *             ID, stream name, and shard ID of the record that was throttled. For more information
 *             about partially successful responses, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/kinesis-using-sdk-java-add-data-to-stream.html#kinesis-using-sdk-java-putrecords">Adding Multiple Records with PutRecords</a> in the <i>Amazon Kinesis
 *                 Data Streams Developer Guide</i>.</p>
 *         <important>
 *             <p>After you write a record to a stream, you cannot modify that record or its order
 *                 within the stream.</p>
 *         </important>
 *         <p>By default, data records are accessible for 24 hours from the time that they are
 *             added to a stream. You can use <a>IncreaseStreamRetentionPeriod</a> or <a>DecreaseStreamRetentionPeriod</a> to modify this retention period.</p>
 */ var PutRecordsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutRecordsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutRecordsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "PutRecordsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutRecordsInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutRecordsOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutRecordsCommand)(input, context);
    };
    PutRecordsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutRecordsCommand)(output, context);
    };
    return PutRecordsCommand;
}((0, _smithyClient.Command));

},{"tslib":"hXPA8","../models/models_0":"hWtNK","../protocols/Aws_json1_1":"9IMCb","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hWtNK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddTagsToStreamInput", ()=>AddTagsToStreamInput);
parcelHelpers.export(exports, "InvalidArgumentException", ()=>InvalidArgumentException);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "ResourceInUseException", ()=>ResourceInUseException);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "HashKeyRange", ()=>HashKeyRange);
parcelHelpers.export(exports, "ChildShard", ()=>ChildShard);
parcelHelpers.export(exports, "ConsumerStatus", ()=>ConsumerStatus);
parcelHelpers.export(exports, "Consumer", ()=>Consumer);
parcelHelpers.export(exports, "ConsumerDescription", ()=>ConsumerDescription);
parcelHelpers.export(exports, "CreateStreamInput", ()=>CreateStreamInput);
parcelHelpers.export(exports, "DecreaseStreamRetentionPeriodInput", ()=>DecreaseStreamRetentionPeriodInput);
parcelHelpers.export(exports, "DeleteStreamInput", ()=>DeleteStreamInput);
parcelHelpers.export(exports, "DeregisterStreamConsumerInput", ()=>DeregisterStreamConsumerInput);
parcelHelpers.export(exports, "DescribeLimitsInput", ()=>DescribeLimitsInput);
parcelHelpers.export(exports, "DescribeLimitsOutput", ()=>DescribeLimitsOutput);
parcelHelpers.export(exports, "DescribeStreamInput", ()=>DescribeStreamInput);
parcelHelpers.export(exports, "EncryptionType", ()=>EncryptionType);
parcelHelpers.export(exports, "MetricsName", ()=>MetricsName);
parcelHelpers.export(exports, "EnhancedMetrics", ()=>EnhancedMetrics);
parcelHelpers.export(exports, "SequenceNumberRange", ()=>SequenceNumberRange);
parcelHelpers.export(exports, "Shard", ()=>Shard);
parcelHelpers.export(exports, "StreamStatus", ()=>StreamStatus);
parcelHelpers.export(exports, "StreamDescription", ()=>StreamDescription);
parcelHelpers.export(exports, "DescribeStreamOutput", ()=>DescribeStreamOutput);
parcelHelpers.export(exports, "DescribeStreamConsumerInput", ()=>DescribeStreamConsumerInput);
parcelHelpers.export(exports, "DescribeStreamConsumerOutput", ()=>DescribeStreamConsumerOutput);
parcelHelpers.export(exports, "DescribeStreamSummaryInput", ()=>DescribeStreamSummaryInput);
parcelHelpers.export(exports, "StreamDescriptionSummary", ()=>StreamDescriptionSummary);
parcelHelpers.export(exports, "DescribeStreamSummaryOutput", ()=>DescribeStreamSummaryOutput);
parcelHelpers.export(exports, "DisableEnhancedMonitoringInput", ()=>DisableEnhancedMonitoringInput);
parcelHelpers.export(exports, "EnhancedMonitoringOutput", ()=>EnhancedMonitoringOutput);
parcelHelpers.export(exports, "EnableEnhancedMonitoringInput", ()=>EnableEnhancedMonitoringInput);
parcelHelpers.export(exports, "ExpiredIteratorException", ()=>ExpiredIteratorException);
parcelHelpers.export(exports, "ExpiredNextTokenException", ()=>ExpiredNextTokenException);
parcelHelpers.export(exports, "GetRecordsInput", ()=>GetRecordsInput);
parcelHelpers.export(exports, "_Record", ()=>_Record);
parcelHelpers.export(exports, "GetRecordsOutput", ()=>GetRecordsOutput);
parcelHelpers.export(exports, "KMSAccessDeniedException", ()=>KMSAccessDeniedException);
parcelHelpers.export(exports, "KMSDisabledException", ()=>KMSDisabledException);
parcelHelpers.export(exports, "KMSInvalidStateException", ()=>KMSInvalidStateException);
parcelHelpers.export(exports, "KMSNotFoundException", ()=>KMSNotFoundException);
parcelHelpers.export(exports, "KMSOptInRequired", ()=>KMSOptInRequired);
parcelHelpers.export(exports, "KMSThrottlingException", ()=>KMSThrottlingException);
parcelHelpers.export(exports, "ProvisionedThroughputExceededException", ()=>ProvisionedThroughputExceededException);
parcelHelpers.export(exports, "ShardIteratorType", ()=>ShardIteratorType);
parcelHelpers.export(exports, "GetShardIteratorInput", ()=>GetShardIteratorInput);
parcelHelpers.export(exports, "GetShardIteratorOutput", ()=>GetShardIteratorOutput);
parcelHelpers.export(exports, "IncreaseStreamRetentionPeriodInput", ()=>IncreaseStreamRetentionPeriodInput);
parcelHelpers.export(exports, "InternalFailureException", ()=>InternalFailureException);
parcelHelpers.export(exports, "ShardFilterType", ()=>ShardFilterType);
parcelHelpers.export(exports, "ShardFilter", ()=>ShardFilter);
parcelHelpers.export(exports, "ListShardsInput", ()=>ListShardsInput);
parcelHelpers.export(exports, "ListShardsOutput", ()=>ListShardsOutput);
parcelHelpers.export(exports, "ListStreamConsumersInput", ()=>ListStreamConsumersInput);
parcelHelpers.export(exports, "ListStreamConsumersOutput", ()=>ListStreamConsumersOutput);
parcelHelpers.export(exports, "ListStreamsInput", ()=>ListStreamsInput);
parcelHelpers.export(exports, "ListStreamsOutput", ()=>ListStreamsOutput);
parcelHelpers.export(exports, "ListTagsForStreamInput", ()=>ListTagsForStreamInput);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "ListTagsForStreamOutput", ()=>ListTagsForStreamOutput);
parcelHelpers.export(exports, "MergeShardsInput", ()=>MergeShardsInput);
parcelHelpers.export(exports, "PutRecordInput", ()=>PutRecordInput);
parcelHelpers.export(exports, "PutRecordOutput", ()=>PutRecordOutput);
parcelHelpers.export(exports, "PutRecordsRequestEntry", ()=>PutRecordsRequestEntry);
parcelHelpers.export(exports, "PutRecordsInput", ()=>PutRecordsInput);
parcelHelpers.export(exports, "PutRecordsResultEntry", ()=>PutRecordsResultEntry);
parcelHelpers.export(exports, "PutRecordsOutput", ()=>PutRecordsOutput);
parcelHelpers.export(exports, "RegisterStreamConsumerInput", ()=>RegisterStreamConsumerInput);
parcelHelpers.export(exports, "RegisterStreamConsumerOutput", ()=>RegisterStreamConsumerOutput);
parcelHelpers.export(exports, "RemoveTagsFromStreamInput", ()=>RemoveTagsFromStreamInput);
parcelHelpers.export(exports, "SplitShardInput", ()=>SplitShardInput);
parcelHelpers.export(exports, "StartStreamEncryptionInput", ()=>StartStreamEncryptionInput);
parcelHelpers.export(exports, "StopStreamEncryptionInput", ()=>StopStreamEncryptionInput);
parcelHelpers.export(exports, "StartingPosition", ()=>StartingPosition);
parcelHelpers.export(exports, "SubscribeToShardInput", ()=>SubscribeToShardInput);
parcelHelpers.export(exports, "SubscribeToShardEvent", ()=>SubscribeToShardEvent);
parcelHelpers.export(exports, "SubscribeToShardEventStream", ()=>SubscribeToShardEventStream);
parcelHelpers.export(exports, "SubscribeToShardOutput", ()=>SubscribeToShardOutput);
parcelHelpers.export(exports, "ScalingType", ()=>ScalingType);
parcelHelpers.export(exports, "UpdateShardCountInput", ()=>UpdateShardCountInput);
parcelHelpers.export(exports, "UpdateShardCountOutput", ()=>UpdateShardCountOutput);
var _tslib = require("tslib");
var AddTagsToStreamInput;
(function(AddTagsToStreamInput) {
    AddTagsToStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(AddTagsToStreamInput || (AddTagsToStreamInput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceInUseException;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceInUseException || (ResourceInUseException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var HashKeyRange;
(function(HashKeyRange) {
    HashKeyRange.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HashKeyRange || (HashKeyRange = {}));
var ChildShard;
(function(ChildShard) {
    ChildShard.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ChildShard || (ChildShard = {}));
var ConsumerStatus;
(function(ConsumerStatus) {
    ConsumerStatus["ACTIVE"] = "ACTIVE";
    ConsumerStatus["CREATING"] = "CREATING";
    ConsumerStatus["DELETING"] = "DELETING";
})(ConsumerStatus || (ConsumerStatus = {}));
var Consumer;
(function(Consumer) {
    Consumer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Consumer || (Consumer = {}));
var ConsumerDescription;
(function(ConsumerDescription) {
    ConsumerDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ConsumerDescription || (ConsumerDescription = {}));
var CreateStreamInput;
(function(CreateStreamInput) {
    CreateStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateStreamInput || (CreateStreamInput = {}));
var DecreaseStreamRetentionPeriodInput;
(function(DecreaseStreamRetentionPeriodInput) {
    DecreaseStreamRetentionPeriodInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DecreaseStreamRetentionPeriodInput || (DecreaseStreamRetentionPeriodInput = {}));
var DeleteStreamInput;
(function(DeleteStreamInput) {
    DeleteStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteStreamInput || (DeleteStreamInput = {}));
var DeregisterStreamConsumerInput;
(function(DeregisterStreamConsumerInput) {
    DeregisterStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeregisterStreamConsumerInput || (DeregisterStreamConsumerInput = {}));
var DescribeLimitsInput;
(function(DescribeLimitsInput) {
    DescribeLimitsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLimitsInput || (DescribeLimitsInput = {}));
var DescribeLimitsOutput;
(function(DescribeLimitsOutput) {
    DescribeLimitsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLimitsOutput || (DescribeLimitsOutput = {}));
var DescribeStreamInput;
(function(DescribeStreamInput) {
    DescribeStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamInput || (DescribeStreamInput = {}));
var EncryptionType;
(function(EncryptionType) {
    EncryptionType["KMS"] = "KMS";
    EncryptionType["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
var MetricsName;
(function(MetricsName) {
    MetricsName["ALL"] = "ALL";
    MetricsName["INCOMING_BYTES"] = "IncomingBytes";
    MetricsName["INCOMING_RECORDS"] = "IncomingRecords";
    MetricsName["ITERATOR_AGE_MILLISECONDS"] = "IteratorAgeMilliseconds";
    MetricsName["OUTGOING_BYTES"] = "OutgoingBytes";
    MetricsName["OUTGOING_RECORDS"] = "OutgoingRecords";
    MetricsName["READ_PROVISIONED_THROUGHPUT_EXCEEDED"] = "ReadProvisionedThroughputExceeded";
    MetricsName["WRITE_PROVISIONED_THROUGHPUT_EXCEEDED"] = "WriteProvisionedThroughputExceeded";
})(MetricsName || (MetricsName = {}));
var EnhancedMetrics;
(function(EnhancedMetrics) {
    EnhancedMetrics.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnhancedMetrics || (EnhancedMetrics = {}));
var SequenceNumberRange;
(function(SequenceNumberRange) {
    SequenceNumberRange.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SequenceNumberRange || (SequenceNumberRange = {}));
var Shard;
(function(Shard) {
    Shard.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Shard || (Shard = {}));
var StreamStatus;
(function(StreamStatus) {
    StreamStatus["ACTIVE"] = "ACTIVE";
    StreamStatus["CREATING"] = "CREATING";
    StreamStatus["DELETING"] = "DELETING";
    StreamStatus["UPDATING"] = "UPDATING";
})(StreamStatus || (StreamStatus = {}));
var StreamDescription;
(function(StreamDescription) {
    StreamDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StreamDescription || (StreamDescription = {}));
var DescribeStreamOutput;
(function(DescribeStreamOutput) {
    DescribeStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamOutput || (DescribeStreamOutput = {}));
var DescribeStreamConsumerInput;
(function(DescribeStreamConsumerInput) {
    DescribeStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamConsumerInput || (DescribeStreamConsumerInput = {}));
var DescribeStreamConsumerOutput;
(function(DescribeStreamConsumerOutput) {
    DescribeStreamConsumerOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamConsumerOutput || (DescribeStreamConsumerOutput = {}));
var DescribeStreamSummaryInput;
(function(DescribeStreamSummaryInput) {
    DescribeStreamSummaryInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamSummaryInput || (DescribeStreamSummaryInput = {}));
var StreamDescriptionSummary;
(function(StreamDescriptionSummary) {
    StreamDescriptionSummary.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StreamDescriptionSummary || (StreamDescriptionSummary = {}));
var DescribeStreamSummaryOutput;
(function(DescribeStreamSummaryOutput) {
    DescribeStreamSummaryOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamSummaryOutput || (DescribeStreamSummaryOutput = {}));
var DisableEnhancedMonitoringInput;
(function(DisableEnhancedMonitoringInput) {
    DisableEnhancedMonitoringInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DisableEnhancedMonitoringInput || (DisableEnhancedMonitoringInput = {}));
var EnhancedMonitoringOutput;
(function(EnhancedMonitoringOutput) {
    EnhancedMonitoringOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnhancedMonitoringOutput || (EnhancedMonitoringOutput = {}));
var EnableEnhancedMonitoringInput;
(function(EnableEnhancedMonitoringInput) {
    EnableEnhancedMonitoringInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnableEnhancedMonitoringInput || (EnableEnhancedMonitoringInput = {}));
var ExpiredIteratorException;
(function(ExpiredIteratorException) {
    ExpiredIteratorException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExpiredIteratorException || (ExpiredIteratorException = {}));
var ExpiredNextTokenException;
(function(ExpiredNextTokenException) {
    ExpiredNextTokenException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExpiredNextTokenException || (ExpiredNextTokenException = {}));
var GetRecordsInput;
(function(GetRecordsInput) {
    GetRecordsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetRecordsInput || (GetRecordsInput = {}));
var _Record;
(function(_Record) {
    _Record.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(_Record || (_Record = {}));
var GetRecordsOutput;
(function(GetRecordsOutput) {
    GetRecordsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetRecordsOutput || (GetRecordsOutput = {}));
var KMSAccessDeniedException;
(function(KMSAccessDeniedException) {
    KMSAccessDeniedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSAccessDeniedException || (KMSAccessDeniedException = {}));
var KMSDisabledException;
(function(KMSDisabledException) {
    KMSDisabledException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSDisabledException || (KMSDisabledException = {}));
var KMSInvalidStateException;
(function(KMSInvalidStateException) {
    KMSInvalidStateException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSInvalidStateException || (KMSInvalidStateException = {}));
var KMSNotFoundException;
(function(KMSNotFoundException) {
    KMSNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSNotFoundException || (KMSNotFoundException = {}));
var KMSOptInRequired;
(function(KMSOptInRequired) {
    KMSOptInRequired.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSOptInRequired || (KMSOptInRequired = {}));
var KMSThrottlingException;
(function(KMSThrottlingException) {
    KMSThrottlingException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSThrottlingException || (KMSThrottlingException = {}));
var ProvisionedThroughputExceededException;
(function(ProvisionedThroughputExceededException) {
    ProvisionedThroughputExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProvisionedThroughputExceededException || (ProvisionedThroughputExceededException = {}));
var ShardIteratorType;
(function(ShardIteratorType) {
    ShardIteratorType["AFTER_SEQUENCE_NUMBER"] = "AFTER_SEQUENCE_NUMBER";
    ShardIteratorType["AT_SEQUENCE_NUMBER"] = "AT_SEQUENCE_NUMBER";
    ShardIteratorType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardIteratorType["LATEST"] = "LATEST";
    ShardIteratorType["TRIM_HORIZON"] = "TRIM_HORIZON";
})(ShardIteratorType || (ShardIteratorType = {}));
var GetShardIteratorInput;
(function(GetShardIteratorInput) {
    GetShardIteratorInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetShardIteratorInput || (GetShardIteratorInput = {}));
var GetShardIteratorOutput;
(function(GetShardIteratorOutput) {
    GetShardIteratorOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetShardIteratorOutput || (GetShardIteratorOutput = {}));
var IncreaseStreamRetentionPeriodInput;
(function(IncreaseStreamRetentionPeriodInput) {
    IncreaseStreamRetentionPeriodInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(IncreaseStreamRetentionPeriodInput || (IncreaseStreamRetentionPeriodInput = {}));
var InternalFailureException;
(function(InternalFailureException) {
    InternalFailureException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InternalFailureException || (InternalFailureException = {}));
var ShardFilterType;
(function(ShardFilterType) {
    ShardFilterType["AFTER_SHARD_ID"] = "AFTER_SHARD_ID";
    ShardFilterType["AT_LATEST"] = "AT_LATEST";
    ShardFilterType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardFilterType["AT_TRIM_HORIZON"] = "AT_TRIM_HORIZON";
    ShardFilterType["FROM_TIMESTAMP"] = "FROM_TIMESTAMP";
    ShardFilterType["FROM_TRIM_HORIZON"] = "FROM_TRIM_HORIZON";
})(ShardFilterType || (ShardFilterType = {}));
var ShardFilter;
(function(ShardFilter) {
    ShardFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ShardFilter || (ShardFilter = {}));
var ListShardsInput;
(function(ListShardsInput) {
    ListShardsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListShardsInput || (ListShardsInput = {}));
var ListShardsOutput;
(function(ListShardsOutput) {
    ListShardsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListShardsOutput || (ListShardsOutput = {}));
var ListStreamConsumersInput;
(function(ListStreamConsumersInput) {
    ListStreamConsumersInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamConsumersInput || (ListStreamConsumersInput = {}));
var ListStreamConsumersOutput;
(function(ListStreamConsumersOutput) {
    ListStreamConsumersOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamConsumersOutput || (ListStreamConsumersOutput = {}));
var ListStreamsInput;
(function(ListStreamsInput) {
    ListStreamsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamsInput || (ListStreamsInput = {}));
var ListStreamsOutput;
(function(ListStreamsOutput) {
    ListStreamsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamsOutput || (ListStreamsOutput = {}));
var ListTagsForStreamInput;
(function(ListTagsForStreamInput) {
    ListTagsForStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForStreamInput || (ListTagsForStreamInput = {}));
var Tag;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Tag || (Tag = {}));
var ListTagsForStreamOutput;
(function(ListTagsForStreamOutput) {
    ListTagsForStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForStreamOutput || (ListTagsForStreamOutput = {}));
var MergeShardsInput;
(function(MergeShardsInput) {
    MergeShardsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MergeShardsInput || (MergeShardsInput = {}));
var PutRecordInput;
(function(PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordOutput || (PutRecordOutput = {}));
var PutRecordsRequestEntry;
(function(PutRecordsRequestEntry) {
    PutRecordsRequestEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsRequestEntry || (PutRecordsRequestEntry = {}));
var PutRecordsInput;
(function(PutRecordsInput) {
    PutRecordsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsInput || (PutRecordsInput = {}));
var PutRecordsResultEntry;
(function(PutRecordsResultEntry) {
    PutRecordsResultEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsResultEntry || (PutRecordsResultEntry = {}));
var PutRecordsOutput;
(function(PutRecordsOutput) {
    PutRecordsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsOutput || (PutRecordsOutput = {}));
var RegisterStreamConsumerInput;
(function(RegisterStreamConsumerInput) {
    RegisterStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RegisterStreamConsumerInput || (RegisterStreamConsumerInput = {}));
var RegisterStreamConsumerOutput;
(function(RegisterStreamConsumerOutput) {
    RegisterStreamConsumerOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RegisterStreamConsumerOutput || (RegisterStreamConsumerOutput = {}));
var RemoveTagsFromStreamInput;
(function(RemoveTagsFromStreamInput) {
    RemoveTagsFromStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RemoveTagsFromStreamInput || (RemoveTagsFromStreamInput = {}));
var SplitShardInput;
(function(SplitShardInput) {
    SplitShardInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplitShardInput || (SplitShardInput = {}));
var StartStreamEncryptionInput;
(function(StartStreamEncryptionInput) {
    StartStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartStreamEncryptionInput || (StartStreamEncryptionInput = {}));
var StopStreamEncryptionInput;
(function(StopStreamEncryptionInput) {
    StopStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopStreamEncryptionInput || (StopStreamEncryptionInput = {}));
var StartingPosition;
(function(StartingPosition) {
    StartingPosition.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartingPosition || (StartingPosition = {}));
var SubscribeToShardInput;
(function(SubscribeToShardInput) {
    SubscribeToShardInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscribeToShardInput || (SubscribeToShardInput = {}));
var SubscribeToShardEvent;
(function(SubscribeToShardEvent) {
    SubscribeToShardEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscribeToShardEvent || (SubscribeToShardEvent = {}));
var SubscribeToShardEventStream;
(function(SubscribeToShardEventStream) {
    SubscribeToShardEventStream.visit = function(value, visitor) {
        if (value.SubscribeToShardEvent !== undefined) return visitor.SubscribeToShardEvent(value.SubscribeToShardEvent);
        if (value.ResourceNotFoundException !== undefined) return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.ResourceInUseException !== undefined) return visitor.ResourceInUseException(value.ResourceInUseException);
        if (value.KMSDisabledException !== undefined) return visitor.KMSDisabledException(value.KMSDisabledException);
        if (value.KMSInvalidStateException !== undefined) return visitor.KMSInvalidStateException(value.KMSInvalidStateException);
        if (value.KMSAccessDeniedException !== undefined) return visitor.KMSAccessDeniedException(value.KMSAccessDeniedException);
        if (value.KMSNotFoundException !== undefined) return visitor.KMSNotFoundException(value.KMSNotFoundException);
        if (value.KMSOptInRequired !== undefined) return visitor.KMSOptInRequired(value.KMSOptInRequired);
        if (value.KMSThrottlingException !== undefined) return visitor.KMSThrottlingException(value.KMSThrottlingException);
        if (value.InternalFailureException !== undefined) return visitor.InternalFailureException(value.InternalFailureException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SubscribeToShardEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.SubscribeToShardEvent !== undefined) return {
            SubscribeToShardEvent: SubscribeToShardEvent.filterSensitiveLog(obj.SubscribeToShardEvent)
        };
        if (obj.ResourceNotFoundException !== undefined) return {
            ResourceNotFoundException: ResourceNotFoundException.filterSensitiveLog(obj.ResourceNotFoundException)
        };
        if (obj.ResourceInUseException !== undefined) return {
            ResourceInUseException: ResourceInUseException.filterSensitiveLog(obj.ResourceInUseException)
        };
        if (obj.KMSDisabledException !== undefined) return {
            KMSDisabledException: KMSDisabledException.filterSensitiveLog(obj.KMSDisabledException)
        };
        if (obj.KMSInvalidStateException !== undefined) return {
            KMSInvalidStateException: KMSInvalidStateException.filterSensitiveLog(obj.KMSInvalidStateException)
        };
        if (obj.KMSAccessDeniedException !== undefined) return {
            KMSAccessDeniedException: KMSAccessDeniedException.filterSensitiveLog(obj.KMSAccessDeniedException)
        };
        if (obj.KMSNotFoundException !== undefined) return {
            KMSNotFoundException: KMSNotFoundException.filterSensitiveLog(obj.KMSNotFoundException)
        };
        if (obj.KMSOptInRequired !== undefined) return {
            KMSOptInRequired: KMSOptInRequired.filterSensitiveLog(obj.KMSOptInRequired)
        };
        if (obj.KMSThrottlingException !== undefined) return {
            KMSThrottlingException: KMSThrottlingException.filterSensitiveLog(obj.KMSThrottlingException)
        };
        if (obj.InternalFailureException !== undefined) return {
            InternalFailureException: InternalFailureException.filterSensitiveLog(obj.InternalFailureException)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})(SubscribeToShardEventStream || (SubscribeToShardEventStream = {}));
var SubscribeToShardOutput;
(function(SubscribeToShardOutput) {
    SubscribeToShardOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EventStream && {
            EventStream: "STREAMING_CONTENT"
        });
    };
})(SubscribeToShardOutput || (SubscribeToShardOutput = {}));
var ScalingType;
(function(ScalingType) {
    ScalingType["UNIFORM_SCALING"] = "UNIFORM_SCALING";
})(ScalingType || (ScalingType = {}));
var UpdateShardCountInput;
(function(UpdateShardCountInput) {
    UpdateShardCountInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateShardCountInput || (UpdateShardCountInput = {}));
var UpdateShardCountOutput;
(function(UpdateShardCountOutput) {
    UpdateShardCountOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateShardCountOutput || (UpdateShardCountOutput = {}));

},{"tslib":"hXPA8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9IMCb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1AddTagsToStreamCommand", ()=>serializeAws_json1_1AddTagsToStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateStreamCommand", ()=>serializeAws_json1_1CreateStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DecreaseStreamRetentionPeriodCommand", ()=>serializeAws_json1_1DecreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteStreamCommand", ()=>serializeAws_json1_1DeleteStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeregisterStreamConsumerCommand", ()=>serializeAws_json1_1DeregisterStreamConsumerCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLimitsCommand", ()=>serializeAws_json1_1DescribeLimitsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamCommand", ()=>serializeAws_json1_1DescribeStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamConsumerCommand", ()=>serializeAws_json1_1DescribeStreamConsumerCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamSummaryCommand", ()=>serializeAws_json1_1DescribeStreamSummaryCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DisableEnhancedMonitoringCommand", ()=>serializeAws_json1_1DisableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "serializeAws_json1_1EnableEnhancedMonitoringCommand", ()=>serializeAws_json1_1EnableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetRecordsCommand", ()=>serializeAws_json1_1GetRecordsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetShardIteratorCommand", ()=>serializeAws_json1_1GetShardIteratorCommand);
parcelHelpers.export(exports, "serializeAws_json1_1IncreaseStreamRetentionPeriodCommand", ()=>serializeAws_json1_1IncreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListShardsCommand", ()=>serializeAws_json1_1ListShardsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListStreamConsumersCommand", ()=>serializeAws_json1_1ListStreamConsumersCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListStreamsCommand", ()=>serializeAws_json1_1ListStreamsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsForStreamCommand", ()=>serializeAws_json1_1ListTagsForStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1MergeShardsCommand", ()=>serializeAws_json1_1MergeShardsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordCommand", ()=>serializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordsCommand", ()=>serializeAws_json1_1PutRecordsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1RegisterStreamConsumerCommand", ()=>serializeAws_json1_1RegisterStreamConsumerCommand);
parcelHelpers.export(exports, "serializeAws_json1_1RemoveTagsFromStreamCommand", ()=>serializeAws_json1_1RemoveTagsFromStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1SplitShardCommand", ()=>serializeAws_json1_1SplitShardCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StartStreamEncryptionCommand", ()=>serializeAws_json1_1StartStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StopStreamEncryptionCommand", ()=>serializeAws_json1_1StopStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1SubscribeToShardCommand", ()=>serializeAws_json1_1SubscribeToShardCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UpdateShardCountCommand", ()=>serializeAws_json1_1UpdateShardCountCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1AddTagsToStreamCommand", ()=>deserializeAws_json1_1AddTagsToStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateStreamCommand", ()=>deserializeAws_json1_1CreateStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand", ()=>deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteStreamCommand", ()=>deserializeAws_json1_1DeleteStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeregisterStreamConsumerCommand", ()=>deserializeAws_json1_1DeregisterStreamConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLimitsCommand", ()=>deserializeAws_json1_1DescribeLimitsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamCommand", ()=>deserializeAws_json1_1DescribeStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamConsumerCommand", ()=>deserializeAws_json1_1DescribeStreamConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamSummaryCommand", ()=>deserializeAws_json1_1DescribeStreamSummaryCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DisableEnhancedMonitoringCommand", ()=>deserializeAws_json1_1DisableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1EnableEnhancedMonitoringCommand", ()=>deserializeAws_json1_1EnableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetRecordsCommand", ()=>deserializeAws_json1_1GetRecordsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetShardIteratorCommand", ()=>deserializeAws_json1_1GetShardIteratorCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand", ()=>deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListShardsCommand", ()=>deserializeAws_json1_1ListShardsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListStreamConsumersCommand", ()=>deserializeAws_json1_1ListStreamConsumersCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListStreamsCommand", ()=>deserializeAws_json1_1ListStreamsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsForStreamCommand", ()=>deserializeAws_json1_1ListTagsForStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1MergeShardsCommand", ()=>deserializeAws_json1_1MergeShardsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordCommand", ()=>deserializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordsCommand", ()=>deserializeAws_json1_1PutRecordsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1RegisterStreamConsumerCommand", ()=>deserializeAws_json1_1RegisterStreamConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1RemoveTagsFromStreamCommand", ()=>deserializeAws_json1_1RemoveTagsFromStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1SplitShardCommand", ()=>deserializeAws_json1_1SplitShardCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StartStreamEncryptionCommand", ()=>deserializeAws_json1_1StartStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StopStreamEncryptionCommand", ()=>deserializeAws_json1_1StopStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1SubscribeToShardCommand", ()=>deserializeAws_json1_1SubscribeToShardCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UpdateShardCountCommand", ()=>deserializeAws_json1_1UpdateShardCountCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1AddTagsToStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.AddTagsToStream"
            };
            body = JSON.stringify(serializeAws_json1_1AddTagsToStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.CreateStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DecreaseStreamRetentionPeriodCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DecreaseStreamRetentionPeriod"
            };
            body = JSON.stringify(serializeAws_json1_1DecreaseStreamRetentionPeriodInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DeleteStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeregisterStreamConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DeregisterStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1DeregisterStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLimitsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeLimits"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLimitsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStream"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamSummaryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStreamSummary"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamSummaryInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DisableEnhancedMonitoringCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DisableEnhancedMonitoring"
            };
            body = JSON.stringify(serializeAws_json1_1DisableEnhancedMonitoringInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1EnableEnhancedMonitoringCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.EnableEnhancedMonitoring"
            };
            body = JSON.stringify(serializeAws_json1_1EnableEnhancedMonitoringInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetRecordsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.GetRecords"
            };
            body = JSON.stringify(serializeAws_json1_1GetRecordsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetShardIteratorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.GetShardIterator"
            };
            body = JSON.stringify(serializeAws_json1_1GetShardIteratorInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1IncreaseStreamRetentionPeriodCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.IncreaseStreamRetentionPeriod"
            };
            body = JSON.stringify(serializeAws_json1_1IncreaseStreamRetentionPeriodInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListShardsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListShards"
            };
            body = JSON.stringify(serializeAws_json1_1ListShardsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListStreamConsumersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListStreamConsumers"
            };
            body = JSON.stringify(serializeAws_json1_1ListStreamConsumersInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListStreamsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListStreams"
            };
            body = JSON.stringify(serializeAws_json1_1ListStreamsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsForStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListTagsForStream"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsForStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1MergeShardsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.MergeShards"
            };
            body = JSON.stringify(serializeAws_json1_1MergeShardsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.PutRecord"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.PutRecords"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1RegisterStreamConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.RegisterStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1RegisterStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1RemoveTagsFromStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.RemoveTagsFromStream"
            };
            body = JSON.stringify(serializeAws_json1_1RemoveTagsFromStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1SplitShardCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.SplitShard"
            };
            body = JSON.stringify(serializeAws_json1_1SplitShardInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.StartStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StartStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.StopStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StopStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1SubscribeToShardCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.SubscribeToShard"
            };
            body = JSON.stringify(serializeAws_json1_1SubscribeToShardInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UpdateShardCountCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.UpdateShardCount"
            };
            body = JSON.stringify(serializeAws_json1_1UpdateShardCountInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1AddTagsToStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1AddTagsToStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1AddTagsToStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeregisterStreamConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeregisterStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeregisterStreamConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLimitsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLimitsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLimitsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLimitsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamConsumerOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamSummaryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamSummaryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamSummaryOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamSummaryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisableEnhancedMonitoringCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DisableEnhancedMonitoringCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1EnhancedMonitoringOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisableEnhancedMonitoringCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1EnableEnhancedMonitoringCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1EnableEnhancedMonitoringCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1EnhancedMonitoringOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1EnableEnhancedMonitoringCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetRecordsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetRecordsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetRecordsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetRecordsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, _tslib.__generator)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _o = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredIteratorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredIteratorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredIteratorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetShardIteratorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetShardIteratorCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetShardIteratorOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetShardIteratorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListShardsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListShardsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListShardsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListShardsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamConsumersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListStreamConsumersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListStreamConsumersOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamConsumersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListStreamsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsForStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsForStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1MergeShardsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1MergeShardsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1MergeShardsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, _tslib.__generator)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _m = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, _tslib.__generator)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _m = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RegisterStreamConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1RegisterStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1RegisterStreamConsumerOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RegisterStreamConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RemoveTagsFromStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1RemoveTagsFromStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RemoveTagsFromStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SplitShardCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1SplitShardCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SplitShardCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, _tslib.__generator)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _o = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SubscribeToShardCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1SubscribeToShardCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1SubscribeToShardOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SubscribeToShardCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateShardCountCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UpdateShardCountCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UpdateShardCountOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateShardCountCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ExpiredIteratorExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ExpiredIteratorException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ExpiredIteratorException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ExpiredNextTokenExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ExpiredNextTokenException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ExpiredNextTokenException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidArgumentException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSAccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSAccessDeniedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSAccessDeniedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSDisabledExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSDisabledException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSDisabledException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSInvalidStateExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSInvalidStateException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSInvalidStateException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSOptInRequiredResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSOptInRequired(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSOptInRequired",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSThrottlingExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSThrottlingException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSThrottlingException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ProvisionedThroughputExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ProvisionedThroughputExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceInUseExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceInUseException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1AddTagsToStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagMap(input.Tags, context)
    });
};
var serializeAws_json1_1CreateStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardCount !== undefined && input.ShardCount !== null && {
        ShardCount: input.ShardCount
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DecreaseStreamRetentionPeriodInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.RetentionPeriodHours !== undefined && input.RetentionPeriodHours !== null && {
        RetentionPeriodHours: input.RetentionPeriodHours
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DeleteStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.EnforceConsumerDeletion !== undefined && input.EnforceConsumerDeletion !== null && {
        EnforceConsumerDeletion: input.EnforceConsumerDeletion
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DeregisterStreamConsumerInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1DescribeLimitsInput = function(input, context) {
    return {};
};
var serializeAws_json1_1DescribeStreamConsumerInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1DescribeStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartShardId !== undefined && input.ExclusiveStartShardId !== null && {
        ExclusiveStartShardId: input.ExclusiveStartShardId
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DescribeStreamSummaryInput = function(input, context) {
    return (0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DisableEnhancedMonitoringInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardLevelMetrics !== undefined && input.ShardLevelMetrics !== null && {
        ShardLevelMetrics: serializeAws_json1_1MetricsNameList(input.ShardLevelMetrics, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1EnableEnhancedMonitoringInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardLevelMetrics !== undefined && input.ShardLevelMetrics !== null && {
        ShardLevelMetrics: serializeAws_json1_1MetricsNameList(input.ShardLevelMetrics, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1GetRecordsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.ShardIterator !== undefined && input.ShardIterator !== null && {
        ShardIterator: input.ShardIterator
    });
};
var serializeAws_json1_1GetShardIteratorInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.ShardIteratorType !== undefined && input.ShardIteratorType !== null && {
        ShardIteratorType: input.ShardIteratorType
    }), input.StartingSequenceNumber !== undefined && input.StartingSequenceNumber !== null && {
        StartingSequenceNumber: input.StartingSequenceNumber
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    });
};
var serializeAws_json1_1IncreaseStreamRetentionPeriodInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.RetentionPeriodHours !== undefined && input.RetentionPeriodHours !== null && {
        RetentionPeriodHours: input.RetentionPeriodHours
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1ListShardsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartShardId !== undefined && input.ExclusiveStartShardId !== null && {
        ExclusiveStartShardId: input.ExclusiveStartShardId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    }), input.ShardFilter !== undefined && input.ShardFilter !== null && {
        ShardFilter: serializeAws_json1_1ShardFilter(input.ShardFilter, context)
    }), input.StreamCreationTimestamp !== undefined && input.StreamCreationTimestamp !== null && {
        StreamCreationTimestamp: Math.round(input.StreamCreationTimestamp.getTime() / 1000)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1ListStreamConsumersInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    }), input.StreamCreationTimestamp !== undefined && input.StreamCreationTimestamp !== null && {
        StreamCreationTimestamp: Math.round(input.StreamCreationTimestamp.getTime() / 1000)
    });
};
var serializeAws_json1_1ListStreamsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartStreamName !== undefined && input.ExclusiveStartStreamName !== null && {
        ExclusiveStartStreamName: input.ExclusiveStartStreamName
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1ListTagsForStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartTagKey !== undefined && input.ExclusiveStartTagKey !== null && {
        ExclusiveStartTagKey: input.ExclusiveStartTagKey
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1MergeShardsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AdjacentShardToMerge !== undefined && input.AdjacentShardToMerge !== null && {
        AdjacentShardToMerge: input.AdjacentShardToMerge
    }), input.ShardToMerge !== undefined && input.ShardToMerge !== null && {
        ShardToMerge: input.ShardToMerge
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1MetricsNameList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1PutRecordInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    }), input.ExplicitHashKey !== undefined && input.ExplicitHashKey !== null && {
        ExplicitHashKey: input.ExplicitHashKey
    }), input.PartitionKey !== undefined && input.PartitionKey !== null && {
        PartitionKey: input.PartitionKey
    }), input.SequenceNumberForOrdering !== undefined && input.SequenceNumberForOrdering !== null && {
        SequenceNumberForOrdering: input.SequenceNumberForOrdering
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1PutRecordsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Records !== undefined && input.Records !== null && {
        Records: serializeAws_json1_1PutRecordsRequestEntryList(input.Records, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1PutRecordsRequestEntry = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    }), input.ExplicitHashKey !== undefined && input.ExplicitHashKey !== null && {
        ExplicitHashKey: input.ExplicitHashKey
    }), input.PartitionKey !== undefined && input.PartitionKey !== null && {
        PartitionKey: input.PartitionKey
    });
};
var serializeAws_json1_1PutRecordsRequestEntryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1PutRecordsRequestEntry(entry, context);
    });
};
var serializeAws_json1_1RegisterStreamConsumerInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1RemoveTagsFromStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: serializeAws_json1_1TagKeyList(input.TagKeys, context)
    });
};
var serializeAws_json1_1ShardFilter = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1SplitShardInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.NewStartingHashKey !== undefined && input.NewStartingHashKey !== null && {
        NewStartingHashKey: input.NewStartingHashKey
    }), input.ShardToSplit !== undefined && input.ShardToSplit !== null && {
        ShardToSplit: input.ShardToSplit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1StartingPosition = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.SequenceNumber !== undefined && input.SequenceNumber !== null && {
        SequenceNumber: input.SequenceNumber
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1StartStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EncryptionType !== undefined && input.EncryptionType !== null && {
        EncryptionType: input.EncryptionType
    }), input.KeyId !== undefined && input.KeyId !== null && {
        KeyId: input.KeyId
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1StopStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EncryptionType !== undefined && input.EncryptionType !== null && {
        EncryptionType: input.EncryptionType
    }), input.KeyId !== undefined && input.KeyId !== null && {
        KeyId: input.KeyId
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1SubscribeToShardInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.StartingPosition !== undefined && input.StartingPosition !== null && {
        StartingPosition: serializeAws_json1_1StartingPosition(input.StartingPosition, context)
    });
};
var serializeAws_json1_1TagKeyList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TagMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1UpdateShardCountInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ScalingType !== undefined && input.ScalingType !== null && {
        ScalingType: input.ScalingType
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.TargetShardCount !== undefined && input.TargetShardCount !== null && {
        TargetShardCount: input.TargetShardCount
    });
};
var deserializeAws_json1_1ChildShard = function(output, context) {
    return {
        HashKeyRange: output.HashKeyRange !== undefined && output.HashKeyRange !== null ? deserializeAws_json1_1HashKeyRange(output.HashKeyRange, context) : undefined,
        ParentShards: output.ParentShards !== undefined && output.ParentShards !== null ? deserializeAws_json1_1ShardIdList(output.ParentShards, context) : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1ChildShardList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ChildShard(entry, context);
    });
};
var deserializeAws_json1_1Consumer = function(output, context) {
    return {
        ConsumerARN: output.ConsumerARN !== undefined && output.ConsumerARN !== null ? output.ConsumerARN : undefined,
        ConsumerCreationTimestamp: output.ConsumerCreationTimestamp !== undefined && output.ConsumerCreationTimestamp !== null ? new Date(Math.round(output.ConsumerCreationTimestamp * 1000)) : undefined,
        ConsumerName: output.ConsumerName !== undefined && output.ConsumerName !== null ? output.ConsumerName : undefined,
        ConsumerStatus: output.ConsumerStatus !== undefined && output.ConsumerStatus !== null ? output.ConsumerStatus : undefined
    };
};
var deserializeAws_json1_1ConsumerDescription = function(output, context) {
    return {
        ConsumerARN: output.ConsumerARN !== undefined && output.ConsumerARN !== null ? output.ConsumerARN : undefined,
        ConsumerCreationTimestamp: output.ConsumerCreationTimestamp !== undefined && output.ConsumerCreationTimestamp !== null ? new Date(Math.round(output.ConsumerCreationTimestamp * 1000)) : undefined,
        ConsumerName: output.ConsumerName !== undefined && output.ConsumerName !== null ? output.ConsumerName : undefined,
        ConsumerStatus: output.ConsumerStatus !== undefined && output.ConsumerStatus !== null ? output.ConsumerStatus : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined
    };
};
var deserializeAws_json1_1ConsumerList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Consumer(entry, context);
    });
};
var deserializeAws_json1_1DescribeLimitsOutput = function(output, context) {
    return {
        OpenShardCount: output.OpenShardCount !== undefined && output.OpenShardCount !== null ? output.OpenShardCount : undefined,
        ShardLimit: output.ShardLimit !== undefined && output.ShardLimit !== null ? output.ShardLimit : undefined
    };
};
var deserializeAws_json1_1DescribeStreamConsumerOutput = function(output, context) {
    return {
        ConsumerDescription: output.ConsumerDescription !== undefined && output.ConsumerDescription !== null ? deserializeAws_json1_1ConsumerDescription(output.ConsumerDescription, context) : undefined
    };
};
var deserializeAws_json1_1DescribeStreamOutput = function(output, context) {
    return {
        StreamDescription: output.StreamDescription !== undefined && output.StreamDescription !== null ? deserializeAws_json1_1StreamDescription(output.StreamDescription, context) : undefined
    };
};
var deserializeAws_json1_1DescribeStreamSummaryOutput = function(output, context) {
    return {
        StreamDescriptionSummary: output.StreamDescriptionSummary !== undefined && output.StreamDescriptionSummary !== null ? deserializeAws_json1_1StreamDescriptionSummary(output.StreamDescriptionSummary, context) : undefined
    };
};
var deserializeAws_json1_1EnhancedMetrics = function(output, context) {
    return {
        ShardLevelMetrics: output.ShardLevelMetrics !== undefined && output.ShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.ShardLevelMetrics, context) : undefined
    };
};
var deserializeAws_json1_1EnhancedMonitoringList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1EnhancedMetrics(entry, context);
    });
};
var deserializeAws_json1_1EnhancedMonitoringOutput = function(output, context) {
    return {
        CurrentShardLevelMetrics: output.CurrentShardLevelMetrics !== undefined && output.CurrentShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.CurrentShardLevelMetrics, context) : undefined,
        DesiredShardLevelMetrics: output.DesiredShardLevelMetrics !== undefined && output.DesiredShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.DesiredShardLevelMetrics, context) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined
    };
};
var deserializeAws_json1_1ExpiredIteratorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ExpiredNextTokenException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1GetRecordsOutput = function(output, context) {
    return {
        ChildShards: output.ChildShards !== undefined && output.ChildShards !== null ? deserializeAws_json1_1ChildShardList(output.ChildShards, context) : undefined,
        MillisBehindLatest: output.MillisBehindLatest !== undefined && output.MillisBehindLatest !== null ? output.MillisBehindLatest : undefined,
        NextShardIterator: output.NextShardIterator !== undefined && output.NextShardIterator !== null ? output.NextShardIterator : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1RecordList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1GetShardIteratorOutput = function(output, context) {
    return {
        ShardIterator: output.ShardIterator !== undefined && output.ShardIterator !== null ? output.ShardIterator : undefined
    };
};
var deserializeAws_json1_1HashKeyRange = function(output, context) {
    return {
        EndingHashKey: output.EndingHashKey !== undefined && output.EndingHashKey !== null ? output.EndingHashKey : undefined,
        StartingHashKey: output.StartingHashKey !== undefined && output.StartingHashKey !== null ? output.StartingHashKey : undefined
    };
};
var deserializeAws_json1_1InternalFailureException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidArgumentException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSAccessDeniedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSDisabledException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSInvalidStateException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSOptInRequired = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSThrottlingException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListShardsOutput = function(output, context) {
    return {
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined,
        Shards: output.Shards !== undefined && output.Shards !== null ? deserializeAws_json1_1ShardList(output.Shards, context) : undefined
    };
};
var deserializeAws_json1_1ListStreamConsumersOutput = function(output, context) {
    return {
        Consumers: output.Consumers !== undefined && output.Consumers !== null ? deserializeAws_json1_1ConsumerList(output.Consumers, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var deserializeAws_json1_1ListStreamsOutput = function(output, context) {
    return {
        HasMoreStreams: output.HasMoreStreams !== undefined && output.HasMoreStreams !== null ? output.HasMoreStreams : undefined,
        StreamNames: output.StreamNames !== undefined && output.StreamNames !== null ? deserializeAws_json1_1StreamNameList(output.StreamNames, context) : undefined
    };
};
var deserializeAws_json1_1ListTagsForStreamOutput = function(output, context) {
    return {
        HasMoreTags: output.HasMoreTags !== undefined && output.HasMoreTags !== null ? output.HasMoreTags : undefined,
        Tags: output.Tags !== undefined && output.Tags !== null ? deserializeAws_json1_1TagList(output.Tags, context) : undefined
    };
};
var deserializeAws_json1_1MetricsNameList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ProvisionedThroughputExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1PutRecordOutput = function(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1PutRecordsOutput = function(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        FailedRecordCount: output.FailedRecordCount !== undefined && output.FailedRecordCount !== null ? output.FailedRecordCount : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1PutRecordsResultEntryList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1PutRecordsResultEntry = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        ErrorMessage: output.ErrorMessage !== undefined && output.ErrorMessage !== null ? output.ErrorMessage : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1PutRecordsResultEntryList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1PutRecordsResultEntry(entry, context);
    });
};
var deserializeAws_json1_1_Record = function(output, context) {
    return {
        ApproximateArrivalTimestamp: output.ApproximateArrivalTimestamp !== undefined && output.ApproximateArrivalTimestamp !== null ? new Date(Math.round(output.ApproximateArrivalTimestamp * 1000)) : undefined,
        Data: output.Data !== undefined && output.Data !== null ? context.base64Decoder(output.Data) : undefined,
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        PartitionKey: output.PartitionKey !== undefined && output.PartitionKey !== null ? output.PartitionKey : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined
    };
};
var deserializeAws_json1_1RecordList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1_Record(entry, context);
    });
};
var deserializeAws_json1_1RegisterStreamConsumerOutput = function(output, context) {
    return {
        Consumer: output.Consumer !== undefined && output.Consumer !== null ? deserializeAws_json1_1Consumer(output.Consumer, context) : undefined
    };
};
var deserializeAws_json1_1ResourceInUseException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1SequenceNumberRange = function(output, context) {
    return {
        EndingSequenceNumber: output.EndingSequenceNumber !== undefined && output.EndingSequenceNumber !== null ? output.EndingSequenceNumber : undefined,
        StartingSequenceNumber: output.StartingSequenceNumber !== undefined && output.StartingSequenceNumber !== null ? output.StartingSequenceNumber : undefined
    };
};
var deserializeAws_json1_1Shard = function(output, context) {
    return {
        AdjacentParentShardId: output.AdjacentParentShardId !== undefined && output.AdjacentParentShardId !== null ? output.AdjacentParentShardId : undefined,
        HashKeyRange: output.HashKeyRange !== undefined && output.HashKeyRange !== null ? deserializeAws_json1_1HashKeyRange(output.HashKeyRange, context) : undefined,
        ParentShardId: output.ParentShardId !== undefined && output.ParentShardId !== null ? output.ParentShardId : undefined,
        SequenceNumberRange: output.SequenceNumberRange !== undefined && output.SequenceNumberRange !== null ? deserializeAws_json1_1SequenceNumberRange(output.SequenceNumberRange, context) : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1ShardIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ShardList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Shard(entry, context);
    });
};
var deserializeAws_json1_1StreamDescription = function(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        EnhancedMonitoring: output.EnhancedMonitoring !== undefined && output.EnhancedMonitoring !== null ? deserializeAws_json1_1EnhancedMonitoringList(output.EnhancedMonitoring, context) : undefined,
        HasMoreShards: output.HasMoreShards !== undefined && output.HasMoreShards !== null ? output.HasMoreShards : undefined,
        KeyId: output.KeyId !== undefined && output.KeyId !== null ? output.KeyId : undefined,
        RetentionPeriodHours: output.RetentionPeriodHours !== undefined && output.RetentionPeriodHours !== null ? output.RetentionPeriodHours : undefined,
        Shards: output.Shards !== undefined && output.Shards !== null ? deserializeAws_json1_1ShardList(output.Shards, context) : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined,
        StreamCreationTimestamp: output.StreamCreationTimestamp !== undefined && output.StreamCreationTimestamp !== null ? new Date(Math.round(output.StreamCreationTimestamp * 1000)) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        StreamStatus: output.StreamStatus !== undefined && output.StreamStatus !== null ? output.StreamStatus : undefined
    };
};
var deserializeAws_json1_1StreamDescriptionSummary = function(output, context) {
    return {
        ConsumerCount: output.ConsumerCount !== undefined && output.ConsumerCount !== null ? output.ConsumerCount : undefined,
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        EnhancedMonitoring: output.EnhancedMonitoring !== undefined && output.EnhancedMonitoring !== null ? deserializeAws_json1_1EnhancedMonitoringList(output.EnhancedMonitoring, context) : undefined,
        KeyId: output.KeyId !== undefined && output.KeyId !== null ? output.KeyId : undefined,
        OpenShardCount: output.OpenShardCount !== undefined && output.OpenShardCount !== null ? output.OpenShardCount : undefined,
        RetentionPeriodHours: output.RetentionPeriodHours !== undefined && output.RetentionPeriodHours !== null ? output.RetentionPeriodHours : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined,
        StreamCreationTimestamp: output.StreamCreationTimestamp !== undefined && output.StreamCreationTimestamp !== null ? new Date(Math.round(output.StreamCreationTimestamp * 1000)) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        StreamStatus: output.StreamStatus !== undefined && output.StreamStatus !== null ? output.StreamStatus : undefined
    };
};
var deserializeAws_json1_1StreamNameList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1SubscribeToShardEvent = function(output, context) {
    return {
        ChildShards: output.ChildShards !== undefined && output.ChildShards !== null ? deserializeAws_json1_1ChildShardList(output.ChildShards, context) : undefined,
        ContinuationSequenceNumber: output.ContinuationSequenceNumber !== undefined && output.ContinuationSequenceNumber !== null ? output.ContinuationSequenceNumber : undefined,
        MillisBehindLatest: output.MillisBehindLatest !== undefined && output.MillisBehindLatest !== null ? output.MillisBehindLatest : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1RecordList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1SubscribeToShardEventStream = function(output, context) {
    if (output.InternalFailureException !== undefined && output.InternalFailureException !== null) return {
        InternalFailureException: deserializeAws_json1_1InternalFailureException(output.InternalFailureException, context)
    };
    if (output.KMSAccessDeniedException !== undefined && output.KMSAccessDeniedException !== null) return {
        KMSAccessDeniedException: deserializeAws_json1_1KMSAccessDeniedException(output.KMSAccessDeniedException, context)
    };
    if (output.KMSDisabledException !== undefined && output.KMSDisabledException !== null) return {
        KMSDisabledException: deserializeAws_json1_1KMSDisabledException(output.KMSDisabledException, context)
    };
    if (output.KMSInvalidStateException !== undefined && output.KMSInvalidStateException !== null) return {
        KMSInvalidStateException: deserializeAws_json1_1KMSInvalidStateException(output.KMSInvalidStateException, context)
    };
    if (output.KMSNotFoundException !== undefined && output.KMSNotFoundException !== null) return {
        KMSNotFoundException: deserializeAws_json1_1KMSNotFoundException(output.KMSNotFoundException, context)
    };
    if (output.KMSOptInRequired !== undefined && output.KMSOptInRequired !== null) return {
        KMSOptInRequired: deserializeAws_json1_1KMSOptInRequired(output.KMSOptInRequired, context)
    };
    if (output.KMSThrottlingException !== undefined && output.KMSThrottlingException !== null) return {
        KMSThrottlingException: deserializeAws_json1_1KMSThrottlingException(output.KMSThrottlingException, context)
    };
    if (output.ResourceInUseException !== undefined && output.ResourceInUseException !== null) return {
        ResourceInUseException: deserializeAws_json1_1ResourceInUseException(output.ResourceInUseException, context)
    };
    if (output.ResourceNotFoundException !== undefined && output.ResourceNotFoundException !== null) return {
        ResourceNotFoundException: deserializeAws_json1_1ResourceNotFoundException(output.ResourceNotFoundException, context)
    };
    if (output.SubscribeToShardEvent !== undefined && output.SubscribeToShardEvent !== null) return {
        SubscribeToShardEvent: deserializeAws_json1_1SubscribeToShardEvent(output.SubscribeToShardEvent, context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var deserializeAws_json1_1SubscribeToShardOutput = function(output, context) {
    return {
        EventStream: output.EventStream !== undefined && output.EventStream !== null ? deserializeAws_json1_1SubscribeToShardEventStream(output.EventStream, context) : undefined
    };
};
var deserializeAws_json1_1Tag = function(output, context) {
    return {
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var deserializeAws_json1_1TagList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Tag(entry, context);
    });
};
var deserializeAws_json1_1UpdateShardCountOutput = function(output, context) {
    return {
        CurrentShardCount: output.CurrentShardCount !== undefined && output.CurrentShardCount !== null ? output.CurrentShardCount : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        TargetShardCount: output.TargetShardCount !== undefined && output.TargetShardCount !== null ? output.TargetShardCount : undefined
    };
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"hXPA8","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"87Cy2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"dZjdF","./whatwgEncodingApi":"h2V0K","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dZjdF":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h2V0K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7QCma":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>AWSKinesisFirehoseProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _awskinesisProvider = require("./AWSKinesisProvider");
var _clientFirehose = require("@aws-sdk/client-firehose");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("AWSKineisFirehoseProvider");
var AWSKinesisFirehoseProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSKinesisFirehoseProvider, _super);
    function AWSKinesisFirehoseProvider(config) {
        return _super.call(this, config) || this;
    }
    /**
     * get provider name of the plugin
     */ AWSKinesisFirehoseProvider.prototype.getProviderName = function() {
        return "AWSKinesisFirehose";
    };
    AWSKinesisFirehoseProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // split by streamName
            var evt = params.event;
            var streamName = evt.streamName, data = evt.data;
            if (records[streamName] === undefined) records[streamName] = [];
            var bufferData = data && typeof data !== "string" ? JSON.stringify(data) : data;
            var Data = (0, _utilUtf8Browser.fromUtf8)(bufferData);
            var record = {
                Data: Data
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            logger.debug("putting records to kinesis", streamName, "with records", records[streamName]);
            _this._kinesisFirehose.send(new (0, _clientFirehose.PutRecordBatchCommand)({
                Records: records[streamName],
                DeliveryStreamName: streamName
            })).then(function(res) {
                return logger.debug("Upload records to stream", streamName);
            }).catch(function(err) {
                return logger.debug("Failed to upload records to Kinesis", err);
            });
        });
    };
    AWSKinesisFirehoseProvider.prototype._init = function(config, credentials) {
        logger.debug("init clients");
        if (this._kinesisFirehose && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        return this._initFirehose(region, credentials);
    };
    AWSKinesisFirehoseProvider.prototype._initFirehose = function(region, credentials) {
        logger.debug("initialize kinesis firehose with credentials", credentials);
        this._kinesisFirehose = new (0, _clientFirehose.FirehoseClient)({
            apiVersion: "2015-08-04",
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record)
        });
        return true;
    };
    return AWSKinesisFirehoseProvider;
}((0, _awskinesisProvider.AWSKinesisProvider));

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./AWSKinesisProvider":"ax2zg","@aws-sdk/client-firehose":"zitDR","@aws-sdk/util-utf8-browser":"87Cy2","../utils/UserAgent":"PNdyN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"zitDR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _firehoseClient = require("./FirehoseClient");
parcelHelpers.exportAll(_firehoseClient, exports);
var _firehose = require("./Firehose");
parcelHelpers.exportAll(_firehose, exports);
var _createDeliveryStreamCommand = require("./commands/CreateDeliveryStreamCommand");
parcelHelpers.exportAll(_createDeliveryStreamCommand, exports);
var _deleteDeliveryStreamCommand = require("./commands/DeleteDeliveryStreamCommand");
parcelHelpers.exportAll(_deleteDeliveryStreamCommand, exports);
var _describeDeliveryStreamCommand = require("./commands/DescribeDeliveryStreamCommand");
parcelHelpers.exportAll(_describeDeliveryStreamCommand, exports);
var _listDeliveryStreamsCommand = require("./commands/ListDeliveryStreamsCommand");
parcelHelpers.exportAll(_listDeliveryStreamsCommand, exports);
var _listTagsForDeliveryStreamCommand = require("./commands/ListTagsForDeliveryStreamCommand");
parcelHelpers.exportAll(_listTagsForDeliveryStreamCommand, exports);
var _putRecordCommand = require("./commands/PutRecordCommand");
parcelHelpers.exportAll(_putRecordCommand, exports);
var _putRecordBatchCommand = require("./commands/PutRecordBatchCommand");
parcelHelpers.exportAll(_putRecordBatchCommand, exports);
var _startDeliveryStreamEncryptionCommand = require("./commands/StartDeliveryStreamEncryptionCommand");
parcelHelpers.exportAll(_startDeliveryStreamEncryptionCommand, exports);
var _stopDeliveryStreamEncryptionCommand = require("./commands/StopDeliveryStreamEncryptionCommand");
parcelHelpers.exportAll(_stopDeliveryStreamEncryptionCommand, exports);
var _tagDeliveryStreamCommand = require("./commands/TagDeliveryStreamCommand");
parcelHelpers.exportAll(_tagDeliveryStreamCommand, exports);
var _untagDeliveryStreamCommand = require("./commands/UntagDeliveryStreamCommand");
parcelHelpers.exportAll(_untagDeliveryStreamCommand, exports);
var _updateDestinationCommand = require("./commands/UpdateDestinationCommand");
parcelHelpers.exportAll(_updateDestinationCommand, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./FirehoseClient":"lFC7Z","./Firehose":false,"./commands/CreateDeliveryStreamCommand":false,"./commands/DeleteDeliveryStreamCommand":false,"./commands/DescribeDeliveryStreamCommand":false,"./commands/ListDeliveryStreamsCommand":false,"./commands/ListTagsForDeliveryStreamCommand":false,"./commands/PutRecordCommand":false,"./commands/PutRecordBatchCommand":"g29V4","./commands/StartDeliveryStreamEncryptionCommand":false,"./commands/StopDeliveryStreamEncryptionCommand":false,"./commands/TagDeliveryStreamCommand":false,"./commands/UntagDeliveryStreamCommand":false,"./commands/UpdateDestinationCommand":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lFC7Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FirehoseClient", ()=>FirehoseClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <fullname>Amazon Kinesis Data Firehose API Reference</fullname>
 *          <p>Amazon Kinesis Data Firehose is a fully managed service that delivers real-time
 *          streaming data to destinations such as Amazon Simple Storage Service (Amazon S3), Amazon
 *          Elasticsearch Service (Amazon ES), Amazon Redshift, and Splunk.</p>
 */ var FirehoseClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(FirehoseClient, _super);
    function FirehoseClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    FirehoseClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return FirehoseClient;
}((0, _smithyClient.Client));

},{"tslib":"hIjnq","./runtimeConfig":"gfl2p","@aws-sdk/config-resolver":"jqbdY","@aws-sdk/middleware-content-length":"bExw4","@aws-sdk/middleware-host-header":"jNt1p","@aws-sdk/middleware-logger":"JsUxj","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/middleware-signing":"9ClYY","@aws-sdk/middleware-user-agent":"7SRzn","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hIjnq":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gfl2p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"hIjnq","./package.json":"1XDYZ","@aws-crypto/sha256-browser":"gxrdh","@aws-sdk/fetch-http-handler":"cl6qU","@aws-sdk/invalid-dependency":"hRSjn","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/util-base64-browser":"gYMH3","@aws-sdk/util-body-length-browser":"11eVP","@aws-sdk/util-user-agent-browser":"9HJ0W","@aws-sdk/util-utf8-browser":"dCYIR","./runtimeConfig.shared":"ivyNM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1XDYZ":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-firehose","description":"AWS SDK for JavaScript Firehose Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-firehose","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-firehose"}}');

},{}],"gxrdh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("9dc62fe694ec464f");
(0, tslib_1.__exportStar)(require("22274831d557bd35"), exports);
var ie11Sha256_1 = require("a70f8fa2eff38fcd");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("611071926684ec8");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"9dc62fe694ec464f":"2XwSk","22274831d557bd35":"lVrKA","a70f8fa2eff38fcd":"aOoGl","611071926684ec8":"9HBLV"}],"2XwSk":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lVrKA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("d0abcbe55d3999e6");
var webCryptoSha256_1 = require("dccd3f0a2ac8c283");
var sha256_js_1 = require("7567bfb4ce114c21");
var supports_web_crypto_1 = require("69370e19a9107810");
var ie11_detection_1 = require("b02261173140b76f");
var util_locate_window_1 = require("b904e489c08b62d4");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"d0abcbe55d3999e6":"aOoGl","dccd3f0a2ac8c283":"9HBLV","7567bfb4ce114c21":"cdEa6","69370e19a9107810":"5weF6","b02261173140b76f":"hKZMg","b904e489c08b62d4":"iQfdF"}],"aOoGl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("5e638acc6c1a78f3");
var constants_1 = require("74cb5433ed3ccc9");
var util_utf8_browser_1 = require("e88e958179152197");
var util_locate_window_1 = require("7bc582f87153c571");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"5e638acc6c1a78f3":"hE4Kf","74cb5433ed3ccc9":"jzRG9","e88e958179152197":"dCYIR","7bc582f87153c571":"iQfdF"}],"hE4Kf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"jzRG9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"dCYIR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"d6iCa","./whatwgEncodingApi":"i8XDF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d6iCa":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i8XDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9HBLV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("90dc6ff7743e8db7");
var constants_1 = require("adb562898b46e5f5");
var util_locate_window_1 = require("ceefe979a4df968d");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"90dc6ff7743e8db7":"6uihl","adb562898b46e5f5":"jzRG9","ceefe979a4df968d":"iQfdF"}],"6uihl":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("74d1ff7bed51858d");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("360bd713b19ded73");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("a7221c77668b7969");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("57cd5a0604430220");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"74d1ff7bed51858d":"gKJDJ","360bd713b19ded73":"8oSFa","a7221c77668b7969":"kv7DL","57cd5a0604430220":"efnFq"}],"gKJDJ":[function(require,module,exports) {
var Buffer = require("b6287b5b9f7956d9").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("4f4eac72702135c8");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"b6287b5b9f7956d9":"8EcTH","4f4eac72702135c8":"dCYIR"}],"8oSFa":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"kv7DL":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"efnFq":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"cdEa6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("5c98e50eba6342ef");
(0, tslib_1.__exportStar)(require("99b9f423ac129b21"), exports);

},{"5c98e50eba6342ef":"jOwYi","99b9f423ac129b21":"ikGfx"}],"jOwYi":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ikGfx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("7a6cdd3cf36b7e91");
var constants_1 = require("27b70037c3900a45");
var RawSha256_1 = require("409e2e230b844dfb");
var util_1 = require("1ef9429f76b78780");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"7a6cdd3cf36b7e91":"jOwYi","27b70037c3900a45":"3pY81","409e2e230b844dfb":"6hc1G","1ef9429f76b78780":"6uihl"}],"3pY81":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"6hc1G":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("f2302dcf7499d963");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"f2302dcf7499d963":"3pY81"}],"5weF6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("823bb8cc7c5970dd");
tslib_1.__exportStar(require("2da4ea42d983e67"), exports);

},{"823bb8cc7c5970dd":"3i08e","2da4ea42d983e67":"9Vebx"}],"3i08e":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Vebx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("d896c564e8a7270a");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"d896c564e8a7270a":"3i08e"}],"hKZMg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("9bdb9b1620c497ff");
tslib_1.__exportStar(require("9bcd4268d59e64b3"), exports);
tslib_1.__exportStar(require("f04e66555d42aacf"), exports);
tslib_1.__exportStar(require("e8ca43954ae04913"), exports);
tslib_1.__exportStar(require("704488855c811b0b"), exports);
tslib_1.__exportStar(require("3453e9987bcec94c"), exports);

},{"9bdb9b1620c497ff":"dJP6J","9bcd4268d59e64b3":"kyMLb","f04e66555d42aacf":"hCf5M","e8ca43954ae04913":"8hMzF","704488855c811b0b":"kwELM","3453e9987bcec94c":"fg95y"}],"dJP6J":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kyMLb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"hCf5M":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"8hMzF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"kwELM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"fg95y":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"9HJ0W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"1ZpjB","bowser":"oLvzi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1ZpjB":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ivyNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2015-08-04",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Firehose",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"ddMRI","@aws-sdk/url-parser":"gQeEv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ddMRI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "firehose.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "firehose.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "firehose.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "firehose.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "firehose.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "firehose.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "firehose.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "firehose.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "firehose.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "firehose.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "firehose.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "firehose.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "firehose.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "firehose.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "firehose.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "firehose.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "firehose.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "firehose.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "firehose.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "firehose.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "firehose.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "firehose-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "firehose-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-gov-east-1":
            regionInfo = {
                hostname: "firehose-fips.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "firehose-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "firehose-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "firehose-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "firehose.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "firehose.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "firehose.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "firehose.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "firehose.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "firehose.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "firehose.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "firehose.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "firehose"
    }, regionInfo));
};

},{"tslib":"hIjnq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jNt1p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"k3o3P","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k3o3P":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"JsUxj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"82bT1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"82bT1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"2Ho2c","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2Ho2c":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7SRzn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"cllW9","./user-agent-middleware":"hYf64","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cllW9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"3ATjt","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3ATjt":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hYf64":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, _constants.X_AMZ_USER_AGENT] = (0, _tslib.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, _constants.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, _constants.USER_AGENT] = headers[0, _constants.USER_AGENT] ? headers[0, _constants.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"3ATjt","@aws-sdk/protocol-http":"8mE6Q","./constants":"eFTbA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eFTbA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g29V4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutRecordBatchCommand", ()=>PutRecordBatchCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Writes multiple data records into a delivery stream in a single call, which can
 *          achieve higher throughput per producer than when writing single records. To write single
 *          data records into a delivery stream, use <a>PutRecord</a>. Applications using
 *          these operations are referred to as producers.</p>
 *          <p>For information about service quota, see <a href="https://docs.aws.amazon.com/firehose/latest/dev/limits.html">Amazon Kinesis Data Firehose
 *          Quota</a>.</p>
 *          <p>Each <a>PutRecordBatch</a> request supports up to 500 records. Each record
 *          in the request can be as large as 1,000 KB (before 64-bit encoding), up to a limit of 4 MB
 *          for the entire request. These limits cannot be changed.</p>
 *          <p>You must specify the name of the delivery stream and the data record when using <a>PutRecord</a>. The data record consists of a data blob that can be up to 1,000
 *          KB in size, and any kind of data. For example, it could be a segment from a log file,
 *          geographic location data, website clickstream data, and so on.</p>
 *          <p>Kinesis Data Firehose buffers records before delivering them to the destination. To
 *          disambiguate the data blobs at the destination, a common solution is to use delimiters in
 *          the data, such as a newline (<code>\n</code>) or some other character unique within the
 *          data. This allows the consumer application to parse individual data items when reading the
 *          data from the destination.</p>
 *          <p>The <a>PutRecordBatch</a> response includes a count of failed records,
 *             <code>FailedPutCount</code>, and an array of responses, <code>RequestResponses</code>.
 *          Even if the <a>PutRecordBatch</a> call succeeds, the value of
 *             <code>FailedPutCount</code> may be greater than 0, indicating that there are records for
 *          which the operation didn't succeed. Each entry in the <code>RequestResponses</code> array
 *          provides additional information about the processed record. It directly correlates with a
 *          record in the request array using the same ordering, from the top to the bottom. The
 *          response array always includes the same number of records as the request array.
 *             <code>RequestResponses</code> includes both successfully and unsuccessfully processed
 *          records. Kinesis Data Firehose tries to process all records in each <a>PutRecordBatch</a> request. A single record failure does not stop the processing
 *          of subsequent records. </p>
 *          <p>A successfully processed record includes a <code>RecordId</code> value, which is
 *          unique for the record. An unsuccessfully processed record includes <code>ErrorCode</code>
 *          and <code>ErrorMessage</code> values. <code>ErrorCode</code> reflects the type of error,
 *          and is one of the following values: <code>ServiceUnavailableException</code> or
 *             <code>InternalFailure</code>. <code>ErrorMessage</code> provides more detailed
 *          information about the error.</p>
 *          <p>If there is an internal server error or a timeout, the write might have completed or
 *          it might have failed. If <code>FailedPutCount</code> is greater than 0, retry the request,
 *          resending only those records that might have failed processing. This minimizes the possible
 *          duplicate records and also reduces the total bytes sent (and corresponding charges). We
 *          recommend that you handle any duplicates at the destination.</p>
 *          <p>If <a>PutRecordBatch</a> throws <code>ServiceUnavailableException</code>,
 *          back off and retry. If the exception persists, it is possible that the throughput limits
 *          have been exceeded for the delivery stream.</p>
 *
 *          <p>Data records sent to Kinesis Data Firehose are stored for 24 hours from the time they
 *          are added to a delivery stream as it attempts to send the records to the destination. If
 *          the destination is unreachable for more than 24 hours, the data is no longer
 *          available.</p>
 *          <important>
 *             <p>Don't concatenate two or more base64 strings to form the data fields of your records.
 *             Instead, concatenate the raw data, then perform base64 encoding.</p>
 *          </important>
 */ var PutRecordBatchCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutRecordBatchCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordBatchCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutRecordBatchCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "PutRecordBatchCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutRecordBatchInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutRecordBatchOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordBatchCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutRecordBatchCommand)(input, context);
    };
    PutRecordBatchCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutRecordBatchCommand)(output, context);
    };
    return PutRecordBatchCommand;
}((0, _smithyClient.Command));

},{"tslib":"hIjnq","../models/models_0":"78Edj","../protocols/Aws_json1_1":"L7RFs","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"78Edj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferingHints", ()=>BufferingHints);
parcelHelpers.export(exports, "CloudWatchLoggingOptions", ()=>CloudWatchLoggingOptions);
parcelHelpers.export(exports, "CompressionFormat", ()=>CompressionFormat);
parcelHelpers.export(exports, "ConcurrentModificationException", ()=>ConcurrentModificationException);
parcelHelpers.export(exports, "ContentEncoding", ()=>ContentEncoding);
parcelHelpers.export(exports, "CopyCommand", ()=>CopyCommand);
parcelHelpers.export(exports, "KeyType", ()=>KeyType);
parcelHelpers.export(exports, "DeliveryStreamEncryptionConfigurationInput", ()=>DeliveryStreamEncryptionConfigurationInput);
parcelHelpers.export(exports, "ElasticsearchBufferingHints", ()=>ElasticsearchBufferingHints);
parcelHelpers.export(exports, "ProcessorParameterName", ()=>ProcessorParameterName);
parcelHelpers.export(exports, "ProcessorParameter", ()=>ProcessorParameter);
parcelHelpers.export(exports, "Processor", ()=>Processor);
parcelHelpers.export(exports, "ProcessingConfiguration", ()=>ProcessingConfiguration);
parcelHelpers.export(exports, "ElasticsearchRetryOptions", ()=>ElasticsearchRetryOptions);
parcelHelpers.export(exports, "KMSEncryptionConfig", ()=>KMSEncryptionConfig);
parcelHelpers.export(exports, "EncryptionConfiguration", ()=>EncryptionConfiguration);
parcelHelpers.export(exports, "S3DestinationConfiguration", ()=>S3DestinationConfiguration);
parcelHelpers.export(exports, "VpcConfiguration", ()=>VpcConfiguration);
parcelHelpers.export(exports, "ElasticsearchDestinationConfiguration", ()=>ElasticsearchDestinationConfiguration);
parcelHelpers.export(exports, "HiveJsonSerDe", ()=>HiveJsonSerDe);
parcelHelpers.export(exports, "OpenXJsonSerDe", ()=>OpenXJsonSerDe);
parcelHelpers.export(exports, "Deserializer", ()=>Deserializer);
parcelHelpers.export(exports, "InputFormatConfiguration", ()=>InputFormatConfiguration);
parcelHelpers.export(exports, "OrcCompression", ()=>OrcCompression);
parcelHelpers.export(exports, "OrcFormatVersion", ()=>OrcFormatVersion);
parcelHelpers.export(exports, "OrcSerDe", ()=>OrcSerDe);
parcelHelpers.export(exports, "ParquetCompression", ()=>ParquetCompression);
parcelHelpers.export(exports, "ParquetWriterVersion", ()=>ParquetWriterVersion);
parcelHelpers.export(exports, "ParquetSerDe", ()=>ParquetSerDe);
parcelHelpers.export(exports, "Serializer", ()=>Serializer);
parcelHelpers.export(exports, "OutputFormatConfiguration", ()=>OutputFormatConfiguration);
parcelHelpers.export(exports, "SchemaConfiguration", ()=>SchemaConfiguration);
parcelHelpers.export(exports, "DataFormatConversionConfiguration", ()=>DataFormatConversionConfiguration);
parcelHelpers.export(exports, "ExtendedS3DestinationConfiguration", ()=>ExtendedS3DestinationConfiguration);
parcelHelpers.export(exports, "HttpEndpointBufferingHints", ()=>HttpEndpointBufferingHints);
parcelHelpers.export(exports, "HttpEndpointConfiguration", ()=>HttpEndpointConfiguration);
parcelHelpers.export(exports, "HttpEndpointCommonAttribute", ()=>HttpEndpointCommonAttribute);
parcelHelpers.export(exports, "HttpEndpointRequestConfiguration", ()=>HttpEndpointRequestConfiguration);
parcelHelpers.export(exports, "HttpEndpointRetryOptions", ()=>HttpEndpointRetryOptions);
parcelHelpers.export(exports, "HttpEndpointDestinationConfiguration", ()=>HttpEndpointDestinationConfiguration);
parcelHelpers.export(exports, "KinesisStreamSourceConfiguration", ()=>KinesisStreamSourceConfiguration);
parcelHelpers.export(exports, "RedshiftRetryOptions", ()=>RedshiftRetryOptions);
parcelHelpers.export(exports, "RedshiftDestinationConfiguration", ()=>RedshiftDestinationConfiguration);
parcelHelpers.export(exports, "SplunkRetryOptions", ()=>SplunkRetryOptions);
parcelHelpers.export(exports, "SplunkDestinationConfiguration", ()=>SplunkDestinationConfiguration);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "CreateDeliveryStreamInput", ()=>CreateDeliveryStreamInput);
parcelHelpers.export(exports, "CreateDeliveryStreamOutput", ()=>CreateDeliveryStreamOutput);
parcelHelpers.export(exports, "InvalidArgumentException", ()=>InvalidArgumentException);
parcelHelpers.export(exports, "InvalidKMSResourceException", ()=>InvalidKMSResourceException);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "ResourceInUseException", ()=>ResourceInUseException);
parcelHelpers.export(exports, "DeleteDeliveryStreamInput", ()=>DeleteDeliveryStreamInput);
parcelHelpers.export(exports, "DeleteDeliveryStreamOutput", ()=>DeleteDeliveryStreamOutput);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "DeliveryStreamFailureType", ()=>DeliveryStreamFailureType);
parcelHelpers.export(exports, "FailureDescription", ()=>FailureDescription);
parcelHelpers.export(exports, "DeliveryStreamEncryptionStatus", ()=>DeliveryStreamEncryptionStatus);
parcelHelpers.export(exports, "DeliveryStreamEncryptionConfiguration", ()=>DeliveryStreamEncryptionConfiguration);
parcelHelpers.export(exports, "DeliveryStreamStatus", ()=>DeliveryStreamStatus);
parcelHelpers.export(exports, "S3DestinationDescription", ()=>S3DestinationDescription);
parcelHelpers.export(exports, "VpcConfigurationDescription", ()=>VpcConfigurationDescription);
parcelHelpers.export(exports, "ElasticsearchDestinationDescription", ()=>ElasticsearchDestinationDescription);
parcelHelpers.export(exports, "ExtendedS3DestinationDescription", ()=>ExtendedS3DestinationDescription);
parcelHelpers.export(exports, "HttpEndpointDescription", ()=>HttpEndpointDescription);
parcelHelpers.export(exports, "HttpEndpointDestinationDescription", ()=>HttpEndpointDestinationDescription);
parcelHelpers.export(exports, "RedshiftDestinationDescription", ()=>RedshiftDestinationDescription);
parcelHelpers.export(exports, "SplunkDestinationDescription", ()=>SplunkDestinationDescription);
parcelHelpers.export(exports, "DestinationDescription", ()=>DestinationDescription);
parcelHelpers.export(exports, "KinesisStreamSourceDescription", ()=>KinesisStreamSourceDescription);
parcelHelpers.export(exports, "SourceDescription", ()=>SourceDescription);
parcelHelpers.export(exports, "DeliveryStreamDescription", ()=>DeliveryStreamDescription);
parcelHelpers.export(exports, "DescribeDeliveryStreamInput", ()=>DescribeDeliveryStreamInput);
parcelHelpers.export(exports, "DescribeDeliveryStreamOutput", ()=>DescribeDeliveryStreamOutput);
parcelHelpers.export(exports, "S3DestinationUpdate", ()=>S3DestinationUpdate);
parcelHelpers.export(exports, "ElasticsearchDestinationUpdate", ()=>ElasticsearchDestinationUpdate);
parcelHelpers.export(exports, "ExtendedS3DestinationUpdate", ()=>ExtendedS3DestinationUpdate);
parcelHelpers.export(exports, "ListDeliveryStreamsInput", ()=>ListDeliveryStreamsInput);
parcelHelpers.export(exports, "ListDeliveryStreamsOutput", ()=>ListDeliveryStreamsOutput);
parcelHelpers.export(exports, "ListTagsForDeliveryStreamInput", ()=>ListTagsForDeliveryStreamInput);
parcelHelpers.export(exports, "ListTagsForDeliveryStreamOutput", ()=>ListTagsForDeliveryStreamOutput);
parcelHelpers.export(exports, "_Record", ()=>_Record);
parcelHelpers.export(exports, "PutRecordInput", ()=>PutRecordInput);
parcelHelpers.export(exports, "PutRecordOutput", ()=>PutRecordOutput);
parcelHelpers.export(exports, "ServiceUnavailableException", ()=>ServiceUnavailableException);
parcelHelpers.export(exports, "PutRecordBatchInput", ()=>PutRecordBatchInput);
parcelHelpers.export(exports, "PutRecordBatchResponseEntry", ()=>PutRecordBatchResponseEntry);
parcelHelpers.export(exports, "PutRecordBatchOutput", ()=>PutRecordBatchOutput);
parcelHelpers.export(exports, "StartDeliveryStreamEncryptionInput", ()=>StartDeliveryStreamEncryptionInput);
parcelHelpers.export(exports, "StartDeliveryStreamEncryptionOutput", ()=>StartDeliveryStreamEncryptionOutput);
parcelHelpers.export(exports, "StopDeliveryStreamEncryptionInput", ()=>StopDeliveryStreamEncryptionInput);
parcelHelpers.export(exports, "StopDeliveryStreamEncryptionOutput", ()=>StopDeliveryStreamEncryptionOutput);
parcelHelpers.export(exports, "TagDeliveryStreamInput", ()=>TagDeliveryStreamInput);
parcelHelpers.export(exports, "TagDeliveryStreamOutput", ()=>TagDeliveryStreamOutput);
parcelHelpers.export(exports, "UntagDeliveryStreamInput", ()=>UntagDeliveryStreamInput);
parcelHelpers.export(exports, "UntagDeliveryStreamOutput", ()=>UntagDeliveryStreamOutput);
parcelHelpers.export(exports, "HttpEndpointDestinationUpdate", ()=>HttpEndpointDestinationUpdate);
parcelHelpers.export(exports, "RedshiftDestinationUpdate", ()=>RedshiftDestinationUpdate);
parcelHelpers.export(exports, "SplunkDestinationUpdate", ()=>SplunkDestinationUpdate);
parcelHelpers.export(exports, "UpdateDestinationInput", ()=>UpdateDestinationInput);
parcelHelpers.export(exports, "UpdateDestinationOutput", ()=>UpdateDestinationOutput);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var BufferingHints;
(function(BufferingHints) {
    BufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(BufferingHints || (BufferingHints = {}));
var CloudWatchLoggingOptions;
(function(CloudWatchLoggingOptions) {
    CloudWatchLoggingOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CloudWatchLoggingOptions || (CloudWatchLoggingOptions = {}));
var CompressionFormat;
(function(CompressionFormat) {
    CompressionFormat["GZIP"] = "GZIP";
    CompressionFormat["HADOOP_SNAPPY"] = "HADOOP_SNAPPY";
    CompressionFormat["SNAPPY"] = "Snappy";
    CompressionFormat["UNCOMPRESSED"] = "UNCOMPRESSED";
    CompressionFormat["ZIP"] = "ZIP";
})(CompressionFormat || (CompressionFormat = {}));
var ConcurrentModificationException;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
var ContentEncoding;
(function(ContentEncoding) {
    ContentEncoding["GZIP"] = "GZIP";
    ContentEncoding["NONE"] = "NONE";
})(ContentEncoding || (ContentEncoding = {}));
var CopyCommand;
(function(CopyCommand) {
    CopyCommand.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CopyCommand || (CopyCommand = {}));
var KeyType;
(function(KeyType) {
    KeyType["AWS_OWNED_CMK"] = "AWS_OWNED_CMK";
    KeyType["CUSTOMER_MANAGED_CMK"] = "CUSTOMER_MANAGED_CMK";
})(KeyType || (KeyType = {}));
var DeliveryStreamEncryptionConfigurationInput;
(function(DeliveryStreamEncryptionConfigurationInput) {
    DeliveryStreamEncryptionConfigurationInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeliveryStreamEncryptionConfigurationInput || (DeliveryStreamEncryptionConfigurationInput = {}));
var ElasticsearchBufferingHints;
(function(ElasticsearchBufferingHints) {
    ElasticsearchBufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchBufferingHints || (ElasticsearchBufferingHints = {}));
var ProcessorParameterName;
(function(ProcessorParameterName) {
    ProcessorParameterName["BUFFER_INTERVAL_IN_SECONDS"] = "BufferIntervalInSeconds";
    ProcessorParameterName["BUFFER_SIZE_IN_MB"] = "BufferSizeInMBs";
    ProcessorParameterName["LAMBDA_ARN"] = "LambdaArn";
    ProcessorParameterName["LAMBDA_NUMBER_OF_RETRIES"] = "NumberOfRetries";
    ProcessorParameterName["ROLE_ARN"] = "RoleArn";
})(ProcessorParameterName || (ProcessorParameterName = {}));
var ProcessorParameter;
(function(ProcessorParameter) {
    ProcessorParameter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProcessorParameter || (ProcessorParameter = {}));
var Processor;
(function(Processor) {
    Processor.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Processor || (Processor = {}));
var ProcessingConfiguration;
(function(ProcessingConfiguration) {
    ProcessingConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProcessingConfiguration || (ProcessingConfiguration = {}));
var ElasticsearchRetryOptions;
(function(ElasticsearchRetryOptions) {
    ElasticsearchRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchRetryOptions || (ElasticsearchRetryOptions = {}));
var KMSEncryptionConfig;
(function(KMSEncryptionConfig) {
    KMSEncryptionConfig.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSEncryptionConfig || (KMSEncryptionConfig = {}));
var EncryptionConfiguration;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EncryptionConfiguration || (EncryptionConfiguration = {}));
var S3DestinationConfiguration;
(function(S3DestinationConfiguration) {
    S3DestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationConfiguration || (S3DestinationConfiguration = {}));
var VpcConfiguration;
(function(VpcConfiguration) {
    VpcConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(VpcConfiguration || (VpcConfiguration = {}));
var ElasticsearchDestinationConfiguration;
(function(ElasticsearchDestinationConfiguration) {
    ElasticsearchDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationConfiguration || (ElasticsearchDestinationConfiguration = {}));
var HiveJsonSerDe;
(function(HiveJsonSerDe) {
    HiveJsonSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HiveJsonSerDe || (HiveJsonSerDe = {}));
var OpenXJsonSerDe;
(function(OpenXJsonSerDe) {
    OpenXJsonSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OpenXJsonSerDe || (OpenXJsonSerDe = {}));
var Deserializer;
(function(Deserializer) {
    Deserializer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Deserializer || (Deserializer = {}));
var InputFormatConfiguration;
(function(InputFormatConfiguration) {
    InputFormatConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InputFormatConfiguration || (InputFormatConfiguration = {}));
var OrcCompression;
(function(OrcCompression) {
    OrcCompression["NONE"] = "NONE";
    OrcCompression["SNAPPY"] = "SNAPPY";
    OrcCompression["ZLIB"] = "ZLIB";
})(OrcCompression || (OrcCompression = {}));
var OrcFormatVersion;
(function(OrcFormatVersion) {
    OrcFormatVersion["V0_11"] = "V0_11";
    OrcFormatVersion["V0_12"] = "V0_12";
})(OrcFormatVersion || (OrcFormatVersion = {}));
var OrcSerDe;
(function(OrcSerDe) {
    OrcSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OrcSerDe || (OrcSerDe = {}));
var ParquetCompression;
(function(ParquetCompression) {
    ParquetCompression["GZIP"] = "GZIP";
    ParquetCompression["SNAPPY"] = "SNAPPY";
    ParquetCompression["UNCOMPRESSED"] = "UNCOMPRESSED";
})(ParquetCompression || (ParquetCompression = {}));
var ParquetWriterVersion;
(function(ParquetWriterVersion) {
    ParquetWriterVersion["V1"] = "V1";
    ParquetWriterVersion["V2"] = "V2";
})(ParquetWriterVersion || (ParquetWriterVersion = {}));
var ParquetSerDe;
(function(ParquetSerDe) {
    ParquetSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ParquetSerDe || (ParquetSerDe = {}));
var Serializer;
(function(Serializer) {
    Serializer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Serializer || (Serializer = {}));
var OutputFormatConfiguration;
(function(OutputFormatConfiguration) {
    OutputFormatConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OutputFormatConfiguration || (OutputFormatConfiguration = {}));
var SchemaConfiguration;
(function(SchemaConfiguration) {
    SchemaConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SchemaConfiguration || (SchemaConfiguration = {}));
var DataFormatConversionConfiguration;
(function(DataFormatConversionConfiguration) {
    DataFormatConversionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DataFormatConversionConfiguration || (DataFormatConversionConfiguration = {}));
var ExtendedS3DestinationConfiguration;
(function(ExtendedS3DestinationConfiguration) {
    ExtendedS3DestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationConfiguration || (ExtendedS3DestinationConfiguration = {}));
var HttpEndpointBufferingHints;
(function(HttpEndpointBufferingHints) {
    HttpEndpointBufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HttpEndpointBufferingHints || (HttpEndpointBufferingHints = {}));
var HttpEndpointConfiguration;
(function(HttpEndpointConfiguration) {
    HttpEndpointConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Url && {
            Url: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.AccessKey && {
            AccessKey: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointConfiguration || (HttpEndpointConfiguration = {}));
var HttpEndpointCommonAttribute;
(function(HttpEndpointCommonAttribute) {
    HttpEndpointCommonAttribute.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.AttributeName && {
            AttributeName: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.AttributeValue && {
            AttributeValue: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointCommonAttribute || (HttpEndpointCommonAttribute = {}));
var HttpEndpointRequestConfiguration;
(function(HttpEndpointRequestConfiguration) {
    HttpEndpointRequestConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.CommonAttributes && {
            CommonAttributes: obj.CommonAttributes.map(function(item) {
                return HttpEndpointCommonAttribute.filterSensitiveLog(item);
            })
        });
    };
})(HttpEndpointRequestConfiguration || (HttpEndpointRequestConfiguration = {}));
var HttpEndpointRetryOptions;
(function(HttpEndpointRetryOptions) {
    HttpEndpointRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HttpEndpointRetryOptions || (HttpEndpointRetryOptions = {}));
var HttpEndpointDestinationConfiguration;
(function(HttpEndpointDestinationConfiguration) {
    HttpEndpointDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationConfiguration || (HttpEndpointDestinationConfiguration = {}));
var KinesisStreamSourceConfiguration;
(function(KinesisStreamSourceConfiguration) {
    KinesisStreamSourceConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KinesisStreamSourceConfiguration || (KinesisStreamSourceConfiguration = {}));
var RedshiftRetryOptions;
(function(RedshiftRetryOptions) {
    RedshiftRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RedshiftRetryOptions || (RedshiftRetryOptions = {}));
var RedshiftDestinationConfiguration;
(function(RedshiftDestinationConfiguration) {
    RedshiftDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.Password && {
            Password: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationConfiguration || (RedshiftDestinationConfiguration = {}));
var SplunkRetryOptions;
(function(SplunkRetryOptions) {
    SplunkRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkRetryOptions || (SplunkRetryOptions = {}));
var SplunkDestinationConfiguration;
(function(SplunkDestinationConfiguration) {
    SplunkDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationConfiguration || (SplunkDestinationConfiguration = {}));
var Tag;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Tag || (Tag = {}));
var CreateDeliveryStreamInput;
(function(CreateDeliveryStreamInput) {
    CreateDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationConfiguration && {
            RedshiftDestinationConfiguration: RedshiftDestinationConfiguration.filterSensitiveLog(obj.RedshiftDestinationConfiguration)
        }), obj.HttpEndpointDestinationConfiguration && {
            HttpEndpointDestinationConfiguration: HttpEndpointDestinationConfiguration.filterSensitiveLog(obj.HttpEndpointDestinationConfiguration)
        });
    };
})(CreateDeliveryStreamInput || (CreateDeliveryStreamInput = {}));
var CreateDeliveryStreamOutput;
(function(CreateDeliveryStreamOutput) {
    CreateDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateDeliveryStreamOutput || (CreateDeliveryStreamOutput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var InvalidKMSResourceException;
(function(InvalidKMSResourceException) {
    InvalidKMSResourceException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidKMSResourceException || (InvalidKMSResourceException = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceInUseException;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceInUseException || (ResourceInUseException = {}));
var DeleteDeliveryStreamInput;
(function(DeleteDeliveryStreamInput) {
    DeleteDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDeliveryStreamInput || (DeleteDeliveryStreamInput = {}));
var DeleteDeliveryStreamOutput;
(function(DeleteDeliveryStreamOutput) {
    DeleteDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDeliveryStreamOutput || (DeleteDeliveryStreamOutput = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var DeliveryStreamFailureType;
(function(DeliveryStreamFailureType) {
    DeliveryStreamFailureType["CREATE_ENI_FAILED"] = "CREATE_ENI_FAILED";
    DeliveryStreamFailureType["CREATE_KMS_GRANT_FAILED"] = "CREATE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["DELETE_ENI_FAILED"] = "DELETE_ENI_FAILED";
    DeliveryStreamFailureType["DISABLED_KMS_KEY"] = "DISABLED_KMS_KEY";
    DeliveryStreamFailureType["ENI_ACCESS_DENIED"] = "ENI_ACCESS_DENIED";
    DeliveryStreamFailureType["INVALID_KMS_KEY"] = "INVALID_KMS_KEY";
    DeliveryStreamFailureType["KMS_ACCESS_DENIED"] = "KMS_ACCESS_DENIED";
    DeliveryStreamFailureType["KMS_KEY_NOT_FOUND"] = "KMS_KEY_NOT_FOUND";
    DeliveryStreamFailureType["KMS_OPT_IN_REQUIRED"] = "KMS_OPT_IN_REQUIRED";
    DeliveryStreamFailureType["RETIRE_KMS_GRANT_FAILED"] = "RETIRE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["SECURITY_GROUP_ACCESS_DENIED"] = "SECURITY_GROUP_ACCESS_DENIED";
    DeliveryStreamFailureType["SECURITY_GROUP_NOT_FOUND"] = "SECURITY_GROUP_NOT_FOUND";
    DeliveryStreamFailureType["SUBNET_ACCESS_DENIED"] = "SUBNET_ACCESS_DENIED";
    DeliveryStreamFailureType["SUBNET_NOT_FOUND"] = "SUBNET_NOT_FOUND";
    DeliveryStreamFailureType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(DeliveryStreamFailureType || (DeliveryStreamFailureType = {}));
var FailureDescription;
(function(FailureDescription) {
    FailureDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FailureDescription || (FailureDescription = {}));
var DeliveryStreamEncryptionStatus;
(function(DeliveryStreamEncryptionStatus) {
    DeliveryStreamEncryptionStatus["DISABLED"] = "DISABLED";
    DeliveryStreamEncryptionStatus["DISABLING"] = "DISABLING";
    DeliveryStreamEncryptionStatus["DISABLING_FAILED"] = "DISABLING_FAILED";
    DeliveryStreamEncryptionStatus["ENABLED"] = "ENABLED";
    DeliveryStreamEncryptionStatus["ENABLING"] = "ENABLING";
    DeliveryStreamEncryptionStatus["ENABLING_FAILED"] = "ENABLING_FAILED";
})(DeliveryStreamEncryptionStatus || (DeliveryStreamEncryptionStatus = {}));
var DeliveryStreamEncryptionConfiguration;
(function(DeliveryStreamEncryptionConfiguration) {
    DeliveryStreamEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeliveryStreamEncryptionConfiguration || (DeliveryStreamEncryptionConfiguration = {}));
var DeliveryStreamStatus;
(function(DeliveryStreamStatus) {
    DeliveryStreamStatus["ACTIVE"] = "ACTIVE";
    DeliveryStreamStatus["CREATING"] = "CREATING";
    DeliveryStreamStatus["CREATING_FAILED"] = "CREATING_FAILED";
    DeliveryStreamStatus["DELETING"] = "DELETING";
    DeliveryStreamStatus["DELETING_FAILED"] = "DELETING_FAILED";
})(DeliveryStreamStatus || (DeliveryStreamStatus = {}));
var S3DestinationDescription;
(function(S3DestinationDescription) {
    S3DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationDescription || (S3DestinationDescription = {}));
var VpcConfigurationDescription;
(function(VpcConfigurationDescription) {
    VpcConfigurationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(VpcConfigurationDescription || (VpcConfigurationDescription = {}));
var ElasticsearchDestinationDescription;
(function(ElasticsearchDestinationDescription) {
    ElasticsearchDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationDescription || (ElasticsearchDestinationDescription = {}));
var ExtendedS3DestinationDescription;
(function(ExtendedS3DestinationDescription) {
    ExtendedS3DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationDescription || (ExtendedS3DestinationDescription = {}));
var HttpEndpointDescription;
(function(HttpEndpointDescription) {
    HttpEndpointDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Url && {
            Url: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointDescription || (HttpEndpointDescription = {}));
var HttpEndpointDestinationDescription;
(function(HttpEndpointDestinationDescription) {
    HttpEndpointDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointDescription.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationDescription || (HttpEndpointDestinationDescription = {}));
var RedshiftDestinationDescription;
(function(RedshiftDestinationDescription) {
    RedshiftDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationDescription || (RedshiftDestinationDescription = {}));
var SplunkDestinationDescription;
(function(SplunkDestinationDescription) {
    SplunkDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationDescription || (SplunkDestinationDescription = {}));
var DestinationDescription;
(function(DestinationDescription) {
    DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationDescription && {
            RedshiftDestinationDescription: RedshiftDestinationDescription.filterSensitiveLog(obj.RedshiftDestinationDescription)
        }), obj.HttpEndpointDestinationDescription && {
            HttpEndpointDestinationDescription: HttpEndpointDestinationDescription.filterSensitiveLog(obj.HttpEndpointDestinationDescription)
        });
    };
})(DestinationDescription || (DestinationDescription = {}));
var KinesisStreamSourceDescription;
(function(KinesisStreamSourceDescription) {
    KinesisStreamSourceDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KinesisStreamSourceDescription || (KinesisStreamSourceDescription = {}));
var SourceDescription;
(function(SourceDescription) {
    SourceDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SourceDescription || (SourceDescription = {}));
var DeliveryStreamDescription;
(function(DeliveryStreamDescription) {
    DeliveryStreamDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Destinations && {
            Destinations: obj.Destinations.map(function(item) {
                return DestinationDescription.filterSensitiveLog(item);
            })
        });
    };
})(DeliveryStreamDescription || (DeliveryStreamDescription = {}));
var DescribeDeliveryStreamInput;
(function(DescribeDeliveryStreamInput) {
    DescribeDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDeliveryStreamInput || (DescribeDeliveryStreamInput = {}));
var DescribeDeliveryStreamOutput;
(function(DescribeDeliveryStreamOutput) {
    DescribeDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeliveryStreamDescription && {
            DeliveryStreamDescription: DeliveryStreamDescription.filterSensitiveLog(obj.DeliveryStreamDescription)
        });
    };
})(DescribeDeliveryStreamOutput || (DescribeDeliveryStreamOutput = {}));
var S3DestinationUpdate;
(function(S3DestinationUpdate) {
    S3DestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationUpdate || (S3DestinationUpdate = {}));
var ElasticsearchDestinationUpdate;
(function(ElasticsearchDestinationUpdate) {
    ElasticsearchDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationUpdate || (ElasticsearchDestinationUpdate = {}));
var ExtendedS3DestinationUpdate;
(function(ExtendedS3DestinationUpdate) {
    ExtendedS3DestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationUpdate || (ExtendedS3DestinationUpdate = {}));
var ListDeliveryStreamsInput;
(function(ListDeliveryStreamsInput) {
    ListDeliveryStreamsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListDeliveryStreamsInput || (ListDeliveryStreamsInput = {}));
var ListDeliveryStreamsOutput;
(function(ListDeliveryStreamsOutput) {
    ListDeliveryStreamsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListDeliveryStreamsOutput || (ListDeliveryStreamsOutput = {}));
var ListTagsForDeliveryStreamInput;
(function(ListTagsForDeliveryStreamInput) {
    ListTagsForDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForDeliveryStreamInput || (ListTagsForDeliveryStreamInput = {}));
var ListTagsForDeliveryStreamOutput;
(function(ListTagsForDeliveryStreamOutput) {
    ListTagsForDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForDeliveryStreamOutput || (ListTagsForDeliveryStreamOutput = {}));
var _Record;
(function(_Record) {
    _Record.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(_Record || (_Record = {}));
var PutRecordInput;
(function(PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordOutput || (PutRecordOutput = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var PutRecordBatchInput;
(function(PutRecordBatchInput) {
    PutRecordBatchInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchInput || (PutRecordBatchInput = {}));
var PutRecordBatchResponseEntry;
(function(PutRecordBatchResponseEntry) {
    PutRecordBatchResponseEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchResponseEntry || (PutRecordBatchResponseEntry = {}));
var PutRecordBatchOutput;
(function(PutRecordBatchOutput) {
    PutRecordBatchOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchOutput || (PutRecordBatchOutput = {}));
var StartDeliveryStreamEncryptionInput;
(function(StartDeliveryStreamEncryptionInput) {
    StartDeliveryStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartDeliveryStreamEncryptionInput || (StartDeliveryStreamEncryptionInput = {}));
var StartDeliveryStreamEncryptionOutput;
(function(StartDeliveryStreamEncryptionOutput) {
    StartDeliveryStreamEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartDeliveryStreamEncryptionOutput || (StartDeliveryStreamEncryptionOutput = {}));
var StopDeliveryStreamEncryptionInput;
(function(StopDeliveryStreamEncryptionInput) {
    StopDeliveryStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopDeliveryStreamEncryptionInput || (StopDeliveryStreamEncryptionInput = {}));
var StopDeliveryStreamEncryptionOutput;
(function(StopDeliveryStreamEncryptionOutput) {
    StopDeliveryStreamEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopDeliveryStreamEncryptionOutput || (StopDeliveryStreamEncryptionOutput = {}));
var TagDeliveryStreamInput;
(function(TagDeliveryStreamInput) {
    TagDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagDeliveryStreamInput || (TagDeliveryStreamInput = {}));
var TagDeliveryStreamOutput;
(function(TagDeliveryStreamOutput) {
    TagDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagDeliveryStreamOutput || (TagDeliveryStreamOutput = {}));
var UntagDeliveryStreamInput;
(function(UntagDeliveryStreamInput) {
    UntagDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagDeliveryStreamInput || (UntagDeliveryStreamInput = {}));
var UntagDeliveryStreamOutput;
(function(UntagDeliveryStreamOutput) {
    UntagDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagDeliveryStreamOutput || (UntagDeliveryStreamOutput = {}));
var HttpEndpointDestinationUpdate;
(function(HttpEndpointDestinationUpdate) {
    HttpEndpointDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationUpdate || (HttpEndpointDestinationUpdate = {}));
var RedshiftDestinationUpdate;
(function(RedshiftDestinationUpdate) {
    RedshiftDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.Password && {
            Password: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationUpdate || (RedshiftDestinationUpdate = {}));
var SplunkDestinationUpdate;
(function(SplunkDestinationUpdate) {
    SplunkDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationUpdate || (SplunkDestinationUpdate = {}));
var UpdateDestinationInput;
(function(UpdateDestinationInput) {
    UpdateDestinationInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationUpdate && {
            RedshiftDestinationUpdate: RedshiftDestinationUpdate.filterSensitiveLog(obj.RedshiftDestinationUpdate)
        }), obj.HttpEndpointDestinationUpdate && {
            HttpEndpointDestinationUpdate: HttpEndpointDestinationUpdate.filterSensitiveLog(obj.HttpEndpointDestinationUpdate)
        });
    };
})(UpdateDestinationInput || (UpdateDestinationInput = {}));
var UpdateDestinationOutput;
(function(UpdateDestinationOutput) {
    UpdateDestinationOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateDestinationOutput || (UpdateDestinationOutput = {}));

},{"tslib":"hIjnq","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"L7RFs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1CreateDeliveryStreamCommand", ()=>serializeAws_json1_1CreateDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteDeliveryStreamCommand", ()=>serializeAws_json1_1DeleteDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeDeliveryStreamCommand", ()=>serializeAws_json1_1DescribeDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListDeliveryStreamsCommand", ()=>serializeAws_json1_1ListDeliveryStreamsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsForDeliveryStreamCommand", ()=>serializeAws_json1_1ListTagsForDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordCommand", ()=>serializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordBatchCommand", ()=>serializeAws_json1_1PutRecordBatchCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StartDeliveryStreamEncryptionCommand", ()=>serializeAws_json1_1StartDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StopDeliveryStreamEncryptionCommand", ()=>serializeAws_json1_1StopDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1TagDeliveryStreamCommand", ()=>serializeAws_json1_1TagDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UntagDeliveryStreamCommand", ()=>serializeAws_json1_1UntagDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UpdateDestinationCommand", ()=>serializeAws_json1_1UpdateDestinationCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateDeliveryStreamCommand", ()=>deserializeAws_json1_1CreateDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteDeliveryStreamCommand", ()=>deserializeAws_json1_1DeleteDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeDeliveryStreamCommand", ()=>deserializeAws_json1_1DescribeDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListDeliveryStreamsCommand", ()=>deserializeAws_json1_1ListDeliveryStreamsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsForDeliveryStreamCommand", ()=>deserializeAws_json1_1ListTagsForDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordCommand", ()=>deserializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordBatchCommand", ()=>deserializeAws_json1_1PutRecordBatchCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StartDeliveryStreamEncryptionCommand", ()=>deserializeAws_json1_1StartDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StopDeliveryStreamEncryptionCommand", ()=>deserializeAws_json1_1StopDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1TagDeliveryStreamCommand", ()=>deserializeAws_json1_1TagDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UntagDeliveryStreamCommand", ()=>deserializeAws_json1_1UntagDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UpdateDestinationCommand", ()=>deserializeAws_json1_1UpdateDestinationCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1CreateDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.CreateDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.DeleteDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.DescribeDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListDeliveryStreamsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.ListDeliveryStreams"
            };
            body = JSON.stringify(serializeAws_json1_1ListDeliveryStreamsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsForDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.ListTagsForDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsForDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.PutRecord"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordBatchCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.PutRecordBatch"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordBatchInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartDeliveryStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.StartDeliveryStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StartDeliveryStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopDeliveryStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.StopDeliveryStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StopDeliveryStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TagDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.TagDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1TagDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UntagDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.UntagDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1UntagDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UpdateDestinationCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.UpdateDestination"
            };
            body = JSON.stringify(serializeAws_json1_1UpdateDestinationInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1CreateDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1CreateDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DeleteDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListDeliveryStreamsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListDeliveryStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListDeliveryStreamsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListDeliveryStreamsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsForDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsForDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordBatchCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordBatchCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordBatchOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordBatchCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StartDeliveryStreamEncryptionOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StopDeliveryStreamEncryptionOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TagDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1TagDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UntagDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UntagDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateDestinationCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UpdateDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UpdateDestinationOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateDestinationCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidArgumentException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidKMSResourceExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidKMSResourceException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidKMSResourceException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceInUseExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceInUseException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ServiceUnavailableException",
                $fault: "server",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1BufferingHints = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1CloudWatchLoggingOptions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.LogGroupName !== undefined && input.LogGroupName !== null && {
        LogGroupName: input.LogGroupName
    }), input.LogStreamName !== undefined && input.LogStreamName !== null && {
        LogStreamName: input.LogStreamName
    });
};
var serializeAws_json1_1ColumnToJsonKeyMappings = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1CopyCommand = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CopyOptions !== undefined && input.CopyOptions !== null && {
        CopyOptions: input.CopyOptions
    }), input.DataTableColumns !== undefined && input.DataTableColumns !== null && {
        DataTableColumns: input.DataTableColumns
    }), input.DataTableName !== undefined && input.DataTableName !== null && {
        DataTableName: input.DataTableName
    });
};
var serializeAws_json1_1CreateDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamEncryptionConfigurationInput !== undefined && input.DeliveryStreamEncryptionConfigurationInput !== null && {
        DeliveryStreamEncryptionConfigurationInput: serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input.DeliveryStreamEncryptionConfigurationInput, context)
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.DeliveryStreamType !== undefined && input.DeliveryStreamType !== null && {
        DeliveryStreamType: input.DeliveryStreamType
    }), input.ElasticsearchDestinationConfiguration !== undefined && input.ElasticsearchDestinationConfiguration !== null && {
        ElasticsearchDestinationConfiguration: serializeAws_json1_1ElasticsearchDestinationConfiguration(input.ElasticsearchDestinationConfiguration, context)
    }), input.ExtendedS3DestinationConfiguration !== undefined && input.ExtendedS3DestinationConfiguration !== null && {
        ExtendedS3DestinationConfiguration: serializeAws_json1_1ExtendedS3DestinationConfiguration(input.ExtendedS3DestinationConfiguration, context)
    }), input.HttpEndpointDestinationConfiguration !== undefined && input.HttpEndpointDestinationConfiguration !== null && {
        HttpEndpointDestinationConfiguration: serializeAws_json1_1HttpEndpointDestinationConfiguration(input.HttpEndpointDestinationConfiguration, context)
    }), input.KinesisStreamSourceConfiguration !== undefined && input.KinesisStreamSourceConfiguration !== null && {
        KinesisStreamSourceConfiguration: serializeAws_json1_1KinesisStreamSourceConfiguration(input.KinesisStreamSourceConfiguration, context)
    }), input.RedshiftDestinationConfiguration !== undefined && input.RedshiftDestinationConfiguration !== null && {
        RedshiftDestinationConfiguration: serializeAws_json1_1RedshiftDestinationConfiguration(input.RedshiftDestinationConfiguration, context)
    }), input.S3DestinationConfiguration !== undefined && input.S3DestinationConfiguration !== null && {
        S3DestinationConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3DestinationConfiguration, context)
    }), input.SplunkDestinationConfiguration !== undefined && input.SplunkDestinationConfiguration !== null && {
        SplunkDestinationConfiguration: serializeAws_json1_1SplunkDestinationConfiguration(input.SplunkDestinationConfiguration, context)
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagDeliveryStreamInputTagList(input.Tags, context)
    });
};
var serializeAws_json1_1DataFormatConversionConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.InputFormatConfiguration !== undefined && input.InputFormatConfiguration !== null && {
        InputFormatConfiguration: serializeAws_json1_1InputFormatConfiguration(input.InputFormatConfiguration, context)
    }), input.OutputFormatConfiguration !== undefined && input.OutputFormatConfiguration !== null && {
        OutputFormatConfiguration: serializeAws_json1_1OutputFormatConfiguration(input.OutputFormatConfiguration, context)
    }), input.SchemaConfiguration !== undefined && input.SchemaConfiguration !== null && {
        SchemaConfiguration: serializeAws_json1_1SchemaConfiguration(input.SchemaConfiguration, context)
    });
};
var serializeAws_json1_1DeleteDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AllowForceDelete !== undefined && input.AllowForceDelete !== null && {
        AllowForceDelete: input.AllowForceDelete
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KeyARN !== undefined && input.KeyARN !== null && {
        KeyARN: input.KeyARN
    }), input.KeyType !== undefined && input.KeyType !== null && {
        KeyType: input.KeyType
    });
};
var serializeAws_json1_1DescribeDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.ExclusiveStartDestinationId !== undefined && input.ExclusiveStartDestinationId !== null && {
        ExclusiveStartDestinationId: input.ExclusiveStartDestinationId
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1Deserializer = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.HiveJsonSerDe !== undefined && input.HiveJsonSerDe !== null && {
        HiveJsonSerDe: serializeAws_json1_1HiveJsonSerDe(input.HiveJsonSerDe, context)
    }), input.OpenXJsonSerDe !== undefined && input.OpenXJsonSerDe !== null && {
        OpenXJsonSerDe: serializeAws_json1_1OpenXJsonSerDe(input.OpenXJsonSerDe, context)
    });
};
var serializeAws_json1_1ElasticsearchBufferingHints = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1ElasticsearchDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1ElasticsearchBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterEndpoint !== undefined && input.ClusterEndpoint !== null && {
        ClusterEndpoint: input.ClusterEndpoint
    }), input.DomainARN !== undefined && input.DomainARN !== null && {
        DomainARN: input.DomainARN
    }), input.IndexName !== undefined && input.IndexName !== null && {
        IndexName: input.IndexName
    }), input.IndexRotationPeriod !== undefined && input.IndexRotationPeriod !== null && {
        IndexRotationPeriod: input.IndexRotationPeriod
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1ElasticsearchRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    }), input.TypeName !== undefined && input.TypeName !== null && {
        TypeName: input.TypeName
    }), input.VpcConfiguration !== undefined && input.VpcConfiguration !== null && {
        VpcConfiguration: serializeAws_json1_1VpcConfiguration(input.VpcConfiguration, context)
    });
};
var serializeAws_json1_1ElasticsearchDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1ElasticsearchBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterEndpoint !== undefined && input.ClusterEndpoint !== null && {
        ClusterEndpoint: input.ClusterEndpoint
    }), input.DomainARN !== undefined && input.DomainARN !== null && {
        DomainARN: input.DomainARN
    }), input.IndexName !== undefined && input.IndexName !== null && {
        IndexName: input.IndexName
    }), input.IndexRotationPeriod !== undefined && input.IndexRotationPeriod !== null && {
        IndexRotationPeriod: input.IndexRotationPeriod
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1ElasticsearchRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    }), input.TypeName !== undefined && input.TypeName !== null && {
        TypeName: input.TypeName
    });
};
var serializeAws_json1_1ElasticsearchRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1EncryptionConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KMSEncryptionConfig !== undefined && input.KMSEncryptionConfig !== null && {
        KMSEncryptionConfig: serializeAws_json1_1KMSEncryptionConfig(input.KMSEncryptionConfig, context)
    }), input.NoEncryptionConfig !== undefined && input.NoEncryptionConfig !== null && {
        NoEncryptionConfig: input.NoEncryptionConfig
    });
};
var serializeAws_json1_1ExtendedS3DestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.DataFormatConversionConfiguration !== undefined && input.DataFormatConversionConfiguration !== null && {
        DataFormatConversionConfiguration: serializeAws_json1_1DataFormatConversionConfiguration(input.DataFormatConversionConfiguration, context)
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupConfiguration !== undefined && input.S3BackupConfiguration !== null && {
        S3BackupConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3BackupConfiguration, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    });
};
var serializeAws_json1_1ExtendedS3DestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.DataFormatConversionConfiguration !== undefined && input.DataFormatConversionConfiguration !== null && {
        DataFormatConversionConfiguration: serializeAws_json1_1DataFormatConversionConfiguration(input.DataFormatConversionConfiguration, context)
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3BackupUpdate !== undefined && input.S3BackupUpdate !== null && {
        S3BackupUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3BackupUpdate, context)
    });
};
var serializeAws_json1_1HiveJsonSerDe = function(input, context) {
    return (0, _tslib.__assign)({}, input.TimestampFormats !== undefined && input.TimestampFormats !== null && {
        TimestampFormats: serializeAws_json1_1ListOfNonEmptyStrings(input.TimestampFormats, context)
    });
};
var serializeAws_json1_1HttpEndpointBufferingHints = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1HttpEndpointCommonAttribute = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AttributeName !== undefined && input.AttributeName !== null && {
        AttributeName: input.AttributeName
    }), input.AttributeValue !== undefined && input.AttributeValue !== null && {
        AttributeValue: input.AttributeValue
    });
};
var serializeAws_json1_1HttpEndpointCommonAttributesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1HttpEndpointCommonAttribute(entry, context);
    });
};
var serializeAws_json1_1HttpEndpointConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AccessKey !== undefined && input.AccessKey !== null && {
        AccessKey: input.AccessKey
    }), input.Name !== undefined && input.Name !== null && {
        Name: input.Name
    }), input.Url !== undefined && input.Url !== null && {
        Url: input.Url
    });
};
var serializeAws_json1_1HttpEndpointDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1HttpEndpointBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.EndpointConfiguration !== undefined && input.EndpointConfiguration !== null && {
        EndpointConfiguration: serializeAws_json1_1HttpEndpointConfiguration(input.EndpointConfiguration, context)
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RequestConfiguration !== undefined && input.RequestConfiguration !== null && {
        RequestConfiguration: serializeAws_json1_1HttpEndpointRequestConfiguration(input.RequestConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1HttpEndpointRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    });
};
var serializeAws_json1_1HttpEndpointDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1HttpEndpointBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.EndpointConfiguration !== undefined && input.EndpointConfiguration !== null && {
        EndpointConfiguration: serializeAws_json1_1HttpEndpointConfiguration(input.EndpointConfiguration, context)
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RequestConfiguration !== undefined && input.RequestConfiguration !== null && {
        RequestConfiguration: serializeAws_json1_1HttpEndpointRequestConfiguration(input.RequestConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1HttpEndpointRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    });
};
var serializeAws_json1_1HttpEndpointRequestConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.CommonAttributes !== undefined && input.CommonAttributes !== null && {
        CommonAttributes: serializeAws_json1_1HttpEndpointCommonAttributesList(input.CommonAttributes, context)
    }), input.ContentEncoding !== undefined && input.ContentEncoding !== null && {
        ContentEncoding: input.ContentEncoding
    });
};
var serializeAws_json1_1HttpEndpointRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1InputFormatConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.Deserializer !== undefined && input.Deserializer !== null && {
        Deserializer: serializeAws_json1_1Deserializer(input.Deserializer, context)
    });
};
var serializeAws_json1_1KinesisStreamSourceConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KinesisStreamARN !== undefined && input.KinesisStreamARN !== null && {
        KinesisStreamARN: input.KinesisStreamARN
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1KMSEncryptionConfig = function(input, context) {
    return (0, _tslib.__assign)({}, input.AWSKMSKeyARN !== undefined && input.AWSKMSKeyARN !== null && {
        AWSKMSKeyARN: input.AWSKMSKeyARN
    });
};
var serializeAws_json1_1ListDeliveryStreamsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamType !== undefined && input.DeliveryStreamType !== null && {
        DeliveryStreamType: input.DeliveryStreamType
    }), input.ExclusiveStartDeliveryStreamName !== undefined && input.ExclusiveStartDeliveryStreamName !== null && {
        ExclusiveStartDeliveryStreamName: input.ExclusiveStartDeliveryStreamName
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1ListOfNonEmptyStrings = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListTagsForDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.ExclusiveStartTagKey !== undefined && input.ExclusiveStartTagKey !== null && {
        ExclusiveStartTagKey: input.ExclusiveStartTagKey
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1OpenXJsonSerDe = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CaseInsensitive !== undefined && input.CaseInsensitive !== null && {
        CaseInsensitive: input.CaseInsensitive
    }), input.ColumnToJsonKeyMappings !== undefined && input.ColumnToJsonKeyMappings !== null && {
        ColumnToJsonKeyMappings: serializeAws_json1_1ColumnToJsonKeyMappings(input.ColumnToJsonKeyMappings, context)
    }), input.ConvertDotsInJsonKeysToUnderscores !== undefined && input.ConvertDotsInJsonKeysToUnderscores !== null && {
        ConvertDotsInJsonKeysToUnderscores: input.ConvertDotsInJsonKeysToUnderscores
    });
};
var serializeAws_json1_1OrcSerDe = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BlockSizeBytes !== undefined && input.BlockSizeBytes !== null && {
        BlockSizeBytes: input.BlockSizeBytes
    }), input.BloomFilterColumns !== undefined && input.BloomFilterColumns !== null && {
        BloomFilterColumns: serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(input.BloomFilterColumns, context)
    }), input.BloomFilterFalsePositiveProbability !== undefined && input.BloomFilterFalsePositiveProbability !== null && {
        BloomFilterFalsePositiveProbability: input.BloomFilterFalsePositiveProbability
    }), input.Compression !== undefined && input.Compression !== null && {
        Compression: input.Compression
    }), input.DictionaryKeyThreshold !== undefined && input.DictionaryKeyThreshold !== null && {
        DictionaryKeyThreshold: input.DictionaryKeyThreshold
    }), input.EnablePadding !== undefined && input.EnablePadding !== null && {
        EnablePadding: input.EnablePadding
    }), input.FormatVersion !== undefined && input.FormatVersion !== null && {
        FormatVersion: input.FormatVersion
    }), input.PaddingTolerance !== undefined && input.PaddingTolerance !== null && {
        PaddingTolerance: input.PaddingTolerance
    }), input.RowIndexStride !== undefined && input.RowIndexStride !== null && {
        RowIndexStride: input.RowIndexStride
    }), input.StripeSizeBytes !== undefined && input.StripeSizeBytes !== null && {
        StripeSizeBytes: input.StripeSizeBytes
    });
};
var serializeAws_json1_1OutputFormatConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.Serializer !== undefined && input.Serializer !== null && {
        Serializer: serializeAws_json1_1Serializer(input.Serializer, context)
    });
};
var serializeAws_json1_1ParquetSerDe = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BlockSizeBytes !== undefined && input.BlockSizeBytes !== null && {
        BlockSizeBytes: input.BlockSizeBytes
    }), input.Compression !== undefined && input.Compression !== null && {
        Compression: input.Compression
    }), input.EnableDictionaryCompression !== undefined && input.EnableDictionaryCompression !== null && {
        EnableDictionaryCompression: input.EnableDictionaryCompression
    }), input.MaxPaddingBytes !== undefined && input.MaxPaddingBytes !== null && {
        MaxPaddingBytes: input.MaxPaddingBytes
    }), input.PageSizeBytes !== undefined && input.PageSizeBytes !== null && {
        PageSizeBytes: input.PageSizeBytes
    }), input.WriterVersion !== undefined && input.WriterVersion !== null && {
        WriterVersion: input.WriterVersion
    });
};
var serializeAws_json1_1ProcessingConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.Processors !== undefined && input.Processors !== null && {
        Processors: serializeAws_json1_1ProcessorList(input.Processors, context)
    });
};
var serializeAws_json1_1Processor = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Parameters !== undefined && input.Parameters !== null && {
        Parameters: serializeAws_json1_1ProcessorParameterList(input.Parameters, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1ProcessorList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1Processor(entry, context);
    });
};
var serializeAws_json1_1ProcessorParameter = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ParameterName !== undefined && input.ParameterName !== null && {
        ParameterName: input.ParameterName
    }), input.ParameterValue !== undefined && input.ParameterValue !== null && {
        ParameterValue: input.ParameterValue
    });
};
var serializeAws_json1_1ProcessorParameterList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1ProcessorParameter(entry, context);
    });
};
var serializeAws_json1_1PutRecordBatchInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Records !== undefined && input.Records !== null && {
        Records: serializeAws_json1_1PutRecordBatchRequestEntryList(input.Records, context)
    });
};
var serializeAws_json1_1PutRecordBatchRequestEntryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1_Record(entry, context);
    });
};
var serializeAws_json1_1PutRecordInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Record !== undefined && input.Record !== null && {
        Record: serializeAws_json1_1_Record(input.Record, context)
    });
};
var serializeAws_json1_1_Record = function(input, context) {
    return (0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    });
};
var serializeAws_json1_1RedshiftDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterJDBCURL !== undefined && input.ClusterJDBCURL !== null && {
        ClusterJDBCURL: input.ClusterJDBCURL
    }), input.CopyCommand !== undefined && input.CopyCommand !== null && {
        CopyCommand: serializeAws_json1_1CopyCommand(input.CopyCommand, context)
    }), input.Password !== undefined && input.Password !== null && {
        Password: input.Password
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1RedshiftRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupConfiguration !== undefined && input.S3BackupConfiguration !== null && {
        S3BackupConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3BackupConfiguration, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    }), input.Username !== undefined && input.Username !== null && {
        Username: input.Username
    });
};
var serializeAws_json1_1RedshiftDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterJDBCURL !== undefined && input.ClusterJDBCURL !== null && {
        ClusterJDBCURL: input.ClusterJDBCURL
    }), input.CopyCommand !== undefined && input.CopyCommand !== null && {
        CopyCommand: serializeAws_json1_1CopyCommand(input.CopyCommand, context)
    }), input.Password !== undefined && input.Password !== null && {
        Password: input.Password
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1RedshiftRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3BackupUpdate !== undefined && input.S3BackupUpdate !== null && {
        S3BackupUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3BackupUpdate, context)
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    }), input.Username !== undefined && input.Username !== null && {
        Username: input.Username
    });
};
var serializeAws_json1_1RedshiftRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1S3DestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1S3DestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1SchemaConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CatalogId !== undefined && input.CatalogId !== null && {
        CatalogId: input.CatalogId
    }), input.DatabaseName !== undefined && input.DatabaseName !== null && {
        DatabaseName: input.DatabaseName
    }), input.Region !== undefined && input.Region !== null && {
        Region: input.Region
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.TableName !== undefined && input.TableName !== null && {
        TableName: input.TableName
    }), input.VersionId !== undefined && input.VersionId !== null && {
        VersionId: input.VersionId
    });
};
var serializeAws_json1_1SecurityGroupIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1Serializer = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.OrcSerDe !== undefined && input.OrcSerDe !== null && {
        OrcSerDe: serializeAws_json1_1OrcSerDe(input.OrcSerDe, context)
    }), input.ParquetSerDe !== undefined && input.ParquetSerDe !== null && {
        ParquetSerDe: serializeAws_json1_1ParquetSerDe(input.ParquetSerDe, context)
    });
};
var serializeAws_json1_1SplunkDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.HECAcknowledgmentTimeoutInSeconds !== undefined && input.HECAcknowledgmentTimeoutInSeconds !== null && {
        HECAcknowledgmentTimeoutInSeconds: input.HECAcknowledgmentTimeoutInSeconds
    }), input.HECEndpoint !== undefined && input.HECEndpoint !== null && {
        HECEndpoint: input.HECEndpoint
    }), input.HECEndpointType !== undefined && input.HECEndpointType !== null && {
        HECEndpointType: input.HECEndpointType
    }), input.HECToken !== undefined && input.HECToken !== null && {
        HECToken: input.HECToken
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1SplunkRetryOptions(input.RetryOptions, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    });
};
var serializeAws_json1_1SplunkDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.HECAcknowledgmentTimeoutInSeconds !== undefined && input.HECAcknowledgmentTimeoutInSeconds !== null && {
        HECAcknowledgmentTimeoutInSeconds: input.HECAcknowledgmentTimeoutInSeconds
    }), input.HECEndpoint !== undefined && input.HECEndpoint !== null && {
        HECEndpoint: input.HECEndpoint
    }), input.HECEndpointType !== undefined && input.HECEndpointType !== null && {
        HECEndpointType: input.HECEndpointType
    }), input.HECToken !== undefined && input.HECToken !== null && {
        HECToken: input.HECToken
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1SplunkRetryOptions(input.RetryOptions, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    });
};
var serializeAws_json1_1SplunkRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1StartDeliveryStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamEncryptionConfigurationInput !== undefined && input.DeliveryStreamEncryptionConfigurationInput !== null && {
        DeliveryStreamEncryptionConfigurationInput: serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input.DeliveryStreamEncryptionConfigurationInput, context)
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1StopDeliveryStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1SubnetIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1Tag = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Key !== undefined && input.Key !== null && {
        Key: input.Key
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var serializeAws_json1_1TagDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagDeliveryStreamInputTagList(input.Tags, context)
    });
};
var serializeAws_json1_1TagDeliveryStreamInputTagList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1Tag(entry, context);
    });
};
var serializeAws_json1_1TagKeyList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1UntagDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: serializeAws_json1_1TagKeyList(input.TagKeys, context)
    });
};
var serializeAws_json1_1UpdateDestinationInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CurrentDeliveryStreamVersionId !== undefined && input.CurrentDeliveryStreamVersionId !== null && {
        CurrentDeliveryStreamVersionId: input.CurrentDeliveryStreamVersionId
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.DestinationId !== undefined && input.DestinationId !== null && {
        DestinationId: input.DestinationId
    }), input.ElasticsearchDestinationUpdate !== undefined && input.ElasticsearchDestinationUpdate !== null && {
        ElasticsearchDestinationUpdate: serializeAws_json1_1ElasticsearchDestinationUpdate(input.ElasticsearchDestinationUpdate, context)
    }), input.ExtendedS3DestinationUpdate !== undefined && input.ExtendedS3DestinationUpdate !== null && {
        ExtendedS3DestinationUpdate: serializeAws_json1_1ExtendedS3DestinationUpdate(input.ExtendedS3DestinationUpdate, context)
    }), input.HttpEndpointDestinationUpdate !== undefined && input.HttpEndpointDestinationUpdate !== null && {
        HttpEndpointDestinationUpdate: serializeAws_json1_1HttpEndpointDestinationUpdate(input.HttpEndpointDestinationUpdate, context)
    }), input.RedshiftDestinationUpdate !== undefined && input.RedshiftDestinationUpdate !== null && {
        RedshiftDestinationUpdate: serializeAws_json1_1RedshiftDestinationUpdate(input.RedshiftDestinationUpdate, context)
    }), input.S3DestinationUpdate !== undefined && input.S3DestinationUpdate !== null && {
        S3DestinationUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3DestinationUpdate, context)
    }), input.SplunkDestinationUpdate !== undefined && input.SplunkDestinationUpdate !== null && {
        SplunkDestinationUpdate: serializeAws_json1_1SplunkDestinationUpdate(input.SplunkDestinationUpdate, context)
    });
};
var serializeAws_json1_1VpcConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.SecurityGroupIds !== undefined && input.SecurityGroupIds !== null && {
        SecurityGroupIds: serializeAws_json1_1SecurityGroupIdList(input.SecurityGroupIds, context)
    }), input.SubnetIds !== undefined && input.SubnetIds !== null && {
        SubnetIds: serializeAws_json1_1SubnetIdList(input.SubnetIds, context)
    });
};
var deserializeAws_json1_1BufferingHints = function(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1CloudWatchLoggingOptions = function(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        LogGroupName: output.LogGroupName !== undefined && output.LogGroupName !== null ? output.LogGroupName : undefined,
        LogStreamName: output.LogStreamName !== undefined && output.LogStreamName !== null ? output.LogStreamName : undefined
    };
};
var deserializeAws_json1_1ColumnToJsonKeyMappings = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1CopyCommand = function(output, context) {
    return {
        CopyOptions: output.CopyOptions !== undefined && output.CopyOptions !== null ? output.CopyOptions : undefined,
        DataTableColumns: output.DataTableColumns !== undefined && output.DataTableColumns !== null ? output.DataTableColumns : undefined,
        DataTableName: output.DataTableName !== undefined && output.DataTableName !== null ? output.DataTableName : undefined
    };
};
var deserializeAws_json1_1CreateDeliveryStreamOutput = function(output, context) {
    return {
        DeliveryStreamARN: output.DeliveryStreamARN !== undefined && output.DeliveryStreamARN !== null ? output.DeliveryStreamARN : undefined
    };
};
var deserializeAws_json1_1DataFormatConversionConfiguration = function(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        InputFormatConfiguration: output.InputFormatConfiguration !== undefined && output.InputFormatConfiguration !== null ? deserializeAws_json1_1InputFormatConfiguration(output.InputFormatConfiguration, context) : undefined,
        OutputFormatConfiguration: output.OutputFormatConfiguration !== undefined && output.OutputFormatConfiguration !== null ? deserializeAws_json1_1OutputFormatConfiguration(output.OutputFormatConfiguration, context) : undefined,
        SchemaConfiguration: output.SchemaConfiguration !== undefined && output.SchemaConfiguration !== null ? deserializeAws_json1_1SchemaConfiguration(output.SchemaConfiguration, context) : undefined
    };
};
var deserializeAws_json1_1DeleteDeliveryStreamOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1DeliveryStreamDescription = function(output, context) {
    return {
        CreateTimestamp: output.CreateTimestamp !== undefined && output.CreateTimestamp !== null ? new Date(Math.round(output.CreateTimestamp * 1000)) : undefined,
        DeliveryStreamARN: output.DeliveryStreamARN !== undefined && output.DeliveryStreamARN !== null ? output.DeliveryStreamARN : undefined,
        DeliveryStreamEncryptionConfiguration: output.DeliveryStreamEncryptionConfiguration !== undefined && output.DeliveryStreamEncryptionConfiguration !== null ? deserializeAws_json1_1DeliveryStreamEncryptionConfiguration(output.DeliveryStreamEncryptionConfiguration, context) : undefined,
        DeliveryStreamName: output.DeliveryStreamName !== undefined && output.DeliveryStreamName !== null ? output.DeliveryStreamName : undefined,
        DeliveryStreamStatus: output.DeliveryStreamStatus !== undefined && output.DeliveryStreamStatus !== null ? output.DeliveryStreamStatus : undefined,
        DeliveryStreamType: output.DeliveryStreamType !== undefined && output.DeliveryStreamType !== null ? output.DeliveryStreamType : undefined,
        Destinations: output.Destinations !== undefined && output.Destinations !== null ? deserializeAws_json1_1DestinationDescriptionList(output.Destinations, context) : undefined,
        FailureDescription: output.FailureDescription !== undefined && output.FailureDescription !== null ? deserializeAws_json1_1FailureDescription(output.FailureDescription, context) : undefined,
        HasMoreDestinations: output.HasMoreDestinations !== undefined && output.HasMoreDestinations !== null ? output.HasMoreDestinations : undefined,
        LastUpdateTimestamp: output.LastUpdateTimestamp !== undefined && output.LastUpdateTimestamp !== null ? new Date(Math.round(output.LastUpdateTimestamp * 1000)) : undefined,
        Source: output.Source !== undefined && output.Source !== null ? deserializeAws_json1_1SourceDescription(output.Source, context) : undefined,
        VersionId: output.VersionId !== undefined && output.VersionId !== null ? output.VersionId : undefined
    };
};
var deserializeAws_json1_1DeliveryStreamEncryptionConfiguration = function(output, context) {
    return {
        FailureDescription: output.FailureDescription !== undefined && output.FailureDescription !== null ? deserializeAws_json1_1FailureDescription(output.FailureDescription, context) : undefined,
        KeyARN: output.KeyARN !== undefined && output.KeyARN !== null ? output.KeyARN : undefined,
        KeyType: output.KeyType !== undefined && output.KeyType !== null ? output.KeyType : undefined,
        Status: output.Status !== undefined && output.Status !== null ? output.Status : undefined
    };
};
var deserializeAws_json1_1DeliveryStreamNameList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamOutput = function(output, context) {
    return {
        DeliveryStreamDescription: output.DeliveryStreamDescription !== undefined && output.DeliveryStreamDescription !== null ? deserializeAws_json1_1DeliveryStreamDescription(output.DeliveryStreamDescription, context) : undefined
    };
};
var deserializeAws_json1_1Deserializer = function(output, context) {
    return {
        HiveJsonSerDe: output.HiveJsonSerDe !== undefined && output.HiveJsonSerDe !== null ? deserializeAws_json1_1HiveJsonSerDe(output.HiveJsonSerDe, context) : undefined,
        OpenXJsonSerDe: output.OpenXJsonSerDe !== undefined && output.OpenXJsonSerDe !== null ? deserializeAws_json1_1OpenXJsonSerDe(output.OpenXJsonSerDe, context) : undefined
    };
};
var deserializeAws_json1_1DestinationDescription = function(output, context) {
    return {
        DestinationId: output.DestinationId !== undefined && output.DestinationId !== null ? output.DestinationId : undefined,
        ElasticsearchDestinationDescription: output.ElasticsearchDestinationDescription !== undefined && output.ElasticsearchDestinationDescription !== null ? deserializeAws_json1_1ElasticsearchDestinationDescription(output.ElasticsearchDestinationDescription, context) : undefined,
        ExtendedS3DestinationDescription: output.ExtendedS3DestinationDescription !== undefined && output.ExtendedS3DestinationDescription !== null ? deserializeAws_json1_1ExtendedS3DestinationDescription(output.ExtendedS3DestinationDescription, context) : undefined,
        HttpEndpointDestinationDescription: output.HttpEndpointDestinationDescription !== undefined && output.HttpEndpointDestinationDescription !== null ? deserializeAws_json1_1HttpEndpointDestinationDescription(output.HttpEndpointDestinationDescription, context) : undefined,
        RedshiftDestinationDescription: output.RedshiftDestinationDescription !== undefined && output.RedshiftDestinationDescription !== null ? deserializeAws_json1_1RedshiftDestinationDescription(output.RedshiftDestinationDescription, context) : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        SplunkDestinationDescription: output.SplunkDestinationDescription !== undefined && output.SplunkDestinationDescription !== null ? deserializeAws_json1_1SplunkDestinationDescription(output.SplunkDestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1DestinationDescriptionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1DestinationDescription(entry, context);
    });
};
var deserializeAws_json1_1ElasticsearchBufferingHints = function(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1ElasticsearchDestinationDescription = function(output, context) {
    return {
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1ElasticsearchBufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        ClusterEndpoint: output.ClusterEndpoint !== undefined && output.ClusterEndpoint !== null ? output.ClusterEndpoint : undefined,
        DomainARN: output.DomainARN !== undefined && output.DomainARN !== null ? output.DomainARN : undefined,
        IndexName: output.IndexName !== undefined && output.IndexName !== null ? output.IndexName : undefined,
        IndexRotationPeriod: output.IndexRotationPeriod !== undefined && output.IndexRotationPeriod !== null ? output.IndexRotationPeriod : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1ElasticsearchRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        TypeName: output.TypeName !== undefined && output.TypeName !== null ? output.TypeName : undefined,
        VpcConfigurationDescription: output.VpcConfigurationDescription !== undefined && output.VpcConfigurationDescription !== null ? deserializeAws_json1_1VpcConfigurationDescription(output.VpcConfigurationDescription, context) : undefined
    };
};
var deserializeAws_json1_1ElasticsearchRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1EncryptionConfiguration = function(output, context) {
    return {
        KMSEncryptionConfig: output.KMSEncryptionConfig !== undefined && output.KMSEncryptionConfig !== null ? deserializeAws_json1_1KMSEncryptionConfig(output.KMSEncryptionConfig, context) : undefined,
        NoEncryptionConfig: output.NoEncryptionConfig !== undefined && output.NoEncryptionConfig !== null ? output.NoEncryptionConfig : undefined
    };
};
var deserializeAws_json1_1ExtendedS3DestinationDescription = function(output, context) {
    return {
        BucketARN: output.BucketARN !== undefined && output.BucketARN !== null ? output.BucketARN : undefined,
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1BufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        CompressionFormat: output.CompressionFormat !== undefined && output.CompressionFormat !== null ? output.CompressionFormat : undefined,
        DataFormatConversionConfiguration: output.DataFormatConversionConfiguration !== undefined && output.DataFormatConversionConfiguration !== null ? deserializeAws_json1_1DataFormatConversionConfiguration(output.DataFormatConversionConfiguration, context) : undefined,
        EncryptionConfiguration: output.EncryptionConfiguration !== undefined && output.EncryptionConfiguration !== null ? deserializeAws_json1_1EncryptionConfiguration(output.EncryptionConfiguration, context) : undefined,
        ErrorOutputPrefix: output.ErrorOutputPrefix !== undefined && output.ErrorOutputPrefix !== null ? output.ErrorOutputPrefix : undefined,
        Prefix: output.Prefix !== undefined && output.Prefix !== null ? output.Prefix : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupDescription: output.S3BackupDescription !== undefined && output.S3BackupDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3BackupDescription, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined
    };
};
var deserializeAws_json1_1FailureDescription = function(output, context) {
    return {
        Details: output.Details !== undefined && output.Details !== null ? output.Details : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var deserializeAws_json1_1HiveJsonSerDe = function(output, context) {
    return {
        TimestampFormats: output.TimestampFormats !== undefined && output.TimestampFormats !== null ? deserializeAws_json1_1ListOfNonEmptyStrings(output.TimestampFormats, context) : undefined
    };
};
var deserializeAws_json1_1HttpEndpointBufferingHints = function(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1HttpEndpointCommonAttribute = function(output, context) {
    return {
        AttributeName: output.AttributeName !== undefined && output.AttributeName !== null ? output.AttributeName : undefined,
        AttributeValue: output.AttributeValue !== undefined && output.AttributeValue !== null ? output.AttributeValue : undefined
    };
};
var deserializeAws_json1_1HttpEndpointCommonAttributesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1HttpEndpointCommonAttribute(entry, context);
    });
};
var deserializeAws_json1_1HttpEndpointDescription = function(output, context) {
    return {
        Name: output.Name !== undefined && output.Name !== null ? output.Name : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_json1_1HttpEndpointDestinationDescription = function(output, context) {
    return {
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1HttpEndpointBufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        EndpointConfiguration: output.EndpointConfiguration !== undefined && output.EndpointConfiguration !== null ? deserializeAws_json1_1HttpEndpointDescription(output.EndpointConfiguration, context) : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RequestConfiguration: output.RequestConfiguration !== undefined && output.RequestConfiguration !== null ? deserializeAws_json1_1HttpEndpointRequestConfiguration(output.RequestConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1HttpEndpointRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1HttpEndpointRequestConfiguration = function(output, context) {
    return {
        CommonAttributes: output.CommonAttributes !== undefined && output.CommonAttributes !== null ? deserializeAws_json1_1HttpEndpointCommonAttributesList(output.CommonAttributes, context) : undefined,
        ContentEncoding: output.ContentEncoding !== undefined && output.ContentEncoding !== null ? output.ContentEncoding : undefined
    };
};
var deserializeAws_json1_1HttpEndpointRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1InputFormatConfiguration = function(output, context) {
    return {
        Deserializer: output.Deserializer !== undefined && output.Deserializer !== null ? deserializeAws_json1_1Deserializer(output.Deserializer, context) : undefined
    };
};
var deserializeAws_json1_1InvalidArgumentException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidKMSResourceException = function(output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KinesisStreamSourceDescription = function(output, context) {
    return {
        DeliveryStartTimestamp: output.DeliveryStartTimestamp !== undefined && output.DeliveryStartTimestamp !== null ? new Date(Math.round(output.DeliveryStartTimestamp * 1000)) : undefined,
        KinesisStreamARN: output.KinesisStreamARN !== undefined && output.KinesisStreamARN !== null ? output.KinesisStreamARN : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined
    };
};
var deserializeAws_json1_1KMSEncryptionConfig = function(output, context) {
    return {
        AWSKMSKeyARN: output.AWSKMSKeyARN !== undefined && output.AWSKMSKeyARN !== null ? output.AWSKMSKeyARN : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListDeliveryStreamsOutput = function(output, context) {
    return {
        DeliveryStreamNames: output.DeliveryStreamNames !== undefined && output.DeliveryStreamNames !== null ? deserializeAws_json1_1DeliveryStreamNameList(output.DeliveryStreamNames, context) : undefined,
        HasMoreDeliveryStreams: output.HasMoreDeliveryStreams !== undefined && output.HasMoreDeliveryStreams !== null ? output.HasMoreDeliveryStreams : undefined
    };
};
var deserializeAws_json1_1ListOfNonEmptyStrings = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamOutput = function(output, context) {
    return {
        HasMoreTags: output.HasMoreTags !== undefined && output.HasMoreTags !== null ? output.HasMoreTags : undefined,
        Tags: output.Tags !== undefined && output.Tags !== null ? deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList(output.Tags, context) : undefined
    };
};
var deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Tag(entry, context);
    });
};
var deserializeAws_json1_1OpenXJsonSerDe = function(output, context) {
    return {
        CaseInsensitive: output.CaseInsensitive !== undefined && output.CaseInsensitive !== null ? output.CaseInsensitive : undefined,
        ColumnToJsonKeyMappings: output.ColumnToJsonKeyMappings !== undefined && output.ColumnToJsonKeyMappings !== null ? deserializeAws_json1_1ColumnToJsonKeyMappings(output.ColumnToJsonKeyMappings, context) : undefined,
        ConvertDotsInJsonKeysToUnderscores: output.ConvertDotsInJsonKeysToUnderscores !== undefined && output.ConvertDotsInJsonKeysToUnderscores !== null ? output.ConvertDotsInJsonKeysToUnderscores : undefined
    };
};
var deserializeAws_json1_1OrcSerDe = function(output, context) {
    return {
        BlockSizeBytes: output.BlockSizeBytes !== undefined && output.BlockSizeBytes !== null ? output.BlockSizeBytes : undefined,
        BloomFilterColumns: output.BloomFilterColumns !== undefined && output.BloomFilterColumns !== null ? deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(output.BloomFilterColumns, context) : undefined,
        BloomFilterFalsePositiveProbability: output.BloomFilterFalsePositiveProbability !== undefined && output.BloomFilterFalsePositiveProbability !== null ? output.BloomFilterFalsePositiveProbability : undefined,
        Compression: output.Compression !== undefined && output.Compression !== null ? output.Compression : undefined,
        DictionaryKeyThreshold: output.DictionaryKeyThreshold !== undefined && output.DictionaryKeyThreshold !== null ? output.DictionaryKeyThreshold : undefined,
        EnablePadding: output.EnablePadding !== undefined && output.EnablePadding !== null ? output.EnablePadding : undefined,
        FormatVersion: output.FormatVersion !== undefined && output.FormatVersion !== null ? output.FormatVersion : undefined,
        PaddingTolerance: output.PaddingTolerance !== undefined && output.PaddingTolerance !== null ? output.PaddingTolerance : undefined,
        RowIndexStride: output.RowIndexStride !== undefined && output.RowIndexStride !== null ? output.RowIndexStride : undefined,
        StripeSizeBytes: output.StripeSizeBytes !== undefined && output.StripeSizeBytes !== null ? output.StripeSizeBytes : undefined
    };
};
var deserializeAws_json1_1OutputFormatConfiguration = function(output, context) {
    return {
        Serializer: output.Serializer !== undefined && output.Serializer !== null ? deserializeAws_json1_1Serializer(output.Serializer, context) : undefined
    };
};
var deserializeAws_json1_1ParquetSerDe = function(output, context) {
    return {
        BlockSizeBytes: output.BlockSizeBytes !== undefined && output.BlockSizeBytes !== null ? output.BlockSizeBytes : undefined,
        Compression: output.Compression !== undefined && output.Compression !== null ? output.Compression : undefined,
        EnableDictionaryCompression: output.EnableDictionaryCompression !== undefined && output.EnableDictionaryCompression !== null ? output.EnableDictionaryCompression : undefined,
        MaxPaddingBytes: output.MaxPaddingBytes !== undefined && output.MaxPaddingBytes !== null ? output.MaxPaddingBytes : undefined,
        PageSizeBytes: output.PageSizeBytes !== undefined && output.PageSizeBytes !== null ? output.PageSizeBytes : undefined,
        WriterVersion: output.WriterVersion !== undefined && output.WriterVersion !== null ? output.WriterVersion : undefined
    };
};
var deserializeAws_json1_1ProcessingConfiguration = function(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        Processors: output.Processors !== undefined && output.Processors !== null ? deserializeAws_json1_1ProcessorList(output.Processors, context) : undefined
    };
};
var deserializeAws_json1_1Processor = function(output, context) {
    return {
        Parameters: output.Parameters !== undefined && output.Parameters !== null ? deserializeAws_json1_1ProcessorParameterList(output.Parameters, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var deserializeAws_json1_1ProcessorList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Processor(entry, context);
    });
};
var deserializeAws_json1_1ProcessorParameter = function(output, context) {
    return {
        ParameterName: output.ParameterName !== undefined && output.ParameterName !== null ? output.ParameterName : undefined,
        ParameterValue: output.ParameterValue !== undefined && output.ParameterValue !== null ? output.ParameterValue : undefined
    };
};
var deserializeAws_json1_1ProcessorParameterList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ProcessorParameter(entry, context);
    });
};
var deserializeAws_json1_1PutRecordBatchOutput = function(output, context) {
    return {
        Encrypted: output.Encrypted !== undefined && output.Encrypted !== null ? output.Encrypted : undefined,
        FailedPutCount: output.FailedPutCount !== undefined && output.FailedPutCount !== null ? output.FailedPutCount : undefined,
        RequestResponses: output.RequestResponses !== undefined && output.RequestResponses !== null ? deserializeAws_json1_1PutRecordBatchResponseEntryList(output.RequestResponses, context) : undefined
    };
};
var deserializeAws_json1_1PutRecordBatchResponseEntry = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        ErrorMessage: output.ErrorMessage !== undefined && output.ErrorMessage !== null ? output.ErrorMessage : undefined,
        RecordId: output.RecordId !== undefined && output.RecordId !== null ? output.RecordId : undefined
    };
};
var deserializeAws_json1_1PutRecordBatchResponseEntryList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1PutRecordBatchResponseEntry(entry, context);
    });
};
var deserializeAws_json1_1PutRecordOutput = function(output, context) {
    return {
        Encrypted: output.Encrypted !== undefined && output.Encrypted !== null ? output.Encrypted : undefined,
        RecordId: output.RecordId !== undefined && output.RecordId !== null ? output.RecordId : undefined
    };
};
var deserializeAws_json1_1RedshiftDestinationDescription = function(output, context) {
    return {
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        ClusterJDBCURL: output.ClusterJDBCURL !== undefined && output.ClusterJDBCURL !== null ? output.ClusterJDBCURL : undefined,
        CopyCommand: output.CopyCommand !== undefined && output.CopyCommand !== null ? deserializeAws_json1_1CopyCommand(output.CopyCommand, context) : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1RedshiftRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupDescription: output.S3BackupDescription !== undefined && output.S3BackupDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3BackupDescription, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        Username: output.Username !== undefined && output.Username !== null ? output.Username : undefined
    };
};
var deserializeAws_json1_1RedshiftRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1ResourceInUseException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1S3DestinationDescription = function(output, context) {
    return {
        BucketARN: output.BucketARN !== undefined && output.BucketARN !== null ? output.BucketARN : undefined,
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1BufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        CompressionFormat: output.CompressionFormat !== undefined && output.CompressionFormat !== null ? output.CompressionFormat : undefined,
        EncryptionConfiguration: output.EncryptionConfiguration !== undefined && output.EncryptionConfiguration !== null ? deserializeAws_json1_1EncryptionConfiguration(output.EncryptionConfiguration, context) : undefined,
        ErrorOutputPrefix: output.ErrorOutputPrefix !== undefined && output.ErrorOutputPrefix !== null ? output.ErrorOutputPrefix : undefined,
        Prefix: output.Prefix !== undefined && output.Prefix !== null ? output.Prefix : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined
    };
};
var deserializeAws_json1_1SchemaConfiguration = function(output, context) {
    return {
        CatalogId: output.CatalogId !== undefined && output.CatalogId !== null ? output.CatalogId : undefined,
        DatabaseName: output.DatabaseName !== undefined && output.DatabaseName !== null ? output.DatabaseName : undefined,
        Region: output.Region !== undefined && output.Region !== null ? output.Region : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        TableName: output.TableName !== undefined && output.TableName !== null ? output.TableName : undefined,
        VersionId: output.VersionId !== undefined && output.VersionId !== null ? output.VersionId : undefined
    };
};
var deserializeAws_json1_1SecurityGroupIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1Serializer = function(output, context) {
    return {
        OrcSerDe: output.OrcSerDe !== undefined && output.OrcSerDe !== null ? deserializeAws_json1_1OrcSerDe(output.OrcSerDe, context) : undefined,
        ParquetSerDe: output.ParquetSerDe !== undefined && output.ParquetSerDe !== null ? deserializeAws_json1_1ParquetSerDe(output.ParquetSerDe, context) : undefined
    };
};
var deserializeAws_json1_1ServiceUnavailableException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1SourceDescription = function(output, context) {
    return {
        KinesisStreamSourceDescription: output.KinesisStreamSourceDescription !== undefined && output.KinesisStreamSourceDescription !== null ? deserializeAws_json1_1KinesisStreamSourceDescription(output.KinesisStreamSourceDescription, context) : undefined
    };
};
var deserializeAws_json1_1SplunkDestinationDescription = function(output, context) {
    return {
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        HECAcknowledgmentTimeoutInSeconds: output.HECAcknowledgmentTimeoutInSeconds !== undefined && output.HECAcknowledgmentTimeoutInSeconds !== null ? output.HECAcknowledgmentTimeoutInSeconds : undefined,
        HECEndpoint: output.HECEndpoint !== undefined && output.HECEndpoint !== null ? output.HECEndpoint : undefined,
        HECEndpointType: output.HECEndpointType !== undefined && output.HECEndpointType !== null ? output.HECEndpointType : undefined,
        HECToken: output.HECToken !== undefined && output.HECToken !== null ? output.HECToken : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1SplunkRetryOptions(output.RetryOptions, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1SplunkRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1SubnetIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1Tag = function(output, context) {
    return {
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var deserializeAws_json1_1TagDeliveryStreamOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1UntagDeliveryStreamOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1UpdateDestinationOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1VpcConfigurationDescription = function(output, context) {
    return {
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        SecurityGroupIds: output.SecurityGroupIds !== undefined && output.SecurityGroupIds !== null ? deserializeAws_json1_1SecurityGroupIdList(output.SecurityGroupIds, context) : undefined,
        SubnetIds: output.SubnetIds !== undefined && output.SubnetIds !== null ? deserializeAws_json1_1SubnetIdList(output.SubnetIds, context) : undefined,
        VpcId: output.VpcId !== undefined && output.VpcId !== null ? output.VpcId : undefined
    };
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"hIjnq","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hTgdX":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>AmazonPersonalizeProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _clientPersonalizeEvents = require("@aws-sdk/client-personalize-events");
var _amazonPersonalizeHelper = require("./AmazonPersonalizeHelper");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("AmazonPersonalizeProvider");
// events buffer
var FLUSH_SIZE = 5;
var FLUSH_SIZE_THRESHHOLD = 10;
var FLUSH_INTERVAL = 5000; // 5s
var IDENTIFY_EVENT = "Identify";
var AmazonPersonalizeProvider = /** @class */ function() {
    function AmazonPersonalizeProvider(config) {
        this._buffer = [];
        this._config = config ? config : {};
        this._config.flushSize = this._config.flushSize > 0 && this._config.flushSize <= FLUSH_SIZE_THRESHHOLD ? this._config.flushSize : FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._sessionManager = new (0, _amazonPersonalizeHelper.SessionInfoManager)();
        if (!(0, _isEmptyDefault.default)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._isBrowser = (0, _core.browserOrNode)().isBrowser;
        // flush event buffer
        this._setupTimer();
    }
    AmazonPersonalizeProvider.prototype._setupTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var flushInterval = this._config.flushInterval;
        var that = this;
        this._timer = setInterval(function() {
            that._sendFromBuffer();
        }, flushInterval);
    };
    /**
     * Record event
     * @param eventType      - type of the event action. e.g. "Click"
     * @param properties     - properties of the event
     * @return Promise
     */ AmazonPersonalizeProvider.prototype.record = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, _a, eventType, properties, requestParams, isLoaded;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials,
                            sentAt: new Date()
                        });
                        _a = params.event, eventType = _a.eventType, properties = _a.properties;
                        if (eventType === IDENTIFY_EVENT) {
                            this._sessionManager.updateSessionInfo(properties && properties.userId ? properties.userId : "", this._sessionInfo);
                            return [
                                2 /*return*/ 
                            ];
                        } else if (!(0, _isEmptyDefault.default)(params.event.userId)) this._sessionManager.updateSessionInfo(params.event.userId, this._sessionInfo);
                        requestParams = this.generateRequestParams(params, this._sessionInfo);
                        if (!(eventType === "MediaAutoTrack")) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!this._isBrowser) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!!(0, _isEmptyDefault.default)((0, _getDefault.default)(requestParams, "eventData.properties.domElementId", null))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.isElementFullyLoaded(this.loadElement, requestParams.eventData.properties["domElementId"], 500, 5)
                        ];
                    case 2:
                        isLoaded = _b.sent();
                        if (isLoaded) new (0, _amazonPersonalizeHelper.MediaAutoTrack)(requestParams, this);
                        else logger.debug("Cannot find the media element.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        logger.debug("Missing domElementId field in 'properties' for MediaAutoTrack event type.");
                        _b.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        logger.debug("MediaAutoTrack only for browser");
                        _b.label = 6;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            this.putToBuffer(requestParams)
                        ];
                }
            });
        });
    };
    AmazonPersonalizeProvider.prototype.loadElement = function(domId) {
        return new Promise(function(resolve, reject) {
            if (document.getElementById(domId) && document.getElementById(domId).clientHeight) return resolve(true);
            else return reject(true);
        });
    };
    AmazonPersonalizeProvider.prototype.isElementFullyLoaded = function(operation, params, delay, times) {
        var _this = this;
        var wait = function(ms) {
            return new Promise(function(r) {
                return setTimeout(r, ms);
            });
        };
        return new Promise(function(resolve, reject) {
            return operation(params).then(resolve).catch(function(reason) {
                if (times - 1 > 0) return wait(delay).then(_this.isElementFullyLoaded.bind(null, operation, params, delay, times - 1)).then(resolve).catch(reject);
                return reject(reason);
            });
        });
    };
    /**
     * get the category of the plugin
     */ AmazonPersonalizeProvider.prototype.getCategory = function() {
        return "Analytics";
    };
    /**
     * get provider name of the plugin
     */ AmazonPersonalizeProvider.prototype.getProviderName = function() {
        return "AmazonPersonalize";
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AmazonPersonalizeProvider.prototype.configure = function(config) {
        logger.debug("configure Analytics", config);
        var conf = config ? config : {};
        this._config = Object.assign({}, this._config, conf);
        if (!(0, _isEmptyDefault.default)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._setupTimer();
        return this._config;
    };
    /**
     * Generate the requestParams from customer input params and sessionInfo
     * @private
     * @param eventData      - customer input for event data
     * @param api            - api name
     * @return RequestParams - wrapper object with all information required for make request
     */ AmazonPersonalizeProvider.prototype.generateRequestParams = function(params, sessionInfo) {
        var requestParams = {};
        var _a = params.event, eventType = _a.eventType, properties = _a.properties;
        requestParams.eventData = {
            eventType: eventType,
            properties: properties
        };
        requestParams.sessionInfo = sessionInfo;
        requestParams.sentAt = params.sentAt;
        requestParams.credentials = params.credentials;
        requestParams.config = params.config;
        return requestParams;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AmazonPersonalizeProvider.prototype._sendEvents = function(group) {
        var groupLen = group.length;
        if (groupLen === 0) {
            logger.debug("events array is empty, directly return");
            return;
        }
        var _a = group[0], config = _a.config, credentials = _a.credentials, sessionInfo = _a.sessionInfo;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        if (groupLen > 0) {
            var events = [];
            for(var i = 0; i < groupLen; i += 1){
                var params = group.shift();
                var eventPayload = this._generateSingleRecordPayload(params, sessionInfo);
                events.push(eventPayload);
            }
            var payload_1 = {};
            payload_1.trackingId = sessionInfo.trackingId;
            payload_1.sessionId = sessionInfo.sessionId;
            payload_1.userId = sessionInfo.userId;
            payload_1.eventList = [];
            events.forEach(function(event) {
                // @ts-ignore
                payload_1.eventList.push(event);
            });
            var command = new (0, _clientPersonalizeEvents.PutEventsCommand)(payload_1);
            this._personalize.send(command, function(err) {
                if (err) logger.debug("Failed to call putEvents in Personalize", err);
                else logger.debug("Put events");
            });
        }
    };
    /**
     * Put event into buffer
     * @private
     * @param params - params for the event recording
     */ AmazonPersonalizeProvider.prototype.putToBuffer = function(params) {
        if (this._buffer.length < this._config.flushSize) this._buffer.push(params);
        else {
            this._buffer.push(params);
            this._sendFromBuffer();
        }
        return Promise.resolve(true);
    };
    /**
     * flush the buffer and batch sending the request
     * @private
     * @param eventsParams - the buffer for cache the payload
     */ AmazonPersonalizeProvider.prototype._sendFromBuffer = function() {
        var _this = this;
        var size = this._buffer.length;
        if (size <= 0) return;
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < size; i += 1){
            var currRequestParams = this._buffer.shift();
            var cred = currRequestParams.credentials;
            var sessionInfo = currRequestParams.sessionInfo;
            if (i === 0) {
                group.push(currRequestParams);
                preCred = cred;
            } else if ((0, _isEqualDefault.default)(sessionInfo, this._sessionInfo) && cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                logger.debug("no change for cred, put event in the same group");
                group.push(currRequestParams);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(currRequestParams);
                preCred = cred;
                this._sessionInfo = sessionInfo;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(group) {
            _this._sendEvents(group);
        });
    };
    /**
     * Generate the record payload for single event
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._generateSingleRecordPayload = function(params, sessionInfo) {
        var eventData = params.eventData, sentAt = params.sentAt;
        var trackPayload = {};
        trackPayload.sentAt = sentAt;
        trackPayload.properties = eventData.properties && JSON.stringify(eventData.properties);
        trackPayload.eventId = this._sessionManager.getTimerKey() + sessionInfo.sessionId;
        trackPayload.eventType = eventData.eventType;
        return trackPayload;
    };
    /**
     * Initialize the personalize client
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._init = function(config, credentials) {
        logger.debug("init clients");
        if (this._personalize && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        logger.debug("initialize personalize with credentials", credentials);
        this._personalize = new (0, _clientPersonalizeEvents.PersonalizeEventsClient)({
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record)
        });
        return true;
    };
    /**
     * check if current credentials exists
     * @private
     */ AmazonPersonalizeProvider.prototype._getCredentials = function() {
        var that = this;
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return null;
            logger.debug("set credentials for analytics", that._config.credentials);
            return (0, _core.Credentials).shear(credentials);
        }).catch(function(err) {
            logger.debug("ensure credentials error", err);
            return null;
        });
    };
    return AmazonPersonalizeProvider;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@aws-sdk/client-personalize-events":"2JAq3","./AmazonPersonalizeHelper":"dRHD2","lodash/get":"4u8u0","lodash/isEmpty":"2iSgw","lodash/isEqual":"6oIYS","../utils/UserAgent":"PNdyN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2JAq3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _personalizeEventsClient = require("./PersonalizeEventsClient");
parcelHelpers.exportAll(_personalizeEventsClient, exports);
var _personalizeEvents = require("./PersonalizeEvents");
parcelHelpers.exportAll(_personalizeEvents, exports);
var _putEventsCommand = require("./commands/PutEventsCommand");
parcelHelpers.exportAll(_putEventsCommand, exports);
var _putItemsCommand = require("./commands/PutItemsCommand");
parcelHelpers.exportAll(_putItemsCommand, exports);
var _putUsersCommand = require("./commands/PutUsersCommand");
parcelHelpers.exportAll(_putUsersCommand, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./PersonalizeEventsClient":"69PbR","./PersonalizeEvents":false,"./commands/PutEventsCommand":"1oHsm","./commands/PutItemsCommand":false,"./commands/PutUsersCommand":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"69PbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PersonalizeEventsClient", ()=>PersonalizeEventsClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Amazon Personalize can consume real-time user event data, such as <i>stream</i> or <i>click</i> data, and use
 *       it for model training either alone or combined with historical data. For more information see <a>recording-events</a>.</p>
 */ var PersonalizeEventsClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(PersonalizeEventsClient, _super);
    function PersonalizeEventsClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    PersonalizeEventsClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return PersonalizeEventsClient;
}((0, _smithyClient.Client));

},{"tslib":"9YbKG","./runtimeConfig":"aScrl","@aws-sdk/config-resolver":"jqbdY","@aws-sdk/middleware-content-length":"bExw4","@aws-sdk/middleware-host-header":"5YhFE","@aws-sdk/middleware-logger":"lMIjC","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/middleware-signing":"9ClYY","@aws-sdk/middleware-user-agent":"58lW5","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9YbKG":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aScrl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"9YbKG","./package.json":"lVvUp","@aws-crypto/sha256-browser":"fOaO0","@aws-sdk/fetch-http-handler":"cl6qU","@aws-sdk/invalid-dependency":"hRSjn","@aws-sdk/middleware-retry":"bTgA6","@aws-sdk/util-base64-browser":"gYMH3","@aws-sdk/util-body-length-browser":"11eVP","@aws-sdk/util-user-agent-browser":"iESJS","@aws-sdk/util-utf8-browser":"eMTun","./runtimeConfig.shared":"gKNFb","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lVvUp":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-personalize-events","description":"AWS SDK for JavaScript Personalize Events Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-personalize-events","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-personalize-events"}}');

},{}],"fOaO0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("9da47d8a5f341d27");
(0, tslib_1.__exportStar)(require("dcd24c7f39859df1"), exports);
var ie11Sha256_1 = require("35ffc1238b0877e");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("c2db05257652fd49");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"9da47d8a5f341d27":"iPwCd","dcd24c7f39859df1":"d0LfU","35ffc1238b0877e":"gbG6L","c2db05257652fd49":"69LNw"}],"iPwCd":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d0LfU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("d9c90e6f3b5159ee");
var webCryptoSha256_1 = require("cdf036c62c8e7fa7");
var sha256_js_1 = require("97d1e993f05b9100");
var supports_web_crypto_1 = require("5e6b12dab186a703");
var ie11_detection_1 = require("1820bf929291ad24");
var util_locate_window_1 = require("6f63fd68b3362c99");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"d9c90e6f3b5159ee":"gbG6L","cdf036c62c8e7fa7":"69LNw","97d1e993f05b9100":"2lT2F","5e6b12dab186a703":"dfXPJ","1820bf929291ad24":"9jIDN","6f63fd68b3362c99":"iQfdF"}],"gbG6L":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("4aabfc3673833be1");
var constants_1 = require("7f615848067865b9");
var util_utf8_browser_1 = require("7749824800dbd48f");
var util_locate_window_1 = require("17f40bd6e4a67e54");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"4aabfc3673833be1":"9aO3O","7f615848067865b9":"8BHcz","7749824800dbd48f":"eMTun","17f40bd6e4a67e54":"iQfdF"}],"9aO3O":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"8BHcz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"eMTun":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"cnegR","./whatwgEncodingApi":"5uhYN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cnegR":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5uhYN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"69LNw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("e7403ad7bd5d7bcb");
var constants_1 = require("663eb21d688ee3ba");
var util_locate_window_1 = require("5e7e106f8d80ee06");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"e7403ad7bd5d7bcb":"9izDy","663eb21d688ee3ba":"8BHcz","5e7e106f8d80ee06":"iQfdF"}],"9izDy":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("112f73d96d8deb8d");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("a044e4438601f0e2");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("4127b906809a3524");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("6a9ca298559c347e");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"112f73d96d8deb8d":"l86fd","a044e4438601f0e2":"cU2z8","4127b906809a3524":"7jHSh","6a9ca298559c347e":"bpse8"}],"l86fd":[function(require,module,exports) {
var Buffer = require("bf3442267304c25d").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("c49107bff8ba1cd5");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"bf3442267304c25d":"8EcTH","c49107bff8ba1cd5":"eMTun"}],"cU2z8":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"7jHSh":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"bpse8":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"2lT2F":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("b8abfafc26c38be7");
(0, tslib_1.__exportStar)(require("7c2eba3089391f9e"), exports);

},{"b8abfafc26c38be7":"kUZHy","7c2eba3089391f9e":"b0kB2"}],"kUZHy":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b0kB2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("d91e610130417538");
var constants_1 = require("d9a869755bd8747e");
var RawSha256_1 = require("952b22bdd005e358");
var util_1 = require("69f77cebc5988e74");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"d91e610130417538":"kUZHy","d9a869755bd8747e":"4uV47","952b22bdd005e358":"b9toT","69f77cebc5988e74":"9izDy"}],"4uV47":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"b9toT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("890a54d4069ed041");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"890a54d4069ed041":"4uV47"}],"dfXPJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("b91fdb9b671b2f83");
tslib_1.__exportStar(require("c1828ad96d4bbd48"), exports);

},{"b91fdb9b671b2f83":"25mHd","c1828ad96d4bbd48":"kJcxn"}],"25mHd":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kJcxn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("52ab67d7e0ea946f");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"52ab67d7e0ea946f":"25mHd"}],"9jIDN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("dc772b7fe6bf4832");
tslib_1.__exportStar(require("f1d97167f03fcfc0"), exports);
tslib_1.__exportStar(require("d7fec7664293be9b"), exports);
tslib_1.__exportStar(require("c1c9d4eca32567b4"), exports);
tslib_1.__exportStar(require("6b8d83431ea60d6f"), exports);
tslib_1.__exportStar(require("7554284ad6746167"), exports);

},{"dc772b7fe6bf4832":"iXhwf","f1d97167f03fcfc0":"1wdYg","d7fec7664293be9b":"l2Vxc","c1c9d4eca32567b4":"ggchj","6b8d83431ea60d6f":"3Akd0","7554284ad6746167":"hq8TS"}],"iXhwf":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1wdYg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"l2Vxc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"ggchj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"3Akd0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"hq8TS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"iESJS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"jyT97","bowser":"oLvzi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jyT97":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gKNFb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2018-03-22",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Personalize Events",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"cQg9c","@aws-sdk/url-parser":"gQeEv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cQg9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "personalize-events.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "personalize-events.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "personalize-events.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "personalize-events.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "personalize-events.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    region;
    if (AWS_REGIONS.has(region)) regionInfo = {
        hostname: AWS_TEMPLATE.replace("{region}", region),
        partition: "aws"
    };
    if (AWS_CN_REGIONS.has(region)) regionInfo = {
        hostname: AWS_CN_TEMPLATE.replace("{region}", region),
        partition: "aws-cn"
    };
    if (AWS_ISO_REGIONS.has(region)) regionInfo = {
        hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
        partition: "aws-iso"
    };
    if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
        hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
        partition: "aws-iso-b"
    };
    if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
        hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
        partition: "aws-us-gov"
    };
    // Finally, assume it's an AWS partition endpoint.
    if (regionInfo === undefined) regionInfo = {
        hostname: AWS_TEMPLATE.replace("{region}", region),
        partition: "aws"
    };
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "personalize"
    }, regionInfo));
};

},{"tslib":"9YbKG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5YhFE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"jpjrI","@aws-sdk/protocol-http":"8mE6Q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jpjrI":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lMIjC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"cYRoU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cYRoU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"4EtbB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4EtbB":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"58lW5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"jD6At","./user-agent-middleware":"ckARK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jD6At":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"k0L8W","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k0L8W":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ckARK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, _constants.X_AMZ_USER_AGENT] = (0, _tslib.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, _constants.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, _constants.USER_AGENT] = headers[0, _constants.USER_AGENT] ? headers[0, _constants.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"k0L8W","@aws-sdk/protocol-http":"8mE6Q","./constants":"6mRiu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6mRiu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1oHsm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutEventsCommand", ()=>PutEventsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Records user interaction event data. For more information see <a>event-record-api</a>.</p>
 */ var PutEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PersonalizeEventsClient";
        var commandName = "PutEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PutEventsCommand)(input, context);
    };
    PutEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PutEventsCommand)(output, context);
    };
    return PutEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"9YbKG","../models/models_0":"f7Fqv","../protocols/Aws_restJson1":"17pc2","@aws-sdk/middleware-serde":"bIoq4","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"f7Fqv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidInputException", ()=>InvalidInputException);
parcelHelpers.export(exports, "Event", ()=>Event);
parcelHelpers.export(exports, "PutEventsRequest", ()=>PutEventsRequest);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "PutItemsRequest", ()=>PutItemsRequest);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "User", ()=>User);
parcelHelpers.export(exports, "PutUsersRequest", ()=>PutUsersRequest);
var _tslib = require("tslib");
var InvalidInputException;
(function(InvalidInputException) {
    InvalidInputException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidInputException || (InvalidInputException = {}));
var Event;
(function(Event) {
    Event.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Event || (Event = {}));
var PutEventsRequest;
(function(PutEventsRequest) {
    PutEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutEventsRequest || (PutEventsRequest = {}));
var Item;
(function(Item) {
    Item.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Item || (Item = {}));
var PutItemsRequest;
(function(PutItemsRequest) {
    PutItemsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutItemsRequest || (PutItemsRequest = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var User;
(function(User) {
    User.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(User || (User = {}));
var PutUsersRequest;
(function(PutUsersRequest) {
    PutUsersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutUsersRequest || (PutUsersRequest = {}));

},{"tslib":"9YbKG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"17pc2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1PutEventsCommand", ()=>serializeAws_restJson1PutEventsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutItemsCommand", ()=>serializeAws_restJson1PutItemsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutUsersCommand", ()=>serializeAws_restJson1PutUsersCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutEventsCommand", ()=>deserializeAws_restJson1PutEventsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutItemsCommand", ()=>deserializeAws_restJson1PutItemsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutUsersCommand", ()=>deserializeAws_restJson1PutUsersCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var serializeAws_restJson1PutEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/events";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.eventList !== undefined && input.eventList !== null && {
                        eventList: serializeAws_restJson1EventList(input.eventList, context)
                    }), input.sessionId !== undefined && input.sessionId !== null && {
                        sessionId: input.sessionId
                    }), input.trackingId !== undefined && input.trackingId !== null && {
                        trackingId: input.trackingId
                    }), input.userId !== undefined && input.userId !== null && {
                        userId: input.userId
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutItemsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/items";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.datasetArn !== undefined && input.datasetArn !== null && {
                        datasetArn: input.datasetArn
                    }), input.items !== undefined && input.items !== null && {
                        items: serializeAws_restJson1ItemList(input.items, context)
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutUsersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/users";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.datasetArn !== undefined && input.datasetArn !== null && {
                        datasetArn: input.datasetArn
                    }), input.users !== undefined && input.users !== null && {
                        users: serializeAws_restJson1UserList(input.users, context)
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutEventsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutItemsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutItemsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutItemsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.personalizeevents#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutUsersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutUsersCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutUsersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.personalizeevents#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1InvalidInputExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = {
                name: "InvalidInputException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput),
                message: undefined
            };
            data = parsedOutput.body;
            if (data.message !== undefined && data.message !== null) contents.message = data.message;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = {
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput),
                message: undefined
            };
            data = parsedOutput.body;
            if (data.message !== undefined && data.message !== null) contents.message = data.message;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_restJson1Event = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.eventId !== undefined && input.eventId !== null && {
        eventId: input.eventId
    }), input.eventType !== undefined && input.eventType !== null && {
        eventType: input.eventType
    }), input.eventValue !== undefined && input.eventValue !== null && {
        eventValue: input.eventValue
    }), input.impression !== undefined && input.impression !== null && {
        impression: serializeAws_restJson1Impression(input.impression, context)
    }), input.itemId !== undefined && input.itemId !== null && {
        itemId: input.itemId
    }), input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    }), input.recommendationId !== undefined && input.recommendationId !== null && {
        recommendationId: input.recommendationId
    }), input.sentAt !== undefined && input.sentAt !== null && {
        sentAt: Math.round(input.sentAt.getTime() / 1000)
    });
};
var serializeAws_restJson1EventList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1Event(entry, context);
    });
};
var serializeAws_restJson1Impression = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_restJson1Item = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.itemId !== undefined && input.itemId !== null && {
        itemId: input.itemId
    }), input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    });
};
var serializeAws_restJson1ItemList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1Item(entry, context);
    });
};
var serializeAws_restJson1User = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    }), input.userId !== undefined && input.userId !== null && {
        userId: input.userId
    });
};
var serializeAws_restJson1UserList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1User(entry, context);
    });
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"9YbKG","@aws-sdk/protocol-http":"8mE6Q","@aws-sdk/smithy-client":"2tZeK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dRHD2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionInfoManager", ()=>(0, _sessionInfoManager.SessionInfoManager));
parcelHelpers.export(exports, "MediaAutoTrack", ()=>(0, _mediaAutoTrack.MediaAutoTrack));
var _sessionInfoManager = require("./SessionInfoManager");
var _mediaAutoTrack = require("./MediaAutoTrack");

},{"./SessionInfoManager":"7v4FV","./MediaAutoTrack":"aOBZh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7v4FV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionInfoManager", ()=>SessionInfoManager);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _uuid = require("uuid");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var PERSONALIZE_CACHE = "_awsct";
var PERSONALIZE_CACHE_USERID = "_awsct_uid";
var PERSONALIZE_CACHE_SESSIONID = "_awsct_sid";
var DEFAULT_CACHE_PREFIX = "personalize";
var TIMER_INTERVAL = 30000;
var DELIMITER = ".";
var CACHE_EXPIRY_IN_DAYS = 7;
var logger = new (0, _core.ConsoleLogger)("AmazonPersonalizeProvider");
var SessionInfoManager = /** @class */ function() {
    function SessionInfoManager(prefixKey) {
        if (prefixKey === void 0) prefixKey = "";
        this._isBrowser = (0, _core.browserOrNode)().isBrowser;
        this._timerKey = (0, _uuid.v1)().substr(0, 15);
        this._refreshTimer();
    }
    SessionInfoManager.prototype._refreshTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var that = this;
        this._timer = setInterval(function() {
            that._timerKey = (0, _uuid.v1)().substr(0, 15);
        }, TIMER_INTERVAL);
    };
    SessionInfoManager.prototype.storeValue = function(key, value) {
        var today = new Date();
        var expire = new Date();
        expire.setTime(today.getTime() + 86400000 * CACHE_EXPIRY_IN_DAYS);
        (0, _cache.Cache).setItem(this._getCachePrefix(key), value, {
            expires: expire.getTime()
        });
    };
    SessionInfoManager.prototype.retrieveValue = function(key) {
        return (0, _cache.Cache).getItem(this._getCachePrefix(key));
    };
    SessionInfoManager.prototype._getCachePrefix = function(key) {
        if (this._isBrowser) return key + DELIMITER + window.location.host;
        return DEFAULT_CACHE_PREFIX;
    };
    SessionInfoManager.prototype.getTimerKey = function() {
        return this._timerKey;
    };
    SessionInfoManager.prototype.updateSessionInfo = function(userId, sessionInfo) {
        var existUserId = sessionInfo.userId;
        var existSessionId = sessionInfo.sessionId;
        if (this._isRequireNewSession(userId, existUserId, existSessionId)) {
            var newSessionId = (0, _uuid.v1)();
            this.storeValue(PERSONALIZE_CACHE_USERID, userId);
            this.storeValue(PERSONALIZE_CACHE_SESSIONID, newSessionId);
            sessionInfo.sessionId = newSessionId;
        } else if (this._isRequireUpdateSessionInfo(userId, existUserId, existSessionId)) this.storeValue(PERSONALIZE_CACHE_USERID, userId);
        sessionInfo.userId = userId;
    };
    SessionInfoManager.prototype._isRequireUpdateSessionInfo = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // anonymouse => sign in : hasSession && s_userId == null && curr_userId !=null
        var isNoCachedSession = (0, _isEmptyDefault.default)(cachedSessionSessionId);
        return !isNoCachedSession && (0, _isEmptyDefault.default)(cachedSessionUserId) && !(0, _isEmptyDefault.default)(userId);
    };
    SessionInfoManager.prototype.retrieveSessionInfo = function(trackingId) {
        var sessionInfo = {};
        sessionInfo.trackingId = trackingId;
        sessionInfo.sessionId = this.retrieveValue(PERSONALIZE_CACHE_SESSIONID);
        sessionInfo.userId = this.retrieveValue(PERSONALIZE_CACHE_USERID);
        if ((0, _isEmptyDefault.default)(sessionInfo.sessionId)) {
            sessionInfo.sessionId = (0, _uuid.v1)();
            this.storeValue(PERSONALIZE_CACHE_SESSIONID, sessionInfo.sessionId);
        }
        this.storeValue(PERSONALIZE_CACHE, trackingId);
        return sessionInfo;
    };
    SessionInfoManager.prototype._isRequireNewSession = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // new session => 1. no cached session info 2. signOut: s_userId !=null && curr_userId ==null
        // 3. switch account: s_userId !=null && curr_userId !=null && s_userId != curr_userId
        var isNoCachedSession = (0, _isEmptyDefault.default)(cachedSessionSessionId);
        var isSignoutCase = (0, _isEmptyDefault.default)(userId) && !(0, _isEmptyDefault.default)(cachedSessionUserId);
        var isSwitchUserCase = !(0, _isEmptyDefault.default)(userId) && !(0, _isEmptyDefault.default)(cachedSessionUserId) && !(0, _isEqualDefault.default)(userId, cachedSessionUserId);
        return isNoCachedSession || isSignoutCase || isSwitchUserCase;
    };
    return SessionInfoManager;
}();

},{"lodash/isEmpty":"2iSgw","lodash/isEqual":"6oIYS","uuid":"9dBTc","@aws-amplify/core":"8BDOx","@aws-amplify/cache":"egrWR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2iSgw":[function(require,module,exports) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"RQWOW","d63799a808049d04":"klLMw","1f4ee6aee3a7eae0":"aZ8vK","b708be4f72c2a706":"9om8C","ab4b4eaf96f9163a":"5qgKC","80b58ade5ee2f70":"1Qhoh","3a444e8bd8b275f2":"1krvv","6af418b3352c301b":"avtgp"}],"RQWOW":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"1krvv","3ec652610d8dd5d3":"i1SdB"}],"1krvv":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"i1SdB":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"lvbwQ"}],"lvbwQ":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"klLMw":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"ayhfk","28e3344aae951f13":"eBZEY","b286298be5b1d9a4":"8Cx1x","3ae50c158f89813":"d73jL","9f458755f627d456":"6imid","8e9160b373d7fe66":"57JFO","b210627dd951641f":"hcxNU"}],"ayhfk":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"jg3e9","f83c375075418382":"5yGId"}],"jg3e9":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"gwk0R","16db51a0e009bd8c":"KxjU3"}],"gwk0R":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"cXGEE","cabbc2adfaeb27d9":"7n2Dm","cbb5703fe1562e7f":"kDBLt","388b819f47a43aa5":"hcxNU"}],"cXGEE":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"57JFO","3cba3c966459d528":"kDBLt"}],"57JFO":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"25xE8","9b2aaf31b7bdd837":"dIRcd","46d5beb3375f8a28":"6y3wG"}],"25xE8":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"5yGId"}],"5yGId":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"k1rdG"}],"k1rdG":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"dIRcd":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"25xE8"}],"6y3wG":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"kDBLt":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"7n2Dm":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"5WKuz"}],"5WKuz":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"5yGId"}],"hcxNU":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"KxjU3":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"eBZEY":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"jg3e9","29224713b8d411e6":"5yGId"}],"8Cx1x":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"jg3e9","a5c6637bac681a0":"5yGId"}],"d73jL":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"jg3e9","ca486d41cdf819d4":"5yGId"}],"6imid":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"jg3e9","7a9a6581834a8452":"5yGId"}],"aZ8vK":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"lGsva","bead821d6af018b5":"h29TI"}],"lGsva":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"57JFO","b6cdbe52dcf709f8":"h29TI"}],"h29TI":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"9om8C":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"5qgKC":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"cXGEE","f3db08d4d1110aaf":"fHDsK"}],"fHDsK":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"1Qhoh":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"5yGId","a1e87b138cf75d1d":"1j8AL"}],"1j8AL":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"avtgp":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"5FrPZ","903f50eb1c16d257":"1QTqI","fa49853a82034c30":"iT2TL"}],"5FrPZ":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"57JFO","f661b3a120d7a4cb":"fHDsK","cdd86c83797c0618":"h29TI"}],"1QTqI":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"iT2TL":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"k1rdG"}],"6oIYS":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"9Vu4W"}],"9Vu4W":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"eOY2D","809bbb0c20650dbc":"h29TI"}],"eOY2D":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"8Y9d2","96bc8a1825db53a5":"ix4L1","8bdece495e87fb69":"i22jl","bb94920432a68eca":"kdgcF","45495edff98e5837":"klLMw","18256411ae9e2858":"9om8C","e5ba7abf54247fc5":"1Qhoh","50d786bb5c7366af":"avtgp"}],"8Y9d2":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"7Zu35","ceda2a63c77c915":"8CdtQ","91ee1b348d9d7172":"kpGEB","3fe28318f65b9332":"Nk5zy","724ca4def8b84e06":"koZg4","e9ceacb40d9582bd":"dUlHy"}],"7Zu35":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"aGUql","b700cb849df2c166":"iQN9E","d76dd90eead6cced":"hlnit","3d210628ba60ec8":"7eV67","76026bf2d4cfff93":"1GIWP"}],"aGUql":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"iQN9E":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"9GZhQ"}],"9GZhQ":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"l89hZ"}],"l89hZ":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"hlnit":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"9GZhQ"}],"7eV67":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"9GZhQ"}],"1GIWP":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"9GZhQ"}],"8CdtQ":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"7Zu35"}],"kpGEB":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"Nk5zy":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"koZg4":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"dUlHy":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"7Zu35","1494efbafafa9552":"eBZEY","6049e8027fe9407f":"8jLfa"}],"8jLfa":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"2zNs3","d2967b0e32ccfa56":"2NDp7","ca21409ea89624c0":"hhpb9","f88fd07f8dd1f67d":"9A7yF","dbf3eae765642a3b":"5kUrZ"}],"2zNs3":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"jxLPg","a07dcf3fd3097a0c":"7Zu35","92c01c953ef00ded":"eBZEY"}],"jxLPg":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"aaCk4","bc25d439ccd1fb47":"5VKJR","f096b37295a92ab0":"7lCiq","d88173cbc6a133c8":"lzDQs","afb9b3bae0461cbf":"5AlG9"}],"aaCk4":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"aKy0h"}],"aKy0h":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"jg3e9"}],"5VKJR":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"7lCiq":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"aKy0h"}],"lzDQs":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"aKy0h"}],"5AlG9":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"aKy0h"}],"2NDp7":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"hm9TG"}],"hm9TG":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"950xk"}],"950xk":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"hhpb9":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"hm9TG"}],"9A7yF":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"hm9TG"}],"5kUrZ":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"hm9TG"}],"ix4L1":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"k0eRl","1ee20de911db0cb0":"6ma0g","defff3d81be91b23":"bodFg"}],"k0eRl":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"8jLfa","9a831e81e9a1f98c":"2ZD7P","1a2b6c8a7399c39f":"iPNgB"}],"2ZD7P":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"iPNgB":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"6ma0g":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"bodFg":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"i22jl":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"25xE8","dbf6aa5033a0f48":"95u9V","539966708f906e61":"l89hZ","8142d4017f0a425f":"ix4L1","48cddf732eff33ba":"jijjW","9dc78b26c5daba20":"8bilU"}],"95u9V":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"5yGId"}],"jijjW":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"8bilU":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kdgcF":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"Gpj2Q"}],"Gpj2Q":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"1aTHW","aa79b69a13f924db":"7QL3i","e3ad83e53433bc8a":"3Kdfe"}],"1aTHW":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"3WqQu","148b85918856c33a":"9om8C"}],"3WqQu":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"7QL3i":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"cfhXe","6b1c62cea92cdb9":"33JRx"}],"cfhXe":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"33JRx":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"3Kdfe":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"bJm93","e8453365fdacc8da":"RQWOW","7760b47b02971dfa":"5qgKC"}],"bJm93":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"7ZR5v","9cdb51ffa56f149b":"aZ8vK","38cd49f1e493b3d7":"9om8C","b379831fe1873fed":"1Qhoh","f362a34cd8321bb7":"ebisk","c019db5297494469":"avtgp"}],"7ZR5v":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"ebisk":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"aOBZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaAutoTrack", ()=>MediaAutoTrack);
var HTML5_MEDIA_EVENT;
(function(HTML5_MEDIA_EVENT) {
    HTML5_MEDIA_EVENT["PLAY"] = "play";
    HTML5_MEDIA_EVENT["PAUSE"] = "pause";
    HTML5_MEDIA_EVENT["ENDED"] = "Ended";
})(HTML5_MEDIA_EVENT || (HTML5_MEDIA_EVENT = {}));
var MEDIA_TYPE;
(function(MEDIA_TYPE) {
    MEDIA_TYPE["IFRAME"] = "IFRAME";
    MEDIA_TYPE["VIDEO"] = "VIDEO";
    MEDIA_TYPE["AUDIO"] = "AUDIO";
})(MEDIA_TYPE || (MEDIA_TYPE = {}));
var EVENT_TYPE;
(function(EVENT_TYPE) {
    EVENT_TYPE["PLAY"] = "Play";
    EVENT_TYPE["ENDED"] = "Ended";
    EVENT_TYPE["PAUSE"] = "Pause";
    EVENT_TYPE["TIME_WATCHED"] = "TimeWatched";
})(EVENT_TYPE || (EVENT_TYPE = {}));
var MediaAutoTrack = /** @class */ function() {
    function MediaAutoTrack(params, provider) {
        var _a;
        this.eventActionMapping = (_a = {}, _a[EVENT_TYPE.ENDED] = this.endedEventAction.bind(this), _a[EVENT_TYPE.PLAY] = this.playEventAction.bind(this), _a[EVENT_TYPE.PAUSE] = this.pauseEventAction.bind(this), _a);
        var eventData = params.eventData;
        this._params = params;
        this._mediaElement = document.getElementById(eventData.properties["domElementId"]);
        this._started = false;
        this._provider = provider;
        var mediaTrackFunMapping = {
            IFRAME: this._iframeMediaTracker,
            VIDEO: this._html5MediaTracker,
            AUDIO: this._html5MediaTracker
        };
        mediaTrackFunMapping[this._mediaElement.tagName].bind(this)();
        this._initYoutubeFrame();
    }
    MediaAutoTrack.prototype._initYoutubeFrame = function() {
        this._youTubeIframeLoader = {
            src: "https://www.youtube.com/iframe_api",
            loading: false,
            loaded: false,
            listeners: [],
            load: function(callback) {
                var _this = this;
                this.listeners.push(callback);
                if (this.loaded) {
                    setTimeout(function() {
                        _this.done();
                    });
                    return;
                }
                if (this.loading) return;
                this.loading = true;
                window["onYouTubeIframeAPIReady"] = function() {
                    _this.loaded = true;
                    _this.done();
                };
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = this.src;
                document.body.appendChild(script);
            },
            done: function() {
                delete window["onYouTubeIframeAPIReady"];
                while(this.listeners.length)this.listeners.pop()(window["YT"]);
            }
        };
    };
    MediaAutoTrack.prototype._iframeMediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent(MEDIA_TYPE.IFRAME, EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._youTubeIframeLoader.load(function(YT) {
            that._iframePlayer = new YT.Player(that._mediaElement.id, {
                events: {
                    onStateChange: that._onPlayerStateChange.bind(that)
                }
            });
        });
    };
    MediaAutoTrack.prototype._onPlayerStateChange = function(event) {
        var iframeEventMapping = {
            0: EVENT_TYPE.ENDED,
            1: EVENT_TYPE.PLAY,
            2: EVENT_TYPE.PAUSE
        };
        var eventType = iframeEventMapping[event.data];
        if (eventType) this.eventActionMapping[eventType](MEDIA_TYPE.IFRAME);
    };
    MediaAutoTrack.prototype._html5MediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent(MEDIA_TYPE.VIDEO, EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PLAY, function() {
            that.eventActionMapping[EVENT_TYPE.PLAY](MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PAUSE, function() {
            that.eventActionMapping[EVENT_TYPE.PAUSE](MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.ENDED, function() {
            that.eventActionMapping[EVENT_TYPE.ENDED](MEDIA_TYPE.VIDEO);
        }, false);
    };
    MediaAutoTrack.prototype.playEventAction = function(mediaType) {
        this._started = true;
        this.recordEvent(mediaType, EVENT_TYPE.PLAY);
    };
    MediaAutoTrack.prototype.pauseEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, EVENT_TYPE.PAUSE);
    };
    MediaAutoTrack.prototype.endedEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, EVENT_TYPE.ENDED);
    };
    MediaAutoTrack.prototype.recordEvent = function(mediaType, eventType) {
        var newParams = Object.assign({}, this._params);
        var eventData = newParams.eventData;
        eventData.eventType = eventType;
        var currentPlayTime;
        if (mediaType === MEDIA_TYPE.VIDEO) {
            currentPlayTime = this._mediaElement.currentTime;
            eventData.properties.duration = this._mediaElement.duration;
        } else {
            currentPlayTime = this._financial(this._iframePlayer.getCurrentTime());
            eventData.properties.duration = this._financial(this._iframePlayer.getDuration());
        }
        var percentage = parseFloat(currentPlayTime) / parseFloat(eventData.properties.duration);
        eventData.properties.eventValue = Number(percentage.toFixed(4));
        delete eventData.properties.domElementId;
        this._provider.putToBuffer(newParams);
    };
    MediaAutoTrack.prototype._financial = function(x) {
        return Number.parseFloat(x).toFixed(4);
    };
    return MediaAutoTrack;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4u8u0":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"7HHv1"}],"7HHv1":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"3DEN3","c3296f04fad32769":"2ib7q"}],"3DEN3":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"9om8C","e823e604d75f975b":"mweLo","f5fff1c342107fbd":"hfAcI","b04e8cc634273c23":"4tAE8"}],"mweLo":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"9om8C","4cdff6c9e9ff5d38":"fn3uU"}],"fn3uU":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"57JFO","74644060ad1a1d3c":"h29TI"}],"hfAcI":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"7QuNJ"}],"7QuNJ":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"jzqFa"}],"jzqFa":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"8jLfa"}],"4tAE8":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"kDU9N"}],"kDU9N":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"25xE8","8439a3a1551d0706":"3A7ak","4b12c9f502d3288a":"9om8C","a0ebd327d618908a":"fn3uU"}],"3A7ak":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"2ib7q":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"fn3uU"}],"6Q2Bh":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Auth", ()=>(0, _auth.Auth));
parcelHelpers.export(exports, "CognitoUser", ()=>(0, _amazonCognitoIdentityJs.CognitoUser));
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _amazonCognitoIdentityJs.CookieStorage));
parcelHelpers.export(exports, "CognitoHostedUIIdentityProvider", ()=>(0, _auth1.CognitoHostedUIIdentityProvider));
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>(0, _amazonCognitoIdentityJs.appendToCognitoUserAgent));
parcelHelpers.export(exports, "AuthErrorStrings", ()=>(0, _authErrorStrings.AuthErrorStrings));
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _auth1.GRAPHQL_AUTH_MODE));
var _auth = require("./Auth");
var _auth1 = require("./types/Auth");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _authErrorStrings = require("./common/AuthErrorStrings");
/**
 * @deprecated use named import
 */ exports.default = (0, _auth.Auth);

},{"./Auth":"hye2w","./types/Auth":"g64Be","amazon-cognito-identity-js":"5JTdi","./common/AuthErrorStrings":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hye2w":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthClass", ()=>AuthClass);
parcelHelpers.export(exports, "Auth", ()=>Auth);
var _tslib = require("tslib");
var _types = require("./types");
var _core = require("@aws-amplify/core");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _internals = require("amazon-cognito-identity-js/internals");
var _url = require("url");
var _oauth = require("./OAuth/OAuth");
var _oauthDefault = parcelHelpers.interopDefault(_oauth);
var _urlListener = require("./urlListener");
var _urlListenerDefault = parcelHelpers.interopDefault(_urlListener);
var _errors = require("./Errors");
var _auth = require("./types/Auth");
var logger = new (0, _core.ConsoleLogger)("AuthClass");
var USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var OAUTH_FLOW_MS_TIMEOUT = 10000;
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAuthEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var MAX_DEVICES = 60;
var MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var AuthClass = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.inflightSessionPromise = null;
        this.inflightSessionPromiseCounter = 0;
        this.Credentials = (0, _core.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) dispatchAuthEvent("tokenRefresh", undefined, "New token retrieved");
                else dispatchAuthEvent("tokenRefresh_failure", error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, _core.Hub).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "verify":
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
        (0, _internals.addAuthCategoryToCognitoUserAgent)();
        (0, _internals.addFrameworkToCognitoUserAgent)((0, _core.Platform).framework);
        (0, _core.Platform).observeFrameworkChanges(function() {
            (0, _internals.addFrameworkToCognitoUserAgent)((0, _core.Platform).framework);
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, _core.parseAWSExports)(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint, storage = _a.storage;
        if (!storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, _amazonCognitoIdentityJs.CookieStorage)(cookieStorage);
            else this._storage = config.ssr ? new (0, _core.UniversalStorage)() : new (0, _core.StorageHelper)().getStorage();
        } else {
            if (!this._isValidAuthStorage(storage)) {
                logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, _amazonCognitoIdentityJs.CognitoUserPool)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            identityPoolRegion: identityPoolRegion
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, _types.isCognitoHostedOpts)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, _oauthDefault.default)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, _urlListenerDefault.default)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
            var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
            if (pollingInitiated) {
                dispatchAuthEvent("autoSignIn_failure", null, (0, _auth.AuthErrorTypes).AutoSignInError);
                this._storage.removeItem("amplify-auto-sign-in");
            }
            this._storage.removeItem("amplify-polling-started");
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                Name: "email",
                Value: email
            }));
            if (phone_number) attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                Name: "phone_number",
                Value: phone_number
            }));
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params["validationData"];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem("amplify-auto-sign-in", "true");
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, _auth.AuthErrorTypes).SignUpError);
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        logger.debug("signUp attrs:", attributes);
        logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, _amazonCognitoIdentityJs.AuthenticationDetails)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === "link") this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === "confirmSignUp") _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, _core.Hub).listen("auth", listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem("amplify-polling-started", "true");
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                dispatchAuthEvent("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
                _this._storage.removeItem("amplify-auto-sign-in");
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                dispatchAuthEvent("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, _core.Hub).remove("auth", listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem("amplify-polling-started");
                                }
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }, function(error) {
                                logger.error(error);
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    dispatchAuthEvent("confirmSignUp", data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        dispatchAuthEvent("autoSignIn_failure", null, (0, _auth.AuthErrorTypes).AutoSignInError);
                        _this._storage.removeItem("amplify-auto-sign-in");
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === "true" : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, _types.isUsernamePasswordOpts)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, _auth.AuthErrorTypes).InvalidUsername);
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var authDetails = new (0, _amazonCognitoIdentityJs.AuthenticationDetails)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                logger.debug("signIn failure", err);
                dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                logger.debug("getting preferred mfa failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej("invalid MFA Type");
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                logger.debug("getting user data failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SOFTWARE_TOKEN_MFA":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "SMS_MFA":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, _auth.AuthErrorTypes).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, _auth.AuthErrorTypes).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    logger.debug("Set user mfa success", result);
                                    logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return (0, _tslib.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        logger.debug("getting user data failed", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    logger.debug("associateSoftwareToken success", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        logger.debug("verification totp token", user, challengeAnswer);
        var signInUserSession;
        if (user && typeof user.getSignInUserSession === "function") signInUserSession = user.getSignInUserSession();
        var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    if (!isLoggedIn) dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    dispatchAuthEvent("verify", user, "A user " + user.getUsername() + " has been verified");
                    logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_3, currentUser, e_4;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        10
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 5:
                                    that.user = user;
                                    _a.label = 6;
                                case 6:
                                    _a.trys.push([
                                        6,
                                        8,
                                        ,
                                        9
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.currentUserPoolUser()
                                    ];
                                case 7:
                                    currentUser = _a.sent();
                                    user.attributes = currentUser.attributes;
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 8:
                                    e_4 = _a.sent();
                                    logger.debug("cannot get updated Cognito User", e_4);
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 9:
                                    dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 10:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_5;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_5 = _a.sent();
                                    logger.debug("cannot get cognito credentials", e_5);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    logger.debug("completeNewPassword failure", err);
                    dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_6, isSignedInHostedUI;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_6 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_6);
                        throw new Error(e_6);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                logger.debug("Failed to get user from user pool");
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error("No current user."))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                logger.debug("Failed to get the user session", err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        dispatchAuthEvent("userDeleted", result, "The authenticated user has been deleted.");
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            logger.debug("failed to clear cached items");
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            dispatchAuthEvent("signOut", _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            logger.debug("no Congito User pool");
                                            rej(new Error("Cognito User pool does not exist"));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result, details) {
                    if (err) {
                        dispatchAuthEvent("updateUserAttributes_failure", err, "Failed to update attributes");
                        return reject(err);
                    } else {
                        var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
                        dispatchAuthEvent("updateUserAttributes", attrs, "Attributes successfully updated");
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    AuthClass.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
        var attrs = {};
        Object.keys(attributes).forEach(function(key) {
            attrs[key] = {
                isUpdated: true
            };
            var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
                return value.AttributeName === key;
            });
            if (codeDeliveryDetails) {
                attrs[key].isUpdated = false;
                attrs[key].codeDeliveryDetails = codeDeliveryDetails;
            }
        });
        return attrs;
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    AuthClass.prototype.isPasswordResetRequiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Password reset required for the user";
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err) || this.isPasswordResetRequiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_7;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var user, session, bypassCache, clientMetadata, _a, scope, err_1;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                logger.debug("OAuth signIn in progress, waiting for resolution...");
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            logger.debug("OAuth signIn in progress timeout");
                                            (0, _core.Hub).remove("auth", hostedUISignCallback);
                                            res();
                                        }, OAUTH_FLOW_MS_TIMEOUT);
                                        (0, _core.Hub).listen("auth", hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                                                logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, _core.Hub).remove("auth", hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    logger.debug("Failed to get user from user pool");
                                    rej("No current user");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                _b.label = 3;
                            case 3:
                                _b.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._userSession(user)
                                ];
                            case 4:
                                session = _b.sent();
                                bypassCache = params ? params.bypassCache : false;
                                if (!bypassCache) return [
                                    3 /*break*/ ,
                                    6
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                clientMetadata = this._config.clientMetadata;
                                _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                                if (scope.split(" ").includes(USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var cleanUpError_5, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                        return (0, _tslib.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    logger.debug("getting user data failed", err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _a.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                case 5:
                                                    res(user);
                                                    _a.label = 6;
                                                case 6:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 7:
                                                    preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                                    attributeList = [];
                                                    for(i = 0; i < data.UserAttributes.length; i++){
                                                        attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value
                                                        };
                                                        userAttribute = new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)(attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    attributes = this.attributesToObject(attributeList);
                                                    Object.assign(user, {
                                                        attributes: attributes,
                                                        preferredMFA: preferredMFA
                                                    });
                                                    return [
                                                        2 /*return*/ ,
                                                        res(user)
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    bypassCache: bypassCache,
                                    clientMetadata: clientMetadata
                                });
                                else {
                                    logger.debug("Unable to get the user data because the " + USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                    return [
                                        2 /*return*/ ,
                                        res(user)
                                    ];
                                }
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                err_1 = _b.sent();
                                rej(err_1);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var federatedUser, e_8, federatedInfo, user, e_9;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_8 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_8);
                        throw e_8;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                            if (federatedInfo) federatedUser = (0, _tslib.__assign)((0, _tslib.__assign)({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_9 = _a.sent();
                        if (e_9 === "No userPool") logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        logger.debug("The user is not authenticated by the error", e_9);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error("No User Pool in the configuration."));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    AuthClass.prototype._userSession = function(user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userSession;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!user) {
                            logger.debug("the user is null");
                            return [
                                2 /*return*/ ,
                                this.rejectAuthError((0, _auth.AuthErrorTypes).NoUserSession)
                            ];
                        }
                        clientMetadata = this._config.clientMetadata;
                        // Debouncing the concurrent userSession calls by caching the promise.
                        // This solution assumes users will always call this function with the same CognitoUser instance.
                        if (this.inflightSessionPromiseCounter === 0) this.inflightSessionPromise = new Promise(function(res, rej) {
                            user.getSession(function(err, session) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var cleanUpError_6;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!err) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                logger.debug("Failed to get the session from user", user);
                                                if (!this.isSessionInvalid(err)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.cleanUpInvalidSession(user)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                cleanUpError_6 = _a.sent();
                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 4:
                                                rej(err);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 5:
                                                logger.debug("Succeed to get the user session", session);
                                                res(session);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, {
                                clientMetadata: clientMetadata
                            });
                        });
                        this.inflightSessionPromiseCounter++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.inflightSessionPromise
                        ];
                    case 2:
                        userSession = _a.sent();
                        // Set private member. Avoid user.setSignInUserSession() to prevent excessive localstorage refresh.
                        // @ts-ignore
                        user.signInUserSession = userSession;
                        return [
                            2 /*return*/ ,
                            userSession
                        ];
                    case 3:
                        this.inflightSessionPromiseCounter--;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        return this._userSession(user);
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_10, federatedInfo;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_10 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_10);
                        throw e_10;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                logger.debug("getting session success", session);
                                return _this.Credentials.set(session, "session");
                            }).catch(function() {
                                logger.debug("getting guest credentials");
                                return _this.Credentials.set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        logger.debug("getting current credentials");
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_11, isSignedInHostedUI;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_11);
                        throw e_11;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_7;
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        logger.debug("failed to get the user session", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_7 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                logger.debug("global sign out success");
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                logger.debug("global sign out failed", err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    logger.debug("user sign out", user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, _core.browserOrNode)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error("Signout timeout fail"));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        if (opts === void 0) opts = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_12, e_13, user;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_12 = _a.sent();
                        logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            11
                        ];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_13 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_13);
                        throw e_13;
                    case 7:
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 8:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        logger.debug("no current Cognito user");
                        _a.label = 10;
                    case 10:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 11:
                        logger.debug("no Cognito User pool");
                        _a.label = 12;
                    case 12:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    logger.debug("forgot password failure", err);
                    dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_14, info, err_2, user;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_14 = _a.sent();
                        logger.debug("Failed to retrieve credentials while getting current user info", e_14);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_2 = _a.sent();
                        logger.error("currentUserInfo error", err_2);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, _types.isFederatedSignInOptions)(providerOrOptions) || (0, _types.isFederatedSignInOptionsCustom)(providerOrOptions) || (0, _types.hasCustomState)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, _auth.CognitoHostedUIIdentityProvider).Cognito
                        };
                        provider = (0, _types.isFederatedSignInOptions)(options) ? options.provider : options.customProvider;
                        customState = (0, _types.isFederatedSignInOptions)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, _types.isCognitoHostedOpts)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, _types.isCognitoHostedOpts)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, _core.browserOrNode)().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, _url.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, _url.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, _amazonCognitoIdentityJs.CognitoUserSession)({
                            IdToken: new (0, _amazonCognitoIdentityJs.CognitoIdToken)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, _amazonCognitoIdentityJs.CognitoRefreshToken)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, _amazonCognitoIdentityJs.CognitoAccessToken)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, "session")
                        ];
                    case 4:
                        credentials = _b.sent();
                        logger.debug("AWS credentials", credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== "undefined") window.history.replaceState(window.history.state, "", this._config.oauth.redirectSignIn);
                        dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            dispatchAuthEvent("customOAuthState", (0, _core.urlSafeDecode)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_3 = _b.sent();
                        logger.debug("Error in cognito hosted auth response", err_3);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== "undefined") window.history.replaceState(window.history.state, "", this._config.oauth.redirectSignIn);
                        dispatchAuthEvent("signIn_failure", err_3, "The OAuth response flow failed");
                        dispatchAuthEvent("cognitoHostedUI_failure", err_3, "A failure occurred when returning to the Cognito Hosted UI");
                        dispatchAuthEvent("customState_failure", err_3, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, _amazonCognitoIdentityJs.CognitoUser)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, _auth.AuthErrorTypes).MissingAuthConfig;
        }
        return (0, _auth.AuthErrorTypes).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, _errors.AuthError)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, _errors.NoUserPoolError)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_2;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        logger.debug("The user is not authenticated by the error", error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        logger.debug("The user is not authenticated by the error", error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_4;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        logger.debug("The user is not authenticated by the error", error_4);
                        throw new Error("The user is not authenticated");
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === "device_name";
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices(MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var Auth = new AuthClass(null);
(0, _core.Amplify).register(Auth);

},{"tslib":"9gMVn","./types":"8UCcL","@aws-amplify/core":"8BDOx","amazon-cognito-identity-js":"5JTdi","amazon-cognito-identity-js/internals":"7haTu","url":"eSLai","./OAuth/OAuth":"kBVi4","./urlListener":"kUOYo","./Errors":"2tSe2","./types/Auth":"g64Be","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8UCcL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("./Auth");
parcelHelpers.exportAll(_auth, exports);

},{"./Auth":"g64Be","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g64Be":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CognitoHostedUIIdentityProvider", ()=>CognitoHostedUIIdentityProvider);
parcelHelpers.export(exports, "isFederatedSignInOptions", ()=>isFederatedSignInOptions);
parcelHelpers.export(exports, "isFederatedSignInOptionsCustom", ()=>isFederatedSignInOptionsCustom);
parcelHelpers.export(exports, "hasCustomState", ()=>hasCustomState);
parcelHelpers.export(exports, "isCognitoHostedOpts", ()=>isCognitoHostedOpts);
parcelHelpers.export(exports, "AuthErrorTypes", ()=>AuthErrorTypes);
parcelHelpers.export(exports, "isUsernamePasswordOpts", ()=>isUsernamePasswordOpts);
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>GRAPHQL_AUTH_MODE);
var CognitoHostedUIIdentityProvider;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})(CognitoHostedUIIdentityProvider || (CognitoHostedUIIdentityProvider = {}));
function isFederatedSignInOptions(obj) {
    var keys = [
        "provider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function isFederatedSignInOptionsCustom(obj) {
    var keys = [
        "customProvider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function hasCustomState(obj) {
    var keys = [
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function isCognitoHostedOpts(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var AuthErrorTypes;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})(AuthErrorTypes || (AuthErrorTypes = {}));
function isUsernamePasswordOpts(obj) {
    return !!obj.username;
}
var GRAPHQL_AUTH_MODE;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})(GRAPHQL_AUTH_MODE || (GRAPHQL_AUTH_MODE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5JTdi":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticationDetails", ()=>(0, _authenticationDetailsDefault.default));
parcelHelpers.export(exports, "AuthenticationHelper", ()=>(0, _authenticationHelperDefault.default));
parcelHelpers.export(exports, "CognitoAccessToken", ()=>(0, _cognitoAccessTokenDefault.default));
parcelHelpers.export(exports, "CognitoIdToken", ()=>(0, _cognitoIdTokenDefault.default));
parcelHelpers.export(exports, "CognitoRefreshToken", ()=>(0, _cognitoRefreshTokenDefault.default));
parcelHelpers.export(exports, "CognitoUser", ()=>(0, _cognitoUserDefault.default));
parcelHelpers.export(exports, "CognitoUserAttribute", ()=>(0, _cognitoUserAttributeDefault.default));
parcelHelpers.export(exports, "CognitoUserPool", ()=>(0, _cognitoUserPoolDefault.default));
parcelHelpers.export(exports, "CognitoUserSession", ()=>(0, _cognitoUserSessionDefault.default));
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _cookieStorageDefault.default));
parcelHelpers.export(exports, "DateHelper", ()=>(0, _dateHelperDefault.default));
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>(0, _userAgent.appendToCognitoUserAgent));
parcelHelpers.export(exports, "WordArray", ()=>(0, _wordArrayDefault.default));
var _authenticationDetails = require("./AuthenticationDetails");
var _authenticationDetailsDefault = parcelHelpers.interopDefault(_authenticationDetails);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _cognitoUserPool = require("./CognitoUserPool");
var _cognitoUserPoolDefault = parcelHelpers.interopDefault(_cognitoUserPool);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _cookieStorage = require("./CookieStorage");
var _cookieStorageDefault = parcelHelpers.interopDefault(_cookieStorage);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _userAgent = require("./UserAgent");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);

},{"./AuthenticationDetails":"jGFO3","./AuthenticationHelper":"DHHEK","./CognitoAccessToken":"cPdgg","./CognitoIdToken":"3zQGf","./CognitoRefreshToken":"lak8T","./CognitoUser":"lRs5W","./CognitoUserAttribute":"5WKHZ","./CognitoUserPool":"dfA6t","./CognitoUserSession":"9cPfS","./CookieStorage":"h4wKA","./DateHelper":"gwO8p","./UserAgent":"cbqof","./utils/WordArray":"k84jJ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jGFO3":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationDetails);
var AuthenticationDetails = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"DHHEK":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationHelper);
var _buffer = require("buffer");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);
var _sha256Js = require("@aws-crypto/sha256-js");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function randomBytes(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _wordArrayDefault.default)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var HEX_MSB_REGEX = /^[89a-f]/i;
var initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var AuthenticationHelper = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, _bigIntegerDefault.default)(initN, 16);
        this.g = new (0, _bigIntegerDefault.default)("2", 16);
        this.k = new (0, _bigIntegerDefault.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, _buffer.Buffer).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = randomBytes(128).toString("hex");
        var randomBigInt = new (0, _bigIntegerDefault.default)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, _bigIntegerDefault.default)(hexRandom, 16));
        this.g.modPow(new (0, _bigIntegerDefault.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, _bigIntegerDefault.default).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, _bigIntegerDefault.default)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, _buffer.Buffer).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, _buffer.Buffer).concat([
            this.infoBits,
            (0, _buffer.Buffer).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, _sha256Js.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, _sha256Js.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, _bigIntegerDefault.default).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, _bigIntegerDefault.default).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, _bigIntegerDefault.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, _buffer.Buffer).from(_this4.padHex(sValue), "hex"), (0, _buffer.Buffer).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, _bigIntegerDefault.default))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, _bigIntegerDefault.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, _bigIntegerDefault.default)(invertedNibbles, 16).add((0, _bigIntegerDefault.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

},{"buffer":"ho4rj","./utils/WordArray":"k84jJ","@aws-crypto/sha256-js":"cN6LR","./BigInteger":"jraNv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ho4rj":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("2eef3896765c9283");
var ieee754 = require("3f12005c1e1b81ab");
var isArray = require("4375d8445b71f5dc");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"2eef3896765c9283":"rFFSX","3f12005c1e1b81ab":"iAbbC","4375d8445b71f5dc":"dIUr1"}],"dIUr1":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"k84jJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WordArray);
var _cryptoSecureRandomInt = require("./cryptoSecureRandomInt");
var _cryptoSecureRandomIntDefault = parcelHelpers.interopDefault(_cryptoSecureRandomInt);
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var WordArray = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, _cryptoSecureRandomIntDefault.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return hexStringify(this);
    };
    return WordArray;
}();

},{"./cryptoSecureRandomInt":"glmBP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"glmBP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cryptoSecureRandomInt);
var global = arguments[3];
var crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!crypto && typeof global !== "undefined" && global.crypto) crypto = global.crypto;
// Native crypto import via require (NodeJS)
if (!crypto && true) try {
    crypto = require("161b1906c5522933");
} catch (err) {}
function cryptoSecureRandomInt() {
    if (crypto) {
        // Use getRandomValues method (Browser)
        if (typeof crypto.getRandomValues === "function") try {
            return crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof crypto.randomBytes === "function") try {
            return crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}

},{"161b1906c5522933":"49Rpi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"49Rpi":[function(require,module,exports) {
"use strict";

},{}],"cN6LR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("2b45303009f839eb");
(0, tslib_1.__exportStar)(require("cfff49a4cd697fc3"), exports);

},{"2b45303009f839eb":"9gMVn","cfff49a4cd697fc3":"5aQ66"}],"5aQ66":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("5b00ee9c8d8ef89c");
var constants_1 = require("ec02801547c2449b");
var RawSha256_1 = require("c3c6d704009a1cd6");
var util_1 = require("6b886b0320c003c9");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"5b00ee9c8d8ef89c":"9gMVn","ec02801547c2449b":"eOE05","c3c6d704009a1cd6":"7friU","6b886b0320c003c9":"13Q6a"}],"eOE05":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"7friU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("9d9152a982a1eef9");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"9d9152a982a1eef9":"eOE05"}],"13Q6a":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("e6433dfba6ef7208");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("5bf0cc557531490c");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("3c85979539bec27d");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("13c97883248bf028");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"e6433dfba6ef7208":"aRtg6","5bf0cc557531490c":"ePrRL","3c85979539bec27d":"dTyFx","13c97883248bf028":"4qHdQ"}],"aRtg6":[function(require,module,exports) {
var Buffer = require("18f97229914e1b2e").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("93bafe888f7ddff3");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"18f97229914e1b2e":"ho4rj","93bafe888f7ddff3":"59GiV"}],"ePrRL":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"dTyFx":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"4qHdQ":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"jraNv":[function(require,module,exports) {
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function nbi() {
    return new BigInteger(null);
}
// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
    BigInteger.prototype.am = am2;
    dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
    BigInteger.prototype.am = am1;
    dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
function int2char(n) {
    return BI_RM.charAt(n);
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = nbi();
    var y = nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function bnAdd(a) {
    var r = nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function bnSubtract(a) {
    var r = nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function bnMultiply(a) {
    var r = nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function bnDivide(a) {
    var r = nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = nbv(1), z = new Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
    i = nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;
// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cPdgg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoAccessToken);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** @class */ var CognitoAccessToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    _inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"15xqy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"15xqy":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoJwtToken);
var _buffer = require("buffer");
/** @class */ var CognitoJwtToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, _buffer.Buffer).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

},{"buffer":"ho4rj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3zQGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoIdToken);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** @class */ var CognitoIdToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    _inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"15xqy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lak8T":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoRefreshToken);
var CognitoRefreshToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lRs5W":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUser);
var _buffer = require("buffer");
var _sha256Js = require("@aws-crypto/sha256-js");
var _platform = require("./Platform");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var isNavigatorAvailable = typeof navigator !== "undefined";
var userAgent = isNavigatorAvailable ? (0, _platform.Platform).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var CognitoUser = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var dateHelper = new (0, _dateHelperDefault.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, _buffer.Buffer).from(_this2.username, "utf8"),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, _buffer.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.deviceGroupKey);
        var dateHelper = new (0, _dateHelperDefault.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this6.deviceGroupKey, "utf8"),
                        (0, _buffer.Buffer).from(_this6.deviceKey, "utf8"),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, _buffer.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, _authenticationHelperDefault.default)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, _cognitoUserAttributeDefault.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, _cognitoIdTokenDefault.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, _cognitoAccessTokenDefault.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, _cognitoRefreshTokenDefault.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, _cognitoUserSessionDefault.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, _cognitoIdTokenDefault.default)(authResult);
        var accessToken = new (0, _cognitoAccessTokenDefault.default)(authResult);
        var refreshToken = new (0, _cognitoRefreshTokenDefault.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, _cognitoUserSessionDefault.default)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

},{"buffer":"ho4rj","@aws-crypto/sha256-js":"cN6LR","./Platform":"iZyEn","./BigInteger":"jraNv","./AuthenticationHelper":"DHHEK","./CognitoAccessToken":"cPdgg","./CognitoIdToken":"3zQGf","./CognitoRefreshToken":"lak8T","./CognitoUserSession":"9cPfS","./DateHelper":"gwO8p","./CognitoUserAttribute":"5WKHZ","./StorageHelper":"cxEQL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iZyEn":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "getUserAgent", ()=>getUserAgent);
var _version = require("./version");
var BASE_USER_AGENT = "aws-amplify/" + (0, _version.version);
var Platform = {
    userAgent: BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var getUserAgent = function getUserAgent() {
    return Platform.userAgent;
};
/**
 * @deprecated use named import
 */ exports.default = Platform;

},{"./version":"eIEaQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eIEaQ":[function(require,module,exports) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var version = "5.0.4";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9cPfS":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserSession);
var CognitoUserSession = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gwO8p":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateHelper);
var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var DateHelper = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = weekNames[now.getUTCDay()];
        var month = monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5WKHZ":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserAttribute);
var CognitoUserAttribute = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cxEQL":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", ()=>MemoryStorage);
parcelHelpers.export(exports, "default", ()=>StorageHelper);
var dataMemory = {};
var MemoryStorage = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var StorageHelper = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dfA6t":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserPool);
var _client = require("./Client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
var USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var CognitoUserPool = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, _clientDefault.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, _cognitoUserDefault.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, _cognitoUserDefault.default)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

},{"./Client":"2Sqry","./CognitoUser":"lRs5W","./StorageHelper":"cxEQL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2Sqry":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Client);
var _isomorphicUnfetch = require("isomorphic-unfetch");
var _userAgent = require("./UserAgent");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var CognitoError = /*#__PURE__*/ function(_Error) {
    _inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
/** @class */ var Client = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, _userAgent.getAmplifyUserAgent)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var NonRetryableError = /*#__PURE__*/ function(_Error2) {
    _inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
var isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        logger.debug("error on " + functionToRetry.name, err);
        if (isNonRetryableError(err)) {
            logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var MAX_DELAY_MS = 300000;
function jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs));
}

},{"isomorphic-unfetch":"htPp0","./UserAgent":"cbqof","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cbqof":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>appendToCognitoUserAgent);
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", ()=>addAuthCategoryToCognitoUserAgent);
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", ()=>addFrameworkToCognitoUserAgent);
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>getAmplifyUserAgent);
var _platform = require("./Platform");
var _constants = require("./Platform/constants");
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = (0, _platform.getUserAgent)();
var appendToCognitoUserAgent = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if (UserAgent.prototype.userAgent && !UserAgent.prototype.userAgent.includes(content)) UserAgent.prototype.userAgent = UserAgent.prototype.userAgent.concat(" ", content);
    if (!UserAgent.prototype.userAgent || UserAgent.prototype.userAgent === "") UserAgent.prototype.userAgent = content;
};
var addAuthCategoryToCognitoUserAgent = function addAuthCategoryToCognitoUserAgent() {
    UserAgent.category = (0, _constants.AUTH_CATEGORY);
};
var addFrameworkToCognitoUserAgent = function addFrameworkToCognitoUserAgent(framework) {
    UserAgent.framework = framework;
};
var getAmplifyUserAgent = function getAmplifyUserAgent(action) {
    var uaCategoryAction = UserAgent.category ? " " + UserAgent.category : "";
    var uaFramework = UserAgent.framework ? " framework/" + UserAgent.framework : "";
    var userAgent = "" + UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
// class for defining the amzn user-agent
exports.default = UserAgent;

},{"./Platform":"iZyEn","./Platform/constants":"bgS6j","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bgS6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FRAMEWORK", ()=>FRAMEWORK);
parcelHelpers.export(exports, "AUTH_CATEGORY", ()=>AUTH_CATEGORY);
var FRAMEWORK = {
    None: "0",
    ReactNative: "1"
};
var AUTH_CATEGORY = "auth";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h4wKA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CookieStorage);
var _jsCookie = require("js-cookie");
/** @class */ var CookieStorage = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        _jsCookie.set(key, value, options);
        return _jsCookie.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return _jsCookie.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return _jsCookie.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = _jsCookie.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

},{"js-cookie":"8gid4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8gid4":[function(require,module,exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"7haTu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", ()=>(0, _userAgent.addAuthCategoryToCognitoUserAgent));
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", ()=>(0, _userAgent.addFrameworkToCognitoUserAgent));
var _userAgent = require("../UserAgent");

},{"../UserAgent":"cbqof","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eSLai":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var punycode = require("6aa635927f16f681");
var util = require("3270586ce442e355");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
}, querystring = require("768fe205c74a17e8");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && util.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if (util.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (util.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!util.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

},{"6aa635927f16f681":"i0GtZ","3270586ce442e355":"3NbC5","768fe205c74a17e8":"29QgD"}],"i0GtZ":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

},{}],"3NbC5":[function(require,module,exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

},{}],"29QgD":[function(require,module,exports) {
"use strict";
exports.decode = exports.parse = require("636e0b84222e531a");
exports.encode = exports.stringify = require("8e17006a06cc4f8");

},{"636e0b84222e531a":"7qbn8","8e17006a06cc4f8":"a3QRC"}],"7qbn8":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!hasOwnProperty(obj, k)) obj[k] = v;
        else if (isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

},{}],"a3QRC":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return map(objectKeys(obj), function(k) {
        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
        if (isArray(obj[k])) return map(obj[k], function(v) {
            return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

},{}],"kBVi4":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _url = require("url"); // Used for OAuth parsing of Cognito Hosted UI
var _urlOpener = require("./urlOpener");
var _oauthStorage = require("./oauthStorage");
var _buffer = require("buffer");
var _auth = require("../types/Auth");
var _core = require("@aws-amplify/core");
var _sha256Js = require("@aws-crypto/sha256-js");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAuthEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", AMPLIFY_SYMBOL);
};
var logger = new (0, _core.ConsoleLogger)("OAuth");
var OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, _urlOpener.launchUri);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error("scopes must be a String Array");
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === "string";
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, _auth.CognitoHostedUIIdentityProvider).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, _core.urlSafeEncode)(customState) : generatedState;
        _oauthStorage.setState(state);
        var pkce_key = this._generateRandom(128);
        _oauthStorage.setPKCE(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var scopesString = this._scopes.join(" ");
        var queryString = Object.entries((0, _tslib.__assign)((0, _tslib.__assign)({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a, access_token, refresh_token, id_token, error;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        code = ((0, _url.parse)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                            return (0, _tslib.__assign)((0, _tslib.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, _url.parse)(currentUrl).pathname || "/";
                        redirectSignInPathname = (0, _url.parse)(this._config.redirectSignIn).pathname || "/";
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, _auth.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, _auth.isCognitoHostedOpts)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = _oauthStorage.getPKCE();
                        oAuthTokenBody = (0, _tslib.__assign)({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        customUserAgentDetails = {
                            category: (0, _core.Category).Auth,
                            action: (0, _core.AuthAction).FederatedSignIn
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: (_b = {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }, _b[0, _core.USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _b),
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.sent().json()
                        ];
                    case 2:
                        _a = _c.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return (0, _tslib.__generator)(this, function(_b) {
                _a = ((0, _url.parse)(currentUrl).hash || "#").substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? (0, _tslib.__assign)((0, _tslib.__assign)({}, ((0, _url.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, _url.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        logger.debug("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = _oauthStorage.getState();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return (0, _tslib.__generator)(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, _auth.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, _auth.isCognitoHostedOpts)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join("&");
                dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(code);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var b64 = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
        var base64URLFromAWSCrypto = this._base64URL(b64);
        return base64URLFromAWSCrypto;
    };
    OAuth.prototype._base64URL = function(string) {
        return string.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
exports.default = OAuth;

},{"tslib":"9gMVn","url":"eSLai","./urlOpener":"3RJF2","./oauthStorage":"1QlyG","buffer":"dIm4X","../types/Auth":"g64Be","@aws-amplify/core":"8BDOx","@aws-crypto/sha256-js":"kdR2o","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3RJF2":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "launchUri", ()=>launchUri);
var SELF = "_self";
var launchUri = function(url) {
    var windowProxy = window.open(url, SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1QlyG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setState", ()=>setState);
parcelHelpers.export(exports, "getState", ()=>getState);
parcelHelpers.export(exports, "setPKCE", ()=>setPKCE);
parcelHelpers.export(exports, "getPKCE", ()=>getPKCE);
parcelHelpers.export(exports, "clearAll", ()=>clearAll);
var setState = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var getState = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var setPKCE = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var getPKCE = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var clearAll = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dIm4X":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("cc9ef38945ca7514");
var ieee754 = require("2029602ab8d0f68");
var isArray = require("e1d6f34cfc72b474");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"cc9ef38945ca7514":"rFFSX","2029602ab8d0f68":"iAbbC","e1d6f34cfc72b474":"aK2In"}],"aK2In":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"kdR2o":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("847e9f41fbd48d18");
tslib_1.__exportStar(require("952fa851a97011d6"), exports);

},{"847e9f41fbd48d18":"9gMVn","952fa851a97011d6":"cm3ei"}],"cm3ei":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("4cf08e042cbd4f6b");
var constants_1 = require("2f5507f5e1102429");
var RawSha256_1 = require("c4be19be66a5b026");
var util_1 = require("2d947ee16d17c108");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new RawSha256_1.RawSha256();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
            return tslib_1.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new RawSha256_1.RawSha256();
        if (this.secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(this.secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"4cf08e042cbd4f6b":"9gMVn","2f5507f5e1102429":"hGtyz","c4be19be66a5b026":"cXo2n","2d947ee16d17c108":"7rM5m"}],"hGtyz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"cXo2n":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("611362490e842507");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"611362490e842507":"hGtyz"}],"7rM5m":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("d546aa13e7a4f234");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("688570fbe8307eb0");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("9f8c2d94c37c0290");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("65327eb5bf877089");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"d546aa13e7a4f234":"jeRtp","688570fbe8307eb0":"harec","9f8c2d94c37c0290":"heodx","65327eb5bf877089":"6ij0m"}],"jeRtp":[function(require,module,exports) {
var Buffer = require("c6f30219801e45d2").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("edd31833385d65db");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"c6f30219801e45d2":"8EcTH","edd31833385d65db":"59GiV"}],"harec":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"heodx":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"6ij0m":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"kUOYo":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
exports.default = function(callback) {
    if ((0, _core.browserOrNode)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, _core.browserOrNode)().isNode) ;
    else throw new Error("Not supported");
};

},{"@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2tSe2":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>AuthError);
parcelHelpers.export(exports, "NoUserPoolError", ()=>NoUserPoolError);
parcelHelpers.export(exports, "authErrorMessages", ()=>authErrorMessages);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _authErrorStrings = require("./common/AuthErrorStrings");
var logger = new (0, _core.ConsoleLogger)("AuthError");
var AuthError = /** @class */ function(_super) {
    (0, _tslib.__extends)(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = authErrorMessages[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var NoUserPoolError = /** @class */ function(_super) {
    (0, _tslib.__extends)(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}(AuthError);
var authErrorMessages = {
    noConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, _authErrorStrings.AuthErrorStrings).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_CODE
    },
    signUpError: {
        message: (0, _authErrorStrings.AuthErrorStrings).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, _authErrorStrings.AuthErrorStrings).NO_MFA
    },
    invalidMFA: {
        message: (0, _authErrorStrings.AuthErrorStrings).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, _authErrorStrings.AuthErrorStrings).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEVICE_CONFIG
    },
    networkError: {
        message: (0, _authErrorStrings.AuthErrorStrings).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, _authErrorStrings.AuthErrorStrings).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG
    }
};

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./common/AuthErrorStrings":"6Fu6w","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6Fu6w":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthErrorStrings", ()=>AuthErrorStrings);
var AuthErrorStrings;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})(AuthErrorStrings || (AuthErrorStrings = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cox1w":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", ()=>(0, _providers.AWSS3Provider));
parcelHelpers.export(exports, "StorageClass", ()=>(0, _storage.Storage));
parcelHelpers.export(exports, "Storage", ()=>(0, _storage.StorageInstance));
var _storage = require("./Storage");
var _providers = require("./providers");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Storage":"WGCkf","./providers":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"WGCkf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Storage", ()=>Storage);
parcelHelpers.export(exports, "StorageInstance", ()=>StorageInstance);
var _core = require("@aws-amplify/core");
var _providers = require("./providers");
var _utils = require("./AwsClients/S3/utils");
var _awss3UploadTask = require("./providers/AWSS3UploadTask");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _core.ConsoleLogger)("StorageClass");
var loggerStorageInstance = new (0, _core.ConsoleLogger)("Storage"); // Logging relating to Storage instance management
var DEFAULT_PROVIDER = "AWSS3";
/**
 * Provide storage methods to use AWS S3
 */ var Storage = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._abortControllerMap = new WeakMap();
        logger.debug("Storage Options", this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return "Storage";
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Storage") {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug("No plugin found with providerName", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        var _a;
        logger.debug("configure Storage");
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        var storageConfig = (_a = amplifyConfig.Storage) !== null && _a !== void 0 ? _a : {};
        var defaultProviderConfigKeys = [
            "bucket",
            "region",
            "level",
            "track",
            "customPrefix",
            "ContentMD5",
            "serverSideEncryption",
            "SSECustomerAlgorithm",
            "SSECustomerKey",
            // TODO(AllanZhengYP): remove in V6.
            "SSECustomerKeyMD5",
            "SSEKMSKeyId"
        ];
        var hasDefaultProviderConfigKeys = function(config) {
            return Object.keys(config).find(function(key) {
                return defaultProviderConfigKeys.includes(key);
            });
        };
        if (hasDefaultProviderConfigKeys(storageConfig) && !storageConfig[DEFAULT_PROVIDER]) storageConfig[DEFAULT_PROVIDER] = {};
        Object.entries(storageConfig).forEach(function(_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (key && defaultProviderConfigKeys.includes(key) && value !== undefined) {
                storageConfig[DEFAULT_PROVIDER][key] = value;
                delete storageConfig[key];
            }
        });
        // only update new values for each provider
        Object.keys(storageConfig).forEach(function(providerName) {
            if (typeof storageConfig[providerName] !== "string") _this._config[providerName] = __assign(__assign({}, _this._config[providerName]), storageConfig[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _providers.AWSS3Provider)());
        return this._config;
    };
    Storage.prototype.getAbortController = function() {
        return new AbortController();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, abortController) {
        this._abortControllerMap.set(request, abortController);
    };
    Storage.prototype.isUploadTask = function(x) {
        return typeof x !== "undefined" && typeof x["pause"] === "function" && typeof x["resume"] === "function";
    };
    Storage.prototype.cancel = function(request, message) {
        if (request instanceof (0, _awss3UploadTask.AWSS3UploadTask)) return request._cancel();
        var abortController = this._abortControllerMap.get(request);
        if (abortController) // TODO: [v6] clean up the aborted promise in the weak map.
        // Not doing it yet to avoid breaking changes when users may abort a request twice.
        abortController.abort(message);
        else logger.debug("The request does not map to any cancel token");
    };
    Storage.prototype.copy = function(src, dest, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        if (typeof plugin.copy !== "function") return Promise.reject(".copy is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin.copy(src, dest, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.get = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        var responsePromise = plugin.get(key, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, _utils.isCancelError)(error);
    };
    Storage.prototype.getProperties = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            throw new Error("No plugin found with providerName");
        }
        var abortController = this.getAbortController();
        if (typeof plugin.getProperties !== "function") return Promise.reject(".getProperties is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin === null || plugin === void 0 ? void 0 : plugin.getProperties(key, __assign({}, config));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.put = function(key, object, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        var response = plugin.put(key, object, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        if (!this.isUploadTask(response)) this.updateRequestToBeCancellable(response, abortController);
        return response;
    };
    Storage.prototype.remove = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return plugin.remove(key, config);
    };
    Storage.prototype.list = function(path, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return plugin.list(path, config);
    };
    return Storage;
}();
/**
 * Configure & register Storage singleton instance.
 */ var _instance = null;
var getInstance = function() {
    if (_instance) return _instance;
    loggerStorageInstance.debug("Create Storage Instance, debug");
    _instance = new Storage();
    _instance.vault = new Storage();
    var old_configure = _instance.configure;
    _instance.configure = function(options) {
        loggerStorageInstance.debug("storage configure called");
        var vaultConfig = __assign({}, old_configure.call(_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== "string") vaultConfig[providerName] = __assign(__assign({}, vaultConfig[providerName]), {
                level: "private"
            });
        });
        loggerStorageInstance.debug("storage vault configure called");
        _instance.vault.configure(vaultConfig);
    };
    return _instance;
};
var StorageInstance = getInstance();
(0, _core.Amplify).register(StorageInstance);

},{"@aws-amplify/core":"8BDOx","./providers":"hzUFQ","./AwsClients/S3/utils":"3mUnf","./providers/AWSS3UploadTask":"3gcVb","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hzUFQ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", ()=>(0, _awss3Provider.AWSS3Provider));
var _awss3Provider = require("./AWSS3Provider");

},{"./AWSS3Provider":"kNR58","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kNR58":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", ()=>AWSS3Provider);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _storageErrorStrings = require("../common/StorageErrorStrings");
var _storageUtils = require("../common/StorageUtils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var _awss3ProviderManagedUpload = require("./AWSS3ProviderManagedUpload");
var _awss3UploadTask = require("./AWSS3UploadTask");
var _storageConstants = require("../common/StorageConstants");
var _events = require("events");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _core.ConsoleLogger)("AWSS3Provider");
var DEFAULT_STORAGE_LEVEL = "public";
var DEFAULT_PRESIGN_EXPIRATION = 900;
var AWSS3Provider = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        var _this = this;
        this._config = config ? config : {};
        this._storage = new (0, _core.StorageHelper)().getStorage();
        (0, _core.Hub).listen("auth", function(data) {
            var payload = data.payload;
            if (payload.event === "signOut" || payload.event === "signIn") _this._storage.removeItem((0, _storageConstants.UPLOADS_STORAGE_KEY));
        });
        logger.debug("Storage Options", this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        logger.debug("configure Storage", config);
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) logger.debug("Do not have bucket yet");
        return this._config;
    };
    AWSS3Provider.prototype.startResumableUpload = function(addTaskInput, config) {
        var _a;
        var s3Config = addTaskInput.s3Config, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
        var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, track = (_a = config.track, _a === void 0 ? false : _a);
        if (!(file instanceof Blob)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).INVALID_BLOB);
        emitter.on((0, _awss3UploadTask.TaskEvents).UPLOAD_PROGRESS, function(event) {
            if (progressCallback) {
                if (typeof progressCallback === "function") progressCallback(event);
                else logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
        });
        emitter.on((0, _awss3UploadTask.TaskEvents).UPLOAD_COMPLETE, function(event) {
            if (completeCallback) {
                if (typeof completeCallback === "function") completeCallback(event);
                else logger.warn("completeCallback should be a function, not a " + typeof completeCallback);
            }
        });
        emitter.on((0, _awss3UploadTask.TaskEvents).ERROR, function(err) {
            if (errorCallback) {
                if (typeof errorCallback === "function") errorCallback(err);
                else logger.warn("errorCallback should be a function, not a " + typeof errorCallback);
            }
        });
        // we want to keep this function sync so we defer this promise to AWSS3UploadTask to resolve when it's needed
        // when its doing a final check with _listSingleFile function
        var prefixPromise = (0, _core.Credentials).get().then(function(credentials) {
            var cred = (0, _core.Credentials).shear(credentials);
            return (0, _s3ClientUtils.getPrefix)(__assign(__assign({}, config), {
                level: addTaskInput.accessLevel,
                credentials: cred
            }));
        });
        var task = new (0, _awss3UploadTask.AWSS3UploadTask)({
            s3Config: s3Config,
            file: file,
            emitter: emitter,
            level: addTaskInput.accessLevel,
            storage: this._storage,
            params: params,
            prefixPromise: prefixPromise
        });
        (0, _storageUtils.dispatchStorageEvent)(track, "upload", {
            method: "put",
            result: "success"
        }, null, "Upload Task created successfully for ".concat(key));
        // automatically start the upload task
        task.resume();
        return task;
    };
    /**
     * Copy an object from a source object to a new object within the same bucket. Can optionally copy files across
     * different level or identityId (if source object's level is 'protected').
     *
     * @async
     * @param {S3CopySource} src - Key and optionally access level and identityId of the source object.
     * @param {S3CopyDestination} dest - Key and optionally access level of the destination object.
     * @param {S3ProviderCopyConfig} [config] - Optional configuration for s3 commands.
     * @return {Promise<S3ProviderCopyOutput>} The key of the copied object.
     */ AWSS3Provider.prototype.copy = function(src, dest, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, srcLevel, srcIdentityId, srcKey, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, error_1;
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        srcLevel = (_a = src.level, _a === void 0 ? DEFAULT_STORAGE_LEVEL : _a), srcIdentityId = src.identityId, srcKey = src.key;
                        destLevel = (_b = dest.level, _b === void 0 ? DEFAULT_STORAGE_LEVEL : _b), destKey = dest.key;
                        if (!srcKey || typeof srcKey !== "string") throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_SRC_KEY);
                        if (!destKey || typeof destKey !== "string") throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_DEST_KEY);
                        if (srcLevel !== "protected" && srcIdentityId) logger.warn('You may copy files from another user if the source level is "protected", currently it\'s '.concat(srcLevel));
                        srcPrefix = this._prefix(__assign(__assign(__assign({}, opt), {
                            level: srcLevel
                        }), srcIdentityId && {
                            identityId: srcIdentityId
                        }));
                        destPrefix = this._prefix(__assign(__assign({}, opt), {
                            level: destLevel
                        }));
                        finalSrcKey = "".concat(bucket, "/").concat(srcPrefix).concat(srcKey);
                        finalDestKey = "".concat(destPrefix).concat(destKey);
                        logger.debug("copying ".concat(finalSrcKey, " to ").concat(finalDestKey));
                        params = {
                            Bucket: bucket,
                            CopySource: finalSrcKey,
                            Key: finalDestKey,
                            // Copies over metadata like contentType as well
                            MetadataDirective: "COPY"
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (expires) params.Expires = expires;
                        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        if (acl) params.ACL = acl;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.copyObject)((0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                                storageAction: (0, _core.StorageAction).Copy
                            })), params)
                        ];
                    case 3:
                        _c.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "copy", {
                            method: "copy",
                            result: "success"
                        }, null, "Copy success from ".concat(srcKey, " to ").concat(destKey));
                        return [
                            2 /*return*/ ,
                            {
                                key: destKey
                            }
                        ];
                    case 4:
                        error_1 = _c.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "copy", {
                            method: "copy",
                            result: "failed"
                        }, null, "Copy failed from ".concat(srcKey, " to ").concat(destKey));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype.get = function(key, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, validateObjectExistence, prefix, final_key, emitter, s3Config, params, response, error_2, error_3, url, _b, _c, error_4;
            var _d, _e;
            return __generator(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _f.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback, validateObjectExistence = (_d = opt.validateObjectExistence, _d === void 0 ? false : _d);
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        emitter = new _events.EventEmitter();
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            emitter: emitter,
                            storageAction: (0, _core.StorageAction).Get
                        }));
                        logger.debug("get " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 2;
                    case 2:
                        _f.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        if (progressCallback) {
                            if (typeof progressCallback === "function") emitter.on((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT), function(progress) {
                                progressCallback(progress);
                            });
                            else logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
                        }
                        return [
                            4 /*yield*/ ,
                            (0, _s3.getObject)(s3Config, params)
                        ];
                    case 3:
                        response = _f.sent();
                        emitter.removeAllListeners((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT));
                        (0, _storageUtils.dispatchStorageEvent)(track, "download", {
                            method: "get",
                            result: "success"
                        }, {
                            fileSize: Number(response.Body["size"] || response.Body["length"])
                        }, "Download success for ".concat(key));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_2 = _f.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "download", {
                            method: "get",
                            result: "failed"
                        }, null, "Download failed with ".concat(error_2.message));
                        throw error_2;
                    case 5:
                        if (!validateObjectExistence) return [
                            3 /*break*/ ,
                            9
                        ];
                        _f.label = 6;
                    case 6:
                        _f.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.headObject)(s3Config, params)
                        ];
                    case 7:
                        _f.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_3 = _f.sent();
                        if (((_a = error_3.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, _storageUtils.dispatchStorageEvent)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "".concat(key, " not found"));
                        throw error_3;
                    case 9:
                        _f.trys.push([
                            9,
                            12,
                            ,
                            13
                        ]);
                        _b = (0, _s3.getPresignedGetObjectUrl);
                        _c = [
                            __assign({}, s3Config)
                        ];
                        _e = {
                            expiration: expires || DEFAULT_PRESIGN_EXPIRATION
                        };
                        return [
                            4 /*yield*/ ,
                            s3Config.credentials()
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, [
                                __assign.apply(void 0, _c.concat([
                                    (_e.credentials = _f.sent(), _e.signingRegion = s3Config.region, _e.signingService = (0, _s3.SERVICE_NAME), _e)
                                ])),
                                params
                            ])
                        ];
                    case 11:
                        url = _f.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "getSignedUrl", {
                            method: "get",
                            result: "success"
                        }, null, "Signed URL: ".concat(url));
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 12:
                        error_4 = _f.sent();
                        logger.warn("get signed url error", error_4);
                        (0, _storageUtils.dispatchStorageEvent)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "Could not get a signed URL for ".concat(key));
                        throw error_4;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get Properties of the object
     *
     * @param {string} key - key of the object
     * @param {S3ProviderGetPropertiesConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderGetPropertiesOutput>} - A promise resolves to contentType,
     * contentLength, eTag, lastModified, metadata
     */ AWSS3Provider.prototype.getProperties = function(key, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, prefix, final_key, s3Config, params, response, getPropertiesResponse, error_5;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = (_b = opt.track, _b === void 0 ? false : _b), SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        logger.debug("getProperties ".concat(key, " from ").concat(final_key));
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            storageAction: (0, _core.StorageAction).GetProperties
                        }));
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.headObject)(s3Config, params)
                        ];
                    case 3:
                        response = _c.sent();
                        getPropertiesResponse = {
                            contentLength: response.ContentLength,
                            contentType: response.ContentType,
                            eTag: response.ETag,
                            lastModified: response.LastModified,
                            metadata: response.Metadata
                        };
                        (0, _storageUtils.dispatchStorageEvent)(track, "getProperties", {
                            method: "getProperties",
                            result: "success"
                        }, null, "getProperties successful for ".concat(key));
                        return [
                            2 /*return*/ ,
                            getPropertiesResponse
                        ];
                    case 4:
                        error_5 = _c.sent();
                        if (((_a = error_5.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, _storageUtils.dispatchStorageEvent)(track, "getProperties", {
                            method: "getProperties",
                            result: "failed"
                        }, null, "".concat(key, " not found"));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param key - key of the object
     * @param object - File to be put in Amazon S3 bucket
     * @param [config] - Optional configuration for the underlying S3 command
     * @return an instance of AWSS3UploadTask or a promise that resolves to an object with the new object's key on
     * success.
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        var opt = Object.assign({}, this._config, config);
        var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
        var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
        var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
        var type = contentType ? contentType : "binary/octet-stream";
        var params = {
            Bucket: bucket,
            Key: key,
            Body: object,
            ContentType: type
        };
        if (cacheControl) params.CacheControl = cacheControl;
        if (contentDisposition) params.ContentDisposition = contentDisposition;
        if (contentEncoding) params.ContentEncoding = contentEncoding;
        if (expires) params.Expires = expires;
        if (metadata) params.Metadata = metadata;
        if (tagging) params.Tagging = tagging;
        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
        var emitter = new _events.EventEmitter();
        var uploader = new (0, _awss3ProviderManagedUpload.AWSS3ProviderManagedUpload)(params, opt, emitter);
        if (acl) params.ACL = acl;
        if (resumable === true) {
            var s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                storageAction: (0, _core.StorageAction).Put
            }));
            var addTaskInput = {
                bucket: bucket,
                key: key,
                s3Config: s3Config,
                file: object,
                emitter: emitter,
                accessLevel: level,
                params: params
            };
            // explicitly asserting the type here as Typescript could not infer that resumable is of type true
            return this.startResumableUpload(addTaskInput, config);
        }
        try {
            if (progressCallback) {
                if (typeof progressCallback === "function") emitter.on((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), function(progress) {
                    progressCallback(progress);
                });
                else logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
            return uploader.upload().then(function(response) {
                logger.debug("upload result", response);
                (0, _storageUtils.dispatchStorageEvent)(track, "upload", {
                    method: "put",
                    result: "success"
                }, null, "Upload success for ".concat(key));
                return {
                    key: key
                };
            });
        } catch (error) {
            logger.warn("error uploading", error);
            (0, _storageUtils.dispatchStorageEvent)(track, "upload", {
                method: "put",
                result: "failed"
            }, null, "Error uploading ".concat(key));
            throw error;
        }
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {S3ProviderRemoveConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderRemoveOutput>} - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, params, s3Config, response, error_6;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        logger.debug("remove " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            storageAction: (0, _core.StorageAction).Remove
                        }));
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.deleteObject)(s3Config, params)
                        ];
                    case 3:
                        response = _a.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "delete", {
                            method: "remove",
                            result: "success"
                        }, null, "Deleted ".concat(key, " successfully"));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_6 = _a.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "delete", {
                            method: "remove",
                            result: "failed"
                        }, null, "Deletion of ".concat(key, " failed with ").concat(error_6));
                        throw error_6;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._list = function(params, opt, prefix) {
        return __awaiter(this, void 0, void 0, function() {
            var list, response;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listObjectsV2)((0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                                storageAction: (0, _core.StorageAction).List
                            })), __assign({}, params))
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response.Contents) {
                            list.results = response.Contents.map(function(item) {
                                return {
                                    key: item.Key.substr(prefix.length),
                                    eTag: item.ETag,
                                    lastModified: item.LastModified,
                                    size: item.Size
                                };
                            });
                            list.nextToken = response.NextContinuationToken;
                            list.hasNextToken = response.IsTruncated;
                        }
                        return [
                            2 /*return*/ ,
                            list
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {S3ProviderListConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderListOutput>} - Promise resolves to list of keys, eTags, lastModified
     * and file size for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, pageSize, nextToken, prefix, final_path, list, MAX_PAGE_SIZE, listResult, params, error_7;
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, pageSize = opt.pageSize, nextToken = opt.nextToken;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        logger.debug("list " + path + " from " + final_path);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        MAX_PAGE_SIZE = 1000;
                        listResult = void 0;
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: MAX_PAGE_SIZE,
                            ContinuationToken: nextToken
                        };
                        params.ContinuationToken = nextToken;
                        if (!(pageSize === "ALL")) return [
                            3 /*break*/ ,
                            7
                        ];
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 4:
                        listResult = _c.sent();
                        (_a = list.results).push.apply(_a, __spreadArray([], __read(listResult.results), false));
                        if (listResult.nextToken) params.ContinuationToken = listResult.nextToken;
                        _c.label = 5;
                    case 5:
                        if (listResult.nextToken) return [
                            3 /*break*/ ,
                            3
                        ];
                        _c.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        if (pageSize && pageSize <= MAX_PAGE_SIZE && typeof pageSize === "number") params.MaxKeys = pageSize;
                        else logger.warn("pageSize should be from 0 - ".concat(MAX_PAGE_SIZE, "."));
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 8:
                        listResult = _c.sent();
                        (_b = list.results).push.apply(_b, __spreadArray([], __read(listResult.results), false));
                        list.hasNextToken = listResult.hasNextToken;
                        list.nextToken = (0, listResult.nextToken);
                        _c.label = 9;
                    case 9:
                        (0, _storageUtils.dispatchStorageEvent)(track, "list", {
                            method: "list",
                            result: "success"
                        }, null, "".concat(list.results.length, " items returned from list operation"));
                        logger.debug("list", list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 10:
                        error_7 = _c.sent();
                        logger.error("list InvalidArgument", error_7);
                        (0, _storageUtils.dispatchStorageEvent)(track, "list", {
                            method: "list",
                            result: "failed"
                        }, null, "Listing items failed: ".concat(error_7.message));
                        throw error_7;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._ensureCredentials = function() {
        return __awaiter(this, void 0, void 0, function() {
            var credentials, cred, error_8;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, _core.Credentials).shear(credentials);
                        logger.debug("set credentials for storage", cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_8 = _a.sent();
                        logger.warn("ensure credentials error", error_8);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._isWithCredentials = function(config) {
        return typeof config === "object" && config.hasOwnProperty("credentials");
    };
    AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : "private/") + identityId + "/";
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : "protected/") + identityId + "/";
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : "public/";
        switch(level){
            case "private":
                return privatePath;
            case "protected":
                return protectedPath;
            default:
                return publicPath;
        }
    };
    AWSS3Provider.CATEGORY = "Storage";
    AWSS3Provider.PROVIDER_NAME = "AWSS3";
    return AWSS3Provider;
}();

},{"@aws-amplify/core":"8BDOx","../AwsClients/S3":"5XjDE","../AwsClients/S3/utils":"3mUnf","../common/StorageErrorStrings":"65AGW","../common/StorageUtils":"34hIw","../common/S3ClientUtils":"1P7ZC","./AWSS3ProviderManagedUpload":"lUpqI","./AWSS3UploadTask":"3gcVb","../common/StorageConstants":"vlPxu","events":"gB3zd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5XjDE":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICE_NAME", ()=>(0, _base.SERVICE_NAME));
parcelHelpers.export(exports, "getObject", ()=>(0, _getObject.getObject));
parcelHelpers.export(exports, "getPresignedGetObjectUrl", ()=>(0, _getObject.getPresignedGetObjectUrl));
parcelHelpers.export(exports, "listObjectsV2", ()=>(0, _listObjectsV2.listObjectsV2));
parcelHelpers.export(exports, "putObject", ()=>(0, _putObject.putObject));
parcelHelpers.export(exports, "createMultipartUpload", ()=>(0, _createMultipartUpload.createMultipartUpload));
parcelHelpers.export(exports, "uploadPart", ()=>(0, _uploadPart.uploadPart));
parcelHelpers.export(exports, "completeMultipartUpload", ()=>(0, _completeMultipartUpload.completeMultipartUpload));
parcelHelpers.export(exports, "listParts", ()=>(0, _listParts.listParts));
parcelHelpers.export(exports, "abortMultipartUpload", ()=>(0, _abortMultipartUpload.abortMultipartUpload));
parcelHelpers.export(exports, "copyObject", ()=>(0, _copyObject.copyObject));
parcelHelpers.export(exports, "headObject", ()=>(0, _headObject.headObject));
parcelHelpers.export(exports, "deleteObject", ()=>(0, _deleteObject.deleteObject));
var _base = require("./base");
var _getObject = require("./getObject");
var _listObjectsV2 = require("./listObjectsV2");
var _putObject = require("./putObject");
var _createMultipartUpload = require("./createMultipartUpload");
var _uploadPart = require("./uploadPart");
var _completeMultipartUpload = require("./completeMultipartUpload");
var _listParts = require("./listParts");
var _abortMultipartUpload = require("./abortMultipartUpload");
var _copyObject = require("./copyObject");
var _headObject = require("./headObject");
var _deleteObject = require("./deleteObject");

},{"./base":"crQEW","./getObject":"4JcH9","./listObjectsV2":"gaqQ7","./putObject":"eRwO3","./createMultipartUpload":"9xcdu","./uploadPart":"eJRZJ","./completeMultipartUpload":"3CNJd","./listParts":"ibA5X","./abortMultipartUpload":"lToIV","./copyObject":"lMVes","./headObject":"Uci2D","./deleteObject":"ETf1q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"crQEW":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICE_NAME", ()=>SERVICE_NAME);
parcelHelpers.export(exports, "isDnsCompatibleBucketName", ()=>isDnsCompatibleBucketName);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
var _core = require("@aws-amplify/core");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("./utils");
var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
var SERVICE_NAME = "s3";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region, and input parameters.
 */ var endpointResolver = function(options, apiInput) {
    var region = options.region, useAccelerateEndpoint = options.useAccelerateEndpoint, customEndpoint = options.customEndpoint, forcePathStyle = options.forcePathStyle;
    var endpoint;
    // 1. get base endpoint
    if (customEndpoint) endpoint = new URL(customEndpoint);
    else if (useAccelerateEndpoint) {
        if (forcePathStyle) throw new Error("Path style URLs are not supported with S3 Transfer Acceleration.");
        endpoint = new URL("https://s3-accelerate.".concat((0, _awsClientUtils.getDnsSuffix)(region)));
    } else endpoint = new URL("https://s3.".concat(region, ".").concat((0, _awsClientUtils.getDnsSuffix)(region)));
    // 2. inject bucket name
    if (apiInput === null || apiInput === void 0 ? void 0 : apiInput.Bucket) {
        if (!isDnsCompatibleBucketName(apiInput.Bucket)) throw new Error('Invalid bucket name: "'.concat(apiInput.Bucket, '".'));
        if (forcePathStyle || apiInput.Bucket.includes(".")) endpoint.pathname = "/".concat(apiInput.Bucket);
        else endpoint.host = "".concat(apiInput.Bucket, ".").concat(endpoint.host);
    }
    return {
        url: endpoint
    };
};
var isDnsCompatibleBucketName = function(bucketName) {
    return DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
};
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _awsClientUtils.getRetryDecider)((0, _utils.parseXmlError)),
    computeDelay: (0, _awsClientUtils.jitteredBackoff),
    userAgentValue: (0, _core.getAmplifyUserAgent)(),
    useAccelerateEndpoint: false,
    uriEscapePath: false
};

},{"@aws-amplify/core":"8BDOx","@aws-amplify/core/internals/aws-client-utils":"9kGXj","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3mUnf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseXmlBody", ()=>(0, _parsePayload.parseXmlBody));
parcelHelpers.export(exports, "parseXmlError", ()=>(0, _parsePayload.parseXmlError));
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", ()=>(0, _runtime.SEND_DOWNLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", ()=>(0, _runtime.SEND_UPLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "s3TransferHandler", ()=>(0, _runtime.s3TransferHandler));
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", ()=>(0, _runtime.CANCELED_ERROR_MESSAGE));
parcelHelpers.export(exports, "isCancelError", ()=>(0, _runtime.isCancelError));
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", ()=>(0, _runtime.CONTENT_SHA256_HEADER));
parcelHelpers.export(exports, "deserializeBoolean", ()=>(0, _deserializeHelpers.deserializeBoolean));
parcelHelpers.export(exports, "deserializeMetadata", ()=>(0, _deserializeHelpers.deserializeMetadata));
parcelHelpers.export(exports, "deserializeNumber", ()=>(0, _deserializeHelpers.deserializeNumber));
parcelHelpers.export(exports, "deserializeTimestamp", ()=>(0, _deserializeHelpers.deserializeTimestamp));
parcelHelpers.export(exports, "emptyArrayGuard", ()=>(0, _deserializeHelpers.emptyArrayGuard));
parcelHelpers.export(exports, "map", ()=>(0, _deserializeHelpers.map));
parcelHelpers.export(exports, "assignStringVariables", ()=>(0, _serializeHelpers.assignStringVariables));
parcelHelpers.export(exports, "serializeObjectConfigsToHeaders", ()=>(0, _serializeHelpers.serializeObjectConfigsToHeaders));
parcelHelpers.export(exports, "serializePathnameObjectKey", ()=>(0, _serializeHelpers.serializePathnameObjectKey));
parcelHelpers.export(exports, "serializeObjectSsecOptionsToHeaders", ()=>(0, _serializeHelpers.serializeObjectSsecOptionsToHeaders));
parcelHelpers.export(exports, "toBase64", ()=>(0, _runtime.toBase64));
parcelHelpers.export(exports, "utf8Encode", ()=>(0, _runtime.utf8Encode));
var _parsePayload = require("./parsePayload");
var _runtime = require("../runtime");
var _deserializeHelpers = require("./deserializeHelpers");
var _serializeHelpers = require("./serializeHelpers");

},{"./parsePayload":"gRm4G","../runtime":"3BoE9","./deserializeHelpers":"W8MCI","./serializeHelpers":"WonpK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gRm4G":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseXmlError", ()=>parseXmlError);
parcelHelpers.export(exports, "parseXmlBody", ()=>parseXmlBody);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _runtime = require("../runtime");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var parseXmlError = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var statusCode, body, code, message, error;
        var _a, _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    statusCode = response.statusCode;
                    return [
                        4 /*yield*/ ,
                        parseXmlBody(response)
                    ];
                case 1:
                    body = _c.sent();
                    code = (body === null || body === void 0 ? void 0 : body["Code"]) ? body.Code : statusCode === 404 ? "NotFound" : statusCode.toString();
                    message = (_b = (_a = body === null || body === void 0 ? void 0 : body["message"]) !== null && _a !== void 0 ? _a : body === null || body === void 0 ? void 0 : body["Message"]) !== null && _b !== void 0 ? _b : code;
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var parseXmlBody = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var data;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) // S3 can return 200 without a body indicating failure.
                    throw new Error("S3 aborted request.");
                    return [
                        4 /*yield*/ ,
                        response.body.text()
                    ];
                case 1:
                    data = _a.sent();
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) try {
                        return [
                            2 /*return*/ ,
                            (0, _runtime.parser).parse(data)
                        ];
                    } catch (error) {
                        throw new Error("Failed to parse XML response.");
                    }
                    return [
                        2 /*return*/ ,
                        {}
                    ];
            }
        });
    });
};

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","../runtime":"3BoE9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3BoE9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Entry point for browser-specific S3 client utilities. It's used where DOMParser is available.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", ()=>(0, _constants.SEND_DOWNLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", ()=>(0, _constants.SEND_UPLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", ()=>(0, _constants.CANCELED_ERROR_MESSAGE));
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", ()=>(0, _constants.CONTENT_SHA256_HEADER));
parcelHelpers.export(exports, "s3TransferHandler", ()=>(0, _xhr.s3TransferHandler));
parcelHelpers.export(exports, "parser", ()=>(0, _dom.parser));
parcelHelpers.export(exports, "isCancelError", ()=>(0, _xhrTransferHandler.isCancelError));
parcelHelpers.export(exports, "toBase64", ()=>(0, _indexBrowser.toBase64));
parcelHelpers.export(exports, "utf8Encode", ()=>(0, _indexBrowser.utf8Encode));
var _constants = require("./constants");
var _xhr = require("./s3TransferHandler/xhr");
var _dom = require("./xmlParser/dom");
var _xhrTransferHandler = require("./xhrTransferHandler");
var _indexBrowser = require("./base64/index.browser");

},{"./constants":"dPASG","./s3TransferHandler/xhr":"5hRK3","./xmlParser/dom":"abgc2","./xhrTransferHandler":"aaMCA","./base64/index.browser":"6iEDx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dPASG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", ()=>SEND_UPLOAD_PROGRESS_EVENT);
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", ()=>SEND_DOWNLOAD_PROGRESS_EVENT);
parcelHelpers.export(exports, "NETWORK_ERROR_MESSAGE", ()=>NETWORK_ERROR_MESSAGE);
parcelHelpers.export(exports, "NETWORK_ERROR_CODE", ()=>NETWORK_ERROR_CODE);
parcelHelpers.export(exports, "ABORT_ERROR_MESSAGE", ()=>ABORT_ERROR_MESSAGE);
parcelHelpers.export(exports, "ABORT_ERROR_CODE", ()=>ABORT_ERROR_CODE);
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", ()=>CANCELED_ERROR_MESSAGE);
parcelHelpers.export(exports, "CANCELED_ERROR_CODE", ()=>CANCELED_ERROR_CODE);
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", ()=>CONTENT_SHA256_HEADER);
var SEND_UPLOAD_PROGRESS_EVENT = "sendUploadProgress";
var SEND_DOWNLOAD_PROGRESS_EVENT = "sendDownloadProgress";
var NETWORK_ERROR_MESSAGE = "Network Error";
var NETWORK_ERROR_CODE = "ECONNABORTED";
var ABORT_ERROR_MESSAGE = "Request aborted";
var ABORT_ERROR_CODE = "ERR_ABORTED";
var CANCELED_ERROR_MESSAGE = "canceled";
var CANCELED_ERROR_CODE = "ERR_CANCELED";
var CONTENT_SHA256_HEADER = "x-amz-content-sha256";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5hRK3":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s3TransferHandler", ()=>s3TransferHandler);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _contentSha256Middleware = require("../contentSha256middleware");
var _xhrTransferHandler = require("../xhrTransferHandler");
var s3TransferHandler = (0, _composers.composeTransferHandler)((0, _xhrTransferHandler.xhrTransferHandler), [
    (0, _contentSha256Middleware.contentSha256Middleware),
    (0, _awsClientUtils.userAgentMiddleware),
    (0, _awsClientUtils.retryMiddleware),
    (0, _awsClientUtils.signingMiddleware)
]);

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","../contentSha256middleware":"7QtHM","../xhrTransferHandler":"aaMCA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7QtHM":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentSha256Middleware", ()=>contentSha256Middleware);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _constants = require("./constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var contentSha256Middleware = function(options) {
    return function(next) {
        return function contentSha256Middleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var hash;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!request.headers[0, _constants.CONTENT_SHA256_HEADER]) return [
                                3 /*break*/ ,
                                1
                            ];
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, _awsClientUtils.getHashedPayload)(request.body)
                            ];
                        case 2:
                            hash = _a.sent();
                            request.headers[0, _constants.CONTENT_SHA256_HEADER] = hash;
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                    }
                });
            });
        };
    };
};

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","./constants":"dPASG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aaMCA":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhrTransferHandler", ()=>xhrTransferHandler);
parcelHelpers.export(exports, "isCancelError", ()=>isCancelError);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _core = require("@aws-amplify/core");
var _constants = require("./constants");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _core.ConsoleLogger)("xhr-http-handler");
var xhrTransferHandler = function(request, options) {
    var url = request.url, method = request.method, headers = request.headers, body = request.body;
    var emitter = options.emitter, responseType = options.responseType, abortSignal = options.abortSignal;
    return new Promise(function(resolve, reject) {
        var _a;
        var xhr = new XMLHttpRequest();
        xhr.open(method.toUpperCase(), url.toString());
        Object.entries(headers).filter(function(_a) {
            var _b = __read(_a, 1), header = _b[0];
            return !FORBIDDEN_HEADERS.includes(header);
        }).forEach(function(_a) {
            var _b = __read(_a, 2), header = _b[0], value = _b[1];
            xhr.setRequestHeader(header, value);
        });
        xhr.responseType = responseType;
        if (emitter) {
            xhr.upload.addEventListener("progress", function(event) {
                emitter.emit((0, _constants.SEND_UPLOAD_PROGRESS_EVENT), event);
                logger.debug(event);
            });
            xhr.addEventListener("progress", function(event) {
                emitter.emit((0, _constants.SEND_DOWNLOAD_PROGRESS_EVENT), event);
                logger.debug(event);
            });
        }
        xhr.addEventListener("error", function() {
            var error = simulateAxiosError((0, _constants.NETWORK_ERROR_MESSAGE), (0, _constants.NETWORK_ERROR_CODE), xhr, options);
            logger.error((0, _constants.NETWORK_ERROR_MESSAGE));
            reject(error);
            xhr = null; // clean up request
        });
        // Handle browser request cancellation (as opposed to a manual cancellation)
        xhr.addEventListener("abort", function() {
            // The abort event can be triggered after the error or load event. So we need to check if the xhr is null.
            if (!xhr || (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted)) return;
            var error = simulateAxiosError((0, _constants.ABORT_ERROR_MESSAGE), (0, _constants.ABORT_ERROR_CODE), xhr, options);
            logger.error((0, _constants.ABORT_ERROR_MESSAGE));
            reject(error);
            xhr = null; // clean up request
        });
        // Skip handling timeout error since we don't have a timeout
        xhr.addEventListener("readystatechange", function() {
            if (!xhr || xhr.readyState !== xhr.DONE) return;
            var onloadend = function() {
                // The load event is triggered after the error/abort/load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var responseHeaders = convertResponseHeaders(xhr.getAllResponseHeaders());
                var responseType = xhr.responseType;
                var responseBlob = xhr.response;
                var responseText = responseType === "text" ? xhr.responseText : "";
                var bodyMixIn = {
                    blob: function() {
                        return Promise.resolve(responseBlob);
                    },
                    text: (0, _awsClientUtils.withMemoization)(function() {
                        return responseType === "blob" ? readBlobAsText(responseBlob) : Promise.resolve(responseText);
                    }),
                    json: function() {
                        return Promise.reject(// S3 does not support JSON response. So fail-fast here with nicer error message.
                        new Error("Parsing response to JSON is not implemented. Please use response.text() instead."));
                    }
                };
                var response = {
                    statusCode: xhr.status,
                    headers: responseHeaders,
                    // The xhr.responseType is only set to 'blob' for streaming binary S3 object data. The streaming data is
                    // exposed via public interface of Storage.get(). So we need to return the response as a Blob object for
                    // backward compatibility. In other cases, the response payload is only used internally, we return it is
                    // {@link ResponseBodyMixin}
                    body: xhr.responseType === "blob" ? Object.assign(responseBlob, bodyMixIn) : bodyMixIn
                };
                resolve(response);
                xhr = null; // clean up request
            };
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            // @see https://github.com/axios/axios/blob/9588fcdec8aca45c3ba2f7968988a5d03f23168c/lib/adapters/xhr.js#L98-L99
            setTimeout(onloadend);
        });
        if (abortSignal) {
            var onCancelled = function() {
                // The abort event is triggered after the error or load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var canceledError = simulateAxiosCanceledError((0, _constants.CANCELED_ERROR_MESSAGE) !== null && (0, _constants.CANCELED_ERROR_MESSAGE) !== void 0 ? (0, _constants.CANCELED_ERROR_MESSAGE) : abortSignal.reason, (0, _constants.CANCELED_ERROR_CODE), xhr, options);
                xhr.abort();
                reject(canceledError);
                xhr = null;
            };
            abortSignal.aborted ? onCancelled() : abortSignal.addEventListener("abort", onCancelled);
        }
        if (typeof ReadableStream === "function" && body instanceof ReadableStream) // This does not matter as previous implementation uses Axios which does not support ReadableStream anyway.
        throw new Error("ReadableStream request payload is not supported.");
        xhr.send((_a = body) !== null && _a !== void 0 ? _a : null);
    });
};
// TODO: V6 remove this
var simulateAxiosError = function(message, code, request, config) {
    return Object.assign(new Error(message), {
        code: code,
        config: config,
        request: request
    });
};
var simulateAxiosCanceledError = function(message, code, request, config) {
    var error = simulateAxiosError(message, code, request, config);
    error.name = "CanceledError";
    error["__CANCEL__"] = true;
    return error;
};
var isCancelError = function(error) {
    return !!(error === null || error === void 0 ? void 0 : error["__CANCEL__"]);
};
/**
 * Convert xhr.getAllResponseHeaders() string to a Record<string, string>. Note that modern browser already returns
 * header names in lowercase.
 * @param xhrHeaders - string of headers returned from xhr.getAllResponseHeaders()
 */ var convertResponseHeaders = function(xhrHeaders) {
    if (!xhrHeaders) return {};
    return xhrHeaders.split("\r\n").reduce(function(headerMap, line) {
        var parts = line.split(": ");
        var header = parts.shift();
        var value = parts.join(": ");
        headerMap[header.toLowerCase()] = value;
        return headerMap;
    }, {});
};
var readBlobAsText = function(blob) {
    var reader = new FileReader();
    return new Promise(function(resolve, reject) {
        reader.onloadend = function() {
            if (reader.readyState !== FileReader.DONE) return;
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
        reader.readAsText(blob);
    });
};
// To add more forbidden headers as found set by S3. Intentionally NOT list all of them here to save bundle size.
// https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
var FORBIDDEN_HEADERS = [
    "host"
];

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core":"8BDOx","./constants":"dPASG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"abgc2":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Drop-in replacement for fast-xml-parser's XmlParser class used in the AWS SDK S3 client XML deserializer. This
 * implementation is not tested against the full xml conformance test suite. It is only tested against the XML responses
 * from S3. This implementation requires the `DOMParser` class in the runtime.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", ()=>parser);
var parser = {
    parse: function(xmlStr) {
        var domParser = new DOMParser();
        var xml = domParser.parseFromString(xmlStr, "text/xml");
        var parsedObj = parseXmlNode(xml);
        var rootKey = Object.keys(parsedObj)[0];
        return parsedObj[rootKey];
    }
};
var parseXmlNode = function(node) {
    var _a;
    var _b, _c;
    if (isDocumentNode(node)) return _a = {}, _a[node.documentElement.nodeName] = parseXmlNode(node.documentElement), _a;
    if (node.nodeType === Node.TEXT_NODE) return (_b = node.nodeValue) === null || _b === void 0 ? void 0 : _b.trim();
    if (isElementNode(node)) {
        // Node like <Location>foo</Location> will be converted to { Location: 'foo' }
        // instead of { Location: { '#text': 'foo' } }.
        if (isTextOnlyElementNode(node)) return (_c = node.childNodes[0]) === null || _c === void 0 ? void 0 : _c.nodeValue;
        var nodeValue = {};
        // convert attributes
        for(var i = 0; i < node.attributes.length; i++){
            var attr = node.attributes[i];
            if (!isNamespaceAttributeName(attr.nodeName)) nodeValue[attr.nodeName] = attr.nodeValue;
        }
        // convert child nodes
        if (node.children.length > 0) for(var i = 0; i < node.children.length; i++){
            var child = node.children[i];
            var childValue = parseXmlNode(child);
            if (childValue === undefined) continue;
            var childName = child.nodeName;
            if (nodeValue[childName] === undefined) nodeValue[childName] = childValue;
            else if (Array.isArray(nodeValue[childName])) nodeValue[childName].push(childValue);
            else nodeValue[childName] = [
                nodeValue[childName],
                childValue
            ];
        }
        // Return empty element node as empty string instead of `{}`, which is the default behavior of fast-xml-parser.
        return Object.keys(nodeValue).length === 0 ? "" : nodeValue;
    }
};
var isElementNode = function(node) {
    return node.nodeType === Node.ELEMENT_NODE;
};
var isDocumentNode = function(node) {
    return node.nodeType === Node.DOCUMENT_NODE;
};
var isTextOnlyElementNode = function(node) {
    var _a;
    return hasOnlyNamespaceAttributes(node) && node.children.length === 0 && ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.nodeType) === Node.TEXT_NODE;
};
var hasOnlyNamespaceAttributes = function(node) {
    for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes[i];
        if (!isNamespaceAttributeName(attr.nodeName)) return false;
    }
    return true;
};
var isNamespaceAttributeName = function(name) {
    return name === "xmlns" || name.startsWith("xmlns:");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6iEDx":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utf8Encode", ()=>utf8Encode);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
function bytesToBase64(bytes) {
    var base64Str = Array.from(bytes, function(x) {
        return String.fromCodePoint(x);
    }).join("");
    return btoa(base64Str);
}
function utf8Encode(input) {
    return new TextEncoder().encode(input);
}
function toBase64(input) {
    if (typeof input === "string") return bytesToBase64(utf8Encode(input));
    return bytesToBase64(new Uint8Array(input.buffer, input.byteOffset, input.byteLength));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"W8MCI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "deserializeNumber", ()=>deserializeNumber);
parcelHelpers.export(exports, "deserializeBoolean", ()=>deserializeBoolean);
parcelHelpers.export(exports, "deserializeTimestamp", ()=>deserializeTimestamp);
parcelHelpers.export(exports, "emptyArrayGuard", ()=>emptyArrayGuard);
parcelHelpers.export(exports, "deserializeMetadata", ()=>deserializeMetadata);
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var map = function(obj, instructions) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = __values(Object.entries(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], instruction = _d[1];
            var _e = __read(Array.isArray(instruction) ? instruction : [
                instruction
            ], 2), accessor = _e[0], deserializer = _e[1];
            if (obj.hasOwnProperty(accessor)) result[key] = deserializer ? deserializer(obj[accessor]) : String(obj[accessor]);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
};
var deserializeNumber = function(value) {
    return value ? Number(value) : undefined;
};
var deserializeBoolean = function(value) {
    return value ? value === "true" : undefined;
};
var deserializeTimestamp = function(value) {
    return value ? new Date(value) : undefined;
};
var emptyArrayGuard = function(value, deserializer) {
    if (value === "") return [];
    var valueArray = (Array.isArray(value) ? value : [
        value
    ]).filter(function(e) {
        return e != null;
    });
    return deserializer(valueArray);
};
var deserializeMetadata = function(headers) {
    var objectMetadataHeaderPrefix = "x-amz-meta-";
    var deserialized = Object.keys(headers).filter(function(header) {
        return header.startsWith(objectMetadataHeaderPrefix);
    }).reduce(function(acc, header) {
        acc[header.replace(objectMetadataHeaderPrefix, "")] = headers[header];
        return acc;
    }, {});
    return Object.keys(deserialized).length > 0 ? deserialized : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"WonpK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignStringVariables", ()=>assignStringVariables);
parcelHelpers.export(exports, "serializeObjectSsecOptionsToHeaders", ()=>serializeObjectSsecOptionsToHeaders);
parcelHelpers.export(exports, "serializeObjectConfigsToHeaders", ()=>serializeObjectConfigsToHeaders);
parcelHelpers.export(exports, "serializePathnameObjectKey", ()=>serializePathnameObjectKey);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _md5Js = require("@aws-sdk/md5-js");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("../utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var assignStringVariables = function(values) {
    var e_1, _a;
    var queryParams = {};
    try {
        for(var _b = __values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (value != null) queryParams[key] = value.toString();
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return queryParams;
};
var serializeObjectSsecOptionsToHeaders = function(input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var getMd5Digest, _a, _b, _c, _d;
        var _e;
        return __generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    getMd5Digest = function(content) {
                        return __awaiter(void 0, void 0, void 0, function() {
                            var md5Hasher;
                            return __generator(this, function(_a) {
                                md5Hasher = new (0, _md5Js.Md5)();
                                md5Hasher.update((0, _utils.utf8Encode)(content));
                                return [
                                    2 /*return*/ ,
                                    md5Hasher.digest()
                                ];
                            });
                        });
                    };
                    _a = assignStringVariables;
                    _e = {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
                        // base64 encoded is need
                        // see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/ServerSideEncryptionCustomerKeys.html#specifying-s3-c-encryption
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey && (0, _utils.toBase64)(input.SSECustomerKey)
                    };
                    // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                    // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                    _b = "x-amz-server-side-encryption-customer-key-md5";
                    _c = input.SSECustomerKey;
                    if (!_c) return [
                        3 /*break*/ ,
                        2
                    ];
                    _d = (0, _utils.toBase64);
                    return [
                        4 /*yield*/ ,
                        getMd5Digest(input.SSECustomerKey)
                    ];
                case 1:
                    _c = _d.apply(void 0, [
                        _f.sent()
                    ]);
                    _f.label = 2;
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                            // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                            (_e[_b] = _c, _e)
                        ])
                    ];
            }
        });
    });
};
var serializeObjectConfigsToHeaders = function(input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var _a;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        serializeObjectSsecOptionsToHeaders(input)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        __assign.apply(void 0, [
                            __assign.apply(void 0, _a.concat([
                                _c.sent()
                            ])),
                            assignStringVariables(__assign({
                                "x-amz-server-side-encryption": input.ServerSideEncryption,
                                "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
                                "x-amz-acl": input.ACL,
                                "cache-control": input.CacheControl,
                                "content-disposition": input.ContentDisposition,
                                "content-language": input.ContentLanguage,
                                "content-encoding": input.ContentEncoding,
                                "content-type": input.ContentType,
                                expires: (_b = input.Expires) === null || _b === void 0 ? void 0 : _b.toUTCString(),
                                "x-amz-tagging": input.Tagging
                            }, serializeMetadata(input.Metadata)))
                        ])
                    ];
            }
        });
    });
};
var serializeMetadata = function(metadata) {
    if (metadata === void 0) metadata = {};
    return Object.keys(metadata).reduce(function(acc, suffix) {
        acc["x-amz-meta-".concat(suffix.toLowerCase())] = metadata[suffix];
        return acc;
    }, {});
};
var serializePathnameObjectKey = function(url, key) {
    return url.pathname.replace(/\/$/, "") + "/".concat(key.split("/").map((0, _awsClientUtils.extendedEncodeURIComponent)).join("/"));
};

},{"@aws-sdk/md5-js":"521VW","@aws-amplify/core/internals/aws-client-utils":"9kGXj","../utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"521VW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Md5", ()=>Md5);
var _tslib = require("tslib");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _constants = require("./constants");
var Md5 = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, _constants.INIT));
        this.buffer = new DataView(new ArrayBuffer((0, _constants.BLOCK_SIZE)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if (isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, _constants.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, _tslib.__generator)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, _constants.BLOCK_SIZE) >= (0, _constants.BLOCK_SIZE) - 8) {
                        for(i = this.bufferLength; i < (0, _constants.BLOCK_SIZE); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, _constants.BLOCK_SIZE) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, _constants.BLOCK_SIZE) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, _constants.BLOCK_SIZE) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, _constants.DIGEST_LENGTH)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function ff(a, b, c, d, x, s, t) {
    return cmn(b & c | ~b & d, a, b, x, s, t);
}
function gg(a, b, c, d, x, s, t) {
    return cmn(b & d | c & ~d, a, b, x, s, t);
}
function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}
function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
}
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function convertToBuffer(data) {
    if (typeof data === "string") return (0, _utilUtf8Browser.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"tslib":"9gMVn","@aws-sdk/util-utf8-browser":"iG5nw","./constants":"iUCc9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iG5nw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"9YhIQ","./whatwgEncodingApi":"dGhfY","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9YhIQ":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dGhfY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iUCc9":[function(require,module,exports) {
/**
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLOCK_SIZE", ()=>BLOCK_SIZE);
parcelHelpers.export(exports, "DIGEST_LENGTH", ()=>DIGEST_LENGTH);
parcelHelpers.export(exports, "INIT", ()=>INIT);
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 16;
var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4JcH9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getObject", ()=>getObject);
parcelHelpers.export(exports, "getPresignedGetObjectUrl", ()=>getPresignedGetObjectUrl);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _core = require("@aws-amplify/core");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, query, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    query = (0, _utils.map)(input, {
                        "response-cache-control": "ResponseCacheControl",
                        "response-content-disposition": "ResponseContentDisposition",
                        "response-content-encoding": "ResponseContentEncoding",
                        "response-content-language": "ResponseContentLanguage",
                        "response-content-type": "ResponseContentType"
                    });
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams(query).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "GET",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var getObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    if (!response.body) throw new Error("Got empty response body.");
                    else return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            DeleteMarker: [
                                "x-amz-delete-marker",
                                (0, _utils.deserializeBoolean)
                            ],
                            AcceptRanges: "accept-ranges",
                            Expiration: "x-amz-expiration",
                            Restore: "x-amz-restore",
                            LastModified: [
                                "last-modified",
                                (0, _utils.deserializeTimestamp)
                            ],
                            ContentLength: [
                                "content-length",
                                (0, _utils.deserializeNumber)
                            ],
                            ETag: "etag",
                            ChecksumCRC32: "x-amz-checksum-crc32",
                            ChecksumCRC32C: "x-amz-checksum-crc32c",
                            ChecksumSHA1: "x-amz-checksum-sha1",
                            ChecksumSHA256: "x-amz-checksum-sha256",
                            MissingMeta: [
                                "x-amz-missing-meta",
                                (0, _utils.deserializeNumber)
                            ],
                            VersionId: "x-amz-version-id",
                            CacheControl: "cache-control",
                            ContentDisposition: "content-disposition",
                            ContentEncoding: "content-encoding",
                            ContentLanguage: "content-language",
                            ContentRange: "content-range",
                            ContentType: "content-type",
                            Expires: [
                                "expires",
                                (0, _utils.deserializeTimestamp)
                            ],
                            WebsiteRedirectLocation: "x-amz-website-redirect-location",
                            ServerSideEncryption: "x-amz-server-side-encryption",
                            SSECustomerAlgorithm: "x-amz-server-side-encryption-customer-algorithm",
                            SSECustomerKeyMD5: "x-amz-server-side-encryption-customer-key-md5",
                            SSEKMSKeyId: "x-amz-server-side-encryption-aws-kms-key-id",
                            BucketKeyEnabled: [
                                "x-amz-server-side-encryption-bucket-key-enabled",
                                (0, _utils.deserializeBoolean)
                            ],
                            StorageClass: "x-amz-storage-class",
                            RequestCharged: "x-amz-request-charged",
                            ReplicationStatus: "x-amz-replication-status",
                            PartsCount: [
                                "x-amz-mp-parts-count",
                                (0, _utils.deserializeNumber)
                            ],
                            TagCount: [
                                "x-amz-tagging-count",
                                (0, _utils.deserializeNumber)
                            ],
                            ObjectLockMode: "x-amz-object-lock-mode",
                            ObjectLockRetainUntilDate: [
                                "x-amz-object-lock-retain-until-date",
                                (0, _utils.deserializeTimestamp)
                            ],
                            ObjectLockLegalHoldStatus: "x-amz-object-lock-legal-hold"
                        })), {
                            Metadata: (0, _utils.deserializeMetadata)(response.headers),
                            $metadata: (0, _awsClientUtils.parseMetadata)(response),
                            Body: response.body
                        })
                    ];
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var getObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), getObjectSerializer, getObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "blob"
}));
var getPresignedGetObjectUrl = function(config, input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var endpoint, _a, url, headers, method, _b, _c, _d, headerName, value;
        var e_1, _e;
        var _f;
        return __generator(this, function(_g) {
            switch(_g.label){
                case 0:
                    endpoint = (0, _base.defaultConfig).endpointResolver(config, input);
                    return [
                        4 /*yield*/ ,
                        getObjectSerializer(input, endpoint)
                    ];
                case 1:
                    _a = _g.sent(), url = _a.url, headers = _a.headers, method = _a.method;
                    // TODO: set content sha256 query parameter with value of UNSIGNED-PAYLOAD.
                    // It requires changes in presignUrl. Without this change, the generated url still works,
                    // but not the same as other tools like AWS SDK and CLI.
                    url.searchParams.append((0, _utils.CONTENT_SHA256_HEADER), (0, _awsClientUtils.EMPTY_SHA256_HASH));
                    url.searchParams.append((_f = config.userAgentHeader) !== null && _f !== void 0 ? _f : (0, _core.USER_AGENT_HEADER), config.userAgentValue);
                    try {
                        for(_b = __values(Object.entries(headers).sort(function(_a, _b) {
                            var _c = __read(_a, 1), key1 = _c[0];
                            var _d = __read(_b, 1), key2 = _d[0];
                            return key1.localeCompare(key2);
                        })), _c = _b.next(); !_c.done; _c = _b.next()){
                            _d = __read(_c.value, 2), headerName = _d[0], value = _d[1];
                            url.searchParams.append(headerName, value);
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    return [
                        2 /*return*/ ,
                        (0, _awsClientUtils.presignUrl)({
                            method: method,
                            url: url,
                            body: null
                        }, __assign(__assign({}, (0, _base.defaultConfig)), config)).toString()
                    ];
            }
        });
    });
};

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","@aws-amplify/core":"8BDOx","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gaqQ7":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listObjectsV2", ()=>listObjectsV2);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var listObjectsV2Serializer = function(input, endpoint) {
    var headers = (0, _utils.assignStringVariables)({
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    var query = (0, _utils.assignStringVariables)({
        "list-type": "2",
        "continuation-token": input.ContinuationToken,
        delimiter: input.Delimiter,
        "encoding-type": input.EncodingType,
        "fetch-owner": input.FetchOwner,
        "max-keys": input.MaxKeys,
        prefix: input.Prefix,
        "start-after": input.StartAfter
    });
    var url = new URL(endpoint.url.toString());
    url.search = new URLSearchParams(query).toString();
    return {
        method: "GET",
        headers: headers,
        url: url
    };
};
var listObjectsV2Deserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        CommonPrefixes: [
                            "CommonPrefixes",
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeCommonPrefixList);
                            }
                        ],
                        Contents: [
                            "Contents",
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeObjectList);
                            }
                        ],
                        ContinuationToken: "ContinuationToken",
                        Delimiter: "Delimiter",
                        EncodingType: "EncodingType",
                        IsTruncated: [
                            "IsTruncated",
                            (0, _utils.deserializeBoolean)
                        ],
                        KeyCount: [
                            "KeyCount",
                            (0, _utils.deserializeNumber)
                        ],
                        MaxKeys: [
                            "MaxKeys",
                            (0, _utils.deserializeNumber)
                        ],
                        Name: "Name",
                        NextContinuationToken: "NextContinuationToken",
                        Prefix: "Prefix",
                        StartAfter: "StartAfter"
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var deserializeCommonPrefixList = function(output) {
    return output.map(deserializeCommonPrefix);
};
var deserializeCommonPrefix = function(output) {
    return (0, _utils.map)(output, {
        Prefix: "Prefix"
    });
};
var deserializeObjectList = function(output) {
    return output.map(deserializeObject);
};
var deserializeObject = function(output) {
    return (0, _utils.map)(output, {
        Key: "Key",
        LastModified: [
            "LastModified",
            (0, _utils.deserializeTimestamp)
        ],
        ETag: "ETag",
        ChecksumAlgorithm: [
            "ChecksumAlgorithm",
            function(value) {
                return (0, _utils.emptyArrayGuard)(value, deserializeChecksumAlgorithmList);
            }
        ],
        Size: [
            "Size",
            (0, _utils.deserializeNumber)
        ],
        StorageClass: "StorageClass",
        Owner: [
            "Owner",
            deserializeOwner
        ]
    });
};
var deserializeChecksumAlgorithmList = function(output) {
    return output.map(function(entry) {
        return String(entry);
    });
};
var deserializeOwner = function(output) {
    return (0, _utils.map)(output, {
        DisplayName: "DisplayName",
        ID: "ID"
    });
};
var listObjectsV2 = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), listObjectsV2Serializer, listObjectsV2Deserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eRwO3":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putObject", ()=>putObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var putObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(__assign(__assign({}, input), {
                            ContentType: (_b = input.ContentType) !== null && _b !== void 0 ? _b : "application/octet-stream"
                        }))
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _c.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            "content-md5": input.ContentMD5
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var putObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            ETag: "etag",
                            VersionId: "x-amz-version-id"
                        })), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var putObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), putObjectSerializer, putObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9xcdu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMultipartUpload", ()=>createMultipartUpload);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var createMultipartUploadSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = "uploads";
                    return [
                        2 /*return*/ ,
                        {
                            method: "POST",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var createMultipartUploadDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        UploadId: "UploadId"
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var createMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), createMultipartUploadSerializer, createMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eJRZJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uploadPart", ()=>uploadPart);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var uploadPartSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            "content-md5": input.ContentMD5
                        })
                    ]);
                    headers["content-type"] = "application/octet-stream";
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        partNumber: input.PartNumber + "",
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var uploadPartDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            ETag: "etag"
                        })), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var uploadPart = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), uploadPartSerializer, uploadPartDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3CNJd":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "completeMultipartUpload", ()=>completeMultipartUpload);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var INVALID_PARAMETER_ERROR_MSG = "Invalid parameter for ComplteMultipartUpload API";
var completeMultipartUploadSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    headers["content-type"] = "application/xml";
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "POST",
                            headers: headers,
                            url: url,
                            body: '<?xml version="1.0" encoding="UTF-8"?>' + serializeCompletedMultipartUpload(input.MultipartUpload)
                        }
                    ];
            }
        });
    });
};
var serializeCompletedMultipartUpload = function(input) {
    var _a;
    if (!((_a = input.Parts) === null || _a === void 0 ? void 0 : _a.length)) throw new Error("".concat(INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return '<CompleteMultipartUpload xmlns="http://s3.amazonaws.com/doc/2006-03-01/">'.concat(input.Parts.map(serializeCompletedPartList).join(""), "</CompleteMultipartUpload>");
};
var serializeCompletedPartList = function(input) {
    if (!input.ETag || input.PartNumber == null) throw new Error("".concat(INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return "<Part><ETag>".concat(input.ETag, "</ETag><PartNumber>").concat(input.PartNumber, "</PartNumber></Part>");
};
/**
 * Parse CompleteMultipartUpload API response payload, which may be empty or error indicating internal
 * server error, even when the status code is 200.
 *
 * Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
 */ var parseXmlBodyOrThrow = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var parsed, error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (!(parsed.Code !== undefined && parsed.Message !== undefined)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(__assign(__assign({}, response), {
                            statusCode: 500
                        }))
                    ];
                case 2:
                    error = _a.sent();
                    error.$metadata.httpStatusCode = response.statusCode;
                    throw error;
                case 3:
                    return [
                        2 /*return*/ ,
                        parsed
                    ];
            }
        });
    });
};
var completeMultipartUploadDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        parseXmlBodyOrThrow(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        ETag: "ETag",
                        Key: "Key",
                        Location: "Location"
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
// CompleteMultiPartUpload API returns 200 status code with empty body or error message.
// This indicates internal server error after the response has been sent to the client.
// Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
var retryWhenErrorWith200StatusCode = function(response, error) {
    return __awaiter(void 0, void 0, void 0, function() {
        var parsed, defaultRetryDecider;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode === 200)) return [
                        3 /*break*/ ,
                        2
                    ];
                    if (!response.body) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (parsed.Code !== undefined && parsed.Message !== undefined) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 2:
                    defaultRetryDecider = (0, _base.defaultConfig).retryDecider;
                    return [
                        2 /*return*/ ,
                        defaultRetryDecider(response, error)
                    ];
            }
        });
    });
};
var completeMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), completeMultipartUploadSerializer, completeMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text",
    retryDecider: retryWhenErrorWith200StatusCode
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ibA5X":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listParts", ()=>listParts);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var listPartsSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "GET",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var listPartsDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        UploadId: "UploadId",
                        Parts: [
                            "Part",
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeCompletedPartList);
                            }
                        ]
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var deserializeCompletedPartList = function(input) {
    return input.map(function(item) {
        return (0, _utils.map)(item, {
            PartNumber: [
                "PartNumber",
                (0, _utils.deserializeNumber)
            ],
            ETag: "ETag",
            Size: [
                "Size",
                (0, _utils.deserializeNumber)
            ]
        });
    });
};
var listParts = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), listPartsSerializer, listPartsDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lToIV":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abortMultipartUpload", ()=>abortMultipartUpload);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var abortMultipartUploadSerializer = function(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
    url.search = new URLSearchParams({
        uploadId: input.UploadId
    }).toString();
    return {
        method: "DELETE",
        headers: {},
        url: url
    };
};
var abortMultipartUploadDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var abortMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), abortMultipartUploadSerializer, abortMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lMVes":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyObject", ()=>copyObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var copyObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(input)
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            "x-amz-copy-source": input.CopySource,
                            "x-amz-metadata-directive": input.MetadataDirective
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var copyObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var copyObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), copyObjectSerializer, copyObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"Uci2D":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "headObject", ()=>headObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var headObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "HEAD",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var headObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    contents = __assign(__assign({}, (0, _utils.map)(response.headers, {
                        ContentLength: [
                            "content-length",
                            (0, _utils.deserializeNumber)
                        ],
                        ContentType: "content-type",
                        ETag: "etag",
                        LastModified: [
                            "last-modified",
                            (0, _utils.deserializeTimestamp)
                        ],
                        VersionId: "x-amz-version-id"
                    })), {
                        Metadata: (0, _utils.deserializeMetadata)(response.headers)
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var headObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), headObjectSerializer, headObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ETf1q":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteObject", ()=>deleteObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var deleteObjectSerializer = function(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
    return {
        method: "DELETE",
        headers: {},
        url: url
    };
};
var deleteObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, content;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    content = (0, _utils.map)(response.headers, {
                        DeleteMarker: [
                            "x-amz-delete-marker",
                            (0, _utils.deserializeBoolean)
                        ],
                        VersionId: "x-amz-version-id",
                        RequestCharged: "x-amz-request-charged"
                    });
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, content), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var deleteObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), deleteObjectSerializer, deleteObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"9kGXj","@aws-amplify/core/internals/aws-client-utils/composers":"fOplU","./base":"crQEW","./utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"65AGW":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageErrorStrings", ()=>StorageErrorStrings);
parcelHelpers.export(exports, "AWSS3ProviderMultipartCopierErrors", ()=>AWSS3ProviderMultipartCopierErrors);
parcelHelpers.export(exports, "AWSS3ProviderUploadErrorStrings", ()=>AWSS3ProviderUploadErrorStrings);
var StorageErrorStrings;
(function(StorageErrorStrings) {
    StorageErrorStrings["NO_CREDENTIALS"] = "No credentials";
    StorageErrorStrings["NO_SRC_KEY"] = 'source param should be an object with the property "key" with value of type string';
    StorageErrorStrings["NO_DEST_KEY"] = 'destination param should be an object with the property "key" with value of type string';
    StorageErrorStrings["INVALID_BLOB"] = "Object must be an instance of Blob";
})(StorageErrorStrings || (StorageErrorStrings = {}));
var AWSS3ProviderMultipartCopierErrors;
(function(AWSS3ProviderMultipartCopierErrors) {
    AWSS3ProviderMultipartCopierErrors["CLEANUP_FAILED"] = "Multipart copy clean up failed";
    AWSS3ProviderMultipartCopierErrors["NO_OBJECT_FOUND"] = "Object does not exist";
    AWSS3ProviderMultipartCopierErrors["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
    AWSS3ProviderMultipartCopierErrors["NO_COPYSOURCE"] = "You must specify a copy source";
    AWSS3ProviderMultipartCopierErrors["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})(AWSS3ProviderMultipartCopierErrors || (AWSS3ProviderMultipartCopierErrors = {}));
var AWSS3ProviderUploadErrorStrings;
(function(AWSS3ProviderUploadErrorStrings) {
    AWSS3ProviderUploadErrorStrings["UPLOAD_PAUSED_MESSAGE"] = "paused";
})(AWSS3ProviderUploadErrorStrings || (AWSS3ProviderUploadErrorStrings = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"34hIw":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "byteLength", ()=>byteLength);
parcelHelpers.export(exports, "dispatchStorageEvent", ()=>dispatchStorageEvent);
parcelHelpers.export(exports, "isFile", ()=>isFile);
parcelHelpers.export(exports, "isBlob", ()=>isBlob);
var _core = require("@aws-amplify/core");
var _storageConstants = require("./StorageConstants");
var byteLength = function(x) {
    if (typeof x === "string") return x.length;
    else if (isArrayBuffer(x)) return x.byteLength;
    else if (isBlob(x)) return x.size;
    else throw new Error("Cannot determine byte length of " + x);
};
var dispatchStorageEvent = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data["metrics"] = metrics;
        (0, _core.Hub).dispatch("storage", {
            event: event,
            data: data,
            message: message
        }, "Storage", (0, _storageConstants.AMPLIFY_SYMBOL));
    }
};
var isFile = function(x) {
    return typeof x !== "undefined" && x instanceof File;
};
var isBlob = function(x) {
    return typeof x !== "undefined" && x instanceof Blob;
};
var isArrayBuffer = function(x) {
    return typeof x !== "undefined" && x instanceof ArrayBuffer;
};

},{"@aws-amplify/core":"8BDOx","./StorageConstants":"vlPxu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"vlPxu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
parcelHelpers.export(exports, "localTestingStorageEndpoint", ()=>localTestingStorageEndpoint);
parcelHelpers.export(exports, "UPLOADS_STORAGE_KEY", ()=>UPLOADS_STORAGE_KEY);
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var localTestingStorageEndpoint = "http://localhost:20005";
var UPLOADS_STORAGE_KEY = "__uploadInProgress";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1P7ZC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrefix", ()=>getPrefix);
parcelHelpers.export(exports, "credentialsProvider", ()=>credentialsProvider);
parcelHelpers.export(exports, "loadS3Config", ()=>loadS3Config);
parcelHelpers.export(exports, "DEFAULT_PART_SIZE", ()=>DEFAULT_PART_SIZE);
parcelHelpers.export(exports, "MAX_OBJECT_SIZE", ()=>MAX_OBJECT_SIZE);
parcelHelpers.export(exports, "MAX_PARTS_COUNT", ()=>MAX_PARTS_COUNT);
parcelHelpers.export(exports, "DEFAULT_QUEUE_SIZE", ()=>DEFAULT_QUEUE_SIZE);
parcelHelpers.export(exports, "calculatePartSize", ()=>calculatePartSize);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _storageConstants = require("./StorageConstants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _core.Logger)("S3ClientUtils");
// placeholder credentials in order to satisfy type requirement, always results in 403 when used
var INVALID_CRED = {
    accessKeyId: "",
    secretAccessKey: ""
};
var getPrefix = function(config) {
    var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
    var resolvedCustomPrefix = customPrefix || {};
    var resolvedIdentityId = identityId || credentials.identityId;
    var privatePath = (resolvedCustomPrefix.private !== undefined ? resolvedCustomPrefix.private : "private/") + resolvedIdentityId + "/";
    var protectedPath = (resolvedCustomPrefix.protected !== undefined ? resolvedCustomPrefix.protected : "protected/") + resolvedIdentityId + "/";
    var publicPath = resolvedCustomPrefix.public !== undefined ? resolvedCustomPrefix.public : "public/";
    switch(level){
        case "private":
            return privatePath;
        case "protected":
            return protectedPath;
        default:
            return publicPath;
    }
};
var credentialsProvider = function() {
    return __awaiter(void 0, void 0, void 0, function() {
        var credentials, cred, error_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, _core.Credentials).get()
                    ];
                case 1:
                    credentials = _a.sent();
                    if (!credentials) return [
                        2 /*return*/ ,
                        INVALID_CRED
                    ];
                    cred = (0, _core.Credentials).shear(credentials);
                    logger.debug("credentials provider get credentials", cred);
                    return [
                        2 /*return*/ ,
                        cred
                    ];
                case 2:
                    error_1 = _a.sent();
                    logger.warn("credentials provider error", error_1);
                    return [
                        2 /*return*/ ,
                        INVALID_CRED
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var loadS3Config = function(config) {
    if (!config.region) // Same error thrown by aws-sdk
    throw new Error("Region is missing.");
    return __assign(__assign(__assign({}, config), {
        region: config.region,
        credentials: config.credentials ? function() {
            return Promise.resolve(config.credentials);
        } : credentialsProvider,
        userAgentValue: (0, _core.getAmplifyUserAgent)({
            category: (0, _core.Category).Storage,
            action: config.storageAction
        })
    }), config.dangerouslyConnectToHttpEndpointForTesting ? {
        customEndpoint: (0, _storageConstants.localTestingStorageEndpoint),
        forcePathStyle: true
    } : {});
};
var MiB = 1048576;
var GiB = 1024 * MiB;
var TiB = 1024 * GiB;
var DEFAULT_PART_SIZE = 5 * MiB;
var MAX_OBJECT_SIZE = 5 * TiB;
var MAX_PARTS_COUNT = 10000;
var DEFAULT_QUEUE_SIZE = 4;
var calculatePartSize = function(totalSize) {
    var partSize = DEFAULT_PART_SIZE;
    var partsCount = Math.ceil(totalSize / partSize);
    while(partsCount > MAX_PARTS_COUNT){
        partSize *= 2;
        partsCount = Math.ceil(totalSize / partSize);
    }
    return partSize;
};

},{"@aws-amplify/core":"8BDOx","./StorageConstants":"vlPxu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lUpqI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3ProviderManagedUpload", ()=>AWSS3ProviderManagedUpload);
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _events = require("events");
var _md5Utils = require("../common/MD5utils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _core.ConsoleLogger)("AWSS3ProviderManagedUpload");
var AWSS3ProviderManagedUpload = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        this.opts = null;
        this.completedParts = [];
        this.partSize = (0, _s3ClientUtils.DEFAULT_PART_SIZE);
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = __assign({
            isObjectLockEnabled: false
        }, opts);
        this.emitter = emitter;
        this.s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opts), {
            emitter: emitter,
            storageAction: (0, _core.StorageAction).Put
        }));
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var isObjectLockEnabled, _a, _b, _c, _d, _e, numberOfPartsToUpload, parts, start, error_1;
            var _f;
            var _this = this;
            return __generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        _g.trys.push([
                            0,
                            12,
                            ,
                            14
                        ]);
                        isObjectLockEnabled = this.opts.isObjectLockEnabled;
                        if (!(isObjectLockEnabled === true)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.params;
                        return [
                            4 /*yield*/ ,
                            (0, _md5Utils.calculateContentMd5)(// @ts-expect-error currently ReadableStream<any> is not being supported in put api
                            this.params.Body)
                        ];
                    case 1:
                        _a.ContentMD5 = _g.sent();
                        _g.label = 2;
                    case 2:
                        this.body = this.validateAndSanitizeBody(this.params.Body);
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= (0, _s3ClientUtils.DEFAULT_PART_SIZE))) return [
                            3 /*break*/ ,
                            4
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        _b = (0, _s3.putObject);
                        _c = [
                            this.s3Config
                        ];
                        _d = [
                            __assign({}, this.params)
                        ];
                        _f = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.apply(void 0, _c.concat([
                                __assign.apply(void 0, _d.concat([
                                    (_f.Key = _g.sent(), _f)
                                ]))
                            ]))
                        ];
                    case 4:
                        // Step 1: Determine appropriate part size.
                        this.partSize = (0, _s3ClientUtils.calculatePartSize)(this.totalBytesToUpload);
                        // Step 2: Initiate the multi part upload
                        _e = this;
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 5:
                        // Step 2: Initiate the multi part upload
                        _e.uploadId = _g.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.partSize);
                        parts = this.createParts();
                        start = 0;
                        _g.label = 6;
                    case 6:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            9
                        ];
                        // Upload as many as `queueSize` parts simultaneously
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(this.uploadId, parts.slice(start, start + (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE)))
                        ];
                    case 7:
                        // Upload as many as `queueSize` parts simultaneously
                        _g.sent();
                        _g.label = 8;
                    case 8:
                        start += (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 9:
                        parts.map(function(part) {
                            _this.removeEventListener(part);
                        });
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(this.uploadId)
                        ];
                    case 10:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _g.sent()
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        error_1 = _g.sent();
                        // if any error is thrown, call cleanup
                        return [
                            4 /*yield*/ ,
                            this.cleanup(this.uploadId)
                        ];
                    case 13:
                        // if any error is thrown, call cleanup
                        _g.sent();
                        logger.error("Error. Cancelling the multipart upload.");
                        throw error_1;
                    case 14:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function() {
        try {
            var parts = [];
            for(var bodyStart = 0; bodyStart < this.totalBytesToUpload;){
                var bodyEnd = Math.min(bodyStart + this.partSize, this.totalBytesToUpload);
                parts.push({
                    bodyPart: this.body.slice(bodyStart, bodyEnd),
                    partNumber: parts.length + 1,
                    emitter: new (0, _events.EventEmitter)(),
                    _lastUploadedBytes: 0
                });
                bodyStart += this.partSize;
            }
            return parts;
        } catch (error) {
            logger.error(error);
            throw error;
        }
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var response, _a, _b, _c, error_2;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _a = (0, _s3.createMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            __assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent(), _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        response = _e.sent();
                        logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                    case 3:
                        error_2 = _e.sent();
                        logger.error(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return __awaiter(this, void 0, void 0, function() {
            var allResults, i, error_3;
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(parts.map(function(part) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var isObjectLockEnabled, _a, _b, Key, Bucket, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, ContentMD5, res, _c, _d;
                                    var _e;
                                    return __generator(this, function(_f) {
                                        switch(_f.label){
                                            case 0:
                                                this.setupEventListener(part);
                                                isObjectLockEnabled = this.opts.isObjectLockEnabled;
                                                if (!isObjectLockEnabled) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _a = this.params;
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _md5Utils.calculateContentMd5)(part.bodyPart)
                                                ];
                                            case 1:
                                                _a.ContentMD5 = _f.sent();
                                                _f.label = 2;
                                            case 2:
                                                _b = this.params, Key = _b.Key, Bucket = _b.Bucket, SSECustomerAlgorithm = _b.SSECustomerAlgorithm, SSECustomerKey = _b.SSECustomerKey, SSECustomerKeyMD5 = _b.SSECustomerKeyMD5, ContentMD5 = _b.ContentMD5;
                                                _c = (0, _s3.uploadPart);
                                                _d = [
                                                    __assign(__assign({}, this.s3Config), {
                                                        emitter: part.emitter
                                                    })
                                                ];
                                                _e = {
                                                    PartNumber: part.partNumber,
                                                    Body: part.bodyPart,
                                                    UploadId: uploadId
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getObjectKeyWithPrefix(this.params.Key)
                                                ];
                                            case 3:
                                                return [
                                                    4 /*yield*/ ,
                                                    _c.apply(void 0, _d.concat([
                                                        (_e.Key = _f.sent(), _e.Bucket = Bucket, _e.SSECustomerAlgorithm = SSECustomerAlgorithm, _e.SSECustomerKey = SSECustomerKey, _e.SSECustomerKeyMD5 = SSECustomerKeyMD5, _e.ContentMD5 = ContentMD5, _e)
                                                    ]))
                                                ];
                                            case 4:
                                                res = _f.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    res
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        allResults = _a.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.completedParts.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        logger.error("Error happened while uploading a part. Cancelling the multipart upload");
                        throw error_3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return __awaiter(this, void 0, void 0, function() {
            var input, Key, error_4;
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a.MultipartUpload = {
                            Parts: this.completedParts
                        }, _a);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.completeMultipartUpload)(this.s3Config, input)
                        ];
                    case 3:
                        Key = _b.sent().Key;
                        return [
                            2 /*return*/ ,
                            Key
                        ];
                    case 4:
                        error_4 = _b.sent();
                        logger.error("Error happened while finishing the upload.");
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return __awaiter(this, void 0, void 0, function() {
            var input, data;
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        if (!uploadId) // This is a single part upload;
                        return [
                            2 /*return*/ 
                        ];
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.abortMultipartUpload)(this.s3Config, input)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listParts)(this.s3Config, input)
                        ];
                    case 3:
                        data = _b.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error("Multipart upload clean up failed.");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.removeEventListener = function(part) {
        part.emitter.removeAllListeners((0, _utils.SEND_UPLOAD_PROGRESS_EVENT));
        part.emitter.removeAllListeners((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT));
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === "number") return input.byteLength;
        else if (typeof input.length === "number") return input.length;
        else if (typeof input.size === "number") return input.size;
        else if (typeof input.path === "string") ;
        else throw new Error("Cannot determine length of " + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        var sanitizedBody = this.isGenericObject(body) ? JSON.stringify(body) : body;
        /* TODO: streams and files for nodejs
        if (
            typeof body.path === 'string' &&
            require('fs').lstatSync(body.path).size > 0
        ) {
            sanitizedBody = body;
        } */ if (this.byteLength(sanitizedBody) > (0, _s3ClientUtils.MAX_OBJECT_SIZE)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytesToUpload, " Bytes"));
        return sanitizedBody;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === "object") try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    AWSS3ProviderManagedUpload.prototype.getObjectKeyWithPrefix = function(keyWithoutPrefix) {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, _s3ClientUtils.getPrefix);
                        _b = [
                            __assign({}, this.opts)
                        ];
                        _c = {};
                        return [
                            4 /*yield*/ ,
                            (0, _s3ClientUtils.credentialsProvider)()
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, [
                                __assign.apply(void 0, _b.concat([
                                    (_c.credentials = _d.sent(), _c)
                                ]))
                            ])
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _d.sent() + keyWithoutPrefix
                        ];
                }
            });
        });
    };
    return AWSS3ProviderManagedUpload;
}();

},{"@aws-amplify/core":"8BDOx","../AwsClients/S3":"5XjDE","../AwsClients/S3/utils":"3mUnf","events":"gB3zd","../common/MD5utils":"aRaSz","../common/S3ClientUtils":"1P7ZC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gB3zd":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"aRaSz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateContentMd5", ()=>calculateContentMd5);
var _md5Js = require("@aws-sdk/md5-js");
var _utils = require("../AwsClients/S3/utils");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var calculateContentMd5 = function(content) {
    return __awaiter(void 0, void 0, void 0, function() {
        var hasher, buffer, digest;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    hasher = new (0, _md5Js.Md5)();
                    if (!(typeof content === "string")) return [
                        3 /*break*/ ,
                        1
                    ];
                    hasher.update(content);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        readFile(content)
                    ];
                case 2:
                    buffer = _a.sent();
                    hasher.update(buffer);
                    _a.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        hasher.digest()
                    ];
                case 4:
                    digest = _a.sent();
                    return [
                        2 /*return*/ ,
                        (0, _utils.toBase64)(digest)
                    ];
            }
        });
    });
};
var readFile = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            if (reader.result) resolve(reader.result);
            reader.onabort = function() {
                return reject(new Error("Read aborted"));
            };
            reader.onerror = function() {
                return reject(reader.error);
            };
        };
        if (file !== undefined) reader.readAsArrayBuffer(file);
    });
};

},{"@aws-sdk/md5-js":"521VW","../AwsClients/S3/utils":"3mUnf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3gcVb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3UploadTaskState", ()=>AWSS3UploadTaskState);
parcelHelpers.export(exports, "TaskEvents", ()=>TaskEvents);
parcelHelpers.export(exports, "AWSS3UploadTask", ()=>AWSS3UploadTask);
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var _storageUtils = require("../common/StorageUtils");
var _storageConstants = require("../common/StorageConstants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _core.Logger)("AWSS3UploadTask");
var AWSS3UploadTaskState;
(function(AWSS3UploadTaskState) {
    AWSS3UploadTaskState[AWSS3UploadTaskState["INIT"] = 0] = "INIT";
    AWSS3UploadTaskState[AWSS3UploadTaskState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AWSS3UploadTaskState[AWSS3UploadTaskState["PAUSED"] = 2] = "PAUSED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["CANCELLED"] = 3] = "CANCELLED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["COMPLETED"] = 4] = "COMPLETED";
})(AWSS3UploadTaskState || (AWSS3UploadTaskState = {}));
var TaskEvents;
(function(TaskEvents) {
    TaskEvents["CANCEL"] = "cancel";
    TaskEvents["UPLOAD_COMPLETE"] = "uploadComplete";
    TaskEvents["UPLOAD_PROGRESS"] = "uploadPartProgress";
    TaskEvents["ERROR"] = "error";
})(TaskEvents || (TaskEvents = {}));
function comparePartNumber(a, b) {
    return a.PartNumber - b.PartNumber;
}
var AWSS3UploadTask = /** @class */ function() {
    function AWSS3UploadTask(_a) {
        var s3Config = _a.s3Config, file = _a.file, emitter = _a.emitter, storage = _a.storage, params = _a.params, level = _a.level, prefixPromise = _a.prefixPromise;
        this.queueSize = (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE);
        this.partSize = (0, _s3ClientUtils.DEFAULT_PART_SIZE);
        this.inProgress = [];
        this.completedParts = [];
        this.queued = [];
        this.bytesUploaded = 0;
        this.totalBytes = 0;
        this.state = AWSS3UploadTaskState.INIT;
        this.prefixPromise = prefixPromise;
        this.s3Config = s3Config;
        this.storage = storage;
        this.storageSync = Promise.resolve();
        if (typeof this.storage["sync"] === "function") this.storageSync = this.storage["sync"]();
        this.params = params;
        this.file = file;
        this.totalBytes = this.file.size;
        this.bytesUploaded = 0;
        this.emitter = emitter;
        this.queued = [];
        this.fileId = this._getFileId(level);
        this._validateParams();
        // event emitter will re-throw an error if an event emits an error unless there's a listener, attaching a no-op
        // function to it unless user adds their own onError callback
        this.emitter.on(TaskEvents.ERROR, function() {});
    }
    Object.defineProperty(AWSS3UploadTask.prototype, "percent", {
        get: function() {
            return this.bytesUploaded / this.totalBytes * 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AWSS3UploadTask.prototype, "isInProgress", {
        get: function() {
            return this.state === AWSS3UploadTaskState.IN_PROGRESS;
        },
        enumerable: false,
        configurable: true
    });
    AWSS3UploadTask.prototype._listSingleFile = function(_a) {
        var key = _a.key, bucket = _a.bucket;
        return __awaiter(this, void 0, void 0, function() {
            var objectKeyPrefix, _b, Contents, obj;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        objectKeyPrefix = _c.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listObjectsV2)(this.s3Config, {
                                Bucket: bucket,
                                Prefix: objectKeyPrefix + key
                            })
                        ];
                    case 2:
                        _b = _c.sent().Contents, Contents = _b === void 0 ? [] : _b;
                        obj = Contents.find(function(o) {
                            return o.Key === "".concat(objectKeyPrefix).concat(key);
                        });
                        return [
                            2 /*return*/ ,
                            obj
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._getFileId = function(level) {
        // We should check if it's a File first because File is also instance of a Blob
        if ((0, _storageUtils.isFile)(this.file)) return [
            this.file.name,
            this.file.lastModified,
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
        else return [
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
    };
    AWSS3UploadTask.prototype._findCachedUploadParts = function() {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests, cachedUploadFileData, _a, Parts, _b, _c;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _e.sent();
                        if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) return [
                            2 /*return*/ ,
                            {
                                parts: [],
                                uploadId: null
                            }
                        ];
                        cachedUploadFileData = uploadRequests[this.fileId];
                        cachedUploadFileData.lastTouched = Date.now();
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        _b = (0, _s3.listParts);
                        _c = [
                            this.s3Config
                        ];
                        _d = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, _c.concat([
                                (_d.Key = _e.sent() + this.params.Key, _d.UploadId = cachedUploadFileData.uploadId, _d)
                            ]))
                        ];
                    case 3:
                        _a = _e.sent().Parts, Parts = _a === void 0 ? [] : _a;
                        return [
                            2 /*return*/ ,
                            {
                                parts: Parts,
                                uploadId: cachedUploadFileData.uploadId
                            }
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._emitEvent = function(event, payload) {
        this.emitter.emit(event, payload);
    };
    AWSS3UploadTask.prototype._validateParams = function() {
        if (this.totalBytes > (0, _s3ClientUtils.MAX_OBJECT_SIZE)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytes, " Bytes"));
    };
    AWSS3UploadTask.prototype._listCachedUploadTasks = function() {
        return __awaiter(this, void 0, void 0, function() {
            var tasks;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storageSync
                        ];
                    case 1:
                        _a.sent();
                        tasks = this.storage.getItem((0, _storageConstants.UPLOADS_STORAGE_KEY)) || "{}";
                        return [
                            2 /*return*/ ,
                            JSON.parse(tasks)
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._cache = function(fileMetadata) {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        uploadRequests[this.fileId] = fileMetadata;
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isCached = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = Object.prototype.hasOwnProperty).call;
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.apply(_a, [
                                _c.sent(),
                                this.fileId
                            ])
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._removeFromCache = function() {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        delete uploadRequests[this.fileId];
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._onPartUploadCompletion = function(_a) {
        var eTag = _a.eTag, partNumber = _a.partNumber, chunk = _a.chunk;
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_b) {
                this.completedParts.push({
                    ETag: eTag,
                    PartNumber: partNumber
                });
                this.bytesUploaded += (0, _storageUtils.byteLength)(chunk);
                this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                });
                // Remove the completed item from the inProgress array
                this.inProgress = this.inProgress.filter(function(job) {
                    return job.uploadPartInput.PartNumber !== partNumber;
                });
                if (this.queued.length && this.state !== AWSS3UploadTaskState.PAUSED) this._startNextPart();
                if (this._isDone()) this._completeUpload();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3UploadTask.prototype._completeUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, err_1;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, _s3.completeMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c.MultipartUpload = {
                                    // Parts are not always completed in order, we need to manually sort them
                                    Parts: __spreadArray([], __read(this.completedParts), false).sort(comparePartNumber)
                                }, _c)
                            ]))
                        ];
                    case 2:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._verifyFileSize()
                        ];
                    case 3:
                        _d.sent();
                        this._emitEvent(TaskEvents.UPLOAD_COMPLETE, {
                            key: this.params.Key
                        });
                        this._removeFromCache();
                        this.state = AWSS3UploadTaskState.COMPLETED;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_1 = _d.sent();
                        logger.error("error completing upload", err_1);
                        this._emitEvent(TaskEvents.ERROR, err_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._makeUploadPartRequest = function(input, abortSignal) {
        return __awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c, err_2;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, _s3.uploadPart);
                        _b = [
                            __assign(__assign({}, this.s3Config), {
                                abortSignal: abortSignal
                            })
                        ];
                        _c = [
                            __assign({}, input)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this._onPartUploadCompletion({
                                eTag: res.ETag,
                                partNumber: input.PartNumber,
                                chunk: input.Body
                            })
                        ];
                    case 3:
                        _e.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_2 = _e.sent();
                        if (this.state === AWSS3UploadTaskState.PAUSED) logger.log("upload paused");
                        else if (this.state === AWSS3UploadTaskState.CANCELLED) logger.log("upload aborted");
                        else logger.error("error starting next part of upload: ", err_2);
                        // xhr transfer handlers' cancel will also throw an error, however we don't need to emit an event in that case as it's an
                        // expected behavior
                        if (!(0, _utils.isCancelError)(err_2) && err_2.message !== (0, _utils.CANCELED_ERROR_MESSAGE)) {
                            this._emitEvent(TaskEvents.ERROR, err_2);
                            this.pause();
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._startNextPart = function() {
        if (this.queued.length > 0 && this.state !== AWSS3UploadTaskState.PAUSED) {
            var abortController = new AbortController();
            var nextPart = this.queued.shift();
            this.inProgress.push({
                uploadPartInput: nextPart,
                s3Request: this._makeUploadPartRequest(nextPart, abortController.signal),
                abortController: abortController
            });
        }
    };
    /**
     * Verify on S3 side that the file size matches the one on the client side.
     *
     * @async
     * @throws throws an error if the file size does not match between local copy of the file and the file on s3.
     */ AWSS3UploadTask.prototype._verifyFileSize = function() {
        return __awaiter(this, void 0, void 0, function() {
            var valid, obj, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._listSingleFile({
                                key: this.params.Key,
                                bucket: this.params.Bucket
                            })
                        ];
                    case 1:
                        obj = _a.sent();
                        valid = Boolean(obj && obj.Size === this.file.size);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _a.sent();
                        logger.log("Could not get file on s3 for size matching: ", e_1);
                        // Don't gate verification on auth or other errors
                        // unrelated to file size verification
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        if (!valid) throw new Error("File size does not match between local file and file on s3");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isDone = function() {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask.prototype._createParts = function() {
        var size = this.file.size;
        var parts = [];
        for(var bodyStart = 0; bodyStart < size;){
            var bodyEnd = Math.min(bodyStart + this.partSize, size);
            parts.push({
                Body: this.file.slice(bodyStart, bodyEnd),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: parts.length + 1,
                UploadId: this.uploadId
            });
            bodyStart += this.partSize;
        }
        return parts;
    };
    AWSS3UploadTask.prototype._initCachedUploadParts = function(cachedParts) {
        this.bytesUploaded += cachedParts.reduce(function(acc, part) {
            return acc + part.Size;
        }, 0);
        // Find the set of part numbers that have already been uploaded
        var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
            return part.PartNumber;
        }));
        this.queued = this.queued.filter(function(part) {
            return !uploadedPartNumSet.has(part.PartNumber);
        });
        this.completedParts = cachedParts.map(function(part) {
            return {
                PartNumber: part.PartNumber,
                ETag: part.ETag
            };
        });
        this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
        });
    };
    AWSS3UploadTask.prototype._initMultipartUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = (0, _s3.createMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            __assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        this._cache({
                            uploadId: res.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ""
                        });
                        return [
                            2 /*return*/ ,
                            res.UploadId
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._initializeUploadTask = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, parts, uploadId, uploadId, err_3;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.state = AWSS3UploadTaskState.IN_PROGRESS;
                        this.partSize = (0, _s3ClientUtils.calculatePartSize)(this.totalBytes);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._isCached()
                        ];
                    case 2:
                        if (!_b.sent()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._findCachedUploadParts()
                        ];
                    case 3:
                        _a = _b.sent(), parts = _a.parts, uploadId = _a.uploadId;
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._initCachedUploadParts(parts);
                        if (this._isDone()) this._completeUpload();
                        else this._startUpload();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (!!this.uploadId) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._initMultipartUpload()
                        ];
                    case 5:
                        uploadId = _b.sent();
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._startUpload();
                        _b.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        err_3 = _b.sent();
                        if (!(0, _utils.isCancelError)(err_3)) {
                            logger.error("Error initializing the upload task", err_3);
                            this._emitEvent(TaskEvents.ERROR, err_3);
                        }
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype.resume = function() {
        if (this.state === AWSS3UploadTaskState.CANCELLED) logger.warn("This task has already been cancelled");
        else if (this.state === AWSS3UploadTaskState.COMPLETED) logger.warn("This task has already been completed");
        else if (this.state === AWSS3UploadTaskState.IN_PROGRESS) logger.warn("Upload task already in progress");
        else if (!this.uploadId) this._initializeUploadTask();
        else this._startUpload();
    };
    AWSS3UploadTask.prototype._startUpload = function() {
        this.state = AWSS3UploadTaskState.IN_PROGRESS;
        for(var i = 0; i < this.queueSize; i++)this._startNextPart();
    };
    AWSS3UploadTask.prototype._cancel = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, err_4;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!(this.state === AWSS3UploadTaskState.CANCELLED)) return [
                            3 /*break*/ ,
                            1
                        ];
                        logger.warn("This task has already been cancelled");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        if (!(this.state === AWSS3UploadTaskState.COMPLETED)) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.warn("This task has already been completed");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 2:
                        this.pause();
                        this.queued = [];
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.state = AWSS3UploadTaskState.CANCELLED;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([
                            3,
                            7,
                            ,
                            8
                        ]);
                        _a = (0, _s3.abortMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c)
                            ]))
                        ];
                    case 5:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._removeFromCache()
                        ];
                    case 6:
                        _d.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 7:
                        err_4 = _d.sent();
                        logger.error("Error cancelling upload task", err_4);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * pause this particular upload task
     **/ AWSS3UploadTask.prototype.pause = function() {
        var _a;
        if (this.state === AWSS3UploadTaskState.CANCELLED) logger.warn("This task has already been cancelled");
        else if (this.state === AWSS3UploadTaskState.COMPLETED) logger.warn("This task has already been completed");
        else if (this.state === AWSS3UploadTaskState.PAUSED) logger.warn("This task is already paused");
        this.state = AWSS3UploadTaskState.PAUSED;
        // Abort the part request immediately
        // Add the inProgress parts back to pending
        var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
        removedInProgressReq.forEach(function(req) {
            req.abortController.abort();
        });
        // Put all removed in progress parts back into the queue
        (_a = this.queued).unshift.apply(_a, __spreadArray([], __read(removedInProgressReq.map(function(req) {
            return req.uploadPartInput;
        })), false));
    };
    return AWSS3UploadTask;
}();

},{"@aws-amplify/core":"8BDOx","../AwsClients/S3":"5XjDE","../AwsClients/S3/utils":"3mUnf","../common/S3ClientUtils":"1P7ZC","../common/StorageUtils":"34hIw","../common/StorageConstants":"vlPxu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"houml":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API", ()=>(0, _api.API));
parcelHelpers.export(exports, "APIClass", ()=>(0, _api.APIClass));
parcelHelpers.export(exports, "graphqlOperation", ()=>(0, _apiGraphql.graphqlOperation));
parcelHelpers.export(exports, "GraphQLAuthError", ()=>(0, _apiGraphql.GraphQLAuthError));
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _apiGraphql.GRAPHQL_AUTH_MODE));
var _api = require("./API");
var _apiGraphql = require("@aws-amplify/api-graphql");

},{"./API":"1HMrW","@aws-amplify/api-graphql":"cbXXL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1HMrW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APIClass", ()=>APIClass);
parcelHelpers.export(exports, "API", ()=>API);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _internalAPI = require("./internals/InternalAPI");
var logger = new (0, _core.ConsoleLogger)("API");
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var APIClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(APIClass, _super);
    function APIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    APIClass.prototype.getModuleName = function() {
        return "API";
    };
    APIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return APIClass;
}((0, _internalAPI.InternalAPIClass));
var API = new APIClass(null);
(0, _core.Amplify).register(API);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./internals/InternalAPI":"6O7b1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6O7b1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalAPIClass", ()=>InternalAPIClass);
parcelHelpers.export(exports, "InternalAPI", ()=>InternalAPI);
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api-graphql/internals");
var _apiRest = require("@aws-amplify/api-rest");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("API");
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var InternalAPIClass = /** @class */ function() {
    /**
     * Initialize API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalAPIClass(options) {
        this.Auth = (0, _auth.Auth);
        this.Cache = (0, _cache.Cache);
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        this._restApi = new (0, _apiRest.RestAPIClass)(options);
        this._graphqlApi = new (0, _internals.InternalGraphQLAPIClass)(options);
        logger.debug("API Options", this._options);
    }
    InternalAPIClass.prototype.getModuleName = function() {
        return "InternalAPI";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalAPIClass.prototype.configure = function(options) {
        this._options = Object.assign({}, this._options, options);
        // Share Amplify instance with client for SSR
        this._restApi.Credentials = this.Credentials;
        this._graphqlApi.Auth = this.Auth;
        this._graphqlApi.Cache = this.Cache;
        this._graphqlApi.Credentials = this.Credentials;
        var restAPIConfig = this._restApi.configure(this._options);
        var graphQLAPIConfig = this._graphqlApi.configure(this._options);
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, restAPIConfig), graphQLAPIConfig);
    };
    /**
     * Make a GET request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.get = function(apiName, path, init) {
        return this._restApi.get(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Get));
    };
    /**
     * Make a POST request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.post = function(apiName, path, init) {
        return this._restApi.post(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Post));
    };
    /**
     * Make a PUT request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.put = function(apiName, path, init) {
        return this._restApi.put(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Put));
    };
    /**
     * Make a PATCH request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.patch = function(apiName, path, init) {
        return this._restApi.patch(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Patch));
    };
    /**
     * Make a DEL request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.del = function(apiName, path, init) {
        return this._restApi.del(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Del));
    };
    /**
     * Make a HEAD request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.head = function(apiName, path, init) {
        return this._restApi.head(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Head));
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param error - Any error
     * @return If the error was from an api request cancellation
     */ InternalAPIClass.prototype.isCancel = function(error) {
        return this._restApi.isCancel(error);
    };
    /**
     * Cancels an inflight request for either a GraphQL request or a Rest API request.
     * @param request - request to cancel
     * @param [message] - custom error message
     * @return If the request was cancelled
     */ InternalAPIClass.prototype.cancel = function(request, message) {
        if (this._restApi.hasCancelToken(request)) return this._restApi.cancel(request, message);
        else if (this._graphqlApi.hasCancelToken(request)) return this._graphqlApi.cancel(request, message);
        return false;
    };
    InternalAPIClass.prototype.getInitWithCustomUserAgentDetails = function(init, action) {
        var customUserAgentDetails = {
            category: (0, _core.Category).API,
            action: action
        };
        var initParams = (0, _tslib.__assign)((0, _tslib.__assign)({}, init), {
            customUserAgentDetails: customUserAgentDetails
        });
        return initParams;
    };
    /**
     * Getting endpoint for API
     * @param apiName - The name of the api
     * @return The endpoint of the api
     */ InternalAPIClass.prototype.endpoint = function(apiName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._restApi.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalAPIClass.prototype.getGraphqlOperationType = function(operation) {
        return this._graphqlApi.getGraphqlOperationType(operation);
    };
    InternalAPIClass.prototype.graphql = function(options, additionalHeaders, customUserAgentDetails) {
        var apiUserAgentDetails = (0, _tslib.__assign)({
            category: (0, _core.Category).API,
            action: (0, _core.ApiAction).GraphQl
        }, customUserAgentDetails);
        return this._graphqlApi.graphql(options, additionalHeaders, apiUserAgentDetails);
    };
    return InternalAPIClass;
}();
var InternalAPI = new InternalAPIClass(null);
(0, _core.Amplify).register(InternalAPI);

},{"tslib":"9gMVn","@aws-amplify/api-graphql/internals":"hbH4E","@aws-amplify/api-rest":"cbK7v","@aws-amplify/auth":"6Q2Bh","@aws-amplify/cache":"egrWR","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hbH4E":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalGraphQLAPI", ()=>(0, _internalGraphQLAPI.InternalGraphQLAPI));
parcelHelpers.export(exports, "InternalGraphQLAPIClass", ()=>(0, _internalGraphQLAPI.InternalGraphQLAPIClass));
var _internalGraphQLAPI = require("./InternalGraphQLAPI");

},{"./InternalGraphQLAPI":"ibmPt","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ibmPt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphqlOperation", ()=>graphqlOperation);
parcelHelpers.export(exports, "InternalGraphQLAPIClass", ()=>InternalGraphQLAPIClass);
parcelHelpers.export(exports, "InternalGraphQLAPI", ()=>InternalGraphQLAPI);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _graphql = require("graphql");
var _core = require("@aws-amplify/core");
var _internals = require("@aws-amplify/pubsub/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _types = require("../types");
var _apiRest = require("@aws-amplify/api-rest");
var USER_AGENT_HEADER = "x-amz-user-agent";
var logger = new (0, _core.ConsoleLogger)("GraphQLAPI");
var graphqlOperation = function(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var InternalGraphQLAPIClass = /** @class */ function() {
    /**
     * Initialize GraphQL API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalGraphQLAPIClass(options) {
        this._api = null;
        this.Auth = (0, _auth.Auth);
        this.Cache = (0, _cache.Cache);
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug("API Options", this._options);
    }
    InternalGraphQLAPIClass.prototype.getModuleName = function() {
        return "InternalGraphQLAPI";
    };
    /**
     * Configure API
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalGraphQLAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, _tslib.__rest)(_a, [
            "API"
        ]);
        var opt = (0, _tslib.__assign)((0, _tslib.__assign)({}, otherOptions), API);
        logger.debug("configure GraphQL API", {
            opt: opt
        });
        if (opt["aws_project_region"]) opt = Object.assign({}, opt, {
            region: opt["aws_project_region"],
            header: {}
        });
        if (typeof opt.graphql_headers !== "undefined" && typeof opt.graphql_headers !== "function") {
            logger.warn("graphql_headers should be a function");
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ InternalGraphQLAPIClass.prototype.createInstance = function() {
        logger.debug("create Rest instance");
        if (this._options) {
            this._api = new (0, _apiRest.RestClient)(this._options);
            // Share instance Credentials with client for SSR
            this._api.Credentials = this.Credentials;
            return true;
        } else return Promise.reject("API not configured");
    };
    InternalGraphQLAPIClass.prototype._headerBasedAuth = function(defaultAuthenticationType, additionalHeaders) {
        if (additionalHeaders === void 0) additionalHeaders = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
                        headers = {};
                        _b = authenticationType;
                        switch(_b){
                            case "API_KEY":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "AWS_IAM":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "OPENID_CONNECT":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "AMAZON_COGNITO_USER_POOLS":
                                return [
                                    3 /*break*/ ,
                                    11
                                ];
                            case "AWS_LAMBDA":
                                return [
                                    3 /*break*/ ,
                                    15
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 1:
                        if (!apiKey) throw new Error((0, _types.GraphQLAuthError).NO_API_KEY);
                        headers = {
                            Authorization: null,
                            "X-Api-Key": apiKey
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) throw new Error((0, _types.GraphQLAuthError).NO_CREDENTIALS);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        _c.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        token = void 0;
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem("federatedInfo")
                        ];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            6
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentAuthenticatedUser()
                        ];
                    case 7:
                        currentUser = _c.sent();
                        if (currentUser) token = currentUser.token;
                        _c.label = 8;
                    case 8:
                        if (!token) throw new Error((0, _types.GraphQLAuthError).NO_FEDERATED_JWT);
                        headers = {
                            Authorization: token
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_1 = _c.sent();
                        throw new Error((0, _types.GraphQLAuthError).NO_CURRENT_USER);
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Auth.currentSession()
                        ];
                    case 12:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken()
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        e_2 = _c.sent();
                        throw new Error((0, _types.GraphQLAuthError).NO_CURRENT_USER);
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        if (!additionalHeaders.Authorization) throw new Error((0, _types.GraphQLAuthError).NO_AUTH_TOKEN);
                        headers = {
                            Authorization: additionalHeaders.Authorization
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        headers = {
                            Authorization: null
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 17:
                        return [
                            2 /*return*/ ,
                            headers
                        ];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalGraphQLAPIClass.prototype.getGraphqlOperationType = function(operation) {
        var doc = (0, _graphql.parse)(operation);
        var definitions = doc.definitions;
        var _a = (0, _tslib.__read)(definitions, 1), operationType = _a[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ InternalGraphQLAPIClass.prototype.graphql = function(_a, additionalHeaders, customUserAgentDetails) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode, authToken = _a.authToken;
        var query = typeof paramQuery === "string" ? (0, _graphql.parse)(paramQuery) : (0, _graphql.parse)((0, _graphql.print)(paramQuery));
        var _c = (0, _tslib.__read)(query.definitions.filter(function(def) {
            return def.kind === "OperationDefinition";
        }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
        var operationType = operationDef.operation;
        var headers = additionalHeaders || {};
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) headers.Authorization = authToken;
        switch(operationType){
            case "query":
            case "mutation":
                this.createInstanceIfNotCreated();
                var cancellableToken = this._api.getCancellableToken();
                var initParams = {
                    cancellableToken: cancellableToken,
                    withCredentials: this._options.withCredentials
                };
                var responsePromise = this._graphql({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, initParams, customUserAgentDetails);
                this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
                return responsePromise;
            case "subscription":
                return this._graphqlSubscribe({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, customUserAgentDetails);
            default:
                throw new Error("invalid operation type: ".concat(operationType));
        }
    };
    InternalGraphQLAPIClass.prototype._graphql = function(_a, additionalHeaders, initParams, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        if (initParams === void 0) initParams = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        this.createInstanceIfNotCreated();
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [
                            {}
                        ];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 1:
                        _e = _l.sent();
                        _l.label = 2;
                    case 2:
                        _f = [
                            (0, _tslib.__assign).apply(void 0, _d.concat([
                                _e
                            ]))
                        ];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!customEndpointRegion) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 3:
                        _h = _l.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _h = {
                            Authorization: null
                        };
                        _l.label = 5;
                    case 5:
                        _g = _h;
                        _l.label = 6;
                    case 6:
                        _j = [
                            (0, _tslib.__assign).apply(void 0, _f.concat([
                                _g
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers({
                                query: query,
                                variables: variables
                            })
                        ];
                    case 7:
                        headers = (0, _tslib.__assign).apply(void 0, [
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _j.concat([
                                    _l.sent()
                                ])),
                                additionalHeaders
                            ]),
                            !customGraphqlEndpoint && (_k = {}, _k[USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _k)
                        ]);
                        body = {
                            query: (0, _graphql.print)(query),
                            variables: variables
                        };
                        init = Object.assign({
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? "appsync" : "execute-api",
                                region: !customGraphqlEndpoint ? region : customEndpointRegion
                            }
                        }, initParams);
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new (0, _graphql.GraphQLError)("No graphql endpoint provided.");
                            throw {
                                data: {},
                                errors: [
                                    error
                                ]
                            };
                        }
                        _l.label = 8;
                    case 8:
                        _l.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._api.post(endpoint, init)
                        ];
                    case 9:
                        response = _l.sent();
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        err_1 = _l.sent();
                        // If the exception is because user intentionally
                        // cancelled the request, do not modify the exception
                        // so that clients can identify the exception correctly.
                        if (this._api.isCancel(err_1)) throw err_1;
                        response = {
                            data: {},
                            errors: [
                                new (0, _graphql.GraphQLError)(err_1.message, null, null, null, null, err_1)
                            ]
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        errors = response.errors;
                        if (errors && errors.length) throw response;
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    InternalGraphQLAPIClass.prototype.createInstanceIfNotCreated = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ InternalGraphQLAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ InternalGraphQLAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ InternalGraphQLAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    InternalGraphQLAPIClass.prototype._graphqlSubscribe = function(_a, additionalHeaders, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode, authToken = _a.authToken;
        if (additionalHeaders === void 0) additionalHeaders = {};
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
            return {};
        } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
        if ((0, _internals.InternalPubSub) && typeof (0, _internals.InternalPubSub).subscribe === "function") return (0, _internals.InternalPubSub).subscribe("", {
            provider: (0, _core.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER),
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            apiKey: apiKey,
            query: (0, _graphql.print)(query),
            region: region,
            variables: variables,
            graphql_headers: graphql_headers,
            additionalHeaders: additionalHeaders,
            authToken: authToken
        }, customUserAgentDetails);
        else {
            logger.debug("No pubsub module applied for subscription");
            throw new Error("No pubsub module applied for subscription");
        }
    };
    /**
     * @private
     */ InternalGraphQLAPIClass.prototype._ensureCredentials = function() {
        var _this = this;
        return this.Credentials.get().then(function(credentials) {
            if (!credentials) return false;
            var cred = _this.Credentials.shear(credentials);
            logger.debug("set credentials for api", cred);
            return true;
        }).catch(function(err) {
            logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return InternalGraphQLAPIClass;
}();
var InternalGraphQLAPI = new InternalGraphQLAPIClass(null);
(0, _core.Amplify).register(InternalGraphQLAPI);

},{"tslib":"9gMVn","graphql":"2Xp4W","@aws-amplify/core":"8BDOx","@aws-amplify/pubsub/internals":"7x5ZR","@aws-amplify/auth":"6Q2Bh","@aws-amplify/cache":"egrWR","../types":"kp3r5","@aws-amplify/api-rest":"cbK7v","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2Xp4W":[function(require,module,exports) {
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */ // The GraphQL.js version info.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _versionMjs.version)) // The primary entry point into fulfilling a GraphQL request.
;
parcelHelpers.export(exports, "versionInfo", ()=>(0, _versionMjs.versionInfo));
parcelHelpers.export(exports, "graphql", ()=>(0, _graphqlMjs.graphql)) // Create and operate on GraphQL type definitions and schema.
;
parcelHelpers.export(exports, "graphqlSync", ()=>(0, _graphqlMjs.graphqlSync));
parcelHelpers.export(exports, "GraphQLSchema", ()=>(0, _indexMjs.GraphQLSchema));
parcelHelpers.export(exports, "GraphQLDirective", ()=>(0, _indexMjs.GraphQLDirective));
parcelHelpers.export(exports, "GraphQLScalarType", ()=>(0, _indexMjs.GraphQLScalarType));
parcelHelpers.export(exports, "GraphQLObjectType", ()=>(0, _indexMjs.GraphQLObjectType));
parcelHelpers.export(exports, "GraphQLInterfaceType", ()=>(0, _indexMjs.GraphQLInterfaceType));
parcelHelpers.export(exports, "GraphQLUnionType", ()=>(0, _indexMjs.GraphQLUnionType));
parcelHelpers.export(exports, "GraphQLEnumType", ()=>(0, _indexMjs.GraphQLEnumType));
parcelHelpers.export(exports, "GraphQLInputObjectType", ()=>(0, _indexMjs.GraphQLInputObjectType));
parcelHelpers.export(exports, "GraphQLList", ()=>(0, _indexMjs.GraphQLList));
parcelHelpers.export(exports, "GraphQLNonNull", ()=>(0, _indexMjs.GraphQLNonNull));
parcelHelpers.export(exports, "specifiedScalarTypes", ()=>(0, _indexMjs.specifiedScalarTypes));
parcelHelpers.export(exports, "GraphQLInt", ()=>(0, _indexMjs.GraphQLInt));
parcelHelpers.export(exports, "GraphQLFloat", ()=>(0, _indexMjs.GraphQLFloat));
parcelHelpers.export(exports, "GraphQLString", ()=>(0, _indexMjs.GraphQLString));
parcelHelpers.export(exports, "GraphQLBoolean", ()=>(0, _indexMjs.GraphQLBoolean));
parcelHelpers.export(exports, "GraphQLID", ()=>(0, _indexMjs.GraphQLID));
parcelHelpers.export(exports, "specifiedDirectives", ()=>(0, _indexMjs.specifiedDirectives));
parcelHelpers.export(exports, "GraphQLIncludeDirective", ()=>(0, _indexMjs.GraphQLIncludeDirective));
parcelHelpers.export(exports, "GraphQLSkipDirective", ()=>(0, _indexMjs.GraphQLSkipDirective));
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", ()=>(0, _indexMjs.GraphQLDeprecatedDirective));
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", ()=>(0, _indexMjs.GraphQLSpecifiedByDirective));
parcelHelpers.export(exports, "TypeKind", ()=>(0, _indexMjs.TypeKind));
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", ()=>(0, _indexMjs.DEFAULT_DEPRECATION_REASON));
parcelHelpers.export(exports, "introspectionTypes", ()=>(0, _indexMjs.introspectionTypes));
parcelHelpers.export(exports, "__Schema", ()=>(0, _indexMjs.__Schema));
parcelHelpers.export(exports, "__Directive", ()=>(0, _indexMjs.__Directive));
parcelHelpers.export(exports, "__DirectiveLocation", ()=>(0, _indexMjs.__DirectiveLocation));
parcelHelpers.export(exports, "__Type", ()=>(0, _indexMjs.__Type));
parcelHelpers.export(exports, "__Field", ()=>(0, _indexMjs.__Field));
parcelHelpers.export(exports, "__InputValue", ()=>(0, _indexMjs.__InputValue));
parcelHelpers.export(exports, "__EnumValue", ()=>(0, _indexMjs.__EnumValue));
parcelHelpers.export(exports, "__TypeKind", ()=>(0, _indexMjs.__TypeKind));
parcelHelpers.export(exports, "SchemaMetaFieldDef", ()=>(0, _indexMjs.SchemaMetaFieldDef));
parcelHelpers.export(exports, "TypeMetaFieldDef", ()=>(0, _indexMjs.TypeMetaFieldDef));
parcelHelpers.export(exports, "TypeNameMetaFieldDef", ()=>(0, _indexMjs.TypeNameMetaFieldDef));
parcelHelpers.export(exports, "isSchema", ()=>(0, _indexMjs.isSchema));
parcelHelpers.export(exports, "isDirective", ()=>(0, _indexMjs.isDirective));
parcelHelpers.export(exports, "isType", ()=>(0, _indexMjs.isType));
parcelHelpers.export(exports, "isScalarType", ()=>(0, _indexMjs.isScalarType));
parcelHelpers.export(exports, "isObjectType", ()=>(0, _indexMjs.isObjectType));
parcelHelpers.export(exports, "isInterfaceType", ()=>(0, _indexMjs.isInterfaceType));
parcelHelpers.export(exports, "isUnionType", ()=>(0, _indexMjs.isUnionType));
parcelHelpers.export(exports, "isEnumType", ()=>(0, _indexMjs.isEnumType));
parcelHelpers.export(exports, "isInputObjectType", ()=>(0, _indexMjs.isInputObjectType));
parcelHelpers.export(exports, "isListType", ()=>(0, _indexMjs.isListType));
parcelHelpers.export(exports, "isNonNullType", ()=>(0, _indexMjs.isNonNullType));
parcelHelpers.export(exports, "isInputType", ()=>(0, _indexMjs.isInputType));
parcelHelpers.export(exports, "isOutputType", ()=>(0, _indexMjs.isOutputType));
parcelHelpers.export(exports, "isLeafType", ()=>(0, _indexMjs.isLeafType));
parcelHelpers.export(exports, "isCompositeType", ()=>(0, _indexMjs.isCompositeType));
parcelHelpers.export(exports, "isAbstractType", ()=>(0, _indexMjs.isAbstractType));
parcelHelpers.export(exports, "isWrappingType", ()=>(0, _indexMjs.isWrappingType));
parcelHelpers.export(exports, "isNullableType", ()=>(0, _indexMjs.isNullableType));
parcelHelpers.export(exports, "isNamedType", ()=>(0, _indexMjs.isNamedType));
parcelHelpers.export(exports, "isRequiredArgument", ()=>(0, _indexMjs.isRequiredArgument));
parcelHelpers.export(exports, "isRequiredInputField", ()=>(0, _indexMjs.isRequiredInputField));
parcelHelpers.export(exports, "isSpecifiedScalarType", ()=>(0, _indexMjs.isSpecifiedScalarType));
parcelHelpers.export(exports, "isIntrospectionType", ()=>(0, _indexMjs.isIntrospectionType));
parcelHelpers.export(exports, "isSpecifiedDirective", ()=>(0, _indexMjs.isSpecifiedDirective));
parcelHelpers.export(exports, "assertSchema", ()=>(0, _indexMjs.assertSchema));
parcelHelpers.export(exports, "assertDirective", ()=>(0, _indexMjs.assertDirective));
parcelHelpers.export(exports, "assertType", ()=>(0, _indexMjs.assertType));
parcelHelpers.export(exports, "assertScalarType", ()=>(0, _indexMjs.assertScalarType));
parcelHelpers.export(exports, "assertObjectType", ()=>(0, _indexMjs.assertObjectType));
parcelHelpers.export(exports, "assertInterfaceType", ()=>(0, _indexMjs.assertInterfaceType));
parcelHelpers.export(exports, "assertUnionType", ()=>(0, _indexMjs.assertUnionType));
parcelHelpers.export(exports, "assertEnumType", ()=>(0, _indexMjs.assertEnumType));
parcelHelpers.export(exports, "assertInputObjectType", ()=>(0, _indexMjs.assertInputObjectType));
parcelHelpers.export(exports, "assertListType", ()=>(0, _indexMjs.assertListType));
parcelHelpers.export(exports, "assertNonNullType", ()=>(0, _indexMjs.assertNonNullType));
parcelHelpers.export(exports, "assertInputType", ()=>(0, _indexMjs.assertInputType));
parcelHelpers.export(exports, "assertOutputType", ()=>(0, _indexMjs.assertOutputType));
parcelHelpers.export(exports, "assertLeafType", ()=>(0, _indexMjs.assertLeafType));
parcelHelpers.export(exports, "assertCompositeType", ()=>(0, _indexMjs.assertCompositeType));
parcelHelpers.export(exports, "assertAbstractType", ()=>(0, _indexMjs.assertAbstractType));
parcelHelpers.export(exports, "assertWrappingType", ()=>(0, _indexMjs.assertWrappingType));
parcelHelpers.export(exports, "assertNullableType", ()=>(0, _indexMjs.assertNullableType));
parcelHelpers.export(exports, "assertNamedType", ()=>(0, _indexMjs.assertNamedType));
parcelHelpers.export(exports, "getNullableType", ()=>(0, _indexMjs.getNullableType));
parcelHelpers.export(exports, "getNamedType", ()=>(0, _indexMjs.getNamedType));
parcelHelpers.export(exports, "validateSchema", ()=>(0, _indexMjs.validateSchema));
parcelHelpers.export(exports, "assertValidSchema", ()=>(0, _indexMjs.assertValidSchema));
// Parse and operate on GraphQL language source files.
parcelHelpers.export(exports, "Token", ()=>(0, _indexMjs1.Token));
parcelHelpers.export(exports, "Source", ()=>(0, _indexMjs1.Source));
parcelHelpers.export(exports, "Location", ()=>(0, _indexMjs1.Location));
parcelHelpers.export(exports, "getLocation", ()=>(0, _indexMjs1.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _indexMjs1.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _indexMjs1.printSourceLocation));
parcelHelpers.export(exports, "Lexer", ()=>(0, _indexMjs1.Lexer));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _indexMjs1.TokenKind));
parcelHelpers.export(exports, "parse", ()=>(0, _indexMjs1.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _indexMjs1.parseValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _indexMjs1.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _indexMjs1.print));
parcelHelpers.export(exports, "visit", ()=>(0, _indexMjs1.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _indexMjs1.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _indexMjs1.getVisitFn));
parcelHelpers.export(exports, "BREAK", ()=>(0, _indexMjs1.BREAK));
parcelHelpers.export(exports, "Kind", ()=>(0, _indexMjs1.Kind));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _indexMjs1.DirectiveLocation));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _indexMjs1.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _indexMjs1.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _indexMjs1.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _indexMjs1.isValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _indexMjs1.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _indexMjs1.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _indexMjs1.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _indexMjs1.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _indexMjs1.isTypeExtensionNode));
// Execute GraphQL queries.
parcelHelpers.export(exports, "execute", ()=>(0, _indexMjs2.execute));
parcelHelpers.export(exports, "executeSync", ()=>(0, _indexMjs2.executeSync));
parcelHelpers.export(exports, "defaultFieldResolver", ()=>(0, _indexMjs2.defaultFieldResolver));
parcelHelpers.export(exports, "defaultTypeResolver", ()=>(0, _indexMjs2.defaultTypeResolver));
parcelHelpers.export(exports, "responsePathAsArray", ()=>(0, _indexMjs2.responsePathAsArray));
parcelHelpers.export(exports, "getDirectiveValues", ()=>(0, _indexMjs2.getDirectiveValues));
parcelHelpers.export(exports, "subscribe", ()=>(0, _indexMjs3.subscribe));
parcelHelpers.export(exports, "createSourceEventStream", ()=>(0, _indexMjs3.createSourceEventStream));
// Validate GraphQL documents.
parcelHelpers.export(exports, "validate", ()=>(0, _indexMjs4.validate));
parcelHelpers.export(exports, "ValidationContext", ()=>(0, _indexMjs4.ValidationContext));
parcelHelpers.export(exports, "specifiedRules", ()=>(0, _indexMjs4.specifiedRules));
parcelHelpers.export(exports, "ExecutableDefinitionsRule", ()=>(0, _indexMjs4.ExecutableDefinitionsRule));
parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", ()=>(0, _indexMjs4.FieldsOnCorrectTypeRule));
parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", ()=>(0, _indexMjs4.FragmentsOnCompositeTypesRule));
parcelHelpers.export(exports, "KnownArgumentNamesRule", ()=>(0, _indexMjs4.KnownArgumentNamesRule));
parcelHelpers.export(exports, "KnownDirectivesRule", ()=>(0, _indexMjs4.KnownDirectivesRule));
parcelHelpers.export(exports, "KnownFragmentNamesRule", ()=>(0, _indexMjs4.KnownFragmentNamesRule));
parcelHelpers.export(exports, "KnownTypeNamesRule", ()=>(0, _indexMjs4.KnownTypeNamesRule));
parcelHelpers.export(exports, "LoneAnonymousOperationRule", ()=>(0, _indexMjs4.LoneAnonymousOperationRule));
parcelHelpers.export(exports, "NoFragmentCyclesRule", ()=>(0, _indexMjs4.NoFragmentCyclesRule));
parcelHelpers.export(exports, "NoUndefinedVariablesRule", ()=>(0, _indexMjs4.NoUndefinedVariablesRule));
parcelHelpers.export(exports, "NoUnusedFragmentsRule", ()=>(0, _indexMjs4.NoUnusedFragmentsRule));
parcelHelpers.export(exports, "NoUnusedVariablesRule", ()=>(0, _indexMjs4.NoUnusedVariablesRule));
parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", ()=>(0, _indexMjs4.OverlappingFieldsCanBeMergedRule));
parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", ()=>(0, _indexMjs4.PossibleFragmentSpreadsRule));
parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", ()=>(0, _indexMjs4.ProvidedRequiredArgumentsRule));
parcelHelpers.export(exports, "ScalarLeafsRule", ()=>(0, _indexMjs4.ScalarLeafsRule));
parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", ()=>(0, _indexMjs4.SingleFieldSubscriptionsRule));
parcelHelpers.export(exports, "UniqueArgumentNamesRule", ()=>(0, _indexMjs4.UniqueArgumentNamesRule));
parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", ()=>(0, _indexMjs4.UniqueDirectivesPerLocationRule));
parcelHelpers.export(exports, "UniqueFragmentNamesRule", ()=>(0, _indexMjs4.UniqueFragmentNamesRule));
parcelHelpers.export(exports, "UniqueInputFieldNamesRule", ()=>(0, _indexMjs4.UniqueInputFieldNamesRule));
parcelHelpers.export(exports, "UniqueOperationNamesRule", ()=>(0, _indexMjs4.UniqueOperationNamesRule));
parcelHelpers.export(exports, "UniqueVariableNamesRule", ()=>(0, _indexMjs4.UniqueVariableNamesRule));
parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", ()=>(0, _indexMjs4.ValuesOfCorrectTypeRule));
parcelHelpers.export(exports, "VariablesAreInputTypesRule", ()=>(0, _indexMjs4.VariablesAreInputTypesRule));
parcelHelpers.export(exports, "VariablesInAllowedPositionRule", ()=>(0, _indexMjs4.VariablesInAllowedPositionRule));
parcelHelpers.export(exports, "LoneSchemaDefinitionRule", ()=>(0, _indexMjs4.LoneSchemaDefinitionRule));
parcelHelpers.export(exports, "UniqueOperationTypesRule", ()=>(0, _indexMjs4.UniqueOperationTypesRule));
parcelHelpers.export(exports, "UniqueTypeNamesRule", ()=>(0, _indexMjs4.UniqueTypeNamesRule));
parcelHelpers.export(exports, "UniqueEnumValueNamesRule", ()=>(0, _indexMjs4.UniqueEnumValueNamesRule));
parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", ()=>(0, _indexMjs4.UniqueFieldDefinitionNamesRule));
parcelHelpers.export(exports, "UniqueDirectiveNamesRule", ()=>(0, _indexMjs4.UniqueDirectiveNamesRule));
parcelHelpers.export(exports, "PossibleTypeExtensionsRule", ()=>(0, _indexMjs4.PossibleTypeExtensionsRule));
parcelHelpers.export(exports, "NoDeprecatedCustomRule", ()=>(0, _indexMjs4.NoDeprecatedCustomRule));
parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", ()=>(0, _indexMjs4.NoSchemaIntrospectionCustomRule));
// Create, format, and print GraphQL errors.
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _indexMjs5.GraphQLError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _indexMjs5.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _indexMjs5.locatedError));
parcelHelpers.export(exports, "printError", ()=>(0, _indexMjs5.printError));
parcelHelpers.export(exports, "formatError", ()=>(0, _indexMjs5.formatError));
// Utilities for operating on GraphQL type schema and parsed sources.
parcelHelpers.export(exports, "getIntrospectionQuery", ()=>(0, _indexMjs6.getIntrospectionQuery));
parcelHelpers.export(exports, "getOperationAST", ()=>(0, _indexMjs6.getOperationAST));
parcelHelpers.export(exports, "getOperationRootType", ()=>(0, _indexMjs6.getOperationRootType));
parcelHelpers.export(exports, "introspectionFromSchema", ()=>(0, _indexMjs6.introspectionFromSchema));
parcelHelpers.export(exports, "buildClientSchema", ()=>(0, _indexMjs6.buildClientSchema));
parcelHelpers.export(exports, "buildASTSchema", ()=>(0, _indexMjs6.buildASTSchema));
parcelHelpers.export(exports, "buildSchema", ()=>(0, _indexMjs6.buildSchema));
parcelHelpers.export(exports, "getDescription", ()=>(0, _indexMjs6.getDescription));
parcelHelpers.export(exports, "extendSchema", ()=>(0, _indexMjs6.extendSchema));
parcelHelpers.export(exports, "lexicographicSortSchema", ()=>(0, _indexMjs6.lexicographicSortSchema));
parcelHelpers.export(exports, "printSchema", ()=>(0, _indexMjs6.printSchema));
parcelHelpers.export(exports, "printType", ()=>(0, _indexMjs6.printType));
parcelHelpers.export(exports, "printIntrospectionSchema", ()=>(0, _indexMjs6.printIntrospectionSchema));
parcelHelpers.export(exports, "typeFromAST", ()=>(0, _indexMjs6.typeFromAST));
parcelHelpers.export(exports, "valueFromAST", ()=>(0, _indexMjs6.valueFromAST));
parcelHelpers.export(exports, "valueFromASTUntyped", ()=>(0, _indexMjs6.valueFromASTUntyped));
parcelHelpers.export(exports, "astFromValue", ()=>(0, _indexMjs6.astFromValue));
parcelHelpers.export(exports, "TypeInfo", ()=>(0, _indexMjs6.TypeInfo));
parcelHelpers.export(exports, "visitWithTypeInfo", ()=>(0, _indexMjs6.visitWithTypeInfo));
parcelHelpers.export(exports, "coerceInputValue", ()=>(0, _indexMjs6.coerceInputValue));
parcelHelpers.export(exports, "concatAST", ()=>(0, _indexMjs6.concatAST));
parcelHelpers.export(exports, "separateOperations", ()=>(0, _indexMjs6.separateOperations));
parcelHelpers.export(exports, "stripIgnoredCharacters", ()=>(0, _indexMjs6.stripIgnoredCharacters));
parcelHelpers.export(exports, "isEqualType", ()=>(0, _indexMjs6.isEqualType));
parcelHelpers.export(exports, "isTypeSubTypeOf", ()=>(0, _indexMjs6.isTypeSubTypeOf));
parcelHelpers.export(exports, "doTypesOverlap", ()=>(0, _indexMjs6.doTypesOverlap));
parcelHelpers.export(exports, "assertValidName", ()=>(0, _indexMjs6.assertValidName));
parcelHelpers.export(exports, "isValidNameError", ()=>(0, _indexMjs6.isValidNameError));
parcelHelpers.export(exports, "BreakingChangeType", ()=>(0, _indexMjs6.BreakingChangeType));
parcelHelpers.export(exports, "DangerousChangeType", ()=>(0, _indexMjs6.DangerousChangeType));
parcelHelpers.export(exports, "findBreakingChanges", ()=>(0, _indexMjs6.findBreakingChanges));
parcelHelpers.export(exports, "findDangerousChanges", ()=>(0, _indexMjs6.findDangerousChanges));
parcelHelpers.export(exports, "findDeprecatedUsages", ()=>(0, _indexMjs6.findDeprecatedUsages));
var _versionMjs = require("./version.mjs");
var _graphqlMjs = require("./graphql.mjs");
var _indexMjs = require("./type/index.mjs");
var _indexMjs1 = require("./language/index.mjs");
var _indexMjs2 = require("./execution/index.mjs");
var _indexMjs3 = require("./subscription/index.mjs");
var _indexMjs4 = require("./validation/index.mjs");
var _indexMjs5 = require("./error/index.mjs");
var _indexMjs6 = require("./utilities/index.mjs");

},{"./version.mjs":false,"./graphql.mjs":false,"./type/index.mjs":false,"./language/index.mjs":"kWbYh","./execution/index.mjs":false,"./subscription/index.mjs":false,"./validation/index.mjs":false,"./error/index.mjs":"2pPJl","./utilities/index.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kWbYh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", ()=>(0, _sourceMjs.Source));
parcelHelpers.export(exports, "getLocation", ()=>(0, _locationMjs.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _printLocationMjs.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _printLocationMjs.printSourceLocation));
parcelHelpers.export(exports, "Kind", ()=>(0, _kindsMjs.Kind));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _tokenKindMjs.TokenKind));
parcelHelpers.export(exports, "Lexer", ()=>(0, _lexerMjs.Lexer));
parcelHelpers.export(exports, "parse", ()=>(0, _parserMjs.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _parserMjs.parseValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _parserMjs.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _printerMjs.print));
parcelHelpers.export(exports, "visit", ()=>(0, _visitorMjs.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _visitorMjs.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _visitorMjs.getVisitFn));
parcelHelpers.export(exports, "BREAK", ()=>(0, _visitorMjs.BREAK));
parcelHelpers.export(exports, "Location", ()=>(0, _astMjs.Location));
parcelHelpers.export(exports, "Token", ()=>(0, _astMjs.Token));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _predicatesMjs.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _predicatesMjs.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _predicatesMjs.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _predicatesMjs.isValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _predicatesMjs.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _predicatesMjs.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _predicatesMjs.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _predicatesMjs.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _predicatesMjs.isTypeExtensionNode));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _directiveLocationMjs.DirectiveLocation));
var _sourceMjs = require("./source.mjs");
var _locationMjs = require("./location.mjs");
var _printLocationMjs = require("./printLocation.mjs");
var _kindsMjs = require("./kinds.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _lexerMjs = require("./lexer.mjs");
var _parserMjs = require("./parser.mjs");
var _printerMjs = require("./printer.mjs");
var _visitorMjs = require("./visitor.mjs");
var _astMjs = require("./ast.mjs");
var _predicatesMjs = require("./predicates.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");

},{"./source.mjs":false,"./location.mjs":false,"./printLocation.mjs":false,"./kinds.mjs":false,"./tokenKind.mjs":false,"./lexer.mjs":false,"./parser.mjs":"fZmKP","./printer.mjs":"dRxF4","./visitor.mjs":false,"./ast.mjs":false,"./predicates.mjs":false,"./directiveLocation.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8nXJa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", ()=>Source);
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */ // eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isSource", ()=>isSource);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
var _instanceOfMjsDefault = parcelHelpers.interopDefault(_instanceOfMjs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Source = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === "string" || (0, _devAssertMjsDefault.default)(0, "Body must be a string. Received: ".concat((0, _inspectMjsDefault.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, _devAssertMjsDefault.default)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, _devAssertMjsDefault.default)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    _createClass(Source, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function isSource(source) {
    return (0, _instanceOfMjsDefault.default)(source, Source);
}

},{"../polyfills/symbols.mjs":"gNgQQ","../jsutils/inspect.mjs":"l5u5F","../jsutils/devAssert.mjs":"g8ddh","../jsutils/instanceOf.mjs":"aLwoX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gNgQQ":[function(require,module,exports) {
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SYMBOL_ITERATOR", ()=>SYMBOL_ITERATOR);
parcelHelpers.export(exports, "SYMBOL_ASYNC_ITERATOR", ()=>SYMBOL_ASYNC_ITERATOR);
parcelHelpers.export(exports, "SYMBOL_TO_STRING_TAG", ()=>SYMBOL_TO_STRING_TAG);
var SYMBOL_ITERATOR = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_TO_STRING_TAG = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l5u5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>inspect);
/* eslint-disable flowtype/no-weak-types */ var _nodejsCustomInspectSymbolMjs = require("./nodejsCustomInspectSymbol.mjs");
var _nodejsCustomInspectSymbolMjsDefault = parcelHelpers.interopDefault(_nodejsCustomInspectSymbolMjs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
    return formatValue(value, []);
}
function formatValue(value, seenValues) {
    switch(_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return formatArray(value, seenValues);
    return formatObject(value, seenValues);
}
function formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[" + getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min(MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push(formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function getCustomFn(object) {
    var customInspectFn = object[String((0, _nodejsCustomInspectSymbolMjsDefault.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

},{"./nodejsCustomInspectSymbol.mjs":"gY5NC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gY5NC":[function(require,module,exports) {
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
exports.default = nodejsCustomInspectSymbol;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g8ddh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>devAssert);
function devAssert(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aLwoX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inspectMjs = require("./inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
exports.default = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

},{"./inspect.mjs":"l5u5F","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3hNht":[function(require,module,exports) {
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocation", ()=>getLocation);
function getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8Eh46":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printLocation", ()=>printLocation);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printSourceLocation", ()=>printSourceLocation);
var _locationMjs = require("./location.mjs");
function printLocation(location) {
    return printSourceLocation(location.source, (0, _locationMjs.getLocation)(location.source, location.start));
}
function printSourceLocation(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function whitespace(len) {
    return Array(len + 1).join(" ");
}
function leftPad(len, str) {
    return whitespace(len - str.length) + str;
}

},{"./location.mjs":"3hNht","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dxuRQ":[function(require,module,exports) {
/**
 * The set of allowed kind values for AST nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Kind", ()=>Kind);
var Kind = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eCFR5":[function(require,module,exports) {
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenKind", ()=>TokenKind);
var TokenKind = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bdsQj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lexer", ()=>Lexer);
/**
 * @internal
 */ parcelHelpers.export(exports, "isPunctuatorTokenKind", ()=>isPunctuatorTokenKind);
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _astMjs = require("./ast.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _blockStringMjs = require("./blockString.mjs");
var Lexer = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, _tokenKindMjs.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
        }while (token.kind === (0, _tokenKindMjs.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function isPunctuatorTokenKind(kind) {
    return kind === (0, _tokenKindMjs.TokenKind).BANG || kind === (0, _tokenKindMjs.TokenKind).DOLLAR || kind === (0, _tokenKindMjs.TokenKind).AMP || kind === (0, _tokenKindMjs.TokenKind).PAREN_L || kind === (0, _tokenKindMjs.TokenKind).PAREN_R || kind === (0, _tokenKindMjs.TokenKind).SPREAD || kind === (0, _tokenKindMjs.TokenKind).COLON || kind === (0, _tokenKindMjs.TokenKind).EQUALS || kind === (0, _tokenKindMjs.TokenKind).AT || kind === (0, _tokenKindMjs.TokenKind).BRACKET_L || kind === (0, _tokenKindMjs.TokenKind).BRACKET_R || kind === (0, _tokenKindMjs.TokenKind).BRACE_L || kind === (0, _tokenKindMjs.TokenKind).PIPE || kind === (0, _tokenKindMjs.TokenKind).BRACE_R;
}
function printCharCode(code) {
    return isNaN(code) ? (0, _tokenKindMjs.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return readBlockString(source, pos, _line, _col, prev, lexer);
                return readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return readName(source, pos, _line, _col, prev);
        }
        throw (0, _syntaxErrorMjs.syntaxError)(source, pos, unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    } else {
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || isNameStart(code)) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
    return new (0, _astMjs.Token)(isFloat ? (0, _tokenKindMjs.TokenKind).FLOAT : (0, _tokenKindMjs.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringMjs.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function uniCharCode(a, b, c, d) {
    return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

},{"../error/syntaxError.mjs":"JPzFx","./ast.mjs":"1TlZd","./tokenKind.mjs":"eCFR5","./blockString.mjs":"fPOSy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"JPzFx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ parcelHelpers.export(exports, "syntaxError", ()=>syntaxError);
var _graphQLErrorMjs = require("./GraphQLError.mjs");
function syntaxError(source, position, description) {
    return new (0, _graphQLErrorMjs.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

},{"./GraphQLError.mjs":"53tLw","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"53tLw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", ()=>GraphQLError);
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ parcelHelpers.export(exports, "printError", ()=>printError);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _locationMjs = require("../language/location.mjs");
var _printLocationMjs = require("../language/printLocation.mjs");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var GraphQLError = /*#__PURE__*/ function(_Error) {
    _inherits(GraphQLError, _Error);
    var _super = _createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        _classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, _locationMjs.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, _locationMjs.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, _isObjectLikeMjsDefault.default)(originalExtensions)) _this.extensions = _objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties(_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty(_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return _possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty(_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    _createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return printError(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function printError(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += "\n\n" + (0, _printLocationMjs.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += "\n\n" + (0, _printLocationMjs.printSourceLocation)(error.source, location);
    }
    return output;
}

},{"../jsutils/isObjectLike.mjs":"d4xxP","../polyfills/symbols.mjs":"gNgQQ","../language/location.mjs":"3hNht","../language/printLocation.mjs":"8Eh46","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d4xxP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObjectLike);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function isObjectLike(value) {
    return _typeof(value) == "object" && value !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1TlZd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Location", ()=>Location);
parcelHelpers.export(exports, "Token", ()=>Token);
/**
 * @internal
 */ parcelHelpers.export(exports, "isNode", ()=>isNode) /**
 * The list of all possible AST node types.
 */ ;
var _defineInspectMjs = require("../jsutils/defineInspect.mjs");
var _defineInspectMjsDefault = parcelHelpers.interopDefault(_defineInspectMjs);
var Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(Location);
var Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(Token);
function isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
}

},{"../jsutils/defineInspect.mjs":"8nJdw","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8nJdw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defineInspect);
var _invariantMjs = require("./invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _nodejsCustomInspectSymbolMjs = require("./nodejsCustomInspectSymbol.mjs");
var _nodejsCustomInspectSymbolMjsDefault = parcelHelpers.interopDefault(_nodejsCustomInspectSymbolMjs);
function defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, _invariantMjsDefault.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, _nodejsCustomInspectSymbolMjsDefault.default) classObject.prototype[0, _nodejsCustomInspectSymbolMjsDefault.default] = fn;
}

},{"./invariant.mjs":"2hHlV","./nodejsCustomInspectSymbol.mjs":"gY5NC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2hHlV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
function invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fPOSy":[function(require,module,exports) {
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dedentBlockStringValue", ()=>dedentBlockStringValue);
/**
 * @internal
 */ parcelHelpers.export(exports, "getBlockStringIndentation", ()=>getBlockStringIndentation);
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ parcelHelpers.export(exports, "printBlockString", ()=>printBlockString);
function dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
function getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fZmKP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Configuration options to control parser behavior
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ parcelHelpers.export(exports, "parseValue", ()=>parseValue);
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ parcelHelpers.export(exports, "parseType", ()=>parseType);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _kindsMjs = require("./kinds.mjs");
var _astMjs = require("./ast.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _sourceMjs = require("./source.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");
var _lexerMjs = require("./lexer.mjs");
function parse(source, options) {
    var parser = new Parser(source, options);
    return parser.parseDocument();
}
function parseValue(source, options) {
    var parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return value;
}
function parseType(source, options) {
    var parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return type;
}
var Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, _sourceMjs.isSource)(source) ? source : new (0, _sourceMjs.Source)(source);
        this._lexer = new (0, _lexerMjs.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        return {
            kind: (0, _kindsMjs.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).DOCUMENT,
            definitions: this.many((0, _tokenKindMjs.TokenKind).SOF, this.parseDefinition, (0, _tokenKindMjs.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseVariableDefinition, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).DOLLAR);
        return {
            kind: (0, _kindsMjs.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).SELECTION_SET,
            selections: this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseSelection, (0, _tokenKindMjs.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, _tokenKindMjs.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, _kindsMjs.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, item, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, _tokenKindMjs.TokenKind).NAME)) return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, _kindsMjs.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, _tokenKindMjs.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, _tokenKindMjs.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, _tokenKindMjs.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, _kindsMjs.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, _tokenKindMjs.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, _kindsMjs.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, _tokenKindMjs.TokenKind).STRING:
            case (0, _tokenKindMjs.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, _tokenKindMjs.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, _kindsMjs.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, _kindsMjs.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, _tokenKindMjs.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, _kindsMjs.Kind).STRING,
            value: token.value,
            block: token.kind === (0, _tokenKindMjs.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, _kindsMjs.Kind).LIST,
            values: this.any((0, _tokenKindMjs.TokenKind).BRACKET_L, item, (0, _tokenKindMjs.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, _kindsMjs.Kind).OBJECT,
            fields: this.any((0, _tokenKindMjs.TokenKind).BRACE_L, item, (0, _tokenKindMjs.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, _tokenKindMjs.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        return {
            kind: (0, _kindsMjs.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, _tokenKindMjs.TokenKind).BRACKET_R);
            type = {
                kind: (0, _kindsMjs.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BANG)) return {
            kind: (0, _kindsMjs.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, _tokenKindMjs.TokenKind).STRING) || this.peek((0, _tokenKindMjs.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        return {
            kind: (0, _kindsMjs.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, _kindsMjs.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword("implements")) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, _tokenKindMjs.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).AMP) || this.peek((0, _tokenKindMjs.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, _tokenKindMjs.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseFieldDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, _directiveLocationMjs.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, _astMjs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat(getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function getTokenDesc(token) {
    var value = token.value;
    return getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function getTokenKindDesc(kind) {
    return (0, _lexerMjs.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

},{"../error/syntaxError.mjs":"JPzFx","./kinds.mjs":"dxuRQ","./ast.mjs":"1TlZd","./tokenKind.mjs":"eCFR5","./source.mjs":"8nXJa","./directiveLocation.mjs":"2lgDF","./lexer.mjs":"bdsQj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2lgDF":[function(require,module,exports) {
/**
 * The set of allowed directive location values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectiveLocation", ()=>DirectiveLocation);
var DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dRxF4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ parcelHelpers.export(exports, "print", ()=>print);
var _visitorMjs = require("./visitor.mjs");
var _blockStringMjs = require("./blockString.mjs");
function print(ast) {
    return (0, _visitorMjs.visit)(ast, {
        leave: printDocASTReducer
    });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
        var directives = join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : join([
            op,
            join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = wrap("", alias, ": ") + name;
        var argsLine = prefix + wrap("(", join(args, ", "), ")");
        if (argsLine.length > MAX_LINE_LENGTH) argsLine = prefix + wrap("(\n", indent(join(args, "\n")), "\n)");
        return join([
            argsLine,
            join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + wrap(" ", join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return join([
            "...",
            wrap("on ", typeCondition),
            join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat(wrap("(", join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat(wrap("", join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, _blockStringMjs.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + wrap("(", join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return join([
            "schema",
            join(directives, " "),
            block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return join([
            "scalar",
            name,
            join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return join([
            "type",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    FieldDefinition: addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " "));
    }),
    InputValueDefinition: addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return join([
            name + ": " + type,
            wrap("= ", defaultValue),
            join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return join([
            "interface",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    UnionTypeDefinition: addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return join([
            "union",
            name,
            join(directives, " "),
            types && types.length !== 0 ? "= " + join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return join([
            "enum",
            name,
            join(directives, " "),
            block(values)
        ], " ");
    }),
    EnumValueDefinition: addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return join([
            name,
            join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return join([
            "input",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    DirectiveDefinition: addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return join([
            "extend schema",
            join(directives, " "),
            block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return join([
            "extend scalar",
            name,
            join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return join([
            "extend type",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return join([
            "extend interface",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return join([
            "extend union",
            name,
            join(directives, " "),
            types && types.length !== 0 ? "= " + join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return join([
            "extend enum",
            name,
            join(directives, " "),
            block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return join([
            "extend input",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }
};
function addDescription(cb) {
    return function(node) {
        return join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function block(array) {
    return wrap("{\n", indent(join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function indent(str) {
    return wrap("  ", str.replace(/\n/g, "\n  "));
}
function isMultiline(str) {
    return str.indexOf("\n") !== -1;
}
function hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some(isMultiline);
}

},{"./visitor.mjs":"5JE7g","./blockString.mjs":"fPOSy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5JE7g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryDocumentKeys", ()=>QueryDocumentKeys);
parcelHelpers.export(exports, "BREAK", ()=>BREAK);
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ parcelHelpers.export(exports, "visit", ()=>visit);
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ parcelHelpers.export(exports, "visitInParallel", ()=>visitInParallel);
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ parcelHelpers.export(exports, "getVisitFn", ()=>getVisitFn);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _astMjs = require("./ast.mjs");
var QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var BREAK = Object.freeze({});
function visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, _astMjs.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, _inspectMjsDefault.default)(node), "."));
            var visitFn = getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, _astMjs.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === BREAK) skipping[i] = BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === BREAK) skipping[i] = BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

},{"../jsutils/inspect.mjs":"l5u5F","./ast.mjs":"1TlZd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2pPJl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _graphQLErrorMjs.GraphQLError));
parcelHelpers.export(exports, "printError", ()=>(0, _graphQLErrorMjs.printError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _syntaxErrorMjs.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _locatedErrorMjs.locatedError));
parcelHelpers.export(exports, "formatError", ()=>(0, _formatErrorMjs.formatError));
var _graphQLErrorMjs = require("./GraphQLError.mjs");
var _syntaxErrorMjs = require("./syntaxError.mjs");
var _locatedErrorMjs = require("./locatedError.mjs");
var _formatErrorMjs = require("./formatError.mjs");

},{"./GraphQLError.mjs":"53tLw","./syntaxError.mjs":false,"./locatedError.mjs":false,"./formatError.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7x5ZR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPubSub", ()=>(0, _internalPubSub.InternalPubSub));
parcelHelpers.export(exports, "InternalPubSubClass", ()=>(0, _internalPubSub.InternalPubSubClass));
var _internalPubSub = require("./InternalPubSub");

},{"./InternalPubSub":"16S9j","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"16S9j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPubSubClass", ()=>InternalPubSubClass);
parcelHelpers.export(exports, "InternalPubSub", ()=>InternalPubSub);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _providers = require("../Providers");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var isNode = (0, _core.browserOrNode)().isNode;
var logger = new (0, _core.ConsoleLogger)("PubSub");
var InternalPubSubClass = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function InternalPubSubClass(options) {
        this._options = options !== null && options !== void 0 ? options : {};
        logger.debug("PubSub Options", this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(InternalPubSubClass.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, _providers.AWSAppSyncRealTimeProvider)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    InternalPubSubClass.prototype.getModuleName = function() {
        return "InternalPubSub";
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ InternalPubSubClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        logger.debug("configure PubSub", {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ InternalPubSubClass.prototype.addPluggable = function(pluggable) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var config;
            return (0, _tslib.__generator)(this, function(_a) {
                if (pluggable && pluggable.getCategory() === "PubSub") {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * remove plugin from PubSub category
     * @param providerName - the name of the plugin
     */ InternalPubSubClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
    };
    InternalPubSubClass.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, _core.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    InternalPubSubClass.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + String(providerName));
        return [
            provider
        ];
    };
    InternalPubSubClass.prototype.publish = function(topics, msg, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    InternalPubSubClass.prototype.subscribe = function(topics, options, customUserAgentDetails) {
        if (isNode && this._options && this._options.ssr) throw new Error("Subscriptions are not supported for Server-Side Rendering (SSR)");
        logger.debug("subscribe options", options);
        var providers = this.getProviders(options);
        var pubSubUserAgentDetails = (0, _tslib.__assign)({
            category: (0, _core.Category).PubSub,
            action: (0, _core.PubSubAction).Subscribe
        }, customUserAgentDetails);
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options, pubSubUserAgentDetails)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function(error) {
                        return observer.error({
                            provider: provider,
                            error: error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return InternalPubSubClass;
}();
var InternalPubSub = new InternalPubSubClass();
(0, _core.Amplify).register(InternalPubSub);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","../Providers":"6FYV1","zen-observable-ts":"klrbV","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6FYV1":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPubSubProvider", ()=>(0, _pubSubProvider.AbstractPubSubProvider));
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", ()=>(0, _awsappSyncRealTimeProvider.AWSAppSyncRealTimeProvider));
parcelHelpers.export(exports, "AWSIoTProvider", ()=>(0, _awsiotProvider.AWSIoTProvider));
parcelHelpers.export(exports, "MqttOverWSProvider", ()=>(0, _mqttOverWSProvider.MqttOverWSProvider));
parcelHelpers.export(exports, "mqttTopicMatch", ()=>(0, _mqttOverWSProvider.mqttTopicMatch));
var _pubSubProvider = require("./PubSubProvider");
var _awsappSyncRealTimeProvider = require("./AWSAppSyncRealTimeProvider");
var _awsiotProvider = require("./AWSIotProvider");
var _mqttOverWSProvider = require("./MqttOverWSProvider");

},{"./PubSubProvider":false,"./AWSAppSyncRealTimeProvider":"bgEsS","./AWSIotProvider":false,"./MqttOverWSProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iRmQl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPubSubProvider", ()=>AbstractPubSubProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("AbstractPubSubProvider");
var AbstractPubSubProvider = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        this._config = (0, _tslib.__assign)((0, _tslib.__assign)({}, config), this._config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return "PubSub";
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function() {
            return (0, _tslib.__assign)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bgEsS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", ()=>AWSAppSyncRealTimeProvider);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _graphql = require("graphql");
var _url = require("url");
var _uuid = require("uuid");
var _buffer = require("buffer");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var _auth = require("@aws-amplify/auth");
var _pubSubProvider = require("../PubSubProvider");
var _pubSub = require("../../types/PubSub");
var _constants = require("../constants");
var _connectionStateMonitor = require("../../utils/ConnectionStateMonitor");
var _reconnectionMonitor = require("../../utils/ReconnectionMonitor");
var logger = new (0, _core.Logger)("AWSAppSyncRealTimeProvider");
var dispatchApiEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("api", {
        event: event,
        data: data,
        message: message
    }, "PubSub", (0, _constants.AMPLIFY_SYMBOL));
};
var standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
var customDomainPath = "/realtime";
var AWSAppSyncRealTimeProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
        _this.keepAliveTimeout = (0, _constants.DEFAULT_KEEP_ALIVE_TIMEOUT);
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        _this.connectionStateMonitor = new (0, _connectionStateMonitor.ConnectionStateMonitor)();
        _this.reconnectionMonitor = new (0, _reconnectionMonitor.ReconnectionMonitor)();
        // Monitor the connection state and pass changes along to Hub
        _this.connectionStateMonitorSubscription = _this.connectionStateMonitor.connectionStateObservable.subscribe(function(connectionState) {
            dispatchApiEvent((0, _constants.CONNECTION_STATE_CHANGE), {
                provider: _this,
                connectionState: connectionState
            }, "Connection state is " + connectionState);
            _this.connectionState = connectionState;
            // Trigger START_RECONNECT when the connection is disrupted
            if (connectionState === (0, _pubSub.ConnectionState).ConnectionDisrupted) _this.reconnectionMonitor.record((0, _reconnectionMonitor.ReconnectEvent).START_RECONNECT);
            // Trigger HALT_RECONNECT to halt reconnection attempts when the state is anything other than
            //   ConnectionDisrupted or Connecting
            if ([
                (0, _pubSub.ConnectionState).Connected,
                (0, _pubSub.ConnectionState).ConnectedPendingDisconnect,
                (0, _pubSub.ConnectionState).ConnectedPendingKeepAlive,
                (0, _pubSub.ConnectionState).ConnectedPendingNetwork,
                (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork,
                (0, _pubSub.ConnectionState).Disconnected
            ].includes(connectionState)) _this.reconnectionMonitor.record((0, _reconnectionMonitor.ReconnectEvent).HALT_RECONNECT);
        });
        return _this;
    }
    /**
     * Mark the socket closed and release all active listeners
     */ AWSAppSyncRealTimeProvider.prototype.close = function() {
        // Mark the socket closed both in status and the connection monitor
        this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_FAILED);
        // Turn off the subscription monitor Hub publishing
        this.connectionStateMonitorSubscription.unsubscribe();
        // Complete all reconnect observers
        this.reconnectionMonitor.close();
    };
    AWSAppSyncRealTimeProvider.prototype.getNewWebSocket = function(url, protocol) {
        return new WebSocket(url, protocol);
    };
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return "AWSAppSyncRealTimeProvider";
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error("Not used here");
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    // Check if url matches standard domain pattern
    AWSAppSyncRealTimeProvider.prototype.isCustomDomain = function(url) {
        return url.match(standardDomainPattern) === null;
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options, customUserAgentDetails) {
        var _this = this;
        var appSyncGraphqlEndpoint = options === null || options === void 0 ? void 0 : options.appSyncGraphqlEndpoint;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            if (!options || !appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionStartActive_1 = false;
                var subscriptionId_1 = (0, _uuid.v4)();
                var startSubscription_1 = function() {
                    if (!subscriptionStartActive_1) {
                        subscriptionStartActive_1 = true;
                        var startSubscriptionPromise = _this._startSubscriptionWithAWSAppSyncRealTime({
                            options: options,
                            observer: observer,
                            subscriptionId: subscriptionId_1,
                            customUserAgentDetails: customUserAgentDetails
                        }).catch(function(err) {
                            logger.debug((0, _pubSub.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err);
                            _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
                        });
                        startSubscriptionPromise.finally(function() {
                            subscriptionStartActive_1 = false;
                        });
                    }
                };
                var reconnectSubscription_1;
                // Add an observable to the reconnection list to manage reconnection for this subscription
                reconnectSubscription_1 = new (0, _zenObservableTsDefault.default)(function(observer) {
                    _this.reconnectionMonitor.addObserver(observer);
                }).subscribe(function() {
                    startSubscription_1();
                });
                startSubscription_1();
                return function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    // Cleanup reconnection subscription
                                    reconnectSubscription_1 === null || reconnectSubscription_1 === void 0 || reconnectSubscription_1.unsubscribe();
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        3,
                                        4,
                                        5
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 2:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === (0, _constants.SUBSCRIPTION_STATUS).CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error("Subscription never connected");
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 3:
                                    err_1 = _a.sent();
                                    logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options["aws_appsync_dangerously_connect_to_http_endpoint_for_testing"];
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId, customUserAgentDetails = _a.customUserAgentDetails;
        var _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _c, graphql_headers, _d, additionalHeaders, subscriptionState, data, dataString, headerObj, _e, _f, subscriptionMessage, stringToAWSRealTime, err_2, _g, subscriptionFailedCallback, subscriptionReadyCallback;
            var _h;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _c = options.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, _d = options.additionalHeaders, additionalHeaders = _d === void 0 ? {} : _d;
                        subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query !== null && query !== void 0 ? query : "",
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: undefined
                        });
                        dataString = JSON.stringify(data);
                        _e = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 1:
                        _f = [
                            (0, _tslib.__assign).apply(void 0, _e.concat([
                                _j.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = (0, _tslib.__assign).apply(void 0, [
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _f.concat([
                                    _j.sent()
                                ])),
                                additionalHeaders
                            ]),
                            (_h = {}, _h[0, _core.USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _h)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: (0, _tslib.__assign)({}, headerObj)
                                }
                            },
                            type: (0, _constants.MESSAGE_TYPES).GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).OPENING_CONNECTION);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 4:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _j.sent();
                        this._logStartSubscriptionError(subscriptionId, observer, err_2);
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _g = (_b = this.subscriptionObserverMap.get(subscriptionId)) !== null && _b !== void 0 ? _b : {}, subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            query: query !== null && query !== void 0 ? query : "",
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, (0, _constants.START_ACK_TIMEOUT))
                        });
                        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Log logic for start subscription failures
    AWSAppSyncRealTimeProvider.prototype._logStartSubscriptionError = function(subscriptionId, observer, err) {
        var _a;
        logger.debug({
            err: err
        });
        var message = String((_a = err.message) !== null && _a !== void 0 ? _a : "");
        // Resolving to give the state observer time to propogate the update
        Promise.resolve(this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED));
        // Capture the error only when the network didn't cause disruption
        if (this.connectionState !== (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork) {
            // When the error is non-retriable, error out the observable
            if ((0, _core.isNonRetryableError)(err)) observer.error({
                errors: [
                    (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + message))
                ]
            });
            else logger.debug((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + message);
            var subscriptionFailedCallback = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
            // Notify concurrent unsubscription
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var subscriptionObserver, subscriptionState;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
                if (subscriptionObserver) {
                    subscriptionState = subscriptionObserver.subscriptionState;
                    // This in case unsubscribe is invoked before sending start subscription message
                    if (subscriptionState === (0, _constants.SUBSCRIPTION_STATUS).PENDING) return [
                        2 /*return*/ ,
                        new Promise(function(res, rej) {
                            var observer = subscriptionObserver.observer, subscriptionState = subscriptionObserver.subscriptionState, variables = subscriptionObserver.variables, query = subscriptionObserver.query;
                            _this.subscriptionObserverMap.set(subscriptionId, {
                                observer: observer,
                                subscriptionState: subscriptionState,
                                variables: variables,
                                query: query,
                                subscriptionReadyCallback: res,
                                subscriptionFailedCallback: rej
                            });
                        })
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === (0, _constants.SOCKET_STATUS).READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: (0, _constants.MESSAGE_TYPES).GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
            return;
        }
        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSING_CONNECTION);
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            logger.debug("closing WebSocket...");
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = null;
            tempSocket.onerror = null;
            tempSocket.close(1000);
            this.awsRealTimeSocket = undefined;
            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        var _this = this;
        if (typeof message.data !== "string") return;
        logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(String(message.data)), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === (0, _constants.MESSAGE_TYPES).GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_START_ACK) {
            logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
            dispatchApiEvent((0, _pubSub.CONTROL_MSG).SUBSCRIPTION_ACK, {
                query: query,
                variables: variables
            }, "Connection established for subscription");
            var subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).CONNECTED;
            if (observer) this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: undefined,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_ESTABLISHED);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_KEEP_ALIVE) {
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            this.keepAliveTimeoutId = setTimeout(function() {
                return _this._errorDisconnect((0, _pubSub.CONTROL_MSG).TIMEOUT_DISCONNECT);
            }, this.keepAliveTimeout);
            this.keepAliveAlertTimeoutId = setTimeout(function() {
                _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).KEEP_ALIVE_MISSED);
            }, (0, _constants.DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT));
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).KEEP_ALIVE);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_ERROR) {
            var subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).FAILED;
            if (observer) {
                this.subscriptionObserverMap.set(id, {
                    observer: observer,
                    query: query,
                    variables: variables,
                    startAckTimeoutId: startAckTimeoutId,
                    subscriptionReadyCallback: subscriptionReadyCallback,
                    subscriptionFailedCallback: subscriptionFailedCallback,
                    subscriptionState: subscriptionState
                });
                logger.debug((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload));
                observer.error({
                    errors: [
                        (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload)))
                    ]
                });
                if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
                if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
            }
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        logger.debug("Disconnect error: " + msg);
        if (this.awsRealTimeSocket) {
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            var observer = subscriptionObserver.observer, query = subscriptionObserver.query, variables = subscriptionObserver.variables;
            if (!observer) return;
            this.subscriptionObserverMap.set(subscriptionId, {
                observer: observer,
                query: query,
                variables: variables,
                subscriptionState: (0, _constants.SUBSCRIPTION_STATUS).FAILED
            });
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
            logger.debug("timeoutStartSubscription", JSON.stringify({
                query: query,
                variables: variables
            }));
        }
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        if (this.socketStatus === (0, _constants.SOCKET_STATUS).READY) return;
        return new Promise(function(res, rej) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var payloadString, authHeader, headerString, headerQs, payloadQs, discoverableEndpoint, protocol, awsRealTimeUrl, err_3;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === (0, _constants.SOCKET_STATUS).CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = (0, _constants.SOCKET_STATUS).CONNECTING;
                            payloadString = "{}";
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region,
                                    additionalHeaders: additionalHeaders
                                })
                            ];
                        case 2:
                            authHeader = _a.sent();
                            headerString = authHeader ? JSON.stringify(authHeader) : "";
                            headerQs = (0, _buffer.Buffer).from(headerString).toString("base64");
                            payloadQs = (0, _buffer.Buffer).from(payloadString).toString("base64");
                            discoverableEndpoint = appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "";
                            if (this.isCustomDomain(discoverableEndpoint)) discoverableEndpoint = discoverableEndpoint.concat(customDomainPath);
                            else discoverableEndpoint = discoverableEndpoint.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                            protocol = this.isSSLEnabled ? "wss://" : "ws://";
                            discoverableEndpoint = discoverableEndpoint.replace("https://", protocol).replace("http://", protocol);
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake(awsRealTimeUrl)
                            ];
                        case 3:
                            _a.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                logger.debug("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = (0, _constants.SOCKET_STATUS).READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            logger.debug("Connection exited with", err_3);
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = undefined;
                            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(awsRealTimeUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, _core.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
                                awsRealTimeUrl
                            ], (0, _constants.MAX_DELAY_MS))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(awsRealTimeUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var err_4, _a, errorType, errorCode;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = _this.getNewWebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    if (_this.awsRealTimeSocket) {
                                        var ackOk_1 = false;
                                        _this.awsRealTimeSocket.onerror = function(error) {
                                            logger.debug("WebSocket error " + JSON.stringify(error));
                                        };
                                        _this.awsRealTimeSocket.onclose = function(event) {
                                            logger.debug("WebSocket closed " + event.reason);
                                            rej(new Error(JSON.stringify(event)));
                                        };
                                        _this.awsRealTimeSocket.onmessage = function(message) {
                                            if (typeof message.data !== "string") return;
                                            logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                            var data = JSON.parse(message.data);
                                            var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? (0, _constants.DEFAULT_KEEP_ALIVE_TIMEOUT) : _b;
                                            if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_ACK) {
                                                ackOk_1 = true;
                                                if (_this.awsRealTimeSocket) {
                                                    _this.keepAliveTimeout = connectionTimeoutMs;
                                                    _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                                    _this.awsRealTimeSocket.onerror = function(err) {
                                                        logger.debug(err);
                                                        _this._errorDisconnect((0, _pubSub.CONTROL_MSG).CONNECTION_CLOSED);
                                                    };
                                                    _this.awsRealTimeSocket.onclose = function(event) {
                                                        logger.debug("WebSocket closed " + event.reason);
                                                        _this._errorDisconnect((0, _pubSub.CONTROL_MSG).CONNECTION_CLOSED);
                                                    };
                                                }
                                                res("Cool, connected to AWS AppSyncRealTime");
                                                return;
                                            }
                                            if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_ERROR) {
                                                var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (0, _tslib.__read)(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? "" : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                                rej({
                                                    errorType: errorType,
                                                    errorCode: errorCode
                                                });
                                            }
                                        };
                                        var gqlInit = {
                                            type: (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_INIT
                                        };
                                        _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                        var checkAckOk_1 = function(ackOk) {
                                            if (!ackOk) {
                                                _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_FAILED);
                                                rej(new Error("Connection timeout: ack from AWSAppSyncRealTime was not received after " + (0, _constants.CONNECTION_INIT_TIMEOUT) + " ms"));
                                            }
                                        };
                                        setTimeout(function() {
                                            return checkAckOk_1(ackOk_1);
                                        }, (0, _constants.CONNECTION_INIT_TIMEOUT));
                                    }
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        _a = err_4, errorType = _a.errorType, errorCode = _a.errorCode;
                        if ((0, _constants.NON_RETRYABLE_CODES).includes(errorCode)) throw new (0, _core.NonRetryableError)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this),
                            AWS_LAMBDA: this._customAuthHeader
                        };
                        if (!(!authenticationType || !headerHandler[authenticationType])) return [
                            3 /*break*/ ,
                            1
                        ];
                        logger.debug("Authentication type " + authenticationType + " not supported");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 1:
                        handler = headerHandler[authenticationType];
                        host = _url.parse(appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "").host;
                        logger.debug("Authenticating with " + authenticationType);
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 2:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var session;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var token, federatedInfo, currentUser;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem("federatedInfo")
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            2
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _b.sent();
                        if (currentUser) token = currentUser.token;
                        _b.label = 4;
                    case 4:
                        if (!token) throw new Error("No federated jwt");
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var dt, dtStr;
            return (0, _tslib.__generator)(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        "x-amz-date": dtStr,
                        "x-api-key": apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: "appsync"
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get().then(function(credentials) {
                                var _a = credentials, secretAccessKey = _a.secretAccessKey, accessKeyId = _a.accessKeyId, sessionToken = _a.sessionToken;
                                return {
                                    secret_key: secretAccessKey,
                                    access_key: accessKeyId,
                                    session_token: sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: "POST",
                            headers: (0, _tslib.__assign)({}, (0, _constants.AWS_APPSYNC_REALTIME_HEADERS))
                        };
                        signed_params = (0, _core.Signer).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._customAuthHeader = function(_a) {
        var host = _a.host, additionalHeaders = _a.additionalHeaders;
        if (!additionalHeaders || !additionalHeaders["Authorization"]) throw new Error("No auth token specified");
        return {
            Authorization: additionalHeaders.Authorization,
            host: host
        };
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, _core.Credentials).shear(credentials);
            logger.debug("set credentials for AWSAppSyncRealTimeProvider", cred);
            return true;
        }).catch(function(err) {
            logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, _pubSubProvider.AbstractPubSubProvider));

},{"tslib":"9gMVn","zen-observable-ts":"klrbV","graphql":"2Xp4W","url":"eSLai","uuid":"9dBTc","buffer":"d5TGT","@aws-amplify/core":"8BDOx","@aws-amplify/cache":"egrWR","@aws-amplify/auth":"6Q2Bh","../PubSubProvider":"iRmQl","../../types/PubSub":"l4jyc","../constants":"4sHsy","../../utils/ConnectionStateMonitor":"eWfOr","../../utils/ReconnectionMonitor":"BOd83","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d5TGT":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("d66f2e1ecf9cf00c");
var ieee754 = require("edca2e5113247e77");
var isArray = require("afbe907bb3b486b3");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"d66f2e1ecf9cf00c":"rFFSX","edca2e5113247e77":"iAbbC","afbe907bb3b486b3":"5mj8Q"}],"5mj8Q":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"l4jyc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", ()=>CONTROL_MSG);
parcelHelpers.export(exports, "ConnectionState", ()=>ConnectionState);
var CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var ConnectionState;
(function(ConnectionState) {
    /*
     * The connection is alive and healthy
     */ ConnectionState["Connected"] = "Connected";
    /*
     * The connection is alive, but the connection is offline
     */ ConnectionState["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
    /*
     * The connection has been disconnected while in use
     */ ConnectionState["ConnectionDisrupted"] = "ConnectionDisrupted";
    /*
     * The connection has been disconnected and the network is offline
     */ ConnectionState["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
    /*
     * The connection is in the process of connecting
     */ ConnectionState["Connecting"] = "Connecting";
    /*
     * The connection is not in use and is being disconnected
     */ ConnectionState["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
    /*
     * The connection is not in use and has been disconnected
     */ ConnectionState["Disconnected"] = "Disconnected";
    /*
     * The connection is alive, but a keep alive message has been missed
     */ ConnectionState["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})(ConnectionState || (ConnectionState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4sHsy":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_DELAY_MS", ()=>MAX_DELAY_MS);
parcelHelpers.export(exports, "NON_RETRYABLE_CODES", ()=>NON_RETRYABLE_CODES);
parcelHelpers.export(exports, "CONNECTION_STATE_CHANGE", ()=>CONNECTION_STATE_CHANGE);
parcelHelpers.export(exports, "MESSAGE_TYPES", ()=>MESSAGE_TYPES);
parcelHelpers.export(exports, "SUBSCRIPTION_STATUS", ()=>SUBSCRIPTION_STATUS);
parcelHelpers.export(exports, "SOCKET_STATUS", ()=>SOCKET_STATUS);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
parcelHelpers.export(exports, "AWS_APPSYNC_REALTIME_HEADERS", ()=>AWS_APPSYNC_REALTIME_HEADERS);
parcelHelpers.export(exports, "CONNECTION_INIT_TIMEOUT", ()=>CONNECTION_INIT_TIMEOUT);
parcelHelpers.export(exports, "START_ACK_TIMEOUT", ()=>START_ACK_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_KEEP_ALIVE_TIMEOUT", ()=>DEFAULT_KEEP_ALIVE_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT", ()=>DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT);
parcelHelpers.export(exports, "RECONNECT_DELAY", ()=>RECONNECT_DELAY);
parcelHelpers.export(exports, "RECONNECT_INTERVAL", ()=>RECONNECT_INTERVAL);
var MAX_DELAY_MS = 5000;
var NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var CONNECTION_STATE_CHANGE = "ConnectionStateChange";
var MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})(MESSAGE_TYPES || (MESSAGE_TYPES = {}));
var SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
var SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})(SOCKET_STATUS || (SOCKET_STATUS = {}));
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var AWS_APPSYNC_REALTIME_HEADERS = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
var CONNECTION_INIT_TIMEOUT = 15000;
var START_ACK_TIMEOUT = 15000;
var DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT = 65000;
var RECONNECT_DELAY = 5000;
var RECONNECT_INTERVAL = 60000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eWfOr":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONNECTION_CHANGE", ()=>CONNECTION_CHANGE);
parcelHelpers.export(exports, "ConnectionStateMonitor", ()=>ConnectionStateMonitor);
var _tslib = require("tslib");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _pubSub = require("../types/PubSub");
var _reachabilityMonitor = require("./ReachabilityMonitor");
var CONNECTION_CHANGE = {
    KEEP_ALIVE_MISSED: {
        keepAliveState: "unhealthy"
    },
    KEEP_ALIVE: {
        keepAliveState: "healthy"
    },
    CONNECTION_ESTABLISHED: {
        connectionState: "connected"
    },
    CONNECTION_FAILED: {
        intendedConnectionState: "disconnected",
        connectionState: "disconnected"
    },
    CLOSING_CONNECTION: {
        intendedConnectionState: "disconnected"
    },
    OPENING_CONNECTION: {
        intendedConnectionState: "connected",
        connectionState: "connecting"
    },
    CLOSED: {
        connectionState: "disconnected"
    },
    ONLINE: {
        networkState: "connected"
    },
    OFFLINE: {
        networkState: "disconnected"
    }
};
var ConnectionStateMonitor = /** @class */ function() {
    function ConnectionStateMonitor() {
        var _this = this;
        this._networkMonitoringSubscription = undefined;
        this._linkedConnectionState = {
            networkState: "connected",
            connectionState: "disconnected",
            intendedConnectionState: "disconnected",
            keepAliveState: "healthy"
        };
        // Attempt to update the state with the current actual network state
        this._initialNetworkStateSubscription = (0, _reachabilityMonitor.ReachabilityMonitor)().subscribe(function(_a) {
            var online = _a.online;
            var _b;
            _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
            (_b = _this._initialNetworkStateSubscription) === null || _b === void 0 || _b.unsubscribe();
        });
        this._linkedConnectionStateObservable = new (0, _zenObservableTsDefault.default)(function(connectionStateObserver) {
            connectionStateObserver.next(_this._linkedConnectionState);
            _this._linkedConnectionStateObserver = connectionStateObserver;
        });
    }
    /**
     * Turn network state monitoring on if it isn't on already
     */ ConnectionStateMonitor.prototype.enableNetworkMonitoring = function() {
        var _this = this;
        var _a;
        // If no initial network state was discovered, stop trying
        (_a = this._initialNetworkStateSubscription) === null || _a === void 0 || _a.unsubscribe();
        // Maintain the network state based on the reachability monitor
        if (this._networkMonitoringSubscription === undefined) this._networkMonitoringSubscription = (0, _reachabilityMonitor.ReachabilityMonitor)().subscribe(function(_a) {
            var online = _a.online;
            _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
        });
    };
    /**
     * Turn network state monitoring off if it isn't off already
     */ ConnectionStateMonitor.prototype.disableNetworkMonitoring = function() {
        var _a;
        (_a = this._networkMonitoringSubscription) === null || _a === void 0 || _a.unsubscribe();
        this._networkMonitoringSubscription = undefined;
    };
    Object.defineProperty(ConnectionStateMonitor.prototype, "connectionStateObservable", {
        /**
         * Get the observable that allows us to monitor the connection state
         *
         * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
         */ get: function() {
            var _this = this;
            var previous;
            // The linked state aggregates state changes to any of the network, connection,
            // intendedConnection and keepAliveHealth. Some states will change these independent
            // states without changing the overall connection state.
            // After translating from linked states to ConnectionState, then remove any duplicates
            return this._linkedConnectionStateObservable.map(function(value) {
                return _this.connectionStatesTranslator(value);
            }).filter(function(current) {
                var toInclude = current !== previous;
                previous = current;
                return toInclude;
            });
        },
        enumerable: true,
        configurable: true
    });
    /*
     * Updates local connection state and emits the full state to the observer.
     */ ConnectionStateMonitor.prototype.record = function(statusUpdates) {
        // Maintain the network monitor
        if (statusUpdates.intendedConnectionState === "connected") this.enableNetworkMonitoring();
        else if (statusUpdates.intendedConnectionState === "disconnected") this.disableNetworkMonitoring();
        // Maintain the socket state
        var newSocketStatus = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._linkedConnectionState), statusUpdates);
        this._linkedConnectionState = (0, _tslib.__assign)({}, newSocketStatus);
        this._linkedConnectionStateObserver.next(this._linkedConnectionState);
    };
    /*
     * Translate the ConnectionState structure into a specific ConnectionState string literal union
     */ ConnectionStateMonitor.prototype.connectionStatesTranslator = function(_a) {
        var connectionState = _a.connectionState, networkState = _a.networkState, intendedConnectionState = _a.intendedConnectionState, keepAliveState = _a.keepAliveState;
        if (connectionState === "connected" && networkState === "disconnected") return (0, _pubSub.ConnectionState).ConnectedPendingNetwork;
        if (connectionState === "connected" && intendedConnectionState === "disconnected") return (0, _pubSub.ConnectionState).ConnectedPendingDisconnect;
        if (connectionState === "disconnected" && intendedConnectionState === "connected" && networkState === "disconnected") return (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork;
        if (connectionState === "disconnected" && intendedConnectionState === "connected") return (0, _pubSub.ConnectionState).ConnectionDisrupted;
        if (connectionState === "connected" && keepAliveState === "unhealthy") return (0, _pubSub.ConnectionState).ConnectedPendingKeepAlive;
        // All remaining states directly correspond to the connection state
        if (connectionState === "connecting") return (0, _pubSub.ConnectionState).Connecting;
        if (connectionState === "disconnected") return (0, _pubSub.ConnectionState).Disconnected;
        return (0, _pubSub.ConnectionState).Connected;
    };
    return ConnectionStateMonitor;
}();

},{"tslib":"9gMVn","zen-observable-ts":"klrbV","../types/PubSub":"l4jyc","./ReachabilityMonitor":"jqfJP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jqfJP":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReachabilityMonitor", ()=>ReachabilityMonitor);
var _core = require("@aws-amplify/core");
var ReachabilityMonitor = function() {
    return new (0, _core.Reachability)().networkMonitor();
};

},{"@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"BOd83":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReconnectEvent", ()=>ReconnectEvent);
parcelHelpers.export(exports, "ReconnectionMonitor", ()=>ReconnectionMonitor);
var _constants = require("../Providers/constants");
var ReconnectEvent;
(function(ReconnectEvent) {
    ReconnectEvent["START_RECONNECT"] = "START_RECONNECT";
    ReconnectEvent["HALT_RECONNECT"] = "HALT_RECONNECT";
})(ReconnectEvent || (ReconnectEvent = {}));
/**
 * Captures the reconnect event logic used to determine when to reconnect to PubSub providers.
 *   Reconnnect attempts are delayed by 5 seconds to let the interface settle.
 *   Attempting to reconnect only once creates unrecoverable states when the network state isn't
 *   supported by the browser, so this keeps retrying every minute until halted.
 */ var ReconnectionMonitor = /** @class */ function() {
    function ReconnectionMonitor() {
        this.reconnectObservers = [];
    }
    /**
     * Add reconnect observer to the list of observers to alert on reconnect
     */ ReconnectionMonitor.prototype.addObserver = function(reconnectObserver) {
        this.reconnectObservers.push(reconnectObserver);
    };
    /**
     * Given a reconnect event, start the appropriate behavior
     */ ReconnectionMonitor.prototype.record = function(event) {
        var _this = this;
        if (event === ReconnectEvent.START_RECONNECT) // If the reconnection hasn't been started
        {
            if (this.reconnectSetTimeoutId === undefined && this.reconnectIntervalId === undefined) this.reconnectSetTimeoutId = setTimeout(function() {
                // Reconnect now
                _this._triggerReconnect();
                // Retry reconnect every periodically until it works
                _this.reconnectIntervalId = setInterval(function() {
                    _this._triggerReconnect();
                }, (0, _constants.RECONNECT_INTERVAL));
            }, (0, _constants.RECONNECT_DELAY));
        }
        if (event === ReconnectEvent.HALT_RECONNECT) {
            if (this.reconnectIntervalId) {
                clearInterval(this.reconnectIntervalId);
                this.reconnectIntervalId = undefined;
            }
            if (this.reconnectSetTimeoutId) {
                clearTimeout(this.reconnectSetTimeoutId);
                this.reconnectSetTimeoutId = undefined;
            }
        }
    };
    /**
     * Complete all reconnect observers
     */ ReconnectionMonitor.prototype.close = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.complete) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    ReconnectionMonitor.prototype._triggerReconnect = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.next) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    return ReconnectionMonitor;
}();

},{"../Providers/constants":"4sHsy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kp3r5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _auth.GRAPHQL_AUTH_MODE));
parcelHelpers.export(exports, "GraphQLAuthError", ()=>GraphQLAuthError);
var _auth = require("@aws-amplify/auth");
var GraphQLAuthError;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
    GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})(GraphQLAuthError || (GraphQLAuthError = {}));

},{"@aws-amplify/auth":"6Q2Bh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cbK7v":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestAPI", ()=>(0, _restAPI.RestAPI));
parcelHelpers.export(exports, "RestAPIClass", ()=>(0, _restAPI.RestAPIClass));
parcelHelpers.export(exports, "RestClient", ()=>(0, _restClient.RestClient));
var _restAPI = require("./RestAPI");
var _restClient = require("./RestClient");

},{"./RestAPI":"lggMk","./RestClient":"b15X7","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lggMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestAPIClass", ()=>RestAPIClass);
parcelHelpers.export(exports, "RestAPI", ()=>RestAPI);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _restClient = require("./RestClient");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("RestAPI");
/**
 * Export Cloud Logic APIs
 */ var RestAPIClass = /** @class */ function() {
    /**
     * Initialize Rest API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function RestAPIClass(options) {
        this._api = null;
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug("API Options", this._options);
    }
    RestAPIClass.prototype.getModuleName = function() {
        return "RestAPI";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ RestAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, _tslib.__rest)(_a, [
            "API"
        ]);
        var opt = (0, _tslib.__assign)((0, _tslib.__assign)({}, otherOptions), API);
        logger.debug("configure Rest API", {
            opt: opt
        });
        if (opt["aws_project_region"]) {
            if (opt["aws_cloud_logic_custom"]) {
                var custom = opt["aws_cloud_logic_custom"];
                opt.endpoints = typeof custom === "string" ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt["aws_project_region"],
                header: {}
            });
        }
        if (Array.isArray(opt.endpoints)) // Check if endpoints has custom_headers and validate if is a function
        opt.endpoints.forEach(function(endpoint) {
            if (typeof endpoint.custom_header !== "undefined" && typeof endpoint.custom_header !== "function") {
                logger.warn("Rest API " + endpoint.name + ", custom_header should be a function");
                endpoint.custom_header = undefined;
            }
        });
        else if (this._options && Array.isArray(this._options.endpoints)) opt.endpoints = this._options.endpoints;
        else opt.endpoints = [];
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ RestAPIClass.prototype.createInstance = function() {
        logger.debug("create Rest API instance");
        this._api = new (0, _restClient.RestClient)(this._options);
        // Share Amplify instance with client for SSR
        this._api.Credentials = this.Credentials;
        return true;
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.get = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.get(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.post = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.post(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.put = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.put(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.patch = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.patch(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.del = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.del(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.head = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.head(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ RestAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestAPIClass.prototype.endpoint = function(apiName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._api.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * Getting endpoint info for API
     * @param {string} apiName - The name of the api
     * @param {string} path - The path of the api that is going to accessed
     * @return {ApiInfo} - The endpoint information for that api-name
     */ RestAPIClass.prototype.getEndpointInfo = function(apiName, path) {
        var cloud_logic_array = this._options.endpoints;
        if (!Array.isArray(cloud_logic_array)) throw new Error("API category not configured");
        var apiConfig = cloud_logic_array.find(function(api) {
            return api.name === apiName;
        });
        if (!apiConfig) throw new Error("API ".concat(apiName, " does not exist"));
        var response = {
            endpoint: apiConfig.endpoint + path
        };
        if (typeof apiConfig.region === "string") response.region = apiConfig.region;
        else if (typeof this._options.region === "string") response.region = this._options.region;
        if (typeof apiConfig.service === "string") response.service = apiConfig.service || "execute-api";
        else response.service = "execute-api";
        if (typeof apiConfig.custom_header === "function") response.custom_header = apiConfig.custom_header;
        else response.custom_header = undefined;
        return response;
    };
    return RestAPIClass;
}();
var RestAPI = new RestAPIClass(null);
(0, _core.Amplify).register(RestAPI);

},{"tslib":"9gMVn","./RestClient":"b15X7","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b15X7":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestClient", ()=>RestClient);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _url = require("url");
var logger = new (0, _core.ConsoleLogger)("RestClient");
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/ var RestClient = /** @class */ function() {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */ function RestClient(options) {
        this._region = "us-east-1"; // this will be updated by endpoint function
        this._service = "execute-api"; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        /**
         * This weak map provides functionality to let clients cancel
         * in-flight axios requests. https://github.com/axios/axios#cancellation
         *
         * 1. For every axios request, a unique cancel token is generated and added in the request.
         * 2. Promise for fulfilling the request is then mapped to that unique cancel token.
         * 3. The promise is returned to the client.
         * 4. Clients can either wait for the promise to fulfill or call `API.cancel(promise)` to cancel the request.
         * 5. If `API.cancel(promise)` is called, then the corresponding cancel token is retrieved from the map below.
         * 6. Promise returned to the client will be in rejected state with the error provided during cancel.
         * 7. Clients can check if the error is because of cancelling by calling `API.isCancel(error)`.
         *
         * For more details, see https://github.com/aws-amplify/amplify-js/pull/3769#issuecomment-552660025
         */ this._cancelTokenMap = null;
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug("API Options", this._options);
        if (this._cancelTokenMap == null) this._cancelTokenMap = new WeakMap();
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/ /**
     * Basic HTTP request. Customizable
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.ajax = function(urlOrApiInfo, method, init) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var parsed_url, url, region, service, custom_header, params, libraryHeaders, initParams, isAllResponse, custom_header_obj, _a, _b, search, parsedUrl, credentials, error_1, signedParams, response, error_2, headers, dateHeader, responseDate, requestDate, rawClientDate;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        logger.debug(method, urlOrApiInfo);
                        region = "us-east-1";
                        service = "execute-api";
                        custom_header = undefined;
                        if (typeof urlOrApiInfo === "string") {
                            parsed_url = this._parseUrl(urlOrApiInfo);
                            url = urlOrApiInfo;
                        } else {
                            url = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service;
                            parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
                        }
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: "json",
                            timeout: 0,
                            cancelToken: null
                        };
                        libraryHeaders = {};
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            if (typeof FormData === "function" && initParams.body instanceof FormData) {
                                libraryHeaders["Content-Type"] = "multipart/form-data";
                                params.data = initParams.body;
                            } else {
                                libraryHeaders["Content-Type"] = "application/json; charset=UTF-8";
                                params.data = JSON.stringify(initParams.body);
                            }
                        }
                        if (initParams.responseType) params.responseType = initParams.responseType;
                        if (initParams.withCredentials) params["withCredentials"] = initParams.withCredentials;
                        if (initParams.timeout) params.timeout = initParams.timeout;
                        if (initParams.cancellableToken) params.cancelToken = initParams.cancellableToken.token;
                        params["signerServiceInfo"] = initParams.signerServiceInfo;
                        if (!(typeof custom_header === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            custom_header()
                        ];
                    case 1:
                        _a = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header_obj = _a;
                        params.headers = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, libraryHeaders), custom_header_obj), initParams.headers);
                        _b = (0, _url.parse)(url, true, true), search = _b.search, parsedUrl = (0, _tslib.__rest)(_b, [
                            "search"
                        ]);
                        params.url = (0, _url.format)((0, _tslib.__assign)((0, _tslib.__assign)({}, parsedUrl), {
                            query: (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedUrl.query), initParams.queryStringParameters || {})
                        }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers["Authorization"] !== "undefined") {
                            params.headers = Object.keys(params.headers).reduce(function(acc, k) {
                                if (params.headers[k]) acc[k] = params.headers[k];
                                return acc;
                            // tslint:disable-next-line:align
                            }, {});
                            return [
                                2 /*return*/ ,
                                this._request(params, isAllResponse)
                            ];
                        }
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Credentials.get()
                        ];
                    case 5:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        error_1 = _c.sent();
                        logger.debug("No credentials available, the request will be unsigned");
                        return [
                            2 /*return*/ ,
                            this._request(params, isAllResponse)
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        signedParams = this._sign((0, _tslib.__assign)({}, params), credentials, {
                            region: region,
                            service: service
                        });
                        return [
                            4 /*yield*/ ,
                            (0, _axiosDefault.default)(signedParams)
                        ];
                    case 8:
                        response = _c.sent();
                        return [
                            2 /*return*/ ,
                            isAllResponse ? response : response.data
                        ];
                    case 9:
                        error_2 = _c.sent();
                        logger.debug(error_2);
                        if ((0, _core.DateUtils).isClockSkewError(error_2)) {
                            headers = error_2.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            responseDate = new Date(dateHeader);
                            requestDate = (0, _core.DateUtils).getDateFromHeaderString(signedParams.headers["x-amz-date"]);
                            // Compare local clock to the server clock
                            if ((0, _core.DateUtils).isClockSkewed(responseDate)) {
                                rawClientDate = requestDate.getTime() - (0, _core.DateUtils).getClockOffset();
                                (0, _core.DateUtils).setClockOffset(responseDate.getTime() - rawClientDate);
                                return [
                                    2 /*return*/ ,
                                    this.ajax(urlOrApiInfo, method, init)
                                ];
                            }
                        }
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.get = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "GET", init);
    };
    /**
     * PUT HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.put = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "PUT", init);
    };
    /**
     * PATCH HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.patch = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "PATCH", init);
    };
    /**
     * POST HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.post = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "POST", init);
    };
    /**
     * DELETE HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.del = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "DELETE", init);
    };
    /**
     * HEAD HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.head = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "HEAD", init);
    };
    /**
     * Cancel an inflight API request
     * @param {Promise<any>} request - The request promise to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */ RestClient.prototype.cancel = function(request, message) {
        var source = this._cancelTokenMap.get(request);
        if (source) {
            source.cancel(message);
            return true;
        }
        return false;
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestClient.prototype.hasCancelToken = function(request) {
        return this._cancelTokenMap.has(request);
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestClient.prototype.isCancel = function(error) {
        return (0, _axiosDefault.default).isCancel(error);
    };
    /**
     * Retrieves a new and unique cancel token which can be
     * provided in an axios request to be cancelled later.
     */ RestClient.prototype.getCancellableToken = function() {
        return (0, _axiosDefault.default).CancelToken.source();
    };
    /**
     * Updates the weakmap with a response promise and its
     * cancel token such that the cancel token can be easily
     * retrieved (and used for cancelling the request)
     */ RestClient.prototype.updateRequestToBeCancellable = function(promise, cancelTokenSource) {
        this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestClient.prototype.endpoint = function(apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = "";
        if (!Array.isArray(cloud_logic_array)) return response;
        cloud_logic_array.forEach(function(v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === "string") _this._region = v.region;
                else if (typeof _this._options.region === "string") _this._region = _this._options.region;
                if (typeof v.service === "string") _this._service = v.service || "execute-api";
                else _this._service = "execute-api";
                if (typeof v.custom_header === "function") _this._custom_header = v.custom_header;
                else _this._custom_header = undefined;
            }
        });
        return response;
    };
    /** private methods **/ RestClient.prototype._sign = function(params, credentials, _a) {
        var service = _a.service, region = _a.region;
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = (0, _tslib.__rest)(params, [
            "signerServiceInfo"
        ]);
        var endpoint_region = region || this._region || this._options.region;
        var endpoint_service = service || this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = (0, _core.Signer).sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) signed_params.body = signed_params.data;
        logger.debug("Signed Request: ", signed_params);
        delete signed_params.headers["host"];
        return signed_params;
    };
    RestClient.prototype._request = function(params, isAllResponse) {
        if (isAllResponse === void 0) isAllResponse = false;
        return (0, _axiosDefault.default)(params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function(url) {
        var parts = url.split("/");
        return {
            host: parts[2],
            path: "/" + parts.slice(3).join("/")
        };
    };
    return RestClient;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","axios":"9UgpL","url":"eSLai","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9UgpL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"iQU3f","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iQU3f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"tJFLW","./helpers/bind.js":"7EFnQ","./core/Axios.js":"1CUwL","./core/mergeConfig.js":"3GQyo","./defaults/index.js":"1kKi6","./helpers/formDataToJSON.js":"SgmtR","./cancel/CanceledError.js":"724ii","./cancel/CancelToken.js":"dpg2S","./cancel/isCancel.js":"1eZWx","./env/data.js":"8F5os","./helpers/toFormData.js":"08qEx","./core/AxiosError.js":"drP1n","./helpers/spread.js":"cWbjh","./helpers/isAxiosError.js":"dStLr","./core/AxiosHeaders.js":"7FEZ8","./adapters/adapters.js":"8jHEt","./helpers/HttpStatusCode.js":"anDnR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"tJFLW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== "object") return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
};

},{"./helpers/bind.js":"7EFnQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7EFnQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
"use strict";
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1CUwL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"tJFLW","../helpers/buildURL.js":"cEihI","./InterceptorManager.js":"7BSRL","./dispatchRequest.js":"3WVaj","./mergeConfig.js":"3GQyo","./buildFullPath.js":"92Pgl","../helpers/validator.js":"29HPG","./AxiosHeaders.js":"7FEZ8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cEihI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

},{"../utils.js":"tJFLW","../helpers/AxiosURLSearchParams.js":"15Yir","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"15Yir":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"08qEx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"08qEx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, _utilsJsDefault.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, "[]")) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"8EcTH","../utils.js":"tJFLW","../core/AxiosError.js":"drP1n","../platform/node/classes/FormData.js":"e3fSj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"drP1n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"tJFLW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e3fSj":[function(require,module,exports) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7BSRL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
class InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"tJFLW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3WVaj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"hUXFk","../cancel/isCancel.js":"1eZWx","../defaults/index.js":"1kKi6","../cancel/CanceledError.js":"724ii","../core/AxiosHeaders.js":"7FEZ8","../adapters/adapters.js":"8jHEt","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hUXFk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"tJFLW","../defaults/index.js":"1kKi6","../core/AxiosHeaders.js":"7FEZ8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1kKi6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"tJFLW","../core/AxiosError.js":"drP1n","./transitional.js":"13nw2","../helpers/toFormData.js":"08qEx","../helpers/toURLEncodedForm.js":"lXLfG","../platform/index.js":"d7AJN","../helpers/formDataToJSON.js":"SgmtR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"13nw2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lXLfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"tJFLW","./toFormData.js":"08qEx","../platform/index.js":"d7AJN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d7AJN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"htYbv","./common/utils.js":"d8WVB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"htYbv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

},{"./classes/URLSearchParams.js":"aFIXT","./classes/FormData.js":"3ZaIi","./classes/Blob.js":"evCvZ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aFIXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
exports.default = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"15Yir","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3ZaIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof FormData !== "undefined" ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"evCvZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof Blob !== "undefined" ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d8WVB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = ((product)=>{
    return hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"SgmtR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"tJFLW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7FEZ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
"use strict";
const $internals = Symbol("internals");
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"tJFLW","../helpers/parseHeaders.js":"hi9FC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hi9FC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

},{"./../utils.js":"tJFLW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1eZWx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
"use strict";
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"724ii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? "canceled" : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"drP1n","../utils.js":"tJFLW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8jHEt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"tJFLW","./http.js":"e3fSj","./xhr.js":"iiwhL","../core/AxiosError.js":"drP1n","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iiwhL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _cookiesJs = require("./../helpers/cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildURLJs = require("./../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _isURLSameOriginJs = require("./../helpers/isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _speedometerJs = require("../helpers/speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
"use strict";
function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(config.headers).normalize();
        let { responseType, withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, _utilsJsDefault.default).isFormData(requestData)) {
            if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)("Request aborted", (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)("Network Error", (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, _cookiesJsDefault.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(fullPath);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)("Unsupported protocol " + protocol + ":", (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"tJFLW","./../core/settle.js":"2PMl8","./../helpers/cookies.js":"kGnMM","./../helpers/buildURL.js":"cEihI","../core/buildFullPath.js":"92Pgl","./../helpers/isURLSameOrigin.js":"hX9Qg","../defaults/transitional.js":"13nw2","../core/AxiosError.js":"drP1n","../cancel/CanceledError.js":"724ii","../helpers/parseProtocol.js":"eM4oB","../platform/index.js":"d7AJN","../core/AxiosHeaders.js":"7FEZ8","../helpers/speedometer.js":"grWT2","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2PMl8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)("Request failed with status code " + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"drP1n","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kGnMM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push("path=" + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"tJFLW","../platform/index.js":"d7AJN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"92Pgl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
"use strict";
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"jHqzU","../helpers/combineURLs.js":"awvbU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jHqzU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
"use strict";
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"awvbU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
"use strict";
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hX9Qg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"tJFLW","../platform/index.js":"d7AJN","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eM4oB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
"use strict";
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"grWT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3GQyo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"tJFLW","./AxiosHeaders.js":"7FEZ8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"29HPG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
const validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, _axiosErrorJsDefault.default)("options must be an object", (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)("option " + opt + " must be " + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)("Unknown option " + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"8F5os","../core/AxiosError.js":"drP1n","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8F5os":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.6.8";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dpg2S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"724ii","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cWbjh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
"use strict";
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dStLr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"tJFLW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"anDnR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cbXXL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLAuthError", ()=>(0, _types.GraphQLAuthError));
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _types.GRAPHQL_AUTH_MODE));
parcelHelpers.export(exports, "GraphQLAPI", ()=>(0, _graphQLAPI.GraphQLAPI));
parcelHelpers.export(exports, "GraphQLAPIClass", ()=>(0, _graphQLAPI.GraphQLAPIClass));
parcelHelpers.export(exports, "graphqlOperation", ()=>(0, _graphQLAPI.graphqlOperation));
var _graphQLAPI = require("./GraphQLAPI");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
exports.default = (0, _graphQLAPI.GraphQLAPI);

},{"./GraphQLAPI":"fUEGm","./types":"kp3r5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fUEGm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphqlOperation", ()=>graphqlOperation);
parcelHelpers.export(exports, "GraphQLAPIClass", ()=>GraphQLAPIClass);
parcelHelpers.export(exports, "GraphQLAPI", ()=>GraphQLAPI);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _internals = require("./internals");
var graphqlOperation = function(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var GraphQLAPIClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(GraphQLAPIClass, _super);
    function GraphQLAPIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphQLAPIClass.prototype.getModuleName = function() {
        return "GraphQLAPI";
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ GraphQLAPIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return GraphQLAPIClass;
}((0, _internals.InternalGraphQLAPIClass));
var GraphQLAPI = new GraphQLAPIClass(null);
(0, _core.Amplify).register(GraphQLAPI);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./internals":"hbH4E","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"f78ey":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataStore", ()=>(0, _datastore.DataStore));
parcelHelpers.export(exports, "DataStoreClass", ()=>(0, _datastore.DataStoreClass));
parcelHelpers.export(exports, "initSchema", ()=>(0, _datastore.initSchema));
parcelHelpers.export(exports, "AsyncCollection", ()=>(0, _datastore.AsyncCollection));
parcelHelpers.export(exports, "AsyncItem", ()=>(0, _datastore.AsyncItem));
parcelHelpers.export(exports, "Predicates", ()=>(0, _predicates.Predicates));
parcelHelpers.export(exports, "ModelPredicateCreator", ()=>(0, _predicates.ModelPredicateCreator));
parcelHelpers.export(exports, "ModelSortPredicateCreator", ()=>(0, _predicates.ModelSortPredicateCreator));
parcelHelpers.export(exports, "NAMESPACES", ()=>(0, _util.NAMESPACES));
parcelHelpers.export(exports, "utils", ()=>utils);
var _datastore = require("./datastore/datastore");
var _predicates = require("./predicates");
var _util = require("./util");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var utils = {
    USER: (0, _util.USER),
    traverseModel: (0, _util.traverseModel),
    validatePredicate: (0, _util.validatePredicate),
    isNonModelConstructor: (0, _util.isNonModelConstructor),
    isModelConstructor: (0, _util.isModelConstructor)
};

},{"./datastore/datastore":"ayGJH","./predicates":"lUiza","./util":"89SDa","./types":"KjGQP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ayGJH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "syncClasses", ()=>syncClasses);
/**
 * Registers a model instance against a data source (DataStore, API, or
 * Detached/None).
 *
 * The API option is demonstrative. Lazy loading against API is not yet
 * implemented.
 *
 * @param result A model instance or array of instances
 * @param attachment A ModelAttachment data source
 * @returns passes the `result` back through after attachment
 */ parcelHelpers.export(exports, "attached", ()=>attached);
parcelHelpers.export(exports, "getAttachment", ()=>getAttachment);
parcelHelpers.export(exports, "AsyncItem", ()=>AsyncItem);
parcelHelpers.export(exports, "AsyncCollection", ()=>AsyncCollection);
parcelHelpers.export(exports, "DataStoreClass", ()=>DataStore);
parcelHelpers.export(exports, "initSchema", ()=>initSchema);
parcelHelpers.export(exports, "DataStore", ()=>instance);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _immer = require("immer");
var _uuid = require("uuid");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _authModeStrategies = require("../authModeStrategies");
var _predicates = require("../predicates");
var _storage = require("../storage/storage");
var _relationship = require("../storage/relationship");
var _sync = require("../sync");
var _types = require("../types");
var _util = require("../util");
var _next = require("../predicates/next");
var _utils = require("../sync/utils");
(0, _immer.setAutoFreeze)(true);
(0, _immer.enablePatches)();
var logger = new (0, _core.ConsoleLogger)("DataStore");
var ulid = (0, _util.monotonicUlidFactory)(Date.now());
var isNode = (0, _core.browserOrNode)().isNode;
var SETTING_SCHEMA_VERSION = "schemaVersion";
var schema;
var modelNamespaceMap = new WeakMap();
/**
 * Stores data for crafting the correct update mutation input for a model.
 *
 * - `Patch[]` - array of changed fields and metadata.
 * - `PersistentModel` - the source model, used for diffing object-type fields.
 */ var modelPatchesMap = new WeakMap();
var getModelDefinition = function(modelConstructor) {
    var namespace = modelNamespaceMap.get(modelConstructor);
    var definition = namespace ? schema.namespaces[namespace].models[modelConstructor.name] : undefined;
    return definition;
};
/**
 * Determines whether the given object is a Model Constructor that DataStore can
 * safely use to construct objects and discover related metadata.
 *
 * @param obj The object to test.
 */ var isValidModelConstructor = function(obj) {
    return (0, _util.isModelConstructor)(obj) && modelNamespaceMap.has(obj);
};
var namespaceResolver = function(modelConstructor) {
    var resolver = modelNamespaceMap.get(modelConstructor);
    if (!resolver) throw new Error("Namespace Resolver for '" + modelConstructor.name + "' not found! This is probably a bug in '@amplify-js/datastore'.");
    return resolver;
};
/**
 * Creates a predicate without any conditions that can be passed to customer
 * code to have conditions added to it.
 *
 * For example, in this query:
 *
 * ```ts
 * await DataStore.query(
 * 	Model,
 * 	item => item.field.eq('value')
 * );
 * ```
 *
 * `buildSeedPredicate(Model)` is used to create `item`, which is passed to the
 * predicate function, which in turn uses that "seed" predicate (`item`) to build
 * a predicate tree.
 *
 * @param modelConstructor The model the predicate will query.
 */ var buildSeedPredicate = function(modelConstructor) {
    if (!modelConstructor) throw new Error("Missing modelConstructor");
    var modelSchema = getModelDefinition(modelConstructor);
    if (!modelSchema) throw new Error("Missing modelSchema");
    var pks = (0, _util.extractPrimaryKeyFieldNames)(modelSchema);
    if (!pks) throw new Error("Could not determine PK");
    return (0, _next.recursivePredicateFor)({
        builder: modelConstructor,
        schema: modelSchema,
        pkField: pks
    });
};
var syncClasses;
var userClasses;
var dataStoreClasses;
var storageClasses;
/**
 * Maps a model to its related models for memoization/immutability.
 */ var modelInstanceAssociationsMap = new WeakMap();
/**
 * Describes whether and to what a model is attached for lazy loading purposes.
 */ var ModelAttachment;
(function(ModelAttachment) {
    /**
     * Model doesn't lazy load from any data source.
     *
     * Related entity properties provided at instantiation are returned
     * via the respective lazy interfaces when their properties are invoked.
     */ ModelAttachment["Detached"] = "Detached";
    /**
     * Model lazy loads from the global DataStore.
     */ ModelAttachment["DataStore"] = "DataStore";
    /**
     * Demonstrative. Not yet implemented.
     */ ModelAttachment["API"] = "API";
})(ModelAttachment || (ModelAttachment = {}));
/**
 * Tells us which data source a model is attached to (lazy loads from).
 *
 * If `Deatched`, the model's lazy properties will only ever return properties
 * from memory provided at construction time.
 */ var attachedModelInstances = new WeakMap();
function attached(result, attachment) {
    if (Array.isArray(result)) result.map(function(record) {
        return attached(record, attachment);
    });
    else result && attachedModelInstances.set(result, attachment);
    return result;
}
var getAttachment = function(instance) {
    return attachedModelInstances.has(instance) ? attachedModelInstances.get(instance) : ModelAttachment.Detached;
};
var initSchema = function(userSchema) {
    var _a;
    if (schema !== undefined) {
        console.warn("The schema has already been initialized");
        return userClasses;
    }
    logger.log("validating schema", {
        schema: userSchema
    });
    checkSchemaCodegenVersion(userSchema.codegenVersion);
    var internalUserNamespace = (0, _tslib.__assign)({
        name: (0, _util.USER)
    }, userSchema);
    logger.log("DataStore", "Init models");
    userClasses = createTypeClasses(internalUserNamespace);
    logger.log("DataStore", "Models initialized");
    var dataStoreNamespace = getNamespace();
    var storageNamespace = (0, _storage.ExclusiveStorage).getNamespace();
    var syncNamespace = (0, _sync.SyncEngine).getNamespace();
    dataStoreClasses = createTypeClasses(dataStoreNamespace);
    storageClasses = createTypeClasses(storageNamespace);
    syncClasses = createTypeClasses(syncNamespace);
    schema = {
        namespaces: (_a = {}, _a[dataStoreNamespace.name] = dataStoreNamespace, _a[internalUserNamespace.name] = internalUserNamespace, _a[storageNamespace.name] = storageNamespace, _a[syncNamespace.name] = syncNamespace, _a),
        version: userSchema.version,
        codegenVersion: userSchema.codegenVersion
    };
    Object.keys(schema.namespaces).forEach(function(namespace) {
        var e_1, _a;
        var _b = (0, _tslib.__read)((0, _util.establishRelationAndKeys)(schema.namespaces[namespace]), 2), relations = _b[0], keys = _b[1];
        schema.namespaces[namespace].relationships = relations;
        schema.namespaces[namespace].keys = keys;
        var modelAssociations = new Map();
        Object.values(schema.namespaces[namespace].models).forEach(function(model) {
            var e_2, _a, e_3, _b;
            var connectedModels = [];
            Object.values(model.fields).filter(function(field) {
                return field.association && field.association.connectionType === "BELONGS_TO" && field.type.model !== model.name;
            }).forEach(function(field) {
                return connectedModels.push(field.type.model);
            });
            modelAssociations.set(model.name, connectedModels);
            // Precompute model info (such as pk fields) so that downstream schema consumers
            // (such as predicate builders) don't have to reach back into "DataStore" space
            // to go looking for it.
            Object.values(model.fields).forEach(function(field) {
                var relatedModel = userClasses[field.type.model];
                if ((0, _util.isModelConstructor)(relatedModel)) Object.defineProperty(field.type, "modelConstructor", {
                    get: function() {
                        var relatedModelDefinition = getModelDefinition(relatedModel);
                        if (!relatedModelDefinition) throw new Error("Could not find model definition for " + relatedModel.name);
                        return {
                            builder: relatedModel,
                            schema: relatedModelDefinition,
                            pkField: (0, _util.extractPrimaryKeyFieldNames)(relatedModelDefinition)
                        };
                    }
                });
            });
            // compatibility with legacy/pre-PK codegen for lazy loading to inject
            // index fields into the model definition.
            // definition.cloudFields = { ...definition.fields };
            var indexes = schema.namespaces[namespace].relationships[model.name].indexes;
            var indexFields = new Set();
            try {
                for(var indexes_1 = (0, _tslib.__values)(indexes), indexes_1_1 = indexes_1.next(); !indexes_1_1.done; indexes_1_1 = indexes_1.next()){
                    var index = indexes_1_1.value;
                    try {
                        for(var _c = (e_3 = void 0, (0, _tslib.__values)(index[1])), _d = _c.next(); !_d.done; _d = _c.next()){
                            var indexField = _d.value;
                            indexFields.add(indexField);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (indexes_1_1 && !indexes_1_1.done && (_a = indexes_1.return)) _a.call(indexes_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            model.allFields = (0, _tslib.__assign)((0, _tslib.__assign)({}, Object.fromEntries((0, _tslib.__spread)(indexFields.values()).map(function(name) {
                return [
                    name,
                    {
                        name: name,
                        type: "ID",
                        isArray: false
                    }
                ];
            }))), model.fields);
        });
        var result = new Map();
        var count = 1000;
        while(count > 0){
            if (modelAssociations.size === 0) break;
            count--;
            if (count === 0) throw new Error("Models are not topologically sortable. Please verify your schema.");
            try {
                for(var _c = (e_1 = void 0, (0, _tslib.__values)(Array.from(modelAssociations.keys()))), _d = _c.next(); !_d.done; _d = _c.next()){
                    var modelName = _d.value;
                    var parents = modelAssociations.get(modelName);
                    if (parents === null || parents === void 0 ? void 0 : parents.every(function(x) {
                        return result.has(x);
                    })) result.set(modelName, parents);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            Array.from(result.keys()).forEach(function(x) {
                return modelAssociations.delete(x);
            });
        }
        schema.namespaces[namespace].modelTopologicalOrdering = result;
    });
    return userClasses;
};
/**
 * Throws an exception if the schema has *not* been initialized
 * by `initSchema()`.
 *
 * **To be called before trying to access schema.**
 *
 * Currently this only needs to be called in `start()` and `clear()` because
 * all other functions will call start first.
 */ var checkSchemaInitialized = function() {
    if (schema === undefined) {
        var message = "Schema is not initialized. DataStore will not function as expected. This could happen if you have multiple versions of DataStore installed. Please see https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js/#check-for-duplicate-versions";
        logger.error(message);
        throw new Error(message);
    }
};
/**
 * Throws an exception if the schema is using a codegen version that is not supported.
 *
 * Set the supported version by setting majorVersion and minorVersion
 * This functions similar to ^ version range.
 * The tested codegenVersion major version must exactly match the set majorVersion
 * The tested codegenVersion minor version must be gt or equal to the set minorVersion
 * Example: For a min supported version of 5.4.0 set majorVersion = 5 and minorVersion = 4
 *
 * This regex will not work when setting a supported range with minor version
 * of 2 or more digits.
 * i.e. minorVersion = 10 will not work
 * The regex will work for testing a codegenVersion with multi digit minor
 * versions as long as the minimum minorVersion is single digit.
 * i.e. codegenVersion = 5.30.1, majorVersion = 5, minorVersion = 4 PASSES
 *
 * @param codegenVersion schema codegenVersion
 */ var checkSchemaCodegenVersion = function(codegenVersion) {
    var majorVersion = 3;
    var minorVersion = 2;
    var isValid = false;
    try {
        var versionParts = codegenVersion.split(".");
        var _a = (0, _tslib.__read)(versionParts, 4), major = _a[0], minor = _a[1], patch = _a[2], patchrevision = _a[3];
        isValid = Number(major) === majorVersion && Number(minor) >= minorVersion;
    } catch (err) {
        console.log("Error parsing codegen version: " + codegenVersion + "\n" + err);
    }
    if (!isValid) {
        var message = "Models were generated with an unsupported version of codegen. Codegen artifacts are from " + (codegenVersion || "an unknown version") + ", whereas ^" + majorVersion + "." + minorVersion + ".0 is required. " + "Update to the latest CLI and run 'amplify codegen models'.";
        logger.error(message);
        throw new Error(message);
    }
};
var createTypeClasses = function(namespace) {
    var classes = {};
    Object.entries(namespace.models).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), modelName = _b[0], modelDefinition = _b[1];
        var clazz = createModelClass(modelDefinition);
        classes[modelName] = clazz;
        modelNamespaceMap.set(clazz, namespace.name);
    });
    Object.entries(namespace.nonModels || {}).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), typeName = _b[0], typeDefinition = _b[1];
        var clazz = createNonModelClass(typeDefinition);
        classes[typeName] = clazz;
    });
    return classes;
};
/**
 * Collection of instantiated models to allow storage of metadata apart from
 * the model visible to the consuming app -- in case the app doesn't have
 * metadata fields (_version, _deleted, etc.) exposed on the model itself.
 */ var instancesMetadata = new WeakSet();
function modelInstanceCreator(modelConstructor, init) {
    instancesMetadata.add(init);
    return new modelConstructor(init);
}
var validateModelFields = function(modelDefinition) {
    return function(k, v) {
        var fieldDefinition = modelDefinition.fields[k];
        if (fieldDefinition !== undefined) {
            var type_1 = fieldDefinition.type, isRequired_1 = fieldDefinition.isRequired, isArrayNullable = fieldDefinition.isArrayNullable, name_1 = fieldDefinition.name, isArray = fieldDefinition.isArray;
            var timestamps = (0, _types.isSchemaModelWithAttributes)(modelDefinition) ? (0, _util.getTimestampFields)(modelDefinition) : {};
            var isTimestampField = !!timestamps[name_1];
            if ((!isArray && isRequired_1 || isArray && !isArrayNullable) && !isTimestampField && (v === null || v === undefined)) throw new Error("Field " + name_1 + " is required");
            if ((0, _types.isSchemaModelWithAttributes)(modelDefinition) && !(0, _util.isIdManaged)(modelDefinition)) {
                var keys = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                if (keys.includes(k) && v === "") {
                    logger.error((0, _util.errorMessages).idEmptyString, {
                        k: k,
                        value: v
                    });
                    throw new Error((0, _util.errorMessages).idEmptyString);
                }
            }
            if ((0, _types.isGraphQLScalarType)(type_1)) {
                var jsType_1 = (0, _types.GraphQLScalarType).getJSType(type_1);
                var validateScalar_1 = (0, _types.GraphQLScalarType).getValidationFunction(type_1);
                if (type_1 === "AWSJSON") {
                    if (typeof v === jsType_1) return;
                    if (typeof v === "string") try {
                        JSON.parse(v);
                        return;
                    } catch (error) {
                        throw new Error("Field " + name_1 + " is an invalid JSON object. " + v);
                    }
                }
                if (isArray) {
                    var errorTypeText = jsType_1;
                    if (!isRequired_1) errorTypeText = jsType_1 + " | null | undefined";
                    if (!Array.isArray(v) && !isArrayNullable) throw new Error("Field " + name_1 + " should be of type [" + errorTypeText + "], " + typeof v + " received. " + v);
                    if (!(0, _util.isNullOrUndefined)(v) && v.some(function(e) {
                        return (0, _util.isNullOrUndefined)(e) ? isRequired_1 : typeof e !== jsType_1;
                    })) {
                        var elemTypes = v.map(function(e) {
                            return e === null ? "null" : typeof e;
                        }).join(",");
                        throw new Error("All elements in the " + name_1 + " array should be of type " + errorTypeText + ", [" + elemTypes + "] received. " + v);
                    }
                    if (validateScalar_1 && !(0, _util.isNullOrUndefined)(v)) {
                        var validationStatus = v.map(function(e) {
                            if (!(0, _util.isNullOrUndefined)(e)) return validateScalar_1(e);
                            else if ((0, _util.isNullOrUndefined)(e) && !isRequired_1) return true;
                            else return false;
                        });
                        if (!validationStatus.every(function(s) {
                            return s;
                        })) throw new Error("All elements in the " + name_1 + " array should be of type " + type_1 + ", validation failed for one or more elements. " + v);
                    }
                } else if (!isRequired_1 && v === undefined) return;
                else if (typeof v !== jsType_1 && v !== null) throw new Error("Field " + name_1 + " should be of type " + jsType_1 + ", " + typeof v + " received. " + v);
                else if (!(0, _util.isNullOrUndefined)(v) && validateScalar_1 && !validateScalar_1(v) // TODO: why never, TS ... why ...
                ) throw new Error("Field " + name_1 + " should be of type " + type_1 + ", validation failed. " + v);
            } else if ((0, _types.isNonModelFieldType)(type_1)) // do not check non model fields if undefined or null
            {
                if (!(0, _util.isNullOrUndefined)(v)) {
                    var subNonModelDefinition_1 = schema.namespaces.user.nonModels[type_1.nonModel];
                    var modelValidator_1 = validateModelFields(subNonModelDefinition_1);
                    if (isArray) {
                        var errorTypeText = type_1.nonModel;
                        if (!isRequired_1) errorTypeText = type_1.nonModel + " | null | undefined";
                        if (!Array.isArray(v)) throw new Error("Field " + name_1 + " should be of type [" + errorTypeText + "], " + typeof v + " received. " + v);
                        v.forEach(function(item) {
                            if ((0, _util.isNullOrUndefined)(item) && isRequired_1 || typeof item !== "object" && typeof item !== "undefined") throw new Error("All elements in the " + name_1 + " array should be of type " + type_1.nonModel + ", [" + typeof item + "] received. " + item);
                            if (!(0, _util.isNullOrUndefined)(item)) Object.keys(subNonModelDefinition_1.fields).forEach(function(subKey) {
                                modelValidator_1(subKey, item[subKey]);
                            });
                        });
                    } else {
                        if (typeof v !== "object") throw new Error("Field " + name_1 + " should be of type " + type_1.nonModel + ", " + typeof v + " recieved. " + v);
                        Object.keys(subNonModelDefinition_1.fields).forEach(function(subKey) {
                            modelValidator_1(subKey, v[subKey]);
                        });
                    }
                }
            }
        }
    };
};
var castInstanceType = function(modelDefinition, k, v) {
    var _a = modelDefinition.fields[k] || {}, isArray = _a.isArray, type = _a.type;
    // attempt to parse stringified JSON
    if (typeof v === "string" && (isArray || type === "AWSJSON" || (0, _types.isNonModelFieldType)(type) || (0, _types.isModelFieldType)(type))) try {
        return JSON.parse(v);
    } catch (_b) {
    // if JSON is invalid, don't throw and let modelValidator handle it
    }
    // cast from numeric representation of boolean to JS boolean
    if (typeof v === "number" && type === "Boolean") return Boolean(v);
    return v;
};
/**
 * Records the patches (as if against an empty object) used to initialize
 * an instance of a Model. This can be used for determining which fields to
 * send to the cloud durnig a CREATE mutation.
 */ var initPatches = new WeakMap();
/**
 * Attempts to apply type-aware, casted field values from a given `init`
 * object to the given `draft`.
 *
 * @param init The initialization object to extract field values from.
 * @param modelDefinition The definition describing the target object shape.
 * @param draft The draft to apply field values to.
 */ var initializeInstance = function(init, modelDefinition, draft) {
    var modelValidator = validateModelFields(modelDefinition);
    Object.entries(init).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        var parsedValue = castInstanceType(modelDefinition, k, v);
        modelValidator(k, parsedValue);
        draft[k] = parsedValue;
    });
};
/**
 * Updates a draft to standardize its customer-defined fields so that they are
 * consistent with the data as it would look after having been synchronized from
 * Cloud storage.
 *
 * The exceptions to this are:
 *
 * 1. Non-schema/Internal [sync] metadata fields.
 * 2. Cloud-managed fields, which are `null` until set by cloud storage.
 *
 * This function should be expanded if/when deviations between canonical Cloud
 * storage data and locally managed data are found. For now, the known areas
 * that require normalization are:
 *
 * 1. Ensuring all non-metadata fields are *defined*. (I.e., turn `undefined` -> `null`.)
 *
 * @param modelDefinition Definition for the draft. Used to discover all fields.
 * @param draft The instance draft to apply normalizations to.
 */ var normalize = function(modelDefinition, draft) {
    var e_4, _a;
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(modelDefinition.fields)), _c = _b.next(); !_c.done; _c = _b.next()){
            var k = _c.value;
            if (draft[k] === undefined) draft[k] = null;
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
};
var createModelClass = function(modelDefinition) {
    var e_5, _a;
    var clazz = /** @class */ function() {
        function Model(init) {
            // we create a base instance first so we can distinguish which fields were explicitly
            // set by customer code versus those set by normalization. only those fields
            // which are explicitly set by customers should be part of create mutations.
            var patches = [];
            var baseInstance = (0, _immer.produce)(this, function(draft) {
                initializeInstance(init, modelDefinition, draft);
                // model is initialized inside a DataStore component (e.g. by Sync Engine, Storage Engine, etc.)
                var isInternallyInitialized = instancesMetadata.has(init);
                var modelInstanceMetadata = isInternallyInitialized ? init : {};
                var _id = modelInstanceMetadata.id;
                if ((0, _util.isIdManaged)(modelDefinition)) {
                    var isInternalModel = _id !== null && _id !== undefined;
                    var id = isInternalModel ? _id : modelDefinition.syncable ? (0, _uuid.v4)() : ulid();
                    draft.id = id;
                } else if ((0, _util.isIdOptionallyManaged)(modelDefinition)) // only auto-populate if the id was not provided
                draft.id = draft.id || (0, _uuid.v4)();
                if (!isInternallyInitialized) checkReadOnlyPropertyOnCreate(draft, modelDefinition);
                var _version = modelInstanceMetadata._version, _lastChangedAt = modelInstanceMetadata._lastChangedAt, _deleted = modelInstanceMetadata._deleted;
                if (modelDefinition.syncable) {
                    draft._version = _version;
                    draft._lastChangedAt = _lastChangedAt;
                    draft._deleted = _deleted;
                }
            }, function(p) {
                return patches = p;
            });
            // now that we have a list of patches that encapsulate the explicit, customer-provided
            // fields, we can normalize. patches from normalization are ignored, because the changes
            // are only create to provide a consistent view of the data for fields pre/post sync
            // where possible. (not all fields can be normalized pre-sync, because they're generally
            // "cloud managed" fields, like createdAt and updatedAt.)
            var normalized = (0, _immer.produce)(baseInstance, function(draft) {
                return normalize(modelDefinition, draft);
            });
            initPatches.set(normalized, patches);
            return normalized;
        }
        Model.copyOf = function(source, fn) {
            var modelConstructor = Object.getPrototypeOf(source || {}).constructor;
            if (!isValidModelConstructor(modelConstructor)) {
                var msg = "The source object is not a valid model";
                logger.error(msg, {
                    source: source
                });
                throw new Error(msg);
            }
            var patches = [];
            var model = (0, _immer.produce)(source, function(draft) {
                fn(draft);
                var keyNames = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                // Keys are immutable
                keyNames.forEach(function(key) {
                    if (draft[key] !== source[key]) logger.warn("copyOf() does not update PK fields. The '" + key + "' update is being ignored.", {
                        source: source
                    });
                    draft[key] = source[key];
                });
                var modelValidator = validateModelFields(modelDefinition);
                Object.entries(draft).forEach(function(_a) {
                    var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                    var parsedValue = castInstanceType(modelDefinition, k, v);
                    modelValidator(k, parsedValue);
                });
                normalize(modelDefinition, draft);
            }, function(p) {
                return patches = p;
            });
            var hasExistingPatches = modelPatchesMap.has(source);
            if (patches.length || hasExistingPatches) {
                if (hasExistingPatches) {
                    var _a = (0, _tslib.__read)(modelPatchesMap.get(source), 2), existingPatches = _a[0], existingSource = _a[1];
                    var mergedPatches = (0, _util.mergePatches)(existingSource, existingPatches, patches);
                    modelPatchesMap.set(model, [
                        mergedPatches,
                        existingSource
                    ]);
                    checkReadOnlyPropertyOnUpdate(mergedPatches, modelDefinition);
                } else {
                    modelPatchesMap.set(model, [
                        patches,
                        source
                    ]);
                    checkReadOnlyPropertyOnUpdate(patches, modelDefinition);
                }
            } else // always register patches when performing a copyOf, even if the
            // patches list is empty. this allows `save()` to recognize when an
            // instance is the result of a `copyOf()`. without more significant
            // refactoring, this is the only way for `save()` to know which
            // diffs (patches) are relevant for `storage` to use in building
            // the list of "changed" fields for mutations.
            modelPatchesMap.set(model, [
                [],
                source
            ]);
            return attached(model, ModelAttachment.DataStore);
        };
        // "private" method (that's hidden via `Setting`) for `withSSRContext` to use
        // to gain access to `modelInstanceCreator` and `clazz` for persisting IDs from server to client.
        Model.fromJSON = function(json) {
            var _this = this;
            if (Array.isArray(json)) return json.map(function(init) {
                return _this.fromJSON(init);
            });
            var instance = modelInstanceCreator(clazz, json);
            var modelValidator = validateModelFields(modelDefinition);
            Object.entries(instance).forEach(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                modelValidator(k, v);
            });
            return attached(instance, ModelAttachment.DataStore);
        };
        return Model;
    }();
    clazz[0, _immer.immerable] = true;
    Object.defineProperty(clazz, "name", {
        value: modelDefinition.name
    });
    // Add getters/setters for relationship fields.
    //  getter - for lazy loading
    //  setter - for FK management
    var allModelRelationships = (0, _relationship.ModelRelationship).allFrom({
        builder: clazz,
        schema: modelDefinition,
        pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
    });
    var _loop_1 = function(relationship) {
        var field = relationship.field;
        Object.defineProperty(clazz.prototype, modelDefinition.fields[field].name, {
            set: function(model) {
                if (!(typeof model === "object" || typeof model === "undefined")) return;
                // if model is undefined or null, the connection should be removed
                if (model) // Avoid validation error when processing AppSync response with nested
                // selection set. Nested entitites lack version field and can not be validated
                // TODO: explore a more reliable method to solve this
                {
                    if (model.hasOwnProperty("_version")) {
                        var modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                        if (!isValidModelConstructor(modelConstructor)) {
                            var msg = "Value passed to " + modelDefinition.name + "." + field + " is not a valid instance of a model";
                            logger.error(msg, {
                                model: model
                            });
                            throw new Error(msg);
                        }
                        if (modelConstructor.name.toLowerCase() !== relationship.remoteModelConstructor.name.toLowerCase()) {
                            var msg = "Value passed to " + modelDefinition.name + "." + field + " is not an instance of " + relationship.remoteModelConstructor.name;
                            logger.error(msg, {
                                model: model
                            });
                            throw new Error(msg);
                        }
                    }
                }
                // if the relationship can be managed automagically, set the FK's
                if (relationship.isComplete) {
                    for(var i = 0; i < relationship.localJoinFields.length; i++)this[relationship.localJoinFields[i]] = model === null || model === void 0 ? void 0 : model[relationship.remoteJoinFields[i]];
                    var instanceMemos = modelInstanceAssociationsMap.has(this) ? modelInstanceAssociationsMap.get(this) : modelInstanceAssociationsMap.set(this, {}).get(this);
                    instanceMemos[field] = model || undefined;
                }
            },
            get: function() {
                var _this = this;
                /**
                 * Bucket for holding related models instances specific to `this` instance.
                 */ var instanceMemos = modelInstanceAssociationsMap.has(this) ? modelInstanceAssociationsMap.get(this) : modelInstanceAssociationsMap.set(this, {}).get(this);
                // if the memos already has a result for this field, we'll use it.
                // there is no "cache" invalidation of any kind; memos are permanent to
                // keep an immutable perception of the instance.
                if (!instanceMemos.hasOwnProperty(field)) {
                    // before we populate the memo, we need to know where to look for relatives.
                    // today, this only supports DataStore. Models aren't managed elsewhere in Amplify.
                    if (getAttachment(this) === ModelAttachment.DataStore) {
                        // when we fetch the results using a query constructed under the guidance
                        // of the relationship metadata, we DO NOT AWAIT resolution. we want to
                        // drop the promise into the memo's synchronously, eliminating the chance
                        // for a race.
                        var resultPromise = instance.query(relationship.remoteModelConstructor, function(base) {
                            return base.and(function(q) {
                                return relationship.remoteJoinFields.map(function(field, index) {
                                    // TODO: anything we can use instead of `any` here?
                                    return q[field].eq(_this[relationship.localJoinFields[index]]);
                                });
                            });
                        });
                        // results in hand, how we return them to the caller depends on the relationship type.
                        if (relationship.type === "HAS_MANY") // collections should support async iteration, even though we don't
                        // leverage it fully [yet].
                        instanceMemos[field] = new AsyncCollection(resultPromise);
                        else // non-collections should only ever return 1 value *or nothing*.
                        // if we have more than 1 record, something's amiss. it's not our job
                        // pick a result for the customer. it's our job to say "something's wrong."
                        instanceMemos[field] = resultPromise.then(function(rows) {
                            if (rows.length > 1) {
                                // should never happen for a HAS_ONE or BELONGS_TO.
                                var err = new Error("\n									Data integrity error.\n									Too many records found for a HAS_ONE/BELONGS_TO field '" + modelDefinition.name + "." + field + "'\n								");
                                console.error(err);
                                throw err;
                            } else return rows[0];
                        });
                    } else if (getAttachment(this) === ModelAttachment.API) throw new Error("Lazy loading from API is not yet supported!");
                    else {
                        if (relationship.type === "HAS_MANY") return new AsyncCollection([]);
                        else return Promise.resolve(undefined);
                    }
                }
                return instanceMemos[field];
            }
        });
    };
    try {
        for(var allModelRelationships_1 = (0, _tslib.__values)(allModelRelationships), allModelRelationships_1_1 = allModelRelationships_1.next(); !allModelRelationships_1_1.done; allModelRelationships_1_1 = allModelRelationships_1.next()){
            var relationship = allModelRelationships_1_1.value;
            _loop_1(relationship);
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (allModelRelationships_1_1 && !allModelRelationships_1_1.done && (_a = allModelRelationships_1.return)) _a.call(allModelRelationships_1);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return clazz;
};
/**
 * An eventually loaded related model instance.
 */ var AsyncItem = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncItem, _super);
    function AsyncItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AsyncItem;
}(Promise);
/**
 * A collection of related model instances.
 *
 * This collection can be async-iterated or turned directly into an array using `toArray()`.
 */ var AsyncCollection = /** @class */ function() {
    function AsyncCollection(values) {
        this.values = values;
    }
    /**
     * Facilitates async iteration.
     *
     * ```ts
     * for await (const item of collection) {
     *   handle(item)
     * }
     * ```
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of
     */ AsyncCollection.prototype[Symbol.asyncIterator] = function() {
        var _this = this;
        var values;
        var index = 0;
        return {
            next: function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var result;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!values) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.values
                                ];
                            case 1:
                                values = _a.sent();
                                _a.label = 2;
                            case 2:
                                if (index < values.length) {
                                    result = {
                                        value: values[index],
                                        done: false
                                    };
                                    index++;
                                    return [
                                        2 /*return*/ ,
                                        result
                                    ];
                                }
                                return [
                                    2 /*return*/ ,
                                    {
                                        value: null,
                                        done: true
                                    }
                                ];
                        }
                    });
                });
            }
        };
    };
    /**
     * Turns the collection into an array, up to the amount specified in `max` param.
     *
     * ```ts
     * const all = await collection.toArray();
     * const first100 = await collection.toArray({max: 100});
     * ```
     */ AsyncCollection.prototype.toArray = function(_a) {
        var _b = (_a === void 0 ? {} : _a).max, max = _b === void 0 ? Number.MAX_SAFE_INTEGER : _b;
        var e_6, _c;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var output, i, _d, _e, element, e_6_1;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        output = [];
                        i = 0;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        _d = (0, _tslib.__asyncValues)(this);
                        _f.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _d.next()
                        ];
                    case 3:
                        if (!(_e = _f.sent(), !_e.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        element = _e.value;
                        if (i < max) {
                            output.push(element);
                            i++;
                        } else return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_6_1 = _f.sent();
                        e_6 = {
                            error: e_6_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _f.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(_e && !_e.done && (_c = _d.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _c.call(_d)
                        ];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_6) throw e_6.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        return [
                            2 /*return*/ ,
                            output
                        ];
                }
            });
        });
    };
    return AsyncCollection;
}();
var checkReadOnlyPropertyOnCreate = function(draft, modelDefinition) {
    var modelKeys = Object.keys(draft);
    var fields = modelDefinition.fields;
    modelKeys.forEach(function(key) {
        if (fields[key] && fields[key].isReadOnly) throw new Error(key + " is read-only.");
    });
};
var checkReadOnlyPropertyOnUpdate = function(patches, modelDefinition) {
    var patchArray = patches.map(function(p) {
        return [
            p.path[0],
            p.value
        ];
    });
    var fields = modelDefinition.fields;
    patchArray.forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], val = _b[1];
        if (!val || !fields[key]) return;
        if (fields[key].isReadOnly) throw new Error(key + " is read-only.");
    });
};
var createNonModelClass = function(typeDefinition) {
    var clazz = /** @class */ function() {
        function Model(init) {
            var instance = (0, _immer.produce)(this, function(draft) {
                initializeInstance(init, typeDefinition, draft);
            });
            return instance;
        }
        return Model;
    }();
    clazz[0, _immer.immerable] = true;
    Object.defineProperty(clazz, "name", {
        value: typeDefinition.name
    });
    (0, _util.registerNonModelClass)(clazz);
    return clazz;
};
function isQueryOne(obj) {
    return typeof obj === "string";
}
function defaultConflictHandler(conflictData) {
    var localModel = conflictData.localModel, modelConstructor = conflictData.modelConstructor, remoteModel = conflictData.remoteModel;
    var _version = remoteModel._version;
    return modelInstanceCreator(modelConstructor, (0, _tslib.__assign)((0, _tslib.__assign)({}, localModel), {
        _version: _version
    }));
}
function defaultErrorHandler(error) {
    logger.warn(error);
}
function getModelConstructorByModelName(namespaceName, modelName) {
    var result;
    switch(namespaceName){
        case 0, _util.DATASTORE:
            result = dataStoreClasses[modelName];
            break;
        case 0, _util.USER:
            result = userClasses[modelName];
            break;
        case 0, _util.SYNC:
            result = syncClasses[modelName];
            break;
        case 0, _util.STORAGE:
            result = storageClasses[modelName];
            break;
        default:
            throw new Error("Invalid namespace: " + namespaceName);
    }
    if (isValidModelConstructor(result)) return result;
    else {
        var msg = "Model name is not valid for namespace. modelName: " + modelName + ", namespace: " + namespaceName;
        logger.error(msg);
        throw new Error(msg);
    }
}
/**
 * Queries the DataStore metadata tables to see if they are the expected
 * version. If not, clobbers the whole DB. If so, leaves them alone.
 * Otherwise, simply writes the schema version.
 *
 * SIDE EFFECT:
 * 1. Creates a transaction
 * 1. Updates data.
 *
 * @param storage Storage adapter containing the metadata.
 * @param version The expected schema version.
 */ function checkSchemaVersion(storage, version) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var Setting, modelDefinition;
        var _this = this;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    Setting = dataStoreClasses.Setting;
                    modelDefinition = schema.namespaces[0, _util.DATASTORE].models.Setting;
                    return [
                        4 /*yield*/ ,
                        storage.runExclusive(function(s) {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var _a, schemaVersionSetting, storedValue;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                s.query(Setting, (0, _predicates.ModelPredicateCreator).createFromAST(modelDefinition, {
                                                    and: {
                                                        key: {
                                                            eq: SETTING_SCHEMA_VERSION
                                                        }
                                                    }
                                                }), {
                                                    page: 0,
                                                    limit: 1
                                                })
                                            ];
                                        case 1:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _b.sent(),
                                                1
                                            ]), schemaVersionSetting = _a[0];
                                            if (!(schemaVersionSetting !== undefined && schemaVersionSetting.value !== undefined)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            storedValue = JSON.parse(schemaVersionSetting.value);
                                            if (!(storedValue !== version)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                s.clear(false)
                                            ];
                                        case 2:
                                            _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 4:
                                            return [
                                                4 /*yield*/ ,
                                                s.save(modelInstanceCreator(Setting, {
                                                    key: SETTING_SCHEMA_VERSION,
                                                    value: JSON.stringify(version)
                                                }))
                                            ];
                                        case 5:
                                            _b.sent();
                                            _b.label = 6;
                                        case 6:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var syncSubscription;
function getNamespace() {
    var namespace = {
        name: (0, _util.DATASTORE),
        relationships: {},
        enums: {},
        nonModels: {},
        models: {
            Setting: {
                name: "Setting",
                pluralName: "Settings",
                syncable: false,
                fields: {
                    id: {
                        name: "id",
                        type: "ID",
                        isRequired: true,
                        isArray: false
                    },
                    key: {
                        name: "key",
                        type: "String",
                        isRequired: true,
                        isArray: false
                    },
                    value: {
                        name: "value",
                        type: "String",
                        isRequired: true,
                        isArray: false
                    }
                }
            }
        }
    };
    return namespace;
}
var DataStoreState;
(function(DataStoreState) {
    DataStoreState["NotRunning"] = "Not Running";
    DataStoreState["Starting"] = "Starting";
    DataStoreState["Running"] = "Running";
    DataStoreState["Stopping"] = "Stopping";
    DataStoreState["Clearing"] = "Clearing";
})(DataStoreState || (DataStoreState = {}));
// TODO: How can we get rid of the non-null assertions?
// https://github.com/aws-amplify/amplify-js/pull/10477/files#r1007363485
var DataStore = /** @class */ function() {
    function DataStore() {
        var _this = this;
        // reference to configured category instances. Used for preserving SSR context
        this.Auth = (0, _auth.Auth);
        this.InternalAPI = (0, _internals.InternalAPI);
        this.Cache = (0, _cache.Cache);
        // Non-null assertions (bang operator) have been added to most of these properties
        // to make TS happy. These properties are all expected to be set immediately after
        // construction.
        // TODO: Refactor to use proper DI if possible. If not possible, change these to
        // optionals and implement conditional checks throughout. Rinse/repeat on all
        // sync engine processors, storage engine, adapters, etc..
        this.amplifyConfig = {};
        this.syncPredicates = new WeakMap();
        // object that gets passed to descendent classes. Allows us to pass these down by reference
        this.amplifyContext = {
            Auth: this.Auth,
            InternalAPI: this.InternalAPI,
            Cache: this.Cache
        };
        /**
         * **IMPORTANT!**
         *
         * Accumulator for background things that can **and MUST** be called when
         * DataStore stops.
         *
         * These jobs **MUST** be *idempotent promises* that resolve ONLY
         * once the intended jobs are completely finished and/or otherwise destroyed
         * and cleaned up with ZERO outstanding:
         *
         * 1. side effects (e.g., state changes)
         * 1. callbacks
         * 1. subscriptions
         * 1. calls to storage
         * 1. *etc.*
         *
         * Methods that create pending promises, subscriptions, callbacks, or any
         * type of side effect **MUST** be registered with the manager. And, a new
         * manager must be created after each `exit()`.
         *
         * Failure to comply will put DataStore into a highly unpredictable state
         * when it needs to stop or clear -- which occurs when restarting with new
         * sync expressions, during testing, and potentially during app code
         * recovery handling, etc..
         *
         * It is up to the discretion of each disposer whether to wait for job
         * completion or to cancel operations and issue failures *as long as the
         * disposer returns in a reasonable amount of time.*
         *
         * (Reasonable = *seconds*, not minutes.)
         */ this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        /**
         * Indicates what state DataStore is in.
         *
         * Not [yet?] used for actual state management; but for messaging
         * when errors occur, to help troubleshoot.
         */ this.state = DataStoreState.NotRunning;
        /**
         * If not already done:
         * 1. Attaches and initializes storage.
         * 2. Loads the schema and records metadata.
         * 3. If `this.amplifyConfig.aws_appsync_graphqlEndpoint` contains a URL,
         * attaches a sync engine, starts it, and subscribes.
         */ this.start = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var aws_appsync_graphqlEndpoint, _a, fullSyncIntervalInMilliseconds;
                                var _this = this;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            this.state = DataStoreState.Starting;
                                            if (!(this.initialized === undefined)) return [
                                                3 /*break*/ ,
                                                1
                                            ];
                                            logger.debug("Starting DataStore");
                                            this.initialized = new Promise(function(res, rej) {
                                                _this.initResolve = res;
                                                _this.initReject = rej;
                                            });
                                            return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 1:
                                            return [
                                                4 /*yield*/ ,
                                                this.initialized
                                            ];
                                        case 2:
                                            _b.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        case 3:
                                            this.storage = new (0, _storage.ExclusiveStorage)(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.init()
                                            ];
                                        case 4:
                                            _b.sent();
                                            checkSchemaInitialized();
                                            return [
                                                4 /*yield*/ ,
                                                checkSchemaVersion(this.storage, schema.version)
                                            ];
                                        case 5:
                                            _b.sent();
                                            aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                                            if (!aws_appsync_graphqlEndpoint) return [
                                                3 /*break*/ ,
                                                7
                                            ];
                                            logger.debug("GraphQL endpoint available", aws_appsync_graphqlEndpoint);
                                            _a = this;
                                            return [
                                                4 /*yield*/ ,
                                                this.processSyncExpressions()
                                            ];
                                        case 6:
                                            _a.syncPredicates = _b.sent();
                                            this.sync = new (0, _sync.SyncEngine)(schema, namespaceResolver, syncClasses, userClasses, this.storage, modelInstanceCreator, this.conflictHandler, this.errorHandler, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, this.amplifyContext, this.connectivityMonitor);
                                            fullSyncIntervalInMilliseconds = this.fullSyncInterval * 60000;
                                            syncSubscription = this.sync.start({
                                                fullSyncInterval: fullSyncIntervalInMilliseconds
                                            }).subscribe({
                                                next: function(_a) {
                                                    var type = _a.type, data = _a.data;
                                                    // In Node, we need to wait for queries to be synced to prevent returning empty arrays.
                                                    // In the Browser, we can begin returning data once subscriptions are in place.
                                                    var readyType = isNode ? (0, _sync.ControlMessage).SYNC_ENGINE_SYNC_QUERIES_READY : (0, _sync.ControlMessage).SYNC_ENGINE_STORAGE_SUBSCRIBED;
                                                    if (type === readyType) _this.initResolve();
                                                    (0, _core.Hub).dispatch("datastore", {
                                                        event: type,
                                                        data: data
                                                    });
                                                },
                                                error: function(err) {
                                                    logger.warn("Sync error", err);
                                                    _this.initReject();
                                                }
                                            });
                                            return [
                                                3 /*break*/ ,
                                                8
                                            ];
                                        case 7:
                                            logger.warn("Data won't be synchronized. No GraphQL endpoint configured. Did you forget `Amplify.configure(awsconfig)`?", {
                                                config: this.amplifyConfig
                                            });
                                            this.initResolve();
                                            _b.label = 8;
                                        case 8:
                                            return [
                                                4 /*yield*/ ,
                                                this.initialized
                                            ];
                                        case 9:
                                            _b.sent();
                                            this.state = DataStoreState.Running;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }, "datastore start").catch(this.handleAddProcError("DataStore.start()"))
                    ];
                });
            });
        };
        this.query = function(modelConstructor, identifierOrCriteria, paginationProducer) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var result, msg, modelDefinition, pagination, keyFields, msg, predicate, predicate, seedPredicate, predicate, returnOne;
                                var _a;
                                var _b;
                                return (0, _tslib.__generator)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _c.sent();
                                            if (!this.storage) throw new Error("No storage to query");
                                            //#region Input validation
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = "Constructor is not for a valid model";
                                                logger.error(msg, {
                                                    modelConstructor: modelConstructor
                                                });
                                                throw new Error(msg);
                                            }
                                            if (typeof identifierOrCriteria === "string") {
                                                if (paginationProducer !== undefined) logger.warn("Pagination is ignored when querying by id");
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Invalid model definition provided!");
                                            pagination = this.processPagination(modelDefinition, paginationProducer);
                                            keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                            if (!isQueryOne(identifierOrCriteria)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            if (keyFields.length > 1) {
                                                msg = (0, _util.errorMessages).queryByPkWithCompositeKeyPresent;
                                                logger.error(msg, {
                                                    keyFields: keyFields
                                                });
                                                throw new Error(msg);
                                            }
                                            predicate = (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(modelDefinition, (_a = {}, _a[keyFields[0]] = identifierOrCriteria, _a));
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.query(modelConstructor, predicate, pagination)
                                            ];
                                        case 2:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 3:
                                            if (!(0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            predicate = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, identifierOrCriteria);
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.query(modelConstructor, predicate, pagination)
                                            ];
                                        case 4:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 5:
                                            if (!(!identifierOrCriteria || (0, _predicates.isPredicatesAll)(identifierOrCriteria))) return [
                                                3 /*break*/ ,
                                                7
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (_b = this.storage) === null || _b === void 0 ? void 0 : _b.query(modelConstructor, undefined, pagination)
                                            ];
                                        case 6:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 7:
                                            seedPredicate = (0, _next.recursivePredicateFor)({
                                                builder: modelConstructor,
                                                schema: modelDefinition,
                                                pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                            });
                                            predicate = (0, _next.internals)(identifierOrCriteria(seedPredicate));
                                            return [
                                                4 /*yield*/ ,
                                                predicate.fetch(this.storage)
                                            ];
                                        case 8:
                                            result = _c.sent();
                                            result = (0, _util.inMemoryPagination)(result, pagination);
                                            _c.label = 9;
                                        case 9:
                                            returnOne = isQueryOne(identifierOrCriteria) || (0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition);
                                            return [
                                                2 /*return*/ ,
                                                attached(returnOne ? result[0] : result, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, "datastore query").catch(this.handleAddProcError("DataStore.query()"))
                    ];
                });
            });
        };
        this.save = function(model, condition) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var updatedPatchesTuple, initPatchesTuple, patchesTuple, modelConstructor, msg, modelDefinition, modelMeta, producedCondition, _a, savedModel;
                                var _this = this;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _b.sent();
                                            if (!this.storage) throw new Error("No storage to save to");
                                            updatedPatchesTuple = modelPatchesMap.get(model);
                                            initPatchesTuple = initPatches.has(model) ? [
                                                initPatches.get(model),
                                                {}
                                            ] : undefined;
                                            patchesTuple = updatedPatchesTuple || initPatchesTuple;
                                            modelConstructor = model ? model.constructor : undefined;
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = "Object is not an instance of a valid model";
                                                logger.error(msg, {
                                                    model: model
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Model Definition could not be found for model");
                                            modelMeta = {
                                                builder: modelConstructor,
                                                schema: modelDefinition,
                                                pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                            };
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.runExclusive(function(s) {
                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                        var nonHasManyRelationships, nonHasManyRelationships_1, nonHasManyRelationships_1_1, relationship, queryObject, related, e_7_1;
                                                        var e_7, _a;
                                                        var _b;
                                                        return (0, _tslib.__generator)(this, function(_c) {
                                                            switch(_c.label){
                                                                case 0:
                                                                    nonHasManyRelationships = (0, _relationship.ModelRelationship).allFrom(modelMeta).filter(function(r) {
                                                                        return r.type === "BELONGS_TO";
                                                                    });
                                                                    _c.label = 1;
                                                                case 1:
                                                                    _c.trys.push([
                                                                        1,
                                                                        6,
                                                                        7,
                                                                        8
                                                                    ]);
                                                                    nonHasManyRelationships_1 = (0, _tslib.__values)(nonHasManyRelationships), nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                                                    _c.label = 2;
                                                                case 2:
                                                                    if (!!nonHasManyRelationships_1_1.done) return [
                                                                        3 /*break*/ ,
                                                                        5
                                                                    ];
                                                                    relationship = nonHasManyRelationships_1_1.value;
                                                                    queryObject = relationship.createRemoteQueryObject(model);
                                                                    if (!(queryObject !== null)) return [
                                                                        3 /*break*/ ,
                                                                        4
                                                                    ];
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        s.query(relationship.remoteModelConstructor, (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(relationship.remoteDefinition, queryObject))
                                                                    ];
                                                                case 3:
                                                                    related = _c.sent();
                                                                    if (related.length === 0) throw new Error([
                                                                        "Data integrity error. You tried to save a " + modelDefinition.name + " (" + JSON.stringify(model) + ")",
                                                                        'but the instance assigned to the "' + relationship.field + '" property',
                                                                        "does not exist in the local database. If you're trying to create the related",
                                                                        '"' + ((_b = relationship.remoteDefinition) === null || _b === void 0 ? void 0 : _b.name) + '", you must save it independently first.'
                                                                    ].join(" "));
                                                                    _c.label = 4;
                                                                case 4:
                                                                    nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        2
                                                                    ];
                                                                case 5:
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        8
                                                                    ];
                                                                case 6:
                                                                    e_7_1 = _c.sent();
                                                                    e_7 = {
                                                                        error: e_7_1
                                                                    };
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        8
                                                                    ];
                                                                case 7:
                                                                    try {
                                                                        if (nonHasManyRelationships_1_1 && !nonHasManyRelationships_1_1.done && (_a = nonHasManyRelationships_1.return)) _a.call(nonHasManyRelationships_1);
                                                                    } finally{
                                                                        if (e_7) throw e_7.error;
                                                                    }
                                                                    return [
                                                                        7 /*endfinally*/ 
                                                                    ];
                                                                case 8:
                                                                    return [
                                                                        2 /*return*/ 
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            _b.sent();
                                            producedCondition = condition ? (0, _next.internals)(condition((0, _next.predicateFor)(modelMeta))).toStoragePredicate() : undefined;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.runExclusive(function(s) {
                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                        var saved;
                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        s.save(model, producedCondition, undefined, patchesTuple)
                                                                    ];
                                                                case 1:
                                                                    saved = _a.sent();
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        s.query(modelConstructor, (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, model))
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                })
                                            ];
                                        case 3:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _b.sent(),
                                                1
                                            ]), savedModel = _a[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(savedModel, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, "datastore save").catch(this.handleAddProcError("DataStore.save()"))
                    ];
                });
            });
        };
        this.setConflictHandler = function(config) {
            var configDataStore = config.DataStore;
            var conflictHandlerIsDefault = function() {
                return _this.conflictHandler === defaultConflictHandler;
            };
            if (configDataStore && configDataStore.conflictHandler) return configDataStore.conflictHandler;
            if (conflictHandlerIsDefault() && config.conflictHandler) return config.conflictHandler;
            return _this.conflictHandler || defaultConflictHandler;
        };
        this.setErrorHandler = function(config) {
            var configDataStore = config.DataStore;
            var errorHandlerIsDefault = function() {
                return _this.errorHandler === defaultErrorHandler;
            };
            if (configDataStore && configDataStore.errorHandler) return configDataStore.errorHandler;
            if (errorHandlerIsDefault() && config.errorHandler) return config.errorHandler;
            return _this.errorHandler || defaultErrorHandler;
        };
        this.delete = function(modelOrConstructor, identifierOrCriteria) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var condition, msg, modelConstructor, msg, modelDefinition, keyFields, msg, msg, _a, deleted, model, modelConstructor, msg, modelDefinition, pkPredicate, msg, _b, _c, deleted;
                                var _d;
                                return (0, _tslib.__generator)(this, function(_e) {
                                    switch(_e.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _e.sent();
                                            if (!this.storage) throw new Error("No storage to delete from");
                                            if (!modelOrConstructor) {
                                                msg = "Model or Model Constructor required";
                                                logger.error(msg, {
                                                    modelOrConstructor: modelOrConstructor
                                                });
                                                throw new Error(msg);
                                            }
                                            if (!isValidModelConstructor(modelOrConstructor)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            modelConstructor = modelOrConstructor;
                                            if (!identifierOrCriteria) {
                                                msg = "Id to delete or criteria required. Do you want to delete all? Pass Predicates.ALL";
                                                logger.error(msg, {
                                                    identifierOrCriteria: identifierOrCriteria
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Could not find model definition for modelConstructor.");
                                            if (typeof identifierOrCriteria === "string") {
                                                keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                                if (keyFields.length > 1) {
                                                    msg = (0, _util.errorMessages).deleteByPkWithCompositeKeyPresent;
                                                    logger.error(msg, {
                                                        keyFields: keyFields
                                                    });
                                                    throw new Error(msg);
                                                }
                                                condition = (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(modelDefinition, (_d = {}, _d[keyFields[0]] = identifierOrCriteria, _d));
                                            } else {
                                                if ((0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition)) condition = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, identifierOrCriteria);
                                                else condition = (0, _next.internals)(identifierOrCriteria((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                                if (!condition || !(0, _predicates.ModelPredicateCreator).isValidPredicate(condition)) {
                                                    msg = "Criteria required. Do you want to delete all? Pass Predicates.ALL";
                                                    logger.error(msg, {
                                                        condition: condition
                                                    });
                                                    throw new Error(msg);
                                                }
                                            }
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.delete(modelConstructor, condition)
                                            ];
                                        case 2:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _e.sent(),
                                                1
                                            ]), deleted = _a[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(deleted, ModelAttachment.DataStore)
                                            ];
                                        case 3:
                                            model = modelOrConstructor;
                                            modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = "Object is not an instance of a valid model";
                                                logger.error(msg, {
                                                    model: model
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Could not find model definition for modelConstructor.");
                                            pkPredicate = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, model);
                                            if (identifierOrCriteria) {
                                                if (typeof identifierOrCriteria !== "function") {
                                                    msg = "Invalid criteria";
                                                    logger.error(msg, {
                                                        identifierOrCriteria: identifierOrCriteria
                                                    });
                                                    throw new Error(msg);
                                                }
                                                condition = (0, _next.internals)(identifierOrCriteria((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                            } else condition = pkPredicate;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.delete(model, condition)
                                            ];
                                        case 4:
                                            _b = (0, _tslib.__read).apply(void 0, [
                                                _e.sent(),
                                                1
                                            ]), _c = (0, _tslib.__read)(_b[0], 1), deleted = _c[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(deleted, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, "datastore delete").catch(this.handleAddProcError("DataStore.delete()"))
                    ];
                });
            });
        };
        this.observe = function(modelOrConstructor, identifierOrCriteria) {
            var executivePredicate;
            var modelConstructor = modelOrConstructor && isValidModelConstructor(modelOrConstructor) ? modelOrConstructor : undefined;
            if (modelOrConstructor && modelConstructor === undefined) {
                var model = modelOrConstructor;
                var modelConstructor_1 = model && Object.getPrototypeOf(model).constructor;
                if (isValidModelConstructor(modelConstructor_1)) {
                    if (identifierOrCriteria) logger.warn("idOrCriteria is ignored when using a model instance", {
                        model: model,
                        identifierOrCriteria: identifierOrCriteria
                    });
                    return _this.observe(modelConstructor_1, model.id);
                } else {
                    var msg = "The model is not an instance of a PersistentModelConstructor";
                    logger.error(msg, {
                        model: model
                    });
                    throw new Error(msg);
                }
            }
            // observe should not accept object literal syntax
            if (identifierOrCriteria && modelConstructor && (0, _types.isIdentifierObject)(identifierOrCriteria, getModelDefinition(modelConstructor))) {
                var msg = (0, _util.errorMessages).observeWithObjectLiteral;
                logger.error(msg, {
                    objectLiteral: identifierOrCriteria
                });
                throw new Error(msg);
            }
            if (identifierOrCriteria !== undefined && modelConstructor === undefined) {
                var msg = "Cannot provide criteria without a modelConstructor";
                logger.error(msg, identifierOrCriteria);
                throw new Error(msg);
            }
            if (modelConstructor && !isValidModelConstructor(modelConstructor)) {
                var msg = "Constructor is not for a valid model";
                logger.error(msg, {
                    modelConstructor: modelConstructor
                });
                throw new Error(msg);
            }
            if (modelConstructor && typeof identifierOrCriteria === "string") {
                var buildIdPredicate = function(seed) {
                    return seed.id.eq(identifierOrCriteria);
                };
                executivePredicate = (0, _next.internals)(buildIdPredicate(buildSeedPredicate(modelConstructor)));
            } else if (modelConstructor && typeof identifierOrCriteria === "function") executivePredicate = (0, _next.internals)(identifierOrCriteria(buildSeedPredicate(modelConstructor)));
            return new (0, _zenObservableTsDefault.default)(function(observer) {
                var source;
                _this.runningProcesses.add(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        this.start()
                                    ];
                                case 1:
                                    _a.sent();
                                    // Filter the events returned by Storage according to namespace,
                                    // append original element data, and subscribe to the observable
                                    source = this.storage.observe(modelConstructor).filter(function(_a) {
                                        var model = _a.model;
                                        return namespaceResolver(model) === (0, _util.USER);
                                    }).subscribe({
                                        next: function(item) {
                                            return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                    var message, modelDefinition, keyFields, primaryKeysAndValues, freshElement, _a;
                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                message = item;
                                                                if (!(item.opType !== "DELETE")) return [
                                                                    3 /*break*/ ,
                                                                    2
                                                                ];
                                                                modelDefinition = getModelDefinition(item.model);
                                                                keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                                                primaryKeysAndValues = (0, _util.extractPrimaryKeysAndValues)(item.element, keyFields);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.query(item.model, primaryKeysAndValues)
                                                                ];
                                                            case 1:
                                                                freshElement = _b.sent();
                                                                message = (0, _tslib.__assign)((0, _tslib.__assign)({}, message), {
                                                                    element: freshElement
                                                                });
                                                                _b.label = 2;
                                                            case 2:
                                                                _a = !executivePredicate;
                                                                if (_a) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    executivePredicate.matches(message.element)
                                                                ];
                                                            case 3:
                                                                _a = _b.sent();
                                                                _b.label = 4;
                                                            case 4:
                                                                if (_a) observer.next(message);
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            }, "datastore observe message handler");
                                        },
                                        error: function(err) {
                                            return observer.error(err);
                                        },
                                        complete: function() {
                                            return observer.complete();
                                        }
                                    });
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "datastore observe observable initialization").catch(_this.handleAddProcError("DataStore.observe()")).catch(function(error) {
                    observer.error(error);
                });
                // better than no cleaner, but if the subscriber is handling the
                // complete() message async and not registering with the context,
                // this will still be problematic.
                return _this.runningProcesses.addCleaner(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (source) source.unsubscribe();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }, "DataStore.observe() cleanup");
            });
        };
        this.observeQuery = function(model, criteria, options) {
            return new (0, _zenObservableTsDefault.default)(function(observer) {
                var items = new Map();
                var itemsChanged = new Map();
                var deletedItemIds = [];
                var handle;
                // let predicate: ModelPredicate<T> | undefined;
                var executivePredicate;
                /**
                 * As the name suggests, this geneates a snapshot in the form of
                 * 	`{items: T[], isSynced: boolean}`
                 * and sends it to the observer.
                 *
                 * SIDE EFFECT: The underlying generation and emission methods may touch:
                 * `items`, `itemsChanged`, and `deletedItemIds`.
                 *
                 * Refer to `generateSnapshot` and `emitSnapshot` for more details.
                 */ var generateAndEmitSnapshot = function() {
                    var snapshot = generateSnapshot();
                    emitSnapshot(snapshot);
                };
                // a mechanism to return data after X amount of seconds OR after the
                // "limit" (itemsChanged >= this.syncPageSize) has been reached, whichever comes first
                var limitTimerRace = new (0, _util.DeferredCallbackResolver)({
                    callback: generateAndEmitSnapshot,
                    errorHandler: observer.error,
                    maxInterval: 2000
                });
                var sort = (options || {}).sort;
                var sortOptions = sort ? {
                    sort: sort
                } : undefined;
                var modelDefinition = getModelDefinition(model);
                if (!modelDefinition) throw new Error("Could not find model definition.");
                if (model && typeof criteria === "function") executivePredicate = (0, _next.internals)(criteria(buildSeedPredicate(model)));
                else if ((0, _predicates.isPredicatesAll)(criteria)) executivePredicate = undefined;
                _this.runningProcesses.add(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var err_1;
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.query(model, criteria, sortOptions)
                                    ];
                                case 1:
                                    // first, query and return any locally-available records
                                    _a.sent().forEach(function(item) {
                                        var itemModelDefinition = getModelDefinition(model);
                                        var idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, item);
                                        items.set(idOrPk, item);
                                    });
                                    // Observe the model and send a stream of updates (debounced).
                                    // We need to post-filter results instead of passing criteria through
                                    // to have visibility into items that move from in-set to out-of-set.
                                    // We need to explicitly remove those items from the existing snapshot.
                                    handle = this.observe(model).subscribe(function(_a) {
                                        var element = _a.element, model = _a.model, opType = _a.opType;
                                        return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                var itemModelDefinition, idOrPk, _a, isSynced, limit;
                                                var _b, _c;
                                                return (0, _tslib.__generator)(this, function(_d) {
                                                    switch(_d.label){
                                                        case 0:
                                                            itemModelDefinition = getModelDefinition(model);
                                                            idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, element);
                                                            _a = executivePredicate;
                                                            if (!_a) return [
                                                                3 /*break*/ ,
                                                                2
                                                            ];
                                                            return [
                                                                4 /*yield*/ ,
                                                                executivePredicate.matches(element)
                                                            ];
                                                        case 1:
                                                            _a = !_d.sent();
                                                            _d.label = 2;
                                                        case 2:
                                                            if (_a) {
                                                                if (opType === "UPDATE" && (items.has(idOrPk) || itemsChanged.has(idOrPk))) // tracking as a "deleted item" will include the item in
                                                                // page limit calculations and ensure it is removed from the
                                                                // final items collection, regardless of which collection(s)
                                                                // it is currently in. (I mean, it could be in both, right!?)
                                                                deletedItemIds.push(idOrPk);
                                                                else // ignore updates for irrelevant/filtered items.
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            }
                                                            // Flag items which have been recently deleted
                                                            // NOTE: Merging of separate operations to the same model instance is handled upstream
                                                            // in the `mergePage` method within src/sync/merger.ts. The final state of a model instance
                                                            // depends on the LATEST record (for a given id).
                                                            if (opType === "DELETE") deletedItemIds.push(idOrPk);
                                                            else itemsChanged.set(idOrPk, element);
                                                            isSynced = (_c = (_b = this.sync) === null || _b === void 0 ? void 0 : _b.getModelSyncedStatus(model)) !== null && _c !== void 0 ? _c : false;
                                                            limit = itemsChanged.size - deletedItemIds.length >= this.syncPageSize;
                                                            if (limit || isSynced) limitTimerRace.resolve();
                                                            // kicks off every subsequent race as results sync down
                                                            limitTimerRace.start();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        }, "handle observeQuery observed event");
                                    });
                                    // returns a set of initial/locally-available results
                                    generateAndEmitSnapshot();
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 2:
                                    err_1 = _a.sent();
                                    observer.error(err_1);
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "datastore observequery startup").catch(_this.handleAddProcError("DataStore.observeQuery()")).catch(function(error) {
                    observer.error(error);
                });
                /**
                 * Combines the `items`, `itemsChanged`, and `deletedItemIds` collections into
                 * a snapshot in the form of `{ items: T[], isSynced: boolean}`.
                 *
                 * SIDE EFFECT: The shared `items` collection is recreated.
                 */ var generateSnapshot = function() {
                    var _a, _b;
                    var isSynced = (_b = (_a = _this.sync) === null || _a === void 0 ? void 0 : _a.getModelSyncedStatus(model)) !== null && _b !== void 0 ? _b : false;
                    var itemsArray = (0, _tslib.__spread)(Array.from(items.values()), Array.from(itemsChanged.values()));
                    items.clear();
                    itemsArray.forEach(function(item) {
                        var itemModelDefinition = getModelDefinition(model);
                        var idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, item);
                        items.set(idOrPk, item);
                    });
                    // remove deleted items from the final result set
                    deletedItemIds.forEach(function(idOrPk) {
                        return items.delete(idOrPk);
                    });
                    var snapshot = Array.from(items.values());
                    // we sort after we merge the snapshots (items, itemsChanged)
                    // otherwise, the merge may not
                    if (options === null || options === void 0 ? void 0 : options.sort) sortItems(snapshot);
                    return {
                        items: snapshot,
                        isSynced: isSynced
                    };
                };
                /**
                 * Emits the list of items to the observer.
                 *
                 * SIDE EFFECT: `itemsChanged` and `deletedItemIds` are cleared to prepare
                 * for the next snapshot.
                 *
                 * @param snapshot The generated items data to emit.
                 */ var emitSnapshot = function(snapshot) {
                    // send the generated snapshot to the primary subscription.
                    // NOTE: This observer's handler *could* be async ...
                    observer.next(snapshot);
                    // reset the changed items sets
                    itemsChanged.clear();
                    deletedItemIds = [];
                };
                /**
                 * Sorts an `Array` of `T` according to the sort instructions given in the
                 * original  `observeQuery()` call.
                 *
                 * @param itemsToSort A array of model type.
                 */ var sortItems = function(itemsToSort) {
                    var modelDefinition = getModelDefinition(model);
                    var pagination = _this.processPagination(modelDefinition, options);
                    var sortPredicates = (0, _predicates.ModelSortPredicateCreator).getPredicates(pagination.sort);
                    if (sortPredicates.length) {
                        var compareFn = (0, _util.sortCompareFunction)(sortPredicates);
                        itemsToSort.sort(compareFn);
                    }
                };
                /**
                 * Force one last snapshot when the model is fully synced.
                 *
                 * This reduces latency for that last snapshot, which will otherwise
                 * wait for the configured timeout.
                 *
                 * @param payload The payload from the Hub event.
                 */ var hubCallback = function(_a) {
                    var payload = _a.payload;
                    var _b;
                    var event = payload.event, data = payload.data;
                    if (event === (0, _sync.ControlMessage).SYNC_ENGINE_MODEL_SYNCED && ((_b = data === null || data === void 0 ? void 0 : data.model) === null || _b === void 0 ? void 0 : _b.name) === model.name) {
                        generateAndEmitSnapshot();
                        (0, _core.Hub).remove("datastore", hubCallback);
                    }
                };
                (0, _core.Hub).listen("datastore", hubCallback);
                return _this.runningProcesses.addCleaner(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (handle) handle.unsubscribe();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }, "datastore observequery cleaner");
            });
        };
        this.configure = function(config) {
            if (config === void 0) config = {};
            _this.amplifyContext.Auth = _this.Auth;
            _this.amplifyContext.InternalAPI = _this.InternalAPI;
            _this.amplifyContext.Cache = _this.Cache;
            var configDataStore = config.DataStore, configAuthModeStrategyType = config.authModeStrategyType, configConflictHandler = config.conflictHandler, configErrorHandler = config.errorHandler, configMaxRecordsToSync = config.maxRecordsToSync, configSyncPageSize = config.syncPageSize, configFullSyncInterval = config.fullSyncInterval, configSyncExpressions = config.syncExpressions, configAuthProviders = config.authProviders, configStorageAdapter = config.storageAdapter, configFromAmplify = (0, _tslib.__rest)(config, [
                "DataStore",
                "authModeStrategyType",
                "conflictHandler",
                "errorHandler",
                "maxRecordsToSync",
                "syncPageSize",
                "fullSyncInterval",
                "syncExpressions",
                "authProviders",
                "storageAdapter"
            ]);
            _this.amplifyConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, configFromAmplify), _this.amplifyConfig);
            _this.conflictHandler = _this.setConflictHandler(config);
            _this.errorHandler = _this.setErrorHandler(config);
            var authModeStrategyType = configDataStore && configDataStore.authModeStrategyType || configAuthModeStrategyType || (0, _types.AuthModeStrategyType).DEFAULT;
            switch(authModeStrategyType){
                case (0, _types.AuthModeStrategyType).MULTI_AUTH:
                    _this.authModeStrategy = (0, _authModeStrategies.multiAuthStrategy)(_this.amplifyContext);
                    break;
                case (0, _types.AuthModeStrategyType).DEFAULT:
                    _this.authModeStrategy = (0, _authModeStrategies.defaultAuthStrategy);
                    break;
                default:
                    _this.authModeStrategy = (0, _authModeStrategies.defaultAuthStrategy);
                    break;
            }
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.authProviders = configDataStore && configDataStore.authProviders || configAuthProviders;
            _this.syncExpressions = configDataStore && configDataStore.syncExpressions || configSyncExpressions || _this.syncExpressions;
            _this.maxRecordsToSync = configDataStore && configDataStore.maxRecordsToSync || configMaxRecordsToSync || _this.maxRecordsToSync || 10000;
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.maxRecordsToSync = _this.maxRecordsToSync;
            _this.syncPageSize = configDataStore && configDataStore.syncPageSize || configSyncPageSize || _this.syncPageSize || 1000;
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.syncPageSize = _this.syncPageSize;
            _this.fullSyncInterval = configDataStore && configDataStore.fullSyncInterval || configFullSyncInterval || _this.fullSyncInterval || 1440; // 1 day
            _this.storageAdapter = configDataStore && configDataStore.storageAdapter || configStorageAdapter || _this.storageAdapter || undefined;
            _this.sessionId = _this.retrieveSessionId();
        };
    }
    DataStore.prototype.getModuleName = function() {
        return "DataStore";
    };
    /**
     * Builds a function to capture `BackgroundManagerNotOpenError`'s to produce friendlier,
     * more instructive errors for customers.
     *
     * @param operation The name of the operation (usually a Datastore method) the customer
     * tried to call.
     */ DataStore.prototype.handleAddProcError = function(operation) {
        var _this = this;
        /**
         * If the tested error is a `BackgroundManagerNotOpenError`, it will be captured
         * and replaced with a friendlier message that instructs the App Developer.
         *
         * @param err An error to test.
         */ var handler = function(err) {
            if (err.message.startsWith("BackgroundManagerNotOpenError")) throw new Error([
                "DataStoreStateError: Tried to execute `" + operation + '` while DataStore was "' + _this.state + '".',
                'This can only be done while DataStore is "Started" or "Stopped". To remedy:',
                "Ensure all calls to `stop()` and `clear()` have completed first.",
                "If this is not possible, retry the operation until it succeeds."
            ].join("\n"));
            else throw err;
        };
        return handler;
    };
    /**
     * Clears all data from storage and removes all data, schema info, other
     * initialization details, and then stops DataStore.
     *
     * That said, reinitialization is required after clearing. This can be done
     * by explicitiliy calling `start()` or any method that implicitly starts
     * DataStore, such as `query()`, `save()`, or `delete()`.
     */ DataStore.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        checkSchemaInitialized();
                        this.state = DataStoreState.Clearing;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        if (!(this.storage === undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // connect to storage so that it can be cleared without fully starting DataStore
                        this.storage = new (0, _storage.ExclusiveStorage)(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                        return [
                            4 /*yield*/ ,
                            this.storage.init()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (syncSubscription && !syncSubscription.closed) syncSubscription.unsubscribe();
                        if (!this.sync) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sync.stop()
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.storage.clear()
                        ];
                    case 6:
                        _a.sent();
                        this.initialized = undefined; // Should re-initialize when start() is called.
                        this.storage = undefined;
                        this.sync = undefined;
                        this.syncPredicates = new WeakMap();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 7:
                        _a.sent();
                        this.state = DataStoreState.NotRunning;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Stops all DataStore sync activities.
     *
     * TODO: "Waits for graceful termination of
     * running queries and terminates subscriptions."
     */ DataStore.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.state = DataStoreState.Stopping;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        if (syncSubscription && !syncSubscription.closed) syncSubscription.unsubscribe();
                        if (!this.sync) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sync.stop()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.initialized = undefined; // Should re-initialize when start() is called.
                        this.sync = undefined;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 4:
                        _a.sent();
                        this.state = DataStoreState.NotRunning;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Validates given pagination input from a query and creates a pagination
     * argument for use against the storage layer.
     *
     * @param modelDefinition
     * @param paginationProducer
     */ DataStore.prototype.processPagination = function(modelDefinition, paginationProducer) {
        var sortPredicate;
        var _a = paginationProducer || {}, limit = _a.limit, page = _a.page, sort = _a.sort;
        if (limit === undefined && page === undefined && sort === undefined) return undefined;
        if (page !== undefined && limit === undefined) throw new Error("Limit is required when requesting a page");
        if (page !== undefined) {
            if (typeof page !== "number") throw new Error("Page should be a number");
            if (page < 0) throw new Error("Page can't be negative");
        }
        if (limit !== undefined) {
            if (typeof limit !== "number") throw new Error("Limit should be a number");
            if (limit < 0) throw new Error("Limit can't be negative");
        }
        if (sort) sortPredicate = (0, _predicates.ModelSortPredicateCreator).createFromExisting(modelDefinition, sort);
        return {
            limit: limit,
            page: page,
            sort: sortPredicate
        };
    };
    /**
     * Examines the configured `syncExpressions` and produces a WeakMap of
     * SchemaModel -> predicate to use during sync.
     */ DataStore.prototype.processSyncExpressions = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var syncPredicates;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.syncExpressions || !this.syncExpressions.length) return [
                            2 /*return*/ ,
                            new WeakMap()
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(this.syncExpressions.map(function(syncExpression) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var _a, modelConstructor, conditionProducer, modelDefinition, condition, predicate;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    syncExpression
                                                ];
                                            case 1:
                                                _a = _b.sent(), modelConstructor = _a.modelConstructor, conditionProducer = _a.conditionProducer;
                                                modelDefinition = getModelDefinition(modelConstructor);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.unwrapPromise(conditionProducer)
                                                ];
                                            case 2:
                                                condition = _b.sent();
                                                if ((0, _predicates.isPredicatesAll)(condition)) return [
                                                    2 /*return*/ ,
                                                    [
                                                        modelDefinition,
                                                        null
                                                    ]
                                                ];
                                                predicate = (0, _next.internals)(condition((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        modelDefinition,
                                                        predicate
                                                    ]
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        syncPredicates = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.weakMapFromEntries(syncPredicates)
                        ];
                }
            });
        });
    };
    DataStore.prototype.unwrapPromise = function(conditionProducer) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var condition, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            conditionProducer()
                        ];
                    case 1:
                        condition = _a.sent();
                        return [
                            2 /*return*/ ,
                            condition || conditionProducer
                        ];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1 instanceof TypeError) return [
                            2 /*return*/ ,
                            conditionProducer
                        ];
                        throw error_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DataStore.prototype.weakMapFromEntries = function(entries) {
        return entries.reduce(function(map, _a) {
            var _b = (0, _tslib.__read)(_a, 2), modelDefinition = _b[0], predicate = _b[1];
            if (map.has(modelDefinition)) {
                var name_2 = modelDefinition.name;
                logger.warn("You can only utilize one Sync Expression per model.\n          Subsequent sync expressions for the " + name_2 + " model will be ignored.");
                return map;
            }
            if (predicate) map.set(modelDefinition, predicate);
            return map;
        }, new WeakMap());
    };
    /**
     * A session ID to allow CMS to open databases against multiple apps.
     * This session ID is only expected be set by AWS Amplify Studio.
     */ DataStore.prototype.retrieveSessionId = function() {
        try {
            var sessionId = sessionStorage.getItem("datastoreSessionId");
            if (sessionId) {
                var aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                var appSyncUrl = aws_appsync_graphqlEndpoint.split("/")[2];
                var _a = (0, _tslib.__read)(appSyncUrl.split("."), 1), appSyncId = _a[0];
                return sessionId + "-" + appSyncId;
            }
        } catch (_b) {}
        return undefined;
    };
    return DataStore;
}();
var instance = new DataStore();
(0, _core.Amplify).register(instance);

},{"tslib":"9gMVn","@aws-amplify/api/internals":"lW1BO","@aws-amplify/auth":"6Q2Bh","@aws-amplify/cache":"egrWR","@aws-amplify/core":"8BDOx","immer":"hF6fx","uuid":"9dBTc","zen-observable-ts":"klrbV","../authModeStrategies":"k00Mu","../predicates":"lUiza","../storage/storage":"gwQJS","../storage/relationship":"4Ulys","../sync":"9T7Vu","../types":"KjGQP","../util":"89SDa","../predicates/next":"1pp40","../sync/utils":"60Gn0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lW1BO":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalAPI", ()=>(0, _internalAPI.InternalAPI));
parcelHelpers.export(exports, "InternalAPIClass", ()=>(0, _internalAPI.InternalAPIClass));
var _internalAPI = require("./InternalAPI");

},{"./InternalAPI":"6O7b1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hF6fx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>un);
parcelHelpers.export(exports, "applyPatches", ()=>pn);
parcelHelpers.export(exports, "castDraft", ()=>K);
parcelHelpers.export(exports, "castImmutable", ()=>$);
parcelHelpers.export(exports, "createDraft", ()=>ln);
parcelHelpers.export(exports, "current", ()=>D);
parcelHelpers.export(exports, "enableAllPlugins", ()=>J);
parcelHelpers.export(exports, "enableES5", ()=>N);
parcelHelpers.export(exports, "enableMapSet", ()=>C);
parcelHelpers.export(exports, "enablePatches", ()=>T);
parcelHelpers.export(exports, "finishDraft", ()=>dn);
parcelHelpers.export(exports, "freeze", ()=>d);
parcelHelpers.export(exports, "immerable", ()=>L);
parcelHelpers.export(exports, "isDraft", ()=>t);
parcelHelpers.export(exports, "isDraftable", ()=>r);
parcelHelpers.export(exports, "nothing", ()=>H);
parcelHelpers.export(exports, "original", ()=>e);
parcelHelpers.export(exports, "produce", ()=>fn);
parcelHelpers.export(exports, "produceWithPatches", ()=>cn);
parcelHelpers.export(exports, "setAutoFreeze", ()=>sn);
parcelHelpers.export(exports, "setUseProxies", ()=>vn);
function n(n) {
    for(var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)r[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (r.length ? " " + r.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function t(n) {
    return !!n && !!n[Q];
}
function r(n) {
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var t = Object.getPrototypeOf(n);
        if (null === t) return !0;
        var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
        return r === Object || "function" == typeof r && Function.toString.call(r) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!n.constructor[L] || s(n) || v(n));
}
function e(r) {
    return t(r) || n(23, r), r[Q].t;
}
function i(n, t, r) {
    void 0 === r && (r = !1), 0 === o(n) ? (r ? Object.keys : nn)(n).forEach(function(e) {
        r && "symbol" == typeof e || t(e, n[e], n);
    }) : n.forEach(function(r, e) {
        return t(e, r, n);
    });
}
function o(n) {
    var t = n[Q];
    return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, t) {
    return 2 === o(n) ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function a(n, t) {
    return 2 === o(n) ? n.get(t) : n[t];
}
function f(n, t, r) {
    var e = o(n);
    2 === e ? n.set(t, r) : 3 === e ? (n.delete(t), n.add(r)) : n[t] = r;
}
function c(n, t) {
    return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var t = tn(n);
    delete t[Q];
    for(var r = nn(t), e = 0; e < r.length; e++){
        var i = r[e], o = t[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), t);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || t(n) || !r(n) ? n : (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, t) {
        return d(t, !0);
    }, !0), n);
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(t) {
    var r = rn[t];
    return r || n(18, t), r;
}
function m(n, t) {
    rn[n] || (rn[n] = t);
}
function _() {
    return U;
}
function j(n, t) {
    t && (b("Patches"), n.u = [], n.s = [], n.v = t);
}
function O(n) {
    g(n), n.p.forEach(S), n.p = null;
}
function g(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var t = n[Q];
    0 === t.i || 1 === t.i ? t.j() : t.O = !0;
}
function P(t, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== t && t !== i;
    return e.h.g || b("ES5").S(e, t, o), o ? (i[Q].P && (O(e), n(4)), r(t) && (t = M(e, t), e.l || x(e, t)), e.u && b("Patches").M(i[Q], t, e.u, e.s)) : t = M(e, i, []), O(e), e.u && e.v(e.u, e.s), t !== H ? t : void 0;
}
function M(n, t, r) {
    if (y(t)) return t;
    var e = t[Q];
    if (!e) return i(t, function(i, o) {
        return A(n, e, t, i, o, r);
    }, !0), t;
    if (e.A !== n) return t;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
        i(3 === e.i ? new Set(o) : o, function(t, i) {
            return A(n, e, o, t, i, r);
        }), x(n, o, !1), r && n.u && b("Patches").R(e, r, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s) {
    if (t(c)) {
        var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
        if (f(o, a, v), !t(v)) return;
        e.m = !1;
    }
    if (r(c) && !y(c)) {
        if (!e.h.F && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, t, r) {
    void 0 === r && (r = !1), n.h.F && n.m && d(t, r);
}
function z(n, t) {
    var r = n[Q];
    return (r ? p(r) : n)[t];
}
function I(n, t) {
    if (t in n) for(var r = Object.getPrototypeOf(n); r;){
        var e = Object.getOwnPropertyDescriptor(r, t);
        if (e) return e;
        r = Object.getPrototypeOf(r);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function R(n, t, r) {
    var e = s(t) ? b("MapSet").N(t, r) : v(t) ? b("MapSet").T(t, r) : n.g ? function(n, t) {
        var r = Array.isArray(n), e = {
            i: r ? 1 : 0,
            A: t ? t.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: t,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        r && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(t, r) : b("ES5").J(t, r);
    return (r ? r.A : _()).p.push(e), e;
}
function D(e) {
    return t(e) || n(22, e), function n(t) {
        if (!r(t)) return t;
        var e, u = t[Q], c = o(t);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = F(t, c), u.I = !1;
        } else e = F(t, c);
        return i(e, function(t, r) {
            u && a(u.t, t) === r || f(e, t, n(r));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function F(n, t) {
    switch(t){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function N() {
    function r(n, t) {
        var r = s[n];
        return r ? r.enumerable = t : s[n] = r = {
            configurable: !0,
            enumerable: t,
            get: function() {
                var t = this[Q];
                return en.get(t, n);
            },
            set: function(t) {
                var r = this[Q];
                en.set(r, n, t);
            }
        }, r;
    }
    function e(n) {
        for(var t = n.length - 1; t >= 0; t--){
            var r = n[t][Q];
            if (!r.P) switch(r.i){
                case 5:
                    a(r) && k(r);
                    break;
                case 4:
                    o(r) && k(r);
            }
        }
    }
    function o(n) {
        for(var t = n.t, r = n.k, e = nn(r), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = t[o];
                if (void 0 === a && !u(t, o)) return !0;
                var f = r[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!t[Q];
        return e.length !== nn(t).length + (v ? 0 : 1);
    }
    function a(n) {
        var t = n.k;
        if (t.length !== n.t.length) return !0;
        var r = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!r || r.get);
    }
    function f(t) {
        t.O && n(3, JSON.stringify(p(t)));
    }
    var s = {};
    m("ES5", {
        J: function(n, t) {
            var e = Array.isArray(n), i = function(n, t) {
                if (n) {
                    for(var e = Array(t.length), i = 0; i < t.length; i++)Object.defineProperty(e, "" + i, r(i, !0));
                    return e;
                }
                var o = tn(t);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = r(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(t), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: n,
                k: i,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, r, o) {
            o ? t(r) && r[Q].A === n && e(n.p) : (n.u && function n(t) {
                if (t && "object" == typeof t) {
                    var r = t[Q];
                    if (r) {
                        var e = r.t, o = r.k, f = r.D, c = r.i;
                        if (4 === c) i(o, function(t) {
                            t !== Q && (void 0 !== e[t] || u(e, t) ? f[t] || n(o[t]) : (f[t] = !0, k(r)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(r));
                        });
                        else if (5 === c) {
                            if (a(r) && (k(r), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!r(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var t = Object.create(Object.getPrototypeOf(n));
        for(var i in n)t[i] = e(n[i]);
        return u(n, L) && (t[L] = n[L]), t;
    }
    function f(n) {
        return t(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(t, r) {
            return r.forEach(function(r) {
                for(var i = r.path, u = r.op, f = t, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = "" + i[s];
                    0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(r.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(r.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), t;
        },
        R: function(n, t, r, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, t, r, e) {
                        var o = n.t, s = n.o;
                        i(n.D, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = t.concat(n);
                                r.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, t, r, e);
                case 5:
                case 1:
                    return function(n, t, r, e) {
                        var i = n.t, o = n.D, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                r
                            ];
                            r = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = t.concat([
                                v
                            ]);
                            r.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = t.concat([
                                l
                            ]);
                            r.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: t.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, t, r, e);
                case 3:
                    return function(n, t, r, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, t, r, e);
            }
        },
        M: function(n, t, r, e) {
            r.push({
                op: "replace",
                path: [],
                value: t === H ? void 0 : t
            }), e.push({
                op: "replace",
                path: [],
                value: n.t
            });
        }
    });
}
function C() {
    function t(n, t) {
        function r() {
            this.constructor = n;
        }
        a(n, t), n.prototype = (r.prototype = t.prototype, new r);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(t) {
            if (r(t)) {
                var e = R(n.A.h, t, n);
                n.p.set(t, e), n.o.add(e);
            } else n.o.add(t);
        }));
    }
    function u(t) {
        t.O && n(3, JSON.stringify(p(t)));
    }
    var a = function(n, t) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, t) {
            n.__proto__ = t;
        } || function(n, t) {
            for(var r in t)t.hasOwnProperty(r) && (n[r] = t[r]);
        })(n, t);
    }, f = function() {
        function n(n, t) {
            return this[Q] = {
                i: 2,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        t(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, t) {
            var r = this[Q];
            return u(r), p(r).has(n) && p(r).get(n) === t || (e(r), k(r), r.D.set(n, !0), r.o.set(n, t), r.D.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var t = this[Q];
            return u(t), e(t), k(t), t.D.set(n, !1), t.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.D = new Map, i(n.t, function(t) {
                n.D.set(t, !1);
            }), n.o.clear());
        }, o.forEach = function(n, t) {
            var r = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(t, r.get(i), i, r);
            });
        }, o.get = function(n) {
            var t = this[Q];
            u(t);
            var i = p(t).get(n);
            if (t.I || !r(i)) return i;
            if (i !== t.t.get(n)) return i;
            var o = R(t.A.h, i, t);
            return e(t), t.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, t = this, r = this.keys();
            return (n = {})[V] = function() {
                return t.values();
            }, n.next = function() {
                var n = r.next();
                return n.done ? n : {
                    done: !1,
                    value: t.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, t = this, r = this.keys();
            return (n = {})[V] = function() {
                return t.entries();
            }, n.next = function() {
                var n = r.next();
                if (n.done) return n;
                var e = t.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, t) {
            return this[Q] = {
                i: 3,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        t(n, Set);
        var r = n.prototype;
        return Object.defineProperty(r, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), r.has = function(n) {
            var t = this[Q];
            return u(t), t.o ? !!t.o.has(n) || !(!t.p.has(n) || !t.o.has(t.p.get(n))) : t.t.has(n);
        }, r.add = function(n) {
            var t = this[Q];
            return u(t), this.has(n) || (o(t), k(t), t.o.add(n)), this;
        }, r.delete = function(n) {
            if (!this.has(n)) return !1;
            var t = this[Q];
            return u(t), o(t), k(t), t.o.delete(n) || !!t.p.has(n) && t.o.delete(t.p.get(n));
        }, r.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, r.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, r.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, r.keys = function() {
            return this.values();
        }, r[V] = function() {
            return this.values();
        }, r.forEach = function(n, t) {
            for(var r = this.values(), e = r.next(); !e.done;)n.call(t, e.value, e.value, this), e = r.next();
        }, n;
    }();
    m("MapSet", {
        N: function(n, t) {
            return new f(n, t);
        },
        T: function(n, t) {
            return new c(n, t);
        }
    });
}
function J() {
    N(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, tn = Object.getOwnPropertyDescriptors || function(n) {
    var t = {};
    return nn(n).forEach(function(r) {
        t[r] = Object.getOwnPropertyDescriptor(n, r);
    }), t;
}, rn = {}, en = {
    get: function(n, t) {
        if (t === Q) return n;
        var e = p(n);
        if (!u(e, t)) return function(n, t, r) {
            var e, i = I(t, r);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, t);
        var i = e[t];
        return n.I || !r(i) ? i : i === z(n.t, t) ? (E(n), n.o[t] = R(n.A.h, i, n)) : i;
    },
    has: function(n, t) {
        return t in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, t, r) {
        var e = I(p(n), t);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, r), !0;
        if (!n.P) {
            var i = z(p(n), t), o = null == i ? void 0 : i[Q];
            if (o && o.t === r) return n.o[t] = r, n.D[t] = !1, !0;
            if (c(r, i) && (void 0 !== r || u(n.t, t))) return !0;
            E(n), k(n);
        }
        return n.o[t] === r && "number" != typeof r && (void 0 !== r || t in n.o) || (n.o[t] = r, n.D[t] = !0, !0);
    },
    deleteProperty: function(n, t) {
        return void 0 !== z(n.t, t) || t in n.t ? (n.D[t] = !1, E(n), k(n)) : delete n.D[t], n.o && delete n.o[t], !0;
    },
    getOwnPropertyDescriptor: function(n, t) {
        var r = p(n), e = Reflect.getOwnPropertyDescriptor(r, t);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== t,
            enumerable: e.enumerable,
            value: r[t]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, t) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], t.apply(this, arguments);
    };
}), on.deleteProperty = function(t, r) {
    return en.deleteProperty.call(this, t[0], r);
}, on.set = function(t, r, e) {
    return en.set.call(this, t[0], r, e, t[0]);
};
var un = function() {
    function e(t) {
        var e = this;
        this.g = B, this.F = !0, this.produce = function(t, i, o) {
            if ("function" == typeof t && "function" != typeof i) {
                var u = i;
                i = t;
                var a = e;
                return function(n) {
                    var t = this;
                    void 0 === n && (n = u);
                    for(var r = arguments.length, e = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var r;
                        return (r = i).call.apply(r, [
                            t,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), r(t)) {
                var c = w(e), s = R(e, t, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? O(c) : g(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw O(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!t || "object" != typeof t) {
                if ((f = i(t)) === H) return;
                return void 0 === f && (f = t), e.F && d(f, !0), f;
            }
            n(21, t);
        }, this.produceWithPatches = function(n, t) {
            var r, i;
            return "function" == typeof n ? function(t) {
                for(var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(t, function(t) {
                    return n.apply(void 0, [
                        t
                    ].concat(i));
                });
            } : [
                e.produce(n, t, function(n, t) {
                    r = n, i = t;
                }),
                r,
                i
            ];
        }, "boolean" == typeof (null == t ? void 0 : t.useProxies) && this.setUseProxies(t.useProxies), "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        r(e) || n(8), t(e) && (e = D(e));
        var i = w(this), o = R(this, e, void 0);
        return o[Q].C = !0, g(i), o;
    }, i.finishDraft = function(t, r) {
        var e = t && t[Q];
        var i = e.A;
        return j(i, r), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.F = n;
    }, i.setUseProxies = function(t) {
        t && !B && n(20), this.g = t;
    }, i.applyPatches = function(n, r) {
        var e;
        for(e = r.length - 1; e >= 0; e--){
            var i = r[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        var o = b("Patches").$;
        return t(n) ? o(n, r) : this.produce(n, function(n) {
            return o(n, r.slice(e + 1));
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
exports.default = fn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k00Mu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAuthStrategy", ()=>(0, _defaultAuthStrategy.defaultAuthStrategy));
parcelHelpers.export(exports, "multiAuthStrategy", ()=>(0, _multiAuthStrategy.multiAuthStrategy));
var _defaultAuthStrategy = require("./defaultAuthStrategy");
var _multiAuthStrategy = require("./multiAuthStrategy");

},{"./defaultAuthStrategy":"fJ5L5","./multiAuthStrategy":"1NlYo","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fJ5L5":[function(require,module,exports) {
// Default behavior is to use the primary auth mode for an API,
// so we are returning an empty array so that DataStore will default
// to using the primary auth mode.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAuthStrategy", ()=>defaultAuthStrategy);
var defaultAuthStrategy = function() {
    return [];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1NlYo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multiAuthStrategy", ()=>multiAuthStrategy);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _auth = require("@aws-amplify/auth");
var _apiGraphql = require("@aws-amplify/api-graphql");
var _types = require("../types");
function getProviderFromRule(rule) {
    // private with no provider means userPools
    if (rule.allow === "private" && !rule.provider) return (0, _types.ModelAttributeAuthProvider).USER_POOLS;
    // public with no provider means apiKey
    if (rule.allow === "public" && !rule.provider) return (0, _types.ModelAttributeAuthProvider).API_KEY;
    return rule.provider;
}
function sortAuthRulesWithPriority(rules) {
    var allowSortPriority = [
        (0, _types.ModelAttributeAuthAllow).CUSTOM,
        (0, _types.ModelAttributeAuthAllow).OWNER,
        (0, _types.ModelAttributeAuthAllow).GROUPS,
        (0, _types.ModelAttributeAuthAllow).PRIVATE,
        (0, _types.ModelAttributeAuthAllow).PUBLIC
    ];
    var providerSortPriority = [
        (0, _types.ModelAttributeAuthProvider).FUNCTION,
        (0, _types.ModelAttributeAuthProvider).USER_POOLS,
        (0, _types.ModelAttributeAuthProvider).OIDC,
        (0, _types.ModelAttributeAuthProvider).IAM,
        (0, _types.ModelAttributeAuthProvider).API_KEY
    ];
    return (0, _tslib.__spread)(rules).sort(function(a, b) {
        if (a.allow === b.allow) return providerSortPriority.indexOf(getProviderFromRule(a)) - providerSortPriority.indexOf(getProviderFromRule(b));
        return allowSortPriority.indexOf(a.allow) - allowSortPriority.indexOf(b.allow);
    });
}
function getAuthRules(_a) {
    var rules = _a.rules, currentUser = _a.currentUser;
    // Using Set to ensure uniqueness
    var authModes = new Set();
    rules.forEach(function(rule) {
        switch(rule.allow){
            case (0, _types.ModelAttributeAuthAllow).CUSTOM:
                // custom with no provider -> function
                if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).FUNCTION) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA);
                break;
            case (0, _types.ModelAttributeAuthAllow).GROUPS:
            case (0, _types.ModelAttributeAuthAllow).OWNER:
                // We shouldn't attempt User Pool or OIDC if there isn't an authenticated user
                if (currentUser) {
                    if (rule.provider === (0, _types.ModelAttributeAuthProvider).USER_POOLS) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS);
                    else if (rule.provider === (0, _types.ModelAttributeAuthProvider).OIDC) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).OPENID_CONNECT);
                }
                break;
            case (0, _types.ModelAttributeAuthAllow).PRIVATE:
                // We shouldn't attempt private if there isn't an authenticated user
                if (currentUser) {
                    // private with no provider means userPools
                    if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).USER_POOLS) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS);
                    else if (rule.provider === (0, _types.ModelAttributeAuthProvider).IAM) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_IAM);
                }
                break;
            case (0, _types.ModelAttributeAuthAllow).PUBLIC:
                if (rule.provider === (0, _types.ModelAttributeAuthProvider).IAM) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_IAM);
                else if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).API_KEY) // public with no provider means apiKey
                authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).API_KEY);
                break;
            default:
                break;
        }
    });
    return Array.from(authModes);
}
var multiAuthStrategy = function(amplifyContext) {
    return function(_a) {
        var schema = _a.schema, modelName = _a.modelName;
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var currentUser, e_1, attributes, authAttribute, sortedRules;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        amplifyContext.Auth = amplifyContext.Auth || (0, _auth.Auth);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            amplifyContext.Auth.currentAuthenticatedUser()
                        ];
                    case 2:
                        currentUser = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        attributes = schema.namespaces.user.models[modelName].attributes;
                        if (attributes) {
                            authAttribute = attributes.find(function(attr) {
                                return attr.type === "auth";
                            });
                            if ((_b = authAttribute === null || authAttribute === void 0 ? void 0 : authAttribute.properties) === null || _b === void 0 ? void 0 : _b.rules) {
                                sortedRules = sortAuthRulesWithPriority(authAttribute.properties.rules);
                                return [
                                    2 /*return*/ ,
                                    getAuthRules({
                                        currentUser: currentUser,
                                        rules: sortedRules
                                    })
                                ];
                            }
                        }
                        return [
                            2 /*return*/ ,
                            []
                        ];
                }
            });
        });
    };
};

},{"tslib":"9gMVn","@aws-amplify/auth":"6Q2Bh","@aws-amplify/api-graphql":"cbXXL","../types":"KjGQP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"KjGQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSchemaModel", ()=>isSchemaModel);
parcelHelpers.export(exports, "isSchemaModelWithAttributes", ()=>isSchemaModelWithAttributes);
parcelHelpers.export(exports, "isAssociatedWith", ()=>isAssociatedWith);
parcelHelpers.export(exports, "isTargetNameAssociation", ()=>isTargetNameAssociation);
parcelHelpers.export(exports, "isFieldAssociation", ()=>isFieldAssociation);
parcelHelpers.export(exports, "isModelAttributeAuth", ()=>isModelAttributeAuth);
parcelHelpers.export(exports, "isModelAttributeKey", ()=>isModelAttributeKey);
parcelHelpers.export(exports, "isModelAttributePrimaryKey", ()=>isModelAttributePrimaryKey);
parcelHelpers.export(exports, "isModelAttributeCompositeKey", ()=>isModelAttributeCompositeKey);
parcelHelpers.export(exports, "ModelAttributeAuthAllow", ()=>ModelAttributeAuthAllow);
parcelHelpers.export(exports, "ModelAttributeAuthProvider", ()=>ModelAttributeAuthProvider);
parcelHelpers.export(exports, "GraphQLScalarType", ()=>GraphQLScalarType);
parcelHelpers.export(exports, "isGraphQLScalarType", ()=>isGraphQLScalarType);
parcelHelpers.export(exports, "isModelFieldType", ()=>isModelFieldType);
parcelHelpers.export(exports, "isNonModelFieldType", ()=>isNonModelFieldType);
parcelHelpers.export(exports, "isEnumFieldType", ()=>isEnumFieldType);
parcelHelpers.export(exports, "isIdentifierObject", ()=>isIdentifierObject);
parcelHelpers.export(exports, "OpType", ()=>OpType);
parcelHelpers.export(exports, "isPredicateObj", ()=>isPredicateObj);
parcelHelpers.export(exports, "isPredicateGroup", ()=>isPredicateGroup);
parcelHelpers.export(exports, "QueryOne", ()=>QueryOne);
parcelHelpers.export(exports, "SortDirection", ()=>SortDirection);
parcelHelpers.export(exports, "AuthModeStrategyType", ()=>AuthModeStrategyType);
parcelHelpers.export(exports, "ModelOperation", ()=>ModelOperation);
parcelHelpers.export(exports, "syncExpression", ()=>syncExpression);
parcelHelpers.export(exports, "ProcessName", ()=>ProcessName);
parcelHelpers.export(exports, "DISCARD", ()=>DISCARD);
parcelHelpers.export(exports, "LimitTimerRaceResolvedValues", ()=>LimitTimerRaceResolvedValues);
parcelHelpers.export(exports, "PredicateInternalsKey", ()=>PredicateInternalsKey) // #endregion
;
var _tslib = require("tslib");
var _util = require("./util");
function isSchemaModel(obj) {
    return obj && obj.pluralName !== undefined;
}
function isSchemaModelWithAttributes(m) {
    return isSchemaModel(m) && m.attributes !== undefined;
}
function isAssociatedWith(obj) {
    return obj && obj.associatedWith;
}
function isTargetNameAssociation(obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.targetName) || (obj === null || obj === void 0 ? void 0 : obj.targetNames);
}
function isFieldAssociation(obj, fieldName) {
    var _a, _b;
    return (_b = (_a = obj === null || obj === void 0 ? void 0 : obj.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.association) === null || _b === void 0 ? void 0 : _b.connectionType;
}
function isModelAttributeAuth(attr) {
    return attr.type === "auth" && attr.properties && attr.properties.rules && attr.properties.rules.length > 0;
}
function isModelAttributeKey(attr) {
    return attr.type === "key" && attr.properties && attr.properties.fields && attr.properties.fields.length > 0;
}
function isModelAttributePrimaryKey(attr) {
    return isModelAttributeKey(attr) && attr.properties.name === undefined;
}
function isModelAttributeCompositeKey(attr) {
    return isModelAttributeKey(attr) && attr.properties.name !== undefined && attr.properties.fields.length > 2;
}
var ModelAttributeAuthAllow;
(function(ModelAttributeAuthAllow) {
    ModelAttributeAuthAllow["CUSTOM"] = "custom";
    ModelAttributeAuthAllow["OWNER"] = "owner";
    ModelAttributeAuthAllow["GROUPS"] = "groups";
    ModelAttributeAuthAllow["PRIVATE"] = "private";
    ModelAttributeAuthAllow["PUBLIC"] = "public";
})(ModelAttributeAuthAllow || (ModelAttributeAuthAllow = {}));
var ModelAttributeAuthProvider;
(function(ModelAttributeAuthProvider) {
    ModelAttributeAuthProvider["FUNCTION"] = "function";
    ModelAttributeAuthProvider["USER_POOLS"] = "userPools";
    ModelAttributeAuthProvider["OIDC"] = "oidc";
    ModelAttributeAuthProvider["IAM"] = "iam";
    ModelAttributeAuthProvider["API_KEY"] = "apiKey";
})(ModelAttributeAuthProvider || (ModelAttributeAuthProvider = {}));
var GraphQLScalarType;
(function(GraphQLScalarType) {
    GraphQLScalarType[GraphQLScalarType["ID"] = 0] = "ID";
    GraphQLScalarType[GraphQLScalarType["String"] = 1] = "String";
    GraphQLScalarType[GraphQLScalarType["Int"] = 2] = "Int";
    GraphQLScalarType[GraphQLScalarType["Float"] = 3] = "Float";
    GraphQLScalarType[GraphQLScalarType["Boolean"] = 4] = "Boolean";
    GraphQLScalarType[GraphQLScalarType["AWSDate"] = 5] = "AWSDate";
    GraphQLScalarType[GraphQLScalarType["AWSTime"] = 6] = "AWSTime";
    GraphQLScalarType[GraphQLScalarType["AWSDateTime"] = 7] = "AWSDateTime";
    GraphQLScalarType[GraphQLScalarType["AWSTimestamp"] = 8] = "AWSTimestamp";
    GraphQLScalarType[GraphQLScalarType["AWSEmail"] = 9] = "AWSEmail";
    GraphQLScalarType[GraphQLScalarType["AWSJSON"] = 10] = "AWSJSON";
    GraphQLScalarType[GraphQLScalarType["AWSURL"] = 11] = "AWSURL";
    GraphQLScalarType[GraphQLScalarType["AWSPhone"] = 12] = "AWSPhone";
    GraphQLScalarType[GraphQLScalarType["AWSIPAddress"] = 13] = "AWSIPAddress";
})(GraphQLScalarType || (GraphQLScalarType = {}));
(function(GraphQLScalarType) {
    function getJSType(scalar) {
        switch(scalar){
            case "Boolean":
                return "boolean";
            case "ID":
            case "String":
            case "AWSDate":
            case "AWSTime":
            case "AWSDateTime":
            case "AWSEmail":
            case "AWSURL":
            case "AWSPhone":
            case "AWSIPAddress":
                return "string";
            case "Int":
            case "Float":
            case "AWSTimestamp":
                return "number";
            case "AWSJSON":
                return "object";
            default:
                throw new Error("Invalid scalar type");
        }
    }
    GraphQLScalarType.getJSType = getJSType;
    function getValidationFunction(scalar) {
        switch(scalar){
            case "AWSDate":
                return 0, _util.isAWSDate;
            case "AWSTime":
                return 0, _util.isAWSTime;
            case "AWSDateTime":
                return 0, _util.isAWSDateTime;
            case "AWSTimestamp":
                return 0, _util.isAWSTimestamp;
            case "AWSEmail":
                return 0, _util.isAWSEmail;
            case "AWSJSON":
                return 0, _util.isAWSJSON;
            case "AWSURL":
                return 0, _util.isAWSURL;
            case "AWSPhone":
                return 0, _util.isAWSPhone;
            case "AWSIPAddress":
                return 0, _util.isAWSIPAddress;
            default:
                return undefined;
        }
    }
    GraphQLScalarType.getValidationFunction = getValidationFunction;
})(GraphQLScalarType || (GraphQLScalarType = {}));
function isGraphQLScalarType(obj) {
    return obj && GraphQLScalarType[obj] !== undefined;
}
function isModelFieldType(obj) {
    var modelField = "model";
    if (obj && obj[modelField]) return true;
    return false;
}
function isNonModelFieldType(obj) {
    var typeField = "nonModel";
    if (obj && obj[typeField]) return true;
    return false;
}
function isEnumFieldType(obj) {
    var modelField = "enum";
    if (obj && obj[modelField]) return true;
    return false;
}
function isIdentifierObject(obj, modelDefinition) {
    var keys = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    return typeof obj === "object" && obj && keys.every(function(k) {
        return obj[k] !== undefined;
    });
}
var OpType;
(function(OpType) {
    OpType["INSERT"] = "INSERT";
    OpType["UPDATE"] = "UPDATE";
    OpType["DELETE"] = "DELETE";
})(OpType || (OpType = {}));
function isPredicateObj(obj) {
    return obj && obj.field !== undefined;
}
function isPredicateGroup(obj) {
    return obj && obj.type !== undefined;
}
var QueryOne;
(function(QueryOne) {
    QueryOne[QueryOne["FIRST"] = 0] = "FIRST";
    QueryOne[QueryOne["LAST"] = 1] = "LAST";
})(QueryOne || (QueryOne = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["ASCENDING"] = "ASCENDING";
    SortDirection["DESCENDING"] = "DESCENDING";
})(SortDirection || (SortDirection = {}));
var AuthModeStrategyType;
(function(AuthModeStrategyType) {
    AuthModeStrategyType["DEFAULT"] = "DEFAULT";
    AuthModeStrategyType["MULTI_AUTH"] = "MULTI_AUTH";
})(AuthModeStrategyType || (AuthModeStrategyType = {}));
var ModelOperation;
(function(ModelOperation) {
    ModelOperation["CREATE"] = "CREATE";
    ModelOperation["READ"] = "READ";
    ModelOperation["UPDATE"] = "UPDATE";
    ModelOperation["DELETE"] = "DELETE";
})(ModelOperation || (ModelOperation = {}));
function syncExpression(modelConstructor, conditionProducer) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                {
                    modelConstructor: modelConstructor,
                    conditionProducer: conditionProducer
                }
            ];
        });
    });
}
var ProcessName;
(function(ProcessName) {
    ProcessName["sync"] = "sync";
    ProcessName["mutate"] = "mutate";
    ProcessName["subscribe"] = "subscribe";
})(ProcessName || (ProcessName = {}));
var DISCARD = Symbol("DISCARD");
var LimitTimerRaceResolvedValues;
(function(LimitTimerRaceResolvedValues) {
    LimitTimerRaceResolvedValues["LIMIT"] = "LIMIT";
    LimitTimerRaceResolvedValues["TIMER"] = "TIMER";
})(LimitTimerRaceResolvedValues || (LimitTimerRaceResolvedValues = {}));
/**
 * A pointer used by DataStore internally to lookup predicate details
 * that should not be exposed on public customer interfaces.
 */ var PredicateInternalsKey = /** @class */ function() {
    function PredicateInternalsKey() {
        this.__isPredicateInternalsKeySentinel = true;
    }
    return PredicateInternalsKey;
}();

},{"tslib":"9gMVn","./util":"89SDa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"89SDa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ID", ()=>ID);
parcelHelpers.export(exports, "DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR", ()=>DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
parcelHelpers.export(exports, "IDENTIFIER_KEY_SEPARATOR", ()=>IDENTIFIER_KEY_SEPARATOR);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
parcelHelpers.export(exports, "NAMESPACES", ()=>NAMESPACES);
parcelHelpers.export(exports, "USER", ()=>USER);
parcelHelpers.export(exports, "SYNC", ()=>SYNC);
parcelHelpers.export(exports, "STORAGE", ()=>STORAGE);
parcelHelpers.export(exports, "DATASTORE", ()=>DATASTORE);
parcelHelpers.export(exports, "exhaustiveCheck", ()=>exhaustiveCheck);
parcelHelpers.export(exports, "isNullOrUndefined", ()=>isNullOrUndefined);
parcelHelpers.export(exports, "validatePredicate", ()=>validatePredicate);
parcelHelpers.export(exports, "validatePredicateField", ()=>validatePredicateField);
parcelHelpers.export(exports, "isModelConstructor", ()=>isModelConstructor);
parcelHelpers.export(exports, "registerNonModelClass", ()=>registerNonModelClass);
parcelHelpers.export(exports, "isNonModelConstructor", ()=>isNonModelConstructor);
parcelHelpers.export(exports, "traverseModel", ()=>traverseModel);
parcelHelpers.export(exports, "isPrivateMode", ()=>isPrivateMode);
parcelHelpers.export(exports, "isSafariCompatabilityMode", ()=>isSafariCompatabilityMode);
parcelHelpers.export(exports, "monotonicUlidFactory", ()=>monotonicUlidFactory);
/**
 * Uses performance.now() if available, otherwise, uses Date.now() (e.g. react native without a polyfill)
 *
 * The values returned by performance.now() always increase at a constant rate,
 * independent of the system clock (which might be adjusted manually or skewed
 * by software like NTP).
 *
 * Otherwise, performance.timing.navigationStart + performance.now() will be
 * approximately equal to Date.now()
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Performance/now#Example
 */ parcelHelpers.export(exports, "getNow", ()=>getNow);
parcelHelpers.export(exports, "sortCompareFunction", ()=>sortCompareFunction);
// deep compare any 2 values
// primitives or object types (including arrays, Sets, and Maps)
// returns true if equal by value
// if nullish is true, treat undefined and null values as equal
// to normalize for GQL response values for undefined fields
parcelHelpers.export(exports, "valuesEqual", ()=>valuesEqual);
/**
 * Statelessly extracts the specified page from an array.
 *
 * @param records - The source array to extract a page from.
 * @param pagination - A definition of the page to extract.
 * @returns This items from `records` matching the `pagination` definition.
 */ parcelHelpers.export(exports, "inMemoryPagination", ()=>inMemoryPagination);
/**
 * An `aysnc` implementation of `Array.some()`. Returns as soon as a match is found.
 * @param items The items to check.
 * @param matches The async matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<boolean>`, `true` if "some" items match; `false` otherwise.
 */ parcelHelpers.export(exports, "asyncSome", ()=>asyncSome);
/**
 * An `aysnc` implementation of `Array.every()`. Returns as soon as a non-match is found.
 * @param items The items to check.
 * @param matches The async matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<boolean>`, `true` if every item matches; `false` otherwise.
 */ parcelHelpers.export(exports, "asyncEvery", ()=>asyncEvery);
/**
 * An `async` implementation of `Array.filter()`. Returns after all items have been filtered.
 * TODO: Return AsyncIterable.
 * @param items The items to filter.
 * @param matches The `async` matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<T>` of matching items.
 */ parcelHelpers.export(exports, "asyncFilter", ()=>asyncFilter);
parcelHelpers.export(exports, "isAWSDate", ()=>isAWSDate);
parcelHelpers.export(exports, "isAWSTime", ()=>isAWSTime);
parcelHelpers.export(exports, "isAWSDateTime", ()=>isAWSDateTime);
parcelHelpers.export(exports, "isAWSTimestamp", ()=>isAWSTimestamp);
parcelHelpers.export(exports, "isAWSEmail", ()=>isAWSEmail);
parcelHelpers.export(exports, "isAWSJSON", ()=>isAWSJSON);
parcelHelpers.export(exports, "isAWSURL", ()=>isAWSURL);
parcelHelpers.export(exports, "isAWSPhone", ()=>isAWSPhone);
parcelHelpers.export(exports, "isAWSIPAddress", ()=>isAWSIPAddress);
parcelHelpers.export(exports, "DeferredPromise", ()=>DeferredPromise);
parcelHelpers.export(exports, "DeferredCallbackResolver", ()=>DeferredCallbackResolver);
/**
 * merge two sets of patches created by immer produce.
 * newPatches take precedent over oldPatches for patches modifying the same path.
 * In the case many consecutive pathces are merged the original model should
 * always be the root model.
 *
 * Example:
 * A -> B, patches1
 * B -> C, patches2
 *
 * mergePatches(A, patches1, patches2) to get patches for A -> C
 *
 * @param originalSource the original Model the patches should be applied to
 * @param oldPatches immer produce patch list
 * @param newPatches immer produce patch list (will take precedence)
 * @return merged patches
 */ parcelHelpers.export(exports, "mergePatches", ()=>mergePatches);
parcelHelpers.export(exports, "getStorename", ()=>getStorename);
parcelHelpers.export(exports, "processCompositeKeys", ()=>processCompositeKeys);
parcelHelpers.export(exports, "extractKeyIfExists", ()=>extractKeyIfExists);
parcelHelpers.export(exports, "extractPrimaryKeyFieldNames", ()=>extractPrimaryKeyFieldNames);
parcelHelpers.export(exports, "extractPrimaryKeyValues", ()=>extractPrimaryKeyValues);
parcelHelpers.export(exports, "extractPrimaryKeysAndValues", ()=>extractPrimaryKeysAndValues);
parcelHelpers.export(exports, "isIdManaged", ()=>isIdManaged);
parcelHelpers.export(exports, "isIdOptionallyManaged", ()=>isIdOptionallyManaged);
parcelHelpers.export(exports, "establishRelationAndKeys", ()=>establishRelationAndKeys);
parcelHelpers.export(exports, "getIndex", ()=>getIndex);
parcelHelpers.export(exports, "getIndexFromAssociation", ()=>getIndexFromAssociation);
parcelHelpers.export(exports, "extractTargetNamesFromSrc", ()=>extractTargetNamesFromSrc);
parcelHelpers.export(exports, "indexNameFromKeys", ()=>indexNameFromKeys);
parcelHelpers.export(exports, "keysEqual", ()=>keysEqual);
parcelHelpers.export(exports, "getIndexKeys", ()=>getIndexKeys);
parcelHelpers.export(exports, "getTimestampFields", ()=>getTimestampFields);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _buffer = require("buffer");
var _ulid = require("ulid");
var _uuid = require("uuid");
var _immer = require("immer");
var _types = require("./types");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _predicates = require("./predicates");
var ID = "id";
var DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR = "#";
var IDENTIFIER_KEY_SEPARATOR = "-";
var errorMessages = {
    idEmptyString: "An index field cannot contain an empty string value",
    queryByPkWithCompositeKeyPresent: "Models with composite primary keys cannot be queried by a single key value. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys",
    deleteByPkWithCompositeKeyPresent: "Models with composite primary keys cannot be deleted by a single key value, unless using a predicate. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys",
    observeWithObjectLiteral: "Object literal syntax cannot be used with observe. Use a predicate instead: https://docs.amplify.aws/lib/datastore/data-access/q/platform/js/#predicates"
};
var NAMESPACES;
(function(NAMESPACES) {
    NAMESPACES["DATASTORE"] = "datastore";
    NAMESPACES["USER"] = "user";
    NAMESPACES["SYNC"] = "sync";
    NAMESPACES["STORAGE"] = "storage";
})(NAMESPACES || (NAMESPACES = {}));
var DATASTORE = NAMESPACES.DATASTORE;
var USER = NAMESPACES.USER;
var SYNC = NAMESPACES.SYNC;
var STORAGE = NAMESPACES.STORAGE;
var exhaustiveCheck = function(obj, throwOnError) {
    if (throwOnError === void 0) throwOnError = true;
    if (throwOnError) throw new Error("Invalid " + obj);
};
var isNullOrUndefined = function(val) {
    return typeof val === "undefined" || val === undefined || val === null;
};
var validatePredicate = function(model, groupType, predicatesOrGroups) {
    var filterType;
    var isNegation = false;
    if (predicatesOrGroups.length === 0) return true;
    switch(groupType){
        case "not":
            filterType = "every";
            isNegation = true;
            break;
        case "and":
            filterType = "every";
            break;
        case "or":
            filterType = "some";
            break;
        default:
            throw new Error("Invalid " + groupType);
    }
    var result = predicatesOrGroups[filterType](function(predicateOrGroup) {
        if ((0, _types.isPredicateObj)(predicateOrGroup)) {
            var field = predicateOrGroup.field, operator = predicateOrGroup.operator, operand = predicateOrGroup.operand;
            var value = model[field];
            return validatePredicateField(value, operator, operand);
        }
        if ((0, _types.isPredicateGroup)(predicateOrGroup)) {
            var type = predicateOrGroup.type, predicates = predicateOrGroup.predicates;
            return validatePredicate(model, type, predicates);
        }
        throw new Error("Not a predicate or group");
    });
    return isNegation ? !result : result;
};
var validatePredicateField = function(value, operator, operand) {
    switch(operator){
        case "ne":
            return value !== operand;
        case "eq":
            return value === operand;
        case "le":
            return value <= operand;
        case "lt":
            return value < operand;
        case "ge":
            return value >= operand;
        case "gt":
            return value > operand;
        case "between":
            var _c = (0, _tslib.__read)(operand, 2), min = _c[0], max = _c[1];
            return value >= min && value <= max;
        case "beginsWith":
            return !isNullOrUndefined(value) && value.startsWith(operand);
        case "contains":
            return !isNullOrUndefined(value) && value.indexOf(operand) > -1;
        case "notContains":
            return isNullOrUndefined(value) || value.indexOf(operand) === -1;
        default:
            return false;
    }
};
var isModelConstructor = function(obj) {
    return obj && typeof obj.copyOf === "function";
};
var nonModelClasses = new WeakSet();
function registerNonModelClass(clazz) {
    nonModelClasses.add(clazz);
}
var isNonModelConstructor = function(obj) {
    return nonModelClasses.has(obj);
};
var topologicallySortedModels = new WeakMap();
var traverseModel = function(srcModelName, instance, namespace, modelInstanceCreator, getModelConstructorByModelName) {
    var modelConstructor = getModelConstructorByModelName(namespace.name, srcModelName);
    var result = [];
    var newInstance = modelConstructor.copyOf(instance, function() {});
    result.unshift({
        modelName: srcModelName,
        item: newInstance,
        instance: newInstance
    });
    if (!topologicallySortedModels.has(namespace)) topologicallySortedModels.set(namespace, Array.from(namespace.modelTopologicalOrdering.keys()));
    var sortedModels = topologicallySortedModels.get(namespace);
    result.sort(function(a, b) {
        return sortedModels.indexOf(a.modelName) - sortedModels.indexOf(b.modelName);
    });
    return result;
};
var privateModeCheckResult;
var isPrivateMode = function() {
    return new Promise(function(resolve) {
        var dbname = (0, _uuid.v4)();
        var db;
        var isPrivate = function() {
            privateModeCheckResult = false;
            resolve(true);
        };
        var isNotPrivate = function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            if (!(db && db.result && typeof db.result.close === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                db.result.close()
                            ];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                indexedDB.deleteDatabase(dbname)
                            ];
                        case 3:
                            _c.sent();
                            privateModeCheckResult = true;
                            return [
                                2 /*return*/ ,
                                resolve(false)
                            ];
                    }
                });
            });
        };
        if (privateModeCheckResult === true) return isNotPrivate();
        if (privateModeCheckResult === false) return isPrivate();
        if (indexedDB === null) return isPrivate();
        db = indexedDB.open(dbname);
        db.onerror = isPrivate;
        db.onsuccess = isNotPrivate;
    });
};
var safariCompatabilityModeResult;
var isSafariCompatabilityMode = function() {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var dbName_1, storeName_1, indexName_1, db_1, rwTx, rwStore, result, error_1;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        6,
                        ,
                        7
                    ]);
                    dbName_1 = (0, _uuid.v4)();
                    storeName_1 = "indexedDBFeatureProbeStore";
                    indexName_1 = "idx";
                    if (indexedDB === null) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (safariCompatabilityModeResult !== undefined) return [
                        2 /*return*/ ,
                        safariCompatabilityModeResult
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            var dbOpenRequest = indexedDB.open(dbName_1);
                            dbOpenRequest.onerror = function() {
                                return resolve(false);
                            };
                            dbOpenRequest.onsuccess = function() {
                                var db = dbOpenRequest.result;
                                resolve(db);
                            };
                            dbOpenRequest.onupgradeneeded = function(event) {
                                var _c;
                                var db = (_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.result;
                                db.onerror = function() {
                                    return resolve(false);
                                };
                                var store = db.createObjectStore(storeName_1, {
                                    autoIncrement: true
                                });
                                store.createIndex(indexName_1, [
                                    "id"
                                ]);
                            };
                        })
                    ];
                case 1:
                    db_1 = _c.sent();
                    if (!db_1) throw new Error("Could not open probe DB");
                    rwTx = db_1.transaction(storeName_1, "readwrite");
                    rwStore = rwTx.objectStore(storeName_1);
                    rwStore.add({
                        id: 1
                    });
                    rwTx.commit();
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            var tx = db_1.transaction(storeName_1, "readonly");
                            var store = tx.objectStore(storeName_1);
                            var index = store.index(indexName_1);
                            var getRequest = index.get([
                                1
                            ]);
                            getRequest.onerror = function() {
                                return resolve(false);
                            };
                            getRequest.onsuccess = function(event) {
                                var _c;
                                resolve((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.result);
                            };
                        })
                    ];
                case 2:
                    result = _c.sent();
                    if (!(db_1 && typeof db_1.close === "function")) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        db_1.close()
                    ];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    return [
                        4 /*yield*/ ,
                        indexedDB.deleteDatabase(dbName_1)
                    ];
                case 5:
                    _c.sent();
                    if (result === undefined) safariCompatabilityModeResult = true;
                    else safariCompatabilityModeResult = false;
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    error_1 = _c.sent();
                    safariCompatabilityModeResult = false;
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        safariCompatabilityModeResult
                    ];
            }
        });
    });
};
var randomBytes = function(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _amazonCognitoIdentityJs.WordArray)().random(nBytes).toString(), "hex");
};
var prng = function() {
    return randomBytes(1).readUInt8(0) / 0xff;
};
function monotonicUlidFactory(seed) {
    var ulid = (0, _ulid.monotonicFactory)(prng);
    return function() {
        return ulid(seed);
    };
}
function getNow() {
    if (typeof performance !== "undefined" && performance && typeof performance.now === "function") return performance.now() | 0; // convert to integer
    else return Date.now();
}
function sortCompareFunction(sortPredicates) {
    return function compareFunction(a, b) {
        var e_1, _c;
        try {
            // enable multi-field sort by iterating over predicates until
            // a comparison returns -1 or 1
            for(var sortPredicates_1 = (0, _tslib.__values)(sortPredicates), sortPredicates_1_1 = sortPredicates_1.next(); !sortPredicates_1_1.done; sortPredicates_1_1 = sortPredicates_1.next()){
                var predicate = sortPredicates_1_1.value;
                var field = predicate.field, sortDirection = predicate.sortDirection;
                // reverse result when direction is descending
                var sortMultiplier = sortDirection === (0, _types.SortDirection).ASCENDING ? 1 : -1;
                if (a[field] < b[field]) return -1 * sortMultiplier;
                if (a[field] > b[field]) return 1 * sortMultiplier;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (sortPredicates_1_1 && !sortPredicates_1_1.done && (_c = sortPredicates_1.return)) _c.call(sortPredicates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return 0;
    };
}
function valuesEqual(valA, valB, nullish) {
    var e_2, _c;
    if (nullish === void 0) nullish = false;
    var a = valA;
    var b = valB;
    var nullishCompare = function(_a, _b) {
        return (_a === undefined || _a === null) && (_b === undefined || _b === null);
    };
    // if one of the values is a primitive and the other is an object
    if (a instanceof Object && !(b instanceof Object) || !(a instanceof Object) && b instanceof Object) return false;
    // compare primitive types
    if (!(a instanceof Object)) {
        if (nullish && nullishCompare(a, b)) return true;
        return a === b;
    }
    // make sure object types match
    if (Array.isArray(a) && !Array.isArray(b) || Array.isArray(b) && !Array.isArray(a)) return false;
    if (a instanceof Set && b instanceof Set) {
        a = (0, _tslib.__spread)(a);
        b = (0, _tslib.__spread)(b);
    }
    if (a instanceof Map && b instanceof Map) {
        a = Object.fromEntries(a);
        b = Object.fromEntries(b);
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    // last condition is to ensure that [] !== [null] even if nullish. However [undefined] === [null] when nullish
    if (aKeys.length !== bKeys.length && (!nullish || Array.isArray(a))) return false;
    // iterate through the longer set of keys
    // e.g., for a nullish comparison of a={ a: 1 } and b={ a: 1, b: null }
    // we want to iterate through bKeys
    var keys = aKeys.length >= bKeys.length ? aKeys : bKeys;
    try {
        for(var keys_1 = (0, _tslib.__values)(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
            var key = keys_1_1.value;
            var aVal = a[key];
            var bVal = b[key];
            if (!valuesEqual(aVal, bVal, nullish)) return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (keys_1_1 && !keys_1_1.done && (_c = keys_1.return)) _c.call(keys_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function inMemoryPagination(records, pagination) {
    if (pagination && records.length > 1) {
        if (pagination.sort) {
            var sortPredicates = (0, _predicates.ModelSortPredicateCreator).getPredicates(pagination.sort);
            if (sortPredicates.length) {
                var compareFn = sortCompareFunction(sortPredicates);
                records.sort(compareFn);
            }
        }
        var _c = pagination.page, page = _c === void 0 ? 0 : _c, _d = pagination.limit, limit = _d === void 0 ? 0 : _d;
        var start = Math.max(0, page * limit) || 0;
        var end = limit > 0 ? start + limit : records.length;
        return records.slice(start, end);
    }
    return records;
}
function asyncSome(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items_1, items_1_1, item, e_3_1;
        var e_3, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _d.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next();
                    _d.label = 1;
                case 1:
                    if (!!items_1_1.done) return [
                        3 /*break*/ ,
                        4
                    ];
                    item = items_1_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 2:
                    if (_d.sent()) return [
                        2 /*return*/ ,
                        true
                    ];
                    _d.label = 3;
                case 3:
                    items_1_1 = items_1.next();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    e_3_1 = _d.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    try {
                        if (items_1_1 && !items_1_1.done && (_c = items_1.return)) _c.call(items_1);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        false
                    ];
            }
        });
    });
}
function asyncEvery(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items_2, items_2_1, item, e_4_1;
        var e_4, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _d.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    items_2 = (0, _tslib.__values)(items), items_2_1 = items_2.next();
                    _d.label = 1;
                case 1:
                    if (!!items_2_1.done) return [
                        3 /*break*/ ,
                        4
                    ];
                    item = items_2_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 2:
                    if (!_d.sent()) return [
                        2 /*return*/ ,
                        false
                    ];
                    _d.label = 3;
                case 3:
                    items_2_1 = items_2.next();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    e_4_1 = _d.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    try {
                        if (items_2_1 && !items_2_1.done && (_c = items_2.return)) _c.call(items_2);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        true
                    ];
            }
        });
    });
}
function asyncFilter(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var results, items_3, items_3_1, item, e_5_1;
        var e_5, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    results = [];
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    items_3 = (0, _tslib.__values)(items), items_3_1 = items_3.next();
                    _d.label = 2;
                case 2:
                    if (!!items_3_1.done) return [
                        3 /*break*/ ,
                        5
                    ];
                    item = items_3_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 3:
                    if (_d.sent()) results.push(item);
                    _d.label = 4;
                case 4:
                    items_3_1 = items_3.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 6:
                    e_5_1 = _d.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    try {
                        if (items_3_1 && !items_3_1.done && (_c = items_3.return)) _c.call(items_3);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 8:
                    return [
                        2 /*return*/ ,
                        results
                    ];
            }
        });
    });
}
var isAWSDate = function(val) {
    return !!/^\d{4}-\d{2}-\d{2}(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSTime = function(val) {
    return !!/^\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSDateTime = function(val) {
    return !!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSTimestamp = function(val) {
    return !!/^\d+$/.exec(String(val));
};
var isAWSEmail = function(val) {
    return !!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.exec(val);
};
var isAWSJSON = function(val) {
    try {
        JSON.parse(val);
        return true;
    } catch (_c) {
        return false;
    }
};
var isAWSURL = function(val) {
    try {
        return new URL(val), true;
    } catch (_c) {
        return false;
    }
};
var isAWSPhone = function(val) {
    return !!/^\+?\d[\d\s-]+$/.exec(val);
};
var isAWSIPAddress = function(val) {
    return !!/((^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$)|(^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?$))$/.exec(val);
};
var DeferredPromise = /** @class */ function() {
    function DeferredPromise() {
        var self = this;
        this.promise = new Promise(function(resolve, reject) {
            self.resolve = resolve;
            self.reject = reject;
        });
    }
    return DeferredPromise;
}();
var DeferredCallbackResolver = /** @class */ function() {
    function DeferredCallbackResolver(options) {
        this.limitPromise = new DeferredPromise();
        this.raceInFlight = false;
        this.callback = function() {};
        this.defaultErrorHandler = function(msg) {
            if (msg === void 0) msg = "DeferredCallbackResolver error";
            throw new Error(msg);
        };
        this.callback = options.callback;
        this.errorHandler = options.errorHandler || this.defaultErrorHandler;
        this.maxInterval = options.maxInterval || 2000;
    }
    DeferredCallbackResolver.prototype.startTimer = function() {
        var _this = this;
        this.timerPromise = new Promise(function(resolve, reject) {
            _this.timer = setTimeout(function() {
                resolve((0, _types.LimitTimerRaceResolvedValues).TIMER);
            }, _this.maxInterval);
        });
    };
    DeferredCallbackResolver.prototype.racePromises = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var winner, err_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        this.raceInFlight = true;
                        this.startTimer();
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                this.timerPromise,
                                this.limitPromise.promise
                            ])
                        ];
                    case 1:
                        winner = _c.sent();
                        this.callback();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        err_1 = _c.sent();
                        this.errorHandler(err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        // reset for the next race
                        this.clear();
                        this.raceInFlight = false;
                        this.limitPromise = new DeferredPromise();
                        return [
                            2 /*return*/ ,
                            winner
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DeferredCallbackResolver.prototype.start = function() {
        if (!this.raceInFlight) this.racePromises();
    };
    DeferredCallbackResolver.prototype.clear = function() {
        clearTimeout(this.timer);
    };
    DeferredCallbackResolver.prototype.resolve = function() {
        this.limitPromise.resolve((0, _types.LimitTimerRaceResolvedValues).LIMIT);
    };
    return DeferredCallbackResolver;
}();
function mergePatches(originalSource, oldPatches, newPatches) {
    var patchesToMerge = oldPatches.concat(newPatches);
    var patches;
    (0, _immer.produce)(originalSource, function(draft) {
        (0, _immer.applyPatches)(draft, patchesToMerge);
    }, function(p) {
        patches = p;
    });
    return patches;
}
var getStorename = function(namespace, modelName) {
    var storeName = namespace + "_" + modelName;
    return storeName;
};
var processCompositeKeys = function(attributes) {
    var extractCompositeSortKey = function(_c) {
        var // ignore the HK (fields[0]) we only need to include the composite sort key fields[1...n]
        _d = (0, _tslib.__read)(_c.properties.fields), sortKeyFields = _d.slice(1);
        return sortKeyFields;
    };
    var compositeKeyFields = attributes.filter((0, _types.isModelAttributeCompositeKey)).map(extractCompositeSortKey);
    /*
        if 2 sets of fields have any intersecting fields => combine them into 1 union set
        e.g., ['a', 'b', 'c'] and ['a', 'b', 'd'] => ['a', 'b', 'c', 'd']
    */ var combineIntersecting = function(fields) {
        return fields.reduce(function(combined, sortKeyFields) {
            var sortKeyFieldsSet = new Set(sortKeyFields);
            if (combined.length === 0) {
                combined.push(sortKeyFieldsSet);
                return combined;
            }
            // does the current set share values with another set we've already added to `combined`?
            var intersectingSetIdx = combined.findIndex(function(existingSet) {
                return (0, _tslib.__spread)(existingSet).some(function(f) {
                    return sortKeyFieldsSet.has(f);
                });
            });
            if (intersectingSetIdx > -1) {
                var union = new Set((0, _tslib.__spread)(combined[intersectingSetIdx], sortKeyFieldsSet));
                // combine the current set with the intersecting set we found above
                combined[intersectingSetIdx] = union;
            } else // none of the sets in `combined` have intersecting values with the current set
            combined.push(sortKeyFieldsSet);
            return combined;
        }, []);
    };
    var initial = combineIntersecting(compositeKeyFields);
    // a single pass pay not be enough to correctly combine all the fields
    // call the function once more to get a final merged list of sets
    var combined = combineIntersecting(initial);
    return combined;
};
var extractKeyIfExists = function(modelDefinition) {
    var _c;
    var keyAttribute = (_c = modelDefinition === null || modelDefinition === void 0 ? void 0 : modelDefinition.attributes) === null || _c === void 0 ? void 0 : _c.find((0, _types.isModelAttributeKey));
    return keyAttribute;
};
var extractPrimaryKeyFieldNames = function(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return keyAttribute.properties.fields;
    return [
        ID
    ];
};
var extractPrimaryKeyValues = function(model, keyFields) {
    return keyFields.map(function(key) {
        return model[key];
    });
};
var extractPrimaryKeysAndValues = function(model, keyFields) {
    var primaryKeysAndValues = {};
    keyFields.forEach(function(key) {
        return primaryKeysAndValues[key] = model[key];
    });
    return primaryKeysAndValues;
};
var isIdManaged = function(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return false;
    return true;
};
var isIdOptionallyManaged = function(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return keyAttribute.properties.fields[0] === ID;
    return false;
};
var establishRelationAndKeys = function(namespace) {
    var relationship = {};
    var keys = {};
    Object.keys(namespace.models).forEach(function(mKey) {
        var e_6, _c;
        relationship[mKey] = {
            indexes: [],
            relationTypes: []
        };
        keys[mKey] = {};
        var model = namespace.models[mKey];
        Object.keys(model.fields).forEach(function(attr) {
            var fieldAttribute = model.fields[attr];
            if (typeof fieldAttribute.type === "object" && "model" in fieldAttribute.type) {
                var connectionType = fieldAttribute.association.connectionType;
                relationship[mKey].relationTypes.push({
                    fieldName: fieldAttribute.name,
                    modelName: fieldAttribute.type.model,
                    relationType: connectionType,
                    targetName: fieldAttribute.association["targetName"],
                    targetNames: fieldAttribute.association["targetNames"],
                    associatedWith: fieldAttribute.association["associatedWith"]
                });
                if (connectionType === "BELONGS_TO") {
                    var targetNames = extractTargetNamesFromSrc(fieldAttribute.association);
                    if (targetNames) {
                        var idxName_1 = indexNameFromKeys(targetNames);
                        var idxExists = relationship[mKey].indexes.find(function(_c) {
                            var _d = (0, _tslib.__read)(_c, 1), index = _d[0];
                            return index === idxName_1;
                        });
                        if (!idxExists) relationship[mKey].indexes.push([
                            idxName_1,
                            targetNames
                        ]);
                    }
                }
            }
        });
        if (model.attributes) {
            keys[mKey].compositeKeys = processCompositeKeys(model.attributes);
            var _loop_1 = function(attribute) {
                if (!(0, _types.isModelAttributeKey)(attribute)) return "continue";
                var fields = attribute.properties.fields;
                if ((0, _types.isModelAttributePrimaryKey)(attribute)) {
                    keys[mKey].primaryKey = fields;
                    return "continue";
                }
                // create indexes for all other keys
                var idxName = indexNameFromKeys(fields);
                var idxExists = relationship[mKey].indexes.find(function(_c) {
                    var _d = (0, _tslib.__read)(_c, 1), index = _d[0];
                    return index === idxName;
                });
                if (!idxExists) relationship[mKey].indexes.push([
                    idxName,
                    fields
                ]);
            };
            try {
                for(var _d = (0, _tslib.__values)(model.attributes), _e = _d.next(); !_e.done; _e = _d.next()){
                    var attribute = _e.value;
                    _loop_1(attribute);
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
        }
        // set 'id' as the PK for models without a custom PK explicitly defined
        if (!keys[mKey].primaryKey) keys[mKey].primaryKey = [
            ID
        ];
        // create primary index
        relationship[mKey].indexes.push([
            "byPk",
            keys[mKey].primaryKey,
            {
                unique: true
            }
        ]);
    });
    return [
        relationship,
        keys
    ];
};
var getIndex = function(rel, src) {
    var indexName;
    rel.some(function(relItem) {
        if (relItem.modelName === src) {
            var targetNames = extractTargetNamesFromSrc(relItem);
            indexName = targetNames && indexNameFromKeys(targetNames);
            return true;
        }
    });
    return indexName;
};
var getIndexFromAssociation = function(indexes, src) {
    var indexName;
    if (Array.isArray(src)) indexName = indexNameFromKeys(src);
    else indexName = src;
    var associationIndex = indexes.find(function(_c) {
        var _d = (0, _tslib.__read)(_c, 1), idxName = _d[0];
        return idxName === indexName;
    });
    return associationIndex && associationIndex[0];
};
var extractTargetNamesFromSrc = function(src) {
    var targetName = src === null || src === void 0 ? void 0 : src.targetName;
    var targetNames = src === null || src === void 0 ? void 0 : src.targetNames;
    if (Array.isArray(targetNames)) return targetNames;
    else if (typeof targetName === "string") return [
        targetName
    ];
    else return undefined;
};
var indexNameFromKeys = function(keys) {
    return keys.reduce(function(prev, cur, idx) {
        if (idx === 0) return cur;
        return "" + prev + IDENTIFIER_KEY_SEPARATOR + cur;
    }, "");
};
var keysEqual = function(keysA, keysB) {
    if (keysA.length !== keysB.length) return false;
    return keysA.every(function(key, idx) {
        return key === keysB[idx];
    });
};
var getIndexKeys = function(namespace, modelName) {
    var _c, _d;
    var keyPath = (_d = (_c = namespace === null || namespace === void 0 ? void 0 : namespace.keys) === null || _c === void 0 ? void 0 : _c[modelName]) === null || _d === void 0 ? void 0 : _d.primaryKey;
    if (keyPath) return keyPath;
    return [
        ID
    ];
};
var getTimestampFields = function(definition) {
    var _c, _d;
    var modelAttributes = (_c = definition.attributes) === null || _c === void 0 ? void 0 : _c.find(function(attr) {
        return attr.type === "model";
    });
    var timestampFieldsMap = (_d = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _d === void 0 ? void 0 : _d.timestamps;
    var defaultFields = {
        createdAt: "createdAt",
        updatedAt: "updatedAt"
    };
    var customFields = timestampFieldsMap || {};
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultFields), customFields);
};

},{"tslib":"9gMVn","buffer":"5zKaV","ulid":"8eh5L","uuid":"9dBTc","immer":"hF6fx","./types":"KjGQP","amazon-cognito-identity-js":"5JTdi","./predicates":"lUiza","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5zKaV":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("8912f9896669a94d");
var ieee754 = require("cef07915f0cfc4ed");
var isArray = require("7fecdd7358c4d78c");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"8912f9896669a94d":"rFFSX","cef07915f0cfc4ed":"iAbbC","7fecdd7358c4d78c":"fttjS"}],"fttjS":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"8eh5L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceCharAt", ()=>replaceCharAt);
parcelHelpers.export(exports, "incrementBase32", ()=>incrementBase32);
parcelHelpers.export(exports, "randomChar", ()=>randomChar);
parcelHelpers.export(exports, "encodeTime", ()=>encodeTime);
parcelHelpers.export(exports, "encodeRandom", ()=>encodeRandom);
parcelHelpers.export(exports, "decodeTime", ()=>decodeTime);
parcelHelpers.export(exports, "detectPrng", ()=>detectPrng);
parcelHelpers.export(exports, "factory", ()=>factory);
parcelHelpers.export(exports, "monotonicFactory", ()=>monotonicFactory);
parcelHelpers.export(exports, "ulid", ()=>ulid);
function createError(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var ENCODING_LEN = ENCODING.length;
var TIME_MAX = Math.pow(2, 48) - 1;
var TIME_LEN = 10;
var RANDOM_LEN = 16;
function replaceCharAt(str, index, char) {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + char + str.substr(index + 1);
}
function incrementBase32(str) {
    var done = undefined;
    var index = str.length;
    var char = void 0;
    var charIndex = void 0;
    var maxCharIndex = ENCODING_LEN - 1;
    while(!done && index-- >= 0){
        char = str[index];
        charIndex = ENCODING.indexOf(char);
        if (charIndex === -1) throw createError("incorrectly encoded string");
        if (charIndex === maxCharIndex) {
            str = replaceCharAt(str, index, ENCODING[0]);
            continue;
        }
        done = replaceCharAt(str, index, ENCODING[charIndex + 1]);
    }
    if (typeof done === "string") return done;
    throw createError("cannot increment this string");
}
function randomChar(prng) {
    var rand = Math.floor(prng() * ENCODING_LEN);
    if (rand === ENCODING_LEN) rand = ENCODING_LEN - 1;
    return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
    if (isNaN(now)) throw new Error(now + " must be a number");
    if (now > TIME_MAX) throw createError("cannot encode time greater than " + TIME_MAX);
    if (now < 0) throw createError("time must be positive");
    if (Number.isInteger(now) === false) throw createError("time must be an integer");
    var mod = void 0;
    var str = "";
    for(; len > 0; len--){
        mod = now % ENCODING_LEN;
        str = ENCODING.charAt(mod) + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}
function encodeRandom(len, prng) {
    var str = "";
    for(; len > 0; len--)str = randomChar(prng) + str;
    return str;
}
function decodeTime(id) {
    if (id.length !== TIME_LEN + RANDOM_LEN) throw createError("malformed ulid");
    var time = id.substr(0, TIME_LEN).split("").reverse().reduce(function(carry, char, index) {
        var encodingIndex = ENCODING.indexOf(char);
        if (encodingIndex === -1) throw createError("invalid character found: " + char);
        return carry += encodingIndex * Math.pow(ENCODING_LEN, index);
    }, 0);
    if (time > TIME_MAX) throw createError("malformed ulid, timestamp too large");
    return time;
}
function detectPrng() {
    var allowInsecure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var root = arguments[1];
    if (!root) root = typeof window !== "undefined" ? window : null;
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) return function() {
        var buffer = new Uint8Array(1);
        browserCrypto.getRandomValues(buffer);
        return buffer[0] / 0xff;
    };
    else try {
        var nodeCrypto = require("1002b1ce995ee642");
        return function() {
            return nodeCrypto.randomBytes(1).readUInt8() / 0xff;
        };
    } catch (e) {}
    if (allowInsecure) {
        try {
            console.error("secure crypto unusable, falling back to insecure Math.random()!");
        } catch (e) {}
        return function() {
            return Math.random();
        };
    }
    throw createError("secure crypto unusable, insecure Math.random not allowed");
}
function factory(currPrng) {
    if (!currPrng) currPrng = detectPrng();
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
    };
}
function monotonicFactory(currPrng) {
    if (!currPrng) currPrng = detectPrng();
    var lastTime = 0;
    var lastRandom = void 0;
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        if (seedTime <= lastTime) {
            var incrementedRandom = lastRandom = incrementBase32(lastRandom);
            return encodeTime(lastTime, TIME_LEN) + incrementedRandom;
        }
        lastTime = seedTime;
        var newRandom = lastRandom = encodeRandom(RANDOM_LEN, currPrng);
        return encodeTime(seedTime, TIME_LEN) + newRandom;
    };
}
var ulid = factory();

},{"1002b1ce995ee642":"1XNwi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1XNwi":[function(require,module,exports) {

},{}],"lUiza":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelSortPredicateCreator", ()=>(0, _sort.ModelSortPredicateCreator));
parcelHelpers.export(exports, "isPredicatesAll", ()=>isPredicatesAll);
parcelHelpers.export(exports, "comparisonKeys", ()=>comparisonKeys);
parcelHelpers.export(exports, "PredicateAll", ()=>PredicateAll);
parcelHelpers.export(exports, "Predicates", ()=>Predicates);
parcelHelpers.export(exports, "ModelPredicateCreator", ()=>ModelPredicateCreator);
var _tslib = require("tslib");
var _util = require("../util");
var _sort = require("./sort");
var predicatesAllSet = new WeakSet();
function isPredicatesAll(predicate) {
    return predicatesAllSet.has(predicate);
}
/**
 * The valid logical grouping keys for a predicate group.
 */ var groupKeys = new Set([
    "and",
    "or",
    "not"
]);
/**
 * Determines whether an object is a GraphQL style predicate "group", which must be an
 * object containing a single "group key", which then contains the child condition(s).
 *
 * E.g.,
 *
 * ```
 * { and: [ ... ] }
 * { not: { ... } }
 * ```
 *
 * @param o The object to test.
 */ var isGroup = function(o) {
    var keys = (0, _tslib.__spread)(Object.keys(o));
    return keys.length === 1 && groupKeys.has(keys[0]);
};
/**
 * Determines whether an object specifies no conditions and should match everything,
 * as would be the case with `Predicates.ALL`.
 *
 * @param o The object to test.
 */ var isEmpty = function(o) {
    return !Array.isArray(o) && Object.keys(o).length === 0;
};
var comparisonKeys = new Set([
    "eq",
    "ne",
    "gt",
    "lt",
    "ge",
    "le",
    "contains",
    "notContains",
    "beginsWith",
    "between"
]);
/**
 * Determines whether an object is a GraphQL style predicate comparison node, which must
 * be an object containing a single "comparison operator" key, which then contains the
 * operand or operands to compare against.
 *
 * @param o The object to test.
 */ var isComparison = function(o) {
    var keys = (0, _tslib.__spread)(Object.keys(o));
    return !Array.isArray(o) && keys.length === 1 && comparisonKeys.has(keys[0]);
};
/**
 * A light check to determine whether an object is a valid GraphQL Condition AST.
 *
 * @param o The object to test.
 */ var isValid = function(o) {
    if (Array.isArray(o)) return o.every(function(v) {
        return isValid(v);
    });
    else return Object.keys(o).length <= 1;
};
var PredicateAll = Symbol("A predicate that matches all records");
var Predicates = /** @class */ function() {
    function Predicates() {}
    Object.defineProperty(Predicates, "ALL", {
        get: function() {
            var predicate = function(c) {
                return c;
            };
            predicatesAllSet.add(predicate);
            return predicate;
        },
        enumerable: true,
        configurable: true
    });
    return Predicates;
}();
var ModelPredicateCreator = /** @class */ function() {
    function ModelPredicateCreator() {}
    /**
     * Determines whether the given storage predicate (lookup key) is a predicate
     * key that DataStore recognizes.
     *
     * @param predicate The storage predicate (lookup key) to test.
     */ ModelPredicateCreator.isValidPredicate = function(predicate) {
        return ModelPredicateCreator.predicateGroupsMap.has(predicate);
    };
    /**
     * Looks for the storage predicate AST that corresponds to a given storage
     * predicate key.
     *
     * The key must have been created internally by a DataStore utility
     * method, such as `ModelPredicate.createFromAST()`.
     *
     * @param predicate The predicate reference to look up.
     * @param throwOnInvalid Whether to throw an exception if the predicate
     * isn't a valid DataStore predicate.
     */ ModelPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelPredicateCreator.isValidPredicate(predicate)) throw new Error("The predicate is not valid");
        return ModelPredicateCreator.predicateGroupsMap.get(predicate);
    };
    /**
     * using the PK values from the given `model` (which can be a partial of T
     * Creates a predicate that matches an instance described by `modelDefinition`
     * that contains only PK field values.)
     *
     * @param modelDefinition The model definition to create a predicate for.
     * @param model The model instance to extract value equalities from.
     */ ModelPredicateCreator.createForPk = function(modelDefinition, model) {
        var keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
        var keyValues = (0, _util.extractPrimaryKeyValues)(model, keyFields);
        var predicate = this.createFromAST(modelDefinition, {
            and: keyFields.map(function(field, idx) {
                var _a;
                var operand = keyValues[idx];
                return _a = {}, _a[field] = {
                    eq: operand
                }, _a;
            })
        });
        return predicate;
    };
    /**
     * Searches a `Model` table for records matching the given equalities object.
     *
     * This only matches against fields given in the equalities object. No other
     * fields are tested by the predicate.
     *
     * @param modelDefinition The model we need a predicate for.
     * @param flatEqualities An object holding field equalities to search for.
     */ ModelPredicateCreator.createFromFlatEqualities = function(modelDefinition, flatEqualities) {
        var ast = {
            and: Object.entries(flatEqualities).map(function(_a) {
                var _b;
                var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                return _b = {}, _b[k] = {
                    eq: v
                }, _b;
            })
        };
        return this.createFromAST(modelDefinition, ast);
    };
    /**
     * Accepts a GraphQL style filter predicate tree and transforms it into an
     * AST that can be used for a storage adapter predicate. Example input:
     *
     * ```js
     * {
     * 	and: [
     * 		{ name: { eq: "Bob Jones" } },
     * 		{ age: { between: [32, 64] } },
     * 		{ not: {
     * 			or: [
     * 				{ favoriteFood: { eq: 'pizza' } },
     * 				{ favoriteFood: { eq: 'tacos' } },
     * 			]
     * 		}}
     * 	]
     * }
     * ```
     *
     * @param gql GraphQL style filter node.
     */ ModelPredicateCreator.transformGraphQLFilterNodeToPredicateAST = function(gql) {
        var _this = this;
        if (!isValid(gql)) throw new Error("Invalid GraphQL Condition or subtree: " + JSON.stringify(gql));
        if (isEmpty(gql)) return {
            type: "and",
            predicates: []
        };
        else if (isGroup(gql)) {
            var groupkey = Object.keys(gql)[0];
            var children = this.transformGraphQLFilterNodeToPredicateAST(gql[groupkey]);
            return {
                type: groupkey,
                predicates: Array.isArray(children) ? children : [
                    children
                ]
            };
        } else if (isComparison(gql)) {
            var operatorKey = Object.keys(gql)[0];
            return {
                operator: operatorKey,
                operand: gql[operatorKey]
            };
        } else {
            if (Array.isArray(gql)) return gql.map(function(o) {
                return _this.transformGraphQLFilterNodeToPredicateAST(o);
            });
            else {
                var fieldKey = Object.keys(gql)[0];
                return (0, _tslib.__assign)({
                    field: fieldKey
                }, this.transformGraphQLFilterNodeToPredicateAST(gql[fieldKey]));
            }
        }
    };
    /**
     * Accepts a GraphQL style filter predicate tree and transforms it into a predicate
     * that storage adapters understand. Example input:
     *
     * ```js
     * {
     * 	and: [
     * 		{ name: { eq: "Bob Jones" } },
     * 		{ age: { between: [32, 64] } },
     * 		{ not: {
     * 			or: [
     * 				{ favoriteFood: { eq: 'pizza' } },
     * 				{ favoriteFood: { eq: 'tacos' } },
     * 			]
     * 		}}
     * 	]
     * }
     * ```
     *
     * @param modelDefinition The model that the AST/predicate must be compatible with.
     * @param ast The graphQL style AST that should specify conditions for `modelDefinition`.
     */ ModelPredicateCreator.createFromAST = function(modelDefinition, ast) {
        var key = {};
        ModelPredicateCreator.predicateGroupsMap.set(key, this.transformGraphQLFilterNodeToPredicateAST(ast));
        return key;
    };
    /**
     * Map of storage predicates (key objects) to storage predicate AST's.
     */ ModelPredicateCreator.predicateGroupsMap = new WeakMap();
    return ModelPredicateCreator;
}();

},{"tslib":"9gMVn","../util":"89SDa","./sort":"HOG8Z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"HOG8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelSortPredicateCreator", ()=>ModelSortPredicateCreator);
var ModelSortPredicateCreator = /** @class */ function() {
    function ModelSortPredicateCreator() {}
    ModelSortPredicateCreator.createPredicateBuilder = function(modelDefinition) {
        var modelName = modelDefinition.name;
        var fieldNames = new Set(Object.keys(modelDefinition.fields));
        var handler;
        var predicate = new Proxy({}, handler = {
            get: function(_target, propertyKey, receiver) {
                var field = propertyKey;
                if (!fieldNames.has(field)) throw new Error("Invalid field for model. field: " + field + ", model: " + modelName);
                var result = function(sortDirection) {
                    var _a;
                    (_a = ModelSortPredicateCreator.sortPredicateGroupsMap.get(receiver)) === null || _a === void 0 || _a.push({
                        field: field,
                        sortDirection: sortDirection
                    });
                    return receiver;
                };
                return result;
            }
        });
        ModelSortPredicateCreator.sortPredicateGroupsMap.set(predicate, []);
        return predicate;
    };
    ModelSortPredicateCreator.isValidPredicate = function(predicate) {
        return ModelSortPredicateCreator.sortPredicateGroupsMap.has(predicate);
    };
    ModelSortPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelSortPredicateCreator.isValidPredicate(predicate)) throw new Error("The predicate is not valid");
        var predicateGroup = ModelSortPredicateCreator.sortPredicateGroupsMap.get(predicate);
        if (predicateGroup) return predicateGroup;
        else throw new Error("Predicate group not found");
    };
    // transforms cb-style predicate into Proxy
    ModelSortPredicateCreator.createFromExisting = function(modelDefinition, existing) {
        if (!existing || !modelDefinition) return undefined;
        return existing(ModelSortPredicateCreator.createPredicateBuilder(modelDefinition));
    };
    ModelSortPredicateCreator.sortPredicateGroupsMap = new WeakMap();
    return ModelSortPredicateCreator;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gwQJS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExclusiveStorage", ()=>ExclusiveStorage);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _zenPush = require("zen-push");
var _zenPushDefault = parcelHelpers.interopDefault(_zenPush);
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _utils = require("../sync/utils");
var _getDefaultAdapter = require("./adapter/getDefaultAdapter");
var _getDefaultAdapterDefault = parcelHelpers.interopDefault(_getDefaultAdapter);
var logger = new (0, _core.Logger)("DataStore");
var StorageClass = /** @class */ function() {
    function StorageClass(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId) {
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.getModelConstructorByModelName = getModelConstructorByModelName;
        this.modelInstanceCreator = modelInstanceCreator;
        this.adapter = adapter;
        this.sessionId = sessionId;
        this.adapter = this.adapter || (0, _getDefaultAdapterDefault.default)();
        this.pushStream = new (0, _zenPushDefault.default)();
    }
    StorageClass.getNamespace = function() {
        var namespace = {
            name: (0, _util.STORAGE),
            relationships: {},
            enums: {},
            models: {},
            nonModels: {}
        };
        return namespace;
    };
    StorageClass.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var resolve, reject;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.initialized !== undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        logger.debug("Starting Storage");
                        this.initialized = new Promise(function(res, rej) {
                            resolve = res;
                            reject = rej;
                        });
                        this.adapter.setUp(this.schema, this.namespaceResolver, this.modelInstanceCreator, this.getModelConstructorByModelName, this.sessionId).then(resolve, reject);
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StorageClass.prototype.save = function(model, condition, mutator, patchesTuple) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.save(model, condition)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(r) {
                            var _a = (0, _tslib.__read)(r, 2), savedElement = _a[0], opType = _a[1];
                            // truthy when save is called by the Merger
                            var syncResponse = !!mutator;
                            var updateMutationInput;
                            // don't attempt to calc mutation input when storage.save
                            // is called by Merger, i.e., when processing an AppSync response
                            if ((opType === (0, _types.OpType).UPDATE || opType === (0, _types.OpType).INSERT) && !syncResponse) {
                                //
                                // TODO: LOOK!!!
                                // the `model` used here is in effect regardless of what model
                                // comes back from adapter.save().
                                // Prior to fix, SQLite adapter had been returning two models
                                // of different types, resulting in invalid outbox entries.
                                //
                                // the bug is essentially fixed in SQLite adapter.
                                // leaving as-is, because it's currently unclear whether anything
                                // depends on this remaining as-is.
                                //
                                updateMutationInput = _this.getChangedFieldsInput(model, savedElement, patchesTuple);
                                // // an update without changed user fields
                                // => don't create mutationEvent
                                if (updateMutationInput === null) return result;
                            }
                            var element = updateMutationInput || savedElement;
                            var modelConstructor = Object.getPrototypeOf(savedElement).constructor;
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: condition && (0, _predicates.ModelPredicateCreator).getPredicates(condition, false) || null,
                                savedElement: savedElement
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    StorageClass.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var models, deleted, modelConstructor, namespaceName, modelDefinition, modelIds;
            var _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _b.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.delete(modelOrModelConstructor, condition)
                        ];
                    case 2:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), models = _a[0], deleted = _a[1];
                        modelConstructor = (0, _util.isModelConstructor)(modelOrModelConstructor) ? modelOrModelConstructor : Object.getPrototypeOf(modelOrModelConstructor || {}).constructor;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
                        modelIds = new Set(models.map(function(model) {
                            var modelId = (0, _utils.getIdentifierValue)(modelDefinition, model);
                            return modelId;
                        }));
                        if (!(0, _util.isModelConstructor)(modelOrModelConstructor) && !Array.isArray(deleted)) deleted = [
                            deleted
                        ];
                        deleted.forEach(function(model) {
                            var modelConstructor = Object.getPrototypeOf(model).constructor;
                            var theCondition;
                            if (!(0, _util.isModelConstructor)(modelOrModelConstructor)) {
                                var modelId = (0, _utils.getIdentifierValue)(modelDefinition, model);
                                theCondition = modelIds.has(modelId) ? (0, _predicates.ModelPredicateCreator).getPredicates(condition, false) : undefined;
                            }
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: (0, _types.OpType).DELETE,
                                element: model,
                                mutator: mutator,
                                condition: theCondition || null
                            });
                        });
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deleted
                            ]
                        ];
                }
            });
        });
    };
    StorageClass.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.query(modelConstructor, predicate, pagination)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    StorageClass.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.queryOne(modelConstructor, firstOrLast)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    StorageClass.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        var listenToAll = !modelConstructor;
        var _a = predicate && (0, _predicates.ModelPredicateCreator).getPredicates(predicate, false) || {}, predicates = _a.predicates, type = _a.type;
        var result = this.pushStream.observable.filter(function(_a) {
            var mutator = _a.mutator;
            return !skipOwn || mutator !== skipOwn;
        }).map(function(_a) {
            var _mutator = _a.mutator, message = (0, _tslib.__rest)(_a, [
                "mutator"
            ]);
            return message;
        });
        if (!listenToAll) result = result.filter(function(_a) {
            var model = _a.model, element = _a.element;
            if (modelConstructor !== model) return false;
            if (!!predicates && !!type) return (0, _util.validatePredicate)(element, type, predicates);
            return true;
        });
        return result;
    };
    StorageClass.prototype.clear = function(completeObservable) {
        if (completeObservable === void 0) completeObservable = true;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.initialized = undefined;
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.clear()
                        ];
                    case 1:
                        _a.sent();
                        if (completeObservable) this.pushStream.complete();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StorageClass.prototype.batchSave = function(modelConstructor, items, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.batchSave(modelConstructor, items)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), element = _b[0], opType = _b[1];
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: null
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    // returns null if no user fields were changed (determined by value comparison)
    StorageClass.prototype.getChangedFieldsInput = function(model, originalElement, patchesTuple) {
        var e_1, _a;
        var _b;
        var containsPatches = patchesTuple && patchesTuple.length;
        if (!containsPatches) return null;
        var _c = (0, _tslib.__read)(patchesTuple, 2), patches = _c[0], source = _c[1];
        var updatedElement = {};
        // extract array of updated fields from patches
        var updatedFields = patches.map(function(patch) {
            return patch.path && patch.path[0];
        });
        // check model def for association and replace with targetName if exists
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var namespace = this.namespaceResolver(modelConstructor);
        var fields = this.schema.namespaces[namespace].models[modelConstructor.name].fields;
        var _d = ((_b = this.schema.namespaces[namespace].keys) === null || _b === void 0 ? void 0 : _b[modelConstructor.name]) || {}, primaryKey = _d.primaryKey, _e = _d.compositeKeys, compositeKeys = _e === void 0 ? [] : _e;
        // set original values for these fields
        updatedFields.forEach(function(field) {
            var e_2, _a, e_3, _b, e_4, _c, e_5, _d, e_6, _e;
            var _f;
            var targetNames = (0, _types.isTargetNameAssociation)((_f = fields[field]) === null || _f === void 0 ? void 0 : _f.association);
            if (Array.isArray(targetNames)) try {
                // if field refers to a belongsTo relation, use the target field instead
                for(var targetNames_1 = (0, _tslib.__values)(targetNames), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()){
                    var targetName = targetNames_1_1.value;
                    // check field values by value. Ignore unchanged fields
                    if (!(0, _util.valuesEqual)(source[targetName], originalElement[targetName])) {
                        // if the field was updated to 'undefined', replace with 'null' for compatibility with JSON and GraphQL
                        updatedElement[targetName] = originalElement[targetName] === undefined ? null : originalElement[targetName];
                        try {
                            for(var compositeKeys_1 = (e_3 = void 0, (0, _tslib.__values)(compositeKeys)), compositeKeys_1_1 = compositeKeys_1.next(); !compositeKeys_1_1.done; compositeKeys_1_1 = compositeKeys_1.next()){
                                var fieldSet = compositeKeys_1_1.value;
                                // include all of the fields that comprise the composite key
                                if (fieldSet.has(targetName)) try {
                                    for(var fieldSet_1 = (e_4 = void 0, (0, _tslib.__values)(fieldSet)), fieldSet_1_1 = fieldSet_1.next(); !fieldSet_1_1.done; fieldSet_1_1 = fieldSet_1.next()){
                                        var compositeField = fieldSet_1_1.value;
                                        updatedElement[compositeField] = originalElement[compositeField];
                                    }
                                } catch (e_4_1) {
                                    e_4 = {
                                        error: e_4_1
                                    };
                                } finally{
                                    try {
                                        if (fieldSet_1_1 && !fieldSet_1_1.done && (_c = fieldSet_1.return)) _c.call(fieldSet_1);
                                    } finally{
                                        if (e_4) throw e_4.error;
                                    }
                                }
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (compositeKeys_1_1 && !compositeKeys_1_1.done && (_b = compositeKeys_1.return)) _b.call(compositeKeys_1);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (targetNames_1_1 && !targetNames_1_1.done && (_a = targetNames_1.return)) _a.call(targetNames_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            else {
                // Backwards compatibility pre-CPK
                // if field refers to a belongsTo relation, use the target field instead
                var key = targetNames || field;
                // check field values by value. Ignore unchanged fields
                if (!(0, _util.valuesEqual)(source[key], originalElement[key])) {
                    // if the field was updated to 'undefined', replace with 'null' for compatibility with JSON and GraphQL
                    updatedElement[key] = originalElement[key] === undefined ? null : originalElement[key];
                    try {
                        for(var compositeKeys_2 = (0, _tslib.__values)(compositeKeys), compositeKeys_2_1 = compositeKeys_2.next(); !compositeKeys_2_1.done; compositeKeys_2_1 = compositeKeys_2.next()){
                            var fieldSet = compositeKeys_2_1.value;
                            // include all of the fields that comprise the composite key
                            if (fieldSet.has(key)) try {
                                for(var fieldSet_2 = (e_6 = void 0, (0, _tslib.__values)(fieldSet)), fieldSet_2_1 = fieldSet_2.next(); !fieldSet_2_1.done; fieldSet_2_1 = fieldSet_2.next()){
                                    var compositeField = fieldSet_2_1.value;
                                    updatedElement[compositeField] = originalElement[compositeField];
                                }
                            } catch (e_6_1) {
                                e_6 = {
                                    error: e_6_1
                                };
                            } finally{
                                try {
                                    if (fieldSet_2_1 && !fieldSet_2_1.done && (_e = fieldSet_2.return)) _e.call(fieldSet_2);
                                } finally{
                                    if (e_6) throw e_6.error;
                                }
                            }
                        }
                    } catch (e_5_1) {
                        e_5 = {
                            error: e_5_1
                        };
                    } finally{
                        try {
                            if (compositeKeys_2_1 && !compositeKeys_2_1.done && (_d = compositeKeys_2.return)) _d.call(compositeKeys_2);
                        } finally{
                            if (e_5) throw e_5.error;
                        }
                    }
                }
            }
        });
        // Exit early when there are no changes introduced in the update mutation
        if (Object.keys(updatedElement).length === 0) return null;
        // include field(s) from custom PK if one is specified for the model
        if (primaryKey && primaryKey.length) try {
            for(var primaryKey_1 = (0, _tslib.__values)(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()){
                var pkField = primaryKey_1_1.value;
                updatedElement[pkField] = originalElement[pkField];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (primaryKey_1_1 && !primaryKey_1_1.done && (_a = primaryKey_1.return)) _a.call(primaryKey_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var id = originalElement.id, _version = originalElement._version, _lastChangedAt = originalElement._lastChangedAt, _deleted = originalElement._deleted;
        // For update mutations we only want to send fields with changes
        // and the required internal fields
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedElement), {
            id: id,
            _version: _version,
            _lastChangedAt: _lastChangedAt,
            _deleted: _deleted
        });
    };
    return StorageClass;
}();
var ExclusiveStorage = /** @class */ function() {
    function ExclusiveStorage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId) {
        this.mutex = new (0, _core.Mutex)();
        this.storage = new StorageClass(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId);
    }
    ExclusiveStorage.prototype.runExclusive = function(fn) {
        return this.mutex.runExclusive(fn.bind(this, this.storage));
    };
    ExclusiveStorage.prototype.save = function(model, condition, mutator, patchesTuple) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.save(model, condition, mutator, patchesTuple);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        if ((0, _util.isModelConstructor)(modelOrModelConstructor)) {
                            var modelConstructor = modelOrModelConstructor;
                            return storage.delete(modelConstructor, condition, mutator);
                        } else {
                            var model = modelOrModelConstructor;
                            return storage.delete(model, condition, mutator);
                        }
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.query(modelConstructor, predicate, pagination);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.queryOne(modelConstructor, firstOrLast);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.getNamespace = function() {
        return StorageClass.getNamespace();
    };
    ExclusiveStorage.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        return this.storage.observe(modelConstructor, predicate, skipOwn);
    };
    ExclusiveStorage.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runExclusive(function(storage) {
                                return storage.clear();
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ExclusiveStorage.prototype.batchSave = function(modelConstructor, items) {
        return this.storage.batchSave(modelConstructor, items);
    };
    ExclusiveStorage.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.storage.init()
                ];
            });
        });
    };
    return ExclusiveStorage;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","zen-push":"lKZNt","../predicates":"lUiza","../types":"KjGQP","../util":"89SDa","../sync/utils":"60Gn0","./adapter/getDefaultAdapter":"aNupa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lKZNt":[function(require,module,exports) {
"use strict";
var Observable = require("8ee1d41987ca192");
function addMethods(target, methods) {
    Object.keys(methods).forEach(function(k) {
        var desc = Object.getOwnPropertyDescriptor(methods, k);
        desc.enumerable = false;
        Object.defineProperty(target, k, desc);
    });
}
function send(p, message, value) {
    if (p._observer) sendMessage(p._observer, message, value);
    else if (p._observers) {
        var list = [];
        p._observers.forEach(function(to) {
            list.push(to);
        });
        list.forEach(function(to) {
            sendMessage(to, message, value);
        });
    }
}
function sendMessage(observer, message, value) {
    if (observer.closed) return;
    switch(message){
        case "next":
            return observer.next(value);
        case "error":
            return observer.error(value);
        case "complete":
            return observer.complete(value);
    }
}
function hasObserver(p) {
    return p._observer || p._observers && p._observers.size > 0;
}
function addObserver(p, observer) {
    if (p._observers) p._observers.add(observer);
    else if (!p._observer) p._observer = observer;
    else {
        p._observers = new Set();
        p._observers.add(p._observer);
        p._observers.add(observer);
        p._observer = null;
    }
}
function deleteObserver(p, observer) {
    if (p._observers) p._observers.delete(observer);
    else if (p._observer === observer) p._observer = null;
}
function notifyStart(p, opts) {
    !hasObserver(p) && opts && opts.start && opts.start();
}
function notifyPause(p, opts) {
    !hasObserver(p) && opts && opts.pause && opts.pause();
}
function PushStream(opts) {
    var p = this;
    this._observer = null;
    this._observers = null;
    this._observable = new Observable(function(observer) {
        notifyStart(p, opts);
        addObserver(p, observer);
        return function() {
            deleteObserver(p, observer);
            notifyPause(p, opts);
        };
    });
}
addMethods(PushStream.prototype, {
    get observable () {
        return this._observable;
    },
    get observed () {
        return hasObserver(this);
    },
    next: function(x) {
        send(this, "next", x);
    },
    error: function(e) {
        send(this, "error", e);
    },
    complete: function(x) {
        send(this, "complete", x);
    }
});
module.exports = PushStream;

},{"8ee1d41987ca192":"lCQg4"}],"lCQg4":[function(require,module,exports) {
module.exports = require("b4c55f2c243ab7f3").Observable;

},{"b4c55f2c243ab7f3":"i5UPo"}],"i5UPo":[function(require,module,exports) {
"use strict";
(function(fn, name) {
    var e;
    fn(exports, module);
})(function(exports1, module1) {
    function hasSymbol(name) {
        return typeof Symbol === "function" && Boolean(Symbol[name]);
    }
    function getSymbol(name) {
        return hasSymbol(name) ? Symbol[name] : "@@" + name;
    }
    // Ponyfill Symbol.observable for interoperability with other libraries
    if (typeof Symbol === "function" && !Symbol.observable) Symbol.observable = Symbol("observable");
    // === Abstract Operations ===
    function hostReportError(e) {
        setTimeout(function() {
            throw e;
        });
    }
    function getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== "function") throw new TypeError(value + " is not a function");
        return value;
    }
    function getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[getSymbol("species")];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : Observable;
    }
    function addMethods(target, methods) {
        Object.keys(methods).forEach(function(k) {
            var desc = Object.getOwnPropertyDescriptor(methods, k);
            desc.enumerable = false;
            Object.defineProperty(target, k, desc);
        });
    }
    function cleanupSubscription(subscription) {
        // Assert:  observer._observer is undefined
        var cleanup = subscription._cleanup;
        if (!cleanup) return;
        // Drop the reference to the cleanup function so that we won't call it
        // more than once
        subscription._cleanup = undefined;
        // Call the cleanup function
        try {
            cleanup();
        } catch (e) {
            hostReportError(e);
        }
    }
    function subscriptionClosed(subscription) {
        return subscription._observer === undefined;
    }
    function closeSubscription(subscription) {
        if (subscriptionClosed(subscription)) return;
        subscription._observer = undefined;
        cleanupSubscription(subscription);
    }
    function cleanupFromSubscription(subscription) {
        return function() {
            subscription.unsubscribe();
        };
    }
    function Subscription(observer, subscriber) {
        // Assert: subscriber is callable
        // The observer must be an object
        if (Object(observer) !== observer) throw new TypeError("Observer must be an object");
        this._cleanup = undefined;
        this._observer = observer;
        try {
            var start$0 = getMethod(observer, "start");
            if (start$0) start$0.call(observer, this);
        } catch (e) {
            hostReportError(e);
        }
        if (subscriptionClosed(this)) return;
        observer = new SubscriptionObserver(this);
        try {
            // Call the subscriber function
            var cleanup$0 = subscriber.call(undefined, observer);
            // The return value must be undefined, null, a subscription object, or a function
            if (cleanup$0 != null) {
                if (typeof cleanup$0.unsubscribe === "function") cleanup$0 = cleanupFromSubscription(cleanup$0);
                else if (typeof cleanup$0 !== "function") throw new TypeError(cleanup$0 + " is not a function");
                this._cleanup = cleanup$0;
            }
        } catch (e) {
            // If an error occurs during startup, then attempt to send the error
            // to the observer
            observer.error(e);
            return;
        }
        // If the stream is already finished, then perform cleanup
        if (subscriptionClosed(this)) cleanupSubscription(this);
    }
    addMethods(Subscription.prototype = {}, {
        get closed () {
            return subscriptionClosed(this);
        },
        unsubscribe: function() {
            closeSubscription(this);
        }
    });
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    addMethods(SubscriptionObserver.prototype = {}, {
        get closed () {
            return subscriptionClosed(this._subscription);
        },
        next: function(value) {
            var subscription = this._subscription;
            // If the stream is closed, then return undefined
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            try {
                // If the observer has a "next" method, send the next value
                var m$0 = getMethod(observer, "next");
                if (m$0) m$0.call(observer, value);
            } catch (e) {
                hostReportError(e);
            }
        },
        error: function(value) {
            var subscription = this._subscription;
            // If the stream is closed, throw the error to the caller
            if (subscriptionClosed(subscription)) {
                hostReportError(value);
                return;
            }
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$1 = getMethod(observer, "error");
                if (m$1) m$1.call(observer, value);
                else throw value;
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        },
        complete: function() {
            var subscription = this._subscription;
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$2 = getMethod(observer, "complete");
                if (m$2) m$2.call(observer);
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        }
    });
    function Observable(subscriber) {
        // Constructor cannot be called as a function
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        // The stream subscriber must be a function
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    addMethods(Observable.prototype, {
        subscribe: function(observer) {
            for(var args = [], __$0 = 1; __$0 < arguments.length; ++__$0)args.push(arguments[__$0]);
            if (typeof observer === "function") observer = {
                next: observer,
                error: args[0],
                complete: args[1]
            };
            else if (typeof observer !== "object" || observer === null) observer = {};
            return new Subscription(observer, this._subscriber);
        },
        forEach: function(fn) {
            var __this = this;
            return new Promise(function(resolve, reject) {
                if (typeof fn !== "function") return Promise.reject(new TypeError(fn + " is not a function"));
                __this.subscribe({
                    _subscription: null,
                    start: function(subscription) {
                        if (Object(subscription) !== subscription) throw new TypeError(subscription + " is not an object");
                        this._subscription = subscription;
                    },
                    next: function(value) {
                        var subscription = this._subscription;
                        if (subscription.closed) return;
                        try {
                            fn(value);
                        } catch (err) {
                            reject(err);
                            subscription.unsubscribe();
                        }
                    },
                    error: reject,
                    complete: resolve
                });
            });
        },
        map: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        try {
                            value = fn(value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        observer.complete();
                    }
                });
            });
        },
        filter: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        try {
                            if (!fn(value)) return;
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        observer.complete();
                    }
                });
            });
        },
        reduce: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            var hasSeed = arguments.length > 1;
            var hasValue = false;
            var seed = arguments[1];
            var acc = seed;
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        var first = !hasValue;
                        hasValue = true;
                        if (!first || hasSeed) try {
                            acc = fn(acc, value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        else acc = value;
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                        observer.next(acc);
                        observer.complete();
                    }
                });
            });
        }
    });
    Object.defineProperty(Observable.prototype, getSymbol("observable"), {
        value: function() {
            return this;
        },
        writable: true,
        configurable: true
    });
    addMethods(Observable, {
        from: function(x) {
            var C = typeof this === "function" ? this : Observable;
            if (x == null) throw new TypeError(x + " is not an object");
            var method = getMethod(x, getSymbol("observable"));
            if (method) {
                var observable$0 = method.call(x);
                if (Object(observable$0) !== observable$0) throw new TypeError(observable$0 + " is not an object");
                if (observable$0.constructor === C) return observable$0;
                return new C(function(observer) {
                    return observable$0.subscribe(observer);
                });
            }
            if (hasSymbol("iterator") && (method = getMethod(x, getSymbol("iterator")))) return new C(function(observer) {
                for(var __$0 = method.call(x)[Symbol.iterator](), __$1; __$1 = __$0.next(), !__$1.done;){
                    var item$0 = __$1.value;
                    observer.next(item$0);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            if (Array.isArray(x)) return new C(function(observer) {
                for(var i$0 = 0; i$0 < x.length; ++i$0){
                    observer.next(x[i$0]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            throw new TypeError(x + " is not observable");
        },
        of: function() {
            for(var items = [], __$0 = 0; __$0 < arguments.length; ++__$0)items.push(arguments[__$0]);
            var C = typeof this === "function" ? this : Observable;
            return new C(function(observer) {
                for(var i$1 = 0; i$1 < items.length; ++i$1){
                    observer.next(items[i$1]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        }
    });
    Object.defineProperty(Observable, getSymbol("species"), {
        get: function() {
            return this;
        },
        configurable: true
    });
    Object.defineProperty(Observable, "extensions", {
        value: {
            observableSymbol: getSymbol("observable"),
            setHostReportError: function(fn) {
                hostReportError = fn;
            }
        }
    });
    exports1.Observable = Observable;
}, "*");

},{}],"60Gn0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransformerMutationType", ()=>TransformerMutationType);
parcelHelpers.export(exports, "getMetadataFields", ()=>getMetadataFields);
parcelHelpers.export(exports, "generateSelectionSet", ()=>generateSelectionSet);
parcelHelpers.export(exports, "getAuthorizationRules", ()=>getAuthorizationRules);
parcelHelpers.export(exports, "buildSubscriptionGraphQLOperation", ()=>buildSubscriptionGraphQLOperation);
parcelHelpers.export(exports, "buildGraphQLOperation", ()=>buildGraphQLOperation);
parcelHelpers.export(exports, "createMutationInstanceFromModelOperation", ()=>createMutationInstanceFromModelOperation);
parcelHelpers.export(exports, "predicateToGraphQLCondition", ()=>predicateToGraphQLCondition);
/**
 * @param predicatesGroup - Predicate Group
    @returns GQL Filter Expression from Predicate Group
    
    @remarks Flattens redundant list predicates
    @example

    ```js
    { and:[{ and:[{ username:  { eq: 'bob' }}] }] }
    ```
    Becomes
    ```js
    { and:[{ username: { eq: 'bob' }}] }
    ```
    */ parcelHelpers.export(exports, "predicateToGraphQLFilter", ()=>predicateToGraphQLFilter);
/**
 *
 * @param group - selective sync predicate group
 * @returns set of distinct field names in the filter group
 */ parcelHelpers.export(exports, "filterFields", ()=>filterFields);
/**
 *
 * @param modelDefinition
 * @returns set of field names used with dynamic auth modes configured for the provided model definition
 */ parcelHelpers.export(exports, "dynamicAuthFields", ()=>dynamicAuthFields);
/**
 *
 * @param group - selective sync predicate group
 * @returns the total number of OR'd predicates in the filter group
 *
 * @example returns 2
 * ```js
 * { type: "or", predicates: [
 * { field: "username", operator: "beginsWith", operand: "a" },
 * { field: "title", operator: "contains", operand: "abc" },
 * ]}
 * ```
 */ parcelHelpers.export(exports, "countFilterCombinations", ()=>countFilterCombinations);
/**
 *
 * @param group - selective sync predicate group
 * @returns name of repeated field | null
 *
 * @example returns "username"
 * ```js
 * { type: "and", predicates: [
 * 		{ field: "username", operator: "beginsWith", operand: "a" },
 * 		{ field: "username", operator: "contains", operand: "abc" },
 * ] }
 * ```
 */ parcelHelpers.export(exports, "repeatedFieldInGroup", ()=>repeatedFieldInGroup);
parcelHelpers.export(exports, "RTFError", ()=>RTFError);
parcelHelpers.export(exports, "generateRTFRemediation", ()=>generateRTFRemediation);
parcelHelpers.export(exports, "getUserGroupsFromToken", ()=>getUserGroupsFromToken);
parcelHelpers.export(exports, "getModelAuthModes", ()=>getModelAuthModes);
parcelHelpers.export(exports, "getForbiddenError", ()=>getForbiddenError);
parcelHelpers.export(exports, "getClientSideAuthError", ()=>getClientSideAuthError);
parcelHelpers.export(exports, "getTokenForCustomAuth", ()=>getTokenForCustomAuth);
// Util that takes a modelDefinition and model and returns either the id value(s) or the custom primary key value(s)
parcelHelpers.export(exports, "getIdentifierValue", ()=>getIdentifierValue);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _apiGraphql = require("@aws-amplify/api-graphql");
var _api = require("@aws-amplify/api");
var _core = require("@aws-amplify/core");
var _types = require("../types");
var _util = require("../util");
var logger = new (0, _core.Logger)("DataStore");
var GraphQLOperationType;
(function(GraphQLOperationType) {
    GraphQLOperationType["LIST"] = "query";
    GraphQLOperationType["CREATE"] = "mutation";
    GraphQLOperationType["UPDATE"] = "mutation";
    GraphQLOperationType["DELETE"] = "mutation";
    GraphQLOperationType["GET"] = "query";
})(GraphQLOperationType || (GraphQLOperationType = {}));
var TransformerMutationType;
(function(TransformerMutationType) {
    TransformerMutationType["CREATE"] = "Create";
    TransformerMutationType["UPDATE"] = "Update";
    TransformerMutationType["DELETE"] = "Delete";
    TransformerMutationType["GET"] = "Get";
})(TransformerMutationType || (TransformerMutationType = {}));
var dummyMetadata = {
    _version: undefined,
    _lastChangedAt: undefined,
    _deleted: undefined
};
var metadataFields = Object.keys(dummyMetadata);
function getMetadataFields() {
    return metadataFields;
}
function generateSelectionSet(namespace, modelDefinition) {
    var scalarFields = getScalarFields(modelDefinition);
    var nonModelFields = getNonModelFields(namespace, modelDefinition);
    var implicitOwnerField = getImplicitOwnerField(modelDefinition, scalarFields);
    var scalarAndMetadataFields = Object.values(scalarFields).map(function(_a) {
        var name = _a.name;
        return name;
    }).concat(implicitOwnerField).concat(nonModelFields);
    if ((0, _types.isSchemaModel)(modelDefinition)) scalarAndMetadataFields = scalarAndMetadataFields.concat(getMetadataFields()).concat(getConnectionFields(modelDefinition, namespace));
    var result = scalarAndMetadataFields.join("\n");
    return result;
}
function getImplicitOwnerField(modelDefinition, scalarFields) {
    var ownerFields = getOwnerFields(modelDefinition);
    if (!scalarFields.owner && ownerFields.includes("owner")) return [
        "owner"
    ];
    return [];
}
function getOwnerFields(modelDefinition) {
    var ownerFields = [];
    if ((0, _types.isSchemaModelWithAttributes)(modelDefinition)) modelDefinition.attributes.forEach(function(attr) {
        if (attr.properties && attr.properties.rules) {
            var rule = attr.properties.rules.find(function(rule) {
                return rule.allow === "owner";
            });
            if (rule && rule.ownerField) ownerFields.push(rule.ownerField);
        }
    });
    return ownerFields;
}
function getScalarFields(modelDefinition) {
    var fields = modelDefinition.fields;
    var result = Object.values(fields).filter(function(field) {
        if ((0, _types.isGraphQLScalarType)(field.type) || (0, _types.isEnumFieldType)(field.type)) return true;
        return false;
    }).reduce(function(acc, field) {
        acc[field.name] = field;
        return acc;
    }, {});
    return result;
}
// Used for generating the selection set for queries and mutations
function getConnectionFields(modelDefinition, namespace) {
    var result = [];
    Object.values(modelDefinition.fields).filter(function(_a) {
        var association = _a.association;
        return association && Object.keys(association).length;
    }).forEach(function(_a) {
        var name = _a.name, association = _a.association;
        var connectionType = (association || {}).connectionType;
        switch(connectionType){
            case "HAS_ONE":
            case "HAS_MANY":
                break;
            case "BELONGS_TO":
                if ((0, _types.isTargetNameAssociation)(association)) {
                    // New codegen (CPK)
                    if (association.targetNames && association.targetNames.length > 0) {
                        // Need to retrieve relations in order to get connected model keys
                        var _b = (0, _tslib.__read)((0, _util.establishRelationAndKeys)(namespace), 1), relations = _b[0];
                        var connectedModelName = modelDefinition.fields[name].type["model"];
                        var byPkIndex = relations[connectedModelName].indexes.find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), name = _b[0];
                            return name === "byPk";
                        });
                        var keyFields = byPkIndex && byPkIndex[1];
                        var keyFieldSelectionSet = keyFields === null || keyFields === void 0 ? void 0 : keyFields.join(" ");
                        // We rely on `_deleted` when we process the sync query (e.g. in batchSave in the adapters)
                        result.push(name + " { " + keyFieldSelectionSet + " _deleted }");
                    } else // backwards-compatability for schema generated prior to custom primary key support
                    result.push(name + " { id _deleted }");
                }
                break;
            default:
                throw new Error("Invalid connection type " + connectionType);
        }
    });
    return result;
}
function getNonModelFields(namespace, modelDefinition) {
    var result = [];
    Object.values(modelDefinition.fields).forEach(function(_a) {
        var name = _a.name, type = _a.type;
        if ((0, _types.isNonModelFieldType)(type)) {
            var typeDefinition = namespace.nonModels[type.nonModel];
            var scalarFields = Object.values(getScalarFields(typeDefinition)).map(function(_a) {
                var name = _a.name;
                return name;
            });
            var nested_1 = [];
            Object.values(typeDefinition.fields).forEach(function(field) {
                var type = field.type, name = field.name;
                if ((0, _types.isNonModelFieldType)(type)) {
                    var typeDefinition_1 = namespace.nonModels[type.nonModel];
                    nested_1.push(name + " { " + generateSelectionSet(namespace, typeDefinition_1) + " }");
                }
            });
            result.push(name + " { " + scalarFields.join(" ") + " " + nested_1.join(" ") + " }");
        }
    });
    return result;
}
function getAuthorizationRules(modelDefinition) {
    // Searching for owner authorization on attributes
    var authConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
        return attr && attr.type === "auth";
    });
    var _a = (authConfig || {}).properties, _b = (_a === void 0 ? {} : _a).rules, rules = _b === void 0 ? [] : _b;
    var resultRules = [];
    // Multiple rules can be declared for allow: owner
    rules.forEach(function(rule) {
        // setting defaults for backwards compatibility with old cli
        var _a = rule.identityClaim, identityClaim = _a === void 0 ? "cognito:username" : _a, _b = rule.ownerField, ownerField = _b === void 0 ? "owner" : _b, _c = rule.operations, operations = _c === void 0 ? [
            "create",
            "update",
            "delete",
            "read"
        ] : _c, _d = rule.provider, provider = _d === void 0 ? "userPools" : _d, _e = rule.groupClaim, groupClaim = _e === void 0 ? "cognito:groups" : _e, _f = rule.allow, authStrategy = _f === void 0 ? "iam" : _f, _g = rule.groups, groups = _g === void 0 ? [] : _g, _h = rule.groupsField, groupsField = _h === void 0 ? "" : _h;
        var isReadAuthorized = operations.includes("read");
        var isOwnerAuth = authStrategy === "owner";
        if (!isReadAuthorized && !isOwnerAuth) return;
        var authRule = {
            identityClaim: identityClaim,
            ownerField: ownerField,
            provider: provider,
            groupClaim: groupClaim,
            authStrategy: authStrategy,
            groups: groups,
            groupsField: groupsField,
            areSubscriptionsPublic: false
        };
        if (isOwnerAuth) {
            // look for the subscription level override
            // only pay attention to the public level
            var modelConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
                return attr && attr.type === "model";
            });
            // find the subscriptions level. ON is default
            var _j = (modelConfig || {}).properties, _k = (_j === void 0 ? {} : _j).subscriptions, _l = (_k === void 0 ? {} : _k).level, level = _l === void 0 ? "on" : _l;
            // treat subscriptions as public for owner auth with unprotected reads
            // when `read` is omitted from `operations`
            authRule.areSubscriptionsPublic = !operations.includes("read") || level === "public";
        }
        if (isOwnerAuth) {
            // owner rules has least priority
            resultRules.push(authRule);
            return;
        }
        resultRules.unshift(authRule);
    });
    return resultRules;
}
function buildSubscriptionGraphQLOperation(namespace, modelDefinition, transformerMutationType, isOwnerAuthorization, ownerField, filterArg) {
    if (filterArg === void 0) filterArg = false;
    var selectionSet = generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name;
    var opName = "on" + transformerMutationType + typeName;
    var docArgs = [];
    var opArgs = [];
    if (filterArg) {
        docArgs.push("$filter: ModelSubscription" + typeName + "FilterInput");
        opArgs.push("filter: $filter");
    }
    if (isOwnerAuthorization) {
        docArgs.push("$" + ownerField + ": String!");
        opArgs.push(ownerField + ": $" + ownerField);
    }
    var docStr = docArgs.length ? "(" + docArgs.join(",") + ")" : "";
    var opStr = opArgs.length ? "(" + opArgs.join(",") + ")" : "";
    return [
        transformerMutationType,
        opName,
        "subscription operation" + docStr + "{\n			" + opName + opStr + "{\n				" + selectionSet + "\n			}\n		}"
    ];
}
function buildGraphQLOperation(namespace, modelDefinition, graphQLOpType) {
    var selectionSet = generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name, pluralTypeName = modelDefinition.pluralName;
    var operation;
    var documentArgs;
    var operationArgs;
    var transformerMutationType;
    switch(graphQLOpType){
        case "LIST":
            operation = "sync" + pluralTypeName;
            documentArgs = "($limit: Int, $nextToken: String, $lastSync: AWSTimestamp, $filter: Model" + typeName + "FilterInput)";
            operationArgs = "(limit: $limit, nextToken: $nextToken, lastSync: $lastSync, filter: $filter)";
            selectionSet = "items {\n							" + selectionSet + "\n						}\n						nextToken\n						startedAt";
            break;
        case "CREATE":
            operation = "create" + typeName;
            documentArgs = "($input: Create" + typeName + "Input!)";
            operationArgs = "(input: $input)";
            transformerMutationType = TransformerMutationType.CREATE;
            break;
        case "UPDATE":
            operation = "update" + typeName;
            documentArgs = "($input: Update" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = "(input: $input, condition: $condition)";
            transformerMutationType = TransformerMutationType.UPDATE;
            break;
        case "DELETE":
            operation = "delete" + typeName;
            documentArgs = "($input: Delete" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = "(input: $input, condition: $condition)";
            transformerMutationType = TransformerMutationType.DELETE;
            break;
        case "GET":
            operation = "get" + typeName;
            documentArgs = "($id: ID!)";
            operationArgs = "(id: $id)";
            transformerMutationType = TransformerMutationType.GET;
            break;
        default:
            throw new Error("Invalid graphQlOpType " + graphQLOpType);
    }
    return [
        [
            transformerMutationType,
            operation,
            GraphQLOperationType[graphQLOpType] + " operation" + documentArgs + "{\n		" + operation + operationArgs + "{\n			" + selectionSet + "\n		}\n	}"
        ]
    ];
}
function createMutationInstanceFromModelOperation(relationships, modelDefinition, opType, model, element, condition, MutationEventConstructor, modelInstanceCreator, id) {
    var operation;
    switch(opType){
        case (0, _types.OpType).INSERT:
            operation = TransformerMutationType.CREATE;
            break;
        case (0, _types.OpType).UPDATE:
            operation = TransformerMutationType.UPDATE;
            break;
        case (0, _types.OpType).DELETE:
            operation = TransformerMutationType.DELETE;
            break;
        default:
            throw new Error("Invalid opType " + opType);
    }
    // stringify nested objects of type AWSJSON
    // this allows us to return parsed JSON to users (see `castInstanceType()` in datastore.ts),
    // but still send the object correctly over the wire
    var replacer = function(k, v) {
        var isAWSJSON = k && v !== null && typeof v === "object" && modelDefinition.fields[k] && modelDefinition.fields[k].type === "AWSJSON";
        if (isAWSJSON) return JSON.stringify(v);
        return v;
    };
    var modelId = getIdentifierValue(modelDefinition, element);
    var optionalId = (0, _types.OpType).INSERT && id ? {
        id: id
    } : {};
    var mutationEvent = modelInstanceCreator(MutationEventConstructor, (0, _tslib.__assign)((0, _tslib.__assign)({}, optionalId), {
        data: JSON.stringify(element, replacer),
        modelId: modelId,
        model: model.name,
        operation: operation,
        condition: JSON.stringify(condition)
    }));
    return mutationEvent;
}
function predicateToGraphQLCondition(predicate, modelDefinition) {
    var result = {};
    if (!predicate || !Array.isArray(predicate.predicates)) return result;
    // This is compatible with how the GQL Transform currently generates the Condition Input,
    // i.e. any PK and SK fields are omitted and can't be used as conditions.
    // However, I think this limits usability.
    // What if we want to delete all records where SK > some value
    // Or all records where PK = some value but SKs are different values
    // TODO: if the Transform gets updated we'll need to modify this logic to only omit
    // key fields from the predicate/condition when ALL of the keyFields are present and using `eq` operators
    var keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    return predicateToGraphQLFilter(predicate, keyFields);
}
function predicateToGraphQLFilter(predicatesGroup, fieldsToOmit, root) {
    if (fieldsToOmit === void 0) fieldsToOmit = [];
    if (root === void 0) root = true;
    var result = {};
    if (!predicatesGroup || !Array.isArray(predicatesGroup.predicates)) return result;
    var type = predicatesGroup.type, predicates = predicatesGroup.predicates;
    var isList = type === "and" || type === "or";
    result[type] = isList ? [] : {};
    var children = [];
    predicates.forEach(function(predicate) {
        var _a, _b;
        if ((0, _types.isPredicateObj)(predicate)) {
            var field = predicate.field, operator = predicate.operator, operand = predicate.operand;
            if (fieldsToOmit.includes(field)) return;
            var gqlField = (_a = {}, _a[field] = (_b = {}, _b[operator] = operand, _b), _a);
            children.push(gqlField);
            return;
        }
        var child = predicateToGraphQLFilter(predicate, fieldsToOmit, false);
        if (Object.keys(child).length > 0) children.push(child);
    });
    // flatten redundant list predicates
    if (children.length === 1) {
        var _a = (0, _tslib.__read)(children, 1), child = _a[0];
        if (// any nested list node
        isList && !root || // root list node where the only child is also a list node
        isList && root && ("and" in child || "or" in child)) {
            delete result[type];
            Object.assign(result, child);
            return result;
        }
    }
    children.forEach(function(child) {
        if (isList) result[type].push(child);
        else result[type] = child;
    });
    if (isList) {
        if (result[type].length === 0) return {};
    } else {
        if (Object.keys(result[type]).length === 0) return {};
    }
    return result;
}
function filterFields(group) {
    var fields = new Set();
    if (!group || !Array.isArray(group.predicates)) return fields;
    var predicates = group.predicates;
    var stack = (0, _tslib.__spread)(predicates);
    while(stack.length > 0){
        var current = stack.pop();
        if ((0, _types.isPredicateObj)(current)) fields.add(current.field);
        else if ((0, _types.isPredicateGroup)(current)) stack.push.apply(stack, (0, _tslib.__spread)(current.predicates));
    }
    return fields;
}
function dynamicAuthFields(modelDefinition) {
    var e_1, _a;
    var rules = getAuthorizationRules(modelDefinition);
    var fields = new Set();
    try {
        for(var rules_1 = (0, _tslib.__values)(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()){
            var rule = rules_1_1.value;
            if (rule.groupsField && !rule.groups.length) // dynamic group rule will have no values in `rule.groups`
            fields.add(rule.groupsField);
            else if (rule.ownerField) fields.add(rule.ownerField);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (rules_1_1 && !rules_1_1.done && (_a = rules_1.return)) _a.call(rules_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return fields;
}
function countFilterCombinations(group) {
    if (!group || !Array.isArray(group.predicates)) return 0;
    var count = 0;
    var stack = [
        group
    ];
    while(stack.length > 0){
        var current = stack.pop();
        if ((0, _types.isPredicateGroup)(current)) {
            var predicates = current.predicates, type = current.type;
            // ignore length = 1; groups with 1 predicate will get flattened when converted to gqlFilter
            if (type === "or" && predicates.length > 1) count += predicates.length;
            stack.push.apply(stack, (0, _tslib.__spread)(predicates));
        }
    }
    // if we didn't encounter any OR groups, default to 1
    return count || 1;
}
function repeatedFieldInGroup(group) {
    if (!group || !Array.isArray(group.predicates)) return null;
    // convert to filter in order to flatten redundant groups
    var gqlFilter = predicateToGraphQLFilter(group);
    var stack = [
        gqlFilter
    ];
    var hasGroupRepeatedFields = function(fields) {
        var e_2, _a;
        var seen = {};
        try {
            for(var fields_1 = (0, _tslib.__values)(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()){
                var f = fields_1_1.value;
                var _b = (0, _tslib.__read)(Object.keys(f), 1), fieldName = _b[0];
                if (seen[fieldName]) return fieldName;
                seen[fieldName] = true;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return null;
    };
    while(stack.length > 0){
        var current = stack.pop();
        var _a = (0, _tslib.__read)(Object.keys(current), 1), key = _a[0];
        var values = current[key];
        if (!Array.isArray(values)) return null;
        // field value will be single object
        var predicateObjects = values.filter(function(v) {
            return !Array.isArray(Object.values(v)[0]);
        });
        // group value will be an array
        var predicateGroups = values.filter(function(v) {
            return Array.isArray(Object.values(v)[0]);
        });
        if (key === "and") {
            var repeatedField = hasGroupRepeatedFields(predicateObjects);
            if (repeatedField) return repeatedField;
        }
        stack.push.apply(stack, (0, _tslib.__spread)(predicateGroups));
    }
    return null;
}
var RTFError;
(function(RTFError) {
    RTFError[RTFError["UnknownField"] = 0] = "UnknownField";
    RTFError[RTFError["MaxAttributes"] = 1] = "MaxAttributes";
    RTFError[RTFError["MaxCombinations"] = 2] = "MaxCombinations";
    RTFError[RTFError["RepeatedFieldname"] = 3] = "RepeatedFieldname";
    RTFError[RTFError["NotGroup"] = 4] = "NotGroup";
    RTFError[RTFError["FieldNotInType"] = 5] = "FieldNotInType";
})(RTFError || (RTFError = {}));
function generateRTFRemediation(errorType, modelDefinition, predicatesGroup) {
    var selSyncFields = filterFields(predicatesGroup);
    var selSyncFieldStr = (0, _tslib.__spread)(selSyncFields).join(", ");
    var dynamicAuthModeFields = dynamicAuthFields(modelDefinition);
    var dynamicAuthFieldsStr = (0, _tslib.__spread)(dynamicAuthModeFields).join(", ");
    var filterCombinations = countFilterCombinations(predicatesGroup);
    var repeatedField = repeatedFieldInGroup(predicatesGroup);
    switch(errorType){
        case RTFError.UnknownField:
            return "Your API was generated with an older version of the CLI that doesn't support backend subscription filtering.To enable backend subscription filtering, upgrade your Amplify CLI to the latest version and push your app by running `amplify upgrade` followed by `amplify push`";
        case RTFError.MaxAttributes:
            var message = "Your selective sync expression for " + modelDefinition.name + " contains " + selSyncFields.size + " different model fields: " + selSyncFieldStr + ".\n\n";
            if (dynamicAuthModeFields.size > 0) message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth each utilize 1 field.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
            return message;
        case RTFError.MaxCombinations:
            var message = "Your selective sync expression for " + modelDefinition.name + " contains " + filterCombinations + " field combinations (total number of predicates in an OR expression).\n\n";
            if (dynamicAuthModeFields.size > 0) message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth factor in to the number of combinations you're using.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
            return message;
        case RTFError.RepeatedFieldname:
            return "Your selective sync expression for " + modelDefinition.name + " contains multiple entries for " + repeatedField + " in the same AND group.";
        case RTFError.NotGroup:
            return "Your selective sync expression for " + modelDefinition.name + " uses a `not` group. If you'd like to filter subscriptions in the backend, " + "rewrite your expression using `ne` or `notContains` operators.";
        case RTFError.FieldNotInType:
            // no remediation instructions. We'll surface the message directly
            return "";
    }
}
function getUserGroupsFromToken(token, rule) {
    // validate token against groupClaim
    var userGroups = token[rule.groupClaim] || [];
    if (typeof userGroups === "string") {
        var parsedGroups = void 0;
        try {
            parsedGroups = JSON.parse(userGroups);
        } catch (e) {
            parsedGroups = userGroups;
        }
        userGroups = [].concat(parsedGroups);
    }
    return userGroups;
}
function getModelAuthModes(_a) {
    var authModeStrategy = _a.authModeStrategy, defaultAuthMode = _a.defaultAuthMode, modelName = _a.modelName, schema = _a.schema;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var operations, modelAuthModes, error_1;
        var _this = this;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    operations = Object.values((0, _types.ModelOperation));
                    modelAuthModes = {
                        CREATE: [],
                        READ: [],
                        UPDATE: [],
                        DELETE: []
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.all(operations.map(function(operation) {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var authModes;
                                return (0, _tslib.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                authModeStrategy({
                                                    schema: schema,
                                                    modelName: modelName,
                                                    operation: operation
                                                })
                                            ];
                                        case 1:
                                            authModes = _a.sent();
                                            if (typeof authModes === "string") modelAuthModes[operation] = [
                                                authModes
                                            ];
                                            else if (Array.isArray(authModes) && authModes.length) modelAuthModes[operation] = authModes;
                                            else // Use default auth mode if nothing is returned from authModeStrategy
                                            modelAuthModes[operation] = [
                                                defaultAuthMode
                                            ];
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }))
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    error_1 = _b.sent();
                    logger.debug("Error getting auth modes for model: " + modelName, error_1);
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        modelAuthModes
                    ];
            }
        });
    });
}
function getForbiddenError(error) {
    var forbiddenErrorMessages = [
        "Request failed with status code 401",
        "Request failed with status code 403"
    ];
    var forbiddenError;
    if (error && error.errors) forbiddenError = error.errors.find(function(err) {
        return forbiddenErrorMessages.includes(err.message);
    });
    else if (error && error.message) forbiddenError = error;
    if (forbiddenError) return forbiddenError.message;
    return null;
}
function getClientSideAuthError(error) {
    var clientSideAuthErrors = Object.values((0, _api.GraphQLAuthError));
    var clientSideError = error && error.message && clientSideAuthErrors.find(function(clientError) {
        return error.message.includes(clientError);
    });
    return clientSideError || null;
}
function getTokenForCustomAuth(authMode, amplifyConfig) {
    if (amplifyConfig === void 0) amplifyConfig = {};
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _a, functionAuthProvider, token, error_2;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(authMode === (0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _a = amplifyConfig.authProviders, functionAuthProvider = (_a === void 0 ? {
                        functionAuthProvider: null
                    } : _a).functionAuthProvider;
                    if (!(functionAuthProvider && typeof functionAuthProvider === "function")) return [
                        3 /*break*/ ,
                        5
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionAuthProvider()
                    ];
                case 2:
                    token = _b.sent().token;
                    return [
                        2 /*return*/ ,
                        token
                    ];
                case 3:
                    error_2 = _b.sent();
                    throw new Error("Error retrieving token from `functionAuthProvider`: " + error_2);
                case 4:
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    // TODO: add docs link once available
                    throw new Error("You must provide a `functionAuthProvider` function to `DataStore.configure` when using " + (0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA);
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function getIdentifierValue(modelDefinition, model) {
    var pkFieldNames = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    var idOrPk = pkFieldNames.map(function(f) {
        return model[f];
    }).join((0, _util.IDENTIFIER_KEY_SEPARATOR));
    return idOrPk;
}

},{"tslib":"9gMVn","@aws-amplify/api-graphql":"cbXXL","@aws-amplify/api":"houml","@aws-amplify/core":"8BDOx","../types":"KjGQP","../util":"89SDa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aNupa":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
var _indexedDBAdapter = require("../IndexedDBAdapter");
var _indexedDBAdapterDefault = parcelHelpers.interopDefault(_indexedDBAdapter);
var _asyncStorageAdapter = require("../AsyncStorageAdapter");
var _asyncStorageAdapterDefault = parcelHelpers.interopDefault(_asyncStorageAdapter);
var getDefaultAdapter = function() {
    var isBrowser = (0, _core.browserOrNode)().isBrowser;
    if (isBrowser && window.indexedDB || (0, _core.isWebWorker)() && self.indexedDB) return 0, _indexedDBAdapterDefault.default;
    return 0, _asyncStorageAdapterDefault.default;
};
exports.default = getDefaultAdapter;

},{"@aws-amplify/core":"8BDOx","../IndexedDBAdapter":"3Bdky","../AsyncStorageAdapter":"10Ofh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Bdky":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _idb = require("idb");
var _types = require("../../types");
var _util = require("../../util");
var _storageAdapterBase = require("./StorageAdapterBase");
var logger = new (0, _core.ConsoleLogger)("DataStore");
/**
 * The point after which queries composed of multiple simple OR conditions
 * should scan-and-filter instead of individual queries for each condition.
 *
 * At some point, this should be configurable and/or dynamic based on table
 * size and possibly even on observed average seek latency. For now, it's
 * based on an manual "binary search" for the breakpoint as measured in the
 * unit test suite. This isn't necessarily optimal. But, it's at least derived
 * empirically, rather than theoretically and without any verification!
 *
 * REMEMBER! If you run more realistic benchmarks and update this value, update
 * this comment so the validity and accuracy of future query tuning exercises
 * can be compared to the methods used to derive the current value. E.g.,
 *
 * 1. In browser benchmark > unit test benchmark
 * 2. Multi-browser benchmark > single browser benchmark
 * 3. Benchmarks of various table sizes > static table size benchmark
 *
 * etc...
 *
 */ var MULTI_OR_CONDITION_SCAN_BREAKPOINT = 7;
//
var DB_VERSION = 3;
var IndexedDBAdapter = /** @class */ function(_super) {
    (0, _tslib.__extends)(IndexedDBAdapter, _super);
    function IndexedDBAdapter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.safariCompatabilityMode = false;
        /**
         * Checks the given path against the browser's IndexedDB implementation for
         * necessary compatibility transformations, applying those transforms if needed.
         *
         * @param `keyArr` strings to compatibilize for browser-indexeddb index operations
         * @returns An array or string, depending on and given key,
         * that is ensured to be compatible with the IndexedDB implementation's nuances.
         */ _this.canonicalKeyPath = function(keyArr) {
            if (_this.safariCompatabilityMode) return keyArr.length > 1 ? keyArr : keyArr[0];
            return keyArr;
        };
        return _this;
    //#endregion
    }
    // checks are called by StorageAdapterBase class
    IndexedDBAdapter.prototype.preSetUpChecks = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.setSafariCompatabilityMode()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.preOpCheck = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Initialize IndexedDB database
     * Create new DB if one doesn't exist
     * Upgrade outdated DB
     *
     * Called by `StorageAdapterBase.setUp()`
     *
     * @returns IDB Database instance
     */ IndexedDBAdapter.prototype.initDb = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            _idb.openDB(this.dbName, DB_VERSION, {
                                upgrade: function(db, oldVersion, newVersion, txn) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var _a, _b, storeName, origStore, tmpName, _c, namespaceName, modelName, modelInCurrentSchema, newStore, cursor, count, e_1_1, error_1;
                                        var e_1, _d;
                                        var _this = this;
                                        return (0, _tslib.__generator)(this, function(_e) {
                                            switch(_e.label){
                                                case 0:
                                                    // create new database
                                                    if (oldVersion === 0) {
                                                        Object.keys(this.schema.namespaces).forEach(function(namespaceName) {
                                                            var namespace = _this.schema.namespaces[namespaceName];
                                                            Object.keys(namespace.models).forEach(function(modelName) {
                                                                var storeName = (0, _util.getStorename)(namespaceName, modelName);
                                                                _this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                            });
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    }
                                                    if (!((oldVersion === 1 || oldVersion === 2) && newVersion === 3)) return [
                                                        3 /*break*/ ,
                                                        16
                                                    ];
                                                    _e.label = 1;
                                                case 1:
                                                    _e.trys.push([
                                                        1,
                                                        14,
                                                        ,
                                                        15
                                                    ]);
                                                    _e.label = 2;
                                                case 2:
                                                    _e.trys.push([
                                                        2,
                                                        11,
                                                        12,
                                                        13
                                                    ]);
                                                    _a = (0, _tslib.__values)(txn.objectStoreNames), _b = _a.next();
                                                    _e.label = 3;
                                                case 3:
                                                    if (!!_b.done) return [
                                                        3 /*break*/ ,
                                                        10
                                                    ];
                                                    storeName = _b.value;
                                                    origStore = txn.objectStore(storeName);
                                                    tmpName = "tmp_" + storeName;
                                                    origStore.name = tmpName;
                                                    _c = this.getNamespaceAndModelFromStorename(storeName), namespaceName = _c.namespaceName, modelName = _c.modelName;
                                                    modelInCurrentSchema = modelName in this.schema.namespaces[namespaceName].models;
                                                    if (!modelInCurrentSchema) {
                                                        // delete original
                                                        db.deleteObjectStore(tmpName);
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    }
                                                    newStore = this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                    return [
                                                        4 /*yield*/ ,
                                                        origStore.openCursor()
                                                    ];
                                                case 4:
                                                    cursor = _e.sent();
                                                    count = 0;
                                                    _e.label = 5;
                                                case 5:
                                                    if (!(cursor && cursor.value)) return [
                                                        3 /*break*/ ,
                                                        8
                                                    ];
                                                    // we don't pass key, since they are all new entries in the new store
                                                    return [
                                                        4 /*yield*/ ,
                                                        newStore.put(cursor.value)
                                                    ];
                                                case 6:
                                                    // we don't pass key, since they are all new entries in the new store
                                                    _e.sent();
                                                    return [
                                                        4 /*yield*/ ,
                                                        cursor.continue()
                                                    ];
                                                case 7:
                                                    cursor = _e.sent();
                                                    count++;
                                                    return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                case 8:
                                                    // delete original
                                                    db.deleteObjectStore(tmpName);
                                                    logger.debug(count + " " + storeName + " records migrated");
                                                    _e.label = 9;
                                                case 9:
                                                    _b = _a.next();
                                                    return [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 10:
                                                    return [
                                                        3 /*break*/ ,
                                                        13
                                                    ];
                                                case 11:
                                                    e_1_1 = _e.sent();
                                                    e_1 = {
                                                        error: e_1_1
                                                    };
                                                    return [
                                                        3 /*break*/ ,
                                                        13
                                                    ];
                                                case 12:
                                                    try {
                                                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                                                    } finally{
                                                        if (e_1) throw e_1.error;
                                                    }
                                                    return [
                                                        7 /*endfinally*/ 
                                                    ];
                                                case 13:
                                                    // add new models created after IndexedDB, but before migration
                                                    // this case may happen when a user has not opened an app for
                                                    // some time and a new model is added during that time
                                                    Object.keys(this.schema.namespaces).forEach(function(namespaceName) {
                                                        var namespace = _this.schema.namespaces[namespaceName];
                                                        var objectStoreNames = new Set(txn.objectStoreNames);
                                                        Object.keys(namespace.models).map(function(modelName) {
                                                            return [
                                                                modelName,
                                                                (0, _util.getStorename)(namespaceName, modelName)
                                                            ];
                                                        }).filter(function(_a) {
                                                            var _b = (0, _tslib.__read)(_a, 2), storeName = _b[1];
                                                            return !objectStoreNames.has(storeName);
                                                        }).forEach(function(_a) {
                                                            var _b = (0, _tslib.__read)(_a, 2), modelName = _b[0], storeName = _b[1];
                                                            _this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                        });
                                                    });
                                                    return [
                                                        3 /*break*/ ,
                                                        15
                                                    ];
                                                case 14:
                                                    error_1 = _e.sent();
                                                    logger.error("Error migrating IndexedDB data", error_1);
                                                    txn.abort();
                                                    throw error_1;
                                                case 15:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 16:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype._get = function(storeOrStoreName, keyArr) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var index, storeName, store, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof storeOrStoreName === "string") {
                            storeName = storeOrStoreName;
                            index = this.db.transaction(storeName, "readonly").store.index("byPk");
                        } else {
                            store = storeOrStoreName;
                            index = store.index("byPk");
                        }
                        return [
                            4 /*yield*/ ,
                            index.get(this.canonicalKeyPath(keyArr))
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.clear = function() {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.db) === null || _a === void 0 || _a.close();
                        return [
                            4 /*yield*/ ,
                            _idb.deleteDB(this.dbName)
                        ];
                    case 2:
                        _b.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.save = function(model, condition) {
        var e_2, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, storeName, set, connectionStoreNames, modelKeyValues, tx, store, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, keys, store_1, itemKeyValues, fromDB_1, opType, key, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _c.sent();
                        _b = this.saveMetadata(model), storeName = _b.storeName, set = _b.set, connectionStoreNames = _b.connectionStoreNames, modelKeyValues = _b.modelKeyValues;
                        tx = this.db.transaction((0, _tslib.__spread)([
                            storeName
                        ], Array.from(set.values())), "readwrite");
                        store = tx.objectStore(storeName);
                        return [
                            4 /*yield*/ ,
                            this._get(store, modelKeyValues)
                        ];
                    case 2:
                        fromDB = _c.sent();
                        this.validateSaveCondition(condition, fromDB);
                        result = [];
                        _c.label = 3;
                    case 3:
                        _c.trys.push([
                            3,
                            11,
                            12,
                            17
                        ]);
                        connectionStoreNames_1 = (0, _tslib.__asyncValues)(connectionStoreNames);
                        _c.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 5:
                        if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            10
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance, keys = resItem.keys;
                        store_1 = tx.objectStore(storeName_1);
                        itemKeyValues = keys.map(function(key) {
                            return item[key];
                        });
                        return [
                            4 /*yield*/ ,
                            this._get(store_1, itemKeyValues)
                        ];
                    case 6:
                        fromDB_1 = _c.sent();
                        opType = fromDB_1 ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT;
                        if (!((0, _util.keysEqual)(itemKeyValues, modelKeyValues) || opType === (0, _types.OpType).INSERT)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            store_1.index("byPk").getKey(this.canonicalKeyPath(itemKeyValues))
                        ];
                    case 7:
                        key = _c.sent();
                        return [
                            4 /*yield*/ ,
                            store_1.put(item, key)
                        ];
                    case 8:
                        _c.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 12:
                        _c.trys.push([
                            12,
                            ,
                            15,
                            16
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 13:
                        _c.sent();
                        _c.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            4 /*yield*/ ,
                            tx.done
                        ];
                    case 18:
                        _c.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        _a = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a.storeName, namespaceName = _a.namespaceName, queryByKey = _a.queryByKey, predicates = _a.predicates, hasSort = _a.hasSort, hasPagination = _a.hasPagination;
                        return [
                            4 /*yield*/ ,
                            function() {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var record, filtered, all;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!queryByKey) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getByKey(storeName, queryByKey)
                                                ];
                                            case 1:
                                                record = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    record ? [
                                                        record
                                                    ] : []
                                                ];
                                            case 2:
                                                if (!predicates) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.filterOnPredicate(storeName, predicates)
                                                ];
                                            case 3:
                                                filtered = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(filtered, pagination)
                                                ];
                                            case 4:
                                                if (!hasSort) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getAll(storeName)
                                                ];
                                            case 5:
                                                all = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(all, pagination)
                                                ];
                                            case 6:
                                                if (hasPagination) return [
                                                    2 /*return*/ ,
                                                    this.enginePagination(storeName, pagination)
                                                ];
                                                return [
                                                    2 /*return*/ ,
                                                    this.getAll(storeName)
                                                ];
                                        }
                                    });
                                });
                            }()
                        ];
                    case 2:
                        records = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, records)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var storeName, cursor, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.transaction([
                                storeName
                            ], "readonly").objectStore(storeName).openCursor(undefined, firstOrLast === (0, _types.QueryOne).FIRST ? "next" : "prev")
                        ];
                    case 2:
                        cursor = _a.sent();
                        result = cursor ? cursor.value : undefined;
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.batchSave = function(modelConstructor, items) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelName, namespaceName, storeName, result, txn, store, _loop_1, this_1, items_1, items_1_1, item, e_3_1;
            var e_3, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        modelName = modelConstructor.name;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        result = [];
                        txn = this.db.transaction(storeName, "readwrite");
                        store = txn.store;
                        _loop_1 = function(item) {
                            var model, connectedModels, keyValues, _deleted, index, key, instance;
                            return (0, _tslib.__generator)(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        model = this_1.modelInstanceCreator(modelConstructor, item);
                                        connectedModels = (0, _util.traverseModel)(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                                        keyValues = this_1.getIndexKeyValuesFromModel(model);
                                        _deleted = item._deleted;
                                        index = store.index("byPk");
                                        return [
                                            4 /*yield*/ ,
                                            index.getKey(this_1.canonicalKeyPath(keyValues))
                                        ];
                                    case 1:
                                        key = _a.sent();
                                        if (!!_deleted) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        instance = connectedModels.find(function(_a) {
                                            var instance = _a.instance;
                                            var instanceKeyValues = _this.getIndexKeyValuesFromModel(instance);
                                            return (0, _util.keysEqual)(instanceKeyValues, keyValues);
                                        }).instance;
                                        result.push([
                                            instance,
                                            key ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            store.put(instance, key)
                                        ];
                                    case 2:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 3:
                                        result.push([
                                            item,
                                            (0, _types.OpType).DELETE
                                        ]);
                                        if (!key) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            store.delete(key)
                                        ];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!items_1_1.done) return [
                            3 /*break*/ ,
                            6
                        ];
                        item = items_1_1.value;
                        return [
                            5 /*yield**/ ,
                            _loop_1(item)
                        ];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        items_1_1 = items_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        try {
                            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            4 /*yield*/ ,
                            txn.done
                        ];
                    case 10:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.deleteItem = function(deleteQueue) {
        var e_4, _a, e_5, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var connectionStoreNames, tx, _c, _d, deleteItem, storeName, items, store, items_2, items_2_1, item, key, keyValues, itemKey, e_5_1, e_4_1;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        connectionStoreNames = deleteQueue.map(function(_a) {
                            var storeName = _a.storeName;
                            return storeName;
                        });
                        tx = this.db.transaction((0, _tslib.__spread)(connectionStoreNames), "readwrite");
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            22,
                            23,
                            28
                        ]);
                        _c = (0, _tslib.__asyncValues)(deleteQueue);
                        _e.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _c.next()
                        ];
                    case 3:
                        if (!(_d = _e.sent(), !_d.done)) return [
                            3 /*break*/ ,
                            21
                        ];
                        deleteItem = _d.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        store = tx.objectStore(storeName);
                        _e.label = 4;
                    case 4:
                        _e.trys.push([
                            4,
                            14,
                            15,
                            20
                        ]);
                        items_2 = (0, _tslib.__asyncValues)(items);
                        _e.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            items_2.next()
                        ];
                    case 6:
                        if (!(items_2_1 = _e.sent(), !items_2_1.done)) return [
                            3 /*break*/ ,
                            13
                        ];
                        item = items_2_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            12
                        ];
                        key = void 0;
                        if (!(typeof item === "object")) return [
                            3 /*break*/ ,
                            8
                        ];
                        keyValues = this.getIndexKeyValuesFromModel(item);
                        return [
                            4 /*yield*/ ,
                            store.index("byPk").getKey(this.canonicalKeyPath(keyValues))
                        ];
                    case 7:
                        key = _e.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        itemKey = item.toString();
                        return [
                            4 /*yield*/ ,
                            store.index("byPk").getKey(itemKey)
                        ];
                    case 9:
                        key = _e.sent();
                        _e.label = 10;
                    case 10:
                        if (!(key !== undefined)) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            store.delete(key)
                        ];
                    case 11:
                        _e.sent();
                        _e.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 14:
                        e_5_1 = _e.sent();
                        e_5 = {
                            error: e_5_1
                        };
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 15:
                        _e.trys.push([
                            15,
                            ,
                            18,
                            19
                        ]);
                        if (!(items_2_1 && !items_2_1.done && (_b = items_2.return))) return [
                            3 /*break*/ ,
                            17
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_2)
                        ];
                    case 16:
                        _e.sent();
                        _e.label = 17;
                    case 17:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 18:
                        if (e_5) throw e_5.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 20:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 21:
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 22:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 23:
                        _e.trys.push([
                            23,
                            ,
                            26,
                            27
                        ]);
                        if (!(_d && !_d.done && (_a = _c.return))) return [
                            3 /*break*/ ,
                            25
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_c)
                        ];
                    case 24:
                        _e.sent();
                        _e.label = 25;
                    case 25:
                        return [
                            3 /*break*/ ,
                            27
                        ];
                    case 26:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 27:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 28:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //#region platform-specific helper methods
    IndexedDBAdapter.prototype.checkPrivate = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var isPrivate;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _util.isPrivateMode)().then(function(isPrivate) {
                                return isPrivate;
                            })
                        ];
                    case 1:
                        isPrivate = _a.sent();
                        if (isPrivate) {
                            logger.error("IndexedDB not supported in this browser's private mode");
                            return [
                                2 /*return*/ ,
                                Promise.reject("IndexedDB not supported in this browser's private mode")
                            ];
                        } else return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Whether the browser's implementation of IndexedDB is coercing single-field
     * indexes to a scalar key.
     *
     * If this returns `true`, we need to treat indexes containing a single field
     * as scalars.
     *
     * See PR description for reference:
     * https://github.com/aws-amplify/amplify-js/pull/10527
     */ IndexedDBAdapter.prototype.setSafariCompatabilityMode = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, _util.isSafariCompatabilityMode)()
                        ];
                    case 1:
                        _a.safariCompatabilityMode = _b.sent();
                        if (this.safariCompatabilityMode === true) logger.debug("IndexedDB Adapter is running in Safari Compatability Mode");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getNamespaceAndModelFromStorename = function(storeName) {
        var _a = (0, _tslib.__read)(storeName.split("_")), namespaceName = _a[0], modelNameArr = _a.slice(1);
        return {
            namespaceName: namespaceName,
            modelName: modelNameArr.join("_")
        };
    };
    IndexedDBAdapter.prototype.createObjectStoreForModel = function(db, namespaceName, storeName, modelName) {
        var store = db.createObjectStore(storeName, {
            autoIncrement: true
        });
        var indexes = this.schema.namespaces[namespaceName].relationships[modelName].indexes;
        indexes.forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 3), idxName = _b[0], keyPath = _b[1], options = _b[2];
            store.createIndex(idxName, keyPath, options);
        });
        return store;
    };
    IndexedDBAdapter.prototype.getByKey = function(storeName, keyValue) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, keyValue)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getAll = function(storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Tries to generate an index fetcher for the given predicates. Assumes
     * that the given predicate conditions are contained by an AND group and
     * should therefore all match a single record.
     *
     * @param storeName The table to query.
     * @param predicates The predicates to try to AND together.
     * @param transaction
     */ IndexedDBAdapter.prototype.matchingIndexQueries = function(storeName, predicates, transaction) {
        var e_6, _a, e_7, _b;
        var _this = this;
        // could be expanded later to include `exec()` and a `cardinality` estimate?
        var queries = [];
        var predicateIndex = new Map();
        try {
            for(var predicates_1 = (0, _tslib.__values)(predicates), predicates_1_1 = predicates_1.next(); !predicates_1_1.done; predicates_1_1 = predicates_1.next()){
                var predicate = predicates_1_1.value;
                predicateIndex.set(String(predicate.field), predicate);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (predicates_1_1 && !predicates_1_1.done && (_a = predicates_1.return)) _a.call(predicates_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var store = transaction.objectStore(storeName);
        var _loop_2 = function(name_1) {
            var e_8, _a;
            var idx = store.index(name_1);
            var keypath = Array.isArray(idx.keyPath) ? idx.keyPath : [
                idx.keyPath
            ];
            var matchingPredicateValues = [];
            try {
                for(var keypath_1 = (e_8 = void 0, (0, _tslib.__values)(keypath)), keypath_1_1 = keypath_1.next(); !keypath_1_1.done; keypath_1_1 = keypath_1.next()){
                    var field = keypath_1_1.value;
                    var p = predicateIndex.get(field);
                    if (p && p.operand !== null && p.operand !== undefined) matchingPredicateValues.push(p.operand);
                    else break;
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (keypath_1_1 && !keypath_1_1.done && (_a = keypath_1.return)) _a.call(keypath_1);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            // if we have a matching predicate field for each component of this index,
            // we can build a query for it. otherwise, we can't.
            if (matchingPredicateValues.length === keypath.length) // re-create a transaction, because the transaction used to fetch the
            // indexes may no longer be active.
            queries.push(function() {
                return _this.db.transaction(storeName).objectStore(storeName).index(name_1).getAll(_this.canonicalKeyPath(matchingPredicateValues));
            });
        };
        try {
            for(var _c = (0, _tslib.__values)(store.indexNames), _d = _c.next(); !_d.done; _d = _c.next()){
                var name_1 = _d.value;
                _loop_2(name_1);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return queries;
    };
    IndexedDBAdapter.prototype.baseQueryIndex = function(storeName, predicates, transaction) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, fieldPredicates, txn, result, groupQueries, objectQueries, indexedQueries;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        // the predicate objects we care about tend to be nested at least
                        // one level down: `{and: {or: {and: { <the predicates we want> }}}}`
                        // so, we unpack and/or groups until we find a group with more than 1
                        // child OR a child that is not a group (and is therefore a predicate "object").
                        while(predicateObjs.length === 1 && (0, _types.isPredicateGroup)(predicateObjs[0]) && predicateObjs[0].type !== "not"){
                            type = predicateObjs[0].type;
                            predicateObjs = predicateObjs[0].predicates;
                        }
                        fieldPredicates = predicateObjs.filter(function(p) {
                            return (0, _types.isPredicateObj)(p) && p.operator === "eq";
                        });
                        txn = transaction || this.db.transaction(storeName);
                        result = {};
                        if (!(type === "or")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(predicateObjs.filter(function(o) {
                                return (0, _types.isPredicateGroup)(o) && o.type === "and";
                            }).map(function(o) {
                                return _this.baseQueryIndex(storeName, o, txn);
                            })).then(function(queries) {
                                return queries.filter(function(q) {
                                    return q.indexedQueries.length === 1;
                                }).map(function(i) {
                                    return i.indexedQueries;
                                });
                            })
                        ];
                    case 1:
                        groupQueries = _a.sent();
                        objectQueries = predicateObjs.filter(function(o) {
                            return (0, _types.isPredicateObj)(o);
                        }).map(function(o) {
                            return _this.matchingIndexQueries(storeName, [
                                o
                            ], txn);
                        });
                        indexedQueries = (0, _tslib.__spread)(groupQueries, objectQueries).map(function(q) {
                            return q[0];
                        }).filter(function(i) {
                            return i;
                        });
                        // if, after hunting for base queries, we don't have exactly 1 base query
                        // for each child group + object, stop trying to optimize. we're not dealing
                        // with a simple query that fits the intended optimization path.
                        if (predicateObjs.length > indexedQueries.length) result = {
                            groupType: null,
                            indexedQueries: []
                        };
                        else result = {
                            groupType: "or",
                            indexedQueries: indexedQueries
                        };
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (type === "and") // our potential indexes or lacks thereof.
                        // note that we're only optimizing for `eq` right now.
                        result = {
                            groupType: type,
                            indexedQueries: this.matchingIndexQueries(storeName, fieldPredicates, txn)
                        };
                        else result = {
                            groupType: null,
                            indexedQueries: []
                        };
                        _a.label = 3;
                    case 3:
                        if (!!transaction) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            txn.done
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.filterOnPredicate = function(storeName, predicates) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, _a, groupType, indexedQueries, candidateResults, distinctResults, indexedQueries_1, indexedQueries_1_1, query, resultGroup, resultGroup_1, resultGroup_1_1, item, distinctificationString, e_9_1, filtered;
            var e_9, _b, e_10, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        return [
                            4 /*yield*/ ,
                            this.baseQueryIndex(storeName, predicates)
                        ];
                    case 1:
                        _a = _d.sent(), groupType = _a.groupType, indexedQueries = _a.indexedQueries;
                        if (!(groupType === "and" && indexedQueries.length > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            indexedQueries[0]()
                        ];
                    case 2:
                        // each condition must be satsified, we can form a base set with any
                        // ONE of those conditions and then filter.
                        candidateResults = _d.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 3:
                        if (!(groupType === "or" && indexedQueries.length > 0 && indexedQueries.length <= MULTI_OR_CONDITION_SCAN_BREAKPOINT)) return [
                            3 /*break*/ ,
                            12
                        ];
                        distinctResults = new Map();
                        _d.label = 4;
                    case 4:
                        _d.trys.push([
                            4,
                            9,
                            10,
                            11
                        ]);
                        indexedQueries_1 = (0, _tslib.__values)(indexedQueries), indexedQueries_1_1 = indexedQueries_1.next();
                        _d.label = 5;
                    case 5:
                        if (!!indexedQueries_1_1.done) return [
                            3 /*break*/ ,
                            8
                        ];
                        query = indexedQueries_1_1.value;
                        return [
                            4 /*yield*/ ,
                            query()
                        ];
                    case 6:
                        resultGroup = _d.sent();
                        try {
                            for(resultGroup_1 = (e_10 = void 0, (0, _tslib.__values)(resultGroup)), resultGroup_1_1 = resultGroup_1.next(); !resultGroup_1_1.done; resultGroup_1_1 = resultGroup_1.next()){
                                item = resultGroup_1_1.value;
                                distinctificationString = JSON.stringify(item);
                                distinctResults.set(distinctificationString, item);
                            }
                        } catch (e_10_1) {
                            e_10 = {
                                error: e_10_1
                            };
                        } finally{
                            try {
                                if (resultGroup_1_1 && !resultGroup_1_1.done && (_c = resultGroup_1.return)) _c.call(resultGroup_1);
                            } finally{
                                if (e_10) throw e_10.error;
                            }
                        }
                        _d.label = 7;
                    case 7:
                        indexedQueries_1_1 = indexedQueries_1.next();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 9:
                        e_9_1 = _d.sent();
                        e_9 = {
                            error: e_9_1
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        try {
                            if (indexedQueries_1_1 && !indexedQueries_1_1.done && (_b = indexedQueries_1.return)) _b.call(indexedQueries_1);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        // we could conceivably check for special conditions and return early here.
                        // but, this is simpler and has not yet had a measurable performance impact.
                        candidateResults = Array.from(distinctResults.values());
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        return [
                            4 /*yield*/ ,
                            this.getAll(storeName)
                        ];
                    case 13:
                        // nothing intelligent we can do with `not` groups unless or until we start
                        // smashing comparison operators against indexes -- at which point we could
                        // perform some reversal here.
                        candidateResults = _d.sent();
                        _d.label = 14;
                    case 14:
                        filtered = predicateObjs ? candidateResults.filter(function(m) {
                            return (0, _util.validatePredicate)(m, type, predicateObjs);
                        }) : candidateResults;
                        return [
                            2 /*return*/ ,
                            filtered
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.inMemoryPagination = function(records, pagination) {
        return (0, _util.inMemoryPagination)(records, pagination);
    };
    IndexedDBAdapter.prototype.enginePagination = function(storeName, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, _a, page, _b, limit, initialRecord, cursor, pageResults, hasLimit;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!pagination) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = pagination.page, page = _a === void 0 ? 0 : _a, _b = pagination.limit, limit = _b === void 0 ? 0 : _b;
                        initialRecord = Math.max(0, page * limit) || 0;
                        return [
                            4 /*yield*/ ,
                            this.db.transaction(storeName).objectStore(storeName).openCursor()
                        ];
                    case 1:
                        cursor = _c.sent();
                        if (!(cursor && initialRecord > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.advance(initialRecord)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        pageResults = [];
                        hasLimit = typeof limit === "number" && limit > 0;
                        _c.label = 4;
                    case 4:
                        if (!(cursor && cursor.value)) return [
                            3 /*break*/ ,
                            6
                        ];
                        pageResults.push(cursor.value);
                        if (hasLimit && pageResults.length === limit) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.continue()
                        ];
                    case 5:
                        cursor = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 6:
                        result = pageResults;
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 8:
                        result = _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    return IndexedDBAdapter;
}((0, _storageAdapterBase.StorageAdapterBase));
exports.default = new IndexedDBAdapter();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","idb":"39Yuj","../../types":"KjGQP","../../util":"89SDa","./StorageAdapterBase":"dUmAF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"39Yuj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrap", ()=>(0, _wrapIdbValueJs.u));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapIdbValueJs.w));
parcelHelpers.export(exports, "deleteDB", ()=>deleteDB);
parcelHelpers.export(exports, "openDB", ()=>openDB);
var _wrapIdbValueJs = require("./wrap-idb-value.js");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, _wrapIdbValueJs.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, _wrapIdbValueJs.w)(request.result), event.oldVersion, event.newVersion, (0, _wrapIdbValueJs.w)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, _wrapIdbValueJs.w)(request).then(()=>undefined);
}
const readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        const returnVal = await target[targetFuncName](...args);
        if (isWrite) await tx.done;
        return returnVal;
    };
    cachedMethods.set(prop, method);
    return method;
}
(0, _wrapIdbValueJs.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!getMethod(target, prop) || oldTraps.has(target, prop)
    }));

},{"./wrap-idb-value.js":"llAMR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"llAMR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>reverseTransformCache);
parcelHelpers.export(exports, "i", ()=>instanceOfAny);
parcelHelpers.export(exports, "r", ()=>replaceTraps);
parcelHelpers.export(exports, "u", ()=>unwrap);
parcelHelpers.export(exports, "w", ()=>wrap);
const instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve(wrap(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call(unwrap(this), storeNames, ...args);
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === "function") return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value)=>reverseTransformCache.get(value);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dUmAF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageAdapterBase", ()=>StorageAdapterBase);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _predicates = require("../../predicates");
var _types = require("../../types");
var _util = require("../../util");
var _relationship = require("../relationship");
var logger = new (0, _core.ConsoleLogger)("DataStore");
var DB_NAME = "amplify-datastore";
var StorageAdapterBase = /** @class */ function() {
    function StorageAdapterBase() {
        this.dbName = DB_NAME;
    }
    /**
     * Initializes local DB
     *
     * @param theSchema
     * @param namespaceResolver
     * @param modelInstanceCreator
     * @param getModelConstructorByModelName
     * @param sessionId
     */ StorageAdapterBase.prototype.setUp = function(theSchema, namespaceResolver, modelInstanceCreator, getModelConstructorByModelName, sessionId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, error_1;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.preSetUpChecks()
                        ];
                    case 1:
                        _b.sent();
                        if (!!this.initPromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.initPromise = new Promise(function(res, rej) {
                            _this.resolve = res;
                            _this.reject = rej;
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.initPromise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        if (sessionId) this.dbName = DB_NAME + "-" + sessionId;
                        this.schema = theSchema;
                        this.namespaceResolver = namespaceResolver;
                        this.modelInstanceCreator = modelInstanceCreator;
                        this.getModelConstructorByModelName = getModelConstructorByModelName;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        if (!!this.db) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.initDb()
                        ];
                    case 6:
                        _a.db = _b.sent();
                        this.resolve();
                        _b.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_1 = _b.sent();
                        this.reject(error_1);
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @param modelConstructor
     * @returns local DB table name
     */ StorageAdapterBase.prototype.getStorenameForModel = function(modelConstructor) {
        var namespace = this.namespaceResolver(modelConstructor);
        var modelName = modelConstructor.name;
        return (0, _util.getStorename)(namespace, modelName);
    };
    /**
     *
     * @param model - instantiated model record
     * @returns the record's primary key values
     */ StorageAdapterBase.prototype.getIndexKeyValuesFromModel = function(model) {
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var namespaceName = this.namespaceResolver(modelConstructor);
        var keys = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelConstructor.name);
        return (0, _util.extractPrimaryKeyValues)(model, keys);
    };
    /**
     * Common metadata for `save` operation
     * used by individual storage adapters
     *
     * @param model
     */ StorageAdapterBase.prototype.saveMetadata = function(model) {
        var _this = this;
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var storeName = this.getStorenameForModel(modelConstructor);
        var namespaceName = this.namespaceResolver(modelConstructor);
        var connectedModels = (0, _util.traverseModel)(modelConstructor.name, model, this.schema.namespaces[namespaceName], this.modelInstanceCreator, this.getModelConstructorByModelName);
        var set = new Set();
        var connectionStoreNames = Object.values(connectedModels).map(function(_a) {
            var modelName = _a.modelName, item = _a.item, instance = _a.instance;
            var storeName = (0, _util.getStorename)(namespaceName, modelName);
            set.add(storeName);
            var keys = (0, _util.getIndexKeys)(_this.schema.namespaces[namespaceName], modelName);
            return {
                storeName: storeName,
                item: item,
                instance: instance,
                keys: keys
            };
        });
        var modelKeyValues = this.getIndexKeyValuesFromModel(model);
        return {
            storeName: storeName,
            set: set,
            connectionStoreNames: connectionStoreNames,
            modelKeyValues: modelKeyValues
        };
    };
    /**
     * Enforces conditional save. Throws if condition is not met.
     * used by individual storage adapters
     *
     * @param model
     */ StorageAdapterBase.prototype.validateSaveCondition = function(condition, fromDB) {
        if (!(condition && fromDB)) return;
        var predicates = (0, _predicates.ModelPredicateCreator).getPredicates(condition);
        var _a = predicates, predicateObjs = _a.predicates, type = _a.type;
        var isValid = (0, _util.validatePredicate)(fromDB, type, predicateObjs);
        if (!isValid) {
            var msg = "Conditional update failed";
            logger.error(msg, {
                model: fromDB,
                condition: predicateObjs
            });
            throw new Error(msg);
        }
    };
    /**
     * Instantiate models from POJO records returned from the database
     *
     * @param namespaceName - string model namespace
     * @param srcModelName - string model name
     * @param records - array of uninstantiated records
     * @returns
     */ StorageAdapterBase.prototype.load = function(namespaceName, srcModelName, records) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var namespace, relations, connectionStoreNames, modelConstructor;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                namespace = this.schema.namespaces[namespaceName];
                relations = namespace.relationships[srcModelName].relationTypes;
                connectionStoreNames = relations.map(function(_a) {
                    var modelName = _a.modelName;
                    return (0, _util.getStorename)(namespaceName, modelName);
                });
                modelConstructor = this.getModelConstructorByModelName(namespaceName, srcModelName);
                if (connectionStoreNames.length === 0) return [
                    2 /*return*/ ,
                    records.map(function(record) {
                        return _this.modelInstanceCreator(modelConstructor, record);
                    })
                ];
                return [
                    2 /*return*/ ,
                    records.map(function(record) {
                        return _this.modelInstanceCreator(modelConstructor, record);
                    })
                ];
            });
        });
    };
    /**
     * Extracts operands from a predicate group into an array of key values
     * Used in the query method
     *
     * @param predicates - predicate group
     * @param keyPath - string array of key names ['id', 'sortKey']
     * @returns string[] of key values
     *
     * @example
     * ```js
     * { and:[{ id: { eq: 'abc' }}, { sortKey: { eq: 'def' }}] }
     * ```
     * Becomes
     * ```
     * ['abc', 'def']
     * ```
     */ StorageAdapterBase.prototype.keyValueFromPredicate = function(predicates, keyPath) {
        var e_1, _a;
        var predicateObjs = predicates.predicates;
        if (predicateObjs.length !== keyPath.length) return;
        var keyValues = [];
        var _loop_1 = function(key) {
            var predicateObj = predicateObjs.find(function(p) {
                // it's a relevant predicate object only if it's an equality
                // operation for a key field from the key:
                return (0, _types.isPredicateObj)(p) && p.field === key && p.operator === "eq" && p.operand !== null && p.operand !== undefined;
            });
            predicateObj && keyValues.push(predicateObj.operand);
        };
        try {
            for(var keyPath_1 = (0, _tslib.__values)(keyPath), keyPath_1_1 = keyPath_1.next(); !keyPath_1_1.done; keyPath_1_1 = keyPath_1.next()){
                var key = keyPath_1_1.value;
                _loop_1(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keyPath_1_1 && !keyPath_1_1.done && (_a = keyPath_1.return)) _a.call(keyPath_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return keyValues.length === keyPath.length ? keyValues : undefined;
    };
    /**
     * Common metadata for `query` operation
     * used by individual storage adapters
     *
     * @param modelConstructor
     * @param predicate
     * @param pagination
     */ StorageAdapterBase.prototype.queryMetadata = function(modelConstructor, predicate, pagination) {
        var storeName = this.getStorenameForModel(modelConstructor);
        var namespaceName = this.namespaceResolver(modelConstructor);
        var predicates = predicate && (0, _predicates.ModelPredicateCreator).getPredicates(predicate);
        var keyPath = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelConstructor.name);
        var queryByKey = predicates && this.keyValueFromPredicate(predicates, keyPath);
        var hasSort = pagination && pagination.sort;
        var hasPagination = pagination && pagination.limit;
        return {
            storeName: storeName,
            namespaceName: namespaceName,
            queryByKey: queryByKey,
            predicates: predicates,
            hasSort: hasSort,
            hasPagination: hasPagination
        };
    };
    /**
     * Delete record
     * Cascades to related records (for Has One and Has Many relationships)
     *
     * @param modelOrModelConstructor
     * @param condition
     * @returns
     */ StorageAdapterBase.prototype.delete = function(modelOrModelConstructor, condition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var deleteQueue, modelConstructor, namespace, models, deletedModels, deletedModels, model, modelConstructor, namespaceName, storeName, keyValues, fromDB, msg, predicates, _a, predicateObjs, type, isValid, msg, deletedModels;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.preOpCheck()
                        ];
                    case 1:
                        _b.sent();
                        deleteQueue = [];
                        if (!(0, _util.isModelConstructor)(modelOrModelConstructor)) return [
                            3 /*break*/ ,
                            9
                        ];
                        modelConstructor = modelOrModelConstructor;
                        namespace = this.namespaceResolver(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.query(modelConstructor, condition)
                        ];
                    case 2:
                        models = _b.sent();
                        if (!(condition !== undefined)) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)
                        ];
                    case 3:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 4:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 7:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 9:
                        model = modelOrModelConstructor;
                        modelConstructor = Object.getPrototypeOf(model).constructor;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        if (!condition) return [
                            3 /*break*/ ,
                            12
                        ];
                        keyValues = this.getIndexKeyValuesFromModel(model);
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, keyValues)
                        ];
                    case 10:
                        fromDB = _b.sent();
                        if (fromDB === undefined) {
                            msg = "Model instance not found in storage";
                            logger.warn(msg, {
                                model: model
                            });
                            return [
                                2 /*return*/ ,
                                [
                                    [
                                        model
                                    ],
                                    []
                                ]
                            ];
                        }
                        predicates = (0, _predicates.ModelPredicateCreator).getPredicates(condition);
                        _a = predicates, predicateObjs = _a.predicates, type = _a.type;
                        isValid = (0, _util.validatePredicate)(fromDB, type, predicateObjs);
                        if (!isValid) {
                            msg = "Conditional update failed";
                            logger.error(msg, {
                                model: fromDB,
                                condition: predicateObjs
                            });
                            throw new Error(msg);
                        }
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse([
                                model
                            ], modelConstructor, namespaceName, deleteQueue)
                        ];
                    case 11:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse([
                                model
                            ], modelConstructor, namespaceName, deleteQueue)
                        ];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 15:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                [
                                    model
                                ],
                                deletedModels
                            ]
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Recursively traverse relationship graph and add
     * all Has One and Has Many relations to `deleteQueue` param
     *
     * Actual deletion of records added to `deleteQueue` occurs in the `delete` method
     *
     * @param models
     * @param modelConstructor
     * @param namespace
     * @param deleteQueue
     */ StorageAdapterBase.prototype.deleteTraverse = function(models, modelConstructor, namespace, deleteQueue) {
        var models_1, models_1_1;
        var e_2, _a, e_3, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var cascadingRelationTypes, model, modelDefinition, modelMeta, relationships, relationships_1, relationships_1_1, r, queryObject, relatedRecords, e_3_1, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        cascadingRelationTypes = [
                            "HAS_ONE",
                            "HAS_MANY"
                        ];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            19,
                            20,
                            25
                        ]);
                        models_1 = (0, _tslib.__asyncValues)(models);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            models_1.next()
                        ];
                    case 3:
                        if (!(models_1_1 = _c.sent(), !models_1_1.done)) return [
                            3 /*break*/ ,
                            18
                        ];
                        model = models_1_1.value;
                        modelDefinition = this.schema.namespaces[namespace].models[modelConstructor.name];
                        modelMeta = {
                            builder: modelConstructor,
                            schema: modelDefinition,
                            pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                        };
                        relationships = (0, _relationship.ModelRelationship).allFrom(modelMeta).filter(function(r) {
                            return cascadingRelationTypes.includes(r.type);
                        });
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            11,
                            12,
                            17
                        ]);
                        relationships_1 = (0, _tslib.__asyncValues)(relationships);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            relationships_1.next()
                        ];
                    case 6:
                        if (!(relationships_1_1 = _c.sent(), !relationships_1_1.done)) return [
                            3 /*break*/ ,
                            10
                        ];
                        r = relationships_1_1.value;
                        queryObject = r.createRemoteQueryObject(model);
                        if (!(queryObject !== null)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.query(r.remoteModelConstructor, (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(r.remoteDefinition, queryObject))
                        ];
                    case 7:
                        relatedRecords = _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relatedRecords, r.remoteModelConstructor, namespace, deleteQueue)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        e_3_1 = _c.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 12:
                        _c.trys.push([
                            12,
                            ,
                            15,
                            16
                        ]);
                        if (!(relationships_1_1 && !relationships_1_1.done && (_b = relationships_1.return))) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(relationships_1)
                        ];
                    case 13:
                        _c.sent();
                        _c.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 18:
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 19:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 20:
                        _c.trys.push([
                            20,
                            ,
                            23,
                            24
                        ]);
                        if (!(models_1_1 && !models_1_1.done && (_a = models_1.return))) return [
                            3 /*break*/ ,
                            22
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(models_1)
                        ];
                    case 21:
                        _c.sent();
                        _c.label = 22;
                    case 22:
                        return [
                            3 /*break*/ ,
                            24
                        ];
                    case 23:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 24:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 25:
                        deleteQueue.push({
                            storeName: (0, _util.getStorename)(namespace, modelConstructor.name),
                            items: models
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StorageAdapterBase;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","../../predicates":"lUiza","../../types":"KjGQP","../../util":"89SDa","../relationship":"4Ulys","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4Ulys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelRelationship", ()=>ModelRelationship);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _types = require("../types");
/**
 * Defines a relationship from a LOCAL model.field to a REMOTE model.field and helps
 * navigate the relationship, providing a simplified peek at the relationship details
 * pertinent to setting FK's and constructing join conditions.
 *
 * Because I mean, relationships are tough.
 *
 */ var ModelRelationship = /** @class */ function() {
    /**
     * @param modelDefinition The "local" model.
     * @param field The "local" model field.
     */ function ModelRelationship(model, field) {
        if (!(0, _types.isFieldAssociation)(model.schema, field)) throw new Error(model.schema.name + "." + field + " is not a relationship.");
        this.localModel = model;
        this._field = field;
    }
    /**
     * Returns a ModelRelationship for the the given model and field if the pair
     * indicates a relationship to another model. Else, returns `null`.
     *
     * @param model The model the relationship field exists in.
     * @param field The field that may relates the local model to the remote model.
     */ ModelRelationship.from = function(model, field) {
        if ((0, _types.isFieldAssociation)(model.schema, field)) return new this(model, field);
        else return null;
    };
    /**
     * Enumerates all valid `ModelRelationship`'s on the given model.
     *
     * @param model The model definition to enumerate relationships of.
     */ ModelRelationship.allFrom = function(model) {
        var e_1, _a;
        var relationships = [];
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(model.schema.fields)), _c = _b.next(); !_c.done; _c = _b.next()){
                var field = _c.value;
                var relationship = ModelRelationship.from(model, field);
                relationship && relationships.push(relationship);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return relationships;
    };
    Object.defineProperty(ModelRelationship.prototype, "localDefinition", {
        get: function() {
            return this.localModel.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "field", {
        /**
         * The virtual/computed field on the local model that should contain
         * the related model.
         */ get: function() {
            return this._field;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localConstructor", {
        /**
         * The constructor that can be used to query DataStore or create instance for
         * the local model.
         */ get: function() {
            return this.localModel.builder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "type", {
        /**
         * The name/type of the relationship the local model has with the remote model
         * via the defined local model field.
         */ get: function() {
            return this.localAssocation.connectionType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localAssocation", {
        /**
         * Raw details about the local FK as-is from the local model's field definition in
         * the schema. This field requires interpretation.
         *
         * @see localJoinFields
         * @see localAssociatedWith
         */ get: function() {
            return this.localDefinition.fields[this.field].association;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localJoinFields", {
        /**
         * The field names on the local model that can be used to query or queried to match
         * with instances of the remote model.
         *
         * Fields are returned in-order to match the order of `this.remoteKeyFields`.
         */ get: function() {
            /**
             * This is relatively straightforward, actually.
             *
             * If we have explicitly stated targetNames, codegen is telling us authoritatively
             * to use those fields for this relationship. The local model "points to" fields
             * in the remote one.
             *
             * In other cases, the remote model points to this one's
             */ if (this.localAssocation.targetName) // This case is theoretically unnecessary going forward.
            return [
                this.localAssocation.targetName
            ];
            else if (this.localAssocation.targetNames) return this.localAssocation.targetNames;
            else return this.localPKFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localPKFields", {
        /**
         * The field names on the local model that uniquely identify it.
         *
         * These fields may or may not be relevant to the join fields.
         */ get: function() {
            return this.localModel.pkField;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteDefinition", {
        get: function() {
            var _a;
            return (_a = this.remoteModelType.modelConstructor) === null || _a === void 0 ? void 0 : _a.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteModelType", {
        get: function() {
            return this.localDefinition.fields[this.field].type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteModelConstructor", {
        /**
         * Constructor that can be used to query DataStore or create instances for
         * the remote model.
         */ get: function() {
            return this.remoteModelType.modelConstructor.builder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remotePKFields", {
        /**
         * The field names on the remote model that uniquely identify it.
         *
         * These fields may or may not be relevant to the join fields.
         */ get: function() {
            var _a;
            return ((_a = this.remoteModelType.modelConstructor) === null || _a === void 0 ? void 0 : _a.pkField) || [
                "id"
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localAssociatedWith", {
        /**
         * The `associatedWith` fields from the local perspective.
         *
         * When present, these fields indicate which fields on the remote model to use
         * when looking for a remote association and/or determining the final remote
         * key fields.
         */ get: function() {
            if (this.localAssocation.connectionType === "HAS_MANY" || this.localAssocation.connectionType === "HAS_ONE") // This de-arraying is theoretically unnecessary going forward.
            return Array.isArray(this.localAssocation.associatedWith) ? this.localAssocation.associatedWith : [
                this.localAssocation.associatedWith
            ];
            else return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "explicitRemoteAssociation", {
        /**
         * The `remote` model's associated field's `assocation` metadata, if
         * present.
         *
         * This is used when determining if the remote model's associated field
         * specifies which FK fields to use. If this value is `undefined`, the
         * name of the remote field (`this.localAssociatedWith`) *is* the remote
         * key field.
         */ get: function() {
            var _a;
            if (this.localAssociatedWith) {
                if (this.localAssociatedWith.length === 1) return (_a = this.remoteDefinition.fields[this.localAssociatedWith[0]]) === null || _a === void 0 ? void 0 : _a.association;
                else return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteJoinFields", {
        /**
         * The field names on the remote model that can used to query or queried to match
         * with instances of the local model.
         *
         * Fields are returned in-order to match the order of `this.localKeyFields`.
         */ get: function() {
            /**
             * If the local relationship explicitly names "associated with" fields, we
             * need to see if this points direction to a reciprocating assocation. If it
             * does, the remote assocation indicates what fields to use.
             */ var _a, _b, _c;
            if ((_a = this.explicitRemoteAssociation) === null || _a === void 0 ? void 0 : _a.targetName) // This case is theoretically unnecessary going forward.
            return [
                this.explicitRemoteAssociation.targetName
            ];
            else if ((_b = this.explicitRemoteAssociation) === null || _b === void 0 ? void 0 : _b.targetNames) return (_c = this.explicitRemoteAssociation) === null || _c === void 0 ? void 0 : _c.targetNames;
            else if (this.localAssociatedWith) return this.localAssociatedWith;
            else return this.remotePKFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "isComplete", {
        /**
         * Whether this relationship everything necessary to get, set, and query from
         * the perspective of the local model provided at instantiation.
         */ get: function() {
            return this.localJoinFields.length > 0 && this.remoteJoinFields.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates an FK mapper object with respect to the given related instance.
     *
     * E.g., if the local FK fields are `[parentId, parentName]` and point to
     * `[customId, name]` on the remote model, `createLocalFKObject(remote)`
     * will return:
     *
     * ```
     * {
     * 	parentId: remote.customId,
     * 	parentName: remote.name
     * }
     * ```
     *
     * @param remote The remote related instance.
     */ ModelRelationship.prototype.createLocalFKObject = function(remote) {
        var fk = {};
        for(var i = 0; i < this.localJoinFields.length; i++)fk[this.localJoinFields[i]] = remote[this.remoteJoinFields[i]];
        return fk;
    };
    /**
     * Creates an query mapper object to help fetch the remote instance(s) or
     * `null` if any of the necessary local fields are `null` or `undefined`.
     *
     * E.g., if the local FK fields are `[parentId, parentName]` and point to
     * `[customId, name]` on the remote model, `createLocalFKObject(remote)`
     * will return:
     *
     * ```
     * {
     * 	customId: local.parentId
     * 	name: local.parentName
     * }
     * ```
     *
     * If the local fields are not populated, returns
     *
     * @param local The local instance.
     */ ModelRelationship.prototype.createRemoteQueryObject = function(local) {
        var query = {};
        for(var i = 0; i < this.remoteJoinFields.length; i++){
            var localValue = local[this.localJoinFields[i]];
            if (localValue === null || localValue === undefined) return null;
            query[this.remoteJoinFields[i]] = local[this.localJoinFields[i]];
        }
        return query;
    };
    return ModelRelationship;
}();

},{"tslib":"9gMVn","../types":"KjGQP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"10Ofh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncStorageAdapter", ()=>AsyncStorageAdapter);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _asyncStorageDatabase = require("./AsyncStorageDatabase");
var _asyncStorageDatabaseDefault = parcelHelpers.interopDefault(_asyncStorageDatabase);
var _types = require("../../types");
var _util = require("../../util");
var _storageAdapterBase = require("./StorageAdapterBase");
var AsyncStorageAdapter = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncStorageAdapter, _super);
    function AsyncStorageAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // no-ops for this adapter
    AsyncStorageAdapter.prototype.preSetUpChecks = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AsyncStorageAdapter.prototype.preOpCheck = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Open AsyncStorage database
     * Create new DB if one doesn't exist
     *
     * Called by `StorageAdapterBase.setUp()`
     *
     * @returns AsyncStorageDatabase instance
     */ AsyncStorageAdapter.prototype.initDb = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var db;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        db = new (0, _asyncStorageDatabaseDefault.default)();
                        return [
                            4 /*yield*/ ,
                            db.init()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            db
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.clear()
                        ];
                    case 1:
                        _a.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.batchSave = function(modelConstructor, items) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelName, namespaceName, storeName, keys, batch, _loop_1, this_1, items_1, items_1_1, item;
            var e_1, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        modelName = modelConstructor.name;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = (0, _util.getStorename)(namespaceName, modelName);
                        keys = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelName);
                        batch = [];
                        _loop_1 = function(item) {
                            var model = this_1.modelInstanceCreator(modelConstructor, item);
                            var connectedModels = (0, _util.traverseModel)(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                            var keyValuesPath = this_1.getIndexKeyValuesPath(model);
                            var instance = connectedModels.find(function(_a) {
                                var instance = _a.instance;
                                var instanceKeyValuesPath = _this.getIndexKeyValuesPath(instance);
                                return (0, _util.keysEqual)([
                                    instanceKeyValuesPath
                                ], [
                                    keyValuesPath
                                ]);
                            }).instance;
                            batch.push(instance);
                        };
                        this_1 = this;
                        try {
                            for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                _loop_1(item);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.db.batchSave(storeName, batch, keys)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype._get = function(storeName, keyArr) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemKeyValuesPath;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        itemKeyValuesPath = keyArr.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                        return [
                            4 /*yield*/ ,
                            this.db.get(itemKeyValuesPath, storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.save = function(model, condition) {
        var e_2, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, storeName, connectionStoreNames, modelKeyValues, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, keys, itemKeyValues, fromDB_1, opType, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = this.saveMetadata(model), storeName = _b.storeName, connectionStoreNames = _b.connectionStoreNames, modelKeyValues = _b.modelKeyValues;
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, modelKeyValues)
                        ];
                    case 1:
                        fromDB = _c.sent();
                        this.validateSaveCondition(condition, fromDB);
                        result = [];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            9,
                            10,
                            15
                        ]);
                        connectionStoreNames_1 = (0, _tslib.__asyncValues)(connectionStoreNames);
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 4:
                        if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            8
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance, keys = resItem.keys;
                        itemKeyValues = keys.map(function(key) {
                            return item[key];
                        });
                        return [
                            4 /*yield*/ ,
                            this._get(storeName_1, itemKeyValues)
                        ];
                    case 5:
                        fromDB_1 = _c.sent();
                        opType = fromDB_1 ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT;
                        if (!((0, _util.keysEqual)(itemKeyValues, modelKeyValues) || opType === (0, _types.OpType).INSERT)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            this.db.save(item, storeName_1, keys, itemKeyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)))
                        ];
                    case 6:
                        _c.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _c.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 9:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 10:
                        _c.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a.storeName, namespaceName = _a.namespaceName, queryByKey = _a.queryByKey, predicates = _a.predicates, hasSort = _a.hasSort, hasPagination = _a.hasPagination;
                        return [
                            4 /*yield*/ ,
                            function() {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var keyValues, record, filtered, all;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!queryByKey) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                keyValues = queryByKey.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getByKey(storeName, keyValues)
                                                ];
                                            case 1:
                                                record = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    record ? [
                                                        record
                                                    ] : []
                                                ];
                                            case 2:
                                                if (!predicates) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.filterOnPredicate(storeName, predicates)
                                                ];
                                            case 3:
                                                filtered = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(filtered, pagination)
                                                ];
                                            case 4:
                                                if (!(hasSort || hasPagination)) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getAll(storeName)
                                                ];
                                            case 5:
                                                all = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(all, pagination)
                                                ];
                                            case 6:
                                                return [
                                                    2 /*return*/ ,
                                                    this.getAll(storeName)
                                                ];
                                        }
                                    });
                                });
                            }()
                        ];
                    case 1:
                        records = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, records)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.getByKey = function(storeName, keyValuePath) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.get(keyValuePath, storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.getAll = function(storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.filterOnPredicate = function(storeName, predicates) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, all, filtered;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        return [
                            4 /*yield*/ ,
                            this.getAll(storeName)
                        ];
                    case 1:
                        all = _a.sent();
                        filtered = predicateObjs ? all.filter(function(m) {
                            return (0, _util.validatePredicate)(m, type, predicateObjs);
                        }) : all;
                        return [
                            2 /*return*/ ,
                            filtered
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.inMemoryPagination = function(records, pagination) {
        return (0, _util.inMemoryPagination)(records, pagination);
    };
    AsyncStorageAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var storeName, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.getOne(firstOrLast, storeName)
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.deleteItem = function(deleteQueue) {
        var e_3, _a, e_4, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, _d, deleteItem, storeName, items, items_2, items_2_1, item, keyValuesPath, e_4_1, e_3_1;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            17,
                            18,
                            23
                        ]);
                        _c = (0, _tslib.__asyncValues)(deleteQueue);
                        _e.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.next()
                        ];
                    case 2:
                        if (!(_d = _e.sent(), !_d.done)) return [
                            3 /*break*/ ,
                            16
                        ];
                        deleteItem = _d.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        _e.label = 3;
                    case 3:
                        _e.trys.push([
                            3,
                            9,
                            10,
                            15
                        ]);
                        items_2 = (0, _tslib.__asyncValues)(items);
                        _e.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            items_2.next()
                        ];
                    case 5:
                        if (!(items_2_1 = _e.sent(), !items_2_1.done)) return [
                            3 /*break*/ ,
                            8
                        ];
                        item = items_2_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!(typeof item === "object")) return [
                            3 /*break*/ ,
                            7
                        ];
                        keyValuesPath = this.getIndexKeyValuesPath(item);
                        return [
                            4 /*yield*/ ,
                            this.db.delete(keyValuesPath, storeName)
                        ];
                    case 6:
                        _e.sent();
                        _e.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 9:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 10:
                        _e.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(items_2_1 && !items_2_1.done && (_b = items_2.return))) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_2)
                        ];
                    case 11:
                        _e.sent();
                        _e.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            3 /*break*/ ,
                            23
                        ];
                    case 17:
                        e_3_1 = _e.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            23
                        ];
                    case 18:
                        _e.trys.push([
                            18,
                            ,
                            21,
                            22
                        ]);
                        if (!(_d && !_d.done && (_a = _c.return))) return [
                            3 /*break*/ ,
                            20
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_c)
                        ];
                    case 19:
                        _e.sent();
                        _e.label = 20;
                    case 20:
                        return [
                            3 /*break*/ ,
                            22
                        ];
                    case 21:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 22:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 23:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //#region platform-specific helper methods
    /**
     * Retrieves concatenated primary key values from a model
     *
     * @param model
     * @returns
     */ AsyncStorageAdapter.prototype.getIndexKeyValuesPath = function(model) {
        return this.getIndexKeyValuesFromModel(model).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
    };
    return AsyncStorageAdapter;
}((0, _storageAdapterBase.StorageAdapterBase));
exports.default = new AsyncStorageAdapter();

},{"tslib":"9gMVn","./AsyncStorageDatabase":"9zAX9","../../types":"KjGQP","../../util":"89SDa","./StorageAdapterBase":"dUmAF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9zAX9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _types = require("../../types");
var _util = require("../../util");
var _inMemoryStore = require("./InMemoryStore");
var DB_NAME = "@AmplifyDatastore";
var COLLECTION = "Collection";
var DATA = "Data";
var monotonicFactoriesMap = new Map();
var AsyncStorageDatabase = /** @class */ function() {
    function AsyncStorageDatabase() {
        /**
         * Maps storeNames to a map of ulid->id
         */ this._collectionInMemoryIndex = new Map();
        this.storage = (0, _inMemoryStore.createInMemoryStore)();
    }
    /**
     * Collection index is map of stores (i.e. sync, metadata, mutation event, and data)
     * @param storeName {string} - Name of the store
     * @returns Map of ulid->id
     */ AsyncStorageDatabase.prototype.getCollectionIndex = function(storeName) {
        if (!this._collectionInMemoryIndex.has(storeName)) this._collectionInMemoryIndex.set(storeName, new Map());
        return this._collectionInMemoryIndex.get(storeName);
    };
    /**
     * Return ULID for store if it exists, otherwise create a new one
     * @param storeName {string} - Name of the store
     * @returns ulid
     */ AsyncStorageDatabase.prototype.getMonotonicFactory = function(storeName) {
        if (!monotonicFactoriesMap.has(storeName)) monotonicFactoriesMap.set(storeName, (0, _util.monotonicUlidFactory)());
        return monotonicFactoriesMap.get(storeName);
    };
    AsyncStorageDatabase.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allKeys, keysForCollectionEntries, allKeys_1, allKeys_1_1, key, _a, dbName, storeName, recordType, ulidOrId, id, ulid, id_1, newUlid, oldKey, newKey, item, e_1_1;
            var e_1, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this._collectionInMemoryIndex.clear();
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllKeys()
                        ];
                    case 1:
                        allKeys = _c.sent();
                        keysForCollectionEntries = [];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            12,
                            13,
                            14
                        ]);
                        allKeys_1 = (0, _tslib.__values)(allKeys), allKeys_1_1 = allKeys_1.next();
                        _c.label = 3;
                    case 3:
                        if (!!allKeys_1_1.done) return [
                            3 /*break*/ ,
                            11
                        ];
                        key = allKeys_1_1.value;
                        _a = (0, _tslib.__read)(key.split("::"), 5), dbName = _a[0], storeName = _a[1], recordType = _a[2], ulidOrId = _a[3], id = _a[4];
                        if (!(dbName === DB_NAME)) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!(recordType === DATA)) return [
                            3 /*break*/ ,
                            9
                        ];
                        ulid = void 0;
                        if (!(id === undefined)) return [
                            3 /*break*/ ,
                            7
                        ];
                        id_1 = ulidOrId;
                        newUlid = this.getMonotonicFactory(storeName)();
                        oldKey = this.getLegacyKeyForItem(storeName, id_1);
                        newKey = this.getKeyForItem(storeName, id_1, newUlid);
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(oldKey)
                        ];
                    case 4:
                        item = _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.storage.setItem(newKey, item)
                        ];
                    case 5:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.storage.removeItem(oldKey)
                        ];
                    case 6:
                        _c.sent();
                        ulid = newUlid;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        ulid = ulidOrId;
                        _c.label = 8;
                    case 8:
                        this.getCollectionIndex(storeName).set(id, ulid);
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        if (recordType === COLLECTION) keysForCollectionEntries.push(key);
                        _c.label = 10;
                    case 10:
                        allKeys_1_1 = allKeys_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        try {
                            if (allKeys_1_1 && !allKeys_1_1.done && (_b = allKeys_1.return)) _b.call(allKeys_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        if (!(keysForCollectionEntries.length > 0)) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.multiRemove(keysForCollectionEntries)
                        ];
                    case 15:
                        _c.sent();
                        _c.label = 16;
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.save = function(item, storeName, keys, keyValuesPath) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var idxName, ulid, itemKey;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        idxName = (0, _util.indexNameFromKeys)(keys);
                        ulid = ((_a = this.getCollectionIndex(storeName)) === null || _a === void 0 ? void 0 : _a.get(idxName)) || this.getMonotonicFactory(storeName)();
                        itemKey = this.getKeyForItem(storeName, keyValuesPath, ulid);
                        // Set key in collection index
                        (_b = this.getCollectionIndex(storeName)) === null || _b === void 0 || _b.set(keyValuesPath, ulid);
                        // Save item in db
                        return [
                            4 /*yield*/ ,
                            this.storage.setItem(itemKey, JSON.stringify(item))
                        ];
                    case 1:
                        // Save item in db
                        _c.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.batchSave = function(storeName, items, keys) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, collection, keysToDelete, keysToSave, allItemsKeys, itemsMap, _loop_1, this_1, items_1, items_1_1, item, existingRecordsMap, existingRecordsKeys, allItemsKeys_1, allItemsKeys_1_1, key;
            var e_2, _a, e_3, _b;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        result = [];
                        collection = this.getCollectionIndex(storeName);
                        keysToDelete = new Set();
                        keysToSave = new Set();
                        allItemsKeys = [];
                        itemsMap = {};
                        _loop_1 = function(item) {
                            // Extract keys from concatenated key path, map to item values
                            var keyValues = keys.map(function(field) {
                                return item[field];
                            });
                            var _deleted = item._deleted;
                            // If id is in the store, retrieve, otherwise generate new ULID
                            var ulid = collection.get(keyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR))) || this_1.getMonotonicFactory(storeName)();
                            // Generate the "longer key" for the item
                            var key = this_1.getKeyForItem(storeName, keyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)), ulid);
                            allItemsKeys.push(key);
                            itemsMap[key] = {
                                ulid: ulid,
                                model: item
                            };
                            if (_deleted) keysToDelete.add(key);
                            else keysToSave.add(key);
                        };
                        this_1 = this;
                        try {
                            /* Populate allItemKeys, keysToDelete, and keysToSave */ for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                _loop_1(item);
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.storage.multiGet(allItemsKeys)
                        ];
                    case 1:
                        existingRecordsMap = _c.sent();
                        existingRecordsKeys = existingRecordsMap.filter(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
                            return !!v;
                        }).reduce(function(set, _a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return set.add(k);
                        }, new Set());
                        // Delete
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                if (keysToDelete.size === 0) {
                                    resolve();
                                    return;
                                }
                                var keysToDeleteArray = Array.from(keysToDelete);
                                keysToDeleteArray.forEach(function(key) {
                                    // key: full db key
                                    // keys: PK and/or SK keys
                                    var primaryKeyValues = keys.map(function(field) {
                                        return itemsMap[key].model[field];
                                    }).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                    collection.delete(primaryKeyValues);
                                });
                                _this.storage.multiRemove(keysToDeleteArray, function(errors) {
                                    if (errors && errors.length > 0) reject(errors);
                                    else resolve();
                                });
                            })
                        ];
                    case 2:
                        // Delete
                        _c.sent();
                        // Save
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                if (keysToSave.size === 0) {
                                    resolve();
                                    return;
                                }
                                var entriesToSet = Array.from(keysToSave).map(function(key) {
                                    return [
                                        key,
                                        JSON.stringify(itemsMap[key].model)
                                    ];
                                });
                                keysToSave.forEach(function(key) {
                                    var _a = itemsMap[key], model = _a.model, ulid = _a.ulid;
                                    // Retrieve values from model, use as key for collection index
                                    var keyValues = keys.map(function(field) {
                                        return model[field];
                                    }).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                    collection.set(keyValues, ulid);
                                });
                                _this.storage.multiSet(entriesToSet, function(errors) {
                                    if (errors && errors.length > 0) reject(errors);
                                    else resolve();
                                });
                            })
                        ];
                    case 3:
                        // Save
                        _c.sent();
                        try {
                            for(allItemsKeys_1 = (0, _tslib.__values)(allItemsKeys), allItemsKeys_1_1 = allItemsKeys_1.next(); !allItemsKeys_1_1.done; allItemsKeys_1_1 = allItemsKeys_1.next()){
                                key = allItemsKeys_1_1.value;
                                if (keysToDelete.has(key) && existingRecordsKeys.has(key)) result.push([
                                    itemsMap[key].model,
                                    (0, _types.OpType).DELETE
                                ]);
                                else if (keysToSave.has(key)) result.push([
                                    itemsMap[key].model,
                                    existingRecordsKeys.has(key) ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT
                                ]);
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (allItemsKeys_1_1 && !allItemsKeys_1_1.done && (_b = allItemsKeys_1.return)) _b.call(allItemsKeys_1);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.get = function(keyValuePath, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ulid, itemKey, recordAsString, record;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ulid = this.getCollectionIndex(storeName).get(keyValuePath);
                        itemKey = this.getKeyForItem(storeName, keyValuePath, ulid);
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(itemKey)
                        ];
                    case 1:
                        recordAsString = _a.sent();
                        record = recordAsString && JSON.parse(recordAsString);
                        return [
                            2 /*return*/ ,
                            record
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.getOne = function(firstOrLast, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var collection, _a, itemId, ulid, itemKey, itemString, _b, result;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        collection = this.getCollectionIndex(storeName);
                        _a = (0, _tslib.__read)(firstOrLast === (0, _types.QueryOne).FIRST ? function() {
                            var e_4, _a, _b;
                            var id, ulid;
                            try {
                                for(var collection_1 = (0, _tslib.__values)(collection), collection_1_1 = collection_1.next(); !collection_1_1.done; collection_1_1 = collection_1.next()){
                                    _b = (0, _tslib.__read)(collection_1_1.value, 2), id = _b[0], ulid = _b[1];
                                    break;
                                } // Get first element of the set
                            } catch (e_4_1) {
                                e_4 = {
                                    error: e_4_1
                                };
                            } finally{
                                try {
                                    if (collection_1_1 && !collection_1_1.done && (_a = collection_1.return)) _a.call(collection_1);
                                } finally{
                                    if (e_4) throw e_4.error;
                                }
                            }
                            return [
                                id,
                                ulid
                            ];
                        }() : function() {
                            var e_5, _a, _b;
                            var id, ulid;
                            try {
                                for(var collection_2 = (0, _tslib.__values)(collection), collection_2_1 = collection_2.next(); !collection_2_1.done; collection_2_1 = collection_2.next())_b = (0, _tslib.__read)(collection_2_1.value, 2), id = _b[0], ulid = _b[1];
                                 // Get last element of the set
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (collection_2_1 && !collection_2_1.done && (_a = collection_2.return)) _a.call(collection_2);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                            return [
                                id,
                                ulid
                            ];
                        }(), 2), itemId = _a[0], ulid = _a[1];
                        itemKey = this.getKeyForItem(storeName, itemId, ulid);
                        _b = itemKey;
                        if (!_b) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(itemKey)
                        ];
                    case 1:
                        _b = _c.sent();
                        _c.label = 2;
                    case 2:
                        itemString = _b;
                        result = itemString ? JSON.parse(itemString) || undefined : undefined;
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * This function gets all the records stored in async storage for a particular storeName
     * It then loads all the records for that filtered set of keys using multiGet()
     */ AsyncStorageDatabase.prototype.getAll = function(storeName, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var collection, _a, _b, page, _c, limit, start, end, keysForStore, count, collection_3, collection_3_1, _d, id, ulid, storeRecordStrings, records;
            var e_6, _e;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        collection = this.getCollectionIndex(storeName);
                        _a = pagination || {}, _b = _a.page, page = _b === void 0 ? 0 : _b, _c = _a.limit, limit = _c === void 0 ? 0 : _c;
                        start = Math.max(0, page * limit) || 0;
                        end = limit > 0 ? start + limit : undefined;
                        keysForStore = [];
                        count = 0;
                        try {
                            for(collection_3 = (0, _tslib.__values)(collection), collection_3_1 = collection_3.next(); !collection_3_1.done; collection_3_1 = collection_3.next()){
                                _d = (0, _tslib.__read)(collection_3_1.value, 2), id = _d[0], ulid = _d[1];
                                count++;
                                if (count <= start) continue;
                                keysForStore.push(this.getKeyForItem(storeName, id, ulid));
                                if (count === end) break;
                            }
                        } catch (e_6_1) {
                            e_6 = {
                                error: e_6_1
                            };
                        } finally{
                            try {
                                if (collection_3_1 && !collection_3_1.done && (_e = collection_3.return)) _e.call(collection_3);
                            } finally{
                                if (e_6) throw e_6.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.storage.multiGet(keysForStore)
                        ];
                    case 1:
                        storeRecordStrings = _f.sent();
                        records = storeRecordStrings.filter(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), value = _b[1];
                            return value;
                        }).map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), value = _b[1];
                            return JSON.parse(value);
                        });
                        return [
                            2 /*return*/ ,
                            records
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.delete = function(key, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ulid, itemKey;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ulid = this.getCollectionIndex(storeName).get(key);
                        itemKey = this.getKeyForItem(storeName, key, ulid);
                        this.getCollectionIndex(storeName).delete(key);
                        return [
                            4 /*yield*/ ,
                            this.storage.removeItem(itemKey)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Clear the AsyncStorage of all DataStore entries
     */ AsyncStorageDatabase.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allKeys, allDataStoreKeys;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllKeys()
                        ];
                    case 1:
                        allKeys = _a.sent();
                        allDataStoreKeys = allKeys.filter(function(key) {
                            return key.startsWith(DB_NAME);
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.multiRemove(allDataStoreKeys)
                        ];
                    case 2:
                        _a.sent();
                        this._collectionInMemoryIndex.clear();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.getKeyForItem = function(storeName, id, ulid) {
        return this.getKeyPrefixForStoreItems(storeName) + "::" + ulid + "::" + id;
    };
    AsyncStorageDatabase.prototype.getLegacyKeyForItem = function(storeName, id) {
        return this.getKeyPrefixForStoreItems(storeName) + "::" + id;
    };
    AsyncStorageDatabase.prototype.getKeyPrefixForStoreItems = function(storeName) {
        return DB_NAME + "::" + storeName + "::" + DATA;
    };
    return AsyncStorageDatabase;
}();
exports.default = AsyncStorageDatabase;

},{"tslib":"9gMVn","../../types":"KjGQP","../../util":"89SDa","./InMemoryStore":"5T3u3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5T3u3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", ()=>InMemoryStore);
parcelHelpers.export(exports, "createInMemoryStore", ()=>createInMemoryStore);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var InMemoryStore = /** @class */ function() {
    function InMemoryStore() {
        var _this = this;
        this.db = new Map();
        this.getAllKeys = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        Array.from(this.db.keys())
                    ];
                });
            });
        };
        this.multiGet = function(keys) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        keys.reduce(function(res, k) {
                            return res.push([
                                k,
                                _this.db.get(k)
                            ]), res;
                        }, [])
                    ];
                });
            });
        };
        this.multiRemove = function(keys, callback) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    keys.forEach(function(k) {
                        return _this.db.delete(k);
                    });
                    typeof callback === "function" && callback();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        this.multiSet = function(entries, callback) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    entries.forEach(function(_a) {
                        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
                        _this.setItem(key, value);
                    });
                    typeof callback === "function" && callback();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        this.setItem = function(key, value) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.set(key, value)
                    ];
                });
            });
        };
        this.removeItem = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.delete(key)
                    ];
                });
            });
        };
        this.getItem = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.get(key)
                    ];
                });
            });
        };
    }
    return InMemoryStore;
}();
function createInMemoryStore() {
    return new InMemoryStore();
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9T7Vu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlMessage", ()=>ControlMessage);
parcelHelpers.export(exports, "SyncEngine", ()=>SyncEngine);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _pubsub = require("@aws-amplify/pubsub");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _datastoreConnectivity = require("./datastoreConnectivity");
var _datastoreConnectivityDefault = parcelHelpers.interopDefault(_datastoreConnectivity);
var _merger = require("./merger");
var _outbox = require("./outbox");
var _mutation = require("./processors/mutation");
var _subscription = require("./processors/subscription");
var _sync = require("./processors/sync");
var _utils = require("./utils");
var isNode = (0, _core.browserOrNode)().isNode;
var logger = new (0, _core.ConsoleLogger)("DataStore");
var ownSymbol = Symbol("sync");
var ControlMessage;
(function(ControlMessage) {
    ControlMessage["SYNC_ENGINE_STORAGE_SUBSCRIBED"] = "storageSubscribed";
    ControlMessage["SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED"] = "subscriptionsEstablished";
    ControlMessage["SYNC_ENGINE_SYNC_QUERIES_STARTED"] = "syncQueriesStarted";
    ControlMessage["SYNC_ENGINE_SYNC_QUERIES_READY"] = "syncQueriesReady";
    ControlMessage["SYNC_ENGINE_MODEL_SYNCED"] = "modelSynced";
    ControlMessage["SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED"] = "outboxMutationEnqueued";
    ControlMessage["SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED"] = "outboxMutationProcessed";
    ControlMessage["SYNC_ENGINE_OUTBOX_STATUS"] = "outboxStatus";
    ControlMessage["SYNC_ENGINE_NETWORK_STATUS"] = "networkStatus";
    ControlMessage["SYNC_ENGINE_READY"] = "ready";
})(ControlMessage || (ControlMessage = {}));
var SyncEngine = /** @class */ function() {
    function SyncEngine(schema, namespaceResolver, modelClasses, userModelClasses, storage, modelInstanceCreator, conflictHandler, errorHandler, syncPredicates, amplifyConfig, authModeStrategy, amplifyContext, connectivityMonitor) {
        var _this = this;
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.modelClasses = modelClasses;
        this.userModelClasses = userModelClasses;
        this.storage = storage;
        this.modelInstanceCreator = modelInstanceCreator;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.amplifyContext = amplifyContext;
        this.connectivityMonitor = connectivityMonitor;
        this.online = false;
        this.modelSyncedStatus = new WeakMap();
        this.connectionDisrupted = false;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        this.waitForSleepState = new Promise(function(resolve) {
            _this.syncQueriesObservableStartSleeping = resolve;
        });
        var MutationEvent = this.modelClasses["MutationEvent"];
        this.outbox = new (0, _outbox.MutationEventOutbox)(this.schema, MutationEvent, modelInstanceCreator, ownSymbol);
        this.modelMerger = new (0, _merger.ModelMerger)(this.outbox, ownSymbol);
        this.syncQueriesProcessor = new (0, _sync.SyncProcessor)(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
        this.subscriptionsProcessor = new (0, _subscription.SubscriptionProcessor)(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
        this.mutationsProcessor = new (0, _mutation.MutationProcessor)(this.schema, this.storage, this.userModelClasses, this.outbox, this.modelInstanceCreator, MutationEvent, this.amplifyConfig, this.authModeStrategy, errorHandler, conflictHandler, this.amplifyContext);
        this.datastoreConnectivity = this.connectivityMonitor || new (0, _datastoreConnectivityDefault.default)();
    }
    SyncEngine.prototype.getModelSyncedStatus = function(modelConstructor) {
        return this.modelSyncedStatus.get(modelConstructor);
    };
    SyncEngine.prototype.start = function(params) {
        var _this = this;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            logger.log("starting sync engine...");
            var subscriptions = [];
            _this.runningProcesses.add(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_1, startPromise, hasMutationsInOutbox;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.setupModels(params)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                observer.error(err_1);
                                return [
                                    2 /*return*/ 
                                ];
                            case 3:
                                startPromise = new Promise(function(doneStarting, failedStarting) {
                                    _this.datastoreConnectivity.status().subscribe(function(_a) {
                                        var online = _a.online;
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var ctlSubsObservable_1, dataSubsObservable, err_2, error_1;
                                                            var _a;
                                                            var _this = this;
                                                            return (0, _tslib.__generator)(this, function(_b) {
                                                                switch(_b.label){
                                                                    case 0:
                                                                        if (!(online && !this.online)) return [
                                                                            3 /*break*/ ,
                                                                            10
                                                                        ];
                                                                        this.online = online;
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                                                            data: {
                                                                                active: this.online
                                                                            }
                                                                        });
                                                                        dataSubsObservable = void 0;
                                                                        if (!isNode) return [
                                                                            3 /*break*/ ,
                                                                            1
                                                                        ];
                                                                        logger.warn("Realtime disabled when in a server-side environment");
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            6
                                                                        ];
                                                                    case 1:
                                                                        this.stopDisruptionListener = this.startDisruptionListener();
                                                                        //#region GraphQL Subscriptions
                                                                        _a = (0, _tslib.__read)(this.subscriptionsProcessor.start(), 2), ctlSubsObservable_1 = _a[0], dataSubsObservable = _a[1];
                                                                        _b.label = 2;
                                                                    case 2:
                                                                        _b.trys.push([
                                                                            2,
                                                                            4,
                                                                            ,
                                                                            5
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            new Promise(function(resolve, reject) {
                                                                                onTerminate.then(reject);
                                                                                var ctlSubsSubscription = ctlSubsObservable_1.subscribe({
                                                                                    next: function(msg) {
                                                                                        if (msg === (0, _subscription.CONTROL_MSG).CONNECTED) resolve();
                                                                                    },
                                                                                    error: function(err) {
                                                                                        reject(err);
                                                                                        var handleDisconnect = _this.disconnectionHandler();
                                                                                        handleDisconnect(err);
                                                                                    }
                                                                                });
                                                                                subscriptions.push(ctlSubsSubscription);
                                                                            })
                                                                        ];
                                                                    case 3:
                                                                        _b.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            5
                                                                        ];
                                                                    case 4:
                                                                        err_2 = _b.sent();
                                                                        observer.error(err_2);
                                                                        failedStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 5:
                                                                        logger.log("Realtime ready");
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED
                                                                        });
                                                                        _b.label = 6;
                                                                    case 6:
                                                                        _b.trys.push([
                                                                            6,
                                                                            8,
                                                                            ,
                                                                            9
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            new Promise(function(resolve, reject) {
                                                                                var syncQuerySubscription = _this.syncQueriesObservable().subscribe({
                                                                                    next: function(message) {
                                                                                        var type = message.type;
                                                                                        if (type === ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY) resolve();
                                                                                        observer.next(message);
                                                                                    },
                                                                                    complete: function() {
                                                                                        resolve();
                                                                                    },
                                                                                    error: function(error) {
                                                                                        reject(error);
                                                                                    }
                                                                                });
                                                                                if (syncQuerySubscription) subscriptions.push(syncQuerySubscription);
                                                                            })
                                                                        ];
                                                                    case 7:
                                                                        _b.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            9
                                                                        ];
                                                                    case 8:
                                                                        error_1 = _b.sent();
                                                                        observer.error(error_1);
                                                                        failedStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 9:
                                                                        //#endregion
                                                                        //#region process mutations (outbox)
                                                                        subscriptions.push(this.mutationsProcessor.start().subscribe(function(_a) {
                                                                            var modelDefinition = _a.modelDefinition, item = _a.model, hasMore = _a.hasMore;
                                                                            return _this.runningProcesses.add(function() {
                                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                    var modelConstructor, model;
                                                                                    var _this = this;
                                                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                                                        switch(_a.label){
                                                                                            case 0:
                                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                                                                return [
                                                                                                    4 /*yield*/ ,
                                                                                                    this.storage.runExclusive(function(storage) {
                                                                                                        return _this.modelMerger.merge(storage, model, modelDefinition);
                                                                                                    })
                                                                                                ];
                                                                                            case 1:
                                                                                                _a.sent();
                                                                                                observer.next({
                                                                                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED,
                                                                                                    data: {
                                                                                                        model: modelConstructor,
                                                                                                        element: model
                                                                                                    }
                                                                                                });
                                                                                                observer.next({
                                                                                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                                                                    data: {
                                                                                                        isEmpty: !hasMore
                                                                                                    }
                                                                                                });
                                                                                                return [
                                                                                                    2 /*return*/ 
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                            }, "mutation processor event");
                                                                        }));
                                                                        //#endregion
                                                                        //#region Merge subscriptions buffer
                                                                        // TODO: extract to function
                                                                        if (!isNode) subscriptions.push(dataSubsObservable.subscribe(function(_a) {
                                                                            var _b = (0, _tslib.__read)(_a, 3), _transformerMutationType = _b[0], modelDefinition = _b[1], item = _b[2];
                                                                            return _this.runningProcesses.add(function() {
                                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                    var modelConstructor, model;
                                                                                    var _this = this;
                                                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                                                        switch(_a.label){
                                                                                            case 0:
                                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                                                                return [
                                                                                                    4 /*yield*/ ,
                                                                                                    this.storage.runExclusive(function(storage) {
                                                                                                        return _this.modelMerger.merge(storage, model, modelDefinition);
                                                                                                    })
                                                                                                ];
                                                                                            case 1:
                                                                                                _a.sent();
                                                                                                return [
                                                                                                    2 /*return*/ 
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                            }, "subscription dataSubsObservable event");
                                                                        }));
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            11
                                                                        ];
                                                                    case 10:
                                                                        if (!online) {
                                                                            this.online = online;
                                                                            observer.next({
                                                                                type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                                                                data: {
                                                                                    active: this.online
                                                                                }
                                                                            });
                                                                            subscriptions.forEach(function(sub) {
                                                                                return sub.unsubscribe();
                                                                            });
                                                                            subscriptions = [];
                                                                        }
                                                                        _b.label = 11;
                                                                    case 11:
                                                                        doneStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, "datastore connectivity event")
                                                ];
                                            });
                                        });
                                    });
                                });
                                this.storage.observe(null, null, ownSymbol).filter(function(_a) {
                                    var model = _a.model;
                                    var modelDefinition = _this.getModelDefinition(model);
                                    return modelDefinition.syncable === true;
                                }).subscribe({
                                    next: function(_a) {
                                        var opType = _a.opType, model = _a.model, element = _a.element, condition = _a.condition;
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    this.runningProcesses.add(function() {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var namespace, MutationEventConstructor, modelDefinition, graphQLCondition, mutationEvent;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        namespace = this.schema.namespaces[this.namespaceResolver(model)];
                                                                        MutationEventConstructor = this.modelClasses["MutationEvent"];
                                                                        modelDefinition = this.getModelDefinition(model);
                                                                        graphQLCondition = (0, _utils.predicateToGraphQLCondition)(condition, modelDefinition);
                                                                        mutationEvent = (0, _utils.createMutationInstanceFromModelOperation)(namespace.relationships, this.getModelDefinition(model), opType, model, element, graphQLCondition, MutationEventConstructor, this.modelInstanceCreator);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.outbox.enqueue(this.storage, mutationEvent)
                                                                        ];
                                                                    case 1:
                                                                        _a.sent();
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED,
                                                                            data: {
                                                                                model: model,
                                                                                element: element
                                                                            }
                                                                        });
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                                            data: {
                                                                                isEmpty: false
                                                                            }
                                                                        });
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            startPromise
                                                                        ];
                                                                    case 2:
                                                                        _a.sent();
                                                                        // Set by the this.datastoreConnectivity.status().subscribe() loop
                                                                        if (this.online) this.mutationsProcessor.resume();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, "storage event")
                                                ];
                                            });
                                        });
                                    }
                                });
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_STORAGE_SUBSCRIBED
                                });
                                return [
                                    4 /*yield*/ ,
                                    this.outbox.peek(this.storage)
                                ];
                            case 4:
                                hasMutationsInOutbox = _a.sent() === undefined;
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                    data: {
                                        isEmpty: hasMutationsInOutbox
                                    }
                                });
                                return [
                                    4 /*yield*/ ,
                                    startPromise
                                ];
                            case 5:
                                _a.sent();
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_READY
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, "sync start");
        });
    };
    SyncEngine.prototype.getModelsMetadataWithNextFullSync = function(currentTimeStamp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelLastSync, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = Map.bind;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.add(function() {
                                return _this.getModelsMetadata();
                            }, "sync/index getModelsMetadataWithNextFullSync")
                        ];
                    case 1:
                        modelLastSync = new (_a.apply(Map, [
                            void 0,
                            _b.sent().map(function(_a) {
                                var namespace = _a.namespace, model = _a.model, lastSync = _a.lastSync, lastFullSync = _a.lastFullSync, fullSyncInterval = _a.fullSyncInterval, lastSyncPredicate = _a.lastSyncPredicate;
                                var nextFullSync = lastFullSync + fullSyncInterval;
                                var syncFrom = !lastFullSync || nextFullSync < currentTimeStamp ? 0 // perform full sync if expired
                                 : lastSync; // perform delta sync
                                return [
                                    _this.schema.namespaces[namespace].models[model],
                                    [
                                        namespace,
                                        syncFrom
                                    ]
                                ];
                            })
                        ]))();
                        return [
                            2 /*return*/ ,
                            modelLastSync
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.syncQueriesObservable = function() {
        var _this = this;
        if (!this.online) return (0, _zenObservableTsDefault.default).of();
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            var syncQueriesSubscription;
            _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var terminated, _loop_1, this_1;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                terminated = false;
                                _loop_1 = function() {
                                    var count, modelLastSync, paginatingModels, lastFullSyncStartedAt, syncInterval, start, syncDuration, lastStartedAt, msNextFullSync;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                count = new WeakMap();
                                                return [
                                                    4 /*yield*/ ,
                                                    this_1.getModelsMetadataWithNextFullSync(Date.now())
                                                ];
                                            case 1:
                                                modelLastSync = _a.sent();
                                                paginatingModels = new Set(modelLastSync.keys());
                                                return [
                                                    4 /*yield*/ ,
                                                    new Promise(function(resolve, reject) {
                                                        if (!_this.runningProcesses.isOpen) resolve();
                                                        onTerminate.then(function() {
                                                            return resolve();
                                                        });
                                                        syncQueriesSubscription = _this.syncQueriesProcessor.start(modelLastSync).subscribe({
                                                            next: function(_a) {
                                                                var namespace = _a.namespace, modelDefinition = _a.modelDefinition, items = _a.items, done = _a.done, startedAt = _a.startedAt, isFullSync = _a.isFullSync;
                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                    var modelConstructor, modelName, modelMetadata_1, lastFullSync, fullSyncInterval, counts;
                                                                    var _this = this;
                                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                                        switch(_b.label){
                                                                            case 0:
                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                if (!count.has(modelConstructor)) {
                                                                                    count.set(modelConstructor, {
                                                                                        new: 0,
                                                                                        updated: 0,
                                                                                        deleted: 0
                                                                                    });
                                                                                    start = (0, _util.getNow)();
                                                                                    lastStartedAt = lastStartedAt === undefined ? startedAt : Math.max(lastStartedAt, startedAt);
                                                                                }
                                                                                /**
                                                                                 * If there are mutations in the outbox for a given id, those need to be
                                                                                 * merged individually. Otherwise, we can merge them in batches.
                                                                                 */ return [
                                                                                    4 /*yield*/ ,
                                                                                    this.storage.runExclusive(function(storage) {
                                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                            var idsInOutbox, oneByOne, page, opTypeCount, oneByOne_1, oneByOne_1_1, item, opType, e_1_1, _a, _b, _c, counts;
                                                                                            var e_1, _d;
                                                                                            return (0, _tslib.__generator)(this, function(_e) {
                                                                                                switch(_e.label){
                                                                                                    case 0:
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.outbox.getModelIds(storage)
                                                                                                        ];
                                                                                                    case 1:
                                                                                                        idsInOutbox = _e.sent();
                                                                                                        oneByOne = [];
                                                                                                        page = items.filter(function(item) {
                                                                                                            var itemId = (0, _utils.getIdentifierValue)(modelDefinition, item);
                                                                                                            if (!idsInOutbox.has(itemId)) return true;
                                                                                                            oneByOne.push(item);
                                                                                                            return false;
                                                                                                        });
                                                                                                        opTypeCount = [];
                                                                                                        _e.label = 2;
                                                                                                    case 2:
                                                                                                        _e.trys.push([
                                                                                                            2,
                                                                                                            7,
                                                                                                            8,
                                                                                                            9
                                                                                                        ]);
                                                                                                        oneByOne_1 = (0, _tslib.__values)(oneByOne), oneByOne_1_1 = oneByOne_1.next();
                                                                                                        _e.label = 3;
                                                                                                    case 3:
                                                                                                        if (!!oneByOne_1_1.done) return [
                                                                                                            3 /*break*/ ,
                                                                                                            6
                                                                                                        ];
                                                                                                        item = oneByOne_1_1.value;
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.modelMerger.merge(storage, item, modelDefinition)
                                                                                                        ];
                                                                                                    case 4:
                                                                                                        opType = _e.sent();
                                                                                                        if (opType !== undefined) opTypeCount.push([
                                                                                                            item,
                                                                                                            opType
                                                                                                        ]);
                                                                                                        _e.label = 5;
                                                                                                    case 5:
                                                                                                        oneByOne_1_1 = oneByOne_1.next();
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            3
                                                                                                        ];
                                                                                                    case 6:
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            9
                                                                                                        ];
                                                                                                    case 7:
                                                                                                        e_1_1 = _e.sent();
                                                                                                        e_1 = {
                                                                                                            error: e_1_1
                                                                                                        };
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            9
                                                                                                        ];
                                                                                                    case 8:
                                                                                                        try {
                                                                                                            if (oneByOne_1_1 && !oneByOne_1_1.done && (_d = oneByOne_1.return)) _d.call(oneByOne_1);
                                                                                                        } finally{
                                                                                                            if (e_1) throw e_1.error;
                                                                                                        }
                                                                                                        return [
                                                                                                            7 /*endfinally*/ 
                                                                                                        ];
                                                                                                    case 9:
                                                                                                        _b = (_a = opTypeCount.push).apply;
                                                                                                        _c = [
                                                                                                            opTypeCount
                                                                                                        ];
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.modelMerger.mergePage(storage, modelConstructor, page, modelDefinition)
                                                                                                        ];
                                                                                                    case 10:
                                                                                                        _b.apply(_a, _c.concat([
                                                                                                            (0, _tslib.__spread).apply(void 0, [
                                                                                                                _e.sent()
                                                                                                            ])
                                                                                                        ]));
                                                                                                        counts = count.get(modelConstructor);
                                                                                                        opTypeCount.forEach(function(_a) {
                                                                                                            var _b = (0, _tslib.__read)(_a, 2), opType = _b[1];
                                                                                                            switch(opType){
                                                                                                                case (0, _types.OpType).INSERT:
                                                                                                                    counts.new++;
                                                                                                                    break;
                                                                                                                case (0, _types.OpType).UPDATE:
                                                                                                                    counts.updated++;
                                                                                                                    break;
                                                                                                                case (0, _types.OpType).DELETE:
                                                                                                                    counts.deleted++;
                                                                                                                    break;
                                                                                                                default:
                                                                                                                    throw new Error("Invalid opType " + opType);
                                                                                                            }
                                                                                                        });
                                                                                                        return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    })
                                                                                ];
                                                                            case 1:
                                                                                /**
                                                                                 * If there are mutations in the outbox for a given id, those need to be
                                                                                 * merged individually. Otherwise, we can merge them in batches.
                                                                                 */ _b.sent();
                                                                                if (!done) return [
                                                                                    3 /*break*/ ,
                                                                                    4
                                                                                ];
                                                                                modelName = modelDefinition.name;
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    this.getModelMetadata(namespace, modelName)
                                                                                ];
                                                                            case 2:
                                                                                modelMetadata_1 = _b.sent();
                                                                                lastFullSync = modelMetadata_1.lastFullSync, fullSyncInterval = modelMetadata_1.fullSyncInterval;
                                                                                syncInterval = fullSyncInterval;
                                                                                lastFullSyncStartedAt = lastFullSyncStartedAt === undefined ? lastFullSync : Math.max(lastFullSyncStartedAt, isFullSync ? startedAt : lastFullSync);
                                                                                modelMetadata_1 = this.modelClasses.ModelMetadata.copyOf(modelMetadata_1, function(draft) {
                                                                                    draft.lastSync = startedAt;
                                                                                    draft.lastFullSync = isFullSync ? startedAt : modelMetadata_1.lastFullSync;
                                                                                });
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    this.storage.save(modelMetadata_1, undefined, ownSymbol)
                                                                                ];
                                                                            case 3:
                                                                                _b.sent();
                                                                                counts = count.get(modelConstructor);
                                                                                this.modelSyncedStatus.set(modelConstructor, true);
                                                                                observer.next({
                                                                                    type: ControlMessage.SYNC_ENGINE_MODEL_SYNCED,
                                                                                    data: {
                                                                                        model: modelConstructor,
                                                                                        isFullSync: isFullSync,
                                                                                        isDeltaSync: !isFullSync,
                                                                                        counts: counts
                                                                                    }
                                                                                });
                                                                                paginatingModels.delete(modelDefinition);
                                                                                if (paginatingModels.size === 0) {
                                                                                    syncDuration = (0, _util.getNow)() - start;
                                                                                    resolve();
                                                                                    observer.next({
                                                                                        type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY
                                                                                    });
                                                                                    syncQueriesSubscription.unsubscribe();
                                                                                }
                                                                                _b.label = 4;
                                                                            case 4:
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            },
                                                            error: function(error) {
                                                                observer.error(error);
                                                            }
                                                        });
                                                        observer.next({
                                                            type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_STARTED,
                                                            data: {
                                                                models: Array.from(paginatingModels).map(function(_a) {
                                                                    var name = _a.name;
                                                                    return name;
                                                                })
                                                            }
                                                        });
                                                    })
                                                ];
                                            case 2:
                                                _a.sent();
                                                if (!lastFullSyncStartedAt) msNextFullSync = syncInterval - syncDuration;
                                                else msNextFullSync = lastFullSyncStartedAt + syncInterval - (lastStartedAt + syncDuration);
                                                logger.debug("Next fullSync in " + msNextFullSync / 1000 + " seconds. (" + new Date(Date.now() + msNextFullSync) + ")");
                                                // TODO: create `BackgroundProcessManager.sleep()` ... but, need to put
                                                // a lot of thought into what that contract looks like to
                                                //  support possible use-cases:
                                                //
                                                //  1. non-cancelable
                                                //  2. cancelable, unsleep on exit()
                                                //  3. cancelable, throw Error on exit()
                                                //  4. cancelable, callback first on exit()?
                                                //  5. ... etc. ? ...
                                                //
                                                // TLDR; this is a lot of complexity here for a sleep(),
                                                // but, it's not clear to me yet how to support an
                                                // extensible, centralized cancelable `sleep()` elegantly.
                                                return [
                                                    4 /*yield*/ ,
                                                    this_1.runningProcesses.add(function(onTerminate) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var sleepTimer, unsleep, sleep;
                                                            var _this = this;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                sleep = new Promise(function(_unsleep) {
                                                                    unsleep = _unsleep;
                                                                    sleepTimer = setTimeout(unsleep, msNextFullSync);
                                                                });
                                                                onTerminate.then(function() {
                                                                    terminated = true;
                                                                    _this.syncQueriesObservableStartSleeping();
                                                                    unsleep();
                                                                });
                                                                this.unsleepSyncQueriesObservable = unsleep;
                                                                this.syncQueriesObservableStartSleeping();
                                                                return [
                                                                    2 /*return*/ ,
                                                                    sleep
                                                                ];
                                                            });
                                                        });
                                                    }, "syncQueriesObservable sleep")
                                                ];
                                            case 3:
                                                // TODO: create `BackgroundProcessManager.sleep()` ... but, need to put
                                                // a lot of thought into what that contract looks like to
                                                //  support possible use-cases:
                                                //
                                                //  1. non-cancelable
                                                //  2. cancelable, unsleep on exit()
                                                //  3. cancelable, throw Error on exit()
                                                //  4. cancelable, callback first on exit()?
                                                //  5. ... etc. ? ...
                                                //
                                                // TLDR; this is a lot of complexity here for a sleep(),
                                                // but, it's not clear to me yet how to support an
                                                // extensible, centralized cancelable `sleep()` elegantly.
                                                _a.sent();
                                                this_1.unsleepSyncQueriesObservable = null;
                                                this_1.waitForSleepState = new Promise(function(resolve) {
                                                    _this.syncQueriesObservableStartSleeping = resolve;
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                };
                                this_1 = this;
                                _a.label = 1;
                            case 1:
                                if (!(!observer.closed && !terminated)) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                return [
                                    5 /*yield**/ ,
                                    _loop_1()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, "syncQueriesObservable main");
        });
    };
    SyncEngine.prototype.disconnectionHandler = function() {
        var _this = this;
        return function(msg) {
            // This implementation is tied to AWSAppSyncRealTimeProvider 'Connection closed', 'Timeout disconnect' msg
            if ((0, _pubsub.CONTROL_MSG).CONNECTION_CLOSED === msg || (0, _pubsub.CONTROL_MSG).TIMEOUT_DISCONNECT === msg) _this.datastoreConnectivity.socketDisconnected();
        };
    };
    SyncEngine.prototype.unsubscribeConnectivity = function() {
        this.datastoreConnectivity.unsubscribe();
    };
    /**
     * Stops all subscription activities and resolves when all activies report
     * that they're disconnected, done retrying, etc..
     */ SyncEngine.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("stopping sync engine");
                        /**
                         * Gracefully disconnecting subscribers first just prevents *more* work
                         * from entering the pipelines.
                         */ this.unsubscribeConnectivity();
                        /**
                         * Stop listening for websocket connection disruption
                         */ this.stopDisruptionListener && this.stopDisruptionListener();
                        /**
                         * aggressively shut down any lingering background processes.
                         * some of this might be semi-redundant with unsubscribing. however,
                         * unsubscribing doesn't allow us to wait for settling.
                         * (Whereas `stop()` does.)
                         */ return [
                            4 /*yield*/ ,
                            this.mutationsProcessor.stop()
                        ];
                    case 1:
                        /**
                         * aggressively shut down any lingering background processes.
                         * some of this might be semi-redundant with unsubscribing. however,
                         * unsubscribing doesn't allow us to wait for settling.
                         * (Whereas `stop()` does.)
                         */ _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.subscriptionsProcessor.stop()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.datastoreConnectivity.stop()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.syncQueriesProcessor.stop()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 5:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 6:
                        _a.sent();
                        logger.debug("sync engine stopped and ready to restart");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.setupModels = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var fullSyncInterval, ModelMetadataConstructor, models, savedModel, promises, result, _a, _b, modelMetadata, modelName, e_2_1;
            var e_2, _c;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        fullSyncInterval = params.fullSyncInterval;
                        ModelMetadataConstructor = this.modelClasses.ModelMetadata;
                        models = [];
                        Object.values(this.schema.namespaces).forEach(function(namespace) {
                            Object.values(namespace.models).filter(function(_a) {
                                var syncable = _a.syncable;
                                return syncable;
                            }).forEach(function(model) {
                                models.push([
                                    namespace.name,
                                    model
                                ]);
                                if (namespace.name === (0, _util.USER)) {
                                    var modelConstructor = _this.userModelClasses[model.name];
                                    _this.modelSyncedStatus.set(modelConstructor, false);
                                }
                            });
                        });
                        promises = models.map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), namespace = _b[0], model = _b[1];
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var modelMetadata, syncPredicate, lastSyncPredicate, prevSyncPredicate, syncPredicateUpdated_1;
                                var _c, _d, _e, _f;
                                return (0, _tslib.__generator)(this, function(_g) {
                                    switch(_g.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.getModelMetadata(namespace, model.name)
                                            ];
                                        case 1:
                                            modelMetadata = _g.sent();
                                            syncPredicate = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(model), false);
                                            lastSyncPredicate = syncPredicate ? JSON.stringify(syncPredicate) : null;
                                            if (!(modelMetadata === undefined)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(this.modelInstanceCreator(ModelMetadataConstructor, {
                                                    model: model.name,
                                                    namespace: namespace,
                                                    lastSync: null,
                                                    fullSyncInterval: fullSyncInterval,
                                                    lastFullSync: null,
                                                    lastSyncPredicate: lastSyncPredicate
                                                }), undefined, ownSymbol)
                                            ];
                                        case 2:
                                            _c = (0, _tslib.__read).apply(void 0, [
                                                _g.sent(),
                                                1
                                            ]), _d = (0, _tslib.__read)(_c[0], 1), savedModel = _d[0];
                                            return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 3:
                                            prevSyncPredicate = modelMetadata.lastSyncPredicate ? modelMetadata.lastSyncPredicate : null;
                                            syncPredicateUpdated_1 = prevSyncPredicate !== lastSyncPredicate;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(ModelMetadataConstructor.copyOf(modelMetadata, function(draft) {
                                                    draft.fullSyncInterval = fullSyncInterval;
                                                    // perform a base sync if the syncPredicate changed in between calls to DataStore.start
                                                    // ensures that the local store contains all the data specified by the syncExpression
                                                    if (syncPredicateUpdated_1) {
                                                        draft.lastSync = null;
                                                        draft.lastFullSync = null;
                                                        draft.lastSyncPredicate = lastSyncPredicate;
                                                    }
                                                }))
                                            ];
                                        case 4:
                                            _e = (0, _tslib.__read).apply(void 0, [
                                                _g.sent(),
                                                1
                                            ]), _f = (0, _tslib.__read)(_e[0], 1), savedModel = _f[0];
                                            _g.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ ,
                                                savedModel
                                            ];
                                    }
                                });
                            });
                        });
                        result = {};
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 2:
                        _a = (0, _tslib.__values).apply(void 0, [
                            _d.sent()
                        ]), _b = _a.next();
                        _d.label = 3;
                    case 3:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        modelMetadata = _b.value;
                        modelName = modelMetadata.model;
                        result[modelName] = modelMetadata;
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_2_1 = _d.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelsMetadata = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ModelMetadata, modelsMetadata;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata)
                        ];
                    case 1:
                        modelsMetadata = _a.sent();
                        return [
                            2 /*return*/ ,
                            modelsMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelMetadata = function(namespace, model) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ModelMetadata, predicate, _a, modelMetadata;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        predicate = (0, _predicates.ModelPredicateCreator).createFromAST(this.schema.namespaces[0, _util.SYNC].models[ModelMetadata.name], {
                            and: [
                                {
                                    namespace: {
                                        eq: namespace
                                    }
                                },
                                {
                                    model: {
                                        eq: model
                                    }
                                }
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata, predicate, {
                                page: 0,
                                limit: 1
                            })
                        ];
                    case 1:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            1
                        ]), modelMetadata = _a[0];
                        return [
                            2 /*return*/ ,
                            modelMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelDefinition = function(modelConstructor) {
        var namespaceName = this.namespaceResolver(modelConstructor);
        var modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
        return modelDefinition;
    };
    SyncEngine.getNamespace = function() {
        var namespace = {
            name: (0, _util.SYNC),
            relationships: {},
            enums: {
                OperationType: {
                    name: "OperationType",
                    values: [
                        "CREATE",
                        "UPDATE",
                        "DELETE"
                    ]
                }
            },
            nonModels: {},
            models: {
                MutationEvent: {
                    name: "MutationEvent",
                    pluralName: "MutationEvents",
                    syncable: false,
                    fields: {
                        id: {
                            name: "id",
                            type: "ID",
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: "model",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        data: {
                            name: "data",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        modelId: {
                            name: "modelId",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        operation: {
                            name: "operation",
                            type: {
                                enum: "Operationtype"
                            },
                            isArray: false,
                            isRequired: true
                        },
                        condition: {
                            name: "condition",
                            type: "String",
                            isArray: false,
                            isRequired: true
                        }
                    }
                },
                ModelMetadata: {
                    name: "ModelMetadata",
                    pluralName: "ModelsMetadata",
                    syncable: false,
                    fields: {
                        id: {
                            name: "id",
                            type: "ID",
                            isRequired: true,
                            isArray: false
                        },
                        namespace: {
                            name: "namespace",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: "model",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        lastSync: {
                            name: "lastSync",
                            type: "Int",
                            isRequired: false,
                            isArray: false
                        },
                        lastFullSync: {
                            name: "lastFullSync",
                            type: "Int",
                            isRequired: false,
                            isArray: false
                        },
                        fullSyncInterval: {
                            name: "fullSyncInterval",
                            type: "Int",
                            isRequired: true,
                            isArray: false
                        },
                        lastSyncPredicate: {
                            name: "lastSyncPredicate",
                            type: "String",
                            isRequired: false,
                            isArray: false
                        }
                    }
                }
            }
        };
        return namespace;
    };
    /**
     * listen for websocket connection disruption
     *
     * May indicate there was a period of time where messages
     * from AppSync were missed. A sync needs to be triggered to
     * retrieve the missed data.
     */ SyncEngine.prototype.startDisruptionListener = function() {
        var _this = this;
        return (0, _core.Hub).listen("api", function(data) {
            if (data.source === "PubSub" && data.payload.event === (0, _pubsub.CONNECTION_STATE_CHANGE)) {
                var connectionState = data.payload.data.connectionState;
                switch(connectionState){
                    // Do not need to listen for ConnectionDisruptedPendingNetwork
                    // Normal network reconnection logic will handle the sync
                    case (0, _pubsub.ConnectionState).ConnectionDisrupted:
                        _this.connectionDisrupted = true;
                        break;
                    case (0, _pubsub.ConnectionState).Connected:
                        if (_this.connectionDisrupted) _this.scheduleSync();
                        _this.connectionDisrupted = false;
                        break;
                }
            }
        });
    };
    /*
     * Schedule a sync to start when syncQueriesObservable enters sleep state
     * Start sync immediately if syncQueriesObservable is already in sleep state
     */ SyncEngine.prototype.scheduleSync = function() {
        var _this = this;
        return this.runningProcesses.isOpen && this.runningProcesses.add(function() {
            return _this.waitForSleepState.then(function() {
                // unsleepSyncQueriesObservable will be set if waitForSleepState has resolved
                _this.unsleepSyncQueriesObservable();
            });
        });
    };
    return SyncEngine;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@aws-amplify/pubsub":"13UKI","zen-observable-ts":"klrbV","../predicates":"lUiza","../types":"KjGQP","../util":"89SDa","./datastoreConnectivity":"eqpn9","./merger":"fhcz8","./outbox":"5XFLA","./processors/mutation":"dzBWo","./processors/subscription":"4c6AT","./processors/sync":"d8dcI","./utils":"60Gn0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"13UKI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PubSub", ()=>(0, _pubSub.PubSub));
parcelHelpers.export(exports, "CONNECTION_STATE_CHANGE", ()=>(0, _constants.CONNECTION_STATE_CHANGE));
parcelHelpers.export(exports, "ConnectionState", ()=>(0, _types.ConnectionState));
parcelHelpers.export(exports, "CONTROL_MSG", ()=>(0, _types.CONTROL_MSG));
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", ()=>(0, _providers.AWSAppSyncRealTimeProvider));
parcelHelpers.export(exports, "AWSIoTProvider", ()=>(0, _providers.AWSIoTProvider));
parcelHelpers.export(exports, "AbstractPubSubProvider", ()=>(0, _providers.AbstractPubSubProvider));
parcelHelpers.export(exports, "MqttOverWSProvider", ()=>(0, _providers.MqttOverWSProvider));
parcelHelpers.export(exports, "mqttTopicMatch", ()=>(0, _providers.mqttTopicMatch));
var _pubSub = require("./PubSub");
var _constants = require("./Providers/constants");
var _types = require("./types");
var _providers = require("./Providers");

},{"./PubSub":"ftTPd","./Providers/constants":"4sHsy","./types":"3fjtY","./Providers":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ftTPd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PubSubClass", ()=>PubSubClass);
parcelHelpers.export(exports, "PubSub", ()=>PubSub);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _internals = require("./internals");
var PubSubClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(PubSubClass, _super);
    function PubSubClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PubSubClass.prototype.getModuleName = function() {
        return "PubSub";
    };
    PubSubClass.prototype.subscribe = function(topics, options) {
        return _super.prototype.subscribe.call(this, topics, options);
    };
    return PubSubClass;
}((0, _internals.InternalPubSubClass));
var PubSub = new PubSubClass();
(0, _core.Amplify).register(PubSub);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./internals":"7x5ZR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3fjtY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", ()=>(0, _pubSub.CONTROL_MSG));
parcelHelpers.export(exports, "ConnectionState", ()=>(0, _pubSub.ConnectionState));
var _pubSub = require("./PubSub");

},{"./PubSub":"l4jyc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eqpn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _core = require("@aws-amplify/core");
var _datastoreReachability = require("./datastoreReachability");
var logger = new (0, _core.ConsoleLogger)("DataStore");
var RECONNECTING_IN = 5000; // 5s this may be configurable in the future
var DataStoreConnectivity = /** @class */ function() {
    function DataStoreConnectivity() {
        this.connectionStatus = {
            online: false
        };
    }
    DataStoreConnectivity.prototype.status = function() {
        var _this = this;
        if (this.observer) throw new Error("Subscriber already exists");
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.observer = observer;
            // Will be used to forward socket connection changes, enhancing Reachability
            _this.subscription = (0, _datastoreReachability.ReachabilityMonitor).subscribe(function(_a) {
                var online = _a.online;
                _this.connectionStatus.online = online;
                var observerResult = (0, _tslib.__assign)({}, _this.connectionStatus); // copyOf status
                observer.next(observerResult);
            });
            return function() {
                clearTimeout(_this.timeout);
                _this.unsubscribe();
            };
        });
    };
    DataStoreConnectivity.prototype.unsubscribe = function() {
        if (this.subscription) {
            clearTimeout(this.timeout);
            this.subscription.unsubscribe();
        }
    };
    // for consistency with other background processors.
    DataStoreConnectivity.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                this.unsubscribe();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    DataStoreConnectivity.prototype.socketDisconnected = function() {
        var _this = this;
        if (this.observer && typeof this.observer.next === "function") {
            this.observer.next({
                online: false
            }); // Notify network issue from the socket
            this.timeout = setTimeout(function() {
                var observerResult = (0, _tslib.__assign)({}, _this.connectionStatus); // copyOf status
                _this.observer.next(observerResult);
            }, RECONNECTING_IN); // giving time for socket cleanup and network status stabilization
        }
    };
    return DataStoreConnectivity;
}();
exports.default = DataStoreConnectivity;

},{"tslib":"9gMVn","zen-observable-ts":"klrbV","@aws-amplify/core":"8BDOx","./datastoreReachability":"lHGxO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lHGxO":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReachabilityMonitor", ()=>ReachabilityMonitor);
var _core = require("@aws-amplify/core");
var ReachabilityMonitor = new (0, _core.Reachability)().networkMonitor();

},{"@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fhcz8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelMerger", ()=>ModelMerger);
var _tslib = require("tslib");
var _types = require("../types");
var _utils = require("./utils");
// https://github.com/aws-amplify/amplify-js/blob/datastore-docs/packages/datastore/docs/sync-engine.md#merger
var ModelMerger = /** @class */ function() {
    function ModelMerger(outbox, ownSymbol) {
        this.outbox = outbox;
        this.ownSymbol = ownSymbol;
    }
    /**
     *
     * @param storage Storage adapter that contains the data.
     * @param model The model from an outbox mutation.
     * @returns The type of operation (INSERT/UPDATE/DELETE)
     */ ModelMerger.prototype.merge = function(storage, model, modelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, mutationsForModel, isDelete;
            var _a, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.outbox.getForModel(storage, model, modelDefinition)
                        ];
                    case 1:
                        mutationsForModel = _c.sent();
                        isDelete = model._deleted;
                        if (!(mutationsForModel.length === 0)) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!isDelete) return [
                            3 /*break*/ ,
                            3
                        ];
                        result = (0, _types.OpType).DELETE;
                        return [
                            4 /*yield*/ ,
                            storage.delete(model, undefined, this.ownSymbol)
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            storage.save(model, undefined, this.ownSymbol)
                        ];
                    case 4:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _c.sent(),
                            1
                        ]), _b = (0, _tslib.__read)(_a[0], 2), result = _b[1];
                        _c.label = 5;
                    case 5:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    ModelMerger.prototype.mergePage = function(storage, modelConstructor, items, modelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemsMap, items_1, items_1_1, item, modelId, page;
            var e_1, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        itemsMap = new Map();
                        try {
                            for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                modelId = (0, _utils.getIdentifierValue)(modelDefinition, item);
                                itemsMap.set(modelId, item);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        page = (0, _tslib.__spread)(itemsMap.values());
                        return [
                            4 /*yield*/ ,
                            storage.batchSave(modelConstructor, page, this.ownSymbol)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return ModelMerger;
}();

},{"tslib":"9gMVn","../types":"KjGQP","./utils":"60Gn0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5XFLA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationEventOutbox", ()=>MutationEventOutbox);
var _tslib = require("tslib");
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _utils = require("./utils");
// TODO: Persist deleted ids
// https://github.com/aws-amplify/amplify-js/blob/datastore-docs/packages/datastore/docs/sync-engine.md#outbox
var MutationEventOutbox = /** @class */ function() {
    function MutationEventOutbox(schema, MutationEvent, modelInstanceCreator, ownSymbol) {
        this.schema = schema;
        this.MutationEvent = MutationEvent;
        this.modelInstanceCreator = modelInstanceCreator;
        this.ownSymbol = ownSymbol;
    }
    MutationEventOutbox.prototype.enqueue = function(storage, mutationEvent) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.runExclusive(function(s) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var mutationEventModelDefinition, predicate, _a, first, incomingMutationType, merged_1, incomingConditionJSON, incomingCondition, merged;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models["MutationEvent"];
                                                predicate = (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                                                    and: [
                                                        {
                                                            modelId: {
                                                                eq: mutationEvent.modelId
                                                            }
                                                        },
                                                        {
                                                            id: {
                                                                ne: this.inProgressMutationEventId
                                                            }
                                                        }
                                                    ]
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    s.query(this.MutationEvent, predicate)
                                                ];
                                            case 1:
                                                _a = (0, _tslib.__read).apply(void 0, [
                                                    _b.sent(),
                                                    1
                                                ]), first = _a[0];
                                                if (!(first === undefined)) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(mutationEvent, undefined, this.ownSymbol)
                                                ];
                                            case 2:
                                                _b.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                incomingMutationType = mutationEvent.operation;
                                                if (!(first.operation === (0, _utils.TransformerMutationType).CREATE)) return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                                if (!(incomingMutationType === (0, _utils.TransformerMutationType).DELETE)) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    s.delete(this.MutationEvent, predicate)
                                                ];
                                            case 4:
                                                _b.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    7
                                                ];
                                            case 5:
                                                merged_1 = this.mergeUserFields(first, mutationEvent);
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(this.MutationEvent.copyOf(first, function(draft) {
                                                        draft.data = merged_1.data;
                                                    }), undefined, this.ownSymbol)
                                                ];
                                            case 6:
                                                _b.sent();
                                                _b.label = 7;
                                            case 7:
                                                return [
                                                    3 /*break*/ ,
                                                    12
                                                ];
                                            case 8:
                                                incomingConditionJSON = mutationEvent.condition;
                                                incomingCondition = JSON.parse(incomingConditionJSON);
                                                merged = void 0;
                                                if (!(Object.keys(incomingCondition).length === 0)) return [
                                                    3 /*break*/ ,
                                                    10
                                                ];
                                                merged = this.mergeUserFields(first, mutationEvent);
                                                // delete all for model
                                                return [
                                                    4 /*yield*/ ,
                                                    s.delete(this.MutationEvent, predicate)
                                                ];
                                            case 9:
                                                // delete all for model
                                                _b.sent();
                                                _b.label = 10;
                                            case 10:
                                                merged = merged || mutationEvent;
                                                // Enqueue new one
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(merged, undefined, this.ownSymbol)
                                                ];
                                            case 11:
                                                // Enqueue new one
                                                _b.sent();
                                                _b.label = 12;
                                            case 12:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.dequeue = function(storage, record, recordOp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var head;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.peek(storage)
                        ];
                    case 1:
                        head = _a.sent();
                        if (!record) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.syncOutboxVersionsOnDequeue(storage, record, head, recordOp)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            storage.delete(head)
                        ];
                    case 4:
                        _a.sent();
                        this.inProgressMutationEventId = undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    /**
     * Doing a peek() implies that the mutation goes "inProgress"
     *
     * @param storage
     */ MutationEventOutbox.prototype.peek = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var head;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.queryOne(this.MutationEvent, (0, _types.QueryOne).FIRST)
                        ];
                    case 1:
                        head = _a.sent();
                        this.inProgressMutationEventId = head ? head.id : undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getForModel = function(storage, model, userModelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationEventModelDefinition, modelId, mutationEvents;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models.MutationEvent;
                        modelId = (0, _utils.getIdentifierValue)(userModelDefinition, model);
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                                and: {
                                    modelId: {
                                        eq: modelId
                                    }
                                }
                            }))
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        return [
                            2 /*return*/ ,
                            mutationEvents
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getModelIds = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationEvents, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent)
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        result = new Set();
                        mutationEvents.forEach(function(_a) {
                            var modelId = _a.modelId;
                            return result.add(modelId);
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    // applies _version from the AppSync mutation response to other items
    // in the mutation queue with the same id
    // see https://github.com/aws-amplify/amplify-js/pull/7354 for more details
    MutationEventOutbox.prototype.syncOutboxVersionsOnDequeue = function(storage, record, head, recordOp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _version, _lastChangedAt, _deleted, _incomingData, incomingData, data, __version, __lastChangedAt, __deleted, _outgoingData, outgoingData, mutationEventModelDefinition, userModelDefinition, recordId, predicate, outdatedMutations, reconciledMutations;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (head.operation !== recordOp) return [
                            2 /*return*/ 
                        ];
                        _version = record._version, _lastChangedAt = record._lastChangedAt, _deleted = record._deleted, _incomingData = (0, _tslib.__rest)(record, [
                            "_version",
                            "_lastChangedAt",
                            "_deleted"
                        ]);
                        incomingData = this.removeTimestampFields(head.model, _incomingData);
                        data = JSON.parse(head.data);
                        if (!data) return [
                            2 /*return*/ 
                        ];
                        __version = data._version, __lastChangedAt = data._lastChangedAt, __deleted = data._deleted, _outgoingData = (0, _tslib.__rest)(data, [
                            "_version",
                            "_lastChangedAt",
                            "_deleted"
                        ]);
                        outgoingData = this.removeTimestampFields(head.model, _outgoingData);
                        // Don't sync the version when the data in the response does not match the data
                        // in the request, i.e., when there's a handled conflict
                        //
                        // NOTE: `incomingData` contains all the fields in the record, and `outgoingData`
                        // only contains updated fields, resulting in an error when doing a comparison
                        // of two equal mutations. Fix this, or mitigate otherwise.
                        if (!(0, _util.valuesEqual)(incomingData, outgoingData, true)) return [
                            2 /*return*/ 
                        ];
                        mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models["MutationEvent"];
                        userModelDefinition = this.schema.namespaces["user"].models[head.model];
                        recordId = (0, _utils.getIdentifierValue)(userModelDefinition, record);
                        predicate = (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                            and: [
                                {
                                    modelId: {
                                        eq: recordId
                                    }
                                },
                                {
                                    id: {
                                        ne: this.inProgressMutationEventId
                                    }
                                }
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, predicate)
                        ];
                    case 1:
                        outdatedMutations = _a.sent();
                        if (!outdatedMutations.length) return [
                            2 /*return*/ 
                        ];
                        reconciledMutations = outdatedMutations.map(function(m) {
                            var oldData = JSON.parse(m.data);
                            var newData = (0, _tslib.__assign)((0, _tslib.__assign)({}, oldData), {
                                _version: _version,
                                _lastChangedAt: _lastChangedAt
                            });
                            return _this.MutationEvent.copyOf(m, function(draft) {
                                draft.data = JSON.stringify(newData);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            storage.delete(this.MutationEvent, predicate)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Promise.all(reconciledMutations.map(function(m) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    storage.save(m, undefined, this.ownSymbol)
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.mergeUserFields = function(previous, current) {
        var _a = JSON.parse(previous.data), _version = _a._version, _lastChangedAt = _a._lastChangedAt, _deleted = _a._deleted, previousData = (0, _tslib.__rest)(_a, [
            "_version",
            "_lastChangedAt",
            "_deleted"
        ]);
        var _b = JSON.parse(current.data), __version = _b._version, __lastChangedAt = _b._lastChangedAt, __deleted = _b._deleted, currentData = (0, _tslib.__rest)(_b, [
            "_version",
            "_lastChangedAt",
            "_deleted"
        ]);
        var data = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({
            _version: _version,
            _lastChangedAt: _lastChangedAt,
            _deleted: _deleted
        }, previousData), currentData));
        return this.modelInstanceCreator(this.MutationEvent, (0, _tslib.__assign)((0, _tslib.__assign)({}, current), {
            data: data
        }));
    };
    /*
    if a model is using custom timestamp fields
    the custom field names will be stored in the model attributes

    e.g.
    "attributes": [
    {
            "type": "model",
            "properties": {
                "timestamps": {
                    "createdAt": "createdOn",
                    "updatedAt": "updatedOn"
                }
            }
    }
    ]
    */ MutationEventOutbox.prototype.removeTimestampFields = function(model, record) {
        var _a, _b;
        var CREATED_AT_DEFAULT_KEY = "createdAt";
        var UPDATED_AT_DEFAULT_KEY = "updatedAt";
        var createdTimestampKey = CREATED_AT_DEFAULT_KEY;
        var updatedTimestampKey = UPDATED_AT_DEFAULT_KEY;
        var modelAttributes = (_a = this.schema.namespaces[0, _util.USER].models[model].attributes) === null || _a === void 0 ? void 0 : _a.find(function(attr) {
            return attr.type === "model";
        });
        var timestampFieldsMap = (_b = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _b === void 0 ? void 0 : _b.timestamps;
        if (timestampFieldsMap) {
            createdTimestampKey = timestampFieldsMap[CREATED_AT_DEFAULT_KEY];
            updatedTimestampKey = timestampFieldsMap[UPDATED_AT_DEFAULT_KEY];
        }
        delete record[createdTimestampKey];
        delete record[updatedTimestampKey];
        return record;
    };
    return MutationEventOutbox;
}();

},{"tslib":"9gMVn","../predicates":"lUiza","../types":"KjGQP","../util":"89SDa","./utils":"60Gn0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dzBWo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJitteredBackoff", ()=>safeJitteredBackoff);
parcelHelpers.export(exports, "MutationProcessor", ()=>MutationProcessor);
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api/internals");
var _core = require("@aws-amplify/core");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _util = require("../../util");
var _utils = require("../utils");
var _errorMaps = require("./errorMaps");
var MAX_ATTEMPTS = 10;
var logger = new (0, _core.ConsoleLogger)("DataStore");
var MutationProcessor = /** @class */ function() {
    function MutationProcessor(schema, storage, userClasses, outbox, modelInstanceCreator, MutationEvent, amplifyConfig, authModeStrategy, errorHandler, conflictHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.storage = storage;
        this.userClasses = userClasses;
        this.outbox = outbox;
        this.modelInstanceCreator = modelInstanceCreator;
        this.MutationEvent = MutationEvent;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.conflictHandler = conflictHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.processing = false;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        this.amplifyContext.InternalAPI = this.amplifyContext.InternalAPI || (0, _internals.InternalAPI);
        this.generateQueries();
    }
    MutationProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "CREATE"), 1), createMutation = _a[0];
                var _b = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "UPDATE"), 1), updateMutation = _b[0];
                var _c = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "DELETE"), 1), deleteMutation = _c[0];
                _this.typeQuery.set(model, [
                    createMutation,
                    updateMutation,
                    deleteMutation
                ]);
            });
        });
    };
    MutationProcessor.prototype.isReady = function() {
        return this.observer !== undefined;
    };
    MutationProcessor.prototype.start = function() {
        var _this = this;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        var observable = new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.observer = observer;
            try {
                _this.resume();
            } catch (error) {
                logger.error("mutations processor start error", error);
                throw error;
            }
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        // The observer has unsubscribed and/or `stop()` has been called.
                        this.removeObserver();
                        this.pause();
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        return observable;
    };
    MutationProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.removeObserver();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.removeObserver = function() {
        var _a, _b;
        (_b = (_a = this.observer) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
        this.observer = undefined;
    };
    MutationProcessor.prototype.resume = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var head, namespaceName, _loop_1, this_1, _a;
                                    var _this = this;
                                    var _b, _c;
                                    return (0, _tslib.__generator)(this, function(_d) {
                                        switch(_d.label){
                                            case 0:
                                                if (this.processing || !this.isReady() || !this.runningProcesses.isOpen) return [
                                                    2 /*return*/ 
                                                ];
                                                this.processing = true;
                                                namespaceName = (0, _util.USER);
                                                _loop_1 = function() {
                                                    var model, operation, data, condition, modelConstructor, result, opName, modelDefinition, modelAuthModes, operationAuthModes_1, authModeAttempts_1, authModeRetry_1, error_1, record, hasMore;
                                                    var _a;
                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                model = head.model, operation = head.operation, data = head.data, condition = head.condition;
                                                                modelConstructor = this_1.userClasses[model];
                                                                result = undefined;
                                                                opName = undefined;
                                                                modelDefinition = undefined;
                                                                _b.label = 1;
                                                            case 1:
                                                                _b.trys.push([
                                                                    1,
                                                                    4,
                                                                    ,
                                                                    5
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    (0, _utils.getModelAuthModes)({
                                                                        authModeStrategy: this_1.authModeStrategy,
                                                                        defaultAuthMode: this_1.amplifyConfig.aws_appsync_authenticationType,
                                                                        modelName: model,
                                                                        schema: this_1.schema
                                                                    })
                                                                ];
                                                            case 2:
                                                                modelAuthModes = _b.sent();
                                                                operationAuthModes_1 = modelAuthModes[operation.toUpperCase()];
                                                                authModeAttempts_1 = 0;
                                                                authModeRetry_1 = function() {
                                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                        var response, error_2, e_1;
                                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                                            switch(_a.label){
                                                                                case 0:
                                                                                    _a.trys.push([
                                                                                        0,
                                                                                        2,
                                                                                        ,
                                                                                        9
                                                                                    ]);
                                                                                    logger.debug("Attempting mutation with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        this.jitteredRetry(namespaceName, model, operation, data, condition, modelConstructor, this.MutationEvent, head, operationAuthModes_1[authModeAttempts_1], onTerminate)
                                                                                    ];
                                                                                case 1:
                                                                                    response = _a.sent();
                                                                                    logger.debug("Mutation sent successfully with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        2 /*return*/ ,
                                                                                        response
                                                                                    ];
                                                                                case 2:
                                                                                    error_2 = _a.sent();
                                                                                    authModeAttempts_1++;
                                                                                    if (!(authModeAttempts_1 >= operationAuthModes_1.length)) return [
                                                                                        3 /*break*/ ,
                                                                                        7
                                                                                    ];
                                                                                    logger.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1]);
                                                                                    _a.label = 3;
                                                                                case 3:
                                                                                    _a.trys.push([
                                                                                        3,
                                                                                        5,
                                                                                        ,
                                                                                        6
                                                                                    ]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        this.errorHandler({
                                                                                            recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                                            localModel: null,
                                                                                            message: error_2.message,
                                                                                            model: modelConstructor.name,
                                                                                            operation: opName,
                                                                                            errorType: (0, _errorMaps.getMutationErrorType)(error_2),
                                                                                            process: (0, _types.ProcessName).sync,
                                                                                            remoteModel: null,
                                                                                            cause: error_2
                                                                                        })
                                                                                    ];
                                                                                case 4:
                                                                                    _a.sent();
                                                                                    return [
                                                                                        3 /*break*/ ,
                                                                                        6
                                                                                    ];
                                                                                case 5:
                                                                                    e_1 = _a.sent();
                                                                                    logger.error("Mutation error handler failed with:", e_1);
                                                                                    return [
                                                                                        3 /*break*/ ,
                                                                                        6
                                                                                    ];
                                                                                case 6:
                                                                                    throw error_2;
                                                                                case 7:
                                                                                    logger.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1] + ". Retrying with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        authModeRetry_1()
                                                                                    ];
                                                                                case 8:
                                                                                    return [
                                                                                        2 /*return*/ ,
                                                                                        _a.sent()
                                                                                    ];
                                                                                case 9:
                                                                                    return [
                                                                                        2 /*return*/ 
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                };
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    authModeRetry_1()
                                                                ];
                                                            case 3:
                                                                _a = (0, _tslib.__read).apply(void 0, [
                                                                    _b.sent(),
                                                                    3
                                                                ]), result = _a[0], opName = _a[1], modelDefinition = _a[2];
                                                                return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                            case 4:
                                                                error_1 = _b.sent();
                                                                if (error_1.message === "Offline" || error_1.message === "RetryMutation") return [
                                                                    2 /*return*/ ,
                                                                    "continue"
                                                                ];
                                                                return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                            case 5:
                                                                if (!(result === undefined)) return [
                                                                    3 /*break*/ ,
                                                                    7
                                                                ];
                                                                logger.debug("done retrying");
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this_1.storage.runExclusive(function(storage) {
                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                                switch(_a.label){
                                                                                    case 0:
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.dequeue(storage)
                                                                                        ];
                                                                                    case 1:
                                                                                        _a.sent();
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                    })
                                                                ];
                                                            case 6:
                                                                _b.sent();
                                                                return [
                                                                    2 /*return*/ ,
                                                                    "continue"
                                                                ];
                                                            case 7:
                                                                record = result.data[opName];
                                                                hasMore = false;
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this_1.storage.runExclusive(function(storage) {
                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                                switch(_a.label){
                                                                                    case 0:
                                                                                        // using runExclusive to prevent possible race condition
                                                                                        // when another record gets enqueued between dequeue and peek
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.dequeue(storage, record, operation)
                                                                                        ];
                                                                                    case 1:
                                                                                        // using runExclusive to prevent possible race condition
                                                                                        // when another record gets enqueued between dequeue and peek
                                                                                        _a.sent();
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.peek(storage)
                                                                                        ];
                                                                                    case 2:
                                                                                        hasMore = _a.sent() !== undefined;
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                    })
                                                                ];
                                                            case 8:
                                                                _b.sent();
                                                                (_c = (_b = this_1.observer) === null || _b === void 0 ? void 0 : _b.next) === null || _c === void 0 || _c.call(_b, {
                                                                    operation: operation,
                                                                    modelDefinition: modelDefinition,
                                                                    model: record,
                                                                    hasMore: hasMore
                                                                });
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                };
                                                this_1 = this;
                                                _d.label = 1;
                                            case 1:
                                                _a = this.processing && this.runningProcesses.isOpen;
                                                if (!_a) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.outbox.peek(this.storage)
                                                ];
                                            case 2:
                                                _a = (head = _d.sent()) !== undefined;
                                                _d.label = 3;
                                            case 3:
                                                if (!_a) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    5 /*yield**/ ,
                                                    _loop_1()
                                                ];
                                            case 4:
                                                _d.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                            case 5:
                                                // pauses itself
                                                this.pause();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, "mutation resume loop")
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.jitteredRetry = function(namespaceName, model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent, authMode, onTerminate) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _core.retry)(function(model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var _a, query, variables, graphQLCondition, opName, modelDefinition, authToken, tryWith, attempt, opType, customUserAgentDetails, result, err_1, _b, error, _c, _d, code, retryWith, err_2, _e, _f, opName_1, query_1, authToken_1, serverData, namespace, updatedMutation;
                                    var _g;
                                    return (0, _tslib.__generator)(this, function(_h) {
                                        switch(_h.label){
                                            case 0:
                                                _a = (0, _tslib.__read)(this.createQueryVariables(namespaceName, model, operation, data, condition), 5), query = _a[0], variables = _a[1], graphQLCondition = _a[2], opName = _a[3], modelDefinition = _a[4];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 1:
                                                authToken = _h.sent();
                                                tryWith = {
                                                    query: query,
                                                    variables: variables,
                                                    authMode: authMode,
                                                    authToken: authToken
                                                };
                                                attempt = 0;
                                                opType = this.opTypeFromTransformerOperation(operation);
                                                customUserAgentDetails = {
                                                    category: (0, _core.Category).DataStore,
                                                    action: (0, _core.DataStoreAction).GraphQl
                                                };
                                                _h.label = 2;
                                            case 2:
                                                _h.trys.push([
                                                    2,
                                                    4,
                                                    ,
                                                    17
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql(tryWith, undefined, customUserAgentDetails)
                                                ];
                                            case 3:
                                                result = _h.sent();
                                                // Use `as any` because TypeScript doesn't seem to like passing tuples
                                                // through generic params.
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        result,
                                                        opName,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 4:
                                                err_1 = _h.sent();
                                                if (!(err_1.errors && err_1.errors.length > 0)) return [
                                                    3 /*break*/ ,
                                                    15
                                                ];
                                                _b = (0, _tslib.__read)(err_1.errors, 1), error = _b[0];
                                                _c = error.originalError, _d = (_c === void 0 ? {} : _c).code, code = _d === void 0 ? null : _d;
                                                if (error.errorType === "Unauthorized") throw new (0, _core.NonRetryableError)("Unauthorized");
                                                if (error.message === "Network Error" || code === "ECONNABORTED" // refers to axios timeout error caused by device's bad network condition
                                                ) {
                                                    if (!this.processing) throw new (0, _core.NonRetryableError)("Offline");
                                                    // TODO: Check errors on different env (react-native or other browsers)
                                                    throw new Error("Network Error");
                                                }
                                                if (!(error.errorType === "ConflictUnhandled")) return [
                                                    3 /*break*/ ,
                                                    13
                                                ];
                                                // TODO: add on ConflictConditionalCheck error query last from server
                                                attempt++;
                                                retryWith = void 0;
                                                if (!(attempt > MAX_ATTEMPTS)) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                retryWith = (0, _types.DISCARD);
                                                return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                            case 5:
                                                _h.trys.push([
                                                    5,
                                                    7,
                                                    ,
                                                    8
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.conflictHandler({
                                                        modelConstructor: modelConstructor,
                                                        localModel: this.modelInstanceCreator(modelConstructor, variables.input),
                                                        remoteModel: this.modelInstanceCreator(modelConstructor, error.data),
                                                        operation: opType,
                                                        attempts: attempt
                                                    })
                                                ];
                                            case 6:
                                                retryWith = _h.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                            case 7:
                                                err_2 = _h.sent();
                                                logger.warn("conflict trycatch", err_2);
                                                return [
                                                    3 /*break*/ ,
                                                    17
                                                ];
                                            case 8:
                                                if (!(retryWith === (0, _types.DISCARD))) return [
                                                    3 /*break*/ ,
                                                    11
                                                ];
                                                _e = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(this.schema.namespaces[namespaceName], modelDefinition, "GET"), 1), _f = (0, _tslib.__read)(_e[0], 3), opName_1 = _f[1], query_1 = _f[2];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 9:
                                                authToken_1 = _h.sent();
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql({
                                                        query: query_1,
                                                        variables: {
                                                            id: variables.input.id
                                                        },
                                                        authMode: authMode,
                                                        authToken: authToken_1
                                                    }, undefined, customUserAgentDetails)
                                                ];
                                            case 10:
                                                serverData = _h.sent();
                                                // onTerminate cancel graphql()
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        serverData,
                                                        opName_1,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 11:
                                                namespace = this.schema.namespaces[namespaceName];
                                                updatedMutation = (0, _utils.createMutationInstanceFromModelOperation)(namespace.relationships, modelDefinition, opType, modelConstructor, retryWith, graphQLCondition, MutationEvent, this.modelInstanceCreator, mutationEvent.id);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.storage.save(updatedMutation)
                                                ];
                                            case 12:
                                                _h.sent();
                                                throw new (0, _core.NonRetryableError)("RetryMutation");
                                            case 13:
                                                try {
                                                    this.errorHandler({
                                                        recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                        localModel: variables.input,
                                                        message: error.message,
                                                        operation: operation,
                                                        errorType: (0, _errorMaps.getMutationErrorType)(error),
                                                        errorInfo: error.errorInfo,
                                                        process: (0, _types.ProcessName).mutate,
                                                        cause: error,
                                                        remoteModel: error.data ? this.modelInstanceCreator(modelConstructor, error.data) : null
                                                    });
                                                } catch (err) {
                                                    logger.warn("Mutation error handler failed with:", err);
                                                } finally{
                                                    // Return empty tuple, dequeues the mutation
                                                    return [
                                                        2 /*return*/ ,
                                                        error.data ? [
                                                            {
                                                                data: (_g = {}, _g[opName] = error.data, _g)
                                                            },
                                                            opName,
                                                            modelDefinition
                                                        ] : []
                                                    ];
                                                }
                                                _h.label = 14;
                                            case 14:
                                                return [
                                                    3 /*break*/ ,
                                                    16
                                                ];
                                            case 15:
                                                // Catch-all for client-side errors that don't come back in the `GraphQLError` format.
                                                // These errors should not be retried.
                                                throw new (0, _core.NonRetryableError)(err_1);
                                            case 16:
                                                return [
                                                    3 /*break*/ ,
                                                    17
                                                ];
                                            case 17:
                                                if (tryWith) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _h.label = 18;
                                            case 18:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                model,
                                operation,
                                data,
                                condition,
                                modelConstructor,
                                MutationEvent,
                                mutationEvent
                            ], safeJitteredBackoff, onTerminate)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.createQueryVariables = function(namespaceName, model, operation, data, condition) {
        var e_2, _a, e_3, _b, e_4, _c;
        var _d, _e;
        var modelDefinition = this.schema.namespaces[namespaceName].models[model];
        var primaryKey = this.schema.namespaces[namespaceName].keys[model].primaryKey;
        var auth = (_d = modelDefinition.attributes) === null || _d === void 0 ? void 0 : _d.find(function(a) {
            return a.type === "auth";
        });
        var ownerFields = ((_e = auth === null || auth === void 0 ? void 0 : auth.properties) === null || _e === void 0 ? void 0 : _e.rules.map(function(rule) {
            return rule.ownerField;
        }).filter(function(f) {
            return f;
        })) || [
            "owner"
        ];
        var queriesTuples = this.typeQuery.get(modelDefinition);
        var _f = (0, _tslib.__read)(queriesTuples.find(function(_a) {
            var _b = (0, _tslib.__read)(_a, 1), transformerMutationType = _b[0];
            return transformerMutationType === operation;
        }), 3), opName = _f[1], query = _f[2];
        var _g = JSON.parse(data), _version = _g._version, parsedData = (0, _tslib.__rest)(_g, [
            "_version"
        ]);
        // include all the fields that comprise a custom PK if one is specified
        var deleteInput = {};
        if (primaryKey === null || primaryKey === void 0 ? void 0 : primaryKey.length) try {
            for(var primaryKey_1 = (0, _tslib.__values)(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()){
                var pkField = primaryKey_1_1.value;
                deleteInput[pkField] = parsedData[pkField];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (primaryKey_1_1 && !primaryKey_1_1.done && (_a = primaryKey_1.return)) _a.call(primaryKey_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        else deleteInput[0, _util.ID] = parsedData.id;
        var mutationInput;
        if (operation === (0, _utils.TransformerMutationType).DELETE) // For DELETE mutations, only the key(s) are included in the input
        mutationInput = deleteInput;
        else {
            // Otherwise, we construct the mutation input with the following logic
            mutationInput = {};
            var modelFields = Object.values(modelDefinition.fields);
            try {
                for(var modelFields_1 = (0, _tslib.__values)(modelFields), modelFields_1_1 = modelFields_1.next(); !modelFields_1_1.done; modelFields_1_1 = modelFields_1.next()){
                    var _h = modelFields_1_1.value, name_1 = _h.name, type = _h.type, association = _h.association, isReadOnly = _h.isReadOnly;
                    // omit readonly fields. cloud storage doesn't need them and won't take them!
                    if (isReadOnly) continue;
                    // omit owner fields if it's `null`. cloud storage doesn't allow it.
                    if (ownerFields.includes(name_1) && parsedData[name_1] === null) continue;
                    // model fields should be stripped out from the input
                    if ((0, _types.isModelFieldType)(type)) {
                        // except for belongs to relations - we need to replace them with the correct foreign key(s)
                        if ((0, _types.isTargetNameAssociation)(association) && association.connectionType === "BELONGS_TO") {
                            var targetNames = (0, _util.extractTargetNamesFromSrc)(association);
                            if (targetNames) try {
                                // instead of including the connected model itself, we add its key(s) to the mutation input
                                for(var targetNames_1 = (e_4 = void 0, (0, _tslib.__values)(targetNames)), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()){
                                    var targetName = targetNames_1_1.value;
                                    mutationInput[targetName] = parsedData[targetName];
                                }
                            } catch (e_4_1) {
                                e_4 = {
                                    error: e_4_1
                                };
                            } finally{
                                try {
                                    if (targetNames_1_1 && !targetNames_1_1.done && (_c = targetNames_1.return)) _c.call(targetNames_1);
                                } finally{
                                    if (e_4) throw e_4.error;
                                }
                            }
                        }
                        continue;
                    }
                    // scalar fields / non-model types
                    if (operation === (0, _utils.TransformerMutationType).UPDATE) {
                        if (!parsedData.hasOwnProperty(name_1)) continue;
                    }
                    // all other fields are added to the input object
                    mutationInput[name_1] = parsedData[name_1];
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (modelFields_1_1 && !modelFields_1_1.done && (_b = modelFields_1.return)) _b.call(modelFields_1);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        }
        // Build mutation variables input object
        var input = (0, _tslib.__assign)((0, _tslib.__assign)({}, mutationInput), {
            _version: _version
        });
        var graphQLCondition = JSON.parse(condition);
        var variables = (0, _tslib.__assign)({
            input: input
        }, operation === (0, _utils.TransformerMutationType).CREATE ? {} : {
            condition: Object.keys(graphQLCondition).length > 0 ? graphQLCondition : null
        });
        return [
            query,
            variables,
            graphQLCondition,
            opName,
            modelDefinition
        ];
    };
    MutationProcessor.prototype.opTypeFromTransformerOperation = function(operation) {
        switch(operation){
            case (0, _utils.TransformerMutationType).CREATE:
                return (0, _types.OpType).INSERT;
            case (0, _utils.TransformerMutationType).DELETE:
                return (0, _types.OpType).DELETE;
            case (0, _utils.TransformerMutationType).UPDATE:
                return (0, _types.OpType).UPDATE;
            case (0, _utils.TransformerMutationType).GET:
                break;
            default:
                throw new Error("Invalid operation " + operation);
        }
        // because it makes TS happy ...
        return undefined;
    };
    MutationProcessor.prototype.pause = function() {
        this.processing = false;
    };
    return MutationProcessor;
}();
var MAX_RETRY_DELAY_MS = 300000;
var originalJitteredBackoff = (0, _core.jitteredBackoff)(MAX_RETRY_DELAY_MS);
var safeJitteredBackoff = function(attempt, _args, error) {
    var attemptResult = originalJitteredBackoff(attempt);
    // If this is the last attempt and it is a network error, we retry indefinitively every 5 minutes
    if (attemptResult === false && (error === null || error === void 0 ? void 0 : error.message) === "Network Error") return MAX_RETRY_DELAY_MS;
    return attemptResult;
};

},{"tslib":"9gMVn","@aws-amplify/api/internals":"lW1BO","@aws-amplify/core":"8BDOx","zen-observable-ts":"klrbV","../../types":"KjGQP","../../util":"89SDa","../utils":"60Gn0","./errorMaps":"4s4oO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4s4oO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mutationErrorMap", ()=>mutationErrorMap);
parcelHelpers.export(exports, "subscriptionErrorMap", ()=>subscriptionErrorMap);
parcelHelpers.export(exports, "syncErrorMap", ()=>syncErrorMap);
parcelHelpers.export(exports, "getMutationErrorType", ()=>getMutationErrorType);
parcelHelpers.export(exports, "getSubscriptionErrorType", ()=>getSubscriptionErrorType);
parcelHelpers.export(exports, "getSyncErrorType", ()=>getSyncErrorType);
/**
 * Categorizes an error with a broad error type, intended to make
 * customer error handling code simpler.
 * @param errorMap Error names and a list of patterns that indicate them (each pattern as a regex or function)
 * @param error The underying error to categorize.
 */ parcelHelpers.export(exports, "mapErrorToType", ()=>mapErrorToType);
var _tslib = require("tslib");
var connectionTimeout = function(error) {
    return /^Connection failed: Connection Timeout/.test(error.message);
};
var serverError = function(error) {
    return /^Error: Request failed with status code 5\d\d/.test(error.message);
};
var mutationErrorMap = {
    BadModel: function() {
        return false;
    },
    BadRecord: function(error) {
        var message = error.message;
        return /^Cannot return \w+ for [\w-_]+ type/.test(message) || /^Variable '.+' has coerced Null value for NonNull type/.test(message); // newly required field, out of date client
    },
    ConfigError: function() {
        return false;
    },
    Transient: function(error) {
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function(error) {
        return error.message === "Unauthorized" || /^Request failed with status code 401/.test(error.message);
    }
};
var subscriptionErrorMap = {
    BadModel: function() {
        return false;
    },
    BadRecord: function() {
        return false;
    },
    ConfigError: function() {
        return false;
    },
    Transient: function(observableError) {
        var error = unwrapObservableError(observableError);
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function(observableError) {
        var error = unwrapObservableError(observableError);
        return /Connection failed.+Unauthorized/.test(error.message);
    }
};
var syncErrorMap = {
    BadModel: function() {
        return false;
    },
    BadRecord: function(error) {
        return /^Cannot return \w+ for [\w-_]+ type/.test(error.message);
    },
    ConfigError: function() {
        return false;
    },
    Transient: function(error) {
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function(error) {
        return error.errorType === "Unauthorized";
    }
};
/**
 * Get the first error reason of an observable.
 * Allows for error maps to be easily applied to observable errors
 *
 * @param observableError an error from ZenObservable subscribe error callback
 */ function unwrapObservableError(observableError) {
    var _a = observableError.error, _b = (0, _tslib.__read)((_a === void 0 ? {
        errors: []
    } : _a).errors, 1), error = _b[0];
    return error;
}
function getMutationErrorType(error) {
    return mapErrorToType(mutationErrorMap, error);
}
function getSubscriptionErrorType(error) {
    return mapErrorToType(subscriptionErrorMap, error);
}
function getSyncErrorType(error) {
    return mapErrorToType(syncErrorMap, error);
}
function mapErrorToType(errorMap, error) {
    var e_1, _a;
    var errorTypes = (0, _tslib.__spread)(Object.keys(errorMap));
    try {
        for(var errorTypes_1 = (0, _tslib.__values)(errorTypes), errorTypes_1_1 = errorTypes_1.next(); !errorTypes_1_1.done; errorTypes_1_1 = errorTypes_1.next()){
            var errorType = errorTypes_1_1.value;
            var matcher = errorMap[errorType];
            if (matcher === null || matcher === void 0 ? void 0 : matcher(error)) return errorType;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (errorTypes_1_1 && !errorTypes_1_1.done && (_a = errorTypes_1.return)) _a.call(errorTypes_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return "Unknown";
}

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4c6AT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", ()=>CONTROL_MSG);
parcelHelpers.export(exports, "USER_CREDENTIALS", ()=>USER_CREDENTIALS);
parcelHelpers.export(exports, "SubscriptionProcessor", ()=>SubscriptionProcessor);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _api = require("@aws-amplify/api");
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _pubsub = require("@aws-amplify/pubsub");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _utils = require("../utils");
var _predicates = require("../../predicates");
var _util = require("../../util");
var _errorMaps = require("./errorMaps");
var Buffer = require("a5da572164cb8f31").Buffer;
var logger = new (0, _core.ConsoleLogger)("DataStore");
var CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTED"] = "CONNECTED";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var USER_CREDENTIALS;
(function(USER_CREDENTIALS) {
    USER_CREDENTIALS[USER_CREDENTIALS["none"] = 0] = "none";
    USER_CREDENTIALS[USER_CREDENTIALS["unauth"] = 1] = "unauth";
    USER_CREDENTIALS[USER_CREDENTIALS["auth"] = 2] = "auth";
})(USER_CREDENTIALS || (USER_CREDENTIALS = {}));
var SubscriptionProcessor = /** @class */ function() {
    function SubscriptionProcessor(schema, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        if (amplifyContext === void 0) amplifyContext = {
            Auth: (0, _auth.Auth),
            InternalAPI: (0, _internals.InternalAPI),
            Cache: (0, _cache.Cache)
        };
        this.schema = schema;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.buffer = [];
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
    }
    SubscriptionProcessor.prototype.buildSubscription = function(namespace, model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload, authMode, filterArg) {
        if (filterArg === void 0) filterArg = false;
        var aws_appsync_authenticationType = this.amplifyConfig.aws_appsync_authenticationType;
        var _a = this.getAuthorizationInfo(model, userCredentials, aws_appsync_authenticationType, cognitoTokenPayload, oidcTokenPayload, authMode) || {}, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue;
        var _b = (0, _tslib.__read)((0, _utils.buildSubscriptionGraphQLOperation)(namespace, model, transformerMutationType, isOwner, ownerField, filterArg), 3), opType = _b[0], opName = _b[1], query = _b[2];
        return {
            authMode: authMode,
            opType: opType,
            opName: opName,
            query: query,
            isOwner: isOwner,
            ownerField: ownerField,
            ownerValue: ownerValue
        };
    };
    SubscriptionProcessor.prototype.getAuthorizationInfo = function(model, userCredentials, defaultAuthType, cognitoTokenPayload, oidcTokenPayload, authMode) {
        if (cognitoTokenPayload === void 0) cognitoTokenPayload = {};
        if (oidcTokenPayload === void 0) oidcTokenPayload = {};
        var rules = (0, _utils.getAuthorizationRules)(model);
        // Return null if user doesn't have proper credentials for private API with IAM auth
        var iamPrivateAuth = authMode === (0, _api.GRAPHQL_AUTH_MODE).AWS_IAM && rules.find(function(rule) {
            return rule.authStrategy === "private" && rule.provider === "iam";
        });
        if (iamPrivateAuth && userCredentials === USER_CREDENTIALS.unauth) return null;
        // Group auth should take precedence over owner auth, so we are checking
        // if rule(s) have group authorization as well as if either the Cognito or
        // OIDC token has a groupClaim. If so, we are returning auth info before
        // any further owner-based auth checks.
        var groupAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === "groups" && [
                "userPools",
                "oidc"
            ].includes(rule.provider);
        });
        var validGroup = (authMode === (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS || authMode === (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT) && groupAuthRules.find(function(groupAuthRule) {
            // validate token against groupClaim
            var cognitoUserGroups = (0, _utils.getUserGroupsFromToken)(cognitoTokenPayload, groupAuthRule);
            var oidcUserGroups = (0, _utils.getUserGroupsFromToken)(oidcTokenPayload, groupAuthRule);
            return (0, _tslib.__spread)(cognitoUserGroups, oidcUserGroups).find(function(userGroup) {
                return groupAuthRule.groups.find(function(group) {
                    return group === userGroup;
                });
            });
        });
        if (validGroup) return {
            authMode: authMode,
            isOwner: false
        };
        // Owner auth needs additional values to be returned in order to create the subscription with
        // the correct parameters so we are getting the owner value from the Cognito token via the
        // identityClaim from the auth rule.
        var cognitoOwnerAuthRules = authMode === (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS ? rules.filter(function(rule) {
            return rule.authStrategy === "owner" && rule.provider === "userPools";
        }) : [];
        var ownerAuthInfo;
        cognitoOwnerAuthRules.forEach(function(ownerAuthRule) {
            var _a;
            var ownerValue = cognitoTokenPayload[ownerAuthRule.identityClaim];
            // AuthZ for "list of owners" is handled dynamically in the subscription auth request
            // resolver. It doesn't rely on a subscription arg.
            // Only pass a subscription arg for single owner auth
            var singleOwner = ((_a = model.fields[ownerAuthRule.ownerField]) === null || _a === void 0 ? void 0 : _a.isArray) !== true;
            var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
            if (ownerValue) ownerAuthInfo = {
                authMode: (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS,
                isOwner: isOwnerArgRequired,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (ownerAuthInfo) return ownerAuthInfo;
        // Owner auth needs additional values to be returned in order to create the subscription with
        // the correct parameters so we are getting the owner value from the OIDC token via the
        // identityClaim from the auth rule.
        var oidcOwnerAuthRules = authMode === (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT ? rules.filter(function(rule) {
            return rule.authStrategy === "owner" && rule.provider === "oidc";
        }) : [];
        oidcOwnerAuthRules.forEach(function(ownerAuthRule) {
            var _a;
            var ownerValue = oidcTokenPayload[ownerAuthRule.identityClaim];
            var singleOwner = ((_a = model.fields[ownerAuthRule.ownerField]) === null || _a === void 0 ? void 0 : _a.isArray) !== true;
            var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
            if (ownerValue) ownerAuthInfo = {
                authMode: (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT,
                isOwner: isOwnerArgRequired,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (ownerAuthInfo) return ownerAuthInfo;
        // Fallback: return authMode or default auth type
        return {
            authMode: authMode || defaultAuthType,
            isOwner: false
        };
    };
    SubscriptionProcessor.prototype.hubQueryCompletionListener = function(completed, capsule) {
        var event = capsule.payload.event;
        if (event === (0, _pubsub.CONTROL_MSG).SUBSCRIPTION_ACK) completed();
    };
    SubscriptionProcessor.prototype.start = function() {
        var _this = this;
        this.runningProcesses = this.runningProcesses || new (0, _core.BackgroundProcessManager)();
        var ctlObservable = new (0, _zenObservableTsDefault.default)(function(observer) {
            var promises = [];
            // Creating subs for each model/operation combo so they can be unsubscribed
            // independently, since the auth retry behavior is asynchronous.
            var subscriptions = {};
            var cognitoTokenPayload, oidcTokenPayload;
            var userCredentials = USER_CREDENTIALS.none;
            _this.runningProcesses.add(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var credentials, err_1, session, err_2, _a, aws_cognito_region, AuthConfig, token, federatedInfo, currentUser, payload, err_3;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _b.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentCredentials()
                                ];
                            case 1:
                                credentials = _b.sent();
                                userCredentials = credentials.authenticated ? USER_CREDENTIALS.auth : USER_CREDENTIALS.unauth;
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _b.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                _b.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentSession()
                                ];
                            case 4:
                                session = _b.sent();
                                cognitoTokenPayload = session.getIdToken().decodePayload();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                err_2 = _b.sent();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 6:
                                _b.trys.push([
                                    6,
                                    11,
                                    ,
                                    12
                                ]);
                                _a = this.amplifyConfig, aws_cognito_region = _a.aws_cognito_region, AuthConfig = _a.Auth;
                                if (!aws_cognito_region || AuthConfig && !AuthConfig.region) throw "Auth is not configured";
                                token = void 0;
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Cache.getItem("federatedInfo")
                                ];
                            case 7:
                                federatedInfo = _b.sent();
                                if (!federatedInfo) return [
                                    3 /*break*/ ,
                                    8
                                ];
                                token = federatedInfo.token;
                                return [
                                    3 /*break*/ ,
                                    10
                                ];
                            case 8:
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentAuthenticatedUser()
                                ];
                            case 9:
                                currentUser = _b.sent();
                                if (currentUser) token = currentUser.token;
                                _b.label = 10;
                            case 10:
                                if (token) {
                                    payload = token.split(".")[1];
                                    oidcTokenPayload = JSON.parse(Buffer.from(payload, "base64").toString("utf8"));
                                }
                                return [
                                    3 /*break*/ ,
                                    12
                                ];
                            case 11:
                                err_3 = _b.sent();
                                logger.debug("error getting OIDC JWT", err_3);
                                return [
                                    3 /*break*/ ,
                                    12
                                ];
                            case 12:
                                Object.values(this.schema.namespaces).forEach(function(namespace) {
                                    Object.values(namespace.models).filter(function(_a) {
                                        var syncable = _a.syncable;
                                        return syncable;
                                    }).forEach(function(modelDefinition) {
                                        return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                var modelAuthModes, readAuthModes, operations, operationAuthModeAttempts, predicatesGroup, addFilterArg, subscriptionRetry;
                                                var _a, _b, _c;
                                                var _this = this;
                                                return (0, _tslib.__generator)(this, function(_d) {
                                                    switch(_d.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                (0, _utils.getModelAuthModes)({
                                                                    authModeStrategy: this.authModeStrategy,
                                                                    defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                                                    modelName: modelDefinition.name,
                                                                    schema: this.schema
                                                                })
                                                            ];
                                                        case 1:
                                                            modelAuthModes = _d.sent();
                                                            readAuthModes = modelAuthModes.READ;
                                                            subscriptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, subscriptions), (_a = {}, _a[modelDefinition.name] = (_b = {}, _b[(0, _utils.TransformerMutationType).CREATE] = [], _b[(0, _utils.TransformerMutationType).UPDATE] = [], _b[(0, _utils.TransformerMutationType).DELETE] = [], _b), _a));
                                                            operations = [
                                                                (0, _utils.TransformerMutationType).CREATE,
                                                                (0, _utils.TransformerMutationType).UPDATE,
                                                                (0, _utils.TransformerMutationType).DELETE
                                                            ];
                                                            operationAuthModeAttempts = (_c = {}, _c[(0, _utils.TransformerMutationType).CREATE] = 0, _c[(0, _utils.TransformerMutationType).UPDATE] = 0, _c[(0, _utils.TransformerMutationType).DELETE] = 0, _c);
                                                            predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(modelDefinition), false);
                                                            addFilterArg = predicatesGroup !== undefined;
                                                            subscriptionRetry = function(operation, addFilter) {
                                                                if (addFilter === void 0) addFilter = addFilterArg;
                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                    var _a, transformerMutationType, opName, query, isOwner, ownerField, ownerValue, authMode, authToken, variables, customUserAgentDetails, queryObservable, subscriptionReadyCallback;
                                                                    var _this = this;
                                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                                        switch(_b.label){
                                                                            case 0:
                                                                                _a = this.buildSubscription(namespace, modelDefinition, operation, userCredentials, cognitoTokenPayload, oidcTokenPayload, readAuthModes[operationAuthModeAttempts[operation]], addFilter), transformerMutationType = _a.opType, opName = _a.opName, query = _a.query, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue, authMode = _a.authMode;
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                                                ];
                                                                            case 1:
                                                                                authToken = _b.sent();
                                                                                variables = {};
                                                                                customUserAgentDetails = {
                                                                                    category: (0, _core.Category).DataStore,
                                                                                    action: (0, _core.DataStoreAction).Subscribe
                                                                                };
                                                                                if (addFilter && predicatesGroup) variables["filter"] = (0, _utils.predicateToGraphQLFilter)(predicatesGroup);
                                                                                if (isOwner) {
                                                                                    if (!ownerValue) {
                                                                                        observer.error("Owner field required, sign in is needed in order to perform this operation");
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                    }
                                                                                    variables[ownerField] = ownerValue;
                                                                                }
                                                                                logger.debug("Attempting " + operation + " subscription with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                                                queryObservable = this.amplifyContext.InternalAPI.graphql((0, _tslib.__assign)((0, _tslib.__assign)({
                                                                                    query: query,
                                                                                    variables: variables
                                                                                }, {
                                                                                    authMode: authMode
                                                                                }), {
                                                                                    authToken: authToken
                                                                                }), undefined, customUserAgentDetails);
                                                                                // TODO: consider onTerminate.then(() => API.cancel(...))
                                                                                subscriptions[modelDefinition.name][transformerMutationType].push(queryObservable.map(function(_a) {
                                                                                    var value = _a.value;
                                                                                    return value;
                                                                                }).subscribe({
                                                                                    next: function(_a) {
                                                                                        var data = _a.data, errors = _a.errors;
                                                                                        if (Array.isArray(errors) && errors.length > 0) {
                                                                                            var messages = errors.map(function(_a) {
                                                                                                var message = _a.message;
                                                                                                return message;
                                                                                            });
                                                                                            logger.warn("Skipping incoming subscription. Messages: " + messages.join("\n"));
                                                                                            _this.drainBuffer();
                                                                                            return;
                                                                                        }
                                                                                        var predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(_this.syncPredicates.get(modelDefinition), false);
                                                                                        // @ts-ignore
                                                                                        var _b = data, _c = opName, record = _b[_c];
                                                                                        // checking incoming subscription against syncPredicate.
                                                                                        // once AppSync implements filters on subscriptions, we'll be
                                                                                        // able to set these when establishing the subscription instead.
                                                                                        // Until then, we'll need to filter inbound
                                                                                        if (_this.passesPredicateValidation(record, predicatesGroup)) _this.pushToBuffer(transformerMutationType, modelDefinition, record);
                                                                                        _this.drainBuffer();
                                                                                    },
                                                                                    error: function(subscriptionError) {
                                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                            var _a, _b, _c, _d, message, isRTFError, e_1;
                                                                                            return (0, _tslib.__generator)(this, function(_e) {
                                                                                                switch(_e.label){
                                                                                                    case 0:
                                                                                                        _a = subscriptionError.error, _b = (0, _tslib.__read)((_a === void 0 ? {
                                                                                                            errors: []
                                                                                                        } : _a).errors, 1), _c = _b[0], _d = (_c === void 0 ? {} : _c).message, message = _d === void 0 ? "" : _d;
                                                                                                        isRTFError = // only attempt catch if a filter variable was added to the subscription query
                                                                                                        addFilter && this.catchRTFError(message, modelDefinition, predicatesGroup);
                                                                                                        // Catch RTF errors
                                                                                                        if (isRTFError) {
                                                                                                            // Unsubscribe and clear subscription array for model/operation
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                                                                                return subscription.unsubscribe();
                                                                                                            });
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                                                                            // retry subscription connection without filter
                                                                                                            subscriptionRetry(operation, false);
                                                                                                            return [
                                                                                                                2 /*return*/ 
                                                                                                            ];
                                                                                                        }
                                                                                                        if (message.includes((0, _pubsub.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR) || message.includes((0, _pubsub.CONTROL_MSG).CONNECTION_FAILED)) {
                                                                                                            // Unsubscribe and clear subscription array for model/operation
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                                                                                return subscription.unsubscribe();
                                                                                                            });
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                                                                            operationAuthModeAttempts[operation]++;
                                                                                                            if (operationAuthModeAttempts[operation] >= readAuthModes.length) // last auth mode retry. Continue with error
                                                                                                            logger.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1]);
                                                                                                            else {
                                                                                                                // retry with different auth mode. Do not trigger
                                                                                                                // observer error or error handler
                                                                                                                logger.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1] + ". Retrying with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                                                                                subscriptionRetry(operation);
                                                                                                                return [
                                                                                                                    2 /*return*/ 
                                                                                                                ];
                                                                                                            }
                                                                                                        }
                                                                                                        logger.warn("subscriptionError", message);
                                                                                                        _e.label = 1;
                                                                                                    case 1:
                                                                                                        _e.trys.push([
                                                                                                            1,
                                                                                                            3,
                                                                                                            ,
                                                                                                            4
                                                                                                        ]);
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.errorHandler({
                                                                                                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                                                                localModel: null,
                                                                                                                message: message,
                                                                                                                model: modelDefinition.name,
                                                                                                                operation: operation,
                                                                                                                errorType: (0, _errorMaps.getSubscriptionErrorType)(subscriptionError),
                                                                                                                process: (0, _types.ProcessName).subscribe,
                                                                                                                remoteModel: null,
                                                                                                                cause: subscriptionError
                                                                                                            })
                                                                                                        ];
                                                                                                    case 2:
                                                                                                        _e.sent();
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            4
                                                                                                        ];
                                                                                                    case 3:
                                                                                                        e_1 = _e.sent();
                                                                                                        logger.error("Subscription error handler failed with:", e_1);
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            4
                                                                                                        ];
                                                                                                    case 4:
                                                                                                        if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
                                                                                                        if (message.includes('"errorType":"Unauthorized"') || message.includes('"errorType":"OperationDisabled"')) return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                        observer.error(message);
                                                                                                        return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                }));
                                                                                promises.push(function() {
                                                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                        var boundFunction;
                                                                                        var _this = this;
                                                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                                                            switch(_a.label){
                                                                                                case 0:
                                                                                                    return [
                                                                                                        4 /*yield*/ ,
                                                                                                        new Promise(function(res) {
                                                                                                            subscriptionReadyCallback = res;
                                                                                                            boundFunction = _this.hubQueryCompletionListener.bind(_this, res);
                                                                                                            (0, _core.Hub).listen("api", boundFunction);
                                                                                                        })
                                                                                                    ];
                                                                                                case 1:
                                                                                                    _a.sent();
                                                                                                    (0, _core.Hub).remove("api", boundFunction);
                                                                                                    return [
                                                                                                        2 /*return*/ 
                                                                                                    ];
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                }());
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            };
                                                            operations.forEach(function(op) {
                                                                return subscriptionRetry(op);
                                                            });
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                    });
                                });
                                this.runningProcesses.isOpen && this.runningProcesses.add(function() {
                                    return Promise.all(promises).then(function() {
                                        observer.next(CONTROL_MSG.CONNECTED);
                                    });
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, "subscription processor new subscriber");
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        Object.keys(subscriptions).forEach(function(modelName) {
                            subscriptions[modelName][(0, _utils.TransformerMutationType).CREATE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                            subscriptions[modelName][(0, _utils.TransformerMutationType).UPDATE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                            subscriptions[modelName][(0, _utils.TransformerMutationType).DELETE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        var dataObservable = new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.dataObserver = observer;
            _this.drainBuffer();
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        this.dataObserver = null;
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        return [
            ctlObservable,
            dataObservable
        ];
    };
    SubscriptionProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SubscriptionProcessor.prototype.passesPredicateValidation = function(record, predicatesGroup) {
        if (!predicatesGroup) return true;
        var predicates = predicatesGroup.predicates, type = predicatesGroup.type;
        return (0, _util.validatePredicate)(record, type, predicates);
    };
    SubscriptionProcessor.prototype.pushToBuffer = function(transformerMutationType, modelDefinition, data) {
        this.buffer.push([
            transformerMutationType,
            modelDefinition,
            data
        ]);
    };
    SubscriptionProcessor.prototype.drainBuffer = function() {
        var _this = this;
        if (this.dataObserver) {
            this.buffer.forEach(function(data) {
                return _this.dataObserver.next(data);
            });
            this.buffer = [];
        }
    };
    /**
     * @returns true if the service returned an RTF subscription error
     * @remarks logs a warning with remediation instructions
     *
     */ SubscriptionProcessor.prototype.catchRTFError = function(message, modelDefinition, predicatesGroup) {
        var header = "Backend subscriptions filtering error.\nSubscriptions filtering will be applied clientside.\n";
        var messageErrorTypeMap = {
            "UnknownArgument: Unknown field argument filter": (0, _utils.RTFError).UnknownField,
            "Filters exceed maximum attributes limit": (0, _utils.RTFError).MaxAttributes,
            "Filters combination exceed maximum limit": (0, _utils.RTFError).MaxCombinations,
            "filter uses same fieldName multiple time": (0, _utils.RTFError).RepeatedFieldname,
            "The variables input contains a field name 'not'": (0, _utils.RTFError).NotGroup,
            "The variables input contains a field that is not defined for input object type": (0, _utils.RTFError).FieldNotInType
        };
        var _a = (0, _tslib.__read)(Object.entries(messageErrorTypeMap).find(function(_a) {
            var _b = (0, _tslib.__read)(_a, 1), errorMsg = _b[0];
            return message.includes(errorMsg);
        }) || [], 2), _errorMsg = _a[0], errorType = _a[1];
        if (errorType !== undefined) {
            var remediationMessage = (0, _utils.generateRTFRemediation)(errorType, modelDefinition, predicatesGroup);
            logger.warn(header + "\n" + message + "\n" + remediationMessage);
            return true;
        }
        return false;
    };
    return SubscriptionProcessor;
}();

},{"a5da572164cb8f31":"5zKaV","tslib":"9gMVn","@aws-amplify/api":"houml","@aws-amplify/api/internals":"lW1BO","@aws-amplify/auth":"6Q2Bh","@aws-amplify/cache":"egrWR","@aws-amplify/core":"8BDOx","@aws-amplify/pubsub":"13UKI","zen-observable-ts":"klrbV","../../types":"KjGQP","../utils":"60Gn0","../../predicates":"lUiza","../../util":"89SDa","./errorMaps":"4s4oO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d8dcI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncProcessor", ()=>SyncProcessor);
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api/internals");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _utils = require("../utils");
var _core = require("@aws-amplify/core");
var _predicates = require("../../predicates");
var _errorMaps = require("./errorMaps");
var opResultDefaults = {
    items: [],
    nextToken: null,
    startedAt: null
};
var logger = new (0, _core.ConsoleLogger)("DataStore");
var SyncProcessor = /** @class */ function() {
    function SyncProcessor(schema, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        amplifyContext.InternalAPI = amplifyContext.InternalAPI || (0, _internals.InternalAPI);
        this.generateQueries();
    }
    SyncProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "LIST"), 1), _b = (0, _tslib.__read)(_a[0]), opNameQuery = _b.slice(1);
                _this.typeQuery.set(model, opNameQuery);
            });
        });
    };
    SyncProcessor.prototype.graphqlFilterFromPredicate = function(model) {
        if (!this.syncPredicates) return null;
        var predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(model), false);
        if (!predicatesGroup) return null;
        return (0, _utils.predicateToGraphQLFilter)(predicatesGroup);
    };
    SyncProcessor.prototype.retrievePage = function(modelDefinition, lastSync, nextToken, limit, filter, onTerminate) {
        if (limit === void 0) limit = null;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, opName, query, variables, modelAuthModes, readAuthModes, authModeAttempts, authModeRetry, data, _b, _c, opResult, items, newNextToken, startedAt;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, _tslib.__read)(this.typeQuery.get(modelDefinition), 2), opName = _a[0], query = _a[1];
                        variables = {
                            limit: limit,
                            nextToken: nextToken,
                            lastSync: lastSync,
                            filter: filter
                        };
                        return [
                            4 /*yield*/ ,
                            (0, _utils.getModelAuthModes)({
                                authModeStrategy: this.authModeStrategy,
                                defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                modelName: modelDefinition.name,
                                schema: this.schema
                            })
                        ];
                    case 1:
                        modelAuthModes = _d.sent();
                        readAuthModes = modelAuthModes.READ;
                        authModeAttempts = 0;
                        authModeRetry = function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var response, error_1, authMode;
                                var _a;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            if (!this.runningProcesses.isOpen) throw new Error("sync.retreievePage termination was requested. Exiting.");
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([
                                                1,
                                                3,
                                                ,
                                                5
                                            ]);
                                            logger.debug("Attempting sync with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                4 /*yield*/ ,
                                                this.jitteredRetry({
                                                    query: query,
                                                    variables: variables,
                                                    opName: opName,
                                                    modelDefinition: modelDefinition,
                                                    authMode: readAuthModes[authModeAttempts],
                                                    onTerminate: onTerminate
                                                })
                                            ];
                                        case 2:
                                            response = _b.sent();
                                            logger.debug("Sync successful with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                2 /*return*/ ,
                                                response
                                            ];
                                        case 3:
                                            error_1 = _b.sent();
                                            authModeAttempts++;
                                            if (authModeAttempts >= readAuthModes.length) {
                                                authMode = readAuthModes[authModeAttempts - 1];
                                                logger.debug("Sync failed with authMode: " + authMode, error_1);
                                                if ((0, _utils.getClientSideAuthError)(error_1) || (0, _utils.getForbiddenError)(error_1)) {
                                                    // return empty list of data so DataStore will continue to sync other models
                                                    logger.warn("User is unauthorized to query " + opName + " with auth mode " + authMode + ". No data could be returned.");
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            data: (_a = {}, _a[opName] = opResultDefaults, _a)
                                                        }
                                                    ];
                                                }
                                                throw error_1;
                                            }
                                            logger.debug("Sync failed with authMode: " + readAuthModes[authModeAttempts - 1] + ". Retrying with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                4 /*yield*/ ,
                                                authModeRetry()
                                            ];
                                        case 4:
                                            return [
                                                2 /*return*/ ,
                                                _b.sent()
                                            ];
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4 /*yield*/ ,
                            authModeRetry()
                        ];
                    case 2:
                        data = _d.sent().data;
                        _b = data, _c = opName, opResult = _b[_c];
                        items = opResult.items, newNextToken = opResult.nextToken, startedAt = opResult.startedAt;
                        return [
                            2 /*return*/ ,
                            {
                                nextToken: newNextToken,
                                startedAt: startedAt,
                                items: items
                            }
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.jitteredRetry = function(_a) {
        var query = _a.query, variables = _a.variables, opName = _a.opName, modelDefinition = _a.modelDefinition, authMode = _a.authMode, onTerminate = _a.onTerminate;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _core.jitteredExponentialRetry)(function(query, variables) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var authToken, customUserAgentDetails, error_2, clientOrForbiddenErrorMessage, hasItems, unauthorized, otherErrors, result;
                                    var _this = this;
                                    var _a, _b, _c, _d;
                                    return (0, _tslib.__generator)(this, function(_e) {
                                        switch(_e.label){
                                            case 0:
                                                _e.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    6
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 1:
                                                authToken = _e.sent();
                                                customUserAgentDetails = {
                                                    category: (0, _core.Category).DataStore,
                                                    action: (0, _core.DataStoreAction).GraphQl
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql({
                                                        query: query,
                                                        variables: variables,
                                                        authMode: authMode,
                                                        authToken: authToken
                                                    }, undefined, customUserAgentDetails)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    _e.sent()
                                                ];
                                            case 3:
                                                error_2 = _e.sent();
                                                clientOrForbiddenErrorMessage = (0, _utils.getClientSideAuthError)(error_2) || (0, _utils.getForbiddenError)(error_2);
                                                if (clientOrForbiddenErrorMessage) {
                                                    logger.error("Sync processor retry error:", error_2);
                                                    throw new (0, _core.NonRetryableError)(clientOrForbiddenErrorMessage);
                                                }
                                                hasItems = Boolean((_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a === void 0 ? void 0 : _a[opName]) === null || _b === void 0 ? void 0 : _b.items);
                                                unauthorized = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.some(function(err) {
                                                    return err.errorType === "Unauthorized";
                                                });
                                                otherErrors = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.filter(function(err) {
                                                    return err.errorType !== "Unauthorized";
                                                });
                                                result = error_2;
                                                if (hasItems) result.data[opName].items = result.data[opName].items.filter(function(item) {
                                                    return item !== null;
                                                });
                                                if (!(hasItems && (otherErrors === null || otherErrors === void 0 ? void 0 : otherErrors.length))) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.all(otherErrors.map(function(err) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var e_1;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        _a.trys.push([
                                                                            0,
                                                                            2,
                                                                            ,
                                                                            3
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.errorHandler({
                                                                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                                localModel: null,
                                                                                message: err.message,
                                                                                model: modelDefinition.name,
                                                                                operation: opName,
                                                                                errorType: (0, _errorMaps.getSyncErrorType)(err),
                                                                                process: (0, _types.ProcessName).sync,
                                                                                remoteModel: null,
                                                                                cause: err
                                                                            })
                                                                        ];
                                                                    case 1:
                                                                        _a.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            3
                                                                        ];
                                                                    case 2:
                                                                        e_1 = _a.sent();
                                                                        logger.error("Sync error handler failed with:", e_1);
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            3
                                                                        ];
                                                                    case 3:
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }))
                                                ];
                                            case 4:
                                                _e.sent();
                                                (0, _core.Hub).dispatch("datastore", {
                                                    event: "nonApplicableDataReceived",
                                                    data: {
                                                        errors: otherErrors,
                                                        modelName: modelDefinition.name
                                                    }
                                                });
                                                _e.label = 5;
                                            case 5:
                                                /**
                                         * Handle $util.unauthorized() in resolver request mapper, which responses with something
                                         * like this:
                                         *
                                         * ```
                                         * {
                                         * 	data: { syncYourModel: null },
                                         * 	errors: [
                                         * 		{
                                         * 			path: ['syncLegacyJSONComments'],
                                         * 			data: null,
                                         * 			errorType: 'Unauthorized',
                                         * 			errorInfo: null,
                                         * 			locations: [{ line: 2, column: 3, sourceName: null }],
                                         * 			message:
                                         * 				'Not Authorized to access syncYourModel on type Query',
                                         * 			},
                                         * 		],
                                         * 	}
                                         * ```
                                         *
                                         * The correct handling for this is to signal that we've encountered a non-retryable error,
                                         * since the server has responded with an auth error and *NO DATA* at this point.
                                         */ if (unauthorized) {
                                                    this.errorHandler({
                                                        recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                        localModel: null,
                                                        message: error_2.message,
                                                        model: modelDefinition.name,
                                                        operation: opName,
                                                        errorType: (0, _errorMaps.getSyncErrorType)(error_2.errors[0]),
                                                        process: (0, _types.ProcessName).sync,
                                                        remoteModel: null,
                                                        cause: error_2
                                                    });
                                                    throw new (0, _core.NonRetryableError)(error_2);
                                                }
                                                if ((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c[opName].items) === null || _d === void 0 ? void 0 : _d.length) return [
                                                    2 /*return*/ ,
                                                    result
                                                ];
                                                throw error_2;
                                            case 6:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                query,
                                variables
                            ], undefined, onTerminate)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.start = function(typesLastSync) {
        var _this = this;
        var _a = this.amplifyConfig, maxRecordsToSync = _a.maxRecordsToSync, syncPageSize = _a.syncPageSize;
        var parentPromises = new Map();
        var observable = new (0, _zenObservableTsDefault.default)(function(observer) {
            var sortedTypesLastSyncs = Object.values(_this.schema.namespaces).reduce(function(map, namespace) {
                var e_2, _a;
                try {
                    for(var _b = (0, _tslib.__values)(Array.from(namespace.modelTopologicalOrdering.keys())), _c = _b.next(); !_c.done; _c = _b.next()){
                        var modelName = _c.value;
                        var typeLastSync = typesLastSync.get(namespace.models[modelName]);
                        map.set(namespace.models[modelName], typeLastSync);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                return map;
            }, new Map());
            var allModelsReady = Array.from(sortedTypesLastSyncs.entries()).filter(function(_a) {
                var _b = (0, _tslib.__read)(_a, 1), syncable = _b[0].syncable;
                return syncable;
            }).map(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), modelDefinition = _b[0], _c = (0, _tslib.__read)(_b[1], 2), namespace = _c[0], lastSync = _c[1];
                return _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var done, nextToken, startedAt, items, recordsReceived, filter, parents, promises, promise;
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    done = false;
                                    nextToken = null;
                                    startedAt = null;
                                    items = null;
                                    recordsReceived = 0;
                                    filter = this.graphqlFilterFromPredicate(modelDefinition);
                                    parents = this.schema.namespaces[namespace].modelTopologicalOrdering.get(modelDefinition.name);
                                    promises = parents.map(function(parent) {
                                        return parentPromises.get(namespace + "_" + parent);
                                    });
                                    promise = new Promise(function(res) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var limit, error_3, e_3;
                                            var _a;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        return [
                                                            4 /*yield*/ ,
                                                            Promise.all(promises)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        _b.label = 2;
                                                    case 2:
                                                        /**
                                                     * If `runningProcesses` is not open, it means that the sync processor has been
                                                     * stopped (for example by calling `DataStore.clear()` upstream) and has not yet
                                                     * finished terminating and/or waiting for its background processes to complete.
                                                     */ if (!this.runningProcesses.isOpen) {
                                                            logger.debug("Sync processor has been stopped, terminating sync for " + modelDefinition.name);
                                                            return [
                                                                2 /*return*/ ,
                                                                res()
                                                            ];
                                                        }
                                                        limit = Math.min(maxRecordsToSync - recordsReceived, syncPageSize);
                                                        _b.label = 3;
                                                    case 3:
                                                        _b.trys.push([
                                                            3,
                                                            5,
                                                            ,
                                                            10
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.retrievePage(modelDefinition, lastSync, nextToken, limit, filter, onTerminate)
                                                        ];
                                                    case 4:
                                                        _a = _b.sent(), items = _a.items, nextToken = _a.nextToken, startedAt = _a.startedAt;
                                                        return [
                                                            3 /*break*/ ,
                                                            10
                                                        ];
                                                    case 5:
                                                        error_3 = _b.sent();
                                                        _b.label = 6;
                                                    case 6:
                                                        _b.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.errorHandler({
                                                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                localModel: null,
                                                                message: error_3.message,
                                                                model: modelDefinition.name,
                                                                operation: null,
                                                                errorType: (0, _errorMaps.getSyncErrorType)(error_3),
                                                                process: (0, _types.ProcessName).sync,
                                                                remoteModel: null,
                                                                cause: error_3
                                                            })
                                                        ];
                                                    case 7:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    case 8:
                                                        e_3 = _b.sent();
                                                        logger.error("Sync error handler failed with:", e_3);
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    case 9:
                                                        /**
                                                     * If there's an error, this model fails, but the rest of the sync should
                                                     * continue. To facilitate this, we explicitly mark this model as `done`
                                                     * with no items and allow the loop to continue organically. This ensures
                                                     * all callbacks (subscription messages) happen as normal, so anything
                                                     * waiting on them knows the model is as done as it can be.
                                                     */ done = true;
                                                        items = [];
                                                        return [
                                                            3 /*break*/ ,
                                                            10
                                                        ];
                                                    case 10:
                                                        recordsReceived += items.length;
                                                        done = nextToken === null || recordsReceived >= maxRecordsToSync;
                                                        observer.next({
                                                            namespace: namespace,
                                                            modelDefinition: modelDefinition,
                                                            items: items,
                                                            done: done,
                                                            startedAt: startedAt,
                                                            isFullSync: !lastSync
                                                        });
                                                        _b.label = 11;
                                                    case 11:
                                                        if (!done) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        _b.label = 12;
                                                    case 12:
                                                        res();
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    });
                                    parentPromises.set(namespace + "_" + modelDefinition.name, promise);
                                    return [
                                        4 /*yield*/ ,
                                        promise
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "adding model " + modelDefinition.name);
            });
            Promise.all(allModelsReady).then(function() {
                observer.complete();
            });
        });
        return observable;
    };
    SyncProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("stopping sync processor");
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        logger.debug("sync processor stopped");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return SyncProcessor;
}();

},{"tslib":"9gMVn","@aws-amplify/api/internals":"lW1BO","zen-observable-ts":"klrbV","../../types":"KjGQP","../utils":"60Gn0","@aws-amplify/core":"8BDOx","../../predicates":"lUiza","./errorMaps":"4s4oO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1pp40":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "internals", ()=>internals);
parcelHelpers.export(exports, "FieldCondition", ()=>FieldCondition);
parcelHelpers.export(exports, "GroupCondition", ()=>GroupCondition);
/**
 * Creates a "seed" predicate that can be used to build an executable condition.
 * This is used in `query()`, for example, to seed customer- E.g.,
 *
 * ```
 * const p = predicateFor({builder: modelConstructor, schema: modelSchema, pkField: string[]});
 * p.and(child => [
 *   child.field.eq('whatever'),
 *   child.childModel.childField.eq('whatever else'),
 *   child.childModel.or(child => [
 *     child.otherField.contains('x'),
 *     child.otherField.contains('y'),
 *     child.otherField.contains('z'),
 *   ])
 * ])
 * ```
 *
 * `predicateFor()` returns objecst with recursive getters. To facilitate this,
 * a `query` and `tail` can be provided to "accumulate" nested conditions.
 *
 * @param ModelType The ModelMeta used to build child properties.
 * @param field Scopes the query branch to a field.
 * @param query A base query to build on. Omit to start a new query.
 * @param tail The point in an existing `query` to attach new conditions to.
 * @returns A ModelPredicate (builder) that customers can create queries with.
 * (As shown in function description.)
 */ parcelHelpers.export(exports, "recursivePredicateFor", ()=>recursivePredicateFor);
parcelHelpers.export(exports, "predicateFor", ()=>predicateFor);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _types = require("../types");
var _index = require("./index");
var _relationship = require("../storage/relationship");
var _util = require("../util");
var ops = (0, _tslib.__spread)((0, _index.comparisonKeys));
/**
 * A map from keys (exposed to customers) to the internal predicate data
 * structures invoking code should not muck with.
 */ var predicateInternalsMap = new Map();
/**
 * Creates a link between a key (and generates a key if needed) and an internal
 * `GroupCondition`, which allows us to return a key object instead of the gory
 * conditions details to customers/invoking code.
 *
 * @param condition The internal condition to keep hidden.
 * @param key The object DataStore will use to find the internal condition.
 * If no key is given, an empty one is created.
 */ var registerPredicateInternals = function(condition, key) {
    var finalKey = key || new (0, _types.PredicateInternalsKey)();
    predicateInternalsMap.set(finalKey, condition);
    return finalKey;
};
var internals = function(key) {
    if (!predicateInternalsMap.has(key)) throw new Error("Invalid predicate. Terminate your predicate with a valid condition (e.g., `p => p.field.eq('value')`) or pass `Predicates.ALL`.");
    return predicateInternalsMap.get(key);
};
/**
 * Maps operators to negated operators.
 * Used to facilitate propagation of negation down a tree of conditions.
 */ var negations = {
    and: "or",
    or: "and",
    not: "and",
    eq: "ne",
    ne: "eq",
    gt: "le",
    ge: "lt",
    lt: "ge",
    le: "gt",
    contains: "notContains",
    notContains: "contains"
};
/**
 * A condition that can operate against a single "primitive" field of a model or item.
 * @member field The field of *some record* to test against.
 * @member operator The equality or comparison operator to use.
 * @member operands The operands for the equality/comparison check.
 */ var FieldCondition = /** @class */ function() {
    function FieldCondition(field, operator, operands) {
        this.field = field;
        this.operator = operator;
        this.operands = operands;
        this.validate();
    }
    /**
     * Creates a copy of self.
     * @param extract Not used. Present only to fulfill the `UntypedCondition` interface.
     * @returns A new, identitical `FieldCondition`.
     */ FieldCondition.prototype.copy = function(extract) {
        return [
            new FieldCondition(this.field, this.operator, (0, _tslib.__spread)(this.operands)),
            undefined
        ];
    };
    /**
     * Produces a tree structure similar to a graphql condition. The returned
     * structure is "dumb" and is intended for another query/condition
     * generation mechanism to interpret, such as the cloud or storage query
     * builders.
     *
     * E.g.,
     *
     * ```json
     * {
     * 	"name": {
     * 		"eq": "robert"
     * 	}
     * }
     * ```
     */ FieldCondition.prototype.toAST = function() {
        var _a, _b;
        return _a = {}, _a[this.field] = (_b = {}, _b[this.operator] = this.operator === "between" ? [
            this.operands[0],
            this.operands[1]
        ] : this.operands[0], _b), _a;
    };
    /**
     * Produces a new condition (`FieldCondition` or `GroupCondition`) that
     * matches the opposite of this condition.
     *
     * Intended to be used when applying De Morgan's Law, which can be done to
     * produce more efficient queries against the storage layer if a negation
     * appears in the query tree.
     *
     * For example:
     *
     * 1. `name.eq('robert')` becomes `name.ne('robert')`
     * 2. `price.between(100, 200)` becomes `m => m.or(m => [m.price.lt(100), m.price.gt(200)])`
     *
     * @param model The model meta to use when construction a new `GroupCondition`
     * for cases where the negation requires multiple `FieldCondition`'s.
     */ FieldCondition.prototype.negated = function(model) {
        if (this.operator === "between") return new GroupCondition(model, undefined, undefined, "or", [
            new FieldCondition(this.field, "lt", [
                this.operands[0]
            ]),
            new FieldCondition(this.field, "gt", [
                this.operands[1]
            ])
        ]);
        else if (this.operator === "beginsWith") // beginsWith negation doesn't have a good, safe optimation right now.
        // just re-wrap it in negation. The adapter will have to scan-and-filter,
        // as is likely optimal for negated beginsWith conditions *anyway*.
        return new GroupCondition(model, undefined, undefined, "not", [
            new FieldCondition(this.field, "beginsWith", [
                this.operands[0]
            ])
        ]);
        else return new FieldCondition(this.field, negations[this.operator], this.operands);
    };
    /**
     * Not implemented. Not needed. GroupCondition instead consumes FieldConditions and
     * transforms them into legacy predicates. (*For now.*)
     * @param storage N/A. If ever implemented, the storage adapter to query.
     * @returns N/A. If ever implemented, return items from `storage` that match.
     */ FieldCondition.prototype.fetch = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.reject("No implementation needed [yet].")
                ];
            });
        });
    };
    /**
     * Determins whether a given item matches the expressed condition.
     * @param item The item to test.
     * @returns `Promise<boolean>`, `true` if matches; `false` otherwise.
     */ FieldCondition.prototype.matches = function(item) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var v, operations, operation, result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                v = item[this.field];
                operations = {
                    eq: function() {
                        return v === _this.operands[0];
                    },
                    ne: function() {
                        return v !== _this.operands[0];
                    },
                    gt: function() {
                        return v > _this.operands[0];
                    },
                    ge: function() {
                        return v >= _this.operands[0];
                    },
                    lt: function() {
                        return v < _this.operands[0];
                    },
                    le: function() {
                        return v <= _this.operands[0];
                    },
                    contains: function() {
                        return (v === null || v === void 0 ? void 0 : v.indexOf(_this.operands[0])) > -1;
                    },
                    notContains: function() {
                        return !v ? true : v.indexOf(_this.operands[0]) === -1;
                    },
                    beginsWith: function() {
                        return v === null || v === void 0 ? void 0 : v.startsWith(_this.operands[0]);
                    },
                    between: function() {
                        return v >= _this.operands[0] && v <= _this.operands[1];
                    }
                };
                operation = operations[this.operator];
                if (operation) {
                    result = operation();
                    return [
                        2 /*return*/ ,
                        result
                    ];
                } else throw new Error("Invalid operator given: " + this.operator);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Checks `this.operands` for compatibility with `this.operator`.
     */ FieldCondition.prototype.validate = function() {
        var _this = this;
        /**
         * Creates a validator that checks for a particular `operands` count.
         * Throws an exception if the `count` disagrees with `operands.length`.
         * @param count The number of `operands` expected.
         */ var argumentCount = function(count) {
            var argsClause = count === 1 ? "argument is" : "arguments are";
            return function() {
                if (_this.operands.length !== count) return "Exactly " + count + " " + argsClause + " required.";
            };
        };
        // NOTE: validations should return a message on failure.
        // hence, they should be "joined" together with logical OR's
        // as seen in the `between:` entry.
        var validations = {
            eq: argumentCount(1),
            ne: argumentCount(1),
            gt: argumentCount(1),
            ge: argumentCount(1),
            lt: argumentCount(1),
            le: argumentCount(1),
            contains: argumentCount(1),
            notContains: argumentCount(1),
            beginsWith: argumentCount(1),
            between: function() {
                return argumentCount(2)() || (_this.operands[0] > _this.operands[1] ? "The first argument must be less than or equal to the second argument." : null);
            }
        };
        var validate = validations[this.operator];
        if (validate) {
            var e = validate();
            if (typeof e === "string") throw new Error("Incorrect usage of `" + this.operator + "()`: " + e);
        } else throw new Error("Non-existent operator: `" + this.operator + "()`");
    };
    return FieldCondition;
}();
/**
 * Small utility function to generate a monotonically increasing ID.
 * Used by GroupCondition to help keep track of which group is doing what,
 * when, and where during troubleshooting.
 */ var getGroupId = function() {
    var seed = 1;
    return function() {
        return "group_" + seed++;
    };
}();
/**
 * A set of sub-conditions to operate against a model, optionally scoped to
 * a specific field, combined with the given operator (one of `and`, `or`, or `not`).
 * @member groupId Used to distinguish between GroupCondition instances for
 * debugging and troublehsooting.
 * @member model A metadata object that tells GroupCondition what to query and how.
 * @member field The field on the model that the sub-conditions apply to.
 * @member operator How to group child conditions together.
 * @member operands The child conditions.
 */ var GroupCondition = /** @class */ function() {
    function GroupCondition(/**
     * The `ModelMeta` of the model to query and/or filter against.
     * Expected to contain:
     *
     * ```js
     * {
     * 	builder: ModelConstructor,
     * 	schema: SchemaModel,
     * 	pkField: string[]
     * }
     * ```
     */ model, /**
     * If populated, this group specifices a condition on a relationship.
     *
     * If `field` does *not* point to a related model, that's an error. It
     * could indicate that the `GroupCondition` was instantiated with bad
     * data, or that the model metadata is incorrect.
     */ field, /**
     * If a `field` is given, whether the relationship is a `HAS_ONE`,
     * 'HAS_MANY`, or `BELONGS_TO`.
     *
     * TODO: Remove this and replace with derivation using
     * `ModelRelationship.from(this.model, this.field).relationship`;
     */ relationshipType, /**
     *
     */ operator, /**
     *
     */ operands, /**
     * Whether this GroupCondition is the result of an optimize call.
     *
     * This is used to guard against infinitely fetch -> optimize -> fetch
     * recursion.
     */ isOptimized) {
        if (isOptimized === void 0) isOptimized = false;
        this.model = model;
        this.field = field;
        this.relationshipType = relationshipType;
        this.operator = operator;
        this.operands = operands;
        this.isOptimized = isOptimized;
        // `groupId` was used for development/debugging.
        // Should we leave this in for future troubleshooting?
        this.groupId = getGroupId();
    }
    /**
     * Returns a copy of a GroupCondition, which also returns the copy of a
     * given reference node to "extract".
     * @param extract A node of interest. Its copy will *also* be returned if the node exists.
     * @returns [The full copy, the copy of `extract` | undefined]
     */ GroupCondition.prototype.copy = function(extract) {
        var copied = new GroupCondition(this.model, this.field, this.relationshipType, this.operator, []);
        var extractedCopy = extract === this ? copied : undefined;
        this.operands.forEach(function(o) {
            var _a = (0, _tslib.__read)(o.copy(extract), 2), operandCopy = _a[0], extractedFromOperand = _a[1];
            copied.operands.push(operandCopy);
            extractedCopy = extractedCopy || extractedFromOperand;
        });
        return [
            copied,
            extractedCopy
        ];
    };
    /**
     * Creates a new `GroupCondition` that contains only the local field conditions,
     * omitting related model conditions. That resulting `GroupCondition` can be
     * used to produce predicates that are compatible with the storage adapters and
     * Cloud storage.
     *
     * @param negate Whether the condition tree should be negated according
     * to De Morgan's law.
     */ GroupCondition.prototype.withFieldConditionsOnly = function(negate) {
        var _this = this;
        var negateChildren = negate !== (this.operator === "not");
        return new GroupCondition(this.model, undefined, undefined, negate ? negations[this.operator] : this.operator, this.operands.filter(function(o) {
            return o instanceof FieldCondition;
        }).map(function(o) {
            return negateChildren ? o.negated(_this.model) : o;
        }));
    };
    /**
     * Returns a version of the predicate tree with unnecessary logical groups
     * condensed and merged together. This is intended to create a dense tree
     * with leaf nodes (`FieldCondition`'s) aggregated under as few group conditions
     * as possible for the most efficient fetching possible -- it allows `fetch()`.
     *
     * E.g. a grouping like this:
     *
     * ```yaml
     * and:
     * 	and:
     * 		id:
     * 			eq: "abc"
     * 	and:
     * 		name:
     * 			eq: "xyz"
     * ```
     *
     * Will become this:
     *
     * ```yaml
     * and:
     * 	id:
     * 		eq: "abc"
     * 	name:
     * 		eq: "xyz"
     * ```
     *
     * This allows `fetch()` to pass both the `id` and `name` conditions to the adapter
     * together, which can then decide what index to use based on both fields together.
     *
     * @param preserveNode Whether to preserve the current node and to explicitly not eliminate
     * it during optimization. Used internally to preserve the root node and children of
     * `not` groups. `not` groups will always have a single child, so there's nothing to
     * optimize below a `not` (for now), and it makes the query logic simpler later.
     */ GroupCondition.prototype.optimized = function(preserveNode) {
        var _this = this;
        if (preserveNode === void 0) preserveNode = true;
        var operands = this.operands.map(function(o) {
            return o instanceof GroupCondition ? o.optimized(_this.operator === "not") : o;
        });
        // we're only collapsing and/or groups that contains a single child for now,
        // because they're much more common and much more trivial to collapse. basically,
        // an `and`/`or` that contains a single child doesn't require the layer of
        // logical grouping.
        if (!preserveNode && [
            "and",
            "or"
        ].includes(this.operator) && !this.field && operands.length === 1) {
            var operand = operands[0];
            if (operand instanceof FieldCondition) {
                // between conditions should NOT be passed up the chain. if they
                // need to be *negated* later, it is important that they be properly
                // contained in an AND group. when de morgan's law is applied, the
                // conditions are reversed and the AND group flips to an OR. this
                // doesn't work right if the a `between` doesn't live in an AND group.
                if (operand.operator !== "between") return operand;
            } else return operand;
        }
        return new GroupCondition(this.model, this.field, this.relationshipType, this.operator, operands, true);
    };
    /**
     * Fetches matching records from a given storage adapter using legacy predicates (for now).
     * @param storage The storage adapter this predicate will query against.
     * @param breadcrumb For debugging/troubleshooting. A list of the `groupId`'s this
     * GroupdCondition.fetch is nested within.
     * @param negate Whether to match on the `NOT` of `this`.
     * @returns An `Promise` of `any[]` from `storage` matching the child conditions.
     */ GroupCondition.prototype.fetch = function(storage, breadcrumb, negate) {
        if (breadcrumb === void 0) breadcrumb = [];
        if (negate === void 0) negate = false;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var resultGroups, operator, negateChildren, groups, conditions, groups_1, groups_1_1, g, relatives, relationship, allJoinConditions, relatives_1, relatives_1_1, relative, relativeConditions, i, predicate, _a, _b, e_1_1, predicate, _c, _d, _e, _f, getPKValue, resultIndex, resultGroups_1, resultGroups_1_1, group, intersectWith, _g, _h, k, resultGroups_2, resultGroups_2_1, group, group_1, group_1_1, item;
            var e_1, _j, e_2, _k, _l, e_3, _m, e_4, _o, e_5, _p, e_6, _q;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_r) {
                switch(_r.label){
                    case 0:
                        if (!this.isOptimized) return [
                            2 /*return*/ ,
                            this.optimized().fetch(storage)
                        ];
                        resultGroups = [];
                        operator = negate ? negations[this.operator] : this.operator;
                        negateChildren = negate !== (this.operator === "not");
                        groups = this.operands.filter(function(op) {
                            return op instanceof GroupCondition;
                        });
                        conditions = this.operands.filter(function(op) {
                            return op instanceof FieldCondition;
                        });
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        groups_1 = (0, _tslib.__values)(groups), groups_1_1 = groups_1.next();
                        _r.label = 2;
                    case 2:
                        if (!!groups_1_1.done) return [
                            3 /*break*/ ,
                            9
                        ];
                        g = groups_1_1.value;
                        return [
                            4 /*yield*/ ,
                            g.fetch(storage, (0, _tslib.__spread)(breadcrumb, [
                                this.groupId
                            ]), negateChildren)
                        ];
                    case 3:
                        relatives = _r.sent();
                        // no relatives -> no need to attempt to perform a "join" query for
                        // candidate results:
                        //
                        // select a.* from a,b where b.id in EMPTY_SET ==> EMPTY_SET
                        //
                        // Additionally, the entire (sub)-query can be short-circuited if
                        // the operator is `AND`. Illustrated in SQL:
                        //
                        // select a.* from a where
                        //   id in [a,b,c]
                        //     AND                        <
                        //   id in EMTPY_SET            <<< Look!
                        //     AND                        <
                        //   id in [x,y,z]
                        //
                        // YIELDS: EMPTY_SET           // <-- Easy peasy. Lemon squeezy.
                        //
                        if (relatives.length === 0) {
                            // aggressively short-circuit as soon as we know the group condition will fail
                            if (operator === "and") return [
                                2 /*return*/ ,
                                []
                            ];
                            // less aggressive short-circuit if we know the relatives will produce no
                            // candidate results; but aren't sure yet how this affects the group condition.
                            resultGroups.push([]);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        }
                        if (!g.field) return [
                            3 /*break*/ ,
                            7
                        ];
                        relationship = (0, _relationship.ModelRelationship).from(this.model, g.field);
                        if (!relationship) return [
                            3 /*break*/ ,
                            5
                        ];
                        allJoinConditions = [];
                        try {
                            for(relatives_1 = (e_2 = void 0, (0, _tslib.__values)(relatives)), relatives_1_1 = relatives_1.next(); !relatives_1_1.done; relatives_1_1 = relatives_1.next()){
                                relative = relatives_1_1.value;
                                relativeConditions = [];
                                for(i = 0; i < relationship.localJoinFields.length; i++)relativeConditions.push((_l = {}, _l[relationship.localJoinFields[i]] = {
                                    eq: relative[relationship.remoteJoinFields[i]]
                                }, _l));
                                allJoinConditions.push({
                                    and: relativeConditions
                                });
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (relatives_1_1 && !relatives_1_1.done && (_k = relatives_1.return)) _k.call(relatives_1);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        predicate = (0, _index.ModelPredicateCreator).createFromAST(this.model.schema, {
                            or: allJoinConditions
                        });
                        _b = (_a = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder, predicate)
                        ];
                    case 4:
                        _b.apply(_a, [
                            _r.sent()
                        ]);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        throw new Error("Missing field metadata.");
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        // relatives are not actually relatives. they're candidate results.
                        resultGroups.push(relatives);
                        _r.label = 8;
                    case 8:
                        groups_1_1 = groups_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        e_1_1 = _r.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 11:
                        try {
                            if (groups_1_1 && !groups_1_1.done && (_j = groups_1.return)) _j.call(groups_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (!(conditions.length > 0)) return [
                            3 /*break*/ ,
                            14
                        ];
                        predicate = this.withFieldConditionsOnly(negateChildren).toStoragePredicate();
                        _d = (_c = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder, predicate)
                        ];
                    case 13:
                        _d.apply(_c, [
                            _r.sent()
                        ]);
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        if (!(conditions.length === 0 && resultGroups.length === 0)) return [
                            3 /*break*/ ,
                            16
                        ];
                        _f = (_e = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder)
                        ];
                    case 15:
                        _f.apply(_e, [
                            _r.sent()
                        ]);
                        _r.label = 16;
                    case 16:
                        getPKValue = function(item) {
                            return JSON.stringify(_this.model.pkField.map(function(name) {
                                return item[name];
                            }));
                        };
                        if (operator === "and") {
                            if (resultGroups.length === 0) return [
                                2 /*return*/ ,
                                []
                            ];
                            try {
                                // for each group, we intersect, removing items from the result index
                                // that aren't present in each subsequent group.
                                for(resultGroups_1 = (0, _tslib.__values)(resultGroups), resultGroups_1_1 = resultGroups_1.next(); !resultGroups_1_1.done; resultGroups_1_1 = resultGroups_1.next()){
                                    group = resultGroups_1_1.value;
                                    if (resultIndex === undefined) resultIndex = new Map(group.map(function(item) {
                                        return [
                                            getPKValue(item),
                                            item
                                        ];
                                    }));
                                    else {
                                        intersectWith = new Map(group.map(function(item) {
                                            return [
                                                getPKValue(item),
                                                item
                                            ];
                                        }));
                                        try {
                                            for(_g = (e_4 = void 0, (0, _tslib.__values)(resultIndex.keys())), _h = _g.next(); !_h.done; _h = _g.next()){
                                                k = _h.value;
                                                if (!intersectWith.has(k)) resultIndex.delete(k);
                                            }
                                        } catch (e_4_1) {
                                            e_4 = {
                                                error: e_4_1
                                            };
                                        } finally{
                                            try {
                                                if (_h && !_h.done && (_o = _g.return)) _o.call(_g);
                                            } finally{
                                                if (e_4) throw e_4.error;
                                            }
                                        }
                                    }
                                }
                            } catch (e_3_1) {
                                e_3 = {
                                    error: e_3_1
                                };
                            } finally{
                                try {
                                    if (resultGroups_1_1 && !resultGroups_1_1.done && (_m = resultGroups_1.return)) _m.call(resultGroups_1);
                                } finally{
                                    if (e_3) throw e_3.error;
                                }
                            }
                        } else if (operator === "or" || operator === "not") {
                            // it's OK to handle NOT here, because NOT must always only negate
                            // a single child predicate. NOT logic will have been distributed down
                            // to the leaf conditions already.
                            resultIndex = new Map();
                            try {
                                // just merge the groups, performing DISTINCT-ification by ID.
                                for(resultGroups_2 = (0, _tslib.__values)(resultGroups), resultGroups_2_1 = resultGroups_2.next(); !resultGroups_2_1.done; resultGroups_2_1 = resultGroups_2.next()){
                                    group = resultGroups_2_1.value;
                                    try {
                                        for(group_1 = (e_6 = void 0, (0, _tslib.__values)(group)), group_1_1 = group_1.next(); !group_1_1.done; group_1_1 = group_1.next()){
                                            item = group_1_1.value;
                                            resultIndex.set(getPKValue(item), item);
                                        }
                                    } catch (e_6_1) {
                                        e_6 = {
                                            error: e_6_1
                                        };
                                    } finally{
                                        try {
                                            if (group_1_1 && !group_1_1.done && (_q = group_1.return)) _q.call(group_1);
                                        } finally{
                                            if (e_6) throw e_6.error;
                                        }
                                    }
                                }
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (resultGroups_2_1 && !resultGroups_2_1.done && (_p = resultGroups_2.return)) _p.call(resultGroups_2);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                        }
                        return [
                            2 /*return*/ ,
                            Array.from((resultIndex === null || resultIndex === void 0 ? void 0 : resultIndex.values()) || [])
                        ];
                }
            });
        });
    };
    /**
     * Determines whether a single item matches the conditions of `this`.
     * When checking the target `item`'s properties, each property will be `await`'d
     * to ensure lazy-loading is respected where applicable.
     * @param item The item to match against.
     * @param ignoreFieldName Tells `match()` that the field name has already been dereferenced.
     * (Used for iterating over children on HAS_MANY checks.)
     * @returns A boolean (promise): `true` if matched, `false` otherwise.
     */ GroupCondition.prototype.matches = function(item, ignoreFieldName) {
        if (ignoreFieldName === void 0) ignoreFieldName = false;
        var e_7, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemToCheck, _b, itemToCheck_1, itemToCheck_1_1, singleItem, e_7_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(this.field && !ignoreFieldName)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            item[this.field]
                        ];
                    case 1:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _b = item;
                        _c.label = 3;
                    case 3:
                        itemToCheck = _b;
                        // if there is no item to check, we can stop recursing immediately.
                        // a condition cannot match against an item that does not exist. this
                        // can occur when `item.field` is optional in the schema.
                        if (!itemToCheck) return [
                            2 /*return*/ ,
                            false
                        ];
                        if (!(this.relationshipType === "HAS_MANY" && typeof itemToCheck[Symbol.asyncIterator] === "function")) return [
                            3 /*break*/ ,
                            17
                        ];
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            10,
                            11,
                            16
                        ]);
                        itemToCheck_1 = (0, _tslib.__asyncValues)(itemToCheck);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            itemToCheck_1.next()
                        ];
                    case 6:
                        if (!(itemToCheck_1_1 = _c.sent(), !itemToCheck_1_1.done)) return [
                            3 /*break*/ ,
                            9
                        ];
                        singleItem = itemToCheck_1_1.value;
                        return [
                            4 /*yield*/ ,
                            this.matches(singleItem, true)
                        ];
                    case 7:
                        if (_c.sent()) return [
                            2 /*return*/ ,
                            true
                        ];
                        _c.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 10:
                        e_7_1 = _c.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            ,
                            14,
                            15
                        ]);
                        if (!(itemToCheck_1_1 && !itemToCheck_1_1.done && (_a = itemToCheck_1.return))) return [
                            3 /*break*/ ,
                            13
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(itemToCheck_1)
                        ];
                    case 12:
                        _c.sent();
                        _c.label = 13;
                    case 13:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        if (e_7) throw e_7.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 17:
                        if (!(this.operator === "or")) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            2 /*return*/ ,
                            (0, _util.asyncSome)(this.operands, function(c) {
                                return c.matches(itemToCheck);
                            })
                        ];
                    case 18:
                        if (!(this.operator === "and")) return [
                            3 /*break*/ ,
                            19
                        ];
                        return [
                            2 /*return*/ ,
                            (0, _util.asyncEvery)(this.operands, function(c) {
                                return c.matches(itemToCheck);
                            })
                        ];
                    case 19:
                        if (!(this.operator === "not")) return [
                            3 /*break*/ ,
                            21
                        ];
                        if (this.operands.length !== 1) throw new Error("Invalid arguments! `not()` accepts exactly one predicate expression.");
                        return [
                            4 /*yield*/ ,
                            this.operands[0].matches(itemToCheck)
                        ];
                    case 20:
                        return [
                            2 /*return*/ ,
                            !_c.sent()
                        ];
                    case 21:
                        throw new Error("Invalid group operator!");
                }
            });
        });
    };
    /**
     * Tranfsorm to a AppSync GraphQL compatible AST.
     * (Does not support filtering in nested types.)
     */ GroupCondition.prototype.toAST = function() {
        var _a;
        if (this.field) throw new Error("Nested type conditions are not supported!");
        return _a = {}, _a[this.operator] = this.operands.map(function(operand) {
            return operand.toAST();
        }), _a;
    };
    /**
     * Turn this predicate group into something a storage adapter
     * understands how to use.
     */ GroupCondition.prototype.toStoragePredicate = function() {
        return (0, _index.ModelPredicateCreator).createFromAST(this.model.schema, this.toAST());
    };
    /**
     * A JSON representation that's good for debugging.
     */ GroupCondition.prototype.toJSON = function() {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            model: this.model.schema.name
        });
    };
    return GroupCondition;
}();
function recursivePredicateFor(ModelType, allowRecursion, field, query, tail) {
    if (allowRecursion === void 0) allowRecursion = true;
    // to be used if we don't have a base query or tail to build onto
    var starter = new GroupCondition(ModelType, field, undefined, "and", []);
    var baseCondition = query && tail ? query : starter;
    var tailCondition = query && tail ? tail : starter;
    // our eventual return object, which can be built upon.
    // next steps will be to add or(), and(), not(), and field.op() methods.
    var link = {};
    // so it can be looked up later with in the internals when processing conditions.
    registerPredicateInternals(baseCondition, link);
    var copyLink = function() {
        var _a = (0, _tslib.__read)(baseCondition.copy(tailCondition), 2), query = _a[0], newTail = _a[1];
        var newLink = recursivePredicateFor(ModelType, allowRecursion, undefined, query, newTail);
        return {
            query: query,
            newTail: newTail,
            newLink: newLink
        };
    };
    // Adds .or() and .and() methods to the link.
    // TODO: If revisiting this code, consider writing a Proxy instead.
    [
        "and",
        "or"
    ].forEach(function(op) {
        link[op] = function(builder) {
            // or() and and() will return a copy of the original link
            // to head off mutability concerns.
            var _a = copyLink(), query = _a.query, newTail = _a.newTail;
            var childConditions = builder(recursivePredicateFor(ModelType, allowRecursion));
            if (!Array.isArray(childConditions)) throw new Error("Invalid predicate. `" + op + "` groups must return an array of child conditions.");
            // the customer will supply a child predicate, which apply to the `model.field`
            // of the tail GroupCondition.
            newTail === null || newTail === void 0 || newTail.operands.push(new GroupCondition(ModelType, field, undefined, op, childConditions.map(function(c) {
                return internals(c);
            })));
            // FinalPredicate
            return registerPredicateInternals(query);
        };
    });
    // TODO: If revisiting this code, consider proxy.
    link.not = function(builder) {
        // not() will return a copy of the original link
        // to head off mutability concerns.
        var _a = copyLink(), query = _a.query, newTail = _a.newTail;
        // unlike and() and or(), the customer will supply a "singular" child predicate.
        // the difference being: not() does not accept an array of predicate-like objects.
        // it negates only a *single* predicate subtree.
        newTail === null || newTail === void 0 || newTail.operands.push(new GroupCondition(ModelType, field, undefined, "not", [
            internals(builder(recursivePredicateFor(ModelType, allowRecursion)))
        ]));
        // A `FinalModelPredicate`.
        // Return a thing that can no longer be extended, but instead used to `async filter(items)`
        // or query storage: `.__query.fetch(storage)`.
        return registerPredicateInternals(query);
    };
    var _loop_1 = function(fieldName) {
        Object.defineProperty(link, fieldName, {
            enumerable: true,
            get: function() {
                var def = ModelType.schema.allFields[fieldName];
                if (!def.association) // we're looking at a value field. we need to return a
                // "field matcher object", which contains all of the comparison
                // functions ('eq', 'ne', 'gt', etc.), scoped to operate
                // against the target field (fieldName).
                return ops.reduce(function(fieldMatcher, operator) {
                    var _a;
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, fieldMatcher), (_a = {}, _a[operator] = function() {
                        var operands = [];
                        for(var _i = 0; _i < arguments.length; _i++)operands[_i] = arguments[_i];
                        // build off a fresh copy of the existing `link`, just in case
                        // the same link is being used elsewhere by the customer.
                        var _a = copyLink(), query = _a.query, newTail = _a.newTail;
                        // normalize operands. if any of the values are `undefiend`, use
                        // `null` instead, because that's what will be stored cross-platform.
                        var normalizedOperands = operands.map(function(o) {
                            return o === undefined ? null : o;
                        });
                        // add the given condition to the link's TAIL node.
                        // remember: the base link might go N nodes deep! e.g.,
                        newTail === null || newTail === void 0 || newTail.operands.push(new FieldCondition(fieldName, operator, normalizedOperands));
                        // A `FinalModelPredicate`.
                        // Return a thing that can no longer be extended, but instead used to `async filter(items)`
                        // or query storage: `.__query.fetch(storage)`.
                        return registerPredicateInternals(query);
                    }, _a));
                }, {});
                else {
                    if (!allowRecursion) throw new Error("Predication on releated models is not supported in this context.");
                    else if (def.association.connectionType === "BELONGS_TO" || def.association.connectionType === "HAS_ONE" || def.association.connectionType === "HAS_MANY") {
                        // the use has just typed '.someRelatedModel'. we need to given them
                        // back a predicate chain.
                        var relatedMeta = def.type.modelConstructor;
                        if (!relatedMeta) throw new Error("Related model metadata is missing. This is a bug! Please report it.");
                        // `Model.reletedModelField` returns a copy of the original link,
                        // and will contains copies of internal GroupConditions
                        // to head off mutability concerns.
                        var _a = (0, _tslib.__read)(baseCondition.copy(tailCondition), 2), newquery = _a[0], oldtail = _a[1];
                        var newtail = new GroupCondition(relatedMeta, fieldName, def.association.connectionType, "and", []);
                        // `oldtail` here refers to the *copy* of the old tail.
                        // so, it's safe to modify at this point. and we need to modify
                        // it to push the *new* tail onto the end of it.
                        oldtail.operands.push(newtail);
                        var newlink = recursivePredicateFor(relatedMeta, allowRecursion, undefined, newquery, newtail);
                        return newlink;
                    } else throw new Error("Related model definition doesn't have a typedef. This is a bug! Please report it.");
                }
            }
        });
    };
    // For each field on the model schema, we want to add a getter
    // that creates the appropriate new `link` in the query chain.
    // TODO: If revisiting, consider a proxy.
    for(var fieldName in ModelType.schema.allFields)_loop_1(fieldName);
    return link;
}
function predicateFor(ModelType) {
    // the cast here is just a cheap way to reduce the surface area from
    // the recursive type.
    return recursivePredicateFor(ModelType, false);
}

},{"tslib":"9gMVn","../types":"KjGQP","./index":"lUiza","../storage/relationship":"4Ulys","../util":"89SDa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5ZNOP":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Interactions", ()=>(0, _interactions.Interactions));
parcelHelpers.export(exports, "AbstractInteractionsProvider", ()=>(0, _interactionsProvider.AbstractInteractionsProvider));
parcelHelpers.export(exports, "AWSLexProvider", ()=>(0, _awslexProvider.AWSLexProvider));
parcelHelpers.export(exports, "AWSLexV2Provider", ()=>(0, _awslexV2Provider.AWSLexV2Provider));
var _interactions = require("./Interactions");
var _interactionsProvider = require("./Providers/InteractionsProvider");
var _awslexProvider = require("./Providers/AWSLexProvider");
var _awslexV2Provider = require("./Providers/AWSLexV2Provider");

},{"./Interactions":"566hT","./Providers/InteractionsProvider":false,"./Providers/AWSLexProvider":false,"./Providers/AWSLexV2Provider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"566hT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionsClass", ()=>InteractionsClass);
parcelHelpers.export(exports, "Interactions", ()=>Interactions);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _providers = require("./Providers");
var logger = new (0, _core.ConsoleLogger)("Interactions");
var InteractionsClass = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     */ function InteractionsClass(options) {
        if (options === void 0) options = {};
        this._options = options;
        logger.debug("Interactions Options", this._options);
        this._pluggables = {};
    }
    InteractionsClass.prototype.getModuleName = function() {
        return "Interactions";
    };
    /**
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     * @return {InteractionsOptions} - The current configuration
     */ InteractionsClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.Interactions || options : {};
        logger.debug("configure Interactions", {
            opt: opt
        });
        this._options = (0, _tslib.__assign)((0, _tslib.__assign)({
            bots: {}
        }, opt), opt.Interactions);
        var aws_bots_config = this._options.aws_bots_config;
        var bots_config = this._options.bots;
        if (!Object.keys(bots_config).length && aws_bots_config) // Convert aws_bots_config to bots object
        {
            if (Array.isArray(aws_bots_config)) aws_bots_config.forEach(function(bot) {
                _this._options.bots[bot.name] = bot;
            });
        }
        // configure bots to their specific providers
        Object.keys(bots_config).forEach(function(botKey) {
            var _a;
            var bot = bots_config[botKey];
            var providerName = bot.providerName || "AWSLexProvider";
            // add default provider if required
            if (!_this._pluggables.AWSLexProvider && providerName === "AWSLexProvider") _this._pluggables.AWSLexProvider = new (0, _providers.AWSLexProvider)();
            // configure bot with it's respective provider
            if (_this._pluggables[providerName]) _this._pluggables[providerName].configure((_a = {}, _a[bot.name] = bot, _a));
            else logger.debug("bot " + bot.name + " was not configured as " + providerName + " provider was not found");
        });
        return this._options;
    };
    InteractionsClass.prototype.addPluggable = function(pluggable) {
        var _this = this;
        if (pluggable && pluggable.getCategory() === "Interactions") {
            if (!this._pluggables[pluggable.getProviderName()]) {
                // configure bots for the new plugin
                Object.keys(this._options.bots).filter(function(botKey) {
                    return _this._options.bots[botKey].providerName === pluggable.getProviderName();
                }).forEach(function(botKey) {
                    var _a;
                    var bot = _this._options.bots[botKey];
                    pluggable.configure((_a = {}, _a[bot.name] = bot, _a));
                });
                this._pluggables[pluggable.getProviderName()] = pluggable;
                return;
            } else throw new Error("Pluggable " + pluggable.getProviderName() + " already plugged");
        }
    };
    InteractionsClass.prototype.send = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var botProvider;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._options.bots || !this._options.bots[botname]) return [
                            2 /*return*/ ,
                            Promise.reject("Bot " + botname + " does not exist")
                        ];
                        botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
                        if (!this._pluggables[botProvider]) return [
                            2 /*return*/ ,
                            Promise.reject("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?")
                        ];
                        return [
                            4 /*yield*/ ,
                            this._pluggables[botProvider].sendMessage(botname, message)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    InteractionsClass.prototype.onComplete = function(botname, callback) {
        if (!this._options.bots || !this._options.bots[botname]) throw new Error("Bot " + botname + " does not exist");
        var botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
        if (!this._pluggables[botProvider]) throw new Error("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?");
        this._pluggables[botProvider].onComplete(botname, callback);
    };
    return InteractionsClass;
}();
var Interactions = new InteractionsClass();
(0, _core.Amplify).register(Interactions);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./Providers":"eZfNm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eZfNm":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexProvider", ()=>(0, _awslexProvider.AWSLexProvider));
parcelHelpers.export(exports, "AWSLexV2Provider", ()=>(0, _awslexV2Provider.AWSLexV2Provider));
parcelHelpers.export(exports, "AbstractInteractionsProvider", ()=>(0, _interactionsProvider.AbstractInteractionsProvider));
var _awslexProvider = require("./AWSLexProvider");
var _awslexV2Provider = require("./AWSLexV2Provider");
var _interactionsProvider = require("./InteractionsProvider");

},{"./AWSLexProvider":"8jUkY","./AWSLexV2Provider":false,"./InteractionsProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8jUkY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexProvider", ()=>AWSLexProvider);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _interactionsProvider = require("./InteractionsProvider");
var _clientLexRuntimeService = require("@aws-sdk/client-lex-runtime-service");
var _core = require("@aws-amplify/core");
var _utils = require("./AWSLexProviderHelper/utils");
var logger = new (0, _core.ConsoleLogger)("AWSLexProvider");
var AWSLexProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSLexProvider, _super);
    function AWSLexProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this._botsCompleteCallback = {};
        return _this;
    }
    AWSLexProvider.prototype.getProviderName = function() {
        return "AWSLexProvider";
    };
    AWSLexProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        var propertiesToTest = [
            "name",
            "alias",
            "region"
        ];
        Object.keys(config).forEach(function(botKey) {
            var botConfig = config[botKey];
            // is bot config correct
            if (!propertiesToTest.every(function(x) {
                return x in botConfig;
            })) throw new Error("invalid bot configuration");
        });
        return _super.prototype.configure.call(this, config);
    };
    /**
     * @private
     * @deprecated
     * This is used internally by 'sendMessage' to call onComplete callback
     * for a bot if configured
     */ AWSLexProvider.prototype.reportBotStatus = function(data, botname) {
        var _this = this;
        // Check if state is fulfilled to resolve onFullfilment promise
        logger.debug("postContent state", data.dialogState);
        if (data.dialogState === "ReadyForFulfillment" || data.dialogState === "Fulfilled") {
            if (typeof this._botsCompleteCallback[botname] === "function") setTimeout(function() {
                return _this._botsCompleteCallback[botname](null, data);
            }, 0);
            if (this._config && typeof this._config[botname].onComplete === "function") setTimeout(function() {
                return _this._config[botname].onComplete(null, data);
            }, 0);
        }
        if (data.dialogState === "Failed") {
            if (typeof this._botsCompleteCallback[botname] === "function") setTimeout(function() {
                return _this._botsCompleteCallback[botname]("Bot conversation failed");
            }, 0);
            if (this._config && typeof this._config[botname].onComplete === "function") setTimeout(function() {
                return _this._config[botname].onComplete("Bot conversation failed");
            }, 0);
        }
    };
    AWSLexProvider.prototype.sendMessage = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, error_1, params, postTextCommand, data, err_1, content, messageType, inputStream, _a, postContentCommand, data, audioArray, _b, response, err_2;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        // check if bot exists
                        if (!this._config[botname]) return [
                            2 /*return*/ ,
                            Promise.reject("Bot " + botname + " does not exist")
                        ];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 2:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject("No credentials")
                        ];
                    case 4:
                        this.lexRuntimeServiceClient = new (0, _clientLexRuntimeService.LexRuntimeServiceClient)({
                            region: this._config[botname].region,
                            credentials: credentials,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        if (!(typeof message === "string")) return [
                            3 /*break*/ ,
                            9
                        ];
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            inputText: message,
                            userId: credentials.identityId
                        };
                        logger.debug("postText to lex", message);
                        _c.label = 5;
                    case 5:
                        _c.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        postTextCommand = new (0, _clientLexRuntimeService.PostTextCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this.lexRuntimeServiceClient.send(postTextCommand)
                        ];
                    case 6:
                        data = _c.sent();
                        this.reportBotStatus(data, botname);
                        return [
                            2 /*return*/ ,
                            data
                        ];
                    case 7:
                        err_1 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_1)
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 9:
                        content = message.content, messageType = message.options.messageType;
                        if (!(messageType === "voice")) return [
                            3 /*break*/ ,
                            13
                        ];
                        if (typeof content !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("invalid content type")
                        ];
                        if (!(content instanceof Uint8Array)) return [
                            3 /*break*/ ,
                            10
                        ];
                        _a = content;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(content)
                        ];
                    case 11:
                        _a = _c.sent();
                        _c.label = 12;
                    case 12:
                        inputStream = _a;
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            contentType: "audio/x-l16; sample-rate=16000; channel-count=1",
                            userId: credentials.identityId,
                            accept: "audio/mpeg",
                            inputStream: inputStream
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (typeof content !== "string") return [
                            2 /*return*/ ,
                            Promise.reject("invalid content type")
                        ];
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            contentType: "text/plain; charset=utf-8",
                            inputStream: content,
                            userId: credentials.identityId,
                            accept: "audio/mpeg"
                        };
                        _c.label = 14;
                    case 14:
                        logger.debug("postContent to lex", message);
                        _c.label = 15;
                    case 15:
                        _c.trys.push([
                            15,
                            20,
                            ,
                            21
                        ]);
                        postContentCommand = new (0, _clientLexRuntimeService.PostContentCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this.lexRuntimeServiceClient.send(postContentCommand)
                        ];
                    case 16:
                        data = _c.sent();
                        if (!data.audioStream) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(data.audioStream)
                        ];
                    case 17:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 18:
                        _b = undefined;
                        _c.label = 19;
                    case 19:
                        audioArray = _b;
                        response = (0, _tslib.__assign)((0, _tslib.__assign)({}, data), {
                            audioStream: audioArray
                        });
                        this.reportBotStatus(response, botname);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 20:
                        err_2 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_2)
                        ];
                    case 21:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSLexProvider.prototype.onComplete = function(botname, callback) {
        // does bot exist
        if (!this._config[botname]) throw new Error("Bot " + botname + " does not exist");
        this._botsCompleteCallback[botname] = callback;
    };
    return AWSLexProvider;
}((0, _interactionsProvider.AbstractInteractionsProvider));

},{"tslib":"9gMVn","./InteractionsProvider":"1lbwo","@aws-sdk/client-lex-runtime-service":"hppH6","@aws-amplify/core":"8BDOx","./AWSLexProviderHelper/utils":"59VeJ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1lbwo":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractInteractionsProvider", ()=>AbstractInteractionsProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("AbstractInteractionsProvider");
var AbstractInteractionsProvider = /** @class */ function() {
    function AbstractInteractionsProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractInteractionsProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._config), config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractInteractionsProvider.prototype.getCategory = function() {
        return "Interactions";
    };
    Object.defineProperty(AbstractInteractionsProvider.prototype, "options", {
        get: function() {
            return (0, _tslib.__assign)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractInteractionsProvider;
}();

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hppH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceServiceException", ()=>(0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var _lexRuntimeService = require("./LexRuntimeService");
parcelHelpers.exportAll(_lexRuntimeService, exports);
var _lexRuntimeServiceClient = require("./LexRuntimeServiceClient");
parcelHelpers.exportAll(_lexRuntimeServiceClient, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _lexRuntimeServiceServiceException = require("./models/LexRuntimeServiceServiceException");

},{"./LexRuntimeService":false,"./LexRuntimeServiceClient":"kCqS8","./commands":"dGZeq","./models":false,"./models/LexRuntimeServiceServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kCqS8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceClient", ()=>LexRuntimeServiceClient);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LexRuntimeServiceClient = function(_super) {
    (0, _tslib.__extends)(LexRuntimeServiceClient, _super);
    function LexRuntimeServiceClient(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LexRuntimeServiceClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LexRuntimeServiceClient;
}((0, _smithyClient.Client));

},{"tslib":"ll1a4","@aws-sdk/config-resolver":"lUWM9","@aws-sdk/middleware-content-length":"ik3vG","@aws-sdk/middleware-host-header":"fFtbq","@aws-sdk/middleware-logger":"lcNkT","@aws-sdk/middleware-recursion-detection":"8UY62","@aws-sdk/middleware-retry":"Dcfme","@aws-sdk/middleware-signing":"3TPew","@aws-sdk/middleware-user-agent":"e9DuH","@aws-sdk/smithy-client":"fD3TM","./runtimeConfig":"9KDDs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ll1a4":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lUWM9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"e03Lw","./regionConfig":"5LTiV","./regionInfo":"r98eU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e03Lw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"7tNNT","./NodeUseFipsEndpointConfigOptions":"fjEX9","./resolveCustomEndpointsConfig":"12MNS","./resolveEndpointsConfig":"eRsX6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7tNNT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", ()=>ENV_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", ()=>CONFIG_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", ()=>DEFAULT_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"a0aP5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a0aP5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _booleanSelector = require("./booleanSelector");
parcelHelpers.exportAll(_booleanSelector, exports);

},{"./booleanSelector":"4j5Ny","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4j5Ny":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectorType", ()=>SelectorType);
parcelHelpers.export(exports, "booleanSelector", ()=>booleanSelector);
var SelectorType;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})(SelectorType || (SelectorType = {}));
var booleanSelector = function(obj, key, type) {
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error("Cannot load ".concat(type, ' "').concat(key, '". Expected "true" or "false", got ').concat(obj[key], "."));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fjEX9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", ()=>ENV_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", ()=>CONFIG_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", ()=>DEFAULT_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"a0aP5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"12MNS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", ()=>resolveCustomEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"ll1a4","@aws-sdk/util-middleware":"anyI5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"anyI5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _normalizeProvider = require("./normalizeProvider");
parcelHelpers.exportAll(_normalizeProvider, exports);

},{"./normalizeProvider":"figAO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"figAO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeProvider", ()=>normalizeProvider);
var normalizeProvider = function(input) {
    if (typeof input === "function") return input;
    var promisified = Promise.resolve(input);
    return function() {
        return promisified;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eRsX6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", ()=>resolveEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"ll1a4","@aws-sdk/util-middleware":"anyI5","./utils/getEndpointFromRegion":"dQUFI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dQUFI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", ()=>getEndpointFromRegion);
var _tslib = require("tslib");
var getEndpointFromRegion = function(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5LTiV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"dvPGY","./resolveRegionConfig":"eVj57","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dvPGY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", ()=>REGION_ENV_NAME);
parcelHelpers.export(exports, "REGION_INI_NAME", ()=>REGION_INI_NAME);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", ()=>NODE_REGION_CONFIG_OPTIONS);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", ()=>NODE_REGION_CONFIG_FILE_OPTIONS);
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eVj57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", ()=>resolveRegionConfig);
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"ll1a4","./getRealRegion":"gHSUr","./isFipsRegion":"heQf3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gHSUr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", ()=>getRealRegion);
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"heQf3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"heQf3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", ()=>isFipsRegion);
var isFipsRegion = function(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"r98eU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"fPzMZ","./RegionHash":"bgTIx","./getRegionInfo":"dd0Hq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fPzMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bgTIx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dd0Hq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", ()=>getRegionInfo);
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"ll1a4","./getHostnameFromVariants":"l2U25","./getResolvedHostname":"huJPN","./getResolvedPartition":"6XojJ","./getResolvedSigningRegion":"2encV","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l2U25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", ()=>getHostnameFromVariants);
var getHostnameFromVariants = function(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"huJPN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", ()=>getResolvedHostname);
var getResolvedHostname = function(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6XojJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", ()=>getResolvedPartition);
var getResolvedPartition = function(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2encV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", ()=>getResolvedSigningRegion);
var getResolvedSigningRegion = function(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ik3vG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", ()=>contentLengthMiddleware);
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", ()=>contentLengthMiddlewareOptions);
parcelHelpers.export(exports, "getContentLengthPlugin", ()=>getContentLengthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Xi1q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"axG4y","./httpRequest":"jyJh9","./httpResponse":"lm8AK","./isValidHostname":"mBB08","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"axG4y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jyJh9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lm8AK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"mBB08":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fFtbq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lcNkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"5hxzB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5hxzB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8UY62":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recursionDetectionMiddleware", ()=>recursionDetectionMiddleware);
parcelHelpers.export(exports, "addRecursionDetectionMiddlewareOptions", ()=>addRecursionDetectionMiddlewareOptions);
parcelHelpers.export(exports, "getRecursionDetectionPlugin", ()=>getRecursionDetectionPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var process = require("8664757a056e7543");
var TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
var ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
var ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
var recursionDetectionMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, functionName, traceId, nonEmptyString;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if (!(0, _protocolHttp.HttpRequest).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) return [
                        2,
                        next(args)
                    ];
                    functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
                    traceId = process.env[ENV_TRACE_ID];
                    nonEmptyString = function(str) {
                        return typeof str === "string" && str.length > 0;
                    };
                    if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[TRACE_ID_HEADER_NAME] = traceId;
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
};
var addRecursionDetectionMiddlewareOptions = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
var getRecursionDetectionPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(recursionDetectionMiddleware(options), addRecursionDetectionMiddlewareOptions);
        }
    };
};

},{"8664757a056e7543":"g1F5c","tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"Dcfme":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"5r0RS","./DefaultRateLimiter":"11rqL","./StandardRetryStrategy":"grNve","./config":"P6JED","./configurations":"izyly","./delayDecider":"1KRMd","./omitRetryHeadersMiddleware":"9cyky","./retryDecider":"7fFE9","./retryMiddleware":"h45bw","./types":"UU5va","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5r0RS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", ()=>AdaptiveRetryStrategy);
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"ll1a4","./config":"P6JED","./DefaultRateLimiter":"11rqL","./StandardRetryStrategy":"grNve","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"P6JED":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", ()=>RETRY_MODES);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", ()=>DEFAULT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", ()=>DEFAULT_RETRY_MODE);
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"11rqL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", ()=>DefaultRateLimiter);
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"ll1a4","@aws-sdk/service-error-classification":"EiaJ8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"EiaJ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", ()=>isRetryableByTrait);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
parcelHelpers.export(exports, "isThrottlingError", ()=>isThrottlingError);
parcelHelpers.export(exports, "isTransientError", ()=>isTransientError);
var _constants = require("./constants");
var isRetryableByTrait = function(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"7QKhJ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7QKhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", ()=>CLOCK_SKEW_ERROR_CODES);
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", ()=>THROTTLING_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", ()=>TRANSIENT_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", ()=>TRANSIENT_ERROR_STATUS_CODES);
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", ()=>NODEJS_TIMEOUT_ERROR_CODES);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"grNve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", ()=>StandardRetryStrategy);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","@aws-sdk/service-error-classification":"EiaJ8","uuid":"cEy2P","./config":"P6JED","./constants":"aBbNq","./defaultRetryQuota":"drMl6","./delayDecider":"1KRMd","./retryDecider":"7fFE9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cEy2P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"igRdg","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"igRdg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"4gCgU","./stringify.js":"ahNYs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4gCgU":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ahNYs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"M6pR4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"M6pR4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"jqG4K","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jqG4K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aBbNq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", ()=>DEFAULT_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", ()=>MAXIMUM_RETRY_DELAY);
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", ()=>THROTTLING_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", ()=>INITIAL_RETRY_TOKENS);
parcelHelpers.export(exports, "RETRY_COST", ()=>RETRY_COST);
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", ()=>TIMEOUT_RETRY_COST);
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", ()=>NO_RETRY_INCREMENT);
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", ()=>INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "REQUEST_HEADER", ()=>REQUEST_HEADER);
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"drMl6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", ()=>getDefaultRetryQuota);
var _constants = require("./constants");
var getDefaultRetryQuota = function(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"aBbNq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1KRMd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", ()=>defaultDelayDecider);
var _constants = require("./constants");
var defaultDelayDecider = function(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"aBbNq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7fFE9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", ()=>defaultRetryDecider);
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"EiaJ8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"izyly":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", ()=>ENV_MAX_ATTEMPTS);
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", ()=>CONFIG_MAX_ATTEMPTS);
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", ()=>NODE_MAX_ATTEMPT_CONFIG_OPTIONS);
parcelHelpers.export(exports, "resolveRetryConfig", ()=>resolveRetryConfig);
parcelHelpers.export(exports, "ENV_RETRY_MODE", ()=>ENV_RETRY_MODE);
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", ()=>CONFIG_RETRY_MODE);
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", ()=>NODE_RETRY_MODE_CONFIG_OPTIONS);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"ll1a4","@aws-sdk/util-middleware":"anyI5","./AdaptiveRetryStrategy":"5r0RS","./config":"P6JED","./StandardRetryStrategy":"grNve","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9cyky":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", ()=>omitRetryHeadersMiddleware);
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", ()=>omitRetryHeadersMiddlewareOptions);
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", ()=>getOmitRetryHeadersPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","./constants":"aBbNq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h45bw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
parcelHelpers.export(exports, "retryMiddlewareOptions", ()=>retryMiddlewareOptions);
parcelHelpers.export(exports, "getRetryPlugin", ()=>getRetryPlugin);
var _tslib = require("tslib");
var retryMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"UU5va":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3TPew":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"cUubD","./middleware":"ehykZ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cUubD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", ()=>resolveAwsAuthConfig);
parcelHelpers.export(exports, "resolveSigV4AuthConfig", ()=>resolveSigV4AuthConfig);
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"ll1a4","@aws-sdk/property-provider":"jMm31","@aws-sdk/signature-v4":"2VvmH","@aws-sdk/util-middleware":"anyI5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jMm31":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"6pbmQ","./ProviderError":"10SiQ","./TokenProviderError":"1qo0z","./chain":"kxAdo","./fromStatic":"3jXBR","./memoize":"b4FXv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6pbmQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", ()=>CredentialsProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"ll1a4","./ProviderError":"10SiQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"10SiQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", ()=>ProviderError);
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1qo0z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", ()=>TokenProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"ll1a4","./ProviderError":"10SiQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kxAdo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"ll1a4","./ProviderError":"10SiQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3jXBR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", ()=>fromStatic);
var fromStatic = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b4FXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
var _tslib = require("tslib");
var memoize = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2VvmH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>(0, _getCanonicalHeaders.getCanonicalHeaders));
parcelHelpers.export(exports, "getCanonicalQuery", ()=>(0, _getCanonicalQuery.getCanonicalQuery));
parcelHelpers.export(exports, "getPayloadHash", ()=>(0, _getPayloadHash.getPayloadHash));
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>(0, _moveHeadersToQuery.moveHeadersToQuery));
parcelHelpers.export(exports, "prepareRequest", ()=>(0, _prepareRequest.prepareRequest));
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"e5DkM","./getCanonicalHeaders":"6FQ4X","./getCanonicalQuery":"5v9Gg","./getPayloadHash":"c4maD","./moveHeadersToQuery":"fXvMO","./prepareRequest":"dHsfp","./credentialDerivation":"chwoH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e5DkM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"tslib":"ll1a4","@aws-sdk/util-hex-encoding":"jg3Sz","@aws-sdk/util-middleware":"anyI5","./constants":"7waJn","./credentialDerivation":"chwoH","./getCanonicalHeaders":"6FQ4X","./getCanonicalQuery":"5v9Gg","./getPayloadHash":"c4maD","./headerUtil":"dCweb","./moveHeadersToQuery":"fXvMO","./prepareRequest":"dHsfp","./utilDate":"8YYrH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jg3Sz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7waJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", ()=>ALGORITHM_IDENTIFIER_V4A);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"chwoH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"ll1a4","@aws-sdk/util-hex-encoding":"jg3Sz","./constants":"7waJn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6FQ4X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"ll1a4","./constants":"7waJn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5v9Gg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"ll1a4","@aws-sdk/util-uri-escape":"egTf1","./constants":"7waJn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"egTf1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"aqKVs","./escape-uri-path":"gDx6t","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aqKVs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
var escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gDx6t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
var escapeUriPath = function(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"aqKVs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"c4maD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"ll1a4","@aws-sdk/is-array-buffer":"gBcjE","@aws-sdk/util-hex-encoding":"jg3Sz","./constants":"7waJn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gBcjE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dCweb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
parcelHelpers.export(exports, "getHeaderValue", ()=>getHeaderValue);
parcelHelpers.export(exports, "deleteHeader", ()=>deleteHeader);
var _tslib = require("tslib");
var hasHeader = function(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fXvMO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"ll1a4","./cloneRequest":"hMDhw","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hMDhw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
parcelHelpers.export(exports, "cloneQuery", ()=>cloneQuery);
var _tslib = require("tslib");
var cloneRequest = function(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dHsfp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"ll1a4","./cloneRequest":"hMDhw","./constants":"7waJn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8YYrH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
var iso8601 = function(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ehykZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", ()=>awsAuthMiddleware);
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", ()=>awsAuthMiddlewareOptions);
parcelHelpers.export(exports, "getAwsAuthPlugin", ()=>getAwsAuthPlugin);
parcelHelpers.export(exports, "getSigV4AuthPlugin", ()=>getSigV4AuthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","./utils/getSkewCorrectedDate":"lUa6n","./utils/getUpdatedSystemClockOffset":"7MjOv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lUa6n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7MjOv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"ki2pD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ki2pD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"lUa6n","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e9DuH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"bsHPg","./user-agent-middleware":"kkIrB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bsHPg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kkIrB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","./constants":"44UOn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"44UOn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fD3TM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"k6loQ","./command":"gX9Ao","./constants":"jo907","./date-utils":"aOin0","./default-error-handler":"g7SWG","./defaults-mode":"dmZil","./emitWarningIfUnsupportedVersion":"jxna9","./exceptions":"8j4vx","./extended-encode-uri-component":"jooKY","./get-array-if-single-item":"3aL3M","./get-value-from-text-node":"iJlhX","./lazy-json":"fxSmX","./object-mapping":"7I2Jg","./parse-utils":"fDKGP","./resolve-path":"ggarE","./ser-utils":"8NdCW","./split-every":"1eHDr","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k6loQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"ibzbS","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ibzbS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"1gXkP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1gXkP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", ()=>constructStack);
var _tslib = require("tslib");
var constructStack = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"'.concat(name, '" middleware with ').concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"'.concat(name, '" middleware ').concat(toOverride.relation, ' "').concat(toOverride.toMiddleware, '" middleware cannot be overridden ') + "by same-name middleware ".concat(entry.relation, ' "').concat(entry.toMiddleware, '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo(constructStack());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gX9Ao":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"ibzbS","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jo907":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", ()=>SENSITIVE_STRING);
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aOin0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", ()=>dateToUtcString);
parcelHelpers.export(exports, "parseRfc3339DateTime", ()=>parseRfc3339DateTime);
parcelHelpers.export(exports, "parseRfc7231DateTime", ()=>parseRfc7231DateTime);
parcelHelpers.export(exports, "parseEpochTimestamp", ()=>parseEpochTimestamp);
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"ll1a4","./parse-utils":"fDKGP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fDKGP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", ()=>parseBoolean);
parcelHelpers.export(exports, "expectBoolean", ()=>expectBoolean);
parcelHelpers.export(exports, "expectNumber", ()=>expectNumber);
parcelHelpers.export(exports, "expectFloat32", ()=>expectFloat32);
parcelHelpers.export(exports, "expectLong", ()=>expectLong);
parcelHelpers.export(exports, "expectInt", ()=>expectInt);
parcelHelpers.export(exports, "expectInt32", ()=>expectInt32);
parcelHelpers.export(exports, "expectShort", ()=>expectShort);
parcelHelpers.export(exports, "expectByte", ()=>expectByte);
parcelHelpers.export(exports, "expectNonNull", ()=>expectNonNull);
parcelHelpers.export(exports, "expectObject", ()=>expectObject);
parcelHelpers.export(exports, "expectString", ()=>expectString);
parcelHelpers.export(exports, "expectUnion", ()=>expectUnion);
parcelHelpers.export(exports, "strictParseDouble", ()=>strictParseDouble);
parcelHelpers.export(exports, "strictParseFloat", ()=>strictParseFloat);
parcelHelpers.export(exports, "strictParseFloat32", ()=>strictParseFloat32);
parcelHelpers.export(exports, "limitedParseDouble", ()=>limitedParseDouble);
parcelHelpers.export(exports, "handleFloat", ()=>handleFloat);
parcelHelpers.export(exports, "limitedParseFloat", ()=>limitedParseFloat);
parcelHelpers.export(exports, "limitedParseFloat32", ()=>limitedParseFloat32);
parcelHelpers.export(exports, "strictParseLong", ()=>strictParseLong);
parcelHelpers.export(exports, "strictParseInt", ()=>strictParseInt);
parcelHelpers.export(exports, "strictParseInt32", ()=>strictParseInt32);
parcelHelpers.export(exports, "strictParseShort", ()=>strictParseShort);
parcelHelpers.export(exports, "strictParseByte", ()=>strictParseByte);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var parseBoolean = function(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error('Unable to parse boolean value "'.concat(value, '"'));
    }
};
var expectBoolean = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value, ": ").concat(value));
};
var expectNumber = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value, ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value, ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value, ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value, ": ").concat(value));
};
var expectUnion = function(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g7SWG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", ()=>throwDefaultError);
var _exceptions = require("./exceptions");
var throwDefaultError = function(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"8j4vx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8j4vx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", ()=>ServiceException);
parcelHelpers.export(exports, "decorateServiceException", ()=>decorateServiceException);
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dmZil":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", ()=>loadConfigsForDefaultMode);
var loadConfigsForDefaultMode = function(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jxna9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", ()=>emitWarningIfUnsupportedVersion);
var process = require("829cfc0ffb172e56");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"829cfc0ffb172e56":"g1F5c","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jooKY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3aL3M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", ()=>getArrayIfSingleItem);
var getArrayIfSingleItem = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iJlhX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", ()=>getValueFromTextNode);
var getValueFromTextNode = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fxSmX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", ()=>StringWrapper);
parcelHelpers.export(exports, "LazyJsonString", ()=>LazyJsonString);
var _tslib = require("tslib");
var StringWrapper = function() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7I2Jg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "convertMap", ()=>convertMap);
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ggarE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", ()=>resolvedPath);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function(resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};

},{"./extended-encode-uri-component":"jooKY","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8NdCW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", ()=>serializeFloat);
var serializeFloat = function(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1eHDr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", ()=>splitEvery);
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9KDDs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, _sha256Browser.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"ll1a4","../package.json":"4KUG1","@aws-crypto/sha256-browser":"bAic6","@aws-sdk/config-resolver":"lUWM9","@aws-sdk/fetch-http-handler":"kYxzk","@aws-sdk/invalid-dependency":"4B3CJ","@aws-sdk/middleware-retry":"Dcfme","@aws-sdk/util-base64-browser":"17TK0","@aws-sdk/util-body-length-browser":"9sw5J","@aws-sdk/util-user-agent-browser":"fdFgF","@aws-sdk/util-utf8-browser":"hj069","./runtimeConfig.shared":"4neXT","@aws-sdk/smithy-client":"fD3TM","@aws-sdk/util-defaults-mode-browser":"94fY5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4KUG1":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-lex-runtime-service","description":"AWS SDK for JavaScript Lex Runtime Service Client for Node.js, Browser and React Native","version":"3.186.3","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"tsc -p tsconfig.cjs.json","build:docs":"typedoc","build:es":"tsc -p tsconfig.es.json","build:include:deps":"lerna run --scope $npm_package_name --include-dependencies build","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo","test":"yarn test:unit","test:unit":"ts-mocha test/**/*.spec.ts"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"2.0.0","@aws-crypto/sha256-js":"2.0.0","@aws-sdk/client-sts":"3.186.3","@aws-sdk/config-resolver":"3.186.0","@aws-sdk/credential-provider-node":"3.186.0","@aws-sdk/fetch-http-handler":"3.186.0","@aws-sdk/hash-node":"3.186.0","@aws-sdk/invalid-dependency":"3.186.0","@aws-sdk/middleware-content-length":"3.186.0","@aws-sdk/middleware-host-header":"3.186.0","@aws-sdk/middleware-logger":"3.186.0","@aws-sdk/middleware-recursion-detection":"3.186.0","@aws-sdk/middleware-retry":"3.186.0","@aws-sdk/middleware-serde":"3.186.0","@aws-sdk/middleware-signing":"3.186.0","@aws-sdk/middleware-stack":"3.186.0","@aws-sdk/middleware-user-agent":"3.186.0","@aws-sdk/node-config-provider":"3.186.0","@aws-sdk/node-http-handler":"3.186.0","@aws-sdk/protocol-http":"3.186.0","@aws-sdk/smithy-client":"3.186.0","@aws-sdk/types":"3.186.0","@aws-sdk/url-parser":"3.186.0","@aws-sdk/util-base64-browser":"3.186.0","@aws-sdk/util-base64-node":"3.186.0","@aws-sdk/util-body-length-browser":"3.186.0","@aws-sdk/util-body-length-node":"3.186.0","@aws-sdk/util-defaults-mode-browser":"3.186.0","@aws-sdk/util-defaults-mode-node":"3.186.0","@aws-sdk/util-user-agent-browser":"3.186.0","@aws-sdk/util-user-agent-node":"3.186.0","@aws-sdk/util-utf8-browser":"3.186.0","@aws-sdk/util-utf8-node":"3.186.0","tslib":"^2.3.1"},"devDependencies":{"@aws-sdk/service-client-documentation-generator":"3.186.0","@tsconfig/recommended":"1.0.1","@types/chai":"^4.2.11","@types/mocha":"^8.0.4","@types/node":"^12.7.5","concurrently":"7.0.0","downlevel-dts":"0.10.1","rimraf":"3.0.2","typedoc":"0.19.2","typescript":"~4.6.2"},"overrides":{"typedoc":{"typescript":"~4.6.2"}},"engines":{"node":">=12.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lex-runtime-service","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-lex-runtime-service"}}');

},{}],"bAic6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("d869f679f32f407d");
(0, tslib_1.__exportStar)(require("b0f537c8404fabe7"), exports);
var ie11Sha256_1 = require("ce93437bcebd91ab");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("68cca9e6fee69adf");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"d869f679f32f407d":"akK78","b0f537c8404fabe7":"i5zA7","ce93437bcebd91ab":"a5kjm","68cca9e6fee69adf":"EuSej"}],"akK78":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i5zA7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("453cd7d5fb36332a");
var webCryptoSha256_1 = require("ef4321517786adfd");
var sha256_js_1 = require("e69e134258c464b3");
var supports_web_crypto_1 = require("f6560285c113a981");
var ie11_detection_1 = require("7008797b0496e8b2");
var util_locate_window_1 = require("4579f58fc373ace9");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"453cd7d5fb36332a":"a5kjm","ef4321517786adfd":"EuSej","e69e134258c464b3":"5XWC3","f6560285c113a981":"8qBxJ","7008797b0496e8b2":"6K9Fu","4579f58fc373ace9":"iQfdF"}],"a5kjm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("bf6d3fc2e60ba76d");
var constants_1 = require("b87616627cf2e0f5");
var util_utf8_browser_1 = require("f850988d1d541c92");
var util_locate_window_1 = require("e2bdadc602eaf4f6");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"bf6d3fc2e60ba76d":"9UhO0","b87616627cf2e0f5":"2nu8S","f850988d1d541c92":"hj069","e2bdadc602eaf4f6":"iQfdF"}],"9UhO0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"2nu8S":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"hj069":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"aUW8n","./whatwgEncodingApi":"bQGr0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aUW8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bQGr0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"EuSej":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("43a5977a498abeed");
var constants_1 = require("c3ed919bd9996f19");
var util_locate_window_1 = require("c35752418ef0f254");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"43a5977a498abeed":"ciXEi","c3ed919bd9996f19":"2nu8S","c35752418ef0f254":"iQfdF"}],"ciXEi":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("9193df0db021fb26");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("459998af8963a091");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("b42a68361f012efb");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("b7e6168de801e09f");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"9193df0db021fb26":"ehhYW","459998af8963a091":"lpDnK","b42a68361f012efb":"hGIMb","b7e6168de801e09f":"ewPHx"}],"ehhYW":[function(require,module,exports) {
var Buffer = require("721a4c132673e957").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("f3d90b8be1dc9038");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"721a4c132673e957":"8EcTH","f3d90b8be1dc9038":"hj069"}],"lpDnK":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"hGIMb":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"ewPHx":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"5XWC3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("418d1b4dc54207be");
(0, tslib_1.__exportStar)(require("6982378e65309145"), exports);

},{"418d1b4dc54207be":"455wm","6982378e65309145":"dps21"}],"455wm":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dps21":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("ab77c912e1099c27");
var constants_1 = require("ce9cc4978892bad6");
var RawSha256_1 = require("ea4a3f6061c5aada");
var util_1 = require("ec7e02f81b214b94");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"ab77c912e1099c27":"455wm","ce9cc4978892bad6":"cAkMN","ea4a3f6061c5aada":"YFvwW","ec7e02f81b214b94":"ciXEi"}],"cAkMN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"YFvwW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("36bcd02814e436e3");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"36bcd02814e436e3":"cAkMN"}],"8qBxJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("d4ba5b9f002454df");
tslib_1.__exportStar(require("42b6a840a4585dcd"), exports);

},{"d4ba5b9f002454df":"7bnNi","42b6a840a4585dcd":"7z148"}],"7bnNi":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7z148":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("467da325f4507076");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"467da325f4507076":"7bnNi"}],"6K9Fu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("4e93ca2400d71317");
tslib_1.__exportStar(require("f6df223ac5240f29"), exports);
tslib_1.__exportStar(require("c68313cfb7180b41"), exports);
tslib_1.__exportStar(require("46c26437e48ef7b3"), exports);
tslib_1.__exportStar(require("903a910efecb3acb"), exports);
tslib_1.__exportStar(require("bea87aa20e4b99bd"), exports);

},{"4e93ca2400d71317":"fiasr","f6df223ac5240f29":"5j1rm","c68313cfb7180b41":"giVaX","46c26437e48ef7b3":"sG1KN","903a910efecb3acb":"kCfn0","bea87aa20e4b99bd":"5RirK"}],"fiasr":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5j1rm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"giVaX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"sG1KN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"kCfn0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"5RirK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"kYxzk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"iLWKn","./stream-collector":"aVf85","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iLWKn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","@aws-sdk/querystring-builder":"gom3U","./request-timeout":"8ThF3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gom3U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"ll1a4","@aws-sdk/util-uri-escape":"egTf1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8ThF3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aVf85":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"ll1a4","@aws-sdk/util-base64-browser":"17TK0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"17TK0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4B3CJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"8XDpQ","./invalidProvider":"1wT8e","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8XDpQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", ()=>invalidFunction);
var invalidFunction = function(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1wT8e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", ()=>invalidProvider);
var invalidProvider = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9sw5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"kTW1S","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kTW1S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", ()=>calculateBodyLength);
var calculateBodyLength = function(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fdFgF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"ll1a4","bowser":"oLvzi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4neXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2016-11-28",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Lex Runtime Service",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"8TGsV","./endpoints":"luVNb","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8TGsV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function(url) {
    if (typeof url === "string") return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"1hdJc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1hdJc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"luVNb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {
    "us-east-1": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-east-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-gov-west-1": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-gov-west-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-west-2": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-west-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    }
};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-1-fips",
            "us-east-2",
            "us-west-1",
            "us-west-2",
            "us-west-2-fips"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-fips.lex.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1",
            "us-gov-west-1-fips"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-fips.lex.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "lex",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"ll1a4","@aws-sdk/config-resolver":"lUWM9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"94fY5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resolveDefaultsModeConfig = require("./resolveDefaultsModeConfig");
parcelHelpers.exportAll(_resolveDefaultsModeConfig, exports);

},{"./resolveDefaultsModeConfig":"ikJFh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ikJFh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveDefaultsModeConfig", ()=>resolveDefaultsModeConfig);
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var _constants = require("./constants");
var resolveDefaultsModeConfig = function(_a) {
    var _b = _a === void 0 ? {} : _a, defaultsMode = _b.defaultsMode;
    return (0, _propertyProvider.memoize)(function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var mode, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof defaultsMode === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            defaultsMode()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _a = defaultsMode;
                        _b.label = 3;
                    case 3:
                        mode = _a;
                        switch(mode === null || mode === void 0 ? void 0 : mode.toLowerCase()){
                            case "auto":
                                return [
                                    2,
                                    Promise.resolve(isMobileBrowser() ? "mobile" : "standard")
                                ];
                            case "mobile":
                            case "in-region":
                            case "cross-region":
                            case "standard":
                            case "legacy":
                                return [
                                    2,
                                    Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase())
                                ];
                            case undefined:
                                return [
                                    2,
                                    Promise.resolve("legacy")
                                ];
                            default:
                                throw new Error('Invalid parameter for "defaultsMode", expect '.concat((0, _constants.DEFAULTS_MODE_OPTIONS).join(", "), ", got ").concat(mode));
                        }
                        return [
                            2
                        ];
                }
            });
        });
    });
};
var isMobileBrowser = function() {
    var _a, _b;
    var parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
    var platform = (_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.platform) === null || _b === void 0 ? void 0 : _b.type;
    return platform === "tablet" || platform === "mobile";
};

},{"tslib":"a7cfK","@aws-sdk/property-provider":"6UZLH","bowser":"oLvzi","./constants":"1uNCD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a7cfK":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6UZLH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"g5E3e","./ProviderError":"8Hds6","./TokenProviderError":"h3Jy9","./chain":"cmpgo","./fromStatic":"9CA2O","./memoize":"kTUqB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g5E3e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", ()=>CredentialsProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"a7cfK","./ProviderError":"8Hds6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8Hds6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", ()=>ProviderError);
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"a7cfK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h3Jy9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", ()=>TokenProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"a7cfK","./ProviderError":"8Hds6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cmpgo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"a7cfK","./ProviderError":"8Hds6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9CA2O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", ()=>fromStatic);
var fromStatic = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kTUqB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
var _tslib = require("tslib");
var memoize = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"a7cfK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1uNCD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULTS_MODE_OPTIONS", ()=>DEFAULTS_MODE_OPTIONS);
var DEFAULTS_MODE_OPTIONS = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dGZeq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deleteSessionCommand = require("./DeleteSessionCommand");
parcelHelpers.exportAll(_deleteSessionCommand, exports);
var _getSessionCommand = require("./GetSessionCommand");
parcelHelpers.exportAll(_getSessionCommand, exports);
var _postContentCommand = require("./PostContentCommand");
parcelHelpers.exportAll(_postContentCommand, exports);
var _postTextCommand = require("./PostTextCommand");
parcelHelpers.exportAll(_postTextCommand, exports);
var _putSessionCommand = require("./PutSessionCommand");
parcelHelpers.exportAll(_putSessionCommand, exports);

},{"./DeleteSessionCommand":false,"./GetSessionCommand":false,"./PostContentCommand":"6fDPM","./PostTextCommand":"ecUPR","./PutSessionCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6fDPM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostContentCommand", ()=>PostContentCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var PostContentCommand = function(_super) {
    (0, _tslib.__extends)(PostContentCommand, _super);
    function PostContentCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PostContentCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeServiceClient";
        var commandName = "PostContentCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PostContentRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.PostContentResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostContentCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PostContentCommand)(input, context);
    };
    PostContentCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PostContentCommand)(output, context);
    };
    return PostContentCommand;
}((0, _smithyClient.Command));

},{"tslib":"ll1a4","@aws-sdk/middleware-serde":"fQBjA","@aws-sdk/smithy-client":"fD3TM","../models/models_0":"jcrmn","../protocols/Aws_restJson1":"dto3r","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fQBjA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"g8iVq","./serdePlugin":"6ZFJ4","./serializerMiddleware":"2EuFl","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g8iVq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", ()=>deserializerMiddleware);
var _tslib = require("tslib");
var deserializerMiddleware = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6ZFJ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", ()=>deserializerMiddlewareOption);
parcelHelpers.export(exports, "serializerMiddlewareOption", ()=>serializerMiddlewareOption);
parcelHelpers.export(exports, "getSerdePlugin", ()=>getSerdePlugin);
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"g8iVq","./serializerMiddleware":"2EuFl","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2EuFl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", ()=>serializerMiddleware);
var _tslib = require("tslib");
var serializerMiddleware = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"ll1a4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jcrmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadRequestException", ()=>BadRequestException);
parcelHelpers.export(exports, "ConflictException", ()=>ConflictException);
parcelHelpers.export(exports, "InternalFailureException", ()=>InternalFailureException);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "NotFoundException", ()=>NotFoundException);
parcelHelpers.export(exports, "FulfillmentState", ()=>FulfillmentState);
parcelHelpers.export(exports, "MessageFormatType", ()=>MessageFormatType);
parcelHelpers.export(exports, "DialogActionType", ()=>DialogActionType);
parcelHelpers.export(exports, "ConfirmationStatus", ()=>ConfirmationStatus);
parcelHelpers.export(exports, "BadGatewayException", ()=>BadGatewayException);
parcelHelpers.export(exports, "DependencyFailedException", ()=>DependencyFailedException);
parcelHelpers.export(exports, "LoopDetectedException", ()=>LoopDetectedException);
parcelHelpers.export(exports, "NotAcceptableException", ()=>NotAcceptableException);
parcelHelpers.export(exports, "DialogState", ()=>DialogState);
parcelHelpers.export(exports, "RequestTimeoutException", ()=>RequestTimeoutException);
parcelHelpers.export(exports, "UnsupportedMediaTypeException", ()=>UnsupportedMediaTypeException);
parcelHelpers.export(exports, "ContentType", ()=>ContentType);
parcelHelpers.export(exports, "ActiveContextTimeToLiveFilterSensitiveLog", ()=>ActiveContextTimeToLiveFilterSensitiveLog);
parcelHelpers.export(exports, "ActiveContextFilterSensitiveLog", ()=>ActiveContextFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteSessionRequestFilterSensitiveLog", ()=>DeleteSessionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteSessionResponseFilterSensitiveLog", ()=>DeleteSessionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetSessionRequestFilterSensitiveLog", ()=>GetSessionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DialogActionFilterSensitiveLog", ()=>DialogActionFilterSensitiveLog);
parcelHelpers.export(exports, "IntentSummaryFilterSensitiveLog", ()=>IntentSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "GetSessionResponseFilterSensitiveLog", ()=>GetSessionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PostContentRequestFilterSensitiveLog", ()=>PostContentRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PostContentResponseFilterSensitiveLog", ()=>PostContentResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PostTextRequestFilterSensitiveLog", ()=>PostTextRequestFilterSensitiveLog);
parcelHelpers.export(exports, "IntentConfidenceFilterSensitiveLog", ()=>IntentConfidenceFilterSensitiveLog);
parcelHelpers.export(exports, "PredictedIntentFilterSensitiveLog", ()=>PredictedIntentFilterSensitiveLog);
parcelHelpers.export(exports, "ButtonFilterSensitiveLog", ()=>ButtonFilterSensitiveLog);
parcelHelpers.export(exports, "GenericAttachmentFilterSensitiveLog", ()=>GenericAttachmentFilterSensitiveLog);
parcelHelpers.export(exports, "ResponseCardFilterSensitiveLog", ()=>ResponseCardFilterSensitiveLog);
parcelHelpers.export(exports, "SentimentResponseFilterSensitiveLog", ()=>SentimentResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PostTextResponseFilterSensitiveLog", ()=>PostTextResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PutSessionRequestFilterSensitiveLog", ()=>PutSessionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PutSessionResponseFilterSensitiveLog", ()=>PutSessionResponseFilterSensitiveLog);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeServiceServiceException = require("./LexRuntimeServiceServiceException");
var BadRequestException = function(_super) {
    (0, _tslib.__extends)(BadRequestException, _super);
    function BadRequestException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadRequestException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "BadRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BadRequestException.prototype);
        return _this;
    }
    return BadRequestException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        return _this;
    }
    return ConflictException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var InternalFailureException = function(_super) {
    (0, _tslib.__extends)(InternalFailureException, _super);
    function InternalFailureException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalFailureException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalFailureException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalFailureException.prototype);
        return _this;
    }
    return InternalFailureException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var LimitExceededException = function(_super) {
    (0, _tslib.__extends)(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "LimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        _this.retryAfterSeconds = opts.retryAfterSeconds;
        return _this;
    }
    return LimitExceededException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var NotFoundException = function(_super) {
    (0, _tslib.__extends)(NotFoundException, _super);
    function NotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "NotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotFoundException.prototype);
        return _this;
    }
    return NotFoundException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var FulfillmentState;
(function(FulfillmentState) {
    FulfillmentState["FAILED"] = "Failed";
    FulfillmentState["FULFILLED"] = "Fulfilled";
    FulfillmentState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(FulfillmentState || (FulfillmentState = {}));
var MessageFormatType;
(function(MessageFormatType) {
    MessageFormatType["COMPOSITE"] = "Composite";
    MessageFormatType["CUSTOM_PAYLOAD"] = "CustomPayload";
    MessageFormatType["PLAIN_TEXT"] = "PlainText";
    MessageFormatType["SSML"] = "SSML";
})(MessageFormatType || (MessageFormatType = {}));
var DialogActionType;
(function(DialogActionType) {
    DialogActionType["CLOSE"] = "Close";
    DialogActionType["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogActionType["DELEGATE"] = "Delegate";
    DialogActionType["ELICIT_INTENT"] = "ElicitIntent";
    DialogActionType["ELICIT_SLOT"] = "ElicitSlot";
})(DialogActionType || (DialogActionType = {}));
var ConfirmationStatus;
(function(ConfirmationStatus) {
    ConfirmationStatus["CONFIRMED"] = "Confirmed";
    ConfirmationStatus["DENIED"] = "Denied";
    ConfirmationStatus["NONE"] = "None";
})(ConfirmationStatus || (ConfirmationStatus = {}));
var BadGatewayException = function(_super) {
    (0, _tslib.__extends)(BadGatewayException, _super);
    function BadGatewayException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadGatewayException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "BadGatewayException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, BadGatewayException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return BadGatewayException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var DependencyFailedException = function(_super) {
    (0, _tslib.__extends)(DependencyFailedException, _super);
    function DependencyFailedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "DependencyFailedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "DependencyFailedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DependencyFailedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return DependencyFailedException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var LoopDetectedException = function(_super) {
    (0, _tslib.__extends)(LoopDetectedException, _super);
    function LoopDetectedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "LoopDetectedException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "LoopDetectedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, LoopDetectedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return LoopDetectedException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var NotAcceptableException = function(_super) {
    (0, _tslib.__extends)(NotAcceptableException, _super);
    function NotAcceptableException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "NotAcceptableException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotAcceptableException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotAcceptableException.prototype);
        return _this;
    }
    return NotAcceptableException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var DialogState;
(function(DialogState) {
    DialogState["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogState["ELICIT_INTENT"] = "ElicitIntent";
    DialogState["ELICIT_SLOT"] = "ElicitSlot";
    DialogState["FAILED"] = "Failed";
    DialogState["FULFILLED"] = "Fulfilled";
    DialogState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(DialogState || (DialogState = {}));
var RequestTimeoutException = function(_super) {
    (0, _tslib.__extends)(RequestTimeoutException, _super);
    function RequestTimeoutException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "RequestTimeoutException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "RequestTimeoutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RequestTimeoutException.prototype);
        return _this;
    }
    return RequestTimeoutException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var UnsupportedMediaTypeException = function(_super) {
    (0, _tslib.__extends)(UnsupportedMediaTypeException, _super);
    function UnsupportedMediaTypeException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "UnsupportedMediaTypeException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "UnsupportedMediaTypeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UnsupportedMediaTypeException.prototype);
        return _this;
    }
    return UnsupportedMediaTypeException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var ContentType;
(function(ContentType) {
    ContentType["GENERIC"] = "application/vnd.amazonaws.card.generic";
})(ContentType || (ContentType = {}));
var ActiveContextTimeToLiveFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ActiveContextFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.parameters && {
        parameters: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var DeleteSessionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteSessionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetSessionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DialogActionFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var IntentSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GetSessionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.recentIntentSummaryView && {
        recentIntentSummaryView: obj.recentIntentSummaryView.map(function(item) {
            return IntentSummaryFilterSensitiveLog(item);
        })
    }), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.dialogAction && {
        dialogAction: DialogActionFilterSensitiveLog(obj.dialogAction)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostContentRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostContentResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedMessage && {
        encodedMessage: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedInputTranscript && {
        encodedInputTranscript: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostTextRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.inputText && {
        inputText: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var IntentConfidenceFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PredictedIntentFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var ButtonFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GenericAttachmentFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ResponseCardFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SentimentResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PostTextResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.alternativeIntents && {
        alternativeIntents: obj.alternativeIntents.map(function(item) {
            return PredictedIntentFilterSensitiveLog(item);
        })
    }), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PutSessionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.dialogAction && {
        dialogAction: DialogActionFilterSensitiveLog(obj.dialogAction)
    }), obj.recentIntentSummaryView && {
        recentIntentSummaryView: obj.recentIntentSummaryView.map(function(item) {
            return IntentSummaryFilterSensitiveLog(item);
        })
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PutSessionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedMessage && {
        encodedMessage: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};

},{"tslib":"ll1a4","@aws-sdk/smithy-client":"fD3TM","./LexRuntimeServiceServiceException":"9SnBI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9SnBI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceServiceException", ()=>LexRuntimeServiceServiceException);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LexRuntimeServiceServiceException = function(_super) {
    (0, _tslib.__extends)(LexRuntimeServiceServiceException, _super);
    function LexRuntimeServiceServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LexRuntimeServiceServiceException.prototype);
        return _this;
    }
    return LexRuntimeServiceServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"ll1a4","@aws-sdk/smithy-client":"fD3TM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dto3r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteSessionCommand", ()=>serializeAws_restJson1DeleteSessionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetSessionCommand", ()=>serializeAws_restJson1GetSessionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PostContentCommand", ()=>serializeAws_restJson1PostContentCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PostTextCommand", ()=>serializeAws_restJson1PostTextCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutSessionCommand", ()=>serializeAws_restJson1PutSessionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteSessionCommand", ()=>deserializeAws_restJson1DeleteSessionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetSessionCommand", ()=>deserializeAws_restJson1GetSessionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PostContentCommand", ()=>deserializeAws_restJson1PostContentCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PostTextCommand", ()=>deserializeAws_restJson1PostTextCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutSessionCommand", ()=>deserializeAws_restJson1PutSessionCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeServiceServiceException = require("../models/LexRuntimeServiceServiceException");
var _models0 = require("../models/models_0");
var Buffer = require("140ff1ec17a71939").Buffer;
var serializeAws_restJson1DeleteSessionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetSessionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    query = map({
                        checkpointLabelFilter: [
                            ,
                            input.checkpointLabelFilter
                        ]
                    });
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PostContentCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
                        "content-type": input.contentType || "application/octet-stream",
                        "x-amz-lex-session-attributes": [
                            function() {
                                return isSerializableHeaderValue(input.sessionAttributes);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.sessionAttributes)));
                            }
                        ],
                        "x-amz-lex-request-attributes": [
                            function() {
                                return isSerializableHeaderValue(input.requestAttributes);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.requestAttributes)));
                            }
                        ],
                        accept: input.accept,
                        "x-amz-lex-active-contexts": [
                            function() {
                                return isSerializableHeaderValue(input.activeContexts);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.activeContexts)));
                            }
                        ]
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/content";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    if (input.inputStream !== undefined) body = input.inputStream;
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PostTextCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
                        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
                    }), input.inputText != null && {
                        inputText: input.inputText
                    }), input.requestAttributes != null && {
                        requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
                    }), input.sessionAttributes != null && {
                        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutSessionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "content-type": "application/json",
                        accept: input.accept
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
                        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
                    }), input.dialogAction != null && {
                        dialogAction: serializeAws_restJson1DialogAction(input.dialogAction, context)
                    }), input.recentIntentSummaryView != null && {
                        recentIntentSummaryView: serializeAws_restJson1IntentSummaryList(input.recentIntentSummaryView, context)
                    }), input.sessionAttributes != null && {
                        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.botAlias != null) contents.botAlias = (0, _smithyClient.expectString)(data.botAlias);
                    if (data.botName != null) contents.botName = (0, _smithyClient.expectString)(data.botName);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.userId != null) contents.userId = (0, _smithyClient.expectString)(data.userId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.activeContexts != null) contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
                    if (data.dialogAction != null) contents.dialogAction = deserializeAws_restJson1DialogAction(data.dialogAction, context);
                    if (data.recentIntentSummaryView != null) contents.recentIntentSummaryView = deserializeAws_restJson1IntentSummaryList(data.recentIntentSummaryView, context);
                    if (data.sessionAttributes != null) contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostContentCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PostContentCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                intentName: [
                    ,
                    output.headers["x-amz-lex-intent-name"]
                ],
                nluIntentConfidence: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-nlu-intent-confidence"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-nlu-intent-confidence"])).toString("utf8"));
                    }
                ],
                alternativeIntents: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-alternative-intents"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-alternative-intents"])).toString("utf8"));
                    }
                ],
                slots: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-slots"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
                    }
                ],
                sessionAttributes: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-session-attributes"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
                    }
                ],
                sentimentResponse: [
                    ,
                    output.headers["x-amz-lex-sentiment"]
                ],
                message: [
                    ,
                    output.headers["x-amz-lex-message"]
                ],
                encodedMessage: [
                    ,
                    output.headers["x-amz-lex-encoded-message"]
                ],
                messageFormat: [
                    ,
                    output.headers["x-amz-lex-message-format"]
                ],
                dialogState: [
                    ,
                    output.headers["x-amz-lex-dialog-state"]
                ],
                slotToElicit: [
                    ,
                    output.headers["x-amz-lex-slot-to-elicit"]
                ],
                inputTranscript: [
                    ,
                    output.headers["x-amz-lex-input-transcript"]
                ],
                encodedInputTranscript: [
                    ,
                    output.headers["x-amz-lex-encoded-input-transcript"]
                ],
                botVersion: [
                    ,
                    output.headers["x-amz-lex-bot-version"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                activeContexts: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-active-contexts"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
                    }
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PostContentCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "NotAcceptableException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotAcceptableException":
                            return [
                                3,
                                16
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                18
                            ];
                        case "RequestTimeoutException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.lexruntimeservice#RequestTimeoutException":
                            return [
                                3,
                                20
                            ];
                        case "UnsupportedMediaTypeException":
                            return [
                                3,
                                22
                            ];
                        case "com.amazonaws.lexruntimeservice#UnsupportedMediaTypeException":
                            return [
                                3,
                                22
                            ];
                    }
                    return [
                        3,
                        24
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    throw _d.sent();
                case 20:
                    return [
                        4,
                        deserializeAws_restJson1RequestTimeoutExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    throw _d.sent();
                case 22:
                    return [
                        4,
                        deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse(parsedOutput, context)
                    ];
                case 23:
                    throw _d.sent();
                case 24:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 25;
                case 25:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostTextCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1PostTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.activeContexts != null) contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
                    if (data.alternativeIntents != null) contents.alternativeIntents = deserializeAws_restJson1IntentList(data.alternativeIntents, context);
                    if (data.botVersion != null) contents.botVersion = (0, _smithyClient.expectString)(data.botVersion);
                    if (data.dialogState != null) contents.dialogState = (0, _smithyClient.expectString)(data.dialogState);
                    if (data.intentName != null) contents.intentName = (0, _smithyClient.expectString)(data.intentName);
                    if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
                    if (data.messageFormat != null) contents.messageFormat = (0, _smithyClient.expectString)(data.messageFormat);
                    if (data.nluIntentConfidence != null) contents.nluIntentConfidence = deserializeAws_restJson1IntentConfidence(data.nluIntentConfidence, context);
                    if (data.responseCard != null) contents.responseCard = deserializeAws_restJson1ResponseCard(data.responseCard, context);
                    if (data.sentimentResponse != null) contents.sentimentResponse = deserializeAws_restJson1SentimentResponse(data.sentimentResponse, context);
                    if (data.sessionAttributes != null) contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.slotToElicit != null) contents.slotToElicit = (0, _smithyClient.expectString)(data.slotToElicit);
                    if (data.slots != null) contents.slots = deserializeAws_restJson1StringMap(data.slots, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostTextCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutSessionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PutSessionCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                intentName: [
                    ,
                    output.headers["x-amz-lex-intent-name"]
                ],
                slots: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-slots"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
                    }
                ],
                sessionAttributes: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-session-attributes"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
                    }
                ],
                message: [
                    ,
                    output.headers["x-amz-lex-message"]
                ],
                encodedMessage: [
                    ,
                    output.headers["x-amz-lex-encoded-message"]
                ],
                messageFormat: [
                    ,
                    output.headers["x-amz-lex-message-format"]
                ],
                dialogState: [
                    ,
                    output.headers["x-amz-lex-dialog-state"]
                ],
                slotToElicit: [
                    ,
                    output.headers["x-amz-lex-slot-to-elicit"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                activeContexts: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-active-contexts"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
                    }
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PutSessionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "NotAcceptableException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#NotAcceptableException":
                            return [
                                3,
                                14
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1BadGatewayExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.BadGatewayException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1BadRequestExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.BadRequestException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1DependencyFailedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.DependencyFailedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalFailureExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalFailureException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({
                retryAfterSeconds: [
                    ,
                    parsedOutput.headers["retry-after"]
                ]
            });
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.LimitExceededException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1LoopDetectedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.LoopDetectedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1NotAcceptableExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.NotAcceptableException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1NotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.NotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1RequestTimeoutExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.RequestTimeoutException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.UnsupportedMediaTypeException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1ActiveContext = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.name != null && {
        name: input.name
    }), input.parameters != null && {
        parameters: serializeAws_restJson1ActiveContextParametersMap(input.parameters, context)
    }), input.timeToLive != null && {
        timeToLive: serializeAws_restJson1ActiveContextTimeToLive(input.timeToLive, context)
    });
};
var serializeAws_restJson1ActiveContextParametersMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1ActiveContextsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1ActiveContext(entry, context);
    });
};
var serializeAws_restJson1ActiveContextTimeToLive = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.timeToLiveInSeconds != null && {
        timeToLiveInSeconds: input.timeToLiveInSeconds
    }), input.turnsToLive != null && {
        turnsToLive: input.turnsToLive
    });
};
var serializeAws_restJson1DialogAction = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.fulfillmentState != null && {
        fulfillmentState: input.fulfillmentState
    }), input.intentName != null && {
        intentName: input.intentName
    }), input.message != null && {
        message: input.message
    }), input.messageFormat != null && {
        messageFormat: input.messageFormat
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.slots != null && {
        slots: serializeAws_restJson1StringMap(input.slots, context)
    }), input.type != null && {
        type: input.type
    });
};
var serializeAws_restJson1IntentSummary = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.checkpointLabel != null && {
        checkpointLabel: input.checkpointLabel
    }), input.confirmationStatus != null && {
        confirmationStatus: input.confirmationStatus
    }), input.dialogActionType != null && {
        dialogActionType: input.dialogActionType
    }), input.fulfillmentState != null && {
        fulfillmentState: input.fulfillmentState
    }), input.intentName != null && {
        intentName: input.intentName
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.slots != null && {
        slots: serializeAws_restJson1StringMap(input.slots, context)
    });
};
var serializeAws_restJson1IntentSummaryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1IntentSummary(entry, context);
    });
};
var serializeAws_restJson1StringMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_restJson1ActiveContext = function(output, context) {
    return {
        name: (0, _smithyClient.expectString)(output.name),
        parameters: output.parameters != null ? deserializeAws_restJson1ActiveContextParametersMap(output.parameters, context) : undefined,
        timeToLive: output.timeToLive != null ? deserializeAws_restJson1ActiveContextTimeToLive(output.timeToLive, context) : undefined
    };
};
var deserializeAws_restJson1ActiveContextParametersMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1ActiveContextsList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ActiveContext(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ActiveContextTimeToLive = function(output, context) {
    return {
        timeToLiveInSeconds: (0, _smithyClient.expectInt32)(output.timeToLiveInSeconds),
        turnsToLive: (0, _smithyClient.expectInt32)(output.turnsToLive)
    };
};
var deserializeAws_restJson1Button = function(output, context) {
    return {
        text: (0, _smithyClient.expectString)(output.text),
        value: (0, _smithyClient.expectString)(output.value)
    };
};
var deserializeAws_restJson1DialogAction = function(output, context) {
    return {
        fulfillmentState: (0, _smithyClient.expectString)(output.fulfillmentState),
        intentName: (0, _smithyClient.expectString)(output.intentName),
        message: (0, _smithyClient.expectString)(output.message),
        messageFormat: (0, _smithyClient.expectString)(output.messageFormat),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined,
        type: (0, _smithyClient.expectString)(output.type)
    };
};
var deserializeAws_restJson1GenericAttachment = function(output, context) {
    return {
        attachmentLinkUrl: (0, _smithyClient.expectString)(output.attachmentLinkUrl),
        buttons: output.buttons != null ? deserializeAws_restJson1listOfButtons(output.buttons, context) : undefined,
        imageUrl: (0, _smithyClient.expectString)(output.imageUrl),
        subTitle: (0, _smithyClient.expectString)(output.subTitle),
        title: (0, _smithyClient.expectString)(output.title)
    };
};
var deserializeAws_restJson1genericAttachmentList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1GenericAttachment(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1IntentConfidence = function(output, context) {
    return {
        score: (0, _smithyClient.limitedParseDouble)(output.score)
    };
};
var deserializeAws_restJson1IntentList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1PredictedIntent(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1IntentSummary = function(output, context) {
    return {
        checkpointLabel: (0, _smithyClient.expectString)(output.checkpointLabel),
        confirmationStatus: (0, _smithyClient.expectString)(output.confirmationStatus),
        dialogActionType: (0, _smithyClient.expectString)(output.dialogActionType),
        fulfillmentState: (0, _smithyClient.expectString)(output.fulfillmentState),
        intentName: (0, _smithyClient.expectString)(output.intentName),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined
    };
};
var deserializeAws_restJson1IntentSummaryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1IntentSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1listOfButtons = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Button(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PredictedIntent = function(output, context) {
    return {
        intentName: (0, _smithyClient.expectString)(output.intentName),
        nluIntentConfidence: output.nluIntentConfidence != null ? deserializeAws_restJson1IntentConfidence(output.nluIntentConfidence, context) : undefined,
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined
    };
};
var deserializeAws_restJson1ResponseCard = function(output, context) {
    return {
        contentType: (0, _smithyClient.expectString)(output.contentType),
        genericAttachments: output.genericAttachments != null ? deserializeAws_restJson1genericAttachmentList(output.genericAttachments, context) : undefined,
        version: (0, _smithyClient.expectString)(output.version)
    };
};
var deserializeAws_restJson1SentimentResponse = function(output, context) {
    return {
        sentimentLabel: (0, _smithyClient.expectString)(output.sentimentLabel),
        sentimentScore: (0, _smithyClient.expectString)(output.sentimentScore)
    };
};
var deserializeAws_restJson1StringMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeMetadata = function(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"140ff1ec17a71939":"8EcTH","tslib":"ll1a4","@aws-sdk/protocol-http":"3Xi1q","@aws-sdk/smithy-client":"fD3TM","../models/LexRuntimeServiceServiceException":"9SnBI","../models/models_0":"jcrmn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ecUPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostTextCommand", ()=>PostTextCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var PostTextCommand = function(_super) {
    (0, _tslib.__extends)(PostTextCommand, _super);
    function PostTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PostTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeServiceClient";
        var commandName = "PostTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PostTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.PostTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PostTextCommand)(input, context);
    };
    PostTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PostTextCommand)(output, context);
    };
    return PostTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"ll1a4","@aws-sdk/middleware-serde":"fQBjA","@aws-sdk/smithy-client":"fD3TM","../models/models_0":"jcrmn","../protocols/Aws_restJson1":"dto3r","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"59VeJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", ()=>convert);
parcelHelpers.export(exports, "base64ToArrayBuffer", ()=>base64ToArrayBuffer);
parcelHelpers.export(exports, "gzipDecompressToString", ()=>gzipDecompressToString);
var _tslib = require("tslib");
var _fflate = require("fflate");
var convert = function(stream) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            if (stream instanceof Blob || stream instanceof ReadableStream) return [
                2 /*return*/ ,
                new Response(stream).arrayBuffer().then(function(buffer) {
                    return new Uint8Array(buffer);
                })
            ];
            else return [
                2 /*return*/ ,
                Promise.reject("Invalid content type")
            ];
            return [
                2 /*return*/ 
            ];
        });
    });
};
var base64ToArrayBuffer = function(base64) {
    return Uint8Array.from(window.atob(base64), function(c) {
        return c.charCodeAt(0);
    });
};
var gzipDecompressToString = function(data) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve, reject) {
                            (0, _fflate.gunzip)(data, function(err, resp) {
                                if (err) reject(err);
                                else resolve((0, _fflate.strFromU8)(resp));
                            });
                        })
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
};

},{"tslib":"9gMVn","fflate":"fAdED","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fAdED":[function(require,module,exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlateErrorCode", ()=>FlateErrorCode);
parcelHelpers.export(exports, "Deflate", ()=>Deflate);
parcelHelpers.export(exports, "AsyncDeflate", ()=>AsyncDeflate);
parcelHelpers.export(exports, "deflate", ()=>deflate);
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ parcelHelpers.export(exports, "deflateSync", ()=>deflateSync);
parcelHelpers.export(exports, "Inflate", ()=>Inflate);
parcelHelpers.export(exports, "AsyncInflate", ()=>AsyncInflate);
parcelHelpers.export(exports, "inflate", ()=>inflate);
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "inflateSync", ()=>inflateSync);
parcelHelpers.export(exports, "Gzip", ()=>Gzip);
parcelHelpers.export(exports, "AsyncGzip", ()=>AsyncGzip);
parcelHelpers.export(exports, "gzip", ()=>gzip);
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ parcelHelpers.export(exports, "gzipSync", ()=>gzipSync);
parcelHelpers.export(exports, "Gunzip", ()=>Gunzip);
parcelHelpers.export(exports, "AsyncGunzip", ()=>AsyncGunzip);
parcelHelpers.export(exports, "gunzip", ()=>gunzip);
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "gunzipSync", ()=>gunzipSync);
parcelHelpers.export(exports, "Zlib", ()=>Zlib);
parcelHelpers.export(exports, "AsyncZlib", ()=>AsyncZlib);
parcelHelpers.export(exports, "zlib", ()=>zlib);
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ parcelHelpers.export(exports, "zlibSync", ()=>zlibSync);
parcelHelpers.export(exports, "Unzlib", ()=>Unzlib);
parcelHelpers.export(exports, "AsyncUnzlib", ()=>AsyncUnzlib);
parcelHelpers.export(exports, "unzlib", ()=>unzlib);
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "unzlibSync", ()=>unzlibSync);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compress", ()=>gzip);
parcelHelpers.export(exports, "AsyncCompress", ()=>AsyncGzip);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compressSync", ()=>gzipSync);
parcelHelpers.export(exports, "Compress", ()=>Gzip);
parcelHelpers.export(exports, "Decompress", ()=>Decompress);
parcelHelpers.export(exports, "AsyncDecompress", ()=>AsyncDecompress);
parcelHelpers.export(exports, "decompress", ()=>decompress);
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "decompressSync", ()=>decompressSync);
parcelHelpers.export(exports, "DecodeUTF8", ()=>DecodeUTF8);
parcelHelpers.export(exports, "EncodeUTF8", ()=>EncodeUTF8);
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ parcelHelpers.export(exports, "strToU8", ()=>strToU8);
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ parcelHelpers.export(exports, "strFromU8", ()=>strFromU8);
parcelHelpers.export(exports, "ZipPassThrough", ()=>ZipPassThrough);
parcelHelpers.export(exports, "ZipDeflate", ()=>ZipDeflate);
parcelHelpers.export(exports, "AsyncZipDeflate", ()=>AsyncZipDeflate);
parcelHelpers.export(exports, "Zip", ()=>Zip);
parcelHelpers.export(exports, "zip", ()=>zip);
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ parcelHelpers.export(exports, "zipSync", ()=>zipSync);
parcelHelpers.export(exports, "UnzipPassThrough", ()=>UnzipPassThrough);
parcelHelpers.export(exports, "UnzipInflate", ()=>UnzipInflate);
parcelHelpers.export(exports, "AsyncUnzipInflate", ()=>AsyncUnzipInflate);
parcelHelpers.export(exports, "Unzip", ()=>Unzip);
parcelHelpers.export(exports, "unzip", ()=>unzip);
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ parcelHelpers.export(exports, "unzipSync", ()=>unzipSync);
var ch2 = {};
var wk = function(c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: "text/javascript"
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err["code"] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var freb = function(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for(var i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[rev[v] >>> rvb] = sv;
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for(var i = 0; i < 144; ++i)flt[i] = 8;
for(var i = 144; i < 256; ++i)flt[i] = 9;
for(var i = 256; i < 280; ++i)flt[i] = 7;
for(var i = 280; i < 288; ++i)flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for(var i = 0; i < 32; ++i)fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? u16 : v.BYTES_PER_ELEMENT == 4 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
];
var err = function(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) err(0);
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else err(1);
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
            if (!c) err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        et,
        0
    ];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var ln = function(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
        var dst = syms[i] & 31;
        wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e >= s) // write final block
        w[pos >> 3] = lst;
        pos = wfblk(w, pos + 1, dat.subarray(i, e));
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = wfblk(w, pos + 1, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var dopt = function(dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf("[") + 1, st.lastIndexOf("]")).replace(/\s+/g, "").split(",");
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == "function") {
            fnStr += ";" + k + "=";
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf("[native code]") != -1) {
                    var spInd = st_1.indexOf(" ", 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf("(", spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ";" + k + ".prototype." + t + "=" + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var ch = [];
// clone bufs
var cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var wrkr = function(fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = "", td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + init.toString() + "}", id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        fl,
        fd,
        flrm,
        fdrm,
        rev,
        ec,
        hMap,
        max,
        bits,
        bits16,
        shft,
        slc,
        err,
        inflt,
        inflateSync,
        pbf,
        gu8
    ];
};
var bDflt = function() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        revfl,
        revfd,
        flm,
        flt,
        fdm,
        fdt,
        rev,
        deo,
        et,
        hMap,
        wbits,
        wbits16,
        hTree,
        ln,
        lc,
        clen,
        wfblk,
        wblk,
        shft,
        slc,
        dflt,
        dopt,
        deflateSync,
        pbf
    ];
};
// gzip extra
var gze = function() {
    return [
        gzh,
        gzhl,
        wbytes,
        crc,
        crct
    ];
};
// gunzip extra
var guze = function() {
    return [
        gzs,
        gzl
    ];
};
// zlib extra
var zle = function() {
    return [
        zlh,
        wbytes,
        adler
    ];
};
// unzlib extra
var zule = function() {
    return [
        zlv
    ];
};
// post buf
var pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var gu8 = function(o) {
    return o && o.size && new u8(o.size);
};
// async helper
var cbify = function(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) err(5);
        if (t) strm.ondata(err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, "invalid gzip data");
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, "invalid zlib data");
    if (d[1] & 32) err(6, "invalid zlib data: preset dictionaries not supported");
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == "function") cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == "function") cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function() {
                return [
                    astrm,
                    Deflate
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt
    ], function(ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function() {
                return [
                    astrm,
                    Inflate
                ];
            }
        ], this, 0, function() {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt
    ], function(ev) {
        return pbf(inflateSync(ev.data[0], gu8(ev.data[1])));
    }, 1, cb);
}
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function() {
                return [
                    astrm,
                    Deflate,
                    Gzip
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function() {
            return [
                gzipSync
            ];
        }
    ], function(ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) err(6, "invalid gzip data");
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function() {
                return [
                    astrm,
                    Inflate,
                    Gunzip
                ];
            }
        ], this, 0, function() {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function() {
            return [
                gunzipSync
            ];
        }
    ], function(ev) {
        return pbf(gunzipSync(ev.data[0]));
    }, 3, cb);
}
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function() {
                return [
                    astrm,
                    Deflate,
                    Zlib
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function() {
            return [
                zlibSync
            ];
        }
    ], function(ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) err(6, "invalid zlib data");
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function() {
                return [
                    astrm,
                    Inflate,
                    Unzlib
                ];
            }
        ], this, 0, function() {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function() {
            return [
                unzlibSync
            ];
        }
    ], function(ev) {
        return pbf(unzlibSync(ev.data[0], gu8(ev.data[1])));
    }, 5, cb);
}
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
function decompressSync(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, out) : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += "/"] = [
                new u8(0),
                op
            ];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != "undefined" && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != "undefined" && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, {
        stream: true
    });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function(d) {
    for(var r = "", i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();
        else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) err(8);
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = "";
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if (td) return td.decode(dat);
    else {
        var _a = dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) err(8);
        return out;
    }
}
// deflate bit flag
var dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function(d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [
        bs,
        b4(d, b + 24),
        b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        b2(d, b + 10),
        sc,
        su,
        fn,
        es + b2(d, b + 30) + b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var z64e = function(d, b) {
    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [
        b8(d, b + 12),
        b8(d, b + 4),
        b8(d, b + 20)
    ];
};
// extra field length
var exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) err(10);
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        wbytes(d, b, +k);
        wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) err(5);
        // finishing or finished
        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    var r = {};
    fltn(data, "", r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl(err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, deflateSync(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, "", r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new AsyncInflate(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) err(5);
        if (!this.p) err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) err(5);
                                if (!sc_1) file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata(err(14, "unknown compression type " + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push(et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var mt = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function(fn) {
    fn();
};
function unzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd(err(13, 0, 1), null);
        return tAll;
    }
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295;
        if (z) {
            e = b4(data, e - 12);
            if (b4(data, e) != 0x6064B50) {
                cbd(err(13, 0, 1), null);
                return tAll;
            }
            c = lft = b4(data, e + 32);
            o = b4(data, e + 48);
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, inflateSync(infl, new u8(su)));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push(inflate(infl, {
                        size: su
                    }, cbl));
                } else cbl(err(14, "unknown compression type " + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50) err(13);
        c = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
            else err(14, "unknown compression type " + c_2);
        }
    }
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2txbR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifications", ()=>(0, _notificationsDefault.default));
parcelHelpers.export(exports, "AWSPinpointProviderCommon", ()=>(0, _common.AWSPinpointProviderCommon));
parcelHelpers.export(exports, "InAppMessageInteractionEvent", ()=>(0, _inAppMessaging.InAppMessageInteractionEvent));
parcelHelpers.export(exports, "PushNotificationPermissionStatus", ()=>(0, _types.PushNotificationPermissionStatus));
var _notifications = require("./Notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _common = require("./common");
var _inAppMessaging = require("./InAppMessaging");
var _types = require("./PushNotification/types");

},{"./Notifications":"5yQUg","./common":false,"./InAppMessaging":false,"./PushNotification/types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5yQUg":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _inAppMessaging = require("./InAppMessaging");
var _inAppMessagingDefault = parcelHelpers.interopDefault(_inAppMessaging);
var _pushNotification = require("./PushNotification");
var _pushNotificationDefault = parcelHelpers.interopDefault(_pushNotification);
var logger = new (0, _core.ConsoleLogger)("Notifications");
var NotificationsClass = /** @class */ function() {
    function NotificationsClass() {
        var _this = this;
        this.config = {};
        /**
         * Configure Notifications
         * @param {Object} config - Notifications configuration object
         */ this.configure = function(_a) {
            var config = (_a === void 0 ? {} : _a).Notifications;
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.config), config);
            logger.debug("configure Notifications", config);
            // Configure sub-categories
            _this.inAppMessaging.configure(_this.config.InAppMessaging);
            if (_this.config.Push) try {
                // only instantiate once
                if (!_this.pushNotification) _this.pushNotification = new (0, _pushNotificationDefault.default)();
                _this.pushNotification.configure(_this.config.Push);
            } catch (err) {
                logger.error(err);
            }
            return _this.config;
        };
        this.identifyUser = function(userId, userInfo) {
            var identifyFunctions = [];
            if (_this.inAppMessaging) identifyFunctions.push(_this.inAppMessaging.identifyUser);
            if (_this.pushNotification) identifyFunctions.push(_this.pushNotification.identifyUser);
            return Promise.all(identifyFunctions.map(function(identifyFunction) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_1;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    identifyFunction(userId, userInfo)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                logger.error("Failed to identify user", err_1);
                                throw err_1;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.inAppMessaging = new (0, _inAppMessagingDefault.default)();
    }
    /**
     * Get the name of the module category
     * @returns {string} name of the module category
     */ NotificationsClass.prototype.getModuleName = function() {
        return "Notifications";
    };
    Object.defineProperty(NotificationsClass.prototype, "InAppMessaging", {
        get: function() {
            return this.inAppMessaging;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClass.prototype, "Push", {
        get: function() {
            var _a;
            return (_a = this.pushNotification) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: true,
        configurable: true
    });
    return NotificationsClass;
}();
var Notifications = new NotificationsClass();
exports.default = Notifications;
(0, _core.Amplify).register(Notifications);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./InAppMessaging":"9RiKm","./PushNotification":"k7PrD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9RiKm":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inAppMessagingDefault.default));
parcelHelpers.export(exports, "InAppMessageInteractionEvent", ()=>(0, _types.InAppMessageInteractionEvent));
var _inAppMessaging = require("./InAppMessaging");
var _inAppMessagingDefault = parcelHelpers.interopDefault(_inAppMessaging);
var _types = require("./types");

},{"./InAppMessaging":"hTjPp","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hTjPp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
var _common = require("../common");
var _providers = require("./Providers");
var _types = require("./types");
var STORAGE_KEY_SUFFIX = "_inAppMessages";
var logger = new (0, _core.ConsoleLogger)("Notifications.InAppMessaging");
var InAppMessaging = /** @class */ function() {
    function InAppMessaging() {
        var _this = this;
        this.config = {};
        this.listeningForAnalyticEvents = false;
        this.pluggables = [];
        this.storageSynced = false;
        /**
         * Configure InAppMessaging
         * @param {Object} config - InAppMessaging configuration object
         */ this.configure = function(_a) {
            if (_a === void 0) _a = {};
            var _b = _a.listenForAnalyticsEvents, listenForAnalyticsEvents = _b === void 0 ? true : _b, config = (0, _tslib.__rest)(_a, [
                "listenForAnalyticsEvents"
            ]);
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.config), config);
            logger.debug("configure InAppMessaging", _this.config);
            _this.pluggables.forEach(function(pluggable) {
                pluggable.configure(_this.config[pluggable.getProviderName()]);
            });
            if (_this.pluggables.length === 0) _this.addPluggable(new (0, _providers.AWSPinpointProvider)());
            if (listenForAnalyticsEvents && !_this.listeningForAnalyticEvents) {
                (0, _core.Hub).listen("analytics", _this.analyticsListener);
                _this.listeningForAnalyticEvents = true;
            }
            return _this.config;
        };
        /**
         * Get a plugin from added plugins
         * @param {string} providerName - the name of the plugin to get
         */ this.getPluggable = function(providerName) {
            var _a;
            var pluggable = (_a = _this.pluggables.find(function(pluggable) {
                return pluggable.getProviderName() === providerName;
            })) !== null && _a !== void 0 ? _a : null;
            if (!pluggable) logger.debug("No plugin found with name " + providerName);
            return pluggable;
        };
        /**
         * Add plugin into InAppMessaging
         * @param {InAppMessagingProvider} pluggable - an instance of the plugin
         */ this.addPluggable = function(pluggable) {
            if (pluggable && pluggable.getCategory() === "Notifications" && pluggable.getSubCategory() === "InAppMessaging") {
                if (_this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable " + pluggable.getProviderName() + " has already been added.");
                _this.pluggables.push(pluggable);
                pluggable.configure(_this.config[pluggable.getProviderName()]);
            }
        };
        /**
         * Remove a plugin from added plugins
         * @param {string} providerName - the name of the plugin to remove
         */ this.removePluggable = function(providerName) {
            var index = _this.pluggables.findIndex(function(pluggable) {
                return pluggable.getProviderName() === providerName;
            });
            if (index === -1) logger.debug("No plugin found with name " + providerName);
            else _this.pluggables.splice(index, 1);
        };
        /**
         * Get the map resources that are currently available through the provider
         * @param {string} provider
         * @returns - Array of available map resources
         */ this.syncMessages = function() {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var messages, key, err_1;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    pluggable.getInAppMessages()
                                ];
                            case 1:
                                messages = _a.sent();
                                key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                return [
                                    4 /*yield*/ ,
                                    this.setMessages(key, messages)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                logger.error("Failed to sync messages", err_1);
                                throw err_1;
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.clearMessages = function() {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var key;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                return [
                                    4 /*yield*/ ,
                                    this.removeMessages(key)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.dispatchEvent = function(event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var messages, flattenedMessages;
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                Promise.all(this.pluggables.map(function(pluggable) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var key, messages;
                                        return (0, _tslib.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.getMessages(key)
                                                    ];
                                                case 1:
                                                    messages = _a.sent();
                                                    return [
                                                        2 /*return*/ ,
                                                        pluggable.processInAppMessages(messages, event)
                                                    ];
                                            }
                                        });
                                    });
                                }))
                            ];
                        case 1:
                            messages = _a.sent();
                            flattenedMessages = (0, _flattenDefault.default)(messages);
                            if (flattenedMessages.length) (0, _common.notifyEventListeners)((0, _types.InAppMessageInteractionEvent).MESSAGE_RECEIVED, this.conflictHandler(flattenedMessages));
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.identifyUser = function(userId, userInfo) {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    pluggable.identifyUser(userId, userInfo)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_2 = _a.sent();
                                logger.error("Failed to identify user", err_2);
                                throw err_2;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.onMessageReceived = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_RECEIVED, handler);
        };
        this.onMessageDisplayed = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISPLAYED, handler);
        };
        this.onMessageDismissed = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISMISSED, handler);
        };
        this.onMessageActionTaken = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_ACTION_TAKEN, handler);
        };
        this.notifyMessageInteraction = function(message, type) {
            (0, _common.notifyEventListeners)(type, message);
        };
        this.setConflictHandler = function(handler) {
            _this.conflictHandler = handler;
        };
        this.analyticsListener = function(_a) {
            var payload = _a.payload;
            var event = payload.event, data = payload.data;
            switch(event){
                case "record":
                    _this.dispatchEvent(data);
                    break;
                default:
                    break;
            }
        };
        this.syncStorage = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_3;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            storage = this.config.storage;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            if (!(typeof storage.sync === "function")) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                storage.sync()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.storageSynced = true;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            logger.error("Failed to sync storage", err_3);
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getMessages = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, storedMessages, err_4;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            storage = this.config.storage;
                            storedMessages = storage.getItem(key);
                            return [
                                2 /*return*/ ,
                                storedMessages ? JSON.parse(storedMessages) : []
                            ];
                        case 3:
                            err_4 = _a.sent();
                            logger.error("Failed to retrieve in-app messages from storage", err_4);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.setMessages = function(key, messages) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_5;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!messages) return [
                                2 /*return*/ 
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            storage = this.config.storage;
                            storage.setItem(key, JSON.stringify(messages));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_5 = _a.sent();
                            logger.error("Failed to store in-app messages", err_5);
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.removeMessages = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_6;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            storage = this.config.storage;
                            storage.removeItem(key);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_6 = _a.sent();
                            logger.error("Failed to remove in-app messages from storage", err_6);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.defaultConflictHandler = function(messages) {
            // default behavior is to return the message closest to expiry
            // this function assumes that messages processed by providers already filters out expired messages
            var sorted = messages.sort(function(a, b) {
                var _a, _b;
                var endDateA = (_a = a.metadata) === null || _a === void 0 ? void 0 : _a.endDate;
                var endDateB = (_b = b.metadata) === null || _b === void 0 ? void 0 : _b.endDate;
                // if both message end dates are falsy or have the same date string, treat them as equal
                if (endDateA === endDateB) return 0;
                // if only message A has an end date, treat it as closer to expiry
                if (endDateA && !endDateB) return -1;
                // if only message B has an end date, treat it as closer to expiry
                if (!endDateA && endDateB) return 1;
                // otherwise, compare them
                return new Date(endDateA) < new Date(endDateB) ? -1 : 1;
            });
            // always return the top sorted
            return sorted[0];
        };
        this.config = {
            storage: new (0, _core.StorageHelper)().getStorage()
        };
        this.setConflictHandler(this.defaultConflictHandler);
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */ InAppMessaging.prototype.getModuleName = function() {
        return "InAppMessaging";
    };
    return InAppMessaging;
}();
exports.default = InAppMessaging;

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","lodash/flatten":"bCwOu","../common":"BL6pC","./Providers":"dIbVp","./types":"85NR5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bCwOu":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"jaR7v"}],"jaR7v":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"3WqQu","ec5f080ebf5764e8":"gy96j"}],"gy96j":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"25xE8","ee6f325d7f5309b1":"aZ8vK","ff8d93236e335297":"9om8C"}],"BL6pC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProviderCommon", ()=>(0, _awspinpointProviderCommonDefault.default));
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>(0, _constants.AMPLIFY_SYMBOL));
parcelHelpers.export(exports, "addEventListener", ()=>(0, _eventListeners.addEventListener));
parcelHelpers.export(exports, "notifyEventListeners", ()=>(0, _eventListeners.notifyEventListeners));
parcelHelpers.export(exports, "notifyEventListenersAndAwaitHandlers", ()=>(0, _eventListeners.notifyEventListenersAndAwaitHandlers));
var _awspinpointProviderCommon = require("./AWSPinpointProviderCommon");
var _awspinpointProviderCommonDefault = parcelHelpers.interopDefault(_awspinpointProviderCommon);
var _constants = require("./constants");
var _eventListeners = require("./eventListeners");

},{"./AWSPinpointProviderCommon":"3Oxq9","./constants":"j8X2W","./eventListeners":"4QOUG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Oxq9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _uuid = require("uuid");
var AWSPinpointProviderCommon = /** @class */ function() {
    function AWSPinpointProviderCommon(logger) {
        var _this = this;
        var _a;
        this.config = {};
        this.endpointInitialized = false;
        this.initialized = false;
        this.identifyUser = function(userId, userInfo) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var err_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.updateEndpoint(userId, userInfo)
                            ];
                        case 3:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_1 = _a.sent();
                            this.logger.error("Error identifying user", err_1);
                            throw err_1;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.init = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, endpointId, storage, providerName, _b, err_2;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            _a = this.config, endpointId = _a.endpointId, storage = _a.storage;
                            providerName = this.getProviderName();
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                6,
                                ,
                                7
                            ]);
                            if (!(typeof storage.sync === "function")) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                storage.sync()
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            if (!!endpointId) return [
                                3 /*break*/ ,
                                5
                            ];
                            _b = this.config;
                            return [
                                4 /*yield*/ ,
                                this.getEndpointId()
                            ];
                        case 4:
                            _b.endpointId = _c.sent();
                            _c.label = 5;
                        case 5:
                            this.initialized = true;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 6:
                            err_2 = _c.sent();
                            this.logger.error("Failed to initialize " + providerName, err_2);
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getUserAgentValue = function() {
            var customUserAgentDetails;
            if (_this.getSubCategory() === "PushNotification") customUserAgentDetails = {
                category: (0, _core.Category).PushNotification,
                action: (0, _core.PushNotificationAction).None
            };
            else customUserAgentDetails = {
                category: (0, _core.Category).InAppMessaging,
                action: (0, _core.InAppMessagingAction).None
            };
            return (0, _core.getAmplifyUserAgent)(customUserAgentDetails);
        };
        this.recordAnalyticsEvent = function(event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, _b, appId, credentials, endpointId, region, input, err_3;
                var _c, _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            // Update credentials
                            _a = this.config;
                            return [
                                4 /*yield*/ ,
                                this.getCredentials()
                            ];
                        case 1:
                            // Update credentials
                            _a.credentials = _e.sent();
                            // Assert required configuration properties to make `putEvents` request are present
                            this.assertNotEmptyConfiguration();
                            _b = this.config, appId = _b.appId, credentials = _b.credentials, endpointId = _b.endpointId, region = _b.region;
                            _e.label = 2;
                        case 2:
                            _e.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            input = {
                                ApplicationId: appId,
                                EventsRequest: {
                                    BatchItem: (_c = {}, _c[endpointId] = {
                                        Endpoint: {},
                                        Events: (_d = {}, _d[(0, _uuid.v4)()] = event, _d)
                                    }, _c)
                                }
                            };
                            this.logger.debug("recording analytics event");
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.putEvents)({
                                    credentials: credentials,
                                    region: region,
                                    userAgentValue: this.getUserAgentValue()
                                }, input)
                            ];
                        case 3:
                            _e.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _e.sent();
                            this.logger.error("Error recording analytics event", err_3);
                            throw err_3;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.updateEndpoint = function(userId, userInfo) {
            if (userId === void 0) userId = null;
            if (userInfo === void 0) userInfo = null;
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var credentials, credentialsUpdated, _a, appId, endpointId, _b, endpointInfo, region, _c, address, attributes, demographic, location_1, metrics, optOut, _d, appVersion, make, model, platform, version, input, err_4;
                var _this = this;
                var _e;
                return (0, _tslib.__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getCredentials()
                            ];
                        case 1:
                            credentials = _f.sent();
                            credentialsUpdated = !this.config.credentials || Object.keys(credentials).some(function(key) {
                                return credentials[key] !== _this.config.credentials[key];
                            });
                            // If endpoint is already initialized, and nothing else is changing, just early return
                            if (this.endpointInitialized && !credentialsUpdated && !userId && !userInfo) return [
                                2 /*return*/ 
                            ];
                            // Update credentials
                            this.config.credentials = credentials;
                            // Assert required configuration properties to make `updateEndpoint` request are present
                            this.assertNotEmptyConfiguration();
                            _a = this.config, appId = _a.appId, endpointId = _a.endpointId, _b = _a.endpointInfo, endpointInfo = _b === void 0 ? {} : _b, region = _a.region;
                            _f.label = 2;
                        case 2:
                            _f.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            _c = userInfo !== null && userInfo !== void 0 ? userInfo : {}, address = _c.address, attributes = _c.attributes, demographic = _c.demographic, location_1 = _c.location, metrics = _c.metrics, optOut = _c.optOut;
                            _d = this.clientInfo, appVersion = _d.appVersion, make = _d.make, model = _d.model, platform = _d.platform, version = _d.version;
                            input = {
                                ApplicationId: appId,
                                EndpointId: endpointId,
                                EndpointRequest: {
                                    RequestId: (0, _uuid.v4)(),
                                    EffectiveDate: new Date().toISOString(),
                                    ChannelType: endpointInfo.channelType,
                                    Address: address !== null && address !== void 0 ? address : endpointInfo.address,
                                    Attributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.attributes), attributes),
                                    Demographic: (0, _tslib.__assign)({
                                        AppVersion: appVersion,
                                        Make: make,
                                        Model: model,
                                        ModelVersion: version,
                                        Platform: platform
                                    }, (0, _core.transferKeyToUpperCase)((0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.demographic), demographic))),
                                    Location: (0, _core.transferKeyToUpperCase)((0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.location), location_1)),
                                    Metrics: (0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.metrics), metrics),
                                    OptOut: optOut !== null && optOut !== void 0 ? optOut : endpointInfo.optOut,
                                    User: {
                                        UserId: (_e = userId !== null && userId !== void 0 ? userId : endpointInfo.userId) !== null && _e !== void 0 ? _e : credentials.identityId,
                                        UserAttributes: attributes !== null && attributes !== void 0 ? attributes : endpointInfo.userAttributes
                                    }
                                }
                            };
                            this.logger.debug("updating endpoint");
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.updateEndpoint)({
                                    credentials: credentials,
                                    region: region,
                                    userAgentValue: this.getUserAgentValue()
                                }, input)
                            ];
                        case 3:
                            _f.sent();
                            this.endpointInitialized = true;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_4 = _f.sent();
                            throw err_4;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getEndpointId = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var appId, cacheKey, cachedEndpointId, endpointId, ttl, expiration;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            appId = this.config.appId;
                            cacheKey = this.getSubCategory() === "PushNotification" ? this.getProviderName() + "_" + appId : this.getSubCategory() + ":" + this.getProviderName() + ":" + appId;
                            return [
                                4 /*yield*/ ,
                                (0, _cache.Cache).getItem(cacheKey)
                            ];
                        case 1:
                            cachedEndpointId = _a.sent();
                            // Found in cache, just return it
                            if (cachedEndpointId) return [
                                2 /*return*/ ,
                                cachedEndpointId
                            ];
                            endpointId = (0, _uuid.v4)();
                            ttl = 3153600000000;
                            expiration = new Date().getTime() + ttl;
                            (0, _cache.Cache).setItem(cacheKey, endpointId, {
                                expires: expiration,
                                priority: 1
                            });
                            return [
                                2 /*return*/ ,
                                endpointId
                            ];
                    }
                });
            });
        };
        this.getCredentials = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var credentials, err_5;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                (0, _core.Credentials).get()
                            ];
                        case 1:
                            credentials = _a.sent();
                            if (!credentials) {
                                this.logger.debug("no credentials found");
                                return [
                                    2 /*return*/ ,
                                    null
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                (0, _core.Credentials).shear(credentials)
                            ];
                        case 2:
                            err_5 = _a.sent();
                            this.logger.error("Error getting credentials:", err_5);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.assertNotEmptyConfiguration = function() {
            var _a = _this.config, appId = _a.appId, credentials = _a.credentials, region = _a.region;
            if (!appId || !credentials || !region) throw new Error("One or more of credentials, appId or region is not configured");
        };
        this.config = {
            storage: new (0, _core.StorageHelper)().getStorage()
        };
        this.clientInfo = (_a = (0, _core.ClientDevice).clientInfo()) !== null && _a !== void 0 ? _a : {};
        this.logger = logger;
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProviderCommon.prototype.getCategory = function() {
        return AWSPinpointProviderCommon.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProviderCommon.prototype.getProviderName = function() {
        return AWSPinpointProviderCommon.providerName;
    };
    AWSPinpointProviderCommon.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.config), config);
        this.logger.debug("configure " + this.getProviderName() + this.getSubCategory() + "Provider", this.config);
        return this.config;
    };
    AWSPinpointProviderCommon.category = "Notifications";
    AWSPinpointProviderCommon.providerName = "AWSPinpoint";
    return AWSPinpointProviderCommon;
}();
exports.default = AWSPinpointProviderCommon;

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@aws-amplify/cache":"egrWR","@aws-amplify/core/internals/aws-clients/pinpoint":"8UVd6","uuid":"9dBTc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"j8X2W":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4QOUG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifyEventListeners", ()=>notifyEventListeners);
parcelHelpers.export(exports, "notifyEventListenersAndAwaitHandlers", ()=>notifyEventListenersAndAwaitHandlers);
parcelHelpers.export(exports, "addEventListener", ()=>addEventListener);
var _tslib = require("tslib");
var eventListeners = {};
var notifyEventListeners = function(type) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var _a;
    (_a = eventListeners[type]) === null || _a === void 0 || _a.forEach(function(listener) {
        listener.handleEvent.apply(listener, (0, _tslib.__spread)(args));
    });
};
var notifyEventListenersAndAwaitHandlers = function(type) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var _a;
    return Promise.all(Array.from((_a = eventListeners[type]) !== null && _a !== void 0 ? _a : []).map(function(listener) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            listener.handleEvent.apply(listener, (0, _tslib.__spread)(args))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }));
};
var addEventListener = function(type, handler) {
    // If there is no listener set for the event type, just create it
    if (!eventListeners[type]) eventListeners[type] = new Set();
    var listener = {
        handleEvent: handler,
        remove: function() {
            eventListeners[type].delete(listener);
        }
    };
    eventListeners[type].add(listener);
    return listener;
};

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dIbVp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _awspinpointProviderDefault.default));
var _awspinpointProvider = require("./AWSPinpointProvider");
var _awspinpointProviderDefault = parcelHelpers.interopDefault(_awspinpointProvider);

},{"./AWSPinpointProvider":"cLzPQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cLzPQ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _common = require("../../../common");
var _sessionTracker = require("../../SessionTracker");
var _sessionTrackerDefault = parcelHelpers.interopDefault(_sessionTracker);
var _types = require("../../types");
var _types1 = require("./types");
var _utils = require("./utils");
var MESSAGE_DAILY_COUNT_KEY = "pinpointProvider_inAppMessages_dailyCount";
var MESSAGE_TOTAL_COUNT_KEY = "pinpointProvider_inAppMessages_totalCount";
var AWSPinpointProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSPinpointProvider, _super);
    function AWSPinpointProvider() {
        var _this = _super.call(this, (0, _utils.logger)) || this;
        _this.configured = false;
        _this.configure = function(config) {
            if (config === void 0) config = {};
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _super.prototype.configure.call(_this, config)), {
                endpointInfo: {
                    channelType: "IN_APP"
                }
            });
            // some configuration steps should not be re-run even if provider is re-configured for some reason
            if (!_this.configured) {
                _this.sessionTracker = new (0, _sessionTrackerDefault.default)(_this.sessionStateChangeHandler);
                _this.sessionTracker.start();
                // wire up default Pinpoint message event handling
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISPLAYED, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISPLAYED);
                });
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISMISSED, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISMISSED);
                });
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_ACTION_TAKEN, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_ACTION_TAKEN);
                });
            }
            _this.configured = true;
            (0, _utils.dispatchInAppMessagingEvent)("pinpointProvider_configured", null);
            return _this.config;
        };
        _this.getInAppMessages = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, appId, credentials, endpointId, region, input, response, messages, err_1;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            // There is no way to granuarly reconcile the filter memoization as the keys are composited from a message id and
                            // event properties thus opting to just clear them out when getting messages rather than leave potentially
                            // obsolete entries that will no longer serve any purpose.
                            (0, _utils.clearMemo)();
                            _b.label = 3;
                        case 3:
                            _b.trys.push([
                                3,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.updateEndpoint()
                            ];
                        case 4:
                            _b.sent();
                            _a = this.config, appId = _a.appId, credentials = _a.credentials, endpointId = _a.endpointId, region = _a.region;
                            input = {
                                ApplicationId: appId,
                                EndpointId: endpointId
                            };
                            this.logger.debug("getting in-app messages");
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.getInAppMessages)({
                                    credentials: credentials,
                                    region: region
                                }, input)
                            ];
                        case 5:
                            response = _b.sent();
                            messages = response.InAppMessagesResponse.InAppMessageCampaigns;
                            (0, _utils.dispatchInAppMessagingEvent)("getInAppMessages", messages);
                            return [
                                2 /*return*/ ,
                                messages
                            ];
                        case 6:
                            err_1 = _b.sent();
                            this.logger.error("Error getting in-app messages", err_1);
                            throw err_1;
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.processInAppMessages = function(messages, event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var highestPrioritySeen;
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ ,
                                this.normalizeMessages(messages.reduce(function(acc, message) {
                                    var messageQualifies = (0, _utils.matchesEventType)(message, event) && (0, _utils.matchesAttributes)(message, event) && (0, _utils.matchesMetrics)(message, event) && (0, _utils.isBeforeEndDate)(message) && _this.isBelowCap(message);
                                    // filter all qualifying messages returning only those that are of (relative) highest priority
                                    if (messageQualifies) {
                                        // have not yet encountered message with priority
                                        if (!highestPrioritySeen) {
                                            // this message has priority, so reset the accumulator with this message only
                                            if (message.Priority) {
                                                highestPrioritySeen = message.Priority;
                                                return [
                                                    message
                                                ];
                                            } else // this message also has no priority, so just add this message to accumulator
                                            acc.push(message);
                                        } else if (message.Priority) {
                                            // this message has higher priority (lower number), so reset the accumulator with this message only
                                            if (message.Priority < highestPrioritySeen) {
                                                highestPrioritySeen = message.Priority;
                                                return [
                                                    message
                                                ];
                                            // this message has the same priority, so just add this message to accumulator
                                            } else if (message.Priority === highestPrioritySeen) acc.push(message);
                                        }
                                    }
                                    return acc;
                                }, []))
                            ];
                    }
                });
            });
        };
        _this.sessionStateChangeHandler = function(state) {
            if (state === "started") // reset all session counts
            _this.sessionMessageCountMap = {};
        };
        _this.isBelowCap = function(_a) {
            var CampaignId = _a.CampaignId, SessionCap = _a.SessionCap, DailyCap = _a.DailyCap, TotalCap = _a.TotalCap;
            var _b = _this.getMessageCounts(CampaignId), sessionCount = _b.sessionCount, dailyCount = _b.dailyCount, totalCount = _b.totalCount;
            return (!SessionCap || sessionCount < SessionCap) && (!DailyCap || dailyCount < DailyCap) && (!TotalCap || totalCount < TotalCap);
        };
        // Use the current session count in memory or initialize as empty count
        _this.getSessionCount = function(messageId) {
            return _this.sessionMessageCountMap[messageId] || 0;
        };
        _this.getDailyCount = function() {
            var storage = _this.config.storage;
            var today = (0, _utils.getStartOfDay)();
            var item = storage.getItem(MESSAGE_DAILY_COUNT_KEY);
            // Parse stored count or initialize as empty count
            var counter = item ? JSON.parse(item) : {
                count: 0,
                lastCountTimestamp: today
            };
            // If the stored counter timestamp is today, use it as the count, otherwise reset to 0
            return counter.lastCountTimestamp === today ? counter.count : 0;
        };
        _this.getTotalCountMap = function() {
            var storage = _this.config.storage;
            var item = storage.getItem(MESSAGE_TOTAL_COUNT_KEY);
            // Parse stored count map or initialize as empty
            return item ? JSON.parse(item) : {};
        };
        _this.getTotalCount = function(messageId) {
            var countMap = _this.getTotalCountMap();
            // Return stored count or initialize as empty count
            return countMap[messageId] || 0;
        };
        _this.getMessageCounts = function(messageId) {
            try {
                return {
                    sessionCount: _this.getSessionCount(messageId),
                    dailyCount: _this.getDailyCount(),
                    totalCount: _this.getTotalCount(messageId)
                };
            } catch (err) {
                _this.logger.error("Failed to get message counts from storage", err);
            }
        };
        _this.setSessionCount = function(messageId, count) {
            _this.sessionMessageCountMap[messageId] = count;
        };
        _this.setDailyCount = function(count) {
            var storage = _this.config.storage;
            var dailyCount = {
                count: count,
                lastCountTimestamp: (0, _utils.getStartOfDay)()
            };
            try {
                storage.setItem(MESSAGE_DAILY_COUNT_KEY, JSON.stringify(dailyCount));
            } catch (err) {
                _this.logger.error("Failed to save daily message count to storage", err);
            }
        };
        _this.setTotalCountMap = function(countMap) {
            var storage = _this.config.storage;
            try {
                storage.setItem(MESSAGE_TOTAL_COUNT_KEY, JSON.stringify(countMap));
            } catch (err) {
                _this.logger.error("Failed to save total count to storage", err);
            }
        };
        _this.setTotalCount = function(messageId, count) {
            var _a;
            var updatedMap = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.getTotalCountMap()), (_a = {}, _a[messageId] = count, _a));
            _this.setTotalCountMap(updatedMap);
        };
        _this.incrementCounts = function(messageId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, sessionCount, dailyCount, totalCount;
                return (0, _tslib.__generator)(this, function(_b) {
                    _a = this.getMessageCounts(messageId), sessionCount = _a.sessionCount, dailyCount = _a.dailyCount, totalCount = _a.totalCount;
                    this.setSessionCount(messageId, sessionCount + 1);
                    this.setDailyCount(dailyCount + 1);
                    this.setTotalCount(messageId, totalCount + 1);
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        _this.normalizeMessages = function(messages) {
            return messages.map(function(message) {
                var CampaignId = message.CampaignId, InAppMessage = message.InAppMessage;
                return {
                    id: CampaignId,
                    content: (0, _utils.extractContent)(message),
                    layout: (0, _utils.interpretLayout)(InAppMessage.Layout),
                    metadata: (0, _utils.extractMetadata)(message)
                };
            });
        };
        _this.recordMessageEvent = function(message, event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            (0, _utils.recordAnalyticsEvent)(event, message);
                            if (!(event === (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISPLAYED)) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                this.incrementCounts(message.id)
                            ];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.sessionMessageCountMap = {};
        return _this;
    }
    /**
     * get the sub-category of the plugin
     */ AWSPinpointProvider.prototype.getSubCategory = function() {
        return AWSPinpointProvider.subCategory;
    };
    AWSPinpointProvider.subCategory = "InAppMessaging";
    return AWSPinpointProvider;
}((0, _common.AWSPinpointProviderCommon));
exports.default = AWSPinpointProvider;

},{"tslib":"9gMVn","@aws-amplify/core/internals/aws-clients/pinpoint":"8UVd6","../../../common":"BL6pC","../../SessionTracker":"cgof7","../../types":"85NR5","./types":"1XjRp","./utils":"bHLXm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cgof7":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sessionTracker = require("./SessionTracker");
var _sessionTrackerDefault = parcelHelpers.interopDefault(_sessionTracker);
exports.default = (0, _sessionTrackerDefault.default);

},{"./SessionTracker":"iuAju","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iuAju":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
var _noop = require("lodash/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
// Per https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
var hidden;
var visibilityChange;
var isBrowser = (0, _core.browserOrNode)().isBrowser;
if (isBrowser && document) {
    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document["msHidden"] !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (typeof document["webkitHidden"] !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }
}
var logger = new (0, _core.ConsoleLogger)("InAppMessagingSessionTracker");
var SessionTracker = /** @class */ function() {
    function SessionTracker(sessionStateChangeHandler) {
        var _this = this;
        if (sessionStateChangeHandler === void 0) sessionStateChangeHandler = (0, _noopDefault.default);
        this.start = function() {
            if (isBrowser) document === null || document === void 0 || document.addEventListener(visibilityChange, _this.visibilityChangeHandler);
            return _this.getSessionState();
        };
        this.end = function() {
            if (isBrowser) document === null || document === void 0 || document.removeEventListener(visibilityChange, _this.visibilityChangeHandler);
            return _this.getSessionState();
        };
        this.getSessionState = function() {
            if (isBrowser && document && !document[hidden]) return "started";
            // If, for any reason, document is undefined the session will never start
            return "ended";
        };
        this.visibilityChangeHandler = function() {
            if (!isBrowser || !document) return;
            if (document[hidden]) {
                logger.debug("App is now hidden");
                _this.sessionStateChangeHandler("ended");
            } else {
                logger.debug("App is now visible");
                _this.sessionStateChangeHandler("started");
            }
        };
        this.sessionStateChangeHandler = sessionStateChangeHandler;
    }
    return SessionTracker;
}();
exports.default = SessionTracker;

},{"@aws-amplify/core":"8BDOx","lodash/noop":"b9txl","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b9txl":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"85NR5":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InAppMessageInteractionEvent", ()=>InAppMessageInteractionEvent);
var InAppMessageInteractionEvent;
(function(InAppMessageInteractionEvent) {
    InAppMessageInteractionEvent["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_DISPLAYED"] = "MESSAGE_DISPLAYED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_DISMISSED"] = "MESSAGE_DISMISSED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_ACTION_TAKEN"] = "MESSAGE_ACTION_TAKEN_EVENT";
})(InAppMessageInteractionEvent || (InAppMessageInteractionEvent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1XjRp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointMessageEvent", ()=>AWSPinpointMessageEvent);
var AWSPinpointMessageEvent;
(function(AWSPinpointMessageEvent) {
    AWSPinpointMessageEvent["MESSAGE_DISPLAYED"] = "_inapp.message_displayed";
    AWSPinpointMessageEvent["MESSAGE_DISMISSED"] = "_inapp.message_dismissed";
    AWSPinpointMessageEvent["MESSAGE_ACTION_TAKEN"] = "_inapp.message_clicked";
})(AWSPinpointMessageEvent || (AWSPinpointMessageEvent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bHLXm":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "dispatchInAppMessagingEvent", ()=>dispatchInAppMessagingEvent);
parcelHelpers.export(exports, "recordAnalyticsEvent", ()=>recordAnalyticsEvent);
parcelHelpers.export(exports, "getStartOfDay", ()=>getStartOfDay);
parcelHelpers.export(exports, "matchesEventType", ()=>matchesEventType);
parcelHelpers.export(exports, "matchesAttributes", ()=>matchesAttributes);
parcelHelpers.export(exports, "matchesMetrics", ()=>matchesMetrics);
parcelHelpers.export(exports, "getComparator", ()=>getComparator);
parcelHelpers.export(exports, "isBeforeEndDate", ()=>isBeforeEndDate);
parcelHelpers.export(exports, "isQuietTime", ()=>isQuietTime);
parcelHelpers.export(exports, "clearMemo", ()=>clearMemo);
parcelHelpers.export(exports, "interpretLayout", ()=>interpretLayout);
parcelHelpers.export(exports, "extractContent", ()=>extractContent);
parcelHelpers.export(exports, "extractMetadata", ()=>extractMetadata);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _common = require("../../../common");
var DELIVERY_TYPE = "IN_APP_MESSAGE";
var eventNameMemo = {};
var eventAttributesMemo = {};
var eventMetricsMemo = {};
var logger = new (0, _core.ConsoleLogger)("InAppMessaging.AWSPinpointProvider");
var dispatchInAppMessagingEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("inAppMessaging", {
        event: event,
        data: data,
        message: message
    }, "InAppMessaging", (0, _common.AMPLIFY_SYMBOL));
};
var recordAnalyticsEvent = function(event, message) {
    if ((0, _core.Amplify).Analytics && typeof (0, _core.Amplify).Analytics.record === "function") {
        var id = message.id, metadata = message.metadata;
        (0, _core.Amplify).Analytics.record({
            name: event,
            attributes: {
                campaign_id: id,
                delivery_type: DELIVERY_TYPE,
                treatment_id: metadata === null || metadata === void 0 ? void 0 : metadata.treatmentId
            }
        });
    } else logger.debug("Analytics module is not registered into Amplify");
};
var getStartOfDay = function() {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return now.toISOString();
};
var matchesEventType = function(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var eventType = _b.name;
    var _c;
    var EventType = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).EventType;
    var memoKey = CampaignId + ":" + eventType;
    if (!eventNameMemo.hasOwnProperty(memoKey)) eventNameMemo[memoKey] = !!(EventType === null || EventType === void 0 ? void 0 : EventType.Values.includes(eventType));
    return eventNameMemo[memoKey];
};
var matchesAttributes = function(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var attributes = _b.attributes;
    var _c;
    var Attributes = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Attributes;
    if ((0, _isEmptyDefault.default)(Attributes)) // if message does not have attributes defined it does not matter what attributes are on the event
    return true;
    if ((0, _isEmptyDefault.default)(attributes)) // if message does have attributes but the event does not then it always fails the check
    return false;
    var memoKey = CampaignId + ":" + JSON.stringify(attributes);
    if (!eventAttributesMemo.hasOwnProperty(memoKey)) eventAttributesMemo[memoKey] = Object.entries(Attributes).every(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], Values = _b[1].Values;
        return Values.includes(attributes[key]);
    });
    return eventAttributesMemo[memoKey];
};
var matchesMetrics = function(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var metrics = _b.metrics;
    var _c;
    var Metrics = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Metrics;
    if ((0, _isEmptyDefault.default)(Metrics)) // if message does not have metrics defined it does not matter what metrics are on the event
    return true;
    if ((0, _isEmptyDefault.default)(metrics)) // if message does have metrics but the event does not then it always fails the check
    return false;
    var memoKey = CampaignId + ":" + JSON.stringify(metrics);
    if (!eventMetricsMemo.hasOwnProperty(memoKey)) eventMetricsMemo[memoKey] = Object.entries(Metrics).every(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], _c = _b[1], ComparisonOperator = _c.ComparisonOperator, Value = _c.Value;
        var compare = getComparator(ComparisonOperator);
        // if there is some unknown comparison operator, treat as a comparison failure
        return compare ? compare(Value, metrics[key]) : false;
    });
    return eventMetricsMemo[memoKey];
};
var getComparator = function(operator) {
    switch(operator){
        case "EQUAL":
            return function(metricsVal, eventVal) {
                return metricsVal === eventVal;
            };
        case "GREATER_THAN":
            return function(metricsVal, eventVal) {
                return metricsVal < eventVal;
            };
        case "GREATER_THAN_OR_EQUAL":
            return function(metricsVal, eventVal) {
                return metricsVal <= eventVal;
            };
        case "LESS_THAN":
            return function(metricsVal, eventVal) {
                return metricsVal > eventVal;
            };
        case "LESS_THAN_OR_EQUAL":
            return function(metricsVal, eventVal) {
                return metricsVal >= eventVal;
            };
        default:
            return null;
    }
};
var isBeforeEndDate = function(_a) {
    var Schedule = _a.Schedule;
    if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate)) return true;
    return new Date() < new Date(Schedule.EndDate);
};
var isQuietTime = function(message) {
    var Schedule = message.Schedule;
    if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.QuietTime)) return false;
    var pattern = /^[0-2]\d:[0-5]\d$/; // basic sanity check, not a fully featured HH:MM validation
    var _a = Schedule.QuietTime, Start = _a.Start, End = _a.End;
    if (!Start || !End || Start === End || !pattern.test(Start) || !pattern.test(End)) return false;
    var now = new Date();
    var start = new Date(now);
    var end = new Date(now);
    var _b = (0, _tslib.__read)(Start.split(":"), 2), startHours = _b[0], startMinutes = _b[1];
    var _c = (0, _tslib.__read)(End.split(":"), 2), endHours = _c[0], endMinutes = _c[1];
    start.setHours(Number.parseInt(startHours, 10), Number.parseInt(startMinutes, 10), 0, 0);
    end.setHours(Number.parseInt(endHours, 10), Number.parseInt(endMinutes, 10), 0, 0);
    // if quiet time includes midnight, bump the end time to the next day
    if (start > end) end.setDate(end.getDate() + 1);
    var isQuietTime = now >= start && now <= end;
    if (isQuietTime) logger.debug("message filtered due to quiet time", message);
    return isQuietTime;
};
var clearMemo = function() {
    eventNameMemo = {};
    eventAttributesMemo = {};
    eventMetricsMemo = {};
};
var interpretLayout = function(layout) {
    if (layout === "MOBILE_FEED") return "MODAL";
    if (layout === "OVERLAYS") return "FULL_SCREEN";
    // cast as PinpointInAppMessage['InAppMessage']['Layout'] allows `string` as a value
    return layout;
};
var extractContent = function(_a) {
    var message = _a.InAppMessage;
    var _b, _c;
    return (_c = (_b = message === null || message === void 0 ? void 0 : message.Content) === null || _b === void 0 ? void 0 : _b.map(function(content) {
        var BackgroundColor = content.BackgroundColor, BodyConfig = content.BodyConfig, HeaderConfig = content.HeaderConfig, ImageUrl = content.ImageUrl, PrimaryBtn = content.PrimaryBtn, SecondaryBtn = content.SecondaryBtn;
        var defaultPrimaryButton = PrimaryBtn === null || PrimaryBtn === void 0 ? void 0 : PrimaryBtn.DefaultConfig;
        var defaultSecondaryButton = SecondaryBtn === null || SecondaryBtn === void 0 ? void 0 : SecondaryBtn.DefaultConfig;
        var extractedContent = {};
        if (BackgroundColor) extractedContent.container = {
            style: {
                backgroundColor: BackgroundColor
            }
        };
        if (HeaderConfig) extractedContent.header = {
            content: HeaderConfig.Header,
            style: {
                color: HeaderConfig.TextColor,
                textAlign: HeaderConfig.Alignment.toLowerCase()
            }
        };
        if (BodyConfig) extractedContent.body = {
            content: BodyConfig.Body,
            style: {
                color: BodyConfig.TextColor,
                textAlign: BodyConfig.Alignment.toLowerCase()
            }
        };
        if (ImageUrl) extractedContent.image = {
            src: ImageUrl
        };
        if (defaultPrimaryButton) extractedContent.primaryButton = {
            title: defaultPrimaryButton.Text,
            action: defaultPrimaryButton.ButtonAction,
            url: defaultPrimaryButton.Link,
            style: {
                backgroundColor: defaultPrimaryButton.BackgroundColor,
                borderRadius: defaultPrimaryButton.BorderRadius,
                color: defaultPrimaryButton.TextColor
            }
        };
        if (defaultSecondaryButton) extractedContent.secondaryButton = {
            title: defaultSecondaryButton.Text,
            action: defaultSecondaryButton.ButtonAction,
            url: defaultSecondaryButton.Link,
            style: {
                backgroundColor: defaultSecondaryButton.BackgroundColor,
                borderRadius: defaultSecondaryButton.BorderRadius,
                color: defaultSecondaryButton.TextColor
            }
        };
        return extractedContent;
    })) !== null && _c !== void 0 ? _c : [];
};
var extractMetadata = function(_a) {
    var InAppMessage = _a.InAppMessage, Priority = _a.Priority, Schedule = _a.Schedule, TreatmentId = _a.TreatmentId;
    return {
        customData: InAppMessage === null || InAppMessage === void 0 ? void 0 : InAppMessage.CustomConfig,
        endDate: Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate,
        priority: Priority,
        treatmentId: TreatmentId
    };
};

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","lodash/isEmpty":"2iSgw","../../../common":"BL6pC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k7PrD":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _pushNotificationDefault.default));
parcelHelpers.export(exports, "PushNotificationPermissionStatus", ()=>(0, _types.PushNotificationPermissionStatus));
var _pushNotification = require("./PushNotification");
var _pushNotificationDefault = parcelHelpers.interopDefault(_pushNotification);
var _types = require("./types");

},{"./PushNotification":"hzxNg","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hzxNg":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _platformNotSupportedError = require("./PlatformNotSupportedError");
var _platformNotSupportedErrorDefault = parcelHelpers.interopDefault(_platformNotSupportedError);
var PushNotification = /** @class */ function() {
    function PushNotification() {
        var _this = this;
        /**
         * Configure PushNotification
         * @param {Object} config - PushNotification configuration object
         */ this.configure = function(_) {
            if (_ === void 0) _ = {};
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Get a plugin from added plugins
         * @param {string} providerName - the name of the plugin to get
         */ this.getPluggable = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Add plugin into PushNotification
         * @param {PushNotificationProvider} pluggable - an instance of the plugin
         */ this.addPluggable = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Remove a plugin from added plugins
         * @param {string} providerName - the name of the plugin to remove
         */ this.removePluggable = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.enable = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.identifyUser = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.getLaunchNotification = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.getBadgeCount = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.setBadgeCount = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.getPermissionStatus = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.requestPermissions = function(_) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.onNotificationReceivedInBackground = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onNotificationReceivedInForeground = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onTokenReceived = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onNotificationOpened = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */ PushNotification.prototype.getModuleName = function() {
        throw new (0, _platformNotSupportedErrorDefault.default)();
    };
    return PushNotification;
}();
exports.default = PushNotification;

},{"tslib":"9gMVn","./PlatformNotSupportedError":"gFnTu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gFnTu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var PlatformNotSupportedError = /** @class */ function(_super) {
    (0, _tslib.__extends)(PlatformNotSupportedError, _super);
    function PlatformNotSupportedError() {
        var _this = _super.call(this, "Function not supported on current platform") || this;
        _this.name = "PlatformNotSupportedError";
        return _this;
    }
    return PlatformNotSupportedError;
}(Error);
exports.default = PlatformNotSupportedError;

},{"tslib":"9gMVn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jJxJq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Predictions", ()=>(0, _predictions.Predictions));
parcelHelpers.export(exports, "AmazonAIIdentifyPredictionsProvider", ()=>(0, _providers.AmazonAIIdentifyPredictionsProvider));
parcelHelpers.export(exports, "AmazonAIConvertPredictionsProvider", ()=>(0, _providers.AmazonAIConvertPredictionsProvider));
parcelHelpers.export(exports, "AmazonAIPredictionsProvider", ()=>(0, _providers.AmazonAIPredictionsProvider));
parcelHelpers.export(exports, "AmazonAIInterpretPredictionsProvider", ()=>(0, _providers.AmazonAIInterpretPredictionsProvider));
var _predictions = require("./Predictions");
var _providers = require("./Providers");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Predictions":"f7Ae4","./Providers":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"f7Ae4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PredictionsClass", ()=>PredictionsClass);
parcelHelpers.export(exports, "Predictions", ()=>Predictions);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("Predictions");
var PredictionsClass = /** @class */ function() {
    /**
     * Initialize Predictions with AWS configurations
     * @param {PredictionsOptions} options - Configuration object for Predictions
     */ function PredictionsClass(options) {
        this._options = options;
        this._convertPluggables = [];
        this._identifyPluggables = [];
        this._interpretPluggables = [];
    }
    PredictionsClass.prototype.getModuleName = function() {
        return "Predictions";
    };
    /**
     * add plugin/pluggable into Predictions category
     * @param {Object} pluggable - an instance of the plugin/pluggable
     **/ PredictionsClass.prototype.addPluggable = function(pluggable) {
        if (this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable with name " + pluggable.getProviderName() + " has already been added.");
        var pluggableAdded = false;
        if (this.implementsConvertPluggable(pluggable)) {
            this._convertPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsIdentifyPluggable(pluggable)) {
            this._identifyPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsInterpretPluggable(pluggable)) {
            this._interpretPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (pluggableAdded) this.configurePluggable(pluggable);
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ PredictionsClass.prototype.getPluggable = function(providerName) {
        var pluggable = this.getAllProviders().find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug("No plugin found with providerName=>", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ PredictionsClass.prototype.removePluggable = function(providerName) {
        this._convertPluggables = this._convertPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._identifyPluggables = this._identifyPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._interpretPluggables = this._interpretPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * To make both top level providers and category level providers work with same interface and configuration
     * this method duplicates Predictions config into parent level config (for top level provider) and
     * category level config (such as convert, identify etc) and pass both to each provider.
     */ PredictionsClass.prototype.configure = function(options) {
        var _this = this;
        var predictionsConfig = options ? options.predictions || options : {};
        predictionsConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, predictionsConfig), options);
        this._options = Object.assign({}, this._options, predictionsConfig);
        logger.debug("configure Predictions", this._options);
        this.getAllProviders().forEach(function(pluggable) {
            return _this.configurePluggable(pluggable);
        });
    };
    PredictionsClass.prototype.interpret = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._interpretPluggables, options);
        return pluggableToExecute.interpret(input);
    };
    PredictionsClass.prototype.convert = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._convertPluggables, options);
        return pluggableToExecute.convert(input);
    };
    PredictionsClass.prototype.identify = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._identifyPluggables, options);
        return pluggableToExecute.identify(input);
    };
    // tslint:disable-next-line: max-line-length
    PredictionsClass.prototype.getPluggableToExecute = function(pluggables, providerOptions) {
        // Give preference to provider name first since it is more specific to this call, even if
        // there is only one provider configured to error out if the name provided is not the one matched.
        if (providerOptions && providerOptions.providerName) return (0, _tslib.__spread)(pluggables).find(function(pluggable) {
            return pluggable.getProviderName() === providerOptions.providerName;
        });
        else {
            if (pluggables.length === 1) return pluggables[0];
            else throw new Error("More than one or no providers are configured, Either specify a provider name or configure exactly one provider");
        }
    };
    PredictionsClass.prototype.getAllProviders = function() {
        return (0, _tslib.__spread)(this._convertPluggables, this._identifyPluggables, this._interpretPluggables);
    };
    PredictionsClass.prototype.configurePluggable = function(pluggable) {
        var categoryConfig = Object.assign({}, this._options["predictions"], this._options[pluggable.getCategory().toLowerCase()] // Actual category level config
        );
        pluggable.configure(categoryConfig);
    };
    PredictionsClass.prototype.implementsConvertPluggable = function(obj) {
        return obj && typeof obj.convert === "function";
    };
    PredictionsClass.prototype.implementsIdentifyPluggable = function(obj) {
        return obj && typeof obj.identify === "function";
    };
    PredictionsClass.prototype.implementsInterpretPluggable = function(obj) {
        return obj && typeof obj.interpret === "function";
    };
    return PredictionsClass;
}();
var Predictions = new PredictionsClass({});
(0, _core.Amplify).register(Predictions);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hUBkl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSSRContext", ()=>withSSRContext);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _api = require("@aws-amplify/api");
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _core = require("@aws-amplify/core");
var _datastore = require("@aws-amplify/datastore");
// ! We have to use this exact reference, since it gets mutated with Amplify.Auth
var _index = require("./index");
var requiredModules = [
    // API cannot function without Auth
    (0, _auth.Auth),
    // Auth cannot function without Credentials
    (0, _core.Credentials)
];
// These modules have been tested with SSR
var defaultModules = [
    (0, _api.API),
    (0, _auth.Auth),
    (0, _datastore.DataStore)
];
function withSSRContext(context) {
    if (context === void 0) context = {};
    var _a = context.modules, modules = _a === void 0 ? defaultModules : _a, req = context.req;
    if (modules.includes((0, _datastore.DataStore)) && !modules.includes((0, _internals.InternalAPI))) modules.push((0, _internals.InternalAPI));
    var previousConfig = (0, _index.Amplify).configure();
    var amplify = new (0, _core.AmplifyClass)();
    var storage = new (0, _core.UniversalStorage)({
        req: req
    });
    requiredModules.forEach(function(m) {
        if (!modules.includes(m)) // @ts-ignore This expression is not constructable.
        // Type 'Function' has no construct signatures.ts(2351)
        amplify.register(new m.constructor());
    });
    // Associate new module instances with this amplify
    modules.forEach(function(m) {
        amplify.register(new m.constructor());
    });
    // Configure new Amplify instances with previous configuration
    amplify.configure((0, _tslib.__assign)((0, _tslib.__assign)({}, previousConfig), {
        storage: storage
    }));
    return amplify;
}

},{"tslib":"gEq2D","@aws-amplify/api":"houml","@aws-amplify/api/internals":"lW1BO","@aws-amplify/auth":"6Q2Bh","@aws-amplify/core":"8BDOx","@aws-amplify/datastore":"f78ey","./index":"aGGkJ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gEq2D":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iaWvL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geo", ()=>(0, _geo.Geo));
var _geo = require("./Geo");

},{"./Geo":"cpSON","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cpSON":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeoClass", ()=>GeoClass);
parcelHelpers.export(exports, "Geo", ()=>Geo);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _amazonLocationServiceProvider = require("./Providers/AmazonLocationServiceProvider");
var _util = require("./util");
var logger = new (0, _core.ConsoleLogger)("Geo");
var DEFAULT_PROVIDER = "AmazonLocationService";
var GeoClass = /** @class */ function() {
    function GeoClass() {
        this._config = {};
        this._pluggables = [];
        logger.debug("Geo Options", this._config);
    }
    /**
     * get the name of the module category
     * @returns {string} name of the module category
     */ GeoClass.prototype.getModuleName = function() {
        return GeoClass.MODULE;
    };
    /**
     * add plugin into Geo category
     * @param {Object} pluggable - an instance of the plugin
     */ GeoClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Geo") {
            this._pluggables.push(pluggable);
            var config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ GeoClass.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug("No plugin found with providerName", providerName);
            throw new Error("No plugin found in Geo for the provider");
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ GeoClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Geo
     * @param {Object} config - Configuration object for Geo
     * @return {Object} - Current configuration
     */ GeoClass.prototype.configure = function(config) {
        var _this = this;
        logger.debug("configure Geo");
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Geo, config);
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _amazonLocationServiceProvider.AmazonLocationServiceProvider)());
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @param {string} provider
     * @returns - Array of available map resources
     */ GeoClass.prototype.getAvailableMaps = function(provider) {
        if (provider === void 0) provider = DEFAULT_PROVIDER;
        var prov = this.getPluggable(provider);
        return prov.getAvailableMaps();
    };
    /**
     * Get the map resource set as default in amplify config
     * @param {string} provider
     * @returns - Map resource set as the default in amplify config
     */ GeoClass.prototype.getDefaultMap = function(provider) {
        if (provider === void 0) provider = DEFAULT_PROVIDER;
        var prov = this.getPluggable(provider);
        return prov.getDefaultMap();
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */ GeoClass.prototype.searchByText = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_1;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchByText(text, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_1 = _b.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Search for search term suggestions based on input text
     * @param  {string} text - The text string that is to be search for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<SearchForSuggestionsResults>} - Resolves to an array of search suggestion strings
     */ GeoClass.prototype.searchForSuggestions = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_2;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchForSuggestions(text, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_2 = _b.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Search for location by unique ID
     * @param  {string} placeId - Unique ID of the location that is to be searched for
     * @param  {searchByPlaceIdOptions} options? - Optional parameters to the search
     * @returns {Promise<Place>} - Resolves to a place with the given placeId
     */ GeoClass.prototype.searchByPlaceId = function(placeId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var providerName, prov, error_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        providerName = DEFAULT_PROVIDER;
                        prov = this.getPluggable(providerName);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchByPlaceId(placeId, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        error_3 = _a.sent();
                        logger.debug(error_3);
                        throw error_3;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */ GeoClass.prototype.searchByCoordinates = function(coordinates, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, _b, lng, lat, error_4;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b = (0, _tslib.__read)(coordinates, 2), lng = _b[0], lat = _b[1];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        (0, _util.validateCoordinates)(lng, lat);
                        return [
                            4 /*yield*/ ,
                            prov.searchByCoordinates(coordinates, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 3:
                        error_4 = _c.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create geofences
     * @param geofences - Single or array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<SaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */ GeoClass.prototype.saveGeofences = function(geofences, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, geofenceInputArray, error_5;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        if (!Array.isArray(geofences)) geofenceInputArray = [
                            geofences
                        ];
                        else geofenceInputArray = geofences;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.saveGeofences(geofenceInputArray, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_5 = _b.sent();
                        logger.debug(error_5);
                        throw error_5;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get a single geofence by geofenceId
     * @param geofenceId: GeofenceId - The string id of the geofence to get
     * @param options?: GeofenceOptions - Optional parameters for getting a geofence
     * @returns Promise<Geofence> - Promise that resolves to a geofence object
     */ GeoClass.prototype.getGeofence = function(geofenceId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_6;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.getGeofence(geofenceId, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_6 = _b.sent();
                        logger.debug(error_6);
                        throw error_6;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List geofences
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */ GeoClass.prototype.listGeofences = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_7;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.listGeofences(options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_7 = _b.sent();
                        logger.debug(error_7);
                        throw error_7;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Delete geofences
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */ GeoClass.prototype.deleteGeofences = function(geofenceIds, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, geofenceIdsInputArray, error_8;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        if (!Array.isArray(geofenceIds)) geofenceIdsInputArray = [
                            geofenceIds
                        ];
                        else geofenceIdsInputArray = geofenceIds;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.deleteGeofences(geofenceIdsInputArray, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_8 = _b.sent();
                        logger.debug(error_8);
                        throw error_8;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    GeoClass.MODULE = "Geo";
    return GeoClass;
}();
var Geo = new GeoClass();
(0, _core.Amplify).register(Geo);

},{"tslib":"9gMVn","@aws-amplify/core":"8BDOx","./Providers/AmazonLocationServiceProvider":"6TBSX","./util":"7YMzF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6TBSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmazonLocationServiceProvider", ()=>AmazonLocationServiceProvider);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _camelcaseKeys = require("camelcase-keys");
var _camelcaseKeysDefault = parcelHelpers.interopDefault(_camelcaseKeys);
var _core = require("@aws-amplify/core");
var _clientLocation = require("@aws-sdk/client-location");
var _util = require("../util");
var logger = new (0, _core.ConsoleLogger)("AmazonLocationServiceProvider");
var AmazonLocationServiceProvider = /** @class */ function() {
    /**
     * Initialize Geo with AWS configurations
     * @param {Object} config - Configuration object for Geo
     */ function AmazonLocationServiceProvider(config) {
        this._config = config ? config : {};
        logger.debug("Geo Options", this._config);
    }
    /**
     * get the category of the plugin
     * @returns {string} name of the category
     */ AmazonLocationServiceProvider.prototype.getCategory = function() {
        return AmazonLocationServiceProvider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     * @returns {string} name of the provider
     */ AmazonLocationServiceProvider.prototype.getProviderName = function() {
        return AmazonLocationServiceProvider.PROVIDER_NAME;
    };
    /**
     * Configure Geo part with aws configuration
     * @param {Object} config - Configuration of the Geo
     * @return {Object} - Current configuration
     */ AmazonLocationServiceProvider.prototype.configure = function(config) {
        logger.debug("configure Amazon Location Service Provider", config);
        if (!config) return this._config;
        this._config = Object.assign({}, this._config, config);
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @returns {AmazonLocationServiceMapStyle[]}- Array of available map resources
     */ AmazonLocationServiceProvider.prototype.getAvailableMaps = function() {
        this._verifyMapResources();
        var mapStyles = [];
        var availableMaps = this._config.maps.items;
        var region = this._config.region;
        for(var mapName in availableMaps){
            var style = availableMaps[mapName].style;
            mapStyles.push({
                mapName: mapName,
                style: style,
                region: region
            });
        }
        return mapStyles;
    };
    /**
     * Get the map resource set as default in amplify config
     * @returns {AmazonLocationServiceMapStyle} - Map resource set as the default in amplify config
     */ AmazonLocationServiceProvider.prototype.getDefaultMap = function() {
        this._verifyMapResources();
        var mapName = this._config.maps.default;
        var style = this._config.maps.items[mapName].style;
        var region = this._config.region;
        return {
            mapName: mapName,
            style: style,
            region: region
        };
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */ AmazonLocationServiceProvider.prototype.searchByText = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_1, PascalResults, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */ if (options) locationServiceInput = (0, _tslib.__assign)((0, _tslib.__assign)({}, locationServiceInput), (0, _util.mapSearchOptions)(options, locationServiceInput));
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForTextCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_1 = _a.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 5:
                        PascalResults = response.Results.map(function(result) {
                            return result.Place;
                        });
                        results = (0, _camelcaseKeysDefault.default)(PascalResults, {
                            deep: true
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Search for suggestions based on the input text
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<SearchForSuggestionsResults>} - Resolves to an array of search suggestion strings
     */ AmazonLocationServiceProvider.prototype.searchForSuggestions = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_2, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */ if (options) locationServiceInput = (0, _tslib.__assign)((0, _tslib.__assign)({}, locationServiceInput), (0, _util.mapSearchOptions)(options, locationServiceInput));
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForSuggestionsCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_2 = _a.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 5:
                        results = response.Results.map(function(result) {
                            return {
                                text: result.Text,
                                placeId: result.PlaceId
                            };
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyPlaceId = function(placeId) {
        if (placeId.length === 0) {
            var errorString = "PlaceId cannot be an empty string.";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype.searchByPlaceId = function(placeId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, searchByPlaceIdInput, command, response, error_3, place;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        this._verifyPlaceId(placeId);
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        searchByPlaceIdInput = {
                            PlaceId: placeId,
                            IndexName: (options === null || options === void 0 ? void 0 : options.searchIndexName) || this._config.search_indices.default
                        };
                        command = new (0, _clientLocation.GetPlaceCommand)(searchByPlaceIdInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_3 = _a.sent();
                        logger.debug(error_3);
                        throw error_3;
                    case 5:
                        place = response.Place;
                        if (place) return [
                            2 /*return*/ ,
                            (0, _camelcaseKeysDefault.default)(place, {
                                deep: true
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */ AmazonLocationServiceProvider.prototype.searchByCoordinates = function(coordinates, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_4, PascalResults, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Position: coordinates,
                            IndexName: this._config.search_indices.default
                        };
                        if (options) {
                            if (options.searchIndexName) locationServiceInput.IndexName = options.searchIndexName;
                            locationServiceInput.MaxResults = options.maxResults;
                        }
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForPositionCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_4 = _a.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 5:
                        PascalResults = response.Results.map(function(result) {
                            return result.Place;
                        });
                        results = (0, _camelcaseKeysDefault.default)(PascalResults[0], {
                            deep: true
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Create geofences inside of a geofence collection
     * @param geofences - Array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<AmazonLocationServiceSaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */ AmazonLocationServiceProvider.prototype.saveGeofences = function(geofences, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, PascalGeofences, results, geofenceBatches, apiLimit;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (geofences.length < 1) throw new Error("Geofence input array is empty");
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        (0, _util.validateGeofencesInput)(geofences);
                        PascalGeofences = geofences.map(function(_a) {
                            var geofenceId = _a.geofenceId, polygon = _a.geometry.polygon;
                            return {
                                GeofenceId: geofenceId,
                                Geometry: {
                                    Polygon: polygon
                                }
                            };
                        });
                        results = {
                            successes: [],
                            errors: []
                        };
                        geofenceBatches = [];
                        while(PascalGeofences.length > 0){
                            apiLimit = 10;
                            geofenceBatches.push(PascalGeofences.splice(0, apiLimit));
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(geofenceBatches.map(function(batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var response, error_5;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                _a.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this._AmazonLocationServiceBatchPutGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)
                                                ];
                                            case 1:
                                                response = _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                error_5 = _a.sent();
                                                // If the API call fails, add the geofences to the errors array and move to next batch
                                                batch.forEach(function(geofence) {
                                                    results.errors.push({
                                                        geofenceId: geofence.GeofenceId,
                                                        error: {
                                                            code: "APIConnectionError",
                                                            message: error_5.message
                                                        }
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                // Push all successes to results
                                                response.Successes.forEach(function(success) {
                                                    var GeofenceId = success.GeofenceId, CreateTime = success.CreateTime, UpdateTime = success.UpdateTime;
                                                    results.successes.push({
                                                        geofenceId: GeofenceId,
                                                        createTime: CreateTime,
                                                        updateTime: UpdateTime
                                                    });
                                                });
                                                // Push all errors to results
                                                response.Errors.forEach(function(error) {
                                                    var _a = error.Error, Code = _a.Code, Message = _a.Message, GeofenceId = error.GeofenceId;
                                                    results.errors.push({
                                                        error: {
                                                            code: Code,
                                                            message: Message
                                                        },
                                                        geofenceId: GeofenceId
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Get geofence from a geofence collection
     * @param geofenceId:string
     * @param options?: Optional parameters for getGeofence
     * @returns {Promise<AmazonLocationServiceGeofence>} - Promise that resolves to a geofence object
     */ AmazonLocationServiceProvider.prototype.getGeofence = function(geofenceId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, commandInput, command, response, error_6, GeofenceId, CreateTime, UpdateTime, Status, Geometry, geofence;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        (0, _util.validateGeofenceId)(geofenceId);
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        commandInput = {
                            GeofenceId: geofenceId,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
                        };
                        command = new (0, _clientLocation.GetGeofenceCommand)(commandInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_6 = _a.sent();
                        logger.debug(error_6);
                        throw error_6;
                    case 5:
                        GeofenceId = response.GeofenceId, CreateTime = response.CreateTime, UpdateTime = response.UpdateTime, Status = response.Status, Geometry = response.Geometry;
                        geofence = {
                            createTime: CreateTime,
                            geofenceId: GeofenceId,
                            geometry: {
                                polygon: Geometry.Polygon
                            },
                            status: Status,
                            updateTime: UpdateTime
                        };
                        return [
                            2 /*return*/ ,
                            geofence
                        ];
                }
            });
        });
    };
    /**
     * List geofences from a geofence collection
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */ AmazonLocationServiceProvider.prototype.listGeofences = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, listGeofencesInput, command, response, error_7, NextToken, Entries, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        listGeofencesInput = {
                            NextToken: options === null || options === void 0 ? void 0 : options.nextToken,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
                        };
                        command = new (0, _clientLocation.ListGeofencesCommand)(listGeofencesInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_7 = _a.sent();
                        logger.debug(error_7);
                        throw error_7;
                    case 5:
                        NextToken = response.NextToken, Entries = response.Entries;
                        results = {
                            entries: Entries.map(function(_a) {
                                var GeofenceId = _a.GeofenceId, CreateTime = _a.CreateTime, UpdateTime = _a.UpdateTime, Status = _a.Status, Polygon = _a.Geometry.Polygon;
                                return {
                                    geofenceId: GeofenceId,
                                    createTime: CreateTime,
                                    updateTime: UpdateTime,
                                    status: Status,
                                    geometry: {
                                        polygon: Polygon
                                    }
                                };
                            }),
                            nextToken: NextToken
                        };
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Delete geofences from a geofence collection
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */ AmazonLocationServiceProvider.prototype.deleteGeofences = function(geofenceIds, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, badGeofenceIds, results, geofenceIdBatches, count;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (geofenceIds.length < 1) throw new Error("GeofenceId input array is empty");
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        badGeofenceIds = geofenceIds.filter(function(geofenceId) {
                            try {
                                (0, _util.validateGeofenceId)(geofenceId);
                            } catch (error) {
                                return true;
                            }
                        });
                        if (badGeofenceIds.length > 0) throw new Error("Invalid geofence ids: " + badGeofenceIds.join(", "));
                        results = {
                            successes: [],
                            errors: []
                        };
                        geofenceIdBatches = [];
                        count = 0;
                        while(count < geofenceIds.length)geofenceIdBatches.push(geofenceIds.slice(count, count += 10));
                        return [
                            4 /*yield*/ ,
                            Promise.all(geofenceIdBatches.map(function(batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var response, error_8, badGeofenceIds;
                                    var _a;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                _b.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this._AmazonLocationServiceBatchDeleteGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)
                                                ];
                                            case 1:
                                                response = _b.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                error_8 = _b.sent();
                                                // If the API call fails, add the geofences to the errors array and move to next batch
                                                batch.forEach(function(geofenceId) {
                                                    var errorObject = {
                                                        geofenceId: geofenceId,
                                                        error: {
                                                            code: error_8.message,
                                                            message: error_8.message
                                                        }
                                                    };
                                                    results.errors.push(errorObject);
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                badGeofenceIds = response.Errors.map(function(_a) {
                                                    var geofenceId = _a.geofenceId;
                                                    return geofenceId;
                                                });
                                                (_a = results.successes).push.apply(_a, (0, _tslib.__spread)(batch.filter(function(Id) {
                                                    return !badGeofenceIds.includes(Id);
                                                })));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AmazonLocationServiceProvider.prototype._ensureCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, cred, error_9;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, _core.Credentials).shear(credentials);
                        logger.debug("Set credentials for storage. Credentials are:", cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_9 = _a.sent();
                        logger.debug("Ensure credentials error. Credentials are:", error_9);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyMapResources = function() {
        if (!this._config.maps) {
            var errorString = "No map resources found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
        if (!this._config.maps.default) {
            var errorString = "No default map resource found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifySearchIndex = function(optionalSearchIndex) {
        if ((!this._config.search_indices || !this._config.search_indices.default) && !optionalSearchIndex) {
            var errorString = "No Search Index found in amplify config, please run `amplify add geo` to create one and run `amplify push` after.";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifyGeofenceCollections = function(optionalGeofenceCollectionName) {
        if ((!this._config.geofenceCollections || !this._config.geofenceCollections.default) && !optionalGeofenceCollectionName) {
            var errorString = "No Geofence Collections found, please run `amplify add geo` to create one and run `amplify push` after.";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchPutGeofenceCall = function(PascalGeofences, collectionName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var geofenceInput, client, command, response, error_10;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        geofenceInput = {
                            Entries: PascalGeofences,
                            CollectionName: collectionName || this._config.geofenceCollections.default
                        };
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.BatchPutGeofenceCommand)(geofenceInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_10 = _a.sent();
                        throw error_10;
                    case 4:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchDeleteGeofenceCall = function(geofenceIds, collectionName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var deleteGeofencesInput, client, command, response, error_11;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        deleteGeofencesInput = {
                            GeofenceIds: geofenceIds,
                            CollectionName: collectionName || this._config.geofenceCollections.default
                        };
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.BatchDeleteGeofenceCommand)(deleteGeofencesInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_11 = _a.sent();
                        throw error_11;
                    case 4:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.CATEGORY = "Geo";
    AmazonLocationServiceProvider.PROVIDER_NAME = "AmazonLocationService";
    return AmazonLocationServiceProvider;
}();

},{"tslib":"9gMVn","camelcase-keys":"jwzMw","@aws-amplify/core":"8BDOx","@aws-sdk/client-location":"4LSOt","../util":"7YMzF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jwzMw":[function(require,module,exports) {
"use strict";
const mapObj = require("bb83174fd2ff41c9");
const camelCase = require("cca3cebeca29a2f8");
const QuickLru = require("f54dcd543b16f228");
const has = (array, key)=>array.some((x)=>{
        if (typeof x === "string") return x === key;
        x.lastIndex = 0;
        return x.test(key);
    });
const cache = new QuickLru({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`
const isObject = (value)=>typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const camelCaseConvert = (input, options)=>{
    if (!isObject(input)) return input;
    options = {
        deep: false,
        pascalCase: false,
        ...options
    };
    const { exclude, pascalCase, stopPaths, deep } = options;
    const stopPathsSet = new Set(stopPaths);
    const makeMapper = (parentPath)=>(key, value)=>{
            if (deep && isObject(value)) {
                const path = parentPath === undefined ? key : `${parentPath}.${key}`;
                if (!stopPathsSet.has(path)) value = mapObj(value, makeMapper(path));
            }
            if (!(exclude && has(exclude, key))) {
                const cacheKey = pascalCase ? `${key}_` : key;
                if (cache.has(cacheKey)) key = cache.get(cacheKey);
                else {
                    const ret = camelCase(key, {
                        pascalCase
                    });
                    if (key.length < 100) cache.set(cacheKey, ret);
                    key = ret;
                }
            }
            return [
                key,
                value
            ];
        };
    return mapObj(input, makeMapper(undefined));
};
module.exports = (input, options)=>{
    if (Array.isArray(input)) return Object.keys(input).map((key)=>camelCaseConvert(input[key], options));
    return camelCaseConvert(input, options);
};

},{"bb83174fd2ff41c9":"euKuX","cca3cebeca29a2f8":"eAsgX","f54dcd543b16f228":"2YeAK"}],"euKuX":[function(require,module,exports) {
"use strict";
const isObject = (value)=>typeof value === "object" && value !== null;
const mapObjectSkip = Symbol("skip");
// Customized for this use-case
const isObjectCustom = (value)=>isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObject = (object, mapper, options, isSeen = new WeakMap())=>{
    options = {
        deep: false,
        target: {},
        ...options
    };
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    const { target } = options;
    delete options.target;
    const mapArray = (array)=>array.map((element)=>isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element);
    if (Array.isArray(object)) return mapArray(object);
    for (const [key, value] of Object.entries(object)){
        const mapResult = mapper(key, value, object);
        if (mapResult === mapObjectSkip) continue;
        let [newKey, newValue, { shouldRecurse = true } = {}] = mapResult;
        // Drop `__proto__` keys.
        if (newKey === "__proto__") continue;
        if (options.deep && shouldRecurse && isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
        target[newKey] = newValue;
    }
    return target;
};
module.exports = (object, mapper, options)=>{
    if (!isObject(object)) throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
    return mapObject(object, mapper, options);
};
module.exports.mapObjectSkip = mapObjectSkip;

},{}],"eAsgX":[function(require,module,exports) {
"use strict";
const preserveCamelCase = (string)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && /[a-zA-Z]/.test(character) && character.toUpperCase() === character) {
            string = string.slice(0, i) + "-" + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(character) && character.toLowerCase() === character) {
            string = string.slice(0, i - 1) + "-" + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = character.toLowerCase() === character && character.toUpperCase() !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = character.toUpperCase() === character && character.toLowerCase() !== character;
        }
    }
    return string;
};
const camelCase = (input, options)=>{
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = Object.assign({
        pascalCase: false
    }, options);
    const postProcess = (x)=>options.pascalCase ? x.charAt(0).toUpperCase() + x.slice(1) : x;
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    if (input.length === 1) return options.pascalCase ? input.toUpperCase() : input.toLowerCase();
    const hasUpperCase = input !== input.toLowerCase();
    if (hasUpperCase) input = preserveCamelCase(input);
    input = input.replace(/^[_.\- ]+/, "").toLowerCase().replace(/[_.\- ]+(\w|$)/g, (_, p1)=>p1.toUpperCase()).replace(/\d+(\w|$)/g, (m)=>m.toUpperCase());
    return postProcess(input);
};
module.exports = camelCase;
// TODO: Remove this for the next major release
module.exports.default = camelCase;

},{}],"2YeAK":[function(require,module,exports) {
"use strict";
class QuickLRU {
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) {
            const value = this.oldCache.get(key);
            this.oldCache.delete(key);
            this._set(key, value);
            return value;
        }
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.set(key, value);
        else this._set(key, value);
        return this;
    }
    has(key) {
        return this.cache.has(key) || this.oldCache.has(key);
    }
    peek(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) return this.oldCache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache)yield item;
        for (const item of this.oldCache){
            const [key] = item;
            if (!this.cache.has(key)) yield item;
        }
    }
    get size() {
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return this._size + oldCacheSize;
    }
    constructor(options = {}){
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError("`maxSize` must be a number greater than 0");
        this.maxSize = options.maxSize;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
}
module.exports = QuickLRU;

},{}],"4LSOt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationServiceException", ()=>(0, _locationServiceException.LocationServiceException));
var _location = require("./Location");
parcelHelpers.exportAll(_location, exports);
var _locationClient = require("./LocationClient");
parcelHelpers.exportAll(_locationClient, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _pagination = require("./pagination");
parcelHelpers.exportAll(_pagination, exports);
var _locationServiceException = require("./models/LocationServiceException");

},{"./Location":false,"./LocationClient":"8UvBu","./commands":"82sgA","./models":false,"./pagination":false,"./models/LocationServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8UvBu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationClient", ()=>LocationClient);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LocationClient = function(_super) {
    (0, _tslib.__extends)(LocationClient, _super);
    function LocationClient(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LocationClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LocationClient;
}((0, _smithyClient.Client));

},{"tslib":"55hEF","@aws-sdk/config-resolver":"7gbZ0","@aws-sdk/middleware-content-length":"1Z2wN","@aws-sdk/middleware-host-header":"9Xtil","@aws-sdk/middleware-logger":"9FBQP","@aws-sdk/middleware-recursion-detection":"keLZi","@aws-sdk/middleware-retry":"2jRux","@aws-sdk/middleware-signing":"3s4zC","@aws-sdk/middleware-user-agent":"e3U3z","@aws-sdk/smithy-client":"l83SD","./runtimeConfig":"9Fwrp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"55hEF":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7gbZ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"6KeRu","./regionConfig":"7KGjl","./regionInfo":"ZNEmH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6KeRu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"8LLkv","./NodeUseFipsEndpointConfigOptions":"1mmZb","./resolveCustomEndpointsConfig":"coz9O","./resolveEndpointsConfig":"3XKum","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8LLkv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", ()=>ENV_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", ()=>CONFIG_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", ()=>DEFAULT_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"a0aP5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1mmZb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", ()=>ENV_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", ()=>CONFIG_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", ()=>DEFAULT_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"a0aP5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"coz9O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", ()=>resolveCustomEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"55hEF","@aws-sdk/util-middleware":"anyI5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3XKum":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", ()=>resolveEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"55hEF","@aws-sdk/util-middleware":"anyI5","./utils/getEndpointFromRegion":"D6mxc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"D6mxc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", ()=>getEndpointFromRegion);
var _tslib = require("tslib");
var getEndpointFromRegion = function(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7KGjl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"8VDEs","./resolveRegionConfig":"6Jy9j","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8VDEs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", ()=>REGION_ENV_NAME);
parcelHelpers.export(exports, "REGION_INI_NAME", ()=>REGION_INI_NAME);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", ()=>NODE_REGION_CONFIG_OPTIONS);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", ()=>NODE_REGION_CONFIG_FILE_OPTIONS);
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6Jy9j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", ()=>resolveRegionConfig);
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"55hEF","./getRealRegion":"fkVDU","./isFipsRegion":"idTkM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fkVDU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", ()=>getRealRegion);
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"idTkM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"idTkM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", ()=>isFipsRegion);
var isFipsRegion = function(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ZNEmH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"2Ku2K","./RegionHash":"1vQwY","./getRegionInfo":"3cbgd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2Ku2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1vQwY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3cbgd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", ()=>getRegionInfo);
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"55hEF","./getHostnameFromVariants":"chnVe","./getResolvedHostname":"kvrkV","./getResolvedPartition":"a9tqP","./getResolvedSigningRegion":"eYDwB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"chnVe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", ()=>getHostnameFromVariants);
var getHostnameFromVariants = function(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kvrkV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", ()=>getResolvedHostname);
var getResolvedHostname = function(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a9tqP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", ()=>getResolvedPartition);
var getResolvedPartition = function(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eYDwB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", ()=>getResolvedSigningRegion);
var getResolvedSigningRegion = function(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Z2wN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", ()=>contentLengthMiddleware);
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", ()=>contentLengthMiddlewareOptions);
parcelHelpers.export(exports, "getContentLengthPlugin", ()=>getContentLengthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"j4nIU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"8qlZ5","./httpRequest":"iutgu","./httpResponse":"3UoZb","./isValidHostname":"9TJAm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8qlZ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iutgu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3UoZb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9TJAm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Xtil":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9FBQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"dcHbV","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dcHbV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"keLZi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recursionDetectionMiddleware", ()=>recursionDetectionMiddleware);
parcelHelpers.export(exports, "addRecursionDetectionMiddlewareOptions", ()=>addRecursionDetectionMiddlewareOptions);
parcelHelpers.export(exports, "getRecursionDetectionPlugin", ()=>getRecursionDetectionPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var process = require("a2e3b8ecede8522b");
var TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
var ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
var ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
var recursionDetectionMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, functionName, traceId, nonEmptyString;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if (!(0, _protocolHttp.HttpRequest).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) return [
                        2,
                        next(args)
                    ];
                    functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
                    traceId = process.env[ENV_TRACE_ID];
                    nonEmptyString = function(str) {
                        return typeof str === "string" && str.length > 0;
                    };
                    if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[TRACE_ID_HEADER_NAME] = traceId;
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
};
var addRecursionDetectionMiddlewareOptions = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
var getRecursionDetectionPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(recursionDetectionMiddleware(options), addRecursionDetectionMiddlewareOptions);
        }
    };
};

},{"a2e3b8ecede8522b":"g1F5c","tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2jRux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"euCij","./DefaultRateLimiter":"dtV6j","./StandardRetryStrategy":"dOuyn","./config":"ekz2C","./configurations":"j8vZf","./delayDecider":"O4RHk","./omitRetryHeadersMiddleware":"5mHe4","./retryDecider":"cOkZ6","./retryMiddleware":"aBu3M","./types":"8thu9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"euCij":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", ()=>AdaptiveRetryStrategy);
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"55hEF","./config":"ekz2C","./DefaultRateLimiter":"dtV6j","./StandardRetryStrategy":"dOuyn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ekz2C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", ()=>RETRY_MODES);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", ()=>DEFAULT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", ()=>DEFAULT_RETRY_MODE);
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dtV6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", ()=>DefaultRateLimiter);
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"55hEF","@aws-sdk/service-error-classification":"26Yem","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"26Yem":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", ()=>isRetryableByTrait);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
parcelHelpers.export(exports, "isThrottlingError", ()=>isThrottlingError);
parcelHelpers.export(exports, "isTransientError", ()=>isTransientError);
var _constants = require("./constants");
var isRetryableByTrait = function(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"lWSf8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lWSf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", ()=>CLOCK_SKEW_ERROR_CODES);
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", ()=>THROTTLING_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", ()=>TRANSIENT_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", ()=>TRANSIENT_ERROR_STATUS_CODES);
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", ()=>NODEJS_TIMEOUT_ERROR_CODES);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dOuyn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", ()=>StandardRetryStrategy);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","@aws-sdk/service-error-classification":"26Yem","uuid":"fbY0h","./config":"ekz2C","./constants":"lg6tX","./defaultRetryQuota":"eaXSa","./delayDecider":"O4RHk","./retryDecider":"cOkZ6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fbY0h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"8Hd9X","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8Hd9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"7iJfG","./stringify.js":"jzeS4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7iJfG":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jzeS4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"7brPO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7brPO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"3Uwqa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Uwqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lg6tX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", ()=>DEFAULT_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", ()=>MAXIMUM_RETRY_DELAY);
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", ()=>THROTTLING_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", ()=>INITIAL_RETRY_TOKENS);
parcelHelpers.export(exports, "RETRY_COST", ()=>RETRY_COST);
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", ()=>TIMEOUT_RETRY_COST);
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", ()=>NO_RETRY_INCREMENT);
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", ()=>INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "REQUEST_HEADER", ()=>REQUEST_HEADER);
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eaXSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", ()=>getDefaultRetryQuota);
var _constants = require("./constants");
var getDefaultRetryQuota = function(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"lg6tX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"O4RHk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", ()=>defaultDelayDecider);
var _constants = require("./constants");
var defaultDelayDecider = function(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"lg6tX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cOkZ6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", ()=>defaultRetryDecider);
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"26Yem","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"j8vZf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", ()=>ENV_MAX_ATTEMPTS);
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", ()=>CONFIG_MAX_ATTEMPTS);
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", ()=>NODE_MAX_ATTEMPT_CONFIG_OPTIONS);
parcelHelpers.export(exports, "resolveRetryConfig", ()=>resolveRetryConfig);
parcelHelpers.export(exports, "ENV_RETRY_MODE", ()=>ENV_RETRY_MODE);
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", ()=>CONFIG_RETRY_MODE);
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", ()=>NODE_RETRY_MODE_CONFIG_OPTIONS);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"55hEF","@aws-sdk/util-middleware":"anyI5","./AdaptiveRetryStrategy":"euCij","./config":"ekz2C","./StandardRetryStrategy":"dOuyn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5mHe4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", ()=>omitRetryHeadersMiddleware);
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", ()=>omitRetryHeadersMiddlewareOptions);
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", ()=>getOmitRetryHeadersPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","./constants":"lg6tX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aBu3M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
parcelHelpers.export(exports, "retryMiddlewareOptions", ()=>retryMiddlewareOptions);
parcelHelpers.export(exports, "getRetryPlugin", ()=>getRetryPlugin);
var _tslib = require("tslib");
var retryMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8thu9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3s4zC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"lrgkT","./middleware":"eEXUj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lrgkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", ()=>resolveAwsAuthConfig);
parcelHelpers.export(exports, "resolveSigV4AuthConfig", ()=>resolveSigV4AuthConfig);
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"55hEF","@aws-sdk/property-provider":"4UJmr","@aws-sdk/signature-v4":"hyvri","@aws-sdk/util-middleware":"anyI5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4UJmr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"9lqKz","./ProviderError":"aSwfx","./TokenProviderError":"5ENgR","./chain":"g65EG","./fromStatic":"e07im","./memoize":"1uEZ1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9lqKz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", ()=>CredentialsProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"55hEF","./ProviderError":"aSwfx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aSwfx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", ()=>ProviderError);
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5ENgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", ()=>TokenProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"55hEF","./ProviderError":"aSwfx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g65EG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"55hEF","./ProviderError":"aSwfx","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e07im":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", ()=>fromStatic);
var fromStatic = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1uEZ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
var _tslib = require("tslib");
var memoize = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hyvri":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>(0, _getCanonicalHeaders.getCanonicalHeaders));
parcelHelpers.export(exports, "getCanonicalQuery", ()=>(0, _getCanonicalQuery.getCanonicalQuery));
parcelHelpers.export(exports, "getPayloadHash", ()=>(0, _getPayloadHash.getPayloadHash));
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>(0, _moveHeadersToQuery.moveHeadersToQuery));
parcelHelpers.export(exports, "prepareRequest", ()=>(0, _prepareRequest.prepareRequest));
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"8MtEg","./getCanonicalHeaders":"6VwjX","./getCanonicalQuery":"4etDr","./getPayloadHash":"1Sdnd","./moveHeadersToQuery":"8TQ7r","./prepareRequest":"e0T59","./credentialDerivation":"cEP9Z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8MtEg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"tslib":"55hEF","@aws-sdk/util-hex-encoding":"bNeC8","@aws-sdk/util-middleware":"anyI5","./constants":"lsSPL","./credentialDerivation":"cEP9Z","./getCanonicalHeaders":"6VwjX","./getCanonicalQuery":"4etDr","./getPayloadHash":"1Sdnd","./headerUtil":"jKm5z","./moveHeadersToQuery":"8TQ7r","./prepareRequest":"e0T59","./utilDate":"ac8ww","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bNeC8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lsSPL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", ()=>ALGORITHM_IDENTIFIER_V4A);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cEP9Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"55hEF","@aws-sdk/util-hex-encoding":"bNeC8","./constants":"lsSPL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6VwjX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"55hEF","./constants":"lsSPL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4etDr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"55hEF","@aws-sdk/util-uri-escape":"1m6jU","./constants":"lsSPL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1m6jU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"cKNBB","./escape-uri-path":"4WMX2","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cKNBB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
var escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4WMX2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
var escapeUriPath = function(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"cKNBB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Sdnd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"55hEF","@aws-sdk/is-array-buffer":"64iYU","@aws-sdk/util-hex-encoding":"bNeC8","./constants":"lsSPL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"64iYU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jKm5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
parcelHelpers.export(exports, "getHeaderValue", ()=>getHeaderValue);
parcelHelpers.export(exports, "deleteHeader", ()=>deleteHeader);
var _tslib = require("tslib");
var hasHeader = function(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8TQ7r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"55hEF","./cloneRequest":"5wWbF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5wWbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
parcelHelpers.export(exports, "cloneQuery", ()=>cloneQuery);
var _tslib = require("tslib");
var cloneRequest = function(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e0T59":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"55hEF","./cloneRequest":"5wWbF","./constants":"lsSPL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ac8ww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
var iso8601 = function(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eEXUj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", ()=>awsAuthMiddleware);
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", ()=>awsAuthMiddlewareOptions);
parcelHelpers.export(exports, "getAwsAuthPlugin", ()=>getAwsAuthPlugin);
parcelHelpers.export(exports, "getSigV4AuthPlugin", ()=>getSigV4AuthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","./utils/getSkewCorrectedDate":"4ZtWQ","./utils/getUpdatedSystemClockOffset":"e1cVv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4ZtWQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e1cVv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"dx7EC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dx7EC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"4ZtWQ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e3U3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"aeEhJ","./user-agent-middleware":"iVvEq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aeEhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iVvEq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","./constants":"26odT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"26odT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l83SD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"1or4P","./command":"lsBhF","./constants":"5QkQV","./date-utils":"dSyDg","./default-error-handler":"8QPRs","./defaults-mode":"8BOvG","./emitWarningIfUnsupportedVersion":"13e0B","./exceptions":"9x9qb","./extended-encode-uri-component":"e21Fd","./get-array-if-single-item":"hLzRu","./get-value-from-text-node":"dSXZc","./lazy-json":"1CShG","./object-mapping":"d3T1Z","./parse-utils":"9bjgp","./resolve-path":"eppn4","./ser-utils":"iA95d","./split-every":"i9lp0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1or4P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"982v6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"982v6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"4L9M8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4L9M8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", ()=>constructStack);
var _tslib = require("tslib");
var constructStack = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"'.concat(name, '" middleware with ').concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"'.concat(name, '" middleware ').concat(toOverride.relation, ' "').concat(toOverride.toMiddleware, '" middleware cannot be overridden ') + "by same-name middleware ".concat(entry.relation, ' "').concat(entry.toMiddleware, '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo(constructStack());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lsBhF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"982v6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5QkQV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", ()=>SENSITIVE_STRING);
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dSyDg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", ()=>dateToUtcString);
parcelHelpers.export(exports, "parseRfc3339DateTime", ()=>parseRfc3339DateTime);
parcelHelpers.export(exports, "parseRfc7231DateTime", ()=>parseRfc7231DateTime);
parcelHelpers.export(exports, "parseEpochTimestamp", ()=>parseEpochTimestamp);
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"55hEF","./parse-utils":"9bjgp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9bjgp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", ()=>parseBoolean);
parcelHelpers.export(exports, "expectBoolean", ()=>expectBoolean);
parcelHelpers.export(exports, "expectNumber", ()=>expectNumber);
parcelHelpers.export(exports, "expectFloat32", ()=>expectFloat32);
parcelHelpers.export(exports, "expectLong", ()=>expectLong);
parcelHelpers.export(exports, "expectInt", ()=>expectInt);
parcelHelpers.export(exports, "expectInt32", ()=>expectInt32);
parcelHelpers.export(exports, "expectShort", ()=>expectShort);
parcelHelpers.export(exports, "expectByte", ()=>expectByte);
parcelHelpers.export(exports, "expectNonNull", ()=>expectNonNull);
parcelHelpers.export(exports, "expectObject", ()=>expectObject);
parcelHelpers.export(exports, "expectString", ()=>expectString);
parcelHelpers.export(exports, "expectUnion", ()=>expectUnion);
parcelHelpers.export(exports, "strictParseDouble", ()=>strictParseDouble);
parcelHelpers.export(exports, "strictParseFloat", ()=>strictParseFloat);
parcelHelpers.export(exports, "strictParseFloat32", ()=>strictParseFloat32);
parcelHelpers.export(exports, "limitedParseDouble", ()=>limitedParseDouble);
parcelHelpers.export(exports, "handleFloat", ()=>handleFloat);
parcelHelpers.export(exports, "limitedParseFloat", ()=>limitedParseFloat);
parcelHelpers.export(exports, "limitedParseFloat32", ()=>limitedParseFloat32);
parcelHelpers.export(exports, "strictParseLong", ()=>strictParseLong);
parcelHelpers.export(exports, "strictParseInt", ()=>strictParseInt);
parcelHelpers.export(exports, "strictParseInt32", ()=>strictParseInt32);
parcelHelpers.export(exports, "strictParseShort", ()=>strictParseShort);
parcelHelpers.export(exports, "strictParseByte", ()=>strictParseByte);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var parseBoolean = function(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error('Unable to parse boolean value "'.concat(value, '"'));
    }
};
var expectBoolean = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value, ": ").concat(value));
};
var expectNumber = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value, ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value, ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value, ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value, ": ").concat(value));
};
var expectUnion = function(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8QPRs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", ()=>throwDefaultError);
var _exceptions = require("./exceptions");
var throwDefaultError = function(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"9x9qb","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9x9qb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", ()=>ServiceException);
parcelHelpers.export(exports, "decorateServiceException", ()=>decorateServiceException);
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8BOvG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", ()=>loadConfigsForDefaultMode);
var loadConfigsForDefaultMode = function(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"13e0B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", ()=>emitWarningIfUnsupportedVersion);
var process = require("5d372f430481d1db");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"5d372f430481d1db":"g1F5c","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e21Fd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hLzRu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", ()=>getArrayIfSingleItem);
var getArrayIfSingleItem = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dSXZc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", ()=>getValueFromTextNode);
var getValueFromTextNode = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1CShG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", ()=>StringWrapper);
parcelHelpers.export(exports, "LazyJsonString", ()=>LazyJsonString);
var _tslib = require("tslib");
var StringWrapper = function() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d3T1Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "convertMap", ()=>convertMap);
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eppn4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", ()=>resolvedPath);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function(resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};

},{"./extended-encode-uri-component":"e21Fd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iA95d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", ()=>serializeFloat);
var serializeFloat = function(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"i9lp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", ()=>splitEvery);
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Fwrp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, _sha256Browser.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"55hEF","../package.json":"1z5xS","@aws-crypto/sha256-browser":"gbEZU","@aws-sdk/config-resolver":"7gbZ0","@aws-sdk/fetch-http-handler":"hd2EH","@aws-sdk/invalid-dependency":"aesoN","@aws-sdk/middleware-retry":"2jRux","@aws-sdk/util-base64-browser":"icaj0","@aws-sdk/util-body-length-browser":"8mPCV","@aws-sdk/util-user-agent-browser":"8lVY5","@aws-sdk/util-utf8-browser":"e11Pq","./runtimeConfig.shared":"9EUgB","@aws-sdk/smithy-client":"l83SD","@aws-sdk/util-defaults-mode-browser":"94fY5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1z5xS":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-location","description":"AWS SDK for JavaScript Location Client for Node.js, Browser and React Native","version":"3.186.3","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"tsc -p tsconfig.cjs.json","build:docs":"typedoc","build:es":"tsc -p tsconfig.es.json","build:include:deps":"lerna run --scope $npm_package_name --include-dependencies build","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"2.0.0","@aws-crypto/sha256-js":"2.0.0","@aws-sdk/client-sts":"3.186.3","@aws-sdk/config-resolver":"3.186.0","@aws-sdk/credential-provider-node":"3.186.0","@aws-sdk/fetch-http-handler":"3.186.0","@aws-sdk/hash-node":"3.186.0","@aws-sdk/invalid-dependency":"3.186.0","@aws-sdk/middleware-content-length":"3.186.0","@aws-sdk/middleware-host-header":"3.186.0","@aws-sdk/middleware-logger":"3.186.0","@aws-sdk/middleware-recursion-detection":"3.186.0","@aws-sdk/middleware-retry":"3.186.0","@aws-sdk/middleware-serde":"3.186.0","@aws-sdk/middleware-signing":"3.186.0","@aws-sdk/middleware-stack":"3.186.0","@aws-sdk/middleware-user-agent":"3.186.0","@aws-sdk/node-config-provider":"3.186.0","@aws-sdk/node-http-handler":"3.186.0","@aws-sdk/protocol-http":"3.186.0","@aws-sdk/smithy-client":"3.186.0","@aws-sdk/types":"3.186.0","@aws-sdk/url-parser":"3.186.0","@aws-sdk/util-base64-browser":"3.186.0","@aws-sdk/util-base64-node":"3.186.0","@aws-sdk/util-body-length-browser":"3.186.0","@aws-sdk/util-body-length-node":"3.186.0","@aws-sdk/util-defaults-mode-browser":"3.186.0","@aws-sdk/util-defaults-mode-node":"3.186.0","@aws-sdk/util-user-agent-browser":"3.186.0","@aws-sdk/util-user-agent-node":"3.186.0","@aws-sdk/util-utf8-browser":"3.186.0","@aws-sdk/util-utf8-node":"3.186.0","tslib":"^2.3.1"},"devDependencies":{"@aws-sdk/service-client-documentation-generator":"3.186.0","@tsconfig/recommended":"1.0.1","@types/node":"^12.7.5","concurrently":"7.0.0","downlevel-dts":"0.10.1","rimraf":"3.0.2","typedoc":"0.19.2","typescript":"~4.6.2"},"overrides":{"typedoc":{"typescript":"~4.6.2"}},"engines":{"node":">=12.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-location","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-location"}}');

},{}],"gbEZU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("2c225c7bd6ec0fe");
(0, tslib_1.__exportStar)(require("17fd527626e0957b"), exports);
var ie11Sha256_1 = require("b94d2f24e70883f0");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("3c3335554c325413");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"2c225c7bd6ec0fe":"gel1E","17fd527626e0957b":"eA5uG","b94d2f24e70883f0":"3Wcwm","3c3335554c325413":"iqEc1"}],"gel1E":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eA5uG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("c668b1c6d918bcf6");
var webCryptoSha256_1 = require("eeda03e8bf347205");
var sha256_js_1 = require("39b1cf8cf20b539e");
var supports_web_crypto_1 = require("52eba68e276c6ae3");
var ie11_detection_1 = require("94511351fb1d82e6");
var util_locate_window_1 = require("65ca30ea13342516");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"c668b1c6d918bcf6":"3Wcwm","eeda03e8bf347205":"iqEc1","39b1cf8cf20b539e":"8pXUG","52eba68e276c6ae3":"53zHj","94511351fb1d82e6":"a05nX","65ca30ea13342516":"iQfdF"}],"3Wcwm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("a38a5551ac6d8db2");
var constants_1 = require("c08111ec498c1a04");
var util_utf8_browser_1 = require("6ecfdac05b8dbe2b");
var util_locate_window_1 = require("9d645356577258e3");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"a38a5551ac6d8db2":"iop9B","c08111ec498c1a04":"jytAf","6ecfdac05b8dbe2b":"e11Pq","9d645356577258e3":"iQfdF"}],"iop9B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"jytAf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"e11Pq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"dp1VO","./whatwgEncodingApi":"7wBst","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dp1VO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7wBst":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iqEc1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("92792c9325c69b4b");
var constants_1 = require("250c7f026fb5aedc");
var util_locate_window_1 = require("8f9e852ccf95572b");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"92792c9325c69b4b":"aHzAk","250c7f026fb5aedc":"jytAf","8f9e852ccf95572b":"iQfdF"}],"aHzAk":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("6970649ba32f1037");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("3cab579e81cbc793");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("60a229355ca01f85");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("9df39cb9b7de08d0");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"6970649ba32f1037":"l5ZWW","3cab579e81cbc793":"jPORx","60a229355ca01f85":"739iO","9df39cb9b7de08d0":"jabRy"}],"l5ZWW":[function(require,module,exports) {
var Buffer = require("34441391e056678b").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("f03a51a5418c7d38");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"34441391e056678b":"8EcTH","f03a51a5418c7d38":"e11Pq"}],"jPORx":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"739iO":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"jabRy":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"8pXUG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("20c2714b53edfe01");
(0, tslib_1.__exportStar)(require("513196a22bbc18cf"), exports);

},{"20c2714b53edfe01":"b62pJ","513196a22bbc18cf":"liU0B"}],"b62pJ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"liU0B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("c06a41fb36a29a5");
var constants_1 = require("2dc139b64fda8f50");
var RawSha256_1 = require("aff94597fafaa776");
var util_1 = require("28ce9add8905c498");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"c06a41fb36a29a5":"b62pJ","2dc139b64fda8f50":"9CS2J","aff94597fafaa776":"4ahas","28ce9add8905c498":"aHzAk"}],"9CS2J":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"4ahas":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("24d866a02214a751");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"24d866a02214a751":"9CS2J"}],"53zHj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("6e3c17eeb0c4fc72");
tslib_1.__exportStar(require("f9aef6f49e6927f"), exports);

},{"6e3c17eeb0c4fc72":"lgogd","f9aef6f49e6927f":"hE8jv"}],"lgogd":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hE8jv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("e4ab527815ab542b");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"e4ab527815ab542b":"lgogd"}],"a05nX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("b50b9aa22aecfe99");
tslib_1.__exportStar(require("e3ed86ecc71f3053"), exports);
tslib_1.__exportStar(require("aadf0a87a5a4af6"), exports);
tslib_1.__exportStar(require("46bfbd58b14d6ddd"), exports);
tslib_1.__exportStar(require("df010a1df45e9da0"), exports);
tslib_1.__exportStar(require("d2102a2d7714dbcd"), exports);

},{"b50b9aa22aecfe99":"aDCnL","e3ed86ecc71f3053":"gEEwq","aadf0a87a5a4af6":"57l1h","46bfbd58b14d6ddd":"2qbYw","df010a1df45e9da0":"lP4kT","d2102a2d7714dbcd":"aJEVX"}],"aDCnL":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gEEwq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"57l1h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"2qbYw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"lP4kT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"aJEVX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"hd2EH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"aaG0M","./stream-collector":"eQ2Hh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aaG0M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","@aws-sdk/querystring-builder":"dk3U6","./request-timeout":"aMIUo","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dk3U6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"55hEF","@aws-sdk/util-uri-escape":"1m6jU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aMIUo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eQ2Hh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"55hEF","@aws-sdk/util-base64-browser":"icaj0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"icaj0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aesoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"jvTo9","./invalidProvider":"7lIpU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jvTo9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", ()=>invalidFunction);
var invalidFunction = function(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7lIpU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", ()=>invalidProvider);
var invalidProvider = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8mPCV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"tPAJf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"tPAJf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", ()=>calculateBodyLength);
var calculateBodyLength = function(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8lVY5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"55hEF","bowser":"oLvzi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9EUgB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2020-11-19",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Location",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"dAkAB","./endpoints":"gwGNn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dAkAB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function(url) {
    if (typeof url === "string") return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"lwlu5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lwlu5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gwGNn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "geo",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"55hEF","@aws-sdk/config-resolver":"7gbZ0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"82sgA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _associateTrackerConsumerCommand = require("./AssociateTrackerConsumerCommand");
parcelHelpers.exportAll(_associateTrackerConsumerCommand, exports);
var _batchDeleteDevicePositionHistoryCommand = require("./BatchDeleteDevicePositionHistoryCommand");
parcelHelpers.exportAll(_batchDeleteDevicePositionHistoryCommand, exports);
var _batchDeleteGeofenceCommand = require("./BatchDeleteGeofenceCommand");
parcelHelpers.exportAll(_batchDeleteGeofenceCommand, exports);
var _batchEvaluateGeofencesCommand = require("./BatchEvaluateGeofencesCommand");
parcelHelpers.exportAll(_batchEvaluateGeofencesCommand, exports);
var _batchGetDevicePositionCommand = require("./BatchGetDevicePositionCommand");
parcelHelpers.exportAll(_batchGetDevicePositionCommand, exports);
var _batchPutGeofenceCommand = require("./BatchPutGeofenceCommand");
parcelHelpers.exportAll(_batchPutGeofenceCommand, exports);
var _batchUpdateDevicePositionCommand = require("./BatchUpdateDevicePositionCommand");
parcelHelpers.exportAll(_batchUpdateDevicePositionCommand, exports);
var _calculateRouteCommand = require("./CalculateRouteCommand");
parcelHelpers.exportAll(_calculateRouteCommand, exports);
var _calculateRouteMatrixCommand = require("./CalculateRouteMatrixCommand");
parcelHelpers.exportAll(_calculateRouteMatrixCommand, exports);
var _createGeofenceCollectionCommand = require("./CreateGeofenceCollectionCommand");
parcelHelpers.exportAll(_createGeofenceCollectionCommand, exports);
var _createMapCommand = require("./CreateMapCommand");
parcelHelpers.exportAll(_createMapCommand, exports);
var _createPlaceIndexCommand = require("./CreatePlaceIndexCommand");
parcelHelpers.exportAll(_createPlaceIndexCommand, exports);
var _createRouteCalculatorCommand = require("./CreateRouteCalculatorCommand");
parcelHelpers.exportAll(_createRouteCalculatorCommand, exports);
var _createTrackerCommand = require("./CreateTrackerCommand");
parcelHelpers.exportAll(_createTrackerCommand, exports);
var _deleteGeofenceCollectionCommand = require("./DeleteGeofenceCollectionCommand");
parcelHelpers.exportAll(_deleteGeofenceCollectionCommand, exports);
var _deleteMapCommand = require("./DeleteMapCommand");
parcelHelpers.exportAll(_deleteMapCommand, exports);
var _deletePlaceIndexCommand = require("./DeletePlaceIndexCommand");
parcelHelpers.exportAll(_deletePlaceIndexCommand, exports);
var _deleteRouteCalculatorCommand = require("./DeleteRouteCalculatorCommand");
parcelHelpers.exportAll(_deleteRouteCalculatorCommand, exports);
var _deleteTrackerCommand = require("./DeleteTrackerCommand");
parcelHelpers.exportAll(_deleteTrackerCommand, exports);
var _describeGeofenceCollectionCommand = require("./DescribeGeofenceCollectionCommand");
parcelHelpers.exportAll(_describeGeofenceCollectionCommand, exports);
var _describeMapCommand = require("./DescribeMapCommand");
parcelHelpers.exportAll(_describeMapCommand, exports);
var _describePlaceIndexCommand = require("./DescribePlaceIndexCommand");
parcelHelpers.exportAll(_describePlaceIndexCommand, exports);
var _describeRouteCalculatorCommand = require("./DescribeRouteCalculatorCommand");
parcelHelpers.exportAll(_describeRouteCalculatorCommand, exports);
var _describeTrackerCommand = require("./DescribeTrackerCommand");
parcelHelpers.exportAll(_describeTrackerCommand, exports);
var _disassociateTrackerConsumerCommand = require("./DisassociateTrackerConsumerCommand");
parcelHelpers.exportAll(_disassociateTrackerConsumerCommand, exports);
var _getDevicePositionCommand = require("./GetDevicePositionCommand");
parcelHelpers.exportAll(_getDevicePositionCommand, exports);
var _getDevicePositionHistoryCommand = require("./GetDevicePositionHistoryCommand");
parcelHelpers.exportAll(_getDevicePositionHistoryCommand, exports);
var _getGeofenceCommand = require("./GetGeofenceCommand");
parcelHelpers.exportAll(_getGeofenceCommand, exports);
var _getMapGlyphsCommand = require("./GetMapGlyphsCommand");
parcelHelpers.exportAll(_getMapGlyphsCommand, exports);
var _getMapSpritesCommand = require("./GetMapSpritesCommand");
parcelHelpers.exportAll(_getMapSpritesCommand, exports);
var _getMapStyleDescriptorCommand = require("./GetMapStyleDescriptorCommand");
parcelHelpers.exportAll(_getMapStyleDescriptorCommand, exports);
var _getMapTileCommand = require("./GetMapTileCommand");
parcelHelpers.exportAll(_getMapTileCommand, exports);
var _getPlaceCommand = require("./GetPlaceCommand");
parcelHelpers.exportAll(_getPlaceCommand, exports);
var _listDevicePositionsCommand = require("./ListDevicePositionsCommand");
parcelHelpers.exportAll(_listDevicePositionsCommand, exports);
var _listGeofenceCollectionsCommand = require("./ListGeofenceCollectionsCommand");
parcelHelpers.exportAll(_listGeofenceCollectionsCommand, exports);
var _listGeofencesCommand = require("./ListGeofencesCommand");
parcelHelpers.exportAll(_listGeofencesCommand, exports);
var _listMapsCommand = require("./ListMapsCommand");
parcelHelpers.exportAll(_listMapsCommand, exports);
var _listPlaceIndexesCommand = require("./ListPlaceIndexesCommand");
parcelHelpers.exportAll(_listPlaceIndexesCommand, exports);
var _listRouteCalculatorsCommand = require("./ListRouteCalculatorsCommand");
parcelHelpers.exportAll(_listRouteCalculatorsCommand, exports);
var _listTagsForResourceCommand = require("./ListTagsForResourceCommand");
parcelHelpers.exportAll(_listTagsForResourceCommand, exports);
var _listTrackerConsumersCommand = require("./ListTrackerConsumersCommand");
parcelHelpers.exportAll(_listTrackerConsumersCommand, exports);
var _listTrackersCommand = require("./ListTrackersCommand");
parcelHelpers.exportAll(_listTrackersCommand, exports);
var _putGeofenceCommand = require("./PutGeofenceCommand");
parcelHelpers.exportAll(_putGeofenceCommand, exports);
var _searchPlaceIndexForPositionCommand = require("./SearchPlaceIndexForPositionCommand");
parcelHelpers.exportAll(_searchPlaceIndexForPositionCommand, exports);
var _searchPlaceIndexForSuggestionsCommand = require("./SearchPlaceIndexForSuggestionsCommand");
parcelHelpers.exportAll(_searchPlaceIndexForSuggestionsCommand, exports);
var _searchPlaceIndexForTextCommand = require("./SearchPlaceIndexForTextCommand");
parcelHelpers.exportAll(_searchPlaceIndexForTextCommand, exports);
var _tagResourceCommand = require("./TagResourceCommand");
parcelHelpers.exportAll(_tagResourceCommand, exports);
var _untagResourceCommand = require("./UntagResourceCommand");
parcelHelpers.exportAll(_untagResourceCommand, exports);
var _updateGeofenceCollectionCommand = require("./UpdateGeofenceCollectionCommand");
parcelHelpers.exportAll(_updateGeofenceCollectionCommand, exports);
var _updateMapCommand = require("./UpdateMapCommand");
parcelHelpers.exportAll(_updateMapCommand, exports);
var _updatePlaceIndexCommand = require("./UpdatePlaceIndexCommand");
parcelHelpers.exportAll(_updatePlaceIndexCommand, exports);
var _updateRouteCalculatorCommand = require("./UpdateRouteCalculatorCommand");
parcelHelpers.exportAll(_updateRouteCalculatorCommand, exports);
var _updateTrackerCommand = require("./UpdateTrackerCommand");
parcelHelpers.exportAll(_updateTrackerCommand, exports);

},{"./AssociateTrackerConsumerCommand":false,"./BatchDeleteDevicePositionHistoryCommand":false,"./BatchDeleteGeofenceCommand":"ccEyJ","./BatchEvaluateGeofencesCommand":false,"./BatchGetDevicePositionCommand":false,"./BatchPutGeofenceCommand":"acKoL","./BatchUpdateDevicePositionCommand":false,"./CalculateRouteCommand":false,"./CalculateRouteMatrixCommand":false,"./CreateGeofenceCollectionCommand":false,"./CreateMapCommand":false,"./CreatePlaceIndexCommand":false,"./CreateRouteCalculatorCommand":false,"./CreateTrackerCommand":false,"./DeleteGeofenceCollectionCommand":false,"./DeleteMapCommand":false,"./DeletePlaceIndexCommand":false,"./DeleteRouteCalculatorCommand":false,"./DeleteTrackerCommand":false,"./DescribeGeofenceCollectionCommand":false,"./DescribeMapCommand":false,"./DescribePlaceIndexCommand":false,"./DescribeRouteCalculatorCommand":false,"./DescribeTrackerCommand":false,"./DisassociateTrackerConsumerCommand":false,"./GetDevicePositionCommand":false,"./GetDevicePositionHistoryCommand":false,"./GetGeofenceCommand":"iA5e0","./GetMapGlyphsCommand":false,"./GetMapSpritesCommand":false,"./GetMapStyleDescriptorCommand":false,"./GetMapTileCommand":false,"./GetPlaceCommand":"kn7aU","./ListDevicePositionsCommand":false,"./ListGeofenceCollectionsCommand":false,"./ListGeofencesCommand":"lFvks","./ListMapsCommand":false,"./ListPlaceIndexesCommand":false,"./ListRouteCalculatorsCommand":false,"./ListTagsForResourceCommand":false,"./ListTrackerConsumersCommand":false,"./ListTrackersCommand":false,"./PutGeofenceCommand":false,"./SearchPlaceIndexForPositionCommand":"hVddP","./SearchPlaceIndexForSuggestionsCommand":"3219k","./SearchPlaceIndexForTextCommand":"iQxnx","./TagResourceCommand":false,"./UntagResourceCommand":false,"./UpdateGeofenceCollectionCommand":false,"./UpdateMapCommand":false,"./UpdatePlaceIndexCommand":false,"./UpdateRouteCalculatorCommand":false,"./UpdateTrackerCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ccEyJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchDeleteGeofenceCommand", ()=>BatchDeleteGeofenceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var BatchDeleteGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(BatchDeleteGeofenceCommand, _super);
    function BatchDeleteGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    BatchDeleteGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "BatchDeleteGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.BatchDeleteGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.BatchDeleteGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchDeleteGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1BatchDeleteGeofenceCommand)(input, context);
    };
    BatchDeleteGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1BatchDeleteGeofenceCommand)(output, context);
    };
    return BatchDeleteGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2Dlnp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"4BQSf","./serdePlugin":"1Qr2K","./serializerMiddleware":"hZlxX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4BQSf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", ()=>deserializerMiddleware);
var _tslib = require("tslib");
var deserializerMiddleware = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Qr2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", ()=>deserializerMiddlewareOption);
parcelHelpers.export(exports, "serializerMiddlewareOption", ()=>serializerMiddlewareOption);
parcelHelpers.export(exports, "getSerdePlugin", ()=>getSerdePlugin);
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"4BQSf","./serializerMiddleware":"hZlxX","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hZlxX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", ()=>serializerMiddleware);
var _tslib = require("tslib");
var serializerMiddleware = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"55hEF","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kPki9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessDeniedException", ()=>AccessDeniedException);
parcelHelpers.export(exports, "ConflictException", ()=>ConflictException);
parcelHelpers.export(exports, "InternalServerException", ()=>InternalServerException);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "ServiceQuotaExceededException", ()=>ServiceQuotaExceededException);
parcelHelpers.export(exports, "ThrottlingException", ()=>ThrottlingException);
parcelHelpers.export(exports, "ValidationException", ()=>ValidationException);
parcelHelpers.export(exports, "AssociateTrackerConsumerRequestFilterSensitiveLog", ()=>AssociateTrackerConsumerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "AssociateTrackerConsumerResponseFilterSensitiveLog", ()=>AssociateTrackerConsumerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ValidationExceptionFieldFilterSensitiveLog", ()=>ValidationExceptionFieldFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog", ()=>BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchItemErrorFilterSensitiveLog", ()=>BatchItemErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog", ()=>BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog", ()=>BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteGeofenceRequestFilterSensitiveLog", ()=>BatchDeleteGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteGeofenceErrorFilterSensitiveLog", ()=>BatchDeleteGeofenceErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteGeofenceResponseFilterSensitiveLog", ()=>BatchDeleteGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PositionalAccuracyFilterSensitiveLog", ()=>PositionalAccuracyFilterSensitiveLog);
parcelHelpers.export(exports, "DevicePositionUpdateFilterSensitiveLog", ()=>DevicePositionUpdateFilterSensitiveLog);
parcelHelpers.export(exports, "BatchEvaluateGeofencesRequestFilterSensitiveLog", ()=>BatchEvaluateGeofencesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchEvaluateGeofencesErrorFilterSensitiveLog", ()=>BatchEvaluateGeofencesErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchEvaluateGeofencesResponseFilterSensitiveLog", ()=>BatchEvaluateGeofencesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "BatchGetDevicePositionRequestFilterSensitiveLog", ()=>BatchGetDevicePositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DevicePositionFilterSensitiveLog", ()=>DevicePositionFilterSensitiveLog);
parcelHelpers.export(exports, "BatchGetDevicePositionErrorFilterSensitiveLog", ()=>BatchGetDevicePositionErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchGetDevicePositionResponseFilterSensitiveLog", ()=>BatchGetDevicePositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CircleFilterSensitiveLog", ()=>CircleFilterSensitiveLog);
parcelHelpers.export(exports, "GeofenceGeometryFilterSensitiveLog", ()=>GeofenceGeometryFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceRequestEntryFilterSensitiveLog", ()=>BatchPutGeofenceRequestEntryFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceRequestFilterSensitiveLog", ()=>BatchPutGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceErrorFilterSensitiveLog", ()=>BatchPutGeofenceErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceSuccessFilterSensitiveLog", ()=>BatchPutGeofenceSuccessFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceResponseFilterSensitiveLog", ()=>BatchPutGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "BatchUpdateDevicePositionRequestFilterSensitiveLog", ()=>BatchUpdateDevicePositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchUpdateDevicePositionErrorFilterSensitiveLog", ()=>BatchUpdateDevicePositionErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchUpdateDevicePositionResponseFilterSensitiveLog", ()=>BatchUpdateDevicePositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteCarModeOptionsFilterSensitiveLog", ()=>CalculateRouteCarModeOptionsFilterSensitiveLog);
parcelHelpers.export(exports, "TruckDimensionsFilterSensitiveLog", ()=>TruckDimensionsFilterSensitiveLog);
parcelHelpers.export(exports, "TruckWeightFilterSensitiveLog", ()=>TruckWeightFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteTruckModeOptionsFilterSensitiveLog", ()=>CalculateRouteTruckModeOptionsFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteRequestFilterSensitiveLog", ()=>CalculateRouteRequestFilterSensitiveLog);
parcelHelpers.export(exports, "LegGeometryFilterSensitiveLog", ()=>LegGeometryFilterSensitiveLog);
parcelHelpers.export(exports, "StepFilterSensitiveLog", ()=>StepFilterSensitiveLog);
parcelHelpers.export(exports, "LegFilterSensitiveLog", ()=>LegFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteSummaryFilterSensitiveLog", ()=>CalculateRouteSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteResponseFilterSensitiveLog", ()=>CalculateRouteResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteMatrixRequestFilterSensitiveLog", ()=>CalculateRouteMatrixRequestFilterSensitiveLog);
parcelHelpers.export(exports, "RouteMatrixEntryErrorFilterSensitiveLog", ()=>RouteMatrixEntryErrorFilterSensitiveLog);
parcelHelpers.export(exports, "RouteMatrixEntryFilterSensitiveLog", ()=>RouteMatrixEntryFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteMatrixSummaryFilterSensitiveLog", ()=>CalculateRouteMatrixSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteMatrixResponseFilterSensitiveLog", ()=>CalculateRouteMatrixResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CreateGeofenceCollectionRequestFilterSensitiveLog", ()=>CreateGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateGeofenceCollectionResponseFilterSensitiveLog", ()=>CreateGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "MapConfigurationFilterSensitiveLog", ()=>MapConfigurationFilterSensitiveLog);
parcelHelpers.export(exports, "CreateMapRequestFilterSensitiveLog", ()=>CreateMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateMapResponseFilterSensitiveLog", ()=>CreateMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DataSourceConfigurationFilterSensitiveLog", ()=>DataSourceConfigurationFilterSensitiveLog);
parcelHelpers.export(exports, "CreatePlaceIndexRequestFilterSensitiveLog", ()=>CreatePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreatePlaceIndexResponseFilterSensitiveLog", ()=>CreatePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CreateRouteCalculatorRequestFilterSensitiveLog", ()=>CreateRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateRouteCalculatorResponseFilterSensitiveLog", ()=>CreateRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CreateTrackerRequestFilterSensitiveLog", ()=>CreateTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateTrackerResponseFilterSensitiveLog", ()=>CreateTrackerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteGeofenceCollectionRequestFilterSensitiveLog", ()=>DeleteGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteGeofenceCollectionResponseFilterSensitiveLog", ()=>DeleteGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteMapRequestFilterSensitiveLog", ()=>DeleteMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteMapResponseFilterSensitiveLog", ()=>DeleteMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeletePlaceIndexRequestFilterSensitiveLog", ()=>DeletePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeletePlaceIndexResponseFilterSensitiveLog", ()=>DeletePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteRouteCalculatorRequestFilterSensitiveLog", ()=>DeleteRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteRouteCalculatorResponseFilterSensitiveLog", ()=>DeleteRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteTrackerRequestFilterSensitiveLog", ()=>DeleteTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteTrackerResponseFilterSensitiveLog", ()=>DeleteTrackerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeGeofenceCollectionRequestFilterSensitiveLog", ()=>DescribeGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeGeofenceCollectionResponseFilterSensitiveLog", ()=>DescribeGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeMapRequestFilterSensitiveLog", ()=>DescribeMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeMapResponseFilterSensitiveLog", ()=>DescribeMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribePlaceIndexRequestFilterSensitiveLog", ()=>DescribePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribePlaceIndexResponseFilterSensitiveLog", ()=>DescribePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeRouteCalculatorRequestFilterSensitiveLog", ()=>DescribeRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeRouteCalculatorResponseFilterSensitiveLog", ()=>DescribeRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeTrackerRequestFilterSensitiveLog", ()=>DescribeTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeTrackerResponseFilterSensitiveLog", ()=>DescribeTrackerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DisassociateTrackerConsumerRequestFilterSensitiveLog", ()=>DisassociateTrackerConsumerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DisassociateTrackerConsumerResponseFilterSensitiveLog", ()=>DisassociateTrackerConsumerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListTagsForResourceRequestFilterSensitiveLog", ()=>ListTagsForResourceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListTagsForResourceResponseFilterSensitiveLog", ()=>ListTagsForResourceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "TagResourceRequestFilterSensitiveLog", ()=>TagResourceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "TagResourceResponseFilterSensitiveLog", ()=>TagResourceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UntagResourceRequestFilterSensitiveLog", ()=>UntagResourceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UntagResourceResponseFilterSensitiveLog", ()=>UntagResourceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetGeofenceRequestFilterSensitiveLog", ()=>GetGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetGeofenceResponseFilterSensitiveLog", ()=>GetGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceCollectionsRequestFilterSensitiveLog", ()=>ListGeofenceCollectionsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceCollectionsResponseEntryFilterSensitiveLog", ()=>ListGeofenceCollectionsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceCollectionsResponseFilterSensitiveLog", ()=>ListGeofenceCollectionsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofencesRequestFilterSensitiveLog", ()=>ListGeofencesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceResponseEntryFilterSensitiveLog", ()=>ListGeofenceResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofencesResponseFilterSensitiveLog", ()=>ListGeofencesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PutGeofenceRequestFilterSensitiveLog", ()=>PutGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PutGeofenceResponseFilterSensitiveLog", ()=>PutGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateGeofenceCollectionRequestFilterSensitiveLog", ()=>UpdateGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateGeofenceCollectionResponseFilterSensitiveLog", ()=>UpdateGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionRequestFilterSensitiveLog", ()=>GetDevicePositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionResponseFilterSensitiveLog", ()=>GetDevicePositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionHistoryRequestFilterSensitiveLog", ()=>GetDevicePositionHistoryRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionHistoryResponseFilterSensitiveLog", ()=>GetDevicePositionHistoryResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapGlyphsRequestFilterSensitiveLog", ()=>GetMapGlyphsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapGlyphsResponseFilterSensitiveLog", ()=>GetMapGlyphsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapSpritesRequestFilterSensitiveLog", ()=>GetMapSpritesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapSpritesResponseFilterSensitiveLog", ()=>GetMapSpritesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapStyleDescriptorRequestFilterSensitiveLog", ()=>GetMapStyleDescriptorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapStyleDescriptorResponseFilterSensitiveLog", ()=>GetMapStyleDescriptorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapTileRequestFilterSensitiveLog", ()=>GetMapTileRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapTileResponseFilterSensitiveLog", ()=>GetMapTileResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetPlaceRequestFilterSensitiveLog", ()=>GetPlaceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PlaceGeometryFilterSensitiveLog", ()=>PlaceGeometryFilterSensitiveLog);
parcelHelpers.export(exports, "TimeZoneFilterSensitiveLog", ()=>TimeZoneFilterSensitiveLog);
parcelHelpers.export(exports, "PlaceFilterSensitiveLog", ()=>PlaceFilterSensitiveLog);
parcelHelpers.export(exports, "GetPlaceResponseFilterSensitiveLog", ()=>GetPlaceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListDevicePositionsRequestFilterSensitiveLog", ()=>ListDevicePositionsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListDevicePositionsResponseEntryFilterSensitiveLog", ()=>ListDevicePositionsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListDevicePositionsResponseFilterSensitiveLog", ()=>ListDevicePositionsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListMapsRequestFilterSensitiveLog", ()=>ListMapsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListMapsResponseEntryFilterSensitiveLog", ()=>ListMapsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListMapsResponseFilterSensitiveLog", ()=>ListMapsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListPlaceIndexesRequestFilterSensitiveLog", ()=>ListPlaceIndexesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListPlaceIndexesResponseEntryFilterSensitiveLog", ()=>ListPlaceIndexesResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListPlaceIndexesResponseFilterSensitiveLog", ()=>ListPlaceIndexesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListRouteCalculatorsRequestFilterSensitiveLog", ()=>ListRouteCalculatorsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListRouteCalculatorsResponseEntryFilterSensitiveLog", ()=>ListRouteCalculatorsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListRouteCalculatorsResponseFilterSensitiveLog", ()=>ListRouteCalculatorsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackerConsumersRequestFilterSensitiveLog", ()=>ListTrackerConsumersRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackerConsumersResponseFilterSensitiveLog", ()=>ListTrackerConsumersResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackersRequestFilterSensitiveLog", ()=>ListTrackersRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackersResponseEntryFilterSensitiveLog", ()=>ListTrackersResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackersResponseFilterSensitiveLog", ()=>ListTrackersResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateMapRequestFilterSensitiveLog", ()=>UpdateMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateMapResponseFilterSensitiveLog", ()=>UpdateMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionRequestFilterSensitiveLog", ()=>SearchPlaceIndexForPositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "SearchForPositionResultFilterSensitiveLog", ()=>SearchForPositionResultFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionSummaryFilterSensitiveLog", ()=>SearchPlaceIndexForPositionSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionResponseFilterSensitiveLog", ()=>SearchPlaceIndexForPositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog", ()=>SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "SearchForSuggestionsResultFilterSensitiveLog", ()=>SearchForSuggestionsResultFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog", ()=>SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog", ()=>SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForTextRequestFilterSensitiveLog", ()=>SearchPlaceIndexForTextRequestFilterSensitiveLog);
parcelHelpers.export(exports, "SearchForTextResultFilterSensitiveLog", ()=>SearchForTextResultFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForTextSummaryFilterSensitiveLog", ()=>SearchPlaceIndexForTextSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForTextResponseFilterSensitiveLog", ()=>SearchPlaceIndexForTextResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdatePlaceIndexRequestFilterSensitiveLog", ()=>UpdatePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdatePlaceIndexResponseFilterSensitiveLog", ()=>UpdatePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateRouteCalculatorRequestFilterSensitiveLog", ()=>UpdateRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateRouteCalculatorResponseFilterSensitiveLog", ()=>UpdateRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateTrackerRequestFilterSensitiveLog", ()=>UpdateTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateTrackerResponseFilterSensitiveLog", ()=>UpdateTrackerResponseFilterSensitiveLog);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _locationServiceException = require("./LocationServiceException");
var AccessDeniedException = function(_super) {
    (0, _tslib.__extends)(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "AccessDeniedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return AccessDeniedException;
}((0, _locationServiceException.LocationServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConflictException;
}((0, _locationServiceException.LocationServiceException));
var InternalServerException = function(_super) {
    (0, _tslib.__extends)(InternalServerException, _super);
    function InternalServerException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalServerException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalServerException";
        _this.$fault = "server";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, InternalServerException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InternalServerException;
}((0, _locationServiceException.LocationServiceException));
var ResourceNotFoundException = function(_super) {
    (0, _tslib.__extends)(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ResourceNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNotFoundException;
}((0, _locationServiceException.LocationServiceException));
var ServiceQuotaExceededException = function(_super) {
    (0, _tslib.__extends)(ServiceQuotaExceededException, _super);
    function ServiceQuotaExceededException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ServiceQuotaExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ServiceQuotaExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ServiceQuotaExceededException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ServiceQuotaExceededException;
}((0, _locationServiceException.LocationServiceException));
var ThrottlingException = function(_super) {
    (0, _tslib.__extends)(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ThrottlingException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "client";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ThrottlingException;
}((0, _locationServiceException.LocationServiceException));
var ValidationException = function(_super) {
    (0, _tslib.__extends)(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ValidationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.Message = opts.Message;
        _this.Reason = opts.Reason;
        _this.FieldList = opts.FieldList;
        return _this;
    }
    return ValidationException;
}((0, _locationServiceException.LocationServiceException));
var AssociateTrackerConsumerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var AssociateTrackerConsumerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ValidationExceptionFieldFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchItemErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PositionalAccuracyFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DevicePositionUpdateFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchEvaluateGeofencesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositionUpdates && {
        DevicePositionUpdates: obj.DevicePositionUpdates.map(function(item) {
            return DevicePositionUpdateFilterSensitiveLog(item);
        })
    });
};
var BatchEvaluateGeofencesErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchEvaluateGeofencesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchGetDevicePositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DevicePositionFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchGetDevicePositionErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchGetDevicePositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map(function(item) {
            return DevicePositionFilterSensitiveLog(item);
        })
    });
};
var CircleFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Center && {
        Center: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GeofenceGeometryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Polygon && {
        Polygon: obj.Polygon.map(function(item) {
            return 0, _smithyClient.SENSITIVE_STRING;
        })
    }), obj.Circle && {
        Circle: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchPutGeofenceRequestEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var BatchPutGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return BatchPutGeofenceRequestEntryFilterSensitiveLog(item);
        })
    });
};
var BatchPutGeofenceErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchPutGeofenceSuccessFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchPutGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchUpdateDevicePositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Updates && {
        Updates: obj.Updates.map(function(item) {
            return DevicePositionUpdateFilterSensitiveLog(item);
        })
    });
};
var BatchUpdateDevicePositionErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchUpdateDevicePositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteCarModeOptionsFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TruckDimensionsFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TruckWeightFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteTruckModeOptionsFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeparturePosition && {
        DeparturePosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.DestinationPosition && {
        DestinationPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.WaypointPositions && {
        WaypointPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var LegGeometryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.LineString && {
        LineString: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var StepFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.StartPosition && {
        StartPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.EndPosition && {
        EndPosition: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var LegFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.StartPosition && {
        StartPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.EndPosition && {
        EndPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.Geometry && {
        Geometry: LegGeometryFilterSensitiveLog(obj.Geometry)
    }), obj.Steps && {
        Steps: obj.Steps.map(function(item) {
            return StepFilterSensitiveLog(item);
        })
    });
};
var CalculateRouteSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RouteBBox && {
        RouteBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var CalculateRouteResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Legs && {
        Legs: obj.Legs.map(function(item) {
            return LegFilterSensitiveLog(item);
        })
    }), obj.Summary && {
        Summary: CalculateRouteSummaryFilterSensitiveLog(obj.Summary)
    });
};
var CalculateRouteMatrixRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeparturePositions && {
        DeparturePositions: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.DestinationPositions && {
        DestinationPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var RouteMatrixEntryErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RouteMatrixEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteMatrixSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteMatrixResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.SnappedDeparturePositions && {
        SnappedDeparturePositions: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.SnappedDestinationPositions && {
        SnappedDestinationPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var CreateGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var MapConfigurationFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DataSourceConfigurationFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreatePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreatePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeletePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeletePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisassociateTrackerConsumerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisassociateTrackerConsumerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTagsForResourceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTagsForResourceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TagResourceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TagResourceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UntagResourceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UntagResourceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var ListGeofenceCollectionsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceCollectionsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceCollectionsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofencesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var ListGeofencesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return ListGeofenceResponseEntryFilterSensitiveLog(item);
        })
    });
};
var PutGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var PutGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GetDevicePositionHistoryRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionHistoryResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map(function(item) {
            return DevicePositionFilterSensitiveLog(item);
        })
    });
};
var GetMapGlyphsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapGlyphsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapSpritesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapSpritesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapStyleDescriptorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapStyleDescriptorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapTileRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapTileResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetPlaceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaceGeometryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Point && {
        Point: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var TimeZoneFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaceFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: PlaceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var GetPlaceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var ListDevicePositionsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListDevicePositionsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var ListDevicePositionsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return ListDevicePositionsResponseEntryFilterSensitiveLog(item);
        })
    });
};
var ListMapsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListMapsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListMapsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackerConsumersRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackerConsumersResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SearchPlaceIndexForPositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForPositionResultFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var SearchPlaceIndexForPositionSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForPositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForPositionSummaryFilterSensitiveLog(obj.Summary)
    }), obj.Results && {
        Results: obj.Results.map(function(item) {
            return SearchForPositionResultFilterSensitiveLog(item);
        })
    });
};
var SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForSuggestionsResultFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog(obj.Summary)
    });
};
var SearchPlaceIndexForTextRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForTextResultFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var SearchPlaceIndexForTextSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.ResultBBox && {
        ResultBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForTextResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForTextSummaryFilterSensitiveLog(obj.Summary)
    }), obj.Results && {
        Results: obj.Results.map(function(item) {
            return SearchForTextResultFilterSensitiveLog(item);
        })
    });
};
var UpdatePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdatePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};

},{"tslib":"55hEF","@aws-sdk/smithy-client":"l83SD","./LocationServiceException":"9E46N","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9E46N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationServiceException", ()=>LocationServiceException);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LocationServiceException = function(_super) {
    (0, _tslib.__extends)(LocationServiceException, _super);
    function LocationServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LocationServiceException.prototype);
        return _this;
    }
    return LocationServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"55hEF","@aws-sdk/smithy-client":"l83SD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5UTGv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1AssociateTrackerConsumerCommand", ()=>serializeAws_restJson1AssociateTrackerConsumerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand", ()=>serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchDeleteGeofenceCommand", ()=>serializeAws_restJson1BatchDeleteGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchEvaluateGeofencesCommand", ()=>serializeAws_restJson1BatchEvaluateGeofencesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchGetDevicePositionCommand", ()=>serializeAws_restJson1BatchGetDevicePositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchPutGeofenceCommand", ()=>serializeAws_restJson1BatchPutGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchUpdateDevicePositionCommand", ()=>serializeAws_restJson1BatchUpdateDevicePositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CalculateRouteCommand", ()=>serializeAws_restJson1CalculateRouteCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CalculateRouteMatrixCommand", ()=>serializeAws_restJson1CalculateRouteMatrixCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateGeofenceCollectionCommand", ()=>serializeAws_restJson1CreateGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateMapCommand", ()=>serializeAws_restJson1CreateMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreatePlaceIndexCommand", ()=>serializeAws_restJson1CreatePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateRouteCalculatorCommand", ()=>serializeAws_restJson1CreateRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateTrackerCommand", ()=>serializeAws_restJson1CreateTrackerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteGeofenceCollectionCommand", ()=>serializeAws_restJson1DeleteGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteMapCommand", ()=>serializeAws_restJson1DeleteMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeletePlaceIndexCommand", ()=>serializeAws_restJson1DeletePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteRouteCalculatorCommand", ()=>serializeAws_restJson1DeleteRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteTrackerCommand", ()=>serializeAws_restJson1DeleteTrackerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeGeofenceCollectionCommand", ()=>serializeAws_restJson1DescribeGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeMapCommand", ()=>serializeAws_restJson1DescribeMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribePlaceIndexCommand", ()=>serializeAws_restJson1DescribePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeRouteCalculatorCommand", ()=>serializeAws_restJson1DescribeRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeTrackerCommand", ()=>serializeAws_restJson1DescribeTrackerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DisassociateTrackerConsumerCommand", ()=>serializeAws_restJson1DisassociateTrackerConsumerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetDevicePositionCommand", ()=>serializeAws_restJson1GetDevicePositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetDevicePositionHistoryCommand", ()=>serializeAws_restJson1GetDevicePositionHistoryCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetGeofenceCommand", ()=>serializeAws_restJson1GetGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapGlyphsCommand", ()=>serializeAws_restJson1GetMapGlyphsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapSpritesCommand", ()=>serializeAws_restJson1GetMapSpritesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapStyleDescriptorCommand", ()=>serializeAws_restJson1GetMapStyleDescriptorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapTileCommand", ()=>serializeAws_restJson1GetMapTileCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetPlaceCommand", ()=>serializeAws_restJson1GetPlaceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListDevicePositionsCommand", ()=>serializeAws_restJson1ListDevicePositionsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListGeofenceCollectionsCommand", ()=>serializeAws_restJson1ListGeofenceCollectionsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListGeofencesCommand", ()=>serializeAws_restJson1ListGeofencesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListMapsCommand", ()=>serializeAws_restJson1ListMapsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListPlaceIndexesCommand", ()=>serializeAws_restJson1ListPlaceIndexesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListRouteCalculatorsCommand", ()=>serializeAws_restJson1ListRouteCalculatorsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListTagsForResourceCommand", ()=>serializeAws_restJson1ListTagsForResourceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListTrackerConsumersCommand", ()=>serializeAws_restJson1ListTrackerConsumersCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListTrackersCommand", ()=>serializeAws_restJson1ListTrackersCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutGeofenceCommand", ()=>serializeAws_restJson1PutGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForPositionCommand", ()=>serializeAws_restJson1SearchPlaceIndexForPositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand", ()=>serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForTextCommand", ()=>serializeAws_restJson1SearchPlaceIndexForTextCommand);
parcelHelpers.export(exports, "serializeAws_restJson1TagResourceCommand", ()=>serializeAws_restJson1TagResourceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UntagResourceCommand", ()=>serializeAws_restJson1UntagResourceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateGeofenceCollectionCommand", ()=>serializeAws_restJson1UpdateGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateMapCommand", ()=>serializeAws_restJson1UpdateMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdatePlaceIndexCommand", ()=>serializeAws_restJson1UpdatePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateRouteCalculatorCommand", ()=>serializeAws_restJson1UpdateRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateTrackerCommand", ()=>serializeAws_restJson1UpdateTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1AssociateTrackerConsumerCommand", ()=>deserializeAws_restJson1AssociateTrackerConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand", ()=>deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchDeleteGeofenceCommand", ()=>deserializeAws_restJson1BatchDeleteGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchEvaluateGeofencesCommand", ()=>deserializeAws_restJson1BatchEvaluateGeofencesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchGetDevicePositionCommand", ()=>deserializeAws_restJson1BatchGetDevicePositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchPutGeofenceCommand", ()=>deserializeAws_restJson1BatchPutGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchUpdateDevicePositionCommand", ()=>deserializeAws_restJson1BatchUpdateDevicePositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CalculateRouteCommand", ()=>deserializeAws_restJson1CalculateRouteCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CalculateRouteMatrixCommand", ()=>deserializeAws_restJson1CalculateRouteMatrixCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateGeofenceCollectionCommand", ()=>deserializeAws_restJson1CreateGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateMapCommand", ()=>deserializeAws_restJson1CreateMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreatePlaceIndexCommand", ()=>deserializeAws_restJson1CreatePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateRouteCalculatorCommand", ()=>deserializeAws_restJson1CreateRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateTrackerCommand", ()=>deserializeAws_restJson1CreateTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteGeofenceCollectionCommand", ()=>deserializeAws_restJson1DeleteGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteMapCommand", ()=>deserializeAws_restJson1DeleteMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeletePlaceIndexCommand", ()=>deserializeAws_restJson1DeletePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteRouteCalculatorCommand", ()=>deserializeAws_restJson1DeleteRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteTrackerCommand", ()=>deserializeAws_restJson1DeleteTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeGeofenceCollectionCommand", ()=>deserializeAws_restJson1DescribeGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeMapCommand", ()=>deserializeAws_restJson1DescribeMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribePlaceIndexCommand", ()=>deserializeAws_restJson1DescribePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeRouteCalculatorCommand", ()=>deserializeAws_restJson1DescribeRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeTrackerCommand", ()=>deserializeAws_restJson1DescribeTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DisassociateTrackerConsumerCommand", ()=>deserializeAws_restJson1DisassociateTrackerConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetDevicePositionCommand", ()=>deserializeAws_restJson1GetDevicePositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetDevicePositionHistoryCommand", ()=>deserializeAws_restJson1GetDevicePositionHistoryCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetGeofenceCommand", ()=>deserializeAws_restJson1GetGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapGlyphsCommand", ()=>deserializeAws_restJson1GetMapGlyphsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapSpritesCommand", ()=>deserializeAws_restJson1GetMapSpritesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapStyleDescriptorCommand", ()=>deserializeAws_restJson1GetMapStyleDescriptorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapTileCommand", ()=>deserializeAws_restJson1GetMapTileCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetPlaceCommand", ()=>deserializeAws_restJson1GetPlaceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListDevicePositionsCommand", ()=>deserializeAws_restJson1ListDevicePositionsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListGeofenceCollectionsCommand", ()=>deserializeAws_restJson1ListGeofenceCollectionsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListGeofencesCommand", ()=>deserializeAws_restJson1ListGeofencesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListMapsCommand", ()=>deserializeAws_restJson1ListMapsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListPlaceIndexesCommand", ()=>deserializeAws_restJson1ListPlaceIndexesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListRouteCalculatorsCommand", ()=>deserializeAws_restJson1ListRouteCalculatorsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListTagsForResourceCommand", ()=>deserializeAws_restJson1ListTagsForResourceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListTrackerConsumersCommand", ()=>deserializeAws_restJson1ListTrackerConsumersCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListTrackersCommand", ()=>deserializeAws_restJson1ListTrackersCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutGeofenceCommand", ()=>deserializeAws_restJson1PutGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForPositionCommand", ()=>deserializeAws_restJson1SearchPlaceIndexForPositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand", ()=>deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForTextCommand", ()=>deserializeAws_restJson1SearchPlaceIndexForTextCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1TagResourceCommand", ()=>deserializeAws_restJson1TagResourceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UntagResourceCommand", ()=>deserializeAws_restJson1UntagResourceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateGeofenceCollectionCommand", ()=>deserializeAws_restJson1UpdateGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateMapCommand", ()=>deserializeAws_restJson1UpdateMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdatePlaceIndexCommand", ()=>deserializeAws_restJson1UpdatePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateRouteCalculatorCommand", ()=>deserializeAws_restJson1UpdateRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateTrackerCommand", ()=>deserializeAws_restJson1UpdateTrackerCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _locationServiceException = require("../models/LocationServiceException");
var _models0 = require("../models/models_0");
var serializeAws_restJson1AssociateTrackerConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/consumers";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.ConsumerArn != null && {
                        ConsumerArn: input.ConsumerArn
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/delete-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DeviceIds != null && {
                        DeviceIds: serializeAws_restJson1DeviceIdsList(input.DeviceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchDeleteGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/delete-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.GeofenceIds != null && {
                        GeofenceIds: serializeAws_restJson1IdList(input.GeofenceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchEvaluateGeofencesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DevicePositionUpdates != null && {
                        DevicePositionUpdates: serializeAws_restJson1DevicePositionUpdateList(input.DevicePositionUpdates, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchGetDevicePositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/get-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DeviceIds != null && {
                        DeviceIds: serializeAws_restJson1IdList(input.DeviceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchPutGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/put-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Entries != null && {
                        Entries: serializeAws_restJson1BatchPutGeofenceRequestEntryList(input.Entries, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchUpdateDevicePositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Updates != null && {
                        Updates: serializeAws_restJson1DevicePositionUpdateList(input.Updates, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CalculateRouteCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}/calculate/route";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CarModeOptions != null && {
                        CarModeOptions: serializeAws_restJson1CalculateRouteCarModeOptions(input.CarModeOptions, context)
                    }), input.DepartNow != null && {
                        DepartNow: input.DepartNow
                    }), input.DeparturePosition != null && {
                        DeparturePosition: serializeAws_restJson1Position(input.DeparturePosition, context)
                    }), input.DepartureTime != null && {
                        DepartureTime: input.DepartureTime.toISOString().split(".")[0] + "Z"
                    }), input.DestinationPosition != null && {
                        DestinationPosition: serializeAws_restJson1Position(input.DestinationPosition, context)
                    }), input.DistanceUnit != null && {
                        DistanceUnit: input.DistanceUnit
                    }), input.IncludeLegGeometry != null && {
                        IncludeLegGeometry: input.IncludeLegGeometry
                    }), input.TravelMode != null && {
                        TravelMode: input.TravelMode
                    }), input.TruckModeOptions != null && {
                        TruckModeOptions: serializeAws_restJson1CalculateRouteTruckModeOptions(input.TruckModeOptions, context)
                    }), input.WaypointPositions != null && {
                        WaypointPositions: serializeAws_restJson1WaypointPositionList(input.WaypointPositions, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CalculateRouteMatrixCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}/calculate/route-matrix";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CarModeOptions != null && {
                        CarModeOptions: serializeAws_restJson1CalculateRouteCarModeOptions(input.CarModeOptions, context)
                    }), input.DepartNow != null && {
                        DepartNow: input.DepartNow
                    }), input.DeparturePositions != null && {
                        DeparturePositions: serializeAws_restJson1PositionList(input.DeparturePositions, context)
                    }), input.DepartureTime != null && {
                        DepartureTime: input.DepartureTime.toISOString().split(".")[0] + "Z"
                    }), input.DestinationPositions != null && {
                        DestinationPositions: serializeAws_restJson1PositionList(input.DestinationPositions, context)
                    }), input.DistanceUnit != null && {
                        DistanceUnit: input.DistanceUnit
                    }), input.TravelMode != null && {
                        TravelMode: input.TravelMode
                    }), input.TruckModeOptions != null && {
                        TruckModeOptions: serializeAws_restJson1CalculateRouteTruckModeOptions(input.TruckModeOptions, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CollectionName != null && {
                        CollectionName: input.CollectionName
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.KmsKeyId != null && {
                        KmsKeyId: input.KmsKeyId
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Configuration != null && {
                        Configuration: serializeAws_restJson1MapConfiguration(input.Configuration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.MapName != null && {
                        MapName: input.MapName
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreatePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DataSource != null && {
                        DataSource: input.DataSource
                    }), input.DataSourceConfiguration != null && {
                        DataSourceConfiguration: serializeAws_restJson1DataSourceConfiguration(input.DataSourceConfiguration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.IndexName != null && {
                        IndexName: input.IndexName
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CalculatorName != null && {
                        CalculatorName: input.CalculatorName
                    }), input.DataSource != null && {
                        DataSource: input.DataSource
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.KmsKeyId != null && {
                        KmsKeyId: input.KmsKeyId
                    }), input.PositionFiltering != null && {
                        PositionFiltering: input.PositionFiltering
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }), input.TrackerName != null && {
                        TrackerName: input.TrackerName
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeletePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DisassociateTrackerConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ConsumerArn", function() {
                        return input.ConsumerArn;
                    }, "{ConsumerArn}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetDevicePositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "DeviceId", function() {
                        return input.DeviceId;
                    }, "{DeviceId}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetDevicePositionHistoryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "DeviceId", function() {
                        return input.DeviceId;
                    }, "{DeviceId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EndTimeExclusive != null && {
                        EndTimeExclusive: input.EndTimeExclusive.toISOString().split(".")[0] + "Z"
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }), input.StartTimeInclusive != null && {
                        StartTimeInclusive: input.StartTimeInclusive.toISOString().split(".")[0] + "Z"
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "GeofenceId", function() {
                        return input.GeofenceId;
                    }, "{GeofenceId}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapGlyphsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FontStack", function() {
                        return input.FontStack;
                    }, "{FontStack}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FontUnicodeRange", function() {
                        return input.FontUnicodeRange;
                    }, "{FontUnicodeRange}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapSpritesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/sprites/{FileName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FileName", function() {
                        return input.FileName;
                    }, "{FileName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapStyleDescriptorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/style-descriptor";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapTileCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "Z", function() {
                        return input.Z;
                    }, "{Z}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "X", function() {
                        return input.X;
                    }, "{X}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "Y", function() {
                        return input.Y;
                    }, "{Y}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetPlaceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/places/{PlaceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "PlaceId", function() {
                        return input.PlaceId;
                    }, "{PlaceId}", false);
                    query = map({
                        language: [
                            ,
                            input.Language
                        ]
                    });
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListDevicePositionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/list-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListGeofenceCollectionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/list-collections";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListGeofencesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/list-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListMapsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/list-maps";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListPlaceIndexesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/list-indexes";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListRouteCalculatorsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/list-calculators";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTagsForResourceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTrackerConsumersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/list-consumers";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTrackersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/list-trackers";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "GeofenceId", function() {
                        return input.GeofenceId;
                    }, "{GeofenceId}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Geometry != null && {
                        Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForPositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/position";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Position != null && {
                        Position: serializeAws_restJson1Position(input.Position, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/suggestions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BiasPosition != null && {
                        BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context)
                    }), input.FilterBBox != null && {
                        FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context)
                    }), input.FilterCountries != null && {
                        FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
                    }), input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Text != null && {
                        Text: input.Text
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForTextCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BiasPosition != null && {
                        BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context)
                    }), input.FilterBBox != null && {
                        FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context)
                    }), input.FilterCountries != null && {
                        FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
                    }), input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Text != null && {
                        Text: input.Text
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1TagResourceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UntagResourceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    query = map({
                        tagKeys: [
                            function() {
                                return input.TagKeys !== void 0;
                            },
                            function() {
                                return (input.TagKeys || []).map(function(_entry) {
                                    return _entry;
                                });
                            }
                        ]
                    });
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdatePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DataSourceConfiguration != null && {
                        DataSourceConfiguration: serializeAws_restJson1DataSourceConfiguration(input.DataSourceConfiguration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PositionFiltering != null && {
                        PositionFiltering: input.PositionFiltering
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AssociateTrackerConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1AssociateTrackerConsumerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AssociateTrackerConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceQuotaExceededException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ServiceQuotaExceededException":
                            return [
                                3,
                                10
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                12
                            ];
                        case "ValidationException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ServiceQuotaExceededExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 17;
                case 17:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchDeleteGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchDeleteGeofenceErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchEvaluateGeofencesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchEvaluateGeofencesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchEvaluateGeofencesErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchEvaluateGeofencesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchGetDevicePositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchGetDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DevicePositions != null) contents.DevicePositions = deserializeAws_restJson1DevicePositionList(data.DevicePositions, context);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchGetDevicePositionErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchGetDevicePositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchPutGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchPutGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchPutGeofenceErrorList(data.Errors, context);
                    if (data.Successes != null) contents.Successes = deserializeAws_restJson1BatchPutGeofenceSuccessList(data.Successes, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchPutGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchUpdateDevicePositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchUpdateDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchUpdateDevicePositionErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchUpdateDevicePositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CalculateRouteCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Legs != null) contents.Legs = deserializeAws_restJson1LegList(data.Legs, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1CalculateRouteSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteMatrixCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CalculateRouteMatrixCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.RouteMatrix != null) contents.RouteMatrix = deserializeAws_restJson1RouteMatrix(data.RouteMatrix, context);
                    if (data.SnappedDeparturePositions != null) contents.SnappedDeparturePositions = deserializeAws_restJson1PositionList(data.SnappedDeparturePositions, context);
                    if (data.SnappedDestinationPositions != null) contents.SnappedDestinationPositions = deserializeAws_restJson1PositionList(data.SnappedDestinationPositions, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1CalculateRouteMatrixSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteMatrixCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreatePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreatePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreatePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeletePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeletePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeletePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.KmsKeyId != null) contents.KmsKeyId = (0, _smithyClient.expectString)(data.KmsKeyId);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.PricingPlanDataSource != null) contents.PricingPlanDataSource = (0, _smithyClient.expectString)(data.PricingPlanDataSource);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Configuration != null) contents.Configuration = deserializeAws_restJson1MapConfiguration(data.Configuration, context);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.DataSourceConfiguration != null) contents.DataSourceConfiguration = deserializeAws_restJson1DataSourceConfiguration(data.DataSourceConfiguration, context);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.KmsKeyId != null) contents.KmsKeyId = (0, _smithyClient.expectString)(data.KmsKeyId);
                    if (data.PositionFiltering != null) contents.PositionFiltering = (0, _smithyClient.expectString)(data.PositionFiltering);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.PricingPlanDataSource != null) contents.PricingPlanDataSource = (0, _smithyClient.expectString)(data.PricingPlanDataSource);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DisassociateTrackerConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DisassociateTrackerConsumerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DisassociateTrackerConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Accuracy != null) contents.Accuracy = deserializeAws_restJson1PositionalAccuracy(data.Accuracy, context);
                    if (data.DeviceId != null) contents.DeviceId = (0, _smithyClient.expectString)(data.DeviceId);
                    if (data.Position != null) contents.Position = deserializeAws_restJson1Position(data.Position, context);
                    if (data.PositionProperties != null) contents.PositionProperties = deserializeAws_restJson1PropertyMap(data.PositionProperties, context);
                    if (data.ReceivedTime != null) contents.ReceivedTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.ReceivedTime));
                    if (data.SampleTime != null) contents.SampleTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.SampleTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionHistoryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetDevicePositionHistoryCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DevicePositions != null) contents.DevicePositions = deserializeAws_restJson1DevicePositionList(data.DevicePositions, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionHistoryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.GeofenceId != null) contents.GeofenceId = (0, _smithyClient.expectString)(data.GeofenceId);
                    if (data.Geometry != null) contents.Geometry = deserializeAws_restJson1GeofenceGeometry(data.Geometry, context);
                    if (data.Status != null) contents.Status = (0, _smithyClient.expectString)(data.Status);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapGlyphsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapGlyphsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapGlyphsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapSpritesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapSpritesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapSpritesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapStyleDescriptorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapStyleDescriptorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapStyleDescriptorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapTileCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapTileCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapTileCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetPlaceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetPlaceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Place != null) contents.Place = deserializeAws_restJson1Place(data.Place, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetPlaceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListDevicePositionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListDevicePositionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListDevicePositionsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListDevicePositionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofenceCollectionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListGeofenceCollectionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofenceCollectionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofencesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListGeofencesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListGeofenceResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofencesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListMapsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListMapsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListMapsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListMapsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListPlaceIndexesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListPlaceIndexesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListPlaceIndexesResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListPlaceIndexesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListRouteCalculatorsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListRouteCalculatorsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListRouteCalculatorsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListRouteCalculatorsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTagsForResourceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTagsForResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTagsForResourceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackerConsumersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTrackerConsumersCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.ConsumerArns != null) contents.ConsumerArns = deserializeAws_restJson1ArnList(data.ConsumerArns, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackerConsumersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTrackersCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListTrackersResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1PutGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.GeofenceId != null) contents.GeofenceId = (0, _smithyClient.expectString)(data.GeofenceId);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "ValidationException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 15;
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForPositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForPositionResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForPositionSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForSuggestionsResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForTextResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForTextSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TagResourceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1TagResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TagResourceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UntagResourceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UntagResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UntagResourceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdatePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdatePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdatePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1AccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.AccessDeniedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalServerExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalServerException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ResourceNotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ServiceQuotaExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ServiceQuotaExceededException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ThrottlingExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ThrottlingException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ValidationExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.fieldList != null) contents.FieldList = deserializeAws_restJson1ValidationExceptionFieldList(data.fieldList, context);
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            if (data.reason != null) contents.Reason = (0, _smithyClient.expectString)(data.reason);
            exception = new (0, _models0.ValidationException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntry = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.GeofenceId != null && {
        GeofenceId: input.GeofenceId
    }), input.Geometry != null && {
        Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context)
    });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1BatchPutGeofenceRequestEntry(entry, context);
    });
};
var serializeAws_restJson1BoundingBox = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return (0, _smithyClient.serializeFloat)(entry);
    });
};
var serializeAws_restJson1CalculateRouteCarModeOptions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AvoidFerries != null && {
        AvoidFerries: input.AvoidFerries
    }), input.AvoidTolls != null && {
        AvoidTolls: input.AvoidTolls
    });
};
var serializeAws_restJson1CalculateRouteTruckModeOptions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AvoidFerries != null && {
        AvoidFerries: input.AvoidFerries
    }), input.AvoidTolls != null && {
        AvoidTolls: input.AvoidTolls
    }), input.Dimensions != null && {
        Dimensions: serializeAws_restJson1TruckDimensions(input.Dimensions, context)
    }), input.Weight != null && {
        Weight: serializeAws_restJson1TruckWeight(input.Weight, context)
    });
};
var serializeAws_restJson1Circle = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Center != null && {
        Center: serializeAws_restJson1Position(input.Center, context)
    }), input.Radius != null && {
        Radius: (0, _smithyClient.serializeFloat)(input.Radius)
    });
};
var serializeAws_restJson1CountryCodeList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1DataSourceConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.IntendedUse != null && {
        IntendedUse: input.IntendedUse
    });
};
var serializeAws_restJson1DeviceIdsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1DevicePositionUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Accuracy != null && {
        Accuracy: serializeAws_restJson1PositionalAccuracy(input.Accuracy, context)
    }), input.DeviceId != null && {
        DeviceId: input.DeviceId
    }), input.Position != null && {
        Position: serializeAws_restJson1Position(input.Position, context)
    }), input.PositionProperties != null && {
        PositionProperties: serializeAws_restJson1PropertyMap(input.PositionProperties, context)
    }), input.SampleTime != null && {
        SampleTime: input.SampleTime.toISOString().split(".")[0] + "Z"
    });
};
var serializeAws_restJson1DevicePositionUpdateList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1DevicePositionUpdate(entry, context);
    });
};
var serializeAws_restJson1GeofenceGeometry = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Circle != null && {
        Circle: serializeAws_restJson1Circle(input.Circle, context)
    }), input.Polygon != null && {
        Polygon: serializeAws_restJson1LinearRings(input.Polygon, context)
    });
};
var serializeAws_restJson1IdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1LinearRing = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var serializeAws_restJson1LinearRings = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1LinearRing(entry, context);
    });
};
var serializeAws_restJson1MapConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.Style != null && {
        Style: input.Style
    });
};
var serializeAws_restJson1Position = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return (0, _smithyClient.serializeFloat)(entry);
    });
};
var serializeAws_restJson1PositionalAccuracy = function(input, context) {
    return (0, _tslib.__assign)({}, input.Horizontal != null && {
        Horizontal: (0, _smithyClient.serializeFloat)(input.Horizontal)
    });
};
var serializeAws_restJson1PositionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var serializeAws_restJson1PropertyMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TagMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TruckDimensions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Height != null && {
        Height: (0, _smithyClient.serializeFloat)(input.Height)
    }), input.Length != null && {
        Length: (0, _smithyClient.serializeFloat)(input.Length)
    }), input.Unit != null && {
        Unit: input.Unit
    }), input.Width != null && {
        Width: (0, _smithyClient.serializeFloat)(input.Width)
    });
};
var serializeAws_restJson1TruckWeight = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Total != null && {
        Total: (0, _smithyClient.serializeFloat)(input.Total)
    }), input.Unit != null && {
        Unit: input.Unit
    });
};
var serializeAws_restJson1WaypointPositionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var deserializeAws_restJson1ArnList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchDeleteDevicePositionHistoryError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteGeofenceError = function(output, context) {
    return {
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId)
    };
};
var deserializeAws_restJson1BatchDeleteGeofenceErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchDeleteGeofenceError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchEvaluateGeofencesError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1BatchEvaluateGeofencesErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchEvaluateGeofencesError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetDevicePositionError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1BatchGetDevicePositionErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchGetDevicePositionError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchItemError = function(output, context) {
    return {
        Code: (0, _smithyClient.expectString)(output.Code),
        Message: (0, _smithyClient.expectString)(output.Message)
    };
};
var deserializeAws_restJson1BatchPutGeofenceError = function(output, context) {
    return {
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId)
    };
};
var deserializeAws_restJson1BatchPutGeofenceErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchPutGeofenceError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchPutGeofenceSuccess = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1BatchPutGeofenceSuccessList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchPutGeofenceSuccess(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchUpdateDevicePositionError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1BatchUpdateDevicePositionErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchUpdateDevicePositionError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BoundingBox = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.limitedParseDouble)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1CalculateRouteMatrixSummary = function(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        DistanceUnit: (0, _smithyClient.expectString)(output.DistanceUnit),
        ErrorCount: (0, _smithyClient.expectInt32)(output.ErrorCount),
        RouteCount: (0, _smithyClient.expectInt32)(output.RouteCount)
    };
};
var deserializeAws_restJson1CalculateRouteSummary = function(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DistanceUnit: (0, _smithyClient.expectString)(output.DistanceUnit),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        RouteBBox: output.RouteBBox != null ? deserializeAws_restJson1BoundingBox(output.RouteBBox, context) : undefined
    };
};
var deserializeAws_restJson1Circle = function(output, context) {
    return {
        Center: output.Center != null ? deserializeAws_restJson1Position(output.Center, context) : undefined,
        Radius: (0, _smithyClient.limitedParseDouble)(output.Radius)
    };
};
var deserializeAws_restJson1CountryCodeList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1DataSourceConfiguration = function(output, context) {
    return {
        IntendedUse: (0, _smithyClient.expectString)(output.IntendedUse)
    };
};
var deserializeAws_restJson1DevicePosition = function(output, context) {
    return {
        Accuracy: output.Accuracy != null ? deserializeAws_restJson1PositionalAccuracy(output.Accuracy, context) : undefined,
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined,
        PositionProperties: output.PositionProperties != null ? deserializeAws_restJson1PropertyMap(output.PositionProperties, context) : undefined,
        ReceivedTime: output.ReceivedTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.ReceivedTime)) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1DevicePositionList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1DevicePosition(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1GeofenceGeometry = function(output, context) {
    return {
        Circle: output.Circle != null ? deserializeAws_restJson1Circle(output.Circle, context) : undefined,
        Polygon: output.Polygon != null ? deserializeAws_restJson1LinearRings(output.Polygon, context) : undefined
    };
};
var deserializeAws_restJson1Leg = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        EndPosition: output.EndPosition != null ? deserializeAws_restJson1Position(output.EndPosition, context) : undefined,
        Geometry: output.Geometry != null ? deserializeAws_restJson1LegGeometry(output.Geometry, context) : undefined,
        StartPosition: output.StartPosition != null ? deserializeAws_restJson1Position(output.StartPosition, context) : undefined,
        Steps: output.Steps != null ? deserializeAws_restJson1StepList(output.Steps, context) : undefined
    };
};
var deserializeAws_restJson1LegGeometry = function(output, context) {
    return {
        LineString: output.LineString != null ? deserializeAws_restJson1LineString(output.LineString, context) : undefined
    };
};
var deserializeAws_restJson1LegList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Leg(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LinearRing = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LinearRings = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1LinearRing(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LineString = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListDevicePositionsResponseEntry = function(output, context) {
    return {
        Accuracy: output.Accuracy != null ? deserializeAws_restJson1PositionalAccuracy(output.Accuracy, context) : undefined,
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined,
        PositionProperties: output.PositionProperties != null ? deserializeAws_restJson1PropertyMap(output.PositionProperties, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1ListDevicePositionsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListDevicePositionsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListGeofenceCollectionsResponseEntry = function(output, context) {
    return {
        CollectionName: (0, _smithyClient.expectString)(output.CollectionName),
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        PricingPlanDataSource: (0, _smithyClient.expectString)(output.PricingPlanDataSource),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListGeofenceCollectionsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListGeofenceResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId),
        Geometry: output.Geometry != null ? deserializeAws_restJson1GeofenceGeometry(output.Geometry, context) : undefined,
        Status: (0, _smithyClient.expectString)(output.Status),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListGeofenceResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListGeofenceResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListMapsResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        MapName: (0, _smithyClient.expectString)(output.MapName),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListMapsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListMapsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListPlaceIndexesResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        IndexName: (0, _smithyClient.expectString)(output.IndexName),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListPlaceIndexesResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListPlaceIndexesResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListRouteCalculatorsResponseEntry = function(output, context) {
    return {
        CalculatorName: (0, _smithyClient.expectString)(output.CalculatorName),
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListRouteCalculatorsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListRouteCalculatorsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListTrackersResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        PricingPlanDataSource: (0, _smithyClient.expectString)(output.PricingPlanDataSource),
        TrackerName: (0, _smithyClient.expectString)(output.TrackerName),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListTrackersResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListTrackersResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MapConfiguration = function(output, context) {
    return {
        Style: (0, _smithyClient.expectString)(output.Style)
    };
};
var deserializeAws_restJson1Place = function(output, context) {
    return {
        AddressNumber: (0, _smithyClient.expectString)(output.AddressNumber),
        Country: (0, _smithyClient.expectString)(output.Country),
        Geometry: output.Geometry != null ? deserializeAws_restJson1PlaceGeometry(output.Geometry, context) : undefined,
        Interpolated: (0, _smithyClient.expectBoolean)(output.Interpolated),
        Label: (0, _smithyClient.expectString)(output.Label),
        Municipality: (0, _smithyClient.expectString)(output.Municipality),
        Neighborhood: (0, _smithyClient.expectString)(output.Neighborhood),
        PostalCode: (0, _smithyClient.expectString)(output.PostalCode),
        Region: (0, _smithyClient.expectString)(output.Region),
        Street: (0, _smithyClient.expectString)(output.Street),
        SubRegion: (0, _smithyClient.expectString)(output.SubRegion),
        TimeZone: output.TimeZone != null ? deserializeAws_restJson1TimeZone(output.TimeZone, context) : undefined,
        UnitNumber: (0, _smithyClient.expectString)(output.UnitNumber),
        UnitType: (0, _smithyClient.expectString)(output.UnitType)
    };
};
var deserializeAws_restJson1PlaceGeometry = function(output, context) {
    return {
        Point: output.Point != null ? deserializeAws_restJson1Position(output.Point, context) : undefined
    };
};
var deserializeAws_restJson1Position = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.limitedParseDouble)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1PositionalAccuracy = function(output, context) {
    return {
        Horizontal: (0, _smithyClient.limitedParseDouble)(output.Horizontal)
    };
};
var deserializeAws_restJson1PositionList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PropertyMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1RouteMatrix = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RouteMatrixRow(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1RouteMatrixEntry = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        Error: output.Error != null ? deserializeAws_restJson1RouteMatrixEntryError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1RouteMatrixEntryError = function(output, context) {
    return {
        Code: (0, _smithyClient.expectString)(output.Code),
        Message: (0, _smithyClient.expectString)(output.Message)
    };
};
var deserializeAws_restJson1RouteMatrixRow = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RouteMatrixEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForPositionResult = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : undefined,
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId)
    };
};
var deserializeAws_restJson1SearchForPositionResultList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForPositionResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForSuggestionsResult = function(output, context) {
    return {
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId),
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1SearchForSuggestionsResultList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForSuggestionsResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForTextResult = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : undefined,
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId),
        Relevance: (0, _smithyClient.limitedParseDouble)(output.Relevance)
    };
};
var deserializeAws_restJson1SearchForTextResultList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForTextResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchPlaceIndexForPositionSummary = function(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined
    };
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary = function(output, context) {
    return {
        BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : undefined,
        FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : undefined,
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1SearchPlaceIndexForTextSummary = function(output, context) {
    return {
        BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : undefined,
        FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : undefined,
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        ResultBBox: output.ResultBBox != null ? deserializeAws_restJson1BoundingBox(output.ResultBBox, context) : undefined,
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1Step = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        EndPosition: output.EndPosition != null ? deserializeAws_restJson1Position(output.EndPosition, context) : undefined,
        GeometryOffset: (0, _smithyClient.expectInt32)(output.GeometryOffset),
        StartPosition: output.StartPosition != null ? deserializeAws_restJson1Position(output.StartPosition, context) : undefined
    };
};
var deserializeAws_restJson1StepList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Step(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TagMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1TimeZone = function(output, context) {
    return {
        Name: (0, _smithyClient.expectString)(output.Name),
        Offset: (0, _smithyClient.expectInt32)(output.Offset)
    };
};
var deserializeAws_restJson1ValidationExceptionField = function(output, context) {
    return {
        Message: (0, _smithyClient.expectString)(output.message),
        Name: (0, _smithyClient.expectString)(output.name)
    };
};
var deserializeAws_restJson1ValidationExceptionFieldList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ValidationExceptionField(entry, context);
    });
    return retVal;
};
var deserializeMetadata = function(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"tslib":"55hEF","@aws-sdk/protocol-http":"j4nIU","@aws-sdk/smithy-client":"l83SD","../models/LocationServiceException":"9E46N","../models/models_0":"kPki9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"acKoL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchPutGeofenceCommand", ()=>BatchPutGeofenceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var BatchPutGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(BatchPutGeofenceCommand, _super);
    function BatchPutGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    BatchPutGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "BatchPutGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.BatchPutGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.BatchPutGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchPutGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1BatchPutGeofenceCommand)(input, context);
    };
    BatchPutGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1BatchPutGeofenceCommand)(output, context);
    };
    return BatchPutGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iA5e0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetGeofenceCommand", ()=>GetGeofenceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var GetGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(GetGeofenceCommand, _super);
    function GetGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "GetGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.GetGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1GetGeofenceCommand)(input, context);
    };
    GetGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1GetGeofenceCommand)(output, context);
    };
    return GetGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kn7aU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetPlaceCommand", ()=>GetPlaceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var GetPlaceCommand = function(_super) {
    (0, _tslib.__extends)(GetPlaceCommand, _super);
    function GetPlaceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetPlaceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "GetPlaceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetPlaceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.GetPlaceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPlaceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1GetPlaceCommand)(input, context);
    };
    GetPlaceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1GetPlaceCommand)(output, context);
    };
    return GetPlaceCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lFvks":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListGeofencesCommand", ()=>ListGeofencesCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var ListGeofencesCommand = function(_super) {
    (0, _tslib.__extends)(ListGeofencesCommand, _super);
    function ListGeofencesCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListGeofencesCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "ListGeofencesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.ListGeofencesRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.ListGeofencesResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListGeofencesCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1ListGeofencesCommand)(input, context);
    };
    ListGeofencesCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1ListGeofencesCommand)(output, context);
    };
    return ListGeofencesCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hVddP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionCommand", ()=>SearchPlaceIndexForPositionCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForPositionCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForPositionCommand, _super);
    function SearchPlaceIndexForPositionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForPositionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForPositionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForPositionRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForPositionResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForPositionCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForPositionCommand)(input, context);
    };
    SearchPlaceIndexForPositionCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForPositionCommand)(output, context);
    };
    return SearchPlaceIndexForPositionCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3219k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsCommand", ()=>SearchPlaceIndexForSuggestionsCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForSuggestionsCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForSuggestionsCommand, _super);
    function SearchPlaceIndexForSuggestionsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForSuggestionsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForSuggestionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForSuggestionsCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand)(input, context);
    };
    SearchPlaceIndexForSuggestionsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand)(output, context);
    };
    return SearchPlaceIndexForSuggestionsCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iQxnx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForTextCommand", ()=>SearchPlaceIndexForTextCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForTextCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForTextCommand, _super);
    function SearchPlaceIndexForTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForTextCommand)(input, context);
    };
    SearchPlaceIndexForTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForTextCommand)(output, context);
    };
    return SearchPlaceIndexForTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"55hEF","@aws-sdk/middleware-serde":"2Dlnp","@aws-sdk/smithy-client":"l83SD","../models/models_0":"kPki9","../protocols/Aws_restJson1":"5UTGv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7YMzF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateCoordinates", ()=>validateCoordinates);
parcelHelpers.export(exports, "validateGeofenceId", ()=>validateGeofenceId);
parcelHelpers.export(exports, "validateLinearRing", ()=>validateLinearRing);
parcelHelpers.export(exports, "validatePolygon", ()=>validatePolygon);
parcelHelpers.export(exports, "validateGeofencesInput", ()=>validateGeofencesInput);
parcelHelpers.export(exports, "mapSearchOptions", ()=>mapSearchOptions);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _booleanClockwise = require("@turf/boolean-clockwise");
var _booleanClockwiseDefault = parcelHelpers.interopDefault(_booleanClockwise);
function validateCoordinates(lng, lat) {
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) throw new Error("Invalid coordinates: [" + lng + "," + lat + "]");
    if (lat < -90 || 90 < lat) throw new Error("Latitude must be between -90 and 90 degrees inclusive.");
    else if (lng < -180 || 180 < lng) throw new Error("Longitude must be between -180 and 180 degrees inclusive.");
}
function validateGeofenceId(geofenceId) {
    var geofenceIdRegex = /^[-._\p{L}\p{N}]+$/iu;
    // Check if geofenceId is valid
    if (!geofenceIdRegex.test(geofenceId)) throw new Error("Invalid geofenceId: '" + geofenceId + "' - IDs can only contain alphanumeric characters, hyphens, underscores and periods.");
}
function validateLinearRing(linearRing, geofenceId) {
    var errorPrefix = geofenceId ? geofenceId + ": " : "";
    // Validate LinearRing size, must be at least 4 points
    if (linearRing.length < 4) throw new Error(errorPrefix + "LinearRing must contain 4 or more coordinates.");
    // Validate all coordinates are valid, error with which ones are bad
    var badCoordinates = [];
    linearRing.forEach(function(coordinates) {
        try {
            validateCoordinates(coordinates[0], coordinates[1]);
        } catch (error) {
            badCoordinates.push({
                coordinates: coordinates,
                error: error.message
            });
        }
    });
    if (badCoordinates.length > 0) throw new Error(errorPrefix + "One or more of the coordinates in the Polygon LinearRing are not valid: " + JSON.stringify(badCoordinates));
    // Validate first and last coordinates are the same
    var _a = (0, _tslib.__read)(linearRing[0], 2), lngA = _a[0], latA = _a[1];
    var _b = (0, _tslib.__read)(linearRing[linearRing.length - 1], 2), lngB = _b[0], latB = _b[1];
    if (lngA !== lngB || latA !== latB) throw new Error(errorPrefix + "LinearRing's first and last coordinates are not the same");
    if ((0, _booleanClockwiseDefault.default)(linearRing)) throw new Error(errorPrefix + "LinearRing coordinates must be wound counterclockwise");
}
function validatePolygon(polygon, geofenceId) {
    var errorPrefix = geofenceId ? geofenceId + ": " : "";
    if (!Array.isArray(polygon)) throw new Error(errorPrefix + "Polygon is of incorrect structure. It should be an array of LinearRings");
    if (polygon.length < 1) throw new Error(errorPrefix + "Polygon must have a single LinearRing array.");
    if (polygon.length > 1) throw new Error(errorPrefix + "Polygon must have a single LinearRing array. Note: We do not currently support polygons with holes, multipolygons, polygons that are wound clockwise, or that cross the antimeridian.");
    var verticesCount = polygon.reduce(function(prev, linearRing) {
        return prev + linearRing.length;
    }, 0);
    if (verticesCount > 1000) throw new Error(errorPrefix + "Polygon has more than the maximum 1000 vertices.");
    polygon.forEach(function(linearRing) {
        validateLinearRing(linearRing, geofenceId);
    });
}
function validateGeofencesInput(geofences) {
    var geofenceIds = {};
    geofences.forEach(function(geofence) {
        // verify all required properties are present
        // Validate geofenceId exists
        if (!geofence.geofenceId) throw new Error("Geofence '" + geofence + "' is missing geofenceId");
        var geofenceId = geofence.geofenceId;
        validateGeofenceId(geofenceId);
        // Validate geofenceId is unique
        if (geofenceIds[geofenceId]) throw new Error("Duplicate geofenceId: " + geofenceId);
        else geofenceIds[geofenceId] = true;
        // Validate geometry exists
        if (!geofence.geometry) throw new Error("Geofence '" + geofenceId + "' is missing geometry");
        var geometry = geofence.geometry;
        // Validate polygon exists
        if (!geometry.polygon) throw new Error("Geofence '" + geofenceId + "' is missing geometry.polygon");
        var polygon = geometry.polygon;
        // Validate polygon length and structure
        try {
            validatePolygon(polygon, geofenceId);
        } catch (error) {
            if (error.message.includes("Polygon has more than the maximum 1000 vertices.")) throw new Error("Geofence '" + geofenceId + "' has more than the maximum of 1000 vertices");
        }
        // Validate LinearRing length, structure, and coordinates
        var _a = (0, _tslib.__read)(polygon, 1), linearRing = _a[0];
        validateLinearRing(linearRing, geofenceId);
    });
}
function mapSearchOptions(options, locationServiceInput) {
    var locationServiceModifiedInput = (0, _tslib.__assign)({}, locationServiceInput);
    locationServiceModifiedInput.FilterCountries = options.countries;
    locationServiceModifiedInput.MaxResults = options.maxResults;
    if (options.searchIndexName) locationServiceModifiedInput.IndexName = options.searchIndexName;
    if (options["biasPosition"] && options["searchAreaConstraints"]) throw new Error("BiasPosition and SearchAreaConstraints are mutually exclusive, please remove one or the other from the options object");
    if (options["biasPosition"]) locationServiceModifiedInput.BiasPosition = options["biasPosition"];
    if (options["searchAreaConstraints"]) locationServiceModifiedInput.FilterBBox = options["searchAreaConstraints"];
    return locationServiceModifiedInput;
}

},{"tslib":"9gMVn","@turf/boolean-clockwise":"4EeGh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4EeGh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>booleanClockwise);
var _invariant = require("@turf/invariant");
function booleanClockwise(line) {
    var ring = (0, _invariant.getCoords)(line);
    var sum = 0;
    var i = 1;
    var prev;
    var cur;
    while(i < ring.length){
        prev = cur || ring[0];
        cur = ring[i];
        sum += (cur[0] - prev[0]) * (cur[1] + prev[1]);
        i++;
    }
    return sum > 0;
}

},{"@turf/invariant":"b6gTv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b6gTv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ parcelHelpers.export(exports, "getCoord", ()=>getCoord);
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ parcelHelpers.export(exports, "getCoords", ()=>getCoords);
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ parcelHelpers.export(exports, "containsNumber", ()=>containsNumber);
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "geojsonType", ()=>geojsonType);
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ parcelHelpers.export(exports, "featureOf", ()=>featureOf);
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "collectionOf", ()=>collectionOf);
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ parcelHelpers.export(exports, "getGeom", ()=>getGeom);
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message (unused)
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ parcelHelpers.export(exports, "getType", ()=>getType);
var _helpers = require("@turf/helpers");
function getCoord(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function containsNumber(coordinates) {
    if (coordinates.length > 1 && (0, _helpers.isNumber)(coordinates[0]) && (0, _helpers.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return containsNumber(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function geojsonType(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function featureOf(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function collectionOf(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function getGeom(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function getType(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

},{"@turf/helpers":"llMUu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"llMUu":[function(require,module,exports) {
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "earthRadius", ()=>earthRadius);
parcelHelpers.export(exports, "factors", ()=>factors);
parcelHelpers.export(exports, "unitsFactors", ()=>unitsFactors);
parcelHelpers.export(exports, "areaFactors", ()=>areaFactors);
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ parcelHelpers.export(exports, "feature", ()=>feature);
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */ parcelHelpers.export(exports, "geometry", ()=>geometry);
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ parcelHelpers.export(exports, "point", ()=>point);
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ parcelHelpers.export(exports, "points", ()=>points);
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ parcelHelpers.export(exports, "polygon", ()=>polygon);
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ parcelHelpers.export(exports, "polygons", ()=>polygons);
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ parcelHelpers.export(exports, "lineString", ()=>lineString);
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ parcelHelpers.export(exports, "lineStrings", ()=>lineStrings);
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ parcelHelpers.export(exports, "featureCollection", ()=>featureCollection);
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ parcelHelpers.export(exports, "multiLineString", ()=>multiLineString);
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ parcelHelpers.export(exports, "multiPoint", ()=>multiPoint);
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ parcelHelpers.export(exports, "multiPolygon", ()=>multiPolygon);
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */ parcelHelpers.export(exports, "geometryCollection", ()=>geometryCollection);
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */ parcelHelpers.export(exports, "radiansToLength", ()=>radiansToLength);
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */ parcelHelpers.export(exports, "lengthToRadians", ()=>lengthToRadians);
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */ parcelHelpers.export(exports, "lengthToDegrees", ()=>lengthToDegrees);
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ parcelHelpers.export(exports, "bearingToAzimuth", ()=>bearingToAzimuth);
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ parcelHelpers.export(exports, "radiansToDegrees", ()=>radiansToDegrees);
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ parcelHelpers.export(exports, "degreesToRadians", ()=>degreesToRadians);
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */ parcelHelpers.export(exports, "convertLength", ()=>convertLength);
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */ parcelHelpers.export(exports, "convertArea", ()=>convertArea);
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ parcelHelpers.export(exports, "isNumber", ()=>isNumber);
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateBBox", ()=>validateBBox);
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateId", ()=>validateId);
var earthRadius = 6371008.8;
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: earthRadius / 111325,
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1000,
    kilometres: earthRadius / 1000,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1000,
    millimetres: earthRadius * 1000,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936
};
var unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / earthRadius,
    yards: 1.0936133
};
var areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function feature(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function geometry(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function point(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function points(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return point(coords, properties);
    }), options);
}
function polygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function polygons(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return polygon(coords, properties);
    }), options);
}
function lineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return lineString(coords, properties);
    }), options);
}
function featureCollection(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function multiLineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return feature(geom, properties, options);
}
function round(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function lengthToRadians(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = areaFactors[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = areaFactors[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
    return !!input && input.constructor === Object;
}
function validateBBox(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!isNumber(num)) throw new Error("bbox must only contain numbers");
    });
}
function validateId(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"74uMJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _awsAmplify = require("aws-amplify");
async function getAccessToken() {
    try {
        const session = await (0, _awsAmplify.Auth).currentSession();
        return session.accessToken.jwtToken;
    } catch (e) {
        return null;
    }
}
function getCustomerDomain() {
    const [domain] = window.location.hostname.split(".");
    return domain;
}
async function getAuthHeaders() {
    const accessToken = await getAccessToken();
    const customerDomain = getCustomerDomain();
    if (accessToken && customerDomain) return {
        Authorization: `Bearer ${customerDomain}:${accessToken}`
    };
    return null;
}
exports.default = {
    API: {
        endpoints: [
            {
                name: "audit-apis",
                endpoint: "https://056k34b3gj.execute-api.us-west-2.amazonaws.com/production",
                custom_header: getAuthHeaders
            }
        ]
    }
};

},{"aws-amplify":"aGGkJ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h7n6R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
/** @jsx jsx */ /* eslint react/jsx-filename-extension: 0 */ /* eslint jsx-a11y/anchor-is-valid: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _core = require("@emotion/core");
var _semanticUiReact = require("semantic-ui-react");
var _indexStyles = require("./index.styles");
var _indexStylesDefault = parcelHelpers.interopDefault(_indexStyles);
var _stackedBarByDepartment = require("./stacked-bar-by-department");
var _stackedBarByDepartmentDefault = parcelHelpers.interopDefault(_stackedBarByDepartment);
var _stackedBarByAudit = require("./stacked-bar-by-audit");
var _stackedBarByAuditDefault = parcelHelpers.interopDefault(_stackedBarByAudit);
var _stackedBarByYear = require("./stacked-bar-by-year");
var _stackedBarByYearDefault = parcelHelpers.interopDefault(_stackedBarByYear);
var _recommendationTable = require("./recommendation-table");
var _recommendationTableDefault = parcelHelpers.interopDefault(_recommendationTable);
var _pie = require("./pie");
var _pieDefault = parcelHelpers.interopDefault(_pie);
var _updateStatuses = require("./update-statuses");
var _updateStatusesDefault = parcelHelpers.interopDefault(_updateStatuses);
var _customGraphColors = require("./custom-graph-colors");
const request = require("bfc270a8f1b4d717");
const recommendationDashboardBucket = "s3-recommendation-dashboard-production";
class RecommendationDashboard extends (0, _react.Component) {
    componentDidMount() {
        const { match } = this.props;
        const { dashboardId } = match.params;
        if (dashboardId) {
            this.getChartingData(dashboardId);
            this.getStatus(dashboardId);
        }
    }
    async getStatus(customerId) {
        const updateStatuses = await (0, _updateStatusesDefault.default).get(customerId);
        this.setState({
            statusKeys: (0, _lodashDefault.default).map(updateStatuses, "value")
        });
    }
    handleChartClick(event, filterPrimary, filterSecondary) {
        const { recommendationsTableCopy } = this.state;
        const filter1 = event.id && (0, _lodashDefault.default).filter(recommendationsTableCopy, {
            [filterPrimary]: event.id
        }) || recommendationsTableCopy;
        if (filterSecondary) {
            const filter2 = event.indexValue && (0, _lodashDefault.default).filter(filter1, {
                [filterSecondary]: event.indexValue
            }) || filter1;
            this.setState({
                recommendationsTable: filter2,
                filteredText: `${event.indexValue} and ${event.id}`,
                activeFilterPrimary: filterPrimary,
                activeFilterSecondary: filterSecondary || null
            });
        } else this.setState({
            recommendationsTable: filter1,
            filteredText: `${event.id}`,
            activeFilterPrimary: filterPrimary
        });
    }
    handleDashboardSectionClick(section) {
        this.setState({
            activeDashboardSection: section
        });
    }
    resetTable() {
        const { recommendationsTableCopy } = this.state;
        this.setState({
            recommendationsTable: recommendationsTableCopy,
            filteredText: null,
            activeFilterPrimary: null,
            activeFilterSecondary: null
        });
    }
    handleSort(clickedColumn) {
        const { sortColumn, sortDirection, recommendationsTable } = this.state;
        if (sortColumn !== clickedColumn) {
            this.setState({
                sortColumn: clickedColumn,
                recommendationsTable: (0, _lodashDefault.default).sortBy(recommendationsTable, [
                    clickedColumn
                ]),
                sortDirection: "ascending"
            });
            return;
        }
        this.setState({
            recommendationsTable: recommendationsTable.reverse(),
            sortDirection: sortDirection === "ascending" ? "descending" : "ascending"
        });
    }
    async getChartingData(dashboardId) {
        const requestUrl = `https://${recommendationDashboardBucket}.s3-us-west-2.amazonaws.com/${dashboardId}/current.json`;
        const params = {
            method: "GET",
            uri: requestUrl,
            json: true,
            headers: {
                "Cache-Control": "no-cache"
            }
        };
        const dashboardData = await request(params);
        const { byDepartmentAndStatus, byYearAndStatus, byAuditAndStatus, byInvestigationAndStatus, byStatus, byCategory, overallStats, recommendationsTable } = dashboardData.open;
        const { trackSavings, recommendationStatuses = [], recommendationCategories = [], recommendationColor = [] } = dashboardData;
        const topTwentyAudits = (0, _lodashDefault.default).takeRight(byAuditAndStatus, 20);
        const topTwentyInvestigations = (0, _lodashDefault.default).takeRight(byInvestigationAndStatus, 20);
        this.setState({
            dashboardData,
            byDepartmentAndStatus,
            byYearAndStatus,
            byAuditAndStatus: topTwentyAudits,
            byInvestigationAndStatus: topTwentyInvestigations,
            byStatus,
            byCategory,
            overallStats,
            recommendationsTable,
            recommendationsTableCopy: recommendationsTable,
            chartingDataIsLoading: false,
            trackSavings,
            recommendationStatuses,
            recommendationCategories,
            recommendationColor
        });
    }
    filterRecommendations(status) {
        const { dashboardData } = this.state;
        const { byDepartmentAndStatus, byYearAndStatus, byAuditAndStatus, byInvestigationAndStatus, byStatus, byCategory, overallStats, recommendationsTable } = status === "open" && dashboardData.open || status === "closed" && dashboardData.closed || dashboardData.all;
        const sortedByDepartmentAndStatus = (0, _lodashDefault.default).sortBy(byDepartmentAndStatus, "totalCount");
        const sortedByAuditAndStatus = (0, _lodashDefault.default)(byAuditAndStatus).sortBy("totalCount").takeRight(20).value();
        const sortedByInvestigationAndStatus = (0, _lodashDefault.default)(byInvestigationAndStatus).sortBy("totalCount").takeRight(20).value();
        this.setState({
            byDepartmentAndStatus: sortedByDepartmentAndStatus,
            byYearAndStatus,
            byAuditAndStatus: sortedByAuditAndStatus,
            byInvestigationAndStatus: sortedByInvestigationAndStatus,
            byStatus,
            byCategory,
            overallStats,
            recommendationsTable,
            recommendationsTableCopy: recommendationsTable
        });
    }
    render() {
        // Functiond for chart clicking interaction
        const currencyFormatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0
        });
        const { byDepartmentAndStatus, byYearAndStatus, byAuditAndStatus, byInvestigationAndStatus, byStatus, byCategory, overallStats, statusKeys, recommendationsTable, sortColumn, sortDirection, chartingDataIsLoading, filteredText, activeDashboardSection, activeFilterPrimary, activeFilterSecondary, trackSavings, recommendationStatuses, recommendationCategories, recommendationColor } = this.state;
        const { handleSort, resetTable, handleChartClick } = this;
        const paramsRecommendationTable = {
            recommendations: recommendationsTable,
            handleSort,
            sortColumn,
            sortDirection,
            chartingDataIsLoading,
            activeFilterPrimary,
            activeFilterSecondary
        };
        const primaryColorObject = (0, _lodashDefault.default).find(recommendationColor, {
            name: "Primary Color"
        });
        const primaryColor = (0, _lodashDefault.default).get(primaryColorObject, "primaryColor");
        const styles = (0, _indexStylesDefault.default)(primaryColor);
        const graphTextColorObject = (0, _lodashDefault.default).find(recommendationColor, {
            name: "Graph Text Color"
        });
        const graphTextColor = (0, _lodashDefault.default).get(graphTextColorObject, "graphTextColor");
        const pieGraphColorData = (data, colors)=>{
            const hasStatus = data.some((item)=>item && typeof item === "object" && "status" in item);
            if (hasStatus) return (0, _customGraphColors.addPhaseColorsToPieData)(data, colors);
            return (0, _customGraphColors.addCategoryColorsToPieData)(data, colors);
        };
        const pieDataForCategories = pieGraphColorData(byCategory, recommendationCategories);
        const pieDataForStatuses = pieGraphColorData(byStatus, recommendationStatuses);
        const filterOptions = [
            {
                key: "open",
                value: "open",
                text: "open recommendations"
            },
            {
                key: "closed",
                value: "closed",
                text: "closed recommendations"
            },
            {
                key: "all",
                value: "all",
                text: "open & closed recommendations"
            }
        ];
        const hasInvestigations = byInvestigationAndStatus.length > 0;
        return /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Container), {
            css: styles
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            columns: 4
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            className: "reco-filter"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 16,
            textAlign: "center"
        }, "Showing all \xa0", /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Dropdown), {
            defaultValue: "open",
            inline: true,
            options: filterOptions,
            placeholder: "choose below",
            onChange: (e, d)=>this.filterRecommendations(d.value)
        }), /*#__PURE__*/ (0, _core.jsx)("br", null), /*#__PURE__*/ (0, _core.jsx)("a", {
            href: "#",
            onClick: ()=>window.open(window.location.href, "_blank")
        }, "View Full Screen \uD83D\uDDD6"))), chartingDataIsLoading ? /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Loader), {
            active: true,
            inline: "centered"
        }, "Loading") : /*#__PURE__*/ (0, _core.jsx)((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            centered: true,
            className: "reco-stats"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 16
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid), null, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            centered: true
        }, !trackSavings && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3
        }), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3,
            className: "reco-stat"
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-stat-body"
        }, /*#__PURE__*/ (0, _core.jsx)("h4", null, overallStats.auditCount), /*#__PURE__*/ (0, _core.jsx)("h5", null, "Audit Reports"))), overallStats.investigationCount > 0 && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3,
            className: "reco-stat"
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-stat-body"
        }, /*#__PURE__*/ (0, _core.jsx)("h4", null, overallStats.investigationCount), /*#__PURE__*/ (0, _core.jsx)("h5", null, "Investigations"))), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3,
            className: "reco-stat"
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-stat-body"
        }, /*#__PURE__*/ (0, _core.jsx)("h4", null, overallStats.recommendationCount), /*#__PURE__*/ (0, _core.jsx)("h5", null, "Recommendations"))), !trackSavings && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3
        }), trackSavings && /*#__PURE__*/ (0, _core.jsx)((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3,
            className: "reco-stat"
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-stat-body"
        }, /*#__PURE__*/ (0, _core.jsx)("h4", null, currencyFormatter.format(overallStats.recommendationExpectedBenefit || 0)), /*#__PURE__*/ (0, _core.jsx)("h5", null, "Potential Benefit"))), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 3,
            className: "reco-stat reco-suav\xe9"
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-stat-body"
        }, /*#__PURE__*/ (0, _core.jsx)("h4", null, currencyFormatter.format(overallStats.recommendationRealizedBenefit || 0)), /*#__PURE__*/ (0, _core.jsx)("h5", null, "Realized Benefit")))))))), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, null, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid), {
            centered: true,
            className: "reco-nav",
            style: {
                marginTop: 10
            }
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, null, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 4
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Button), {
            active: activeDashboardSection === 0,
            fluid: true,
            onClick: ()=>this.handleDashboardSectionClick(0)
        }, "Summary")), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 4
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Button), {
            active: activeDashboardSection === 1,
            fluid: true,
            onClick: ()=>this.handleDashboardSectionClick(1)
        }, "By Department")), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 4
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Button), {
            active: activeDashboardSection === 2,
            fluid: true,
            onClick: ()=>this.handleDashboardSectionClick(2)
        }, "By Audit")), hasInvestigations && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 4
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Button), {
            active: activeDashboardSection === 3,
            fluid: true,
            onClick: ()=>this.handleDashboardSectionClick(3)
        }, "By Investigation"))))), activeDashboardSection === 0 && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid), {
            className: "reco-detailed-stats"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            className: "reco-detailed-stats-feature"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 16
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-feature-chart"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h5",
            textAlign: "center",
            color: "grey"
        }, "Recommendations Issued by Year"), /*#__PURE__*/ (0, _core.jsx)((0, _stackedBarByYearDefault.default), {
            byYearAndStatus,
            statusKeys,
            handleChartClick,
            recommendationStatuses,
            graphTextColor
        })))), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, null, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 8
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-sub-visual"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h5",
            textAlign: "center",
            color: "grey"
        }, "Recommendations by Category"), /*#__PURE__*/ (0, _core.jsx)((0, _pieDefault.default), {
            data: pieDataForCategories,
            handleChartClick,
            clickType: "category",
            graphTextColor
        }))), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 8
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-sub-visual"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h5",
            textAlign: "center",
            color: "grey"
        }, "Recommendations by Status"), /*#__PURE__*/ (0, _core.jsx)((0, _pieDefault.default), {
            data: pieDataForStatuses,
            handleChartClick,
            clickType: "status",
            graphTextColor
        }))))), activeDashboardSection === 1 && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid), {
            className: "reco-detailed-stats"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            className: "reco-detailed-stats-feature"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 16
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-feature-chart"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h5",
            textAlign: "center",
            color: "grey"
        }, "Recommendations by Department and Status"), /*#__PURE__*/ (0, _core.jsx)((0, _stackedBarByDepartmentDefault.default), {
            byDepartmentAndStatus,
            statusKeys,
            handleChartClick,
            recommendationStatuses,
            graphTextColor
        }))))), activeDashboardSection === 2 && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid), {
            className: "reco-detailed-stats"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            className: "reco-detailed-stats-feature"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 16
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-feature-chart"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h5",
            textAlign: "center",
            color: "grey"
        }, "Recommendations Issued by Audit (Top 20)"), /*#__PURE__*/ (0, _core.jsx)((0, _stackedBarByAuditDefault.default), {
            byAuditAndStatus,
            statusKeys,
            handleChartClick,
            recommendationStatuses,
            graphTextColor
        }))))), activeDashboardSection === 3 && /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid), {
            className: "reco-detailed-stats"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            className: "reco-detailed-stats-feature"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 16
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-feature-chart"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h5",
            textAlign: "center",
            color: "grey"
        }, "Recommendations Issued by Investigation (Top 20)"), /*#__PURE__*/ (0, _core.jsx)((0, _stackedBarByAuditDefault.default), {
            byAuditAndStatus: byInvestigationAndStatus,
            statusKeys,
            handleChartClick,
            recommendationStatuses,
            graphTextColor
        }))))), /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Row, {
            width: 8
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Grid).Column, {
            width: 10
        }, /*#__PURE__*/ (0, _core.jsx)("div", {
            className: "reco-detailed-stats-header"
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header), {
            as: "h3",
            textAlign: "left"
        }, "Recommendation List", /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Header).Subheader, null, "This table will filter itself as you interact with the charts above.")), filteredText && /*#__PURE__*/ (0, _core.jsx)((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _core.jsx)("br", null), /*#__PURE__*/ (0, _core.jsx)("br", null), /*#__PURE__*/ (0, _core.jsx)("span", null, /*#__PURE__*/ (0, _core.jsx)("strong", null, "Filtered by: "), filteredText, "\xa0\xa0", /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Button), {
            size: "mini",
            compact: true,
            icon: true,
            labelPosition: "left",
            onClick: resetTable
        }, /*#__PURE__*/ (0, _core.jsx)((0, _semanticUiReact.Icon), {
            name: "undo alternate"
        }), "Reset Table"))), /*#__PURE__*/ (0, _core.jsx)((0, _recommendationTableDefault.default), paramsRecommendationTable)))))));
    }
    constructor(params){
        super(params);
        (0, _definePropertyDefault.default)(this, "state", {
            byDepartmentAndStatus: [],
            byYearAndStatus: [],
            byInvestigationAndStatus: [],
            byStatus: [],
            byCategory: [],
            overallStats: [],
            statusKeys: [],
            recommendationsTable: [],
            recommendationsTableCopy: [],
            sortColumn: "",
            sortDirection: "",
            chartingDataIsLoading: true,
            filteredText: null,
            activeFilterPrimary: null,
            activeFilterSecondary: null,
            activeDashboardSection: 0,
            dashboardData: null,
            trackSavings: true,
            recommendationStatuses: [],
            recommendationCategories: [],
            recommendationColor: []
        });
        this.getChartingData = this.getChartingData.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.resetTable = this.resetTable.bind(this);
        this.handleChartClick = this.handleChartClick.bind(this);
    }
}
RecommendationDashboard.propTypes = {
    match: (0, _propTypesDefault.default).shape({
        params: (0, _propTypesDefault.default).shape({
            dashboardId: (0, _propTypesDefault.default).string.isRequired
        }).isRequired
    }).isRequired
};
exports.default = RecommendationDashboard;

},{"@babel/runtime/helpers/defineProperty":"djTAw","react":"6AiW6","prop-types":"kKQPU","lodash":"hT5ak","@emotion/core":"f01eg","semantic-ui-react":"gydXr","./index.styles":"7DWEJ","./stacked-bar-by-department":"6FVld","./stacked-bar-by-audit":"b8p9A","./stacked-bar-by-year":"lqWmY","./recommendation-table":"jRBX6","./pie":"gwrfj","./update-statuses":"9Yjao","./custom-graph-colors":"leLSB","bfc270a8f1b4d717":"emIBu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"djTAw":[function(require,module,exports) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"ldMor"}],"ldMor":[function(require,module,exports) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"d1yVP","2713647ce51d8c75":"lLTGR"}],"d1yVP":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lLTGR":[function(require,module,exports) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"d1yVP"}],"hT5ak":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"f01eg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElement04D85134BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElement04D85134BrowserEsmJs.T));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElement04D85134BrowserEsmJs.w));
parcelHelpers.export(exports, "css", ()=>(0, _cssDefault.default));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _cache = require("@emotion/cache");
var _emotionElement04D85134BrowserEsmJs = require("./emotion-element-04d85134.browser.esm.js");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _sheet = require("@emotion/sheet");
var _css = require("@emotion/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement04D85134BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return (0, _react.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement04D85134BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement04D85134BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, _react.createElement).apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */ (0, _emotionElement04D85134BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === "function") return /*#__PURE__*/ (0, _react.createElement)((0, _emotionElement04D85134BrowserEsmJs.T).Consumer, null, function(theme) {
        var serialized = (0, _serialize.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, _react.createElement)(InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, _react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, _sheet.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, _react.Component));
var keyframes = function keyframes() {
    var insertable = (0, _cssDefault.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Noop = function Noop() {
    return null;
};
var ClassNames = (0, _emotionElement04D85134BrowserEsmJs.w)(function(props, context) {
    return /*#__PURE__*/ (0, _react.createElement)((0, _emotionElement04D85134BrowserEsmJs.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, _serialize.serializeStyles)(args, context.registered);
            (0, _utils.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return merge(context.registered, css, classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, _react.createElement)(Noop, null);
        return /*#__PURE__*/ (0, _react.createElement)((0, _react.Fragment), null, possiblyStyleElement, ele);
    });
});

},{"@babel/runtime/helpers/esm/inheritsLoose":"2bjHy","react":"6AiW6","@emotion/cache":"epOvR","./emotion-element-04d85134.browser.esm.js":"gRAG8","@emotion/utils":"eS4WP","@emotion/serialize":"9CVXD","@emotion/sheet":"fVen3","@emotion/css":"da5sp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2bjHy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"dyRSb","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dyRSb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"epOvR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sheet = require("@emotion/sheet");
var _stylis = require("@emotion/stylis");
var _stylisDefault = parcelHelpers.interopDefault(_stylis);
var _weakMemoize = require("@emotion/weak-memoize");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = "/*|*/";
var needle = delimiter + "}";
function toSheet(block) {
    if (block) Sheet.current.insert(block + "}");
}
var Sheet = {
    current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? delimiter : "");
            }
        case -2:
            content.split(needle).forEach(toSheet);
    }
};
var createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, _stylisDefault.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
exports.default = createCache;

},{"@emotion/sheet":"fVen3","@emotion/stylis":"1dhCm","@emotion/weak-memoize":"jQuvd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fVen3":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1dhCm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
exports.default = stylis_min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jQuvd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
exports.default = weakMemoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gRAG8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwnProperty);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var EmotionCacheContext = /*#__PURE__*/ (0, _react.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, _cacheDefault.default)() : null);
var ThemeContext = /*#__PURE__*/ (0, _react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, _react.createElement)(EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var Noop = function Noop() {
    return null;
};
var render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, _utils.insertStyles)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, _react.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, _react.createElement)(Noop, null);
    return /*#__PURE__*/ (0, _react.createElement)((0, _react.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    if (typeof props.css === "function") return /*#__PURE__*/ (0, _react.createElement)(ThemeContext.Consumer, null, function(theme) {
        return render(cache, props, theme, ref);
    });
    return render(cache, props, null, ref);
});

},{"@babel/runtime/helpers/inheritsLoose":"gRWRc","react":"6AiW6","@emotion/cache":"epOvR","@emotion/utils":"eS4WP","@emotion/serialize":"9CVXD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gRWRc":[function(require,module,exports) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"7x2ld"}],"7x2ld":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"eS4WP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9CVXD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var shouldWarnAboutInterpolatingClassNameFromCss = true;
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"4JuWt","@emotion/unitless":"eYn3Q","@emotion/memoize":"dxVqi","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4JuWt":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
exports.default = murmur2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eYn3Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dxVqi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"da5sp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _serialize = require("@emotion/serialize");
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
exports.default = css;

},{"@emotion/serialize":"9CVXD","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gydXr":[function(require,module,exports) {
// Addons
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Confirm", ()=>(0, _confirmDefault.default));
parcelHelpers.export(exports, "MountNode", ()=>(0, _mountNodeDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "PaginationItem", ()=>(0, _paginationItemDefault.default));
parcelHelpers.export(exports, "Portal", ()=>(0, _portalDefault.default));
parcelHelpers.export(exports, "PortalInner", ()=>(0, _portalInnerDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioDefault.default));
parcelHelpers.export(exports, "Ref", ()=>(0, _refDefault.default));
parcelHelpers.export(exports, "Responsive", ()=>(0, _responsiveDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "TextArea", ()=>(0, _textAreaDefault.default));
parcelHelpers.export(exports, "TransitionablePortal", ()=>(0, _transitionablePortalDefault.default)) // Behaviors
;
parcelHelpers.export(exports, "Visibility", ()=>(0, _visibilityDefault.default)) // Collections
;
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbDefault.default));
parcelHelpers.export(exports, "BreadcrumbDivider", ()=>(0, _breadcrumbDividerDefault.default));
parcelHelpers.export(exports, "BreadcrumbSection", ()=>(0, _breadcrumbSectionDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormButton", ()=>(0, _formButtonDefault.default));
parcelHelpers.export(exports, "FormCheckbox", ()=>(0, _formCheckboxDefault.default));
parcelHelpers.export(exports, "FormDropdown", ()=>(0, _formDropdownDefault.default));
parcelHelpers.export(exports, "FormField", ()=>(0, _formFieldDefault.default));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "FormInput", ()=>(0, _formInputDefault.default));
parcelHelpers.export(exports, "FormRadio", ()=>(0, _formRadioDefault.default));
parcelHelpers.export(exports, "FormSelect", ()=>(0, _formSelectDefault.default));
parcelHelpers.export(exports, "FormTextArea", ()=>(0, _formTextAreaDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "GridColumn", ()=>(0, _gridColumnDefault.default));
parcelHelpers.export(exports, "GridRow", ()=>(0, _gridRowDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MenuHeader", ()=>(0, _menuHeaderDefault.default));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "MenuMenu", ()=>(0, _menuMenuDefault.default));
parcelHelpers.export(exports, "Message", ()=>(0, _messageDefault.default));
parcelHelpers.export(exports, "MessageContent", ()=>(0, _messageContentDefault.default));
parcelHelpers.export(exports, "MessageHeader", ()=>(0, _messageHeaderDefault.default));
parcelHelpers.export(exports, "MessageItem", ()=>(0, _messageItemDefault.default));
parcelHelpers.export(exports, "MessageList", ()=>(0, _messageListDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TableBody", ()=>(0, _tableBodyDefault.default));
parcelHelpers.export(exports, "TableCell", ()=>(0, _tableCellDefault.default));
parcelHelpers.export(exports, "TableFooter", ()=>(0, _tableFooterDefault.default));
parcelHelpers.export(exports, "TableHeader", ()=>(0, _tableHeaderDefault.default));
parcelHelpers.export(exports, "TableHeaderCell", ()=>(0, _tableHeaderCellDefault.default));
parcelHelpers.export(exports, "TableRow", ()=>(0, _tableRowDefault.default)) // Elements
;
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "ButtonContent", ()=>(0, _buttonContentDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
parcelHelpers.export(exports, "ButtonOr", ()=>(0, _buttonOrDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Divider", ()=>(0, _dividerDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "Header", ()=>(0, _headerDefault.default));
parcelHelpers.export(exports, "HeaderContent", ()=>(0, _headerContentDefault.default));
parcelHelpers.export(exports, "HeaderSubheader", ()=>(0, _headerSubheaderDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconDefault.default));
parcelHelpers.export(exports, "IconGroup", ()=>(0, _iconGroupDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "ImageGroup", ()=>(0, _imageGroupDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "Label", ()=>(0, _labelDefault.default));
parcelHelpers.export(exports, "LabelDetail", ()=>(0, _labelDetailDefault.default));
parcelHelpers.export(exports, "LabelGroup", ()=>(0, _labelGroupDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListContent", ()=>(0, _listContentDefault.default));
parcelHelpers.export(exports, "ListDescription", ()=>(0, _listDescriptionDefault.default));
parcelHelpers.export(exports, "ListHeader", ()=>(0, _listHeaderDefault.default));
parcelHelpers.export(exports, "ListIcon", ()=>(0, _listIconDefault.default));
parcelHelpers.export(exports, "ListItem", ()=>(0, _listItemDefault.default));
parcelHelpers.export(exports, "ListList", ()=>(0, _listListDefault.default));
parcelHelpers.export(exports, "Loader", ()=>(0, _loaderDefault.default));
parcelHelpers.export(exports, "Placeholder", ()=>(0, _placeholderDefault.default));
parcelHelpers.export(exports, "PlaceholderHeader", ()=>(0, _placeholderHeaderDefault.default));
parcelHelpers.export(exports, "PlaceholderImage", ()=>(0, _placeholderImageDefault.default));
parcelHelpers.export(exports, "PlaceholderLine", ()=>(0, _placeholderLineDefault.default));
parcelHelpers.export(exports, "PlaceholderParagraph", ()=>(0, _placeholderParagraphDefault.default));
parcelHelpers.export(exports, "Rail", ()=>(0, _railDefault.default));
parcelHelpers.export(exports, "Reveal", ()=>(0, _revealDefault.default));
parcelHelpers.export(exports, "RevealContent", ()=>(0, _revealContentDefault.default));
parcelHelpers.export(exports, "Segment", ()=>(0, _segmentDefault.default));
parcelHelpers.export(exports, "SegmentGroup", ()=>(0, _segmentGroupDefault.default));
parcelHelpers.export(exports, "SegmentInline", ()=>(0, _segmentInlineDefault.default));
parcelHelpers.export(exports, "Step", ()=>(0, _stepDefault.default));
parcelHelpers.export(exports, "StepContent", ()=>(0, _stepContentDefault.default));
parcelHelpers.export(exports, "StepDescription", ()=>(0, _stepDescriptionDefault.default));
parcelHelpers.export(exports, "StepGroup", ()=>(0, _stepGroupDefault.default));
parcelHelpers.export(exports, "StepTitle", ()=>(0, _stepTitleDefault.default)) // Modules
;
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "AccordionAccordion", ()=>(0, _accordionAccordionDefault.default));
parcelHelpers.export(exports, "AccordionContent", ()=>(0, _accordionContentDefault.default));
parcelHelpers.export(exports, "AccordionPanel", ()=>(0, _accordionPanelDefault.default));
parcelHelpers.export(exports, "AccordionTitle", ()=>(0, _accordionTitleDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "Dimmer", ()=>(0, _dimmerDefault.default));
parcelHelpers.export(exports, "DimmerDimmable", ()=>(0, _dimmerDimmableDefault.default));
parcelHelpers.export(exports, "DimmerInner", ()=>(0, _dimmerInnerDefault.default));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdownDefault.default));
parcelHelpers.export(exports, "DropdownDivider", ()=>(0, _dropdownDividerDefault.default));
parcelHelpers.export(exports, "DropdownHeader", ()=>(0, _dropdownHeaderDefault.default));
parcelHelpers.export(exports, "DropdownItem", ()=>(0, _dropdownItemDefault.default));
parcelHelpers.export(exports, "DropdownMenu", ()=>(0, _dropdownMenuDefault.default));
parcelHelpers.export(exports, "DropdownSearchInput", ()=>(0, _dropdownSearchInputDefault.default));
parcelHelpers.export(exports, "Embed", ()=>(0, _embedDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalActions", ()=>(0, _modalActionsDefault.default));
parcelHelpers.export(exports, "ModalContent", ()=>(0, _modalContentDefault.default));
parcelHelpers.export(exports, "ModalDescription", ()=>(0, _modalDescriptionDefault.default));
parcelHelpers.export(exports, "ModalHeader", ()=>(0, _modalHeaderDefault.default));
parcelHelpers.export(exports, "Popup", ()=>(0, _popupDefault.default));
parcelHelpers.export(exports, "PopupContent", ()=>(0, _popupContentDefault.default));
parcelHelpers.export(exports, "PopupHeader", ()=>(0, _popupHeaderDefault.default));
parcelHelpers.export(exports, "Progress", ()=>(0, _progressDefault.default));
parcelHelpers.export(exports, "Rating", ()=>(0, _ratingDefault.default));
parcelHelpers.export(exports, "RatingIcon", ()=>(0, _ratingIconDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchDefault.default));
parcelHelpers.export(exports, "SearchCategory", ()=>(0, _searchCategoryDefault.default));
parcelHelpers.export(exports, "SearchResult", ()=>(0, _searchResultDefault.default));
parcelHelpers.export(exports, "SearchResults", ()=>(0, _searchResultsDefault.default));
parcelHelpers.export(exports, "Sidebar", ()=>(0, _sidebarDefault.default));
parcelHelpers.export(exports, "SidebarPushable", ()=>(0, _sidebarPushableDefault.default));
parcelHelpers.export(exports, "SidebarPusher", ()=>(0, _sidebarPusherDefault.default));
parcelHelpers.export(exports, "Sticky", ()=>(0, _stickyDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabPane", ()=>(0, _tabPaneDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default)) // Views
;
parcelHelpers.export(exports, "Advertisement", ()=>(0, _advertisementDefault.default));
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "CardContent", ()=>(0, _cardContentDefault.default));
parcelHelpers.export(exports, "CardDescription", ()=>(0, _cardDescriptionDefault.default));
parcelHelpers.export(exports, "CardGroup", ()=>(0, _cardGroupDefault.default));
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "CardMeta", ()=>(0, _cardMetaDefault.default));
parcelHelpers.export(exports, "Comment", ()=>(0, _commentDefault.default));
parcelHelpers.export(exports, "CommentAction", ()=>(0, _commentActionDefault.default));
parcelHelpers.export(exports, "CommentActions", ()=>(0, _commentActionsDefault.default));
parcelHelpers.export(exports, "CommentAuthor", ()=>(0, _commentAuthorDefault.default));
parcelHelpers.export(exports, "CommentAvatar", ()=>(0, _commentAvatarDefault.default));
parcelHelpers.export(exports, "CommentContent", ()=>(0, _commentContentDefault.default));
parcelHelpers.export(exports, "CommentGroup", ()=>(0, _commentGroupDefault.default));
parcelHelpers.export(exports, "CommentMetadata", ()=>(0, _commentMetadataDefault.default));
parcelHelpers.export(exports, "CommentText", ()=>(0, _commentTextDefault.default));
parcelHelpers.export(exports, "Feed", ()=>(0, _feedDefault.default));
parcelHelpers.export(exports, "FeedContent", ()=>(0, _feedContentDefault.default));
parcelHelpers.export(exports, "FeedDate", ()=>(0, _feedDateDefault.default));
parcelHelpers.export(exports, "FeedEvent", ()=>(0, _feedEventDefault.default));
parcelHelpers.export(exports, "FeedExtra", ()=>(0, _feedExtraDefault.default));
parcelHelpers.export(exports, "FeedLabel", ()=>(0, _feedLabelDefault.default));
parcelHelpers.export(exports, "FeedLike", ()=>(0, _feedLikeDefault.default));
parcelHelpers.export(exports, "FeedMeta", ()=>(0, _feedMetaDefault.default));
parcelHelpers.export(exports, "FeedSummary", ()=>(0, _feedSummaryDefault.default));
parcelHelpers.export(exports, "FeedUser", ()=>(0, _feedUserDefault.default));
parcelHelpers.export(exports, "Item", ()=>(0, _itemDefault.default));
parcelHelpers.export(exports, "ItemContent", ()=>(0, _itemContentDefault.default));
parcelHelpers.export(exports, "ItemDescription", ()=>(0, _itemDescriptionDefault.default));
parcelHelpers.export(exports, "ItemExtra", ()=>(0, _itemExtraDefault.default));
parcelHelpers.export(exports, "ItemGroup", ()=>(0, _itemGroupDefault.default));
parcelHelpers.export(exports, "ItemHeader", ()=>(0, _itemHeaderDefault.default));
parcelHelpers.export(exports, "ItemImage", ()=>(0, _itemImageDefault.default));
parcelHelpers.export(exports, "ItemMeta", ()=>(0, _itemMetaDefault.default));
parcelHelpers.export(exports, "Statistic", ()=>(0, _statisticDefault.default));
parcelHelpers.export(exports, "StatisticGroup", ()=>(0, _statisticGroupDefault.default));
parcelHelpers.export(exports, "StatisticLabel", ()=>(0, _statisticLabelDefault.default));
parcelHelpers.export(exports, "StatisticValue", ()=>(0, _statisticValueDefault.default));
var _confirm = require("./addons/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _mountNode = require("./addons/MountNode");
var _mountNodeDefault = parcelHelpers.interopDefault(_mountNode);
var _pagination = require("./addons/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationItem = require("./addons/Pagination/PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _portal = require("./addons/Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _portalInner = require("./addons/Portal/PortalInner");
var _portalInnerDefault = parcelHelpers.interopDefault(_portalInner);
var _radio = require("./addons/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _ref = require("./addons/Ref");
var _refDefault = parcelHelpers.interopDefault(_ref);
var _responsive = require("./addons/Responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _select = require("./addons/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textArea = require("./addons/TextArea");
var _textAreaDefault = parcelHelpers.interopDefault(_textArea);
var _transitionablePortal = require("./addons/TransitionablePortal");
var _transitionablePortalDefault = parcelHelpers.interopDefault(_transitionablePortal);
var _visibility = require("./behaviors/Visibility");
var _visibilityDefault = parcelHelpers.interopDefault(_visibility);
var _breadcrumb = require("./collections/Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _breadcrumbDivider = require("./collections/Breadcrumb/BreadcrumbDivider");
var _breadcrumbDividerDefault = parcelHelpers.interopDefault(_breadcrumbDivider);
var _breadcrumbSection = require("./collections/Breadcrumb/BreadcrumbSection");
var _breadcrumbSectionDefault = parcelHelpers.interopDefault(_breadcrumbSection);
var _form = require("./collections/Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formButton = require("./collections/Form/FormButton");
var _formButtonDefault = parcelHelpers.interopDefault(_formButton);
var _formCheckbox = require("./collections/Form/FormCheckbox");
var _formCheckboxDefault = parcelHelpers.interopDefault(_formCheckbox);
var _formDropdown = require("./collections/Form/FormDropdown");
var _formDropdownDefault = parcelHelpers.interopDefault(_formDropdown);
var _formField = require("./collections/Form/FormField");
var _formFieldDefault = parcelHelpers.interopDefault(_formField);
var _formGroup = require("./collections/Form/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formInput = require("./collections/Form/FormInput");
var _formInputDefault = parcelHelpers.interopDefault(_formInput);
var _formRadio = require("./collections/Form/FormRadio");
var _formRadioDefault = parcelHelpers.interopDefault(_formRadio);
var _formSelect = require("./collections/Form/FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _formTextArea = require("./collections/Form/FormTextArea");
var _formTextAreaDefault = parcelHelpers.interopDefault(_formTextArea);
var _grid = require("./collections/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridColumn = require("./collections/Grid/GridColumn");
var _gridColumnDefault = parcelHelpers.interopDefault(_gridColumn);
var _gridRow = require("./collections/Grid/GridRow");
var _gridRowDefault = parcelHelpers.interopDefault(_gridRow);
var _menu = require("./collections/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuHeader = require("./collections/Menu/MenuHeader");
var _menuHeaderDefault = parcelHelpers.interopDefault(_menuHeader);
var _menuItem = require("./collections/Menu/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _menuMenu = require("./collections/Menu/MenuMenu");
var _menuMenuDefault = parcelHelpers.interopDefault(_menuMenu);
var _message = require("./collections/Message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _messageContent = require("./collections/Message/MessageContent");
var _messageContentDefault = parcelHelpers.interopDefault(_messageContent);
var _messageHeader = require("./collections/Message/MessageHeader");
var _messageHeaderDefault = parcelHelpers.interopDefault(_messageHeader);
var _messageItem = require("./collections/Message/MessageItem");
var _messageItemDefault = parcelHelpers.interopDefault(_messageItem);
var _messageList = require("./collections/Message/MessageList");
var _messageListDefault = parcelHelpers.interopDefault(_messageList);
var _table = require("./collections/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableBody = require("./collections/Table/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("./collections/Table/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableFooter = require("./collections/Table/TableFooter");
var _tableFooterDefault = parcelHelpers.interopDefault(_tableFooter);
var _tableHeader = require("./collections/Table/TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableHeaderCell = require("./collections/Table/TableHeaderCell");
var _tableHeaderCellDefault = parcelHelpers.interopDefault(_tableHeaderCell);
var _tableRow = require("./collections/Table/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _button = require("./elements/Button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonContent = require("./elements/Button/ButtonContent");
var _buttonContentDefault = parcelHelpers.interopDefault(_buttonContent);
var _buttonGroup = require("./elements/Button/ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonOr = require("./elements/Button/ButtonOr");
var _buttonOrDefault = parcelHelpers.interopDefault(_buttonOr);
var _container = require("./elements/Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _divider = require("./elements/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _flag = require("./elements/Flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _header = require("./elements/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _headerContent = require("./elements/Header/HeaderContent");
var _headerContentDefault = parcelHelpers.interopDefault(_headerContent);
var _headerSubheader = require("./elements/Header/HeaderSubheader");
var _headerSubheaderDefault = parcelHelpers.interopDefault(_headerSubheader);
var _icon = require("./elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _iconGroup = require("./elements/Icon/IconGroup");
var _iconGroupDefault = parcelHelpers.interopDefault(_iconGroup);
var _image = require("./elements/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _imageGroup = require("./elements/Image/ImageGroup");
var _imageGroupDefault = parcelHelpers.interopDefault(_imageGroup);
var _input = require("./elements/Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _label = require("./elements/Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _labelDetail = require("./elements/Label/LabelDetail");
var _labelDetailDefault = parcelHelpers.interopDefault(_labelDetail);
var _labelGroup = require("./elements/Label/LabelGroup");
var _labelGroupDefault = parcelHelpers.interopDefault(_labelGroup);
var _list = require("./elements/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listContent = require("./elements/List/ListContent");
var _listContentDefault = parcelHelpers.interopDefault(_listContent);
var _listDescription = require("./elements/List/ListDescription");
var _listDescriptionDefault = parcelHelpers.interopDefault(_listDescription);
var _listHeader = require("./elements/List/ListHeader");
var _listHeaderDefault = parcelHelpers.interopDefault(_listHeader);
var _listIcon = require("./elements/List/ListIcon");
var _listIconDefault = parcelHelpers.interopDefault(_listIcon);
var _listItem = require("./elements/List/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listList = require("./elements/List/ListList");
var _listListDefault = parcelHelpers.interopDefault(_listList);
var _loader = require("./elements/Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _placeholder = require("./elements/Placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _placeholderHeader = require("./elements/Placeholder/PlaceholderHeader");
var _placeholderHeaderDefault = parcelHelpers.interopDefault(_placeholderHeader);
var _placeholderImage = require("./elements/Placeholder/PlaceholderImage");
var _placeholderImageDefault = parcelHelpers.interopDefault(_placeholderImage);
var _placeholderLine = require("./elements/Placeholder/PlaceholderLine");
var _placeholderLineDefault = parcelHelpers.interopDefault(_placeholderLine);
var _placeholderParagraph = require("./elements/Placeholder/PlaceholderParagraph");
var _placeholderParagraphDefault = parcelHelpers.interopDefault(_placeholderParagraph);
var _rail = require("./elements/Rail");
var _railDefault = parcelHelpers.interopDefault(_rail);
var _reveal = require("./elements/Reveal");
var _revealDefault = parcelHelpers.interopDefault(_reveal);
var _revealContent = require("./elements/Reveal/RevealContent");
var _revealContentDefault = parcelHelpers.interopDefault(_revealContent);
var _segment = require("./elements/Segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _segmentGroup = require("./elements/Segment/SegmentGroup");
var _segmentGroupDefault = parcelHelpers.interopDefault(_segmentGroup);
var _segmentInline = require("./elements/Segment/SegmentInline");
var _segmentInlineDefault = parcelHelpers.interopDefault(_segmentInline);
var _step = require("./elements/Step");
var _stepDefault = parcelHelpers.interopDefault(_step);
var _stepContent = require("./elements/Step/StepContent");
var _stepContentDefault = parcelHelpers.interopDefault(_stepContent);
var _stepDescription = require("./elements/Step/StepDescription");
var _stepDescriptionDefault = parcelHelpers.interopDefault(_stepDescription);
var _stepGroup = require("./elements/Step/StepGroup");
var _stepGroupDefault = parcelHelpers.interopDefault(_stepGroup);
var _stepTitle = require("./elements/Step/StepTitle");
var _stepTitleDefault = parcelHelpers.interopDefault(_stepTitle);
var _accordion = require("./modules/Accordion/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionAccordion = require("./modules/Accordion/AccordionAccordion");
var _accordionAccordionDefault = parcelHelpers.interopDefault(_accordionAccordion);
var _accordionContent = require("./modules/Accordion/AccordionContent");
var _accordionContentDefault = parcelHelpers.interopDefault(_accordionContent);
var _accordionPanel = require("./modules/Accordion/AccordionPanel");
var _accordionPanelDefault = parcelHelpers.interopDefault(_accordionPanel);
var _accordionTitle = require("./modules/Accordion/AccordionTitle");
var _accordionTitleDefault = parcelHelpers.interopDefault(_accordionTitle);
var _checkbox = require("./modules/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _dimmer = require("./modules/Dimmer");
var _dimmerDefault = parcelHelpers.interopDefault(_dimmer);
var _dimmerDimmable = require("./modules/Dimmer/DimmerDimmable");
var _dimmerDimmableDefault = parcelHelpers.interopDefault(_dimmerDimmable);
var _dimmerInner = require("./modules/Dimmer/DimmerInner");
var _dimmerInnerDefault = parcelHelpers.interopDefault(_dimmerInner);
var _dropdown = require("./modules/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownDivider = require("./modules/Dropdown/DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./modules/Dropdown/DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./modules/Dropdown/DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownMenu = require("./modules/Dropdown/DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownSearchInput = require("./modules/Dropdown/DropdownSearchInput");
var _dropdownSearchInputDefault = parcelHelpers.interopDefault(_dropdownSearchInput);
var _embed = require("./modules/Embed");
var _embedDefault = parcelHelpers.interopDefault(_embed);
var _modal = require("./modules/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalActions = require("./modules/Modal/ModalActions");
var _modalActionsDefault = parcelHelpers.interopDefault(_modalActions);
var _modalContent = require("./modules/Modal/ModalContent");
var _modalContentDefault = parcelHelpers.interopDefault(_modalContent);
var _modalDescription = require("./modules/Modal/ModalDescription");
var _modalDescriptionDefault = parcelHelpers.interopDefault(_modalDescription);
var _modalHeader = require("./modules/Modal/ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _popup = require("./modules/Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _popupContent = require("./modules/Popup/PopupContent");
var _popupContentDefault = parcelHelpers.interopDefault(_popupContent);
var _popupHeader = require("./modules/Popup/PopupHeader");
var _popupHeaderDefault = parcelHelpers.interopDefault(_popupHeader);
var _progress = require("./modules/Progress");
var _progressDefault = parcelHelpers.interopDefault(_progress);
var _rating = require("./modules/Rating");
var _ratingDefault = parcelHelpers.interopDefault(_rating);
var _ratingIcon = require("./modules/Rating/RatingIcon");
var _ratingIconDefault = parcelHelpers.interopDefault(_ratingIcon);
var _search = require("./modules/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _searchCategory = require("./modules/Search/SearchCategory");
var _searchCategoryDefault = parcelHelpers.interopDefault(_searchCategory);
var _searchResult = require("./modules/Search/SearchResult");
var _searchResultDefault = parcelHelpers.interopDefault(_searchResult);
var _searchResults = require("./modules/Search/SearchResults");
var _searchResultsDefault = parcelHelpers.interopDefault(_searchResults);
var _sidebar = require("./modules/Sidebar");
var _sidebarDefault = parcelHelpers.interopDefault(_sidebar);
var _sidebarPushable = require("./modules/Sidebar/SidebarPushable");
var _sidebarPushableDefault = parcelHelpers.interopDefault(_sidebarPushable);
var _sidebarPusher = require("./modules/Sidebar/SidebarPusher");
var _sidebarPusherDefault = parcelHelpers.interopDefault(_sidebarPusher);
var _sticky = require("./modules/Sticky");
var _stickyDefault = parcelHelpers.interopDefault(_sticky);
var _tab = require("./modules/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabPane = require("./modules/Tab/TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _transition = require("./modules/Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _transitionGroup = require("./modules/Transition/TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _advertisement = require("./views/Advertisement");
var _advertisementDefault = parcelHelpers.interopDefault(_advertisement);
var _card = require("./views/Card/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("./views/Card/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _cardDescription = require("./views/Card/CardDescription");
var _cardDescriptionDefault = parcelHelpers.interopDefault(_cardDescription);
var _cardGroup = require("./views/Card/CardGroup");
var _cardGroupDefault = parcelHelpers.interopDefault(_cardGroup);
var _cardHeader = require("./views/Card/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardMeta = require("./views/Card/CardMeta");
var _cardMetaDefault = parcelHelpers.interopDefault(_cardMeta);
var _comment = require("./views/Comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _commentAction = require("./views/Comment/CommentAction");
var _commentActionDefault = parcelHelpers.interopDefault(_commentAction);
var _commentActions = require("./views/Comment/CommentActions");
var _commentActionsDefault = parcelHelpers.interopDefault(_commentActions);
var _commentAuthor = require("./views/Comment/CommentAuthor");
var _commentAuthorDefault = parcelHelpers.interopDefault(_commentAuthor);
var _commentAvatar = require("./views/Comment/CommentAvatar");
var _commentAvatarDefault = parcelHelpers.interopDefault(_commentAvatar);
var _commentContent = require("./views/Comment/CommentContent");
var _commentContentDefault = parcelHelpers.interopDefault(_commentContent);
var _commentGroup = require("./views/Comment/CommentGroup");
var _commentGroupDefault = parcelHelpers.interopDefault(_commentGroup);
var _commentMetadata = require("./views/Comment/CommentMetadata");
var _commentMetadataDefault = parcelHelpers.interopDefault(_commentMetadata);
var _commentText = require("./views/Comment/CommentText");
var _commentTextDefault = parcelHelpers.interopDefault(_commentText);
var _feed = require("./views/Feed");
var _feedDefault = parcelHelpers.interopDefault(_feed);
var _feedContent = require("./views/Feed/FeedContent");
var _feedContentDefault = parcelHelpers.interopDefault(_feedContent);
var _feedDate = require("./views/Feed/FeedDate");
var _feedDateDefault = parcelHelpers.interopDefault(_feedDate);
var _feedEvent = require("./views/Feed/FeedEvent");
var _feedEventDefault = parcelHelpers.interopDefault(_feedEvent);
var _feedExtra = require("./views/Feed/FeedExtra");
var _feedExtraDefault = parcelHelpers.interopDefault(_feedExtra);
var _feedLabel = require("./views/Feed/FeedLabel");
var _feedLabelDefault = parcelHelpers.interopDefault(_feedLabel);
var _feedLike = require("./views/Feed/FeedLike");
var _feedLikeDefault = parcelHelpers.interopDefault(_feedLike);
var _feedMeta = require("./views/Feed/FeedMeta");
var _feedMetaDefault = parcelHelpers.interopDefault(_feedMeta);
var _feedSummary = require("./views/Feed/FeedSummary");
var _feedSummaryDefault = parcelHelpers.interopDefault(_feedSummary);
var _feedUser = require("./views/Feed/FeedUser");
var _feedUserDefault = parcelHelpers.interopDefault(_feedUser);
var _item = require("./views/Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
var _itemContent = require("./views/Item/ItemContent");
var _itemContentDefault = parcelHelpers.interopDefault(_itemContent);
var _itemDescription = require("./views/Item/ItemDescription");
var _itemDescriptionDefault = parcelHelpers.interopDefault(_itemDescription);
var _itemExtra = require("./views/Item/ItemExtra");
var _itemExtraDefault = parcelHelpers.interopDefault(_itemExtra);
var _itemGroup = require("./views/Item/ItemGroup");
var _itemGroupDefault = parcelHelpers.interopDefault(_itemGroup);
var _itemHeader = require("./views/Item/ItemHeader");
var _itemHeaderDefault = parcelHelpers.interopDefault(_itemHeader);
var _itemImage = require("./views/Item/ItemImage");
var _itemImageDefault = parcelHelpers.interopDefault(_itemImage);
var _itemMeta = require("./views/Item/ItemMeta");
var _itemMetaDefault = parcelHelpers.interopDefault(_itemMeta);
var _statistic = require("./views/Statistic");
var _statisticDefault = parcelHelpers.interopDefault(_statistic);
var _statisticGroup = require("./views/Statistic/StatisticGroup");
var _statisticGroupDefault = parcelHelpers.interopDefault(_statisticGroup);
var _statisticLabel = require("./views/Statistic/StatisticLabel");
var _statisticLabelDefault = parcelHelpers.interopDefault(_statisticLabel);
var _statisticValue = require("./views/Statistic/StatisticValue");
var _statisticValueDefault = parcelHelpers.interopDefault(_statisticValue);

},{"./addons/Confirm":false,"./addons/MountNode":false,"./addons/Pagination":false,"./addons/Pagination/PaginationItem":false,"./addons/Portal":false,"./addons/Portal/PortalInner":false,"./addons/Radio":false,"./addons/Ref":false,"./addons/Responsive":false,"./addons/Select":false,"./addons/TextArea":false,"./addons/TransitionablePortal":false,"./behaviors/Visibility":false,"./collections/Breadcrumb":false,"./collections/Breadcrumb/BreadcrumbDivider":false,"./collections/Breadcrumb/BreadcrumbSection":false,"./collections/Form":false,"./collections/Form/FormButton":false,"./collections/Form/FormCheckbox":false,"./collections/Form/FormDropdown":false,"./collections/Form/FormField":false,"./collections/Form/FormGroup":false,"./collections/Form/FormInput":false,"./collections/Form/FormRadio":false,"./collections/Form/FormSelect":false,"./collections/Form/FormTextArea":false,"./collections/Grid":"cusZf","./collections/Grid/GridColumn":false,"./collections/Grid/GridRow":false,"./collections/Menu":false,"./collections/Menu/MenuHeader":false,"./collections/Menu/MenuItem":false,"./collections/Menu/MenuMenu":false,"./collections/Message":"5AcDN","./collections/Message/MessageContent":false,"./collections/Message/MessageHeader":false,"./collections/Message/MessageItem":false,"./collections/Message/MessageList":false,"./collections/Table":"gFwYL","./collections/Table/TableBody":false,"./collections/Table/TableCell":false,"./collections/Table/TableFooter":false,"./collections/Table/TableHeader":false,"./collections/Table/TableHeaderCell":false,"./collections/Table/TableRow":false,"./elements/Button/Button":"9FLKC","./elements/Button/ButtonContent":false,"./elements/Button/ButtonGroup":false,"./elements/Button/ButtonOr":false,"./elements/Container":"9Sfid","./elements/Divider":false,"./elements/Flag":false,"./elements/Header":"91b6B","./elements/Header/HeaderContent":false,"./elements/Header/HeaderSubheader":false,"./elements/Icon":"dUMma","./elements/Icon/IconGroup":false,"./elements/Image":false,"./elements/Image/ImageGroup":false,"./elements/Input":false,"./elements/Label":"gilpf","./elements/Label/LabelDetail":false,"./elements/Label/LabelGroup":false,"./elements/List":false,"./elements/List/ListContent":false,"./elements/List/ListDescription":false,"./elements/List/ListHeader":false,"./elements/List/ListIcon":false,"./elements/List/ListItem":false,"./elements/List/ListList":false,"./elements/Loader":"aE2R1","./elements/Placeholder":false,"./elements/Placeholder/PlaceholderHeader":false,"./elements/Placeholder/PlaceholderImage":false,"./elements/Placeholder/PlaceholderLine":false,"./elements/Placeholder/PlaceholderParagraph":false,"./elements/Rail":false,"./elements/Reveal":false,"./elements/Reveal/RevealContent":false,"./elements/Segment":false,"./elements/Segment/SegmentGroup":false,"./elements/Segment/SegmentInline":false,"./elements/Step":false,"./elements/Step/StepContent":false,"./elements/Step/StepDescription":false,"./elements/Step/StepGroup":false,"./elements/Step/StepTitle":false,"./modules/Accordion/Accordion":false,"./modules/Accordion/AccordionAccordion":false,"./modules/Accordion/AccordionContent":false,"./modules/Accordion/AccordionPanel":false,"./modules/Accordion/AccordionTitle":false,"./modules/Checkbox":false,"./modules/Dimmer":false,"./modules/Dimmer/DimmerDimmable":false,"./modules/Dimmer/DimmerInner":false,"./modules/Dropdown":"iE3eZ","./modules/Dropdown/DropdownDivider":false,"./modules/Dropdown/DropdownHeader":false,"./modules/Dropdown/DropdownItem":false,"./modules/Dropdown/DropdownMenu":false,"./modules/Dropdown/DropdownSearchInput":false,"./modules/Embed":false,"./modules/Modal":false,"./modules/Modal/ModalActions":false,"./modules/Modal/ModalContent":false,"./modules/Modal/ModalDescription":false,"./modules/Modal/ModalHeader":false,"./modules/Popup":false,"./modules/Popup/PopupContent":false,"./modules/Popup/PopupHeader":false,"./modules/Progress":false,"./modules/Rating":false,"./modules/Rating/RatingIcon":false,"./modules/Search":false,"./modules/Search/SearchCategory":false,"./modules/Search/SearchResult":false,"./modules/Search/SearchResults":false,"./modules/Sidebar":false,"./modules/Sidebar/SidebarPushable":false,"./modules/Sidebar/SidebarPusher":false,"./modules/Sticky":false,"./modules/Tab":false,"./modules/Tab/TabPane":false,"./modules/Transition":false,"./modules/Transition/TransitionGroup":false,"./views/Advertisement":false,"./views/Card/Card":false,"./views/Card/CardContent":false,"./views/Card/CardDescription":false,"./views/Card/CardGroup":false,"./views/Card/CardHeader":false,"./views/Card/CardMeta":false,"./views/Comment":false,"./views/Comment/CommentAction":false,"./views/Comment/CommentActions":false,"./views/Comment/CommentAuthor":false,"./views/Comment/CommentAvatar":false,"./views/Comment/CommentContent":false,"./views/Comment/CommentGroup":false,"./views/Comment/CommentMetadata":false,"./views/Comment/CommentText":false,"./views/Feed":false,"./views/Feed/FeedContent":false,"./views/Feed/FeedDate":false,"./views/Feed/FeedEvent":false,"./views/Feed/FeedExtra":false,"./views/Feed/FeedLabel":false,"./views/Feed/FeedLike":false,"./views/Feed/FeedMeta":false,"./views/Feed/FeedSummary":false,"./views/Feed/FeedUser":false,"./views/Item":false,"./views/Item/ItemContent":false,"./views/Item/ItemDescription":false,"./views/Item/ItemExtra":false,"./views/Item/ItemGroup":false,"./views/Item/ItemHeader":false,"./views/Item/ItemImage":false,"./views/Item/ItemMeta":false,"./views/Statistic":false,"./views/Statistic/StatisticGroup":false,"./views/Statistic/StatisticLabel":false,"./views/Statistic/StatisticValue":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"46BVs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _portalDefault.default));
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);

},{"./Portal":"eOAMp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eOAMp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@babel/runtime/helpers/objectSpread");
var _objectSpreadDefault = parcelHelpers.interopDefault(_objectSpread);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _keyboardKey = require("keyboard-key");
var _keyboardKeyDefault = parcelHelpers.interopDefault(_keyboardKey);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _ref = require("../Ref");
var _refDefault = parcelHelpers.interopDefault(_ref);
var _portalInner = require("./PortalInner");
var _portalInnerDefault = parcelHelpers.interopDefault(_portalInner);
/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */ var Portal = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Portal, _Component);
    function Portal() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, Portal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(Portal)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleDocumentClick", function(e) {
            var closeOnDocumentClick = _this.props.closeOnDocumentClick;
            if (!_this.portalNode || // no portal
            (0, _lib.doesNodeContainClick)(_this.triggerNode, e) || // event happened in trigger (delegate to trigger handlers)
            (0, _lib.doesNodeContainClick)(_this.portalNode, e) // event happened in the portal
            ) return;
             // ignore the click
            if (closeOnDocumentClick) _this.close(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleEscape", function(e) {
            if (!_this.props.closeOnEscape) return;
            if ((0, _keyboardKeyDefault.default).getCode(e) !== (0, _keyboardKeyDefault.default).Escape) return;
            _this.close(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handlePortalMouseLeave", function(e) {
            var _this$props = _this.props, closeOnPortalMouseLeave = _this$props.closeOnPortalMouseLeave, mouseLeaveDelay = _this$props.mouseLeaveDelay;
            if (!closeOnPortalMouseLeave) return; // Do not close the portal when 'mouseleave' is triggered by children
            if (e.target !== _this.portalNode) return;
            _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handlePortalMouseEnter", function() {
            // In order to enable mousing from the trigger to the portal, we need to
            // clear the mouseleave timer that was set when leaving the trigger.
            var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
            if (!closeOnPortalMouseLeave) return;
            clearTimeout(_this.mouseLeaveTimer);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleTriggerBlur", function(e) {
            var _this$props2 = _this.props, trigger = _this$props2.trigger, closeOnTriggerBlur = _this$props2.closeOnTriggerBlur; // Call original event handler
            for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
            (0, _invokeDefault.default).apply(void 0, [
                trigger,
                "props.onBlur",
                e
            ].concat(rest)); // do not close if focus is given to the portal
            var didFocusPortal = (0, _invokeDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "portalNode.contains", e.relatedTarget);
            if (!closeOnTriggerBlur || didFocusPortal) return;
            _this.close(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleTriggerClick", function(e) {
            var _this$props3 = _this.props, trigger = _this$props3.trigger, closeOnTriggerClick = _this$props3.closeOnTriggerClick, openOnTriggerClick = _this$props3.openOnTriggerClick;
            var open = _this.state.open; // Call original event handler
            for(var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)rest[_key3 - 1] = arguments[_key3];
            (0, _invokeDefault.default).apply(void 0, [
                trigger,
                "props.onClick",
                e
            ].concat(rest));
            if (open && closeOnTriggerClick) _this.close(e);
            else if (!open && openOnTriggerClick) _this.open(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleTriggerFocus", function(e) {
            var _this$props4 = _this.props, trigger = _this$props4.trigger, openOnTriggerFocus = _this$props4.openOnTriggerFocus; // Call original event handler
            for(var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)rest[_key4 - 1] = arguments[_key4];
            (0, _invokeDefault.default).apply(void 0, [
                trigger,
                "props.onFocus",
                e
            ].concat(rest));
            if (!openOnTriggerFocus) return;
            _this.open(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleTriggerMouseLeave", function(e) {
            clearTimeout(_this.mouseEnterTimer);
            var _this$props5 = _this.props, trigger = _this$props5.trigger, closeOnTriggerMouseLeave = _this$props5.closeOnTriggerMouseLeave, mouseLeaveDelay = _this$props5.mouseLeaveDelay; // Call original event handler
            for(var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)rest[_key5 - 1] = arguments[_key5];
            (0, _invokeDefault.default).apply(void 0, [
                trigger,
                "props.onMouseLeave",
                e
            ].concat(rest));
            if (!closeOnTriggerMouseLeave) return;
            _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleTriggerMouseEnter", function(e) {
            clearTimeout(_this.mouseLeaveTimer);
            var _this$props6 = _this.props, trigger = _this$props6.trigger, mouseEnterDelay = _this$props6.mouseEnterDelay, openOnTriggerMouseEnter = _this$props6.openOnTriggerMouseEnter; // Call original event handler
            for(var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)rest[_key6 - 1] = arguments[_key6];
            (0, _invokeDefault.default).apply(void 0, [
                trigger,
                "props.onMouseEnter",
                e
            ].concat(rest));
            if (!openOnTriggerMouseEnter) return;
            _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "open", function(e) {
            var onOpen = _this.props.onOpen;
            if (onOpen) onOpen(e, _this.props);
            _this.trySetState({
                open: true
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "openWithTimeout", function(e, delay) {
            // React wipes the entire event object and suggests using e.persist() if
            // you need the event for async access. However, even with e.persist
            // certain required props (e.g. currentTarget) are null so we're forced to clone.
            var eventClone = (0, _objectSpreadDefault.default)({}, e);
            return setTimeout(function() {
                return _this.open(eventClone);
            }, delay || 0);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "close", function(e) {
            var onClose = _this.props.onClose;
            if (onClose) onClose(e, _this.props);
            _this.trySetState({
                open: false
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "closeWithTimeout", function(e, delay) {
            // React wipes the entire event object and suggests using e.persist() if
            // you need the event for async access. However, even with e.persist
            // certain required props (e.g. currentTarget) are null so we're forced to clone.
            var eventClone = (0, _objectSpreadDefault.default)({}, e);
            return setTimeout(function() {
                return _this.close(eventClone);
            }, delay || 0);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleMount", function(e, _ref) {
            var target = _ref.node;
            var eventPool = _this.props.eventPool;
            _this.portalNode = target;
            (0, _lib.eventStack).sub("mouseleave", _this.handlePortalMouseLeave, {
                pool: eventPool,
                target: target
            });
            (0, _lib.eventStack).sub("mouseenter", _this.handlePortalMouseEnter, {
                pool: eventPool,
                target: target
            });
            (0, _lib.eventStack).sub("click", _this.handleDocumentClick, {
                pool: eventPool
            });
            (0, _lib.eventStack).sub("keydown", _this.handleEscape, {
                pool: eventPool
            });
            (0, _invokeDefault.default)(_this.props, "onMount", null, _this.props);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleUnmount", function(e, _ref2) {
            var target = _ref2.node;
            var eventPool = _this.props.eventPool;
            _this.portalNode = null;
            (0, _lib.eventStack).unsub("mouseleave", _this.handlePortalMouseLeave, {
                pool: eventPool,
                target: target
            });
            (0, _lib.eventStack).unsub("mouseenter", _this.handlePortalMouseEnter, {
                pool: eventPool,
                target: target
            });
            (0, _lib.eventStack).unsub("click", _this.handleDocumentClick, {
                pool: eventPool
            });
            (0, _lib.eventStack).unsub("keydown", _this.handleEscape, {
                pool: eventPool
            });
            (0, _invokeDefault.default)(_this.props, "onUnmount", null, _this.props);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleTriggerRef", function(c) {
            _this.triggerNode = c;
            (0, _lib.handleRef)(_this.props.triggerRef, c);
        });
        return _this;
    }
    (0, _createClassDefault.default)(Portal, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clean up timers
                clearTimeout(this.mouseEnterTimer);
                clearTimeout(this.mouseLeaveTimer);
            } // ----------------------------------------
        },
        {
            key: "render",
            value: function render() {
                var _this$props7 = this.props, children = _this$props7.children, mountNode = _this$props7.mountNode, trigger = _this$props7.trigger;
                var open = this.state.open;
                return (0, _reactDefault.default).createElement((0, _react.Fragment), null, open && (0, _reactDefault.default).createElement((0, _portalInnerDefault.default), {
                    mountNode: mountNode,
                    onMount: this.handleMount,
                    onUnmount: this.handleUnmount
                }, children), trigger && (0, _reactDefault.default).createElement((0, _refDefault.default), {
                    innerRef: this.handleTriggerRef
                }, (0, _react.cloneElement)(trigger, {
                    onBlur: this.handleTriggerBlur,
                    onClick: this.handleTriggerClick,
                    onFocus: this.handleTriggerFocus,
                    onMouseLeave: this.handleTriggerMouseLeave,
                    onMouseEnter: this.handleTriggerMouseEnter
                })));
            }
        }
    ]);
    return Portal;
}((0, _lib.AutoControlledComponent));
(0, _definePropertyDefault.default)(Portal, "defaultProps", {
    closeOnDocumentClick: true,
    closeOnEscape: true,
    eventPool: "default",
    openOnTriggerClick: true
});
(0, _definePropertyDefault.default)(Portal, "autoControlledProps", [
    "open"
]);
(0, _definePropertyDefault.default)(Portal, "Inner", (0, _portalInnerDefault.default));
(0, _definePropertyDefault.default)(Portal, "handledProps", [
    "children",
    "closeOnDocumentClick",
    "closeOnEscape",
    "closeOnPortalMouseLeave",
    "closeOnTriggerBlur",
    "closeOnTriggerClick",
    "closeOnTriggerMouseLeave",
    "defaultOpen",
    "eventPool",
    "mountNode",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "onClose",
    "onMount",
    "onOpen",
    "onUnmount",
    "open",
    "openOnTriggerClick",
    "openOnTriggerFocus",
    "openOnTriggerMouseEnter",
    "trigger",
    "triggerRef"
]);
Portal.propTypes = {};
exports.default = Portal;

},{"@babel/runtime/helpers/objectSpread":"9Q79w","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/invoke":"jRmLc","keyboard-key":"3c9ko","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../Ref":"d2QMC","./PortalInner":"iL3MA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Q79w":[function(require,module,exports) {
var defineProperty = require("900785af2ea09f72");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            defineProperty(target, key, source[key]);
        });
    }
    return target;
}
module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"900785af2ea09f72":"djTAw"}],"2I6Ai":[function(require,module,exports) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6vj9L":[function(require,module,exports) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"ldMor"}],"fmNgP":[function(require,module,exports) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"d1yVP","ca3744a9acc8b6f9":"6NXy1"}],"6NXy1":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4eWPd":[function(require,module,exports) {
function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"52iuZ":[function(require,module,exports) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"7x2ld"}],"jRmLc":[function(require,module,exports) {
var baseInvoke = require("8f46d242e58356be"), baseRest = require("824397b51f3950a3");
/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */ var invoke = baseRest(baseInvoke);
module.exports = invoke;

},{"8f46d242e58356be":"2yRb6","824397b51f3950a3":"cFFHO"}],"2yRb6":[function(require,module,exports) {
var apply = require("ac762a0bb6e8149f"), castPath = require("9f4267f66f5c1d0a"), last = require("bbc1c17b8c368d7c"), parent = require("f2cbf82cd927014d"), toKey = require("249cf52180a0c208");
/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */ function baseInvoke(object, path, args) {
    path = castPath(path, object);
    object = parent(object, path);
    var func = object == null ? object : object[toKey(last(path))];
    return func == null ? undefined : apply(func, object, args);
}
module.exports = baseInvoke;

},{"ac762a0bb6e8149f":"dAmzO","9f4267f66f5c1d0a":"3DEN3","bbc1c17b8c368d7c":"4OGfA","f2cbf82cd927014d":"9Hbax","249cf52180a0c208":"2ib7q"}],"dAmzO":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"4OGfA":[function(require,module,exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"9Hbax":[function(require,module,exports) {
var baseGet = require("cbcb75b7339c1ad"), baseSlice = require("3443758a32fd0de1");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"cbcb75b7339c1ad":"7HHv1","3443758a32fd0de1":"eZ4Ej"}],"eZ4Ej":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"cFFHO":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"5HMso","ff7d23ff2a2ea6f8":"1pIhz","a11d545e809d14f7":"5wgE3"}],"5HMso":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"1pIhz":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"dAmzO"}],"5wgE3":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"7Iyoi","9114f59293388d49":"adumK"}],"7Iyoi":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"kl4Wu","eff1240bc0447727":"a0aUc","b00d1e57326793e1":"5HMso"}],"kl4Wu":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"a0aUc":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"jg3e9"}],"adumK":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"3c9ko":[function(require,module,exports) {
"use strict";
var isObject = function isObject(val) {
    return val !== null && !Array.isArray(val) && typeof val === "object";
};
var codes = {
    // ----------------------------------------
    // By Code
    // ----------------------------------------
    3: "Cancel",
    6: "Help",
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    28: "Convert",
    29: "NonConvert",
    30: "Accept",
    31: "ModeChange",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    41: "Select",
    42: "Print",
    43: "Execute",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    48: [
        "0",
        ")"
    ],
    49: [
        "1",
        "!"
    ],
    50: [
        "2",
        "@"
    ],
    51: [
        "3",
        "#"
    ],
    52: [
        "4",
        "$"
    ],
    53: [
        "5",
        "%"
    ],
    54: [
        "6",
        "^"
    ],
    55: [
        "7",
        "&"
    ],
    56: [
        "8",
        "*"
    ],
    57: [
        "9",
        "("
    ],
    91: "OS",
    93: "ContextMenu",
    144: "NumLock",
    145: "ScrollLock",
    181: "VolumeMute",
    182: "VolumeDown",
    183: "VolumeUp",
    186: [
        ";",
        ":"
    ],
    187: [
        "=",
        "+"
    ],
    188: [
        ",",
        "<"
    ],
    189: [
        "-",
        "_"
    ],
    190: [
        ".",
        ">"
    ],
    191: [
        "/",
        "?"
    ],
    192: [
        "`",
        "~"
    ],
    219: [
        "[",
        "{"
    ],
    220: [
        "\\",
        "|"
    ],
    221: [
        "]",
        "}"
    ],
    222: [
        "'",
        '"'
    ],
    224: "Meta",
    225: "AltGraph",
    246: "Attn",
    247: "CrSel",
    248: "ExSel",
    249: "EraseEof",
    250: "Play",
    251: "ZoomOut"
};
// Function Keys (F1-24)
for(var i = 0; i < 24; i += 1)codes[112 + i] = "F" + (i + 1);
// Alphabet (a-Z)
for(var j = 0; j < 26; j += 1){
    var n = j + 65;
    codes[n] = [
        String.fromCharCode(n + 32),
        String.fromCharCode(n)
    ];
}
var keyboardKey = {
    codes: codes,
    /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
   * @returns {number|undefined}
   */ getCode: function getCode(eventOrKey) {
        if (isObject(eventOrKey)) return eventOrKey.keyCode || eventOrKey.which || this[eventOrKey.key];
        return this[eventOrKey];
    },
    /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} eventOrCode A keyboard event-like object or key code.
   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
   * @returns {string|undefined}
   */ getKey: function getKey(eventOrCode) {
        var isEvent = isObject(eventOrCode);
        // handle events with a `key` already defined
        if (isEvent && eventOrCode.key) return eventOrCode.key;
        var name = codes[isEvent ? eventOrCode.keyCode || eventOrCode.which : eventOrCode];
        if (Array.isArray(name)) {
            if (isEvent) name = name[eventOrCode.shiftKey ? 1 : 0];
            else name = name[0];
        }
        return name;
    },
    // ----------------------------------------
    // By Name
    // ----------------------------------------
    // declare these manually for static analysis
    Cancel: 3,
    Help: 6,
    Backspace: 8,
    Tab: 9,
    Clear: 12,
    Enter: 13,
    Shift: 16,
    Control: 17,
    Alt: 18,
    Pause: 19,
    CapsLock: 20,
    Escape: 27,
    Convert: 28,
    NonConvert: 29,
    Accept: 30,
    ModeChange: 31,
    " ": 32,
    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Select: 41,
    Print: 42,
    Execute: 43,
    PrintScreen: 44,
    Insert: 45,
    Delete: 46,
    0: 48,
    ")": 48,
    1: 49,
    "!": 49,
    2: 50,
    "@": 50,
    3: 51,
    "#": 51,
    4: 52,
    $: 52,
    5: 53,
    "%": 53,
    6: 54,
    "^": 54,
    7: 55,
    "&": 55,
    8: 56,
    "*": 56,
    9: 57,
    "(": 57,
    a: 65,
    A: 65,
    b: 66,
    B: 66,
    c: 67,
    C: 67,
    d: 68,
    D: 68,
    e: 69,
    E: 69,
    f: 70,
    F: 70,
    g: 71,
    G: 71,
    h: 72,
    H: 72,
    i: 73,
    I: 73,
    j: 74,
    J: 74,
    k: 75,
    K: 75,
    l: 76,
    L: 76,
    m: 77,
    M: 77,
    n: 78,
    N: 78,
    o: 79,
    O: 79,
    p: 80,
    P: 80,
    q: 81,
    Q: 81,
    r: 82,
    R: 82,
    s: 83,
    S: 83,
    t: 84,
    T: 84,
    u: 85,
    U: 85,
    v: 86,
    V: 86,
    w: 87,
    W: 87,
    x: 88,
    X: 88,
    y: 89,
    Y: 89,
    z: 90,
    Z: 90,
    OS: 91,
    ContextMenu: 93,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    F13: 124,
    F14: 125,
    F15: 126,
    F16: 127,
    F17: 128,
    F18: 129,
    F19: 130,
    F20: 131,
    F21: 132,
    F22: 133,
    F23: 134,
    F24: 135,
    NumLock: 144,
    ScrollLock: 145,
    VolumeMute: 181,
    VolumeDown: 182,
    VolumeUp: 183,
    ";": 186,
    ":": 186,
    "=": 187,
    "+": 187,
    ",": 188,
    "<": 188,
    "-": 189,
    _: 189,
    ".": 190,
    ">": 190,
    "/": 191,
    "?": 191,
    "`": 192,
    "~": 192,
    "[": 219,
    "{": 219,
    "\\": 220,
    "|": 220,
    "]": 221,
    "}": 221,
    "'": 222,
    '"': 222,
    Meta: 224,
    AltGraph: 225,
    Attn: 246,
    CrSel: 247,
    ExSel: 248,
    EraseEof: 249,
    Play: 250,
    ZoomOut: 251
};
// ----------------------------------------
// By Alias
// ----------------------------------------
// provide dot-notation accessible keys for all key names
keyboardKey.Spacebar = keyboardKey[" "];
keyboardKey.Digit0 = keyboardKey["0"];
keyboardKey.Digit1 = keyboardKey["1"];
keyboardKey.Digit2 = keyboardKey["2"];
keyboardKey.Digit3 = keyboardKey["3"];
keyboardKey.Digit4 = keyboardKey["4"];
keyboardKey.Digit5 = keyboardKey["5"];
keyboardKey.Digit6 = keyboardKey["6"];
keyboardKey.Digit7 = keyboardKey["7"];
keyboardKey.Digit8 = keyboardKey["8"];
keyboardKey.Digit9 = keyboardKey["9"];
keyboardKey.Tilde = keyboardKey["~"];
keyboardKey.GraveAccent = keyboardKey["`"];
keyboardKey.ExclamationPoint = keyboardKey["!"];
keyboardKey.AtSign = keyboardKey["@"];
keyboardKey.PoundSign = keyboardKey["#"];
keyboardKey.PercentSign = keyboardKey["%"];
keyboardKey.Caret = keyboardKey["^"];
keyboardKey.Ampersand = keyboardKey["&"];
keyboardKey.PlusSign = keyboardKey["+"];
keyboardKey.MinusSign = keyboardKey["-"];
keyboardKey.EqualsSign = keyboardKey["="];
keyboardKey.DivisionSign = keyboardKey["/"];
keyboardKey.MultiplicationSign = keyboardKey["*"];
keyboardKey.Comma = keyboardKey[","];
keyboardKey.Decimal = keyboardKey["."];
keyboardKey.Colon = keyboardKey[":"];
keyboardKey.Semicolon = keyboardKey[";"];
keyboardKey.Pipe = keyboardKey["|"];
keyboardKey.BackSlash = keyboardKey["\\"];
keyboardKey.QuestionMark = keyboardKey["?"];
keyboardKey.SingleQuote = keyboardKey["'"];
keyboardKey.DoubleQuote = keyboardKey['"'];
keyboardKey.LeftCurlyBrace = keyboardKey["{"];
keyboardKey.RightCurlyBrace = keyboardKey["}"];
keyboardKey.LeftParenthesis = keyboardKey["("];
keyboardKey.RightParenthesis = keyboardKey[")"];
keyboardKey.LeftAngleBracket = keyboardKey["<"];
keyboardKey.RightAngleBracket = keyboardKey[">"];
keyboardKey.LeftSquareBracket = keyboardKey["["];
keyboardKey.RightSquareBracket = keyboardKey["]"];
module.exports = keyboardKey;

},{}],"1RlVA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChildMapping", ()=>(0, _childMapping.getChildMapping));
parcelHelpers.export(exports, "mergeChildMappings", ()=>(0, _childMapping.mergeChildMappings));
parcelHelpers.export(exports, "useKeyOnly", ()=>(0, _classNameBuilders.useKeyOnly));
parcelHelpers.export(exports, "useKeyOrValueAndKey", ()=>(0, _classNameBuilders.useKeyOrValueAndKey));
parcelHelpers.export(exports, "useValueAndKey", ()=>(0, _classNameBuilders.useValueAndKey));
parcelHelpers.export(exports, "useMultipleProp", ()=>(0, _classNameBuilders.useMultipleProp));
parcelHelpers.export(exports, "useTextAlignProp", ()=>(0, _classNameBuilders.useTextAlignProp));
parcelHelpers.export(exports, "useVerticalAlignProp", ()=>(0, _classNameBuilders.useVerticalAlignProp));
parcelHelpers.export(exports, "useWidthProp", ()=>(0, _classNameBuilders.useWidthProp));
parcelHelpers.export(exports, "debug", ()=>(0, _debug.debug));
parcelHelpers.export(exports, "makeDebugger", ()=>(0, _debug.makeDebugger));
parcelHelpers.export(exports, "htmlInputAttrs", ()=>(0, _htmlPropsUtils.htmlInputAttrs));
parcelHelpers.export(exports, "htmlInputEvents", ()=>(0, _htmlPropsUtils.htmlInputEvents));
parcelHelpers.export(exports, "htmlInputProps", ()=>(0, _htmlPropsUtils.htmlInputProps));
parcelHelpers.export(exports, "htmlImageProps", ()=>(0, _htmlPropsUtils.htmlImageProps));
parcelHelpers.export(exports, "partitionHTMLProps", ()=>(0, _htmlPropsUtils.partitionHTMLProps));
parcelHelpers.export(exports, "numberToWordMap", ()=>(0, _numberToWord.numberToWordMap));
parcelHelpers.export(exports, "numberToWord", ()=>(0, _numberToWord.numberToWord));
parcelHelpers.export(exports, "AutoControlledComponent", ()=>(0, _autoControlledComponentDefault.default));
parcelHelpers.export(exports, "childrenUtils", ()=>_childrenUtils);
parcelHelpers.export(exports, "customPropTypes", ()=>_customPropTypes);
parcelHelpers.export(exports, "eventStack", ()=>(0, _eventStackDefault.default));
parcelHelpers.export(exports, "getUnhandledProps", ()=>(0, _getUnhandledPropsDefault.default));
parcelHelpers.export(exports, "getElementType", ()=>(0, _getElementTypeDefault.default));
parcelHelpers.export(exports, "handleRef", ()=>(0, _handleRefDefault.default));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserDefault.default));
parcelHelpers.export(exports, "doesNodeContainClick", ()=>(0, _doesNodeContainClickDefault.default));
parcelHelpers.export(exports, "leven", ()=>(0, _levenDefault.default));
parcelHelpers.export(exports, "createPaginationItems", ()=>(0, _createPaginationItemsDefault.default));
parcelHelpers.export(exports, "SUI", ()=>_sui);
parcelHelpers.export(exports, "normalizeOffset", ()=>(0, _normalizeOffsetDefault.default));
parcelHelpers.export(exports, "normalizeTransitionDuration", ()=>(0, _normalizeTransitionDurationDefault.default));
parcelHelpers.export(exports, "objectDiff", ()=>(0, _objectDiffDefault.default));
var _autoControlledComponent = require("./AutoControlledComponent");
var _autoControlledComponentDefault = parcelHelpers.interopDefault(_autoControlledComponent);
var _childMapping = require("./childMapping");
var _childrenUtils = require("./childrenUtils");
var _classNameBuilders = require("./classNameBuilders");
var _customPropTypes = require("./customPropTypes");
var _debug = require("./debug");
var _eventStack = require("./eventStack");
var _eventStackDefault = parcelHelpers.interopDefault(_eventStack);
var _factories = require("./factories");
parcelHelpers.exportAll(_factories, exports);
var _getUnhandledProps = require("./getUnhandledProps");
var _getUnhandledPropsDefault = parcelHelpers.interopDefault(_getUnhandledProps);
var _getElementType = require("./getElementType");
var _getElementTypeDefault = parcelHelpers.interopDefault(_getElementType);
var _handleRef = require("./handleRef");
var _handleRefDefault = parcelHelpers.interopDefault(_handleRef);
var _htmlPropsUtils = require("./htmlPropsUtils");
var _isBrowser = require("./isBrowser");
var _isBrowserDefault = parcelHelpers.interopDefault(_isBrowser);
var _doesNodeContainClick = require("./doesNodeContainClick");
var _doesNodeContainClickDefault = parcelHelpers.interopDefault(_doesNodeContainClick);
var _leven = require("./leven");
var _levenDefault = parcelHelpers.interopDefault(_leven);
var _createPaginationItems = require("./createPaginationItems");
var _createPaginationItemsDefault = parcelHelpers.interopDefault(_createPaginationItems);
var _sui = require("./SUI");
var _numberToWord = require("./numberToWord");
var _normalizeOffset = require("./normalizeOffset");
var _normalizeOffsetDefault = parcelHelpers.interopDefault(_normalizeOffset);
var _normalizeTransitionDuration = require("./normalizeTransitionDuration");
var _normalizeTransitionDurationDefault = parcelHelpers.interopDefault(_normalizeTransitionDuration);
var _objectDiff = require("./objectDiff");
var _objectDiffDefault = parcelHelpers.interopDefault(_objectDiff);

},{"./AutoControlledComponent":"1Gg0T","./childMapping":false,"./childrenUtils":"iuZdz","./classNameBuilders":"j6O7x","./customPropTypes":false,"./debug":false,"./eventStack":"7Oy9X","./factories":"bseWj","./getUnhandledProps":"lnSqL","./getElementType":"1Q1Co","./handleRef":"6tQJc","./htmlPropsUtils":"fVRTG","./isBrowser":"e8WiN","./doesNodeContainClick":"6QEQ8","./leven":false,"./createPaginationItems":false,"./SUI":false,"./numberToWord":false,"./normalizeOffset":false,"./normalizeTransitionDuration":false,"./objectDiff":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Gg0T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAutoControlledStateValue", ()=>getAutoControlledStateValue);
parcelHelpers.export(exports, "default", ()=>AutoControlledComponent);
var _objectSpread = require("@babel/runtime/helpers/objectSpread");
var _objectSpreadDefault = parcelHelpers.interopDefault(_objectSpread);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _difference = require("lodash/difference");
var _differenceDefault = parcelHelpers.interopDefault(_difference);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _startsWith = require("lodash/startsWith");
var _startsWithDefault = parcelHelpers.interopDefault(_startsWith);
var _filter = require("lodash/filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _intersection = require("lodash/intersection");
var _intersectionDefault = parcelHelpers.interopDefault(_intersection);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _each = require("lodash/each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _react = require("react");
var getDefaultPropName = function getDefaultPropName(prop) {
    return "default".concat(prop[0].toUpperCase() + prop.slice(1));
};
var getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
    var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // regular props
    var propValue = props[propName];
    if (propValue !== undefined) return propValue;
    if (includeDefaults) {
        // defaultProps
        var defaultProp = props[getDefaultPropName(propName)];
        if (defaultProp !== undefined) return defaultProp; // initial state - state may be null or undefined
        if (state) {
            var initialState = state[propName];
            if (initialState !== undefined) return initialState;
        }
    } // React doesn't allow changing from uncontrolled to controlled components,
    // default checked/value if they were not present.
    if (propName === "checked") return false;
    if (propName === "value") return props.multiple ? [] : ""; // otherwise, undefined
};
var AutoControlledComponent = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(AutoControlledComponent, _Component);
    function AutoControlledComponent() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, AutoControlledComponent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(AutoControlledComponent)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "trySetState", function(maybeState, state) {
            var autoControlledProps = _this.constructor.autoControlledProps;
            var name, illegalKeys;
            var newState = Object.keys(maybeState).reduce(function(acc, prop) {
                // ignore props defined by the parent
                if (_this.props[prop] !== undefined) return acc; // ignore props not listed in auto controlled props
                if (autoControlledProps.indexOf(prop) === -1) return acc;
                acc[prop] = maybeState[prop];
                return acc;
            }, {});
            if (state) newState = (0, _objectSpreadDefault.default)({}, newState, state);
            if (Object.keys(newState).length > 0) _this.setState(newState);
        });
        var _autoControlledProps = _this.constructor.autoControlledProps;
        var _state = (0, _invokeDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getInitialAutoControlledState", _this.props) || {};
        var _this$constructor, defaultProps, name, propTypes, illegalDefaults, illegalAutoControlled;
        // Set initial state by copying auto controlled props to state.
        // Also look for the default prop for any auto controlled props (foo => defaultFoo)
        // so we can set initial values from defaults.
        var initialAutoControlledState = _autoControlledProps.reduce(function(acc, prop) {
            acc[prop] = getAutoControlledStateValue(prop, _this.props, _state, true);
            var defaultPropName, _name;
            return acc;
        }, {});
        _this.state = (0, _objectSpreadDefault.default)({}, _state, initialAutoControlledState);
        return _this;
    }
    (0, _createClassDefault.default)(AutoControlledComponent, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var autoControlledProps = this.constructor.autoControlledProps; // Solve the next state for autoControlledProps
                var newState = autoControlledProps.reduce(function(acc, prop) {
                    var isNextDefined = !(0, _isUndefinedDefault.default)(nextProps[prop]); // if next is defined then use its value
                    if (isNextDefined) acc[prop] = nextProps[prop];
                    return acc;
                }, {});
                if (Object.keys(newState).length > 0) this.setState(newState);
            }
        }
    ]);
    return AutoControlledComponent;
}((0, _react.Component));

},{"@babel/runtime/helpers/objectSpread":"9Q79w","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/difference":"gzKCk","lodash/isUndefined":"iGoGN","lodash/startsWith":"i3VVD","lodash/filter":"h5ETC","lodash/isEmpty":"2iSgw","lodash/keys":"3Kdfe","lodash/intersection":"eWZTT","lodash/has":"dNPtT","lodash/each":"rGuto","lodash/invoke":"jRmLc","react":"6AiW6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gzKCk":[function(require,module,exports) {
var baseDifference = require("68ad3ed657165894"), baseFlatten = require("274eacf6c5db21d1"), baseRest = require("f81b002f05d9fa3d"), isArrayLikeObject = require("c0d5ae8b8d1e5645");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var difference = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
});
module.exports = difference;

},{"68ad3ed657165894":"ldH2S","274eacf6c5db21d1":"jaR7v","f81b002f05d9fa3d":"cFFHO","c0d5ae8b8d1e5645":"8rrEV"}],"ldH2S":[function(require,module,exports) {
var SetCache = require("24f4b9cbc81696e0"), arrayIncludes = require("81e4fe535468d831"), arrayIncludesWith = require("90bb2140eaac029e"), arrayMap = require("7436ea7dfb9a8bab"), baseUnary = require("c466a3eeaa8c48da"), cacheHas = require("aea8a6a021670ce5");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = baseDifference;

},{"24f4b9cbc81696e0":"k0eRl","81e4fe535468d831":"1GQtS","90bb2140eaac029e":"8lNbl","7436ea7dfb9a8bab":"3A7ak","c466a3eeaa8c48da":"1QTqI","aea8a6a021670ce5":"bodFg"}],"1GQtS":[function(require,module,exports) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"gIBck"}],"gIBck":[function(require,module,exports) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"2U5JS","c991ed2b82d165b":"jZpVR","c0bb8190b05a00a5":"cL1tq"}],"2U5JS":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"jZpVR":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"cL1tq":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"8lNbl":[function(require,module,exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"8rrEV":[function(require,module,exports) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"5qgKC","639a4883b097af28":"h29TI"}],"iGoGN":[function(require,module,exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function isUndefined(value) {
    return value === undefined;
}
module.exports = isUndefined;

},{}],"i3VVD":[function(require,module,exports) {
var baseClamp = require("52c73eb5252c6d81"), baseToString = require("3d4e96fed48637c2"), toInteger = require("aa5b1571434cd59b"), toString = require("cdac63497c9f90aa");
/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */ function startsWith(string, target, position) {
    string = toString(string);
    position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
    target = baseToString(target);
    return string.slice(position, position + target.length) == target;
}
module.exports = startsWith;

},{"52c73eb5252c6d81":"7wGBH","3d4e96fed48637c2":"kDU9N","aa5b1571434cd59b":"4WHfQ","cdac63497c9f90aa":"4tAE8"}],"7wGBH":[function(require,module,exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = baseClamp;

},{}],"4WHfQ":[function(require,module,exports) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"8gwVY"}],"8gwVY":[function(require,module,exports) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"be9oZ"}],"be9oZ":[function(require,module,exports) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"axUKa","faaa289d287a34a5":"kDBLt","47b3bd23f771891":"fn3uU"}],"axUKa":[function(require,module,exports) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"Q3nzl"}],"Q3nzl":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"h5ETC":[function(require,module,exports) {
var arrayFilter = require("a1b76c4f8942e73e"), baseFilter = require("a430472df6f36dc1"), baseIteratee = require("65ac72656eceb615"), isArray = require("458bf6bb1af9daa2");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function filter(collection, predicate) {
    var func = isArray(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = filter;

},{"a1b76c4f8942e73e":"cfhXe","a430472df6f36dc1":"a8Q32","65ac72656eceb615":"1zzIW","458bf6bb1af9daa2":"9om8C"}],"a8Q32":[function(require,module,exports) {
var baseEach = require("f9b416bbd850c1fb");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = baseFilter;

},{"f9b416bbd850c1fb":"4KrJl"}],"4KrJl":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"cUayz","f1e3fc84161ef3ec":"kQG99"}],"cUayz":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"2wJUE","1fb77c53defe5720":"3Kdfe"}],"2wJUE":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"bSisR"}],"bSisR":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"kQG99":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"5qgKC"}],"1zzIW":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"2DE2t","4f010869f7b63154":"cH1ec","28f06147d1eb9502":"5HMso","3c56f88c4debf449":"9om8C","aee920e0ef5bf111":"63S17"}],"2DE2t":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"g9IPv","89e9034a8071e297":"hoaFW","782598b150762386":"5aPNk"}],"g9IPv":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"8Y9d2","9003c0cc8ac007b6":"9Vu4W"}],"hoaFW":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"gbK1I","94ffded3a85af2f6":"3Kdfe"}],"gbK1I":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"kDBLt"}],"5aPNk":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"cH1ec":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"9Vu4W","d5ca180f7d6f956a":"4u8u0","3462bb3f546fa1f7":"54LFf","f5fef07966a1c4ee":"mweLo","2a1cd212d48516":"gbK1I","885e72ee7fc6d296":"5aPNk","cd65eaf4a3af29f6":"2ib7q"}],"54LFf":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"a2kGG","b0aefd36de99e579":"cQmjS"}],"a2kGG":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"cQmjS":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"3DEN3","47ffafdab3ba0d6f":"aZ8vK","93ebd263ff0131c1":"9om8C","252ef74480e01958":"ebisk","23c2f64e75e90a2":"fHDsK","af5ade297cb685ee":"2ib7q"}],"63S17":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"cjkUU","abf31da39349df22":"vcjzD","a387ef4a4373de2c":"mweLo","9315973458389ae7":"2ib7q"}],"cjkUU":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"vcjzD":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"7HHv1"}],"eWZTT":[function(require,module,exports) {
var arrayMap = require("6a250a20b4b08a64"), baseIntersection = require("a82701bebbafe8d6"), baseRest = require("a4c4fe36b8bc714c"), castArrayLikeObject = require("a81a4617d84f59b5");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var intersection = baseRest(function(arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
module.exports = intersection;

},{"6a250a20b4b08a64":"3A7ak","a82701bebbafe8d6":"agh1z","a4c4fe36b8bc714c":"cFFHO","a81a4617d84f59b5":"daRll"}],"agh1z":[function(require,module,exports) {
var SetCache = require("7070c945ceea62ce"), arrayIncludes = require("ea93e7f7041da225"), arrayIncludesWith = require("95ac92fc6b845c29"), arrayMap = require("96e97fb8c1f62c2a"), baseUnary = require("cfcf6ce49738e1b2"), cacheHas = require("27c425d77edc5a7b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseIntersection;

},{"7070c945ceea62ce":"k0eRl","ea93e7f7041da225":"1GQtS","95ac92fc6b845c29":"8lNbl","96e97fb8c1f62c2a":"3A7ak","cfcf6ce49738e1b2":"1QTqI","27c425d77edc5a7b":"bodFg"}],"daRll":[function(require,module,exports) {
var isArrayLikeObject = require("36f79b126a48f510");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function castArrayLikeObject(value) {
    return isArrayLikeObject(value) ? value : [];
}
module.exports = castArrayLikeObject;

},{"36f79b126a48f510":"8rrEV"}],"dNPtT":[function(require,module,exports) {
var baseHas = require("adf86b651ea78123"), hasPath = require("d1ab8f0895b2d3d5");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
}
module.exports = has;

},{"adf86b651ea78123":"jUNU3","d1ab8f0895b2d3d5":"cQmjS"}],"jUNU3":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHas(object, key) {
    return object != null && hasOwnProperty.call(object, key);
}
module.exports = baseHas;

},{}],"rGuto":[function(require,module,exports) {
module.exports = require("f27bdc5ac6ae0e0a");

},{"f27bdc5ac6ae0e0a":"fIynw"}],"fIynw":[function(require,module,exports) {
var arrayEach = require("5dbec210c3629ee5"), baseEach = require("8e0dc727d328c3d7"), castFunction = require("759fcc4330a9fea9"), isArray = require("38760405c7e16565");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = isArray(collection) ? arrayEach : baseEach;
    return func(collection, castFunction(iteratee));
}
module.exports = forEach;

},{"5dbec210c3629ee5":"a4f8p","8e0dc727d328c3d7":"4KrJl","759fcc4330a9fea9":"dquuL","38760405c7e16565":"9om8C"}],"a4f8p":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"dquuL":[function(require,module,exports) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"5HMso"}],"iuZdz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "someByType", ()=>someByType);
parcelHelpers.export(exports, "findByType", ()=>findByType);
parcelHelpers.export(exports, "isNil", ()=>isNil);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _react = require("react");
var someByType = function someByType(children, type) {
    return (0, _someDefault.default)((0, _react.Children).toArray(children), {
        type: type
    });
};
var findByType = function findByType(children, type) {
    return (0, _findDefault.default)((0, _react.Children).toArray(children), {
        type: type
    });
};
var isNil = function isNil(children) {
    return children === null || children === undefined || Array.isArray(children) && children.length === 0;
};

},{"lodash/find":"lf7Bf","lodash/some":"gLzPv","react":"6AiW6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lf7Bf":[function(require,module,exports) {
var createFind = require("f180f4459f295340"), findIndex = require("5af87c887948f3ca");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"f180f4459f295340":"hSaiQ","5af87c887948f3ca":"cDEeG"}],"hSaiQ":[function(require,module,exports) {
var baseIteratee = require("ad0cafc4de9b66e6"), isArrayLike = require("cfacddc571674e4b"), keys = require("847fe2f1205991cd");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"ad0cafc4de9b66e6":"1zzIW","cfacddc571674e4b":"5qgKC","847fe2f1205991cd":"3Kdfe"}],"cDEeG":[function(require,module,exports) {
var baseFindIndex = require("c4739d82cf87a9be"), baseIteratee = require("a250b62014668b1"), toInteger = require("8b47b48a148e503b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"c4739d82cf87a9be":"2U5JS","a250b62014668b1":"1zzIW","8b47b48a148e503b":"4WHfQ"}],"gLzPv":[function(require,module,exports) {
var arraySome = require("499d9ae1b712c84d"), baseIteratee = require("6137baa4d335eb2f"), baseSome = require("dffda66140b0b703"), isArray = require("21c688a994e48617"), isIterateeCall = require("86e6a8e9c3fc8343");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = some;

},{"499d9ae1b712c84d":"6ma0g","6137baa4d335eb2f":"1zzIW","dffda66140b0b703":"6u6Zs","21c688a994e48617":"9om8C","86e6a8e9c3fc8343":"9DmJa"}],"6u6Zs":[function(require,module,exports) {
var baseEach = require("fbf6b3dce93949f8");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = baseSome;

},{"fbf6b3dce93949f8":"4KrJl"}],"9DmJa":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"l89hZ","616bc732534dffe0":"5qgKC","e781332a36d1bd7":"ebisk","c8548bf6929b8a5d":"kDBLt"}],"j6O7x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useKeyOnly", ()=>useKeyOnly);
parcelHelpers.export(exports, "useValueAndKey", ()=>useValueAndKey);
parcelHelpers.export(exports, "useKeyOrValueAndKey", ()=>useKeyOrValueAndKey);
parcelHelpers.export(exports, "useMultipleProp", ()=>useMultipleProp);
parcelHelpers.export(exports, "useTextAlignProp", ()=>useTextAlignProp);
parcelHelpers.export(exports, "useVerticalAlignProp", ()=>useVerticalAlignProp);
parcelHelpers.export(exports, "useWidthProp", ()=>useWidthProp);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _numberToWord = require("./numberToWord");
var useKeyOnly = function useKeyOnly(val, key) {
    return val && key;
};
var useValueAndKey = function useValueAndKey(val, key) {
    return val && val !== true && "".concat(val, " ").concat(key);
};
var useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
    return val && (val === true ? key : "".concat(val, " ").concat(key));
}; //
var useMultipleProp = function useMultipleProp(val, key) {
    if (!val || val === true) return null;
    return val.replace("large screen", "large-screen").replace(/ vertically/g, "-vertically").split(" ").map(function(prop) {
        return "".concat(prop.replace("-", " "), " ").concat(key);
    }).join(" ");
};
var useTextAlignProp = function useTextAlignProp(val) {
    return val === "justified" ? "justified" : useValueAndKey(val, "aligned");
};
var useVerticalAlignProp = function useVerticalAlignProp(val) {
    return useValueAndKey(val, "aligned");
};
var useWidthProp = function useWidthProp(val) {
    var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (canEqual && val === "equal") return "equal width";
    var valType = (0, _typeofDefault.default)(val);
    if ((valType === "string" || valType === "number") && widthClass) return "".concat((0, _numberToWord.numberToWord)(val), " ").concat(widthClass);
    return (0, _numberToWord.numberToWord)(val);
};

},{"@babel/runtime/helpers/typeof":"d1yVP","./numberToWord":"bCdEd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bCdEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberToWordMap", ()=>numberToWordMap);
parcelHelpers.export(exports, "numberToWord", ()=>numberToWord);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var numberToWordMap = {
    1: "one",
    2: "two",
    3: "three",
    4: "four",
    5: "five",
    6: "six",
    7: "seven",
    8: "eight",
    9: "nine",
    10: "ten",
    11: "eleven",
    12: "twelve",
    13: "thirteen",
    14: "fourteen",
    15: "fifteen",
    16: "sixteen"
};
function numberToWord(value) {
    var type = (0, _typeofDefault.default)(value);
    if (type === "string" || type === "number") return numberToWordMap[value] || value;
    return "";
}

},{"@babel/runtime/helpers/typeof":"d1yVP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7Oy9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStack = require("@semantic-ui-react/event-stack");
exports.default = (0, _eventStack.instance);

},{"@semantic-ui-react/event-stack":"2pUIp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2pUIp":[function(require,module,exports) {
"use strict";
var stack;
stack = require("1078ba8f762093de");
module.exports = stack.default;
module.exports.instance = stack.instance;

},{"1078ba8f762093de":"hYXLK"}],"hYXLK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var env = require("b517349a17596a91");
require("e534c0a9d680bef5");
var React = require("f3ebf6b4402ec70c");
function _typeof(e) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
}
function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function _createClass(e, t, n) {
    return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}
function _defineProperty(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), t && _setPrototypeOf(e, t);
}
function _getPrototypeOf(e) {
    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
}
function _setPrototypeOf(e, t) {
    return (_setPrototypeOf = Object.setPrototypeOf || function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function _possibleConstructorReturn(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}
var EventSet = function() {
    function e(t) {
        _classCallCheck(this, e), _defineProperty(this, "handlers", void 0), this.handlers = t.slice(0);
    }
    return _createClass(e, [
        {
            key: "addHandlers",
            value: function(t) {
                for(var n = this.handlers.slice(0), r = t.length, o = 0; o < r; o += 1)n.push(t[o]);
                return new e(n);
            }
        },
        {
            key: "dispatchEvent",
            value: function(e, t) {
                var n = this.handlers.length - 1;
                if (t) {
                    for(var r = n; r >= 0; r -= 1)this.handlers[r].called || (this.handlers[r].called = !0, this.handlers[r](e));
                    for(var o = n; o >= 0; o -= 1)this.handlers[o].called = !1;
                } else (0, this.handlers[n])(e);
            }
        },
        {
            key: "hasHandlers",
            value: function() {
                return this.handlers.length > 0;
            }
        },
        {
            key: "removeHandlers",
            value: function(t) {
                for(var n = [], r = this.handlers.length, o = 0; o < r; o += 1){
                    var a = this.handlers[o];
                    -1 === t.indexOf(a) && n.push(a);
                }
                return new e(n);
            }
        }
    ]), e;
}();
function cloneMap(e) {
    var t = new Map;
    return e.forEach(function(e, n) {
        t.set(n, e);
    }), t;
}
function normalizeHandlers(e) {
    return Array.isArray(e) ? e : [
        e
    ];
}
var isRefObject = function(e) {
    return null !== e && "object" === _typeof(e) && e.hasOwnProperty("current");
};
function normalizeTarget(e) {
    return "document" === e ? document : "window" === e ? window : isRefObject(e) ? e.current || document : e || document;
}
var EventPool = function() {
    function e(t, n) {
        _classCallCheck(this, e), _defineProperty(this, "handlerSets", void 0), _defineProperty(this, "poolName", void 0), this.handlerSets = n, this.poolName = t;
    }
    return _createClass(e, [
        {
            key: "addHandlers",
            value: function(t, n) {
                var r = cloneMap(this.handlerSets);
                if (r.has(t)) {
                    var o = r.get(t);
                    r.set(t, o.addHandlers(n));
                } else r.set(t, new EventSet(n));
                return new e(this.poolName, r);
            }
        },
        {
            key: "dispatchEvent",
            value: function(e, t) {
                var n = this.handlerSets.get(e), r = "default" === this.poolName;
                n && n.dispatchEvent(t, r);
            }
        },
        {
            key: "hasHandlers",
            value: function(e) {
                if (!e) return this.handlerSets.size > 0;
                var t = this.handlerSets.get(e);
                return !!t && t.hasHandlers();
            }
        },
        {
            key: "removeHandlers",
            value: function(t, n) {
                var r = cloneMap(this.handlerSets);
                if (!r.has(t)) return new e(this.poolName, r);
                var o = r.get(t).removeHandlers(n);
                return o.hasHandlers() ? r.set(t, o) : r.delete(t), new e(this.poolName, r);
            }
        }
    ]), e;
}();
_defineProperty(EventPool, "createByType", function(e, t, n) {
    var r = new Map;
    return r.set(t, new EventSet(n)), new EventPool(e, r);
});
var EventTarget = function() {
    function e(t) {
        var n = this;
        _classCallCheck(this, e), _defineProperty(this, "handlers", new Map), _defineProperty(this, "pools", new Map), _defineProperty(this, "target", void 0), _defineProperty(this, "createEmitter", function(e) {
            return function(t) {
                n.pools.forEach(function(n) {
                    n.dispatchEvent(e, t);
                });
            };
        }), this.target = t;
    }
    return _createClass(e, [
        {
            key: "addHandlers",
            value: function(e, t, n) {
                if (this.pools.has(e)) {
                    var r = this.pools.get(e);
                    this.pools.set(e, r.addHandlers(t, n));
                } else this.pools.set(e, EventPool.createByType(e, t, n));
                this.handlers.has(t) || this.addTargetHandler(t);
            }
        },
        {
            key: "hasHandlers",
            value: function() {
                return this.handlers.size > 0;
            }
        },
        {
            key: "removeHandlers",
            value: function(e, t, n) {
                if (this.pools.has(e)) {
                    var r = this.pools.get(e).removeHandlers(t, n);
                    r.hasHandlers() ? this.pools.set(e, r) : this.pools.delete(e);
                    var o = !1;
                    this.pools.forEach(function(e) {
                        return o = o || e.hasHandlers(t);
                    }), o || this.removeTargetHandler(t);
                }
            }
        },
        {
            key: "addTargetHandler",
            value: function(e) {
                var t = this.createEmitter(e);
                this.handlers.set(e, t), this.target.addEventListener(e, t, !0);
            }
        },
        {
            key: "removeTargetHandler",
            value: function(e) {
                this.handlers.has(e) && (this.target.removeEventListener(e, this.handlers.get(e), !0), this.handlers.delete(e));
            }
        }
    ]), e;
}(), EventStack = function() {
    function e() {
        var t = this;
        _classCallCheck(this, e), _defineProperty(this, "targets", new Map), _defineProperty(this, "getTarget", function(e) {
            var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = normalizeTarget(e);
            if (t.targets.has(r)) return t.targets.get(r);
            if (!n) return null;
            var o = new EventTarget(r);
            return t.targets.set(r, o), o;
        }), _defineProperty(this, "removeTarget", function(e) {
            t.targets.delete(normalizeTarget(e));
        });
    }
    return _createClass(e, [
        {
            key: "sub",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (env.canUseDOM) {
                    var r = n.target, o = void 0 === r ? document : r, a = n.pool, s = void 0 === a ? "default" : a;
                    this.getTarget(o).addHandlers(s, e, normalizeHandlers(t));
                }
            }
        },
        {
            key: "unsub",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (env.canUseDOM) {
                    var r = n.target, o = void 0 === r ? document : r, a = n.pool, s = void 0 === a ? "default" : a, i = this.getTarget(o, !1);
                    i && (i.removeHandlers(s, e, normalizeHandlers(t)), i.hasHandlers() || this.removeTarget(o));
                }
            }
        }
    ]), e;
}(), instance = new EventStack, EventStack$1 = function(e) {
    function t() {
        return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
    }
    return _inherits(t, React.PureComponent), _createClass(t, [
        {
            key: "componentDidMount",
            value: function() {
                this.subscribe(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                this.unsubscribe(e), this.subscribe(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.unsubscribe(this.props);
            }
        },
        {
            key: "subscribe",
            value: function(e) {
                var t = e.name, n = e.on, r = e.pool, o = e.target;
                instance.sub(t, n, {
                    pool: r,
                    target: o
                });
            }
        },
        {
            key: "unsubscribe",
            value: function(e) {
                var t = e.name, n = e.on, r = e.pool, o = e.target;
                instance.unsub(t, n, {
                    pool: r,
                    target: o
                });
            }
        },
        {
            key: "render",
            value: function() {
                return null;
            }
        }
    ]), t;
}();
_defineProperty(EventStack$1, "defaultProps", {
    pool: "default",
    target: "document"
}), EventStack$1.propTypes = {}, exports.instance = instance, exports.default = EventStack$1;

},{"b517349a17596a91":"j6COH","e534c0a9d680bef5":"kKQPU","f3ebf6b4402ec70c":"6AiW6"}],"j6COH":[function(require,module,exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

},{}],"bseWj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Factories
// ============================================================
/**
 * A more robust React.createElement. It can create elements from primitive values.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @param {string|object|function} val The value to create a ReactElement from
 * @param {Object} [options={}]
 * @param {object} [options.defaultProps={}] Default props object
 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
 * @param {boolean} [options.autoGenerateKey=true] Whether or not automatic key generation is allowed
 * @returns {object|null}
 */ parcelHelpers.export(exports, "createShorthand", ()=>createShorthand) // ============================================================
;
parcelHelpers.export(exports, "createShorthandFactory", ()=>createShorthandFactory) // ============================================================
;
parcelHelpers.export(exports, "createHTMLDivision", ()=>createHTMLDivision);
parcelHelpers.export(exports, "createHTMLIframe", ()=>createHTMLIframe);
parcelHelpers.export(exports, "createHTMLImage", ()=>createHTMLImage);
parcelHelpers.export(exports, "createHTMLInput", ()=>createHTMLInput);
parcelHelpers.export(exports, "createHTMLLabel", ()=>createHTMLLabel);
parcelHelpers.export(exports, "createHTMLParagraph", ()=>createHTMLParagraph);
var _objectSpread = require("@babel/runtime/helpers/objectSpread");
var _objectSpreadDefault = parcelHelpers.interopDefault(_objectSpread);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _isArray = require("lodash/isArray");
var _isArrayDefault = parcelHelpers.interopDefault(_isArray);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isBoolean = require("lodash/isBoolean");
var _isBooleanDefault = parcelHelpers.interopDefault(_isBoolean);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react"); // ============================================================
var _reactDefault = parcelHelpers.interopDefault(_react);
function createShorthand(Component, mapValueToProps, val) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (typeof Component !== "function" && typeof Component !== "string") throw new Error("createShorthand() Component must be a string or function.");
     // short circuit noop values
    if ((0, _isNilDefault.default)(val) || (0, _isBooleanDefault.default)(val)) return null;
    var valIsString = (0, _isStringDefault.default)(val);
    var valIsNumber = (0, _isNumberDefault.default)(val);
    var valIsFunction = (0, _isFunctionDefault.default)(val);
    var valIsReactElement = (0, _react.isValidElement)(val);
    var valIsPropsObject = (0, _isPlainObjectDefault.default)(val);
    var valIsPrimitiveValue = valIsString || valIsNumber || (0, _isArrayDefault.default)(val); // unhandled type return null
    /* eslint-disable no-console */ if (!valIsFunction && !valIsReactElement && !valIsPropsObject && !valIsPrimitiveValue) return null;
    /* eslint-enable no-console */ // ----------------------------------------
    // Build up props
    // ----------------------------------------
    var _options$defaultProps = options.defaultProps, defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps; // User's props
    var usersProps = valIsReactElement && val.props || valIsPropsObject && val || valIsPrimitiveValue && mapValueToProps(val); // Override props
    var _options$overrideProp = options.overrideProps, overrideProps = _options$overrideProp === void 0 ? {} : _options$overrideProp;
    overrideProps = (0, _isFunctionDefault.default)(overrideProps) ? overrideProps((0, _objectSpreadDefault.default)({}, defaultProps, usersProps)) : overrideProps; // Merge props
    /* eslint-disable react/prop-types */ var props = (0, _objectSpreadDefault.default)({}, defaultProps, usersProps, overrideProps); // Merge className
    if (defaultProps.className || overrideProps.className || usersProps.className) {
        var mergedClassesNames = (0, _classnamesDefault.default)(defaultProps.className, overrideProps.className, usersProps.className);
        props.className = (0, _uniqDefault.default)(mergedClassesNames.split(" ")).join(" ");
    } // Merge style
    if (defaultProps.style || overrideProps.style || usersProps.style) props.style = (0, _objectSpreadDefault.default)({}, defaultProps.style, usersProps.style, overrideProps.style);
     // ----------------------------------------
    // Get key
    // ----------------------------------------
    // Use key, childKey, or generate key
    if ((0, _isNilDefault.default)(props.key)) {
        var childKey = props.childKey;
        var _options$autoGenerate = options.autoGenerateKey, autoGenerateKey = _options$autoGenerate === void 0 ? true : _options$autoGenerate;
        if (!(0, _isNilDefault.default)(childKey)) {
            // apply and consume the childKey
            props.key = typeof childKey === "function" ? childKey(props) : childKey;
            delete props.childKey;
        } else if (autoGenerateKey && (valIsString || valIsNumber)) // use string/number shorthand values as the key
        props.key = val;
    } // ----------------------------------------
    // Create Element
    // ----------------------------------------
    // Clone ReactElements
    if (valIsReactElement) return (0, _react.cloneElement)(val, props); // Create ReactElements from built up props
    if (valIsPrimitiveValue || valIsPropsObject) return (0, _reactDefault.default).createElement(Component, props); // Call functions with args similar to createElement()
    if (valIsFunction) return val(Component, props, props.children);
/* eslint-enable react/prop-types */ }
// Factory Creators
// ============================================================
/**
 * Creates a `createShorthand` function that is waiting for a value and options.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
 */ createShorthand.handledProps = [];
function createShorthandFactory(Component, mapValueToProps) {
    if (typeof Component !== "function" && typeof Component !== "string") throw new Error("createShorthandFactory() Component must be a string or function.");
    return function(val, options) {
        return createShorthand(Component, mapValueToProps, val, options);
    };
}
var createHTMLDivision = createShorthandFactory("div", function(val) {
    return {
        children: val
    };
});
var createHTMLIframe = createShorthandFactory("iframe", function(src) {
    return {
        src: src
    };
});
var createHTMLImage = createShorthandFactory("img", function(val) {
    return {
        src: val
    };
});
var createHTMLInput = createShorthandFactory("input", function(val) {
    return {
        type: val
    };
});
var createHTMLLabel = createShorthandFactory("label", function(val) {
    return {
        children: val
    };
});
var createHTMLParagraph = createShorthandFactory("p", function(val) {
    return {
        children: val
    };
});

},{"@babel/runtime/helpers/objectSpread":"9Q79w","@babel/runtime/helpers/typeof":"d1yVP","lodash/uniq":"8tDxW","lodash/isArray":"9om8C","lodash/isPlainObject":"9qlpu","lodash/isFunction":"cXGEE","lodash/isNumber":"qMDht","lodash/isString":"3iITv","lodash/isBoolean":"bMpJ7","lodash/isNil":"c786m","classnames":"7kXBo","react":"6AiW6","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8tDxW":[function(require,module,exports) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"eGMc6"}],"eGMc6":[function(require,module,exports) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"k0eRl","a1d85be956e037a9":"1GQtS","8cd18f86a4a2c118":"8lNbl","3acf9f4a3a78c511":"bodFg","19b77385b4f7775a":"78fEh","4568580f7416eb83":"8bilU"}],"78fEh":[function(require,module,exports) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"d73jL","a02c367b3608ccee":"b9txl","cd8d0af6a14b2f7d":"8bilU"}],"9qlpu":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"57JFO","2ca5b85a120835de":"lYbAK","963b65e043435612":"h29TI"}],"lYbAK":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"lvbwQ"}],"qMDht":[function(require,module,exports) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"57JFO","6ae0825ac2dae50f":"h29TI"}],"3iITv":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"57JFO","46fdd4d2c5d7b4ab":"9om8C","36ebbb6a9d8b3fe4":"h29TI"}],"bMpJ7":[function(require,module,exports) {
var baseGetTag = require("763d54281423d9ac"), isObjectLike = require("37c1c7912587466b");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"763d54281423d9ac":"57JFO","37c1c7912587466b":"h29TI"}],"c786m":[function(require,module,exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"7kXBo":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"lnSqL":[function(require,module,exports) {
/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var getUnhandledProps = function getUnhandledProps(Component, props) {
    // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
    var _Component$handledPro = Component.handledProps, handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
    return Object.keys(props).reduce(function(acc, prop) {
        if (prop === "childKey") return acc;
        if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
        return acc;
    }, {});
};
exports.default = getUnhandledProps;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1Q1Co":[function(require,module,exports) {
/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getElementType(Component, props, getDefault) {
    var _Component$defaultPro = Component.defaultProps, defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
    // user defined "as" element type
    if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
    // computed default element type
    if (getDefault) {
        var computedDefault = getDefault();
        if (computedDefault) return computedDefault;
    } // ----------------------------------------
    // infer anchor links
    if (props.href) return "a"; // ----------------------------------------
    // use defaultProp or 'div'
    return defaultProps.as || "div";
}
exports.default = getElementType;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6tQJc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
/**
 * The function that correctly handles passing refs.
 *
 * @param {Function|Object} ref An ref object or function
 * @param {HTMLElement} node A node that should be passed by ref
 */ var handleRef = function handleRef(ref, node) {
    if (typeof ref === "function") {
        ref(node);
        return;
    }
    if (ref !== null && (0, _typeofDefault.default)(ref) === "object") // The `current` property is defined as readonly, however it's a valid way because `ref` is a mutable object
    // eslint-disable-next-line no-param-reassign
    ref.current = node;
};
exports.default = handleRef;

},{"@babel/runtime/helpers/typeof":"d1yVP","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fVRTG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "htmlInputAttrs", ()=>htmlInputAttrs);
parcelHelpers.export(exports, "htmlInputEvents", ()=>htmlInputEvents);
parcelHelpers.export(exports, "htmlInputProps", ()=>htmlInputProps);
parcelHelpers.export(exports, "htmlImageProps", ()=>htmlImageProps);
parcelHelpers.export(exports, "partitionHTMLProps", ()=>partitionHTMLProps);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _forEach = require("lodash/forEach");
var _forEachDefault = parcelHelpers.interopDefault(_forEach);
var htmlInputAttrs = [
    "selected",
    "defaultValue",
    "defaultChecked",
    "accept",
    "autoCapitalize",
    "autoComplete",
    "autoCorrect",
    "autoFocus",
    "checked",
    "disabled",
    "form",
    "id",
    "lang",
    "list",
    "max",
    "maxLength",
    "min",
    "minLength",
    "multiple",
    "name",
    "pattern",
    "placeholder",
    "readOnly",
    "required",
    "step",
    "title",
    "type",
    "value"
];
var htmlInputEvents = [
    // keyboard
    "onKeyDown",
    "onKeyPress",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "onChange",
    "onInput",
    "onClick",
    "onContextMenu",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp",
    "onSelect",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart"
];
var htmlInputProps = htmlInputAttrs.concat(htmlInputEvents);
var htmlImageProps = [
    "alt",
    "height",
    "src",
    "srcSet",
    "width"
];
var partitionHTMLProps = function partitionHTMLProps(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$htmlProps = options.htmlProps, htmlProps = _options$htmlProps === void 0 ? htmlInputProps : _options$htmlProps, _options$includeAria = options.includeAria, includeAria = _options$includeAria === void 0 ? true : _options$includeAria;
    var inputProps = {};
    var rest = {};
    (0, _forEachDefault.default)(props, function(val, prop) {
        var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === "role");
        var target = (0, _includesDefault.default)(htmlProps, prop) || possibleAria ? inputProps : rest;
        target[prop] = val;
    });
    return [
        inputProps,
        rest
    ];
};

},{"lodash/includes":"havof","lodash/forEach":"fIynw","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"havof":[function(require,module,exports) {
var baseIndexOf = require("be21b9c147562b02"), isArrayLike = require("6b484a793d8b5ea9"), isString = require("bdb00e2bd146c748"), toInteger = require("c8f4f1fcd82bd63e"), values = require("2f52c3a6f24a285e");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
    return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
module.exports = includes;

},{"be21b9c147562b02":"gIBck","6b484a793d8b5ea9":"5qgKC","bdb00e2bd146c748":"3iITv","c8f4f1fcd82bd63e":"4WHfQ","2f52c3a6f24a285e":"cYqMZ"}],"cYqMZ":[function(require,module,exports) {
var baseValues = require("f4ee8afbcaba5363"), keys = require("4f6b7e914d03d8e3");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"f4ee8afbcaba5363":"iCJsp","4f6b7e914d03d8e3":"3Kdfe"}],"iCJsp":[function(require,module,exports) {
var arrayMap = require("2696d06e8e2fc398");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"2696d06e8e2fc398":"3A7ak"}],"e8WiN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var hasDocument = (typeof document === "undefined" ? "undefined" : (0, _typeofDefault.default)(document)) === "object" && document !== null;
var hasWindow = (typeof window === "undefined" ? "undefined" : (0, _typeofDefault.default)(window)) === "object" && window !== null && window.self === window; // eslint-disable-next-line no-confusing-arrow
var isBrowser = function isBrowser() {
    return !(0, _isNilDefault.default)(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
};
exports.default = isBrowser;

},{"@babel/runtime/helpers/typeof":"d1yVP","lodash/isNil":"c786m","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6QEQ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inRange = require("lodash/inRange");
var _inRangeDefault = parcelHelpers.interopDefault(_inRange);
var _first = require("lodash/first");
var _firstDefault = parcelHelpers.interopDefault(_first);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
/**
 * Determines if a click's coordinates are within the bounds of a node.
 *
 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
 *
 * @param {object} node - A DOM node.
 * @param {object} e - A SyntheticEvent or DOM Event.
 * @returns {boolean}
 */ var doesNodeContainClick = function doesNodeContainClick(node, e) {
    if ((0, _someDefault.default)([
        e,
        node
    ], (0, _isNilDefault.default))) return false; // if there is an e.target and it is in the document, use a simple node.contains() check
    if (e.target) {
        (0, _invokeDefault.default)(e.target, "setAttribute", "data-suir-click-target", true);
        if (document.querySelector("[data-suir-click-target=true]")) {
            (0, _invokeDefault.default)(e.target, "removeAttribute", "data-suir-click-target");
            return node.contains(e.target);
        }
    } // Below logic handles cases where the e.target is no longer in the document.
    // The result of the click likely has removed the e.target node.
    // Instead of node.contains(), we'll identify the click by X/Y position.
    // return early if the event properties aren't available
    // prevent measuring the node and repainting if we don't need to
    var clientX = e.clientX, clientY = e.clientY;
    if ((0, _someDefault.default)([
        clientX,
        clientY
    ], (0, _isNilDefault.default))) return false; // false if the node is not visible
    var clientRects = node.getClientRects(); // Heads Up!
    // getClientRects returns a DOMRectList, not an array nor a plain object
    // We explicitly avoid _.isEmpty and check .length to cover all possible shapes
    if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false; // false if the node doesn't have a valid bounding rect
    var _first2 = (0, _firstDefault.default)(clientRects), top = _first2.top, bottom = _first2.bottom, left = _first2.left, right = _first2.right;
    if ((0, _someDefault.default)([
        top,
        bottom,
        left,
        right
    ], (0, _isNilDefault.default))) return false; // we add a small decimal to the upper bound just to make it inclusive
    // don't add an whole pixel (1) as the event/node values may be decimal sensitive
    return (0, _inRangeDefault.default)(clientY, top, bottom + 0.001) && (0, _inRangeDefault.default)(clientX, left, right + 0.001);
};
exports.default = doesNodeContainClick;

},{"lodash/inRange":"9DHdl","lodash/first":"lx5CG","lodash/invoke":"jRmLc","lodash/isNil":"c786m","lodash/some":"gLzPv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9DHdl":[function(require,module,exports) {
var baseInRange = require("6119c20bf2d5e618"), toFinite = require("c5f519badc88f67a"), toNumber = require("5d36ebb402288ff3");
/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */ function inRange(number, start, end) {
    start = toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = toFinite(end);
    number = toNumber(number);
    return baseInRange(number, start, end);
}
module.exports = inRange;

},{"6119c20bf2d5e618":"fCgTc","c5f519badc88f67a":"8gwVY","5d36ebb402288ff3":"be9oZ"}],"fCgTc":[function(require,module,exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */ function baseInRange(number, start, end) {
    return number >= nativeMin(start, end) && number < nativeMax(start, end);
}
module.exports = baseInRange;

},{}],"lx5CG":[function(require,module,exports) {
module.exports = require("4b24fec89d0eece4");

},{"4b24fec89d0eece4":"dGsxw"}],"dGsxw":[function(require,module,exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = head;

},{}],"d2QMC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _refDefault.default));
var _ref = require("./Ref");
var _refDefault = parcelHelpers.interopDefault(_ref);

},{"./Ref":"kKN88","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kKN88":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Ref);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDom = require("react-dom");
var _handleRef = require("../../lib/handleRef");
var _handleRefDefault = parcelHelpers.interopDefault(_handleRef);
/**
 * This component exposes a callback prop that always returns the DOM node of both functional and class component
 * children.
 */ var Ref = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Ref, _Component);
    function Ref() {
        (0, _classCallCheckDefault.default)(this, Ref);
        return (0, _possibleConstructorReturnDefault.default)(this, (0, _getPrototypeOfDefault.default)(Ref).apply(this, arguments));
    }
    (0, _createClassDefault.default)(Ref, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // eslint-disable-next-line react/no-find-dom-node
                (0, _handleRefDefault.default)(this.props.innerRef, (0, _reactDom.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, _handleRefDefault.default)(this.props.innerRef, null);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return (0, _react.Children).only(children);
            }
        }
    ]);
    return Ref;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Ref, "handledProps", [
    "children",
    "innerRef"
]);
Ref.propTypes = {};

},{"@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/defineProperty":"djTAw","prop-types":"kKQPU","react":"6AiW6","react-dom":"3q3jV","../../lib/handleRef":"6tQJc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iL3MA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@babel/runtime/helpers/objectSpread");
var _objectSpreadDefault = parcelHelpers.interopDefault(_objectSpread);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _lib = require("../../lib");
var _ref = require("../Ref");
var _refDefault = parcelHelpers.interopDefault(_ref);
/**
 * An inner component that allows you to render children outside their parent.
 */ var PortalInner = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(PortalInner, _Component);
    function PortalInner() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, PortalInner);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(PortalInner)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleRef", function(c) {
            return _this.ref = c;
        });
        return _this;
    }
    (0, _createClassDefault.default)(PortalInner, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                (0, _invokeDefault.default)(this.props, "onMount", null, (0, _objectSpreadDefault.default)({}, this.props, {
                    node: this.ref
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, _invokeDefault.default)(this.props, "onUnmount", null, (0, _objectSpreadDefault.default)({}, this.props, {
                    node: this.ref
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, _this$props$mountNode = _this$props.mountNode, mountNode = _this$props$mountNode === void 0 ? (0, _lib.isBrowser)() ? document.body : null : _this$props$mountNode;
                return (0, _reactDom.createPortal)((0, _reactDefault.default).createElement((0, _refDefault.default), {
                    innerRef: this.handleRef
                }, children), mountNode);
            }
        }
    ]);
    return PortalInner;
}((0, _react.Component));
(0, _definePropertyDefault.default)(PortalInner, "handledProps", [
    "children",
    "mountNode",
    "onMount",
    "onUnmount"
]);
PortalInner.propTypes = {};
exports.default = PortalInner;

},{"@babel/runtime/helpers/objectSpread":"9Q79w","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/invoke":"jRmLc","prop-types":"kKQPU","react":"6AiW6","react-dom":"3q3jV","../../lib":"1RlVA","../Ref":"d2QMC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cusZf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _gridDefault.default));
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);

},{"./Grid":"5dPM3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5dPM3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _gridColumn = require("./GridColumn");
var _gridColumnDefault = parcelHelpers.interopDefault(_gridColumn);
var _gridRow = require("./GridRow");
var _gridRowDefault = parcelHelpers.interopDefault(_gridRow);
/**
 * A grid is used to harmonize negative space in a layout.
 */ function Grid(props) {
    var celled = props.celled, centered = props.centered, children = props.children, className = props.className, columns = props.columns, container = props.container, divided = props.divided, doubling = props.doubling, inverted = props.inverted, padded = props.padded, relaxed = props.relaxed, reversed = props.reversed, stackable = props.stackable, stretched = props.stretched, textAlign = props.textAlign, verticalAlign = props.verticalAlign;
    var classes = (0, _classnamesDefault.default)("ui", (0, _lib.useKeyOnly)(centered, "centered"), (0, _lib.useKeyOnly)(container, "container"), (0, _lib.useKeyOnly)(doubling, "doubling"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(stackable, "stackable"), (0, _lib.useKeyOnly)(stretched, "stretched"), (0, _lib.useKeyOrValueAndKey)(celled, "celled"), (0, _lib.useKeyOrValueAndKey)(divided, "divided"), (0, _lib.useKeyOrValueAndKey)(padded, "padded"), (0, _lib.useKeyOrValueAndKey)(relaxed, "relaxed"), (0, _lib.useMultipleProp)(reversed, "reversed"), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, "column", true), "grid", className);
    var rest = (0, _lib.getUnhandledProps)(Grid, props);
    var ElementType = (0, _lib.getElementType)(Grid, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
}
Grid.handledProps = [
    "as",
    "celled",
    "centered",
    "children",
    "className",
    "columns",
    "container",
    "divided",
    "doubling",
    "inverted",
    "padded",
    "relaxed",
    "reversed",
    "stackable",
    "stretched",
    "textAlign",
    "verticalAlign"
];
Grid.Column = (0, _gridColumnDefault.default);
Grid.Row = (0, _gridRowDefault.default);
Grid.propTypes = {};
exports.default = Grid;

},{"@babel/runtime/helpers/toConsumableArray":"hg0ai","@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./GridColumn":"hpCY1","./GridRow":"c76pp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hg0ai":[function(require,module,exports) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"k13kU","4f1268a27b81f1fd":"9DlrD","bfa7725fe5f724b":"90yZI","24ae2b6222a85da6":"hpCJe"}],"k13kU":[function(require,module,exports) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"2nsFi"}],"2nsFi":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"9DlrD":[function(require,module,exports) {
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"90yZI":[function(require,module,exports) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"2nsFi"}],"hpCJe":[function(require,module,exports) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"l6HRm":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hpCY1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A column sub-component for Grid.
 */ function GridColumn(props) {
    var children = props.children, className = props.className, computer = props.computer, color = props.color, floated = props.floated, largeScreen = props.largeScreen, mobile = props.mobile, only = props.only, stretched = props.stretched, tablet = props.tablet, textAlign = props.textAlign, verticalAlign = props.verticalAlign, widescreen = props.widescreen, width = props.width;
    var classes = (0, _classnamesDefault.default)(color, (0, _lib.useKeyOnly)(stretched, "stretched"), (0, _lib.useMultipleProp)(only, "only"), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, "floated"), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(computer, "wide computer"), (0, _lib.useWidthProp)(largeScreen, "wide large screen"), (0, _lib.useWidthProp)(mobile, "wide mobile"), (0, _lib.useWidthProp)(tablet, "wide tablet"), (0, _lib.useWidthProp)(widescreen, "wide widescreen"), (0, _lib.useWidthProp)(width, "wide"), "column", className);
    var rest = (0, _lib.getUnhandledProps)(GridColumn, props);
    var ElementType = (0, _lib.getElementType)(GridColumn, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
}
GridColumn.handledProps = [
    "as",
    "children",
    "className",
    "color",
    "computer",
    "floated",
    "largeScreen",
    "mobile",
    "only",
    "stretched",
    "tablet",
    "textAlign",
    "verticalAlign",
    "widescreen",
    "width"
];
GridColumn.propTypes = {};
GridColumn.create = (0, _lib.createShorthandFactory)(GridColumn, function(children) {
    return {
        children: children
    };
});
exports.default = GridColumn;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"c76pp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A row sub-component for Grid.
 */ function GridRow(props) {
    var centered = props.centered, children = props.children, className = props.className, color = props.color, columns = props.columns, divided = props.divided, only = props.only, reversed = props.reversed, stretched = props.stretched, textAlign = props.textAlign, verticalAlign = props.verticalAlign;
    var classes = (0, _classnamesDefault.default)(color, (0, _lib.useKeyOnly)(centered, "centered"), (0, _lib.useKeyOnly)(divided, "divided"), (0, _lib.useKeyOnly)(stretched, "stretched"), (0, _lib.useMultipleProp)(only, "only"), (0, _lib.useMultipleProp)(reversed, "reversed"), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, "column", true), "row", className);
    var rest = (0, _lib.getUnhandledProps)(GridRow, props);
    var ElementType = (0, _lib.getElementType)(GridRow, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
}
GridRow.handledProps = [
    "as",
    "centered",
    "children",
    "className",
    "color",
    "columns",
    "divided",
    "only",
    "reversed",
    "stretched",
    "textAlign",
    "verticalAlign"
];
GridRow.propTypes = {};
exports.default = GridRow;

},{"@babel/runtime/helpers/toConsumableArray":"hg0ai","@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5AcDN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _messageDefault.default));
var _message = require("./Message");
var _messageDefault = parcelHelpers.interopDefault(_message);

},{"./Message":"7PekT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7PekT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Message);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _icon = require("../../elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _messageContent = require("./MessageContent");
var _messageContentDefault = parcelHelpers.interopDefault(_messageContent);
var _messageHeader = require("./MessageHeader");
var _messageHeaderDefault = parcelHelpers.interopDefault(_messageHeader);
var _messageList = require("./MessageList");
var _messageListDefault = parcelHelpers.interopDefault(_messageList);
var _messageItem = require("./MessageItem");
var _messageItemDefault = parcelHelpers.interopDefault(_messageItem);
/**
 * A message displays information that explains nearby content.
 * @see Form
 */ var Message = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Message, _Component);
    function Message() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, Message);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(Message)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleDismiss", function(e) {
            var onDismiss = _this.props.onDismiss;
            if (onDismiss) onDismiss(e, _this.props);
        });
        return _this;
    }
    (0, _createClassDefault.default)(Message, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, attached = _this$props.attached, children = _this$props.children, className = _this$props.className, color = _this$props.color, compact = _this$props.compact, content = _this$props.content, error = _this$props.error, floating = _this$props.floating, header = _this$props.header, hidden = _this$props.hidden, icon = _this$props.icon, info = _this$props.info, list = _this$props.list, negative = _this$props.negative, onDismiss = _this$props.onDismiss, positive = _this$props.positive, size = _this$props.size, success = _this$props.success, visible = _this$props.visible, warning = _this$props.warning;
                var classes = (0, _classnamesDefault.default)("ui", color, size, (0, _lib.useKeyOnly)(compact, "compact"), (0, _lib.useKeyOnly)(error, "error"), (0, _lib.useKeyOnly)(floating, "floating"), (0, _lib.useKeyOnly)(hidden, "hidden"), (0, _lib.useKeyOnly)(icon, "icon"), (0, _lib.useKeyOnly)(info, "info"), (0, _lib.useKeyOnly)(negative, "negative"), (0, _lib.useKeyOnly)(positive, "positive"), (0, _lib.useKeyOnly)(success, "success"), (0, _lib.useKeyOnly)(visible, "visible"), (0, _lib.useKeyOnly)(warning, "warning"), (0, _lib.useKeyOrValueAndKey)(attached, "attached"), "message", className);
                var dismissIcon = onDismiss && (0, _reactDefault.default).createElement((0, _iconDefault.default), {
                    name: "close",
                    onClick: this.handleDismiss
                });
                var rest = (0, _lib.getUnhandledProps)(Message, this.props);
                var ElementType = (0, _lib.getElementType)(Message, this.props);
                if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                    className: classes
                }), dismissIcon, children);
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                    className: classes
                }), dismissIcon, (0, _iconDefault.default).create(icon, {
                    autoGenerateKey: false
                }), (!(0, _isNilDefault.default)(header) || !(0, _isNilDefault.default)(content) || !(0, _isNilDefault.default)(list)) && (0, _reactDefault.default).createElement((0, _messageContentDefault.default), null, (0, _messageHeaderDefault.default).create(header, {
                    autoGenerateKey: false
                }), (0, _messageListDefault.default).create(list, {
                    autoGenerateKey: false
                }), (0, _lib.createHTMLParagraph)(content, {
                    autoGenerateKey: false
                })));
            }
        }
    ]);
    return Message;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Message, "Content", (0, _messageContentDefault.default));
(0, _definePropertyDefault.default)(Message, "Header", (0, _messageHeaderDefault.default));
(0, _definePropertyDefault.default)(Message, "List", (0, _messageListDefault.default));
(0, _definePropertyDefault.default)(Message, "Item", (0, _messageItemDefault.default));
(0, _definePropertyDefault.default)(Message, "handledProps", [
    "as",
    "attached",
    "children",
    "className",
    "color",
    "compact",
    "content",
    "error",
    "floating",
    "header",
    "hidden",
    "icon",
    "info",
    "list",
    "negative",
    "onDismiss",
    "positive",
    "size",
    "success",
    "visible",
    "warning"
]);
Message.propTypes = {};

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/isNil":"c786m","lodash/without":"8BeqI","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../elements/Icon":"dUMma","./MessageContent":"6qoob","./MessageHeader":"9Ns9e","./MessageList":"1dMqY","./MessageItem":"1Zf6Y","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8BeqI":[function(require,module,exports) {
var baseDifference = require("4db0cb250ff88e72"), baseRest = require("b2f01aa6851573dc"), isArrayLikeObject = require("15809c5e06486880");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
module.exports = without;

},{"4db0cb250ff88e72":"ldH2S","b2f01aa6851573dc":"cFFHO","15809c5e06486880":"8rrEV"}],"dUMma":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _iconDefault.default));
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);

},{"./Icon":"7f7ww","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7f7ww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _iconGroup = require("./IconGroup");
var _iconGroupDefault = parcelHelpers.interopDefault(_iconGroup);
/**
 * An icon is a glyph used to represent something else.
 * @see Image
 */ var Icon = /*#__PURE__*/ function(_PureComponent) {
    (0, _inheritsDefault.default)(Icon, _PureComponent);
    function Icon() {
        (0, _classCallCheckDefault.default)(this, Icon);
        return (0, _possibleConstructorReturnDefault.default)(this, (0, _getPrototypeOfDefault.default)(Icon).apply(this, arguments));
    }
    (0, _createClassDefault.default)(Icon, [
        {
            key: "getIconAriaOptions",
            value: function getIconAriaOptions() {
                var ariaOptions = {};
                var _this$props = this.props, ariaLabel = _this$props["aria-label"], ariaHidden = _this$props["aria-hidden"];
                if ((0, _isNilDefault.default)(ariaLabel)) ariaOptions["aria-hidden"] = "true";
                else ariaOptions["aria-label"] = ariaLabel;
                if (!(0, _isNilDefault.default)(ariaHidden)) ariaOptions["aria-hidden"] = ariaHidden;
                return ariaOptions;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, bordered = _this$props2.bordered, circular = _this$props2.circular, className = _this$props2.className, color = _this$props2.color, corner = _this$props2.corner, disabled = _this$props2.disabled, fitted = _this$props2.fitted, flipped = _this$props2.flipped, inverted = _this$props2.inverted, link = _this$props2.link, loading = _this$props2.loading, name = _this$props2.name, rotated = _this$props2.rotated, size = _this$props2.size;
                var classes = (0, _classnamesDefault.default)(color, name, size, (0, _lib.useKeyOnly)(bordered, "bordered"), (0, _lib.useKeyOnly)(circular, "circular"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(fitted, "fitted"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(link, "link"), (0, _lib.useKeyOnly)(loading, "loading"), (0, _lib.useKeyOrValueAndKey)(corner, "corner"), (0, _lib.useValueAndKey)(flipped, "flipped"), (0, _lib.useValueAndKey)(rotated, "rotated"), "icon", className);
                var rest = (0, _lib.getUnhandledProps)(Icon, this.props);
                var ElementType = (0, _lib.getElementType)(Icon, this.props);
                var ariaOptions = this.getIconAriaOptions();
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, ariaOptions, {
                    className: classes
                }));
            }
        }
    ]);
    return Icon;
}((0, _react.PureComponent));
(0, _definePropertyDefault.default)(Icon, "defaultProps", {
    as: "i"
});
(0, _definePropertyDefault.default)(Icon, "Group", (0, _iconGroupDefault.default));
(0, _definePropertyDefault.default)(Icon, "handledProps", [
    "aria-hidden",
    "aria-label",
    "as",
    "bordered",
    "circular",
    "className",
    "color",
    "corner",
    "disabled",
    "fitted",
    "flipped",
    "inverted",
    "link",
    "loading",
    "name",
    "rotated",
    "size"
]);
Icon.propTypes = {};
Icon.create = (0, _lib.createShorthandFactory)(Icon, function(value) {
    return {
        name: value
    };
});
exports.default = Icon;

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/defineProperty":"djTAw","lodash/isNil":"c786m","lodash/without":"8BeqI","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./IconGroup":"cR5nw","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cR5nw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * Several icons can be used together as a group.
 */ function IconGroup(props) {
    var children = props.children, className = props.className, content = props.content, size = props.size;
    var classes = (0, _classnamesDefault.default)(size, "icons", className);
    var rest = (0, _lib.getUnhandledProps)(IconGroup, props);
    var ElementType = (0, _lib.getElementType)(IconGroup, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
IconGroup.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "size"
];
IconGroup.propTypes = {};
IconGroup.defaultProps = {
    as: "i"
};
exports.default = IconGroup;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/without":"8BeqI","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6qoob":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A message can contain a content.
 */ function MessageContent(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, _classnamesDefault.default)("content", className);
    var rest = (0, _lib.getUnhandledProps)(MessageContent, props);
    var ElementType = (0, _lib.getElementType)(MessageContent, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
MessageContent.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
MessageContent.propTypes = {};
exports.default = MessageContent;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Ns9e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A message can contain a header.
 */ function MessageHeader(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, _classnamesDefault.default)("header", className);
    var rest = (0, _lib.getUnhandledProps)(MessageHeader, props);
    var ElementType = (0, _lib.getElementType)(MessageHeader, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
MessageHeader.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
MessageHeader.propTypes = {};
MessageHeader.create = (0, _lib.createShorthandFactory)(MessageHeader, function(val) {
    return {
        content: val
    };
});
exports.default = MessageHeader;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1dMqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _map = require("lodash/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _messageItem = require("./MessageItem");
var _messageItemDefault = parcelHelpers.interopDefault(_messageItem);
/**
 * A message can contain a list of items.
 */ function MessageList(props) {
    var children = props.children, className = props.className, items = props.items;
    var classes = (0, _classnamesDefault.default)("list", className);
    var rest = (0, _lib.getUnhandledProps)(MessageList, props);
    var ElementType = (0, _lib.getElementType)(MessageList, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? (0, _mapDefault.default)(items, (0, _messageItemDefault.default).create) : children);
}
MessageList.handledProps = [
    "as",
    "children",
    "className",
    "items"
];
MessageList.propTypes = {};
MessageList.defaultProps = {
    as: "ul"
};
MessageList.create = (0, _lib.createShorthandFactory)(MessageList, function(val) {
    return {
        items: val
    };
});
exports.default = MessageList;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/map":"8CvOZ","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./MessageItem":"1Zf6Y","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8CvOZ":[function(require,module,exports) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"3A7ak","8bad46685c8864d":"1zzIW","51c76ab24fdb66f9":"t119M","7cb4cacc4dea406c":"9om8C"}],"t119M":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"4KrJl","2924e2db4bb5430d":"5qgKC"}],"1Zf6Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A message list can contain an item.
 */ function MessageItem(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, _classnamesDefault.default)("content", className);
    var rest = (0, _lib.getUnhandledProps)(MessageItem, props);
    var ElementType = (0, _lib.getElementType)(MessageItem, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
MessageItem.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
MessageItem.propTypes = {};
MessageItem.defaultProps = {
    as: "li"
};
MessageItem.create = (0, _lib.createShorthandFactory)(MessageItem, function(content) {
    return {
        content: content
    };
});
exports.default = MessageItem;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gFwYL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableDefault.default));
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);

},{"./Table":"5KzrM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5KzrM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _map = require("lodash/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _tableBody = require("./TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableFooter = require("./TableFooter");
var _tableFooterDefault = parcelHelpers.interopDefault(_tableFooter);
var _tableHeader = require("./TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableHeaderCell = require("./TableHeaderCell");
var _tableHeaderCellDefault = parcelHelpers.interopDefault(_tableHeaderCell);
var _tableRow = require("./TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
/**
 * A table displays a collections of data grouped into rows.
 */ function Table(props) {
    var attached = props.attached, basic = props.basic, celled = props.celled, children = props.children, className = props.className, collapsing = props.collapsing, color = props.color, columns = props.columns, compact = props.compact, definition = props.definition, fixed = props.fixed, footerRow = props.footerRow, headerRow = props.headerRow, inverted = props.inverted, padded = props.padded, renderBodyRow = props.renderBodyRow, selectable = props.selectable, singleLine = props.singleLine, size = props.size, sortable = props.sortable, stackable = props.stackable, striped = props.striped, structured = props.structured, tableData = props.tableData, textAlign = props.textAlign, unstackable = props.unstackable, verticalAlign = props.verticalAlign;
    var classes = (0, _classnamesDefault.default)("ui", color, size, (0, _lib.useKeyOnly)(celled, "celled"), (0, _lib.useKeyOnly)(collapsing, "collapsing"), (0, _lib.useKeyOnly)(definition, "definition"), (0, _lib.useKeyOnly)(fixed, "fixed"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(selectable, "selectable"), (0, _lib.useKeyOnly)(singleLine, "single line"), (0, _lib.useKeyOnly)(sortable, "sortable"), (0, _lib.useKeyOnly)(stackable, "stackable"), (0, _lib.useKeyOnly)(striped, "striped"), (0, _lib.useKeyOnly)(structured, "structured"), (0, _lib.useKeyOnly)(unstackable, "unstackable"), (0, _lib.useKeyOrValueAndKey)(attached, "attached"), (0, _lib.useKeyOrValueAndKey)(basic, "basic"), (0, _lib.useKeyOrValueAndKey)(compact, "compact"), (0, _lib.useKeyOrValueAndKey)(padded, "padded"), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, "column"), "table", className);
    var rest = (0, _lib.getUnhandledProps)(Table, props);
    var ElementType = (0, _lib.getElementType)(Table, props);
    if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), headerRow && (0, _reactDefault.default).createElement((0, _tableHeaderDefault.default), null, (0, _tableRowDefault.default).create(headerRow, {
        defaultProps: {
            cellAs: "th"
        }
    })), (0, _reactDefault.default).createElement((0, _tableBodyDefault.default), null, renderBodyRow && (0, _mapDefault.default)(tableData, function(data, index) {
        return (0, _tableRowDefault.default).create(renderBodyRow(data, index));
    })), footerRow && (0, _reactDefault.default).createElement((0, _tableFooterDefault.default), null, (0, _tableRowDefault.default).create(footerRow)));
}
Table.handledProps = [
    "as",
    "attached",
    "basic",
    "celled",
    "children",
    "className",
    "collapsing",
    "color",
    "columns",
    "compact",
    "definition",
    "fixed",
    "footerRow",
    "headerRow",
    "inverted",
    "padded",
    "renderBodyRow",
    "selectable",
    "singleLine",
    "size",
    "sortable",
    "stackable",
    "striped",
    "structured",
    "tableData",
    "textAlign",
    "unstackable",
    "verticalAlign"
];
Table.defaultProps = {
    as: "table"
};
Table.propTypes = {};
Table.Body = (0, _tableBodyDefault.default);
Table.Cell = (0, _tableCellDefault.default);
Table.Footer = (0, _tableFooterDefault.default);
Table.Header = (0, _tableHeaderDefault.default);
Table.HeaderCell = (0, _tableHeaderCellDefault.default);
Table.Row = (0, _tableRowDefault.default);
exports.default = Table;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/without":"8BeqI","lodash/map":"8CvOZ","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./TableBody":"kYIVr","./TableCell":"4NiTe","./TableFooter":"s8rvv","./TableHeader":"e2Fvs","./TableHeaderCell":"hkNO5","./TableRow":"h6p0l","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kYIVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
function TableBody(props) {
    var children = props.children, className = props.className;
    var classes = (0, _classnamesDefault.default)(className);
    var rest = (0, _lib.getUnhandledProps)(TableBody, props);
    var ElementType = (0, _lib.getElementType)(TableBody, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
}
TableBody.handledProps = [
    "as",
    "children",
    "className"
];
TableBody.defaultProps = {
    as: "tbody"
};
TableBody.propTypes = {};
exports.default = TableBody;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4NiTe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _icon = require("../../elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
/**
 * A table row can have cells.
 */ function TableCell(props) {
    var active = props.active, children = props.children, className = props.className, collapsing = props.collapsing, content = props.content, disabled = props.disabled, error = props.error, icon = props.icon, negative = props.negative, positive = props.positive, selectable = props.selectable, singleLine = props.singleLine, textAlign = props.textAlign, verticalAlign = props.verticalAlign, warning = props.warning, width = props.width;
    var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(active, "active"), (0, _lib.useKeyOnly)(collapsing, "collapsing"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(error, "error"), (0, _lib.useKeyOnly)(negative, "negative"), (0, _lib.useKeyOnly)(positive, "positive"), (0, _lib.useKeyOnly)(selectable, "selectable"), (0, _lib.useKeyOnly)(singleLine, "single line"), (0, _lib.useKeyOnly)(warning, "warning"), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(width, "wide"), className);
    var rest = (0, _lib.getUnhandledProps)(TableCell, props);
    var ElementType = (0, _lib.getElementType)(TableCell, props);
    if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _iconDefault.default).create(icon), content);
}
TableCell.handledProps = [
    "active",
    "as",
    "children",
    "className",
    "collapsing",
    "content",
    "disabled",
    "error",
    "icon",
    "negative",
    "positive",
    "selectable",
    "singleLine",
    "textAlign",
    "verticalAlign",
    "warning",
    "width"
];
TableCell.defaultProps = {
    as: "td"
};
TableCell.propTypes = {};
TableCell.create = (0, _lib.createShorthandFactory)(TableCell, function(content) {
    return {
        content: content
    };
});
exports.default = TableCell;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/without":"8BeqI","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../elements/Icon":"dUMma","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"s8rvv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _tableHeader = require("./TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
/**
 * A table can have a footer.
 */ function TableFooter(props) {
    var as = props.as;
    var rest = (0, _lib.getUnhandledProps)(TableFooter, props);
    return (0, _reactDefault.default).createElement((0, _tableHeaderDefault.default), (0, _extendsDefault.default)({}, rest, {
        as: as
    }));
}
TableFooter.handledProps = [
    "as"
];
TableFooter.propTypes = {};
TableFooter.defaultProps = {
    as: "tfoot"
};
exports.default = TableFooter;

},{"@babel/runtime/helpers/extends":"l6HRm","react":"6AiW6","../../lib":"1RlVA","./TableHeader":"e2Fvs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e2Fvs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A table can have a header.
 */ function TableHeader(props) {
    var children = props.children, className = props.className, content = props.content, fullWidth = props.fullWidth;
    var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(fullWidth, "full-width"), className);
    var rest = (0, _lib.getUnhandledProps)(TableHeader, props);
    var ElementType = (0, _lib.getElementType)(TableHeader, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
TableHeader.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "fullWidth"
];
TableHeader.defaultProps = {
    as: "thead"
};
TableHeader.propTypes = {};
exports.default = TableHeader;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hkNO5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
/**
 * A table can have a header cell.
 */ function TableHeaderCell(props) {
    var as = props.as, className = props.className, sorted = props.sorted;
    var classes = (0, _classnamesDefault.default)((0, _lib.useValueAndKey)(sorted, "sorted"), className);
    var rest = (0, _lib.getUnhandledProps)(TableHeaderCell, props);
    return (0, _reactDefault.default).createElement((0, _tableCellDefault.default), (0, _extendsDefault.default)({}, rest, {
        as: as,
        className: classes
    }));
}
TableHeaderCell.handledProps = [
    "as",
    "className",
    "sorted"
];
TableHeaderCell.propTypes = {};
TableHeaderCell.defaultProps = {
    as: "th"
};
exports.default = TableHeaderCell;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./TableCell":"4NiTe","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h6p0l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _map = require("lodash/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
/**
 * A table can have rows.
 */ function TableRow(props) {
    var active = props.active, cellAs = props.cellAs, cells = props.cells, children = props.children, className = props.className, disabled = props.disabled, error = props.error, negative = props.negative, positive = props.positive, textAlign = props.textAlign, verticalAlign = props.verticalAlign, warning = props.warning;
    var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(active, "active"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(error, "error"), (0, _lib.useKeyOnly)(negative, "negative"), (0, _lib.useKeyOnly)(positive, "positive"), (0, _lib.useKeyOnly)(warning, "warning"), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), className);
    var rest = (0, _lib.getUnhandledProps)(TableRow, props);
    var ElementType = (0, _lib.getElementType)(TableRow, props);
    if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _mapDefault.default)(cells, function(cell) {
        return (0, _tableCellDefault.default).create(cell, {
            defaultProps: {
                as: cellAs
            }
        });
    }));
}
TableRow.handledProps = [
    "active",
    "as",
    "cellAs",
    "cells",
    "children",
    "className",
    "disabled",
    "error",
    "negative",
    "positive",
    "textAlign",
    "verticalAlign",
    "warning"
];
TableRow.defaultProps = {
    as: "tr",
    cellAs: "td"
};
TableRow.propTypes = {};
TableRow.create = (0, _lib.createShorthandFactory)(TableRow, function(cells) {
    return {
        cells: cells
    };
});
exports.default = TableRow;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/without":"8BeqI","lodash/map":"8CvOZ","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./TableCell":"4NiTe","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9FLKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _icon = require("../Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _label = require("../Label/Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _buttonContent = require("./ButtonContent");
var _buttonContentDefault = parcelHelpers.interopDefault(_buttonContent);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonOr = require("./ButtonOr");
var _buttonOrDefault = parcelHelpers.interopDefault(_buttonOr);
/**
 * A Button indicates a possible user action.
 * @see Form
 * @see Icon
 * @see Label
 */ var Button = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Button, _Component);
    function Button() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, Button);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(Button)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "computeElementType", function() {
            var _this$props = _this.props, attached = _this$props.attached, label = _this$props.label;
            if (!(0, _isNilDefault.default)(attached) || !(0, _isNilDefault.default)(label)) return "div";
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "computeTabIndex", function(ElementType) {
            var _this$props2 = _this.props, disabled = _this$props2.disabled, tabIndex = _this$props2.tabIndex;
            if (!(0, _isNilDefault.default)(tabIndex)) return tabIndex;
            if (disabled) return -1;
            if (ElementType === "div") return 0;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "focus", function() {
            return (0, _invokeDefault.default)(_this.ref, "focus");
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleClick", function(e) {
            var disabled = _this.props.disabled;
            if (disabled) {
                e.preventDefault();
                return;
            }
            (0, _invokeDefault.default)(_this.props, "onClick", e, _this.props);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleRef", function(c) {
            return _this.ref = c;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "hasIconClass", function() {
            var _this$props3 = _this.props, labelPosition = _this$props3.labelPosition, children = _this$props3.children, content = _this$props3.content, icon = _this$props3.icon;
            if (icon === true) return true;
            return icon && (labelPosition || (0, _lib.childrenUtils).isNil(children) && (0, _isNilDefault.default)(content));
        });
        return _this;
    }
    (0, _createClassDefault.default)(Button, [
        {
            key: "computeButtonAriaRole",
            value: function computeButtonAriaRole(ElementType) {
                var role = this.props.role;
                if (!(0, _isNilDefault.default)(role)) return role;
                if (ElementType !== "button") return "button";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, active = _this$props4.active, animated = _this$props4.animated, attached = _this$props4.attached, basic = _this$props4.basic, children = _this$props4.children, circular = _this$props4.circular, className = _this$props4.className, color = _this$props4.color, compact = _this$props4.compact, content = _this$props4.content, disabled = _this$props4.disabled, floated = _this$props4.floated, fluid = _this$props4.fluid, icon = _this$props4.icon, inverted = _this$props4.inverted, label = _this$props4.label, labelPosition = _this$props4.labelPosition, loading = _this$props4.loading, negative = _this$props4.negative, positive = _this$props4.positive, primary = _this$props4.primary, secondary = _this$props4.secondary, size = _this$props4.size, toggle = _this$props4.toggle;
                var baseClasses = (0, _classnamesDefault.default)(color, size, (0, _lib.useKeyOnly)(active, "active"), (0, _lib.useKeyOnly)(basic, "basic"), (0, _lib.useKeyOnly)(circular, "circular"), (0, _lib.useKeyOnly)(compact, "compact"), (0, _lib.useKeyOnly)(fluid, "fluid"), (0, _lib.useKeyOnly)(this.hasIconClass(), "icon"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(loading, "loading"), (0, _lib.useKeyOnly)(negative, "negative"), (0, _lib.useKeyOnly)(positive, "positive"), (0, _lib.useKeyOnly)(primary, "primary"), (0, _lib.useKeyOnly)(secondary, "secondary"), (0, _lib.useKeyOnly)(toggle, "toggle"), (0, _lib.useKeyOrValueAndKey)(animated, "animated"), (0, _lib.useKeyOrValueAndKey)(attached, "attached"));
                var labeledClasses = (0, _classnamesDefault.default)((0, _lib.useKeyOrValueAndKey)(labelPosition || !!label, "labeled"));
                var wrapperClasses = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useValueAndKey)(floated, "floated"));
                var rest = (0, _lib.getUnhandledProps)(Button, this.props);
                var ElementType = (0, _lib.getElementType)(Button, this.props, this.computeElementType);
                var tabIndex = this.computeTabIndex(ElementType);
                if (!(0, _isNilDefault.default)(label)) {
                    var buttonClasses = (0, _classnamesDefault.default)("ui", baseClasses, "button", className);
                    var containerClasses = (0, _classnamesDefault.default)("ui", labeledClasses, "button", className, wrapperClasses);
                    var labelElement = (0, _labelDefault.default).create(label, {
                        defaultProps: {
                            basic: true,
                            pointing: labelPosition === "left" ? "right" : "left"
                        },
                        autoGenerateKey: false
                    });
                    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                        className: containerClasses,
                        onClick: this.handleClick
                    }), labelPosition === "left" && labelElement, (0, _reactDefault.default).createElement("button", {
                        className: buttonClasses,
                        "aria-pressed": toggle ? !!active : undefined,
                        disabled: disabled,
                        ref: this.handleRef,
                        tabIndex: tabIndex
                    }, (0, _iconDefault.default).create(icon, {
                        autoGenerateKey: false
                    }), " ", content), (labelPosition === "right" || !labelPosition) && labelElement);
                }
                var classes = (0, _classnamesDefault.default)("ui", baseClasses, wrapperClasses, labeledClasses, "button", className);
                var hasChildren = !(0, _lib.childrenUtils).isNil(children);
                var role = this.computeButtonAriaRole(ElementType);
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                    className: classes,
                    "aria-pressed": toggle ? !!active : undefined,
                    disabled: disabled && ElementType === "button" || undefined,
                    onClick: this.handleClick,
                    ref: this.handleRef,
                    role: role,
                    tabIndex: tabIndex
                }), hasChildren && children, !hasChildren && (0, _iconDefault.default).create(icon, {
                    autoGenerateKey: false
                }), !hasChildren && content);
            }
        }
    ]);
    return Button;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Button, "defaultProps", {
    as: "button"
});
(0, _definePropertyDefault.default)(Button, "Content", (0, _buttonContentDefault.default));
(0, _definePropertyDefault.default)(Button, "Group", (0, _buttonGroupDefault.default));
(0, _definePropertyDefault.default)(Button, "Or", (0, _buttonOrDefault.default));
(0, _definePropertyDefault.default)(Button, "handledProps", [
    "active",
    "animated",
    "as",
    "attached",
    "basic",
    "children",
    "circular",
    "className",
    "color",
    "compact",
    "content",
    "disabled",
    "floated",
    "fluid",
    "icon",
    "inverted",
    "label",
    "labelPosition",
    "loading",
    "negative",
    "onClick",
    "positive",
    "primary",
    "role",
    "secondary",
    "size",
    "tabIndex",
    "toggle"
]);
Button.propTypes = {};
Button.create = (0, _lib.createShorthandFactory)(Button, function(value) {
    return {
        content: value
    };
});
exports.default = Button;

},{"@babel/runtime/helpers/toConsumableArray":"hg0ai","@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/invoke":"jRmLc","lodash/isNil":"c786m","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../Icon/Icon":"7f7ww","../Label/Label":"h3wMW","./ButtonContent":"8BZtV","./ButtonGroup":"9oC9C","./ButtonOr":"24A32","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h3wMW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Label);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _icon = require("../Icon/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _image = require("../Image/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _labelDetail = require("./LabelDetail");
var _labelDetailDefault = parcelHelpers.interopDefault(_labelDetail);
var _labelGroup = require("./LabelGroup");
var _labelGroupDefault = parcelHelpers.interopDefault(_labelGroup);
/**
 * A label displays content classification.
 */ var Label = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Label, _Component);
    function Label() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, Label);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(Label)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleClick", function(e) {
            var onClick = _this.props.onClick;
            if (onClick) onClick(e, _this.props);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleIconOverrides", function(predefinedProps) {
            return {
                onClick: function onClick(e) {
                    (0, _invokeDefault.default)(predefinedProps, "onClick", e);
                    (0, _invokeDefault.default)(_this.props, "onRemove", e, _this.props);
                }
            };
        });
        return _this;
    }
    (0, _createClassDefault.default)(Label, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, attached = _this$props.attached, basic = _this$props.basic, children = _this$props.children, circular = _this$props.circular, className = _this$props.className, color = _this$props.color, content = _this$props.content, corner = _this$props.corner, detail = _this$props.detail, empty = _this$props.empty, floating = _this$props.floating, horizontal = _this$props.horizontal, icon = _this$props.icon, image = _this$props.image, onRemove = _this$props.onRemove, pointing = _this$props.pointing, removeIcon = _this$props.removeIcon, ribbon = _this$props.ribbon, size = _this$props.size, tag = _this$props.tag;
                var pointingClass = pointing === true && "pointing" || (pointing === "left" || pointing === "right") && "".concat(pointing, " pointing") || (pointing === "above" || pointing === "below") && "pointing ".concat(pointing);
                var classes = (0, _classnamesDefault.default)("ui", color, pointingClass, size, (0, _lib.useKeyOnly)(active, "active"), (0, _lib.useKeyOnly)(basic, "basic"), (0, _lib.useKeyOnly)(circular, "circular"), (0, _lib.useKeyOnly)(empty, "empty"), (0, _lib.useKeyOnly)(floating, "floating"), (0, _lib.useKeyOnly)(horizontal, "horizontal"), (0, _lib.useKeyOnly)(image === true, "image"), (0, _lib.useKeyOnly)(tag, "tag"), (0, _lib.useKeyOrValueAndKey)(corner, "corner"), (0, _lib.useKeyOrValueAndKey)(ribbon, "ribbon"), (0, _lib.useValueAndKey)(attached, "attached"), "label", className);
                var rest = (0, _lib.getUnhandledProps)(Label, this.props);
                var ElementType = (0, _lib.getElementType)(Label, this.props);
                if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                    className: classes,
                    onClick: this.handleClick
                }), children);
                var removeIconShorthand = (0, _isUndefinedDefault.default)(removeIcon) ? "delete" : removeIcon;
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({
                    className: classes,
                    onClick: this.handleClick
                }, rest), (0, _iconDefault.default).create(icon, {
                    autoGenerateKey: false
                }), typeof image !== "boolean" && (0, _imageDefault.default).create(image, {
                    autoGenerateKey: false
                }), content, (0, _labelDetailDefault.default).create(detail, {
                    autoGenerateKey: false
                }), onRemove && (0, _iconDefault.default).create(removeIconShorthand, {
                    autoGenerateKey: false,
                    overrideProps: this.handleIconOverrides
                }));
            }
        }
    ]);
    return Label;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Label, "Detail", (0, _labelDetailDefault.default));
(0, _definePropertyDefault.default)(Label, "Group", (0, _labelGroupDefault.default));
(0, _definePropertyDefault.default)(Label, "handledProps", [
    "active",
    "as",
    "attached",
    "basic",
    "children",
    "circular",
    "className",
    "color",
    "content",
    "corner",
    "detail",
    "empty",
    "floating",
    "horizontal",
    "icon",
    "image",
    "onClick",
    "onRemove",
    "pointing",
    "removeIcon",
    "ribbon",
    "size",
    "tag"
]);
Label.propTypes = {};
Label.create = (0, _lib.createShorthandFactory)(Label, function(value) {
    return {
        content: value
    };
});

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/isUndefined":"iGoGN","lodash/invoke":"jRmLc","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../Icon/Icon":"7f7ww","../Image/Image":"b2gk5","./LabelDetail":"8HTzL","./LabelGroup":"k9XTn","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b2gk5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _dimmer = require("../../modules/Dimmer");
var _dimmerDefault = parcelHelpers.interopDefault(_dimmer);
var _label = require("../Label/Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _imageGroup = require("./ImageGroup");
var _imageGroupDefault = parcelHelpers.interopDefault(_imageGroup);
/**
 * An image is a graphic representation of something.
 * @see Icon
 */ function Image(props) {
    var avatar = props.avatar, bordered = props.bordered, centered = props.centered, children = props.children, circular = props.circular, className = props.className, content = props.content, dimmer = props.dimmer, disabled = props.disabled, floated = props.floated, fluid = props.fluid, hidden = props.hidden, href = props.href, inline = props.inline, label = props.label, rounded = props.rounded, size = props.size, spaced = props.spaced, verticalAlign = props.verticalAlign, wrapped = props.wrapped, ui = props.ui;
    var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(ui, "ui"), size, (0, _lib.useKeyOnly)(avatar, "avatar"), (0, _lib.useKeyOnly)(bordered, "bordered"), (0, _lib.useKeyOnly)(circular, "circular"), (0, _lib.useKeyOnly)(centered, "centered"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(fluid, "fluid"), (0, _lib.useKeyOnly)(hidden, "hidden"), (0, _lib.useKeyOnly)(inline, "inline"), (0, _lib.useKeyOnly)(rounded, "rounded"), (0, _lib.useKeyOrValueAndKey)(spaced, "spaced"), (0, _lib.useValueAndKey)(floated, "floated"), (0, _lib.useVerticalAlignProp)(verticalAlign, "aligned"), "image", className);
    var rest = (0, _lib.getUnhandledProps)(Image, props);
    var _partitionHTMLProps = (0, _lib.partitionHTMLProps)(rest, {
        htmlProps: (0, _lib.htmlImageProps)
    }), _partitionHTMLProps2 = (0, _slicedToArrayDefault.default)(_partitionHTMLProps, 2), imgTagProps = _partitionHTMLProps2[0], rootProps = _partitionHTMLProps2[1];
    var ElementType = (0, _lib.getElementType)(Image, props, function() {
        if (!(0, _isNilDefault.default)(dimmer) || !(0, _isNilDefault.default)(label) || !(0, _isNilDefault.default)(wrapped) || !(0, _lib.childrenUtils).isNil(children)) return "div";
    });
    if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
    if (!(0, _lib.childrenUtils).isNil(content)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), content);
    if (ElementType === "img") return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rootProps, imgTagProps, {
        className: classes
    }));
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rootProps, {
        className: classes,
        href: href
    }), (0, _dimmerDefault.default).create(dimmer, {
        autoGenerateKey: false
    }), (0, _labelDefault.default).create(label, {
        autoGenerateKey: false
    }), (0, _reactDefault.default).createElement("img", imgTagProps));
}
Image.handledProps = [
    "as",
    "avatar",
    "bordered",
    "centered",
    "children",
    "circular",
    "className",
    "content",
    "dimmer",
    "disabled",
    "floated",
    "fluid",
    "hidden",
    "href",
    "inline",
    "label",
    "rounded",
    "size",
    "spaced",
    "ui",
    "verticalAlign",
    "wrapped"
];
Image.Group = (0, _imageGroupDefault.default);
Image.propTypes = {};
Image.defaultProps = {
    as: "img",
    ui: true
};
Image.create = (0, _lib.createShorthandFactory)(Image, function(value) {
    return {
        src: value
    };
});
exports.default = Image;

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/slicedToArray":"ezVdZ","lodash/isNil":"c786m","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../modules/Dimmer":"hg7YE","../Label/Label":"h3wMW","./ImageGroup":"2aZUg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ezVdZ":[function(require,module,exports) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"amGVi","c109e0e3b1a7ef05":"h5IJZ","6782568c4383bd49":"90yZI","1e06d43f4bd6e532":"coiWq"}],"amGVi":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"h5IJZ":[function(require,module,exports) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"coiWq":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hg7YE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dimmerDefault.default));
var _dimmer = require("./Dimmer");
var _dimmerDefault = parcelHelpers.interopDefault(_dimmer);

},{"./Dimmer":"dGJU1","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dGJU1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dimmer);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _portal = require("../../addons/Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _dimmerDimmable = require("./DimmerDimmable");
var _dimmerDimmableDefault = parcelHelpers.interopDefault(_dimmerDimmable);
var _dimmerInner = require("./DimmerInner");
var _dimmerInnerDefault = parcelHelpers.interopDefault(_dimmerInner);
/**
 * A dimmer hides distractions to focus attention on particular content.
 */ var Dimmer = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Dimmer, _Component);
    function Dimmer() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, Dimmer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(Dimmer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handlePortalMount", function() {
            if (!(0, _lib.isBrowser)()) return; // Heads up, IE doesn't support second argument in add()
            document.body.classList.add("dimmed");
            document.body.classList.add("dimmable");
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handlePortalUnmount", function() {
            if (!(0, _lib.isBrowser)()) return; // Heads up, IE doesn't support second argument in add()
            document.body.classList.remove("dimmed");
            document.body.classList.remove("dimmable");
        });
        return _this;
    }
    (0, _createClassDefault.default)(Dimmer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, page = _this$props.page;
                var rest = (0, _lib.getUnhandledProps)(Dimmer, this.props);
                if (page) return (0, _reactDefault.default).createElement((0, _portalDefault.default), {
                    closeOnEscape: false,
                    closeOnDocumentClick: false,
                    onMount: this.handlePortalMount,
                    onUnmount: this.handlePortalUnmount,
                    open: active,
                    openOnTriggerClick: false
                }, (0, _reactDefault.default).createElement((0, _dimmerInnerDefault.default), (0, _extendsDefault.default)({}, rest, {
                    active: active,
                    page: page
                })));
                return (0, _reactDefault.default).createElement((0, _dimmerInnerDefault.default), (0, _extendsDefault.default)({}, rest, {
                    active: active,
                    page: page
                }));
            }
        }
    ]);
    return Dimmer;
}((0, _react.Component));
(0, _definePropertyDefault.default)(Dimmer, "Dimmable", (0, _dimmerDimmableDefault.default));
(0, _definePropertyDefault.default)(Dimmer, "Inner", (0, _dimmerInnerDefault.default));
(0, _definePropertyDefault.default)(Dimmer, "handledProps", [
    "active",
    "page"
]);
Dimmer.propTypes = {};
Dimmer.create = (0, _lib.createShorthandFactory)(Dimmer, function(value) {
    return {
        content: value
    };
});

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../addons/Portal":"46BVs","./DimmerDimmable":"clLkU","./DimmerInner":"eBCnp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"clLkU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A dimmable sub-component for Dimmer.
 */ function DimmerDimmable(props) {
    var blurring = props.blurring, className = props.className, children = props.children, content = props.content, dimmed = props.dimmed;
    var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(blurring, "blurring"), (0, _lib.useKeyOnly)(dimmed, "dimmed"), "dimmable", className);
    var rest = (0, _lib.getUnhandledProps)(DimmerDimmable, props);
    var ElementType = (0, _lib.getElementType)(DimmerDimmable, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
DimmerDimmable.handledProps = [
    "as",
    "blurring",
    "children",
    "className",
    "content",
    "dimmed"
];
DimmerDimmable.propTypes = {};
exports.default = DimmerDimmable;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eBCnp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DimmerInner);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * An inner element for a Dimmer.
 */ var DimmerInner = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(DimmerInner, _Component);
    function DimmerInner() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, DimmerInner);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(DimmerInner)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "containerRef", (0, _react.createRef)());
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "contentRef", (0, _react.createRef)());
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleClick", function(e) {
            var contentRef = _this.contentRef.current;
            (0, _invokeDefault.default)(_this.props, "onClick", e, _this.props);
            if (contentRef && contentRef !== e.target && (0, _lib.doesNodeContainClick)(contentRef, e)) return;
            (0, _invokeDefault.default)(_this.props, "onClickOutside", e, _this.props);
        });
        return _this;
    }
    (0, _createClassDefault.default)(DimmerInner, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var active = this.props.active;
                this.toggleStyles(active);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var currentActive = this.props.active;
                var prevActive = prevProps.active;
                if (prevActive !== currentActive) this.toggleStyles(currentActive);
            }
        },
        {
            key: "toggleStyles",
            value: function toggleStyles(active) {
                var containerRef = this.containerRef.current;
                if (!containerRef) return;
                if (active) containerRef.style.setProperty("display", "flex", "important");
                else containerRef.style.removeProperty("display");
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, children = _this$props.children, className = _this$props.className, content = _this$props.content, disabled = _this$props.disabled, inverted = _this$props.inverted, page = _this$props.page, simple = _this$props.simple, verticalAlign = _this$props.verticalAlign;
                var classes = (0, _classnamesDefault.default)("ui", (0, _lib.useKeyOnly)(active, "active transition visible"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(page, "page"), (0, _lib.useKeyOnly)(simple, "simple"), (0, _lib.useVerticalAlignProp)(verticalAlign), "dimmer", className);
                var rest = (0, _lib.getUnhandledProps)(DimmerInner, this.props);
                var ElementType = (0, _lib.getElementType)(DimmerInner, this.props);
                var childrenContent = (0, _lib.childrenUtils).isNil(children) ? content : children;
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                    className: classes,
                    onClick: this.handleClick,
                    ref: this.containerRef
                }), childrenContent && (0, _reactDefault.default).createElement("div", {
                    className: "content",
                    ref: this.contentRef
                }, childrenContent));
            }
        }
    ]);
    return DimmerInner;
}((0, _react.Component));
(0, _definePropertyDefault.default)(DimmerInner, "handledProps", [
    "active",
    "as",
    "children",
    "className",
    "content",
    "disabled",
    "inverted",
    "onClick",
    "onClickOutside",
    "page",
    "simple",
    "verticalAlign"
]);
DimmerInner.propTypes = {};

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/invoke":"jRmLc","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2aZUg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A group of images.
 */ function ImageGroup(props) {
    var children = props.children, className = props.className, content = props.content, size = props.size;
    var classes = (0, _classnamesDefault.default)("ui", size, className, "images");
    var rest = (0, _lib.getUnhandledProps)(ImageGroup, props);
    var ElementType = (0, _lib.getElementType)(ImageGroup, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
ImageGroup.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "size"
];
ImageGroup.propTypes = {};
exports.default = ImageGroup;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8HTzL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
function LabelDetail(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, _classnamesDefault.default)("detail", className);
    var rest = (0, _lib.getUnhandledProps)(LabelDetail, props);
    var ElementType = (0, _lib.getElementType)(LabelDetail, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
LabelDetail.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
LabelDetail.propTypes = {};
LabelDetail.create = (0, _lib.createShorthandFactory)(LabelDetail, function(val) {
    return {
        content: val
    };
});
exports.default = LabelDetail;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k9XTn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A label can be grouped.
 */ function LabelGroup(props) {
    var children = props.children, circular = props.circular, className = props.className, color = props.color, content = props.content, size = props.size, tag = props.tag;
    var classes = (0, _classnamesDefault.default)("ui", color, size, (0, _lib.useKeyOnly)(circular, "circular"), (0, _lib.useKeyOnly)(tag, "tag"), "labels", className);
    var rest = (0, _lib.getUnhandledProps)(LabelGroup, props);
    var ElementType = (0, _lib.getElementType)(LabelGroup, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
LabelGroup.handledProps = [
    "as",
    "children",
    "circular",
    "className",
    "color",
    "content",
    "size",
    "tag"
];
LabelGroup.propTypes = {};
exports.default = LabelGroup;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8BZtV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * Used in some Button types, such as `animated`.
 */ function ButtonContent(props) {
    var children = props.children, className = props.className, content = props.content, hidden = props.hidden, visible = props.visible;
    var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(visible, "visible"), (0, _lib.useKeyOnly)(hidden, "hidden"), "content", className);
    var rest = (0, _lib.getUnhandledProps)(ButtonContent, props);
    var ElementType = (0, _lib.getElementType)(ButtonContent, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
ButtonContent.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "hidden",
    "visible"
];
ButtonContent.propTypes = {};
exports.default = ButtonContent;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9oC9C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _map = require("lodash/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
/**
 * Buttons can be grouped.
 */ function ButtonGroup(props) {
    var attached = props.attached, basic = props.basic, buttons = props.buttons, children = props.children, className = props.className, color = props.color, compact = props.compact, content = props.content, floated = props.floated, fluid = props.fluid, icon = props.icon, inverted = props.inverted, labeled = props.labeled, negative = props.negative, positive = props.positive, primary = props.primary, secondary = props.secondary, size = props.size, toggle = props.toggle, vertical = props.vertical, widths = props.widths;
    var classes = (0, _classnamesDefault.default)("ui", color, size, (0, _lib.useKeyOnly)(basic, "basic"), (0, _lib.useKeyOnly)(compact, "compact"), (0, _lib.useKeyOnly)(fluid, "fluid"), (0, _lib.useKeyOnly)(icon, "icon"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(labeled, "labeled"), (0, _lib.useKeyOnly)(negative, "negative"), (0, _lib.useKeyOnly)(positive, "positive"), (0, _lib.useKeyOnly)(primary, "primary"), (0, _lib.useKeyOnly)(secondary, "secondary"), (0, _lib.useKeyOnly)(toggle, "toggle"), (0, _lib.useKeyOnly)(vertical, "vertical"), (0, _lib.useKeyOrValueAndKey)(attached, "attached"), (0, _lib.useValueAndKey)(floated, "floated"), (0, _lib.useWidthProp)(widths), "buttons", className);
    var rest = (0, _lib.getUnhandledProps)(ButtonGroup, props);
    var ElementType = (0, _lib.getElementType)(ButtonGroup, props);
    if ((0, _isNilDefault.default)(buttons)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _mapDefault.default)(buttons, function(button) {
        return (0, _buttonDefault.default).create(button);
    }));
}
ButtonGroup.handledProps = [
    "as",
    "attached",
    "basic",
    "buttons",
    "children",
    "className",
    "color",
    "compact",
    "content",
    "floated",
    "fluid",
    "icon",
    "inverted",
    "labeled",
    "negative",
    "positive",
    "primary",
    "secondary",
    "size",
    "toggle",
    "vertical",
    "widths"
];
ButtonGroup.propTypes = {};
exports.default = ButtonGroup;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/map":"8CvOZ","lodash/isNil":"c786m","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","./Button":"9FLKC","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"24A32":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * Button groups can contain conditionals.
 */ function ButtonOr(props) {
    var className = props.className, text = props.text;
    var classes = (0, _classnamesDefault.default)("or", className);
    var rest = (0, _lib.getUnhandledProps)(ButtonOr, props);
    var ElementType = (0, _lib.getElementType)(ButtonOr, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes,
        "data-text": text
    }));
}
ButtonOr.handledProps = [
    "as",
    "className",
    "text"
];
ButtonOr.propTypes = {};
exports.default = ButtonOr;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Sfid":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _containerDefault.default));
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);

},{"./Container":"cZeKp","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cZeKp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A container limits content to a maximum width.
 */ function Container(props) {
    var children = props.children, className = props.className, content = props.content, fluid = props.fluid, text = props.text, textAlign = props.textAlign;
    var classes = (0, _classnamesDefault.default)("ui", (0, _lib.useKeyOnly)(text, "text"), (0, _lib.useKeyOnly)(fluid, "fluid"), (0, _lib.useTextAlignProp)(textAlign), "container", className);
    var rest = (0, _lib.getUnhandledProps)(Container, props);
    var ElementType = (0, _lib.getElementType)(Container, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
Container.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "fluid",
    "text",
    "textAlign"
];
Container.propTypes = {};
exports.default = Container;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6wifd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _flagDefault.default));
var _flag = require("./Flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);

},{"./Flag":"2TY4m","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2TY4m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "names", ()=>names);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var names = [
    "ad",
    "andorra",
    "ae",
    "united arab emirates",
    "uae",
    "af",
    "afghanistan",
    "ag",
    "antigua",
    "ai",
    "anguilla",
    "al",
    "albania",
    "am",
    "armenia",
    "an",
    "netherlands antilles",
    "ao",
    "angola",
    "ar",
    "argentina",
    "as",
    "american samoa",
    "at",
    "austria",
    "au",
    "australia",
    "aw",
    "aruba",
    "ax",
    "aland islands",
    "az",
    "azerbaijan",
    "ba",
    "bosnia",
    "bb",
    "barbados",
    "bd",
    "bangladesh",
    "be",
    "belgium",
    "bf",
    "burkina faso",
    "bg",
    "bulgaria",
    "bh",
    "bahrain",
    "bi",
    "burundi",
    "bj",
    "benin",
    "bm",
    "bermuda",
    "bn",
    "brunei",
    "bo",
    "bolivia",
    "br",
    "brazil",
    "bs",
    "bahamas",
    "bt",
    "bhutan",
    "bv",
    "bouvet island",
    "bw",
    "botswana",
    "by",
    "belarus",
    "bz",
    "belize",
    "ca",
    "canada",
    "cc",
    "cocos islands",
    "cd",
    "congo",
    "cf",
    "central african republic",
    "cg",
    "congo brazzaville",
    "ch",
    "switzerland",
    "ci",
    "cote divoire",
    "ck",
    "cook islands",
    "cl",
    "chile",
    "cm",
    "cameroon",
    "cn",
    "china",
    "co",
    "colombia",
    "cr",
    "costa rica",
    "cs",
    "cu",
    "cuba",
    "cv",
    "cape verde",
    "cx",
    "christmas island",
    "cy",
    "cyprus",
    "cz",
    "czech republic",
    "de",
    "germany",
    "dj",
    "djibouti",
    "dk",
    "denmark",
    "dm",
    "dominica",
    "do",
    "dominican republic",
    "dz",
    "algeria",
    "ec",
    "ecuador",
    "ee",
    "estonia",
    "eg",
    "egypt",
    "eh",
    "western sahara",
    "er",
    "eritrea",
    "es",
    "spain",
    "et",
    "ethiopia",
    "eu",
    "european union",
    "fi",
    "finland",
    "fj",
    "fiji",
    "fk",
    "falkland islands",
    "fm",
    "micronesia",
    "fo",
    "faroe islands",
    "fr",
    "france",
    "ga",
    "gabon",
    "gb",
    "uk",
    "united kingdom",
    "gd",
    "grenada",
    "ge",
    "georgia",
    "gf",
    "french guiana",
    "gh",
    "ghana",
    "gi",
    "gibraltar",
    "gl",
    "greenland",
    "gm",
    "gambia",
    "gn",
    "guinea",
    "gp",
    "guadeloupe",
    "gq",
    "equatorial guinea",
    "gr",
    "greece",
    "gs",
    "sandwich islands",
    "gt",
    "guatemala",
    "gu",
    "guam",
    "gw",
    "guinea-bissau",
    "gy",
    "guyana",
    "hk",
    "hong kong",
    "hm",
    "heard island",
    "hn",
    "honduras",
    "hr",
    "croatia",
    "ht",
    "haiti",
    "hu",
    "hungary",
    "id",
    "indonesia",
    "ie",
    "ireland",
    "il",
    "israel",
    "in",
    "india",
    "io",
    "indian ocean territory",
    "iq",
    "iraq",
    "ir",
    "iran",
    "is",
    "iceland",
    "it",
    "italy",
    "jm",
    "jamaica",
    "jo",
    "jordan",
    "jp",
    "japan",
    "ke",
    "kenya",
    "kg",
    "kyrgyzstan",
    "kh",
    "cambodia",
    "ki",
    "kiribati",
    "km",
    "comoros",
    "kn",
    "saint kitts and nevis",
    "kp",
    "north korea",
    "kr",
    "south korea",
    "kw",
    "kuwait",
    "ky",
    "cayman islands",
    "kz",
    "kazakhstan",
    "la",
    "laos",
    "lb",
    "lebanon",
    "lc",
    "saint lucia",
    "li",
    "liechtenstein",
    "lk",
    "sri lanka",
    "lr",
    "liberia",
    "ls",
    "lesotho",
    "lt",
    "lithuania",
    "lu",
    "luxembourg",
    "lv",
    "latvia",
    "ly",
    "libya",
    "ma",
    "morocco",
    "mc",
    "monaco",
    "md",
    "moldova",
    "me",
    "montenegro",
    "mg",
    "madagascar",
    "mh",
    "marshall islands",
    "mk",
    "macedonia",
    "ml",
    "mali",
    "mm",
    "myanmar",
    "burma",
    "mn",
    "mongolia",
    "mo",
    "macau",
    "mp",
    "northern mariana islands",
    "mq",
    "martinique",
    "mr",
    "mauritania",
    "ms",
    "montserrat",
    "mt",
    "malta",
    "mu",
    "mauritius",
    "mv",
    "maldives",
    "mw",
    "malawi",
    "mx",
    "mexico",
    "my",
    "malaysia",
    "mz",
    "mozambique",
    "na",
    "namibia",
    "nc",
    "new caledonia",
    "ne",
    "niger",
    "nf",
    "norfolk island",
    "ng",
    "nigeria",
    "ni",
    "nicaragua",
    "nl",
    "netherlands",
    "no",
    "norway",
    "np",
    "nepal",
    "nr",
    "nauru",
    "nu",
    "niue",
    "nz",
    "new zealand",
    "om",
    "oman",
    "pa",
    "panama",
    "pe",
    "peru",
    "pf",
    "french polynesia",
    "pg",
    "new guinea",
    "ph",
    "philippines",
    "pk",
    "pakistan",
    "pl",
    "poland",
    "pm",
    "saint pierre",
    "pn",
    "pitcairn islands",
    "pr",
    "puerto rico",
    "ps",
    "palestine",
    "pt",
    "portugal",
    "pw",
    "palau",
    "py",
    "paraguay",
    "qa",
    "qatar",
    "re",
    "reunion",
    "ro",
    "romania",
    "rs",
    "serbia",
    "ru",
    "russia",
    "rw",
    "rwanda",
    "sa",
    "saudi arabia",
    "sb",
    "solomon islands",
    "sc",
    "seychelles",
    "gb sct",
    "scotland",
    "sd",
    "sudan",
    "se",
    "sweden",
    "sg",
    "singapore",
    "sh",
    "saint helena",
    "si",
    "slovenia",
    "sj",
    "svalbard",
    "jan mayen",
    "sk",
    "slovakia",
    "sl",
    "sierra leone",
    "sm",
    "san marino",
    "sn",
    "senegal",
    "so",
    "somalia",
    "sr",
    "suriname",
    "st",
    "sao tome",
    "sv",
    "el salvador",
    "sy",
    "syria",
    "sz",
    "swaziland",
    "tc",
    "caicos islands",
    "td",
    "chad",
    "tf",
    "french territories",
    "tg",
    "togo",
    "th",
    "thailand",
    "tj",
    "tajikistan",
    "tk",
    "tokelau",
    "tl",
    "timorleste",
    "tm",
    "turkmenistan",
    "tn",
    "tunisia",
    "to",
    "tonga",
    "tr",
    "turkey",
    "tt",
    "trinidad",
    "tv",
    "tuvalu",
    "tw",
    "taiwan",
    "tz",
    "tanzania",
    "ua",
    "ukraine",
    "ug",
    "uganda",
    "um",
    "us minor islands",
    "us",
    "america",
    "united states",
    "uy",
    "uruguay",
    "uz",
    "uzbekistan",
    "va",
    "vatican city",
    "vc",
    "saint vincent",
    "ve",
    "venezuela",
    "vg",
    "british virgin islands",
    "vi",
    "us virgin islands",
    "vn",
    "vietnam",
    "vu",
    "vanuatu",
    "gb wls",
    "wales",
    "wf",
    "wallis and futuna",
    "ws",
    "samoa",
    "ye",
    "yemen",
    "yt",
    "mayotte",
    "za",
    "south africa",
    "zm",
    "zambia",
    "zw",
    "zimbabwe"
];
/**
 * A flag is is used to represent a political state.
 */ var Flag = /*#__PURE__*/ function(_PureComponent) {
    (0, _inheritsDefault.default)(Flag, _PureComponent);
    function Flag() {
        (0, _classCallCheckDefault.default)(this, Flag);
        return (0, _possibleConstructorReturnDefault.default)(this, (0, _getPrototypeOfDefault.default)(Flag).apply(this, arguments));
    }
    (0, _createClassDefault.default)(Flag, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, name = _this$props.name;
                var classes = (0, _classnamesDefault.default)(name, "flag", className);
                var rest = (0, _lib.getUnhandledProps)(Flag, this.props);
                var ElementType = (0, _lib.getElementType)(Flag, this.props);
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
                    className: classes
                }));
            }
        }
    ]);
    return Flag;
}((0, _react.PureComponent));
(0, _definePropertyDefault.default)(Flag, "defaultProps", {
    as: "i"
});
(0, _definePropertyDefault.default)(Flag, "handledProps", [
    "as",
    "className",
    "name"
]);
Flag.propTypes = {};
Flag.create = (0, _lib.createShorthandFactory)(Flag, function(value) {
    return {
        name: value
    };
});
exports.default = Flag;

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/defineProperty":"djTAw","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"91b6B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _headerDefault.default));
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);

},{"./Header":"2U0WY","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2U0WY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _icon = require("../../elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _image = require("../../elements/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _headerSubheader = require("./HeaderSubheader");
var _headerSubheaderDefault = parcelHelpers.interopDefault(_headerSubheader);
var _headerContent = require("./HeaderContent");
var _headerContentDefault = parcelHelpers.interopDefault(_headerContent);
/**
 * A header provides a short summary of content
 */ function Header(props) {
    var attached = props.attached, block = props.block, children = props.children, className = props.className, color = props.color, content = props.content, disabled = props.disabled, dividing = props.dividing, floated = props.floated, icon = props.icon, image = props.image, inverted = props.inverted, size = props.size, sub = props.sub, subheader = props.subheader, textAlign = props.textAlign;
    var classes = (0, _classnamesDefault.default)("ui", color, size, (0, _lib.useKeyOnly)(block, "block"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(dividing, "dividing"), (0, _lib.useValueAndKey)(floated, "floated"), (0, _lib.useKeyOnly)(icon === true, "icon"), (0, _lib.useKeyOnly)(image === true, "image"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(sub, "sub"), (0, _lib.useKeyOrValueAndKey)(attached, "attached"), (0, _lib.useTextAlignProp)(textAlign), "header", className);
    var rest = (0, _lib.getUnhandledProps)(Header, props);
    var ElementType = (0, _lib.getElementType)(Header, props);
    if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
    var iconElement = (0, _iconDefault.default).create(icon, {
        autoGenerateKey: false
    });
    var imageElement = (0, _imageDefault.default).create(image, {
        autoGenerateKey: false
    });
    var subheaderElement = (0, _headerSubheaderDefault.default).create(subheader, {
        autoGenerateKey: false
    });
    if (iconElement || imageElement) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), iconElement || imageElement, (content || subheaderElement) && (0, _reactDefault.default).createElement((0, _headerContentDefault.default), null, content, subheaderElement));
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), content, subheaderElement);
}
Header.handledProps = [
    "as",
    "attached",
    "block",
    "children",
    "className",
    "color",
    "content",
    "disabled",
    "dividing",
    "floated",
    "icon",
    "image",
    "inverted",
    "size",
    "sub",
    "subheader",
    "textAlign"
];
Header.propTypes = {};
Header.Content = (0, _headerContentDefault.default);
Header.Subheader = (0, _headerSubheaderDefault.default);
exports.default = Header;

},{"@babel/runtime/helpers/extends":"l6HRm","lodash/without":"8BeqI","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../elements/Icon":"dUMma","../../elements/Image":"bBmlq","./HeaderSubheader":"4e8t4","./HeaderContent":"6gVnh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bBmlq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _imageDefault.default));
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);

},{"./Image":"b2gk5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4e8t4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * Headers may contain subheaders.
 */ function HeaderSubheader(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, _classnamesDefault.default)("sub header", className);
    var rest = (0, _lib.getUnhandledProps)(HeaderSubheader, props);
    var ElementType = (0, _lib.getElementType)(HeaderSubheader, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
HeaderSubheader.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
HeaderSubheader.propTypes = {};
HeaderSubheader.create = (0, _lib.createShorthandFactory)(HeaderSubheader, function(content) {
    return {
        content: content
    };
});
exports.default = HeaderSubheader;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6gVnh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * Header content wraps the main content when there is an adjacent Icon or Image.
 */ function HeaderContent(props) {
    var children = props.children, className = props.className, content = props.content;
    var classes = (0, _classnamesDefault.default)("content", className);
    var rest = (0, _lib.getUnhandledProps)(HeaderContent, props);
    var ElementType = (0, _lib.getElementType)(HeaderContent, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
HeaderContent.handledProps = [
    "as",
    "children",
    "className",
    "content"
];
HeaderContent.propTypes = {};
exports.default = HeaderContent;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gilpf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _labelDefault.default));
var _label = require("./Label");
var _labelDefault = parcelHelpers.interopDefault(_label);

},{"./Label":"h3wMW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aE2R1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _loaderDefault.default));
var _loader = require("./Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);

},{"./Loader":"aDksa","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aDksa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A loader alerts a user to wait for an activity to complete.
 * @see Dimmer
 */ function Loader(props) {
    var active = props.active, children = props.children, className = props.className, content = props.content, disabled = props.disabled, indeterminate = props.indeterminate, inline = props.inline, inverted = props.inverted, size = props.size;
    var classes = (0, _classnamesDefault.default)("ui", size, (0, _lib.useKeyOnly)(active, "active"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(indeterminate, "indeterminate"), (0, _lib.useKeyOnly)(inverted, "inverted"), (0, _lib.useKeyOnly)(children || content, "text"), (0, _lib.useKeyOrValueAndKey)(inline, "inline"), "loader", className);
    var rest = (0, _lib.getUnhandledProps)(Loader, props);
    var ElementType = (0, _lib.getElementType)(Loader, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
Loader.handledProps = [
    "active",
    "as",
    "children",
    "className",
    "content",
    "disabled",
    "indeterminate",
    "inline",
    "inverted",
    "size"
];
Loader.propTypes = {};
exports.default = Loader;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iE3eZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dropdownDefault.default));
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);

},{"./Dropdown":"cY1GB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cY1GB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dropdown);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread = require("@babel/runtime/helpers/objectSpread");
var _objectSpreadDefault = parcelHelpers.interopDefault(_objectSpread);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _get = require("@babel/runtime/helpers/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _compact = require("lodash/compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _map = require("lodash/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _findIndex = require("lodash/findIndex");
var _findIndexDefault = parcelHelpers.interopDefault(_findIndex);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _reduce = require("lodash/reduce");
var _reduceDefault = parcelHelpers.interopDefault(_reduce);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _escapeRegExp = require("lodash/escapeRegExp");
var _escapeRegExpDefault = parcelHelpers.interopDefault(_escapeRegExp);
var _deburr = require("lodash/deburr");
var _deburrDefault = parcelHelpers.interopDefault(_deburr);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _filter = require("lodash/filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _dropRight = require("lodash/dropRight");
var _dropRightDefault = parcelHelpers.interopDefault(_dropRight);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _size = require("lodash/size");
var _sizeDefault = parcelHelpers.interopDefault(_size);
var _union = require("lodash/union");
var _unionDefault = parcelHelpers.interopDefault(_union);
var _get1 = require("lodash/get");
var _getDefault1 = parcelHelpers.interopDefault(_get1);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _keyboardKey = require("keyboard-key");
var _keyboardKeyDefault = parcelHelpers.interopDefault(_keyboardKey);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _lib = require("../../lib");
var _icon = require("../../elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _label = require("../../elements/Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownSearchInput = require("./DropdownSearchInput");
var _dropdownSearchInputDefault = parcelHelpers.interopDefault(_dropdownSearchInput);
var getKeyOrValue = function getKeyOrValue(key, value) {
    return (0, _isNilDefault.default)(key) ? value : key;
};
/**
 * A dropdown allows a user to select a value from a series of options.
 * @see Form
 * @see Select
 * @see Menu
 */ var Dropdown = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Dropdown, _Component);
    function Dropdown() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, Dropdown);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(Dropdown)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleChange", function(e, value) {
            (0, _invokeDefault.default)(_this.props, "onChange", e, (0, _objectSpreadDefault.default)({}, _this.props, {
                value: value
            }));
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "closeOnChange", function(e) {
            var _this$props = _this.props, closeOnChange = _this$props.closeOnChange, multiple = _this$props.multiple;
            var shouldClose = (0, _isUndefinedDefault.default)(closeOnChange) ? !multiple : closeOnChange;
            if (shouldClose) _this.close(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "closeOnEscape", function(e) {
            if ((0, _keyboardKeyDefault.default).getCode(e) !== (0, _keyboardKeyDefault.default).Escape) return;
            e.preventDefault();
            _this.close();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "moveSelectionOnKeyDown", function(e) {
            var _moves;
            var _this$props2 = _this.props, multiple = _this$props2.multiple, selectOnNavigation = _this$props2.selectOnNavigation;
            var moves = (_moves = {}, (0, _definePropertyDefault.default)(_moves, (0, _keyboardKeyDefault.default).ArrowDown, 1), (0, _definePropertyDefault.default)(_moves, (0, _keyboardKeyDefault.default).ArrowUp, -1), _moves);
            var move = moves[(0, _keyboardKeyDefault.default).getCode(e)];
            if (move === undefined) return;
            e.preventDefault();
            _this.moveSelectionBy(move);
            if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "openOnSpace", function(e) {
            if ((0, _keyboardKeyDefault.default).getCode(e) !== (0, _keyboardKeyDefault.default).Spacebar) return;
            if (_this.state.open) return;
            e.preventDefault();
            _this.open(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "openOnArrow", function(e) {
            var code = (0, _keyboardKeyDefault.default).getCode(e);
            if (!(0, _includesDefault.default)([
                (0, _keyboardKeyDefault.default).ArrowDown,
                (0, _keyboardKeyDefault.default).ArrowUp
            ], code)) return;
            if (_this.state.open) return;
            e.preventDefault();
            _this.open(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "makeSelectedItemActive", function(e) {
            var open = _this.state.open;
            var multiple = _this.props.multiple;
            var item = _this.getSelectedItem();
            var value = (0, _getDefault1.default)(item, "value"); // prevent selecting null if there was no selected item value
            // prevent selecting duplicate items when the dropdown is closed
            if ((0, _isNilDefault.default)(value) || !open) return; // state value may be undefined
            var newValue = multiple ? (0, _unionDefault.default)(_this.state.value, [
                value
            ]) : value; // notify the onChange prop that the user is trying to change value
            _this.setValue(newValue);
            _this.setSelectedIndex(newValue);
            _this.handleChange(e, newValue); // Heads up! This event handler should be called after `onChange`
            // Notify the onAddItem prop if this is a new value
            if (item["data-additional"]) (0, _invokeDefault.default)(_this.props, "onAddItem", e, (0, _objectSpreadDefault.default)({}, _this.props, {
                value: value
            }));
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "selectItemOnEnter", function(e) {
            var search = _this.props.search;
            if ((0, _keyboardKeyDefault.default).getCode(e) !== (0, _keyboardKeyDefault.default).Enter) return;
            e.preventDefault();
            var optionSize = (0, _sizeDefault.default)(_this.getMenuOptions());
            if (search && optionSize === 0) return;
            _this.makeSelectedItemActive(e);
            _this.closeOnChange(e);
            _this.clearSearchQuery();
            if (search && _this.searchRef) _this.searchRef.focus();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "removeItemOnBackspace", function(e) {
            var _this$props3 = _this.props, multiple = _this$props3.multiple, search = _this$props3.search;
            var _this$state = _this.state, searchQuery = _this$state.searchQuery, value = _this$state.value;
            if ((0, _keyboardKeyDefault.default).getCode(e) !== (0, _keyboardKeyDefault.default).Backspace) return;
            if (searchQuery || !search || !multiple || (0, _isEmptyDefault.default)(value)) return;
            e.preventDefault(); // remove most recent value
            var newValue = (0, _dropRightDefault.default)(value);
            _this.setValue(newValue);
            _this.setSelectedIndex(newValue);
            _this.handleChange(e, newValue);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "closeOnDocumentClick", function(e) {
            if (!_this.props.closeOnBlur) return; // If event happened in the dropdown, ignore it
            if (_this.ref && (0, _lib.doesNodeContainClick)(_this.ref, e)) return;
            _this.close();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "attachHandlersOnOpen", function() {
            (0, _lib.eventStack).sub("keydown", [
                _this.closeOnEscape,
                _this.moveSelectionOnKeyDown,
                _this.selectItemOnEnter,
                _this.removeItemOnBackspace
            ]);
            (0, _lib.eventStack).sub("click", _this.closeOnDocumentClick);
            (0, _lib.eventStack).unsub("keydown", [
                _this.openOnArrow,
                _this.openOnSpace
            ]);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleMouseDown", function(e) {
            _this.isMouseDown = true;
            (0, _lib.eventStack).sub("mouseup", _this.handleDocumentMouseUp);
            (0, _invokeDefault.default)(_this.props, "onMouseDown", e, _this.props);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleDocumentMouseUp", function() {
            _this.isMouseDown = false;
            (0, _lib.eventStack).unsub("mouseup", _this.handleDocumentMouseUp);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleClick", function(e) {
            var _this$props4 = _this.props, minCharacters = _this$props4.minCharacters, search = _this$props4.search;
            var _this$state2 = _this.state, open = _this$state2.open, searchQuery = _this$state2.searchQuery;
            (0, _invokeDefault.default)(_this.props, "onClick", e, _this.props); // prevent closeOnDocumentClick()
            e.stopPropagation();
            if (!search) return _this.toggle(e);
            if (open) return;
            if (searchQuery.length >= minCharacters || minCharacters === 1) {
                _this.open(e);
                return;
            }
            if (_this.searchRef) _this.searchRef.focus();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleIconClick", function(e) {
            var clearable = _this.props.clearable;
            var hasValue = _this.hasValue();
            (0, _invokeDefault.default)(_this.props, "onClick", e, _this.props); // prevent handleClick()
            e.stopPropagation();
            if (clearable && hasValue) _this.clearValue(e);
            else _this.toggle(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleItemClick", function(e, item) {
            var _this$props5 = _this.props, multiple = _this$props5.multiple, search = _this$props5.search;
            var value = item.value; // prevent toggle() in handleClick()
            e.stopPropagation(); // prevent closeOnDocumentClick() if multiple or item is disabled
            if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
            if (item.disabled) return;
            var isAdditionItem = item["data-additional"];
            var newValue = multiple ? (0, _unionDefault.default)(_this.state.value, [
                value
            ]) : value; // notify the onChange prop that the user is trying to change value
            _this.setValue(newValue);
            _this.setSelectedIndex(value);
            _this.clearSearchQuery();
            _this.handleChange(e, newValue);
            _this.closeOnChange(e); // Heads up! This event handler should be called after `onChange`
            // Notify the onAddItem prop if this is a new value
            if (isAdditionItem) (0, _invokeDefault.default)(_this.props, "onAddItem", e, (0, _objectSpreadDefault.default)({}, _this.props, {
                value: value
            }));
            if (multiple && search && _this.searchRef) _this.searchRef.focus();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleFocus", function(e) {
            var focus = _this.state.focus;
            if (focus) return;
            (0, _invokeDefault.default)(_this.props, "onFocus", e, _this.props);
            _this.setState({
                focus: true
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleBlur", function(e) {
            // Heads up! Don't remove this.
            // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
            var currentTarget = (0, _getDefault1.default)(e, "currentTarget");
            if (currentTarget && currentTarget.contains(document.activeElement)) return;
            var _this$props6 = _this.props, closeOnBlur = _this$props6.closeOnBlur, multiple = _this$props6.multiple, selectOnBlur = _this$props6.selectOnBlur; // do not "blur" when the mouse is down inside of the Dropdown
            if (_this.isMouseDown) return;
            (0, _invokeDefault.default)(_this.props, "onBlur", e, _this.props);
            if (selectOnBlur && !multiple) {
                _this.makeSelectedItemActive(e);
                if (closeOnBlur) _this.close();
            }
            _this.setState({
                focus: false
            });
            _this.clearSearchQuery();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleSearchChange", function(e, _ref) {
            var value = _ref.value;
            // prevent propagating to this.props.onChange()
            e.stopPropagation();
            var minCharacters = _this.props.minCharacters;
            var open = _this.state.open;
            var newQuery = value;
            (0, _invokeDefault.default)(_this.props, "onSearchChange", e, (0, _objectSpreadDefault.default)({}, _this.props, {
                searchQuery: newQuery
            }));
            _this.trySetState({
                searchQuery: newQuery
            }, {
                selectedIndex: 0
            }); // open search dropdown on search query
            if (!open && newQuery.length >= minCharacters) {
                _this.open();
                return;
            } // close search dropdown if search query is too small
            if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getKeyAndValues", function(options) {
            return options ? options.map(function(option) {
                return (0, _pickDefault.default)(option, [
                    "key",
                    "value"
                ]);
            }) : options;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getMenuOptions", function() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
            var _this$props7 = _this.props, additionLabel = _this$props7.additionLabel, additionPosition = _this$props7.additionPosition, allowAdditions = _this$props7.allowAdditions, deburr = _this$props7.deburr, multiple = _this$props7.multiple, search = _this$props7.search;
            var searchQuery = _this.state.searchQuery;
            var filteredOptions = options; // filter out active options
            if (multiple) filteredOptions = (0, _filterDefault.default)(filteredOptions, function(opt) {
                return !(0, _includesDefault.default)(value, opt.value);
            });
             // filter by search query
            if (search && searchQuery) {
                if ((0, _isFunctionDefault.default)(search)) filteredOptions = search(filteredOptions, searchQuery);
                else {
                    // remove diacritics on search input and options, if deburr prop is set
                    var strippedQuery = deburr ? (0, _deburrDefault.default)(searchQuery) : searchQuery;
                    var re = new RegExp((0, _escapeRegExpDefault.default)(strippedQuery), "i");
                    filteredOptions = (0, _filterDefault.default)(filteredOptions, function(opt) {
                        return re.test(deburr ? (0, _deburrDefault.default)(opt.text) : opt.text);
                    });
                }
            } // insert the "add" item
            if (allowAdditions && search && searchQuery && !(0, _someDefault.default)(filteredOptions, {
                text: searchQuery
            })) {
                var additionLabelElement = (0, _reactDefault.default).isValidElement(additionLabel) ? (0, _reactDefault.default).cloneElement(additionLabel, {
                    key: "addition-label"
                }) : additionLabel || "";
                var addItem = {
                    key: "addition",
                    // by using an array, we can pass multiple elements, but when doing so
                    // we must specify a `key` for React to know which one is which
                    text: [
                        additionLabelElement,
                        (0, _reactDefault.default).createElement("b", {
                            key: "addition-query"
                        }, searchQuery)
                    ],
                    value: searchQuery,
                    className: "addition",
                    "data-additional": true
                };
                if (additionPosition === "top") filteredOptions.unshift(addItem);
                else filteredOptions.push(addItem);
            }
            return filteredOptions;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getSelectedItem", function() {
            var selectedIndex = _this.state.selectedIndex;
            var options = _this.getMenuOptions();
            return (0, _getDefault1.default)(options, "[".concat(selectedIndex, "]"));
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getEnabledIndices", function(givenOptions) {
            var options = givenOptions || _this.getMenuOptions();
            return (0, _reduceDefault.default)(options, function(memo, item, index) {
                if (!item.disabled) memo.push(index);
                return memo;
            }, []);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getItemByValue", function(value) {
            var options = _this.props.options;
            return (0, _findDefault.default)(options, {
                value: value
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getMenuItemIndexByValue", function(value, givenOptions) {
            var options = givenOptions || _this.getMenuOptions();
            return (0, _findIndexDefault.default)(options, [
                "value",
                value
            ]);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getDropdownAriaOptions", function() {
            var _this$props8 = _this.props, loading = _this$props8.loading, disabled = _this$props8.disabled, search = _this$props8.search, multiple = _this$props8.multiple;
            var open = _this.state.open;
            var ariaOptions = {
                role: search ? "combobox" : "listbox",
                "aria-busy": loading,
                "aria-disabled": disabled,
                "aria-expanded": !!open
            };
            if (ariaOptions.role === "listbox") ariaOptions["aria-multiselectable"] = multiple;
            return ariaOptions;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "clearSearchQuery", function() {
            _this.trySetState({
                searchQuery: ""
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setValue", function(value) {
            _this.trySetState({
                value: value
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setSelectedIndex", function() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
            var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
            var multiple = _this.props.multiple;
            var selectedIndex = _this.state.selectedIndex;
            var options = _this.getMenuOptions(value, optionsProps);
            var enabledIndicies = _this.getEnabledIndices(options);
            var newSelectedIndex; // update the selected index
            if (!selectedIndex || selectedIndex < 0) {
                var firstIndex = enabledIndicies[0]; // Select the currently active item, if none, use the first item.
                // Multiple selects remove active items from the list,
                // their initial selected index should be 0.
                newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
            } else if (multiple) // multiple selects remove options from the menu as they are made active
            // keep the selected index within range of the remaining items
            {
                if (selectedIndex >= options.length - 1) newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
            } else {
                var activeIndex = _this.getMenuItemIndexByValue(value, options); // regular selects can only have one active item
                // set the selected index to the currently active item
                newSelectedIndex = (0, _includesDefault.default)(enabledIndicies, activeIndex) ? activeIndex : undefined;
            }
            if (!newSelectedIndex || newSelectedIndex < 0) newSelectedIndex = enabledIndicies[0];
            _this.setState({
                selectedIndex: newSelectedIndex
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleLabelClick", function(e, labelProps) {
            // prevent focusing search input on click
            e.stopPropagation();
            _this.setState({
                selectedLabel: labelProps.value
            });
            (0, _invokeDefault.default)(_this.props, "onLabelClick", e, labelProps);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleLabelRemove", function(e, labelProps) {
            // prevent focusing search input on click
            e.stopPropagation();
            var value = _this.state.value;
            var newValue = (0, _withoutDefault.default)(value, labelProps.value);
            _this.setValue(newValue);
            _this.setSelectedIndex(newValue);
            _this.handleChange(e, newValue);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "moveSelectionBy", function(offset) {
            var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;
            var options = _this.getMenuOptions(); // Prevent infinite loop
            // TODO: remove left part of condition after children API will be removed
            if (options === undefined || (0, _everyDefault.default)(options, "disabled")) return;
            var lastIndex = options.length - 1;
            var wrapSelection = _this.props.wrapSelection; // next is after last, wrap to beginning
            // next is before first, wrap to end
            var nextIndex = startIndex + offset; // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change
            if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) nextIndex = startIndex;
            else if (nextIndex > lastIndex) nextIndex = 0;
            else if (nextIndex < 0) nextIndex = lastIndex;
            if (options[nextIndex].disabled) {
                _this.moveSelectionBy(offset, nextIndex);
                return;
            }
            _this.setState({
                selectedIndex: nextIndex
            });
            _this.scrollSelectedItemIntoView();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleIconOverrides", function(predefinedProps) {
            var clearable = _this.props.clearable;
            var classes = (0, _classnamesDefault.default)(clearable && _this.hasValue() && "clear", predefinedProps.className);
            return {
                className: classes,
                onClick: function onClick(e) {
                    (0, _invokeDefault.default)(predefinedProps, "onClick", e, predefinedProps);
                    _this.handleIconClick(e);
                }
            };
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleSearchRef", function(c) {
            return _this.searchRef = c;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleSizerRef", function(c) {
            return _this.sizerRef = c;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleRef", function(c) {
            return _this.ref = c;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "clearValue", function(e) {
            var multiple = _this.props.multiple;
            var newValue = multiple ? [] : "";
            _this.setValue(newValue);
            _this.setSelectedIndex(newValue);
            _this.handleChange(e, newValue);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "computeSearchInputTabIndex", function() {
            var _this$props9 = _this.props, disabled = _this$props9.disabled, tabIndex = _this$props9.tabIndex;
            if (!(0, _isNilDefault.default)(tabIndex)) return tabIndex;
            return disabled ? -1 : 0;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "computeSearchInputWidth", function() {
            var searchQuery = _this.state.searchQuery;
            if (_this.sizerRef && searchQuery) {
                // resize the search input, temporarily show the sizer so we can measure it
                _this.sizerRef.style.display = "inline";
                _this.sizerRef.textContent = searchQuery;
                var searchWidth = Math.ceil(_this.sizerRef.getBoundingClientRect().width);
                _this.sizerRef.style.removeProperty("display");
                return searchWidth;
            }
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "computeTabIndex", function() {
            var _this$props10 = _this.props, disabled = _this$props10.disabled, search = _this$props10.search, tabIndex = _this$props10.tabIndex; // don't set a root node tabIndex as the search input has its own tabIndex
            if (search) return undefined;
            if (disabled) return -1;
            return (0, _isNilDefault.default)(tabIndex) ? 0 : tabIndex;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleSearchInputOverrides", function(predefinedProps) {
            return {
                onChange: function onChange(e, inputProps) {
                    (0, _invokeDefault.default)(predefinedProps, "onChange", e, inputProps);
                    _this.handleSearchChange(e, inputProps);
                }
            };
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "hasValue", function() {
            var multiple = _this.props.multiple;
            var value = _this.state.value;
            return multiple ? !(0, _isEmptyDefault.default)(value) : !(0, _isNilDefault.default)(value) && value !== "";
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "scrollSelectedItemIntoView", function() {
            if (!_this.ref) return;
            var menu = _this.ref.querySelector(".menu.visible");
            if (!menu) return;
            var item = menu.querySelector(".item.selected");
            if (!item) return;
            var isOutOfUpperView = item.offsetTop < menu.scrollTop;
            var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
            if (isOutOfUpperView) menu.scrollTop = item.offsetTop;
            else if (isOutOfLowerView) // eslint-disable-next-line no-mixed-operators
            menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setOpenDirection", function() {
            if (!_this.ref) return;
            var menu = _this.ref.querySelector(".menu.visible");
            if (!menu) return;
            var dropdownRect = _this.ref.getBoundingClientRect();
            var menuHeight = menu.clientHeight;
            var spaceAtTheBottom = document.documentElement.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight;
            var spaceAtTheTop = dropdownRect.top - menuHeight;
            var upward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom; // set state only if there's a relevant difference
            if (!upward !== !_this.state.upward) _this.trySetState({
                upward: upward
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "open", function(e) {
            var _this$props11 = _this.props, disabled = _this$props11.disabled, open = _this$props11.open, search = _this$props11.search;
            if (disabled) return;
            if (search && _this.searchRef) _this.searchRef.focus();
            (0, _invokeDefault.default)(_this.props, "onOpen", e, _this.props);
            _this.trySetState({
                open: true
            });
            _this.scrollSelectedItemIntoView();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "close", function(e) {
            var open = _this.state.open;
            if (open) {
                (0, _invokeDefault.default)(_this.props, "onClose", e, _this.props);
                _this.trySetState({
                    open: false
                });
            }
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleClose", function() {
            var hasSearchFocus = document.activeElement === _this.searchRef;
            var hasDropdownFocus = document.activeElement === _this.ref;
            var hasFocus = hasSearchFocus || hasDropdownFocus; // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
            // Blur the Dropdown on close so it is blurred after selecting an item.
            // This is to prevent it from re-opening when switching tabs after selecting an item.
            if (!hasSearchFocus) _this.ref.blur();
             // We need to keep the virtual model in sync with the browser focus change
            // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
            _this.setState({
                focus: hasFocus
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "toggle", function(e) {
            return _this.state.open ? _this.close(e) : _this.open(e);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "renderText", function() {
            var _this$props12 = _this.props, multiple = _this$props12.multiple, placeholder = _this$props12.placeholder, search = _this$props12.search, text = _this$props12.text;
            var _this$state3 = _this.state, searchQuery = _this$state3.searchQuery, value = _this$state3.value, open = _this$state3.open;
            var hasValue = _this.hasValue();
            var classes = (0, _classnamesDefault.default)(placeholder && !hasValue && "default", "text", search && searchQuery && "filtered");
            var _text = placeholder;
            if (searchQuery) _text = null;
            else if (text) _text = text;
            else if (open && !multiple) _text = (0, _getDefault1.default)(_this.getSelectedItem(), "text");
            else if (hasValue) _text = (0, _getDefault1.default)(_this.getItemByValue(value), "text");
            return (0, _reactDefault.default).createElement("div", {
                className: classes,
                role: "alert",
                "aria-live": "polite"
            }, _text);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "renderSearchInput", function() {
            var _this$props13 = _this.props, search = _this$props13.search, searchInput = _this$props13.searchInput;
            var searchQuery = _this.state.searchQuery;
            if (!search) return null;
            return (0, _dropdownSearchInputDefault.default).create(searchInput, {
                defaultProps: {
                    inputRef: _this.handleSearchRef,
                    style: {
                        width: _this.computeSearchInputWidth()
                    },
                    tabIndex: _this.computeSearchInputTabIndex(),
                    value: searchQuery
                },
                overrideProps: _this.handleSearchInputOverrides
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "renderSearchSizer", function() {
            var _this$props14 = _this.props, search = _this$props14.search, multiple = _this$props14.multiple;
            if (!(search && multiple)) return null;
            return (0, _reactDefault.default).createElement("span", {
                className: "sizer",
                ref: _this.handleSizerRef
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "renderLabels", function() {
            var _this$props15 = _this.props, multiple = _this$props15.multiple, renderLabel = _this$props15.renderLabel;
            var _this$state4 = _this.state, selectedLabel = _this$state4.selectedLabel, value = _this$state4.value;
            if (!multiple || (0, _isEmptyDefault.default)(value)) return;
            var selectedItems = (0, _mapDefault.default)(value, _this.getItemByValue);
            // if no item could be found for a given state value the selected item will be undefined
            // compact the selectedItems so we only have actual objects left
            return (0, _mapDefault.default)((0, _compactDefault.default)(selectedItems), function(item, index) {
                var defaultProps = {
                    active: item.value === selectedLabel,
                    as: "a",
                    key: getKeyOrValue(item.key, item.value),
                    onClick: _this.handleLabelClick,
                    onRemove: _this.handleLabelRemove,
                    value: item.value
                };
                return (0, _labelDefault.default).create(renderLabel(item, index, defaultProps), {
                    defaultProps: defaultProps
                });
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "renderOptions", function() {
            var _this$props16 = _this.props, lazyLoad = _this$props16.lazyLoad, multiple = _this$props16.multiple, search = _this$props16.search, noResultsMessage = _this$props16.noResultsMessage;
            var _this$state5 = _this.state, open = _this$state5.open, selectedIndex = _this$state5.selectedIndex, value = _this$state5.value; // lazy load, only render options when open
            if (lazyLoad && !open) return null;
            var options = _this.getMenuOptions();
            if (noResultsMessage !== null && search && (0, _isEmptyDefault.default)(options)) return (0, _reactDefault.default).createElement("div", {
                className: "message"
            }, noResultsMessage);
            var isActive = multiple ? function(optValue) {
                return (0, _includesDefault.default)(value, optValue);
            } : function(optValue) {
                return optValue === value;
            };
            return (0, _mapDefault.default)(options, function(opt, i) {
                return (0, _dropdownItemDefault.default).create((0, _objectSpreadDefault.default)({
                    active: isActive(opt.value),
                    onClick: _this.handleItemClick,
                    selected: selectedIndex === i
                }, opt, {
                    key: getKeyOrValue(opt.key, opt.value),
                    // Needed for handling click events on disabled items
                    style: (0, _objectSpreadDefault.default)({}, opt.style, {
                        pointerEvents: "all"
                    })
                }));
            });
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "renderMenu", function() {
            var _this$props17 = _this.props, children = _this$props17.children, direction = _this$props17.direction, header = _this$props17.header;
            var open = _this.state.open;
            var ariaOptions = _this.getDropdownMenuAriaOptions(); // single menu child
            if (!(0, _lib.childrenUtils).isNil(children)) {
                var menuChild = (0, _react.Children).only(children);
                var className = (0, _classnamesDefault.default)(direction, (0, _lib.useKeyOnly)(open, "visible"), menuChild.props.className);
                return (0, _react.cloneElement)(menuChild, (0, _objectSpreadDefault.default)({
                    className: className
                }, ariaOptions));
            }
            return (0, _reactDefault.default).createElement((0, _dropdownMenuDefault.default), (0, _extendsDefault.default)({}, ariaOptions, {
                direction: direction,
                open: open
            }), (0, _dropdownHeaderDefault.default).create(header, {
                autoGenerateKey: false
            }), _this.renderOptions());
        });
        return _this;
    }
    (0, _createClassDefault.default)(Dropdown, [
        {
            key: "getInitialAutoControlledState",
            value: function getInitialAutoControlledState() {
                return {
                    searchQuery: ""
                };
            }
        },
        {
            key: "componentWillMount",
            value: function componentWillMount() {
                var _this$state6 = this.state, open = _this$state6.open, value = _this$state6.value;
                this.setValue(value);
                this.setSelectedIndex(value);
                if (open) {
                    this.open();
                    this.attachHandlersOnOpen();
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                (0, _getDefault.default)((0, _getPrototypeOfDefault.default)(Dropdown.prototype), "componentWillReceiveProps", this).call(this, nextProps);
                var isNextValueArray, hasValue;
                /* eslint-enable no-console */ if (!(0, _shallowequalDefault.default)(nextProps.value, this.props.value)) {
                    this.setValue(nextProps.value);
                    this.setSelectedIndex(nextProps.value);
                } // The selected index is only dependent on option keys/values.
                // We only check those properties to avoid recursive performance impacts.
                // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000
                if (!(0, _isEqualDefault.default)(this.getKeyAndValues(nextProps.options), this.getKeyAndValues(this.props.options))) this.setSelectedIndex(undefined, nextProps.options);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return !(0, _shallowequalDefault.default)(nextProps, this.props) || !(0, _shallowequalDefault.default)(nextState, this.state);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // eslint-disable-line complexity
                // focused / blurred
                if (!prevState.focus && this.state.focus) {
                    if (!this.isMouseDown) {
                        var _this$props18 = this.props, minCharacters = _this$props18.minCharacters, openOnFocus = _this$props18.openOnFocus, search = _this$props18.search;
                        var openable = !search || search && minCharacters === 1 && !this.state.open;
                        if (openOnFocus && openable) this.open();
                    }
                    if (!this.state.open) (0, _lib.eventStack).sub("keydown", [
                        this.openOnArrow,
                        this.openOnSpace
                    ]);
                    else (0, _lib.eventStack).sub("keydown", [
                        this.moveSelectionOnKeyDown,
                        this.selectItemOnEnter
                    ]);
                    (0, _lib.eventStack).sub("keydown", this.removeItemOnBackspace);
                } else if (prevState.focus && !this.state.focus) {
                    var closeOnBlur = this.props.closeOnBlur;
                    if (!this.isMouseDown && closeOnBlur) this.close();
                    (0, _lib.eventStack).unsub("keydown", [
                        this.openOnArrow,
                        this.openOnSpace,
                        this.moveSelectionOnKeyDown,
                        this.selectItemOnEnter,
                        this.removeItemOnBackspace
                    ]);
                } // opened / closed
                if (!prevState.open && this.state.open) {
                    this.attachHandlersOnOpen();
                    this.setOpenDirection();
                    this.scrollSelectedItemIntoView();
                } else if (prevState.open && !this.state.open) {
                    this.handleClose();
                    (0, _lib.eventStack).unsub("keydown", [
                        this.closeOnEscape,
                        this.moveSelectionOnKeyDown,
                        this.selectItemOnEnter
                    ]);
                    (0, _lib.eventStack).unsub("click", this.closeOnDocumentClick);
                    if (!this.state.focus) (0, _lib.eventStack).unsub("keydown", this.removeItemOnBackspace);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, _lib.eventStack).unsub("keydown", [
                    this.openOnArrow,
                    this.openOnSpace,
                    this.moveSelectionOnKeyDown,
                    this.selectItemOnEnter,
                    this.removeItemOnBackspace,
                    this.closeOnEscape
                ]);
                (0, _lib.eventStack).unsub("click", this.closeOnDocumentClick);
            } // ----------------------------------------
        },
        {
            key: "getDropdownMenuAriaOptions",
            value: function getDropdownMenuAriaOptions() {
                var _this$props19 = this.props, search = _this$props19.search, multiple = _this$props19.multiple;
                var ariaOptions = {};
                if (search) {
                    ariaOptions["aria-multiselectable"] = multiple;
                    ariaOptions.role = "listbox";
                }
                return ariaOptions;
            } // ----------------------------------------
        },
        {
            key: "render",
            value: function render() {
                var _this$props20 = this.props, basic = _this$props20.basic, button = _this$props20.button, className = _this$props20.className, compact = _this$props20.compact, disabled = _this$props20.disabled, error = _this$props20.error, fluid = _this$props20.fluid, floating = _this$props20.floating, icon = _this$props20.icon, inline = _this$props20.inline, item = _this$props20.item, labeled = _this$props20.labeled, loading = _this$props20.loading, multiple = _this$props20.multiple, pointing = _this$props20.pointing, search = _this$props20.search, selection = _this$props20.selection, scrolling = _this$props20.scrolling, simple = _this$props20.simple, trigger = _this$props20.trigger;
                var _this$state7 = this.state, open = _this$state7.open, upward = _this$state7.upward; // Classes
                var classes = (0, _classnamesDefault.default)("ui", (0, _lib.useKeyOnly)(open, "active visible"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(error, "error"), (0, _lib.useKeyOnly)(loading, "loading"), (0, _lib.useKeyOnly)(basic, "basic"), (0, _lib.useKeyOnly)(button, "button"), (0, _lib.useKeyOnly)(compact, "compact"), (0, _lib.useKeyOnly)(fluid, "fluid"), (0, _lib.useKeyOnly)(floating, "floating"), (0, _lib.useKeyOnly)(inline, "inline"), // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
                // TODO: the icon class is only required when a dropdown is a button
                // useKeyOnly(icon, 'icon'),
                (0, _lib.useKeyOnly)(labeled, "labeled"), (0, _lib.useKeyOnly)(item, "item"), (0, _lib.useKeyOnly)(multiple, "multiple"), (0, _lib.useKeyOnly)(search, "search"), (0, _lib.useKeyOnly)(selection, "selection"), (0, _lib.useKeyOnly)(simple, "simple"), (0, _lib.useKeyOnly)(scrolling, "scrolling"), (0, _lib.useKeyOnly)(upward, "upward"), (0, _lib.useKeyOrValueAndKey)(pointing, "pointing"), "dropdown", className);
                var rest = (0, _lib.getUnhandledProps)(Dropdown, this.props);
                var ElementType = (0, _lib.getElementType)(Dropdown, this.props);
                var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, ariaOptions, {
                    className: classes,
                    onBlur: this.handleBlur,
                    onClick: this.handleClick,
                    onMouseDown: this.handleMouseDown,
                    onFocus: this.handleFocus,
                    onChange: this.handleChange,
                    tabIndex: this.computeTabIndex(),
                    ref: this.handleRef
                }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), trigger || this.renderText(), (0, _iconDefault.default).create(icon, {
                    overrideProps: this.handleIconOverrides,
                    autoGenerateKey: false
                }), this.renderMenu());
            }
        }
    ]);
    return Dropdown;
}((0, _lib.AutoControlledComponent));
(0, _definePropertyDefault.default)(Dropdown, "defaultProps", {
    additionLabel: "Add ",
    additionPosition: "top",
    closeOnBlur: true,
    deburr: false,
    icon: "dropdown",
    minCharacters: 1,
    noResultsMessage: "No results found.",
    openOnFocus: true,
    renderLabel: function renderLabel(_ref2) {
        var text = _ref2.text;
        return text;
    },
    searchInput: "text",
    selectOnBlur: true,
    selectOnNavigation: true,
    wrapSelection: true
});
(0, _definePropertyDefault.default)(Dropdown, "autoControlledProps", [
    "open",
    "searchQuery",
    "selectedLabel",
    "value",
    "upward"
]);
(0, _definePropertyDefault.default)(Dropdown, "Divider", (0, _dropdownDividerDefault.default));
(0, _definePropertyDefault.default)(Dropdown, "Header", (0, _dropdownHeaderDefault.default));
(0, _definePropertyDefault.default)(Dropdown, "Item", (0, _dropdownItemDefault.default));
(0, _definePropertyDefault.default)(Dropdown, "Menu", (0, _dropdownMenuDefault.default));
(0, _definePropertyDefault.default)(Dropdown, "SearchInput", (0, _dropdownSearchInputDefault.default));
(0, _definePropertyDefault.default)(Dropdown, "handledProps", [
    "additionLabel",
    "additionPosition",
    "allowAdditions",
    "as",
    "basic",
    "button",
    "children",
    "className",
    "clearable",
    "closeOnBlur",
    "closeOnChange",
    "compact",
    "deburr",
    "defaultOpen",
    "defaultSearchQuery",
    "defaultSelectedLabel",
    "defaultUpward",
    "defaultValue",
    "direction",
    "disabled",
    "error",
    "floating",
    "fluid",
    "header",
    "icon",
    "inline",
    "item",
    "labeled",
    "lazyLoad",
    "loading",
    "minCharacters",
    "multiple",
    "noResultsMessage",
    "onAddItem",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onLabelClick",
    "onMouseDown",
    "onOpen",
    "onSearchChange",
    "open",
    "openOnFocus",
    "options",
    "placeholder",
    "pointing",
    "renderLabel",
    "scrolling",
    "search",
    "searchInput",
    "searchQuery",
    "selectOnBlur",
    "selectOnNavigation",
    "selectedLabel",
    "selection",
    "simple",
    "tabIndex",
    "text",
    "trigger",
    "upward",
    "value",
    "wrapSelection"
]);
Dropdown.propTypes = {};

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/objectSpread":"9Q79w","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/get":"7tZNY","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/compact":"lta5r","lodash/map":"8CvOZ","lodash/every":"fFwUb","lodash/without":"8BeqI","lodash/findIndex":"cDEeG","lodash/find":"lf7Bf","lodash/reduce":"gsGBO","lodash/some":"gLzPv","lodash/escapeRegExp":"dg4RJ","lodash/deburr":"6mnzW","lodash/isFunction":"cXGEE","lodash/filter":"h5ETC","lodash/pick":"e8B6O","lodash/dropRight":"jsStQ","lodash/isEmpty":"2iSgw","lodash/size":"kAQOl","lodash/union":"ivm8y","lodash/get":"4u8u0","lodash/includes":"havof","lodash/isUndefined":"iGoGN","lodash/invoke":"jRmLc","lodash/isEqual":"6oIYS","lodash/has":"dNPtT","lodash/isNil":"c786m","classnames":"7kXBo","keyboard-key":"3c9ko","prop-types":"kKQPU","react":"6AiW6","shallowequal":"cPQ2O","../../lib":"1RlVA","../../elements/Icon":"dUMma","../../elements/Label":"gilpf","./DropdownDivider":"ksFAy","./DropdownItem":"klQLn","./DropdownHeader":"hWpTt","./DropdownMenu":"eAfLg","./DropdownSearchInput":"e3v0p","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7tZNY":[function(require,module,exports) {
var superPropBase = require("6e537077e7e3a1c2");
function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = _get = function _get(target, property, receiver) {
        var base = superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _get.apply(this, arguments);
}
module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"6e537077e7e3a1c2":"b5OQx"}],"b5OQx":[function(require,module,exports) {
var getPrototypeOf = require("b50b8ab32046070");
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b50b8ab32046070":"4eWPd"}],"lta5r":[function(require,module,exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = compact;

},{}],"fFwUb":[function(require,module,exports) {
var arrayEvery = require("35998aa94ab060f1"), baseEvery = require("44e7ab95f8b26a55"), baseIteratee = require("1d5621a35ca53be0"), isArray = require("e0e4c2e424adb44f"), isIterateeCall = require("2f9b3b0ab0300132");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function every(collection, predicate, guard) {
    var func = isArray(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = every;

},{"35998aa94ab060f1":"gKE2c","44e7ab95f8b26a55":"cxPzq","1d5621a35ca53be0":"1zzIW","e0e4c2e424adb44f":"9om8C","2f9b3b0ab0300132":"9DmJa"}],"gKE2c":[function(require,module,exports) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = arrayEvery;

},{}],"cxPzq":[function(require,module,exports) {
var baseEach = require("88b2ceed9e7ead7a");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = baseEvery;

},{"88b2ceed9e7ead7a":"4KrJl"}],"gsGBO":[function(require,module,exports) {
var arrayReduce = require("8772d9c160085222"), baseEach = require("7c156122a905f02e"), baseIteratee = require("288ce78b1e338692"), baseReduce = require("7941e51212237a70"), isArray = require("b7d00545ad8400ba");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
module.exports = reduce;

},{"8772d9c160085222":"aHy6O","7c156122a905f02e":"4KrJl","288ce78b1e338692":"1zzIW","7941e51212237a70":"4npQW","b7d00545ad8400ba":"9om8C"}],"aHy6O":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"4npQW":[function(require,module,exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = baseReduce;

},{}],"dg4RJ":[function(require,module,exports) {
var toString = require("7612829dde7c7410");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function escapeRegExp(string) {
    string = toString(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
}
module.exports = escapeRegExp;

},{"7612829dde7c7410":"4tAE8"}],"6mnzW":[function(require,module,exports) {
var deburrLetter = require("86c70dfa448b37ae"), toString = require("f68583105b85d455");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
module.exports = deburr;

},{"86c70dfa448b37ae":"17YkD","f68583105b85d455":"4tAE8"}],"17YkD":[function(require,module,exports) {
var basePropertyOf = require("c95029d8b26d3cfc");
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
module.exports = deburrLetter;

},{"c95029d8b26d3cfc":"jqPoW"}],"jqPoW":[function(require,module,exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;

},{}],"e8B6O":[function(require,module,exports) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"es55Q","7f4b4cdb31764f87":"lXQzd"}],"es55Q":[function(require,module,exports) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"gULfx","c697490fd5f67a25":"54LFf"}],"gULfx":[function(require,module,exports) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"7HHv1","b07dbab95dca4167":"5WNvo","64b51364f27b9088":"3DEN3"}],"5WNvo":[function(require,module,exports) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"5AyTU","56e0b8a492d56399":"3DEN3","d1eb8acc5a65dc38":"ebisk","dfb182b16ef275c0":"kDBLt","6a51dc787ca5b6e3":"2ib7q"}],"5AyTU":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"gvCFd","b62ef95b3cf1cde1":"l89hZ"}],"gvCFd":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"a0aUc"}],"lXQzd":[function(require,module,exports) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + "");
}
module.exports = flatRest;

},{"199f7cbd69032298":"bCwOu","aa5c38699e42775a":"1pIhz","6a66c8b3fbd122d5":"5wgE3"}],"jsStQ":[function(require,module,exports) {
var baseSlice = require("5600faecaeddf8c7"), toInteger = require("55ad9a87fc726443");
/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function dropRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    n = guard || n === undefined ? 1 : toInteger(n);
    n = length - n;
    return baseSlice(array, 0, n < 0 ? 0 : n);
}
module.exports = dropRight;

},{"5600faecaeddf8c7":"eZ4Ej","55ad9a87fc726443":"4WHfQ"}],"kAQOl":[function(require,module,exports) {
var baseKeys = require("ae2c189907f81768"), getTag = require("228071a48fe3cd5b"), isArrayLike = require("cea196857d2bb20b"), isString = require("907320fe4c05b89a"), stringSize = require("ce396806053ecbed");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function size(collection) {
    if (collection == null) return 0;
    if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
    var tag = getTag(collection);
    if (tag == mapTag || tag == setTag) return collection.size;
    return baseKeys(collection).length;
}
module.exports = size;

},{"ae2c189907f81768":"RQWOW","228071a48fe3cd5b":"klLMw","cea196857d2bb20b":"5qgKC","907320fe4c05b89a":"3iITv","ce396806053ecbed":"bWhbN"}],"bWhbN":[function(require,module,exports) {
var asciiSize = require("e059612a0c57b006"), hasUnicode = require("47804eb9cd4baae7"), unicodeSize = require("ed6324400286f1de");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
module.exports = stringSize;

},{"e059612a0c57b006":"5IcHb","47804eb9cd4baae7":"kpvsk","ed6324400286f1de":"5BhBC"}],"5IcHb":[function(require,module,exports) {
var baseProperty = require("915f17501141a880");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var asciiSize = baseProperty("length");
module.exports = asciiSize;

},{"915f17501141a880":"cjkUU"}],"kpvsk":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"5BhBC":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while(reUnicode.test(string))++result;
    return result;
}
module.exports = unicodeSize;

},{}],"ivm8y":[function(require,module,exports) {
var baseFlatten = require("4c6a8d1d22b46f1e"), baseRest = require("3c5b68a5bd4cb3c4"), baseUniq = require("d4a39eace292bbe3"), isArrayLikeObject = require("b9956cfd928a69da");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var union = baseRest(function(arrays) {
    return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});
module.exports = union;

},{"4c6a8d1d22b46f1e":"jaR7v","3c5b68a5bd4cb3c4":"cFFHO","d4a39eace292bbe3":"eGMc6","b9956cfd928a69da":"8rrEV"}],"cPQ2O":[function(require,module,exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"ksFAy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A dropdown menu can contain dividers to separate related content.
 */ function DropdownDivider(props) {
    var className = props.className;
    var classes = (0, _classnamesDefault.default)("divider", className);
    var rest = (0, _lib.getUnhandledProps)(DropdownDivider, props);
    var ElementType = (0, _lib.getElementType)(DropdownDivider, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }));
}
DropdownDivider.handledProps = [
    "as",
    "className"
];
DropdownDivider.propTypes = {};
exports.default = DropdownDivider;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"klQLn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _flag = require("../../elements/Flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _icon = require("../../elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _image = require("../../elements/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _label = require("../../elements/Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
/**
 * An item sub-component for Dropdown component.
 */ var DropdownItem = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(DropdownItem, _Component);
    function DropdownItem() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, DropdownItem);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(DropdownItem)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleClick", function(e) {
            var onClick = _this.props.onClick;
            if (onClick) onClick(e, _this.props);
        });
        return _this;
    }
    (0, _createClassDefault.default)(DropdownItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, children = _this$props.children, className = _this$props.className, content = _this$props.content, disabled = _this$props.disabled, description = _this$props.description, flag = _this$props.flag, icon = _this$props.icon, image = _this$props.image, label = _this$props.label, selected = _this$props.selected, text = _this$props.text;
                var classes = (0, _classnamesDefault.default)((0, _lib.useKeyOnly)(active, "active"), (0, _lib.useKeyOnly)(disabled, "disabled"), (0, _lib.useKeyOnly)(selected, "selected"), "item", className); // add default dropdown icon if item contains another menu
                var iconName = (0, _isNilDefault.default)(icon) ? (0, _lib.childrenUtils).someByType(children, "DropdownMenu") && "dropdown" : icon;
                var rest = (0, _lib.getUnhandledProps)(DropdownItem, this.props);
                var ElementType = (0, _lib.getElementType)(DropdownItem, this.props);
                var ariaOptions = {
                    role: "option",
                    "aria-disabled": disabled,
                    "aria-checked": active,
                    "aria-selected": selected
                };
                if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, ariaOptions, {
                    className: classes,
                    onClick: this.handleClick
                }), children);
                var flagElement = (0, _flagDefault.default).create(flag, {
                    autoGenerateKey: false
                });
                var iconElement = (0, _iconDefault.default).create(iconName, {
                    autoGenerateKey: false
                });
                var imageElement = (0, _imageDefault.default).create(image, {
                    autoGenerateKey: false
                });
                var labelElement = (0, _labelDefault.default).create(label, {
                    autoGenerateKey: false
                });
                var descriptionElement = (0, _lib.createShorthand)("span", function(val) {
                    return {
                        children: val
                    };
                }, description, {
                    defaultProps: {
                        className: "description"
                    },
                    autoGenerateKey: false
                });
                var textElement = (0, _lib.createShorthand)("span", function(val) {
                    return {
                        children: val
                    };
                }, (0, _lib.childrenUtils).isNil(content) ? text : content, {
                    defaultProps: {
                        className: "text"
                    },
                    autoGenerateKey: false
                });
                return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, ariaOptions, {
                    className: classes,
                    onClick: this.handleClick
                }), imageElement, iconElement, flagElement, labelElement, descriptionElement, textElement);
            }
        }
    ]);
    return DropdownItem;
}((0, _react.Component));
(0, _definePropertyDefault.default)(DropdownItem, "handledProps", [
    "active",
    "as",
    "children",
    "className",
    "content",
    "description",
    "disabled",
    "flag",
    "icon",
    "image",
    "label",
    "onClick",
    "selected",
    "text",
    "value"
]);
DropdownItem.propTypes = {};
DropdownItem.create = (0, _lib.createShorthandFactory)(DropdownItem, function(opts) {
    return opts;
});
exports.default = DropdownItem;

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/isNil":"c786m","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../elements/Flag":"6wifd","../../elements/Icon":"dUMma","../../elements/Image":"bBmlq","../../elements/Label":"gilpf","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hWpTt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
var _icon = require("../../elements/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
/**
 * A dropdown menu can contain a header.
 */ function DropdownHeader(props) {
    var children = props.children, className = props.className, content = props.content, icon = props.icon;
    var classes = (0, _classnamesDefault.default)("header", className);
    var rest = (0, _lib.getUnhandledProps)(DropdownHeader, props);
    var ElementType = (0, _lib.getElementType)(DropdownHeader, props);
    if (!(0, _lib.childrenUtils).isNil(children)) return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), children);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _iconDefault.default).create(icon, {
        autoGenerateKey: false
    }), content);
}
DropdownHeader.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "icon"
];
DropdownHeader.propTypes = {};
DropdownHeader.create = (0, _lib.createShorthandFactory)(DropdownHeader, function(content) {
    return {
        content: content
    };
});
exports.default = DropdownHeader;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","../../elements/Icon":"dUMma","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eAfLg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A dropdown menu can contain a menu.
 */ function DropdownMenu(props) {
    var children = props.children, className = props.className, content = props.content, direction = props.direction, open = props.open, scrolling = props.scrolling;
    var classes = (0, _classnamesDefault.default)(direction, (0, _lib.useKeyOnly)(open, "visible"), (0, _lib.useKeyOnly)(scrolling, "scrolling"), "menu transition", className);
    var rest = (0, _lib.getUnhandledProps)(DropdownMenu, props);
    var ElementType = (0, _lib.getElementType)(DropdownMenu, props);
    return (0, _reactDefault.default).createElement(ElementType, (0, _extendsDefault.default)({}, rest, {
        className: classes
    }), (0, _lib.childrenUtils).isNil(children) ? content : children);
}
DropdownMenu.handledProps = [
    "as",
    "children",
    "className",
    "content",
    "direction",
    "open",
    "scrolling"
];
DropdownMenu.propTypes = {};
exports.default = DropdownMenu;

},{"@babel/runtime/helpers/extends":"l6HRm","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e3v0p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread = require("@babel/runtime/helpers/objectSpread");
var _objectSpreadDefault = parcelHelpers.interopDefault(_objectSpread);
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");
var _getPrototypeOfDefault = parcelHelpers.interopDefault(_getPrototypeOf);
var _inherits = require("@babel/runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _invoke = require("lodash/invoke");
var _invokeDefault = parcelHelpers.interopDefault(_invoke);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lib = require("../../lib");
/**
 * A search item sub-component for Dropdown component.
 */ var DropdownSearchInput = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(DropdownSearchInput, _Component);
    function DropdownSearchInput() {
        var _getPrototypeOf2;
        var _this;
        (0, _classCallCheckDefault.default)(this, DropdownSearchInput);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, _possibleConstructorReturnDefault.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOfDefault.default)(DropdownSearchInput)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleChange", function(e) {
            var value = (0, _getDefault.default)(e, "target.value");
            (0, _invokeDefault.default)(_this.props, "onChange", e, (0, _objectSpreadDefault.default)({}, _this.props, {
                value: value
            }));
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "handleRef", function(c) {
            (0, _lib.handleRef)(_this.props.inputRef, c);
        });
        return _this;
    }
    (0, _createClassDefault.default)(DropdownSearchInput, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, autoComplete = _this$props.autoComplete, className = _this$props.className, tabIndex = _this$props.tabIndex, type = _this$props.type, value = _this$props.value;
                var classes = (0, _classnamesDefault.default)("search", className);
                var rest = (0, _lib.getUnhandledProps)(DropdownSearchInput, this.props);
                return (0, _reactDefault.default).createElement("input", (0, _extendsDefault.default)({}, rest, {
                    "aria-autocomplete": "list",
                    autoComplete: autoComplete,
                    className: classes,
                    onChange: this.handleChange,
                    ref: this.handleRef,
                    tabIndex: tabIndex,
                    type: type,
                    value: value
                }));
            }
        }
    ]);
    return DropdownSearchInput;
}((0, _react.Component));
(0, _definePropertyDefault.default)(DropdownSearchInput, "defaultProps", {
    autoComplete: "off",
    type: "text"
});
(0, _definePropertyDefault.default)(DropdownSearchInput, "handledProps", [
    "as",
    "autoComplete",
    "className",
    "inputRef",
    "tabIndex",
    "type",
    "value"
]);
DropdownSearchInput.propTypes = {};
DropdownSearchInput.create = (0, _lib.createShorthandFactory)(DropdownSearchInput, function(type) {
    return {
        type: type
    };
});
exports.default = DropdownSearchInput;

},{"@babel/runtime/helpers/extends":"l6HRm","@babel/runtime/helpers/objectSpread":"9Q79w","@babel/runtime/helpers/classCallCheck":"2I6Ai","@babel/runtime/helpers/createClass":"6vj9L","@babel/runtime/helpers/possibleConstructorReturn":"fmNgP","@babel/runtime/helpers/getPrototypeOf":"4eWPd","@babel/runtime/helpers/inherits":"52iuZ","@babel/runtime/helpers/assertThisInitialized":"6NXy1","@babel/runtime/helpers/defineProperty":"djTAw","lodash/invoke":"jRmLc","lodash/get":"4u8u0","classnames":"7kXBo","prop-types":"kKQPU","react":"6AiW6","../../lib":"1RlVA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7DWEJ":[function(require,module,exports) {
/* @jsx jsx */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@emotion/core");
let _ = (t)=>t, t;
// const LIGHT_GREEN = "#D6DEDD";
const BORDER_RADIUS = ".7rem";
const LIGHT_GREY = "#f8f8f8";
const getStyles = (customColor)=>{
    const primaryColor = customColor || "#5EB58F"; // color from settings or MINT_ALTOID_GREEN
    return (0, _core.css)(t || (t = _`
    .reco-filter {
      text-align: center;
      margin-bottom: 1em;
      font-weight: 120;
    }

    .reco-stats {
      background: ${0};
      border-radius: ${0};
      padding: 2rem 2rem !important;
    }

    .reco-stat {
      text-align: left;
      font-size: 100%;

      .reco-stat-body {
        padding: 1rem;
        border-radius: ${0};
        background: #fff;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
      }

      h4 {
        color: ${0};
        font-size: 2rem;
        margin: 0;
        padding: 0;
        font-weight: 200;
      }

      h5 {
        font-size: 1em;
        font-weight: 800;
        line-height: 1;
        text-transform: uppercase;
        margin: 0.6rem 0 0 0;
        padding: 0;
        color: #666;
      }
    }

    .reco-nav {
      text-align: center;

      .button {
        border: 1px solid ${0};
        background-color: transparent;
        color: ${0};
        text-align: center;
        font-size: 1.2rem;
        display: inline-block;

        &.active,
        &:hover {
          border: none;
          color: #fff !important;
          background: ${0} !important;
          border: 1px solid ${0} !important;
        }
      }
    }

    .reco-detailed-stats {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .reco-detailed-stats-feature {
      background: ${0};
      padding: 2rem 0 4rem 0 !important;
      margin-top: 2rem;
    }

    .reco-detailed-stats-feature-chart {
      height: 350px;
    }

    .reco-detailed-stats-sub-visual {
      height: 300px;
      margin: 2rem 0;
    }

    .recommendations-table {
      margin-top: 2em;
    }

    .reco-detailed-stats-header {
      margin: 2rem 0;

      h3 {
        color: ${0} !important;
        margin: 0 !important;
      }
    }
  `), LIGHT_GREY, BORDER_RADIUS, BORDER_RADIUS, primaryColor, primaryColor, primaryColor, primaryColor, primaryColor, LIGHT_GREY, primaryColor);
};
exports.default = getStyles;

},{"@emotion/core":"f01eg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6FVld":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _bar = require("@nivo/bar");
var _customGraphColors = require("./custom-graph-colors");
const StackedBarByDepartment = ({ byDepartmentAndStatus, statusKeys, handleChartClick, recommendationStatuses, graphTextColor })=>{
    const newData = (0, _customGraphColors.addColorsToBarGraphData)(byDepartmentAndStatus, recommendationStatuses);
    const defaultColorScheme = {
        scheme: "blue_purple"
    };
    const hasCustomColors = newData.some((data)=>data.colors && Object.keys(data.colors).length > 0);
    const colorSetting = hasCustomColors ? ({ id, data })=>data.colors[id] : defaultColorScheme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bar.ResponsiveBar), {
        data: newData,
        labelTextColor: graphTextColor || "black",
        keys: statusKeys,
        layout: "horizontal",
        indexBy: "department",
        margin: {
            top: 10,
            right: 170,
            bottom: 50,
            left: 300
        },
        padding: 0.2,
        colors: colorSetting,
        borderColor: {
            theme: "background"
        },
        legends: [
            {
                dataFrom: "keys",
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: "hover",
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ],
        animate: true,
        motionStiffness: 90,
        motionDamping: 15,
        axisRight: null,
        axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "# Recommendations",
            legendPosition: "middle",
            legendOffset: 40
        },
        enableGridY: false,
        defs: [
            {
                id: "lines-pattern",
                type: "patternLines",
                spacing: 10,
                rotation: -110,
                lineWidth: 1,
                background: "inherit",
                color: "#ccc"
            },
            {
                id: "dots-pattern",
                type: "patternDots",
                size: 2,
                padding: 4,
                stagger: false,
                background: "inherit",
                color: "#ccc"
            }
        ],
        fill: [
            {
                match: {
                    id: "Not Started"
                },
                id: "lines-pattern"
            },
            {
                match: {
                    id: "Implemented"
                },
                id: "dots-pattern"
            }
        ],
        onClick: (e)=>handleChartClick(e, "status", "department")
    }));
};
StackedBarByDepartment.propTypes = {
    byDepartmentAndStatus: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        department: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    recommendationStatuses: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({})).isRequired,
    statusKeys: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    handleChartClick: (0, _propTypesDefault.default).func.isRequired,
    graphTextColor: (0, _propTypesDefault.default).string
};
StackedBarByDepartment.defaultProps = {
    graphTextColor: null
};
exports.default = StackedBarByDepartment;

},{"react":"6AiW6","prop-types":"kKQPU","@nivo/bar":"cM2r9","./custom-graph-colors":"leLSB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cM2r9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar$1);
parcelHelpers.export(exports, "BarCanvas", ()=>BarCanvas$1);
parcelHelpers.export(exports, "BarDefaultProps", ()=>BarDefaultProps);
parcelHelpers.export(exports, "BarPropTypes", ()=>BarPropTypes);
parcelHelpers.export(exports, "ResponsiveBar", ()=>ResponsiveBar);
parcelHelpers.export(exports, "ResponsiveBarCanvas", ()=>ResponsiveBarCanvas);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactMotion = require("react-motion");
var _core = require("@nivo/core");
var _axes = require("@nivo/axes");
var _legends = require("@nivo/legends");
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _d3Scale = require("d3-scale");
var _flattenDepth = require("lodash/flattenDepth");
var _flattenDepthDefault = parcelHelpers.interopDefault(_flattenDepth);
var _d3Shape = require("d3-shape");
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _setDisplayName = require("recompose/setDisplayName");
var _setDisplayNameDefault = parcelHelpers.interopDefault(_setDisplayName);
var _compose = require("recompose/compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _defaultProps = require("recompose/defaultProps");
var _defaultPropsDefault = parcelHelpers.interopDefault(_defaultProps);
var _withPropsOnChange = require("recompose/withPropsOnChange");
var _withPropsOnChangeDefault = parcelHelpers.interopDefault(_withPropsOnChange);
var _pure = require("recompose/pure");
var _pureDefault = parcelHelpers.interopDefault(_pure);
var _colors = require("@nivo/colors");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tooltip = require("@nivo/tooltip");
var _annotations = require("@nivo/annotations");
var global = arguments[3];
var getIndexedScale = function getIndexedScale(data, getIndex, range, padding) {
    return (0, _d3Scale.scaleBand)().rangeRound(range).domain(data.map(getIndex)).padding(padding);
};
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var getGroupedScale = function getGroupedScale(data, keys, _minValue, _maxValue, range) {
    var allValues = data.reduce(function(acc, entry) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(keys.map(function(k) {
            return entry[k];
        })));
    }, []);
    var maxValue = _maxValue;
    if (maxValue === "auto") maxValue = (0, _maxDefault.default)(allValues);
    var minValue = _minValue;
    if (minValue === "auto") {
        minValue = (0, _minDefault.default)(allValues);
        if (minValue > 0) minValue = 0;
    }
    return (0, _d3Scale.scaleLinear)().rangeRound(range).domain([
        minValue,
        maxValue
    ]);
};
var generateVerticalGroupedBars = function generateVerticalGroupedBars(_ref) {
    var data = _ref.data, getIndex = _ref.getIndex, keys = _ref.keys, minValue = _ref.minValue, maxValue = _ref.maxValue, reverse = _ref.reverse, width = _ref.width, height = _ref.height, getColor = _ref.getColor, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 0 : _ref$padding, _ref$innerPadding = _ref.innerPadding, innerPadding = _ref$innerPadding === void 0 ? 0 : _ref$innerPadding;
    var xScale = getIndexedScale(data, getIndex, [
        0,
        width
    ], padding);
    var yRange = reverse ? [
        0,
        height
    ] : [
        height,
        0
    ];
    var yScale = getGroupedScale(data, keys, minValue, maxValue, yRange);
    var barWidth = (xScale.bandwidth() - innerPadding * (keys.length - 1)) / keys.length;
    var yRef = yScale(0);
    var getY = function getY(d) {
        return d > 0 ? yScale(d) : yRef;
    };
    var getHeight = function getHeight(d, y) {
        return d > 0 ? yRef - y : yScale(d) - yRef;
    };
    if (reverse) {
        getY = function getY(d) {
            return d < 0 ? yScale(d) : yRef;
        };
        getHeight = function getHeight(d, y) {
            return d < 0 ? yRef - y : yScale(d) - yRef;
        };
    }
    var bars = [];
    if (barWidth > 0) keys.forEach(function(key, i) {
        (0, _rangeDefault.default)(xScale.domain().length).forEach(function(index) {
            var x = xScale(getIndex(data[index])) + barWidth * i + innerPadding * i;
            var y = getY(data[index][key]);
            var barHeight = getHeight(data[index][key], y);
            if (barWidth > 0 && barHeight > 0) {
                var barData = {
                    id: key,
                    value: data[index][key],
                    index: index,
                    indexValue: getIndex(data[index]),
                    data: data[index]
                };
                bars.push({
                    key: "".concat(key, ".").concat(barData.indexValue),
                    data: barData,
                    x: x,
                    y: y,
                    width: barWidth,
                    height: barHeight,
                    color: getColor(barData)
                });
            }
        });
    });
    return {
        xScale: xScale,
        yScale: yScale,
        bars: bars
    };
};
var generateHorizontalGroupedBars = function generateHorizontalGroupedBars(_ref2) {
    var data = _ref2.data, getIndex = _ref2.getIndex, keys = _ref2.keys, minValue = _ref2.minValue, maxValue = _ref2.maxValue, reverse = _ref2.reverse, width = _ref2.width, height = _ref2.height, getColor = _ref2.getColor, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? 0 : _ref2$padding, _ref2$innerPadding = _ref2.innerPadding, innerPadding = _ref2$innerPadding === void 0 ? 0 : _ref2$innerPadding;
    var xRange = reverse ? [
        width,
        0
    ] : [
        0,
        width
    ];
    var xScale = getGroupedScale(data, keys, minValue, maxValue, xRange);
    var yScale = getIndexedScale(data, getIndex, [
        height,
        0
    ], padding);
    var barHeight = (yScale.bandwidth() - innerPadding * (keys.length - 1)) / keys.length;
    var xRef = xScale(0);
    var getX = function getX(d) {
        return d > 0 ? xRef : xScale(d);
    };
    var getWidth = function getWidth(d, x) {
        return d > 0 ? xScale(d) - xRef : xRef - x;
    };
    if (reverse) {
        getX = function getX(d) {
            return d < 0 ? xRef : xScale(d);
        };
        getWidth = function getWidth(d, x) {
            return d < 0 ? xScale(d) - xRef : xRef - x;
        };
    }
    var bars = [];
    if (barHeight > 0) keys.forEach(function(key, i) {
        (0, _rangeDefault.default)(yScale.domain().length).forEach(function(index) {
            var x = getX(data[index][key]);
            var y = yScale(getIndex(data[index])) + barHeight * i + innerPadding * i;
            var barWidth = getWidth(data[index][key], x);
            if (barWidth > 0) {
                var barData = {
                    id: key,
                    value: data[index][key],
                    index: index,
                    indexValue: getIndex(data[index]),
                    data: data[index]
                };
                bars.push({
                    key: "".concat(key, ".").concat(barData.indexValue),
                    data: barData,
                    x: x,
                    y: y,
                    width: barWidth,
                    height: barHeight,
                    color: getColor(barData)
                });
            }
        });
    });
    return {
        xScale: xScale,
        yScale: yScale,
        bars: bars
    };
};
var generateGroupedBars = function generateGroupedBars(options) {
    return options.layout === "vertical" ? generateVerticalGroupedBars(options) : generateHorizontalGroupedBars(options);
};
var getStackedScale = function getStackedScale(data, _minValue, _maxValue, range) {
    var allValues = (0, _flattenDepthDefault.default)(data, 2);
    var minValue = _minValue;
    if (minValue === "auto") minValue = (0, _minDefault.default)(allValues);
    var maxValue = _maxValue;
    if (maxValue === "auto") maxValue = (0, _maxDefault.default)(allValues);
    return (0, _d3Scale.scaleLinear)().rangeRound(range).domain([
        minValue,
        maxValue
    ]);
};
var generateVerticalStackedBars = function generateVerticalStackedBars(_ref) {
    var data = _ref.data, getIndex = _ref.getIndex, keys = _ref.keys, minValue = _ref.minValue, maxValue = _ref.maxValue, reverse = _ref.reverse, width = _ref.width, height = _ref.height, getColor = _ref.getColor, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 0 : _ref$padding, _ref$innerPadding = _ref.innerPadding, innerPadding = _ref$innerPadding === void 0 ? 0 : _ref$innerPadding;
    var stackedData = (0, _d3Shape.stack)().keys(keys).offset((0, _d3Shape.stackOffsetDiverging))(data);
    var xScale = getIndexedScale(data, getIndex, [
        0,
        width
    ], padding);
    var yRange = reverse ? [
        0,
        height
    ] : [
        height,
        0
    ];
    var yScale = getStackedScale(stackedData, minValue, maxValue, yRange);
    var bars = [];
    var barWidth = xScale.bandwidth();
    var getY = function getY(d) {
        return yScale(d[1]);
    };
    var getHeight = function getHeight(d, y) {
        return yScale(d[0]) - y;
    };
    if (reverse) {
        getY = function getY(d) {
            return yScale(d[0]);
        };
        getHeight = function getHeight(d, y) {
            return yScale(d[1]) - y;
        };
    }
    if (barWidth > 0) stackedData.forEach(function(stackedDataItem) {
        xScale.domain().forEach(function(index, i) {
            var d = stackedDataItem[i];
            var x = xScale(getIndex(d.data));
            var y = getY(d);
            var barHeight = getHeight(d, y);
            if (innerPadding > 0) {
                y += innerPadding * 0.5;
                barHeight -= innerPadding;
            }
            if (barHeight > 0) {
                var barData = {
                    id: stackedDataItem.key,
                    value: d.data[stackedDataItem.key],
                    index: i,
                    indexValue: index,
                    data: d.data
                };
                bars.push({
                    key: "".concat(stackedDataItem.key, ".").concat(index),
                    data: barData,
                    x: x,
                    y: y,
                    width: barWidth,
                    height: barHeight,
                    color: getColor(barData)
                });
            }
        });
    });
    return {
        xScale: xScale,
        yScale: yScale,
        bars: bars
    };
};
var generateHorizontalStackedBars = function generateHorizontalStackedBars(_ref2) {
    var data = _ref2.data, getIndex = _ref2.getIndex, keys = _ref2.keys, minValue = _ref2.minValue, maxValue = _ref2.maxValue, reverse = _ref2.reverse, width = _ref2.width, height = _ref2.height, getColor = _ref2.getColor, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? 0 : _ref2$padding, _ref2$innerPadding = _ref2.innerPadding, innerPadding = _ref2$innerPadding === void 0 ? 0 : _ref2$innerPadding;
    var stackedData = (0, _d3Shape.stack)().keys(keys).offset((0, _d3Shape.stackOffsetDiverging))(data);
    var xRange = reverse ? [
        width,
        0
    ] : [
        0,
        width
    ];
    var xScale = getStackedScale(stackedData, minValue, maxValue, xRange);
    var yScale = getIndexedScale(data, getIndex, [
        height,
        0
    ], padding);
    var bars = [];
    var barHeight = yScale.bandwidth();
    var getX = function getX(d) {
        return xScale(d[0]);
    };
    var getWidth = function getWidth(d, x) {
        return xScale(d[1]) - x;
    };
    if (reverse) {
        getX = function getX(d) {
            return xScale(d[1]);
        };
        getWidth = function getWidth(d, y) {
            return xScale(d[0]) - y;
        };
    }
    if (barHeight > 0) stackedData.forEach(function(stackedDataItem) {
        yScale.domain().forEach(function(index, i) {
            var d = stackedDataItem[i];
            var y = yScale(getIndex(d.data));
            var barData = {
                id: stackedDataItem.key,
                value: d.data[stackedDataItem.key],
                index: i,
                indexValue: index,
                data: d.data
            };
            var x = getX(d);
            var barWidth = getWidth(d, x);
            if (innerPadding > 0) {
                x += innerPadding * 0.5;
                barWidth -= innerPadding;
            }
            if (barWidth > 0) bars.push({
                key: "".concat(stackedDataItem.key, ".").concat(index),
                data: barData,
                x: x,
                y: y,
                width: barWidth,
                height: barHeight,
                color: getColor(barData)
            });
        });
    });
    return {
        xScale: xScale,
        yScale: yScale,
        bars: bars
    };
};
var generateStackedBars = function generateStackedBars(options) {
    return options.layout === "vertical" ? generateVerticalStackedBars(options) : generateHorizontalStackedBars(options);
};
var getLegendDataForKeys = function getLegendDataForKeys(bars, layout, groupMode, reverse) {
    var data = (0, _uniqByDefault.default)(bars.map(function(bar) {
        return {
            id: bar.data.id,
            label: bar.data.id,
            color: bar.color,
            fill: bar.data.fill
        };
    }), function(_ref) {
        var id = _ref.id;
        return id;
    });
    if (layout === "vertical" && groupMode === "stacked" && reverse !== true || layout === "horizontal" && groupMode === "stacked" && reverse === true) data.reverse();
    return data;
};
var getLegendDataForIndexes = function getLegendDataForIndexes(bars) {
    return (0, _uniqByDefault.default)(bars.map(function(bar) {
        return {
            id: bar.data.indexValue,
            label: bar.data.indexValue,
            color: bar.color,
            fill: bar.data.fill
        };
    }), function(_ref2) {
        var id = _ref2.id;
        return id;
    });
};
var getLegendData = function getLegendData(_ref3) {
    var from = _ref3.from, bars = _ref3.bars, layout = _ref3.layout, groupMode = _ref3.groupMode, reverse = _ref3.reverse;
    if (from === "indexes") return getLegendDataForIndexes(bars);
    return getLegendDataForKeys(bars, layout, groupMode, reverse);
};
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var BarItem = function BarItem(_ref) {
    var data = _ref.data, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height, borderRadius = _ref.borderRadius, color = _ref.color, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor, label = _ref.label, shouldRenderLabel = _ref.shouldRenderLabel, labelColor = _ref.labelColor, showTooltip = _ref.showTooltip, hideTooltip = _ref.hideTooltip, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, tooltip = _ref.tooltip, theme = _ref.theme;
    var handleTooltip = function handleTooltip(e) {
        return showTooltip(tooltip, e);
    };
    var handleMouseEnter = function handleMouseEnter(e) {
        onMouseEnter(data, e);
        showTooltip(tooltip, e);
    };
    var handleMouseLeave = function handleMouseLeave(e) {
        onMouseLeave(data, e);
        hideTooltip(e);
    };
    return (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(x, ", ").concat(y, ")")
    }, (0, _reactDefault.default).createElement("rect", {
        width: width,
        height: height,
        rx: borderRadius,
        ry: borderRadius,
        fill: data.fill ? data.fill : color,
        strokeWidth: borderWidth,
        stroke: borderColor,
        onMouseEnter: handleMouseEnter,
        onMouseMove: handleTooltip,
        onMouseLeave: handleMouseLeave,
        onClick: onClick
    }), shouldRenderLabel && (0, _reactDefault.default).createElement("text", {
        x: width / 2,
        y: height / 2,
        textAnchor: "middle",
        dominantBaseline: "central",
        style: _objectSpread({}, theme.labels.text, {
            pointerEvents: "none",
            fill: labelColor
        })
    }, label));
};
BarItem.propTypes = {
    data: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        value: (0, _propTypesDefault.default).number.isRequired,
        indexValue: (0, _propTypesDefault.default).string.isRequired
    }).isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    borderRadius: (0, _propTypesDefault.default).number.isRequired,
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _propTypesDefault.default).string.isRequired,
    label: (0, _propTypesDefault.default).node.isRequired,
    shouldRenderLabel: (0, _propTypesDefault.default).bool.isRequired,
    labelColor: (0, _propTypesDefault.default).string.isRequired,
    showTooltip: (0, _propTypesDefault.default).func.isRequired,
    hideTooltip: (0, _propTypesDefault.default).func.isRequired,
    getTooltipLabel: (0, _propTypesDefault.default).func.isRequired,
    tooltipFormat: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    onClick: (0, _propTypesDefault.default).func,
    onMouseEnter: (0, _propTypesDefault.default).func,
    onMouseLeave: (0, _propTypesDefault.default).func,
    tooltip: (0, _propTypesDefault.default).element.isRequired,
    theme: (0, _propTypesDefault.default).shape({
        tooltip: (0, _propTypesDefault.default).shape({}).isRequired
    }).isRequired
};
var enhance = (0, _composeDefault.default)((0, _withPropsOnChangeDefault.default)([
    "data",
    "color",
    "onClick"
], function(_ref2) {
    var data = _ref2.data, color = _ref2.color, _onClick = _ref2.onClick;
    return {
        onClick: function onClick(event) {
            return _onClick(_objectSpread({
                color: color
            }, data), event);
        }
    };
}), (0, _withPropsOnChangeDefault.default)([
    "data",
    "color",
    "theme",
    "tooltip",
    "getTooltipLabel",
    "tooltipFormat"
], function(_ref3) {
    var data = _ref3.data, color = _ref3.color, theme = _ref3.theme, tooltip = _ref3.tooltip, getTooltipLabel = _ref3.getTooltipLabel, tooltipFormat = _ref3.tooltipFormat;
    return {
        tooltip: (0, _reactDefault.default).createElement((0, _tooltip.BasicTooltip), {
            id: getTooltipLabel(data),
            value: data.value,
            enableChip: true,
            color: color,
            theme: theme,
            format: tooltipFormat,
            renderContent: typeof tooltip === "function" ? tooltip.bind(null, _objectSpread({
                color: color,
                theme: theme
            }, data)) : null
        })
    };
}), (0, _pureDefault.default));
var BarItem$1 = enhance(BarItem);
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var BarPropTypes = _objectSpread$1({
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object).isRequired,
    indexBy: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    getIndex: (0, _propTypesDefault.default).func.isRequired,
    keys: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])).isRequired,
    layers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            "grid",
            "axes",
            "bars",
            "markers",
            "legends",
            "annotations"
        ]),
        (0, _propTypesDefault.default).func
    ])).isRequired,
    groupMode: (0, _propTypesDefault.default).oneOf([
        "stacked",
        "grouped"
    ]).isRequired,
    layout: (0, _propTypesDefault.default).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired,
    reverse: (0, _propTypesDefault.default).bool.isRequired,
    minValue: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).oneOf([
            "auto"
        ])
    ]).isRequired,
    maxValue: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).oneOf([
            "auto"
        ])
    ]).isRequired,
    padding: (0, _propTypesDefault.default).number.isRequired,
    innerPadding: (0, _propTypesDefault.default).number.isRequired,
    axisTop: (0, _axes.axisPropType),
    axisRight: (0, _axes.axisPropType),
    axisBottom: (0, _axes.axisPropType),
    axisLeft: (0, _axes.axisPropType),
    enableGridX: (0, _propTypesDefault.default).bool.isRequired,
    enableGridY: (0, _propTypesDefault.default).bool.isRequired,
    gridXValues: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    gridYValues: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    barComponent: (0, _propTypesDefault.default).func.isRequired,
    enableLabel: (0, _propTypesDefault.default).bool.isRequired,
    label: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    labelFormat: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    getLabel: (0, _propTypesDefault.default).func.isRequired,
    labelSkipWidth: (0, _propTypesDefault.default).number.isRequired,
    labelSkipHeight: (0, _propTypesDefault.default).number.isRequired,
    labelTextColor: (0, _colors.inheritedColorPropType).isRequired,
    getLabelTextColor: (0, _propTypesDefault.default).func.isRequired,
    labelLinkColor: (0, _colors.inheritedColorPropType).isRequired,
    getLabelLinkColor: (0, _propTypesDefault.default).func.isRequired,
    colors: (0, _colors.ordinalColorsPropType).isRequired,
    colorBy: (0, _colors.colorPropertyAccessorPropType).isRequired,
    borderRadius: (0, _propTypesDefault.default).number.isRequired,
    getColor: (0, _propTypesDefault.default).func.isRequired
}, (0, _core.defsPropTypes), {
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _colors.inheritedColorPropType).isRequired,
    getBorderColor: (0, _propTypesDefault.default).func.isRequired,
    isInteractive: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func.isRequired,
    onMouseEnter: (0, _propTypesDefault.default).func.isRequired,
    onMouseLeave: (0, _propTypesDefault.default).func.isRequired,
    tooltipLabel: (0, _propTypesDefault.default).func,
    getTooltipLabel: (0, _propTypesDefault.default).func.isRequired,
    tooltipFormat: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    tooltip: (0, _propTypesDefault.default).func,
    legends: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape(_objectSpread$1({
        dataFrom: (0, _propTypesDefault.default).oneOf([
            "indexes",
            "keys"
        ]).isRequired
    }, (0, _legends.LegendPropShape)))).isRequired,
    pixelRatio: (0, _propTypesDefault.default).number.isRequired
});
var BarDefaultProps = {
    indexBy: "id",
    keys: [
        "value"
    ],
    layers: [
        "grid",
        "axes",
        "bars",
        "markers",
        "legends",
        "annotations"
    ],
    groupMode: "stacked",
    layout: "vertical",
    reverse: false,
    minValue: "auto",
    maxValue: "auto",
    padding: 0.1,
    innerPadding: 0,
    axisBottom: {},
    axisLeft: {},
    enableGridX: false,
    enableGridY: true,
    barComponent: BarItem$1,
    enableLabel: true,
    label: "value",
    labelSkipWidth: 0,
    labelSkipHeight: 0,
    labelLinkColor: "theme",
    labelTextColor: "theme",
    colors: {
        scheme: "nivo"
    },
    colorBy: "id",
    defs: [],
    fill: [],
    borderRadius: 0,
    borderWidth: 0,
    borderColor: {
        from: "color"
    },
    isInteractive: true,
    onClick: (0, _core.noop),
    onMouseEnter: (0, _core.noop),
    onMouseLeave: (0, _core.noop),
    legends: [],
    annotations: [],
    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
};
var enhance$1 = function(Component) {
    return (0, _composeDefault.default)((0, _defaultPropsDefault.default)(BarDefaultProps), (0, _core.withTheme)(), (0, _core.withDimensions)(), (0, _core.withMotion)(), (0, _withPropsOnChangeDefault.default)([
        "colors",
        "colorBy"
    ], function(_ref) {
        var colors = _ref.colors, colorBy = _ref.colorBy;
        return {
            getColor: (0, _colors.getOrdinalColorScale)(colors, colorBy)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "indexBy"
    ], function(_ref2) {
        var indexBy = _ref2.indexBy;
        return {
            getIndex: (0, _core.getAccessorFor)(indexBy)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "labelTextColor",
        "theme"
    ], function(_ref3) {
        var labelTextColor = _ref3.labelTextColor, theme = _ref3.theme;
        return {
            getLabelTextColor: (0, _colors.getInheritedColorGenerator)(labelTextColor, theme)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "labelLinkColor",
        "theme"
    ], function(_ref4) {
        var labelLinkColor = _ref4.labelLinkColor, theme = _ref4.theme;
        return {
            getLabelLinkColor: (0, _colors.getInheritedColorGenerator)(labelLinkColor, theme)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "label",
        "labelFormat"
    ], function(_ref5) {
        var label = _ref5.label, labelFormat = _ref5.labelFormat;
        return {
            getLabel: (0, _core.getLabelGenerator)(label, labelFormat)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "borderColor",
        "theme"
    ], function(_ref6) {
        var borderColor = _ref6.borderColor, theme = _ref6.theme;
        return {
            getBorderColor: (0, _colors.getInheritedColorGenerator)(borderColor, theme)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "tooltipLabel"
    ], function(_ref7) {
        var tooltipLabel = _ref7.tooltipLabel;
        var getTooltipLabel = function getTooltipLabel(d) {
            return "".concat(d.id, " - ").concat(d.indexValue);
        };
        if (typeof tooltipLabel === "function") getTooltipLabel = tooltipLabel;
        return {
            getTooltipLabel: getTooltipLabel
        };
    }), (0, _pureDefault.default))(Component);
};
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var BarAnnotations = function BarAnnotations(_ref) {
    var bars = _ref.bars, annotations = _ref.annotations, animate = _ref.animate, motionStiffness = _ref.motionStiffness, motionDamping = _ref.motionDamping;
    var boundAnnotations = (0, _annotations.useAnnotations)({
        items: bars,
        annotations: annotations,
        getPosition: function getPosition(bar) {
            return {
                x: bar.x + bar.width / 2,
                y: bar.y + bar.height / 2
            };
        },
        getDimensions: function getDimensions(bar, offset) {
            var width = bar.width + offset * 2;
            var height = bar.height + offset * 2;
            return {
                width: width,
                height: height,
                size: Math.max(width, height)
            };
        }
    });
    return boundAnnotations.map(function(annotation, i) {
        return (0, _reactDefault.default).createElement((0, _annotations.Annotation), _extends({
            key: i
        }, annotation, {
            containerWidth: innerWidth,
            containerHeight: innerHeight,
            animate: animate,
            motionStiffness: motionStiffness,
            motionDamping: motionDamping
        }));
    });
};
BarAnnotations.propTypes = {};
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var barWillEnterHorizontal = function barWillEnterHorizontal(_ref) {
    var style = _ref.style;
    return {
        x: style.x.val,
        y: style.y.val,
        width: 0,
        height: style.height.val
    };
};
var barWillEnterVertical = function barWillEnterVertical(_ref2) {
    var style = _ref2.style;
    return {
        x: style.x.val,
        y: style.y.val + style.height.val,
        width: style.width.val,
        height: 0
    };
};
var barWillLeaveHorizontal = function barWillLeaveHorizontal(springConfig) {
    return function(_ref3) {
        var style = _ref3.style;
        return {
            x: style.x,
            y: style.y,
            width: (0, _reactMotion.spring)(0, springConfig),
            height: style.height
        };
    };
};
var barWillLeaveVertical = function barWillLeaveVertical(springConfig) {
    return function(_ref4) {
        var style = _ref4.style;
        return {
            x: style.x,
            y: (0, _reactMotion.spring)(style.y.val + style.height.val, springConfig),
            width: style.width,
            height: (0, _reactMotion.spring)(0, springConfig)
        };
    };
};
var Bar = function Bar(props) {
    var data = props.data, getIndex = props.getIndex, keys = props.keys, groupMode = props.groupMode, layout = props.layout, reverse = props.reverse, minValue = props.minValue, maxValue = props.maxValue, margin = props.margin, width = props.width, height = props.height, outerWidth = props.outerWidth, outerHeight = props.outerHeight, padding = props.padding, innerPadding = props.innerPadding, axisTop = props.axisTop, axisRight = props.axisRight, axisBottom = props.axisBottom, axisLeft = props.axisLeft, enableGridX = props.enableGridX, enableGridY = props.enableGridY, gridXValues = props.gridXValues, gridYValues = props.gridYValues, layers = props.layers, barComponent = props.barComponent, enableLabel = props.enableLabel, getLabel = props.getLabel, labelSkipWidth = props.labelSkipWidth, labelSkipHeight = props.labelSkipHeight, getLabelTextColor = props.getLabelTextColor, markers = props.markers, theme = props.theme, getColor = props.getColor, defs = props.defs, fill = props.fill, borderRadius = props.borderRadius, borderWidth = props.borderWidth, getBorderColor = props.getBorderColor, annotations = props.annotations, isInteractive = props.isInteractive, getTooltipLabel = props.getTooltipLabel, tooltipFormat = props.tooltipFormat, tooltip = props.tooltip, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, legends = props.legends, animate = props.animate, motionStiffness = props.motionStiffness, motionDamping = props.motionDamping;
    var options = {
        layout: layout,
        reverse: reverse,
        data: data,
        getIndex: getIndex,
        keys: keys,
        minValue: minValue,
        maxValue: maxValue,
        width: width,
        height: height,
        getColor: getColor,
        padding: padding,
        innerPadding: innerPadding
    };
    var result = groupMode === "grouped" ? generateGroupedBars(options) : generateStackedBars(options);
    var motionProps = {
        animate: animate,
        motionDamping: motionDamping,
        motionStiffness: motionStiffness
    };
    var springConfig = {
        damping: motionDamping,
        stiffness: motionStiffness
    };
    var willEnter = layout === "vertical" ? barWillEnterVertical : barWillEnterHorizontal;
    var willLeave = layout === "vertical" ? barWillLeaveVertical(springConfig) : barWillLeaveHorizontal(springConfig);
    var shouldRenderLabel = function shouldRenderLabel(_ref5) {
        var width = _ref5.width, height = _ref5.height;
        if (!enableLabel) return false;
        if (labelSkipWidth > 0 && width < labelSkipWidth) return false;
        if (labelSkipHeight > 0 && height < labelSkipHeight) return false;
        return true;
    };
    var boundDefs = (0, _core.bindDefs)(defs, result.bars, fill, {
        dataKey: "data",
        targetKey: "data.fill"
    });
    return (0, _reactDefault.default).createElement((0, _core.Container), {
        isInteractive: isInteractive,
        theme: theme,
        animate: animate,
        motionStiffness: motionStiffness,
        motionDamping: motionDamping
    }, function(_ref6) {
        var showTooltip = _ref6.showTooltip, hideTooltip = _ref6.hideTooltip;
        var commonProps = {
            borderRadius: borderRadius,
            borderWidth: borderWidth,
            enableLabel: enableLabel,
            labelSkipWidth: labelSkipWidth,
            labelSkipHeight: labelSkipHeight,
            showTooltip: showTooltip,
            hideTooltip: hideTooltip,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            theme: theme,
            getTooltipLabel: getTooltipLabel,
            tooltipFormat: tooltipFormat,
            tooltip: tooltip
        };
        var bars;
        if (animate === true) bars = (0, _reactDefault.default).createElement((0, _reactMotion.TransitionMotion), {
            key: "bars",
            willEnter: willEnter,
            willLeave: willLeave,
            styles: result.bars.map(function(bar) {
                return {
                    key: bar.key,
                    data: bar,
                    style: {
                        x: (0, _reactMotion.spring)(bar.x, springConfig),
                        y: (0, _reactMotion.spring)(bar.y, springConfig),
                        width: (0, _reactMotion.spring)(bar.width, springConfig),
                        height: (0, _reactMotion.spring)(bar.height, springConfig)
                    }
                };
            })
        }, function(interpolatedStyles) {
            return (0, _reactDefault.default).createElement("g", null, interpolatedStyles.map(function(_ref7) {
                var key = _ref7.key, style = _ref7.style, bar = _ref7.data;
                var baseProps = _objectSpread$2({}, bar, style);
                return (0, _reactDefault.default).createElement(barComponent, _objectSpread$2({
                    key: key
                }, baseProps, commonProps, {
                    shouldRenderLabel: shouldRenderLabel(baseProps),
                    width: Math.max(style.width, 0),
                    height: Math.max(style.height, 0),
                    label: getLabel(bar.data),
                    labelColor: getLabelTextColor(baseProps, theme),
                    borderColor: getBorderColor(baseProps),
                    theme: theme
                }));
            }));
        });
        else bars = result.bars.map(function(d) {
            return (0, _reactDefault.default).createElement(barComponent, _objectSpread$2({
                key: d.key
            }, d, commonProps, {
                label: getLabel(d.data),
                shouldRenderLabel: shouldRenderLabel(d),
                labelColor: getLabelTextColor(d, theme),
                borderColor: getBorderColor(d),
                theme: theme
            }));
        });
        var layerById = {
            grid: (0, _reactDefault.default).createElement((0, _axes.Grid), {
                key: "grid",
                width: width,
                height: height,
                xScale: enableGridX ? result.xScale : null,
                yScale: enableGridY ? result.yScale : null,
                xValues: gridXValues,
                yValues: gridYValues
            }),
            axes: (0, _reactDefault.default).createElement((0, _axes.Axes), {
                key: "axes",
                xScale: result.xScale,
                yScale: result.yScale,
                width: width,
                height: height,
                top: axisTop,
                right: axisRight,
                bottom: axisBottom,
                left: axisLeft
            }),
            bars: bars,
            markers: (0, _reactDefault.default).createElement((0, _core.CartesianMarkers), {
                key: "markers",
                markers: markers,
                width: width,
                height: height,
                xScale: result.xScale,
                yScale: result.yScale,
                theme: theme
            }),
            legends: legends.map(function(legend, i) {
                var legendData = getLegendData({
                    from: legend.dataFrom,
                    bars: result.bars,
                    layout: layout,
                    groupMode: groupMode,
                    reverse: reverse
                });
                if (legendData === undefined) return null;
                return (0, _reactDefault.default).createElement((0, _legends.BoxLegendSvg), _extends$1({
                    key: i
                }, legend, {
                    containerWidth: width,
                    containerHeight: height,
                    data: legendData,
                    theme: theme
                }));
            }),
            annotations: (0, _reactDefault.default).createElement(BarAnnotations, _extends$1({
                key: "annotations",
                innerWidth: width,
                innerHeight: height,
                bars: result.bars,
                annotations: annotations
            }, motionProps))
        };
        return (0, _reactDefault.default).createElement((0, _core.SvgWrapper), {
            width: outerWidth,
            height: outerHeight,
            margin: margin,
            defs: boundDefs,
            theme: theme
        }, layers.map(function(layer, i) {
            if (typeof layer === "function") return (0, _reactDefault.default).createElement((0, _react.Fragment), {
                key: i
            }, layer(_objectSpread$2({}, props, result)));
            return layerById[layer];
        }));
    });
};
Bar.propTypes = BarPropTypes;
var Bar$1 = (0, _setDisplayNameDefault.default)("Bar")(enhance$1(Bar));
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var findNodeUnderCursor = function findNodeUnderCursor(nodes, margin, x, y) {
    return nodes.find(function(node) {
        return (0, _core.isCursorInRect)(node.x + margin.left, node.y + margin.top, node.width, node.height, x, y);
    });
};
var BarCanvas = function(_Component) {
    _inherits(BarCanvas, _Component);
    function BarCanvas() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, BarCanvas);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BarCanvas)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty$3(_assertThisInitialized(_this), "handleMouseHover", function(showTooltip, hideTooltip) {
            return function(event) {
                if (!_this.bars) return;
                var _this$props = _this.props, margin = _this$props.margin, theme = _this$props.theme, tooltip = _this$props.tooltip, getTooltipLabel = _this$props.getTooltipLabel, tooltipFormat = _this$props.tooltipFormat;
                var _getRelativeCursor = (0, _core.getRelativeCursor)(_this.surface, event), _getRelativeCursor2 = _slicedToArray(_getRelativeCursor, 2), x = _getRelativeCursor2[0], y = _getRelativeCursor2[1];
                var bar = findNodeUnderCursor(_this.bars, margin, x, y);
                if (bar !== undefined) showTooltip((0, _reactDefault.default).createElement((0, _tooltip.BasicTooltip), {
                    id: getTooltipLabel(bar.data),
                    value: bar.data.value,
                    enableChip: true,
                    color: bar.color,
                    theme: theme,
                    format: tooltipFormat,
                    renderContent: typeof tooltip === "function" ? tooltip.bind(null, _objectSpread$3({
                        color: bar.color
                    }, bar.data)) : null
                }), event);
                else hideTooltip();
            };
        });
        _defineProperty$3(_assertThisInitialized(_this), "handleMouseLeave", function(hideTooltip) {
            return function() {
                hideTooltip();
            };
        });
        _defineProperty$3(_assertThisInitialized(_this), "handleClick", function(event) {
            if (!_this.bars) return;
            var _this$props2 = _this.props, margin = _this$props2.margin, onClick = _this$props2.onClick;
            var _getRelativeCursor3 = (0, _core.getRelativeCursor)(_this.surface, event), _getRelativeCursor4 = _slicedToArray(_getRelativeCursor3, 2), x = _getRelativeCursor4[0], y = _getRelativeCursor4[1];
            var node = findNodeUnderCursor(_this.bars, margin, x, y);
            if (node !== undefined) onClick(node.data, event);
        });
        return _this;
    }
    _createClass(BarCanvas, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.ctx = this.surface.getContext("2d");
                this.draw(this.props);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(props) {
                if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) return true;
                else {
                    this.draw(props);
                    return false;
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.ctx = this.surface.getContext("2d");
                this.draw(this.props);
            }
        },
        {
            key: "draw",
            value: function draw(props) {
                var _this2 = this;
                var data = props.data, keys = props.keys, getIndex = props.getIndex, minValue = props.minValue, maxValue = props.maxValue, width = props.width, height = props.height, outerWidth = props.outerWidth, outerHeight = props.outerHeight, pixelRatio = props.pixelRatio, margin = props.margin, layout = props.layout, reverse = props.reverse, groupMode = props.groupMode, padding = props.padding, innerPadding = props.innerPadding, axisTop = props.axisTop, axisRight = props.axisRight, axisBottom = props.axisBottom, axisLeft = props.axisLeft, theme = props.theme, getColor = props.getColor, borderWidth = props.borderWidth, getBorderColor = props.getBorderColor, legends = props.legends, enableGridX = props.enableGridX, gridXValues = props.gridXValues, enableGridY = props.enableGridY, gridYValues = props.gridYValues;
                this.surface.width = outerWidth * pixelRatio;
                this.surface.height = outerHeight * pixelRatio;
                this.ctx.scale(pixelRatio, pixelRatio);
                var options = {
                    layout: layout,
                    reverse: reverse,
                    data: data,
                    getIndex: getIndex,
                    keys: keys,
                    minValue: minValue,
                    maxValue: maxValue,
                    width: width,
                    height: height,
                    getColor: getColor,
                    padding: padding,
                    innerPadding: innerPadding
                };
                var result = groupMode === "grouped" ? generateGroupedBars(options) : generateStackedBars(options);
                this.bars = result.bars;
                this.ctx.fillStyle = theme.background;
                this.ctx.fillRect(0, 0, outerWidth, outerHeight);
                this.ctx.translate(margin.left, margin.top);
                if (theme.grid.line.strokeWidth > 0) {
                    this.ctx.lineWidth = theme.grid.line.strokeWidth;
                    this.ctx.strokeStyle = theme.grid.line.stroke;
                    enableGridX && (0, _axes.renderGridLinesToCanvas)(this.ctx, {
                        width: width,
                        height: height,
                        scale: result.xScale,
                        axis: "x",
                        values: gridXValues
                    });
                    enableGridY && (0, _axes.renderGridLinesToCanvas)(this.ctx, {
                        width: width,
                        height: height,
                        scale: result.yScale,
                        axis: "y",
                        values: gridYValues
                    });
                }
                this.ctx.strokeStyle = "#dddddd";
                var legendDataForKeys = (0, _uniqByDefault.default)(result.bars.map(function(bar) {
                    return {
                        id: bar.data.id,
                        label: bar.data.id,
                        color: bar.color,
                        fill: bar.data.fill
                    };
                }).reverse(), function(_ref) {
                    var id = _ref.id;
                    return id;
                });
                var legendDataForIndexes = (0, _uniqByDefault.default)(result.bars.map(function(bar) {
                    return {
                        id: bar.data.indexValue,
                        label: bar.data.indexValue,
                        color: bar.color,
                        fill: bar.data.fill
                    };
                }), function(_ref2) {
                    var id = _ref2.id;
                    return id;
                });
                legends.forEach(function(legend) {
                    var legendData;
                    if (legend.dataFrom === "keys") legendData = legendDataForKeys;
                    else if (legend.dataFrom === "indexes") legendData = legendDataForIndexes;
                    if (legendData === undefined) return null;
                    (0, _legends.renderLegendToCanvas)(_this2.ctx, _objectSpread$3({}, legend, {
                        data: legendData,
                        containerWidth: width,
                        containerHeight: height,
                        itemTextColor: "#999",
                        symbolSize: 16
                    }));
                });
                (0, _axes.renderAxesToCanvas)(this.ctx, {
                    xScale: result.xScale,
                    yScale: result.yScale,
                    width: width,
                    height: height,
                    top: axisTop,
                    right: axisRight,
                    bottom: axisBottom,
                    left: axisLeft,
                    theme: theme
                });
                result.bars.forEach(function(bar) {
                    var x = bar.x, y = bar.y, color = bar.color, width = bar.width, height = bar.height;
                    _this2.ctx.fillStyle = color;
                    if (borderWidth > 0) {
                        _this2.ctx.strokeStyle = getBorderColor(bar);
                        _this2.ctx.lineWidth = borderWidth;
                    }
                    _this2.ctx.beginPath();
                    _this2.ctx.rect(x, y, width, height);
                    _this2.ctx.fill();
                    if (borderWidth > 0) _this2.ctx.stroke();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, outerWidth = _this$props3.outerWidth, outerHeight = _this$props3.outerHeight, pixelRatio = _this$props3.pixelRatio, isInteractive = _this$props3.isInteractive, theme = _this$props3.theme;
                return (0, _reactDefault.default).createElement((0, _core.Container), {
                    isInteractive: isInteractive,
                    theme: theme,
                    animate: false
                }, function(_ref3) {
                    var showTooltip = _ref3.showTooltip, hideTooltip = _ref3.hideTooltip;
                    return (0, _reactDefault.default).createElement("canvas", {
                        ref: function ref(surface) {
                            _this3.surface = surface;
                        },
                        width: outerWidth * pixelRatio,
                        height: outerHeight * pixelRatio,
                        style: {
                            width: outerWidth,
                            height: outerHeight
                        },
                        onMouseEnter: _this3.handleMouseHover(showTooltip, hideTooltip),
                        onMouseMove: _this3.handleMouseHover(showTooltip, hideTooltip),
                        onMouseLeave: _this3.handleMouseLeave(hideTooltip),
                        onClick: _this3.handleClick
                    });
                });
            }
        }
    ]);
    return BarCanvas;
}((0, _react.Component));
BarCanvas.propTypes = BarPropTypes;
var BarCanvas$1 = (0, _setDisplayNameDefault.default)("BarCanvas")(enhance$1(BarCanvas));
function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
var ResponsiveBar = function ResponsiveBar(props) {
    return (0, _reactDefault.default).createElement((0, _core.ResponsiveWrapper), null, function(_ref) {
        var width = _ref.width, height = _ref.height;
        return (0, _reactDefault.default).createElement(Bar$1, _extends$2({
            width: width,
            height: height
        }, props));
    });
};
function _extends$3() {
    _extends$3 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$3.apply(this, arguments);
}
var ResponsiveBarCanvas = function ResponsiveBarCanvas(props) {
    return (0, _reactDefault.default).createElement((0, _core.ResponsiveWrapper), null, function(_ref) {
        var width = _ref.width, height = _ref.height;
        return (0, _reactDefault.default).createElement(BarCanvas$1, _extends$3({
            width: width,
            height: height
        }, props));
    });
};

},{"react":"6AiW6","react-motion":"lqe7n","@nivo/core":"guBSY","@nivo/axes":"6YXID","@nivo/legends":"KxnAT","lodash/min":"3dnGH","lodash/max":"gXRHv","lodash/range":"8dl7w","d3-scale":"7Ll4r","lodash/flattenDepth":"9BpCx","d3-shape":"kgLQU","lodash/uniqBy":"56ibO","recompose/setDisplayName":"9JGr7","recompose/compose":"lv27x","recompose/defaultProps":"6nQWc","recompose/withPropsOnChange":"bf8Lh","recompose/pure":"9wymM","@nivo/colors":"c3QTw","prop-types":"kKQPU","@nivo/tooltip":"D7d3j","@nivo/annotations":"5HBnS","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lqe7n":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
function _interopRequire(obj) {
    return obj && obj.__esModule ? obj["default"] : obj;
}
var _Motion = require("b2278efbdb88ad05");
exports.Motion = _interopRequire(_Motion);
var _StaggeredMotion = require("5188d7b7221dbb73");
exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
var _TransitionMotion = require("2c225f0896d912e3");
exports.TransitionMotion = _interopRequire(_TransitionMotion);
var _spring = require("544afa4922dd4a1b");
exports.spring = _interopRequire(_spring);
var _presets = require("ff0694e38ea965b6");
exports.presets = _interopRequire(_presets);
var _stripStyle = require("6bf7ff44cbd11ae9");
exports.stripStyle = _interopRequire(_stripStyle);
// deprecated, dummy warning function
var _reorderKeys = require("a8adbcb565d16908");
exports.reorderKeys = _interopRequire(_reorderKeys);

},{"b2278efbdb88ad05":"7rpec","5188d7b7221dbb73":"cnrXk","2c225f0896d912e3":"bSUvH","544afa4922dd4a1b":"9857H","ff0694e38ea965b6":"7Pv1O","6bf7ff44cbd11ae9":"krFo6","a8adbcb565d16908":"dAhUU"}],"7rpec":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _mapToZero = require("f120b541eeeed904");
var _mapToZero2 = _interopRequireDefault(_mapToZero);
var _stripStyle = require("5e4131dea0a7a0bc");
var _stripStyle2 = _interopRequireDefault(_stripStyle);
var _stepper3 = require("8abbba9b27839a9f");
var _stepper4 = _interopRequireDefault(_stepper3);
var _performanceNow = require("344656bf65e6a22");
var _performanceNow2 = _interopRequireDefault(_performanceNow);
var _raf = require("cbd84c83e8d0281e");
var _raf2 = _interopRequireDefault(_raf);
var _shouldStopAnimation = require("d54f282637ad11aa");
var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
var _react = require("d49b3f0a63648400");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("8fb16a1aa200a26f");
var _propTypes2 = _interopRequireDefault(_propTypes);
var msPerFrame = 1000 / 60;
var Motion = function(_React$Component) {
    _inherits(Motion, _React$Component);
    _createClass(Motion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyle: _propTypes2["default"].objectOf(_propTypes2["default"].number),
                style: _propTypes2["default"].objectOf(_propTypes2["default"].oneOfType([
                    _propTypes2["default"].number,
                    _propTypes2["default"].object
                ])).isRequired,
                children: _propTypes2["default"].func.isRequired,
                onRest: _propTypes2["default"].func
            },
            enumerable: true
        }
    ]);
    function Motion(props) {
        var _this = this;
        _classCallCheck(this, Motion);
        _React$Component.call(this, props);
        this.wasAnimating = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyle = null;
        this.clearUnreadPropStyle = function(destStyle) {
            var dirty = false;
            var _state = _this.state;
            var currentStyle = _state.currentStyle;
            var currentVelocity = _state.currentVelocity;
            var lastIdealStyle = _state.lastIdealStyle;
            var lastIdealVelocity = _state.lastIdealVelocity;
            for(var key in destStyle){
                if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                var styleValue = destStyle[key];
                if (typeof styleValue === "number") {
                    if (!dirty) {
                        dirty = true;
                        currentStyle = _extends({}, currentStyle);
                        currentVelocity = _extends({}, currentVelocity);
                        lastIdealStyle = _extends({}, lastIdealStyle);
                        lastIdealVelocity = _extends({}, lastIdealVelocity);
                    }
                    currentStyle[key] = styleValue;
                    currentVelocity[key] = 0;
                    lastIdealStyle[key] = styleValue;
                    lastIdealVelocity[key] = 0;
                }
            }
            if (dirty) _this.setState({
                currentStyle: currentStyle,
                currentVelocity: currentVelocity,
                lastIdealStyle: lastIdealStyle,
                lastIdealVelocity: lastIdealVelocity
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = _raf2["default"](function(timestamp) {
                // check if we need to animate in the first place
                var propsStyle = _this.props.style;
                if (_shouldStopAnimation2["default"](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
                    if (_this.wasAnimating && _this.props.onRest) _this.props.onRest();
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.wasAnimating = false;
                    _this.accumulatedTime = 0;
                    return;
                }
                _this.wasAnimating = true;
                var currentTime = timestamp || _performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
                var newLastIdealStyle = {};
                var newLastIdealVelocity = {};
                var newCurrentStyle = {};
                var newCurrentVelocity = {};
                for(var key in propsStyle){
                    if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) continue;
                    var styleValue = propsStyle[key];
                    if (typeof styleValue === "number") {
                        newCurrentStyle[key] = styleValue;
                        newCurrentVelocity[key] = 0;
                        newLastIdealStyle[key] = styleValue;
                        newLastIdealVelocity[key] = 0;
                    } else {
                        var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
                        var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
                        for(var i = 0; i < framesToCatchUp; i++){
                            var _stepper = _stepper4["default"](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            newLastIdealStyleValue = _stepper[0];
                            newLastIdealVelocityValue = _stepper[1];
                        }
                        var _stepper2 = _stepper4["default"](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                        var nextIdealX = _stepper2[0];
                        var nextIdealV = _stepper2[1];
                        newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                        newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                        newLastIdealStyle[key] = newLastIdealStyleValue;
                        newLastIdealVelocity[key] = newLastIdealVelocityValue;
                    }
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * msPerFrame;
                _this.setState({
                    currentStyle: newCurrentStyle,
                    currentVelocity: newCurrentVelocity,
                    lastIdealStyle: newLastIdealStyle,
                    lastIdealVelocity: newLastIdealVelocity
                });
                _this.unreadPropStyle = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    Motion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyle = _props.defaultStyle;
        var style = _props.style;
        var currentStyle = defaultStyle || _stripStyle2["default"](style);
        var currentVelocity = _mapToZero2["default"](currentStyle);
        return {
            currentStyle: currentStyle,
            currentVelocity: currentVelocity,
            lastIdealStyle: currentStyle,
            lastIdealVelocity: currentVelocity
        };
    };
    // it's possible that currentStyle's value is stale: if props is immediately
    // changed from 0 to 400 to spring(0) again, the async currentStyle is still
    // at 0 (didn't have time to tick and interpolate even once). If we naively
    // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
    // In reality currentStyle should be 400
    Motion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = _performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyle != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyle);
        this.unreadPropStyle = props.style;
        if (this.animationID == null) {
            this.prevTime = _performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    Motion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            _raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    Motion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyle);
        return renderedChildren && _react2["default"].Children.only(renderedChildren);
    };
    return Motion;
}(_react2["default"].Component);
exports["default"] = Motion;
module.exports = exports["default"]; // after checking for unreadPropStyle != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

},{"f120b541eeeed904":"a36U4","5e4131dea0a7a0bc":"krFo6","8abbba9b27839a9f":"hK8Nn","344656bf65e6a22":"d94oG","cbd84c83e8d0281e":"4Oopo","d54f282637ad11aa":"dWhTN","d49b3f0a63648400":"6AiW6","8fb16a1aa200a26f":"kKQPU"}],"a36U4":[function(require,module,exports) {
// currently used to initiate the velocity style object to 0
"use strict";
exports.__esModule = true;
exports["default"] = mapToZero;
function mapToZero(obj) {
    var ret = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) ret[key] = 0;
    return ret;
}
module.exports = exports["default"];

},{}],"krFo6":[function(require,module,exports) {
// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
"use strict";
exports.__esModule = true;
exports["default"] = stripStyle;
function stripStyle(style) {
    var ret = {};
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        ret[key] = typeof style[key] === "number" ? style[key] : style[key].val;
    }
    return ret;
}
module.exports = exports["default"];

},{}],"hK8Nn":[function(require,module,exports) {
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
"use strict";
exports.__esModule = true;
exports["default"] = stepper;
var reusedTuple = [
    0,
    0
];
function stepper(secondPerFrame, x, v, destX, k, b, precision) {
    // Spring stiffness, in kg / s^2
    // for animations, destX is really spring length (spring at rest). initial
    // position is considered as the stretched/compressed position of a spring
    var Fspring = -k * (x - destX);
    // Damping, in kg / s
    var Fdamper = -b * v;
    // usually we put mass here, but for animation purposes, specifying mass is a
    // bit redundant. you could simply adjust k and b accordingly
    // let a = (Fspring + Fdamper) / mass;
    var a = Fspring + Fdamper;
    var newV = v + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
        reusedTuple[0] = destX;
        reusedTuple[1] = 0;
        return reusedTuple;
    }
    reusedTuple[0] = newX;
    reusedTuple[1] = newV;
    return reusedTuple;
}
module.exports = exports["default"]; // array reference around.

},{}],"d94oG":[function(require,module,exports) {
var process = require("f348cfb52b253442");
// Generated by CoffeeScript 1.7.1
(function() {
    var getNanoSeconds, hrtime, loadTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof process !== "undefined" && process !== null && process.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - loadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        loadTime = getNanoSeconds();
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(this);

},{"f348cfb52b253442":"g1F5c"}],"4Oopo":[function(require,module,exports) {
var global = arguments[3];
var now = require("cf76948a525d1513"), root = typeof window === "undefined" ? global : window, vendors = [
    "moz",
    "webkit"
], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
for(var i = 0; !raf && i < vendors.length; i++){
    raf = root[vendors[i] + "Request" + suffix];
    caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
}
// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
    var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
    raf = function(callback) {
        if (queue.length === 0) {
            var _now = now(), next = Math.max(0, frameDuration - (_now - last));
            last = next + _now;
            setTimeout(function() {
                var cp = queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback(last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        queue.push({
            handle: ++id,
            callback: callback,
            cancelled: false
        });
        return id;
    };
    caf = function(handle) {
        for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn);
};
module.exports.cancel = function() {
    caf.apply(root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = root;
    object.requestAnimationFrame = raf;
    object.cancelAnimationFrame = caf;
};

},{"cf76948a525d1513":"3gXhT"}],"3gXhT":[function(require,module,exports) {
var process = require("71d49479de03c0e7");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof process !== "undefined" && process !== null && process.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(this);

},{"71d49479de03c0e7":"g1F5c"}],"dWhTN":[function(require,module,exports) {
// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
"use strict";
exports.__esModule = true;
exports["default"] = shouldStopAnimation;
function shouldStopAnimation(currentStyle, style, currentVelocity) {
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        if (currentVelocity[key] !== 0) return false;
        var styleValue = typeof style[key] === "number" ? style[key] : style[key].val;
        // stepper will have already taken care of rounding precision errors, so
        // won't have such thing as 0.9999 !=== 1
        if (currentStyle[key] !== styleValue) return false;
    }
    return true;
}
module.exports = exports["default"];

},{}],"cnrXk":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _mapToZero = require("e54a895313009dd1");
var _mapToZero2 = _interopRequireDefault(_mapToZero);
var _stripStyle = require("17b00b987caefd1d");
var _stripStyle2 = _interopRequireDefault(_stripStyle);
var _stepper3 = require("64a2a223dc26cd88");
var _stepper4 = _interopRequireDefault(_stepper3);
var _performanceNow = require("4ccfd21d1ed09fd7");
var _performanceNow2 = _interopRequireDefault(_performanceNow);
var _raf = require("b297decacd85db62");
var _raf2 = _interopRequireDefault(_raf);
var _shouldStopAnimation = require("5985e072e5768ab1");
var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
var _react = require("2e3c6578fd8933e8");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("e3bd1a396f827857");
var _propTypes2 = _interopRequireDefault(_propTypes);
var msPerFrame = 1000 / 60;
function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
    for(var i = 0; i < currentStyles.length; i++){
        if (!_shouldStopAnimation2["default"](currentStyles[i], styles[i], currentVelocities[i])) return false;
    }
    return true;
}
var StaggeredMotion = function(_React$Component) {
    _inherits(StaggeredMotion, _React$Component);
    _createClass(StaggeredMotion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyles: _propTypes2["default"].arrayOf(_propTypes2["default"].objectOf(_propTypes2["default"].number)),
                styles: _propTypes2["default"].func.isRequired,
                children: _propTypes2["default"].func.isRequired
            },
            enumerable: true
        }
    ]);
    function StaggeredMotion(props) {
        var _this = this;
        _classCallCheck(this, StaggeredMotion);
        _React$Component.call(this, props);
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _state = _this.state;
            var currentStyles = _state.currentStyles;
            var currentVelocities = _state.currentVelocities;
            var lastIdealStyles = _state.lastIdealStyles;
            var lastIdealVelocities = _state.lastIdealVelocities;
            var someDirty = false;
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i];
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            someDirty = true;
                            currentStyles[i] = _extends({}, currentStyles[i]);
                            currentVelocities[i] = _extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                    }
                }
            }
            if (someDirty) _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = _raf2["default"](function(timestamp) {
                var destStyles = _this.props.styles(_this.state.lastIdealStyles);
                // check if we need to animate in the first place
                if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || _performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
                var newLastIdealStyles = [];
                var newLastIdealVelocities = [];
                var newCurrentStyles = [];
                var newCurrentVelocities = [];
                for(var i = 0; i < destStyles.length; i++){
                    var destStyle = destStyles[i];
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in destStyle){
                        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                        var styleValue = destStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
                            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = _stepper4["default"](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = _stepper4["default"](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    StaggeredMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var currentStyles = defaultStyles || styles().map(_stripStyle2["default"]);
        var currentVelocities = currentStyles.map(function(currentStyle) {
            return _mapToZero2["default"](currentStyle);
        });
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: currentStyles,
            lastIdealVelocities: currentVelocities
        };
    };
    StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = _performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
        if (this.animationID == null) {
            this.prevTime = _performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            _raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    StaggeredMotion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyles);
        return renderedChildren && _react2["default"].Children.only(renderedChildren);
    };
    return StaggeredMotion;
}(_react2["default"].Component);
exports["default"] = StaggeredMotion;
module.exports = exports["default"]; // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400
 // after checking for unreadPropStyles != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

},{"e54a895313009dd1":"a36U4","17b00b987caefd1d":"krFo6","64a2a223dc26cd88":"hK8Nn","4ccfd21d1ed09fd7":"d94oG","b297decacd85db62":"4Oopo","5985e072e5768ab1":"dWhTN","2e3c6578fd8933e8":"6AiW6","e3bd1a396f827857":"kKQPU"}],"bSUvH":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _mapToZero = require("8b49365747f27ca4");
var _mapToZero2 = _interopRequireDefault(_mapToZero);
var _stripStyle = require("dbf24fe6f096ba12");
var _stripStyle2 = _interopRequireDefault(_stripStyle);
var _stepper3 = require("970d0e88a8b82aab");
var _stepper4 = _interopRequireDefault(_stepper3);
var _mergeDiff = require("9be2e8553baed48c");
var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
var _performanceNow = require("51fc3bbb9a1bf865");
var _performanceNow2 = _interopRequireDefault(_performanceNow);
var _raf = require("29b9c0a439fc7295");
var _raf2 = _interopRequireDefault(_raf);
var _shouldStopAnimation = require("d92ecfdb604cc8e2");
var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
var _react = require("641e28b7cdec88c9");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("2c009b0eef433fee");
var _propTypes2 = _interopRequireDefault(_propTypes);
var msPerFrame = 1000 / 60;
// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    // Copy the value to a `const` so that Flow understands that the const won't
    // change and will be non-nullable in the callback below.
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        for(var j = 0; j < cUnreadPropStyles.length; j++){
            if (cUnreadPropStyles[j].key === mergedPropsStyle.key) return {
                key: cUnreadPropStyles[j].key,
                data: cUnreadPropStyles[j].data,
                style: plainStyles[i]
            };
        }
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
}
function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) return false;
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (mergedPropsStyles[i].key !== destStyles[i].key) return false;
    }
    // we have the invariant that mergedPropsStyles and
    // currentStyles/currentVelocities/last* are synced in terms of cells, see
    // mergeAndSync comment for more info
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (!_shouldStopAnimation2["default"](currentStyles[i], destStyles[i].style, currentVelocities[i])) return false;
    }
    return true;
}
// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = _mergeDiff2["default"](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
        var leavingStyle = willLeave(oldMergedPropsStyle);
        if (leavingStyle == null) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        if (_shouldStopAnimation2["default"](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        return {
            key: oldMergedPropsStyle.key,
            data: oldMergedPropsStyle.data,
            style: leavingStyle
        };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for(var i = 0; i < newMergedPropsStyles.length; i++){
        var newMergedPropsStyleCell = newMergedPropsStyles[i];
        var foundOldIndex = null;
        for(var j = 0; j < oldMergedPropsStyles.length; j++)if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
            foundOldIndex = j;
            break;
        }
        // TODO: key search code
        if (foundOldIndex == null) {
            var plainStyle = willEnter(newMergedPropsStyleCell);
            newCurrentStyles[i] = plainStyle;
            newLastIdealStyles[i] = plainStyle;
            var velocity = _mapToZero2["default"](newMergedPropsStyleCell.style);
            newCurrentVelocities[i] = velocity;
            newLastIdealVelocities[i] = velocity;
        } else {
            newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
            newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
            newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
            newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
        }
    }
    return [
        newMergedPropsStyles,
        newCurrentStyles,
        newCurrentVelocities,
        newLastIdealStyles,
        newLastIdealVelocities
    ];
}
var TransitionMotion = function(_React$Component) {
    _inherits(TransitionMotion, _React$Component);
    _createClass(TransitionMotion, null, [
        {
            key: "propTypes",
            value: {
                defaultStyles: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
                    key: _propTypes2["default"].string.isRequired,
                    data: _propTypes2["default"].any,
                    style: _propTypes2["default"].objectOf(_propTypes2["default"].number).isRequired
                })),
                styles: _propTypes2["default"].oneOfType([
                    _propTypes2["default"].func,
                    _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
                        key: _propTypes2["default"].string.isRequired,
                        data: _propTypes2["default"].any,
                        style: _propTypes2["default"].objectOf(_propTypes2["default"].oneOfType([
                            _propTypes2["default"].number,
                            _propTypes2["default"].object
                        ])).isRequired
                    }))
                ]).isRequired,
                children: _propTypes2["default"].func.isRequired,
                willEnter: _propTypes2["default"].func,
                willLeave: _propTypes2["default"].func,
                didLeave: _propTypes2["default"].func
            },
            enumerable: true
        },
        {
            key: "defaultProps",
            value: {
                willEnter: function willEnter(styleThatEntered) {
                    return _stripStyle2["default"](styleThatEntered.style);
                },
                // recall: returning null makes the current unmounting TransitionStyle
                // disappear immediately
                willLeave: function willLeave() {
                    return null;
                },
                didLeave: function didLeave() {}
            },
            enumerable: true
        }
    ]);
    function TransitionMotion(props) {
        var _this = this;
        _classCallCheck(this, TransitionMotion);
        _React$Component.call(this, props);
        this.unmounting = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
            var mergedPropsStyles = _mergeAndSync[0];
            var currentStyles = _mergeAndSync[1];
            var currentVelocities = _mergeAndSync[2];
            var lastIdealStyles = _mergeAndSync[3];
            var lastIdealVelocities = _mergeAndSync[4];
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i].style;
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            currentStyles[i] = _extends({}, currentStyles[i]);
                            currentVelocities[i] = _extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
                            mergedPropsStyles[i] = {
                                key: mergedPropsStyles[i].key,
                                data: mergedPropsStyles[i].data,
                                style: _extends({}, mergedPropsStyles[i].style)
                            };
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                        mergedPropsStyles[i].style[key] = styleValue;
                    }
                }
            }
            // unlike the other 2 components, we can't detect staleness and optionally
            // opt out of setState here. each style object's data might contain new
            // stuff we're not/cannot compare
            _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                mergedPropsStyles: mergedPropsStyles,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            if (_this.unmounting) return;
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = _raf2["default"](function(timestamp) {
                // https://github.com/chenglou/react-motion/pull/420
                // > if execution passes the conditional if (this.unmounting), then
                // executes async defaultRaf and after that component unmounts and after
                // that the callback of defaultRaf is called, then setState will be called
                // on unmounted component.
                if (_this.unmounting) return;
                var propStyles = _this.props.styles;
                var destStyles = typeof propStyles === "function" ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
                // check if we need to animate in the first place
                if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || _performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
                var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
                var newMergedPropsStyles = _mergeAndSync2[0];
                var newCurrentStyles = _mergeAndSync2[1];
                var newCurrentVelocities = _mergeAndSync2[2];
                var newLastIdealStyles = _mergeAndSync2[3];
                var newLastIdealVelocities = _mergeAndSync2[4];
                for(var i = 0; i < newMergedPropsStyles.length; i++){
                    var newMergedPropsStyle = newMergedPropsStyles[i].style;
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in newMergedPropsStyle){
                        if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) continue;
                        var styleValue = newMergedPropsStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = newLastIdealStyles[i][key];
                            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = _stepper4["default"](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = _stepper4["default"](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities,
                    mergedPropsStyles: newMergedPropsStyles
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    TransitionMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var willEnter = _props.willEnter;
        var willLeave = _props.willLeave;
        var didLeave = _props.didLeave;
        var destStyles = typeof styles === "function" ? styles(defaultStyles) : styles;
        // this is special. for the first time around, we don't have a comparison
        // between last (no last) and current merged props. we'll compute last so:
        // say default is {a, b} and styles (dest style) is {b, c}, we'll
        // fabricate last as {a, b}
        var oldMergedPropsStyles = undefined;
        if (defaultStyles == null) oldMergedPropsStyles = destStyles;
        else oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
            // TODO: key search code
            for(var i = 0; i < destStyles.length; i++){
                if (destStyles[i].key === defaultStyleCell.key) return destStyles[i];
            }
            return defaultStyleCell;
        });
        var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
            return _stripStyle2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return _stripStyle2["default"](s.style);
        });
        var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
            return _mapToZero2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return _mapToZero2["default"](s.style);
        });
        var _mergeAndSync3 = mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
        // understand that the willEnter and willLeave props have default values
        // and will always be present.
        willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
        var mergedPropsStyles = _mergeAndSync3[0];
        var currentStyles = _mergeAndSync3[1];
        var currentVelocities = _mergeAndSync3[2];
        var lastIdealStyles = _mergeAndSync3[3];
        var lastIdealVelocities = _mergeAndSync3[4];
        // oldLastIdealVelocities really
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: lastIdealStyles,
            lastIdealVelocities: lastIdealVelocities,
            mergedPropsStyles: mergedPropsStyles
        };
    };
    // after checking for unreadPropStyles != null, we manually go set the
    // non-interpolating values (those that are a number, without a spring
    // config)
    TransitionMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = _performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        var styles = props.styles;
        if (typeof styles === "function") this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
        else this.unreadPropStyles = styles;
        if (this.animationID == null) {
            this.prevTime = _performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounting = true;
        if (this.animationID != null) {
            _raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    TransitionMotion.prototype.render = function render() {
        var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
        var renderedChildren = this.props.children(hydratedStyles);
        return renderedChildren && _react2["default"].Children.only(renderedChildren);
    };
    return TransitionMotion;
}(_react2["default"].Component);
exports["default"] = TransitionMotion;
module.exports = exports["default"]; // list of styles, each containing interpolating values. Part of what's passed
 // to children function. Notice that this is
 // Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
 // data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
 // contains the key & data info (so that we only have a single source of truth
 // for these, and to save space). Check the comment for `rehydrateStyles` to
 // see how we regenerate the entirety of what's passed to children function
 // the array that keeps track of currently rendered stuff! Including stuff
 // that you've unmounted but that's still animating. This is where it lives
 // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400

},{"8b49365747f27ca4":"a36U4","dbf24fe6f096ba12":"krFo6","970d0e88a8b82aab":"hK8Nn","9be2e8553baed48c":"1cjUB","51fc3bbb9a1bf865":"d94oG","29b9c0a439fc7295":"4Oopo","d92ecfdb604cc8e2":"dWhTN","641e28b7cdec88c9":"6AiW6","2c009b0eef433fee":"kKQPU"}],"1cjUB":[function(require,module,exports) {
// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
"use strict";
exports.__esModule = true;
exports["default"] = mergeDiff;
function mergeDiff(prev, next, onRemove) {
    // bookkeeping for easier access of a key's index below. This is 2 allocations +
    // potentially triggering chrome hash map mode for objs (so it might be faster
    var prevKeyIndex = {};
    for(var i = 0; i < prev.length; i++)prevKeyIndex[prev[i].key] = i;
    var nextKeyIndex = {};
    for(var i = 0; i < next.length; i++)nextKeyIndex[next[i].key] = i;
    // first, an overly elaborate way of merging prev and next, eliminating
    // duplicates (in terms of keys). If there's dupe, keep the item in next).
    // This way of writing it saves allocations
    var ret = [];
    for(var i = 0; i < next.length; i++)ret[i] = next[i];
    for(var i = 0; i < prev.length; i++)if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
        // merge in keys that the user desires to kill
        var fill = onRemove(i, prev[i]);
        if (fill != null) ret.push(fill);
    }
    // now all the items all present. Core sorting logic to have the right order
    return ret.sort(function(a, b) {
        var nextOrderA = nextKeyIndex[a.key];
        var nextOrderB = nextKeyIndex[b.key];
        var prevOrderA = prevKeyIndex[a.key];
        var prevOrderB = prevKeyIndex[b.key];
        if (nextOrderA != null && nextOrderB != null) // both keys in next
        return nextKeyIndex[a.key] - nextKeyIndex[b.key];
        else if (prevOrderA != null && prevOrderB != null) // both keys in prev
        return prevKeyIndex[a.key] - prevKeyIndex[b.key];
        else if (nextOrderA != null) {
            // key a in next, key b in prev
            // how to determine the order between a and b? We find a "pivot" (term
            // abuse), a key present in both prev and next, that is sandwiched between
            // a and b. In the context of our above example, if we're comparing a and
            // d, b's (the only) pivot
            for(var i = 0; i < next.length; i++){
                var pivot = next[i].key;
                if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
                if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) return -1;
                else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) return 1;
            }
            // pluggable. default to: next bigger than prev
            return 1;
        }
        // prevOrderA, nextOrderB
        for(var i = 0; i < next.length; i++){
            var pivot = next[i].key;
            if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
            if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) return 1;
            else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) return -1;
        }
        // pluggable. default to: next bigger than prev
        return -1;
    });
}
module.exports = exports["default"]; // to loop through and find a key's index each time), but I no longer care

},{}],"9857H":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports["default"] = spring;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var _presets = require("89b95437786fde98");
var _presets2 = _interopRequireDefault(_presets);
var defaultConfig = _extends({}, _presets2["default"].noWobble, {
    precision: 0.01
});
function spring(val, config) {
    return _extends({}, defaultConfig, config, {
        val: val
    });
}
module.exports = exports["default"];

},{"89b95437786fde98":"7Pv1O"}],"7Pv1O":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports["default"] = {
    noWobble: {
        stiffness: 170,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 210,
        damping: 20
    }
};
module.exports = exports["default"];

},{}],"dAhUU":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports["default"] = reorderKeys;
var hasWarned = false;
function reorderKeys() {}
module.exports = exports["default"];

},{}],"guBSY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianMarkers", ()=>CartesianMarkers$1);
parcelHelpers.export(exports, "CartesianMarkersItem", ()=>CartesianMarkersItem$1);
parcelHelpers.export(exports, "Container", ()=>Container);
parcelHelpers.export(exports, "Defs", ()=>Defs$1);
parcelHelpers.export(exports, "DotsItem", ()=>DotsItem$1);
parcelHelpers.export(exports, "DotsItemDefaultProps", ()=>DotsItemDefaultProps);
parcelHelpers.export(exports, "LinearGradient", ()=>LinearGradient);
parcelHelpers.export(exports, "MotionConfigProvider", ()=>MotionConfigProvider);
parcelHelpers.export(exports, "PatternDots", ()=>PatternDots);
parcelHelpers.export(exports, "PatternLines", ()=>PatternLines);
parcelHelpers.export(exports, "PatternSquares", ()=>PatternSquares);
parcelHelpers.export(exports, "ResponsiveWrapper", ()=>ResponsiveWrapper);
parcelHelpers.export(exports, "SmartMotion", ()=>SmartMotion);
parcelHelpers.export(exports, "SvgWrapper", ()=>SvgWrapper);
parcelHelpers.export(exports, "TWO_PI", ()=>TWO_PI);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "absoluteAngleDegrees", ()=>absoluteAngleDegrees);
parcelHelpers.export(exports, "absoluteAngleRadians", ()=>absoluteAngleRadians);
parcelHelpers.export(exports, "alignBox", ()=>alignBox);
parcelHelpers.export(exports, "annotationsPropType", ()=>annotationsPropType);
parcelHelpers.export(exports, "areaCurvePropKeys", ()=>areaCurvePropKeys);
parcelHelpers.export(exports, "areaCurvePropType", ()=>areaCurvePropType);
parcelHelpers.export(exports, "axisThemePropType", ()=>axisThemePropType);
parcelHelpers.export(exports, "bindDefs", ()=>bindDefs);
parcelHelpers.export(exports, "blendModePropType", ()=>blendModePropType);
parcelHelpers.export(exports, "blendModes", ()=>blendModes);
parcelHelpers.export(exports, "boxAlignments", ()=>boxAlignments);
parcelHelpers.export(exports, "closedCurvePropKeys", ()=>closedCurvePropKeys);
parcelHelpers.export(exports, "closedCurvePropType", ()=>closedCurvePropType);
parcelHelpers.export(exports, "colorInterpolatorIds", ()=>colorInterpolatorIds);
parcelHelpers.export(exports, "colorInterpolators", ()=>colorInterpolators);
parcelHelpers.export(exports, "colorSchemeIds", ()=>colorSchemeIds);
parcelHelpers.export(exports, "computeArcBoundingBox", ()=>computeArcBoundingBox);
parcelHelpers.export(exports, "crosshairPropType", ()=>crosshairPropType);
parcelHelpers.export(exports, "curveFromProp", ()=>curveFromProp);
parcelHelpers.export(exports, "curvePropKeys", ()=>curvePropKeys);
parcelHelpers.export(exports, "curvePropMapping", ()=>curvePropMapping);
parcelHelpers.export(exports, "curvePropType", ()=>curvePropType);
parcelHelpers.export(exports, "defaultAnimate", ()=>defaultAnimate);
parcelHelpers.export(exports, "defaultCategoricalColors", ()=>defaultCategoricalColors);
parcelHelpers.export(exports, "defaultColorRange", ()=>defaultColorRange);
parcelHelpers.export(exports, "defaultMargin", ()=>defaultMargin);
parcelHelpers.export(exports, "defaultMotionDamping", ()=>defaultMotionDamping);
parcelHelpers.export(exports, "defaultMotionStiffness", ()=>defaultMotionStiffness);
parcelHelpers.export(exports, "defaultTheme", ()=>defaultTheme);
parcelHelpers.export(exports, "defsPropTypes", ()=>defsPropTypes);
parcelHelpers.export(exports, "degreesToRadians", ()=>degreesToRadians);
parcelHelpers.export(exports, "dotsThemePropType", ()=>dotsThemePropType);
parcelHelpers.export(exports, "extendDefaultTheme", ()=>extendDefaultTheme);
parcelHelpers.export(exports, "getAccessorFor", ()=>getAccessorFor);
parcelHelpers.export(exports, "getAccessorOrValue", ()=>getAccessorOrValue);
parcelHelpers.export(exports, "getAngle", ()=>getAngle);
parcelHelpers.export(exports, "getColorScale", ()=>getColorScale);
parcelHelpers.export(exports, "getDistance", ()=>getDistance);
parcelHelpers.export(exports, "getHoveredArc", ()=>getHoveredArc);
parcelHelpers.export(exports, "getLabelGenerator", ()=>getLabelGenerator);
parcelHelpers.export(exports, "getPolarLabelProps", ()=>getPolarLabelProps);
parcelHelpers.export(exports, "getRelativeCursor", ()=>getRelativeCursor);
parcelHelpers.export(exports, "getValueFormatter", ()=>getValueFormatter);
parcelHelpers.export(exports, "gradientTypes", ()=>gradientTypes);
parcelHelpers.export(exports, "gridThemePropType", ()=>gridThemePropType);
parcelHelpers.export(exports, "guessQuantizeColorScale", ()=>guessQuantizeColorScale);
parcelHelpers.export(exports, "isCursorInRect", ()=>isCursorInRect);
parcelHelpers.export(exports, "isCursorInRing", ()=>isCursorInRing);
parcelHelpers.export(exports, "isMatchingDef", ()=>isMatchingDef);
parcelHelpers.export(exports, "labelsThemePropType", ()=>labelsThemePropType);
parcelHelpers.export(exports, "legendsThemePropType", ()=>legendsThemePropType);
parcelHelpers.export(exports, "lineCurvePropKeys", ()=>lineCurvePropKeys);
parcelHelpers.export(exports, "lineCurvePropType", ()=>lineCurvePropType);
parcelHelpers.export(exports, "linearGradientDef", ()=>linearGradientDef);
parcelHelpers.export(exports, "marginPropType", ()=>marginPropType);
parcelHelpers.export(exports, "markersThemePropType", ()=>markersThemePropType);
parcelHelpers.export(exports, "midAngle", ()=>midAngle);
parcelHelpers.export(exports, "motionConfigContext", ()=>motionConfigContext);
parcelHelpers.export(exports, "motionPropTypes", ()=>motionPropTypes);
parcelHelpers.export(exports, "nivoCategoricalColors", ()=>nivoCategoricalColors);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "patternDotsDef", ()=>patternDotsDef);
parcelHelpers.export(exports, "patternLinesDef", ()=>patternLinesDef);
parcelHelpers.export(exports, "patternSquaresDef", ()=>patternSquaresDef);
parcelHelpers.export(exports, "patternTypes", ()=>patternTypes);
parcelHelpers.export(exports, "positionFromAngle", ()=>positionFromAngle);
parcelHelpers.export(exports, "quantizeColorScalePropType", ()=>quantizeColorScalePropType);
parcelHelpers.export(exports, "quantizeColorScales", ()=>quantizeColorScales);
parcelHelpers.export(exports, "quantizeColorScalesKeys", ()=>quantizeColorScalesKeys);
parcelHelpers.export(exports, "radiansToDegrees", ()=>radiansToDegrees);
parcelHelpers.export(exports, "stackOffsetFromProp", ()=>stackOffsetFromProp);
parcelHelpers.export(exports, "stackOffsetPropKeys", ()=>stackOffsetPropKeys);
parcelHelpers.export(exports, "stackOffsetPropMapping", ()=>stackOffsetPropMapping);
parcelHelpers.export(exports, "stackOffsetPropType", ()=>stackOffsetPropType);
parcelHelpers.export(exports, "stackOrderFromProp", ()=>stackOrderFromProp);
parcelHelpers.export(exports, "stackOrderPropKeys", ()=>stackOrderPropKeys);
parcelHelpers.export(exports, "stackOrderPropMapping", ()=>stackOrderPropMapping);
parcelHelpers.export(exports, "stackOrderPropType", ()=>stackOrderPropType);
parcelHelpers.export(exports, "textPropsByEngine", ()=>textPropsByEngine);
parcelHelpers.export(exports, "themeContext", ()=>themeContext);
parcelHelpers.export(exports, "themePropType", ()=>themePropType);
parcelHelpers.export(exports, "treeMapTileFromProp", ()=>treeMapTileFromProp);
parcelHelpers.export(exports, "treeMapTilePropKeys", ()=>treeMapTilePropKeys);
parcelHelpers.export(exports, "treeMapTilePropMapping", ()=>treeMapTilePropMapping);
parcelHelpers.export(exports, "treeMapTilePropType", ()=>treeMapTilePropType);
parcelHelpers.export(exports, "useCurveInterpolation", ()=>useCurveInterpolation);
parcelHelpers.export(exports, "useDimensions", ()=>useDimensions);
parcelHelpers.export(exports, "useMotionConfig", ()=>useMotionConfig);
parcelHelpers.export(exports, "usePartialTheme", ()=>usePartialTheme);
parcelHelpers.export(exports, "useTheme", ()=>useTheme);
parcelHelpers.export(exports, "useValueFormatter", ()=>useValueFormatter);
parcelHelpers.export(exports, "withContainer", ()=>withContainer);
parcelHelpers.export(exports, "withCurve", ()=>withCurve);
parcelHelpers.export(exports, "withDimensions", ()=>withDimensions);
parcelHelpers.export(exports, "withHierarchy", ()=>withHierarchy);
parcelHelpers.export(exports, "withMotion", ()=>withMotion);
parcelHelpers.export(exports, "withTheme", ()=>withTheme);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tooltip = require("@nivo/tooltip");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _isArray = require("lodash/isArray");
var _isArrayDefault = parcelHelpers.interopDefault(_isArray);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _d3Scale = require("d3-scale");
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _d3Shape = require("d3-shape");
var _d3Hierarchy = require("d3-hierarchy");
var _d3Format = require("d3-format");
var _d3TimeFormat = require("d3-time-format");
var _reactMotion = require("react-motion");
var _d3Interpolate = require("d3-interpolate");
var _reactMeasure = require("react-measure");
var _reactMeasureDefault = parcelHelpers.interopDefault(_reactMeasure);
var _withProps = require("recompose/withProps");
var _withPropsDefault = parcelHelpers.interopDefault(_withProps);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _compose = require("recompose/compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _setPropTypes = require("recompose/setPropTypes");
var _setPropTypesDefault = parcelHelpers.interopDefault(_setPropTypes);
var _defaultProps = require("recompose/defaultProps");
var _defaultPropsDefault = parcelHelpers.interopDefault(_defaultProps);
var _withPropsOnChange = require("recompose/withPropsOnChange");
var _withPropsOnChangeDefault = parcelHelpers.interopDefault(_withPropsOnChange);
var _partialRight = require("lodash/partialRight");
var _partialRightDefault = parcelHelpers.interopDefault(_partialRight);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var noop = function() {};
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var textProps = {
    fill: (0, _propTypesDefault.default).string,
    fontSize: (0, _propTypesDefault.default).number,
    fontFamily: (0, _propTypesDefault.default).string
};
var axisThemePropType = (0, _propTypesDefault.default).shape({
    domain: (0, _propTypesDefault.default).shape({
        line: (0, _propTypesDefault.default).shape({
            stroke: (0, _propTypesDefault.default).string.isRequired,
            strokeWidth: (0, _propTypesDefault.default).number.isRequired,
            strokeDasharray: (0, _propTypesDefault.default).string
        }).isRequired
    }).isRequired,
    ticks: (0, _propTypesDefault.default).shape({
        line: (0, _propTypesDefault.default).shape({
            stroke: (0, _propTypesDefault.default).string.isRequired,
            strokeWidth: (0, _propTypesDefault.default).number.isRequired,
            strokeDasharray: (0, _propTypesDefault.default).string
        }).isRequired,
        text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps)).isRequired
    }).isRequired,
    legend: (0, _propTypesDefault.default).shape({
        text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps)).isRequired
    }).isRequired
});
var gridThemePropType = (0, _propTypesDefault.default).shape({
    line: (0, _propTypesDefault.default).shape({
        stroke: (0, _propTypesDefault.default).string.isRequired,
        strokeWidth: (0, _propTypesDefault.default).number.isRequired,
        strokeDasharray: (0, _propTypesDefault.default).string
    }).isRequired
});
var legendsThemePropType = (0, _propTypesDefault.default).shape({
    text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps)).isRequired
});
var labelsThemePropType = (0, _propTypesDefault.default).shape({
    text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps)).isRequired
});
var dotsThemePropType = (0, _propTypesDefault.default).shape({
    text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps)).isRequired
});
var markersThemePropType = (0, _propTypesDefault.default).shape({
    text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps)).isRequired
});
var crosshairPropType = (0, _propTypesDefault.default).shape({
    line: (0, _propTypesDefault.default).shape({
        stroke: (0, _propTypesDefault.default).string.isRequired,
        strokeWidth: (0, _propTypesDefault.default).number.isRequired,
        strokeDasharray: (0, _propTypesDefault.default).string
    }).isRequired
});
var annotationsPropType = (0, _propTypesDefault.default).shape({
    text: (0, _propTypesDefault.default).shape(_objectSpread({}, textProps, {
        outlineWidth: (0, _propTypesDefault.default).number.isRequired,
        outlineColor: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    link: (0, _propTypesDefault.default).shape({
        stroke: (0, _propTypesDefault.default).string.isRequired,
        strokeWidth: (0, _propTypesDefault.default).number.isRequired,
        outlineWidth: (0, _propTypesDefault.default).number.isRequired,
        outlineColor: (0, _propTypesDefault.default).string.isRequired
    }).isRequired,
    outline: (0, _propTypesDefault.default).shape({
        stroke: (0, _propTypesDefault.default).string.isRequired,
        strokeWidth: (0, _propTypesDefault.default).number.isRequired,
        outlineWidth: (0, _propTypesDefault.default).number.isRequired,
        outlineColor: (0, _propTypesDefault.default).string.isRequired
    }).isRequired,
    symbol: (0, _propTypesDefault.default).shape({
        fill: (0, _propTypesDefault.default).string.isRequired,
        outlineWidth: (0, _propTypesDefault.default).number.isRequired,
        outlineColor: (0, _propTypesDefault.default).string.isRequired
    }).isRequired
});
var themePropType = (0, _propTypesDefault.default).shape({
    background: (0, _propTypesDefault.default).string.isRequired,
    fontFamily: (0, _propTypesDefault.default).string.isRequired,
    fontSize: (0, _propTypesDefault.default).number.isRequired,
    textColor: (0, _propTypesDefault.default).string.isRequired,
    axis: axisThemePropType.isRequired,
    grid: gridThemePropType.isRequired,
    legends: legendsThemePropType.isRequired,
    labels: labelsThemePropType.isRequired,
    dots: dotsThemePropType.isRequired,
    markers: markersThemePropType,
    crosshair: crosshairPropType.isRequired,
    annotations: annotationsPropType.isRequired
});
var defaultTheme = {
    background: "transparent",
    fontFamily: "sans-serif",
    fontSize: 11,
    textColor: "#333333",
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        text: {
            fill: "#333333"
        }
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: 0.75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff"
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff"
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff"
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff"
        }
    }
};
var fontProps = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
];
var extendDefaultTheme = function extendDefaultTheme(defaultTheme, customTheme) {
    var theme = (0, _mergeDefault.default)({}, defaultTheme, customTheme);
    fontProps.forEach(function(prop) {
        if ((0, _getDefault.default)(theme, "".concat(prop, ".fontFamily")) === undefined) (0, _setDefault.default)(theme, "".concat(prop, ".fontFamily"), theme.fontFamily);
        if ((0, _getDefault.default)(theme, "".concat(prop, ".fontSize")) === undefined) (0, _setDefault.default)(theme, "".concat(prop, ".fontSize"), theme.fontSize);
        if ((0, _getDefault.default)(theme, "".concat(prop, ".fill")) === undefined) (0, _setDefault.default)(theme, "".concat(prop, ".fill"), theme.textColor);
    });
    return theme;
};
var quantizeColorScales = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBrBG)),
    PRGn: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePRGn)),
    PiYG: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePiYG)),
    PuOr: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuOr)),
    RdBu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdBu)),
    RdGy: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdGy)),
    RdYlBu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdYlBu)),
    RdYlGn: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdYlGn)),
    spectral: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeSpectral)),
    blues: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBlues)),
    greens: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeGreens)),
    greys: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeGreys)),
    oranges: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeOranges)),
    purples: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePurples)),
    reds: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeReds)),
    BuGn: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBuGn)),
    BuPu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBuPu)),
    GnBu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeGnBu)),
    OrRd: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeOrRd)),
    PuBuGn: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuBuGn)),
    PuBu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuBu)),
    PuRd: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuRd)),
    RdPu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdPu)),
    YlGnBu: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlGnBu)),
    YlGn: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlGn)),
    YlOrBr: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlOrBr)),
    YlOrRd: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlOrRd))
};
var quantizeColorScalesKeys = Object.keys(quantizeColorScales);
var guessQuantizeColorScale = function guessQuantizeColorScale(colors) {
    if ((0, _isFunctionDefault.default)(colors)) {
        if (!(0, _isFunctionDefault.default)(colors.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return colors;
    }
    if (quantizeColorScales[colors]) return (0, _d3Scale.scaleQuantize)().range(quantizeColorScales[colors]);
    if ((0, _isArrayDefault.default)(colors)) return (0, _d3Scale.scaleQuantize)().range(colors);
    throw new Error("Unable to guess quantize color scale from '".concat(colors, "',\nmust be a function or one of:\n'").concat(quantizeColorScalesKeys.join("', '"), "'"));
};
var colorSchemes = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, _d3ScaleChromatic.schemeCategory10),
    accent: (0, _d3ScaleChromatic.schemeAccent),
    dark2: (0, _d3ScaleChromatic.schemeDark2),
    paired: (0, _d3ScaleChromatic.schemePaired),
    pastel1: (0, _d3ScaleChromatic.schemePastel1),
    pastel2: (0, _d3ScaleChromatic.schemePastel2),
    set1: (0, _d3ScaleChromatic.schemeSet1),
    set2: (0, _d3ScaleChromatic.schemeSet2),
    set3: (0, _d3ScaleChromatic.schemeSet3),
    brown_blueGreen: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBrBG)),
    purpleRed_green: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePRGn)),
    pink_yellowGreen: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePiYG)),
    purple_orange: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuOr)),
    red_blue: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdBu)),
    red_grey: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdGy)),
    red_yellow_blue: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdYlBu)),
    red_yellow_green: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdYlGn)),
    spectral: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeSpectral)),
    blues: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBlues)),
    greens: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeGreens)),
    greys: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeGreys)),
    oranges: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeOranges)),
    purples: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePurples)),
    reds: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeReds)),
    blue_green: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBuGn)),
    blue_purple: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeBuPu)),
    green_blue: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeGnBu)),
    orange_red: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeOrRd)),
    purple_blue_green: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuBuGn)),
    purple_blue: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuBu)),
    purple_red: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemePuRd)),
    red_purple: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeRdPu)),
    yellow_green_blue: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlGnBu)),
    yellow_green: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlGn)),
    yellow_orange_brown: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlOrBr)),
    yellow_orange_red: (0, _lastDefault.default)((0, _d3ScaleChromatic.schemeYlOrRd))
};
var colorSchemeIds = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
];
var colorInterpolators = {
    brown_blueGreen: (0, _d3ScaleChromatic.interpolateBrBG),
    purpleRed_green: (0, _d3ScaleChromatic.interpolatePRGn),
    pink_yellowGreen: (0, _d3ScaleChromatic.interpolatePiYG),
    purple_orange: (0, _d3ScaleChromatic.interpolatePuOr),
    red_blue: (0, _d3ScaleChromatic.interpolateRdBu),
    red_grey: (0, _d3ScaleChromatic.interpolateRdGy),
    red_yellow_blue: (0, _d3ScaleChromatic.interpolateRdYlBu),
    red_yellow_green: (0, _d3ScaleChromatic.interpolateRdYlGn),
    spectral: (0, _d3ScaleChromatic.interpolateSpectral),
    blues: (0, _d3ScaleChromatic.interpolateBlues),
    greens: (0, _d3ScaleChromatic.interpolateGreens),
    greys: (0, _d3ScaleChromatic.interpolateGreys),
    oranges: (0, _d3ScaleChromatic.interpolateOranges),
    purples: (0, _d3ScaleChromatic.interpolatePurples),
    reds: (0, _d3ScaleChromatic.interpolateReds),
    viridis: (0, _d3ScaleChromatic.interpolateViridis),
    inferno: (0, _d3ScaleChromatic.interpolateInferno),
    magma: (0, _d3ScaleChromatic.interpolateMagma),
    plasma: (0, _d3ScaleChromatic.interpolatePlasma),
    warm: (0, _d3ScaleChromatic.interpolateWarm),
    cool: (0, _d3ScaleChromatic.interpolateCool),
    cubehelixDefault: (0, _d3ScaleChromatic.interpolateCubehelixDefault),
    blue_green: (0, _d3ScaleChromatic.interpolateBuGn),
    blue_purple: (0, _d3ScaleChromatic.interpolateBuPu),
    green_blue: (0, _d3ScaleChromatic.interpolateGnBu),
    orange_red: (0, _d3ScaleChromatic.interpolateOrRd),
    purple_blue_green: (0, _d3ScaleChromatic.interpolatePuBuGn),
    purple_blue: (0, _d3ScaleChromatic.interpolatePuBu),
    purple_red: (0, _d3ScaleChromatic.interpolatePuRd),
    red_purple: (0, _d3ScaleChromatic.interpolateRdPu),
    yellow_green_blue: (0, _d3ScaleChromatic.interpolateYlGnBu),
    yellow_green: (0, _d3ScaleChromatic.interpolateYlGn),
    yellow_orange_brown: (0, _d3ScaleChromatic.interpolateYlOrBr),
    yellow_orange_red: (0, _d3ScaleChromatic.interpolateYlOrRd),
    rainbow: (0, _d3ScaleChromatic.interpolateRainbow),
    sinebow: (0, _d3ScaleChromatic.interpolateSinebow)
};
var colorInterpolatorIds = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
];
var nivoCategoricalColors = function nivoCategoricalColors() {
    return (0, _d3Scale.scaleOrdinal)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
};
var getColorScale = function getColorScale(colors, dataScale) {
    if ((0, _isStringDefault.default)(colors)) {
        var scheme = colorSchemes[colors];
        if (scheme !== undefined) {
            var scale = (0, _d3Scale.scaleOrdinal)(scheme);
            scale.type = "ordinal";
            return scale;
        }
        if (dataScale !== undefined && colors.indexOf("seq:") === 0) {
            var interpolator = colorInterpolators[colors.slice(4)];
            if (interpolator !== undefined) {
                var _scale = (0, _d3Scale.scaleSequential)(interpolator).domain(dataScale.domain());
                _scale.type = "sequential";
                return _scale;
            }
        }
    }
    if ((0, _isArrayDefault.default)(colors)) {
        var _scale2 = (0, _d3Scale.scaleOrdinal)(colors);
        _scale2.type = "ordinal";
        return _scale2;
    }
    return function() {
        return colors;
    };
};
var quantizeColorScalePropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf(quantizeColorScalesKeys),
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
]);
var curvePropMapping = {
    basis: (0, _d3Shape.curveBasis),
    basisClosed: (0, _d3Shape.curveBasisClosed),
    basisOpen: (0, _d3Shape.curveBasisOpen),
    bundle: (0, _d3Shape.curveBundle),
    cardinal: (0, _d3Shape.curveCardinal),
    cardinalClosed: (0, _d3Shape.curveCardinalClosed),
    cardinalOpen: (0, _d3Shape.curveCardinalOpen),
    catmullRom: (0, _d3Shape.curveCatmullRom),
    catmullRomClosed: (0, _d3Shape.curveCatmullRomClosed),
    catmullRomOpen: (0, _d3Shape.curveCatmullRomOpen),
    linear: (0, _d3Shape.curveLinear),
    linearClosed: (0, _d3Shape.curveLinearClosed),
    monotoneX: (0, _d3Shape.curveMonotoneX),
    monotoneY: (0, _d3Shape.curveMonotoneY),
    natural: (0, _d3Shape.curveNatural),
    step: (0, _d3Shape.curveStep),
    stepAfter: (0, _d3Shape.curveStepAfter),
    stepBefore: (0, _d3Shape.curveStepBefore)
};
var curvePropKeys = Object.keys(curvePropMapping);
var curvePropType = (0, _propTypesDefault.default).oneOf(curvePropKeys);
var closedCurvePropKeys = curvePropKeys.filter(function(c) {
    return c.endsWith("Closed");
});
var closedCurvePropType = (0, _propTypesDefault.default).oneOf(closedCurvePropKeys);
var areaCurvePropKeys = (0, _withoutDefault.default)(curvePropKeys, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var areaCurvePropType = (0, _propTypesDefault.default).oneOf(areaCurvePropKeys);
var lineCurvePropKeys = (0, _withoutDefault.default)(curvePropKeys, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var lineCurvePropType = (0, _propTypesDefault.default).oneOf(lineCurvePropKeys);
var curveFromProp = function curveFromProp(id) {
    var curveInterpolator = curvePropMapping[id];
    if (!curveInterpolator) throw new TypeError("'".concat(id, "', is not a valid curve interpolator identifier."));
    return curvePropMapping[id];
};
var defsPropTypes = {
    defs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    fill: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        match: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                "*"
            ]),
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).func
        ]).isRequired
    })).isRequired
};
var stackOrderPropMapping = {
    ascending: (0, _d3Shape.stackOrderAscending),
    descending: (0, _d3Shape.stackOrderDescending),
    insideOut: (0, _d3Shape.stackOrderInsideOut),
    none: (0, _d3Shape.stackOrderNone),
    reverse: (0, _d3Shape.stackOrderReverse)
};
var stackOrderPropKeys = Object.keys(stackOrderPropMapping);
var stackOrderPropType = (0, _propTypesDefault.default).oneOf(stackOrderPropKeys);
var stackOrderFromProp = function stackOrderFromProp(prop) {
    return stackOrderPropMapping[prop];
};
var stackOffsetPropMapping = {
    expand: (0, _d3Shape.stackOffsetExpand),
    diverging: (0, _d3Shape.stackOffsetDiverging),
    none: (0, _d3Shape.stackOffsetNone),
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    wiggle: (0, _d3Shape.stackOffsetWiggle)
};
var stackOffsetPropKeys = Object.keys(stackOffsetPropMapping);
var stackOffsetPropType = (0, _propTypesDefault.default).oneOf(stackOffsetPropKeys);
var stackOffsetFromProp = function stackOffsetFromProp(prop) {
    return stackOffsetPropMapping[prop];
};
var treeMapTilePropMapping = {
    binary: (0, _d3Hierarchy.treemapBinary),
    dice: (0, _d3Hierarchy.treemapDice),
    slice: (0, _d3Hierarchy.treemapSlice),
    sliceDice: (0, _d3Hierarchy.treemapSliceDice),
    squarify: (0, _d3Hierarchy.treemapSquarify),
    resquarify: (0, _d3Hierarchy.treemapResquarify)
};
var treeMapTilePropKeys = Object.keys(treeMapTilePropMapping);
var treeMapTilePropType = (0, _propTypesDefault.default).oneOf(treeMapTilePropKeys);
var treeMapTileFromProp = function treeMapTileFromProp(prop) {
    return treeMapTilePropMapping[prop];
};
var marginPropType = (0, _propTypesDefault.default).shape({
    top: (0, _propTypesDefault.default).number,
    right: (0, _propTypesDefault.default).number,
    bottom: (0, _propTypesDefault.default).number,
    left: (0, _propTypesDefault.default).number
}).isRequired;
var motionPropTypes = {
    animate: (0, _propTypesDefault.default).bool.isRequired,
    motionStiffness: (0, _propTypesDefault.default).number.isRequired,
    motionDamping: (0, _propTypesDefault.default).number.isRequired
};
var blendModes = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
];
var blendModePropType = (0, _propTypesDefault.default).oneOf(blendModes);
var useCurveInterpolation = function useCurveInterpolation(interpolation) {
    return (0, _react.useMemo)(function() {
        return curveFromProp(interpolation);
    }, [
        interpolation
    ]);
};
var defaultAnimate = true;
var defaultMotionStiffness = 90;
var defaultMotionDamping = 15;
var defaultCategoricalColors = nivoCategoricalColors;
var defaultColorRange = (0, _d3Scale.scaleOrdinal)((0, _d3ScaleChromatic.schemeSet3));
var defaultMargin = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var useDimensions = function useDimensions(width, height) {
    var partialMargin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0, _react.useMemo)(function() {
        var margin = _objectSpread$1({}, defaultMargin, partialMargin);
        return {
            margin: margin,
            innerWidth: width - margin.left - margin.right,
            innerHeight: height - margin.top - margin.bottom,
            outerWidth: width,
            outerHeight: height
        };
    }, [
        width,
        height,
        partialMargin.top,
        partialMargin.right,
        partialMargin.bottom,
        partialMargin.left
    ]);
};
var usePartialTheme = function usePartialTheme(partialTheme) {
    return (0, _react.useMemo)(function() {
        return extendDefaultTheme(defaultTheme, partialTheme);
    }, [
        partialTheme
    ]);
};
var getValueFormatter = function getValueFormatter(format$1) {
    if (typeof format$1 === "function") return format$1;
    if (typeof format$1 === "string") {
        if (format$1.indexOf("time:") === 0) return (0, _d3TimeFormat.timeFormat)(format$1.slice("5"));
        return (0, _d3Format.format)(format$1);
    }
    return function(v) {
        return v;
    };
};
var useValueFormatter = function useValueFormatter(format) {
    return (0, _react.useMemo)(function() {
        return getValueFormatter(format);
    }, [
        format
    ]);
};
var themeContext = (0, _react.createContext)();
var defaultPartialTheme = {};
var ThemeProvider = function ThemeProvider(_ref) {
    var _ref$theme = _ref.theme, partialTheme = _ref$theme === void 0 ? defaultPartialTheme : _ref$theme, children = _ref.children;
    var theme = usePartialTheme(partialTheme);
    return (0, _reactDefault.default).createElement(themeContext.Provider, {
        value: theme
    }, children);
};
ThemeProvider.propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    theme: (0, _propTypesDefault.default).object
};
var useTheme = function useTheme() {
    return (0, _react.useContext)(themeContext);
};
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var enhancedSpring = function enhancedSpring(value, config) {
    if (typeof value !== "number") return {
        value: value,
        config: config,
        interpolator: config && config.interpolator ? config.interpolator : (0, _d3Interpolate.interpolate)
    };
    return (0, _reactMotion.spring)(value, config);
};
var SmartMotion = function(_PureComponent) {
    _inherits(SmartMotion, _PureComponent);
    function SmartMotion() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, SmartMotion);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SmartMotion)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty$2(_assertThisInitialized(_this), "oldValues", {});
        _defineProperty$2(_assertThisInitialized(_this), "newInters", {});
        _defineProperty$2(_assertThisInitialized(_this), "currentStepValues", {});
        _defineProperty$2(_assertThisInitialized(_this), "stepValues", {});
        _defineProperty$2(_assertThisInitialized(_this), "stepInterpolators", {});
        return _this;
    }
    _createClass(SmartMotion, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, style = _this$props.style, children = _this$props.children, rest = _objectWithoutProperties(_this$props, [
                    "style",
                    "children"
                ]);
                var resolvedStyle = style(enhancedSpring);
                for(var key in resolvedStyle)if (resolvedStyle[key] && resolvedStyle[key].interpolator) {
                    this.currentStepValues[key] = this.currentStepValues[key] || 0;
                    if (typeof this.newInters[key] === "undefined" || resolvedStyle[key].value !== this.newInters[key].value) {
                        this.newInters[key] = resolvedStyle[key];
                        this.stepValues[key] = this.currentStepValues[key] + 1;
                        this.stepInterpolators[key] = this.newInters[key].interpolator(this.oldValues[key], this.newInters[key].value);
                    }
                    resolvedStyle[key] = (0, _reactMotion.spring)(this.stepValues[key], this.newInters[key].config);
                }
                return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), _extends({}, rest, {
                    style: resolvedStyle
                }), function(values) {
                    var newValues = {};
                    for(var _key2 in values)if (_this2.stepValues[_key2]) {
                        _this2.currentStepValues[_key2] = values[_key2];
                        var percentage = _this2.currentStepValues[_key2] - _this2.stepValues[_key2] + 1;
                        _this2.oldValues[_key2] = newValues[_key2] = _this2.stepInterpolators[_key2](percentage);
                    }
                    return children(_objectSpread$2({}, values, newValues));
                });
            }
        }
    ]);
    return SmartMotion;
}((0, _react.PureComponent));
_defineProperty$2(SmartMotion, "propTypes", {
    children: (0, _propTypesDefault.default).func.isRequired,
    style: (0, _propTypesDefault.default).func.isRequired
});
var motionConfigContext = (0, _react.createContext)();
var MotionConfigProvider = function MotionConfigProvider(_ref) {
    var children = _ref.children, animate = _ref.animate, stiffness = _ref.stiffness, damping = _ref.damping;
    var value = (0, _react.useMemo)(function() {
        return {
            animate: animate,
            springConfig: {
                stiffness: stiffness,
                damping: damping
            }
        };
    }, [
        animate,
        stiffness,
        damping
    ]);
    return (0, _reactDefault.default).createElement(motionConfigContext.Provider, {
        value: value
    }, children);
};
MotionConfigProvider.propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    animate: (0, _propTypesDefault.default).bool.isRequired,
    stiffness: (0, _propTypesDefault.default).number.isRequired,
    damping: (0, _propTypesDefault.default).number.isRequired
};
MotionConfigProvider.defaultProps = {
    animate: true,
    stiffness: 90,
    damping: 15
};
var useMotionConfig = function useMotionConfig() {
    return (0, _react.useContext)(motionConfigContext);
};
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var containerStyle = {
    position: "relative"
};
var tooltipStyle = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10
};
var Container = function Container(_ref) {
    var children = _ref.children, theme = _ref.theme, _ref$isInteractive = _ref.isInteractive, isInteractive = _ref$isInteractive === void 0 ? true : _ref$isInteractive, animate = _ref.animate, motionStiffness = _ref.motionStiffness, motionDamping = _ref.motionDamping;
    var containerEl = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)({
        isTooltipVisible: false,
        tooltipContent: null,
        position: {}
    }), _useState2 = _slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var showTooltip = (0, _react.useCallback)(function(content, event) {
        if (!containerEl) return;
        var bounds = containerEl.current.getBoundingClientRect();
        var clientX = event.clientX, clientY = event.clientY;
        var x = clientX - bounds.left;
        var y = clientY - bounds.top;
        var position = {};
        if (x < bounds.width / 2) position.left = x + 20;
        else position.right = bounds.width - x + 20;
        if (y < bounds.height / 2) position.top = y - 12;
        else position.bottom = bounds.height - y - 12;
        setState({
            isTooltipVisible: true,
            tooltipContent: content,
            position: position
        });
    }, [
        containerEl
    ]);
    var hideTooltip = (0, _react.useCallback)(function() {
        setState({
            isTooltipVisible: false,
            tooltipContent: null
        });
    });
    var isTooltipVisible = state.isTooltipVisible, tooltipContent = state.tooltipContent, position = state.position;
    var content;
    if (isInteractive === true) content = (0, _reactDefault.default).createElement("div", {
        style: containerStyle,
        ref: containerEl
    }, children({
        showTooltip: isInteractive ? showTooltip : noop,
        hideTooltip: isInteractive ? hideTooltip : noop
    }), isTooltipVisible && (0, _reactDefault.default).createElement("div", {
        style: _objectSpread$3({}, tooltipStyle, position, theme.tooltip)
    }, tooltipContent));
    else content = children({
        showTooltip: isInteractive ? showTooltip : noop,
        hideTooltip: isInteractive ? hideTooltip : noop
    });
    return (0, _reactDefault.default).createElement(themeContext.Provider, {
        value: theme
    }, (0, _reactDefault.default).createElement(MotionConfigProvider, {
        animate: animate,
        stiffness: motionStiffness,
        damping: motionDamping
    }, (0, _reactDefault.default).createElement((0, _tooltip.tooltipContext).Provider, {
        value: [
            showTooltip,
            hideTooltip
        ]
    }, content)));
};
Container.propTypes = {
    children: (0, _propTypesDefault.default).func.isRequired,
    isInteractive: (0, _propTypesDefault.default).bool,
    theme: (0, _propTypesDefault.default).object.isRequired,
    animate: (0, _propTypesDefault.default).bool.isRequired,
    motionStiffness: (0, _propTypesDefault.default).number,
    motionDamping: (0, _propTypesDefault.default).number
};
function _typeof$1(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$1 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$1(obj);
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$1(self);
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _assertThisInitialized$1(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ResponsiveWrapper = function(_Component) {
    _inherits$1(ResponsiveWrapper, _Component);
    function ResponsiveWrapper() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck$1(this, ResponsiveWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(ResponsiveWrapper)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty$4(_assertThisInitialized$1(_this), "state", {
            dimensions: {
                width: -1,
                height: -1
            }
        });
        return _this;
    }
    _createClass$1(ResponsiveWrapper, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$state$dimension = this.state.dimensions, width = _this$state$dimension.width, height = _this$state$dimension.height;
                var shouldRender = width > 0 && height > 0;
                return (0, _reactDefault.default).createElement((0, _reactMeasureDefault.default), {
                    bounds: true,
                    onResize: function onResize(contentRect) {
                        _this2.setState({
                            dimensions: contentRect.bounds
                        });
                    }
                }, function(_ref) {
                    var measureRef = _ref.measureRef;
                    return (0, _reactDefault.default).createElement("div", {
                        ref: measureRef,
                        style: {
                            width: "100%",
                            height: "100%"
                        }
                    }, shouldRender && _this2.props.children({
                        width: width,
                        height: height
                    }));
                });
            }
        }
    ]);
    return ResponsiveWrapper;
}((0, _react.Component));
_defineProperty$4(ResponsiveWrapper, "propTypes", {
    children: (0, _propTypesDefault.default).func.isRequired
});
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var LinearGradient = function LinearGradient(_ref) {
    var id = _ref.id, colors = _ref.colors;
    return (0, _reactDefault.default).createElement("linearGradient", {
        id: id,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, colors.map(function(_ref2) {
        var offset = _ref2.offset, color = _ref2.color, opacity = _ref2.opacity;
        return (0, _reactDefault.default).createElement("stop", {
            key: offset,
            offset: "".concat(offset, "%"),
            stopColor: color,
            stopOpacity: opacity !== undefined ? opacity : 1
        });
    }));
};
LinearGradient.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        offset: (0, _propTypesDefault.default).number.isRequired,
        color: (0, _propTypesDefault.default).string.isRequired
    })).isRequired
};
var linearGradientDef = function linearGradientDef(id, colors) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _objectSpread$4({
        id: id,
        type: "linearGradient",
        colors: colors
    }, options);
};
var gradientTypes = {
    linearGradient: LinearGradient
};
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$6(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$6(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PatternDots = (0, _react.memo)(function(_ref) {
    var id = _ref.id, background = _ref.background, color = _ref.color, size = _ref.size, padding = _ref.padding, stagger = _ref.stagger;
    var fullSize = size + padding;
    var radius = size / 2;
    var halfPadding = padding / 2;
    if (stagger === true) fullSize = size * 2 + padding * 2;
    return (0, _reactDefault.default).createElement("pattern", {
        id: id,
        width: fullSize,
        height: fullSize,
        patternUnits: "userSpaceOnUse"
    }, (0, _reactDefault.default).createElement("rect", {
        width: fullSize,
        height: fullSize,
        fill: background
    }), (0, _reactDefault.default).createElement("circle", {
        cx: halfPadding + radius,
        cy: halfPadding + radius,
        r: radius,
        fill: color
    }), stagger && (0, _reactDefault.default).createElement("circle", {
        cx: padding * 1.5 + size + radius,
        cy: padding * 1.5 + size + radius,
        r: radius,
        fill: color
    }));
});
PatternDots.displayName = "PatternDots";
PatternDots.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    background: (0, _propTypesDefault.default).string.isRequired,
    size: (0, _propTypesDefault.default).number.isRequired,
    padding: (0, _propTypesDefault.default).number.isRequired,
    stagger: (0, _propTypesDefault.default).bool.isRequired
};
PatternDots.defaultProps = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: false
};
var patternDotsDef = function patternDotsDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread$5({
        id: id,
        type: "patternDots"
    }, options);
};
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$1(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
var TWO_PI = Math.PI * 2;
var degreesToRadians = function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
};
var radiansToDegrees = function radiansToDegrees(radians) {
    return 180 * radians / Math.PI;
};
var midAngle = function midAngle(arc) {
    return arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
};
var positionFromAngle = function positionFromAngle(angle, distance) {
    return {
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * distance
    };
};
var absoluteAngleDegrees = function absoluteAngleDegrees(angle) {
    var absAngle = angle % 360;
    if (absAngle < 0) absAngle += 360;
    return absAngle;
};
var absoluteAngleRadians = function absoluteAngleRadians(angle) {
    return angle - TWO_PI * Math.floor((angle + Math.PI) / TWO_PI);
};
var computeArcBoundingBox = function computeArcBoundingBox(ox, oy, radius, startAngle, endAngle) {
    var includeCenter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var points = [];
    var p0 = positionFromAngle(degreesToRadians(startAngle), radius);
    points.push([
        p0.x,
        p0.y
    ]);
    var p1 = positionFromAngle(degreesToRadians(endAngle), radius);
    points.push([
        p1.x,
        p1.y
    ]);
    for(var angle = Math.round(Math.min(startAngle, endAngle)); angle <= Math.round(Math.max(startAngle, endAngle)); angle++)if (angle % 90 === 0) {
        var p = positionFromAngle(degreesToRadians(angle), radius);
        points.push([
            p.x,
            p.y
        ]);
    }
    points = points.map(function(_ref) {
        var _ref2 = _slicedToArray$1(_ref, 2), x = _ref2[0], y = _ref2[1];
        return [
            ox + x,
            oy + y
        ];
    });
    if (includeCenter === true) points.push([
        ox,
        oy
    ]);
    var xs = points.map(function(_ref3) {
        var _ref4 = _slicedToArray$1(_ref3, 1), x = _ref4[0];
        return x;
    });
    var ys = points.map(function(_ref5) {
        var _ref6 = _slicedToArray$1(_ref5, 2), y = _ref6[1];
        return y;
    });
    var x0 = Math.min.apply(Math, _toConsumableArray(xs));
    var x1 = Math.max.apply(Math, _toConsumableArray(xs));
    var y0 = Math.min.apply(Math, _toConsumableArray(ys));
    var y1 = Math.max.apply(Math, _toConsumableArray(ys));
    return {
        points: points,
        x: x0,
        y: y0,
        width: x1 - x0,
        height: y1 - y0
    };
};
var textPropsByEngine = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
};
var getPolarLabelProps = function getPolarLabelProps(radius, angle, rotation) {
    var engine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "svg";
    var textProps = textPropsByEngine[engine];
    var _positionFromAngle = positionFromAngle(angle - Math.PI / 2, radius), x = _positionFromAngle.x, y = _positionFromAngle.y;
    var rotate = radiansToDegrees(angle);
    var align = textProps.align.center;
    var baseline = textProps.baseline.bottom;
    if (rotation > 0) {
        align = textProps.align.right;
        baseline = textProps.baseline.center;
    } else if (rotation < 0) {
        align = textProps.align.left;
        baseline = textProps.baseline.center;
    }
    if (rotation !== 0 && rotate > 180) {
        rotate -= 180;
        align = align === textProps.align.right ? textProps.align.left : textProps.align.right;
    }
    rotate += rotation;
    return {
        x: x,
        y: y,
        rotate: rotate,
        align: align,
        baseline: baseline
    };
};
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$7(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$7(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PatternLines = (0, _react.memo)(function(_ref) {
    var id = _ref.id, _spacing = _ref.spacing, _rotation = _ref.rotation, background = _ref.background, color = _ref.color, lineWidth = _ref.lineWidth;
    var rotation = Math.round(_rotation) % 360;
    var spacing = Math.abs(_spacing);
    if (rotation > 180) rotation = rotation - 360;
    else if (rotation > 90) rotation = rotation - 180;
    else if (rotation < -180) rotation = rotation + 360;
    else if (rotation < -90) rotation = rotation + 180;
    var width = spacing;
    var height = spacing;
    var path;
    if (rotation === 0) path = "\n                M 0 0 L ".concat(width, " 0\n                M 0 ").concat(height, " L ").concat(width, " ").concat(height, "\n            ");
    else if (rotation === 90) path = "\n                M 0 0 L 0 ".concat(height, "\n                M ").concat(width, " 0 L ").concat(width, " ").concat(height, "\n            ");
    else {
        width = Math.abs(spacing / Math.sin(degreesToRadians(rotation)));
        height = spacing / Math.sin(degreesToRadians(90 - rotation));
        if (rotation > 0) path = "\n                    M 0 ".concat(-height, " L ").concat(width * 2, " ").concat(height, "\n                    M ").concat(-width, " ").concat(-height, " L ").concat(width, " ").concat(height, "\n                    M ").concat(-width, " 0 L ").concat(width, " ").concat(height * 2, "\n                ");
        else path = "\n                    M ".concat(-width, " ").concat(height, " L ").concat(width, " ").concat(-height, "\n                    M ").concat(-width, " ").concat(height * 2, " L ").concat(width * 2, " ").concat(-height, "\n                    M 0 ").concat(height * 2, " L ").concat(width * 2, " 0\n                ");
    }
    return (0, _reactDefault.default).createElement("pattern", {
        id: id,
        width: width,
        height: height,
        patternUnits: "userSpaceOnUse"
    }, (0, _reactDefault.default).createElement("rect", {
        width: width,
        height: height,
        fill: background,
        stroke: "rgba(255, 0, 0, 0.1)",
        strokeWidth: 0
    }), (0, _reactDefault.default).createElement("path", {
        d: path,
        strokeWidth: lineWidth,
        stroke: color,
        strokeLinecap: "square"
    }));
});
PatternLines.displayName = "PatternLines";
PatternLines.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    spacing: (0, _propTypesDefault.default).number.isRequired,
    rotation: (0, _propTypesDefault.default).number.isRequired,
    background: (0, _propTypesDefault.default).string.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    lineWidth: (0, _propTypesDefault.default).number.isRequired
};
PatternLines.defaultProps = {
    spacing: 5,
    rotation: 0,
    color: "#000000",
    background: "#ffffff",
    lineWidth: 2
};
var patternLinesDef = function patternLinesDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread$6({
        id: id,
        type: "patternLines"
    }, options);
};
function _objectSpread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$8(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$8(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PatternSquares = (0, _react.memo)(function(_ref) {
    var id = _ref.id, background = _ref.background, color = _ref.color, size = _ref.size, padding = _ref.padding, stagger = _ref.stagger;
    var fullSize = size + padding;
    var halfPadding = padding / 2;
    if (stagger === true) fullSize = size * 2 + padding * 2;
    return (0, _reactDefault.default).createElement("pattern", {
        id: id,
        width: fullSize,
        height: fullSize,
        patternUnits: "userSpaceOnUse"
    }, (0, _reactDefault.default).createElement("rect", {
        width: fullSize,
        height: fullSize,
        fill: background
    }), (0, _reactDefault.default).createElement("rect", {
        x: halfPadding,
        y: halfPadding,
        width: size,
        height: size,
        fill: color
    }), stagger && (0, _reactDefault.default).createElement("rect", {
        x: padding * 1.5 + size,
        y: padding * 1.5 + size,
        width: size,
        height: size,
        fill: color
    }));
});
PatternSquares.displayName = "PatternSquares";
PatternSquares.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    background: (0, _propTypesDefault.default).string.isRequired,
    size: (0, _propTypesDefault.default).number.isRequired,
    padding: (0, _propTypesDefault.default).number.isRequired,
    stagger: (0, _propTypesDefault.default).bool.isRequired
};
PatternSquares.defaultProps = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: false
};
var patternSquaresDef = function patternSquaresDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _objectSpread$7({
        id: id,
        type: "patternSquares"
    }, options);
};
var patternTypes = {
    patternDots: PatternDots,
    patternLines: PatternLines,
    patternSquares: PatternSquares
};
function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectSpread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$9(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$9(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var defsMapping = _objectSpread$8({}, gradientTypes, patternTypes);
var Defs = function Defs(_ref) {
    var definitions = _ref.defs;
    if (!definitions || definitions.length < 1) return null;
    return (0, _reactDefault.default).createElement("defs", null, definitions.map(function(_ref2) {
        var type = _ref2.type, def = _objectWithoutProperties$1(_ref2, [
            "type"
        ]);
        if (defsMapping[type]) return (0, _reactDefault.default).createElement(defsMapping[type], _objectSpread$8({
            key: def.id
        }, def));
        return null;
    }));
};
Defs.propTypes = {
    defs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        type: (0, _propTypesDefault.default).oneOf(Object.keys(defsMapping)).isRequired,
        id: (0, _propTypesDefault.default).string.isRequired
    }))
};
var Defs$1 = (0, _react.memo)(Defs);
var SvgWrapper = function SvgWrapper(_ref) {
    var width = _ref.width, height = _ref.height, margin = _ref.margin, defs = _ref.defs, children = _ref.children;
    var theme = useTheme();
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        width: width,
        height: height
    }, (0, _reactDefault.default).createElement(Defs$1, {
        defs: defs
    }), (0, _reactDefault.default).createElement("rect", {
        width: width,
        height: height,
        fill: theme.background
    }), (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(margin.left, ",").concat(margin.top, ")")
    }, children));
};
SvgWrapper.propTypes = {
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    margin: (0, _propTypesDefault.default).shape({
        top: (0, _propTypesDefault.default).number.isRequired,
        left: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    defs: (0, _propTypesDefault.default).array,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
        (0, _propTypesDefault.default).node
    ]).isRequired
};
var DotsItemSymbol = function DotsItemSymbol(_ref) {
    var size = _ref.size, color = _ref.color, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor;
    return (0, _reactDefault.default).createElement("circle", {
        r: size / 2,
        fill: color,
        stroke: borderColor,
        strokeWidth: borderWidth,
        style: {
            pointerEvents: "none"
        }
    });
};
DotsItemSymbol.propTypes = {
    size: (0, _propTypesDefault.default).number.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _propTypesDefault.default).string.isRequired
};
var DotsItemSymbol$1 = (0, _react.memo)(DotsItemSymbol);
var DotsItem = function DotsItem(_ref) {
    var x = _ref.x, y = _ref.y, symbol = _ref.symbol, size = _ref.size, datum = _ref.datum, color = _ref.color, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor, label = _ref.label, labelTextAnchor = _ref.labelTextAnchor, labelYOffset = _ref.labelYOffset, theme = _ref.theme;
    return (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(x, ", ").concat(y, ")"),
        style: {
            pointerEvents: "none"
        }
    }, (0, _reactDefault.default).createElement(symbol, {
        size: size,
        color: color,
        datum: datum,
        borderWidth: borderWidth,
        borderColor: borderColor
    }), label && (0, _reactDefault.default).createElement("text", {
        textAnchor: labelTextAnchor,
        y: labelYOffset,
        style: theme.dots.text
    }, label));
};
DotsItem.propTypes = {
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    datum: (0, _propTypesDefault.default).object.isRequired,
    size: (0, _propTypesDefault.default).number.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _propTypesDefault.default).string.isRequired,
    symbol: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ]),
    label: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    labelTextAnchor: (0, _propTypesDefault.default).oneOf([
        "start",
        "middle",
        "end"
    ]),
    labelYOffset: (0, _propTypesDefault.default).number.isRequired,
    theme: (0, _propTypesDefault.default).shape({
        dots: dotsThemePropType.isRequired
    }).isRequired
};
var DotsItemDefaultProps = {
    symbol: DotsItemSymbol$1,
    labelTextAnchor: "middle",
    labelYOffset: -12
};
DotsItem.defaultProps = DotsItemDefaultProps;
var DotsItem$1 = (0, _react.memo)(DotsItem);
var computeLabel = function computeLabel(_ref) {
    var axis = _ref.axis, width = _ref.width, height = _ref.height, position = _ref.position, offsetX = _ref.offsetX, offsetY = _ref.offsetY, orientation = _ref.orientation;
    var x = 0;
    var y = 0;
    var rotation = orientation === "vertical" ? -90 : 0;
    var textAnchor = "start";
    if (axis === "x") switch(position){
        case "top-left":
            x = -offsetX;
            y = offsetY;
            textAnchor = "end";
            break;
        case "top":
            y = -offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "start";
            break;
        case "top-right":
            x = offsetX;
            y = offsetY;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "end";
            break;
        case "right":
            x = offsetX;
            y = height / 2;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "middle";
            break;
        case "bottom-right":
            x = offsetX;
            y = height - offsetY;
            textAnchor = "start";
            break;
        case "bottom":
            y = height + offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "end";
            break;
        case "bottom-left":
            y = height - offsetY;
            x = -offsetX;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "start";
            break;
        case "left":
            x = -offsetX;
            y = height / 2;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "middle";
            break;
    }
    else switch(position){
        case "top-left":
            x = offsetX;
            y = -offsetY;
            textAnchor = "start";
            break;
        case "top":
            x = width / 2;
            y = -offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "start";
            break;
        case "top-right":
            x = width - offsetX;
            y = -offsetY;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "start";
            break;
        case "right":
            x = width + offsetX;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "middle";
            break;
        case "bottom-right":
            x = width - offsetX;
            y = offsetY;
            textAnchor = "end";
            break;
        case "bottom":
            x = width / 2;
            y = offsetY;
            if (orientation === "horizontal") textAnchor = "middle";
            else textAnchor = "end";
            break;
        case "bottom-left":
            x = offsetX;
            y = offsetY;
            if (orientation === "horizontal") textAnchor = "start";
            else textAnchor = "end";
            break;
        case "left":
            x = -offsetX;
            if (orientation === "horizontal") textAnchor = "end";
            else textAnchor = "middle";
            break;
    }
    return {
        x: x,
        y: y,
        rotation: rotation,
        textAnchor: textAnchor
    };
};
var CartesianMarkersItem = function CartesianMarkersItem(_ref2) {
    var width = _ref2.width, height = _ref2.height, axis = _ref2.axis, scale = _ref2.scale, value = _ref2.value, lineStyle = _ref2.lineStyle, textStyle = _ref2.textStyle, legend = _ref2.legend, legendPosition = _ref2.legendPosition, legendOffsetX = _ref2.legendOffsetX, legendOffsetY = _ref2.legendOffsetY, legendOrientation = _ref2.legendOrientation;
    var theme = useTheme();
    var x = 0;
    var x2 = 0;
    var y = 0;
    var y2 = 0;
    if (axis === "y") {
        y = scale(value);
        x2 = width;
    } else {
        x = scale(value);
        y2 = height;
    }
    var legendNode = null;
    if (legend) {
        var legendProps = computeLabel({
            axis: axis,
            width: width,
            height: height,
            position: legendPosition,
            offsetX: legendOffsetX,
            offsetY: legendOffsetY,
            orientation: legendOrientation
        });
        legendNode = (0, _reactDefault.default).createElement("text", {
            transform: "translate(".concat(legendProps.x, ", ").concat(legendProps.y, ") rotate(").concat(legendProps.rotation, ")"),
            textAnchor: legendProps.textAnchor,
            dominantBaseline: "central",
            style: textStyle
        }, legend);
    }
    return (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(x, ", ").concat(y, ")")
    }, (0, _reactDefault.default).createElement("line", {
        x1: 0,
        x2: x2,
        y1: 0,
        y2: y2,
        stroke: theme.markers.lineColor,
        strokeWidth: theme.markers.lineStrokeWidth,
        style: lineStyle
    }), legendNode);
};
CartesianMarkersItem.propTypes = {
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    axis: (0, _propTypesDefault.default).oneOf([
        "x",
        "y"
    ]).isRequired,
    scale: (0, _propTypesDefault.default).func.isRequired,
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]).isRequired,
    lineStyle: (0, _propTypesDefault.default).object,
    textStyle: (0, _propTypesDefault.default).object,
    legend: (0, _propTypesDefault.default).string,
    legendPosition: (0, _propTypesDefault.default).oneOf([
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]),
    legendOffsetX: (0, _propTypesDefault.default).number.isRequired,
    legendOffsetY: (0, _propTypesDefault.default).number.isRequired,
    legendOrientation: (0, _propTypesDefault.default).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired
};
CartesianMarkersItem.defaultProps = {
    legendPosition: "top-right",
    legendOffsetX: 14,
    legendOffsetY: 14,
    legendOrientation: "horizontal"
};
var CartesianMarkersItem$1 = (0, _react.memo)(CartesianMarkersItem);
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
var CartesianMarkers = function CartesianMarkers(_ref) {
    var markers = _ref.markers, width = _ref.width, height = _ref.height, xScale = _ref.xScale, yScale = _ref.yScale;
    if (!markers || markers.length === 0) return null;
    return markers.map(function(marker, i) {
        return (0, _reactDefault.default).createElement(CartesianMarkersItem$1, _extends$1({
            key: i
        }, marker, {
            width: width,
            height: height,
            scale: marker.axis === "y" ? yScale : xScale
        }));
    });
};
CartesianMarkers.propTypes = {
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    xScale: (0, _propTypesDefault.default).func.isRequired,
    yScale: (0, _propTypesDefault.default).func.isRequired,
    markers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        axis: (0, _propTypesDefault.default).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]).isRequired,
        lineStyle: (0, _propTypesDefault.default).object,
        textStyle: (0, _propTypesDefault.default).object
    }))
};
var CartesianMarkers$1 = (0, _react.memo)(CartesianMarkers);
function _defineProperty$a(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var withCurve = function() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$srcKey = _ref.srcKey, srcKey = _ref$srcKey === void 0 ? "curve" : _ref$srcKey, _ref$destKey = _ref.destKey, destKey = _ref$destKey === void 0 ? "curveInterpolator" : _ref$destKey;
    return (0, _withPropsDefault.default)(function(props) {
        return _defineProperty$a({}, destKey, curveFromProp(props[srcKey]));
    });
};
var withDimensions = function() {
    return (0, _composeDefault.default)((0, _defaultPropsDefault.default)({
        margin: defaultMargin
    }), (0, _setPropTypesDefault.default)({
        width: (0, _propTypesDefault.default).number.isRequired,
        height: (0, _propTypesDefault.default).number.isRequired,
        margin: marginPropType
    }), (0, _withPropsOnChangeDefault.default)(function(props, nextProps) {
        return props.width !== nextProps.width || props.height !== nextProps.height || !(0, _isEqualDefault.default)(props.margin, nextProps.margin);
    }, function(props) {
        var margin = Object.assign({}, defaultMargin, props.margin);
        return {
            margin: margin,
            width: props.width - margin.left - margin.right,
            height: props.height - margin.top - margin.bottom,
            outerWidth: props.width,
            outerHeight: props.height
        };
    }));
};
var getLabelGenerator = function getLabelGenerator(_label, labelFormat) {
    var getRawLabel = (0, _isFunctionDefault.default)(_label) ? _label : function(d) {
        return (0, _getDefault.default)(d, _label);
    };
    var formatter;
    if (labelFormat) formatter = (0, _isFunctionDefault.default)(labelFormat) ? labelFormat : (0, _d3Format.format)(labelFormat);
    if (formatter) return function(d) {
        return formatter(getRawLabel(d));
    };
    return getRawLabel;
};
var getAccessorFor = function getAccessorFor(directive) {
    return (0, _isFunctionDefault.default)(directive) ? directive : function(d) {
        return d[directive];
    };
};
var getAccessorOrValue = function getAccessorOrValue(value) {
    return (0, _isFunctionDefault.default)(value) ? value : function() {
        return value;
    };
};
function _defineProperty$b(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var withHierarchy = function() {
    var _setPropTypes;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$srcKey = _ref.srcKey, srcKey = _ref$srcKey === void 0 ? "root" : _ref$srcKey, _ref$destKey = _ref.destKey, destKey = _ref$destKey === void 0 ? "root" : _ref$destKey, _ref$valueKey = _ref.valueKey, valueKey = _ref$valueKey === void 0 ? "value" : _ref$valueKey, _ref$valueDefault = _ref.valueDefault, valueDefault = _ref$valueDefault === void 0 ? "value" : _ref$valueDefault;
    return (0, _composeDefault.default)((0, _defaultPropsDefault.default)(_defineProperty$b({}, valueKey, valueDefault)), (0, _setPropTypesDefault.default)((_setPropTypes = {}, _defineProperty$b(_setPropTypes, srcKey, (0, _propTypesDefault.default).object.isRequired), _defineProperty$b(_setPropTypes, valueKey, (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]).isRequired), _setPropTypes)), (0, _withPropsOnChangeDefault.default)([
        srcKey,
        valueKey
    ], function(props) {
        return _defineProperty$b({}, destKey, (0, _d3Hierarchy.hierarchy)(props[srcKey]).sum(getAccessorFor(props[valueKey])));
    }));
};
var withMotion = function() {
    return (0, _composeDefault.default)((0, _setPropTypesDefault.default)(motionPropTypes), (0, _defaultPropsDefault.default)({
        animate: defaultAnimate,
        motionDamping: defaultMotionDamping,
        motionStiffness: defaultMotionStiffness
    }), (0, _withPropsOnChangeDefault.default)([
        "motionDamping",
        "motionStiffness"
    ], function(_ref) {
        var motionDamping = _ref.motionDamping, motionStiffness = _ref.motionStiffness;
        return {
            boundSpring: (0, _partialRightDefault.default)((0, _reactMotion.spring), {
                damping: motionDamping,
                stiffness: motionStiffness
            })
        };
    }));
};
function _defineProperty$c(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var withTheme = function() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$srcKey = _ref.srcKey, srcKey = _ref$srcKey === void 0 ? "theme" : _ref$srcKey, _ref$destKey = _ref.destKey, destKey = _ref$destKey === void 0 ? "theme" : _ref$destKey;
    return (0, _composeDefault.default)((0, _setPropTypesDefault.default)(_defineProperty$c({}, srcKey, (0, _propTypesDefault.default).object)), (0, _withPropsOnChangeDefault.default)([
        srcKey
    ], function(props) {
        return _defineProperty$c({}, destKey, extendDefaultTheme(defaultTheme, props[srcKey]));
    }));
};
function _typeof$2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$2 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$2(obj);
}
function _objectWithoutProperties$2(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$2(self);
}
function _assertThisInitialized$2(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var containerStyle$1 = {
    position: "relative"
};
var Container$1 = function Container(_ref) {
    var theme = _ref.theme, _ref$renderWrapper = _ref.renderWrapper, renderWrapper = _ref$renderWrapper === void 0 ? true : _ref$renderWrapper, children = _ref.children, animate = _ref.animate, motionStiffness = _ref.motionStiffness, motionDamping = _ref.motionDamping;
    var container = (0, _react.useRef)(null);
    var _useTooltipHandlers = (0, _tooltip.useTooltipHandlers)(container), showTooltipAt = _useTooltipHandlers.showTooltipAt, showTooltipFromEvent = _useTooltipHandlers.showTooltipFromEvent, hideTooltip = _useTooltipHandlers.hideTooltip, isTooltipVisible = _useTooltipHandlers.isTooltipVisible, tooltipContent = _useTooltipHandlers.tooltipContent, tooltipPosition = _useTooltipHandlers.tooltipPosition, tooltipAnchor = _useTooltipHandlers.tooltipAnchor;
    return (0, _reactDefault.default).createElement(ThemeProvider, {
        theme: theme
    }, (0, _reactDefault.default).createElement(MotionConfigProvider, {
        animate: animate,
        stiffness: motionStiffness,
        damping: motionDamping
    }, (0, _reactDefault.default).createElement((0, _tooltip.tooltipContext).Provider, {
        value: {
            showTooltipAt: showTooltipAt,
            showTooltipFromEvent: showTooltipFromEvent,
            hideTooltip: hideTooltip
        }
    }, renderWrapper === true && (0, _reactDefault.default).createElement("div", {
        style: containerStyle$1,
        ref: container
    }, children, isTooltipVisible && (0, _reactDefault.default).createElement((0, _tooltip.TooltipWrapper), {
        position: tooltipPosition,
        anchor: tooltipAnchor
    }, tooltipContent)), renderWrapper !== true && children)));
};
Container$1.propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    theme: (0, _propTypesDefault.default).object,
    animate: (0, _propTypesDefault.default).bool,
    motionStiffness: (0, _propTypesDefault.default).number,
    motionDamping: (0, _propTypesDefault.default).number,
    renderWrapper: (0, _propTypesDefault.default).bool
};
var withContainer = function withContainer(WrappedComponent) {
    return function(_Component) {
        _inherits$2(_class, _Component);
        function _class() {
            _classCallCheck$2(this, _class);
            return _possibleConstructorReturn$2(this, _getPrototypeOf$2(_class).apply(this, arguments));
        }
        _createClass$2(_class, [
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, theme = _this$props.theme, renderWrapper = _this$props.renderWrapper, childProps = _objectWithoutProperties$2(_this$props, [
                        "theme",
                        "renderWrapper"
                    ]);
                    return (0, _reactDefault.default).createElement(Container$1, {
                        theme: theme,
                        renderWrapper: renderWrapper,
                        animate: childProps.animate,
                        motionStiffness: childProps.motionStiffness,
                        motionDamping: childProps.motionDamping
                    }, (0, _reactDefault.default).createElement(WrappedComponent, childProps));
                }
            }
        ]);
        return _class;
    }((0, _react.Component));
};
var boxAlignments = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
];
var alignBox = function alignBox(box, container, alignment) {
    var deltaX = container.width - box.width;
    var deltaY = container.height - box.height;
    var x = 0;
    var y = 0;
    if (alignment === "center") {
        x = deltaX / 2;
        y = deltaY / 2;
    }
    if (alignment === "top") x = deltaX / 2;
    if (alignment === "top-right") x = deltaX;
    if (alignment === "right") {
        x = deltaX;
        y = deltaY / 2;
    }
    if (alignment === "bottom-right") {
        x = deltaX;
        y = deltaY;
    }
    if (alignment === "bottom") {
        x = deltaX / 2;
        y = deltaY;
    }
    if (alignment === "bottom-left") y = deltaY;
    if (alignment === "left") y = deltaY / 2;
    return [
        x,
        y
    ];
};
var getDistance = function getDistance(x1, y1, x2, y2) {
    var deltaX = x2 - x1;
    var deltaY = y2 - y1;
    deltaX *= deltaX;
    deltaY *= deltaY;
    return Math.sqrt(deltaX + deltaY);
};
var getAngle = function getAngle(x1, y1, x2, y2) {
    var angle = Math.atan2(y2 - y1, x2 - x1) - Math.PI / 2;
    return angle > 0 ? angle : Math.PI * 2 + angle;
};
var isCursorInRect = function isCursorInRect(x, y, width, height, cursorX, cursorY) {
    return x <= cursorX && cursorX <= x + width && y <= cursorY && cursorY <= y + height;
};
var isCursorInRing = function isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY) {
    var distance = getDistance(cursorX, cursorY, centerX, centerY);
    return distance < radius && distance > innerRadius;
};
var getHoveredArc = function getHoveredArc(centerX, centerY, radius, innerRadius, arcs, cursorX, cursorY) {
    if (!isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY)) return null;
    var cursorAngle = getAngle(cursorX, cursorY, centerX, centerY);
    return arcs.find(function(_ref) {
        var startAngle = _ref.startAngle, endAngle = _ref.endAngle;
        return cursorAngle >= startAngle && cursorAngle < endAngle;
    });
};
var getRelativeCursor = function getRelativeCursor(el, event) {
    var clientX = event.clientX, clientY = event.clientY;
    var bounds = el.getBoundingClientRect();
    return [
        clientX - bounds.left,
        clientY - bounds.top
    ];
};
function _objectSpread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$d(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$d(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray$1(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var gradientKeys = Object.keys(gradientTypes);
var patternKeys = Object.keys(patternTypes);
var isMatchingDef = function isMatchingDef(predicate, node, dataKey) {
    if (predicate === "*") return true;
    else if ((0, _isFunctionDefault.default)(predicate)) return predicate(node);
    else if ((0, _isPlainObjectDefault.default)(predicate)) {
        var data = dataKey ? (0, _getDefault.default)(node, dataKey) : node;
        return (0, _isEqualDefault.default)((0, _pickDefault.default)(data, Object.keys(predicate)), predicate);
    }
    return false;
};
var bindDefs = function bindDefs(defs, nodes, rules) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {}, dataKey = _ref.dataKey, _ref$colorKey = _ref.colorKey, colorKey = _ref$colorKey === void 0 ? "color" : _ref$colorKey, _ref$targetKey = _ref.targetKey, targetKey = _ref$targetKey === void 0 ? "fill" : _ref$targetKey;
    var boundDefs = [];
    var generatedIds = {};
    if (defs.length && nodes.length) {
        boundDefs = _toConsumableArray$1(defs);
        nodes.forEach(function(node) {
            var _loop = function _loop(i) {
                var _rules$i = rules[i], id = _rules$i.id, match = _rules$i.match;
                if (isMatchingDef(match, node, dataKey)) {
                    var def = defs.find(function(_ref2) {
                        var defId = _ref2.id;
                        return defId === id;
                    });
                    if (def) {
                        if (patternKeys.includes(def.type)) {
                            if (def.background === "inherit" || def.color === "inherit") {
                                var nodeColor = (0, _getDefault.default)(node, colorKey);
                                var background = def.background;
                                var color = def.color;
                                var inheritedId = id;
                                if (def.background === "inherit") {
                                    inheritedId = "".concat(inheritedId, ".bg.").concat(nodeColor);
                                    background = nodeColor;
                                }
                                if (def.color === "inherit") {
                                    inheritedId = "".concat(inheritedId, ".fg.").concat(nodeColor);
                                    color = nodeColor;
                                }
                                (0, _setDefault.default)(node, targetKey, "url(#".concat(inheritedId, ")"));
                                if (!generatedIds[inheritedId]) {
                                    boundDefs.push(_objectSpread$9({}, def, {
                                        id: inheritedId,
                                        background: background,
                                        color: color
                                    }));
                                    generatedIds[inheritedId] = 1;
                                }
                            } else (0, _setDefault.default)(node, targetKey, "url(#".concat(id, ")"));
                        } else if (gradientKeys.includes(def.type)) {
                            var allColors = def.colors.map(function(_ref3) {
                                var color = _ref3.color;
                                return color;
                            });
                            if (allColors.includes("inherit")) {
                                var _nodeColor = (0, _getDefault.default)(node, colorKey);
                                var _inheritedId = id;
                                var inheritedDef = _objectSpread$9({}, def, {
                                    colors: def.colors.map(function(colorStop, i) {
                                        if (colorStop.color !== "inherit") return colorStop;
                                        _inheritedId = "".concat(_inheritedId, ".").concat(i, ".").concat(_nodeColor);
                                        return _objectSpread$9({}, colorStop, {
                                            color: colorStop.color === "inherit" ? _nodeColor : colorStop.color
                                        });
                                    })
                                });
                                inheritedDef.id = _inheritedId;
                                (0, _setDefault.default)(node, targetKey, "url(#".concat(_inheritedId, ")"));
                                if (!generatedIds[_inheritedId]) {
                                    boundDefs.push(inheritedDef);
                                    generatedIds[_inheritedId] = 1;
                                }
                            } else (0, _setDefault.default)(node, targetKey, "url(#".concat(id, ")"));
                        }
                    }
                    return "break";
                }
            };
            for(var i = 0; i < rules.length; i++){
                var _ret = _loop(i);
                if (_ret === "break") break;
            }
        });
    }
    return boundDefs;
};

},{"react":"6AiW6","prop-types":"kKQPU","@nivo/tooltip":"D7d3j","lodash/merge":"79LnX","lodash/get":"4u8u0","lodash/set":"cxZlQ","lodash/last":"4OGfA","lodash/isArray":"9om8C","lodash/isString":"3iITv","d3-scale":"7Ll4r","d3-scale-chromatic":"laFUI","lodash/isFunction":"cXGEE","lodash/without":"8BeqI","d3-shape":"kgLQU","d3-hierarchy":"aOVRm","d3-format":"3rxcZ","d3-time-format":"285I3","react-motion":"lqe7n","d3-interpolate":"gydkL","react-measure":"jHbNy","recompose/withProps":"1DqG0","lodash/isEqual":"6oIYS","recompose/compose":"lv27x","recompose/setPropTypes":"bV7hD","recompose/defaultProps":"6nQWc","recompose/withPropsOnChange":"bf8Lh","lodash/partialRight":"7e9ga","lodash/isPlainObject":"9qlpu","lodash/pick":"e8B6O","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"D7d3j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BasicTooltip", ()=>BasicTooltip);
parcelHelpers.export(exports, "Chip", ()=>Chip);
parcelHelpers.export(exports, "Crosshair", ()=>Crosshair);
parcelHelpers.export(exports, "TableTooltip", ()=>TableTooltip);
parcelHelpers.export(exports, "TooltipWrapper", ()=>TooltipWrapper);
parcelHelpers.export(exports, "crosshairPropTypes", ()=>crosshairPropTypes);
parcelHelpers.export(exports, "crosshairTypes", ()=>crosshairTypes);
parcelHelpers.export(exports, "tooltipContext", ()=>tooltipContext);
parcelHelpers.export(exports, "useTooltip", ()=>useTooltip);
parcelHelpers.export(exports, "useTooltipHandlers", ()=>useTooltipHandlers);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactMeasure = require("react-measure");
var _reactMeasureDefault = parcelHelpers.interopDefault(_reactMeasure);
var _reactMotion = require("react-motion");
var _core = require("@nivo/core");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var TOOLTIP_OFFSET = 14;
var tooltipStyle = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
};
var TooltipWrapper = (0, _react.memo)(function(_ref) {
    var position = _ref.position, anchor = _ref.anchor, children = _ref.children;
    var _useState = (0, _react.useState)(null), _useState2 = _slicedToArray(_useState, 2), dimensions = _useState2[0], setDimensions = _useState2[1];
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    var x = Math.round(position[0]);
    var y = Math.round(position[1]);
    if (dimensions !== null) {
        if (anchor === "top") {
            x -= dimensions[0] / 2;
            y -= dimensions[1] + TOOLTIP_OFFSET;
        } else if (anchor === "right") {
            x += TOOLTIP_OFFSET;
            y -= dimensions[1] / 2;
        } else if (anchor === "bottom") {
            x -= dimensions[0] / 2;
            y += TOOLTIP_OFFSET;
        } else if (anchor === "left") {
            x -= dimensions[0] + TOOLTIP_OFFSET;
            y -= dimensions[1] / 2;
        } else if (anchor === "center") {
            x -= dimensions[0] / 2;
            y -= dimensions[1] / 2;
        }
    }
    var style = (0, _react.useMemo)(function() {
        return _objectSpread({}, tooltipStyle, theme.tooltip, {
            transform: "translate(".concat(x, "px, ").concat(y, "px)"),
            opacity: dimensions === null ? 0 : 1
        });
    }, [
        x,
        y,
        dimensions,
        theme.tooltip
    ]);
    if (animate !== true || dimensions === null) return (0, _reactDefault.default).createElement((0, _reactMeasureDefault.default), {
        client: false,
        offset: false,
        bounds: true,
        margin: false,
        onResize: function onResize(_ref2) {
            var bounds = _ref2.bounds;
            setDimensions([
                bounds.width,
                bounds.height
            ]);
        }
    }, function(_ref3) {
        var measureRef = _ref3.measureRef;
        return (0, _reactDefault.default).createElement("div", {
            ref: measureRef,
            style: style
        }, children);
    });
    return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x: (0, _reactMotion.spring)(x, springConfig),
            y: (0, _reactMotion.spring)(y, springConfig)
        }
    }, function(animatedPosition) {
        return (0, _reactDefault.default).createElement((0, _reactMeasureDefault.default), {
            client: false,
            offset: false,
            bounds: true,
            margin: false,
            onResize: function onResize(_ref4) {
                var bounds = _ref4.bounds;
                setDimensions([
                    bounds.width,
                    bounds.height
                ]);
            }
        }, function(_ref5) {
            var measureRef = _ref5.measureRef;
            return (0, _reactDefault.default).createElement("div", {
                ref: measureRef,
                style: _objectSpread({}, tooltipStyle, theme.tooltip, {
                    transform: "translate3d(".concat(animatedPosition.x, "px, ").concat(animatedPosition.y, "px, 0)")
                })
            }, children);
        });
    });
});
TooltipWrapper.displayName = "TooltipWrapper";
TooltipWrapper.propTypes = {
    position: (0, _propTypesDefault.default).array.isRequired,
    anchor: (0, _propTypesDefault.default).oneOf([
        "top",
        "right",
        "bottom",
        "left",
        "center"
    ]).isRequired,
    children: (0, _propTypesDefault.default).node.isRequired
};
TooltipWrapper.defaultProps = {
    anchor: "top"
};
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Chip = (0, _react.memo)(function(_ref) {
    var size = _ref.size, color = _ref.color, style = _ref.style;
    return (0, _reactDefault.default).createElement("span", {
        style: _objectSpread$1({
            display: "block",
            width: size,
            height: size,
            background: color
        }, style)
    });
});
Chip.propTypes = {
    size: (0, _propTypesDefault.default).number.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    style: (0, _propTypesDefault.default).object.isRequired
};
Chip.defaultProps = {
    size: 12,
    style: {}
};
Chip.displayName = "Chip";
var BasicTooltip = (0, _react.memo)(function(_ref) {
    var id = _ref.id, _value = _ref.value, format = _ref.format, enableChip = _ref.enableChip, color = _ref.color, renderContent = _ref.renderContent;
    var theme = (0, _core.useTheme)();
    var formatValue = (0, _core.useValueFormatter)(format);
    var content;
    if (typeof renderContent === "function") content = renderContent();
    else {
        var value = _value;
        if (formatValue !== undefined && value !== undefined) value = formatValue(value);
        content = (0, _reactDefault.default).createElement("div", {
            style: theme.tooltip.basic
        }, enableChip && (0, _reactDefault.default).createElement(Chip, {
            color: color,
            style: theme.tooltip.chip
        }), value !== undefined ? (0, _reactDefault.default).createElement("span", null, id, ": ", (0, _reactDefault.default).createElement("strong", null, isNaN(value) ? String(value) : value)) : id);
    }
    return (0, _reactDefault.default).createElement("div", {
        style: theme.tooltip.container
    }, content);
});
BasicTooltip.displayName = "BasicTooltip";
BasicTooltip.propTypes = {
    id: (0, _propTypesDefault.default).node.isRequired,
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    enableChip: (0, _propTypesDefault.default).bool.isRequired,
    color: (0, _propTypesDefault.default).string,
    format: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    renderContent: (0, _propTypesDefault.default).func
};
BasicTooltip.defaultProps = {
    enableChip: false
};
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var tableStyle = {
    width: "100%",
    borderCollapse: "collapse"
};
var TableTooltip = (0, _react.memo)(function(_ref) {
    var title = _ref.title, rows = _ref.rows, renderContent = _ref.renderContent;
    var theme = (0, _core.useTheme)();
    if (!rows.length) return null;
    var content;
    if (typeof renderContent === "function") content = renderContent();
    else content = (0, _reactDefault.default).createElement("div", null, title && title, (0, _reactDefault.default).createElement("table", {
        style: _objectSpread$2({}, tableStyle, theme.tooltip.table)
    }, (0, _reactDefault.default).createElement("tbody", null, rows.map(function(row, i) {
        return (0, _reactDefault.default).createElement("tr", {
            key: i
        }, row.map(function(column, j) {
            return (0, _reactDefault.default).createElement("td", {
                key: j,
                style: theme.tooltip.tableCell
            }, column);
        }));
    }))));
    return (0, _reactDefault.default).createElement("div", {
        style: theme.tooltip.container
    }, content);
});
TableTooltip.propTypes = {
    title: (0, _propTypesDefault.default).node,
    rows: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node)).isRequired,
    renderContent: (0, _propTypesDefault.default).func
};
TableTooltip.displayName = "TableTooltip";
var crosshairTypes = [
    "x",
    "y",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left",
    "cross"
];
var crosshairPropTypes = {
    type: (0, _propTypesDefault.default).oneOf(crosshairTypes)
};
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var CrosshairLine = (0, _react.memo)(function(_ref) {
    var x0 = _ref.x0, x1 = _ref.x1, y0 = _ref.y0, y1 = _ref.y1;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    var style = (0, _react.useMemo)(function() {
        return _objectSpread$3({}, theme.crosshair.line, {
            pointerEvents: "none"
        });
    }, [
        theme.crosshair.line
    ]);
    if (animate !== true) return (0, _reactDefault.default).createElement("line", {
        x1: x0,
        x2: x1,
        y1: y0,
        y2: y1,
        fill: "none",
        style: style
    });
    return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x0: (0, _reactMotion.spring)(x0, springConfig),
            x1: (0, _reactMotion.spring)(x1, springConfig),
            y0: (0, _reactMotion.spring)(y0, springConfig),
            y1: (0, _reactMotion.spring)(y1, springConfig)
        }
    }, function(line) {
        return (0, _reactDefault.default).createElement("line", {
            x1: line.x0,
            x2: line.x1,
            y1: line.y0,
            y2: line.y1,
            fill: "none",
            style: style
        });
    });
});
CrosshairLine.displayName = "CrosshairLine";
CrosshairLine.propTypes = {
    x0: (0, _propTypesDefault.default).number.isRequired,
    x1: (0, _propTypesDefault.default).number.isRequired,
    y0: (0, _propTypesDefault.default).number.isRequired,
    y1: (0, _propTypesDefault.default).number.isRequired
};
var Crosshair = (0, _react.memo)(function(_ref) {
    var width = _ref.width, height = _ref.height, type = _ref.type, x = _ref.x, y = _ref.y;
    var xLine;
    var yLine;
    if (type === "cross") {
        xLine = {
            x0: x,
            x1: x,
            y0: 0,
            y1: height
        };
        yLine = {
            x0: 0,
            x1: width,
            y0: y,
            y1: y
        };
    } else if (type === "top-left") {
        xLine = {
            x0: x,
            x1: x,
            y0: 0,
            y1: y
        };
        yLine = {
            x0: 0,
            x1: x,
            y0: y,
            y1: y
        };
    } else if (type === "top") xLine = {
        x0: x,
        x1: x,
        y0: 0,
        y1: y
    };
    else if (type === "top-right") {
        xLine = {
            x0: x,
            x1: x,
            y0: 0,
            y1: y
        };
        yLine = {
            x0: x,
            x1: width,
            y0: y,
            y1: y
        };
    } else if (type === "right") yLine = {
        x0: x,
        x1: width,
        y0: y,
        y1: y
    };
    else if (type === "bottom-right") {
        xLine = {
            x0: x,
            x1: x,
            y0: y,
            y1: height
        };
        yLine = {
            x0: x,
            x1: width,
            y0: y,
            y1: y
        };
    } else if (type === "bottom") xLine = {
        x0: x,
        x1: x,
        y0: y,
        y1: height
    };
    else if (type === "bottom-left") {
        xLine = {
            x0: x,
            x1: x,
            y0: y,
            y1: height
        };
        yLine = {
            x0: 0,
            x1: x,
            y0: y,
            y1: y
        };
    } else if (type === "left") yLine = {
        x0: 0,
        x1: x,
        y0: y,
        y1: y
    };
    else if (type === "x") xLine = {
        x0: x,
        x1: x,
        y0: 0,
        y1: height
    };
    else if (type === "y") yLine = {
        x0: 0,
        x1: width,
        y0: y,
        y1: y
    };
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, xLine && (0, _reactDefault.default).createElement(CrosshairLine, {
        x0: xLine.x0,
        x1: xLine.x1,
        y0: xLine.y0,
        y1: xLine.y1
    }), yLine && (0, _reactDefault.default).createElement(CrosshairLine, {
        x0: yLine.x0,
        x1: yLine.x1,
        y0: yLine.y0,
        y1: yLine.y1
    }));
});
Crosshair.displayName = "Crosshair";
Crosshair.propTypes = {
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    type: crosshairPropTypes.type.isRequired
};
Crosshair.defaultProps = {
    type: "cross"
};
var tooltipContext = (0, _react.createContext)();
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$1(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
var useTooltipHandlers = function useTooltipHandlers(container) {
    var _useState = (0, _react.useState)({
        isVisible: false,
        content: null,
        position: {}
    }), _useState2 = _slicedToArray$1(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var showTooltipAt = (0, _react.useCallback)(function(content, _ref, anchor) {
        var _ref2 = _slicedToArray$1(_ref, 2), x = _ref2[0], y = _ref2[1];
        setState({
            isVisible: true,
            position: [
                x,
                y
            ],
            anchor: anchor,
            content: content
        });
    }, []);
    var showTooltipFromEvent = (0, _react.useCallback)(function(content, event, anchor) {
        var bounds = container.current.getBoundingClientRect();
        var x = event.clientX - bounds.left;
        var y = event.clientY - bounds.top;
        setState({
            isVisible: true,
            position: [
                x,
                y
            ],
            anchor: anchor,
            content: content
        });
    }, [
        container
    ]);
    var hideTooltip = (0, _react.useCallback)(function() {
        setState({
            isVisible: false,
            content: null
        });
    });
    return {
        showTooltipAt: showTooltipAt,
        showTooltipFromEvent: showTooltipFromEvent,
        hideTooltip: hideTooltip,
        isTooltipVisible: state.isVisible,
        tooltipPosition: state.position,
        tooltipAnchor: state.anchor,
        tooltipContent: state.content
    };
};
var useTooltip = function useTooltip() {
    return (0, _react.useContext)(tooltipContext);
};

},{"react":"6AiW6","prop-types":"kKQPU","react-measure":"jHbNy","react-motion":"lqe7n","@nivo/core":"guBSY","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jHbNy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withContentRect", ()=>withContentRect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resizeObserverPolyfill = require("resize-observer-polyfill");
var _resizeObserverPolyfillDefault = parcelHelpers.interopDefault(_resizeObserverPolyfill);
var types = [
    "client",
    "offset",
    "scroll",
    "bounds",
    "margin"
];
function getTypes(props) {
    var allowedTypes = [];
    types.forEach(function(type) {
        if (props[type]) allowedTypes.push(type);
    });
    return allowedTypes;
}
function getContentRect(node, types) {
    var calculations = {};
    if (types.indexOf("client") > -1) calculations.client = {
        top: node.clientTop,
        left: node.clientLeft,
        width: node.clientWidth,
        height: node.clientHeight
    };
    if (types.indexOf("offset") > -1) calculations.offset = {
        top: node.offsetTop,
        left: node.offsetLeft,
        width: node.offsetWidth,
        height: node.offsetHeight
    };
    if (types.indexOf("scroll") > -1) calculations.scroll = {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
    if (types.indexOf("bounds") > -1) {
        var rect = node.getBoundingClientRect();
        calculations.bounds = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height
        };
    }
    if (types.indexOf("margin") > -1) {
        var styles = getComputedStyle(node);
        calculations.margin = {
            top: styles ? parseInt(styles.marginTop) : 0,
            right: styles ? parseInt(styles.marginRight) : 0,
            bottom: styles ? parseInt(styles.marginBottom) : 0,
            left: styles ? parseInt(styles.marginLeft) : 0
        };
    }
    return calculations;
}
/**
 * Returns the global window object associated with provided element.
 */ function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
    // provided element.
    return ownerGlobal || window;
}
function withContentRect(types) {
    return function(WrappedComponent) {
        var _class, _temp;
        return _temp = _class = /*#__PURE__*/ function(_Component) {
            (0, _inheritsLooseDefault.default)(WithContentRect, _Component);
            function WithContentRect() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _Component.call.apply(_Component, [
                    this
                ].concat(args)) || this;
                _this.state = {
                    contentRect: {
                        entry: {},
                        client: {},
                        offset: {},
                        scroll: {},
                        bounds: {},
                        margin: {}
                    }
                };
                _this._animationFrameID = null;
                _this._resizeObserver = null;
                _this._node = null;
                _this._window = null;
                _this.measure = function(entries) {
                    var contentRect = getContentRect(_this._node, types || getTypes(_this.props));
                    if (entries) contentRect.entry = entries[0].contentRect;
                    _this._animationFrameID = _this._window.requestAnimationFrame(function() {
                        if (_this._resizeObserver !== null) {
                            _this.setState({
                                contentRect: contentRect
                            });
                            if (typeof _this.props.onResize === "function") _this.props.onResize(contentRect);
                        }
                    });
                };
                _this._handleRef = function(node) {
                    if (_this._resizeObserver !== null && _this._node !== null) _this._resizeObserver.unobserve(_this._node);
                    _this._node = node;
                    _this._window = getWindowOf(_this._node);
                    var innerRef = _this.props.innerRef;
                    if (innerRef) {
                        if (typeof innerRef === "function") innerRef(_this._node);
                        else innerRef.current = _this._node;
                    }
                    if (_this._resizeObserver !== null && _this._node !== null) _this._resizeObserver.observe(_this._node);
                };
                return _this;
            }
            var _proto = WithContentRect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new (0, _resizeObserverPolyfillDefault.default)(this.measure);
                if (this._node !== null) {
                    this._resizeObserver.observe(this._node);
                    if (typeof this.props.onResize === "function") this.props.onResize(getContentRect(this._node, types || getTypes(this.props)));
                }
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                if (this._window !== null) this._window.cancelAnimationFrame(this._animationFrameID);
                if (this._resizeObserver !== null) {
                    this._resizeObserver.disconnect();
                    this._resizeObserver = null;
                }
            };
            _proto.render = function render() {
                var _this$props = this.props, innerRef = _this$props.innerRef, onResize = _this$props.onResize, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
                    "innerRef",
                    "onResize"
                ]);
                return (0, _react.createElement)(WrappedComponent, (0, _extendsDefault.default)({}, props, {
                    measureRef: this._handleRef,
                    measure: this.measure,
                    contentRect: this.state.contentRect
                }));
            };
            return WithContentRect;
        }((0, _react.Component)), _class.propTypes = {
            client: (0, _propTypesDefault.default).bool,
            offset: (0, _propTypesDefault.default).bool,
            scroll: (0, _propTypesDefault.default).bool,
            bounds: (0, _propTypesDefault.default).bool,
            margin: (0, _propTypesDefault.default).bool,
            innerRef: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).object,
                (0, _propTypesDefault.default).func
            ]),
            onResize: (0, _propTypesDefault.default).func
        }, _temp;
    };
}
var Measure = withContentRect()(function(_ref) {
    var measure = _ref.measure, measureRef = _ref.measureRef, contentRect = _ref.contentRect, children = _ref.children;
    return children({
        measure: measure,
        measureRef: measureRef,
        contentRect: contentRect
    });
});
Measure.displayName = "Measure";
Measure.propTypes.children = (0, _propTypesDefault.default).func;
exports.default = Measure;

},{"@babel/runtime/helpers/esm/extends":"jDQP2","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"e9fBz","@babel/runtime/helpers/esm/inheritsLoose":"2bjHy","react":"6AiW6","prop-types":"kKQPU","resize-observer-polyfill":"f005u","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e9fBz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"f005u":[function(require,module,exports) {
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var global$1 = function() {
    if (typeof global !== "undefined" && global.Math === Math) return global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};
// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return emptyRect;
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function getContentRect(target) {
    if (!isBrowser) return emptyRect;
    if (isSVGGraphicsElement(target)) return getSVGContentRect(target);
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== "undefined" ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});
var index = function() {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== "undefined") return global$1.ResizeObserver;
    return ResizeObserver;
}();
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"79LnX":[function(require,module,exports) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"efxeq","e87a09d93c0fc32d":"59hB2"}],"efxeq":[function(require,module,exports) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"8Y9d2","76e9fd6386317324":"6ypU3","e7dca58bcfe9c669":"2wJUE","4ea46d88599071ec":"cGyDw","c52c932be04280cc":"kDBLt","27adf66142f57b4b":"bKXkD","564385b2292facea":"9Z7sg"}],"6ypU3":[function(require,module,exports) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"gvCFd","7d9c95e1ffdd4f16":"l89hZ"}],"cGyDw":[function(require,module,exports) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"6ypU3","ec8e1b90277c5e12":"947dd","4b1a2b5090faf247":"b22Jd","d7675bdf0a02bffc":"btK5B","1067a6f3f6bd5986":"3soAI","2238139506f6727b":"aZ8vK","290c774b41e416bb":"9om8C","f481819c40e5b527":"8rrEV","6532fda6a198015f":"1Qhoh","7f306c94b573f977":"cXGEE","32c89e763261c579":"kDBLt","ff359d315efefc4f":"9qlpu","61ce92c01fd411fe":"avtgp","abfa8f7e72201edb":"9Z7sg","c54d414b219fa287":"wEST7"}],"947dd":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"5yGId"}],"b22Jd":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"axvVD"}],"axvVD":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"95u9V"}],"btK5B":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"3soAI":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"fNQBY","8c92276927b7c3e0":"lYbAK","e939f15d7a0f64a5":"1krvv"}],"fNQBY":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"kDBLt"}],"9Z7sg":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"wEST7":[function(require,module,exports) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"32Wbe","437a3e3814017158":"bKXkD"}],"32Wbe":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"5AyTU","9cddf6ac1a092765":"gvCFd"}],"bKXkD":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"bJm93","194eb1a802636842":"iiM0u","ac15afdc3ddd76cd":"5qgKC"}],"iiM0u":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"kDBLt","f7d53cd92b2b977b":"1krvv","c039208a16eb68bd":"9udEX"}],"9udEX":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"59hB2":[function(require,module,exports) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"cFFHO","4f5832110eba92d3":"9DmJa"}],"cxZlQ":[function(require,module,exports) {
var baseSet = require("a003324b62105673");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a003324b62105673":"5WNvo"}],"7Ll4r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"hX3ge","./identity.js":false,"./linear.js":"2UimK","./log.js":false,"./symlog.js":false,"./ordinal.js":"6Wigm","./pow.js":false,"./radial.js":false,"./quantile.js":false,"./quantize.js":"hCv96","./threshold.js":false,"./time.js":false,"./utcTime.js":false,"./sequential.js":"ajDG0","./sequentialQuantile.js":false,"./diverging.js":false,"./tickFormat.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hX3ge":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":"ljA07","./init.js":"jaSpq","./ordinal.js":"6Wigm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ljA07":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"8Z3Gd","./ascending.js":"b8bGy","./bisector.js":"cnq7T","./count.js":"7EMwg","./cross.js":"jxxUm","./cumsum.js":"cUspc","./descending.js":"bAw4Y","./deviation.js":"dVjZh","./extent.js":"iIW8w","./fsum.js":"klFP2","./group.js":"eg04H","./groupSort.js":"hYKSP","./bin.js":"kbbFu","./threshold/freedmanDiaconis.js":"7Rh54","./threshold/scott.js":"93xXd","./threshold/sturges.js":"g04dA","./max.js":"hKDPn","./maxIndex.js":"jXfoW","./mean.js":"xE9tE","./median.js":"hq1D8","./merge.js":"6RviJ","./min.js":"bW7gM","./minIndex.js":"j99r9","./nice.js":"6GrCC","./pairs.js":"dMCWc","./permute.js":"4KA0f","./quantile.js":"iOcul","./quickselect.js":"4MhNN","./range.js":"fxJKQ","./least.js":"7SgBs","./leastIndex.js":"4h9pE","./greatest.js":"1940a","./greatestIndex.js":"egIy0","./scan.js":"69IRd","./shuffle.js":"3djxD","./sum.js":"fml6f","./ticks.js":"3ZTQ7","./transpose.js":"8NFQ3","./variance.js":"dC9AI","./zip.js":"1oJkT","./every.js":"3hxDu","./some.js":"kARZg","./filter.js":"4bVf2","./map.js":"hOank","./reduce.js":"euYTd","./reverse.js":"eGzGm","./sort.js":"duqcz","./difference.js":"8QHd6","./disjoint.js":"c5UwE","./intersection.js":"5uaXh","./subset.js":"likis","./superset.js":"gNp3o","./union.js":"4BaVQ","internmap":"l3nRd","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8Z3Gd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"b8bGy","./bisector.js":"cnq7T","./number.js":"eGkTv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b8bGy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cnq7T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(f) {
        let delta = f;
        let compare = f;
        if (f.length === 1) {
            delta = (d, x)=>f(d) - x;
            compare = ascendingComparator(f);
        }
        function left(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                const mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        }
        function right(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                const mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
        function center(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            const i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return {
            left,
            center,
            right
        };
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function ascendingComparator(f) {
    return (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
}

},{"./ascending.js":"b8bGy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eGkTv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x === null ? NaN : +x;
    });
parcelHelpers.export(exports, "numbers", ()=>numbers);
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7EMwg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jxxUm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cUspc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bAw4Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dVjZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"dC9AI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dC9AI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iIW8w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        let min;
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"klFP2":[function(require,module,exports) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eg04H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"l3nRd","./identity.js":"3gC8n","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l3nRd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
}
class InternSet extends Set {
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3gC8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hYKSP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length === 1 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"b8bGy","./group.js":"eg04H","./sort.js":"duqcz","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"duqcz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f = (0, _ascendingJsDefault.default)] = F;
    if (f.length === 1 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = (0, _ascendingJsDefault.default)(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>(0, _ascendingJsDefault.default)(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(f);
}

},{"./ascending.js":"b8bGy","./permute.js":"4KA0f","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4KA0f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(source, keys) {
        return Array.from(keys, (key)=>source[key]);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kbbFu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
        function histogram(data) {
            if (!Array.isArray(data)) data = Array.from(data);
            var i, n = data.length, x, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds, and nice the
            // default domain accordingly.
            if (!Array.isArray(tz)) {
                const max = x1, tn = +tz;
                if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
                tz = (0, _ticksJsDefault.default)(x0, x1, tn);
                // If the last threshold is coincident with the domain’s upper bound, the
                // last bin will be zero-width. If the default domain is used, and this
                // last threshold is coincident with the maximum input value, we can
                // extend the niced upper bound by one tick to ensure uniform bin widths;
                // otherwise, we simply remove the last threshold. Note that we don’t
                // coerce values or the domain to numbers, and thus must be careful to
                // compare order (>=) rather than strict equality (===)!
                if (tz[tz.length - 1] >= x1) {
                    if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                        const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                        if (isFinite(step)) {
                            if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                            else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                        }
                    } else tz.pop();
                }
            }
            // Remove any thresholds outside the domain.
            var m = tz.length;
            while(tz[0] <= x0)tz.shift(), --m;
            while(tz[m - 1] > x1)tz.pop(), --m;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            for(i = 0; i < n; ++i){
                x = values[i];
                if (x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), histogram) : threshold;
        };
        return histogram;
    });
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);

},{"./array.js":"dM7Dy","./bisect.js":"8Z3Gd","./constant.js":"eRzJW","./extent.js":"iIW8w","./identity.js":"3gC8n","./nice.js":"6GrCC","./ticks.js":"3ZTQ7","./threshold/sturges.js":"g04dA","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dM7Dy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eRzJW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6GrCC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"3ZTQ7","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3ZTQ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            let r0 = Math.round(start / step), r1 = Math.round(stop / step);
            if (r0 * step < start) ++r0;
            if (r1 * step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) * step;
        } else {
            step = -step;
            let r0 = Math.round(start * step), r1 = Math.round(stop * step);
            if (r0 / step < start) ++r0;
            if (r1 / step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    });
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g04dA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        return Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1;
    });
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);

},{"../count.js":"7EMwg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7Rh54":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        return Math.ceil((max - min) / (2 * ((0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25)) * Math.pow((0, _countJsDefault.default)(values), -1 / 3)));
    });
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);

},{"../count.js":"7EMwg","../quantile.js":"iOcul","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iOcul":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"./max.js":"hKDPn","./min.js":"bW7gM","./quickselect.js":"4MhNN","./number.js":"eGkTv","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hKDPn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bW7gM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4MhNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function quickselect(array, k, left = 0, right = array.length - 1, compare = (0, _ascendingJsDefault.default)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./ascending.js":"b8bGy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"93xXd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        return Math.ceil((max - min) / (3.5 * (0, _deviationJsDefault.default)(values) * Math.pow((0, _countJsDefault.default)(values), -1 / 3)));
    });
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);

},{"../count.js":"7EMwg","../deviation.js":"dVjZh","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jXfoW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"xE9tE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hq1D8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        return (0, _quantileJsDefault.default)(values, 0.5, valueof);
    });
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);

},{"./quantile.js":"iOcul","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6RviJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"j99r9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dMCWc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fxJKQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7SgBs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"b8bGy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4h9pE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"b8bGy","./minIndex.js":"j99r9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1940a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"b8bGy","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"egIy0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"b8bGy","./maxIndex.js":"jXfoW","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"69IRd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"4h9pE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3djxD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fml6f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8NFQ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    });
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function length(d) {
    return d.length;
}

},{"./min.js":"bW7gM","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1oJkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _transposeJsDefault.default)(arguments);
    });
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);

},{"./transpose.js":"8NFQ3","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3hxDu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kARZg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4bVf2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hOank":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"euYTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eGzGm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8QHd6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
function difference(values, ...others) {
    values = new Set(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"c5UwE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new Set();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5uaXh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _setJs = require("./set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
function intersection(values, ...others) {
    values = new Set(values);
    others = others.map((0, _setJsDefault.default));
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}

},{"./set.js":"6dUOR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6dUOR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>set);
function set(values) {
    return values instanceof Set ? values : new Set(values);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"likis":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"gNp3o","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gNp3o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        if (set.has(o)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            set.add(value);
            if (Object.is(o, value)) break;
        }
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4BaVQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
function union(...others) {
    const set = new Set();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jaSpq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6Wigm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new Map(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== implicit) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"./init.js":"jaSpq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2UimK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"ljA07","./continuous.js":"gZ7eI","./init.js":"jaSpq","./tickFormat.js":"kXRqE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gZ7eI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":"ljA07","d3-interpolate":"gydkL","./constant.js":"a9yqp","./number.js":"d4097","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gydkL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"kbqkS","./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":"1DVf0","./numberArray.js":false,"./object.js":false,"./round.js":"iGKxf","./string.js":false,"./transform/index.js":false,"./zoom.js":false,"./rgb.js":"x2Wq7","./hsl.js":false,"./lab.js":false,"./hcl.js":false,"./cubehelix.js":"kWA0V","./piecewise.js":false,"./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kbqkS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":"fIEE2","./rgb.js":"x2Wq7","./array.js":"cnvY8","./date.js":"9bfRq","./number.js":"1DVf0","./object.js":"1vIOx","./string.js":"bXryg","./constant.js":"btQoG","./numberArray.js":"ktevV","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fIEE2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"idGlk","./lab.js":false,"./cubehelix.js":"7aH8B","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"idGlk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"lcBAI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lcBAI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7aH8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.rad2deg) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"lcBAI","./color.js":"idGlk","./math.js":"jMx7c","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jMx7c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deg2rad", ()=>deg2rad);
parcelHelpers.export(exports, "rad2deg", ()=>rad2deg);
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"x2Wq7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"fIEE2","./basis.js":"dyBJg","./basisClosed.js":"fAedC","./color.js":"a8xY0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dyBJg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fAedC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"dyBJg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a8xY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"btQoG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"btQoG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cnvY8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"kbqkS","./numberArray.js":"ktevV","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ktevV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9bfRq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1DVf0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1vIOx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"kbqkS","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bXryg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"1DVf0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iGKxf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kWA0V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"fIEE2","./color.js":"a8xY0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a9yqp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d4097":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kXRqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"ljA07","d3-format":"3rxcZ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3rxcZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"9M7Mc","./locale.js":false,"./formatSpecifier.js":"k0SEE","./precisionFixed.js":"llCtV","./precisionPrefix.js":"7TRhZ","./precisionRound.js":"jPejq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9M7Mc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"enPLG","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"enPLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"4lpYE","./formatGroup.js":"gNDuY","./formatNumerals.js":"9eIoJ","./formatSpecifier.js":"k0SEE","./formatTrim.js":"bzENx","./formatTypes.js":"ijq6J","./formatPrefixAuto.js":"2WOuU","./identity.js":"drpgu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4lpYE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"ihXPR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ihXPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gNDuY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9eIoJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k0SEE":[function(require,module,exports) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bzENx":[function(require,module,exports) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ijq6J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, _formatDecimalJsDefault.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRoundedJsDefault.default)(x * 100, p);
    },
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

},{"./formatDecimal.js":"ihXPR","./formatPrefixAuto.js":"2WOuU","./formatRounded.js":"6YM8Z","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2WOuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"ihXPR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6YM8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"ihXPR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"drpgu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"llCtV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"4lpYE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7TRhZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"4lpYE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jPejq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"4lpYE","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l0P03":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function loggish(transform) {
    var scale = transform(transformLog, transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, _d3Format.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function log() {
    var scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, log()).base(scale.base());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"ljA07","d3-format":"3rxcZ","./nice.js":"7PM2j","./continuous.js":"gZ7eI","./init.js":"jaSpq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7PM2j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lMjsC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"2UimK","./continuous.js":"gZ7eI","./init.js":"jaSpq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dt5tO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"2UimK","./continuous.js":"gZ7eI","./init.js":"jaSpq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hCv96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"ljA07","./linear.js":"2UimK","./init.js":"jaSpq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ajDG0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"gydkL","./continuous.js":"gZ7eI","./init.js":"jaSpq","./linear.js":"2UimK","./log.js":"l0P03","./symlog.js":"lMjsC","./pow.js":"dt5tO","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"laFUI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"aFqmc","./categorical/Accent.js":"dVOHh","./categorical/Dark2.js":"ldx6c","./categorical/Paired.js":"kdVnu","./categorical/Pastel1.js":"cZron","./categorical/Pastel2.js":"90j8W","./categorical/Set1.js":"dqEom","./categorical/Set2.js":"1DIV4","./categorical/Set3.js":"kKVnD","./categorical/Tableau10.js":false,"./diverging/BrBG.js":"iAfAf","./diverging/PRGn.js":"7QlTp","./diverging/PiYG.js":"bWMHH","./diverging/PuOr.js":"1VXPR","./diverging/RdBu.js":"h3Kr3","./diverging/RdGy.js":"2UFad","./diverging/RdYlBu.js":"UzBSA","./diverging/RdYlGn.js":"akEbx","./diverging/Spectral.js":"03jNL","./sequential-multi/BuGn.js":"eUBPL","./sequential-multi/BuPu.js":"ecKTo","./sequential-multi/GnBu.js":"4XuF9","./sequential-multi/OrRd.js":"byCgC","./sequential-multi/PuBuGn.js":"iYuV6","./sequential-multi/PuBu.js":"jQzcd","./sequential-multi/PuRd.js":"aoown","./sequential-multi/RdPu.js":"34D6G","./sequential-multi/YlGnBu.js":"13dB9","./sequential-multi/YlGn.js":"LzrRC","./sequential-multi/YlOrBr.js":"2zkuL","./sequential-multi/YlOrRd.js":"aupwH","./sequential-single/Blues.js":"dyJaf","./sequential-single/Greens.js":"hKl9F","./sequential-single/Greys.js":"bG1A5","./sequential-single/Purples.js":"815GB","./sequential-single/Reds.js":"jJC0Q","./sequential-single/Oranges.js":"bkzXC","./sequential-multi/cividis.js":false,"./sequential-multi/cubehelix.js":"irejo","./sequential-multi/rainbow.js":"62k2y","./sequential-multi/sinebow.js":"8P0pb","./sequential-multi/turbo.js":false,"./sequential-multi/viridis.js":"at8Tm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aFqmc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"d8zV8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dVOHh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ldx6c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kdVnu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cZron":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"90j8W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dqEom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1DIV4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kKVnD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iAfAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3cvAg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(scheme) {
        return (0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);
    });
var _d3Interpolate = require("d3-interpolate");

},{"d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7QlTp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bWMHH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1VXPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h3Kr3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2UFad":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"UzBSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"akEbx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"03jNL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eUBPL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ecKTo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4XuF9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"byCgC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iYuV6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jQzcd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aoown":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"34D6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"13dB9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"LzrRC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2zkuL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aupwH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dyJaf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hKl9F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bG1A5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"815GB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jJC0Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bkzXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d8zV8","../ramp.js":"3cvAg","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"irejo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"fIEE2","d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"62k2y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"fIEE2","d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8P0pb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"fIEE2","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"at8Tm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"d8zV8","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kgLQU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _indexJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _indexJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _indexJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbols));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _indexJs = require("./link/index.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"7ACSA","./area.js":false,"./line.js":"dLMG0","./pie.js":"diCGN","./areaRadial.js":false,"./lineRadial.js":false,"./pointRadial.js":false,"./link/index.js":false,"./symbol.js":false,"./symbol/circle.js":false,"./symbol/cross.js":false,"./symbol/diamond.js":false,"./symbol/square.js":false,"./symbol/star.js":false,"./symbol/triangle.js":false,"./symbol/wye.js":false,"./curve/basisClosed.js":"dI1uG","./curve/basisOpen.js":"gRZ8b","./curve/basis.js":"3QAib","./curve/bundle.js":"edrJo","./curve/cardinalClosed.js":"1QyhW","./curve/cardinalOpen.js":"bpzSD","./curve/cardinal.js":"f0ZPo","./curve/catmullRomClosed.js":"g6Jk4","./curve/catmullRomOpen.js":"744hE","./curve/catmullRom.js":"9g0eI","./curve/linearClosed.js":"1amw4","./curve/linear.js":"aGrPz","./curve/monotone.js":"6sfoZ","./curve/natural.js":"3s9QH","./curve/step.js":"hMQPp","./stack.js":"bWEg7","./offset/expand.js":"a30Bf","./offset/diverging.js":"gFfhX","./offset/none.js":"lbesj","./offset/silhouette.js":"hg4Fu","./offset/wiggle.js":"1nZky","./order/appearance.js":false,"./order/ascending.js":"eJYGl","./order/descending.js":"euHiu","./order/insideOut.js":"4Hf1p","./order/none.js":"fQ8JK","./order/reverse.js":"38Cg0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7ACSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = (0, _d3Path.path)();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < (0, _mathJs.pi) && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"d3-path":"6UBRd","./constant.js":"7FWB4","./math.js":"hof2q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6UBRd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", ()=>(0, _pathJsDefault.default));
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);

},{"./path.js":"dkgeH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dkgeH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path;
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
exports.default = path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7FWB4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hof2q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dLMG0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = (0, _pointJs.x), y = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function line(data) {
            var i, n = data.length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pointJs = require("./point.js");

},{"d3-path":"6UBRd","./constant.js":"7FWB4","./curve/linear.js":"aGrPz","./point.js":"avedc","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aGrPz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"avedc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"diCGN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./constant.js":"7FWB4","./descending.js":"8dGbH","./identity.js":"erSOz","./math.js":"hof2q","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8dGbH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"erSOz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        return d;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dI1uG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"SpYGU","./basis.js":"3QAib","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"SpYGU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3QAib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gRZ8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"3QAib","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"edrJo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"3QAib","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1QyhW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"SpYGU","./cardinal.js":"f0ZPo","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"f0ZPo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bpzSD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"f0ZPo","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"g6Jk4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"1QyhW","../noop.js":"SpYGU","./catmullRom.js":"9g0eI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9g0eI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"hof2q","./cardinal.js":"f0ZPo","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"744hE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"bpzSD","./catmullRom.js":"9g0eI","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1amw4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"SpYGU","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6sfoZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3s9QH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hMQPp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bWEg7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
            for(i = 0; i < n; ++i){
                for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                    si[j] = sij = [
                        0,
                        +value(data[j], ki, j, data)
                    ];
                    sij.data = data[j];
                }
                si.key = ki;
            }
            for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    });
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}

},{"./array.js":"gzMzS","./constant.js":"7FWB4","./offset/none.js":"lbesj","./order/none.js":"fQ8JK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gzMzS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lbesj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fQ8JK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a30Bf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"lbesj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gFfhX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hg4Fu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"lbesj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1nZky":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"lbesj","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aFEJB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"fQ8JK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eJYGl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    });
parcelHelpers.export(exports, "sum", ()=>sum);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"fQ8JK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"euHiu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"eJYGl","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4Hf1p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    });
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"aFEJB","./ascending.js":"eJYGl","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"38Cg0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"fQ8JK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aOVRm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cluster", ()=>(0, _clusterJsDefault.default));
parcelHelpers.export(exports, "hierarchy", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "pack", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "packSiblings", ()=>(0, _siblingsJsDefault.default));
parcelHelpers.export(exports, "packEnclose", ()=>(0, _encloseJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "stratify", ()=>(0, _stratifyJsDefault.default));
parcelHelpers.export(exports, "tree", ()=>(0, _treeJsDefault.default));
parcelHelpers.export(exports, "treemap", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "treemapBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "treemapDice", ()=>(0, _diceJsDefault.default));
parcelHelpers.export(exports, "treemapSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "treemapSliceDice", ()=>(0, _sliceDiceJsDefault.default));
parcelHelpers.export(exports, "treemapSquarify", ()=>(0, _squarifyJsDefault.default));
parcelHelpers.export(exports, "treemapResquarify", ()=>(0, _resquarifyJsDefault.default));
var _clusterJs = require("./cluster.js");
var _clusterJsDefault = parcelHelpers.interopDefault(_clusterJs);
var _indexJs = require("./hierarchy/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./pack/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _siblingsJs = require("./pack/siblings.js");
var _siblingsJsDefault = parcelHelpers.interopDefault(_siblingsJs);
var _encloseJs = require("./pack/enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _stratifyJs = require("./stratify.js");
var _stratifyJsDefault = parcelHelpers.interopDefault(_stratifyJs);
var _treeJs = require("./tree.js");
var _treeJsDefault = parcelHelpers.interopDefault(_treeJs);
var _indexJs2 = require("./treemap/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _binaryJs = require("./treemap/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./treemap/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sliceDiceJs = require("./treemap/sliceDice.js");
var _sliceDiceJsDefault = parcelHelpers.interopDefault(_sliceDiceJs);
var _squarifyJs = require("./treemap/squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _resquarifyJs = require("./treemap/resquarify.js");
var _resquarifyJsDefault = parcelHelpers.interopDefault(_resquarifyJs);

},{"./cluster.js":false,"./hierarchy/index.js":"8LXbO","./pack/index.js":false,"./pack/siblings.js":false,"./pack/enclose.js":false,"./partition.js":false,"./stratify.js":false,"./tree.js":false,"./treemap/index.js":false,"./treemap/binary.js":"dHBTk","./treemap/dice.js":"27gXT","./treemap/slice.js":"cFLTK","./treemap/sliceDice.js":"7Z28l","./treemap/squarify.js":"17Gph","./treemap/resquarify.js":"ahv3m","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8LXbO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
function hierarchy(data, children) {
    var root = new Node(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new Node(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function defaultChildren(d) {
    return d.children;
}
function copyData(node) {
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy
};

},{"./count.js":"jQ6Bs","./each.js":"adae2","./eachBefore.js":"kYbZR","./eachAfter.js":"3FDdu","./sum.js":"12yom","./sort.js":"jAvAP","./path.js":"hv0bl","./ancestors.js":"8sOFK","./descendants.js":"8wrB3","./leaves.js":"l43fj","./links.js":"e2eXm","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jQ6Bs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"adae2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                callback(node), children = node.children;
                if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kYbZR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var node = this, nodes = [
            node
        ], children, i;
        while(node = nodes.pop()){
            callback(node), children = node.children;
            if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3FDdu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n;
        while(node = nodes.pop()){
            next.push(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback(node);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"12yom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jAvAP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hv0bl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8sOFK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8wrB3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes = [];
        this.each(function(node) {
            nodes.push(node);
        });
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l43fj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e2eXm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dHBTk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = (x0 * valueRight + x1 * valueLeft) / value;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = (y0 * valueRight + y1 * valueLeft) / value;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"27gXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cFLTK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"7Z28l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"27gXT","./slice.js":"cFLTK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"17Gph":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"27gXT","./slice.js":"cFLTK","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ahv3m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, _sliceJsDefault.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"27gXT","./slice.js":"cFLTK","./squarify.js":"17Gph","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"285I3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"bZ1PP","./locale.js":false,"./isoFormat.js":false,"./isoParse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"bZ1PP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"cqBUH","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cqBUH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"dNf0J","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dNf0J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJsDefault.default));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJsDefault.default));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.minutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJsDefault.default));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.hours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJsDefault.default));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.days));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.monday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.mondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.tuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.tuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.wednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.wednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.thursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.thursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.friday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.fridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.saturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.saturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJsDefault.default));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.months));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJsDefault.default));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.years));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _utcMinuteJsDefault.default));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _utcMinuteJs.utcMinutes));
parcelHelpers.export(exports, "utcHour", ()=>(0, _utcHourJsDefault.default));
parcelHelpers.export(exports, "utcHours", ()=>(0, _utcHourJs.utcHours));
parcelHelpers.export(exports, "utcDay", ()=>(0, _utcDayJsDefault.default));
parcelHelpers.export(exports, "utcDays", ()=>(0, _utcDayJs.utcDays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _utcWeekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _utcWeekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _utcWeekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _utcWeekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _utcWeekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _utcWeekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _utcWeekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _utcWeekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _utcWeekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _utcWeekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _utcWeekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _utcWeekJs.utcSaturdays));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _utcMonthJsDefault.default));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _utcMonthJs.utcMonths));
parcelHelpers.export(exports, "utcYear", ()=>(0, _utcYearJsDefault.default));
parcelHelpers.export(exports, "utcYears", ()=>(0, _utcYearJs.utcYears));
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);

},{"./interval.js":false,"./millisecond.js":"biijN","./second.js":"gXIzO","./minute.js":"1YvuF","./hour.js":"guSc3","./day.js":"4VcVJ","./week.js":"igEJ8","./month.js":"2GstP","./year.js":"61rmF","./utcMinute.js":"jBmEj","./utcHour.js":"dVHTs","./utcDay.js":"amegU","./utcWeek.js":"h4hOf","./utcMonth.js":"947ID","./utcYear.js":"9gLMz","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jr5s9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newInterval);
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"biijN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var millisecond = (0, _intervalJsDefault.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJsDefault.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
exports.default = millisecond;
var milliseconds = millisecond.range;

},{"./interval.js":"jr5s9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gXIzO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1euz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1YvuF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", ()=>minutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"guSc3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", ()=>hours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4VcVJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", ()=>days);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
exports.default = day;
var days = day.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"igEJ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", ()=>sunday);
parcelHelpers.export(exports, "monday", ()=>monday);
parcelHelpers.export(exports, "tuesday", ()=>tuesday);
parcelHelpers.export(exports, "wednesday", ()=>wednesday);
parcelHelpers.export(exports, "thursday", ()=>thursday);
parcelHelpers.export(exports, "friday", ()=>friday);
parcelHelpers.export(exports, "saturday", ()=>saturday);
parcelHelpers.export(exports, "sundays", ()=>sundays);
parcelHelpers.export(exports, "mondays", ()=>mondays);
parcelHelpers.export(exports, "tuesdays", ()=>tuesdays);
parcelHelpers.export(exports, "wednesdays", ()=>wednesdays);
parcelHelpers.export(exports, "thursdays", ()=>thursdays);
parcelHelpers.export(exports, "fridays", ()=>fridays);
parcelHelpers.export(exports, "saturdays", ()=>saturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2GstP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", ()=>months);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"jr5s9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"61rmF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", ()=>years);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"jr5s9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jBmEj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dVHTs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"amegU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h4hOf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"jr5s9","./duration.js":"1euz4","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"947ID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"jr5s9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9gLMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"jr5s9","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"1DqG0":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5ec6c9f24fb7f9a4");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("adb4723ef5bd5dcb"));
var _wrapDisplayName = _interopRequireDefault(require("8e36d0a5d8f0032b"));
var _setDisplayName = _interopRequireDefault(require("2a86e57e44954a08"));
var _mapProps = _interopRequireDefault(require("6f87bffa4df2059f"));
var withProps = function withProps(input) {
    var hoc = (0, _mapProps.default)(function(props) {
        return (0, _extends2.default)({}, props, typeof input === "function" ? input(props) : input);
    });
    return hoc;
};
var _default = withProps;
exports.default = _default;

},{"5ec6c9f24fb7f9a4":"eZnmC","adb4723ef5bd5dcb":"l6HRm","8e36d0a5d8f0032b":"7bdyS","2a86e57e44954a08":"9JGr7","6f87bffa4df2059f":"iy9PK"}],"eZnmC":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"7bdyS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7a6a7560bb694bf");
exports.__esModule = true;
exports.default = void 0;
var _getDisplayName = _interopRequireDefault(require("ac6dff5dab374012"));
var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
    return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};
var _default = wrapDisplayName;
exports.default = _default;

},{"7a6a7560bb694bf":"eZnmC","ac6dff5dab374012":"haxXv"}],"haxXv":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var getDisplayName = function getDisplayName(Component) {
    if (typeof Component === "string") return Component;
    if (!Component) return undefined;
    return Component.displayName || Component.name || "Component";
};
var _default = getDisplayName;
exports.default = _default;

},{}],"9JGr7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3b49ed7bce67d715");
exports.__esModule = true;
exports.default = void 0;
var _setStatic = _interopRequireDefault(require("e898af94aaa9bd92"));
var setDisplayName = function setDisplayName(displayName) {
    return (0, _setStatic.default)("displayName", displayName);
};
var _default = setDisplayName;
exports.default = _default;

},{"3b49ed7bce67d715":"eZnmC","e898af94aaa9bd92":"7CCk6"}],"7CCk6":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var setStatic = function setStatic(key, value) {
    return function(BaseComponent) {
        /* eslint-disable no-param-reassign */ BaseComponent[key] = value;
        /* eslint-enable no-param-reassign */ return BaseComponent;
    };
};
var _default = setStatic;
exports.default = _default;

},{}],"iy9PK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b2763353e6719b9a");
exports.__esModule = true;
exports.default = void 0;
var _react = require("c98817b01fa7822e");
var _setDisplayName = _interopRequireDefault(require("95fc7bc99f4761b7"));
var _wrapDisplayName = _interopRequireDefault(require("4023e00db1cad7a9"));
var mapProps = function mapProps(propsMapper) {
    return function(BaseComponent) {
        var factory = (0, _react.createFactory)(BaseComponent);
        var MapProps = function MapProps(props) {
            return factory(propsMapper(props));
        };
        return MapProps;
    };
};
var _default = mapProps;
exports.default = _default;

},{"b2763353e6719b9a":"eZnmC","c98817b01fa7822e":"6AiW6","95fc7bc99f4761b7":"9JGr7","4023e00db1cad7a9":"7bdyS"}],"lv27x":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var compose = function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    }, function(arg) {
        return arg;
    });
};
var _default = compose;
exports.default = _default;

},{}],"bV7hD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ade371e67d9adacd");
exports.__esModule = true;
exports.default = void 0;
var _setStatic = _interopRequireDefault(require("19e57e8439183a27"));
var setPropTypes = function setPropTypes(propTypes) {
    return (0, _setStatic.default)("propTypes", propTypes);
};
var _default = setPropTypes;
exports.default = _default;

},{"ade371e67d9adacd":"eZnmC","19e57e8439183a27":"7CCk6"}],"6nQWc":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d954f9e4a5228988");
exports.__esModule = true;
exports.default = void 0;
var _react = require("8f01258c2c6adbe7");
var _setDisplayName = _interopRequireDefault(require("83ff5072aaf60ee8"));
var _wrapDisplayName = _interopRequireDefault(require("9f957b2c89b265e5"));
var defaultProps = function defaultProps(props) {
    return function(BaseComponent) {
        var factory = (0, _react.createFactory)(BaseComponent);
        var DefaultProps = function DefaultProps(ownerProps) {
            return factory(ownerProps);
        };
        DefaultProps.defaultProps = props;
        return DefaultProps;
    };
};
var _default = defaultProps;
exports.default = _default;

},{"d954f9e4a5228988":"eZnmC","8f01258c2c6adbe7":"6AiW6","83ff5072aaf60ee8":"9JGr7","9f957b2c89b265e5":"7bdyS"}],"bf8Lh":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f80a82f35803ce6a");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("8b39bcf82611ec33"));
var _inheritsLoose2 = _interopRequireDefault(require("a2daf9b5064c919d"));
var _react = require("8fe45b677240c9b0");
var _reactLifecyclesCompat = require("f6724807c0c95fd2");
var _pick = _interopRequireDefault(require("388816241c185dd0"));
var _shallowEqual = _interopRequireDefault(require("aa1b9cf03ce73a0f"));
var _setDisplayName = _interopRequireDefault(require("9762c1e0d6f22b5b"));
var _wrapDisplayName = _interopRequireDefault(require("a67b816f823e9d9e"));
var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
    return function(BaseComponent) {
        var factory = (0, _react.createFactory)(BaseComponent);
        var shouldMap = typeof shouldMapOrKeys === "function" ? shouldMapOrKeys : function(props, nextProps) {
            return !(0, _shallowEqual.default)((0, _pick.default)(props, shouldMapOrKeys), (0, _pick.default)(nextProps, shouldMapOrKeys));
        };
        var WithPropsOnChange = /*#__PURE__*/ function(_Component) {
            (0, _inheritsLoose2.default)(WithPropsOnChange, _Component);
            function WithPropsOnChange() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _Component.call.apply(_Component, [
                    this
                ].concat(args)) || this;
                _this.state = {
                    computedProps: propsMapper(_this.props),
                    prevProps: _this.props
                };
                return _this;
            }
            WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
                if (shouldMap(prevState.prevProps, nextProps)) return {
                    computedProps: propsMapper(nextProps),
                    prevProps: nextProps
                };
                return {
                    prevProps: nextProps
                };
            };
            var _proto = WithPropsOnChange.prototype;
            _proto.render = function render() {
                return factory((0, _extends2.default)({}, this.props, this.state.computedProps));
            };
            return WithPropsOnChange;
        }(_react.Component);
        (0, _reactLifecyclesCompat.polyfill)(WithPropsOnChange);
        return WithPropsOnChange;
    };
};
var _default = withPropsOnChange;
exports.default = _default;

},{"f80a82f35803ce6a":"eZnmC","8b39bcf82611ec33":"l6HRm","a2daf9b5064c919d":"gRWRc","8fe45b677240c9b0":"6AiW6","f6724807c0c95fd2":"4p7lQ","388816241c185dd0":"5riLw","aa1b9cf03ce73a0f":"fb6wP","9762c1e0d6f22b5b":"9JGr7","a67b816f823e9d9e":"7bdyS"}],"4p7lQ":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5riLw":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var pick = function pick(obj, keys) {
    var result = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (obj.hasOwnProperty(key)) result[key] = obj[key];
    }
    return result;
};
var _default = pick;
exports.default = _default;

},{}],"fb6wP":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("28e36b8fe446a180");
exports.__esModule = true;
exports.default = void 0;
var _shallowEqual = _interopRequireDefault(require("1a2c0a7540c82656"));
var _default = _shallowEqual.default;
exports.default = _default;

},{"28e36b8fe446a180":"eZnmC","1a2c0a7540c82656":"6Ei1p"}],"6Ei1p":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */ /*eslint-disable no-self-compare */ "use strict";
var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
    // SameValue algorithm
    if (x === y) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(var i = 0; i < keysA.length; i++){
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
module.exports = shallowEqual;

},{}],"7e9ga":[function(require,module,exports) {
var baseRest = require("725af6f54fc7f252"), createWrap = require("466f895250cc98b4"), getHolder = require("cdfa922541a36e5b"), replaceHolders = require("ec4f6825fcbd2e04");
/** Used to compose bitmasks for function metadata. */ var WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */ var partialRight = baseRest(function(func, partials) {
    var holders = replaceHolders(partials, getHolder(partialRight));
    return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});
// Assign default placeholders.
partialRight.placeholder = {};
module.exports = partialRight;

},{"725af6f54fc7f252":"cFFHO","466f895250cc98b4":"jjvea","cdfa922541a36e5b":"jTQF9","ec4f6825fcbd2e04":"3PNFR"}],"jjvea":[function(require,module,exports) {
var baseSetData = require("409194a967409865"), createBind = require("f88dc89f94fe40a3"), createCurry = require("29ea913928e7d154"), createHybrid = require("2adf83513657047c"), createPartial = require("c86d22b8cb5bc4fc"), getData = require("2d859c2fc32d8003"), mergeData = require("58e166128ff051de"), setData = require("f669ed19558981e5"), setWrapToString = require("3a1920f3fd9cced0"), toInteger = require("16ec8d22e97f7e63");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
    arity = arity === undefined ? arity : toInteger(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : getData(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) mergeData(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
    else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
    else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
    else result = createHybrid.apply(undefined, newData);
    var setter = data ? baseSetData : setData;
    return setWrapToString(setter(result, newData), func, bitmask);
}
module.exports = createWrap;

},{"409194a967409865":"4VH3s","f88dc89f94fe40a3":"jkjDU","29ea913928e7d154":"bmUhg","2adf83513657047c":"euKbE","c86d22b8cb5bc4fc":"88NKT","2d859c2fc32d8003":"bfsx0","58e166128ff051de":"3CgGb","f669ed19558981e5":"c6hAt","3a1920f3fd9cced0":"apB2s","16ec8d22e97f7e63":"4WHfQ"}],"4VH3s":[function(require,module,exports) {
var identity = require("64b374501e4aa524"), metaMap = require("e1fa1ff9966d0e31");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var baseSetData = !metaMap ? identity : function(func, data) {
    metaMap.set(func, data);
    return func;
};
module.exports = baseSetData;

},{"64b374501e4aa524":"5HMso","e1fa1ff9966d0e31":"52edm"}],"52edm":[function(require,module,exports) {
var WeakMap = require("e4c0cdd8d94afe67");
/** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
module.exports = metaMap;

},{"e4c0cdd8d94afe67":"6imid"}],"jkjDU":[function(require,module,exports) {
var createCtor = require("ccaaf0e66be6c54a"), root = require("d1dd8dedf8fd24c7");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createBind(func, bitmask, thisArg) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
    function wrapper() {
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = createBind;

},{"ccaaf0e66be6c54a":"8drlc","d1dd8dedf8fd24c7":"5yGId"}],"8drlc":[function(require,module,exports) {
var baseCreate = require("df50f76f41ee2ce5"), isObject = require("b541546f05e2a238");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
    };
}
module.exports = createCtor;

},{"df50f76f41ee2ce5":"fNQBY","b541546f05e2a238":"kDBLt"}],"bmUhg":[function(require,module,exports) {
var apply = require("388fbbd86e6fe243"), createCtor = require("77e2a1940f4ba2c8"), createHybrid = require("a562f889cf091133"), createRecurry = require("7e279b7556b7064c"), getHolder = require("4927f0c28406c6ff"), replaceHolders = require("90abff02836ba632"), root = require("c9c2f614b542db58");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createCurry(func, bitmask, arity) {
    var Ctor = createCtor(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = getHolder(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
        length -= holders.length;
        if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return apply(fn, this, args);
    }
    return wrapper;
}
module.exports = createCurry;

},{"388fbbd86e6fe243":"dAmzO","77e2a1940f4ba2c8":"8drlc","a562f889cf091133":"euKbE","7e279b7556b7064c":"bAq0e","4927f0c28406c6ff":"jTQF9","90abff02836ba632":"3PNFR","c9c2f614b542db58":"5yGId"}],"euKbE":[function(require,module,exports) {
var composeArgs = require("e5b1f7769f51a295"), composeArgsRight = require("7521cffaa8d6168b"), countHolders = require("48392761c9fdbe47"), createCtor = require("ad0b9ebe1b614b63"), createRecurry = require("534414524611b6c2"), getHolder = require("1bb141c8de8d25e5"), reorder = require("3f41ce0b0d04374f"), replaceHolders = require("d8aa89cb216e33ea"), root = require("e22e533ef0983b6c");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_ARY_FLAG = 128, WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
        if (partials) args = composeArgs(args, partials, holders, isCurried);
        if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = reorder(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = createHybrid;

},{"e5b1f7769f51a295":"eBNEJ","7521cffaa8d6168b":"hfON3","48392761c9fdbe47":"I4Fhl","ad0b9ebe1b614b63":"8drlc","534414524611b6c2":"bAq0e","1bb141c8de8d25e5":"jTQF9","3f41ce0b0d04374f":"lCy4d","d8aa89cb216e33ea":"3PNFR","e22e533ef0983b6c":"5yGId"}],"eBNEJ":[function(require,module,exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = composeArgs;

},{}],"hfON3":[function(require,module,exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = composeArgsRight;

},{}],"I4Fhl":[function(require,module,exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = countHolders;

},{}],"bAq0e":[function(require,module,exports) {
var isLaziable = require("e94afdb912b40a39"), setData = require("d53c8677d10257d3"), setWrapToString = require("87f278675d13ada5");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
    if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if (isLaziable(func)) setData(result, newData);
    result.placeholder = placeholder;
    return setWrapToString(result, func, bitmask);
}
module.exports = createRecurry;

},{"e94afdb912b40a39":"xJuLd","d53c8677d10257d3":"c6hAt","87f278675d13ada5":"apB2s"}],"xJuLd":[function(require,module,exports) {
var LazyWrapper = require("56693ece680765d7"), getData = require("60c1c90169f6a5fe"), getFuncName = require("c8348f842539c358"), lodash = require("81fdf3ae1e47ec3e");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function isLaziable(func) {
    var funcName = getFuncName(func), other = lodash[funcName];
    if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
    if (func === other) return true;
    var data = getData(other);
    return !!data && func === data[0];
}
module.exports = isLaziable;

},{"56693ece680765d7":"4quPU","60c1c90169f6a5fe":"bfsx0","c8348f842539c358":"jrLYL","81fdf3ae1e47ec3e":"jkBG5"}],"4quPU":[function(require,module,exports) {
var baseCreate = require("e4056cbc3b9903bd"), baseLodash = require("3dfa16f8f7f9ba49");
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;
module.exports = LazyWrapper;

},{"e4056cbc3b9903bd":"fNQBY","3dfa16f8f7f9ba49":"2fWwk"}],"2fWwk":[function(require,module,exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function baseLodash() {
// No operation performed.
}
module.exports = baseLodash;

},{}],"bfsx0":[function(require,module,exports) {
var metaMap = require("64c6b8282a70671c"), noop = require("19698e8556ad5081");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var getData = !metaMap ? noop : function(func) {
    return metaMap.get(func);
};
module.exports = getData;

},{"64c6b8282a70671c":"52edm","19698e8556ad5081":"b9txl"}],"jrLYL":[function(require,module,exports) {
var realNames = require("14ca6afa60113322");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function getFuncName(func) {
    var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = getFuncName;

},{"14ca6afa60113322":"b6o9w"}],"b6o9w":[function(require,module,exports) {
/** Used to lookup unminified function names. */ var realNames = {};
module.exports = realNames;

},{}],"jkBG5":[function(require,module,exports) {
var LazyWrapper = require("e957c6a134f81ad3"), LodashWrapper = require("dc12267c6e1ac251"), baseLodash = require("2e62ee2285f7942e"), isArray = require("7d71cf75ddd5142"), isObjectLike = require("31691bc364b8b2af"), wrapperClone = require("d2329b4b44e63943");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function lodash(value) {
    if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) return value;
        if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
    }
    return new LodashWrapper(value);
}
// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;
module.exports = lodash;

},{"e957c6a134f81ad3":"4quPU","dc12267c6e1ac251":"f7ZAC","2e62ee2285f7942e":"2fWwk","7d71cf75ddd5142":"9om8C","31691bc364b8b2af":"h29TI","d2329b4b44e63943":"fFTBt"}],"f7ZAC":[function(require,module,exports) {
var baseCreate = require("1f2f5be1a3c6d678"), baseLodash = require("2c2205c836afd08b");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;
module.exports = LodashWrapper;

},{"1f2f5be1a3c6d678":"fNQBY","2c2205c836afd08b":"2fWwk"}],"fFTBt":[function(require,module,exports) {
var LazyWrapper = require("c911f6aa155b3acf"), LodashWrapper = require("8e63eae4d3286327"), copyArray = require("633c60334a2eb5ec");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function wrapperClone(wrapper) {
    if (wrapper instanceof LazyWrapper) return wrapper.clone();
    var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = copyArray(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = wrapperClone;

},{"c911f6aa155b3acf":"4quPU","8e63eae4d3286327":"f7ZAC","633c60334a2eb5ec":"btK5B"}],"c6hAt":[function(require,module,exports) {
var baseSetData = require("8a974c6f711104d4"), shortOut = require("8d948a175fb74005");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var setData = shortOut(baseSetData);
module.exports = setData;

},{"8a974c6f711104d4":"4VH3s","8d948a175fb74005":"adumK"}],"apB2s":[function(require,module,exports) {
var getWrapDetails = require("ce1525e50ee5903f"), insertWrapDetails = require("8ac4da188da03fb"), setToString = require("f6a71ef5006628a0"), updateWrapDetails = require("b632a55f254888a4");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function setWrapToString(wrapper, reference, bitmask) {
    var source = reference + "";
    return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}
module.exports = setWrapToString;

},{"ce1525e50ee5903f":"jNQip","8ac4da188da03fb":"eETfJ","f6a71ef5006628a0":"5wgE3","b632a55f254888a4":"9Kxnx"}],"jNQip":[function(require,module,exports) {
/** Used to match wrap detail comments. */ var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function getWrapDetails(source) {
    var match = source.match(reWrapDetails);
    return match ? match[1].split(reSplitDetails) : [];
}
module.exports = getWrapDetails;

},{}],"eETfJ":[function(require,module,exports) {
/** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
    details = details.join(length > 2 ? ", " : " ");
    return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
}
module.exports = insertWrapDetails;

},{}],"9Kxnx":[function(require,module,exports) {
var arrayEach = require("a7a49cef037dbfe1"), arrayIncludes = require("af2237e87f92af85");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
    [
        "ary",
        WRAP_ARY_FLAG
    ],
    [
        "bind",
        WRAP_BIND_FLAG
    ],
    [
        "bindKey",
        WRAP_BIND_KEY_FLAG
    ],
    [
        "curry",
        WRAP_CURRY_FLAG
    ],
    [
        "curryRight",
        WRAP_CURRY_RIGHT_FLAG
    ],
    [
        "flip",
        WRAP_FLIP_FLAG
    ],
    [
        "partial",
        WRAP_PARTIAL_FLAG
    ],
    [
        "partialRight",
        WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        "rearg",
        WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function updateWrapDetails(details, bitmask) {
    arrayEach(wrapFlags, function(pair) {
        var value = "_." + pair[0];
        if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = updateWrapDetails;

},{"a7a49cef037dbfe1":"a4f8p","af2237e87f92af85":"1GQtS"}],"jTQF9":[function(require,module,exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = getHolder;

},{}],"lCy4d":[function(require,module,exports) {
var copyArray = require("c6e993da92674ed"), isIndex = require("2f2bb616bb09517c");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
    while(length--){
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = reorder;

},{"c6e993da92674ed":"btK5B","2f2bb616bb09517c":"ebisk"}],"3PNFR":[function(require,module,exports) {
/** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = replaceHolders;

},{}],"88NKT":[function(require,module,exports) {
var apply = require("efc11e615cec5fee"), createCtor = require("2c37aff03fcedfc"), root = require("d72e13e375eeb85f");
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return apply(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = createPartial;

},{"efc11e615cec5fee":"dAmzO","2c37aff03fcedfc":"8drlc","d72e13e375eeb85f":"5yGId"}],"3CgGb":[function(require,module,exports) {
var composeArgs = require("a3cfccd73f098250"), composeArgsRight = require("7f237b86dc59ec17"), replaceHolders = require("35c070da925561c8");
/** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
/** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
    var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = mergeData;

},{"a3cfccd73f098250":"eBNEJ","7f237b86dc59ec17":"hfON3","35c070da925561c8":"3PNFR"}],"6YXID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Axes", ()=>Axes$1);
parcelHelpers.export(exports, "Axis", ()=>Axis$1);
parcelHelpers.export(exports, "Grid", ()=>Grid$1);
parcelHelpers.export(exports, "axisPropType", ()=>axisPropType);
parcelHelpers.export(exports, "axisPropTypes", ()=>axisPropTypes);
parcelHelpers.export(exports, "renderAxesToCanvas", ()=>renderAxesToCanvas);
parcelHelpers.export(exports, "renderAxisToCanvas", ()=>renderAxisToCanvas);
parcelHelpers.export(exports, "renderGridLinesToCanvas", ()=>renderGridLinesToCanvas);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactMotion = require("react-motion");
var _core = require("@nivo/core");
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _d3Format = require("d3-format");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var centerScale = function centerScale(scale) {
    var bandwidth = scale.bandwidth();
    if (bandwidth === 0) return scale;
    var offset = bandwidth / 2;
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return scale(d) + offset;
    };
};
var timeByType = {
    millisecond: [
        (0, _d3Time.timeMillisecond),
        (0, _d3Time.utcMillisecond)
    ],
    second: [
        (0, _d3Time.timeSecond),
        (0, _d3Time.utcSecond)
    ],
    minute: [
        (0, _d3Time.timeMinute),
        (0, _d3Time.utcMinute)
    ],
    hour: [
        (0, _d3Time.timeHour),
        (0, _d3Time.utcHour)
    ],
    day: [
        (0, _d3Time.timeDay),
        (0, _d3Time.utcDay)
    ],
    week: [
        (0, _d3Time.timeWeek),
        (0, _d3Time.utcWeek)
    ],
    sunday: [
        (0, _d3Time.timeSunday),
        (0, _d3Time.utcSunday)
    ],
    monday: [
        (0, _d3Time.timeMonday),
        (0, _d3Time.utcMonday)
    ],
    tuesday: [
        (0, _d3Time.timeTuesday),
        (0, _d3Time.utcTuesday)
    ],
    wednesday: [
        (0, _d3Time.timeWednesday),
        (0, _d3Time.utcWednesday)
    ],
    thursday: [
        (0, _d3Time.timeThursday),
        (0, _d3Time.utcThursday)
    ],
    friday: [
        (0, _d3Time.timeFriday),
        (0, _d3Time.utcFriday)
    ],
    saturday: [
        (0, _d3Time.timeSaturday),
        (0, _d3Time.utcSaturday)
    ],
    month: [
        (0, _d3Time.timeMonth),
        (0, _d3Time.utcMonth)
    ],
    year: [
        (0, _d3Time.timeYear),
        (0, _d3Time.utcYear)
    ]
};
var timeTypes = Object.keys(timeByType);
var timeIntervalRegexp = new RegExp("^every\\s*(\\d+)?\\s*(".concat(timeTypes.join("|"), ")s?$"), "i");
var getScaleTicks = function getScaleTicks(scale, spec) {
    if (Array.isArray(spec)) return spec;
    if (scale.ticks) {
        if (spec === undefined) return scale.ticks();
        if ((0, _isNumberDefault.default)(spec)) return scale.ticks(spec);
        if (typeof spec === "string") {
            var matches = spec.match(timeIntervalRegexp);
            if (matches) {
                var timeType = timeByType[matches[2]][scale.useUTC ? 1 : 0];
                if (matches[1] === undefined) return scale.ticks(timeType);
                return scale.ticks(timeType.every(Number(matches[1])));
            }
            throw new Error("Invalid tickValues: ".concat(spec));
        }
    }
    return scale.domain();
};
var computeCartesianTicks = function computeCartesianTicks(_ref) {
    var axis = _ref.axis, scale = _ref.scale, ticksPosition = _ref.ticksPosition, tickValues = _ref.tickValues, tickSize = _ref.tickSize, tickPadding = _ref.tickPadding, tickRotation = _ref.tickRotation, _ref$engine = _ref.engine, engine = _ref$engine === void 0 ? "svg" : _ref$engine;
    var values = getScaleTicks(scale, tickValues);
    var textProps = (0, _core.textPropsByEngine)[engine];
    var position = scale.bandwidth ? centerScale(scale) : scale;
    var line = {
        lineX: 0,
        lineY: 0
    };
    var text = {
        textX: 0,
        textY: 0
    };
    var translate;
    var textAlign = textProps.align.center;
    var textBaseline = textProps.baseline.center;
    if (axis === "x") {
        translate = function translate(d) {
            return {
                x: position(d),
                y: 0
            };
        };
        line.lineY = tickSize * (ticksPosition === "after" ? 1 : -1);
        text.textY = (tickSize + tickPadding) * (ticksPosition === "after" ? 1 : -1);
        if (ticksPosition === "after") textBaseline = textProps.baseline.top;
        else textBaseline = textProps.baseline.bottom;
        if (tickRotation === 0) textAlign = textProps.align.center;
        else if (ticksPosition === "after" && tickRotation < 0 || ticksPosition === "before" && tickRotation > 0) {
            textAlign = textProps.align.right;
            textBaseline = textProps.baseline.center;
        } else if (ticksPosition === "after" && tickRotation > 0 || ticksPosition === "before" && tickRotation < 0) {
            textAlign = textProps.align.left;
            textBaseline = textProps.baseline.center;
        }
    } else {
        translate = function translate(d) {
            return {
                x: 0,
                y: position(d)
            };
        };
        line.lineX = tickSize * (ticksPosition === "after" ? 1 : -1);
        text.textX = (tickSize + tickPadding) * (ticksPosition === "after" ? 1 : -1);
        if (ticksPosition === "after") textAlign = textProps.align.left;
        else textAlign = textProps.align.right;
    }
    var ticks = values.map(function(value) {
        return _objectSpread({
            key: value,
            value: value
        }, translate(value), line, text);
    });
    return {
        ticks: ticks,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
};
var getFormatter = function getFormatter(format$1, scale) {
    if (!format$1 || typeof format$1 === "function") return format$1;
    if (scale.type === "time") {
        var f = (0, _d3TimeFormat.timeFormat)(format$1);
        return function(d) {
            return f(new Date(d));
        };
    }
    return (0, _d3Format.format)(format$1);
};
var computeGridLines = function computeGridLines(_ref2) {
    var width = _ref2.width, height = _ref2.height, scale = _ref2.scale, axis = _ref2.axis, _values = _ref2.values;
    var lineValues = Array.isArray(_values) ? _values : undefined;
    var lineCount = (0, _isNumberDefault.default)(_values) ? _values : undefined;
    var values = lineValues || getScaleTicks(scale, lineCount);
    var position = scale.bandwidth ? centerScale(scale) : scale;
    var lines;
    if (axis === "x") lines = values.map(function(v) {
        return {
            key: "".concat(v),
            x1: position(v),
            x2: position(v),
            y1: 0,
            y2: height
        };
    });
    else if (axis === "y") lines = values.map(function(v) {
        return {
            key: "".concat(v),
            x1: 0,
            x2: width,
            y1: position(v),
            y2: position(v)
        };
    });
    return lines;
};
var axisPropTypes = {
    ticksPosition: (0, _propTypesDefault.default).oneOf([
        "before",
        "after"
    ]),
    tickValues: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).instanceOf(Date)
        ])),
        (0, _propTypesDefault.default).string
    ]),
    tickSize: (0, _propTypesDefault.default).number,
    tickPadding: (0, _propTypesDefault.default).number,
    tickRotation: (0, _propTypesDefault.default).number,
    format: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    renderTick: (0, _propTypesDefault.default).func,
    legend: (0, _propTypesDefault.default).node,
    legendPosition: (0, _propTypesDefault.default).oneOf([
        "start",
        "middle",
        "end"
    ]),
    legendOffset: (0, _propTypesDefault.default).number
};
var axisPropType = (0, _propTypesDefault.default).shape(axisPropTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var AxisTick = function AxisTick(_ref) {
    var _value = _ref.value, x = _ref.x, y = _ref.y, opacity = _ref.opacity, rotate = _ref.rotate, format = _ref.format, lineX = _ref.lineX, lineY = _ref.lineY, _onClick = _ref.onClick, textX = _ref.textX, textY = _ref.textY, textBaseline = _ref.textBaseline, textAnchor = _ref.textAnchor;
    var theme = (0, _core.useTheme)();
    var value = _value;
    if (format !== undefined) value = format(value);
    var gStyle = {
        opacity: opacity
    };
    if (_onClick) gStyle["cursor"] = "pointer";
    return (0, _reactDefault.default).createElement("g", _extends({
        transform: "translate(".concat(x, ",").concat(y, ")")
    }, _onClick ? {
        onClick: function onClick(e) {
            return _onClick(e, value);
        }
    } : {}, {
        style: gStyle
    }), (0, _reactDefault.default).createElement("line", {
        x1: 0,
        x2: lineX,
        y1: 0,
        y2: lineY,
        style: theme.axis.ticks.line
    }), (0, _reactDefault.default).createElement("text", {
        dominantBaseline: textBaseline,
        textAnchor: textAnchor,
        transform: "translate(".concat(textX, ",").concat(textY, ") rotate(").concat(rotate, ")"),
        style: theme.axis.ticks.text
    }, value));
};
AxisTick.propTypes = {
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).instanceOf(Date)
    ]).isRequired,
    format: (0, _propTypesDefault.default).func,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    lineX: (0, _propTypesDefault.default).number.isRequired,
    lineY: (0, _propTypesDefault.default).number.isRequired,
    textX: (0, _propTypesDefault.default).number.isRequired,
    textY: (0, _propTypesDefault.default).number.isRequired,
    textBaseline: (0, _propTypesDefault.default).string.isRequired,
    textAnchor: (0, _propTypesDefault.default).string.isRequired,
    opacity: (0, _propTypesDefault.default).number.isRequired,
    rotate: (0, _propTypesDefault.default).number.isRequired,
    onClick: (0, _propTypesDefault.default).func
};
AxisTick.defaultProps = {
    opacity: 1,
    rotate: 0
};
var AxisTick$1 = (0, _react.memo)(AxisTick);
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var willEnter = function willEnter() {
    return {
        rotate: 0,
        opacity: 0,
        x: 0,
        y: 0
    };
};
var willLeave = function willLeave(springConfig) {
    return function(_ref) {
        var _ref$style = _ref.style, x = _ref$style.x, y = _ref$style.y, rotate = _ref$style.rotate;
        return {
            rotate: rotate,
            opacity: (0, _reactMotion.spring)(0, springConfig),
            x: (0, _reactMotion.spring)(x.val, springConfig),
            y: (0, _reactMotion.spring)(y.val, springConfig)
        };
    };
};
var defaultTickRenderer = function defaultTickRenderer(props) {
    return (0, _reactDefault.default).createElement(AxisTick$1, props);
};
var Axis = function Axis(_ref2) {
    var axis = _ref2.axis, scale = _ref2.scale, x = _ref2.x, y = _ref2.y, length = _ref2.length, ticksPosition = _ref2.ticksPosition, tickValues = _ref2.tickValues, tickSize = _ref2.tickSize, tickPadding = _ref2.tickPadding, tickRotation = _ref2.tickRotation, format = _ref2.format, renderTick = _ref2.renderTick, legend = _ref2.legend, legendPosition = _ref2.legendPosition, legendOffset = _ref2.legendOffset, onClick = _ref2.onClick;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    var formatValue = (0, _react.useMemo)(function() {
        return getFormatter(format, scale);
    }, [
        format,
        scale
    ]);
    var _computeCartesianTick = computeCartesianTicks({
        axis: axis,
        scale: scale,
        ticksPosition: ticksPosition,
        tickValues: tickValues,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation
    }), ticks = _computeCartesianTick.ticks, textAlign = _computeCartesianTick.textAlign, textBaseline = _computeCartesianTick.textBaseline;
    var legendNode = null;
    if (legend !== undefined) {
        var legendX = 0;
        var legendY = 0;
        var legendRotation = 0;
        var textAnchor;
        if (axis === "y") {
            legendRotation = -90;
            legendX = legendOffset;
            if (legendPosition === "start") {
                textAnchor = "start";
                legendY = length;
            } else if (legendPosition === "middle") {
                textAnchor = "middle";
                legendY = length / 2;
            } else if (legendPosition === "end") textAnchor = "end";
        } else {
            legendY = legendOffset;
            if (legendPosition === "start") textAnchor = "start";
            else if (legendPosition === "middle") {
                textAnchor = "middle";
                legendX = length / 2;
            } else if (legendPosition === "end") {
                textAnchor = "end";
                legendX = length;
            }
        }
        legendNode = (0, _reactDefault.default).createElement("text", {
            transform: "translate(".concat(legendX, ", ").concat(legendY, ") rotate(").concat(legendRotation, ")"),
            textAnchor: textAnchor,
            style: _objectSpread$1({
                dominantBaseline: "central"
            }, theme.axis.legend.text)
        }, legend);
    }
    if (animate !== true) return (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
    }, ticks.map(function(tick, tickIndex) {
        return (0, _reactDefault.default).createElement(renderTick, _objectSpread$1({
            tickIndex: tickIndex,
            format: formatValue,
            rotate: tickRotation,
            textBaseline: textBaseline,
            textAnchor: textAlign
        }, tick, onClick ? {
            onClick: onClick
        } : {}));
    }), (0, _reactDefault.default).createElement("line", {
        style: theme.axis.domain.line,
        x1: 0,
        x2: axis === "x" ? length : 0,
        y1: 0,
        y2: axis === "x" ? 0 : length
    }), legendNode);
    return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x: (0, _reactMotion.spring)(x, springConfig),
            y: (0, _reactMotion.spring)(y, springConfig)
        }
    }, function(xy) {
        return (0, _reactDefault.default).createElement("g", {
            transform: "translate(".concat(xy.x, ",").concat(xy.y, ")")
        }, (0, _reactDefault.default).createElement((0, _reactMotion.TransitionMotion), {
            willEnter: willEnter,
            willLeave: willLeave(springConfig),
            styles: ticks.map(function(tick) {
                return {
                    key: "".concat(tick.key),
                    data: tick,
                    style: {
                        opacity: (0, _reactMotion.spring)(1, springConfig),
                        x: (0, _reactMotion.spring)(tick.x, springConfig),
                        y: (0, _reactMotion.spring)(tick.y, springConfig),
                        rotate: (0, _reactMotion.spring)(tickRotation, springConfig)
                    }
                };
            })
        }, function(interpolatedStyles) {
            return (0, _reactDefault.default).createElement((0, _react.Fragment), null, interpolatedStyles.map(function(_ref3, tickIndex) {
                var style = _ref3.style, tick = _ref3.data;
                return (0, _reactDefault.default).createElement(renderTick, _objectSpread$1({
                    tickIndex: tickIndex,
                    format: formatValue,
                    textBaseline: textBaseline,
                    textAnchor: textAlign
                }, tick, style, onClick ? {
                    onClick: onClick
                } : {}));
            }));
        }), (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
            style: {
                x2: (0, _reactMotion.spring)(axis === "x" ? length : 0, springConfig),
                y2: (0, _reactMotion.spring)(axis === "x" ? 0 : length, springConfig)
            }
        }, function(values) {
            return (0, _reactDefault.default).createElement("line", _extends$1({
                style: theme.axis.domain.line,
                x1: 0,
                y1: 0
            }, values));
        }), legendNode);
    });
};
Axis.propTypes = {
    axis: (0, _propTypesDefault.default).oneOf([
        "x",
        "y"
    ]).isRequired,
    scale: (0, _propTypesDefault.default).func.isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    length: (0, _propTypesDefault.default).number.isRequired,
    ticksPosition: (0, _propTypesDefault.default).oneOf([
        "before",
        "after"
    ]).isRequired,
    tickValues: axisPropTypes.tickValues,
    tickSize: (0, _propTypesDefault.default).number.isRequired,
    tickPadding: (0, _propTypesDefault.default).number.isRequired,
    tickRotation: (0, _propTypesDefault.default).number.isRequired,
    format: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    renderTick: (0, _propTypesDefault.default).func.isRequired,
    legend: (0, _propTypesDefault.default).node,
    legendPosition: (0, _propTypesDefault.default).oneOf([
        "start",
        "middle",
        "end"
    ]).isRequired,
    legendOffset: (0, _propTypesDefault.default).number.isRequired,
    onClick: (0, _propTypesDefault.default).func
};
Axis.defaultProps = {
    x: 0,
    y: 0,
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    renderTick: defaultTickRenderer,
    legendPosition: "end",
    legendOffset: 0
};
var Axis$1 = (0, _react.memo)(Axis);
function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
var positions = [
    "top",
    "right",
    "bottom",
    "left"
];
var Axes = function Axes(_ref) {
    var xScale = _ref.xScale, yScale = _ref.yScale, width = _ref.width, height = _ref.height, top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var axes = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    return positions.map(function(position) {
        var axis = axes[position];
        if (!axis) return null;
        var isXAxis = position === "top" || position === "bottom";
        var ticksPosition = position === "top" || position === "left" ? "before" : "after";
        return (0, _reactDefault.default).createElement(Axis$1, _extends$2({
            key: position
        }, axis, {
            axis: isXAxis ? "x" : "y",
            x: position === "right" ? width : 0,
            y: position === "bottom" ? height : 0,
            scale: isXAxis ? xScale : yScale,
            length: isXAxis ? width : height,
            ticksPosition: ticksPosition
        }));
    });
};
Axes.propTypes = {
    xScale: (0, _propTypesDefault.default).func,
    yScale: (0, _propTypesDefault.default).func,
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    top: axisPropType,
    right: axisPropType,
    bottom: axisPropType,
    left: axisPropType
};
var Axes$1 = (0, _react.memo)(Axes);
var GridLine = function GridLine(props) {
    return (0, _reactDefault.default).createElement("line", props);
};
GridLine.propTypes = {
    x1: (0, _propTypesDefault.default).number.isRequired,
    x2: (0, _propTypesDefault.default).number.isRequired,
    y1: (0, _propTypesDefault.default).number.isRequired,
    y2: (0, _propTypesDefault.default).number.isRequired
};
GridLine.defaultProps = {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
};
var GridLine$1 = (0, _react.memo)(GridLine);
function _extends$3() {
    _extends$3 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$3.apply(this, arguments);
}
var GridLines = function GridLines(_ref) {
    var type = _ref.type, lines = _ref.lines;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    var lineWillEnter = (0, _react.useMemo)(function() {
        return function(_ref2) {
            var style = _ref2.style;
            return {
                opacity: 0,
                x1: type === "x" ? 0 : style.x1.val,
                x2: type === "x" ? 0 : style.x2.val,
                y1: type === "y" ? 0 : style.y1.val,
                y2: type === "y" ? 0 : style.y2.val
            };
        };
    }, [
        type
    ]);
    var lineWillLeave = (0, _react.useMemo)(function() {
        return function(_ref3) {
            var style = _ref3.style;
            return {
                opacity: (0, _reactMotion.spring)(0, springConfig),
                x1: (0, _reactMotion.spring)(style.x1.val, springConfig),
                x2: (0, _reactMotion.spring)(style.x2.val, springConfig),
                y1: (0, _reactMotion.spring)(style.y1.val, springConfig),
                y2: (0, _reactMotion.spring)(style.y2.val, springConfig)
            };
        };
    }, [
        springConfig
    ]);
    if (!animate) return (0, _reactDefault.default).createElement("g", null, lines.map(function(line) {
        return (0, _reactDefault.default).createElement(GridLine$1, _extends$3({
            key: line.key
        }, line, theme.grid.line));
    }));
    return (0, _reactDefault.default).createElement((0, _reactMotion.TransitionMotion), {
        willEnter: lineWillEnter,
        willLeave: lineWillLeave,
        styles: lines.map(function(line) {
            return {
                key: line.key,
                style: {
                    opacity: (0, _reactMotion.spring)(1, springConfig),
                    x1: (0, _reactMotion.spring)(line.x1 || 0, springConfig),
                    x2: (0, _reactMotion.spring)(line.x2 || 0, springConfig),
                    y1: (0, _reactMotion.spring)(line.y1 || 0, springConfig),
                    y2: (0, _reactMotion.spring)(line.y2 || 0, springConfig)
                }
            };
        })
    }, function(interpolatedStyles) {
        return (0, _reactDefault.default).createElement("g", null, interpolatedStyles.map(function(interpolatedStyle) {
            var key = interpolatedStyle.key, style = interpolatedStyle.style;
            return (0, _reactDefault.default).createElement(GridLine$1, _extends$3({
                key: key
            }, theme.grid.line, style));
        }));
    });
};
GridLines.propTypes = {
    type: (0, _propTypesDefault.default).oneOf([
        "x",
        "y"
    ]).isRequired,
    lines: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        key: (0, _propTypesDefault.default).string.isRequired,
        x1: (0, _propTypesDefault.default).number,
        x2: (0, _propTypesDefault.default).number,
        y1: (0, _propTypesDefault.default).number,
        y2: (0, _propTypesDefault.default).number
    })).isRequired
};
var GridLines$1 = (0, _react.memo)(GridLines);
var Grid = function Grid(_ref) {
    var width = _ref.width, height = _ref.height, xScale = _ref.xScale, yScale = _ref.yScale, xValues = _ref.xValues, yValues = _ref.yValues;
    var xLines = (0, _react.useMemo)(function() {
        if (!xScale) return false;
        return computeGridLines({
            width: width,
            height: height,
            scale: xScale,
            axis: "x",
            values: xValues
        });
    }, [
        xScale,
        xValues
    ]);
    var yLines = yScale ? computeGridLines({
        width: width,
        height: height,
        scale: yScale,
        axis: "y",
        values: yValues
    }) : false;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, xLines && (0, _reactDefault.default).createElement(GridLines$1, {
        type: "x",
        lines: xLines
    }), yLines && (0, _reactDefault.default).createElement(GridLines$1, {
        type: "y",
        lines: yLines
    }));
};
Grid.propTypes = {
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    xScale: (0, _propTypesDefault.default).func,
    yScale: (0, _propTypesDefault.default).func,
    xValues: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).instanceOf(Date)
        ]))
    ]),
    yValues: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).instanceOf(Date)
        ]))
    ])
};
var Grid$1 = (0, _react.memo)(Grid);
var degreesToRadians = function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
};
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var renderAxisToCanvas = function renderAxisToCanvas(ctx, _ref) {
    var axis = _ref.axis, scale = _ref.scale, _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, length = _ref.length, ticksPosition = _ref.ticksPosition, tickValues = _ref.tickValues, _ref$tickSize = _ref.tickSize, tickSize = _ref$tickSize === void 0 ? 5 : _ref$tickSize, _ref$tickPadding = _ref.tickPadding, tickPadding = _ref$tickPadding === void 0 ? 5 : _ref$tickPadding, _ref$tickRotation = _ref.tickRotation, tickRotation = _ref$tickRotation === void 0 ? 0 : _ref$tickRotation, format = _ref.format, legend = _ref.legend, _ref$legendPosition = _ref.legendPosition, legendPosition = _ref$legendPosition === void 0 ? "end" : _ref$legendPosition, _ref$legendOffset = _ref.legendOffset, legendOffset = _ref$legendOffset === void 0 ? 0 : _ref$legendOffset, theme = _ref.theme;
    var _computeCartesianTick = computeCartesianTicks({
        axis: axis,
        scale: scale,
        ticksPosition: ticksPosition,
        tickValues: tickValues,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation,
        engine: "canvas"
    }), ticks = _computeCartesianTick.ticks, textAlign = _computeCartesianTick.textAlign, textBaseline = _computeCartesianTick.textBaseline;
    ctx.save();
    ctx.translate(x, y);
    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = "".concat(theme.axis.ticks.text.fontSize, "px ").concat(theme.axis.ticks.text.fontFamily);
    if (theme.axis.domain.line.strokeWidth > 0) {
        ctx.lineWidth = theme.axis.domain.line.strokeWidth;
        ctx.lineCap = "square";
        ctx.strokeStyle = theme.axis.domain.line.stroke;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(axis === "x" ? length : 0, axis === "x" ? 0 : length);
        ctx.stroke();
    }
    ticks.forEach(function(tick) {
        if (theme.axis.ticks.line.strokeWidth > 0) {
            ctx.lineWidth = theme.axis.ticks.line.strokeWidth;
            ctx.lineCap = "square";
            ctx.strokeStyle = theme.axis.ticks.line.stroke;
            ctx.beginPath();
            ctx.moveTo(tick.x, tick.y);
            ctx.lineTo(tick.x + tick.lineX, tick.y + tick.lineY);
            ctx.stroke();
        }
        var value = format !== undefined ? format(tick.value) : tick.value;
        ctx.save();
        ctx.translate(tick.x + tick.textX, tick.y + tick.textY);
        ctx.rotate(degreesToRadians(tickRotation));
        ctx.fillStyle = theme.axis.ticks.text.fill;
        ctx.fillText(value, 0, 0);
        ctx.restore();
    });
    if (legend !== undefined) {
        var legendX = 0;
        var legendY = 0;
        var legendRotation = 0;
        var _textAlign;
        if (axis === "y") {
            legendRotation = -90;
            legendX = legendOffset;
            if (legendPosition === "start") {
                _textAlign = "start";
                legendY = length;
            } else if (legendPosition === "middle") {
                _textAlign = "center";
                legendY = length / 2;
            } else if (legendPosition === "end") _textAlign = "end";
        } else {
            legendY = legendOffset;
            if (legendPosition === "start") _textAlign = "start";
            else if (legendPosition === "middle") {
                _textAlign = "center";
                legendX = length / 2;
            } else if (legendPosition === "end") {
                _textAlign = "end";
                legendX = length;
            }
        }
        ctx.translate(legendX, legendY);
        ctx.rotate(degreesToRadians(legendRotation));
        ctx.font = "".concat(theme.axis.legend.text.fontWeight ? "".concat(theme.axis.legend.text.fontWeight, " ") : "").concat(theme.axis.legend.text.fontSize, "px ").concat(theme.axis.legend.text.fontFamily);
        ctx.fillStyle = theme.axis.legend.text.fill;
        ctx.textAlign = _textAlign;
        ctx.textBaseline = "middle";
        ctx.fillText(legend, 0, 0);
    }
    ctx.restore();
};
var positions$1 = [
    "top",
    "right",
    "bottom",
    "left"
];
var renderAxesToCanvas = function renderAxesToCanvas(ctx, _ref2) {
    var xScale = _ref2.xScale, yScale = _ref2.yScale, width = _ref2.width, height = _ref2.height, top = _ref2.top, right = _ref2.right, bottom = _ref2.bottom, left = _ref2.left, theme = _ref2.theme;
    var axes = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    positions$1.forEach(function(position) {
        var axis = axes[position];
        if (!axis) return null;
        var isXAxis = position === "top" || position === "bottom";
        var ticksPosition = position === "top" || position === "left" ? "before" : "after";
        var scale = isXAxis ? xScale : yScale;
        var format = getFormatter(axis.format, scale);
        renderAxisToCanvas(ctx, _objectSpread$2({}, axis, {
            axis: isXAxis ? "x" : "y",
            x: position === "right" ? width : 0,
            y: position === "bottom" ? height : 0,
            scale: scale,
            format: format,
            length: isXAxis ? width : height,
            ticksPosition: ticksPosition,
            theme: theme
        }));
    });
};
var renderGridLinesToCanvas = function renderGridLinesToCanvas(ctx, _ref3) {
    var width = _ref3.width, height = _ref3.height, scale = _ref3.scale, axis = _ref3.axis, values = _ref3.values;
    var lines = computeGridLines({
        width: width,
        height: height,
        scale: scale,
        axis: axis,
        values: values
    });
    lines.forEach(function(line) {
        ctx.beginPath();
        ctx.moveTo(line.x1, line.y1);
        ctx.lineTo(line.x2, line.y2);
        ctx.stroke();
    });
};

},{"react":"6AiW6","prop-types":"kKQPU","react-motion":"lqe7n","@nivo/core":"guBSY","lodash/isNumber":"qMDht","d3-time":"dNf0J","d3-time-format":"285I3","d3-format":"3rxcZ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"KxnAT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANCHOR_BOTTOM", ()=>ANCHOR_BOTTOM);
parcelHelpers.export(exports, "ANCHOR_BOTTOM_LEFT", ()=>ANCHOR_BOTTOM_LEFT);
parcelHelpers.export(exports, "ANCHOR_BOTTOM_RIGHT", ()=>ANCHOR_BOTTOM_RIGHT);
parcelHelpers.export(exports, "ANCHOR_CENTER", ()=>ANCHOR_CENTER);
parcelHelpers.export(exports, "ANCHOR_LEFT", ()=>ANCHOR_LEFT);
parcelHelpers.export(exports, "ANCHOR_RIGHT", ()=>ANCHOR_RIGHT);
parcelHelpers.export(exports, "ANCHOR_TOP", ()=>ANCHOR_TOP);
parcelHelpers.export(exports, "ANCHOR_TOP_LEFT", ()=>ANCHOR_TOP_LEFT);
parcelHelpers.export(exports, "ANCHOR_TOP_RIGHT", ()=>ANCHOR_TOP_RIGHT);
parcelHelpers.export(exports, "BoxLegendSvg", ()=>BoxLegendSvg);
parcelHelpers.export(exports, "DIRECTION_BOTTOM_TO_TOP", ()=>DIRECTION_BOTTOM_TO_TOP);
parcelHelpers.export(exports, "DIRECTION_COLUMN", ()=>DIRECTION_COLUMN);
parcelHelpers.export(exports, "DIRECTION_LEFT_TO_RIGHT", ()=>DIRECTION_LEFT_TO_RIGHT);
parcelHelpers.export(exports, "DIRECTION_RIGHT_TO_LEFT", ()=>DIRECTION_RIGHT_TO_LEFT);
parcelHelpers.export(exports, "DIRECTION_ROW", ()=>DIRECTION_ROW);
parcelHelpers.export(exports, "DIRECTION_TOP_TO_BOTTOM", ()=>DIRECTION_TOP_TO_BOTTOM);
parcelHelpers.export(exports, "LegendPropShape", ()=>LegendPropShape);
parcelHelpers.export(exports, "LegendSvg", ()=>LegendSvg);
parcelHelpers.export(exports, "LegendSvgItem", ()=>LegendSvgItem);
parcelHelpers.export(exports, "datumPropType", ()=>datumPropType);
parcelHelpers.export(exports, "interactivityPropTypes", ()=>interactivityPropTypes);
parcelHelpers.export(exports, "legendEffectPropType", ()=>legendEffectPropType);
parcelHelpers.export(exports, "renderLegendToCanvas", ()=>renderLegendToCanvas);
parcelHelpers.export(exports, "symbolPropTypes", ()=>symbolPropTypes);
parcelHelpers.export(exports, "useQuantizeColorScaleLegendData", ()=>useQuantizeColorScaleLegendData);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _core = require("@nivo/core");
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var DIRECTION_ROW = "row";
var DIRECTION_COLUMN = "column";
var ANCHOR_TOP = "top";
var ANCHOR_TOP_RIGHT = "top-right";
var ANCHOR_RIGHT = "right";
var ANCHOR_BOTTOM_RIGHT = "bottom-right";
var ANCHOR_BOTTOM = "bottom";
var ANCHOR_BOTTOM_LEFT = "bottom-left";
var ANCHOR_LEFT = "left";
var ANCHOR_TOP_LEFT = "top-left";
var ANCHOR_CENTER = "center";
var DIRECTION_LEFT_TO_RIGHT = "left-to-right";
var DIRECTION_RIGHT_TO_LEFT = "right-to-left";
var DIRECTION_TOP_TO_BOTTOM = "top-to-bottom";
var DIRECTION_BOTTOM_TO_TOP = "bottom-to-top";
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var legendEffectPropType = (0, _propTypesDefault.default).shape({
    on: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            "hover"
        ])
    ]).isRequired,
    style: (0, _propTypesDefault.default).shape({
        itemTextColor: (0, _propTypesDefault.default).string,
        itemBackground: (0, _propTypesDefault.default).string,
        itemOpacity: (0, _propTypesDefault.default).number,
        symbolSize: (0, _propTypesDefault.default).number,
        symbolBorderWidth: (0, _propTypesDefault.default).number,
        symbolBorderColor: (0, _propTypesDefault.default).string
    }).isRequired
});
var symbolPropTypes = {
    symbolShape: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    symbolSize: (0, _propTypesDefault.default).number,
    symbolSpacing: (0, _propTypesDefault.default).number,
    symbolBorderWidth: (0, _propTypesDefault.default).number,
    symbolBorderColor: (0, _propTypesDefault.default).string
};
var interactivityPropTypes = {
    onClick: (0, _propTypesDefault.default).func,
    onMouseEnter: (0, _propTypesDefault.default).func,
    onMouseLeave: (0, _propTypesDefault.default).func
};
var datumPropType = (0, _propTypesDefault.default).shape({
    id: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]).isRequired,
    label: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]).isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    fill: (0, _propTypesDefault.default).string
});
var LegendPropShape = _objectSpread({
    data: (0, _propTypesDefault.default).arrayOf(datumPropType),
    anchor: (0, _propTypesDefault.default).oneOf([
        ANCHOR_TOP,
        ANCHOR_TOP_RIGHT,
        ANCHOR_RIGHT,
        ANCHOR_BOTTOM_RIGHT,
        ANCHOR_BOTTOM,
        ANCHOR_BOTTOM_LEFT,
        ANCHOR_LEFT,
        ANCHOR_TOP_LEFT,
        ANCHOR_CENTER
    ]).isRequired,
    translateX: (0, _propTypesDefault.default).number,
    translateY: (0, _propTypesDefault.default).number,
    direction: (0, _propTypesDefault.default).oneOf([
        DIRECTION_ROW,
        DIRECTION_COLUMN
    ]).isRequired,
    itemsSpacing: (0, _propTypesDefault.default).number,
    itemWidth: (0, _propTypesDefault.default).number.isRequired,
    itemHeight: (0, _propTypesDefault.default).number.isRequired,
    itemDirection: (0, _propTypesDefault.default).oneOf([
        DIRECTION_LEFT_TO_RIGHT,
        DIRECTION_RIGHT_TO_LEFT,
        DIRECTION_TOP_TO_BOTTOM,
        DIRECTION_BOTTOM_TO_TOP
    ]),
    itemTextColor: (0, _propTypesDefault.default).string,
    itemBackground: (0, _propTypesDefault.default).string,
    itemOpacity: (0, _propTypesDefault.default).number
}, symbolPropTypes, interactivityPropTypes, {
    effects: (0, _propTypesDefault.default).arrayOf(legendEffectPropType)
});
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var zeroPadding = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var computeDimensions = function computeDimensions(_ref) {
    var direction = _ref.direction, itemsSpacing = _ref.itemsSpacing, _padding = _ref.padding, itemCount = _ref.itemCount, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight;
    var padding;
    if ((0, _isNumberDefault.default)(_padding)) padding = {
        top: _padding,
        right: _padding,
        bottom: _padding,
        left: _padding
    };
    else if ((0, _isPlainObjectDefault.default)(_padding)) padding = _objectSpread$1({}, zeroPadding, _padding);
    else throw new TypeError("Invalid property padding, must be one of: number, object");
    var horizontalPadding = padding.left + padding.right;
    var verticalPadding = padding.top + padding.bottom;
    var width = itemWidth + horizontalPadding;
    var height = itemHeight + verticalPadding;
    var spacing = (itemCount - 1) * itemsSpacing;
    if (direction === DIRECTION_ROW) width = itemWidth * itemCount + spacing + horizontalPadding;
    else if (direction === DIRECTION_COLUMN) height = itemHeight * itemCount + spacing + verticalPadding;
    return {
        width: width,
        height: height,
        padding: padding
    };
};
var computePositionFromAnchor = function computePositionFromAnchor(_ref2) {
    var anchor = _ref2.anchor, translateX = _ref2.translateX, translateY = _ref2.translateY, containerWidth = _ref2.containerWidth, containerHeight = _ref2.containerHeight, width = _ref2.width, height = _ref2.height;
    var x = translateX;
    var y = translateY;
    switch(anchor){
        case ANCHOR_TOP:
            x += (containerWidth - width) / 2;
            break;
        case ANCHOR_TOP_RIGHT:
            x += containerWidth - width;
            break;
        case ANCHOR_RIGHT:
            x += containerWidth - width;
            y += (containerHeight - height) / 2;
            break;
        case ANCHOR_BOTTOM_RIGHT:
            x += containerWidth - width;
            y += containerHeight - height;
            break;
        case ANCHOR_BOTTOM:
            x += (containerWidth - width) / 2;
            y += containerHeight - height;
            break;
        case ANCHOR_BOTTOM_LEFT:
            y += containerHeight - height;
            break;
        case ANCHOR_LEFT:
            y += (containerHeight - height) / 2;
            break;
        case ANCHOR_CENTER:
            x += (containerWidth - width) / 2;
            y += (containerHeight - height) / 2;
            break;
    }
    return {
        x: x,
        y: y
    };
};
var computeItemLayout = function computeItemLayout(_ref3) {
    var direction = _ref3.direction, justify = _ref3.justify, symbolSize = _ref3.symbolSize, symbolSpacing = _ref3.symbolSpacing, width = _ref3.width, height = _ref3.height;
    var symbolX;
    var symbolY;
    var labelX;
    var labelY;
    var labelAnchor;
    var labelAlignment;
    switch(direction){
        case DIRECTION_LEFT_TO_RIGHT:
            symbolX = 0;
            symbolY = (height - symbolSize) / 2;
            labelY = height / 2;
            labelAlignment = "central";
            if (justify === true) {
                labelX = width;
                labelAnchor = "end";
            } else {
                labelX = symbolSize + symbolSpacing;
                labelAnchor = "start";
            }
            break;
        case DIRECTION_RIGHT_TO_LEFT:
            symbolX = width - symbolSize;
            symbolY = (height - symbolSize) / 2;
            labelY = height / 2;
            labelAlignment = "central";
            if (justify === true) {
                labelX = 0;
                labelAnchor = "start";
            } else {
                labelX = width - symbolSize - symbolSpacing;
                labelAnchor = "end";
            }
            break;
        case DIRECTION_TOP_TO_BOTTOM:
            symbolX = (width - symbolSize) / 2;
            symbolY = 0;
            labelX = width / 2;
            labelAnchor = "middle";
            if (justify === true) {
                labelY = height;
                labelAlignment = "alphabetic";
            } else {
                labelY = symbolSize + symbolSpacing;
                labelAlignment = "text-before-edge";
            }
            break;
        case DIRECTION_BOTTOM_TO_TOP:
            symbolX = (width - symbolSize) / 2;
            symbolY = height - symbolSize;
            labelX = width / 2;
            labelAnchor = "middle";
            if (justify === true) {
                labelY = 0;
                labelAlignment = "text-before-edge";
            } else {
                labelY = height - symbolSize - symbolSpacing;
                labelAlignment = "alphabetic";
            }
            break;
    }
    return {
        symbolX: symbolX,
        symbolY: symbolY,
        labelX: labelX,
        labelY: labelY,
        labelAnchor: labelAnchor,
        labelAlignment: labelAlignment
    };
};
var symbolPropTypes$1 = {
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    size: (0, _propTypesDefault.default).number.isRequired,
    fill: (0, _propTypesDefault.default).string.isRequired,
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _propTypesDefault.default).string.isRequired
};
var symbolDefaultProps = {
    borderWidth: 0,
    borderColor: "transparent"
};
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var SymbolCircle = function(_PureComponent) {
    _inherits(SymbolCircle, _PureComponent);
    function SymbolCircle() {
        _classCallCheck(this, SymbolCircle);
        return _possibleConstructorReturn(this, _getPrototypeOf(SymbolCircle).apply(this, arguments));
    }
    _createClass(SymbolCircle, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, size = _this$props.size, fill = _this$props.fill, borderWidth = _this$props.borderWidth, borderColor = _this$props.borderColor;
                return (0, _reactDefault.default).createElement("circle", {
                    r: size / 2,
                    cx: x + size / 2,
                    cy: y + size / 2,
                    fill: fill,
                    strokeWidth: borderWidth,
                    stroke: borderColor,
                    style: {
                        pointerEvents: "none"
                    }
                });
            }
        }
    ]);
    return SymbolCircle;
}((0, _react.PureComponent));
_defineProperty$2(SymbolCircle, "propTypes", _objectSpread$2({}, symbolPropTypes$1));
_defineProperty$2(SymbolCircle, "defaultProps", _objectSpread$2({}, symbolDefaultProps));
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function _typeof$1(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$1 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$1(obj);
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$1(self);
}
function _assertThisInitialized$1(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var SymbolDiamond = function(_PureComponent) {
    _inherits$1(SymbolDiamond, _PureComponent);
    function SymbolDiamond() {
        _classCallCheck$1(this, SymbolDiamond);
        return _possibleConstructorReturn$1(this, _getPrototypeOf$1(SymbolDiamond).apply(this, arguments));
    }
    _createClass$1(SymbolDiamond, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, size = _this$props.size, fill = _this$props.fill, borderWidth = _this$props.borderWidth, borderColor = _this$props.borderColor;
                return (0, _reactDefault.default).createElement("g", {
                    transform: "translate(".concat(x, ",").concat(y, ")")
                }, (0, _reactDefault.default).createElement("path", {
                    d: "\n                    M".concat(size / 2, " 0\n                    L").concat(size * 0.8, " ").concat(size / 2, "\n                    L").concat(size / 2, " ").concat(size, "\n                    L").concat(size * 0.2, " ").concat(size / 2, "\n                    L").concat(size / 2, " 0\n                "),
                    fill: fill,
                    strokeWidth: borderWidth,
                    stroke: borderColor,
                    style: {
                        pointerEvents: "none"
                    }
                }));
            }
        }
    ]);
    return SymbolDiamond;
}((0, _react.PureComponent));
_defineProperty$3(SymbolDiamond, "propTypes", _objectSpread$3({}, symbolPropTypes$1));
_defineProperty$3(SymbolDiamond, "defaultProps", _objectSpread$3({}, symbolDefaultProps));
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function _typeof$2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$2 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$2(obj);
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$2(self);
}
function _assertThisInitialized$2(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var SymbolSquare = function(_PureComponent) {
    _inherits$2(SymbolSquare, _PureComponent);
    function SymbolSquare() {
        _classCallCheck$2(this, SymbolSquare);
        return _possibleConstructorReturn$2(this, _getPrototypeOf$2(SymbolSquare).apply(this, arguments));
    }
    _createClass$2(SymbolSquare, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, size = _this$props.size, fill = _this$props.fill, borderWidth = _this$props.borderWidth, borderColor = _this$props.borderColor;
                return (0, _reactDefault.default).createElement("rect", {
                    x: x,
                    y: y,
                    fill: fill,
                    strokeWidth: borderWidth,
                    stroke: borderColor,
                    width: size,
                    height: size,
                    style: {
                        pointerEvents: "none"
                    }
                });
            }
        }
    ]);
    return SymbolSquare;
}((0, _react.PureComponent));
_defineProperty$4(SymbolSquare, "propTypes", _objectSpread$4({}, symbolPropTypes$1));
_defineProperty$4(SymbolSquare, "defaultProps", _objectSpread$4({}, symbolDefaultProps));
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function _typeof$3(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$3 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$3(obj);
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$3(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$3(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$3(self);
}
function _assertThisInitialized$3(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var SymbolTriangle = function(_PureComponent) {
    _inherits$3(SymbolTriangle, _PureComponent);
    function SymbolTriangle() {
        _classCallCheck$3(this, SymbolTriangle);
        return _possibleConstructorReturn$3(this, _getPrototypeOf$3(SymbolTriangle).apply(this, arguments));
    }
    _createClass$3(SymbolTriangle, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, size = _this$props.size, fill = _this$props.fill, borderWidth = _this$props.borderWidth, borderColor = _this$props.borderColor;
                return (0, _reactDefault.default).createElement("g", {
                    transform: "translate(".concat(x, ",").concat(y, ")")
                }, (0, _reactDefault.default).createElement("path", {
                    d: "\n                M".concat(size / 2, " 0\n                L").concat(size, " ").concat(size, "\n                L0 ").concat(size, "\n                L").concat(size / 2, " 0\n            "),
                    fill: fill,
                    strokeWidth: borderWidth,
                    stroke: borderColor,
                    style: {
                        pointerEvents: "none"
                    }
                }));
            }
        }
    ]);
    return SymbolTriangle;
}((0, _react.PureComponent));
_defineProperty$5(SymbolTriangle, "propTypes", _objectSpread$5({}, symbolPropTypes$1));
_defineProperty$5(SymbolTriangle, "defaultProps", _objectSpread$5({}, symbolDefaultProps));
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$6(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$6(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var symbolByShape = {
    circle: SymbolCircle,
    diamond: SymbolDiamond,
    square: SymbolSquare,
    triangle: SymbolTriangle
};
var LegendSvgItem = function LegendSvgItem(_ref) {
    var x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height, data = _ref.data, direction = _ref.direction, justify = _ref.justify, textColor = _ref.textColor, background = _ref.background, opacity = _ref.opacity, symbolShape = _ref.symbolShape, symbolSize = _ref.symbolSize, symbolSpacing = _ref.symbolSpacing, symbolBorderWidth = _ref.symbolBorderWidth, symbolBorderColor = _ref.symbolBorderColor, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, effects = _ref.effects;
    var _useState = (0, _react.useState)({}), _useState2 = _slicedToArray(_useState, 2), style = _useState2[0], setStyle = _useState2[1];
    var theme = (0, _core.useTheme)();
    var handleClick = (0, _react.useCallback)(function(event1) {
        return onClick && onClick(data, event1);
    }, [
        onClick,
        data
    ]);
    var handleMouseEnter = (0, _react.useCallback)(function(event1) {
        if (effects.length > 0) {
            var applyEffects = effects.filter(function(_ref2) {
                var on = _ref2.on;
                return on === "hover";
            });
            var _style = applyEffects.reduce(function(acc, effect) {
                return _objectSpread$6({}, acc, effect.style);
            }, {});
            setStyle(_style);
        }
        if (onMouseEnter === undefined) return;
        onMouseEnter(data, event1);
    }, [
        onMouseEnter,
        data,
        effects
    ]);
    var handleMouseLeave = (0, _react.useCallback)(function() {
        if (effects.length > 0) {
            var applyEffects = effects.filter(function(_ref3) {
                var on = _ref3.on;
                return on !== "hover";
            });
            var _style2 = applyEffects.reduce(function(acc, effect) {
                return _objectSpread$6({}, acc, effect.style);
            }, {});
            setStyle(_style2);
        }
        if (onMouseLeave === undefined) return;
        onMouseLeave(data, event);
    }, [
        onMouseLeave,
        data,
        effects
    ]);
    var _computeItemLayout = computeItemLayout({
        direction: direction,
        justify: justify,
        symbolSize: style.symbolSize || symbolSize,
        symbolSpacing: symbolSpacing,
        width: width,
        height: height
    }), symbolX = _computeItemLayout.symbolX, symbolY = _computeItemLayout.symbolY, labelX = _computeItemLayout.labelX, labelY = _computeItemLayout.labelY, labelAnchor = _computeItemLayout.labelAnchor, labelAlignment = _computeItemLayout.labelAlignment;
    var isInteractive = [
        onClick,
        onMouseEnter,
        onMouseLeave
    ].some(function(handler) {
        return handler !== undefined;
    });
    var _Symbol;
    if ((0, _isFunctionDefault.default)(symbolShape)) _Symbol = symbolShape;
    else _Symbol = symbolByShape[symbolShape];
    return (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")"),
        style: {
            opacity: style.itemOpacity !== undefined ? style.itemOpacity : opacity
        }
    }, (0, _reactDefault.default).createElement("rect", {
        width: width,
        height: height,
        fill: style.itemBackground || background,
        style: {
            cursor: isInteractive ? "pointer" : "auto"
        },
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), (0, _reactDefault.default).createElement(_Symbol, {
        x: symbolX,
        y: symbolY,
        size: style.symbolSize || symbolSize,
        fill: data.fill || data.color,
        borderWidth: style.symbolBorderWidth !== undefined ? style.symbolBorderWidth : symbolBorderWidth,
        borderColor: style.symbolBorderColor || symbolBorderColor
    }), (0, _reactDefault.default).createElement("text", {
        textAnchor: labelAnchor,
        style: _objectSpread$6({}, theme.legends.text, {
            fill: style.itemTextColor || textColor,
            dominantBaseline: labelAlignment,
            pointerEvents: "none",
            userSelect: "none"
        }),
        x: labelX,
        y: labelY
    }, data.label));
};
LegendSvgItem.displayName = "LegendSvgItem";
LegendSvgItem.propTypes = _objectSpread$6({
    data: datumPropType.isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    textColor: (0, _propTypesDefault.default).string,
    background: (0, _propTypesDefault.default).string,
    opacity: (0, _propTypesDefault.default).number,
    direction: (0, _propTypesDefault.default).oneOf([
        "left-to-right",
        "right-to-left",
        "top-to-bottom",
        "bottom-to-top"
    ]).isRequired,
    justify: (0, _propTypesDefault.default).bool.isRequired
}, symbolPropTypes, interactivityPropTypes);
LegendSvgItem.defaultProps = {
    direction: "left-to-right",
    justify: false,
    textColor: "black",
    background: "transparent",
    opacity: 1,
    symbolShape: "square",
    symbolSize: 16,
    symbolSpacing: 8,
    symbolBorderWidth: 0,
    symbolBorderColor: "transparent",
    effects: []
};
function _objectSpread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$7(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$7(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var LegendSvg = function LegendSvg(_ref) {
    var data = _ref.data, x = _ref.x, y = _ref.y, direction = _ref.direction, _padding = _ref.padding, justify = _ref.justify, effects = _ref.effects, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight, itemDirection = _ref.itemDirection, itemsSpacing = _ref.itemsSpacing, itemTextColor = _ref.itemTextColor, itemBackground = _ref.itemBackground, itemOpacity = _ref.itemOpacity, symbolShape = _ref.symbolShape, symbolSize = _ref.symbolSize, symbolSpacing = _ref.symbolSpacing, symbolBorderWidth = _ref.symbolBorderWidth, symbolBorderColor = _ref.symbolBorderColor, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave;
    var _computeDimensions = computeDimensions({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }), padding = _computeDimensions.padding;
    var xStep = 0;
    var yStep = 0;
    if (direction === "row") xStep = itemWidth + itemsSpacing;
    else if (direction === "column") yStep = itemHeight + itemsSpacing;
    return (0, _reactDefault.default).createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
    }, data.map(function(data, i) {
        return (0, _reactDefault.default).createElement(LegendSvgItem, {
            key: i,
            data: data,
            x: i * xStep + padding.left,
            y: i * yStep + padding.top,
            width: itemWidth,
            height: itemHeight,
            direction: itemDirection,
            justify: justify,
            effects: effects,
            textColor: itemTextColor,
            background: itemBackground,
            opacity: itemOpacity,
            symbolShape: symbolShape,
            symbolSize: symbolSize,
            symbolSpacing: symbolSpacing,
            symbolBorderWidth: symbolBorderWidth,
            symbolBorderColor: symbolBorderColor,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        });
    }));
};
LegendSvg.propTypes = _objectSpread$7({
    data: (0, _propTypesDefault.default).arrayOf(datumPropType).isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    direction: (0, _propTypesDefault.default).oneOf([
        "row",
        "column"
    ]).isRequired,
    padding: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            top: (0, _propTypesDefault.default).number,
            right: (0, _propTypesDefault.default).number,
            bottom: (0, _propTypesDefault.default).number,
            left: (0, _propTypesDefault.default).number
        })
    ]).isRequired,
    justify: (0, _propTypesDefault.default).bool.isRequired,
    itemsSpacing: (0, _propTypesDefault.default).number.isRequired,
    itemWidth: (0, _propTypesDefault.default).number.isRequired,
    itemHeight: (0, _propTypesDefault.default).number.isRequired,
    itemDirection: (0, _propTypesDefault.default).oneOf([
        DIRECTION_LEFT_TO_RIGHT,
        DIRECTION_RIGHT_TO_LEFT,
        DIRECTION_TOP_TO_BOTTOM,
        DIRECTION_BOTTOM_TO_TOP
    ]).isRequired,
    itemTextColor: (0, _propTypesDefault.default).string.isRequired,
    itemBackground: (0, _propTypesDefault.default).string.isRequired,
    itemOpacity: (0, _propTypesDefault.default).number.isRequired
}, symbolPropTypes, interactivityPropTypes);
LegendSvg.defaultProps = {
    padding: 0,
    justify: false,
    itemsSpacing: 0,
    itemDirection: "left-to-right",
    itemTextColor: "black",
    itemBackground: "transparent",
    itemOpacity: 1
};
function _objectSpread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$8(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$8(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var BoxLegendSvg = function BoxLegendSvg(_ref) {
    var data = _ref.data, containerWidth = _ref.containerWidth, containerHeight = _ref.containerHeight, translateX = _ref.translateX, translateY = _ref.translateY, anchor = _ref.anchor, direction = _ref.direction, padding = _ref.padding, justify = _ref.justify, itemsSpacing = _ref.itemsSpacing, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight, itemDirection = _ref.itemDirection, itemTextColor = _ref.itemTextColor, itemBackground = _ref.itemBackground, itemOpacity = _ref.itemOpacity, symbolShape = _ref.symbolShape, symbolSize = _ref.symbolSize, symbolSpacing = _ref.symbolSpacing, symbolBorderWidth = _ref.symbolBorderWidth, symbolBorderColor = _ref.symbolBorderColor, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, effects = _ref.effects;
    var _computeDimensions = computeDimensions({
        itemCount: data.length,
        itemsSpacing: itemsSpacing,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        direction: direction,
        padding: padding
    }), width = _computeDimensions.width, height = _computeDimensions.height;
    var _computePositionFromA = computePositionFromAnchor({
        anchor: anchor,
        translateX: translateX,
        translateY: translateY,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        width: width,
        height: height
    }), x = _computePositionFromA.x, y = _computePositionFromA.y;
    return (0, _reactDefault.default).createElement(LegendSvg, {
        data: data,
        x: x,
        y: y,
        direction: direction,
        padding: padding,
        justify: justify,
        effects: effects,
        itemsSpacing: itemsSpacing,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemDirection: itemDirection,
        itemTextColor: itemTextColor,
        itemBackground: itemBackground,
        itemOpacity: itemOpacity,
        symbolShape: symbolShape,
        symbolSize: symbolSize,
        symbolSpacing: symbolSpacing,
        symbolBorderWidth: symbolBorderWidth,
        symbolBorderColor: symbolBorderColor,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    });
};
BoxLegendSvg.propTypes = _objectSpread$8({
    data: (0, _propTypesDefault.default).arrayOf(datumPropType).isRequired,
    containerWidth: (0, _propTypesDefault.default).number.isRequired,
    containerHeight: (0, _propTypesDefault.default).number.isRequired,
    translateX: (0, _propTypesDefault.default).number.isRequired,
    translateY: (0, _propTypesDefault.default).number.isRequired,
    anchor: (0, _propTypesDefault.default).oneOf([
        ANCHOR_TOP,
        ANCHOR_TOP_RIGHT,
        ANCHOR_RIGHT,
        ANCHOR_BOTTOM_RIGHT,
        ANCHOR_BOTTOM,
        ANCHOR_BOTTOM_LEFT,
        ANCHOR_LEFT,
        ANCHOR_TOP_LEFT,
        ANCHOR_CENTER
    ]).isRequired,
    direction: (0, _propTypesDefault.default).oneOf([
        DIRECTION_ROW,
        DIRECTION_COLUMN
    ]).isRequired,
    padding: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            top: (0, _propTypesDefault.default).number,
            right: (0, _propTypesDefault.default).number,
            bottom: (0, _propTypesDefault.default).number,
            left: (0, _propTypesDefault.default).number
        })
    ]).isRequired,
    justify: (0, _propTypesDefault.default).bool,
    itemWidth: (0, _propTypesDefault.default).number.isRequired,
    itemHeight: (0, _propTypesDefault.default).number.isRequired,
    itemDirection: (0, _propTypesDefault.default).oneOf([
        DIRECTION_LEFT_TO_RIGHT,
        DIRECTION_RIGHT_TO_LEFT,
        DIRECTION_TOP_TO_BOTTOM,
        DIRECTION_BOTTOM_TO_TOP
    ]),
    itemsSpacing: (0, _propTypesDefault.default).number.isRequired,
    itemTextColor: (0, _propTypesDefault.default).string,
    itemBackground: (0, _propTypesDefault.default).string,
    itemOpacity: (0, _propTypesDefault.default).number
}, symbolPropTypes, interactivityPropTypes);
BoxLegendSvg.defaultProps = {
    translateX: 0,
    translateY: 0,
    itemsSpacing: LegendSvg.defaultProps.itemsSpacing,
    padding: LegendSvg.defaultProps.padding
};
var textPropsMapping = {
    align: {
        start: "left",
        middle: "center",
        end: "right"
    },
    baseline: {
        hanging: "top",
        middle: "middle",
        baseline: "bottom"
    }
};
var renderLegendToCanvas = function renderLegendToCanvas(ctx, _ref) {
    var data = _ref.data, containerWidth = _ref.containerWidth, containerHeight = _ref.containerHeight, _ref$translateX = _ref.translateX, translateX = _ref$translateX === void 0 ? BoxLegendSvg.defaultProps.translateX : _ref$translateX, _ref$translateY = _ref.translateY, translateY = _ref$translateY === void 0 ? BoxLegendSvg.defaultProps.translateY : _ref$translateY, anchor = _ref.anchor, direction = _ref.direction, _ref$padding = _ref.padding, _padding = _ref$padding === void 0 ? LegendSvg.defaultProps.padding : _ref$padding, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? LegendSvgItem.defaultProps.justify : _ref$justify, _ref$itemsSpacing = _ref.itemsSpacing, itemsSpacing = _ref$itemsSpacing === void 0 ? LegendSvg.defaultProps.itemsSpacing : _ref$itemsSpacing, itemWidth = _ref.itemWidth, itemHeight = _ref.itemHeight, _ref$itemDirection = _ref.itemDirection, itemDirection = _ref$itemDirection === void 0 ? LegendSvgItem.defaultProps.direction : _ref$itemDirection, _ref$itemTextColor = _ref.itemTextColor, itemTextColor = _ref$itemTextColor === void 0 ? LegendSvg.defaultProps.textColor : _ref$itemTextColor, _ref$symbolSize = _ref.symbolSize, symbolSize = _ref$symbolSize === void 0 ? LegendSvgItem.defaultProps.symbolSize : _ref$symbolSize, _ref$symbolSpacing = _ref.symbolSpacing, symbolSpacing = _ref$symbolSpacing === void 0 ? LegendSvgItem.defaultProps.symbolSpacing : _ref$symbolSpacing, theme = _ref.theme;
    var _computeDimensions = computeDimensions({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }), width = _computeDimensions.width, height = _computeDimensions.height, padding = _computeDimensions.padding;
    var _computePositionFromA = computePositionFromAnchor({
        anchor: anchor,
        translateX: translateX,
        translateY: translateY,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        width: width,
        height: height
    }), x = _computePositionFromA.x, y = _computePositionFromA.y;
    var xStep = 0;
    var yStep = 0;
    if (direction === DIRECTION_ROW) xStep = itemWidth + itemsSpacing;
    else if (direction === DIRECTION_COLUMN) yStep = itemHeight + itemsSpacing;
    ctx.save();
    ctx.translate(x, y);
    data.forEach(function(d, i) {
        var itemX = i * xStep + padding.left;
        var itemY = i * yStep + padding.top;
        var _computeItemLayout = computeItemLayout({
            direction: itemDirection,
            justify: justify,
            symbolSize: symbolSize,
            symbolSpacing: symbolSpacing,
            width: itemWidth,
            height: itemHeight
        }), symbolX = _computeItemLayout.symbolX, symbolY = _computeItemLayout.symbolY, labelX = _computeItemLayout.labelX, labelY = _computeItemLayout.labelY, labelAnchor = _computeItemLayout.labelAnchor, labelAlignment = _computeItemLayout.labelAlignment;
        ctx.fillStyle = d.color;
        ctx.fillRect(itemX + symbolX, itemY + symbolY, symbolSize, symbolSize);
        ctx.textAlign = textPropsMapping.align[labelAnchor];
        ctx.textBaseline = textPropsMapping.baseline[labelAlignment];
        ctx.fillStyle = itemTextColor || theme.legends.text.fill;
        ctx.fillText(d.label, itemX + labelX, itemY + labelY);
    });
    ctx.restore();
};
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$1(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
var useQuantizeColorScaleLegendData = function useQuantizeColorScaleLegendData(_ref) {
    var scale = _ref.scale, overriddenDomain = _ref.domain, _ref$reverse = _ref.reverse, reverse = _ref$reverse === void 0 ? false : _ref$reverse, _ref$valueFormat = _ref.valueFormat, valueFormat = _ref$valueFormat === void 0 ? function(v) {
        return v;
    } : _ref$valueFormat, _ref$separator = _ref.separator, separator = _ref$separator === void 0 ? " - " : _ref$separator;
    return (0, _react.useMemo)(function() {
        var domain = overriddenDomain || scale.range();
        var items = domain.map(function(domainValue, index) {
            var _scale$invertExtent = scale.invertExtent(domainValue), _scale$invertExtent2 = _slicedToArray$1(_scale$invertExtent, 2), start = _scale$invertExtent2[0], end = _scale$invertExtent2[1];
            return {
                id: domainValue,
                index: index,
                extent: [
                    start,
                    end
                ],
                label: "".concat(valueFormat(start)).concat(separator).concat(valueFormat(end)),
                value: scale(start),
                color: domainValue
            };
        });
        if (reverse === true) items.reverse();
        return items;
    }, [
        overriddenDomain,
        scale,
        reverse
    ]);
};

},{"react":"6AiW6","prop-types":"kKQPU","lodash/isFunction":"cXGEE","@nivo/core":"guBSY","lodash/isNumber":"qMDht","lodash/isPlainObject":"9qlpu","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3dnGH":[function(require,module,exports) {
var baseExtremum = require("122393f3e0d791dc"), baseLt = require("8122a719ac68b5c4"), identity = require("3161b76b624de11a");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function min(array) {
    return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
}
module.exports = min;

},{"122393f3e0d791dc":"f1e6p","8122a719ac68b5c4":"dTLXz","3161b76b624de11a":"5HMso"}],"f1e6p":[function(require,module,exports) {
var isSymbol = require("6a2d056d200c4854");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = baseExtremum;

},{"6a2d056d200c4854":"fn3uU"}],"dTLXz":[function(require,module,exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function baseLt(value, other) {
    return value < other;
}
module.exports = baseLt;

},{}],"gXRHv":[function(require,module,exports) {
var baseExtremum = require("c7d87741ab4129b0"), baseGt = require("dbeef59341d150f4"), identity = require("3c95c3c9fbe3850f");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function max(array) {
    return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
}
module.exports = max;

},{"c7d87741ab4129b0":"f1e6p","dbeef59341d150f4":"fVecI","3c95c3c9fbe3850f":"5HMso"}],"fVecI":[function(require,module,exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function baseGt(value, other) {
    return value > other;
}
module.exports = baseGt;

},{}],"8dl7w":[function(require,module,exports) {
var createRange = require("1232c42be39f64d6");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"1232c42be39f64d6":"863cq"}],"863cq":[function(require,module,exports) {
var baseRange = require("f5c6552fbc38341a"), isIterateeCall = require("ae36f017fbc9946"), toFinite = require("c59818521cb53c6a");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"f5c6552fbc38341a":"3TIjc","ae36f017fbc9946":"9DmJa","c59818521cb53c6a":"8gwVY"}],"3TIjc":[function(require,module,exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"9BpCx":[function(require,module,exports) {
var baseFlatten = require("e551ebc58c3920ee"), toInteger = require("c642f10f6d11057f");
/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */ function flattenDepth(array, depth) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    depth = depth === undefined ? 1 : toInteger(depth);
    return baseFlatten(array, depth);
}
module.exports = flattenDepth;

},{"e551ebc58c3920ee":"jaR7v","c642f10f6d11057f":"4WHfQ"}],"56ibO":[function(require,module,exports) {
var baseIteratee = require("ce9604aad32f97ab"), baseUniq = require("9fbd8e46e11f49c4");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
module.exports = uniqBy;

},{"ce9604aad32f97ab":"1zzIW","9fbd8e46e11f49c4":"eGMc6"}],"9wymM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e24529554856ac15");
exports.__esModule = true;
exports.default = void 0;
var _shouldUpdate = _interopRequireDefault(require("b2d90a0d9d82a25c"));
var _shallowEqual = _interopRequireDefault(require("905506dd4351a828"));
var _setDisplayName = _interopRequireDefault(require("5a30bf0b5e73ae9f"));
var _wrapDisplayName = _interopRequireDefault(require("13746f6ae55cdbb7"));
var pure = function pure(BaseComponent) {
    var hoc = (0, _shouldUpdate.default)(function(props, nextProps) {
        return !(0, _shallowEqual.default)(props, nextProps);
    });
    return hoc(BaseComponent);
};
var _default = pure;
exports.default = _default;

},{"e24529554856ac15":"eZnmC","b2d90a0d9d82a25c":"ablcO","905506dd4351a828":"fb6wP","5a30bf0b5e73ae9f":"9JGr7","13746f6ae55cdbb7":"7bdyS"}],"ablcO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("20e5949ac7d6334");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("14d7afa4e6ad2024"));
var _react = require("4c42011fe6ca9922");
var _setDisplayName = _interopRequireDefault(require("8f841be028114450"));
var _wrapDisplayName = _interopRequireDefault(require("e05026080942da00"));
var shouldUpdate = function shouldUpdate(test) {
    return function(BaseComponent) {
        var factory = (0, _react.createFactory)(BaseComponent);
        var ShouldUpdate = /*#__PURE__*/ function(_Component) {
            (0, _inheritsLoose2.default)(ShouldUpdate, _Component);
            function ShouldUpdate() {
                return _Component.apply(this, arguments) || this;
            }
            var _proto = ShouldUpdate.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return test(this.props, nextProps);
            };
            _proto.render = function render() {
                return factory(this.props);
            };
            return ShouldUpdate;
        }(_react.Component);
        return ShouldUpdate;
    };
};
var _default = shouldUpdate;
exports.default = _default;

},{"20e5949ac7d6334":"eZnmC","14d7afa4e6ad2024":"gRWRc","4c42011fe6ca9922":"6AiW6","8f841be028114450":"9JGr7","e05026080942da00":"7bdyS"}],"c3QTw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "categoricalColorSchemeIds", ()=>categoricalColorSchemeIds);
parcelHelpers.export(exports, "categoricalColorSchemes", ()=>categoricalColorSchemes);
parcelHelpers.export(exports, "colorInterpolatorIds", ()=>colorInterpolatorIds);
parcelHelpers.export(exports, "colorInterpolators", ()=>colorInterpolators);
parcelHelpers.export(exports, "colorPropertyAccessorPropType", ()=>colorPropertyAccessorPropType);
parcelHelpers.export(exports, "colorSchemeIds", ()=>colorSchemeIds);
parcelHelpers.export(exports, "colorSchemes", ()=>colorSchemes);
parcelHelpers.export(exports, "divergingColorSchemeIds", ()=>divergingColorSchemeIds);
parcelHelpers.export(exports, "divergingColorSchemes", ()=>divergingColorSchemes);
parcelHelpers.export(exports, "getInheritedColorGenerator", ()=>getInheritedColorGenerator);
parcelHelpers.export(exports, "getInterpolatedColor", ()=>getInterpolatedColor);
parcelHelpers.export(exports, "getOrdinalColorScale", ()=>getOrdinalColorScale);
parcelHelpers.export(exports, "inheritedColorPropType", ()=>inheritedColorPropType);
parcelHelpers.export(exports, "interpolateColor", ()=>interpolateColor);
parcelHelpers.export(exports, "isCategoricalColorScheme", ()=>isCategoricalColorScheme);
parcelHelpers.export(exports, "isDivergingColorScheme", ()=>isDivergingColorScheme);
parcelHelpers.export(exports, "isSequentialColorScheme", ()=>isSequentialColorScheme);
parcelHelpers.export(exports, "ordinalColorsPropType", ()=>ordinalColorsPropType);
parcelHelpers.export(exports, "sequentialColorSchemeIds", ()=>sequentialColorSchemeIds);
parcelHelpers.export(exports, "sequentialColorSchemes", ()=>sequentialColorSchemes);
parcelHelpers.export(exports, "useInheritedColor", ()=>useInheritedColor);
parcelHelpers.export(exports, "useOrdinalColorScale", ()=>useOrdinalColorScale);
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _react = require("react");
var _lodashGet = require("lodash.get");
var _lodashGetDefault = parcelHelpers.interopDefault(_lodashGet);
var _lodashIsplainobject = require("lodash.isplainobject");
var _lodashIsplainobjectDefault = parcelHelpers.interopDefault(_lodashIsplainobject);
var _d3Scale = require("d3-scale");
var _d3Color = require("d3-color");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactMotion = require("react-motion");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var categoricalColorSchemes = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, _d3ScaleChromatic.schemeCategory10),
    accent: (0, _d3ScaleChromatic.schemeAccent),
    dark2: (0, _d3ScaleChromatic.schemeDark2),
    paired: (0, _d3ScaleChromatic.schemePaired),
    pastel1: (0, _d3ScaleChromatic.schemePastel1),
    pastel2: (0, _d3ScaleChromatic.schemePastel2),
    set1: (0, _d3ScaleChromatic.schemeSet1),
    set2: (0, _d3ScaleChromatic.schemeSet2),
    set3: (0, _d3ScaleChromatic.schemeSet3)
};
var categoricalColorSchemeIds = Object.keys(categoricalColorSchemes);
var isCategoricalColorScheme = function isCategoricalColorScheme(scheme) {
    return categoricalColorSchemeIds.includes(scheme);
};
var divergingColorSchemes = {
    brown_blueGreen: (0, _d3ScaleChromatic.schemeBrBG),
    purpleRed_green: (0, _d3ScaleChromatic.schemePRGn),
    pink_yellowGreen: (0, _d3ScaleChromatic.schemePiYG),
    purple_orange: (0, _d3ScaleChromatic.schemePuOr),
    red_blue: (0, _d3ScaleChromatic.schemeRdBu),
    red_grey: (0, _d3ScaleChromatic.schemeRdGy),
    red_yellow_blue: (0, _d3ScaleChromatic.schemeRdYlBu),
    red_yellow_green: (0, _d3ScaleChromatic.schemeRdYlGn),
    spectral: (0, _d3ScaleChromatic.schemeSpectral)
};
var divergingColorSchemeIds = Object.keys(divergingColorSchemes);
var isDivergingColorScheme = function isDivergingColorScheme(scheme) {
    return divergingColorSchemeIds.includes(scheme);
};
var sequentialColorSchemes = {
    blues: (0, _d3ScaleChromatic.schemeBlues),
    greens: (0, _d3ScaleChromatic.schemeGreens),
    greys: (0, _d3ScaleChromatic.schemeGreys),
    oranges: (0, _d3ScaleChromatic.schemeOranges),
    purples: (0, _d3ScaleChromatic.schemePurples),
    reds: (0, _d3ScaleChromatic.schemeReds),
    blue_green: (0, _d3ScaleChromatic.schemeBuGn),
    blue_purple: (0, _d3ScaleChromatic.schemeBuPu),
    green_blue: (0, _d3ScaleChromatic.schemeGnBu),
    orange_red: (0, _d3ScaleChromatic.schemeOrRd),
    purple_blue_green: (0, _d3ScaleChromatic.schemePuBuGn),
    purple_blue: (0, _d3ScaleChromatic.schemePuBu),
    purple_red: (0, _d3ScaleChromatic.schemePuRd),
    red_purple: (0, _d3ScaleChromatic.schemeRdPu),
    yellow_green_blue: (0, _d3ScaleChromatic.schemeYlGnBu),
    yellow_green: (0, _d3ScaleChromatic.schemeYlGn),
    yellow_orange_brown: (0, _d3ScaleChromatic.schemeYlOrBr),
    yellow_orange_red: (0, _d3ScaleChromatic.schemeYlOrRd)
};
var sequentialColorSchemeIds = Object.keys(sequentialColorSchemes);
var isSequentialColorScheme = function isSequentialColorScheme(scheme) {
    return sequentialColorSchemeIds.includes(scheme);
};
var colorSchemes = _objectSpread({}, categoricalColorSchemes, divergingColorSchemes, sequentialColorSchemes);
var colorSchemeIds = Object.keys(colorSchemes);
var colorInterpolators = {
    brown_blueGreen: (0, _d3ScaleChromatic.interpolateBrBG),
    purpleRed_green: (0, _d3ScaleChromatic.interpolatePRGn),
    pink_yellowGreen: (0, _d3ScaleChromatic.interpolatePiYG),
    purple_orange: (0, _d3ScaleChromatic.interpolatePuOr),
    red_blue: (0, _d3ScaleChromatic.interpolateRdBu),
    red_grey: (0, _d3ScaleChromatic.interpolateRdGy),
    red_yellow_blue: (0, _d3ScaleChromatic.interpolateRdYlBu),
    red_yellow_green: (0, _d3ScaleChromatic.interpolateRdYlGn),
    spectral: (0, _d3ScaleChromatic.interpolateSpectral),
    blues: (0, _d3ScaleChromatic.interpolateBlues),
    greens: (0, _d3ScaleChromatic.interpolateGreens),
    greys: (0, _d3ScaleChromatic.interpolateGreys),
    oranges: (0, _d3ScaleChromatic.interpolateOranges),
    purples: (0, _d3ScaleChromatic.interpolatePurples),
    reds: (0, _d3ScaleChromatic.interpolateReds),
    viridis: (0, _d3ScaleChromatic.interpolateViridis),
    inferno: (0, _d3ScaleChromatic.interpolateInferno),
    magma: (0, _d3ScaleChromatic.interpolateMagma),
    plasma: (0, _d3ScaleChromatic.interpolatePlasma),
    warm: (0, _d3ScaleChromatic.interpolateWarm),
    cool: (0, _d3ScaleChromatic.interpolateCool),
    cubehelixDefault: (0, _d3ScaleChromatic.interpolateCubehelixDefault),
    blue_green: (0, _d3ScaleChromatic.interpolateBuGn),
    blue_purple: (0, _d3ScaleChromatic.interpolateBuPu),
    green_blue: (0, _d3ScaleChromatic.interpolateGnBu),
    orange_red: (0, _d3ScaleChromatic.interpolateOrRd),
    purple_blue_green: (0, _d3ScaleChromatic.interpolatePuBuGn),
    purple_blue: (0, _d3ScaleChromatic.interpolatePuBu),
    purple_red: (0, _d3ScaleChromatic.interpolatePuRd),
    red_purple: (0, _d3ScaleChromatic.interpolateRdPu),
    yellow_green_blue: (0, _d3ScaleChromatic.interpolateYlGnBu),
    yellow_green: (0, _d3ScaleChromatic.interpolateYlGn),
    yellow_orange_brown: (0, _d3ScaleChromatic.interpolateYlOrBr),
    yellow_orange_red: (0, _d3ScaleChromatic.interpolateYlOrRd),
    rainbow: (0, _d3ScaleChromatic.interpolateRainbow),
    sinebow: (0, _d3ScaleChromatic.interpolateSinebow)
};
var colorInterpolatorIds = Object.keys(colorInterpolators);
var getOrdinalColorScale = function getOrdinalColorScale(instruction, identity) {
    if (typeof instruction === "function") return instruction;
    var getIdentity = typeof identity === "function" ? identity : function(d) {
        return (0, _lodashGetDefault.default)(d, identity);
    };
    if (Array.isArray(instruction)) {
        var scale = (0, _d3Scale.scaleOrdinal)(instruction);
        var generator = function generator(d) {
            return scale(getIdentity(d));
        };
        generator.scale = scale;
        return generator;
    }
    if ((0, _lodashIsplainobjectDefault.default)(instruction)) {
        if (instruction.datum !== undefined) return function(datum) {
            return (0, _lodashGetDefault.default)(datum, instruction.datum);
        };
        if (instruction.scheme !== undefined) {
            if (isCategoricalColorScheme(instruction.scheme)) {
                var _scale = (0, _d3Scale.scaleOrdinal)(colorSchemes[instruction.scheme]);
                var _generator = function _generator(d) {
                    return _scale(getIdentity(d));
                };
                _generator.scale = _scale;
                return _generator;
            }
            if (isDivergingColorScheme(instruction.scheme)) {
                if (instruction.size !== undefined && (instruction.size < 3 || instruction.size > 11)) throw new Error("Invalid size '".concat(instruction.size, "' for diverging color scheme '").concat(instruction.scheme, "', must be between 3~11"));
                var _scale2 = (0, _d3Scale.scaleOrdinal)(colorSchemes[instruction.scheme][instruction.size || 11]);
                var _generator2 = function _generator2(d) {
                    return _scale2(getIdentity(d));
                };
                _generator2.scale = _scale2;
                return _generator2;
            }
            if (isSequentialColorScheme(instruction.scheme)) {
                if (instruction.size !== undefined && (instruction.size < 3 || instruction.size > 9)) throw new Error("Invalid size '".concat(instruction.size, "' for sequential color scheme '").concat(instruction.scheme, "', must be between 3~9"));
                var _scale3 = (0, _d3Scale.scaleOrdinal)(colorSchemes[instruction.scheme][instruction.size || 9]);
                var _generator3 = function _generator3(d) {
                    return _scale3(getIdentity(d));
                };
                _generator3.scale = _scale3;
                return _generator3;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return instruction;
    };
};
var useOrdinalColorScale = function useOrdinalColorScale(instruction, identity) {
    return (0, _react.useMemo)(function() {
        return getOrdinalColorScale(instruction, identity);
    }, [
        instruction,
        identity
    ]);
};
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var getInheritedColorGenerator = function getInheritedColorGenerator(inheritedColor, theme) {
    if (typeof inheritedColor === "function") return function(node) {
        return inheritedColor(node);
    };
    if ((0, _lodashIsplainobjectDefault.default)(inheritedColor)) {
        if (inheritedColor.theme !== undefined) {
            if (theme === undefined) throw new Error("Unable to use color from theme as no theme was provided");
            var themeColor = (0, _lodashGetDefault.default)(theme, inheritedColor.theme);
            if (themeColor === undefined) throw new Error("Color from theme is undefined at path: '".concat(inheritedColor.theme, "'"));
            return function() {
                return themeColor;
            };
        }
        if (inheritedColor.from !== undefined) {
            var getColor = function getColor(datum) {
                return (0, _lodashGetDefault.default)(datum, inheritedColor.from);
            };
            if (Array.isArray(inheritedColor.modifiers)) {
                var modifiers = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    var _loop = function _loop() {
                        var modifier = _step.value;
                        var _modifier = _slicedToArray(modifier, 2), modifierType = _modifier[0], amount = _modifier[1];
                        if (modifierType === "brighter") modifiers.push(function(color) {
                            return color.brighter(amount);
                        });
                        else if (modifierType === "darker") modifiers.push(function(color) {
                            return color.darker(amount);
                        });
                        else if (modifierType === "opacity") modifiers.push(function(color) {
                            color.opacity = amount;
                            return color;
                        });
                        else throw new Error("Invalid color modifier: '".concat(modifierType, "', must be one of: 'brighter', 'darker', 'opacity'"));
                    };
                    for(var _iterator = inheritedColor.modifiers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                if (modifiers.length === 0) return getColor;
                return function(datum) {
                    return modifiers.reduce(function(color, modify) {
                        return modify(color);
                    }, (0, _d3Color.rgb)(getColor(datum))).toString();
                };
            }
            return getColor;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return inheritedColor;
    };
};
var useInheritedColor = function useInheritedColor(parentColor, theme) {
    return (0, _react.useMemo)(function() {
        return getInheritedColorGenerator(parentColor, theme);
    }, [
        parentColor,
        theme
    ]);
};
var ordinalColorsPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    (0, _propTypesDefault.default).shape({
        scheme: (0, _propTypesDefault.default).oneOf(colorSchemeIds).isRequired,
        size: (0, _propTypesDefault.default).number
    }),
    (0, _propTypesDefault.default).shape({
        datum: (0, _propTypesDefault.default).string.isRequired
    }),
    (0, _propTypesDefault.default).string
]);
var colorPropertyAccessorPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).string
]);
var inheritedColorPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).shape({
        theme: (0, _propTypesDefault.default).string.isRequired
    }),
    (0, _propTypesDefault.default).shape({
        from: (0, _propTypesDefault.default).string.isRequired,
        modifiers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).array)
    })
]);
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var interpolateColor = function interpolateColor(color, springConfig) {
    var colorComponents = (0, _d3Color.rgb)(color);
    if (!springConfig) return {
        colorR: colorComponents.r,
        colorG: colorComponents.g,
        colorB: colorComponents.b
    };
    var configWithPrecision = _objectSpread$1({}, springConfig, {
        precision: 1
    });
    return {
        colorR: (0, _reactMotion.spring)(colorComponents.r, configWithPrecision),
        colorG: (0, _reactMotion.spring)(colorComponents.g, configWithPrecision),
        colorB: (0, _reactMotion.spring)(colorComponents.b, configWithPrecision)
    };
};
var getInterpolatedColor = function getInterpolatedColor(_ref) {
    var colorR = _ref.colorR, colorG = _ref.colorG, colorB = _ref.colorB;
    return "rgb(".concat(Math.round(Math.max(colorR, 0)), ",").concat(Math.round(Math.max(colorG, 0)), ",").concat(Math.round(Math.max(colorB, 0)), ")");
};

},{"d3-scale-chromatic":"cmMGd","react":"6AiW6","lodash.get":"9EGt2","lodash.isplainobject":"bgmwN","d3-scale":"7Ll4r","d3-color":"fIEE2","prop-types":"kKQPU","react-motion":"lqe7n","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cmMGd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"a3dPT","./categorical/Accent.js":"jUCla","./categorical/Dark2.js":"8x4fS","./categorical/Paired.js":"hsHvI","./categorical/Pastel1.js":"fmgMt","./categorical/Pastel2.js":"b270z","./categorical/Set1.js":"2HEXb","./categorical/Set2.js":"lEqU7","./categorical/Set3.js":"aKJ38","./categorical/Tableau10.js":false,"./diverging/BrBG.js":"9UvxN","./diverging/PRGn.js":"36k0h","./diverging/PiYG.js":"3Fyue","./diverging/PuOr.js":"jd3QS","./diverging/RdBu.js":"ez6s8","./diverging/RdGy.js":"6pMyp","./diverging/RdYlBu.js":"6LBVD","./diverging/RdYlGn.js":"h13OJ","./diverging/Spectral.js":"l14Iq","./sequential-multi/BuGn.js":"2KQZr","./sequential-multi/BuPu.js":"hMOyf","./sequential-multi/GnBu.js":"kBnfJ","./sequential-multi/OrRd.js":"XMq8y","./sequential-multi/PuBuGn.js":"dDBcG","./sequential-multi/PuBu.js":"6YDDR","./sequential-multi/PuRd.js":"40hdS","./sequential-multi/RdPu.js":"cRR0r","./sequential-multi/YlGnBu.js":"jpX6x","./sequential-multi/YlGn.js":"UIOJA","./sequential-multi/YlOrBr.js":"jHhsU","./sequential-multi/YlOrRd.js":"9u4db","./sequential-single/Blues.js":"fzfp4","./sequential-single/Greens.js":"eNOyg","./sequential-single/Greys.js":"eVM8F","./sequential-single/Purples.js":"8op0y","./sequential-single/Reds.js":"iEfKH","./sequential-single/Oranges.js":"k97fN","./sequential-multi/cividis.js":false,"./sequential-multi/cubehelix.js":"e0lBP","./sequential-multi/rainbow.js":"6pla4","./sequential-multi/sinebow.js":"lzzcW","./sequential-multi/turbo.js":false,"./sequential-multi/viridis.js":"cBvki","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"a3dPT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"4F3jT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jUCla":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8x4fS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hsHvI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fmgMt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b270z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2HEXb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lEqU7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"aKJ38":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9UvxN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3LjIq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(scheme) {
        return (0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);
    });
var _d3Interpolate = require("d3-interpolate");

},{"d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"36k0h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3Fyue":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jd3QS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"ez6s8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6pMyp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6LBVD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"h13OJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"l14Iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2KQZr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"hMOyf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"kBnfJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"XMq8y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"dDBcG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6YDDR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"40hdS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cRR0r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jpX6x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"UIOJA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jHhsU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9u4db":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"fzfp4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eNOyg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"eVM8F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"8op0y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iEfKH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"k97fN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"4F3jT","../ramp.js":"3LjIq","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"e0lBP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"fIEE2","d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"6pla4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"fIEE2","d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lzzcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"fIEE2","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cBvki":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"4F3jT","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9EGt2":[function(require,module,exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** `Object#toString` result references. */ var funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{}],"bgmwN":[function(require,module,exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{}],"5HBnS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Annotation", ()=>Annotation);
parcelHelpers.export(exports, "annotationSpecPropType", ()=>annotationSpecPropType);
parcelHelpers.export(exports, "bindAnnotations", ()=>bindAnnotations);
parcelHelpers.export(exports, "computeAnnotation", ()=>computeAnnotation);
parcelHelpers.export(exports, "defaultProps", ()=>defaultProps);
parcelHelpers.export(exports, "getLinkAngle", ()=>getLinkAngle);
parcelHelpers.export(exports, "renderAnnotationsToCanvas", ()=>renderAnnotationsToCanvas);
parcelHelpers.export(exports, "useAnnotations", ()=>useAnnotations);
parcelHelpers.export(exports, "useComputedAnnotation", ()=>useComputedAnnotation);
parcelHelpers.export(exports, "useComputedAnnotations", ()=>useComputedAnnotations);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactMotion = require("react-motion");
var _core = require("@nivo/core");
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _filter = require("lodash/filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var annotationSpecPropType = (0, _propTypesDefault.default).shape({
    match: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ]).isRequired,
    type: (0, _propTypesDefault.default).oneOf([
        "circle",
        "rect",
        "dot"
    ]).isRequired,
    noteX: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            abs: (0, _propTypesDefault.default).number.isRequired
        })
    ]).isRequired,
    noteY: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            abs: (0, _propTypesDefault.default).number.isRequired
        })
    ]).isRequired,
    noteWidth: (0, _propTypesDefault.default).number,
    noteTextOffset: (0, _propTypesDefault.default).number,
    note: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    offset: (0, _propTypesDefault.default).number
});
var defaultProps = {
    noteWidth: 120,
    noteTextOffset: 8,
    animate: true,
    motionStiffness: 90,
    motionDamping: 13
};
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var defaultPositionAccessor = function defaultPositionAccessor(item) {
    return {
        x: item.x,
        y: item.y
    };
};
var bindAnnotations = function bindAnnotations(_ref) {
    var items = _ref.items, annotations = _ref.annotations, _ref$getPosition = _ref.getPosition, getPosition = _ref$getPosition === void 0 ? defaultPositionAccessor : _ref$getPosition, getDimensions = _ref.getDimensions;
    return annotations.reduce(function(acc, annotation) {
        (0, _filterDefault.default)(items, annotation.match).forEach(function(item) {
            var position = getPosition(item);
            var dimensions = getDimensions(item, annotation.offset || 0);
            acc.push(_objectSpread({}, (0, _omitDefault.default)(annotation, [
                "match",
                "offset"
            ]), position, dimensions, {
                datum: item,
                size: annotation.size || dimensions.size
            }));
        });
        return acc;
    }, []);
};
var getLinkAngle = function getLinkAngle(sourceX, sourceY, targetX, targetY) {
    var angle = Math.atan2(targetY - sourceY, targetX - sourceX);
    return (0, _core.absoluteAngleDegrees)((0, _core.radiansToDegrees)(angle));
};
var computeAnnotation = function computeAnnotation(_ref2) {
    var type = _ref2.type, x = _ref2.x, y = _ref2.y, size = _ref2.size, width = _ref2.width, height = _ref2.height, noteX = _ref2.noteX, noteY = _ref2.noteY, _ref2$noteWidth = _ref2.noteWidth, noteWidth = _ref2$noteWidth === void 0 ? defaultProps.noteWidth : _ref2$noteWidth, _ref2$noteTextOffset = _ref2.noteTextOffset, noteTextOffset = _ref2$noteTextOffset === void 0 ? defaultProps.noteTextOffset : _ref2$noteTextOffset;
    var computedNoteX;
    var computedNoteY;
    if ((0, _isPlainObjectDefault.default)(noteX)) {
        if (noteX.abs !== undefined) computedNoteX = noteX.abs;
    } else computedNoteX = x + noteX;
    if ((0, _isPlainObjectDefault.default)(noteY)) {
        if (noteY.abs !== undefined) computedNoteY = noteY.abs;
    } else computedNoteY = y + noteY;
    var computedX = x;
    var computedY = y;
    var angle = getLinkAngle(x, y, computedNoteX, computedNoteY);
    if (type === "circle") {
        var position = (0, _core.positionFromAngle)((0, _core.degreesToRadians)(angle), size / 2);
        computedX += position.x;
        computedY += position.y;
    }
    if (type === "rect") {
        var eighth = Math.round((angle + 90) / 45) % 8;
        if (eighth === 0) computedY -= height / 2;
        if (eighth === 1) {
            computedX += width / 2;
            computedY -= height / 2;
        }
        if (eighth === 2) computedX += width / 2;
        if (eighth === 3) {
            computedX += width / 2;
            computedY += height / 2;
        }
        if (eighth === 4) computedY += height / 2;
        if (eighth === 5) {
            computedX -= width / 2;
            computedY += height / 2;
        }
        if (eighth === 6) computedX -= width / 2;
        if (eighth === 7) {
            computedX -= width / 2;
            computedY -= height / 2;
        }
    }
    var textX = computedNoteX;
    var textY = computedNoteY - noteTextOffset;
    var noteLineX = computedNoteX;
    var noteLineY = computedNoteY;
    if ((angle + 90) % 360 > 180) {
        textX -= noteWidth;
        noteLineX -= noteWidth;
    } else noteLineX += noteWidth;
    return {
        points: [
            [
                computedX,
                computedY
            ],
            [
                computedNoteX,
                computedNoteY
            ],
            [
                noteLineX,
                noteLineY
            ]
        ],
        text: [
            textX,
            textY
        ],
        angle: angle + 90
    };
};
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var useAnnotations = function useAnnotations(_ref) {
    var items = _ref.items, annotations = _ref.annotations, getPosition = _ref.getPosition, getDimensions = _ref.getDimensions;
    return (0, _react.useMemo)(function() {
        return bindAnnotations({
            items: items,
            annotations: annotations,
            getPosition: getPosition,
            getDimensions: getDimensions
        });
    }, [
        items,
        annotations,
        getPosition,
        getDimensions
    ]);
};
var useComputedAnnotations = function useComputedAnnotations(_ref2) {
    var annotations = _ref2.annotations, containerWidth = _ref2.containerWidth, containerHeight = _ref2.containerHeight;
    return (0, _react.useMemo)(function() {
        return annotations.map(function(annotation) {
            return _objectSpread$1({}, annotation, {
                computed: computeAnnotation(_objectSpread$1({
                    containerWidth: containerWidth,
                    containerHeight: containerHeight
                }, annotation))
            });
        });
    }, [
        annotations,
        containerWidth,
        containerHeight
    ]);
};
var useComputedAnnotation = function useComputedAnnotation(_ref3) {
    var type = _ref3.type, containerWidth = _ref3.containerWidth, containerHeight = _ref3.containerHeight, x = _ref3.x, y = _ref3.y, size = _ref3.size, width = _ref3.width, height = _ref3.height, noteX = _ref3.noteX, noteY = _ref3.noteY, noteWidth = _ref3.noteWidth, noteTextOffset = _ref3.noteTextOffset;
    return (0, _react.useMemo)(function() {
        return computeAnnotation({
            type: type,
            containerWidth: containerWidth,
            containerHeight: containerHeight,
            x: x,
            y: y,
            size: size,
            width: width,
            height: height,
            noteX: noteX,
            noteY: noteY,
            noteWidth: noteWidth,
            noteTextOffset: noteTextOffset
        });
    }, [
        type,
        containerWidth,
        containerHeight,
        x,
        y,
        size,
        width,
        height,
        noteX,
        noteY,
        noteWidth,
        noteTextOffset
    ]);
};
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var AnnotationNote = (0, _react.memo)(function(_ref) {
    var datum = _ref.datum, x = _ref.x, y = _ref.y, note = _ref.note;
    var theme = (0, _core.useTheme)();
    if (typeof note === "function") return note({
        x: x,
        y: y,
        datum: datum
    });
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.text.outlineWidth > 0 && (0, _reactDefault.default).createElement("text", {
        x: x,
        y: y,
        style: _objectSpread$2({}, theme.annotations.text, {
            strokeLinejoin: "round",
            strokeWidth: theme.annotations.text.outlineWidth * 2,
            stroke: theme.annotations.text.outlineColor
        })
    }, note), (0, _reactDefault.default).createElement("text", {
        x: x,
        y: y,
        style: (0, _omitDefault.default)(theme.annotations.text, [
            "outlineWidth",
            "outlineColor"
        ])
    }, note));
});
AnnotationNote.displayName = "AnnotationNote";
AnnotationNote.propTypes = {
    datum: (0, _propTypesDefault.default).object.isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    note: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
AnnotationNote.defaultProps = {};
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var AnnotationLink = (0, _react.memo)(function(_ref) {
    var points = _ref.points, isOutline = _ref.isOutline;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    if (isOutline && theme.annotations.link.outlineWidth <= 0) return null;
    var style = _objectSpread$3({}, theme.annotations.link);
    if (isOutline) {
        style.strokeLinecap = "square";
        style.strokeWidth = theme.annotations.link.strokeWidth + theme.annotations.link.outlineWidth * 2;
        style.stroke = theme.annotations.link.outlineColor;
    }
    var path = "M".concat(points[0][0], ",").concat(points[0][1]);
    points.slice(1).forEach(function(point) {
        path = "".concat(path, " L").concat(point[0], ",").concat(point[1]);
    });
    if (!animate) return (0, _reactDefault.default).createElement("path", {
        fill: "none",
        d: path,
        style: style
    });
    return (0, _reactDefault.default).createElement((0, _core.SmartMotion), {
        style: function style(spring) {
            return {
                d: spring(path, springConfig)
            };
        }
    }, function(interpolated) {
        return (0, _reactDefault.default).createElement("path", {
            fill: "none",
            d: interpolated.d,
            style: style
        });
    });
});
AnnotationLink.displayName = "AnnotationLink";
AnnotationLink.propTypes = {
    points: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).array).isRequired,
    isOutline: (0, _propTypesDefault.default).bool.isRequired
};
AnnotationLink.defaultProps = {
    isOutline: false
};
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var CircleAnnotationOutline = (0, _react.memo)(function(_ref) {
    var x = _ref.x, y = _ref.y, size = _ref.size;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    if (!animate) return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.outline.outlineWidth > 0 && (0, _reactDefault.default).createElement("circle", {
        cx: x,
        cy: y,
        r: size / 2,
        style: _objectSpread$4({}, theme.annotations.outline, {
            fill: "none",
            strokeWidth: theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2,
            stroke: theme.annotations.outline.outlineColor
        })
    }), (0, _reactDefault.default).createElement("circle", {
        cx: x,
        cy: y,
        r: size / 2,
        style: theme.annotations.outline
    }));
    return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x: (0, _reactMotion.spring)(x, springConfig),
            y: (0, _reactMotion.spring)(y, springConfig),
            size: (0, _reactMotion.spring)(size, springConfig)
        }
    }, function(interpolated) {
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.outline.outlineWidth > 0 && (0, _reactDefault.default).createElement("circle", {
            cx: interpolated.x,
            cy: interpolated.y,
            r: interpolated.size / 2,
            style: _objectSpread$4({}, theme.annotations.outline, {
                fill: "none",
                strokeWidth: theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2,
                stroke: theme.annotations.outline.outlineColor
            })
        }), (0, _reactDefault.default).createElement("circle", {
            cx: interpolated.x,
            cy: interpolated.y,
            r: interpolated.size / 2,
            style: theme.annotations.outline
        }));
    });
});
CircleAnnotationOutline.displayName = "CircleAnnotationOutline";
CircleAnnotationOutline.propTypes = {
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    size: (0, _propTypesDefault.default).number.isRequired
};
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DotAnnotationOutline = (0, _react.memo)(function(_ref) {
    var x = _ref.x, y = _ref.y, size = _ref.size;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    if (!animate) return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.outline.outlineWidth > 0 && (0, _reactDefault.default).createElement("circle", {
        cx: x,
        cy: y,
        r: size / 2,
        style: _objectSpread$5({}, theme.annotations.outline, {
            fill: "none",
            strokeWidth: theme.annotations.outline.outlineWidth * 2,
            stroke: theme.annotations.outline.outlineColor
        })
    }), (0, _reactDefault.default).createElement("circle", {
        cx: x,
        cy: y,
        r: size / 2,
        style: theme.annotations.symbol
    }));
    return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x: (0, _reactMotion.spring)(x, springConfig),
            y: (0, _reactMotion.spring)(y, springConfig),
            size: (0, _reactMotion.spring)(size, springConfig)
        }
    }, function(interpolated) {
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.outline.outlineWidth > 0 && (0, _reactDefault.default).createElement("circle", {
            cx: interpolated.x,
            cy: interpolated.y,
            r: interpolated.size / 2,
            style: _objectSpread$5({}, theme.annotations.outline, {
                fill: "none",
                strokeWidth: theme.annotations.outline.outlineWidth * 2,
                stroke: theme.annotations.outline.outlineColor
            })
        }), (0, _reactDefault.default).createElement("circle", {
            cx: interpolated.x,
            cy: interpolated.y,
            r: interpolated.size / 2,
            style: theme.annotations.symbol
        }));
    });
});
DotAnnotationOutline.displayName = "DotAnnotationOutline";
DotAnnotationOutline.propTypes = {
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    size: (0, _propTypesDefault.default).number.isRequired
};
DotAnnotationOutline.defaultProps = {
    size: 4
};
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$6(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$6(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var RectAnnotationOutline = (0, _react.memo)(function(_ref) {
    var x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
    var theme = (0, _core.useTheme)();
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    if (!animate) return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.outline.outlineWidth > 0 && (0, _reactDefault.default).createElement("rect", {
        x: x - width / 2,
        y: y - height / 2,
        width: width,
        height: height,
        style: _objectSpread$6({}, theme.annotations.outline, {
            fill: "none",
            strokeWidth: theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2,
            stroke: theme.annotations.outline.outlineColor
        })
    }), (0, _reactDefault.default).createElement("rect", {
        x: x - width / 2,
        y: y - height / 2,
        width: width,
        height: height,
        style: theme.annotations.outline
    }));
    return (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x: (0, _reactMotion.spring)(x - width / 2, springConfig),
            y: (0, _reactMotion.spring)(y - height / 2, springConfig),
            width: (0, _reactMotion.spring)(width, springConfig),
            height: (0, _reactMotion.spring)(height, springConfig)
        }
    }, function(interpolated) {
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, theme.annotations.outline.outlineWidth > 0 && (0, _reactDefault.default).createElement("rect", {
            x: interpolated.x,
            y: interpolated.y,
            width: interpolated.width,
            height: interpolated.height,
            style: _objectSpread$6({}, theme.annotations.outline, {
                fill: "none",
                strokeWidth: theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2,
                stroke: theme.annotations.outline.outlineColor
            })
        }), (0, _reactDefault.default).createElement("rect", {
            x: interpolated.x,
            y: interpolated.y,
            width: interpolated.width,
            height: interpolated.height,
            style: theme.annotations.outline
        }));
    });
});
RectAnnotationOutline.displayName = "RectAnnotationOutline";
RectAnnotationOutline.propTypes = {
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired
};
var Annotation = (0, _react.memo)(function(_ref) {
    var datum = _ref.datum, type = _ref.type, containerWidth = _ref.containerWidth, containerHeight = _ref.containerHeight, x = _ref.x, y = _ref.y, size = _ref.size, width = _ref.width, height = _ref.height, noteX = _ref.noteX, noteY = _ref.noteY, noteWidth = _ref.noteWidth, noteTextOffset = _ref.noteTextOffset, note = _ref.note;
    var _useMotionConfig = (0, _core.useMotionConfig)(), animate = _useMotionConfig.animate, springConfig = _useMotionConfig.springConfig;
    var computed = useComputedAnnotation({
        type: type,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        x: x,
        y: y,
        size: size,
        width: width,
        height: height,
        noteX: noteX,
        noteY: noteY,
        noteWidth: noteWidth,
        noteTextOffset: noteTextOffset
    });
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(AnnotationLink, {
        points: computed.points,
        isOutline: true
    }), type === "circle" && (0, _reactDefault.default).createElement(CircleAnnotationOutline, {
        x: x,
        y: y,
        size: size
    }), type === "dot" && (0, _reactDefault.default).createElement(DotAnnotationOutline, {
        x: x,
        y: y,
        size: size
    }), type === "rect" && (0, _reactDefault.default).createElement(RectAnnotationOutline, {
        x: x,
        y: y,
        width: width,
        height: height
    }), (0, _reactDefault.default).createElement(AnnotationLink, {
        points: computed.points
    }), !animate && (0, _reactDefault.default).createElement(AnnotationNote, {
        x: computed.text[0],
        y: computed.text[1],
        note: note
    }), animate && (0, _reactDefault.default).createElement((0, _reactMotion.Motion), {
        style: {
            x: (0, _reactMotion.spring)(computed.text[0], springConfig),
            y: (0, _reactMotion.spring)(computed.text[1], springConfig)
        }
    }, function(interpolated) {
        return (0, _reactDefault.default).createElement(AnnotationNote, {
            datum: datum,
            x: interpolated.x,
            y: interpolated.y,
            note: note
        });
    }));
});
Annotation.displayName = "Annotation";
Annotation.propTypes = {
    datum: (0, _propTypesDefault.default).object.isRequired,
    type: (0, _propTypesDefault.default).oneOf([
        "circle",
        "rect",
        "dot"
    ]).isRequired,
    containerWidth: (0, _propTypesDefault.default).number.isRequired,
    containerHeight: (0, _propTypesDefault.default).number.isRequired,
    x: (0, _propTypesDefault.default).number.isRequired,
    y: (0, _propTypesDefault.default).number.isRequired,
    size: (0, _propTypesDefault.default).number,
    width: (0, _propTypesDefault.default).number,
    height: (0, _propTypesDefault.default).number,
    noteX: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            abs: (0, _propTypesDefault.default).number.isRequired
        })
    ]).isRequired,
    noteY: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            abs: (0, _propTypesDefault.default).number.isRequired
        })
    ]).isRequired,
    noteWidth: (0, _propTypesDefault.default).number.isRequired,
    noteTextOffset: (0, _propTypesDefault.default).number.isRequired,
    note: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired
};
Annotation.defaultProps = {
    noteWidth: defaultProps.noteWidth,
    noteTextOffset: defaultProps.noteTextOffset
};
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var drawPoints = function drawPoints(ctx, points) {
    points.forEach(function(_ref, index) {
        var _ref2 = _slicedToArray(_ref, 2), x = _ref2[0], y = _ref2[1];
        if (index === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    });
};
var renderAnnotationsToCanvas = function renderAnnotationsToCanvas(ctx, _ref3) {
    var annotations = _ref3.annotations, theme = _ref3.theme;
    if (annotations.length === 0) return;
    ctx.save();
    annotations.forEach(function(annotation) {
        if (theme.annotations.link.outlineWidth > 0) {
            ctx.lineCap = "square";
            ctx.strokeStyle = theme.annotations.link.outlineColor;
            ctx.lineWidth = theme.annotations.link.strokeWidth + theme.annotations.link.outlineWidth * 2;
            ctx.beginPath();
            drawPoints(ctx, annotation.computed.points);
            ctx.stroke();
            ctx.lineCap = "butt";
        }
        if (annotation.type === "circle" && theme.annotations.outline.outlineWidth > 0) {
            ctx.strokeStyle = theme.annotations.outline.outlineColor;
            ctx.lineWidth = theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2;
            ctx.beginPath();
            ctx.arc(annotation.x, annotation.y, annotation.size / 2, 0, 2 * Math.PI);
            ctx.stroke();
        }
        if (annotation.type === "dot" && theme.annotations.symbol.outlineWidth > 0) {
            ctx.strokeStyle = theme.annotations.symbol.outlineColor;
            ctx.lineWidth = theme.annotations.symbol.outlineWidth * 2;
            ctx.beginPath();
            ctx.arc(annotation.x, annotation.y, annotation.size / 2, 0, 2 * Math.PI);
            ctx.stroke();
        }
        if (annotation.type === "rect" && theme.annotations.outline.outlineWidth > 0) {
            ctx.strokeStyle = theme.annotations.outline.outlineColor;
            ctx.lineWidth = theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2;
            ctx.beginPath();
            ctx.rect(annotation.x - annotation.width / 2, annotation.y - annotation.height / 2, annotation.width, annotation.height);
            ctx.stroke();
        }
        ctx.strokeStyle = theme.annotations.link.stroke;
        ctx.lineWidth = theme.annotations.link.strokeWidth;
        ctx.beginPath();
        drawPoints(ctx, annotation.computed.points);
        ctx.stroke();
        if (annotation.type === "circle") {
            ctx.strokeStyle = theme.annotations.outline.stroke;
            ctx.lineWidth = theme.annotations.outline.strokeWidth;
            ctx.beginPath();
            ctx.arc(annotation.x, annotation.y, annotation.size / 2, 0, 2 * Math.PI);
            ctx.stroke();
        }
        if (annotation.type === "dot") {
            ctx.fillStyle = theme.annotations.symbol.fill;
            ctx.beginPath();
            ctx.arc(annotation.x, annotation.y, annotation.size / 2, 0, 2 * Math.PI);
            ctx.fill();
        }
        if (annotation.type === "rect") {
            ctx.strokeStyle = theme.annotations.outline.stroke;
            ctx.lineWidth = theme.annotations.outline.strokeWidth;
            ctx.beginPath();
            ctx.rect(annotation.x - annotation.width / 2, annotation.y - annotation.height / 2, annotation.width, annotation.height);
            ctx.stroke();
        }
        if (typeof annotation.note === "function") annotation.note(ctx, {
            datum: annotation.datum,
            x: annotation.computed.text[0],
            y: annotation.computed.text[1],
            theme: theme
        });
        else {
            ctx.font = "".concat(theme.annotations.text.fontSize, "px ").concat(theme.annotations.text.fontFamily);
            ctx.fillStyle = theme.annotations.text.fill;
            ctx.strokeStyle = theme.annotations.text.outlineColor;
            ctx.lineWidth = theme.annotations.text.outlineWidth * 2;
            if (theme.annotations.text.outlineWidth > 0) {
                ctx.lineJoin = "round";
                ctx.strokeText(annotation.note, annotation.computed.text[0], annotation.computed.text[1]);
                ctx.lineJoin = "miter";
            }
            ctx.fillText(annotation.note, annotation.computed.text[0], annotation.computed.text[1]);
        }
    });
    ctx.restore();
};

},{"react":"6AiW6","prop-types":"kKQPU","react-motion":"lqe7n","@nivo/core":"guBSY","lodash/isPlainObject":"9qlpu","lodash/filter":"h5ETC","lodash/omit":"5vMvR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"5vMvR":[function(require,module,exports) {
var arrayMap = require("edf8d2f2f36e65cf"), baseClone = require("dd27ddc2340179e5"), baseUnset = require("589767d435c41297"), castPath = require("565c158f6d380e60"), copyObject = require("9b4f3122fc9cc1a6"), customOmitClone = require("1c19467b6c51de37"), flatRest = require("24ab2b6e4b71312a"), getAllKeysIn = require("e20a1a7cbb58999e");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"edf8d2f2f36e65cf":"3A7ak","dd27ddc2340179e5":"1C68a","589767d435c41297":"bXvMX","565c158f6d380e60":"3DEN3","9b4f3122fc9cc1a6":"32Wbe","1c19467b6c51de37":"dTmUK","24ab2b6e4b71312a":"lXQzd","e20a1a7cbb58999e":"30bET"}],"1C68a":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"8Y9d2","3a79976eb46af94a":"a4f8p","bc83a05a4f99d69b":"5AyTU","e6b4c3e6c85df6bb":"eF8bu","f340cc553ba5643c":"4t5YM","e72e99883a50402d":"947dd","dc840ead07f1054":"btK5B","309288e8ee190af0":"inwit","687fa30fede0b048":"bPOoZ","bb0ba724f98b094d":"Gpj2Q","12bae1dca0e83064":"30bET","4c3204eaea28d680":"klLMw","fd7741200b462cdf":"4NkcB","f93a1d24ac08e076":"hmNtQ","630039e80f692f17":"3soAI","f37949484ab52dae":"9om8C","ac876cc65d29c86e":"1Qhoh","1056c031d98783c0":"748W3","1800fb3122907fc2":"kDBLt","31f022f648037bd3":"ir03e","5f3267fbd9848a7d":"3Kdfe","7d3f3bdc4f2e7bb8":"bKXkD"}],"eF8bu":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"32Wbe","fcf23a0242ef0da9":"3Kdfe"}],"4t5YM":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"32Wbe","7697a1565646c93":"bKXkD"}],"inwit":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"32Wbe","39cbde2205d9399c":"7QL3i"}],"bPOoZ":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"32Wbe","9b660e6b0c20d303":"hmzjl"}],"hmzjl":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"3WqQu","6ccae2aa7cfa3c66":"lYbAK","bdb501682ee9305d":"7QL3i","7641fe4ae6d2cc96":"33JRx"}],"30bET":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"1aTHW","feede5d0a2d06427":"hmzjl","287f70f798405911":"bKXkD"}],"4NkcB":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"hmNtQ":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"axvVD","dbf04edaab2ae376":"dGOk5","763300f2dd9bdaf3":"44rsp","c30e64d90e4b92d1":"cEJeh","d1edd8349e9ad54d":"b22Jd"}],"dGOk5":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"axvVD"}],"44rsp":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"cEJeh":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"25xE8"}],"748W3":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"bgtaf","6a7e6b1a2d9fb1d5":"1QTqI","7d4f449dd306450f":"iT2TL"}],"bgtaf":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"klLMw","88260e33e0003386":"h29TI"}],"ir03e":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"68Eo7","3cb35dba719c68b1":"1QTqI","7a3e899a332ff7be":"iT2TL"}],"68Eo7":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"klLMw","b6fc875bc5f351c9":"h29TI"}],"bXvMX":[function(require,module,exports) {
var castPath = require("f9ed36b4ad99fc49"), last = require("bbfbe3a50d8efe39"), parent = require("b7b0084465c39aec"), toKey = require("7b9792fcc4179101");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"f9ed36b4ad99fc49":"3DEN3","bbfbe3a50d8efe39":"4OGfA","b7b0084465c39aec":"9Hbax","7b9792fcc4179101":"2ib7q"}],"dTmUK":[function(require,module,exports) {
var isPlainObject = require("e34ef634df1bf68a");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"e34ef634df1bf68a":"9qlpu"}],"leLSB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addColorsToBarGraphData", ()=>addColorsToBarGraphData);
parcelHelpers.export(exports, "addPhaseColorsToPieData", ()=>addPhaseColorsToPieData);
parcelHelpers.export(exports, "addCategoryColorsToPieData", ()=>addCategoryColorsToPieData);
var _d3ScaleChromatic = require("d3-scale-chromatic");
// using to convert all color data in settings to hexadecmial format
function rgbToHex(rgb) {
    const [r, g, b] = rgb.match(/\d+/g).map(Number);
    // Calculate hex values
    const redHex = r * 65536;
    const greenHex = g * 256;
    const blueHex = b;
    const hex = redHex + greenHex + blueHex;
    // Convert to hexadecimal and format
    return `#${(hex + 0x1000000).toString(16).slice(1).toUpperCase()}`;
}
function getNivoColors(num, scheme) {
    const colors = [];
    for(let i = 0; i <= num; i += 1){
        const color = scheme(i / num);
        colors.push(rgbToHex(color));
    }
    return colors;
}
// Get 9 colors in the blue-purple or yellow-orange-brown scheme
const bluePurpleColors = getNivoColors(8, (0, _d3ScaleChromatic.interpolateBuPu));
const yellowOrangeBrown = getNivoColors(8, (0, _d3ScaleChromatic.interpolateYlOrBr));
function addColorsToBarGraphData(data, statuses) {
    const colorMap = {};
    statuses.forEach((status, index)=>{
        colorMap[status.name] = status.graphColor || bluePurpleColors[index % bluePurpleColors.length];
    });
    return data.map((item)=>{
        const colors = {};
        Object.keys(item).forEach((key)=>{
            if (colorMap[key]) colors[key] = colorMap[key];
        });
        return {
            ...item,
            colors
        };
    });
}
function addPhaseColorsToPieData(data, statuses) {
    const colorMap = {};
    statuses.forEach((status, index)=>{
        colorMap[status.name] = status.graphColor || bluePurpleColors[index % bluePurpleColors.length];
    });
    return data.map((item, index)=>{
        const graphColor = colorMap[item.id] || bluePurpleColors[index % bluePurpleColors.length];
        return {
            ...item,
            graphColor
        };
    });
}
function addCategoryColorsToPieData(data, categories) {
    const colorMap = {};
    categories.forEach((category, index)=>{
        colorMap[category.name] = category.graphColor || yellowOrangeBrown[index % yellowOrangeBrown.length];
    });
    return data.map((item, index)=>{
        const graphColor = colorMap[item.id] || yellowOrangeBrown[index % yellowOrangeBrown.length];
        return {
            ...item,
            graphColor
        };
    });
}

},{"d3-scale-chromatic":"iCcT5","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"iCcT5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemeObservable10", ()=>(0, _observable10JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _observable10Js = require("./categorical/observable10.js");
var _observable10JsDefault = parcelHelpers.interopDefault(_observable10Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":false,"./categorical/Accent.js":false,"./categorical/Dark2.js":false,"./categorical/observable10.js":false,"./categorical/Paired.js":false,"./categorical/Pastel1.js":false,"./categorical/Pastel2.js":false,"./categorical/Set1.js":false,"./categorical/Set2.js":false,"./categorical/Set3.js":false,"./categorical/Tableau10.js":false,"./diverging/BrBG.js":false,"./diverging/PRGn.js":false,"./diverging/PiYG.js":false,"./diverging/PuOr.js":false,"./diverging/RdBu.js":false,"./diverging/RdGy.js":false,"./diverging/RdYlBu.js":false,"./diverging/RdYlGn.js":false,"./diverging/Spectral.js":false,"./sequential-multi/BuGn.js":false,"./sequential-multi/BuPu.js":"2TRXC","./sequential-multi/GnBu.js":false,"./sequential-multi/OrRd.js":false,"./sequential-multi/PuBuGn.js":false,"./sequential-multi/PuBu.js":false,"./sequential-multi/PuRd.js":false,"./sequential-multi/RdPu.js":false,"./sequential-multi/YlGnBu.js":false,"./sequential-multi/YlGn.js":false,"./sequential-multi/YlOrBr.js":"cQUHV","./sequential-multi/YlOrRd.js":false,"./sequential-single/Blues.js":false,"./sequential-single/Greens.js":false,"./sequential-single/Greys.js":false,"./sequential-single/Purples.js":false,"./sequential-single/Reds.js":false,"./sequential-single/Oranges.js":false,"./sequential-multi/cividis.js":false,"./sequential-multi/cubehelix.js":false,"./sequential-multi/rainbow.js":false,"./sequential-multi/sinebow.js":false,"./sequential-multi/turbo.js":false,"./sequential-multi/viridis.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"2TRXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"173uv","../ramp.js":"3FXmR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"173uv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"3FXmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Interpolate = require("d3-interpolate");
exports.default = (scheme)=>(0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);

},{"d3-interpolate":"gydkL","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"cQUHV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"173uv","../ramp.js":"3FXmR","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"b8p9A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _bar = require("@nivo/bar");
var _customGraphColors = require("./custom-graph-colors");
const StackedBarByAudit = ({ byAuditAndStatus, statusKeys, handleChartClick, recommendationStatuses, graphTextColor })=>{
    const newData = (0, _customGraphColors.addColorsToBarGraphData)(byAuditAndStatus, recommendationStatuses);
    const defaultColorScheme = {
        scheme: "blue_purple"
    };
    const hasCustomColors = newData.some((data)=>data.colors && Object.keys(data.colors).length > 0);
    const colorSetting = hasCustomColors ? ({ id, data })=>data.colors[id] : defaultColorScheme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bar.ResponsiveBar), {
        data: newData,
        labelTextColor: graphTextColor || "black",
        keys: statusKeys,
        layout: "horizontal",
        indexBy: "auditName",
        margin: {
            top: 10,
            right: 170,
            bottom: 50,
            left: 300
        },
        padding: 0.2,
        colors: colorSetting,
        borderColor: {
            theme: "background"
        },
        legends: [
            {
                dataFrom: "keys",
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: "hover",
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ],
        animate: true,
        motionStiffness: 90,
        motionDamping: 15,
        axisRight: null,
        axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "# Recommendations",
            legendPosition: "middle",
            legendOffset: 40
        },
        enableGridY: false,
        defs: [
            {
                id: "lines-pattern",
                type: "patternLines",
                spacing: 10,
                rotation: -110,
                lineWidth: 1,
                background: "inherit",
                color: "#ccc"
            },
            {
                id: "dots-pattern",
                type: "patternDots",
                size: 2,
                padding: 4,
                stagger: false,
                background: "inherit",
                color: "#ccc"
            }
        ],
        fill: [
            {
                match: {
                    id: "Not Started"
                },
                id: "lines-pattern"
            },
            {
                match: {
                    id: "Implemented"
                },
                id: "dots-pattern"
            }
        ],
        axisLeft: {
            renderTick: (d)=>{
                const { opacity, textAnchor, textBaseline, value = "", x, y } = d;
                const trimValue = value.length > 55 ? `${value.slice(0, 55)}...` : value;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
                    transform: `translate(${x},${y})`,
                    style: {
                        opacity
                    }
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: "0",
                    x2: "-5",
                    y1: "0",
                    y2: "0",
                    style: {
                        stroke: "rgb(119, 119, 119)",
                        strokeWidth: 1
                    }
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("text", {
                    alignmentBaseline: textBaseline,
                    textAnchor: textAnchor,
                    transform: "translate(-10, 0)",
                    style: {
                        fontFamily: "sans-serif",
                        fontSize: 11,
                        fill: "rgb(51, 51, 51)"
                    }
                }, trimValue));
            }
        },
        onClick: (e)=>handleChartClick(e, "status", "auditName")
    }));
};
StackedBarByAudit.propTypes = {
    byAuditAndStatus: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        auditName: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    recommendationStatuses: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({})).isRequired,
    statusKeys: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    handleChartClick: (0, _propTypesDefault.default).func.isRequired,
    graphTextColor: (0, _propTypesDefault.default).string
};
StackedBarByAudit.defaultProps = {
    graphTextColor: null
};
exports.default = StackedBarByAudit;

},{"react":"6AiW6","prop-types":"kKQPU","@nivo/bar":"cM2r9","./custom-graph-colors":"leLSB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"lqWmY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _bar = require("@nivo/bar");
var _customGraphColors = require("./custom-graph-colors");
const StackedBarByYear = ({ byYearAndStatus, statusKeys, handleChartClick, recommendationStatuses, graphTextColor })=>{
    const newData = (0, _customGraphColors.addColorsToBarGraphData)(byYearAndStatus, recommendationStatuses);
    const defaultColorScheme = {
        scheme: "blue_purple"
    };
    const hasCustomColors = newData.some((data)=>data.colors && Object.keys(data.colors).length > 0);
    const colorSetting = hasCustomColors ? ({ id, data })=>data.colors[id] : defaultColorScheme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bar.ResponsiveBar), {
        data: newData,
        labelTextColor: graphTextColor || "black",
        keys: statusKeys,
        layout: "vertical",
        indexBy: "year",
        margin: {
            top: 50,
            right: 170,
            bottom: 50,
            left: 60
        },
        padding: 0.2,
        colors: colorSetting,
        borderColor: {
            theme: "background"
        },
        legends: [
            {
                dataFrom: "keys",
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: "hover",
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ],
        animate: true,
        motionStiffness: 90,
        motionDamping: 15,
        axisTop: null,
        axisRight: null,
        axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "# Recommendations",
            legendPosition: "middle",
            legendOffset: -50
        },
        defs: [
            {
                id: "lines-pattern",
                type: "patternLines",
                spacing: 10,
                rotation: -140,
                lineWidth: 1,
                background: "inherit",
                color: "#ccc"
            },
            {
                id: "dots-pattern",
                type: "patternDots",
                size: 1,
                padding: 4,
                stagger: false,
                background: "inherit",
                color: "#ccc"
            }
        ],
        fill: [
            {
                match: {
                    id: "Not Started"
                },
                id: "lines-pattern"
            },
            {
                match: {
                    id: "Implemented"
                },
                id: "dots-pattern"
            }
        ],
        onClick: (e)=>handleChartClick(e, "status", "year")
    }));
};
StackedBarByYear.propTypes = {
    byYearAndStatus: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        year: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    recommendationStatuses: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({})).isRequired,
    handleChartClick: (0, _propTypesDefault.default).func.isRequired,
    statusKeys: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    graphTextColor: (0, _propTypesDefault.default).string
};
StackedBarByYear.defaultProps = {
    graphTextColor: null
};
exports.default = StackedBarByYear;

},{"react":"6AiW6","prop-types":"kKQPU","@nivo/bar":"cM2r9","./custom-graph-colors":"leLSB","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jRBX6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _semanticUiReact = require("semantic-ui-react");
var _recommendationRow = require("./recommendation-row");
var _recommendationRowDefault = parcelHelpers.interopDefault(_recommendationRow);
const RecommendationTable = ({ recommendations = [], loadingData, handleSort, sortColumn, sortDirection, activeFilterPrimary, activeFilterSecondary })=>{
    const haveRecommendations = recommendations.length > 0;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Container), {
        className: "recommendations-table"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table), {
        sortable: true,
        unstackable: true,
        celled: true,
        selectable: haveRecommendations,
        size: "small"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Header, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Row, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "auditName" ? sortDirection : null,
        onClick: ()=>{
            handleSort("auditName");
        }
    }, "Audit & Finding"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "recommendationText" ? sortDirection : null,
        onClick: ()=>{
            handleSort("recommendationText");
        }
    }, "Recommendation"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "update" ? sortDirection : null,
        onClick: ()=>{
            handleSort("update");
        }
    }, "Last Update"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "status" ? sortDirection : null,
        onClick: ()=>{
            handleSort("status");
        }
    }, "Status"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "issueDate" ? sortDirection : null,
        onClick: ()=>{
            handleSort("issueDate");
        }
    }, "Issue Date"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "department" ? sortDirection : null,
        onClick: ()=>{
            handleSort("department");
        }
    }, "Department"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).HeaderCell, {
        sorted: sortColumn === "category" ? sortDirection : null,
        onClick: ()=>{
            handleSort("category");
        }
    }, "Category"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Body, null, recommendations.map((recommendation)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _recommendationRowDefault.default), {
            key: recommendation.recommendationId,
            recommendation,
            activeFilterPrimary,
            activeFilterSecondary
        })), !haveRecommendations && !loadingData && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Row, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        colSpan: 6
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Message), {
        info: true,
        content: "No recommendations found!"
    }))))));
};
RecommendationTable.propTypes = {
    recommendations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        recommendationId: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    loadingData: (0, _propTypesDefault.default).bool.isRequired,
    handleSort: (0, _propTypesDefault.default).func.isRequired,
    sortColumn: (0, _propTypesDefault.default).string.isRequired,
    sortDirection: (0, _propTypesDefault.default).string.isRequired,
    activeFilterPrimary: (0, _propTypesDefault.default).string,
    activeFilterSecondary: (0, _propTypesDefault.default).string
};
RecommendationTable.defaultProps = {
    activeFilterPrimary: null,
    activeFilterSecondary: null
};
exports.default = RecommendationTable;

},{"react":"6AiW6","prop-types":"kKQPU","semantic-ui-react":"gydXr","./recommendation-row":"jrPBs","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"jrPBs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _semanticUiReact = require("semantic-ui-react");
const RecommendationRow = ({ recommendation, activeFilterPrimary, activeFilterSecondary })=>{
    const { recommendationId, recommendationText, category, auditName, department, status, update, issueDate, auditURL, findingText, auditType } = recommendation;
    let dateString = "";
    if (issueDate && issueDate.length > 1) {
        const dateTime = new Date(issueDate);
        const dateMonth = dateTime.getMonth() + 1;
        const dateYear = dateTime.getFullYear();
        dateString = `${dateMonth}/${dateYear}`;
    }
    const hasAuditURL = auditURL && auditURL.length > 1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Row, {
        key: recommendationId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "3",
        positive: activeFilterPrimary === "auditName" || activeFilterSecondary === "auditName"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Header), {
        as: "h5"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Header).Content, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, hasAuditURL && /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: auditURL,
        target: "_blank",
        rel: "noopener noreferrer"
    }, auditName), !hasAuditURL && auditName, auditType === "investigation" && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Label), {
        color: "violet",
        size: "mini"
    }, "Investigation"))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Header).Subheader, {
        style: {
            whiteSpace: "pre-line"
        }
    }, findingText)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "3",
        style: {
            maxWidth: "200px",
            overflow: "hidden",
            whiteSpace: "pre-line"
        }
    }, recommendationText), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "4",
        style: {
            maxWidth: "300px",
            overflow: "hidden",
            whiteSpace: "pre-line"
        }
    }, update), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "2",
        positive: activeFilterPrimary === "status" || activeFilterSecondary === "status"
    }, status), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "1",
        positive: activeFilterPrimary === "year" || activeFilterSecondary === "year"
    }, dateString), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "2",
        positive: activeFilterPrimary === "department" || activeFilterSecondary === "department"
    }, department), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _semanticUiReact.Table).Cell, {
        width: "2",
        positive: activeFilterPrimary === "category" || activeFilterSecondary === "category"
    }, category)));
};
RecommendationRow.propTypes = {
    recommendation: (0, _propTypesDefault.default).shape({
        recommendationId: (0, _propTypesDefault.default).string.isRequired,
        recommendationText: (0, _propTypesDefault.default).string.isRequired
    }).isRequired,
    activeFilterPrimary: (0, _propTypesDefault.default).string,
    activeFilterSecondary: (0, _propTypesDefault.default).string
};
RecommendationRow.defaultProps = {
    activeFilterPrimary: null,
    activeFilterSecondary: null
};
exports.default = RecommendationRow;

},{"react":"6AiW6","prop-types":"kKQPU","semantic-ui-react":"gydXr","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"gwrfj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _pie = require("@nivo/pie");
const PieGeneric = ({ data, handleChartClick, clickType, graphTextColor })=>{
    // @nivo/pie v 0.59.1 does not have a ResponsivePie parameter to change only the pie slice inner text color,
    // so I had to add a theme for all text that contained my custom color (graphTextColor) and then set the radialLabelsTextColor="black"
    const theme = {
        labels: {
            text: {
                fill: graphTextColor
            }
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pie.ResponsivePie), {
        data: data,
        radialLabelsTextColor: "black",
        theme: theme,
        margin: {
            top: 50,
            right: 30,
            bottom: 40,
            left: 30
        },
        innerRadius: 0.5,
        padAngle: 0.7,
        cornerRadius: 3,
        borderWidth: 1,
        colors: (d)=>d.graphColor,
        borderColor: {
            from: "color",
            modifiers: [
                [
                    "darker",
                    0.2
                ]
            ]
        },
        animate: true,
        motionStiffness: 90,
        motionDamping: 15,
        enableRadialLabels: true,
        defs: [
            {
                id: "lines-pattern",
                type: "patternLines",
                spacing: 10,
                rotation: -110,
                lineWidth: 1,
                background: "inherit",
                color: "#ccc"
            },
            {
                id: "dots-pattern",
                type: "patternDots",
                size: 1,
                padding: 4,
                stagger: false,
                background: "inherit",
                color: "#ccc"
            }
        ],
        fill: [
            {
                match: {
                    id: "Not Started"
                },
                id: "dots-pattern"
            }
        ],
        onClick: (e)=>handleChartClick(e, clickType)
    }));
};
PieGeneric.propTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    handleChartClick: (0, _propTypesDefault.default).func.isRequired,
    clickType: (0, _propTypesDefault.default).string,
    graphTextColor: (0, _propTypesDefault.default).string
};
PieGeneric.defaultProps = {
    clickType: "",
    graphTextColor: null
};
exports.default = PieGeneric;

},{"react":"6AiW6","prop-types":"kKQPU","@nivo/pie":"UfmUJ","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"UfmUJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pie", ()=>Pie$1);
parcelHelpers.export(exports, "PieCanvas", ()=>PieCanvas$1);
parcelHelpers.export(exports, "PieDefaultProps", ()=>PieDefaultProps);
parcelHelpers.export(exports, "PieLayout", ()=>PieLayout$1);
parcelHelpers.export(exports, "PiePropTypes", ()=>PiePropTypes);
parcelHelpers.export(exports, "ResponsivePie", ()=>ResponsivePie);
parcelHelpers.export(exports, "ResponsivePieCanvas", ()=>ResponsivePieCanvas);
parcelHelpers.export(exports, "arcPropType", ()=>arcPropType);
parcelHelpers.export(exports, "usePie", ()=>usePie);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _d3Shape = require("d3-shape");
var _setDisplayName = require("recompose/setDisplayName");
var _setDisplayNameDefault = parcelHelpers.interopDefault(_setDisplayName);
var _compose = require("recompose/compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _pure = require("recompose/pure");
var _pureDefault = parcelHelpers.interopDefault(_pure);
var _defaultProps = require("recompose/defaultProps");
var _defaultPropsDefault = parcelHelpers.interopDefault(_defaultProps);
var _withPropsOnChange = require("recompose/withPropsOnChange");
var _withPropsOnChangeDefault = parcelHelpers.interopDefault(_withPropsOnChange);
var _core = require("@nivo/core");
var _colors = require("@nivo/colors");
var _legends = require("@nivo/legends");
var _tooltip = require("@nivo/tooltip");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PieLayout = function(_Component) {
    _inherits(PieLayout, _Component);
    function PieLayout() {
        _classCallCheck(this, PieLayout);
        return _possibleConstructorReturn(this, _getPrototypeOf(PieLayout).apply(this, arguments));
    }
    _createClass(PieLayout, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, arcs = _this$props.arcs, arcGenerator = _this$props.arcGenerator, startAngle = _this$props.startAngle, endAngle = _this$props.endAngle, width = _this$props.width, height = _this$props.height, centerX = _this$props.centerX, centerY = _this$props.centerY, radius = _this$props.radius, innerRadius = _this$props.innerRadius, debug = _this$props.debug, render = _this$props.children;
                return render({
                    arcs: arcs,
                    arcGenerator: arcGenerator,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    width: width,
                    height: height,
                    centerX: centerX,
                    centerY: centerY,
                    radius: radius,
                    innerRadius: innerRadius,
                    debug: debug
                });
            }
        }
    ]);
    return PieLayout;
}((0, _react.Component));
_defineProperty(PieLayout, "propTypes", {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        value: (0, _propTypesDefault.default).number.isRequired
    })).isRequired,
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    fit: (0, _propTypesDefault.default).bool.isRequired,
    sortByValue: (0, _propTypesDefault.default).bool.isRequired,
    startAngle: (0, _propTypesDefault.default).number.isRequired,
    endAngle: (0, _propTypesDefault.default).number.isRequired,
    padAngle: (0, _propTypesDefault.default).number.isRequired,
    arcs: (0, _propTypesDefault.default).array.isRequired,
    arcGenerator: (0, _propTypesDefault.default).func.isRequired,
    centerX: (0, _propTypesDefault.default).number.isRequired,
    centerY: (0, _propTypesDefault.default).number.isRequired,
    radius: (0, _propTypesDefault.default).number.isRequired,
    innerRadius: (0, _propTypesDefault.default).number.isRequired,
    cornerRadius: (0, _propTypesDefault.default).number.isRequired,
    debug: (0, _propTypesDefault.default).shape({
        points: (0, _propTypesDefault.default).array.isRequired,
        box: (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).number.isRequired,
            y: (0, _propTypesDefault.default).number.isRequired,
            width: (0, _propTypesDefault.default).number.isRequired,
            height: (0, _propTypesDefault.default).number.isRequired
        }).isRequired,
        ratio: (0, _propTypesDefault.default).number.isRequired
    }),
    children: (0, _propTypesDefault.default).func.isRequired
});
var PieLayoutDefaultProps = {
    fit: true,
    sortByValue: false,
    innerRadius: 0,
    startAngle: 0,
    endAngle: 360,
    padAngle: 0,
    cornerRadius: 0
};
var enhance = function enhance(Component) {
    return (0, _composeDefault.default)((0, _defaultPropsDefault.default)(PieLayoutDefaultProps), (0, _withPropsOnChangeDefault.default)([
        "colors"
    ], function(_ref) {
        var colors = _ref.colors;
        return {
            getColor: (0, _colors.getOrdinalColorScale)(colors, "id")
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "width",
        "height",
        "innerRadius",
        "startAngle",
        "endAngle",
        "fit",
        "cornerRadius"
    ], function(_ref2) {
        var width = _ref2.width, height = _ref2.height, _innerRadius = _ref2.innerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle, fit = _ref2.fit, cornerRadius = _ref2.cornerRadius;
        var radius = Math.min(width, height) / 2;
        var innerRadius = radius * Math.min(_innerRadius, 1);
        var centerX = width / 2;
        var centerY = height / 2;
        var boundingBox;
        if (fit === true) {
            var _computeArcBoundingBo = (0, _core.computeArcBoundingBox)(centerX, centerY, radius, startAngle - 90, endAngle - 90), points = _computeArcBoundingBo.points, box = _objectWithoutProperties(_computeArcBoundingBo, [
                "points"
            ]);
            var ratio = Math.min(width / box.width, height / box.height);
            var adjustedBox = {
                width: box.width * ratio,
                height: box.height * ratio
            };
            adjustedBox.x = (width - adjustedBox.width) / 2;
            adjustedBox.y = (height - adjustedBox.height) / 2;
            centerX = (centerX - box.x) / box.width * box.width * ratio + adjustedBox.x;
            centerY = (centerY - box.y) / box.height * box.height * ratio + adjustedBox.y;
            boundingBox = {
                box: box,
                ratio: ratio,
                points: points
            };
            radius = radius * ratio;
            innerRadius = innerRadius * ratio;
        }
        var arcGenerator = (0, _d3Shape.arc)().outerRadius(radius).innerRadius(innerRadius).cornerRadius(cornerRadius);
        return {
            centerX: centerX,
            centerY: centerY,
            radius: radius,
            innerRadius: innerRadius,
            arcGenerator: arcGenerator,
            debug: boundingBox
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "sortByValue",
        "padAngle",
        "startAngle",
        "endAngle"
    ], function(_ref3) {
        var sortByValue = _ref3.sortByValue, padAngle = _ref3.padAngle, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
        var pie$1 = (0, _d3Shape.pie)().value(function(d) {
            return d.value;
        }).padAngle((0, _core.degreesToRadians)(padAngle)).startAngle((0, _core.degreesToRadians)(startAngle)).endAngle((0, _core.degreesToRadians)(endAngle));
        if (sortByValue !== true) pie$1.sortValues(null);
        return {
            pie: pie$1
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "pie",
        "data"
    ], function(_ref4) {
        var pie = _ref4.pie, data = _ref4.data;
        return {
            arcs: pie(data).map(function(arc) {
                var angle = Math.abs(arc.endAngle - arc.startAngle);
                return _objectSpread({}, arc, {
                    angle: angle,
                    angleDeg: (0, _core.radiansToDegrees)(angle)
                });
            })
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "arcs",
        "getColor"
    ], function(_ref5) {
        var arcs = _ref5.arcs, getColor = _ref5.getColor;
        return {
            arcs: arcs.map(function(arc) {
                return _objectSpread({}, arc, {
                    color: getColor(arc.data)
                });
            })
        };
    }), (0, _pureDefault.default))(Component);
};
var PieLayout$1 = (0, _setDisplayNameDefault.default)("PieLayout")(enhance(PieLayout));
var arcPropType = (0, _propTypesDefault.default).shape({
    startAngle: (0, _propTypesDefault.default).number.isRequired,
    endAngle: (0, _propTypesDefault.default).number.isRequired,
    angle: (0, _propTypesDefault.default).number.isRequired,
    angleDeg: (0, _propTypesDefault.default).number.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    data: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).number
        ]).isRequired,
        value: (0, _propTypesDefault.default).number.isRequired
    }).isRequired
});
var PiePropTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).number
        ]),
        value: (0, _propTypesDefault.default).number.isRequired
    })).isRequired,
    startAngle: (0, _propTypesDefault.default).number.isRequired,
    endAngle: (0, _propTypesDefault.default).number.isRequired,
    fit: (0, _propTypesDefault.default).bool.isRequired,
    padAngle: (0, _propTypesDefault.default).number.isRequired,
    sortByValue: (0, _propTypesDefault.default).bool.isRequired,
    innerRadius: (0, _propTypesDefault.default).number.isRequired,
    cornerRadius: (0, _propTypesDefault.default).number.isRequired,
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _colors.inheritedColorPropType).isRequired,
    enableRadialLabels: (0, _propTypesDefault.default).bool.isRequired,
    radialLabel: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    radialLabelsSkipAngle: (0, _propTypesDefault.default).number,
    radialLabelsTextXOffset: (0, _propTypesDefault.default).number,
    radialLabelsTextColor: (0, _colors.inheritedColorPropType).isRequired,
    radialLabelsLinkOffset: (0, _propTypesDefault.default).number,
    radialLabelsLinkDiagonalLength: (0, _propTypesDefault.default).number,
    radialLabelsLinkHorizontalLength: (0, _propTypesDefault.default).number,
    radialLabelsLinkStrokeWidth: (0, _propTypesDefault.default).number,
    radialLabelsLinkColor: (0, _colors.inheritedColorPropType).isRequired,
    enableSlicesLabels: (0, _propTypesDefault.default).bool.isRequired,
    sliceLabel: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    slicesLabelsSkipAngle: (0, _propTypesDefault.default).number,
    slicesLabelsTextColor: (0, _colors.inheritedColorPropType).isRequired,
    colors: (0, _colors.ordinalColorsPropType).isRequired,
    defs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    fill: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string,
        match: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                "*"
            ]),
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).func
        ]).isRequired
    })).isRequired,
    isInteractive: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func.isRequired,
    onMouseEnter: (0, _propTypesDefault.default).func.isRequired,
    onMouseLeave: (0, _propTypesDefault.default).func.isRequired,
    lockTooltip: (0, _propTypesDefault.default).bool.isRequired,
    tooltipFormat: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    tooltip: (0, _propTypesDefault.default).func,
    legends: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape((0, _legends.LegendPropShape))).isRequired
};
var PieDefaultProps = {
    sortByValue: false,
    innerRadius: 0,
    padAngle: 0,
    cornerRadius: 0,
    startAngle: 0,
    endAngle: (0, _core.radiansToDegrees)(Math.PI * 2),
    fit: true,
    borderWidth: 0,
    borderColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                1
            ]
        ]
    },
    enableRadialLabels: true,
    radialLabel: "id",
    radialLabelsTextColor: {
        theme: "labels.text.fill"
    },
    radialLabelsLinkColor: {
        theme: "axis.ticks.line.stroke"
    },
    enableSlicesLabels: true,
    sliceLabel: "value",
    slicesLabelsTextColor: {
        theme: "labels.text.fill"
    },
    colors: {
        scheme: "nivo"
    },
    defs: [],
    fill: [],
    isInteractive: true,
    onClick: (0, _core.noop),
    onMouseEnter: (0, _core.noop),
    onMouseLeave: (0, _core.noop),
    lockTooltip: true,
    legends: []
};
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PieSlice = function PieSlice(_ref) {
    var data = _ref.data, path = _ref.path, color = _ref.color, fill = _ref.fill, borderWidth = _ref.borderWidth, borderColor = _ref.borderColor, showTooltip = _ref.showTooltip, hideTooltip = _ref.hideTooltip, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, tooltipFormat = _ref.tooltipFormat, tooltip = _ref.tooltip, theme = _ref.theme;
    var handleTooltip = function handleTooltip(e) {
        return showTooltip((0, _reactDefault.default).createElement((0, _tooltip.BasicTooltip), {
            id: data.label,
            value: data.value,
            enableChip: true,
            color: color,
            theme: theme,
            format: tooltipFormat,
            renderContent: typeof tooltip === "function" ? tooltip.bind(null, _objectSpread$1({
                color: color
            }, data)) : null
        }), e);
    };
    var handleMouseEnter = function handleMouseEnter(e) {
        onMouseEnter(data, e);
        handleTooltip(e);
    };
    var handleMouseLeave = function handleMouseLeave(e) {
        onMouseLeave(data, e);
        hideTooltip(e);
    };
    return (0, _reactDefault.default).createElement("path", {
        key: data.id,
        d: path,
        fill: fill,
        strokeWidth: borderWidth,
        stroke: borderColor,
        onMouseEnter: handleMouseEnter,
        onMouseMove: handleTooltip,
        onMouseLeave: handleMouseLeave,
        onClick: onClick
    });
};
PieSlice.propTypes = {
    data: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).number
        ]).isRequired,
        value: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    path: (0, _propTypesDefault.default).string.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    fill: (0, _propTypesDefault.default).string.isRequired,
    borderWidth: (0, _propTypesDefault.default).number.isRequired,
    borderColor: (0, _propTypesDefault.default).string.isRequired,
    tooltipFormat: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    tooltip: (0, _propTypesDefault.default).func,
    showTooltip: (0, _propTypesDefault.default).func.isRequired,
    hideTooltip: (0, _propTypesDefault.default).func.isRequired,
    onClick: (0, _propTypesDefault.default).func,
    onMouseEnter: (0, _propTypesDefault.default).func,
    onMouseLeave: (0, _propTypesDefault.default).func,
    theme: (0, _propTypesDefault.default).shape({
        tooltip: (0, _propTypesDefault.default).shape({}).isRequired
    }).isRequired
};
var enhance$1 = (0, _composeDefault.default)((0, _withPropsOnChangeDefault.default)([
    "data",
    "onClick"
], function(_ref2) {
    var data = _ref2.data, _onClick = _ref2.onClick;
    return {
        onClick: function onClick(event) {
            return _onClick(data, event);
        }
    };
}), (0, _pureDefault.default));
var PieSlice$1 = enhance$1(PieSlice);
var computeRadialLabels = function computeRadialLabels(arcs, _ref) {
    var getLabel = _ref.getLabel, radius = _ref.radius, skipAngle = _ref.skipAngle, linkOffset = _ref.linkOffset, linkDiagonalLength = _ref.linkDiagonalLength, linkHorizontalLength = _ref.linkHorizontalLength, textXOffset = _ref.textXOffset;
    return arcs.filter(function(arc) {
        return skipAngle === 0 || arc.angleDeg > skipAngle;
    }).map(function(arc) {
        var angle = (0, _core.absoluteAngleRadians)((0, _core.midAngle)(arc) - Math.PI / 2);
        var positionA = (0, _core.positionFromAngle)(angle, radius + linkOffset);
        var positionB = (0, _core.positionFromAngle)(angle, radius + linkOffset + linkDiagonalLength);
        var positionC;
        var labelPosition;
        var textAlign;
        if ((0, _core.absoluteAngleDegrees)((0, _core.radiansToDegrees)(angle)) < 90 || (0, _core.absoluteAngleDegrees)((0, _core.radiansToDegrees)(angle)) >= 270) {
            positionC = {
                x: positionB.x + linkHorizontalLength,
                y: positionB.y
            };
            labelPosition = {
                x: positionB.x + linkHorizontalLength + textXOffset,
                y: positionB.y
            };
            textAlign = "left";
        } else {
            positionC = {
                x: positionB.x - linkHorizontalLength,
                y: positionB.y
            };
            labelPosition = {
                x: positionB.x - linkHorizontalLength - textXOffset,
                y: positionB.y
            };
            textAlign = "right";
        }
        return {
            arc: arc,
            text: getLabel(arc.data),
            position: labelPosition,
            align: textAlign,
            line: [
                positionA,
                positionB,
                positionC
            ]
        };
    });
};
function _typeof$1(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$1 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$1(obj);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$1(self);
}
function _assertThisInitialized$1(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var lineGenerator = (0, _d3Shape.line)().x(function(d) {
    return d.x;
}).y(function(d) {
    return d.y;
});
var PieRadialLabels = function(_Component) {
    _inherits$1(PieRadialLabels, _Component);
    function PieRadialLabels() {
        _classCallCheck$1(this, PieRadialLabels);
        return _possibleConstructorReturn$1(this, _getPrototypeOf$1(PieRadialLabels).apply(this, arguments));
    }
    _createClass$1(PieRadialLabels, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, arcs = _this$props.arcs, label = _this$props.label, radius = _this$props.radius, skipAngle = _this$props.skipAngle, linkOffset = _this$props.linkOffset, linkDiagonalLength = _this$props.linkDiagonalLength, linkHorizontalLength = _this$props.linkHorizontalLength, linkStrokeWidth = _this$props.linkStrokeWidth, textXOffset = _this$props.textXOffset, textColor = _this$props.textColor, linkColor = _this$props.linkColor, theme = _this$props.theme;
                var labels = computeRadialLabels(arcs, {
                    getLabel: label,
                    radius: radius,
                    skipAngle: skipAngle,
                    linkOffset: linkOffset,
                    linkDiagonalLength: linkDiagonalLength,
                    linkHorizontalLength: linkHorizontalLength,
                    textXOffset: textXOffset
                });
                return labels.map(function(label) {
                    return (0, _reactDefault.default).createElement((0, _react.Fragment), {
                        key: label.arc.data.id
                    }, (0, _reactDefault.default).createElement("path", {
                        d: lineGenerator(label.line),
                        fill: "none",
                        style: {
                            fill: "none",
                            stroke: linkColor(label.arc, theme)
                        },
                        strokeWidth: linkStrokeWidth
                    }), (0, _reactDefault.default).createElement("g", {
                        transform: "translate(".concat(label.position.x, ", ").concat(label.position.y, ")")
                    }, (0, _reactDefault.default).createElement("text", {
                        textAnchor: (0, _core.textPropsByEngine).svg.align[label.align],
                        dominantBaseline: "central",
                        style: _objectSpread$2({}, theme.labels.text, {
                            fill: textColor(label.arc.data, theme)
                        })
                    }, label.text)));
                });
            }
        }
    ]);
    return PieRadialLabels;
}((0, _react.Component));
_defineProperty$2(PieRadialLabels, "propTypes", {
    arcs: (0, _propTypesDefault.default).arrayOf(arcPropType).isRequired,
    label: (0, _propTypesDefault.default).func.isRequired,
    skipAngle: (0, _propTypesDefault.default).number.isRequired,
    radius: (0, _propTypesDefault.default).number.isRequired,
    linkOffset: (0, _propTypesDefault.default).number.isRequired,
    linkDiagonalLength: (0, _propTypesDefault.default).number.isRequired,
    linkHorizontalLength: (0, _propTypesDefault.default).number.isRequired,
    linkStrokeWidth: (0, _propTypesDefault.default).number.isRequired,
    textXOffset: (0, _propTypesDefault.default).number.isRequired,
    textColor: (0, _propTypesDefault.default).func.isRequired,
    linkColor: (0, _propTypesDefault.default).func.isRequired,
    theme: (0, _propTypesDefault.default).shape({
        axis: (0, _core.axisThemePropType).isRequired,
        labels: (0, _core.labelsThemePropType).isRequired
    }).isRequired
});
_defineProperty$2(PieRadialLabels, "defaultProps", {
    skipAngle: 0,
    linkOffset: 0,
    linkDiagonalLength: 16,
    linkHorizontalLength: 24,
    linkStrokeWidth: 1,
    textXOffset: 6
});
function _typeof$2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$2 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$2(obj);
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$2(self);
}
function _assertThisInitialized$2(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var sliceStyle = {
    pointerEvents: "none"
};
var PieSlicesLabels = function(_Component) {
    _inherits$2(PieSlicesLabels, _Component);
    function PieSlicesLabels() {
        _classCallCheck$2(this, PieSlicesLabels);
        return _possibleConstructorReturn$2(this, _getPrototypeOf$2(PieSlicesLabels).apply(this, arguments));
    }
    _createClass$2(PieSlicesLabels, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, arcs = _this$props.arcs, label = _this$props.label, radius = _this$props.radius, skipAngle = _this$props.skipAngle, innerRadius = _this$props.innerRadius, textColor = _this$props.textColor, theme = _this$props.theme;
                var centerRadius = innerRadius + (radius - innerRadius) / 2;
                return (0, _reactDefault.default).createElement((0, _react.Fragment), null, arcs.filter(function(arc) {
                    return skipAngle === 0 || arc.angleDeg > skipAngle;
                }).map(function(arc) {
                    var angle = (0, _core.midAngle)(arc) - Math.PI / 2;
                    var position = (0, _core.positionFromAngle)(angle, centerRadius);
                    return (0, _reactDefault.default).createElement("g", {
                        key: arc.data.id,
                        transform: "translate(".concat(position.x, ", ").concat(position.y, ")"),
                        style: sliceStyle
                    }, (0, _reactDefault.default).createElement("text", {
                        textAnchor: "middle",
                        dominantBaseline: "central",
                        style: _objectSpread$3({}, theme.labels.text, {
                            fill: textColor(arc.data, theme)
                        })
                    }, label(arc.data)));
                }));
            }
        }
    ]);
    return PieSlicesLabels;
}((0, _react.Component));
_defineProperty$3(PieSlicesLabels, "propTypes", {
    arcs: (0, _propTypesDefault.default).arrayOf(arcPropType).isRequired,
    label: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    skipAngle: (0, _propTypesDefault.default).number.isRequired,
    radius: (0, _propTypesDefault.default).number.isRequired,
    innerRadius: (0, _propTypesDefault.default).number.isRequired,
    textColor: (0, _propTypesDefault.default).func.isRequired,
    theme: (0, _propTypesDefault.default).shape({
        labels: (0, _core.labelsThemePropType).isRequired
    }).isRequired
});
_defineProperty$3(PieSlicesLabels, "defaultProps", {
    skipAngle: 0
});
function _typeof$3(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$3 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$3(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$3(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$3(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$3(self);
}
function _assertThisInitialized$3(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PieLegends = function(_Component) {
    _inherits$3(PieLegends, _Component);
    function PieLegends() {
        _classCallCheck$3(this, PieLegends);
        return _possibleConstructorReturn$3(this, _getPrototypeOf$3(PieLegends).apply(this, arguments));
    }
    _createClass$3(PieLegends, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, width = _this$props.width, height = _this$props.height, legends = _this$props.legends, data = _this$props.data, theme = _this$props.theme;
                return legends.map(function(legend, i) {
                    return (0, _reactDefault.default).createElement((0, _legends.BoxLegendSvg), _extends({
                        key: i
                    }, legend, {
                        containerWidth: width,
                        containerHeight: height,
                        data: data,
                        theme: theme
                    }));
                });
            }
        }
    ]);
    return PieLegends;
}((0, _react.Component));
_defineProperty$4(PieLegends, "propTypes", {
    width: (0, _propTypesDefault.default).number.isRequired,
    height: (0, _propTypesDefault.default).number.isRequired,
    arcs: (0, _propTypesDefault.default).arrayOf(arcPropType).isRequired,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object).isRequired,
    legends: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape((0, _legends.LegendPropShape))).isRequired,
    theme: (0, _core.themePropType).isRequired
});
var enhance$2 = function enhance(Component) {
    return (0, _composeDefault.default)((0, _withPropsOnChangeDefault.default)([
        "arcs"
    ], function(_ref) {
        var arcs = _ref.arcs;
        return {
            data: arcs.map(function(arc) {
                return {
                    id: arc.data.id,
                    label: arc.data.id,
                    color: arc.color,
                    fill: arc.fill
                };
            })
        };
    }), (0, _pureDefault.default))(Component);
};
var PieLegends$1 = (0, _setDisplayNameDefault.default)("PieLegends")(enhance$2(PieLegends));
function _typeof$4(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$4 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$4(obj);
}
function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$4(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$4(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$4(self, call) {
    if (call && (_typeof$4(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$4(self);
}
function _assertThisInitialized$4(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$4(o) {
    _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$4(o);
}
function _inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$4(subClass, superClass);
}
function _setPrototypeOf$4(o, p) {
    _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$4(o, p);
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Pie = function(_Component) {
    _inherits$4(Pie, _Component);
    function Pie() {
        _classCallCheck$4(this, Pie);
        return _possibleConstructorReturn$4(this, _getPrototypeOf$4(Pie).apply(this, arguments));
    }
    _createClass$4(Pie, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, data = _this$props.data, sortByValue = _this$props.sortByValue, startAngle = _this$props.startAngle, endAngle = _this$props.endAngle, padAngle = _this$props.padAngle, fit = _this$props.fit, innerRadius = _this$props.innerRadius, cornerRadius = _this$props.cornerRadius, margin = _this$props.margin, width = _this$props.width, height = _this$props.height, outerWidth = _this$props.outerWidth, outerHeight = _this$props.outerHeight, colors = _this$props.colors, colorBy = _this$props.colorBy, borderWidth = _this$props.borderWidth, _borderColor = _this$props.borderColor, enableRadialLabels = _this$props.enableRadialLabels, getRadialLabel = _this$props.getRadialLabel, radialLabelsSkipAngle = _this$props.radialLabelsSkipAngle, radialLabelsLinkOffset = _this$props.radialLabelsLinkOffset, radialLabelsLinkDiagonalLength = _this$props.radialLabelsLinkDiagonalLength, radialLabelsLinkHorizontalLength = _this$props.radialLabelsLinkHorizontalLength, radialLabelsLinkStrokeWidth = _this$props.radialLabelsLinkStrokeWidth, radialLabelsTextXOffset = _this$props.radialLabelsTextXOffset, radialLabelsTextColor = _this$props.radialLabelsTextColor, radialLabelsLinkColor = _this$props.radialLabelsLinkColor, enableSlicesLabels = _this$props.enableSlicesLabels, getSliceLabel = _this$props.getSliceLabel, slicesLabelsSkipAngle = _this$props.slicesLabelsSkipAngle, slicesLabelsTextColor = _this$props.slicesLabelsTextColor, theme = _this$props.theme, defs = _this$props.defs, fill = _this$props.fill, isInteractive = _this$props.isInteractive, onClick = _this$props.onClick, onMouseEnter = _this$props.onMouseEnter, onMouseLeave = _this$props.onMouseLeave, tooltipFormat = _this$props.tooltipFormat, tooltip = _this$props.tooltip, legends = _this$props.legends;
                var borderColor = (0, _colors.getInheritedColorGenerator)(_borderColor, theme);
                return (0, _reactDefault.default).createElement(PieLayout$1, {
                    width: width,
                    height: height,
                    data: data,
                    sortByValue: sortByValue,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    fit: fit,
                    padAngle: padAngle,
                    innerRadius: innerRadius,
                    cornerRadius: cornerRadius,
                    colors: colors,
                    colorBy: colorBy
                }, function(_ref) {
                    var centerX = _ref.centerX, centerY = _ref.centerY, radius = _ref.radius, innerRadius = _ref.innerRadius, arcs = _ref.arcs, arcGenerator = _ref.arcGenerator;
                    var boundDefs = (0, _core.bindDefs)(defs, arcs, fill, {
                        dataKey: "data"
                    });
                    return (0, _reactDefault.default).createElement((0, _core.Container), {
                        isInteractive: isInteractive,
                        theme: theme,
                        animate: false
                    }, function(_ref2) {
                        var showTooltip = _ref2.showTooltip, hideTooltip = _ref2.hideTooltip;
                        return (0, _reactDefault.default).createElement((0, _core.SvgWrapper), {
                            width: outerWidth,
                            height: outerHeight,
                            margin: margin,
                            defs: boundDefs,
                            theme: theme
                        }, (0, _reactDefault.default).createElement("g", {
                            transform: "translate(".concat(centerX, ",").concat(centerY, ")")
                        }, arcs.map(function(arc) {
                            return (0, _reactDefault.default).createElement(PieSlice$1, {
                                key: arc.data.id,
                                data: arc.data,
                                path: arcGenerator(arc),
                                color: arc.color,
                                fill: arc.fill ? arc.fill : arc.color,
                                borderWidth: borderWidth,
                                borderColor: borderColor(arc),
                                showTooltip: showTooltip,
                                hideTooltip: hideTooltip,
                                tooltipFormat: tooltipFormat,
                                tooltip: tooltip,
                                onClick: onClick,
                                onMouseEnter: onMouseEnter,
                                onMouseLeave: onMouseLeave,
                                theme: theme
                            });
                        }), enableRadialLabels && (0, _reactDefault.default).createElement(PieRadialLabels, {
                            arcs: arcs,
                            radius: radius,
                            label: getRadialLabel,
                            skipAngle: radialLabelsSkipAngle,
                            linkOffset: radialLabelsLinkOffset,
                            linkDiagonalLength: radialLabelsLinkDiagonalLength,
                            linkHorizontalLength: radialLabelsLinkHorizontalLength,
                            linkStrokeWidth: radialLabelsLinkStrokeWidth,
                            textXOffset: radialLabelsTextXOffset,
                            textColor: (0, _colors.getInheritedColorGenerator)(radialLabelsTextColor, theme),
                            linkColor: (0, _colors.getInheritedColorGenerator)(radialLabelsLinkColor, theme),
                            theme: theme
                        }), enableSlicesLabels && (0, _reactDefault.default).createElement(PieSlicesLabels, {
                            arcs: arcs,
                            radius: radius,
                            innerRadius: innerRadius,
                            theme: theme,
                            label: getSliceLabel,
                            skipAngle: slicesLabelsSkipAngle,
                            textColor: (0, _colors.getInheritedColorGenerator)(slicesLabelsTextColor, theme)
                        })), (0, _reactDefault.default).createElement(PieLegends$1, {
                            width: width,
                            height: height,
                            arcs: arcs,
                            legends: legends,
                            theme: theme
                        }));
                    });
                });
            }
        }
    ]);
    return Pie;
}((0, _react.Component));
_defineProperty$5(Pie, "propTypes", PiePropTypes);
var enhance$3 = function enhance(Component) {
    return (0, _composeDefault.default)((0, _defaultPropsDefault.default)(PieDefaultProps), (0, _core.withTheme)(), (0, _core.withDimensions)(), (0, _withPropsOnChangeDefault.default)([
        "radialLabel"
    ], function(_ref3) {
        var radialLabel = _ref3.radialLabel;
        return {
            getRadialLabel: (0, _core.getLabelGenerator)(radialLabel)
        };
    }), (0, _withPropsOnChangeDefault.default)([
        "sliceLabel"
    ], function(_ref4) {
        var sliceLabel = _ref4.sliceLabel;
        return {
            getSliceLabel: (0, _core.getLabelGenerator)(sliceLabel)
        };
    }), (0, _pureDefault.default))(Component);
};
var Pie$1 = (0, _setDisplayNameDefault.default)("Pie")(enhance$3(Pie));
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
var ResponsivePie = function ResponsivePie(props) {
    return (0, _reactDefault.default).createElement((0, _core.ResponsiveWrapper), null, function(_ref) {
        var width = _ref.width, height = _ref.height;
        return (0, _reactDefault.default).createElement(Pie$1, _extends$1({
            width: width,
            height: height
        }, props));
    });
};
var enhance$4 = function(Component) {
    return (0, _composeDefault.default)((0, _defaultPropsDefault.default)(PieDefaultProps), (0, _core.withTheme)(), (0, _core.withDimensions)(), (0, _pureDefault.default))(Component);
};
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$6(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$6(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var drawSliceLabels = function drawSliceLabels(ctx, arcs, _ref) {
    var arcGenerator = _ref.arcGenerator, getLabel = _ref.getLabel, skipAngle = _ref.skipAngle, getTextColor = _ref.getTextColor, theme = _ref.theme;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "".concat(theme.labels.text.fontSize, "px ").concat(theme.labels.text.fontFamily);
    arcs.filter(function(arc) {
        return skipAngle === 0 || arc.angleDeg > skipAngle;
    }).forEach(function(arc) {
        var _arcGenerator$centroi = arcGenerator.centroid(arc), _arcGenerator$centroi2 = _slicedToArray(_arcGenerator$centroi, 2), centroidX = _arcGenerator$centroi2[0], centroidY = _arcGenerator$centroi2[1];
        var sliceLabel = getLabel(arc.data);
        var textColor = getTextColor(arc, theme);
        ctx.save();
        ctx.translate(centroidX, centroidY);
        ctx.fillStyle = textColor;
        ctx.fillText(sliceLabel, 0, 0);
        ctx.restore();
    });
};
var drawRadialLabels = function drawRadialLabels(ctx, arcs, _ref2) {
    var radius = _ref2.radius, getLabel = _ref2.getLabel, skipAngle = _ref2.skipAngle, linkOffset = _ref2.linkOffset, linkDiagonalLength = _ref2.linkDiagonalLength, linkHorizontalLength = _ref2.linkHorizontalLength, linkStrokeWidth = _ref2.linkStrokeWidth, textXOffset = _ref2.textXOffset, getTextColor = _ref2.getTextColor, getLinkColor = _ref2.getLinkColor, theme = _ref2.theme;
    var radialLabels = computeRadialLabels(arcs, {
        getLabel: getLabel,
        radius: radius,
        skipAngle: skipAngle,
        linkOffset: linkOffset,
        linkDiagonalLength: linkDiagonalLength,
        linkHorizontalLength: linkHorizontalLength,
        textXOffset: textXOffset
    });
    ctx.textBaseline = "middle";
    ctx.font = "".concat(theme.labels.text.fontSize, "px ").concat(theme.labels.text.fontFamily);
    radialLabels.forEach(function(label) {
        var dataWithColor = _objectSpread$4({}, label.arc.data, {
            color: label.arc.color
        });
        ctx.save();
        ctx.translate(label.position.x, label.position.y);
        ctx.fillStyle = getTextColor(dataWithColor, theme);
        ctx.textAlign = (0, _core.textPropsByEngine).canvas.align[label.align];
        ctx.fillText(label.text, 0, 0);
        ctx.restore();
        ctx.beginPath();
        ctx.strokeStyle = getLinkColor(dataWithColor, theme);
        ctx.lineWidth = linkStrokeWidth;
        label.line.forEach(function(point, index) {
            if (index === 0) ctx.moveTo(point.x, point.y);
            else ctx.lineTo(point.x, point.y);
        });
        if (linkStrokeWidth > 0) ctx.stroke();
    });
};
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$7(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$7(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PieTooltip = function PieTooltip(_ref) {
    var data = _ref.data, color = _ref.color, tooltipFormat = _ref.tooltipFormat, tooltip = _ref.tooltip, theme = _ref.theme;
    return (0, _reactDefault.default).createElement((0, _tooltip.BasicTooltip), {
        id: data.label,
        value: data.value,
        enableChip: true,
        color: color,
        theme: theme,
        format: tooltipFormat,
        renderContent: typeof tooltip === "function" ? tooltip.bind(null, _objectSpread$5({
            color: color
        }, data)) : null
    });
};
PieTooltip.propTypes = {
    data: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).number
        ]).isRequired,
        value: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    tooltipFormat: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    tooltip: (0, _propTypesDefault.default).func,
    theme: (0, _propTypesDefault.default).shape({
        tooltip: (0, _propTypesDefault.default).shape({}).isRequired
    }).isRequired
};
var PieTooltip$1 = (0, _pureDefault.default)(PieTooltip);
function _typeof$5(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$5 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$5(obj);
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$8(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit$1(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$5(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$5(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$5(self, call) {
    if (call && (_typeof$5(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$5(self);
}
function _getPrototypeOf$5(o) {
    _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$5(o);
}
function _assertThisInitialized$5(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$5(subClass, superClass);
}
function _setPrototypeOf$5(o, p) {
    _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$5(o, p);
}
function _defineProperty$8(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PieCanvasRenderer = function(_Component) {
    _inherits$5(PieCanvasRenderer, _Component);
    function PieCanvasRenderer() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck$5(this, PieCanvasRenderer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn$5(this, (_getPrototypeOf2 = _getPrototypeOf$5(PieCanvasRenderer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty$8(_assertThisInitialized$5(_this), "getArcFromMouse", function(event) {
            var _getRelativeCursor = (0, _core.getRelativeCursor)(_this.surface, event), _getRelativeCursor2 = _slicedToArray$1(_getRelativeCursor, 2), x = _getRelativeCursor2[0], y = _getRelativeCursor2[1];
            var _this$props = _this.props, centerX = _this$props.centerX, centerY = _this$props.centerY, margin = _this$props.margin, radius = _this$props.radius, innerRadius = _this$props.innerRadius, arcs = _this$props.arcs;
            return (0, _core.getHoveredArc)(margin.left + centerX, margin.top + centerY, radius, innerRadius, arcs, x, y);
        });
        _defineProperty$8(_assertThisInitialized$5(_this), "handleMouseHover", function(showTooltip, hideTooltip) {
            return function(event) {
                if (_this.props.isInteractive !== true) return;
                var arc = _this.getArcFromMouse(event);
                if (arc) showTooltip((0, _reactDefault.default).createElement(PieTooltip$1, {
                    data: arc.data,
                    color: arc.color,
                    theme: _this.props.theme
                }), event);
                else hideTooltip();
            };
        });
        _defineProperty$8(_assertThisInitialized$5(_this), "handleMouseLeave", function(hideTooltip) {
            return function() {
                if (_this.props.isInteractive !== true) return;
                hideTooltip();
            };
        });
        _defineProperty$8(_assertThisInitialized$5(_this), "handleClick", function(event) {
            var arc = _this.getArcFromMouse(event);
            if (arc) _this.props.onClick(arc.data, event);
        });
        return _this;
    }
    _createClass$5(PieCanvasRenderer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.ctx = this.surface.getContext("2d");
                this.draw(this.props);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(props) {
                if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) return true;
                this.draw(props);
                return false;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.ctx = this.surface.getContext("2d");
                this.draw(this.props);
            }
        },
        {
            key: "draw",
            value: function draw(props) {
                var _this2 = this;
                var arcs = props.arcs, arcGenerator = props.arcGenerator, width = props.width, height = props.height, centerX = props.centerX, centerY = props.centerY, radius = props.radius, outerWidth = props.outerWidth, outerHeight = props.outerHeight, pixelRatio = props.pixelRatio, margin = props.margin, borderWidth = props.borderWidth, borderColor = props.borderColor, enableSlicesLabels = props.enableSlicesLabels, enableRadialLabels = props.enableRadialLabels, legends = props.legends, theme = props.theme;
                this.surface.width = outerWidth * pixelRatio;
                this.surface.height = outerHeight * pixelRatio;
                this.ctx.scale(pixelRatio, pixelRatio);
                this.ctx.fillStyle = theme.background;
                this.ctx.fillRect(0, 0, outerWidth, outerHeight);
                this.ctx.save();
                this.ctx.translate(margin.left, margin.top);
                arcGenerator.context(this.ctx);
                this.ctx.save();
                this.ctx.translate(centerX, centerY);
                var getBorderColor = (0, _colors.getInheritedColorGenerator)(borderColor, theme);
                arcs.forEach(function(arc) {
                    _this2.ctx.beginPath();
                    _this2.ctx.fillStyle = arc.color;
                    _this2.ctx.strokeStyle = getBorderColor(_objectSpread$6({}, arc.data, {
                        color: arc.color
                    }));
                    _this2.ctx.lineWidth = borderWidth;
                    arcGenerator(arc);
                    _this2.ctx.fill();
                    if (borderWidth > 0) _this2.ctx.stroke();
                });
                if (enableSlicesLabels === true) {
                    var sliceLabel = props.sliceLabel, slicesLabelsSkipAngle = props.slicesLabelsSkipAngle, slicesLabelsTextColor = props.slicesLabelsTextColor;
                    drawSliceLabels(this.ctx, arcs, {
                        arcGenerator: arcGenerator,
                        skipAngle: slicesLabelsSkipAngle,
                        getLabel: (0, _core.getLabelGenerator)(sliceLabel),
                        getTextColor: (0, _colors.getInheritedColorGenerator)(slicesLabelsTextColor, theme),
                        theme: theme
                    });
                }
                if (enableRadialLabels === true) {
                    var radialLabel = props.radialLabel, radialLabelsSkipAngle = props.radialLabelsSkipAngle, radialLabelsLinkOffset = props.radialLabelsLinkOffset, radialLabelsLinkStrokeWidth = props.radialLabelsLinkStrokeWidth, radialLabelsLinkDiagonalLength = props.radialLabelsLinkDiagonalLength, radialLabelsLinkHorizontalLength = props.radialLabelsLinkHorizontalLength, radialLabelsTextXOffset = props.radialLabelsTextXOffset, radialLabelsTextColor = props.radialLabelsTextColor, radialLabelsLinkColor = props.radialLabelsLinkColor;
                    drawRadialLabels(this.ctx, arcs, {
                        radius: radius,
                        getLabel: (0, _core.getLabelGenerator)(radialLabel),
                        skipAngle: radialLabelsSkipAngle,
                        linkOffset: radialLabelsLinkOffset,
                        linkDiagonalLength: radialLabelsLinkDiagonalLength,
                        linkHorizontalLength: radialLabelsLinkHorizontalLength,
                        linkStrokeWidth: radialLabelsLinkStrokeWidth,
                        textXOffset: radialLabelsTextXOffset,
                        getTextColor: (0, _colors.getInheritedColorGenerator)(radialLabelsTextColor, theme),
                        getLinkColor: (0, _colors.getInheritedColorGenerator)(radialLabelsLinkColor, theme),
                        theme: theme
                    });
                }
                this.ctx.restore();
                legends.forEach(function(legend) {
                    (0, _legends.renderLegendToCanvas)(_this2.ctx, _objectSpread$6({}, legend, {
                        data: arcs.map(function(arc) {
                            return {
                                id: arc.data.id,
                                label: arc.data.id,
                                color: arc.color
                            };
                        }),
                        containerWidth: width,
                        containerHeight: height,
                        theme: theme
                    }));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props2 = this.props, outerWidth = _this$props2.outerWidth, outerHeight = _this$props2.outerHeight, pixelRatio = _this$props2.pixelRatio, isInteractive = _this$props2.isInteractive, theme = _this$props2.theme;
                return (0, _reactDefault.default).createElement((0, _core.Container), {
                    isInteractive: isInteractive,
                    theme: theme,
                    animate: false
                }, function(_ref) {
                    var showTooltip = _ref.showTooltip, hideTooltip = _ref.hideTooltip;
                    return (0, _reactDefault.default).createElement("canvas", {
                        ref: function ref(surface) {
                            _this3.surface = surface;
                        },
                        width: outerWidth * pixelRatio,
                        height: outerHeight * pixelRatio,
                        style: {
                            width: outerWidth,
                            height: outerHeight
                        },
                        onMouseEnter: _this3.handleMouseHover(showTooltip, hideTooltip),
                        onMouseMove: _this3.handleMouseHover(showTooltip, hideTooltip),
                        onMouseLeave: _this3.handleMouseLeave(hideTooltip),
                        onClick: _this3.handleClick
                    });
                });
            }
        }
    ]);
    return PieCanvasRenderer;
}((0, _react.Component));
_defineProperty$8(PieCanvasRenderer, "propTypes", {
    arcs: (0, _propTypesDefault.default).arrayOf(arcPropType).isRequired,
    arcGenerator: (0, _propTypesDefault.default).func.isRequired,
    pixelRatio: (0, _propTypesDefault.default).number.isRequired,
    outerWidth: (0, _propTypesDefault.default).number.isRequired,
    outerHeight: (0, _propTypesDefault.default).number.isRequired,
    centerX: (0, _propTypesDefault.default).number.isRequired,
    centerY: (0, _propTypesDefault.default).number.isRequired,
    margin: (0, _propTypesDefault.default).object.isRequired,
    radius: (0, _propTypesDefault.default).number.isRequired,
    innerRadius: (0, _propTypesDefault.default).number.isRequired,
    isInteractive: (0, _propTypesDefault.default).bool.isRequired,
    onClick: (0, _propTypesDefault.default).func.isRequired,
    theme: (0, _propTypesDefault.default).object.isRequired
});
function _typeof$6(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$6 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$6(obj);
}
function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$6(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$6(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn$6(self, call) {
    if (call && (_typeof$6(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$6(self);
}
function _assertThisInitialized$6(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _getPrototypeOf$6(o) {
    _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$6(o);
}
function _inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$6(subClass, superClass);
}
function _setPrototypeOf$6(o, p) {
    _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$6(o, p);
}
function _defineProperty$9(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var PieCanvas = function(_Component) {
    _inherits$6(PieCanvas, _Component);
    function PieCanvas() {
        _classCallCheck$6(this, PieCanvas);
        return _possibleConstructorReturn$6(this, _getPrototypeOf$6(PieCanvas).apply(this, arguments));
    }
    _createClass$6(PieCanvas, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, data = _this$props.data, sortByValue = _this$props.sortByValue, startAngle = _this$props.startAngle, endAngle = _this$props.endAngle, fit = _this$props.fit, padAngle = _this$props.padAngle, innerRadius = _this$props.innerRadius, cornerRadius = _this$props.cornerRadius, width = _this$props.width, height = _this$props.height, colors = _this$props.colors, colorBy = _this$props.colorBy, topProps = _objectWithoutProperties$1(_this$props, [
                    "data",
                    "sortByValue",
                    "startAngle",
                    "endAngle",
                    "fit",
                    "padAngle",
                    "innerRadius",
                    "cornerRadius",
                    "width",
                    "height",
                    "colors",
                    "colorBy"
                ]);
                return (0, _reactDefault.default).createElement(PieLayout$1, {
                    width: width,
                    height: height,
                    data: data,
                    sortByValue: sortByValue,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    fit: fit,
                    padAngle: padAngle,
                    innerRadius: innerRadius,
                    cornerRadius: cornerRadius,
                    colors: colors,
                    colorBy: colorBy
                }, function(props) {
                    return (0, _reactDefault.default).createElement(PieCanvasRenderer, _extends$2({}, topProps, props));
                });
            }
        }
    ]);
    return PieCanvas;
}((0, _react.Component));
_defineProperty$9(PieCanvas, "propTypes", PiePropTypes);
var PieCanvas$1 = (0, _setDisplayNameDefault.default)("PieCanvas")(enhance$4(PieCanvas));
function _extends$3() {
    _extends$3 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$3.apply(this, arguments);
}
var ResponsivePieCanvas = function ResponsivePieCanvas(props) {
    return (0, _reactDefault.default).createElement((0, _core.ResponsiveWrapper), null, function(_ref) {
        var width = _ref.width, height = _ref.height;
        return (0, _reactDefault.default).createElement(PieCanvas$1, _extends$3({
            width: width,
            height: height
        }, props));
    });
};
function _objectSpread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty$a(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty$a(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var usePie = function usePie(_ref) {
    var data = _ref.data, radius = _ref.radius, _ref$value = _ref.value, value = _ref$value === void 0 ? function(v) {
        return v;
    } : _ref$value, _ref$startAngle = _ref.startAngle, startAngle = _ref$startAngle === void 0 ? 0 : _ref$startAngle, _ref$endAngle = _ref.endAngle, endAngle = _ref$endAngle === void 0 ? 360 : _ref$endAngle, _ref$innerRadius = _ref.innerRadius, innerRadius = _ref$innerRadius === void 0 ? 0 : _ref$innerRadius, _ref$cornerRadius = _ref.cornerRadius, cornerRadius = _ref$cornerRadius === void 0 ? 0 : _ref$cornerRadius, _ref$sortByValue = _ref.sortByValue, sortByValue = _ref$sortByValue === void 0 ? false : _ref$sortByValue, _ref$padAngle = _ref.padAngle, padAngle = _ref$padAngle === void 0 ? 0 : _ref$padAngle;
    var arcGenerator = (0, _react.useMemo)(function() {
        return (0, _d3Shape.arc)().outerRadius(radius).innerRadius(innerRadius).cornerRadius(cornerRadius);
    }, [
        radius,
        innerRadius,
        cornerRadius
    ]);
    var getValue = (0, _react.useMemo)(function() {
        return typeof value === "function" ? value : function(d) {
            return (0, _getDefault.default)(d, value);
        };
    }, [
        value
    ]);
    var pie$1 = (0, _react.useMemo)(function() {
        var computedPie = (0, _d3Shape.pie)().value(getValue).padAngle((0, _core.degreesToRadians)(padAngle)).startAngle((0, _core.degreesToRadians)(startAngle)).endAngle((0, _core.degreesToRadians)(endAngle));
        if (sortByValue !== true) computedPie.sortValues(null);
        return computedPie;
    }, [
        getValue,
        padAngle,
        startAngle,
        endAngle,
        sortByValue
    ]);
    var arcs = (0, _react.useMemo)(function() {
        return pie$1(data).map(function(arc) {
            var angle = arc.endAngle - (arc.endAngle - arc.startAngle) * 0.5;
            return _objectSpread$7({}, arc, {
                startAngleDeg: (0, _core.radiansToDegrees)(angle.startAngle),
                endAngleDeg: (0, _core.radiansToDegrees)(arc.endAngle),
                angle: angle,
                angleDeg: (0, _core.radiansToDegrees)(angle)
            });
        });
    }, [
        data,
        pie$1
    ]);
    return {
        arcs: arcs,
        arcGenerator: arcGenerator
    };
};

},{"react":"6AiW6","prop-types":"kKQPU","d3-shape":"kgLQU","recompose/setDisplayName":"9JGr7","recompose/compose":"lv27x","recompose/pure":"9wymM","recompose/defaultProps":"6nQWc","recompose/withPropsOnChange":"bf8Lh","@nivo/core":"guBSY","@nivo/colors":"c3QTw","@nivo/legends":"KxnAT","@nivo/tooltip":"D7d3j","lodash/get":"4u8u0","@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"9Yjao":[function(require,module,exports) {
var _awsAmplify = require("aws-amplify");
function formatStatus(status) {
    const { name, color, closed } = status;
    const text = closed ? `${name} (Closed)` : name;
    return {
        key: name,
        text,
        value: name,
        label: {
            color,
            empty: true,
            circular: true
        }
    };
}
async function get(customerId) {
    const settings = await (0, _awsAmplify.API).get("audit-apis", `/customers/${customerId}/dashboard/`, {});
    const { data } = settings;
    return data.map(formatStatus);
}
module.exports = {
    get
};

},{"aws-amplify":"aGGkJ"}],"emIBu":[function(require,module,exports) {
"use strict";
var Bluebird = require("1a49ccc0783eac33").getNewLibraryCopy(), configure = require("d523d3d7e35f823a"), stealthyRequire = require("3cf70bb2642e7c69");
try {
    // Load Request freshly - so that users can require an unaltered request instance!
    var request = stealthyRequire(undefined, function() {
        return require("d9ddda4f48f4c780");
    }, function() {
        require("4f1aead5156de0c4");
    }, module);
} catch (err) {
    /* istanbul ignore next */ var EOL = require("6053ab8c29f4f451").EOL;
    /* istanbul ignore next */ console.error(EOL + "###" + EOL + '### The "request" library is not installed automatically anymore.' + EOL + '### But is a dependency of "request-promise".' + EOL + "### Please install it with:" + EOL + "### npm install request --save" + EOL + "###" + EOL);
    /* istanbul ignore next */ throw err;
}
Bluebird.config({
    cancellation: true
});
configure({
    request: request,
    PromiseImpl: Bluebird,
    expose: [
        "then",
        "catch",
        "finally",
        "cancel",
        "promise"
    ],
    constructorMixin: function(resolve, reject, onCancel) {
        var self = this;
        onCancel(function() {
            self.abort();
        });
    }
});
request.bindCLS = function RP$bindCLS() {
    throw new Error("CLS support was dropped. To get it back read: https://github.com/request/request-promise/wiki/Getting-Back-Support-for-Continuation-Local-Storage");
};
module.exports = request;

},{"1a49ccc0783eac33":"aKZBJ","d523d3d7e35f823a":"hoSRs","3cf70bb2642e7c69":"aYBw5","d9ddda4f48f4c780":"6JQv4","4f1aead5156de0c4":"JK3wo","6053ab8c29f4f451":"6pne9"}],"aKZBJ":[function(require,module,exports) {
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */ /**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/ var process = require("fb71ed40a9331d76");
var global = arguments[3];
!function(e) {
    var f;
    module.exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof _dereq_ == "function" && _dereq_;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var SomePromiseArray = Promise1._SomePromiseArray;
                    function any(promises) {
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(1);
                        ret.setUnwrap();
                        ret.init();
                        return promise;
                    }
                    Promise1.any = function(promises) {
                        return any(promises);
                    };
                    Promise1.prototype.any = function() {
                        return any(this);
                    };
                };
            },
            {}
        ],
        2: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var firstLineError;
                try {
                    throw new Error();
                } catch (e) {
                    firstLineError = e;
                }
                var schedule = _dereq_1("./schedule");
                var Queue = _dereq_1("./queue");
                function Async() {
                    this._customScheduler = false;
                    this._isTickUsed = false;
                    this._lateQueue = new Queue(16);
                    this._normalQueue = new Queue(16);
                    this._haveDrainedQueues = false;
                    var self1 = this;
                    this.drainQueues = function() {
                        self1._drainQueues();
                    };
                    this._schedule = schedule;
                }
                Async.prototype.setScheduler = function(fn) {
                    var prev = this._schedule;
                    this._schedule = fn;
                    this._customScheduler = true;
                    return prev;
                };
                Async.prototype.hasCustomScheduler = function() {
                    return this._customScheduler;
                };
                Async.prototype.haveItemsQueued = function() {
                    return this._isTickUsed || this._haveDrainedQueues;
                };
                Async.prototype.fatalError = function(e, isNode) {
                    if (isNode) {
                        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                        process.exit(2);
                    } else this.throwLater(e);
                };
                Async.prototype.throwLater = function(fn, arg) {
                    if (arguments.length === 1) {
                        arg = fn;
                        fn = function() {
                            throw arg;
                        };
                    }
                    if (typeof setTimeout !== "undefined") setTimeout(function() {
                        fn(arg);
                    }, 0);
                    else try {
                        this._schedule(function() {
                            fn(arg);
                        });
                    } catch (e) {
                        throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                    }
                };
                function AsyncInvokeLater(fn, receiver, arg) {
                    this._lateQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncInvoke(fn, receiver, arg) {
                    this._normalQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncSettlePromises(promise) {
                    this._normalQueue._pushOne(promise);
                    this._queueTick();
                }
                Async.prototype.invokeLater = AsyncInvokeLater;
                Async.prototype.invoke = AsyncInvoke;
                Async.prototype.settlePromises = AsyncSettlePromises;
                function _drainQueue(queue) {
                    while(queue.length() > 0)_drainQueueStep(queue);
                }
                function _drainQueueStep(queue) {
                    var fn = queue.shift();
                    if (typeof fn !== "function") fn._settlePromises();
                    else {
                        var receiver = queue.shift();
                        var arg = queue.shift();
                        fn.call(receiver, arg);
                    }
                }
                Async.prototype._drainQueues = function() {
                    _drainQueue(this._normalQueue);
                    this._reset();
                    this._haveDrainedQueues = true;
                    _drainQueue(this._lateQueue);
                };
                Async.prototype._queueTick = function() {
                    if (!this._isTickUsed) {
                        this._isTickUsed = true;
                        this._schedule(this.drainQueues);
                    }
                };
                Async.prototype._reset = function() {
                    this._isTickUsed = false;
                };
                module1.exports = Async;
                module1.exports.firstLineError = firstLineError;
            },
            {
                "./queue": 26,
                "./schedule": 29
            }
        ],
        3: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, debug) {
                    var calledBind = false;
                    var rejectThis = function(_, e) {
                        this._reject(e);
                    };
                    var targetRejected = function(e, context) {
                        context.promiseRejectionQueued = true;
                        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                    };
                    var bindingResolved = function(thisArg, context) {
                        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
                    };
                    var bindingRejected = function(e, context) {
                        if (!context.promiseRejectionQueued) this._reject(e);
                    };
                    Promise1.prototype.bind = function(thisArg) {
                        if (!calledBind) {
                            calledBind = true;
                            Promise1.prototype._propagateFrom = debug.propagateFromFunction();
                            Promise1.prototype._boundValue = debug.boundValueFunction();
                        }
                        var maybePromise = tryConvertToPromise(thisArg);
                        var ret = new Promise1(INTERNAL);
                        ret._propagateFrom(this, 1);
                        var target = this._target();
                        ret._setBoundTo(maybePromise);
                        if (maybePromise instanceof Promise1) {
                            var context = {
                                promiseRejectionQueued: false,
                                promise: ret,
                                target: target,
                                bindingPromise: maybePromise
                            };
                            target._then(INTERNAL, targetRejected, undefined, ret, context);
                            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                            ret._setOnCancel(maybePromise);
                        } else ret._resolveCallback(target);
                        return ret;
                    };
                    Promise1.prototype._setBoundTo = function(obj) {
                        if (obj !== undefined) {
                            this._bitField = this._bitField | 2097152;
                            this._boundTo = obj;
                        } else this._bitField = this._bitField & -2097153;
                    };
                    Promise1.prototype._isBound = function() {
                        return (this._bitField & 2097152) === 2097152;
                    };
                    Promise1.bind = function(thisArg, value) {
                        return Promise1.resolve(value).bind(thisArg);
                    };
                };
            },
            {}
        ],
        4: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var old;
                if (typeof Promise !== "undefined") old = Promise;
                function noConflict() {
                    try {
                        if (Promise === bluebird) Promise = old;
                    } catch (e) {}
                    return bluebird;
                }
                var bluebird = _dereq_1("./promise")();
                bluebird.noConflict = noConflict;
                module1.exports = bluebird;
            },
            {
                "./promise": 22
            }
        ],
        5: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var cr = Object.create;
                if (cr) {
                    var callerCache = cr(null);
                    var getterCache = cr(null);
                    callerCache[" size"] = getterCache[" size"] = 0;
                }
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var isIdentifier = util.isIdentifier;
                    var getMethodCaller;
                    var getGetter;
                    var makeMethodCaller, makeGetter, getCompiled;
                    function ensureMethod(obj, methodName) {
                        var fn;
                        if (obj != null) fn = obj[methodName];
                        if (typeof fn !== "function") {
                            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                            throw new Promise1.TypeError(message);
                        }
                        return fn;
                    }
                    function caller(obj) {
                        var methodName = this.pop();
                        var fn = ensureMethod(obj, methodName);
                        return fn.apply(obj, this);
                    }
                    Promise1.prototype.call = function(methodName) {
                        var args = [].slice.call(arguments, 1);
                        var maybeCaller;
                        args.push(methodName);
                        return this._then(caller, undefined, undefined, args, undefined);
                    };
                    function namedGetter(obj) {
                        return obj[this];
                    }
                    function indexedGetter(obj) {
                        var index = +this;
                        if (index < 0) index = Math.max(0, index + obj.length);
                        return obj[index];
                    }
                    Promise1.prototype.get = function(propertyName) {
                        var isIndex = typeof propertyName === "number";
                        var getter;
                        if (!isIndex) {
                            if (canEvaluate) {
                                var maybeGetter = getGetter(propertyName);
                                getter = maybeGetter !== null ? maybeGetter : namedGetter;
                            } else getter = namedGetter;
                        } else getter = indexedGetter;
                        return this._then(getter, undefined, undefined, propertyName, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        6: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    Promise1.prototype["break"] = Promise1.prototype.cancel = function() {
                        if (!debug.cancellation()) return this._warn("cancellation is disabled");
                        var promise = this;
                        var child = promise;
                        while(promise._isCancellable()){
                            if (!promise._cancelBy(child)) {
                                if (child._isFollowing()) child._followee().cancel();
                                else child._cancelBranched();
                                break;
                            }
                            var parent = promise._cancellationParent;
                            if (parent == null || !parent._isCancellable()) {
                                if (promise._isFollowing()) promise._followee().cancel();
                                else promise._cancelBranched();
                                break;
                            } else {
                                if (promise._isFollowing()) promise._followee().cancel();
                                promise._setWillBeCancelled();
                                child = promise;
                                promise = parent;
                            }
                        }
                    };
                    Promise1.prototype._branchHasCancelled = function() {
                        this._branchesRemainingToCancel--;
                    };
                    Promise1.prototype._enoughBranchesHaveCancelled = function() {
                        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                    };
                    Promise1.prototype._cancelBy = function(canceller) {
                        if (canceller === this) {
                            this._branchesRemainingToCancel = 0;
                            this._invokeOnCancel();
                            return true;
                        } else {
                            this._branchHasCancelled();
                            if (this._enoughBranchesHaveCancelled()) {
                                this._invokeOnCancel();
                                return true;
                            }
                        }
                        return false;
                    };
                    Promise1.prototype._cancelBranched = function() {
                        if (this._enoughBranchesHaveCancelled()) this._cancel();
                    };
                    Promise1.prototype._cancel = function() {
                        if (!this._isCancellable()) return;
                        this._setCancelled();
                        async.invoke(this._cancelPromises, this, undefined);
                    };
                    Promise1.prototype._cancelPromises = function() {
                        if (this._length() > 0) this._settlePromises();
                    };
                    Promise1.prototype._unsetOnCancel = function() {
                        this._onCancelField = undefined;
                    };
                    Promise1.prototype._isCancellable = function() {
                        return this.isPending() && !this._isCancelled();
                    };
                    Promise1.prototype.isCancellable = function() {
                        return this.isPending() && !this.isCancelled();
                    };
                    Promise1.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
                        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                        else if (onCancelCallback !== undefined) {
                            if (typeof onCancelCallback === "function") {
                                if (!internalOnly) {
                                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                                    if (e === errorObj) {
                                        this._attachExtraTrace(e.e);
                                        async.throwLater(e.e);
                                    }
                                }
                            } else onCancelCallback._resultCancelled(this);
                        }
                    };
                    Promise1.prototype._invokeOnCancel = function() {
                        var onCancelCallback = this._onCancel();
                        this._unsetOnCancel();
                        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                    };
                    Promise1.prototype._invokeInternalOnCancel = function() {
                        if (this._isCancellable()) {
                            this._doInvokeOnCancel(this._onCancel(), true);
                            this._unsetOnCancel();
                        }
                    };
                    Promise1.prototype._resultCancelled = function() {
                        this.cancel();
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        7: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var getKeys = _dereq_1("./es5").keys;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function catchFilter(instances, cb, promise) {
                        return function(e) {
                            var boundTo = promise._boundValue();
                            predicateLoop: for(var i = 0; i < instances.length; ++i){
                                var item = instances[i];
                                if (item === Error || item != null && item.prototype instanceof Error) {
                                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                                } else if (typeof item === "function") {
                                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                                    if (matchesPredicate === errorObj) return matchesPredicate;
                                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                                } else if (util.isObject(e)) {
                                    var keys = getKeys(item);
                                    for(var j = 0; j < keys.length; ++j){
                                        var key = keys[j];
                                        if (item[key] != e[key]) continue predicateLoop;
                                    }
                                    return tryCatch(cb).call(boundTo, e);
                                }
                            }
                            return NEXT_FILTER;
                        };
                    }
                    return catchFilter;
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        8: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var longStackTraces = false;
                    var contextStack = [];
                    Promise1.prototype._promiseCreated = function() {};
                    Promise1.prototype._pushContext = function() {};
                    Promise1.prototype._popContext = function() {
                        return null;
                    };
                    Promise1._peekContext = Promise1.prototype._peekContext = function() {};
                    function Context() {
                        this._trace = new Context.CapturedTrace(peekContext());
                    }
                    Context.prototype._pushContext = function() {
                        if (this._trace !== undefined) {
                            this._trace._promiseCreated = null;
                            contextStack.push(this._trace);
                        }
                    };
                    Context.prototype._popContext = function() {
                        if (this._trace !== undefined) {
                            var trace = contextStack.pop();
                            var ret = trace._promiseCreated;
                            trace._promiseCreated = null;
                            return ret;
                        }
                        return null;
                    };
                    function createContext() {
                        if (longStackTraces) return new Context();
                    }
                    function peekContext() {
                        var lastIndex = contextStack.length - 1;
                        if (lastIndex >= 0) return contextStack[lastIndex];
                        return undefined;
                    }
                    Context.CapturedTrace = null;
                    Context.create = createContext;
                    Context.deactivateLongStackTraces = function() {};
                    Context.activateLongStackTraces = function() {
                        var Promise_pushContext = Promise1.prototype._pushContext;
                        var Promise_popContext = Promise1.prototype._popContext;
                        var Promise_PeekContext = Promise1._peekContext;
                        var Promise_peekContext = Promise1.prototype._peekContext;
                        var Promise_promiseCreated = Promise1.prototype._promiseCreated;
                        Context.deactivateLongStackTraces = function() {
                            Promise1.prototype._pushContext = Promise_pushContext;
                            Promise1.prototype._popContext = Promise_popContext;
                            Promise1._peekContext = Promise_PeekContext;
                            Promise1.prototype._peekContext = Promise_peekContext;
                            Promise1.prototype._promiseCreated = Promise_promiseCreated;
                            longStackTraces = false;
                        };
                        longStackTraces = true;
                        Promise1.prototype._pushContext = Context.prototype._pushContext;
                        Promise1.prototype._popContext = Context.prototype._popContext;
                        Promise1._peekContext = Promise1.prototype._peekContext = peekContext;
                        Promise1.prototype._promiseCreated = function() {
                            var ctx = this._peekContext();
                            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                        };
                    };
                    return Context;
                };
            },
            {}
        ],
        9: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, Context, enableAsyncHooks, disableAsyncHooks) {
                    var async = Promise1._async;
                    var Warning = _dereq_1("./errors").Warning;
                    var util = _dereq_1("./util");
                    var es5 = _dereq_1("./es5");
                    var canAttachTrace = util.canAttachTrace;
                    var unhandledRejectionHandled;
                    var possiblyUnhandledRejection;
                    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                    var stackFramePattern = null;
                    var formatStack = null;
                    var indentStackFrames = false;
                    var printWarning;
                    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
                    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    var deferUnhandledRejectionCheck;
                    (function() {
                        var promises = [];
                        function unhandledRejectionCheck() {
                            for(var i = 0; i < promises.length; ++i)promises[i]._notifyUnhandledRejection();
                            unhandledRejectionClear();
                        }
                        function unhandledRejectionClear() {
                            promises.length = 0;
                        }
                        deferUnhandledRejectionCheck = function(promise) {
                            promises.push(promise);
                            setTimeout(unhandledRejectionCheck, 1);
                        };
                        es5.defineProperty(Promise1, "_unhandledRejectionCheck", {
                            value: unhandledRejectionCheck
                        });
                        es5.defineProperty(Promise1, "_unhandledRejectionClear", {
                            value: unhandledRejectionClear
                        });
                    })();
                    Promise1.prototype.suppressUnhandledRejections = function() {
                        var target = this._target();
                        target._bitField = target._bitField & -1048577 | 524288;
                    };
                    Promise1.prototype._ensurePossibleRejectionHandled = function() {
                        if ((this._bitField & 524288) !== 0) return;
                        this._setRejectionIsUnhandled();
                        deferUnhandledRejectionCheck(this);
                    };
                    Promise1.prototype._notifyUnhandledRejectionIsHandled = function() {
                        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                    };
                    Promise1.prototype._setReturnedNonUndefined = function() {
                        this._bitField = this._bitField | 268435456;
                    };
                    Promise1.prototype._returnedNonUndefined = function() {
                        return (this._bitField & 268435456) !== 0;
                    };
                    Promise1.prototype._notifyUnhandledRejection = function() {
                        if (this._isRejectionUnhandled()) {
                            var reason = this._settledValue();
                            this._setUnhandledRejectionIsNotified();
                            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                        }
                    };
                    Promise1.prototype._setUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField | 262144;
                    };
                    Promise1.prototype._unsetUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField & -262145;
                    };
                    Promise1.prototype._isUnhandledRejectionNotified = function() {
                        return (this._bitField & 262144) > 0;
                    };
                    Promise1.prototype._setRejectionIsUnhandled = function() {
                        this._bitField = this._bitField | 1048576;
                    };
                    Promise1.prototype._unsetRejectionIsUnhandled = function() {
                        this._bitField = this._bitField & -1048577;
                        if (this._isUnhandledRejectionNotified()) {
                            this._unsetUnhandledRejectionIsNotified();
                            this._notifyUnhandledRejectionIsHandled();
                        }
                    };
                    Promise1.prototype._isRejectionUnhandled = function() {
                        return (this._bitField & 1048576) > 0;
                    };
                    Promise1.prototype._warn = function(message, shouldUseOwnTrace, promise) {
                        return warn(message, shouldUseOwnTrace, promise || this);
                    };
                    Promise1.onPossiblyUnhandledRejection = function(fn) {
                        var context = Promise1._getContext();
                        possiblyUnhandledRejection = util.contextBind(context, fn);
                    };
                    Promise1.onUnhandledRejectionHandled = function(fn) {
                        var context = Promise1._getContext();
                        unhandledRejectionHandled = util.contextBind(context, fn);
                    };
                    var disableLongStackTraces = function() {};
                    Promise1.longStackTraces = function() {
                        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                        if (!config.longStackTraces && longStackTracesIsSupported()) {
                            var Promise_captureStackTrace = Promise1.prototype._captureStackTrace;
                            var Promise_attachExtraTrace = Promise1.prototype._attachExtraTrace;
                            var Promise_dereferenceTrace = Promise1.prototype._dereferenceTrace;
                            config.longStackTraces = true;
                            disableLongStackTraces = function() {
                                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                                Promise1.prototype._captureStackTrace = Promise_captureStackTrace;
                                Promise1.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                Promise1.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                Context.deactivateLongStackTraces();
                                config.longStackTraces = false;
                            };
                            Promise1.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                            Promise1.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                            Promise1.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                            Context.activateLongStackTraces();
                        }
                    };
                    Promise1.hasLongStackTraces = function() {
                        return config.longStackTraces && longStackTracesIsSupported();
                    };
                    var legacyHandlers = {
                        unhandledrejection: {
                            before: function() {
                                var ret = util.global.onunhandledrejection;
                                util.global.onunhandledrejection = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onunhandledrejection = fn;
                            }
                        },
                        rejectionhandled: {
                            before: function() {
                                var ret = util.global.onrejectionhandled;
                                util.global.onrejectionhandled = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onrejectionhandled = fn;
                            }
                        }
                    };
                    var fireDomEvent = function() {
                        var dispatch = function(legacy, e) {
                            if (legacy) {
                                var fn;
                                try {
                                    fn = legacy.before();
                                    return !util.global.dispatchEvent(e);
                                } finally{
                                    legacy.after(fn);
                                }
                            } else return !util.global.dispatchEvent(e);
                        };
                        try {
                            if (typeof CustomEvent === "function") {
                                var event = new CustomEvent("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var eventData = {
                                        detail: event,
                                        cancelable: true
                                    };
                                    var domEvent = new CustomEvent(name, eventData);
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else if (typeof Event === "function") {
                                var event = new Event("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = new Event(name, {
                                        cancelable: true
                                    });
                                    domEvent.detail = event;
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else {
                                var event = document.createEvent("CustomEvent");
                                event.initCustomEvent("testingtheevent", false, true, {});
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = document.createEvent("CustomEvent");
                                    domEvent.initCustomEvent(name, false, true, event);
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            }
                        } catch (e) {}
                        return function() {
                            return false;
                        };
                    }();
                    var fireGlobalEvent = function() {
                        if (util.isNode) return function() {
                            return process.emit.apply(process, arguments);
                        };
                        else {
                            if (!util.global) return function() {
                                return false;
                            };
                            return function(name) {
                                var methodName = "on" + name.toLowerCase();
                                var method = util.global[methodName];
                                if (!method) return false;
                                method.apply(util.global, [].slice.call(arguments, 1));
                                return true;
                            };
                        }
                    }();
                    function generatePromiseLifecycleEventObject(name, promise) {
                        return {
                            promise: promise
                        };
                    }
                    var eventToObjectGenerator = {
                        promiseCreated: generatePromiseLifecycleEventObject,
                        promiseFulfilled: generatePromiseLifecycleEventObject,
                        promiseRejected: generatePromiseLifecycleEventObject,
                        promiseResolved: generatePromiseLifecycleEventObject,
                        promiseCancelled: generatePromiseLifecycleEventObject,
                        promiseChained: function(name, promise, child) {
                            return {
                                promise: promise,
                                child: child
                            };
                        },
                        warning: function(name, warning) {
                            return {
                                warning: warning
                            };
                        },
                        unhandledRejection: function(name, reason, promise) {
                            return {
                                reason: reason,
                                promise: promise
                            };
                        },
                        rejectionHandled: generatePromiseLifecycleEventObject
                    };
                    var activeFireEvent = function(name) {
                        var globalEventFired = false;
                        try {
                            globalEventFired = fireGlobalEvent.apply(null, arguments);
                        } catch (e) {
                            async.throwLater(e);
                            globalEventFired = true;
                        }
                        var domEventFired = false;
                        try {
                            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                        } catch (e) {
                            async.throwLater(e);
                            domEventFired = true;
                        }
                        return domEventFired || globalEventFired;
                    };
                    Promise1.config = function(opts) {
                        opts = Object(opts);
                        if ("longStackTraces" in opts) {
                            if (opts.longStackTraces) Promise1.longStackTraces();
                            else if (!opts.longStackTraces && Promise1.hasLongStackTraces()) disableLongStackTraces();
                        }
                        if ("warnings" in opts) {
                            var warningsOption = opts.warnings;
                            config.warnings = !!warningsOption;
                            wForgottenReturn = config.warnings;
                            if (util.isObject(warningsOption)) {
                                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
                            }
                        }
                        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                            Promise1.prototype._clearCancellationData = cancellationClearCancellationData;
                            Promise1.prototype._propagateFrom = cancellationPropagateFrom;
                            Promise1.prototype._onCancel = cancellationOnCancel;
                            Promise1.prototype._setOnCancel = cancellationSetOnCancel;
                            Promise1.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                            Promise1.prototype._execute = cancellationExecute;
                            propagateFromFunction = cancellationPropagateFrom;
                            config.cancellation = true;
                        }
                        if ("monitoring" in opts) {
                            if (opts.monitoring && !config.monitoring) {
                                config.monitoring = true;
                                Promise1.prototype._fireEvent = activeFireEvent;
                            } else if (!opts.monitoring && config.monitoring) {
                                config.monitoring = false;
                                Promise1.prototype._fireEvent = defaultFireEvent;
                            }
                        }
                        if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                            var prev = config.asyncHooks;
                            var cur = !!opts.asyncHooks;
                            if (prev !== cur) {
                                config.asyncHooks = cur;
                                if (cur) enableAsyncHooks();
                                else disableAsyncHooks();
                            }
                        }
                        return Promise1;
                    };
                    function defaultFireEvent() {
                        return false;
                    }
                    Promise1.prototype._fireEvent = defaultFireEvent;
                    Promise1.prototype._execute = function(executor, resolve, reject) {
                        try {
                            executor(resolve, reject);
                        } catch (e) {
                            return e;
                        }
                    };
                    Promise1.prototype._onCancel = function() {};
                    Promise1.prototype._setOnCancel = function(handler) {};
                    Promise1.prototype._attachCancellationCallback = function(onCancel) {};
                    Promise1.prototype._captureStackTrace = function() {};
                    Promise1.prototype._attachExtraTrace = function() {};
                    Promise1.prototype._dereferenceTrace = function() {};
                    Promise1.prototype._clearCancellationData = function() {};
                    Promise1.prototype._propagateFrom = function(parent, flags) {};
                    function cancellationExecute(executor, resolve, reject) {
                        var promise = this;
                        try {
                            executor(resolve, reject, function(onCancel) {
                                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                promise._attachCancellationCallback(onCancel);
                            });
                        } catch (e) {
                            return e;
                        }
                    }
                    function cancellationAttachCancellationCallback(onCancel) {
                        if (!this._isCancellable()) return this;
                        var previousOnCancel = this._onCancel();
                        if (previousOnCancel !== undefined) {
                            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
                            else this._setOnCancel([
                                previousOnCancel,
                                onCancel
                            ]);
                        } else this._setOnCancel(onCancel);
                    }
                    function cancellationOnCancel() {
                        return this._onCancelField;
                    }
                    function cancellationSetOnCancel(onCancel) {
                        this._onCancelField = onCancel;
                    }
                    function cancellationClearCancellationData() {
                        this._cancellationParent = undefined;
                        this._onCancelField = undefined;
                    }
                    function cancellationPropagateFrom(parent, flags) {
                        if ((flags & 1) !== 0) {
                            this._cancellationParent = parent;
                            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
                            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                        }
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    function bindingPropagateFrom(parent, flags) {
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    var propagateFromFunction = bindingPropagateFrom;
                    function boundValueFunction() {
                        var ret = this._boundTo;
                        if (ret !== undefined) {
                            if (ret instanceof Promise1) {
                                if (ret.isFulfilled()) return ret.value();
                                else return undefined;
                            }
                        }
                        return ret;
                    }
                    function longStackTracesCaptureStackTrace() {
                        this._trace = new CapturedTrace(this._peekContext());
                    }
                    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                        if (canAttachTrace(error)) {
                            var trace = this._trace;
                            if (trace !== undefined) {
                                if (ignoreSelf) trace = trace._parent;
                            }
                            if (trace !== undefined) trace.attachExtraTrace(error);
                            else if (!error.__stackCleaned__) {
                                var parsed = parseStackAndMessage(error);
                                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                util.notEnumerableProp(error, "__stackCleaned__", true);
                            }
                        }
                    }
                    function longStackTracesDereferenceTrace() {
                        this._trace = undefined;
                    }
                    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                            if (parent !== undefined && parent._returnedNonUndefined()) return;
                            if ((promise._bitField & 65535) === 0) return;
                            if (name) name = name + " ";
                            var handlerLine = "";
                            var creatorLine = "";
                            if (promiseCreated._trace) {
                                var traceLines = promiseCreated._trace.stack.split("\n");
                                var stack = cleanStack(traceLines);
                                for(var i = stack.length - 1; i >= 0; --i){
                                    var line = stack[i];
                                    if (!nodeFramePattern.test(line)) {
                                        var lineMatches = line.match(parseLinePattern);
                                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                        break;
                                    }
                                }
                                if (stack.length > 0) {
                                    var firstUserLine = stack[0];
                                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                                        break;
                                    }
                                }
                            }
                            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                            promise._warn(msg, true, promiseCreated);
                        }
                    }
                    function deprecated(name, replacement) {
                        var message = name + " is deprecated and will be removed in a future version.";
                        if (replacement) message += " Use " + replacement + " instead.";
                        return warn(message);
                    }
                    function warn(message, shouldUseOwnTrace, promise) {
                        if (!config.warnings) return;
                        var warning = new Warning(message);
                        var ctx;
                        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
                        else if (config.longStackTraces && (ctx = Promise1._peekContext())) ctx.attachExtraTrace(warning);
                        else {
                            var parsed = parseStackAndMessage(warning);
                            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                        }
                        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
                    }
                    function reconstructStack(message, stacks) {
                        for(var i = 0; i < stacks.length - 1; ++i){
                            stacks[i].push("From previous event:");
                            stacks[i] = stacks[i].join("\n");
                        }
                        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
                        return message + "\n" + stacks.join("\n");
                    }
                    function removeDuplicateOrEmptyJumps(stacks) {
                        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                            stacks.splice(i, 1);
                            i--;
                        }
                    }
                    function removeCommonRoots(stacks) {
                        var current = stacks[0];
                        for(var i = 1; i < stacks.length; ++i){
                            var prev = stacks[i];
                            var currentLastIndex = current.length - 1;
                            var currentLastLine = current[currentLastIndex];
                            var commonRootMeetPoint = -1;
                            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                                commonRootMeetPoint = j;
                                break;
                            }
                            for(var j = commonRootMeetPoint; j >= 0; --j){
                                var line = prev[j];
                                if (current[currentLastIndex] === line) {
                                    current.pop();
                                    currentLastIndex--;
                                } else break;
                            }
                            current = prev;
                        }
                    }
                    function cleanStack(stack) {
                        var ret = [];
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                            var isInternalFrame = isTraceLine && shouldIgnore(line);
                            if (isTraceLine && !isInternalFrame) {
                                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                                ret.push(line);
                            }
                        }
                        return ret;
                    }
                    function stackFramesAsArray(error) {
                        var stack = error.stack.replace(/\s+$/g, "").split("\n");
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
                        }
                        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
                        return stack;
                    }
                    function parseStackAndMessage(error) {
                        var stack = error.stack;
                        var message = error.toString();
                        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
                            "    (No stack trace)"
                        ];
                        return {
                            message: message,
                            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
                        };
                    }
                    function formatAndLogError(error, title, isSoft) {
                        if (typeof console !== "undefined") {
                            var message;
                            if (util.isObject(error)) {
                                var stack = error.stack;
                                message = title + formatStack(stack, error);
                            } else message = title + String(error);
                            if (typeof printWarning === "function") printWarning(message, isSoft);
                            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
                        }
                    }
                    function fireRejectionEvent(name, localHandler, reason, promise) {
                        var localEventFired = false;
                        try {
                            if (typeof localHandler === "function") {
                                localEventFired = true;
                                if (name === "rejectionHandled") localHandler(promise);
                                else localHandler(reason, promise);
                            }
                        } catch (e) {
                            async.throwLater(e);
                        }
                        if (name === "unhandledRejection") {
                            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
                        } else activeFireEvent(name, promise);
                    }
                    function formatNonError(obj) {
                        var str;
                        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
                        else {
                            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                            if (ruselessToString.test(str)) try {
                                var newStr = JSON.stringify(obj);
                                str = newStr;
                            } catch (e) {}
                            if (str.length === 0) str = "(empty array)";
                        }
                        return "(<" + snip(str) + ">, no stack trace)";
                    }
                    function snip(str) {
                        var maxChars = 41;
                        if (str.length < maxChars) return str;
                        return str.substr(0, maxChars - 3) + "...";
                    }
                    function longStackTracesIsSupported() {
                        return typeof captureStackTrace === "function";
                    }
                    var shouldIgnore = function() {
                        return false;
                    };
                    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    function parseLineInfo(line) {
                        var matches = line.match(parseLineInfoRegex);
                        if (matches) return {
                            fileName: matches[1],
                            line: parseInt(matches[2], 10)
                        };
                    }
                    function setBounds(firstLineError, lastLineError) {
                        if (!longStackTracesIsSupported()) return;
                        var firstStackLines = (firstLineError.stack || "").split("\n");
                        var lastStackLines = (lastLineError.stack || "").split("\n");
                        var firstIndex = -1;
                        var lastIndex = -1;
                        var firstFileName;
                        var lastFileName;
                        for(var i = 0; i < firstStackLines.length; ++i){
                            var result = parseLineInfo(firstStackLines[i]);
                            if (result) {
                                firstFileName = result.fileName;
                                firstIndex = result.line;
                                break;
                            }
                        }
                        for(var i = 0; i < lastStackLines.length; ++i){
                            var result = parseLineInfo(lastStackLines[i]);
                            if (result) {
                                lastFileName = result.fileName;
                                lastIndex = result.line;
                                break;
                            }
                        }
                        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
                        shouldIgnore = function(line) {
                            if (bluebirdFramePattern.test(line)) return true;
                            var info = parseLineInfo(line);
                            if (info) {
                                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
                            }
                            return false;
                        };
                    }
                    function CapturedTrace(parent) {
                        this._parent = parent;
                        this._promisesCreated = 0;
                        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
                        captureStackTrace(this, CapturedTrace);
                        if (length > 32) this.uncycle();
                    }
                    util.inherits(CapturedTrace, Error);
                    Context.CapturedTrace = CapturedTrace;
                    CapturedTrace.prototype.uncycle = function() {
                        var length = this._length;
                        if (length < 2) return;
                        var nodes = [];
                        var stackToIndex = {};
                        for(var i = 0, node = this; node !== undefined; ++i){
                            nodes.push(node);
                            node = node._parent;
                        }
                        length = this._length = i;
                        for(var i = length - 1; i >= 0; --i){
                            var stack = nodes[i].stack;
                            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
                        }
                        for(var i = 0; i < length; ++i){
                            var currentStack = nodes[i].stack;
                            var index = stackToIndex[currentStack];
                            if (index !== undefined && index !== i) {
                                if (index > 0) {
                                    nodes[index - 1]._parent = undefined;
                                    nodes[index - 1]._length = 1;
                                }
                                nodes[i]._parent = undefined;
                                nodes[i]._length = 1;
                                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                if (index < length - 1) {
                                    cycleEdgeNode._parent = nodes[index + 1];
                                    cycleEdgeNode._parent.uncycle();
                                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                } else {
                                    cycleEdgeNode._parent = undefined;
                                    cycleEdgeNode._length = 1;
                                }
                                var currentChildLength = cycleEdgeNode._length + 1;
                                for(var j = i - 2; j >= 0; --j){
                                    nodes[j]._length = currentChildLength;
                                    currentChildLength++;
                                }
                                return;
                            }
                        }
                    };
                    CapturedTrace.prototype.attachExtraTrace = function(error) {
                        if (error.__stackCleaned__) return;
                        this.uncycle();
                        var parsed = parseStackAndMessage(error);
                        var message = parsed.message;
                        var stacks = [
                            parsed.stack
                        ];
                        var trace = this;
                        while(trace !== undefined){
                            stacks.push(cleanStack(trace.stack.split("\n")));
                            trace = trace._parent;
                        }
                        removeCommonRoots(stacks);
                        removeDuplicateOrEmptyJumps(stacks);
                        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                        util.notEnumerableProp(error, "__stackCleaned__", true);
                    };
                    var captureStackTrace = function stackDetection() {
                        var v8stackFramePattern = /^\s*at\s*/;
                        var v8stackFormatter = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if (error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                            Error.stackTraceLimit += 6;
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            var captureStackTrace = Error.captureStackTrace;
                            shouldIgnore = function(line) {
                                return bluebirdFramePattern.test(line);
                            };
                            return function(receiver, ignoreUntil) {
                                Error.stackTraceLimit += 6;
                                captureStackTrace(receiver, ignoreUntil);
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        var err = new Error();
                        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            stackFramePattern = /@/;
                            formatStack = v8stackFormatter;
                            indentStackFrames = true;
                            return function captureStackTrace(o) {
                                o.stack = new Error().stack;
                            };
                        }
                        var hasStackAfterThrow;
                        try {
                            throw new Error();
                        } catch (e) {
                            hasStackAfterThrow = "stack" in e;
                        }
                        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            return function captureStackTrace(o) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error();
                                } catch (e) {
                                    o.stack = e.stack;
                                }
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        formatStack = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        return null;
                    }([]);
                    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                        printWarning = function(message) {
                            console.warn(message);
                        };
                        if (util.isNode && process.stderr.isTTY) printWarning = function(message, isSoft) {
                            var color = isSoft ? "\x1b[33m" : "\x1b[31m";
                            console.warn(color + message + "\x1b[0m\n");
                        };
                        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
                            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                        };
                    }
                    var config = {
                        warnings: warnings,
                        longStackTraces: false,
                        cancellation: false,
                        monitoring: false,
                        asyncHooks: false
                    };
                    if (longStackTraces) Promise1.longStackTraces();
                    return {
                        asyncHooks: function() {
                            return config.asyncHooks;
                        },
                        longStackTraces: function() {
                            return config.longStackTraces;
                        },
                        warnings: function() {
                            return config.warnings;
                        },
                        cancellation: function() {
                            return config.cancellation;
                        },
                        monitoring: function() {
                            return config.monitoring;
                        },
                        propagateFromFunction: function() {
                            return propagateFromFunction;
                        },
                        boundValueFunction: function() {
                            return boundValueFunction;
                        },
                        checkForgottenReturns: checkForgottenReturns,
                        setBounds: setBounds,
                        warn: warn,
                        deprecated: deprecated,
                        CapturedTrace: CapturedTrace,
                        fireDomEvent: fireDomEvent,
                        fireGlobalEvent: fireGlobalEvent
                    };
                };
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        10: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function returner() {
                        return this.value;
                    }
                    function thrower() {
                        throw this.reason;
                    }
                    Promise1.prototype["return"] = Promise1.prototype.thenReturn = function(value) {
                        if (value instanceof Promise1) value.suppressUnhandledRejections();
                        return this._then(returner, undefined, undefined, {
                            value: value
                        }, undefined);
                    };
                    Promise1.prototype["throw"] = Promise1.prototype.thenThrow = function(reason) {
                        return this._then(thrower, undefined, undefined, {
                            reason: reason
                        }, undefined);
                    };
                    Promise1.prototype.catchThrow = function(reason) {
                        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
                            reason: reason
                        }, undefined);
                        else {
                            var _reason = arguments[1];
                            var handler = function() {
                                throw _reason;
                            };
                            return this.caught(reason, handler);
                        }
                    };
                    Promise1.prototype.catchReturn = function(value) {
                        if (arguments.length <= 1) {
                            if (value instanceof Promise1) value.suppressUnhandledRejections();
                            return this._then(undefined, returner, undefined, {
                                value: value
                            }, undefined);
                        } else {
                            var _value = arguments[1];
                            if (_value instanceof Promise1) _value.suppressUnhandledRejections();
                            var handler = function() {
                                return _value;
                            };
                            return this.caught(value, handler);
                        }
                    };
                };
            },
            {}
        ],
        11: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseReduce = Promise1.reduce;
                    var PromiseAll = Promise1.all;
                    function promiseAllThis() {
                        return PromiseAll(this);
                    }
                    function PromiseMapSeries(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                    }
                    Promise1.prototype.each = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                    };
                    Promise1.prototype.mapSeries = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                    };
                    Promise1.each = function(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                    };
                    Promise1.mapSeries = PromiseMapSeries;
                };
            },
            {}
        ],
        12: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var Objectfreeze = es5.freeze;
                var util = _dereq_1("./util");
                var inherits = util.inherits;
                var notEnumerableProp = util.notEnumerableProp;
                function subError(nameProperty, defaultMessage) {
                    function SubError(message) {
                        if (!(this instanceof SubError)) return new SubError(message);
                        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                        notEnumerableProp(this, "name", nameProperty);
                        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        else Error.call(this);
                    }
                    inherits(SubError, Error);
                    return SubError;
                }
                var _TypeError, _RangeError;
                var Warning = subError("Warning", "warning");
                var CancellationError = subError("CancellationError", "cancellation error");
                var TimeoutError = subError("TimeoutError", "timeout error");
                var AggregateError = subError("AggregateError", "aggregate error");
                try {
                    _TypeError = TypeError;
                    _RangeError = RangeError;
                } catch (e) {
                    _TypeError = subError("TypeError", "type error");
                    _RangeError = subError("RangeError", "range error");
                }
                var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
                for(var i = 0; i < methods.length; ++i)if (typeof Array.prototype[methods[i]] === "function") AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                es5.defineProperty(AggregateError.prototype, "length", {
                    value: 0,
                    configurable: false,
                    writable: true,
                    enumerable: true
                });
                AggregateError.prototype["isOperational"] = true;
                var level = 0;
                AggregateError.prototype.toString = function() {
                    var indent = Array(level * 4 + 1).join(" ");
                    var ret = "\n" + indent + "AggregateError of:" + "\n";
                    level++;
                    indent = Array(level * 4 + 1).join(" ");
                    for(var i = 0; i < this.length; ++i){
                        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                        var lines = str.split("\n");
                        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
                        str = lines.join("\n");
                        ret += str + "\n";
                    }
                    level--;
                    return ret;
                };
                function OperationalError(message) {
                    if (!(this instanceof OperationalError)) return new OperationalError(message);
                    notEnumerableProp(this, "name", "OperationalError");
                    notEnumerableProp(this, "message", message);
                    this.cause = message;
                    this["isOperational"] = true;
                    if (message instanceof Error) {
                        notEnumerableProp(this, "message", message.message);
                        notEnumerableProp(this, "stack", message.stack);
                    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                }
                inherits(OperationalError, Error);
                var errorTypes = Error["__BluebirdErrorTypes__"];
                if (!errorTypes) {
                    errorTypes = Objectfreeze({
                        CancellationError: CancellationError,
                        TimeoutError: TimeoutError,
                        OperationalError: OperationalError,
                        RejectionError: OperationalError,
                        AggregateError: AggregateError
                    });
                    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: errorTypes,
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
                module1.exports = {
                    Error: Error,
                    TypeError: _TypeError,
                    RangeError: _RangeError,
                    CancellationError: errorTypes.CancellationError,
                    OperationalError: errorTypes.OperationalError,
                    TimeoutError: errorTypes.TimeoutError,
                    AggregateError: errorTypes.AggregateError,
                    Warning: Warning
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        13: [
            function(_dereq_1, module1, exports) {
                var isES5 = function() {
                    "use strict";
                    return this === undefined;
                }();
                if (isES5) module1.exports = {
                    freeze: Object.freeze,
                    defineProperty: Object.defineProperty,
                    getDescriptor: Object.getOwnPropertyDescriptor,
                    keys: Object.keys,
                    names: Object.getOwnPropertyNames,
                    getPrototypeOf: Object.getPrototypeOf,
                    isArray: Array.isArray,
                    isES5: isES5,
                    propertyIsWritable: function(obj, prop) {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                        return !!(!descriptor || descriptor.writable || descriptor.set);
                    }
                };
                else {
                    var has = {}.hasOwnProperty;
                    var str = {}.toString;
                    var proto = {}.constructor.prototype;
                    var ObjectKeys = function(o) {
                        var ret = [];
                        for(var key in o)if (has.call(o, key)) ret.push(key);
                        return ret;
                    };
                    var ObjectGetDescriptor = function(o, key) {
                        return {
                            value: o[key]
                        };
                    };
                    var ObjectDefineProperty = function(o, key, desc) {
                        o[key] = desc.value;
                        return o;
                    };
                    var ObjectFreeze = function(obj) {
                        return obj;
                    };
                    var ObjectGetPrototypeOf = function(obj) {
                        try {
                            return Object(obj).constructor.prototype;
                        } catch (e) {
                            return proto;
                        }
                    };
                    var ArrayIsArray = function(obj) {
                        try {
                            return str.call(obj) === "[object Array]";
                        } catch (e) {
                            return false;
                        }
                    };
                    module1.exports = {
                        isArray: ArrayIsArray,
                        keys: ObjectKeys,
                        names: ObjectKeys,
                        defineProperty: ObjectDefineProperty,
                        getDescriptor: ObjectGetDescriptor,
                        freeze: ObjectFreeze,
                        getPrototypeOf: ObjectGetPrototypeOf,
                        isES5: isES5,
                        propertyIsWritable: function() {
                            return true;
                        }
                    };
                }
            },
            {}
        ],
        14: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseMap = Promise1.map;
                    Promise1.prototype.filter = function(fn, options) {
                        return PromiseMap(this, fn, options, INTERNAL);
                    };
                    Promise1.filter = function(promises, fn, options) {
                        return PromiseMap(promises, fn, options, INTERNAL);
                    };
                };
            },
            {}
        ],
        15: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, tryConvertToPromise, NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var CancellationError = Promise1.CancellationError;
                    var errorObj = util.errorObj;
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    function PassThroughHandlerContext(promise, type, handler) {
                        this.promise = promise;
                        this.type = type;
                        this.handler = handler;
                        this.called = false;
                        this.cancelPromise = null;
                    }
                    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
                        return this.type === 0;
                    };
                    function FinallyHandlerCancelReaction(finallyHandler) {
                        this.finallyHandler = finallyHandler;
                    }
                    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
                        checkCancel(this.finallyHandler);
                    };
                    function checkCancel(ctx, reason) {
                        if (ctx.cancelPromise != null) {
                            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
                            else ctx.cancelPromise._cancel();
                            ctx.cancelPromise = null;
                            return true;
                        }
                        return false;
                    }
                    function succeed() {
                        return finallyHandler.call(this, this.promise._target()._settledValue());
                    }
                    function fail(reason) {
                        if (checkCancel(this, reason)) return;
                        errorObj.e = reason;
                        return errorObj;
                    }
                    function finallyHandler(reasonOrValue) {
                        var promise = this.promise;
                        var handler = this.handler;
                        if (!this.called) {
                            this.called = true;
                            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                            if (ret === NEXT_FILTER) return ret;
                            else if (ret !== undefined) {
                                promise._setReturnedNonUndefined();
                                var maybePromise = tryConvertToPromise(ret, promise);
                                if (maybePromise instanceof Promise1) {
                                    if (this.cancelPromise != null) {
                                        if (maybePromise._isCancelled()) {
                                            var reason = new CancellationError("late cancellation observer");
                                            promise._attachExtraTrace(reason);
                                            errorObj.e = reason;
                                            return errorObj;
                                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                    }
                                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                                }
                            }
                        }
                        if (promise.isRejected()) {
                            checkCancel(this);
                            errorObj.e = reasonOrValue;
                            return errorObj;
                        } else {
                            checkCancel(this);
                            return reasonOrValue;
                        }
                    }
                    Promise1.prototype._passThrough = function(handler, type, success, fail) {
                        if (typeof handler !== "function") return this.then();
                        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                    };
                    Promise1.prototype.lastly = Promise1.prototype["finally"] = function(handler) {
                        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                    };
                    Promise1.prototype.tap = function(handler) {
                        return this._passThrough(handler, 1, finallyHandler);
                    };
                    Promise1.prototype.tapCatch = function(handlerOrPredicate) {
                        var len = arguments.length;
                        if (len === 1) return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                        else {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return Promise1.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                            }
                            catchInstances.length = j;
                            var handler = arguments[i];
                            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                        }
                    };
                    return PassThroughHandlerContext;
                };
            },
            {
                "./catch_filter": 7,
                "./util": 36
            }
        ],
        16: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                    var errors = _dereq_1("./errors");
                    var TypeError1 = errors.TypeError;
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var yieldHandlers = [];
                    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                        for(var i = 0; i < yieldHandlers.length; ++i){
                            traceParent._pushContext();
                            var result = tryCatch(yieldHandlers[i])(value);
                            traceParent._popContext();
                            if (result === errorObj) {
                                traceParent._pushContext();
                                var ret = Promise1.reject(errorObj.e);
                                traceParent._popContext();
                                return ret;
                            }
                            var maybePromise = tryConvertToPromise(result, traceParent);
                            if (maybePromise instanceof Promise1) return maybePromise;
                        }
                        return null;
                    }
                    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                        if (debug.cancellation()) {
                            var internal = new Promise1(INTERNAL);
                            var _finallyPromise = this._finallyPromise = new Promise1(INTERNAL);
                            this._promise = internal.lastly(function() {
                                return _finallyPromise;
                            });
                            internal._captureStackTrace();
                            internal._setOnCancel(this);
                        } else {
                            var promise = this._promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                        }
                        this._stack = stack;
                        this._generatorFunction = generatorFunction;
                        this._receiver = receiver;
                        this._generator = undefined;
                        this._yieldHandlers = typeof yieldHandler === "function" ? [
                            yieldHandler
                        ].concat(yieldHandlers) : yieldHandlers;
                        this._yieldedPromise = null;
                        this._cancellationPhase = false;
                    }
                    util.inherits(PromiseSpawn, Proxyable);
                    PromiseSpawn.prototype._isResolved = function() {
                        return this._promise === null;
                    };
                    PromiseSpawn.prototype._cleanup = function() {
                        this._promise = this._generator = null;
                        if (debug.cancellation() && this._finallyPromise !== null) {
                            this._finallyPromise._fulfill();
                            this._finallyPromise = null;
                        }
                    };
                    PromiseSpawn.prototype._promiseCancelled = function() {
                        if (this._isResolved()) return;
                        var implementsReturn = typeof this._generator["return"] !== "undefined";
                        var result;
                        if (!implementsReturn) {
                            var reason = new Promise1.CancellationError("generator .return() sentinel");
                            Promise1.coroutine.returnSentinel = reason;
                            this._promise._attachExtraTrace(reason);
                            this._promise._pushContext();
                            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                            this._promise._popContext();
                        } else {
                            this._promise._pushContext();
                            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                            this._promise._popContext();
                        }
                        this._cancellationPhase = true;
                        this._yieldedPromise = null;
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseFulfilled = function(value) {
                        this._yieldedPromise = null;
                        this._promise._pushContext();
                        var result = tryCatch(this._generator.next).call(this._generator, value);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseRejected = function(reason) {
                        this._yieldedPromise = null;
                        this._promise._attachExtraTrace(reason);
                        this._promise._pushContext();
                        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._resultCancelled = function() {
                        if (this._yieldedPromise instanceof Promise1) {
                            var promise = this._yieldedPromise;
                            this._yieldedPromise = null;
                            promise.cancel();
                        }
                    };
                    PromiseSpawn.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseSpawn.prototype._run = function() {
                        this._generator = this._generatorFunction.call(this._receiver);
                        this._receiver = this._generatorFunction = undefined;
                        this._promiseFulfilled(undefined);
                    };
                    PromiseSpawn.prototype._continue = function(result) {
                        var promise = this._promise;
                        if (result === errorObj) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._rejectCallback(result.e, false);
                        }
                        var value = result.value;
                        if (result.done === true) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._resolveCallback(value);
                        } else {
                            var maybePromise = tryConvertToPromise(value, this._promise);
                            if (!(maybePromise instanceof Promise1)) {
                                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                if (maybePromise === null) {
                                    this._promiseRejected(new TypeError1("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
                                    return;
                                }
                            }
                            maybePromise = maybePromise._target();
                            var bitField = maybePromise._bitField;
                            if ((bitField & 50397184) === 0) {
                                this._yieldedPromise = maybePromise;
                                maybePromise._proxy(this, null);
                            } else if ((bitField & 33554432) !== 0) Promise1._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                            else if ((bitField & 16777216) !== 0) Promise1._async.invoke(this._promiseRejected, this, maybePromise._reason());
                            else this._promiseCancelled();
                        }
                    };
                    Promise1.coroutine = function(generatorFunction, options) {
                        if (typeof generatorFunction !== "function") throw new TypeError1("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                        var yieldHandler = Object(options).yieldHandler;
                        var PromiseSpawn$ = PromiseSpawn;
                        var stack = new Error().stack;
                        return function() {
                            var generator = generatorFunction.apply(this, arguments);
                            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                            var ret = spawn.promise();
                            spawn._generator = generator;
                            spawn._promiseFulfilled(undefined);
                            return ret;
                        };
                    };
                    Promise1.coroutine.addYieldHandler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        yieldHandlers.push(fn);
                    };
                    Promise1.spawn = function(generatorFunction) {
                        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                        var spawn = new PromiseSpawn(generatorFunction, this);
                        var ret = spawn.promise();
                        spawn._run(Promise1.spawn);
                        return ret;
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        17: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var reject;
                    var thenCallback, promiseSetter, generateHolderClass, holderClasses, thenCallbacks, promiseSetters, i;
                    Promise1.join = function() {
                        var last = arguments.length - 1;
                        var fn;
                        if (last > 0 && typeof arguments[last] === "function") {
                            fn = arguments[last];
                            var ret, HolderClass, holder, callbacks, i, maybePromise, bitField, context;
                        }
                        var args = [].slice.call(arguments);
                        if (fn) args.pop();
                        var ret = new PromiseArray(args).promise();
                        return fn !== undefined ? ret.spread(fn) : ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        18: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    function MappingPromiseArray(promises, fn, limit, _filter) {
                        this.constructor$(promises);
                        this._promise._captureStackTrace();
                        var context = Promise1._getContext();
                        this._callback = util.contextBind(context, fn);
                        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                        this._limit = limit;
                        this._inFlight = 0;
                        this._queue = [];
                        async.invoke(this._asyncInit, this, undefined);
                        if (util.isArray(promises)) for(var i = 0; i < promises.length; ++i){
                            var maybePromise = promises[i];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                    }
                    util.inherits(MappingPromiseArray, PromiseArray);
                    MappingPromiseArray.prototype._asyncInit = function() {
                        this._init$(undefined, -2);
                    };
                    MappingPromiseArray.prototype._init = function() {};
                    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var values = this._values;
                        var length = this.length();
                        var preservedValues = this._preservedValues;
                        var limit = this._limit;
                        if (index < 0) {
                            index = index * -1 - 1;
                            values[index] = value;
                            if (limit >= 1) {
                                this._inFlight--;
                                this._drainQueue();
                                if (this._isResolved()) return true;
                            }
                        } else {
                            if (limit >= 1 && this._inFlight >= limit) {
                                values[index] = value;
                                this._queue.push(index);
                                return false;
                            }
                            if (preservedValues !== null) preservedValues[index] = value;
                            var promise = this._promise;
                            var callback = this._callback;
                            var receiver = promise._boundValue();
                            promise._pushContext();
                            var ret = tryCatch(callback).call(receiver, value, index, length);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                            if (ret === errorObj) {
                                this._reject(ret.e);
                                return true;
                            }
                            var maybePromise = tryConvertToPromise(ret, this._promise);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                var bitField = maybePromise._bitField;
                                if ((bitField & 50397184) === 0) {
                                    if (limit >= 1) this._inFlight++;
                                    values[index] = maybePromise;
                                    maybePromise._proxy(this, (index + 1) * -1);
                                    return false;
                                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                                else if ((bitField & 16777216) !== 0) {
                                    this._reject(maybePromise._reason());
                                    return true;
                                } else {
                                    this._cancel();
                                    return true;
                                }
                            }
                            values[index] = ret;
                        }
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= length) {
                            if (preservedValues !== null) this._filter(values, preservedValues);
                            else this._resolve(values);
                            return true;
                        }
                        return false;
                    };
                    MappingPromiseArray.prototype._drainQueue = function() {
                        var queue = this._queue;
                        var limit = this._limit;
                        var values = this._values;
                        while(queue.length > 0 && this._inFlight < limit){
                            if (this._isResolved()) return;
                            var index = queue.pop();
                            this._promiseFulfilled(values[index], index);
                        }
                    };
                    MappingPromiseArray.prototype._filter = function(booleans, values) {
                        var len = values.length;
                        var ret = new Array(len);
                        var j = 0;
                        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
                        ret.length = j;
                        this._resolve(ret);
                    };
                    MappingPromiseArray.prototype.preservedValues = function() {
                        return this._preservedValues;
                    };
                    function map(promises, fn, options, _filter) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var limit = 0;
                        if (options !== undefined) {
                            if (typeof options === "object" && options !== null) {
                                if (typeof options.concurrency !== "number") return Promise1.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                limit = options.concurrency;
                            } else return Promise1.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                        }
                        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                    }
                    Promise1.prototype.map = function(fn, options) {
                        return map(this, fn, options, null);
                    };
                    Promise1.map = function(promises, fn, options, _filter) {
                        return map(promises, fn, options, _filter);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        19: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    Promise1.method = function(fn) {
                        if (typeof fn !== "function") throw new Promise1.TypeError("expecting a function but got " + util.classString(fn));
                        return function() {
                            var ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._pushContext();
                            var value = tryCatch(fn).apply(this, arguments);
                            var promiseCreated = ret._popContext();
                            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                            ret._resolveFromSyncValue(value);
                            return ret;
                        };
                    };
                    Promise1.attempt = Promise1["try"] = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._pushContext();
                        var value;
                        if (arguments.length > 1) {
                            debug.deprecated("calling Promise.try with more than 1 argument");
                            var arg = arguments[1];
                            var ctx = arguments[2];
                            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                        } else value = tryCatch(fn)();
                        var promiseCreated = ret._popContext();
                        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                        ret._resolveFromSyncValue(value);
                        return ret;
                    };
                    Promise1.prototype._resolveFromSyncValue = function(value) {
                        if (value === util.errorObj) this._rejectCallback(value.e, false);
                        else this._resolveCallback(value, true);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        20: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var maybeWrapAsError = util.maybeWrapAsError;
                var errors = _dereq_1("./errors");
                var OperationalError = errors.OperationalError;
                var es5 = _dereq_1("./es5");
                function isUntypedError(obj) {
                    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                }
                var rErrorKey = /^(?:name|message|stack|cause)$/;
                function wrapAsOperationalError(obj) {
                    var ret;
                    if (isUntypedError(obj)) {
                        ret = new OperationalError(obj);
                        ret.name = obj.name;
                        ret.message = obj.message;
                        ret.stack = obj.stack;
                        var keys = es5.keys(obj);
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            if (!rErrorKey.test(key)) ret[key] = obj[key];
                        }
                        return ret;
                    }
                    util.markAsOriginatingFromRejection(obj);
                    return obj;
                }
                function nodebackForPromise(promise, multiArgs) {
                    return function(err, value) {
                        if (promise === null) return;
                        if (err) {
                            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                            promise._attachExtraTrace(wrapped);
                            promise._reject(wrapped);
                        } else if (!multiArgs) promise._fulfill(value);
                        else {
                            var args = [].slice.call(arguments, 1);
                            promise._fulfill(args);
                        }
                        promise = null;
                    };
                }
                module1.exports = nodebackForPromise;
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        21: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var async = Promise1._async;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function spreadAdapter(val, nodeback) {
                        var promise = this;
                        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
                            null
                        ].concat(val));
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function successAdapter(val, nodeback) {
                        var promise = this;
                        var receiver = promise._boundValue();
                        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function errorAdapter(reason, nodeback) {
                        var promise = this;
                        if (!reason) {
                            var newReason = new Error(reason + "");
                            newReason.cause = reason;
                            reason = newReason;
                        }
                        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    Promise1.prototype.asCallback = Promise1.prototype.nodeify = function(nodeback, options) {
                        if (typeof nodeback == "function") {
                            var adapter = successAdapter;
                            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
                            this._then(adapter, errorAdapter, undefined, this, nodeback);
                        }
                        return this;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        22: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function() {
                    var makeSelfResolutionError = function() {
                        return new TypeError1("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
                    };
                    var reflectHandler = function() {
                        return new Promise1.PromiseInspection(this._target());
                    };
                    var apiRejection = function(msg) {
                        return Promise1.reject(new TypeError1(msg));
                    };
                    function Proxyable() {}
                    var UNDEFINED_BINDING = {};
                    var util = _dereq_1("./util");
                    util.setReflectHandler(reflectHandler);
                    var getDomain = function() {
                        var domain = process.domain;
                        if (domain === undefined) return null;
                        return domain;
                    };
                    var getContextDefault = function() {
                        return null;
                    };
                    var getContextDomain = function() {
                        return {
                            domain: getDomain(),
                            async: null
                        };
                    };
                    var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_1("async_hooks").AsyncResource : null;
                    var getContextAsyncHooks = function() {
                        return {
                            domain: getDomain(),
                            async: new AsyncResource("Bluebird::Promise")
                        };
                    };
                    var getContext = util.isNode ? getContextDomain : getContextDefault;
                    util.notEnumerableProp(Promise1, "_getContext", getContext);
                    var enableAsyncHooks = function() {
                        getContext = getContextAsyncHooks;
                        util.notEnumerableProp(Promise1, "_getContext", getContextAsyncHooks);
                    };
                    var disableAsyncHooks = function() {
                        getContext = getContextDomain;
                        util.notEnumerableProp(Promise1, "_getContext", getContextDomain);
                    };
                    var es5 = _dereq_1("./es5");
                    var Async = _dereq_1("./async");
                    var async = new Async();
                    es5.defineProperty(Promise1, "_async", {
                        value: async
                    });
                    var errors = _dereq_1("./errors");
                    var TypeError1 = Promise1.TypeError = errors.TypeError;
                    Promise1.RangeError = errors.RangeError;
                    var CancellationError = Promise1.CancellationError = errors.CancellationError;
                    Promise1.TimeoutError = errors.TimeoutError;
                    Promise1.OperationalError = errors.OperationalError;
                    Promise1.RejectionError = errors.OperationalError;
                    Promise1.AggregateError = errors.AggregateError;
                    var INTERNAL = function() {};
                    var APPLY = {};
                    var NEXT_FILTER = {};
                    var tryConvertToPromise = _dereq_1("./thenables")(Promise1, INTERNAL);
                    var PromiseArray = _dereq_1("./promise_array")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                    var Context = _dereq_1("./context")(Promise1);
                    /*jshint unused:false*/ var createContext = Context.create;
                    var debug = _dereq_1("./debuggability")(Promise1, Context, enableAsyncHooks, disableAsyncHooks);
                    var CapturedTrace = debug.CapturedTrace;
                    var PassThroughHandlerContext = _dereq_1("./finally")(Promise1, tryConvertToPromise, NEXT_FILTER);
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    function check(self1, executor) {
                        if (self1 == null || self1.constructor !== Promise1) throw new TypeError1("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                        if (typeof executor !== "function") throw new TypeError1("expecting a function but got " + util.classString(executor));
                    }
                    function Promise1(executor) {
                        if (executor !== INTERNAL) check(this, executor);
                        this._bitField = 0;
                        this._fulfillmentHandler0 = undefined;
                        this._rejectionHandler0 = undefined;
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._resolveFromExecutor(executor);
                        this._promiseCreated();
                        this._fireEvent("promiseCreated", this);
                    }
                    Promise1.prototype.toString = function() {
                        return "[object Promise]";
                    };
                    Promise1.prototype.caught = Promise1.prototype["catch"] = function(fn) {
                        var len = arguments.length;
                        if (len > 1) {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                            }
                            catchInstances.length = j;
                            fn = arguments[i];
                            if (typeof fn !== "function") throw new TypeError1("The last argument to .catch() must be a function, got " + util.toString(fn));
                            return this.then(undefined, catchFilter(catchInstances, fn, this));
                        }
                        return this.then(undefined, fn);
                    };
                    Promise1.prototype.reflect = function() {
                        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                    };
                    Promise1.prototype.then = function(didFulfill, didReject) {
                        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                            if (arguments.length > 1) msg += ", " + util.classString(didReject);
                            this._warn(msg);
                        }
                        return this._then(didFulfill, didReject, undefined, undefined, undefined);
                    };
                    Promise1.prototype.done = function(didFulfill, didReject) {
                        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                        promise._setIsFinal();
                    };
                    Promise1.prototype.spread = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                    };
                    Promise1.prototype.toJSON = function() {
                        var ret = {
                            isFulfilled: false,
                            isRejected: false,
                            fulfillmentValue: undefined,
                            rejectionReason: undefined
                        };
                        if (this.isFulfilled()) {
                            ret.fulfillmentValue = this.value();
                            ret.isFulfilled = true;
                        } else if (this.isRejected()) {
                            ret.rejectionReason = this.reason();
                            ret.isRejected = true;
                        }
                        return ret;
                    };
                    Promise1.prototype.all = function() {
                        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
                        return new PromiseArray(this).promise();
                    };
                    Promise1.prototype.error = function(fn) {
                        return this.caught(util.originatesFromRejection, fn);
                    };
                    Promise1.getNewLibraryCopy = module1.exports;
                    Promise1.is = function(val) {
                        return val instanceof Promise1;
                    };
                    Promise1.fromNode = Promise1.fromCallback = function(fn) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                        if (result === errorObj) ret._rejectCallback(result.e, true);
                        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.all = function(promises) {
                        return new PromiseArray(promises).promise();
                    };
                    Promise1.cast = function(obj) {
                        var ret = tryConvertToPromise(obj);
                        if (!(ret instanceof Promise1)) {
                            ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._setFulfilled();
                            ret._rejectionHandler0 = obj;
                        }
                        return ret;
                    };
                    Promise1.resolve = Promise1.fulfilled = Promise1.cast;
                    Promise1.reject = Promise1.rejected = function(reason) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._rejectCallback(reason, true);
                        return ret;
                    };
                    Promise1.setScheduler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        return async.setScheduler(fn);
                    };
                    Promise1.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
                        var haveInternalData = internalData !== undefined;
                        var promise = haveInternalData ? internalData : new Promise1(INTERNAL);
                        var target = this._target();
                        var bitField = target._bitField;
                        if (!haveInternalData) {
                            promise._propagateFrom(this, 3);
                            promise._captureStackTrace();
                            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                                else receiver = target === this ? undefined : this._boundTo;
                            }
                            this._fireEvent("promiseChained", this, promise);
                        }
                        var context = getContext();
                        if (!((bitField & 50397184) === 0)) {
                            var handler, value, settler = target._settlePromiseCtx;
                            if ((bitField & 33554432) !== 0) {
                                value = target._rejectionHandler0;
                                handler = didFulfill;
                            } else if ((bitField & 16777216) !== 0) {
                                value = target._fulfillmentHandler0;
                                handler = didReject;
                                target._unsetRejectionIsUnhandled();
                            } else {
                                settler = target._settlePromiseLateCancellationObserver;
                                value = new CancellationError("late cancellation observer");
                                target._attachExtraTrace(value);
                                handler = didReject;
                            }
                            async.invoke(settler, target, {
                                handler: util.contextBind(context, handler),
                                promise: promise,
                                receiver: receiver,
                                value: value
                            });
                        } else target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                        return promise;
                    };
                    Promise1.prototype._length = function() {
                        return this._bitField & 65535;
                    };
                    Promise1.prototype._isFateSealed = function() {
                        return (this._bitField & 117506048) !== 0;
                    };
                    Promise1.prototype._isFollowing = function() {
                        return (this._bitField & 67108864) === 67108864;
                    };
                    Promise1.prototype._setLength = function(len) {
                        this._bitField = this._bitField & -65536 | len & 65535;
                    };
                    Promise1.prototype._setFulfilled = function() {
                        this._bitField = this._bitField | 33554432;
                        this._fireEvent("promiseFulfilled", this);
                    };
                    Promise1.prototype._setRejected = function() {
                        this._bitField = this._bitField | 16777216;
                        this._fireEvent("promiseRejected", this);
                    };
                    Promise1.prototype._setFollowing = function() {
                        this._bitField = this._bitField | 67108864;
                        this._fireEvent("promiseResolved", this);
                    };
                    Promise1.prototype._setIsFinal = function() {
                        this._bitField = this._bitField | 4194304;
                    };
                    Promise1.prototype._isFinal = function() {
                        return (this._bitField & 4194304) > 0;
                    };
                    Promise1.prototype._unsetCancelled = function() {
                        this._bitField = this._bitField & -65537;
                    };
                    Promise1.prototype._setCancelled = function() {
                        this._bitField = this._bitField | 65536;
                        this._fireEvent("promiseCancelled", this);
                    };
                    Promise1.prototype._setWillBeCancelled = function() {
                        this._bitField = this._bitField | 8388608;
                    };
                    Promise1.prototype._setAsyncGuaranteed = function() {
                        if (async.hasCustomScheduler()) return;
                        var bitField = this._bitField;
                        this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
                    };
                    Promise1.prototype._setNoAsyncGuarantee = function() {
                        this._bitField = (this._bitField | 536870912) & -134217729;
                    };
                    Promise1.prototype._receiverAt = function(index) {
                        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                        if (ret === UNDEFINED_BINDING) return undefined;
                        else if (ret === undefined && this._isBound()) return this._boundValue();
                        return ret;
                    };
                    Promise1.prototype._promiseAt = function(index) {
                        return this[index * 4 - 4 + 2];
                    };
                    Promise1.prototype._fulfillmentHandlerAt = function(index) {
                        return this[index * 4 - 4 + 0];
                    };
                    Promise1.prototype._rejectionHandlerAt = function(index) {
                        return this[index * 4 - 4 + 1];
                    };
                    Promise1.prototype._boundValue = function() {};
                    Promise1.prototype._migrateCallback0 = function(follower) {
                        var bitField = follower._bitField;
                        var fulfill = follower._fulfillmentHandler0;
                        var reject = follower._rejectionHandler0;
                        var promise = follower._promise0;
                        var receiver = follower._receiverAt(0);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._migrateCallbackAt = function(follower, index) {
                        var fulfill = follower._fulfillmentHandlerAt(index);
                        var reject = follower._rejectionHandlerAt(index);
                        var promise = follower._promiseAt(index);
                        var receiver = follower._receiverAt(index);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._addCallbacks = function(fulfill, reject, promise, receiver, context) {
                        var index = this._length();
                        if (index >= 65531) {
                            index = 0;
                            this._setLength(0);
                        }
                        if (index === 0) {
                            this._promise0 = promise;
                            this._receiver0 = receiver;
                            if (typeof fulfill === "function") this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this._rejectionHandler0 = util.contextBind(context, reject);
                        } else {
                            var base = index * 4 - 4;
                            this[base + 2] = promise;
                            this[base + 3] = receiver;
                            if (typeof fulfill === "function") this[base + 0] = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this[base + 1] = util.contextBind(context, reject);
                        }
                        this._setLength(index + 1);
                        return index;
                    };
                    Promise1.prototype._proxy = function(proxyable, arg) {
                        this._addCallbacks(undefined, undefined, arg, proxyable, null);
                    };
                    Promise1.prototype._resolveCallback = function(value, shouldBind) {
                        if ((this._bitField & 117506048) !== 0) return;
                        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                        var maybePromise = tryConvertToPromise(value, this);
                        if (!(maybePromise instanceof Promise1)) return this._fulfill(value);
                        if (shouldBind) this._propagateFrom(maybePromise, 2);
                        var promise = maybePromise._target();
                        if (promise === this) {
                            this._reject(makeSelfResolutionError());
                            return;
                        }
                        var bitField = promise._bitField;
                        if ((bitField & 50397184) === 0) {
                            var len = this._length();
                            if (len > 0) promise._migrateCallback0(this);
                            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
                            this._setFollowing();
                            this._setLength(0);
                            this._setFollowee(maybePromise);
                        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
                        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
                        else {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            this._reject(reason);
                        }
                    };
                    Promise1.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
                        var trace = util.ensureErrorObject(reason);
                        var hasStack = trace === reason;
                        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                            var message = "a promise was rejected with a non-error: " + util.classString(reason);
                            this._warn(message, true);
                        }
                        this._attachExtraTrace(trace, synchronous ? hasStack : false);
                        this._reject(reason);
                    };
                    Promise1.prototype._resolveFromExecutor = function(executor) {
                        if (executor === INTERNAL) return;
                        var promise = this;
                        this._captureStackTrace();
                        this._pushContext();
                        var synchronous = true;
                        var r = this._execute(executor, function(value) {
                            promise._resolveCallback(value);
                        }, function(reason) {
                            promise._rejectCallback(reason, synchronous);
                        });
                        synchronous = false;
                        this._popContext();
                        if (r !== undefined) promise._rejectCallback(r, true);
                    };
                    Promise1.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
                        var bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        promise._pushContext();
                        var x;
                        if (receiver === APPLY) {
                            if (!value || typeof value.length !== "number") {
                                x = errorObj;
                                x.e = new TypeError1("cannot .spread() a non-array: " + util.classString(value));
                            } else x = tryCatch(handler).apply(this._boundValue(), value);
                        } else x = tryCatch(handler).call(receiver, value);
                        var promiseCreated = promise._popContext();
                        bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        if (x === NEXT_FILTER) promise._reject(value);
                        else if (x === errorObj) promise._rejectCallback(x.e, false);
                        else {
                            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                            promise._resolveCallback(x);
                        }
                    };
                    Promise1.prototype._target = function() {
                        var ret = this;
                        while(ret._isFollowing())ret = ret._followee();
                        return ret;
                    };
                    Promise1.prototype._followee = function() {
                        return this._rejectionHandler0;
                    };
                    Promise1.prototype._setFollowee = function(promise) {
                        this._rejectionHandler0 = promise;
                    };
                    Promise1.prototype._settlePromise = function(promise, handler, receiver, value) {
                        var isPromise = promise instanceof Promise1;
                        var bitField = this._bitField;
                        var asyncGuaranteed = (bitField & 134217728) !== 0;
                        if ((bitField & 65536) !== 0) {
                            if (isPromise) promise._invokeInternalOnCancel();
                            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                receiver.cancelPromise = promise;
                                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
                            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
                            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
                            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
                            else receiver.cancel();
                        } else if (typeof handler === "function") {
                            if (!isPromise) handler.call(receiver, value, promise);
                            else {
                                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                this._settlePromiseFromHandler(handler, receiver, value, promise);
                            }
                        } else if (receiver instanceof Proxyable) {
                            if (!receiver._isResolved()) {
                                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                                else receiver._promiseRejected(value, promise);
                            }
                        } else if (isPromise) {
                            if (asyncGuaranteed) promise._setAsyncGuaranteed();
                            if ((bitField & 33554432) !== 0) promise._fulfill(value);
                            else promise._reject(value);
                        }
                    };
                    Promise1.prototype._settlePromiseLateCancellationObserver = function(ctx) {
                        var handler = ctx.handler;
                        var promise = ctx.promise;
                        var receiver = ctx.receiver;
                        var value = ctx.value;
                        if (typeof handler === "function") {
                            if (!(promise instanceof Promise1)) handler.call(receiver, value, promise);
                            else this._settlePromiseFromHandler(handler, receiver, value, promise);
                        } else if (promise instanceof Promise1) promise._reject(value);
                    };
                    Promise1.prototype._settlePromiseCtx = function(ctx) {
                        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                    };
                    Promise1.prototype._settlePromise0 = function(handler, value, bitField) {
                        var promise = this._promise0;
                        var receiver = this._receiverAt(0);
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._settlePromise(promise, handler, receiver, value);
                    };
                    Promise1.prototype._clearCallbackDataAtIndex = function(index) {
                        var base = index * 4 - 4;
                        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                    };
                    Promise1.prototype._fulfill = function(value) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        if (value === this) {
                            var err = makeSelfResolutionError();
                            this._attachExtraTrace(err);
                            return this._reject(err);
                        }
                        this._setFulfilled();
                        this._rejectionHandler0 = value;
                        if ((bitField & 65535) > 0) {
                            if ((bitField & 134217728) !== 0) this._settlePromises();
                            else async.settlePromises(this);
                            this._dereferenceTrace();
                        }
                    };
                    Promise1.prototype._reject = function(reason) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        this._setRejected();
                        this._fulfillmentHandler0 = reason;
                        if (this._isFinal()) return async.fatalError(reason, util.isNode);
                        if ((bitField & 65535) > 0) async.settlePromises(this);
                        else this._ensurePossibleRejectionHandled();
                    };
                    Promise1.prototype._fulfillPromises = function(len, value) {
                        for(var i = 1; i < len; i++){
                            var handler = this._fulfillmentHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, value);
                        }
                    };
                    Promise1.prototype._rejectPromises = function(len, reason) {
                        for(var i = 1; i < len; i++){
                            var handler = this._rejectionHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, reason);
                        }
                    };
                    Promise1.prototype._settlePromises = function() {
                        var bitField = this._bitField;
                        var len = bitField & 65535;
                        if (len > 0) {
                            if ((bitField & 16842752) !== 0) {
                                var reason = this._fulfillmentHandler0;
                                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                this._rejectPromises(len, reason);
                            } else {
                                var value = this._rejectionHandler0;
                                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                this._fulfillPromises(len, value);
                            }
                            this._setLength(0);
                        }
                        this._clearCancellationData();
                    };
                    Promise1.prototype._settledValue = function() {
                        var bitField = this._bitField;
                        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
                        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
                    };
                    if (typeof Symbol !== "undefined" && Symbol.toStringTag) es5.defineProperty(Promise1.prototype, Symbol.toStringTag, {
                        get: function() {
                            return "Object";
                        }
                    });
                    function deferResolve(v) {
                        this.promise._resolveCallback(v);
                    }
                    function deferReject(v) {
                        this.promise._rejectCallback(v, false);
                    }
                    Promise1.defer = Promise1.pending = function() {
                        debug.deprecated("Promise.defer", "new Promise");
                        var promise = new Promise1(INTERNAL);
                        return {
                            promise: promise,
                            resolve: deferResolve,
                            reject: deferReject
                        };
                    };
                    util.notEnumerableProp(Promise1, "_makeSelfResolutionError", makeSelfResolutionError);
                    _dereq_1("./method")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug);
                    _dereq_1("./bind")(Promise1, INTERNAL, tryConvertToPromise, debug);
                    _dereq_1("./cancel")(Promise1, PromiseArray, apiRejection, debug);
                    _dereq_1("./direct_resolve")(Promise1);
                    _dereq_1("./synchronous_inspection")(Promise1);
                    _dereq_1("./join")(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async);
                    Promise1.Promise = Promise1;
                    Promise1.version = "3.7.2";
                    _dereq_1("./call_get.js")(Promise1);
                    _dereq_1("./generators.js")(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                    _dereq_1("./map.js")(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1("./nodeify.js")(Promise1);
                    _dereq_1("./promisify.js")(Promise1, INTERNAL);
                    _dereq_1("./props.js")(Promise1, PromiseArray, tryConvertToPromise, apiRejection);
                    _dereq_1("./race.js")(Promise1, INTERNAL, tryConvertToPromise, apiRejection);
                    _dereq_1("./reduce.js")(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1("./settle.js")(Promise1, PromiseArray, debug);
                    _dereq_1("./some.js")(Promise1, PromiseArray, apiRejection);
                    _dereq_1("./timers.js")(Promise1, INTERNAL, debug);
                    _dereq_1("./using.js")(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                    _dereq_1("./any.js")(Promise1);
                    _dereq_1("./each.js")(Promise1, INTERNAL);
                    _dereq_1("./filter.js")(Promise1, INTERNAL);
                    util.toFastProperties(Promise1);
                    util.toFastProperties(Promise1.prototype);
                    function fillTypes(value) {
                        var p = new Promise1(INTERNAL);
                        p._fulfillmentHandler0 = value;
                        p._rejectionHandler0 = value;
                        p._promise0 = value;
                        p._receiver0 = value;
                    }
                    // Complete slack tracking, opt out of field-type tracking and           
                    // stabilize map                                                         
                    fillTypes({
                        a: 1
                    });
                    fillTypes({
                        b: 2
                    });
                    fillTypes({
                        c: 3
                    });
                    fillTypes(1);
                    fillTypes(function() {});
                    fillTypes(undefined);
                    fillTypes(false);
                    fillTypes(new Promise1(INTERNAL));
                    debug.setBounds(Async.firstLineError, util.lastLineError);
                    return Promise1;
                };
            },
            {
                "./any.js": 1,
                "./async": 2,
                "./bind": 3,
                "./call_get.js": 5,
                "./cancel": 6,
                "./catch_filter": 7,
                "./context": 8,
                "./debuggability": 9,
                "./direct_resolve": 10,
                "./each.js": 11,
                "./errors": 12,
                "./es5": 13,
                "./filter.js": 14,
                "./finally": 15,
                "./generators.js": 16,
                "./join": 17,
                "./map.js": 18,
                "./method": 19,
                "./nodeback": 20,
                "./nodeify.js": 21,
                "./promise_array": 23,
                "./promisify.js": 24,
                "./props.js": 25,
                "./race.js": 27,
                "./reduce.js": 28,
                "./settle.js": 30,
                "./some.js": 31,
                "./synchronous_inspection": 32,
                "./thenables": 33,
                "./timers.js": 34,
                "./using.js": 35,
                "./util": 36,
                "async_hooks": undefined
            }
        ],
        23: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                    var util = _dereq_1("./util");
                    var isArray = util.isArray;
                    function toResolutionValue(val) {
                        switch(val){
                            case -2:
                                return [];
                            case -3:
                                return {};
                            case -6:
                                return new Map();
                        }
                    }
                    function PromiseArray(values) {
                        var promise = this._promise = new Promise1(INTERNAL);
                        if (values instanceof Promise1) {
                            promise._propagateFrom(values, 3);
                            values.suppressUnhandledRejections();
                        }
                        promise._setOnCancel(this);
                        this._values = values;
                        this._length = 0;
                        this._totalResolved = 0;
                        this._init(undefined, -2);
                    }
                    util.inherits(PromiseArray, Proxyable);
                    PromiseArray.prototype.length = function() {
                        return this._length;
                    };
                    PromiseArray.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                        var values = tryConvertToPromise(this._values, this._promise);
                        if (values instanceof Promise1) {
                            values = values._target();
                            var bitField = values._bitField;
                            this._values = values;
                            if ((bitField & 50397184) === 0) {
                                this._promise._setAsyncGuaranteed();
                                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                            } else if ((bitField & 33554432) !== 0) values = values._value();
                            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
                            else return this._cancel();
                        }
                        values = util.asArray(values);
                        if (values === null) {
                            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                            this._promise._rejectCallback(err, false);
                            return;
                        }
                        if (values.length === 0) {
                            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
                            else this._resolve(toResolutionValue(resolveValueIfEmpty));
                            return;
                        }
                        this._iterate(values);
                    };
                    PromiseArray.prototype._iterate = function(values) {
                        var len = this.getActualLength(values.length);
                        this._length = len;
                        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                        var result = this._promise;
                        var isResolved = false;
                        var bitField = null;
                        for(var i = 0; i < len; ++i){
                            var maybePromise = tryConvertToPromise(values[i], result);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                bitField = maybePromise._bitField;
                            } else bitField = null;
                            if (isResolved) {
                                if (bitField !== null) maybePromise.suppressUnhandledRejections();
                            } else if (bitField !== null) {
                                if ((bitField & 50397184) === 0) {
                                    maybePromise._proxy(this, i);
                                    this._values[i] = maybePromise;
                                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                                else isResolved = this._promiseCancelled(i);
                            } else isResolved = this._promiseFulfilled(maybePromise, i);
                        }
                        if (!isResolved) result._setAsyncGuaranteed();
                    };
                    PromiseArray.prototype._isResolved = function() {
                        return this._values === null;
                    };
                    PromiseArray.prototype._resolve = function(value) {
                        this._values = null;
                        this._promise._fulfill(value);
                    };
                    PromiseArray.prototype._cancel = function() {
                        if (this._isResolved() || !this._promise._isCancellable()) return;
                        this._values = null;
                        this._promise._cancel();
                    };
                    PromiseArray.prototype._reject = function(reason) {
                        this._values = null;
                        this._promise._rejectCallback(reason, false);
                    };
                    PromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    PromiseArray.prototype._promiseCancelled = function() {
                        this._cancel();
                        return true;
                    };
                    PromiseArray.prototype._promiseRejected = function(reason) {
                        this._totalResolved++;
                        this._reject(reason);
                        return true;
                    };
                    PromiseArray.prototype._resultCancelled = function() {
                        if (this._isResolved()) return;
                        var values = this._values;
                        this._cancel();
                        if (values instanceof Promise1) values.cancel();
                        else {
                            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise1) values[i].cancel();
                        }
                    };
                    PromiseArray.prototype.shouldCopyValues = function() {
                        return true;
                    };
                    PromiseArray.prototype.getActualLength = function(len) {
                        return len;
                    };
                    return PromiseArray;
                };
            },
            {
                "./util": 36
            }
        ],
        24: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var THIS = {};
                    var util = _dereq_1("./util");
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var withAppended = util.withAppended;
                    var maybeWrapAsError = util.maybeWrapAsError;
                    var canEvaluate = util.canEvaluate;
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var defaultSuffix = "Async";
                    var defaultPromisified = {
                        __isPromisified__: true
                    };
                    var noCopyProps = [
                        "arity",
                        "length",
                        "name",
                        "arguments",
                        "caller",
                        "callee",
                        "prototype",
                        "__isPromisified__"
                    ];
                    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                    var defaultFilter = function(name) {
                        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                    };
                    function propsFilter(key) {
                        return !noCopyPropsPattern.test(key);
                    }
                    function isPromisified(fn) {
                        try {
                            return fn.__isPromisified__ === true;
                        } catch (e) {
                            return false;
                        }
                    }
                    function hasPromisified(obj, key, suffix) {
                        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                        return val ? isPromisified(val) : false;
                    }
                    function checkValid(ret, suffix, suffixRegexp) {
                        for(var i = 0; i < ret.length; i += 2){
                            var key = ret[i];
                            if (suffixRegexp.test(key)) {
                                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                for(var j = 0; j < ret.length; j += 2){
                                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError1("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
                                }
                            }
                        }
                    }
                    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                        var keys = util.inheritedDataKeys(obj);
                        var ret = [];
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            var value = obj[key];
                            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
                        }
                        checkValid(ret, suffix, suffixRegexp);
                        return ret;
                    }
                    var escapeIdentRegex = function(str) {
                        return str.replace(/([$])/, "\\$");
                    };
                    var makeNodePromisifiedEval;
                    var switchCaseArgumentOrder, argumentSequence, parameterDeclaration, parameterCount;
                    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                        var defaultThis = function() {
                            return this;
                        }();
                        var method = callback;
                        if (typeof method === "string") callback = fn;
                        function promisified() {
                            var _receiver = receiver;
                            if (receiver === THIS) _receiver = this;
                            var promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                            var fn = nodebackForPromise(promise, multiArgs);
                            try {
                                cb.apply(_receiver, withAppended(arguments, fn));
                            } catch (e) {
                                promise._rejectCallback(maybeWrapAsError(e), true, true);
                            }
                            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                            return promise;
                        }
                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                        return promisified;
                    }
                    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                        for(var i = 0, len = methods.length; i < len; i += 2){
                            var key = methods[i];
                            var fn = methods[i + 1];
                            var promisifiedKey = key + suffix;
                            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                            else {
                                var promisified = promisifier(fn, function() {
                                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                });
                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                obj[promisifiedKey] = promisified;
                            }
                        }
                        util.toFastProperties(obj);
                        return obj;
                    }
                    function promisify(callback, receiver, multiArgs) {
                        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                    }
                    Promise1.promisify = function(fn, options) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        if (isPromisified(fn)) return fn;
                        options = Object(options);
                        var receiver = options.context === undefined ? THIS : options.context;
                        var multiArgs = !!options.multiArgs;
                        var ret = promisify(fn, receiver, multiArgs);
                        util.copyDescriptors(fn, ret, propsFilter);
                        return ret;
                    };
                    Promise1.promisifyAll = function(target, options) {
                        if (typeof target !== "function" && typeof target !== "object") throw new TypeError1("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
                        options = Object(options);
                        var multiArgs = !!options.multiArgs;
                        var suffix = options.suffix;
                        if (typeof suffix !== "string") suffix = defaultSuffix;
                        var filter = options.filter;
                        if (typeof filter !== "function") filter = defaultFilter;
                        var promisifier = options.promisifier;
                        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
                        var keys = util.inheritedDataKeys(target);
                        for(var i = 0; i < keys.length; ++i){
                            var value = target[keys[i]];
                            if (keys[i] !== "constructor" && util.isClass(value)) {
                                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                promisifyAll(value, suffix, filter, promisifier, multiArgs);
                            }
                        }
                        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                    };
                };
            },
            {
                "./errors": 12,
                "./nodeback": 20,
                "./util": 36
            }
        ],
        25: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var isObject = util.isObject;
                    var es5 = _dereq_1("./es5");
                    var Es6Map;
                    if (typeof Map === "function") Es6Map = Map;
                    var mapToEntries = function() {
                        var index = 0;
                        var size = 0;
                        function extractEntry(value, key) {
                            this[index] = value;
                            this[index + size] = key;
                            index++;
                        }
                        return function mapToEntries(map) {
                            size = map.size;
                            index = 0;
                            var ret = new Array(map.size * 2);
                            map.forEach(extractEntry, ret);
                            return ret;
                        };
                    }();
                    var entriesToMap = function(entries) {
                        var ret = new Es6Map();
                        var length = entries.length / 2 | 0;
                        for(var i = 0; i < length; ++i){
                            var key = entries[length + i];
                            var value = entries[i];
                            ret.set(key, value);
                        }
                        return ret;
                    };
                    function PropertiesPromiseArray(obj) {
                        var isMap = false;
                        var entries;
                        if (Es6Map !== undefined && obj instanceof Es6Map) {
                            entries = mapToEntries(obj);
                            isMap = true;
                        } else {
                            var keys = es5.keys(obj);
                            var len = keys.length;
                            entries = new Array(len * 2);
                            for(var i = 0; i < len; ++i){
                                var key = keys[i];
                                entries[i] = obj[key];
                                entries[i + len] = key;
                            }
                        }
                        this.constructor$(entries);
                        this._isMap = isMap;
                        this._init$(undefined, isMap ? -6 : -3);
                    }
                    util.inherits(PropertiesPromiseArray, PromiseArray);
                    PropertiesPromiseArray.prototype._init = function() {};
                    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            var val;
                            if (this._isMap) val = entriesToMap(this._values);
                            else {
                                val = {};
                                var keyOffset = this.length();
                                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
                            }
                            this._resolve(val);
                            return true;
                        }
                        return false;
                    };
                    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    PropertiesPromiseArray.prototype.getActualLength = function(len) {
                        return len >> 1;
                    };
                    function props(promises) {
                        var ret;
                        var castValue = tryConvertToPromise(promises);
                        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
                        else if (castValue instanceof Promise1) ret = castValue._then(Promise1.props, undefined, undefined, undefined, undefined);
                        else ret = new PropertiesPromiseArray(castValue).promise();
                        if (castValue instanceof Promise1) ret._propagateFrom(castValue, 2);
                        return ret;
                    }
                    Promise1.prototype.props = function() {
                        return props(this);
                    };
                    Promise1.props = function(promises) {
                        return props(promises);
                    };
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        26: [
            function(_dereq_1, module1, exports) {
                "use strict";
                function arrayMove(src, srcIndex, dst, dstIndex, len) {
                    for(var j = 0; j < len; ++j){
                        dst[j + dstIndex] = src[j + srcIndex];
                        src[j + srcIndex] = void 0;
                    }
                }
                function Queue(capacity) {
                    this._capacity = capacity;
                    this._length = 0;
                    this._front = 0;
                }
                Queue.prototype._willBeOverCapacity = function(size) {
                    return this._capacity < size;
                };
                Queue.prototype._pushOne = function(arg) {
                    var length = this.length();
                    this._checkCapacity(length + 1);
                    var i = this._front + length & this._capacity - 1;
                    this[i] = arg;
                    this._length = length + 1;
                };
                Queue.prototype.push = function(fn, receiver, arg) {
                    var length = this.length() + 3;
                    if (this._willBeOverCapacity(length)) {
                        this._pushOne(fn);
                        this._pushOne(receiver);
                        this._pushOne(arg);
                        return;
                    }
                    var j = this._front + length - 3;
                    this._checkCapacity(length);
                    var wrapMask = this._capacity - 1;
                    this[j + 0 & wrapMask] = fn;
                    this[j + 1 & wrapMask] = receiver;
                    this[j + 2 & wrapMask] = arg;
                    this._length = length;
                };
                Queue.prototype.shift = function() {
                    var front = this._front, ret = this[front];
                    this[front] = undefined;
                    this._front = front + 1 & this._capacity - 1;
                    this._length--;
                    return ret;
                };
                Queue.prototype.length = function() {
                    return this._length;
                };
                Queue.prototype._checkCapacity = function(size) {
                    if (this._capacity < size) this._resizeTo(this._capacity << 1);
                };
                Queue.prototype._resizeTo = function(capacity) {
                    var oldCapacity = this._capacity;
                    this._capacity = capacity;
                    var front = this._front;
                    var length = this._length;
                    var moveItemsCount = front + length & oldCapacity - 1;
                    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                };
                module1.exports = Queue;
            },
            {}
        ],
        27: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var raceLater = function(promise) {
                        return promise.then(function(array) {
                            return race(array, promise);
                        });
                    };
                    function race(promises, parent) {
                        var maybePromise = tryConvertToPromise(promises);
                        if (maybePromise instanceof Promise1) return raceLater(maybePromise);
                        else {
                            promises = util.asArray(promises);
                            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                        }
                        var ret = new Promise1(INTERNAL);
                        if (parent !== undefined) ret._propagateFrom(parent, 3);
                        var fulfill = ret._fulfill;
                        var reject = ret._reject;
                        for(var i = 0, len = promises.length; i < len; ++i){
                            var val = promises[i];
                            if (val === undefined && !(i in promises)) continue;
                            Promise1.cast(val)._then(fulfill, reject, undefined, ret, null);
                        }
                        return ret;
                    }
                    Promise1.race = function(promises) {
                        return race(promises, undefined);
                    };
                    Promise1.prototype.race = function() {
                        return race(this, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        28: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    function ReductionPromiseArray(promises, fn, initialValue, _each) {
                        this.constructor$(promises);
                        var context = Promise1._getContext();
                        this._fn = util.contextBind(context, fn);
                        if (initialValue !== undefined) {
                            initialValue = Promise1.resolve(initialValue);
                            initialValue._attachCancellationCallback(this);
                        }
                        this._initialValue = initialValue;
                        this._currentCancellable = null;
                        if (_each === INTERNAL) this._eachValues = Array(this._length);
                        else if (_each === 0) this._eachValues = null;
                        else this._eachValues = undefined;
                        this._promise._captureStackTrace();
                        this._init$(undefined, -5);
                    }
                    util.inherits(ReductionPromiseArray, PromiseArray);
                    ReductionPromiseArray.prototype._gotAccum = function(accum) {
                        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
                    };
                    ReductionPromiseArray.prototype._eachComplete = function(value) {
                        if (this._eachValues !== null) this._eachValues.push(value);
                        return this._eachValues;
                    };
                    ReductionPromiseArray.prototype._init = function() {};
                    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
                        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                    };
                    ReductionPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    ReductionPromiseArray.prototype._resolve = function(value) {
                        this._promise._resolveCallback(value);
                        this._values = null;
                    };
                    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
                        if (sender === this._initialValue) return this._cancel();
                        if (this._isResolved()) return;
                        this._resultCancelled$();
                        if (this._currentCancellable instanceof Promise1) this._currentCancellable.cancel();
                        if (this._initialValue instanceof Promise1) this._initialValue.cancel();
                    };
                    ReductionPromiseArray.prototype._iterate = function(values) {
                        this._values = values;
                        var value;
                        var i;
                        var length = values.length;
                        if (this._initialValue !== undefined) {
                            value = this._initialValue;
                            i = 0;
                        } else {
                            value = Promise1.resolve(values[0]);
                            i = 1;
                        }
                        this._currentCancellable = value;
                        for(var j = i; j < length; ++j){
                            var maybePromise = values[j];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                        if (!value.isRejected()) for(; i < length; ++i){
                            var ctx = {
                                accum: null,
                                value: values[i],
                                index: i,
                                length: length,
                                array: this
                            };
                            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                            if ((i & 127) === 0) value._setNoAsyncGuarantee();
                        }
                        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                        value._then(completed, completed, undefined, value, this);
                    };
                    Promise1.prototype.reduce = function(fn, initialValue) {
                        return reduce(this, fn, initialValue, null);
                    };
                    Promise1.reduce = function(promises, fn, initialValue, _each) {
                        return reduce(promises, fn, initialValue, _each);
                    };
                    function completed(valueOrReason, array) {
                        if (this.isFulfilled()) array._resolve(valueOrReason);
                        else array._reject(valueOrReason);
                    }
                    function reduce(promises, fn, initialValue, _each) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                        return array.promise();
                    }
                    function gotAccum(accum) {
                        this.accum = accum;
                        this.array._gotAccum(accum);
                        var value = tryConvertToPromise(this.value, this.array._promise);
                        if (value instanceof Promise1) {
                            this.array._currentCancellable = value;
                            return value._then(gotValue, undefined, undefined, this, undefined);
                        } else return gotValue.call(this, value);
                    }
                    function gotValue(value) {
                        var array = this.array;
                        var promise = array._promise;
                        var fn = tryCatch(array._fn);
                        promise._pushContext();
                        var ret;
                        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
                        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                        if (ret instanceof Promise1) array._currentCancellable = ret;
                        var promiseCreated = promise._popContext();
                        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                        return ret;
                    }
                };
            },
            {
                "./util": 36
            }
        ],
        29: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var schedule;
                var noAsyncScheduler = function() {
                    throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                };
                var NativePromise = util.getNativePromise();
                if (util.isNode && typeof MutationObserver === "undefined") {
                    var GlobalSetImmediate = global.setImmediate;
                    var ProcessNextTick = process.nextTick;
                    schedule = util.isRecentNode ? function(fn) {
                        GlobalSetImmediate.call(global, fn);
                    } : function(fn) {
                        ProcessNextTick.call(process, fn);
                    };
                } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                    var nativePromise = NativePromise.resolve();
                    schedule = function(fn) {
                        nativePromise.then(fn);
                    };
                } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) schedule = function() {
                    var div = document.createElement("div");
                    var opts = {
                        attributes: true
                    };
                    var toggleScheduled = false;
                    var div2 = document.createElement("div");
                    var o2 = new MutationObserver(function() {
                        div.classList.toggle("foo");
                        toggleScheduled = false;
                    });
                    o2.observe(div2, opts);
                    var scheduleToggle = function() {
                        if (toggleScheduled) return;
                        toggleScheduled = true;
                        div2.classList.toggle("foo");
                    };
                    return function schedule(fn) {
                        var o = new MutationObserver(function() {
                            o.disconnect();
                            fn();
                        });
                        o.observe(div, opts);
                        scheduleToggle();
                    };
                }();
                else if (typeof setImmediate !== "undefined") schedule = function(fn) {
                    setImmediate(fn);
                };
                else if (typeof setTimeout !== "undefined") schedule = function(fn) {
                    setTimeout(fn, 0);
                };
                else schedule = noAsyncScheduler;
                module1.exports = schedule;
            },
            {
                "./util": 36
            }
        ],
        30: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, debug) {
                    var PromiseInspection = Promise1.PromiseInspection;
                    var util = _dereq_1("./util");
                    function SettledPromiseArray(values) {
                        this.constructor$(values);
                    }
                    util.inherits(SettledPromiseArray, PromiseArray);
                    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
                        this._values[index] = inspection;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 33554432;
                        ret._settledValueField = value;
                        return this._promiseResolved(index, ret);
                    };
                    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 16777216;
                        ret._settledValueField = reason;
                        return this._promiseResolved(index, ret);
                    };
                    Promise1.settle = function(promises) {
                        debug.deprecated(".settle()", ".reflect()");
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.allSettled = function(promises) {
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.prototype.settle = function() {
                        return Promise1.settle(this);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        31: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection) {
                    var util = _dereq_1("./util");
                    var RangeError1 = _dereq_1("./errors").RangeError;
                    var AggregateError = _dereq_1("./errors").AggregateError;
                    var isArray = util.isArray;
                    var CANCELLATION = {};
                    function SomePromiseArray(values) {
                        this.constructor$(values);
                        this._howMany = 0;
                        this._unwrap = false;
                        this._initialized = false;
                    }
                    util.inherits(SomePromiseArray, PromiseArray);
                    SomePromiseArray.prototype._init = function() {
                        if (!this._initialized) return;
                        if (this._howMany === 0) {
                            this._resolve([]);
                            return;
                        }
                        this._init$(undefined, -5);
                        var isArrayResolved = isArray(this._values);
                        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
                    };
                    SomePromiseArray.prototype.init = function() {
                        this._initialized = true;
                        this._init();
                    };
                    SomePromiseArray.prototype.setUnwrap = function() {
                        this._unwrap = true;
                    };
                    SomePromiseArray.prototype.howMany = function() {
                        return this._howMany;
                    };
                    SomePromiseArray.prototype.setHowMany = function(count) {
                        this._howMany = count;
                    };
                    SomePromiseArray.prototype._promiseFulfilled = function(value) {
                        this._addFulfilled(value);
                        if (this._fulfilled() === this.howMany()) {
                            this._values.length = this.howMany();
                            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
                            else this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._promiseRejected = function(reason) {
                        this._addRejected(reason);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._promiseCancelled = function() {
                        if (this._values instanceof Promise1 || this._values == null) return this._cancel();
                        this._addRejected(CANCELLATION);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._checkOutcome = function() {
                        if (this.howMany() > this._canPossiblyFulfill()) {
                            var e = new AggregateError();
                            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
                            if (e.length > 0) this._reject(e);
                            else this._cancel();
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._fulfilled = function() {
                        return this._totalResolved;
                    };
                    SomePromiseArray.prototype._rejected = function() {
                        return this._values.length - this.length();
                    };
                    SomePromiseArray.prototype._addRejected = function(reason) {
                        this._values.push(reason);
                    };
                    SomePromiseArray.prototype._addFulfilled = function(value) {
                        this._values[this._totalResolved++] = value;
                    };
                    SomePromiseArray.prototype._canPossiblyFulfill = function() {
                        return this.length() - this._rejected();
                    };
                    SomePromiseArray.prototype._getRangeError = function(count) {
                        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                        return new RangeError1(message);
                    };
                    SomePromiseArray.prototype._resolveEmptyArray = function() {
                        this._reject(this._getRangeError(0));
                    };
                    function some(promises, howMany) {
                        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(howMany);
                        ret.init();
                        return promise;
                    }
                    Promise1.some = function(promises, howMany) {
                        return some(promises, howMany);
                    };
                    Promise1.prototype.some = function(howMany) {
                        return some(this, howMany);
                    };
                    Promise1._SomePromiseArray = SomePromiseArray;
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        32: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function PromiseInspection(promise) {
                        if (promise !== undefined) {
                            promise = promise._target();
                            this._bitField = promise._bitField;
                            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                        } else {
                            this._bitField = 0;
                            this._settledValueField = undefined;
                        }
                    }
                    PromiseInspection.prototype._settledValue = function() {
                        return this._settledValueField;
                    };
                    var value = PromiseInspection.prototype.value = function() {
                        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
                        return this._settledValue();
                    };
                    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
                        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
                        return this._settledValue();
                    };
                    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
                        return (this._bitField & 33554432) !== 0;
                    };
                    var isRejected = PromiseInspection.prototype.isRejected = function() {
                        return (this._bitField & 16777216) !== 0;
                    };
                    var isPending = PromiseInspection.prototype.isPending = function() {
                        return (this._bitField & 50397184) === 0;
                    };
                    var isResolved = PromiseInspection.prototype.isResolved = function() {
                        return (this._bitField & 50331648) !== 0;
                    };
                    PromiseInspection.prototype.isCancelled = function() {
                        return (this._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.__isCancelled = function() {
                        return (this._bitField & 65536) === 65536;
                    };
                    Promise1.prototype._isCancelled = function() {
                        return this._target().__isCancelled();
                    };
                    Promise1.prototype.isCancelled = function() {
                        return (this._target()._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.isPending = function() {
                        return isPending.call(this._target());
                    };
                    Promise1.prototype.isRejected = function() {
                        return isRejected.call(this._target());
                    };
                    Promise1.prototype.isFulfilled = function() {
                        return isFulfilled.call(this._target());
                    };
                    Promise1.prototype.isResolved = function() {
                        return isResolved.call(this._target());
                    };
                    Promise1.prototype.value = function() {
                        return value.call(this._target());
                    };
                    Promise1.prototype.reason = function() {
                        var target = this._target();
                        target._unsetRejectionIsUnhandled();
                        return reason.call(target);
                    };
                    Promise1.prototype._value = function() {
                        return this._settledValue();
                    };
                    Promise1.prototype._reason = function() {
                        this._unsetRejectionIsUnhandled();
                        return this._settledValue();
                    };
                    Promise1.PromiseInspection = PromiseInspection;
                };
            },
            {}
        ],
        33: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var isObject = util.isObject;
                    function tryConvertToPromise(obj, context) {
                        if (isObject(obj)) {
                            if (obj instanceof Promise1) return obj;
                            var then = getThen(obj);
                            if (then === errorObj) {
                                if (context) context._pushContext();
                                var ret = Promise1.reject(then.e);
                                if (context) context._popContext();
                                return ret;
                            } else if (typeof then === "function") {
                                if (isAnyBluebirdPromise(obj)) {
                                    var ret = new Promise1(INTERNAL);
                                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                    return ret;
                                }
                                return doThenable(obj, then, context);
                            }
                        }
                        return obj;
                    }
                    function doGetThen(obj) {
                        return obj.then;
                    }
                    function getThen(obj) {
                        try {
                            return doGetThen(obj);
                        } catch (e) {
                            errorObj.e = e;
                            return errorObj;
                        }
                    }
                    var hasProp = {}.hasOwnProperty;
                    function isAnyBluebirdPromise(obj) {
                        try {
                            return hasProp.call(obj, "_promise0");
                        } catch (e) {
                            return false;
                        }
                    }
                    function doThenable(x, then, context) {
                        var promise = new Promise1(INTERNAL);
                        var ret = promise;
                        if (context) context._pushContext();
                        promise._captureStackTrace();
                        if (context) context._popContext();
                        var synchronous = true;
                        var result = util.tryCatch(then).call(x, resolve, reject);
                        synchronous = false;
                        if (promise && result === errorObj) {
                            promise._rejectCallback(result.e, true, true);
                            promise = null;
                        }
                        function resolve(value) {
                            if (!promise) return;
                            promise._resolveCallback(value);
                            promise = null;
                        }
                        function reject(reason) {
                            if (!promise) return;
                            promise._rejectCallback(reason, synchronous, true);
                            promise = null;
                        }
                        return ret;
                    }
                    return tryConvertToPromise;
                };
            },
            {
                "./util": 36
            }
        ],
        34: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TimeoutError = Promise1.TimeoutError;
                    function HandleWrapper(handle) {
                        this.handle = handle;
                    }
                    HandleWrapper.prototype._resultCancelled = function() {
                        clearTimeout(this.handle);
                    };
                    var afterValue = function(value) {
                        return delay(+this).thenReturn(value);
                    };
                    var delay = Promise1.delay = function(ms, value) {
                        var ret;
                        var handle;
                        if (value !== undefined) {
                            ret = Promise1.resolve(value)._then(afterValue, null, null, ms, undefined);
                            if (debug.cancellation() && value instanceof Promise1) ret._setOnCancel(value);
                        } else {
                            ret = new Promise1(INTERNAL);
                            handle = setTimeout(function() {
                                ret._fulfill();
                            }, +ms);
                            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
                            ret._captureStackTrace();
                        }
                        ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.prototype.delay = function(ms) {
                        return delay(ms, this);
                    };
                    var afterTimeout = function(promise, message, parent) {
                        var err;
                        if (typeof message !== "string") {
                            if (message instanceof Error) err = message;
                            else err = new TimeoutError("operation timed out");
                        } else err = new TimeoutError(message);
                        util.markAsOriginatingFromRejection(err);
                        promise._attachExtraTrace(err);
                        promise._reject(err);
                        if (parent != null) parent.cancel();
                    };
                    function successClear(value) {
                        clearTimeout(this.handle);
                        return value;
                    }
                    function failureClear(reason) {
                        clearTimeout(this.handle);
                        throw reason;
                    }
                    Promise1.prototype.timeout = function(ms, message) {
                        ms = +ms;
                        var ret, parent;
                        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                            if (ret.isPending()) afterTimeout(ret, message, parent);
                        }, ms));
                        if (debug.cancellation()) {
                            parent = this.then();
                            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                            ret._setOnCancel(handleWrapper);
                        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                        return ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        35: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var inherits = _dereq_1("./util").inherits;
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var NULL = {};
                    function thrower(e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                    function castPreservingDisposable(thenable) {
                        var maybePromise = tryConvertToPromise(thenable);
                        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
                        return maybePromise;
                    }
                    function dispose(resources, inspection) {
                        var i = 0;
                        var len = resources.length;
                        var ret = new Promise1(INTERNAL);
                        function iterator() {
                            if (i >= len) return ret._fulfill();
                            var maybePromise = castPreservingDisposable(resources[i++]);
                            if (maybePromise instanceof Promise1 && maybePromise._isDisposable()) {
                                try {
                                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                } catch (e) {
                                    return thrower(e);
                                }
                                if (maybePromise instanceof Promise1) return maybePromise._then(iterator, thrower, null, null, null);
                            }
                            iterator();
                        }
                        iterator();
                        return ret;
                    }
                    function Disposer(data, promise, context) {
                        this._data = data;
                        this._promise = promise;
                        this._context = context;
                    }
                    Disposer.prototype.data = function() {
                        return this._data;
                    };
                    Disposer.prototype.promise = function() {
                        return this._promise;
                    };
                    Disposer.prototype.resource = function() {
                        if (this.promise().isFulfilled()) return this.promise().value();
                        return NULL;
                    };
                    Disposer.prototype.tryDispose = function(inspection) {
                        var resource = this.resource();
                        var context = this._context;
                        if (context !== undefined) context._pushContext();
                        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                        if (context !== undefined) context._popContext();
                        this._promise._unsetDisposable();
                        this._data = null;
                        return ret;
                    };
                    Disposer.isDisposer = function(d) {
                        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                    };
                    function FunctionDisposer(fn, promise, context) {
                        this.constructor$(fn, promise, context);
                    }
                    inherits(FunctionDisposer, Disposer);
                    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
                        var fn = this.data();
                        return fn.call(resource, resource, inspection);
                    };
                    function maybeUnwrapDisposer(value) {
                        if (Disposer.isDisposer(value)) {
                            this.resources[this.index]._setDisposable(value);
                            return value.promise();
                        }
                        return value;
                    }
                    function ResourceList(length) {
                        this.length = length;
                        this.promise = null;
                        this[length - 1] = null;
                    }
                    ResourceList.prototype._resultCancelled = function() {
                        var len = this.length;
                        for(var i = 0; i < len; ++i){
                            var item = this[i];
                            if (item instanceof Promise1) item.cancel();
                        }
                    };
                    Promise1.using = function() {
                        var len = arguments.length;
                        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                        var fn = arguments[len - 1];
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var input;
                        var spreadArgs = true;
                        if (len === 2 && Array.isArray(arguments[0])) {
                            input = arguments[0];
                            len = input.length;
                            spreadArgs = false;
                        } else {
                            input = arguments;
                            len--;
                        }
                        var resources = new ResourceList(len);
                        for(var i = 0; i < len; ++i){
                            var resource = input[i];
                            if (Disposer.isDisposer(resource)) {
                                var disposer = resource;
                                resource = resource.promise();
                                resource._setDisposable(disposer);
                            } else {
                                var maybePromise = tryConvertToPromise(resource);
                                if (maybePromise instanceof Promise1) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                                    resources: resources,
                                    index: i
                                }, undefined);
                            }
                            resources[i] = resource;
                        }
                        var reflectedResources = new Array(resources.length);
                        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise1.resolve(resources[i]).reflect();
                        var resultPromise = Promise1.all(reflectedResources).then(function(inspections) {
                            for(var i = 0; i < inspections.length; ++i){
                                var inspection = inspections[i];
                                if (inspection.isRejected()) {
                                    errorObj.e = inspection.error();
                                    return errorObj;
                                } else if (!inspection.isFulfilled()) {
                                    resultPromise.cancel();
                                    return;
                                }
                                inspections[i] = inspection.value();
                            }
                            promise._pushContext();
                            fn = tryCatch(fn);
                            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                            return ret;
                        });
                        var promise = resultPromise.lastly(function() {
                            var inspection = new Promise1.PromiseInspection(resultPromise);
                            return dispose(resources, inspection);
                        });
                        resources.promise = promise;
                        promise._setOnCancel(resources);
                        return promise;
                    };
                    Promise1.prototype._setDisposable = function(disposer) {
                        this._bitField = this._bitField | 131072;
                        this._disposer = disposer;
                    };
                    Promise1.prototype._isDisposable = function() {
                        return (this._bitField & 131072) > 0;
                    };
                    Promise1.prototype._getDisposer = function() {
                        return this._disposer;
                    };
                    Promise1.prototype._unsetDisposable = function() {
                        this._bitField = this._bitField & -131073;
                        this._disposer = undefined;
                    };
                    Promise1.prototype.disposer = function(fn) {
                        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
                        throw new TypeError1();
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        36: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var canEvaluate = typeof navigator == "undefined";
                var errorObj = {
                    e: {}
                };
                var tryCatchTarget;
                var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : this !== undefined ? this : null;
                function tryCatcher() {
                    try {
                        var target = tryCatchTarget;
                        tryCatchTarget = null;
                        return target.apply(this, arguments);
                    } catch (e) {
                        errorObj.e = e;
                        return errorObj;
                    }
                }
                function tryCatch(fn) {
                    tryCatchTarget = fn;
                    return tryCatcher;
                }
                var inherits = function(Child, Parent) {
                    var hasProp = {}.hasOwnProperty;
                    function T() {
                        this.constructor = Child;
                        this.constructor$ = Parent;
                        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
                    }
                    T.prototype = Parent.prototype;
                    Child.prototype = new T();
                    return Child.prototype;
                };
                function isPrimitive(val) {
                    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                }
                function isObject(value) {
                    return typeof value === "function" || typeof value === "object" && value !== null;
                }
                function maybeWrapAsError(maybeError) {
                    if (!isPrimitive(maybeError)) return maybeError;
                    return new Error(safeToString(maybeError));
                }
                function withAppended(target, appendee) {
                    var len = target.length;
                    var ret = new Array(len + 1);
                    var i;
                    for(i = 0; i < len; ++i)ret[i] = target[i];
                    ret[i] = appendee;
                    return ret;
                }
                function getDataPropertyOrDefault(obj, key, defaultValue) {
                    if (es5.isES5) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
                    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                }
                function notEnumerableProp(obj, name, value) {
                    if (isPrimitive(obj)) return obj;
                    var descriptor = {
                        value: value,
                        configurable: true,
                        enumerable: false,
                        writable: true
                    };
                    es5.defineProperty(obj, name, descriptor);
                    return obj;
                }
                function thrower(r) {
                    throw r;
                }
                var inheritedDataKeys = function() {
                    var excludedPrototypes = [
                        Array.prototype,
                        Object.prototype,
                        Function.prototype
                    ];
                    var isExcludedProto = function(val) {
                        for(var i = 0; i < excludedPrototypes.length; ++i){
                            if (excludedPrototypes[i] === val) return true;
                        }
                        return false;
                    };
                    if (es5.isES5) {
                        var getKeys = Object.getOwnPropertyNames;
                        return function(obj) {
                            var ret = [];
                            var visitedKeys = Object.create(null);
                            while(obj != null && !isExcludedProto(obj)){
                                var keys;
                                try {
                                    keys = getKeys(obj);
                                } catch (e) {
                                    return ret;
                                }
                                for(var i = 0; i < keys.length; ++i){
                                    var key = keys[i];
                                    if (visitedKeys[key]) continue;
                                    visitedKeys[key] = true;
                                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                                }
                                obj = es5.getPrototypeOf(obj);
                            }
                            return ret;
                        };
                    } else {
                        var hasProp = {}.hasOwnProperty;
                        return function(obj) {
                            if (isExcludedProto(obj)) return [];
                            var ret = [];
                            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
                            else {
                                for(var i = 0; i < excludedPrototypes.length; ++i){
                                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                                }
                                ret.push(key);
                            }
                            return ret;
                        };
                    }
                }();
                var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                function isClass(fn) {
                    try {
                        if (typeof fn === "function") {
                            var keys = es5.names(fn.prototype);
                            var hasMethods = es5.isES5 && keys.length > 1;
                            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
                        }
                        return false;
                    } catch (e) {
                        return false;
                    }
                }
                function toFastProperties(obj) {
                    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                    FakeConstructor.prototype = obj;
                    var receiver = new FakeConstructor();
                    function ic() {
                        return typeof receiver.foo;
                    }
                    ic();
                    ic();
                    return obj;
                }
                var rident = /^[a-z$_][a-z$_0-9]*$/i;
                function isIdentifier(str) {
                    return rident.test(str);
                }
                function filledRange(count, prefix, suffix) {
                    var ret = new Array(count);
                    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
                    return ret;
                }
                function safeToString(obj) {
                    try {
                        return obj + "";
                    } catch (e) {
                        return "[no string representation]";
                    }
                }
                function isError(obj) {
                    return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
                }
                function markAsOriginatingFromRejection(e) {
                    try {
                        notEnumerableProp(e, "isOperational", true);
                    } catch (ignore) {}
                }
                function originatesFromRejection(e) {
                    if (e == null) return false;
                    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                }
                function canAttachTrace(obj) {
                    return isError(obj) && es5.propertyIsWritable(obj, "stack");
                }
                var ensureErrorObject = function() {
                    if (!("stack" in new Error())) return function(value) {
                        if (canAttachTrace(value)) return value;
                        try {
                            throw new Error(safeToString(value));
                        } catch (err) {
                            return err;
                        }
                    };
                    else return function(value) {
                        if (canAttachTrace(value)) return value;
                        return new Error(safeToString(value));
                    };
                }();
                function classString(obj) {
                    return ({}).toString.call(obj);
                }
                function copyDescriptors(from, to, filter) {
                    var keys = es5.names(from);
                    for(var i = 0; i < keys.length; ++i){
                        var key = keys[i];
                        if (filter(key)) try {
                            es5.defineProperty(to, key, es5.getDescriptor(from, key));
                        } catch (ignore) {}
                    }
                }
                var asArray = function(v) {
                    if (es5.isArray(v)) return v;
                    return null;
                };
                if (typeof Symbol !== "undefined" && Symbol.iterator) {
                    var ArrayFrom = typeof Array.from === "function" ? function(v) {
                        return Array.from(v);
                    } : function(v) {
                        var ret = [];
                        var it = v[Symbol.iterator]();
                        var itResult;
                        while(!(itResult = it.next()).done)ret.push(itResult.value);
                        return ret;
                    };
                    asArray = function(v) {
                        if (es5.isArray(v)) return v;
                        else if (v != null && typeof v[Symbol.iterator] === "function") return ArrayFrom(v);
                        return null;
                    };
                }
                var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
                var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";
                function env(key) {
                    return hasEnvVariables ? process.env[key] : undefined;
                }
                function getNativePromise() {
                    if (typeof Promise === "function") try {
                        var promise = new Promise(function() {});
                        if (classString(promise) === "[object Promise]") return Promise;
                    } catch (e) {}
                }
                var reflectHandler;
                function contextBind(ctx, cb) {
                    if (ctx === null || typeof cb !== "function" || cb === reflectHandler) return cb;
                    if (ctx.domain !== null) cb = ctx.domain.bind(cb);
                    var async = ctx.async;
                    if (async !== null) {
                        var old = cb;
                        cb = function() {
                            var args = new Array(2).concat([].slice.call(arguments));
                            args[0] = old;
                            args[1] = this;
                            return async.runInAsyncScope.apply(async, args);
                        };
                    }
                    return cb;
                }
                var ret = {
                    setReflectHandler: function(fn) {
                        reflectHandler = fn;
                    },
                    isClass: isClass,
                    isIdentifier: isIdentifier,
                    inheritedDataKeys: inheritedDataKeys,
                    getDataPropertyOrDefault: getDataPropertyOrDefault,
                    thrower: thrower,
                    isArray: es5.isArray,
                    asArray: asArray,
                    notEnumerableProp: notEnumerableProp,
                    isPrimitive: isPrimitive,
                    isObject: isObject,
                    isError: isError,
                    canEvaluate: canEvaluate,
                    errorObj: errorObj,
                    tryCatch: tryCatch,
                    inherits: inherits,
                    withAppended: withAppended,
                    maybeWrapAsError: maybeWrapAsError,
                    toFastProperties: toFastProperties,
                    filledRange: filledRange,
                    toString: safeToString,
                    canAttachTrace: canAttachTrace,
                    ensureErrorObject: ensureErrorObject,
                    originatesFromRejection: originatesFromRejection,
                    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                    classString: classString,
                    copyDescriptors: copyDescriptors,
                    isNode: isNode,
                    hasEnvVariables: hasEnvVariables,
                    env: env,
                    global: globalObject,
                    getNativePromise: getNativePromise,
                    contextBind: contextBind
                };
                ret.isRecentNode = ret.isNode && function() {
                    var version;
                    if (process.versions && process.versions.node) version = process.versions.node.split(".").map(Number);
                    else if (process.version) version = process.version.split(".").map(Number);
                    return version[0] === 0 && version[1] > 10 || version[0] > 0;
                }();
                ret.nodeSupportsAsyncResource = ret.isNode && function() {
                    var supportsAsync = false;
                    try {
                        var res = _dereq_1("async_hooks").AsyncResource;
                        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                    } catch (e) {
                        supportsAsync = false;
                    }
                    return supportsAsync;
                }();
                if (ret.isNode) ret.toFastProperties(process);
                try {
                    throw new Error();
                } catch (e) {
                    ret.lastLineError = e;
                }
                module1.exports = ret;
            },
            {
                "./es5": 13,
                "async_hooks": undefined
            }
        ]
    }, {}, [
        4
    ])(4);
});
if (typeof window !== "undefined" && window !== null) window.P = window.Promise;
else if (typeof self !== "undefined" && self !== null) self.P = self.Promise;

},{"fb71ed40a9331d76":"g1F5c"}],"hoSRs":[function(require,module,exports) {
"use strict";
var core = require("1c5943d7aad0cf38"), isArray = require("9bdae53673e66e77"), isFunction = require("c048ad27a8ea9d7c"), isObjectLike = require("82d2412622925862");
module.exports = function(options) {
    var errorText = "Please verify options"; // For better minification because this string is repeating
    if (!isObjectLike(options)) throw new TypeError(errorText);
    if (!isFunction(options.request)) throw new TypeError(errorText + ".request");
    if (!isArray(options.expose) || options.expose.length === 0) throw new TypeError(errorText + ".expose");
    var plumbing = core({
        PromiseImpl: options.PromiseImpl,
        constructorMixin: options.constructorMixin
    });
    // Intercepting Request's init method
    var originalInit = options.request.Request.prototype.init;
    options.request.Request.prototype.init = function RP$initInterceptor(requestOptions) {
        // Init may be called again - currently in case of redirects
        if (isObjectLike(requestOptions) && !this._callback && !this._rp_promise) plumbing.init.call(this, requestOptions);
        return originalInit.apply(this, arguments);
    };
    // Exposing the Promise capabilities
    var thenExposed = false;
    for(var i = 0; i < options.expose.length; i += 1){
        var method = options.expose[i];
        plumbing[method === "promise" ? "exposePromise" : "exposePromiseMethod"](options.request.Request.prototype, null, "_rp_promise", method);
        if (method === "then") thenExposed = true;
    }
    if (!thenExposed) throw new Error('Please expose "then"');
};

},{"1c5943d7aad0cf38":"4cFsm","9bdae53673e66e77":"9om8C","c048ad27a8ea9d7c":"cXGEE","82d2412622925862":"h29TI"}],"4cFsm":[function(require,module,exports) {
"use strict";
var errors = require("ca4b6a62d30b5c90"), isFunction = require("60a2c90e63e3dc3b"), isObjectLike = require("f99b4afecfe3a488"), isString = require("53b661fa36d7345c"), isUndefined = require("2adef3fa3e7986bd");
module.exports = function(options) {
    var errorText = "Please verify options"; // For better minification because this string is repeating
    if (!isObjectLike(options)) throw new TypeError(errorText);
    if (!isFunction(options.PromiseImpl)) throw new TypeError(errorText + ".PromiseImpl");
    if (!isUndefined(options.constructorMixin) && !isFunction(options.constructorMixin)) throw new TypeError(errorText + ".PromiseImpl");
    var PromiseImpl = options.PromiseImpl;
    var constructorMixin = options.constructorMixin;
    var plumbing = {};
    plumbing.init = function(requestOptions) {
        var self = this;
        self._rp_promise = new PromiseImpl(function(resolve, reject) {
            self._rp_resolve = resolve;
            self._rp_reject = reject;
            if (constructorMixin) constructorMixin.apply(self, arguments); // Using arguments since specific Promise libraries may pass additional parameters
        });
        self._rp_callbackOrig = requestOptions.callback;
        requestOptions.callback = self.callback = function RP$callback(err, response, body) {
            plumbing.callback.call(self, err, response, body);
        };
        if (isString(requestOptions.method)) requestOptions.method = requestOptions.method.toUpperCase();
        requestOptions.transform = requestOptions.transform || plumbing.defaultTransformations[requestOptions.method];
        self._rp_options = requestOptions;
        self._rp_options.simple = requestOptions.simple !== false;
        self._rp_options.resolveWithFullResponse = requestOptions.resolveWithFullResponse === true;
        self._rp_options.transform2xxOnly = requestOptions.transform2xxOnly === true;
    };
    plumbing.defaultTransformations = {
        HEAD: function(body, response, resolveWithFullResponse) {
            return resolveWithFullResponse ? response : response.headers;
        }
    };
    plumbing.callback = function(err, response, body) {
        var self = this;
        var origCallbackThrewException = false, thrownException = null;
        if (isFunction(self._rp_callbackOrig)) try {
            self._rp_callbackOrig.apply(self, arguments); // TODO: Apply to self mimics behavior of request@2. Is that also right for request@next?
        } catch (e) {
            origCallbackThrewException = true;
            thrownException = e;
        }
        var is2xx = !err && /^2/.test("" + response.statusCode);
        if (err) self._rp_reject(new errors.RequestError(err, self._rp_options, response));
        else if (self._rp_options.simple && !is2xx) {
            if (isFunction(self._rp_options.transform) && self._rp_options.transform2xxOnly === false) new PromiseImpl(function(resolve) {
                resolve(self._rp_options.transform(body, response, self._rp_options.resolveWithFullResponse)); // transform may return a Promise
            }).then(function(transformedResponse) {
                self._rp_reject(new errors.StatusCodeError(response.statusCode, body, self._rp_options, transformedResponse));
            }).catch(function(transformErr) {
                self._rp_reject(new errors.TransformError(transformErr, self._rp_options, response));
            });
            else self._rp_reject(new errors.StatusCodeError(response.statusCode, body, self._rp_options, response));
        } else {
            if (isFunction(self._rp_options.transform) && (is2xx || self._rp_options.transform2xxOnly === false)) new PromiseImpl(function(resolve) {
                resolve(self._rp_options.transform(body, response, self._rp_options.resolveWithFullResponse)); // transform may return a Promise
            }).then(function(transformedResponse) {
                self._rp_resolve(transformedResponse);
            }).catch(function(transformErr) {
                self._rp_reject(new errors.TransformError(transformErr, self._rp_options, response));
            });
            else if (self._rp_options.resolveWithFullResponse) self._rp_resolve(response);
            else self._rp_resolve(body);
        }
        if (origCallbackThrewException) throw thrownException;
    };
    plumbing.exposePromiseMethod = function(exposeTo, bindTo, promisePropertyKey, methodToExpose, exposeAs) {
        exposeAs = exposeAs || methodToExpose;
        if (exposeAs in exposeTo) throw new Error('Unable to expose method "' + exposeAs + '"');
        exposeTo[exposeAs] = function RP$exposed() {
            var self = bindTo || this;
            return self[promisePropertyKey][methodToExpose].apply(self[promisePropertyKey], arguments);
        };
    };
    plumbing.exposePromise = function(exposeTo, bindTo, promisePropertyKey, exposeAs) {
        exposeAs = exposeAs || "promise";
        if (exposeAs in exposeTo) throw new Error('Unable to expose method "' + exposeAs + '"');
        exposeTo[exposeAs] = function RP$promise() {
            var self = bindTo || this;
            return self[promisePropertyKey];
        };
    };
    return plumbing;
};

},{"ca4b6a62d30b5c90":"8o1P4","60a2c90e63e3dc3b":"cXGEE","f99b4afecfe3a488":"h29TI","53b661fa36d7345c":"3iITv","2adef3fa3e7986bd":"iGoGN"}],"8o1P4":[function(require,module,exports) {
"use strict";
function RequestError(cause, options, response) {
    this.name = "RequestError";
    this.message = String(cause);
    this.cause = cause;
    this.error = cause; // legacy attribute
    this.options = options;
    this.response = response;
    if (Error.captureStackTrace) Error.captureStackTrace(this);
}
RequestError.prototype = Object.create(Error.prototype);
RequestError.prototype.constructor = RequestError;
function StatusCodeError(statusCode, body, options, response) {
    this.name = "StatusCodeError";
    this.statusCode = statusCode;
    this.message = statusCode + " - " + (JSON && JSON.stringify ? JSON.stringify(body) : body);
    this.error = body; // legacy attribute
    this.options = options;
    this.response = response;
    if (Error.captureStackTrace) Error.captureStackTrace(this);
}
StatusCodeError.prototype = Object.create(Error.prototype);
StatusCodeError.prototype.constructor = StatusCodeError;
function TransformError(cause, options, response) {
    this.name = "TransformError";
    this.message = String(cause);
    this.cause = cause;
    this.error = cause; // legacy attribute
    this.options = options;
    this.response = response;
    if (Error.captureStackTrace) Error.captureStackTrace(this);
}
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
module.exports = {
    RequestError: RequestError,
    StatusCodeError: StatusCodeError,
    TransformError: TransformError
};

},{}],"aYBw5":[function(require,module,exports) {
"use strict";
var isNative = /\.node$/;
function forEach(obj, callback) {
    for(var key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        callback(key);
    }
}
function assign(target, source) {
    forEach(source, function(key) {
        target[key] = source[key];
    });
    return target;
}
function clearCache(requireCache) {
    forEach(requireCache, function(resolvedPath) {
        if (!isNative.test(resolvedPath)) delete requireCache[resolvedPath];
    });
}
module.exports = function(requireCache, callback, callbackForModulesToKeep, module1) {
    var originalCache = assign({}, requireCache);
    clearCache(requireCache);
    if (callbackForModulesToKeep) {
        var originalModuleChildren = module1.children ? module1.children.slice() : false; // Creates a shallow copy of module.children
        callbackForModulesToKeep();
        // Lists the cache entries made by callbackForModulesToKeep()
        var modulesToKeep = [];
        forEach(requireCache, function(key) {
            modulesToKeep.push(key);
        });
        // Discards the modules required in callbackForModulesToKeep()
        clearCache(requireCache);
        if (module1.children) module1.children = originalModuleChildren; // Removes last references to modules required in callbackForModulesToKeep() -> No memory leak
        // Takes the cache entries of the original cache in case the modules where required before
        for(var i = 0; i < modulesToKeep.length; i += 1)if (originalCache[modulesToKeep[i]]) requireCache[modulesToKeep[i]] = originalCache[modulesToKeep[i]];
    }
    var freshModule = callback();
    var stealthCache = callbackForModulesToKeep ? assign({}, requireCache) : false;
    clearCache(requireCache);
    if (callbackForModulesToKeep) {
        // In case modules to keep were required inside the stealthy require for the first time, copy them to the restored cache
        for(var k = 0; k < modulesToKeep.length; k += 1)if (stealthCache[modulesToKeep[k]]) requireCache[modulesToKeep[k]] = stealthCache[modulesToKeep[k]];
    }
    assign(requireCache, originalCache);
    return freshModule;
};

},{}],"6JQv4":[function(require,module,exports) {
// Copyright 2010-2012 Mikeal Rogers
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
"use strict";
var extend = require("5957cd4242ebf2f2");
var cookies = require("622c755bb6ae16f6");
var helpers = require("b80cd02299b28c20");
var paramsHaveRequestBody = helpers.paramsHaveRequestBody;
// organize params for patch, post, put, head, del
function initParams(uri, options, callback) {
    if (typeof options === "function") callback = options;
    var params = {};
    if (options !== null && typeof options === "object") extend(params, options, {
        uri: uri
    });
    else if (typeof uri === "string") extend(params, {
        uri: uri
    });
    else extend(params, uri);
    params.callback = callback || params.callback;
    return params;
}
function request(uri, options, callback) {
    if (typeof uri === "undefined") throw new Error("undefined is not a valid uri or options object.");
    var params = initParams(uri, options, callback);
    if (params.method === "HEAD" && paramsHaveRequestBody(params)) throw new Error("HTTP HEAD requests MUST NOT include a request body.");
    return new request.Request(params);
}
function verbFunc(verb) {
    var method = verb.toUpperCase();
    return function(uri, options, callback) {
        var params = initParams(uri, options, callback);
        params.method = method;
        return request(params, params.callback);
    };
}
// define like this to please codeintel/intellisense IDEs
request.get = verbFunc("get");
request.head = verbFunc("head");
request.options = verbFunc("options");
request.post = verbFunc("post");
request.put = verbFunc("put");
request.patch = verbFunc("patch");
request.del = verbFunc("delete");
request["delete"] = verbFunc("delete");
request.jar = function(store) {
    return cookies.jar(store);
};
request.cookie = function(str) {
    return cookies.parse(str);
};
function wrapRequestMethod(method, options, requester, verb) {
    return function(uri, opts, callback) {
        var params = initParams(uri, opts, callback);
        var target = {};
        extend(true, target, options, params);
        target.pool = params.pool || options.pool;
        if (verb) target.method = verb.toUpperCase();
        if (typeof requester === "function") method = requester;
        return method(target, target.callback);
    };
}
request.defaults = function(options, requester) {
    var self = this;
    options = options || {};
    if (typeof options === "function") {
        requester = options;
        options = {};
    }
    var defaults = wrapRequestMethod(self, options, requester);
    var verbs = [
        "get",
        "head",
        "post",
        "put",
        "patch",
        "del",
        "delete"
    ];
    verbs.forEach(function(verb) {
        defaults[verb] = wrapRequestMethod(self[verb], options, requester, verb);
    });
    defaults.cookie = wrapRequestMethod(self.cookie, options, requester);
    defaults.jar = self.jar;
    defaults.defaults = self.defaults;
    return defaults;
};
request.forever = function(agentOptions, optionsArg) {
    var options = {};
    if (optionsArg) extend(options, optionsArg);
    if (agentOptions) options.agentOptions = agentOptions;
    options.forever = true;
    return request.defaults(options);
};
// Exports
module.exports = request;
request.Request = require("804424fc01a5ff5d");
request.initParams = initParams;
// Backwards compatibility for request.debug
Object.defineProperty(request, "debug", {
    enumerable: true,
    get: function() {
        return request.Request.debug;
    },
    set: function(debug) {
        request.Request.debug = debug;
    }
});

},{"5957cd4242ebf2f2":"3ZGTo","622c755bb6ae16f6":"fWA8Q","b80cd02299b28c20":"37SAC","804424fc01a5ff5d":"cMLzO"}],"3ZGTo":[function(require,module,exports) {
"use strict";
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return toStr.call(arr) === "[object Array]";
};
var isPlainObject = function isPlainObject(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
    if (defineProperty && options.name === "__proto__") defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!hasOwn.call(obj, name)) return void 0;
        else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = getProperty(target, name);
            copy = getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray(src) ? src : [];
                    } else clone = src && isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

},{}],"fWA8Q":[function(require,module,exports) {
"use strict";
var tough = require("f99ee3a45257f86a");
var Cookie = tough.Cookie;
var CookieJar = tough.CookieJar;
exports.parse = function(str) {
    if (str && str.uri) str = str.uri;
    if (typeof str !== "string") throw new Error("The cookie function only accepts STRING as param");
    return Cookie.parse(str, {
        loose: true
    });
};
// Adapt the sometimes-Async api of tough.CookieJar to our requirements
function RequestJar(store) {
    var self = this;
    self._jar = new CookieJar(store, {
        looseMode: true
    });
}
RequestJar.prototype.setCookie = function(cookieOrStr, uri, options) {
    var self = this;
    return self._jar.setCookieSync(cookieOrStr, uri, options || {});
};
RequestJar.prototype.getCookieString = function(uri) {
    var self = this;
    return self._jar.getCookieStringSync(uri);
};
RequestJar.prototype.getCookies = function(uri) {
    var self = this;
    return self._jar.getCookiesSync(uri);
};
exports.jar = function(store) {
    return new RequestJar(store);
};

},{"f99ee3a45257f86a":"JK3wo"}],"JK3wo":[function(require,module,exports) {
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ "use strict";
var net = require("21d22bb892bb7293");
var urlParse = require("bb6b4d383b33cea8").parse;
var util = require("2e0c777cc3828bd4");
var pubsuffix = require("c17e29454b90a5d5");
var Store = require("25dad64a6e179994").Store;
var MemoryCookieStore = require("d74ac4918cabaeff").MemoryCookieStore;
var pathMatch = require("835feb1cdebb5e1b").pathMatch;
var VERSION = require("c937d48c3523e601");
var punycode;
try {
    punycode = require("a850fd6322f59bc0");
} catch (e) {
    console.warn("tough-cookie: can't load punycode; won't use punycode for domain normalization");
}
// From RFC6265 S4.1.1
// note that it excludes \x3B ";"
var COOKIE_OCTETS = /^[\x21\x23-\x2B\x2D-\x3A\x3C-\x5B\x5D-\x7E]+$/;
var CONTROL_CHARS = /[\x00-\x1F]/;
// From Chromium // '\r', '\n' and '\0' should be treated as a terminator in
// the "relaxed" mode, see:
// https://github.com/ChromiumWebApps/chromium/blob/b3d3b4da8bb94c1b2e061600df106d590fda3620/net/cookies/parsed_cookie.cc#L60
var TERMINATORS = [
    "\n",
    "\r",
    "\0"
];
// RFC6265 S4.1.1 defines path value as 'any CHAR except CTLs or ";"'
// Note ';' is \x3B
var PATH_VALUE = /[\x20-\x3A\x3C-\x7E]+/;
// date-time parsing constants (RFC6265 S5.1.1)
var DATE_DELIM = /[\x09\x20-\x2F\x3B-\x40\x5B-\x60\x7B-\x7E]/;
var MONTH_TO_NUM = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11
};
var NUM_TO_MONTH = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var NUM_TO_DAY = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MAX_TIME = 2147483647000; // 31-bit max
var MIN_TIME = 0; // 31-bit min
/*
 * Parses a Natural number (i.e., non-negative integer) with either the
 *    <min>*<max>DIGIT ( non-digit *OCTET )
 * or
 *    <min>*<max>DIGIT
 * grammar (RFC6265 S5.1.1).
 *
 * The "trailingOK" boolean controls if the grammar accepts a
 * "( non-digit *OCTET )" trailer.
 */ function parseDigits(token, minDigits, maxDigits, trailingOK) {
    var count = 0;
    while(count < token.length){
        var c = token.charCodeAt(count);
        // "non-digit = %x00-2F / %x3A-FF"
        if (c <= 0x2F || c >= 0x3A) break;
        count++;
    }
    // constrain to a minimum and maximum number of digits.
    if (count < minDigits || count > maxDigits) return null;
    if (!trailingOK && count != token.length) return null;
    return parseInt(token.substr(0, count), 10);
}
function parseTime(token) {
    var parts = token.split(":");
    var result = [
        0,
        0,
        0
    ];
    /* RF6256 S5.1.1:
   *      time            = hms-time ( non-digit *OCTET )
   *      hms-time        = time-field ":" time-field ":" time-field
   *      time-field      = 1*2DIGIT
   */ if (parts.length !== 3) return null;
    for(var i = 0; i < 3; i++){
        // "time-field" must be strictly "1*2DIGIT", HOWEVER, "hms-time" can be
        // followed by "( non-digit *OCTET )" so therefore the last time-field can
        // have a trailer
        var trailingOK = i == 2;
        var num = parseDigits(parts[i], 1, 2, trailingOK);
        if (num === null) return null;
        result[i] = num;
    }
    return result;
}
function parseMonth(token) {
    token = String(token).substr(0, 3).toLowerCase();
    var num = MONTH_TO_NUM[token];
    return num >= 0 ? num : null;
}
/*
 * RFC6265 S5.1.1 date parser (see RFC for full grammar)
 */ function parseDate(str) {
    if (!str) return;
    /* RFC6265 S5.1.1:
   * 2. Process each date-token sequentially in the order the date-tokens
   * appear in the cookie-date
   */ var tokens = str.split(DATE_DELIM);
    if (!tokens) return;
    var hour = null;
    var minute = null;
    var second = null;
    var dayOfMonth = null;
    var month = null;
    var year = null;
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i].trim();
        if (!token.length) continue;
        var result;
        /* 2.1. If the found-time flag is not set and the token matches the time
     * production, set the found-time flag and set the hour- value,
     * minute-value, and second-value to the numbers denoted by the digits in
     * the date-token, respectively.  Skip the remaining sub-steps and continue
     * to the next date-token.
     */ if (second === null) {
            result = parseTime(token);
            if (result) {
                hour = result[0];
                minute = result[1];
                second = result[2];
                continue;
            }
        }
        /* 2.2. If the found-day-of-month flag is not set and the date-token matches
     * the day-of-month production, set the found-day-of- month flag and set
     * the day-of-month-value to the number denoted by the date-token.  Skip
     * the remaining sub-steps and continue to the next date-token.
     */ if (dayOfMonth === null) {
            // "day-of-month = 1*2DIGIT ( non-digit *OCTET )"
            result = parseDigits(token, 1, 2, true);
            if (result !== null) {
                dayOfMonth = result;
                continue;
            }
        }
        /* 2.3. If the found-month flag is not set and the date-token matches the
     * month production, set the found-month flag and set the month-value to
     * the month denoted by the date-token.  Skip the remaining sub-steps and
     * continue to the next date-token.
     */ if (month === null) {
            result = parseMonth(token);
            if (result !== null) {
                month = result;
                continue;
            }
        }
        /* 2.4. If the found-year flag is not set and the date-token matches the
     * year production, set the found-year flag and set the year-value to the
     * number denoted by the date-token.  Skip the remaining sub-steps and
     * continue to the next date-token.
     */ if (year === null) {
            // "year = 2*4DIGIT ( non-digit *OCTET )"
            result = parseDigits(token, 2, 4, true);
            if (result !== null) {
                year = result;
                /* From S5.1.1:
         * 3.  If the year-value is greater than or equal to 70 and less
         * than or equal to 99, increment the year-value by 1900.
         * 4.  If the year-value is greater than or equal to 0 and less
         * than or equal to 69, increment the year-value by 2000.
         */ if (year >= 70 && year <= 99) year += 1900;
                else if (year >= 0 && year <= 69) year += 2000;
            }
        }
    }
    /* RFC 6265 S5.1.1
   * "5. Abort these steps and fail to parse the cookie-date if:
   *     *  at least one of the found-day-of-month, found-month, found-
   *        year, or found-time flags is not set,
   *     *  the day-of-month-value is less than 1 or greater than 31,
   *     *  the year-value is less than 1601,
   *     *  the hour-value is greater than 23,
   *     *  the minute-value is greater than 59, or
   *     *  the second-value is greater than 59.
   *     (Note that leap seconds cannot be represented in this syntax.)"
   *
   * So, in order as above:
   */ if (dayOfMonth === null || month === null || year === null || second === null || dayOfMonth < 1 || dayOfMonth > 31 || year < 1601 || hour > 23 || minute > 59 || second > 59) return;
    return new Date(Date.UTC(year, month, dayOfMonth, hour, minute, second));
}
function formatDate(date) {
    var d = date.getUTCDate();
    d = d >= 10 ? d : "0" + d;
    var h = date.getUTCHours();
    h = h >= 10 ? h : "0" + h;
    var m = date.getUTCMinutes();
    m = m >= 10 ? m : "0" + m;
    var s = date.getUTCSeconds();
    s = s >= 10 ? s : "0" + s;
    return NUM_TO_DAY[date.getUTCDay()] + ", " + d + " " + NUM_TO_MONTH[date.getUTCMonth()] + " " + date.getUTCFullYear() + " " + h + ":" + m + ":" + s + " GMT";
}
// S5.1.2 Canonicalized Host Names
function canonicalDomain(str) {
    if (str == null) return null;
    str = str.trim().replace(/^\./, ""); // S4.1.2.3 & S5.2.3: ignore leading .
    // convert to IDN if any non-ASCII characters
    if (punycode && /[^\u0001-\u007f]/.test(str)) str = punycode.toASCII(str);
    return str.toLowerCase();
}
// S5.1.3 Domain Matching
function domainMatch(str, domStr, canonicalize) {
    if (str == null || domStr == null) return null;
    if (canonicalize !== false) {
        str = canonicalDomain(str);
        domStr = canonicalDomain(domStr);
    }
    /*
   * "The domain string and the string are identical. (Note that both the
   * domain string and the string will have been canonicalized to lower case at
   * this point)"
   */ if (str == domStr) return true;
    /* "All of the following [three] conditions hold:" (order adjusted from the RFC) */ /* "* The string is a host name (i.e., not an IP address)." */ if (net.isIP(str)) return false;
    /* "* The domain string is a suffix of the string" */ var idx = str.indexOf(domStr);
    if (idx <= 0) return false; // it's a non-match (-1) or prefix (0)
    // e.g "a.b.c".indexOf("b.c") === 2
    // 5 === 3+2
    if (str.length !== domStr.length + idx) return false;
    /* "* The last character of the string that is not included in the domain
  * string is a %x2E (".") character." */ if (str.substr(idx - 1, 1) !== ".") return false;
    return true;
}
// RFC6265 S5.1.4 Paths and Path-Match
/*
 * "The user agent MUST use an algorithm equivalent to the following algorithm
 * to compute the default-path of a cookie:"
 *
 * Assumption: the path (and not query part or absolute uri) is passed in.
 */ function defaultPath(path) {
    // "2. If the uri-path is empty or if the first character of the uri-path is not
    // a %x2F ("/") character, output %x2F ("/") and skip the remaining steps.
    if (!path || path.substr(0, 1) !== "/") return "/";
    // "3. If the uri-path contains no more than one %x2F ("/") character, output
    // %x2F ("/") and skip the remaining step."
    if (path === "/") return path;
    var rightSlash = path.lastIndexOf("/");
    if (rightSlash === 0) return "/";
    // "4. Output the characters of the uri-path from the first character up to,
    // but not including, the right-most %x2F ("/")."
    return path.slice(0, rightSlash);
}
function trimTerminator(str) {
    for(var t = 0; t < TERMINATORS.length; t++){
        var terminatorIdx = str.indexOf(TERMINATORS[t]);
        if (terminatorIdx !== -1) str = str.substr(0, terminatorIdx);
    }
    return str;
}
function parseCookiePair(cookiePair, looseMode) {
    cookiePair = trimTerminator(cookiePair);
    var firstEq = cookiePair.indexOf("=");
    if (looseMode) {
        if (firstEq === 0) {
            cookiePair = cookiePair.substr(1);
            firstEq = cookiePair.indexOf("="); // might still need to split on '='
        }
    } else {
        if (firstEq <= 0) return; // needs to have non-empty "cookie-name"
    }
    var cookieName, cookieValue;
    if (firstEq <= 0) {
        cookieName = "";
        cookieValue = cookiePair.trim();
    } else {
        cookieName = cookiePair.substr(0, firstEq).trim();
        cookieValue = cookiePair.substr(firstEq + 1).trim();
    }
    if (CONTROL_CHARS.test(cookieName) || CONTROL_CHARS.test(cookieValue)) return;
    var c = new Cookie();
    c.key = cookieName;
    c.value = cookieValue;
    return c;
}
function parse(str, options) {
    if (!options || typeof options !== "object") options = {};
    str = str.trim();
    // We use a regex to parse the "name-value-pair" part of S5.2
    var firstSemi = str.indexOf(";"); // S5.2 step 1
    var cookiePair = firstSemi === -1 ? str : str.substr(0, firstSemi);
    var c = parseCookiePair(cookiePair, !!options.loose);
    if (!c) return;
    if (firstSemi === -1) return c;
    // S5.2.3 "unparsed-attributes consist of the remainder of the set-cookie-string
    // (including the %x3B (";") in question)." plus later on in the same section
    // "discard the first ";" and trim".
    var unparsed = str.slice(firstSemi + 1).trim();
    // "If the unparsed-attributes string is empty, skip the rest of these
    // steps."
    if (unparsed.length === 0) return c;
    /*
   * S5.2 says that when looping over the items "[p]rocess the attribute-name
   * and attribute-value according to the requirements in the following
   * subsections" for every item.  Plus, for many of the individual attributes
   * in S5.3 it says to use the "attribute-value of the last attribute in the
   * cookie-attribute-list".  Therefore, in this implementation, we overwrite
   * the previous value.
   */ var cookie_avs = unparsed.split(";");
    while(cookie_avs.length){
        var av = cookie_avs.shift().trim();
        if (av.length === 0) continue;
        var av_sep = av.indexOf("=");
        var av_key, av_value;
        if (av_sep === -1) {
            av_key = av;
            av_value = null;
        } else {
            av_key = av.substr(0, av_sep);
            av_value = av.substr(av_sep + 1);
        }
        av_key = av_key.trim().toLowerCase();
        if (av_value) av_value = av_value.trim();
        switch(av_key){
            case "expires":
                if (av_value) {
                    var exp = parseDate(av_value);
                    // "If the attribute-value failed to parse as a cookie date, ignore the
                    // cookie-av."
                    if (exp) // over and underflow not realistically a concern: V8's getTime() seems to
                    // store something larger than a 32-bit time_t (even with 32-bit node)
                    c.expires = exp;
                }
                break;
            case "max-age":
                if (av_value) // "If the first character of the attribute-value is not a DIGIT or a "-"
                // character ...[or]... If the remainder of attribute-value contains a
                // non-DIGIT character, ignore the cookie-av."
                {
                    if (/^-?[0-9]+$/.test(av_value)) {
                        var delta = parseInt(av_value, 10);
                        // "If delta-seconds is less than or equal to zero (0), let expiry-time
                        // be the earliest representable date and time."
                        c.setMaxAge(delta);
                    }
                }
                break;
            case "domain":
                // "If the attribute-value is empty, the behavior is undefined.  However,
                // the user agent SHOULD ignore the cookie-av entirely."
                if (av_value) {
                    // S5.2.3 "Let cookie-domain be the attribute-value without the leading %x2E
                    // (".") character."
                    var domain = av_value.trim().replace(/^\./, "");
                    if (domain) // "Convert the cookie-domain to lower case."
                    c.domain = domain.toLowerCase();
                }
                break;
            case "path":
                /*
       * "If the attribute-value is empty or if the first character of the
       * attribute-value is not %x2F ("/"):
       *   Let cookie-path be the default-path.
       * Otherwise:
       *   Let cookie-path be the attribute-value."
       *
       * We'll represent the default-path as null since it depends on the
       * context of the parsing.
       */ c.path = av_value && av_value[0] === "/" ? av_value : null;
                break;
            case "secure":
                /*
       * "If the attribute-name case-insensitively matches the string "Secure",
       * the user agent MUST append an attribute to the cookie-attribute-list
       * with an attribute-name of Secure and an empty attribute-value."
       */ c.secure = true;
                break;
            case "httponly":
                c.httpOnly = true;
                break;
            default:
                c.extensions = c.extensions || [];
                c.extensions.push(av);
                break;
        }
    }
    return c;
}
// avoid the V8 deoptimization monster!
function jsonParse(str) {
    var obj;
    try {
        obj = JSON.parse(str);
    } catch (e) {
        return e;
    }
    return obj;
}
function fromJSON(str) {
    if (!str) return null;
    var obj;
    if (typeof str === "string") {
        obj = jsonParse(str);
        if (obj instanceof Error) return null;
    } else // assume it's an Object
    obj = str;
    var c = new Cookie();
    for(var i = 0; i < Cookie.serializableProperties.length; i++){
        var prop = Cookie.serializableProperties[i];
        if (obj[prop] === undefined || obj[prop] === Cookie.prototype[prop]) continue; // leave as prototype default
        if (prop === "expires" || prop === "creation" || prop === "lastAccessed") {
            if (obj[prop] === null) c[prop] = null;
            else c[prop] = obj[prop] == "Infinity" ? "Infinity" : new Date(obj[prop]);
        } else c[prop] = obj[prop];
    }
    return c;
}
/* Section 5.4 part 2:
 * "*  Cookies with longer paths are listed before cookies with
 *     shorter paths.
 *
 *  *  Among cookies that have equal-length path fields, cookies with
 *     earlier creation-times are listed before cookies with later
 *     creation-times."
 */ function cookieCompare(a, b) {
    var cmp = 0;
    // descending for length: b CMP a
    var aPathLen = a.path ? a.path.length : 0;
    var bPathLen = b.path ? b.path.length : 0;
    cmp = bPathLen - aPathLen;
    if (cmp !== 0) return cmp;
    // ascending for time: a CMP b
    var aTime = a.creation ? a.creation.getTime() : MAX_TIME;
    var bTime = b.creation ? b.creation.getTime() : MAX_TIME;
    cmp = aTime - bTime;
    if (cmp !== 0) return cmp;
    // break ties for the same millisecond (precision of JavaScript's clock)
    cmp = a.creationIndex - b.creationIndex;
    return cmp;
}
// Gives the permutation of all possible pathMatch()es of a given path. The
// array is in longest-to-shortest order.  Handy for indexing.
function permutePath(path) {
    if (path === "/") return [
        "/"
    ];
    if (path.lastIndexOf("/") === path.length - 1) path = path.substr(0, path.length - 1);
    var permutations = [
        path
    ];
    while(path.length > 1){
        var lindex = path.lastIndexOf("/");
        if (lindex === 0) break;
        path = path.substr(0, lindex);
        permutations.push(path);
    }
    permutations.push("/");
    return permutations;
}
function getCookieContext(url) {
    if (url instanceof Object) return url;
    // NOTE: decodeURI will throw on malformed URIs (see GH-32).
    // Therefore, we will just skip decoding for such URIs.
    try {
        url = decodeURI(url);
    } catch (err) {
    // Silently swallow error
    }
    return urlParse(url);
}
function Cookie(options) {
    options = options || {};
    Object.keys(options).forEach(function(prop) {
        if (Cookie.prototype.hasOwnProperty(prop) && Cookie.prototype[prop] !== options[prop] && prop.substr(0, 1) !== "_") this[prop] = options[prop];
    }, this);
    this.creation = this.creation || new Date();
    // used to break creation ties in cookieCompare():
    Object.defineProperty(this, "creationIndex", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: ++Cookie.cookiesCreated
    });
}
Cookie.cookiesCreated = 0; // incremented each time a cookie is created
Cookie.parse = parse;
Cookie.fromJSON = fromJSON;
Cookie.prototype.key = "";
Cookie.prototype.value = "";
// the order in which the RFC has them:
Cookie.prototype.expires = "Infinity"; // coerces to literal Infinity
Cookie.prototype.maxAge = null; // takes precedence over expires for TTL
Cookie.prototype.domain = null;
Cookie.prototype.path = null;
Cookie.prototype.secure = false;
Cookie.prototype.httpOnly = false;
Cookie.prototype.extensions = null;
// set by the CookieJar:
Cookie.prototype.hostOnly = null; // boolean when set
Cookie.prototype.pathIsDefault = null; // boolean when set
Cookie.prototype.creation = null; // Date when set; defaulted by Cookie.parse
Cookie.prototype.lastAccessed = null; // Date when set
Object.defineProperty(Cookie.prototype, "creationIndex", {
    configurable: true,
    enumerable: false,
    writable: true,
    value: 0
});
Cookie.serializableProperties = Object.keys(Cookie.prototype).filter(function(prop) {
    return !(Cookie.prototype[prop] instanceof Function || prop === "creationIndex" || prop.substr(0, 1) === "_");
});
Cookie.prototype.inspect = function inspect() {
    var now = Date.now();
    return 'Cookie="' + this.toString() + "; hostOnly=" + (this.hostOnly != null ? this.hostOnly : "?") + "; aAge=" + (this.lastAccessed ? now - this.lastAccessed.getTime() + "ms" : "?") + "; cAge=" + (this.creation ? now - this.creation.getTime() + "ms" : "?") + '"';
};
// Use the new custom inspection symbol to add the custom inspect function if
// available.
if (util.inspect.custom) Cookie.prototype[util.inspect.custom] = Cookie.prototype.inspect;
Cookie.prototype.toJSON = function() {
    var obj = {};
    var props = Cookie.serializableProperties;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (this[prop] === Cookie.prototype[prop]) continue; // leave as prototype default
        if (prop === "expires" || prop === "creation" || prop === "lastAccessed") {
            if (this[prop] === null) obj[prop] = null;
            else obj[prop] = this[prop] == "Infinity" ? "Infinity" : this[prop].toISOString();
        } else if (prop === "maxAge") {
            if (this[prop] !== null) // again, intentionally not ===
            obj[prop] = this[prop] == Infinity || this[prop] == -Infinity ? this[prop].toString() : this[prop];
        } else if (this[prop] !== Cookie.prototype[prop]) obj[prop] = this[prop];
    }
    return obj;
};
Cookie.prototype.clone = function() {
    return fromJSON(this.toJSON());
};
Cookie.prototype.validate = function validate() {
    if (!COOKIE_OCTETS.test(this.value)) return false;
    if (this.expires != Infinity && !(this.expires instanceof Date) && !parseDate(this.expires)) return false;
    if (this.maxAge != null && this.maxAge <= 0) return false; // "Max-Age=" non-zero-digit *DIGIT
    if (this.path != null && !PATH_VALUE.test(this.path)) return false;
    var cdomain = this.cdomain();
    if (cdomain) {
        if (cdomain.match(/\.$/)) return false; // S4.1.2.3 suggests that this is bad. domainMatch() tests confirm this
        var suffix = pubsuffix.getPublicSuffix(cdomain);
        if (suffix == null) return false;
    }
    return true;
};
Cookie.prototype.setExpires = function setExpires(exp) {
    if (exp instanceof Date) this.expires = exp;
    else this.expires = parseDate(exp) || "Infinity";
};
Cookie.prototype.setMaxAge = function setMaxAge(age) {
    if (age === Infinity || age === -Infinity) this.maxAge = age.toString(); // so JSON.stringify() works
    else this.maxAge = age;
};
// gives Cookie header format
Cookie.prototype.cookieString = function cookieString() {
    var val = this.value;
    if (val == null) val = "";
    if (this.key === "") return val;
    return this.key + "=" + val;
};
// gives Set-Cookie header format
Cookie.prototype.toString = function toString() {
    var str = this.cookieString();
    if (this.expires != Infinity) {
        if (this.expires instanceof Date) str += "; Expires=" + formatDate(this.expires);
        else str += "; Expires=" + this.expires;
    }
    if (this.maxAge != null && this.maxAge != Infinity) str += "; Max-Age=" + this.maxAge;
    if (this.domain && !this.hostOnly) str += "; Domain=" + this.domain;
    if (this.path) str += "; Path=" + this.path;
    if (this.secure) str += "; Secure";
    if (this.httpOnly) str += "; HttpOnly";
    if (this.extensions) this.extensions.forEach(function(ext) {
        str += "; " + ext;
    });
    return str;
};
// TTL() partially replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
// elsewhere)
// S5.3 says to give the "latest representable date" for which we use Infinity
// For "expired" we use 0
Cookie.prototype.TTL = function TTL(now) {
    /* RFC6265 S4.1.2.2 If a cookie has both the Max-Age and the Expires
   * attribute, the Max-Age attribute has precedence and controls the
   * expiration date of the cookie.
   * (Concurs with S5.3 step 3)
   */ if (this.maxAge != null) return this.maxAge <= 0 ? 0 : this.maxAge * 1000;
    var expires = this.expires;
    if (expires != Infinity) {
        if (!(expires instanceof Date)) expires = parseDate(expires) || Infinity;
        if (expires == Infinity) return Infinity;
        return expires.getTime() - (now || Date.now());
    }
    return Infinity;
};
// expiryTime() replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
// elsewhere)
Cookie.prototype.expiryTime = function expiryTime(now) {
    if (this.maxAge != null) {
        var relativeTo = now || this.creation || new Date();
        var age = this.maxAge <= 0 ? -Infinity : this.maxAge * 1000;
        return relativeTo.getTime() + age;
    }
    if (this.expires == Infinity) return Infinity;
    return this.expires.getTime();
};
// expiryDate() replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
// elsewhere), except it returns a Date
Cookie.prototype.expiryDate = function expiryDate(now) {
    var millisec = this.expiryTime(now);
    if (millisec == Infinity) return new Date(MAX_TIME);
    else if (millisec == -Infinity) return new Date(MIN_TIME);
    else return new Date(millisec);
};
// This replaces the "persistent-flag" parts of S5.3 step 3
Cookie.prototype.isPersistent = function isPersistent() {
    return this.maxAge != null || this.expires != Infinity;
};
// Mostly S5.1.2 and S5.2.3:
Cookie.prototype.cdomain = Cookie.prototype.canonicalizedDomain = function canonicalizedDomain() {
    if (this.domain == null) return null;
    return canonicalDomain(this.domain);
};
function CookieJar(store, options) {
    if (typeof options === "boolean") options = {
        rejectPublicSuffixes: options
    };
    else if (options == null) options = {};
    if (options.rejectPublicSuffixes != null) this.rejectPublicSuffixes = options.rejectPublicSuffixes;
    if (options.looseMode != null) this.enableLooseMode = options.looseMode;
    if (!store) store = new MemoryCookieStore();
    this.store = store;
}
CookieJar.prototype.store = null;
CookieJar.prototype.rejectPublicSuffixes = true;
CookieJar.prototype.enableLooseMode = false;
var CAN_BE_SYNC = [];
CAN_BE_SYNC.push("setCookie");
CookieJar.prototype.setCookie = function(cookie, url, options, cb) {
    var err;
    var context = getCookieContext(url);
    if (options instanceof Function) {
        cb = options;
        options = {};
    }
    var host = canonicalDomain(context.hostname);
    var loose = this.enableLooseMode;
    if (options.loose != null) loose = options.loose;
    // S5.3 step 1
    if (!(cookie instanceof Cookie)) cookie = Cookie.parse(cookie, {
        loose: loose
    });
    if (!cookie) {
        err = new Error("Cookie failed to parse");
        return cb(options.ignoreError ? null : err);
    }
    // S5.3 step 2
    var now = options.now || new Date(); // will assign later to save effort in the face of errors
    // S5.3 step 3: NOOP; persistent-flag and expiry-time is handled by getCookie()
    // S5.3 step 4: NOOP; domain is null by default
    // S5.3 step 5: public suffixes
    if (this.rejectPublicSuffixes && cookie.domain) {
        var suffix = pubsuffix.getPublicSuffix(cookie.cdomain());
        if (suffix == null) {
            err = new Error("Cookie has domain set to a public suffix");
            return cb(options.ignoreError ? null : err);
        }
    }
    // S5.3 step 6:
    if (cookie.domain) {
        if (!domainMatch(host, cookie.cdomain(), false)) {
            err = new Error("Cookie not in this host's domain. Cookie:" + cookie.cdomain() + " Request:" + host);
            return cb(options.ignoreError ? null : err);
        }
        if (cookie.hostOnly == null) cookie.hostOnly = false;
    } else {
        cookie.hostOnly = true;
        cookie.domain = host;
    }
    //S5.2.4 If the attribute-value is empty or if the first character of the
    //attribute-value is not %x2F ("/"):
    //Let cookie-path be the default-path.
    if (!cookie.path || cookie.path[0] !== "/") {
        cookie.path = defaultPath(context.pathname);
        cookie.pathIsDefault = true;
    }
    // S5.3 step 8: NOOP; secure attribute
    // S5.3 step 9: NOOP; httpOnly attribute
    // S5.3 step 10
    if (options.http === false && cookie.httpOnly) {
        err = new Error("Cookie is HttpOnly and this isn't an HTTP API");
        return cb(options.ignoreError ? null : err);
    }
    var store = this.store;
    if (!store.updateCookie) store.updateCookie = function(oldCookie, newCookie, cb) {
        this.putCookie(newCookie, cb);
    };
    function withCookie(err, oldCookie) {
        if (err) return cb(err);
        var next = function(err) {
            if (err) return cb(err);
            else cb(null, cookie);
        };
        if (oldCookie) {
            // S5.3 step 11 - "If the cookie store contains a cookie with the same name,
            // domain, and path as the newly created cookie:"
            if (options.http === false && oldCookie.httpOnly) {
                err = new Error("old Cookie is HttpOnly and this isn't an HTTP API");
                return cb(options.ignoreError ? null : err);
            }
            cookie.creation = oldCookie.creation; // step 11.3
            cookie.creationIndex = oldCookie.creationIndex; // preserve tie-breaker
            cookie.lastAccessed = now;
            // Step 11.4 (delete cookie) is implied by just setting the new one:
            store.updateCookie(oldCookie, cookie, next); // step 12
        } else {
            cookie.creation = cookie.lastAccessed = now;
            store.putCookie(cookie, next); // step 12
        }
    }
    store.findCookie(cookie.domain, cookie.path, cookie.key, withCookie);
};
// RFC6365 S5.4
CAN_BE_SYNC.push("getCookies");
CookieJar.prototype.getCookies = function(url, options, cb) {
    var context = getCookieContext(url);
    if (options instanceof Function) {
        cb = options;
        options = {};
    }
    var host = canonicalDomain(context.hostname);
    var path = context.pathname || "/";
    var secure = options.secure;
    if (secure == null && context.protocol && (context.protocol == "https:" || context.protocol == "wss:")) secure = true;
    var http = options.http;
    if (http == null) http = true;
    var now = options.now || Date.now();
    var expireCheck = options.expire !== false;
    var allPaths = !!options.allPaths;
    var store = this.store;
    function matchingCookie(c) {
        // "Either:
        //   The cookie's host-only-flag is true and the canonicalized
        //   request-host is identical to the cookie's domain.
        // Or:
        //   The cookie's host-only-flag is false and the canonicalized
        //   request-host domain-matches the cookie's domain."
        if (c.hostOnly) {
            if (c.domain != host) return false;
        } else {
            if (!domainMatch(host, c.domain, false)) return false;
        }
        // "The request-uri's path path-matches the cookie's path."
        if (!allPaths && !pathMatch(path, c.path)) return false;
        // "If the cookie's secure-only-flag is true, then the request-uri's
        // scheme must denote a "secure" protocol"
        if (c.secure && !secure) return false;
        // "If the cookie's http-only-flag is true, then exclude the cookie if the
        // cookie-string is being generated for a "non-HTTP" API"
        if (c.httpOnly && !http) return false;
        // deferred from S5.3
        // non-RFC: allow retention of expired cookies by choice
        if (expireCheck && c.expiryTime() <= now) {
            store.removeCookie(c.domain, c.path, c.key, function() {}); // result ignored
            return false;
        }
        return true;
    }
    store.findCookies(host, allPaths ? null : path, function(err, cookies) {
        if (err) return cb(err);
        cookies = cookies.filter(matchingCookie);
        // sorting of S5.4 part 2
        if (options.sort !== false) cookies = cookies.sort(cookieCompare);
        // S5.4 part 3
        var now = new Date();
        cookies.forEach(function(c) {
            c.lastAccessed = now;
        });
        // TODO persist lastAccessed
        cb(null, cookies);
    });
};
CAN_BE_SYNC.push("getCookieString");
CookieJar.prototype.getCookieString = function() {
    var args = Array.prototype.slice.call(arguments, 0);
    var cb = args.pop();
    var next = function(err, cookies) {
        if (err) cb(err);
        else cb(null, cookies.sort(cookieCompare).map(function(c) {
            return c.cookieString();
        }).join("; "));
    };
    args.push(next);
    this.getCookies.apply(this, args);
};
CAN_BE_SYNC.push("getSetCookieStrings");
CookieJar.prototype.getSetCookieStrings = function() {
    var args = Array.prototype.slice.call(arguments, 0);
    var cb = args.pop();
    var next = function(err, cookies) {
        if (err) cb(err);
        else cb(null, cookies.map(function(c) {
            return c.toString();
        }));
    };
    args.push(next);
    this.getCookies.apply(this, args);
};
CAN_BE_SYNC.push("serialize");
CookieJar.prototype.serialize = function(cb) {
    var type = this.store.constructor.name;
    if (type === "Object") type = null;
    // update README.md "Serialization Format" if you change this, please!
    var serialized = {
        // The version of tough-cookie that serialized this jar. Generally a good
        // practice since future versions can make data import decisions based on
        // known past behavior. When/if this matters, use `semver`.
        version: "tough-cookie@" + VERSION,
        // add the store type, to make humans happy:
        storeType: type,
        // CookieJar configuration:
        rejectPublicSuffixes: !!this.rejectPublicSuffixes,
        // this gets filled from getAllCookies:
        cookies: []
    };
    if (!(this.store.getAllCookies && typeof this.store.getAllCookies === "function")) return cb(new Error("store does not support getAllCookies and cannot be serialized"));
    this.store.getAllCookies(function(err, cookies) {
        if (err) return cb(err);
        serialized.cookies = cookies.map(function(cookie) {
            // convert to serialized 'raw' cookies
            cookie = cookie instanceof Cookie ? cookie.toJSON() : cookie;
            // Remove the index so new ones get assigned during deserialization
            delete cookie.creationIndex;
            return cookie;
        });
        return cb(null, serialized);
    });
};
// well-known name that JSON.stringify calls
CookieJar.prototype.toJSON = function() {
    return this.serializeSync();
};
// use the class method CookieJar.deserialize instead of calling this directly
CAN_BE_SYNC.push("_importCookies");
CookieJar.prototype._importCookies = function(serialized, cb) {
    var jar = this;
    var cookies = serialized.cookies;
    if (!cookies || !Array.isArray(cookies)) return cb(new Error("serialized jar has no cookies array"));
    cookies = cookies.slice(); // do not modify the original
    function putNext(err) {
        if (err) return cb(err);
        if (!cookies.length) return cb(err, jar);
        var cookie;
        try {
            cookie = fromJSON(cookies.shift());
        } catch (e) {
            return cb(e);
        }
        if (cookie === null) return putNext(null); // skip this cookie
        jar.store.putCookie(cookie, putNext);
    }
    putNext();
};
CookieJar.deserialize = function(strOrObj, store, cb) {
    if (arguments.length !== 3) {
        // store is optional
        cb = store;
        store = null;
    }
    var serialized;
    if (typeof strOrObj === "string") {
        serialized = jsonParse(strOrObj);
        if (serialized instanceof Error) return cb(serialized);
    } else serialized = strOrObj;
    var jar = new CookieJar(store, serialized.rejectPublicSuffixes);
    jar._importCookies(serialized, function(err) {
        if (err) return cb(err);
        cb(null, jar);
    });
};
CookieJar.deserializeSync = function(strOrObj, store) {
    var serialized = typeof strOrObj === "string" ? JSON.parse(strOrObj) : strOrObj;
    var jar = new CookieJar(store, serialized.rejectPublicSuffixes);
    // catch this mistake early:
    if (!jar.store.synchronous) throw new Error("CookieJar store is not synchronous; use async API instead.");
    jar._importCookiesSync(serialized);
    return jar;
};
CookieJar.fromJSON = CookieJar.deserializeSync;
CookieJar.prototype.clone = function(newStore, cb) {
    if (arguments.length === 1) {
        cb = newStore;
        newStore = null;
    }
    this.serialize(function(err, serialized) {
        if (err) return cb(err);
        CookieJar.deserialize(serialized, newStore, cb);
    });
};
CAN_BE_SYNC.push("removeAllCookies");
CookieJar.prototype.removeAllCookies = function(cb) {
    var store = this.store;
    // Check that the store implements its own removeAllCookies(). The default
    // implementation in Store will immediately call the callback with a "not
    // implemented" Error.
    if (store.removeAllCookies instanceof Function && store.removeAllCookies !== Store.prototype.removeAllCookies) return store.removeAllCookies(cb);
    store.getAllCookies(function(err, cookies) {
        if (err) return cb(err);
        if (cookies.length === 0) return cb(null);
        var completedCount = 0;
        var removeErrors = [];
        function removeCookieCb(removeErr) {
            if (removeErr) removeErrors.push(removeErr);
            completedCount++;
            if (completedCount === cookies.length) return cb(removeErrors.length ? removeErrors[0] : null);
        }
        cookies.forEach(function(cookie) {
            store.removeCookie(cookie.domain, cookie.path, cookie.key, removeCookieCb);
        });
    });
};
CookieJar.prototype._cloneSync = syncWrap("clone");
CookieJar.prototype.cloneSync = function(newStore) {
    if (!newStore.synchronous) throw new Error("CookieJar clone destination store is not synchronous; use async API instead.");
    return this._cloneSync(newStore);
};
// Use a closure to provide a true imperative API for synchronous stores.
function syncWrap(method) {
    return function() {
        if (!this.store.synchronous) throw new Error("CookieJar store is not synchronous; use async API instead.");
        var args = Array.prototype.slice.call(arguments);
        var syncErr, syncResult;
        args.push(function syncCb(err, result) {
            syncErr = err;
            syncResult = result;
        });
        this[method].apply(this, args);
        if (syncErr) throw syncErr;
        return syncResult;
    };
}
// wrap all declared CAN_BE_SYNC methods in the sync wrapper
CAN_BE_SYNC.forEach(function(method) {
    CookieJar.prototype[method + "Sync"] = syncWrap(method);
});
exports.version = VERSION;
exports.CookieJar = CookieJar;
exports.Cookie = Cookie;
exports.Store = Store;
exports.MemoryCookieStore = MemoryCookieStore;
exports.parseDate = parseDate;
exports.formatDate = formatDate;
exports.parse = parse;
exports.fromJSON = fromJSON;
exports.domainMatch = domainMatch;
exports.defaultPath = defaultPath;
exports.pathMatch = pathMatch;
exports.getPublicSuffix = pubsuffix.getPublicSuffix;
exports.cookieCompare = cookieCompare;
exports.permuteDomain = require("cbb1518162343462").permuteDomain;
exports.permutePath = permutePath;
exports.canonicalDomain = canonicalDomain;

},{"21d22bb892bb7293":"49Rpi","bb6b4d383b33cea8":"eSLai","2e0c777cc3828bd4":"dJawj","c17e29454b90a5d5":"iIpMI","25dad64a6e179994":"cgCOH","d74ac4918cabaeff":"gJCsj","835feb1cdebb5e1b":"6PDj2","c937d48c3523e601":"pSqMQ","a850fd6322f59bc0":"8YYDt","cbb1518162343462":"9sdUx"}],"dJawj":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("bc23a3ea4a141c0b");
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
    if (!isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
    else str += " " + inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
    if (typeof process !== "undefined" && process.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof process === "undefined") return function() {
        return exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (process.throwDeprecation) throw new Error(msg);
            else if (process.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var debugs = {};
var debugEnvRegex = /^$/;
var debugEnv;
exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!debugs[set]) {
        if (debugEnvRegex.test(set)) {
            var pid = process.pid;
            debugs[set] = function() {
                var msg = exports.format.apply(exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else debugs[set] = function() {};
    }
    return debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    exports._extend(ctx, opts);
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];
    if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
    else return str;
}
function stylizeNoColor(str, styleType) {
    return str;
}
function arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if (isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if (isError(value)) return formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if (isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if (isError(value)) base = " " + formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
}
function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if (isNumber(value)) return ctx.stylize("" + value, "number");
    if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if (isNull(value)) return ctx.stylize("null", "null");
}
function formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
            else str = formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = require("6a1c15bae847a134");
function isArray(ar) {
    return Array.isArray(ar);
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === "boolean";
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === "number";
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === "string";
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === "symbol";
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return isObject(re) && objectToString(re) === "[object RegExp]";
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
exports.isDate = isDate;
exports.types.isDate = isDate;
function isError(e) {
    return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;
function isFunction(arg) {
    return typeof arg === "function";
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("a42137cd7fc8700d");
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function timestamp() {
    var d = new Date();
    var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
    console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
};
/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = require("a792e8e3e2aa1973");
exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
};
exports.promisify.custom = kCustomPromisifiedSymbol;
function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            process.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
}
exports.callbackify = callbackify;

},{"bc23a3ea4a141c0b":"g1F5c","6a1c15bae847a134":"9H0vM","a42137cd7fc8700d":"2FKlt","a792e8e3e2aa1973":"crNcs"}],"9H0vM":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
var isArgumentsObject = require("6b5f9ae3e436d527");
var isGeneratorFunction = require("285c2b8081bf4b68");
var whichTypedArray = require("e95b88ccd80e1671");
var isTypedArray = require("7db151546a22c2a8");
function uncurryThis(f) {
    return f.call.bind(f);
}
var BigIntSupported = typeof BigInt !== "undefined";
var SymbolSupported = typeof Symbol !== "undefined";
var ObjectToString = uncurryThis(Object.prototype.toString);
var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);
if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
function checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
exports.isPromise = isPromise;
function isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return isTypedArray(value) || isDataView(value);
}
exports.isArrayBufferView = isArrayBufferView;
function isUint8Array(value) {
    return whichTypedArray(value) === "Uint8Array";
}
exports.isUint8Array = isUint8Array;
function isUint8ClampedArray(value) {
    return whichTypedArray(value) === "Uint8ClampedArray";
}
exports.isUint8ClampedArray = isUint8ClampedArray;
function isUint16Array(value) {
    return whichTypedArray(value) === "Uint16Array";
}
exports.isUint16Array = isUint16Array;
function isUint32Array(value) {
    return whichTypedArray(value) === "Uint32Array";
}
exports.isUint32Array = isUint32Array;
function isInt8Array(value) {
    return whichTypedArray(value) === "Int8Array";
}
exports.isInt8Array = isInt8Array;
function isInt16Array(value) {
    return whichTypedArray(value) === "Int16Array";
}
exports.isInt16Array = isInt16Array;
function isInt32Array(value) {
    return whichTypedArray(value) === "Int32Array";
}
exports.isInt32Array = isInt32Array;
function isFloat32Array(value) {
    return whichTypedArray(value) === "Float32Array";
}
exports.isFloat32Array = isFloat32Array;
function isFloat64Array(value) {
    return whichTypedArray(value) === "Float64Array";
}
exports.isFloat64Array = isFloat64Array;
function isBigInt64Array(value) {
    return whichTypedArray(value) === "BigInt64Array";
}
exports.isBigInt64Array = isBigInt64Array;
function isBigUint64Array(value) {
    return whichTypedArray(value) === "BigUint64Array";
}
exports.isBigUint64Array = isBigUint64Array;
function isMapToString(value) {
    return ObjectToString(value) === "[object Map]";
}
isMapToString.working = typeof Map !== "undefined" && isMapToString(new Map());
function isMap(value) {
    if (typeof Map === "undefined") return false;
    return isMapToString.working ? isMapToString(value) : value instanceof Map;
}
exports.isMap = isMap;
function isSetToString(value) {
    return ObjectToString(value) === "[object Set]";
}
isSetToString.working = typeof Set !== "undefined" && isSetToString(new Set());
function isSet(value) {
    if (typeof Set === "undefined") return false;
    return isSetToString.working ? isSetToString(value) : value instanceof Set;
}
exports.isSet = isSet;
function isWeakMapToString(value) {
    return ObjectToString(value) === "[object WeakMap]";
}
isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(new WeakMap());
function isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;
function isWeakSetToString(value) {
    return ObjectToString(value) === "[object WeakSet]";
}
isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(new WeakSet());
function isWeakSet(value) {
    return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;
function isArrayBufferToString(value) {
    return ObjectToString(value) === "[object ArrayBuffer]";
}
isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
function isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;
function isDataViewToString(value) {
    return ObjectToString(value) === "[object DataView]";
}
isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
}
exports.isDataView = isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
    return ObjectToString(value) === "[object SharedArrayBuffer]";
}
function isSharedArrayBuffer(value) {
    if (typeof SharedArrayBufferCopy === "undefined") return false;
    if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
    return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;
function isAsyncFunction(value) {
    return ObjectToString(value) === "[object AsyncFunction]";
}
exports.isAsyncFunction = isAsyncFunction;
function isMapIterator(value) {
    return ObjectToString(value) === "[object Map Iterator]";
}
exports.isMapIterator = isMapIterator;
function isSetIterator(value) {
    return ObjectToString(value) === "[object Set Iterator]";
}
exports.isSetIterator = isSetIterator;
function isGeneratorObject(value) {
    return ObjectToString(value) === "[object Generator]";
}
exports.isGeneratorObject = isGeneratorObject;
function isWebAssemblyCompiledModule(value) {
    return ObjectToString(value) === "[object WebAssembly.Module]";
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
function isNumberObject(value) {
    return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;
function isStringObject(value) {
    return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;
function isBooleanObject(value) {
    return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;
function isBigIntObject(value) {
    return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;
function isSymbolObject(value) {
    return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;
function isBoxedPrimitive(value) {
    return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
}
exports.isBoxedPrimitive = isBoxedPrimitive;
function isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

},{"6b5f9ae3e436d527":"hvIur","285c2b8081bf4b68":"lYmCf","e95b88ccd80e1671":"budtm","7db151546a22c2a8":"cZinQ"}],"hvIur":[function(require,module,exports) {
"use strict";
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("649cbf9949986a39");
var $toString = callBound("Object.prototype.toString");
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $toString(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"e2b01ce809f132fb":"gH0lm","649cbf9949986a39":"5RJ3y"}],"gH0lm":[function(require,module,exports) {
"use strict";
var hasSymbols = require("2ef89576d4959bff");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"5Gfra"}],"5Gfra":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"5RJ3y":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"6LX47","266fc50410cfc4a":"WZ13z"}],"6LX47":[function(require,module,exports) {
"use strict";
var undefined1;
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $Error,
    "%eval%": eval,
    "%EvalError%": $EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $RangeError,
    "%ReferenceError%": $ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"ff34c740859aa28e":"bsxq3","349515b7ea9b6cef":"6c5mL","9da01653b2dd9abf":"fFo2M","68586abd6b0136da":"5Q8r9","662263fdbc077fc8":"kpGBG","abdfc34e5f6bb86":"hjSiH","daca1f932429e03e":"9Bu1E","1f00f712d594ccf":"2URnW","23730654306aa64c":"jgjsp","7c5e688e48cd07b0":"8UYGj","af36d49b4b8c6c7c":"3HKn4"}],"bsxq3":[function(require,module,exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

},{}],"6c5mL":[function(require,module,exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"fFo2M":[function(require,module,exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"5Q8r9":[function(require,module,exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"kpGBG":[function(require,module,exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"hjSiH":[function(require,module,exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"9Bu1E":[function(require,module,exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"2URnW":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"5Gfra"}],"jgjsp":[function(require,module,exports) {
"use strict";
var test = {
    __proto__: null,
    foo: {}
};
var $Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: test
    }).foo === test.foo && !(test instanceof $Object);
};

},{}],"8UYGj":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"hll4Y"}],"hll4Y":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"3HKn4":[function(require,module,exports) {
"use strict";
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"8UYGj"}],"WZ13z":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var setFunctionLength = require("f4b53071c102d4e");
var $TypeError = require("761613670c43be80");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $defineProperty = require("3426ee59b177cf96");
var $max = GetIntrinsic("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
    var func = $reflectApply(bind, $call, arguments);
    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"8UYGj","68d2ad3775278f43":"6LX47","f4b53071c102d4e":"fTlyp","761613670c43be80":"hjSiH","3426ee59b177cf96":"7WKHU"}],"fTlyp":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"6LX47","37dd1486f0f556ef":"8XcZz","6a9d2b46085df706":"k1QDR","2d412b0f532d1834":"jkcVH","4352c534d27fe477":"hjSiH"}],"8XcZz":[function(require,module,exports) {
"use strict";
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

},{"f17fd23367965521":"7WKHU","50f12088ee0f6bb":"kpGBG","45c79de2b2f9c949":"hjSiH","3f9bd39335781ec7":"jkcVH"}],"7WKHU":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8e0b8e4026aaf38a");
/** @type {import('.')} */ var $defineProperty = GetIntrinsic("%Object.defineProperty%", true) || false;
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{"8e0b8e4026aaf38a":"6LX47"}],"jkcVH":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("693e651525841e04");
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"693e651525841e04":"6LX47"}],"k1QDR":[function(require,module,exports) {
"use strict";
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"7WKHU"}],"lYmCf":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = require("b42ab74c25dbb155")();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function() {
    if (!hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if (isFnRegex.test(fnToStr.call(fn))) return true;
    if (!hasToStringTag) {
        var str = toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!getProto) return false;
    if (typeof GeneratorFunction === "undefined") {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
    }
    return getProto(fn) === GeneratorFunction;
};

},{"b42ab74c25dbb155":"gH0lm"}],"budtm":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var forEach = require("2941d48f36957e3c");
var availableTypedArrays = require("beaf5502a5823cce");
var callBind = require("e5d203a1b4c809f9");
var callBound = require("83f633f9b335db8f");
var gOPD = require("ce6b45c571ba4e3e");
/** @type {(O: object) => string} */ var $toString = callBound("Object.prototype.toString");
var hasToStringTag = require("9e7ef6c88184c56")();
var g = typeof globalThis === "undefined" ? global : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound("String.prototype.slice");
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var cache = {
    __proto__: null
};
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        cache["$" + typedArray] = callBind(descriptor.get);
    }
});
else forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    cache["$" + typedArray] = callBind(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!hasToStringTag) {
        /** @type {string} */ var tag = $slice($toString(value), 8, -1);
        if ($indexOf(typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return trySlices(value);
    }
    if (!gOPD) return null;
     // unknown engine
    return tryTypedArrays(value);
};

},{"2941d48f36957e3c":"eCFPC","beaf5502a5823cce":"h9M6v","e5d203a1b4c809f9":"WZ13z","83f633f9b335db8f":"5RJ3y","ce6b45c571ba4e3e":"jkcVH","9e7ef6c88184c56":"gH0lm"}],"eCFPC":[function(require,module,exports) {
"use strict";
var isCallable = require("e50ebc24bbb25feb");
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if (hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if (toStr.call(list) === "[object Array]") forEachArray(list, iterator, receiver);
    else if (typeof list === "string") forEachString(list, iterator, receiver);
    else forEachObject(list, iterator, receiver);
};
module.exports = forEach;

},{"e50ebc24bbb25feb":"4R2sz"}],"4R2sz":[function(require,module,exports) {
"use strict";
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") try {
    badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw isCallableMarker;
        }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function() {
        throw 42;
    }, null, badArrayLike);
} catch (_) {
    if (_ !== isCallableMarker) reflectApply = null;
}
else reflectApply = null;
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if (isES6ClassFn(value)) return false;
        fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var objectClass = "[object Object]";
var fnClass = "[object Function]";
var genClass = "[object GeneratorFunction]";
var ddaClass = "[object HTMLAllCollection]"; // IE 11
var ddaClass2 = "[object HTML document.all class]";
var ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
             || str === objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = reflectApply ? function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        reflectApply(value, null, badArrayLike);
    } catch (e) {
        if (e !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if (hasToStringTag) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
    return tryFunctionObject(value);
};

},{}],"h9M6v":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var possibleNames = require("3021d1584ad62785");
var g = typeof globalThis === "undefined" ? global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === "function") // @ts-expect-error
    out[out.length] = possibleNames[i];
    return out;
};

},{"3021d1584ad62785":"2YWAG"}],"2YWAG":[function(require,module,exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

},{}],"cZinQ":[function(require,module,exports) {
"use strict";
var whichTypedArray = require("ccf73e5f240c2b8");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!whichTypedArray(value);
};

},{"ccf73e5f240c2b8":"budtm"}],"2FKlt":[function(require,module,exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

},{}],"crNcs":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"iIpMI":[function(require,module,exports) {
/*!
 * Copyright (c) 2018, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ "use strict";
var psl = require("26ce2585e5d7a729");
function getPublicSuffix(domain) {
    return psl.get(domain);
}
exports.getPublicSuffix = getPublicSuffix;

},{"26ce2585e5d7a729":"kqyg0"}],"kqyg0":[function(require,module,exports) {
/*eslint no-var:0, prefer-arrow-callback: 0, object-shorthand: 0 */ "use strict";
var Punycode = require("99febcef612d4899");
var internals = {};
//
// Read rules from file.
//
internals.rules = require("5d082da49c224237").map(function(rule) {
    return {
        rule: rule,
        suffix: rule.replace(/^(\*\.|\!)/, ""),
        punySuffix: -1,
        wildcard: rule.charAt(0) === "*",
        exception: rule.charAt(0) === "!"
    };
});
//
// Check is given string ends with `suffix`.
//
internals.endsWith = function(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
};
//
// Find rule for a given domain.
//
internals.findRule = function(domain) {
    var punyDomain = Punycode.toASCII(domain);
    return internals.rules.reduce(function(memo, rule) {
        if (rule.punySuffix === -1) rule.punySuffix = Punycode.toASCII(rule.suffix);
        if (!internals.endsWith(punyDomain, "." + rule.punySuffix) && punyDomain !== rule.punySuffix) return memo;
        // This has been commented out as it never seems to run. This is because
        // sub tlds always appear after their parents and we never find a shorter
        // match.
        //if (memo) {
        //  var memoSuffix = Punycode.toASCII(memo.suffix);
        //  if (memoSuffix.length >= punySuffix.length) {
        //    return memo;
        //  }
        //}
        return rule;
    }, null);
};
//
// Error codes and messages.
//
exports.errorCodes = {
    DOMAIN_TOO_SHORT: "Domain name too short.",
    DOMAIN_TOO_LONG: "Domain name too long. It should be no more than 255 chars.",
    LABEL_STARTS_WITH_DASH: "Domain name label can not start with a dash.",
    LABEL_ENDS_WITH_DASH: "Domain name label can not end with a dash.",
    LABEL_TOO_LONG: "Domain name label should be at most 63 chars long.",
    LABEL_TOO_SHORT: "Domain name label should be at least 1 character long.",
    LABEL_INVALID_CHARS: "Domain name label can only contain alphanumeric characters or dashes."
};
//
// Validate domain name and throw if not valid.
//
// From wikipedia:
//
// Hostnames are composed of series of labels concatenated with dots, as are all
// domain names. Each label must be between 1 and 63 characters long, and the
// entire hostname (including the delimiting dots) has a maximum of 255 chars.
//
// Allowed chars:
//
// * `a-z`
// * `0-9`
// * `-` but not as a starting or ending character
// * `.` as a separator for the textual portions of a domain name
//
// * http://en.wikipedia.org/wiki/Domain_name
// * http://en.wikipedia.org/wiki/Hostname
//
internals.validate = function(input) {
    // Before we can validate we need to take care of IDNs with unicode chars.
    var ascii = Punycode.toASCII(input);
    if (ascii.length < 1) return "DOMAIN_TOO_SHORT";
    if (ascii.length > 255) return "DOMAIN_TOO_LONG";
    // Check each part's length and allowed chars.
    var labels = ascii.split(".");
    var label;
    for(var i = 0; i < labels.length; ++i){
        label = labels[i];
        if (!label.length) return "LABEL_TOO_SHORT";
        if (label.length > 63) return "LABEL_TOO_LONG";
        if (label.charAt(0) === "-") return "LABEL_STARTS_WITH_DASH";
        if (label.charAt(label.length - 1) === "-") return "LABEL_ENDS_WITH_DASH";
        if (!/^[a-z0-9\-]+$/.test(label)) return "LABEL_INVALID_CHARS";
    }
};
//
// Public API
//
//
// Parse domain.
//
exports.parse = function(input) {
    if (typeof input !== "string") throw new TypeError("Domain name must be a string.");
    // Force domain to lowercase.
    var domain = input.slice(0).toLowerCase();
    // Handle FQDN.
    // TODO: Simply remove trailing dot?
    if (domain.charAt(domain.length - 1) === ".") domain = domain.slice(0, domain.length - 1);
    // Validate and sanitise input.
    var error = internals.validate(domain);
    if (error) return {
        input: input,
        error: {
            message: exports.errorCodes[error],
            code: error
        }
    };
    var parsed = {
        input: input,
        tld: null,
        sld: null,
        domain: null,
        subdomain: null,
        listed: false
    };
    var domainParts = domain.split(".");
    // Non-Internet TLD
    if (domainParts[domainParts.length - 1] === "local") return parsed;
    var handlePunycode = function() {
        if (!/xn--/.test(domain)) return parsed;
        if (parsed.domain) parsed.domain = Punycode.toASCII(parsed.domain);
        if (parsed.subdomain) parsed.subdomain = Punycode.toASCII(parsed.subdomain);
        return parsed;
    };
    var rule = internals.findRule(domain);
    // Unlisted tld.
    if (!rule) {
        if (domainParts.length < 2) return parsed;
        parsed.tld = domainParts.pop();
        parsed.sld = domainParts.pop();
        parsed.domain = [
            parsed.sld,
            parsed.tld
        ].join(".");
        if (domainParts.length) parsed.subdomain = domainParts.pop();
        return handlePunycode();
    }
    // At this point we know the public suffix is listed.
    parsed.listed = true;
    var tldParts = rule.suffix.split(".");
    var privateParts = domainParts.slice(0, domainParts.length - tldParts.length);
    if (rule.exception) privateParts.push(tldParts.shift());
    parsed.tld = tldParts.join(".");
    if (!privateParts.length) return handlePunycode();
    if (rule.wildcard) {
        tldParts.unshift(privateParts.pop());
        parsed.tld = tldParts.join(".");
    }
    if (!privateParts.length) return handlePunycode();
    parsed.sld = privateParts.pop();
    parsed.domain = [
        parsed.sld,
        parsed.tld
    ].join(".");
    if (privateParts.length) parsed.subdomain = privateParts.join(".");
    return handlePunycode();
};
//
// Get domain.
//
exports.get = function(domain) {
    if (!domain) return null;
    return exports.parse(domain).domain || null;
};
//
// Check whether domain belongs to a known public suffix.
//
exports.isValid = function(domain) {
    var parsed = exports.parse(domain);
    return Boolean(parsed.domain && parsed.listed);
};

},{"99febcef612d4899":"96MYH","5d082da49c224237":"afSL4"}],"96MYH":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"afSL4":[function(require,module,exports) {
module.exports = JSON.parse('["ac","com.ac","edu.ac","gov.ac","net.ac","mil.ac","org.ac","ad","nom.ad","ae","co.ae","net.ae","org.ae","sch.ae","ac.ae","gov.ae","mil.ae","aero","accident-investigation.aero","accident-prevention.aero","aerobatic.aero","aeroclub.aero","aerodrome.aero","agents.aero","aircraft.aero","airline.aero","airport.aero","air-surveillance.aero","airtraffic.aero","air-traffic-control.aero","ambulance.aero","amusement.aero","association.aero","author.aero","ballooning.aero","broker.aero","caa.aero","cargo.aero","catering.aero","certification.aero","championship.aero","charter.aero","civilaviation.aero","club.aero","conference.aero","consultant.aero","consulting.aero","control.aero","council.aero","crew.aero","design.aero","dgca.aero","educator.aero","emergency.aero","engine.aero","engineer.aero","entertainment.aero","equipment.aero","exchange.aero","express.aero","federation.aero","flight.aero","fuel.aero","gliding.aero","government.aero","groundhandling.aero","group.aero","hanggliding.aero","homebuilt.aero","insurance.aero","journal.aero","journalist.aero","leasing.aero","logistics.aero","magazine.aero","maintenance.aero","media.aero","microlight.aero","modelling.aero","navigation.aero","parachuting.aero","paragliding.aero","passenger-association.aero","pilot.aero","press.aero","production.aero","recreation.aero","repbody.aero","res.aero","research.aero","rotorcraft.aero","safety.aero","scientist.aero","services.aero","show.aero","skydiving.aero","software.aero","student.aero","trader.aero","trading.aero","trainer.aero","union.aero","workinggroup.aero","works.aero","af","gov.af","com.af","org.af","net.af","edu.af","ag","com.ag","org.ag","net.ag","co.ag","nom.ag","ai","off.ai","com.ai","net.ai","org.ai","al","com.al","edu.al","gov.al","mil.al","net.al","org.al","am","co.am","com.am","commune.am","net.am","org.am","ao","ed.ao","gv.ao","og.ao","co.ao","pb.ao","it.ao","aq","ar","bet.ar","com.ar","coop.ar","edu.ar","gob.ar","gov.ar","int.ar","mil.ar","musica.ar","mutual.ar","net.ar","org.ar","senasa.ar","tur.ar","arpa","e164.arpa","in-addr.arpa","ip6.arpa","iris.arpa","uri.arpa","urn.arpa","as","gov.as","asia","at","ac.at","co.at","gv.at","or.at","sth.ac.at","au","com.au","net.au","org.au","edu.au","gov.au","asn.au","id.au","info.au","conf.au","oz.au","act.au","nsw.au","nt.au","qld.au","sa.au","tas.au","vic.au","wa.au","act.edu.au","catholic.edu.au","nsw.edu.au","nt.edu.au","qld.edu.au","sa.edu.au","tas.edu.au","vic.edu.au","wa.edu.au","qld.gov.au","sa.gov.au","tas.gov.au","vic.gov.au","wa.gov.au","schools.nsw.edu.au","aw","com.aw","ax","az","com.az","net.az","int.az","gov.az","org.az","edu.az","info.az","pp.az","mil.az","name.az","pro.az","biz.az","ba","com.ba","edu.ba","gov.ba","mil.ba","net.ba","org.ba","bb","biz.bb","co.bb","com.bb","edu.bb","gov.bb","info.bb","net.bb","org.bb","store.bb","tv.bb","*.bd","be","ac.be","bf","gov.bf","bg","a.bg","b.bg","c.bg","d.bg","e.bg","f.bg","g.bg","h.bg","i.bg","j.bg","k.bg","l.bg","m.bg","n.bg","o.bg","p.bg","q.bg","r.bg","s.bg","t.bg","u.bg","v.bg","w.bg","x.bg","y.bg","z.bg","0.bg","1.bg","2.bg","3.bg","4.bg","5.bg","6.bg","7.bg","8.bg","9.bg","bh","com.bh","edu.bh","net.bh","org.bh","gov.bh","bi","co.bi","com.bi","edu.bi","or.bi","org.bi","biz","bj","asso.bj","barreau.bj","gouv.bj","bm","com.bm","edu.bm","gov.bm","net.bm","org.bm","bn","com.bn","edu.bn","gov.bn","net.bn","org.bn","bo","com.bo","edu.bo","gob.bo","int.bo","org.bo","net.bo","mil.bo","tv.bo","web.bo","academia.bo","agro.bo","arte.bo","blog.bo","bolivia.bo","ciencia.bo","cooperativa.bo","democracia.bo","deporte.bo","ecologia.bo","economia.bo","empresa.bo","indigena.bo","industria.bo","info.bo","medicina.bo","movimiento.bo","musica.bo","natural.bo","nombre.bo","noticias.bo","patria.bo","politica.bo","profesional.bo","plurinacional.bo","pueblo.bo","revista.bo","salud.bo","tecnologia.bo","tksat.bo","transporte.bo","wiki.bo","br","9guacu.br","abc.br","adm.br","adv.br","agr.br","aju.br","am.br","anani.br","aparecida.br","app.br","arq.br","art.br","ato.br","b.br","barueri.br","belem.br","bhz.br","bib.br","bio.br","blog.br","bmd.br","boavista.br","bsb.br","campinagrande.br","campinas.br","caxias.br","cim.br","cng.br","cnt.br","com.br","contagem.br","coop.br","coz.br","cri.br","cuiaba.br","curitiba.br","def.br","des.br","det.br","dev.br","ecn.br","eco.br","edu.br","emp.br","enf.br","eng.br","esp.br","etc.br","eti.br","far.br","feira.br","flog.br","floripa.br","fm.br","fnd.br","fortal.br","fot.br","foz.br","fst.br","g12.br","geo.br","ggf.br","goiania.br","gov.br","ac.gov.br","al.gov.br","am.gov.br","ap.gov.br","ba.gov.br","ce.gov.br","df.gov.br","es.gov.br","go.gov.br","ma.gov.br","mg.gov.br","ms.gov.br","mt.gov.br","pa.gov.br","pb.gov.br","pe.gov.br","pi.gov.br","pr.gov.br","rj.gov.br","rn.gov.br","ro.gov.br","rr.gov.br","rs.gov.br","sc.gov.br","se.gov.br","sp.gov.br","to.gov.br","gru.br","imb.br","ind.br","inf.br","jab.br","jampa.br","jdf.br","joinville.br","jor.br","jus.br","leg.br","lel.br","log.br","londrina.br","macapa.br","maceio.br","manaus.br","maringa.br","mat.br","med.br","mil.br","morena.br","mp.br","mus.br","natal.br","net.br","niteroi.br","*.nom.br","not.br","ntr.br","odo.br","ong.br","org.br","osasco.br","palmas.br","poa.br","ppg.br","pro.br","psc.br","psi.br","pvh.br","qsl.br","radio.br","rec.br","recife.br","rep.br","ribeirao.br","rio.br","riobranco.br","riopreto.br","salvador.br","sampa.br","santamaria.br","santoandre.br","saobernardo.br","saogonca.br","seg.br","sjc.br","slg.br","slz.br","sorocaba.br","srv.br","taxi.br","tc.br","tec.br","teo.br","the.br","tmp.br","trd.br","tur.br","tv.br","udi.br","vet.br","vix.br","vlog.br","wiki.br","zlg.br","bs","com.bs","net.bs","org.bs","edu.bs","gov.bs","bt","com.bt","edu.bt","gov.bt","net.bt","org.bt","bv","bw","co.bw","org.bw","by","gov.by","mil.by","com.by","of.by","bz","com.bz","net.bz","org.bz","edu.bz","gov.bz","ca","ab.ca","bc.ca","mb.ca","nb.ca","nf.ca","nl.ca","ns.ca","nt.ca","nu.ca","on.ca","pe.ca","qc.ca","sk.ca","yk.ca","gc.ca","cat","cc","cd","gov.cd","cf","cg","ch","ci","org.ci","or.ci","com.ci","co.ci","edu.ci","ed.ci","ac.ci","net.ci","go.ci","asso.ci","a\xe9roport.ci","int.ci","presse.ci","md.ci","gouv.ci","*.ck","!www.ck","cl","co.cl","gob.cl","gov.cl","mil.cl","cm","co.cm","com.cm","gov.cm","net.cm","cn","ac.cn","com.cn","edu.cn","gov.cn","net.cn","org.cn","mil.cn","\u516C\u53F8.cn","\u7F51\u7EDC.cn","\u7DB2\u7D61.cn","ah.cn","bj.cn","cq.cn","fj.cn","gd.cn","gs.cn","gz.cn","gx.cn","ha.cn","hb.cn","he.cn","hi.cn","hl.cn","hn.cn","jl.cn","js.cn","jx.cn","ln.cn","nm.cn","nx.cn","qh.cn","sc.cn","sd.cn","sh.cn","sn.cn","sx.cn","tj.cn","xj.cn","xz.cn","yn.cn","zj.cn","hk.cn","mo.cn","tw.cn","co","arts.co","com.co","edu.co","firm.co","gov.co","info.co","int.co","mil.co","net.co","nom.co","org.co","rec.co","web.co","com","coop","cr","ac.cr","co.cr","ed.cr","fi.cr","go.cr","or.cr","sa.cr","cu","com.cu","edu.cu","org.cu","net.cu","gov.cu","inf.cu","cv","com.cv","edu.cv","int.cv","nome.cv","org.cv","cw","com.cw","edu.cw","net.cw","org.cw","cx","gov.cx","cy","ac.cy","biz.cy","com.cy","ekloges.cy","gov.cy","ltd.cy","mil.cy","net.cy","org.cy","press.cy","pro.cy","tm.cy","cz","de","dj","dk","dm","com.dm","net.dm","org.dm","edu.dm","gov.dm","do","art.do","com.do","edu.do","gob.do","gov.do","mil.do","net.do","org.do","sld.do","web.do","dz","art.dz","asso.dz","com.dz","edu.dz","gov.dz","org.dz","net.dz","pol.dz","soc.dz","tm.dz","ec","com.ec","info.ec","net.ec","fin.ec","k12.ec","med.ec","pro.ec","org.ec","edu.ec","gov.ec","gob.ec","mil.ec","edu","ee","edu.ee","gov.ee","riik.ee","lib.ee","med.ee","com.ee","pri.ee","aip.ee","org.ee","fie.ee","eg","com.eg","edu.eg","eun.eg","gov.eg","mil.eg","name.eg","net.eg","org.eg","sci.eg","*.er","es","com.es","nom.es","org.es","gob.es","edu.es","et","com.et","gov.et","org.et","edu.et","biz.et","name.et","info.et","net.et","eu","fi","aland.fi","fj","ac.fj","biz.fj","com.fj","gov.fj","info.fj","mil.fj","name.fj","net.fj","org.fj","pro.fj","*.fk","com.fm","edu.fm","net.fm","org.fm","fm","fo","fr","asso.fr","com.fr","gouv.fr","nom.fr","prd.fr","tm.fr","aeroport.fr","avocat.fr","avoues.fr","cci.fr","chambagri.fr","chirurgiens-dentistes.fr","experts-comptables.fr","geometre-expert.fr","greta.fr","huissier-justice.fr","medecin.fr","notaires.fr","pharmacien.fr","port.fr","veterinaire.fr","ga","gb","edu.gd","gov.gd","gd","ge","com.ge","edu.ge","gov.ge","org.ge","mil.ge","net.ge","pvt.ge","gf","gg","co.gg","net.gg","org.gg","gh","com.gh","edu.gh","gov.gh","org.gh","mil.gh","gi","com.gi","ltd.gi","gov.gi","mod.gi","edu.gi","org.gi","gl","co.gl","com.gl","edu.gl","net.gl","org.gl","gm","gn","ac.gn","com.gn","edu.gn","gov.gn","org.gn","net.gn","gov","gp","com.gp","net.gp","mobi.gp","edu.gp","org.gp","asso.gp","gq","gr","com.gr","edu.gr","net.gr","org.gr","gov.gr","gs","gt","com.gt","edu.gt","gob.gt","ind.gt","mil.gt","net.gt","org.gt","gu","com.gu","edu.gu","gov.gu","guam.gu","info.gu","net.gu","org.gu","web.gu","gw","gy","co.gy","com.gy","edu.gy","gov.gy","net.gy","org.gy","hk","com.hk","edu.hk","gov.hk","idv.hk","net.hk","org.hk","\u516C\u53F8.hk","\u6559\u80B2.hk","\u654E\u80B2.hk","\u653F\u5E9C.hk","\u500B\u4EBA.hk","\u4E2A\uFFFD\uFFFD.hk","\u7B87\u4EBA.hk","\u7DB2\u7EDC.hk","\u7F51\u7EDC.hk","\u7EC4\u7E54.hk","\u7DB2\u7D61.hk","\u7F51\u7D61.hk","\u7EC4\u7EC7.hk","\u7D44\u7E54.hk","\u7D44\u7EC7.hk","hm","hn","com.hn","edu.hn","org.hn","net.hn","mil.hn","gob.hn","hr","iz.hr","from.hr","name.hr","com.hr","ht","com.ht","shop.ht","firm.ht","info.ht","adult.ht","net.ht","pro.ht","org.ht","med.ht","art.ht","coop.ht","pol.ht","asso.ht","edu.ht","rel.ht","gouv.ht","perso.ht","hu","co.hu","info.hu","org.hu","priv.hu","sport.hu","tm.hu","2000.hu","agrar.hu","bolt.hu","casino.hu","city.hu","erotica.hu","erotika.hu","film.hu","forum.hu","games.hu","hotel.hu","ingatlan.hu","jogasz.hu","konyvelo.hu","lakas.hu","media.hu","news.hu","reklam.hu","sex.hu","shop.hu","suli.hu","szex.hu","tozsde.hu","utazas.hu","video.hu","id","ac.id","biz.id","co.id","desa.id","go.id","mil.id","my.id","net.id","or.id","ponpes.id","sch.id","web.id","ie","gov.ie","il","ac.il","co.il","gov.il","idf.il","k12.il","muni.il","net.il","org.il","im","ac.im","co.im","com.im","ltd.co.im","net.im","org.im","plc.co.im","tt.im","tv.im","in","co.in","firm.in","net.in","org.in","gen.in","ind.in","nic.in","ac.in","edu.in","res.in","gov.in","mil.in","info","int","eu.int","io","com.io","iq","gov.iq","edu.iq","mil.iq","com.iq","org.iq","net.iq","ir","ac.ir","co.ir","gov.ir","id.ir","net.ir","org.ir","sch.ir","\u0627\u06CC\u0631\u0627\u0646.ir","\u0627\u064A\u0631\u0627\u0646.ir","is","net.is","com.is","edu.is","gov.is","org.is","int.is","it","gov.it","edu.it","abr.it","abruzzo.it","aosta-valley.it","aostavalley.it","bas.it","basilicata.it","cal.it","calabria.it","cam.it","campania.it","emilia-romagna.it","emiliaromagna.it","emr.it","friuli-v-giulia.it","friuli-ve-giulia.it","friuli-vegiulia.it","friuli-venezia-giulia.it","friuli-veneziagiulia.it","friuli-vgiulia.it","friuliv-giulia.it","friulive-giulia.it","friulivegiulia.it","friulivenezia-giulia.it","friuliveneziagiulia.it","friulivgiulia.it","fvg.it","laz.it","lazio.it","lig.it","liguria.it","lom.it","lombardia.it","lombardy.it","lucania.it","mar.it","marche.it","mol.it","molise.it","piedmont.it","piemonte.it","pmn.it","pug.it","puglia.it","sar.it","sardegna.it","sardinia.it","sic.it","sicilia.it","sicily.it","taa.it","tos.it","toscana.it","trentin-sud-tirol.it","trentin-s\xfcd-tirol.it","trentin-sudtirol.it","trentin-s\xfcdtirol.it","trentin-sued-tirol.it","trentin-suedtirol.it","trentino-a-adige.it","trentino-aadige.it","trentino-alto-adige.it","trentino-altoadige.it","trentino-s-tirol.it","trentino-stirol.it","trentino-sud-tirol.it","trentino-s\xfcd-tirol.it","trentino-sudtirol.it","trentino-s\xfcdtirol.it","trentino-sued-tirol.it","trentino-suedtirol.it","trentino.it","trentinoa-adige.it","trentinoaadige.it","trentinoalto-adige.it","trentinoaltoadige.it","trentinos-tirol.it","trentinostirol.it","trentinosud-tirol.it","trentinos\xfcd-tirol.it","trentinosudtirol.it","trentinos\xfcdtirol.it","trentinosued-tirol.it","trentinosuedtirol.it","trentinsud-tirol.it","trentins\xfcd-tirol.it","trentinsudtirol.it","trentins\xfcdtirol.it","trentinsued-tirol.it","trentinsuedtirol.it","tuscany.it","umb.it","umbria.it","val-d-aosta.it","val-daosta.it","vald-aosta.it","valdaosta.it","valle-aosta.it","valle-d-aosta.it","valle-daosta.it","valleaosta.it","valled-aosta.it","valledaosta.it","vallee-aoste.it","vall\xe9e-aoste.it","vallee-d-aoste.it","vall\xe9e-d-aoste.it","valleeaoste.it","vall\xe9eaoste.it","valleedaoste.it","vall\xe9edaoste.it","vao.it","vda.it","ven.it","veneto.it","ag.it","agrigento.it","al.it","alessandria.it","alto-adige.it","altoadige.it","an.it","ancona.it","andria-barletta-trani.it","andria-trani-barletta.it","andriabarlettatrani.it","andriatranibarletta.it","ao.it","aosta.it","aoste.it","ap.it","aq.it","aquila.it","ar.it","arezzo.it","ascoli-piceno.it","ascolipiceno.it","asti.it","at.it","av.it","avellino.it","ba.it","balsan-sudtirol.it","balsan-s\xfcdtirol.it","balsan-suedtirol.it","balsan.it","bari.it","barletta-trani-andria.it","barlettatraniandria.it","belluno.it","benevento.it","bergamo.it","bg.it","bi.it","biella.it","bl.it","bn.it","bo.it","bologna.it","bolzano-altoadige.it","bolzano.it","bozen-sudtirol.it","bozen-s\xfcdtirol.it","bozen-suedtirol.it","bozen.it","br.it","brescia.it","brindisi.it","bs.it","bt.it","bulsan-sudtirol.it","bulsan-s\xfcdtirol.it","bulsan-suedtirol.it","bulsan.it","bz.it","ca.it","cagliari.it","caltanissetta.it","campidano-medio.it","campidanomedio.it","campobasso.it","carbonia-iglesias.it","carboniaiglesias.it","carrara-massa.it","carraramassa.it","caserta.it","catania.it","catanzaro.it","cb.it","ce.it","cesena-forli.it","cesena-forl\xec.it","cesenaforli.it","cesenaforl\xec.it","ch.it","chieti.it","ci.it","cl.it","cn.it","co.it","como.it","cosenza.it","cr.it","cremona.it","crotone.it","cs.it","ct.it","cuneo.it","cz.it","dell-ogliastra.it","dellogliastra.it","en.it","enna.it","fc.it","fe.it","fermo.it","ferrara.it","fg.it","fi.it","firenze.it","florence.it","fm.it","foggia.it","forli-cesena.it","forl\xec-cesena.it","forlicesena.it","forl\xeccesena.it","fr.it","frosinone.it","ge.it","genoa.it","genova.it","go.it","gorizia.it","gr.it","grosseto.it","iglesias-carbonia.it","iglesiascarbonia.it","im.it","imperia.it","is.it","isernia.it","kr.it","la-spezia.it","laquila.it","laspezia.it","latina.it","lc.it","le.it","lecce.it","lecco.it","li.it","livorno.it","lo.it","lodi.it","lt.it","lu.it","lucca.it","macerata.it","mantova.it","massa-carrara.it","massacarrara.it","matera.it","mb.it","mc.it","me.it","medio-campidano.it","mediocampidano.it","messina.it","mi.it","milan.it","milano.it","mn.it","mo.it","modena.it","monza-brianza.it","monza-e-della-brianza.it","monza.it","monzabrianza.it","monzaebrianza.it","monzaedellabrianza.it","ms.it","mt.it","na.it","naples.it","napoli.it","no.it","novara.it","nu.it","nuoro.it","og.it","ogliastra.it","olbia-tempio.it","olbiatempio.it","or.it","oristano.it","ot.it","pa.it","padova.it","padua.it","palermo.it","parma.it","pavia.it","pc.it","pd.it","pe.it","perugia.it","pesaro-urbino.it","pesarourbino.it","pescara.it","pg.it","pi.it","piacenza.it","pisa.it","pistoia.it","pn.it","po.it","pordenone.it","potenza.it","pr.it","prato.it","pt.it","pu.it","pv.it","pz.it","ra.it","ragusa.it","ravenna.it","rc.it","re.it","reggio-calabria.it","reggio-emilia.it","reggiocalabria.it","reggioemilia.it","rg.it","ri.it","rieti.it","rimini.it","rm.it","rn.it","ro.it","roma.it","rome.it","rovigo.it","sa.it","salerno.it","sassari.it","savona.it","si.it","siena.it","siracusa.it","so.it","sondrio.it","sp.it","sr.it","ss.it","suedtirol.it","s\xfcdtirol.it","sv.it","ta.it","taranto.it","te.it","tempio-olbia.it","tempioolbia.it","teramo.it","terni.it","tn.it","to.it","torino.it","tp.it","tr.it","trani-andria-barletta.it","trani-barletta-andria.it","traniandriabarletta.it","tranibarlettaandria.it","trapani.it","trento.it","treviso.it","trieste.it","ts.it","turin.it","tv.it","ud.it","udine.it","urbino-pesaro.it","urbinopesaro.it","va.it","varese.it","vb.it","vc.it","ve.it","venezia.it","venice.it","verbania.it","vercelli.it","verona.it","vi.it","vibo-valentia.it","vibovalentia.it","vicenza.it","viterbo.it","vr.it","vs.it","vt.it","vv.it","je","co.je","net.je","org.je","*.jm","jo","com.jo","org.jo","net.jo","edu.jo","sch.jo","gov.jo","mil.jo","name.jo","jobs","jp","ac.jp","ad.jp","co.jp","ed.jp","go.jp","gr.jp","lg.jp","ne.jp","or.jp","aichi.jp","akita.jp","aomori.jp","chiba.jp","ehime.jp","fukui.jp","fukuoka.jp","fukushima.jp","gifu.jp","gunma.jp","hiroshima.jp","hokkaido.jp","hyogo.jp","ibaraki.jp","ishikawa.jp","iwate.jp","kagawa.jp","kagoshima.jp","kanagawa.jp","kochi.jp","kumamoto.jp","kyoto.jp","mie.jp","miyagi.jp","miyazaki.jp","nagano.jp","nagasaki.jp","nara.jp","niigata.jp","oita.jp","okayama.jp","okinawa.jp","osaka.jp","saga.jp","saitama.jp","shiga.jp","shimane.jp","shizuoka.jp","tochigi.jp","tokushima.jp","tokyo.jp","tottori.jp","toyama.jp","wakayama.jp","yamagata.jp","yamaguchi.jp","yamanashi.jp","\u6803\u6728.jp","\u611B\u77E5.jp","\u611B\u5A9B.jp","\u5175\u5EAB.jp","\u718A\u672C.jp","\u8328\u57CE.jp","\u5317\u6D77\u9053.jp","\u5343\u8449.jp","\u548C\u6B4C\u5C71.jp","\u9577\u5D0E.jp","\u9577\u91CE.jp","\u65B0\u6F5F.jp","\u9752\u68EE.jp","\u9759\u5CA1.jp","\u6771\u4EAC.jp","\u77F3\u5DDD.jp","\u57FC\u7389.jp","\u4E09\u91CD.jp","\u4EAC\u90FD.jp","\u4F50\u8CC0.jp","\u5927\u5206.jp","\u5927\u962A.jp","\u5948\u826F.jp","\u5BAE\u57CE.jp","\u5BAE\u5D0E.jp","\u5BCC\u5C71.jp","\u5C71\u53E3.jp","\u5C71\u5F62.jp","\u5C71\u68A8.jp","\u5CA9\u624B.jp","\u5C90\u961C.jp","\u5CA1\u5C71.jp","\u5CF6\u6839.jp","\u5E83\u5CF6.jp","\u5FB3\u5CF6.jp","\u6C96\u7E04.jp","\u6ECB\u8CC0.jp","\u795E\u5948\u5DDD.jp","\u798F\u4E95.jp","\u798F\u5CA1.jp","\u798F\u5CF6.jp","\u79CB\u7530.jp","\u7FA4\u99AC.jp","\u9999\u5DDD.jp","\u9AD8\u77E5.jp","\u9CE5\u53D6.jp","\u9E7F\u5150\u5CF6.jp","*.kawasaki.jp","*.kitakyushu.jp","*.kobe.jp","*.nagoya.jp","*.sapporo.jp","*.sendai.jp","*.yokohama.jp","!city.kawasaki.jp","!city.kitakyushu.jp","!city.kobe.jp","!city.nagoya.jp","!city.sapporo.jp","!city.sendai.jp","!city.yokohama.jp","aisai.aichi.jp","ama.aichi.jp","anjo.aichi.jp","asuke.aichi.jp","chiryu.aichi.jp","chita.aichi.jp","fuso.aichi.jp","gamagori.aichi.jp","handa.aichi.jp","hazu.aichi.jp","hekinan.aichi.jp","higashiura.aichi.jp","ichinomiya.aichi.jp","inazawa.aichi.jp","inuyama.aichi.jp","isshiki.aichi.jp","iwakura.aichi.jp","kanie.aichi.jp","kariya.aichi.jp","kasugai.aichi.jp","kira.aichi.jp","kiyosu.aichi.jp","komaki.aichi.jp","konan.aichi.jp","kota.aichi.jp","mihama.aichi.jp","miyoshi.aichi.jp","nishio.aichi.jp","nisshin.aichi.jp","obu.aichi.jp","oguchi.aichi.jp","oharu.aichi.jp","okazaki.aichi.jp","owariasahi.aichi.jp","seto.aichi.jp","shikatsu.aichi.jp","shinshiro.aichi.jp","shitara.aichi.jp","tahara.aichi.jp","takahama.aichi.jp","tobishima.aichi.jp","toei.aichi.jp","togo.aichi.jp","tokai.aichi.jp","tokoname.aichi.jp","toyoake.aichi.jp","toyohashi.aichi.jp","toyokawa.aichi.jp","toyone.aichi.jp","toyota.aichi.jp","tsushima.aichi.jp","yatomi.aichi.jp","akita.akita.jp","daisen.akita.jp","fujisato.akita.jp","gojome.akita.jp","hachirogata.akita.jp","happou.akita.jp","higashinaruse.akita.jp","honjo.akita.jp","honjyo.akita.jp","ikawa.akita.jp","kamikoani.akita.jp","kamioka.akita.jp","katagami.akita.jp","kazuno.akita.jp","kitaakita.akita.jp","kosaka.akita.jp","kyowa.akita.jp","misato.akita.jp","mitane.akita.jp","moriyoshi.akita.jp","nikaho.akita.jp","noshiro.akita.jp","odate.akita.jp","oga.akita.jp","ogata.akita.jp","semboku.akita.jp","yokote.akita.jp","yurihonjo.akita.jp","aomori.aomori.jp","gonohe.aomori.jp","hachinohe.aomori.jp","hashikami.aomori.jp","hiranai.aomori.jp","hirosaki.aomori.jp","itayanagi.aomori.jp","kuroishi.aomori.jp","misawa.aomori.jp","mutsu.aomori.jp","nakadomari.aomori.jp","noheji.aomori.jp","oirase.aomori.jp","owani.aomori.jp","rokunohe.aomori.jp","sannohe.aomori.jp","shichinohe.aomori.jp","shingo.aomori.jp","takko.aomori.jp","towada.aomori.jp","tsugaru.aomori.jp","tsuruta.aomori.jp","abiko.chiba.jp","asahi.chiba.jp","chonan.chiba.jp","chosei.chiba.jp","choshi.chiba.jp","chuo.chiba.jp","funabashi.chiba.jp","futtsu.chiba.jp","hanamigawa.chiba.jp","ichihara.chiba.jp","ichikawa.chiba.jp","ichinomiya.chiba.jp","inzai.chiba.jp","isumi.chiba.jp","kamagaya.chiba.jp","kamogawa.chiba.jp","kashiwa.chiba.jp","katori.chiba.jp","katsuura.chiba.jp","kimitsu.chiba.jp","kisarazu.chiba.jp","kozaki.chiba.jp","kujukuri.chiba.jp","kyonan.chiba.jp","matsudo.chiba.jp","midori.chiba.jp","mihama.chiba.jp","minamiboso.chiba.jp","mobara.chiba.jp","mutsuzawa.chiba.jp","nagara.chiba.jp","nagareyama.chiba.jp","narashino.chiba.jp","narita.chiba.jp","noda.chiba.jp","oamishirasato.chiba.jp","omigawa.chiba.jp","onjuku.chiba.jp","otaki.chiba.jp","sakae.chiba.jp","sakura.chiba.jp","shimofusa.chiba.jp","shirako.chiba.jp","shiroi.chiba.jp","shisui.chiba.jp","sodegaura.chiba.jp","sosa.chiba.jp","tako.chiba.jp","tateyama.chiba.jp","togane.chiba.jp","tohnosho.chiba.jp","tomisato.chiba.jp","urayasu.chiba.jp","yachimata.chiba.jp","yachiyo.chiba.jp","yokaichiba.chiba.jp","yokoshibahikari.chiba.jp","yotsukaido.chiba.jp","ainan.ehime.jp","honai.ehime.jp","ikata.ehime.jp","imabari.ehime.jp","iyo.ehime.jp","kamijima.ehime.jp","kihoku.ehime.jp","kumakogen.ehime.jp","masaki.ehime.jp","matsuno.ehime.jp","matsuyama.ehime.jp","namikata.ehime.jp","niihama.ehime.jp","ozu.ehime.jp","saijo.ehime.jp","seiyo.ehime.jp","shikokuchuo.ehime.jp","tobe.ehime.jp","toon.ehime.jp","uchiko.ehime.jp","uwajima.ehime.jp","yawatahama.ehime.jp","echizen.fukui.jp","eiheiji.fukui.jp","fukui.fukui.jp","ikeda.fukui.jp","katsuyama.fukui.jp","mihama.fukui.jp","minamiechizen.fukui.jp","obama.fukui.jp","ohi.fukui.jp","ono.fukui.jp","sabae.fukui.jp","sakai.fukui.jp","takahama.fukui.jp","tsuruga.fukui.jp","wakasa.fukui.jp","ashiya.fukuoka.jp","buzen.fukuoka.jp","chikugo.fukuoka.jp","chikuho.fukuoka.jp","chikujo.fukuoka.jp","chikushino.fukuoka.jp","chikuzen.fukuoka.jp","chuo.fukuoka.jp","dazaifu.fukuoka.jp","fukuchi.fukuoka.jp","hakata.fukuoka.jp","higashi.fukuoka.jp","hirokawa.fukuoka.jp","hisayama.fukuoka.jp","iizuka.fukuoka.jp","inatsuki.fukuoka.jp","kaho.fukuoka.jp","kasuga.fukuoka.jp","kasuya.fukuoka.jp","kawara.fukuoka.jp","keisen.fukuoka.jp","koga.fukuoka.jp","kurate.fukuoka.jp","kurogi.fukuoka.jp","kurume.fukuoka.jp","minami.fukuoka.jp","miyako.fukuoka.jp","miyama.fukuoka.jp","miyawaka.fukuoka.jp","mizumaki.fukuoka.jp","munakata.fukuoka.jp","nakagawa.fukuoka.jp","nakama.fukuoka.jp","nishi.fukuoka.jp","nogata.fukuoka.jp","ogori.fukuoka.jp","okagaki.fukuoka.jp","okawa.fukuoka.jp","oki.fukuoka.jp","omuta.fukuoka.jp","onga.fukuoka.jp","onojo.fukuoka.jp","oto.fukuoka.jp","saigawa.fukuoka.jp","sasaguri.fukuoka.jp","shingu.fukuoka.jp","shinyoshitomi.fukuoka.jp","shonai.fukuoka.jp","soeda.fukuoka.jp","sue.fukuoka.jp","tachiarai.fukuoka.jp","tagawa.fukuoka.jp","takata.fukuoka.jp","toho.fukuoka.jp","toyotsu.fukuoka.jp","tsuiki.fukuoka.jp","ukiha.fukuoka.jp","umi.fukuoka.jp","usui.fukuoka.jp","yamada.fukuoka.jp","yame.fukuoka.jp","yanagawa.fukuoka.jp","yukuhashi.fukuoka.jp","aizubange.fukushima.jp","aizumisato.fukushima.jp","aizuwakamatsu.fukushima.jp","asakawa.fukushima.jp","bandai.fukushima.jp","date.fukushima.jp","fukushima.fukushima.jp","furudono.fukushima.jp","futaba.fukushima.jp","hanawa.fukushima.jp","higashi.fukushima.jp","hirata.fukushima.jp","hirono.fukushima.jp","iitate.fukushima.jp","inawashiro.fukushima.jp","ishikawa.fukushima.jp","iwaki.fukushima.jp","izumizaki.fukushima.jp","kagamiishi.fukushima.jp","kaneyama.fukushima.jp","kawamata.fukushima.jp","kitakata.fukushima.jp","kitashiobara.fukushima.jp","koori.fukushima.jp","koriyama.fukushima.jp","kunimi.fukushima.jp","miharu.fukushima.jp","mishima.fukushima.jp","namie.fukushima.jp","nango.fukushima.jp","nishiaizu.fukushima.jp","nishigo.fukushima.jp","okuma.fukushima.jp","omotego.fukushima.jp","ono.fukushima.jp","otama.fukushima.jp","samegawa.fukushima.jp","shimogo.fukushima.jp","shirakawa.fukushima.jp","showa.fukushima.jp","soma.fukushima.jp","sukagawa.fukushima.jp","taishin.fukushima.jp","tamakawa.fukushima.jp","tanagura.fukushima.jp","tenei.fukushima.jp","yabuki.fukushima.jp","yamato.fukushima.jp","yamatsuri.fukushima.jp","yanaizu.fukushima.jp","yugawa.fukushima.jp","anpachi.gifu.jp","ena.gifu.jp","gifu.gifu.jp","ginan.gifu.jp","godo.gifu.jp","gujo.gifu.jp","hashima.gifu.jp","hichiso.gifu.jp","hida.gifu.jp","higashishirakawa.gifu.jp","ibigawa.gifu.jp","ikeda.gifu.jp","kakamigahara.gifu.jp","kani.gifu.jp","kasahara.gifu.jp","kasamatsu.gifu.jp","kawaue.gifu.jp","kitagata.gifu.jp","mino.gifu.jp","minokamo.gifu.jp","mitake.gifu.jp","mizunami.gifu.jp","motosu.gifu.jp","nakatsugawa.gifu.jp","ogaki.gifu.jp","sakahogi.gifu.jp","seki.gifu.jp","sekigahara.gifu.jp","shirakawa.gifu.jp","tajimi.gifu.jp","takayama.gifu.jp","tarui.gifu.jp","toki.gifu.jp","tomika.gifu.jp","wanouchi.gifu.jp","yamagata.gifu.jp","yaotsu.gifu.jp","yoro.gifu.jp","annaka.gunma.jp","chiyoda.gunma.jp","fujioka.gunma.jp","higashiagatsuma.gunma.jp","isesaki.gunma.jp","itakura.gunma.jp","kanna.gunma.jp","kanra.gunma.jp","katashina.gunma.jp","kawaba.gunma.jp","kiryu.gunma.jp","kusatsu.gunma.jp","maebashi.gunma.jp","meiwa.gunma.jp","midori.gunma.jp","minakami.gunma.jp","naganohara.gunma.jp","nakanojo.gunma.jp","nanmoku.gunma.jp","numata.gunma.jp","oizumi.gunma.jp","ora.gunma.jp","ota.gunma.jp","shibukawa.gunma.jp","shimonita.gunma.jp","shinto.gunma.jp","showa.gunma.jp","takasaki.gunma.jp","takayama.gunma.jp","tamamura.gunma.jp","tatebayashi.gunma.jp","tomioka.gunma.jp","tsukiyono.gunma.jp","tsumagoi.gunma.jp","ueno.gunma.jp","yoshioka.gunma.jp","asaminami.hiroshima.jp","daiwa.hiroshima.jp","etajima.hiroshima.jp","fuchu.hiroshima.jp","fukuyama.hiroshima.jp","hatsukaichi.hiroshima.jp","higashihiroshima.hiroshima.jp","hongo.hiroshima.jp","jinsekikogen.hiroshima.jp","kaita.hiroshima.jp","kui.hiroshima.jp","kumano.hiroshima.jp","kure.hiroshima.jp","mihara.hiroshima.jp","miyoshi.hiroshima.jp","naka.hiroshima.jp","onomichi.hiroshima.jp","osakikamijima.hiroshima.jp","otake.hiroshima.jp","saka.hiroshima.jp","sera.hiroshima.jp","seranishi.hiroshima.jp","shinichi.hiroshima.jp","shobara.hiroshima.jp","takehara.hiroshima.jp","abashiri.hokkaido.jp","abira.hokkaido.jp","aibetsu.hokkaido.jp","akabira.hokkaido.jp","akkeshi.hokkaido.jp","asahikawa.hokkaido.jp","ashibetsu.hokkaido.jp","ashoro.hokkaido.jp","assabu.hokkaido.jp","atsuma.hokkaido.jp","bibai.hokkaido.jp","biei.hokkaido.jp","bifuka.hokkaido.jp","bihoro.hokkaido.jp","biratori.hokkaido.jp","chippubetsu.hokkaido.jp","chitose.hokkaido.jp","date.hokkaido.jp","ebetsu.hokkaido.jp","embetsu.hokkaido.jp","eniwa.hokkaido.jp","erimo.hokkaido.jp","esan.hokkaido.jp","esashi.hokkaido.jp","fukagawa.hokkaido.jp","fukushima.hokkaido.jp","furano.hokkaido.jp","furubira.hokkaido.jp","haboro.hokkaido.jp","hakodate.hokkaido.jp","hamatonbetsu.hokkaido.jp","hidaka.hokkaido.jp","higashikagura.hokkaido.jp","higashikawa.hokkaido.jp","hiroo.hokkaido.jp","hokuryu.hokkaido.jp","hokuto.hokkaido.jp","honbetsu.hokkaido.jp","horokanai.hokkaido.jp","horonobe.hokkaido.jp","ikeda.hokkaido.jp","imakane.hokkaido.jp","ishikari.hokkaido.jp","iwamizawa.hokkaido.jp","iwanai.hokkaido.jp","kamifurano.hokkaido.jp","kamikawa.hokkaido.jp","kamishihoro.hokkaido.jp","kamisunagawa.hokkaido.jp","kamoenai.hokkaido.jp","kayabe.hokkaido.jp","kembuchi.hokkaido.jp","kikonai.hokkaido.jp","kimobetsu.hokkaido.jp","kitahiroshima.hokkaido.jp","kitami.hokkaido.jp","kiyosato.hokkaido.jp","koshimizu.hokkaido.jp","kunneppu.hokkaido.jp","kuriyama.hokkaido.jp","kuromatsunai.hokkaido.jp","kushiro.hokkaido.jp","kutchan.hokkaido.jp","kyowa.hokkaido.jp","mashike.hokkaido.jp","matsumae.hokkaido.jp","mikasa.hokkaido.jp","minamifurano.hokkaido.jp","mombetsu.hokkaido.jp","moseushi.hokkaido.jp","mukawa.hokkaido.jp","muroran.hokkaido.jp","naie.hokkaido.jp","nakagawa.hokkaido.jp","nakasatsunai.hokkaido.jp","nakatombetsu.hokkaido.jp","nanae.hokkaido.jp","nanporo.hokkaido.jp","nayoro.hokkaido.jp","nemuro.hokkaido.jp","niikappu.hokkaido.jp","niki.hokkaido.jp","nishiokoppe.hokkaido.jp","noboribetsu.hokkaido.jp","numata.hokkaido.jp","obihiro.hokkaido.jp","obira.hokkaido.jp","oketo.hokkaido.jp","okoppe.hokkaido.jp","otaru.hokkaido.jp","otobe.hokkaido.jp","otofuke.hokkaido.jp","otoineppu.hokkaido.jp","oumu.hokkaido.jp","ozora.hokkaido.jp","pippu.hokkaido.jp","rankoshi.hokkaido.jp","rebun.hokkaido.jp","rikubetsu.hokkaido.jp","rishiri.hokkaido.jp","rishirifuji.hokkaido.jp","saroma.hokkaido.jp","sarufutsu.hokkaido.jp","shakotan.hokkaido.jp","shari.hokkaido.jp","shibecha.hokkaido.jp","shibetsu.hokkaido.jp","shikabe.hokkaido.jp","shikaoi.hokkaido.jp","shimamaki.hokkaido.jp","shimizu.hokkaido.jp","shimokawa.hokkaido.jp","shinshinotsu.hokkaido.jp","shintoku.hokkaido.jp","shiranuka.hokkaido.jp","shiraoi.hokkaido.jp","shiriuchi.hokkaido.jp","sobetsu.hokkaido.jp","sunagawa.hokkaido.jp","taiki.hokkaido.jp","takasu.hokkaido.jp","takikawa.hokkaido.jp","takinoue.hokkaido.jp","teshikaga.hokkaido.jp","tobetsu.hokkaido.jp","tohma.hokkaido.jp","tomakomai.hokkaido.jp","tomari.hokkaido.jp","toya.hokkaido.jp","toyako.hokkaido.jp","toyotomi.hokkaido.jp","toyoura.hokkaido.jp","tsubetsu.hokkaido.jp","tsukigata.hokkaido.jp","urakawa.hokkaido.jp","urausu.hokkaido.jp","uryu.hokkaido.jp","utashinai.hokkaido.jp","wakkanai.hokkaido.jp","wassamu.hokkaido.jp","yakumo.hokkaido.jp","yoichi.hokkaido.jp","aioi.hyogo.jp","akashi.hyogo.jp","ako.hyogo.jp","amagasaki.hyogo.jp","aogaki.hyogo.jp","asago.hyogo.jp","ashiya.hyogo.jp","awaji.hyogo.jp","fukusaki.hyogo.jp","goshiki.hyogo.jp","harima.hyogo.jp","himeji.hyogo.jp","ichikawa.hyogo.jp","inagawa.hyogo.jp","itami.hyogo.jp","kakogawa.hyogo.jp","kamigori.hyogo.jp","kamikawa.hyogo.jp","kasai.hyogo.jp","kasuga.hyogo.jp","kawanishi.hyogo.jp","miki.hyogo.jp","minamiawaji.hyogo.jp","nishinomiya.hyogo.jp","nishiwaki.hyogo.jp","ono.hyogo.jp","sanda.hyogo.jp","sannan.hyogo.jp","sasayama.hyogo.jp","sayo.hyogo.jp","shingu.hyogo.jp","shinonsen.hyogo.jp","shiso.hyogo.jp","sumoto.hyogo.jp","taishi.hyogo.jp","taka.hyogo.jp","takarazuka.hyogo.jp","takasago.hyogo.jp","takino.hyogo.jp","tamba.hyogo.jp","tatsuno.hyogo.jp","toyooka.hyogo.jp","yabu.hyogo.jp","yashiro.hyogo.jp","yoka.hyogo.jp","yokawa.hyogo.jp","ami.ibaraki.jp","asahi.ibaraki.jp","bando.ibaraki.jp","chikusei.ibaraki.jp","daigo.ibaraki.jp","fujishiro.ibaraki.jp","hitachi.ibaraki.jp","hitachinaka.ibaraki.jp","hitachiomiya.ibaraki.jp","hitachiota.ibaraki.jp","ibaraki.ibaraki.jp","ina.ibaraki.jp","inashiki.ibaraki.jp","itako.ibaraki.jp","iwama.ibaraki.jp","joso.ibaraki.jp","kamisu.ibaraki.jp","kasama.ibaraki.jp","kashima.ibaraki.jp","kasumigaura.ibaraki.jp","koga.ibaraki.jp","miho.ibaraki.jp","mito.ibaraki.jp","moriya.ibaraki.jp","naka.ibaraki.jp","namegata.ibaraki.jp","oarai.ibaraki.jp","ogawa.ibaraki.jp","omitama.ibaraki.jp","ryugasaki.ibaraki.jp","sakai.ibaraki.jp","sakuragawa.ibaraki.jp","shimodate.ibaraki.jp","shimotsuma.ibaraki.jp","shirosato.ibaraki.jp","sowa.ibaraki.jp","suifu.ibaraki.jp","takahagi.ibaraki.jp","tamatsukuri.ibaraki.jp","tokai.ibaraki.jp","tomobe.ibaraki.jp","tone.ibaraki.jp","toride.ibaraki.jp","tsuchiura.ibaraki.jp","tsukuba.ibaraki.jp","uchihara.ibaraki.jp","ushiku.ibaraki.jp","yachiyo.ibaraki.jp","yamagata.ibaraki.jp","yawara.ibaraki.jp","yuki.ibaraki.jp","anamizu.ishikawa.jp","hakui.ishikawa.jp","hakusan.ishikawa.jp","kaga.ishikawa.jp","kahoku.ishikawa.jp","kanazawa.ishikawa.jp","kawakita.ishikawa.jp","komatsu.ishikawa.jp","nakanoto.ishikawa.jp","nanao.ishikawa.jp","nomi.ishikawa.jp","nonoichi.ishikawa.jp","noto.ishikawa.jp","shika.ishikawa.jp","suzu.ishikawa.jp","tsubata.ishikawa.jp","tsurugi.ishikawa.jp","uchinada.ishikawa.jp","wajima.ishikawa.jp","fudai.iwate.jp","fujisawa.iwate.jp","hanamaki.iwate.jp","hiraizumi.iwate.jp","hirono.iwate.jp","ichinohe.iwate.jp","ichinoseki.iwate.jp","iwaizumi.iwate.jp","iwate.iwate.jp","joboji.iwate.jp","kamaishi.iwate.jp","kanegasaki.iwate.jp","karumai.iwate.jp","kawai.iwate.jp","kitakami.iwate.jp","kuji.iwate.jp","kunohe.iwate.jp","kuzumaki.iwate.jp","miyako.iwate.jp","mizusawa.iwate.jp","morioka.iwate.jp","ninohe.iwate.jp","noda.iwate.jp","ofunato.iwate.jp","oshu.iwate.jp","otsuchi.iwate.jp","rikuzentakata.iwate.jp","shiwa.iwate.jp","shizukuishi.iwate.jp","sumita.iwate.jp","tanohata.iwate.jp","tono.iwate.jp","yahaba.iwate.jp","yamada.iwate.jp","ayagawa.kagawa.jp","higashikagawa.kagawa.jp","kanonji.kagawa.jp","kotohira.kagawa.jp","manno.kagawa.jp","marugame.kagawa.jp","mitoyo.kagawa.jp","naoshima.kagawa.jp","sanuki.kagawa.jp","tadotsu.kagawa.jp","takamatsu.kagawa.jp","tonosho.kagawa.jp","uchinomi.kagawa.jp","utazu.kagawa.jp","zentsuji.kagawa.jp","akune.kagoshima.jp","amami.kagoshima.jp","hioki.kagoshima.jp","isa.kagoshima.jp","isen.kagoshima.jp","izumi.kagoshima.jp","kagoshima.kagoshima.jp","kanoya.kagoshima.jp","kawanabe.kagoshima.jp","kinko.kagoshima.jp","kouyama.kagoshima.jp","makurazaki.kagoshima.jp","matsumoto.kagoshima.jp","minamitane.kagoshima.jp","nakatane.kagoshima.jp","nishinoomote.kagoshima.jp","satsumasendai.kagoshima.jp","soo.kagoshima.jp","tarumizu.kagoshima.jp","yusui.kagoshima.jp","aikawa.kanagawa.jp","atsugi.kanagawa.jp","ayase.kanagawa.jp","chigasaki.kanagawa.jp","ebina.kanagawa.jp","fujisawa.kanagawa.jp","hadano.kanagawa.jp","hakone.kanagawa.jp","hiratsuka.kanagawa.jp","isehara.kanagawa.jp","kaisei.kanagawa.jp","kamakura.kanagawa.jp","kiyokawa.kanagawa.jp","matsuda.kanagawa.jp","minamiashigara.kanagawa.jp","miura.kanagawa.jp","nakai.kanagawa.jp","ninomiya.kanagawa.jp","odawara.kanagawa.jp","oi.kanagawa.jp","oiso.kanagawa.jp","sagamihara.kanagawa.jp","samukawa.kanagawa.jp","tsukui.kanagawa.jp","yamakita.kanagawa.jp","yamato.kanagawa.jp","yokosuka.kanagawa.jp","yugawara.kanagawa.jp","zama.kanagawa.jp","zushi.kanagawa.jp","aki.kochi.jp","geisei.kochi.jp","hidaka.kochi.jp","higashitsuno.kochi.jp","ino.kochi.jp","kagami.kochi.jp","kami.kochi.jp","kitagawa.kochi.jp","kochi.kochi.jp","mihara.kochi.jp","motoyama.kochi.jp","muroto.kochi.jp","nahari.kochi.jp","nakamura.kochi.jp","nankoku.kochi.jp","nishitosa.kochi.jp","niyodogawa.kochi.jp","ochi.kochi.jp","okawa.kochi.jp","otoyo.kochi.jp","otsuki.kochi.jp","sakawa.kochi.jp","sukumo.kochi.jp","susaki.kochi.jp","tosa.kochi.jp","tosashimizu.kochi.jp","toyo.kochi.jp","tsuno.kochi.jp","umaji.kochi.jp","yasuda.kochi.jp","yusuhara.kochi.jp","amakusa.kumamoto.jp","arao.kumamoto.jp","aso.kumamoto.jp","choyo.kumamoto.jp","gyokuto.kumamoto.jp","kamiamakusa.kumamoto.jp","kikuchi.kumamoto.jp","kumamoto.kumamoto.jp","mashiki.kumamoto.jp","mifune.kumamoto.jp","minamata.kumamoto.jp","minamioguni.kumamoto.jp","nagasu.kumamoto.jp","nishihara.kumamoto.jp","oguni.kumamoto.jp","ozu.kumamoto.jp","sumoto.kumamoto.jp","takamori.kumamoto.jp","uki.kumamoto.jp","uto.kumamoto.jp","yamaga.kumamoto.jp","yamato.kumamoto.jp","yatsushiro.kumamoto.jp","ayabe.kyoto.jp","fukuchiyama.kyoto.jp","higashiyama.kyoto.jp","ide.kyoto.jp","ine.kyoto.jp","joyo.kyoto.jp","kameoka.kyoto.jp","kamo.kyoto.jp","kita.kyoto.jp","kizu.kyoto.jp","kumiyama.kyoto.jp","kyotamba.kyoto.jp","kyotanabe.kyoto.jp","kyotango.kyoto.jp","maizuru.kyoto.jp","minami.kyoto.jp","minamiyamashiro.kyoto.jp","miyazu.kyoto.jp","muko.kyoto.jp","nagaokakyo.kyoto.jp","nakagyo.kyoto.jp","nantan.kyoto.jp","oyamazaki.kyoto.jp","sakyo.kyoto.jp","seika.kyoto.jp","tanabe.kyoto.jp","uji.kyoto.jp","ujitawara.kyoto.jp","wazuka.kyoto.jp","yamashina.kyoto.jp","yawata.kyoto.jp","asahi.mie.jp","inabe.mie.jp","ise.mie.jp","kameyama.mie.jp","kawagoe.mie.jp","kiho.mie.jp","kisosaki.mie.jp","kiwa.mie.jp","komono.mie.jp","kumano.mie.jp","kuwana.mie.jp","matsusaka.mie.jp","meiwa.mie.jp","mihama.mie.jp","minamiise.mie.jp","misugi.mie.jp","miyama.mie.jp","nabari.mie.jp","shima.mie.jp","suzuka.mie.jp","tado.mie.jp","taiki.mie.jp","taki.mie.jp","tamaki.mie.jp","toba.mie.jp","tsu.mie.jp","udono.mie.jp","ureshino.mie.jp","watarai.mie.jp","yokkaichi.mie.jp","furukawa.miyagi.jp","higashimatsushima.miyagi.jp","ishinomaki.miyagi.jp","iwanuma.miyagi.jp","kakuda.miyagi.jp","kami.miyagi.jp","kawasaki.miyagi.jp","marumori.miyagi.jp","matsushima.miyagi.jp","minamisanriku.miyagi.jp","misato.miyagi.jp","murata.miyagi.jp","natori.miyagi.jp","ogawara.miyagi.jp","ohira.miyagi.jp","onagawa.miyagi.jp","osaki.miyagi.jp","rifu.miyagi.jp","semine.miyagi.jp","shibata.miyagi.jp","shichikashuku.miyagi.jp","shikama.miyagi.jp","shiogama.miyagi.jp","shiroishi.miyagi.jp","tagajo.miyagi.jp","taiwa.miyagi.jp","tome.miyagi.jp","tomiya.miyagi.jp","wakuya.miyagi.jp","watari.miyagi.jp","yamamoto.miyagi.jp","zao.miyagi.jp","aya.miyazaki.jp","ebino.miyazaki.jp","gokase.miyazaki.jp","hyuga.miyazaki.jp","kadogawa.miyazaki.jp","kawaminami.miyazaki.jp","kijo.miyazaki.jp","kitagawa.miyazaki.jp","kitakata.miyazaki.jp","kitaura.miyazaki.jp","kobayashi.miyazaki.jp","kunitomi.miyazaki.jp","kushima.miyazaki.jp","mimata.miyazaki.jp","miyakonojo.miyazaki.jp","miyazaki.miyazaki.jp","morotsuka.miyazaki.jp","nichinan.miyazaki.jp","nishimera.miyazaki.jp","nobeoka.miyazaki.jp","saito.miyazaki.jp","shiiba.miyazaki.jp","shintomi.miyazaki.jp","takaharu.miyazaki.jp","takanabe.miyazaki.jp","takazaki.miyazaki.jp","tsuno.miyazaki.jp","achi.nagano.jp","agematsu.nagano.jp","anan.nagano.jp","aoki.nagano.jp","asahi.nagano.jp","azumino.nagano.jp","chikuhoku.nagano.jp","chikuma.nagano.jp","chino.nagano.jp","fujimi.nagano.jp","hakuba.nagano.jp","hara.nagano.jp","hiraya.nagano.jp","iida.nagano.jp","iijima.nagano.jp","iiyama.nagano.jp","iizuna.nagano.jp","ikeda.nagano.jp","ikusaka.nagano.jp","ina.nagano.jp","karuizawa.nagano.jp","kawakami.nagano.jp","kiso.nagano.jp","kisofukushima.nagano.jp","kitaaiki.nagano.jp","komagane.nagano.jp","komoro.nagano.jp","matsukawa.nagano.jp","matsumoto.nagano.jp","miasa.nagano.jp","minamiaiki.nagano.jp","minamimaki.nagano.jp","minamiminowa.nagano.jp","minowa.nagano.jp","miyada.nagano.jp","miyota.nagano.jp","mochizuki.nagano.jp","nagano.nagano.jp","nagawa.nagano.jp","nagiso.nagano.jp","nakagawa.nagano.jp","nakano.nagano.jp","nozawaonsen.nagano.jp","obuse.nagano.jp","ogawa.nagano.jp","okaya.nagano.jp","omachi.nagano.jp","omi.nagano.jp","ookuwa.nagano.jp","ooshika.nagano.jp","otaki.nagano.jp","otari.nagano.jp","sakae.nagano.jp","sakaki.nagano.jp","saku.nagano.jp","sakuho.nagano.jp","shimosuwa.nagano.jp","shinanomachi.nagano.jp","shiojiri.nagano.jp","suwa.nagano.jp","suzaka.nagano.jp","takagi.nagano.jp","takamori.nagano.jp","takayama.nagano.jp","tateshina.nagano.jp","tatsuno.nagano.jp","togakushi.nagano.jp","togura.nagano.jp","tomi.nagano.jp","ueda.nagano.jp","wada.nagano.jp","yamagata.nagano.jp","yamanouchi.nagano.jp","yasaka.nagano.jp","yasuoka.nagano.jp","chijiwa.nagasaki.jp","futsu.nagasaki.jp","goto.nagasaki.jp","hasami.nagasaki.jp","hirado.nagasaki.jp","iki.nagasaki.jp","isahaya.nagasaki.jp","kawatana.nagasaki.jp","kuchinotsu.nagasaki.jp","matsuura.nagasaki.jp","nagasaki.nagasaki.jp","obama.nagasaki.jp","omura.nagasaki.jp","oseto.nagasaki.jp","saikai.nagasaki.jp","sasebo.nagasaki.jp","seihi.nagasaki.jp","shimabara.nagasaki.jp","shinkamigoto.nagasaki.jp","togitsu.nagasaki.jp","tsushima.nagasaki.jp","unzen.nagasaki.jp","ando.nara.jp","gose.nara.jp","heguri.nara.jp","higashiyoshino.nara.jp","ikaruga.nara.jp","ikoma.nara.jp","kamikitayama.nara.jp","kanmaki.nara.jp","kashiba.nara.jp","kashihara.nara.jp","katsuragi.nara.jp","kawai.nara.jp","kawakami.nara.jp","kawanishi.nara.jp","koryo.nara.jp","kurotaki.nara.jp","mitsue.nara.jp","miyake.nara.jp","nara.nara.jp","nosegawa.nara.jp","oji.nara.jp","ouda.nara.jp","oyodo.nara.jp","sakurai.nara.jp","sango.nara.jp","shimoichi.nara.jp","shimokitayama.nara.jp","shinjo.nara.jp","soni.nara.jp","takatori.nara.jp","tawaramoto.nara.jp","tenkawa.nara.jp","tenri.nara.jp","uda.nara.jp","yamatokoriyama.nara.jp","yamatotakada.nara.jp","yamazoe.nara.jp","yoshino.nara.jp","aga.niigata.jp","agano.niigata.jp","gosen.niigata.jp","itoigawa.niigata.jp","izumozaki.niigata.jp","joetsu.niigata.jp","kamo.niigata.jp","kariwa.niigata.jp","kashiwazaki.niigata.jp","minamiuonuma.niigata.jp","mitsuke.niigata.jp","muika.niigata.jp","murakami.niigata.jp","myoko.niigata.jp","nagaoka.niigata.jp","niigata.niigata.jp","ojiya.niigata.jp","omi.niigata.jp","sado.niigata.jp","sanjo.niigata.jp","seiro.niigata.jp","seirou.niigata.jp","sekikawa.niigata.jp","shibata.niigata.jp","tagami.niigata.jp","tainai.niigata.jp","tochio.niigata.jp","tokamachi.niigata.jp","tsubame.niigata.jp","tsunan.niigata.jp","uonuma.niigata.jp","yahiko.niigata.jp","yoita.niigata.jp","yuzawa.niigata.jp","beppu.oita.jp","bungoono.oita.jp","bungotakada.oita.jp","hasama.oita.jp","hiji.oita.jp","himeshima.oita.jp","hita.oita.jp","kamitsue.oita.jp","kokonoe.oita.jp","kuju.oita.jp","kunisaki.oita.jp","kusu.oita.jp","oita.oita.jp","saiki.oita.jp","taketa.oita.jp","tsukumi.oita.jp","usa.oita.jp","usuki.oita.jp","yufu.oita.jp","akaiwa.okayama.jp","asakuchi.okayama.jp","bizen.okayama.jp","hayashima.okayama.jp","ibara.okayama.jp","kagamino.okayama.jp","kasaoka.okayama.jp","kibichuo.okayama.jp","kumenan.okayama.jp","kurashiki.okayama.jp","maniwa.okayama.jp","misaki.okayama.jp","nagi.okayama.jp","niimi.okayama.jp","nishiawakura.okayama.jp","okayama.okayama.jp","satosho.okayama.jp","setouchi.okayama.jp","shinjo.okayama.jp","shoo.okayama.jp","soja.okayama.jp","takahashi.okayama.jp","tamano.okayama.jp","tsuyama.okayama.jp","wake.okayama.jp","yakage.okayama.jp","aguni.okinawa.jp","ginowan.okinawa.jp","ginoza.okinawa.jp","gushikami.okinawa.jp","haebaru.okinawa.jp","higashi.okinawa.jp","hirara.okinawa.jp","iheya.okinawa.jp","ishigaki.okinawa.jp","ishikawa.okinawa.jp","itoman.okinawa.jp","izena.okinawa.jp","kadena.okinawa.jp","kin.okinawa.jp","kitadaito.okinawa.jp","kitanakagusuku.okinawa.jp","kumejima.okinawa.jp","kunigami.okinawa.jp","minamidaito.okinawa.jp","motobu.okinawa.jp","nago.okinawa.jp","naha.okinawa.jp","nakagusuku.okinawa.jp","nakijin.okinawa.jp","nanjo.okinawa.jp","nishihara.okinawa.jp","ogimi.okinawa.jp","okinawa.okinawa.jp","onna.okinawa.jp","shimoji.okinawa.jp","taketomi.okinawa.jp","tarama.okinawa.jp","tokashiki.okinawa.jp","tomigusuku.okinawa.jp","tonaki.okinawa.jp","urasoe.okinawa.jp","uruma.okinawa.jp","yaese.okinawa.jp","yomitan.okinawa.jp","yonabaru.okinawa.jp","yonaguni.okinawa.jp","zamami.okinawa.jp","abeno.osaka.jp","chihayaakasaka.osaka.jp","chuo.osaka.jp","daito.osaka.jp","fujiidera.osaka.jp","habikino.osaka.jp","hannan.osaka.jp","higashiosaka.osaka.jp","higashisumiyoshi.osaka.jp","higashiyodogawa.osaka.jp","hirakata.osaka.jp","ibaraki.osaka.jp","ikeda.osaka.jp","izumi.osaka.jp","izumiotsu.osaka.jp","izumisano.osaka.jp","kadoma.osaka.jp","kaizuka.osaka.jp","kanan.osaka.jp","kashiwara.osaka.jp","katano.osaka.jp","kawachinagano.osaka.jp","kishiwada.osaka.jp","kita.osaka.jp","kumatori.osaka.jp","matsubara.osaka.jp","minato.osaka.jp","minoh.osaka.jp","misaki.osaka.jp","moriguchi.osaka.jp","neyagawa.osaka.jp","nishi.osaka.jp","nose.osaka.jp","osakasayama.osaka.jp","sakai.osaka.jp","sayama.osaka.jp","sennan.osaka.jp","settsu.osaka.jp","shijonawate.osaka.jp","shimamoto.osaka.jp","suita.osaka.jp","tadaoka.osaka.jp","taishi.osaka.jp","tajiri.osaka.jp","takaishi.osaka.jp","takatsuki.osaka.jp","tondabayashi.osaka.jp","toyonaka.osaka.jp","toyono.osaka.jp","yao.osaka.jp","ariake.saga.jp","arita.saga.jp","fukudomi.saga.jp","genkai.saga.jp","hamatama.saga.jp","hizen.saga.jp","imari.saga.jp","kamimine.saga.jp","kanzaki.saga.jp","karatsu.saga.jp","kashima.saga.jp","kitagata.saga.jp","kitahata.saga.jp","kiyama.saga.jp","kouhoku.saga.jp","kyuragi.saga.jp","nishiarita.saga.jp","ogi.saga.jp","omachi.saga.jp","ouchi.saga.jp","saga.saga.jp","shiroishi.saga.jp","taku.saga.jp","tara.saga.jp","tosu.saga.jp","yoshinogari.saga.jp","arakawa.saitama.jp","asaka.saitama.jp","chichibu.saitama.jp","fujimi.saitama.jp","fujimino.saitama.jp","fukaya.saitama.jp","hanno.saitama.jp","hanyu.saitama.jp","hasuda.saitama.jp","hatogaya.saitama.jp","hatoyama.saitama.jp","hidaka.saitama.jp","higashichichibu.saitama.jp","higashimatsuyama.saitama.jp","honjo.saitama.jp","ina.saitama.jp","iruma.saitama.jp","iwatsuki.saitama.jp","kamiizumi.saitama.jp","kamikawa.saitama.jp","kamisato.saitama.jp","kasukabe.saitama.jp","kawagoe.saitama.jp","kawaguchi.saitama.jp","kawajima.saitama.jp","kazo.saitama.jp","kitamoto.saitama.jp","koshigaya.saitama.jp","kounosu.saitama.jp","kuki.saitama.jp","kumagaya.saitama.jp","matsubushi.saitama.jp","minano.saitama.jp","misato.saitama.jp","miyashiro.saitama.jp","miyoshi.saitama.jp","moroyama.saitama.jp","nagatoro.saitama.jp","namegawa.saitama.jp","niiza.saitama.jp","ogano.saitama.jp","ogawa.saitama.jp","ogose.saitama.jp","okegawa.saitama.jp","omiya.saitama.jp","otaki.saitama.jp","ranzan.saitama.jp","ryokami.saitama.jp","saitama.saitama.jp","sakado.saitama.jp","satte.saitama.jp","sayama.saitama.jp","shiki.saitama.jp","shiraoka.saitama.jp","soka.saitama.jp","sugito.saitama.jp","toda.saitama.jp","tokigawa.saitama.jp","tokorozawa.saitama.jp","tsurugashima.saitama.jp","urawa.saitama.jp","warabi.saitama.jp","yashio.saitama.jp","yokoze.saitama.jp","yono.saitama.jp","yorii.saitama.jp","yoshida.saitama.jp","yoshikawa.saitama.jp","yoshimi.saitama.jp","aisho.shiga.jp","gamo.shiga.jp","higashiomi.shiga.jp","hikone.shiga.jp","koka.shiga.jp","konan.shiga.jp","kosei.shiga.jp","koto.shiga.jp","kusatsu.shiga.jp","maibara.shiga.jp","moriyama.shiga.jp","nagahama.shiga.jp","nishiazai.shiga.jp","notogawa.shiga.jp","omihachiman.shiga.jp","otsu.shiga.jp","ritto.shiga.jp","ryuoh.shiga.jp","takashima.shiga.jp","takatsuki.shiga.jp","torahime.shiga.jp","toyosato.shiga.jp","yasu.shiga.jp","akagi.shimane.jp","ama.shimane.jp","gotsu.shimane.jp","hamada.shimane.jp","higashiizumo.shimane.jp","hikawa.shimane.jp","hikimi.shimane.jp","izumo.shimane.jp","kakinoki.shimane.jp","masuda.shimane.jp","matsue.shimane.jp","misato.shimane.jp","nishinoshima.shimane.jp","ohda.shimane.jp","okinoshima.shimane.jp","okuizumo.shimane.jp","shimane.shimane.jp","tamayu.shimane.jp","tsuwano.shimane.jp","unnan.shimane.jp","yakumo.shimane.jp","yasugi.shimane.jp","yatsuka.shimane.jp","arai.shizuoka.jp","atami.shizuoka.jp","fuji.shizuoka.jp","fujieda.shizuoka.jp","fujikawa.shizuoka.jp","fujinomiya.shizuoka.jp","fukuroi.shizuoka.jp","gotemba.shizuoka.jp","haibara.shizuoka.jp","hamamatsu.shizuoka.jp","higashiizu.shizuoka.jp","ito.shizuoka.jp","iwata.shizuoka.jp","izu.shizuoka.jp","izunokuni.shizuoka.jp","kakegawa.shizuoka.jp","kannami.shizuoka.jp","kawanehon.shizuoka.jp","kawazu.shizuoka.jp","kikugawa.shizuoka.jp","kosai.shizuoka.jp","makinohara.shizuoka.jp","matsuzaki.shizuoka.jp","minamiizu.shizuoka.jp","mishima.shizuoka.jp","morimachi.shizuoka.jp","nishiizu.shizuoka.jp","numazu.shizuoka.jp","omaezaki.shizuoka.jp","shimada.shizuoka.jp","shimizu.shizuoka.jp","shimoda.shizuoka.jp","shizuoka.shizuoka.jp","susono.shizuoka.jp","yaizu.shizuoka.jp","yoshida.shizuoka.jp","ashikaga.tochigi.jp","bato.tochigi.jp","haga.tochigi.jp","ichikai.tochigi.jp","iwafune.tochigi.jp","kaminokawa.tochigi.jp","kanuma.tochigi.jp","karasuyama.tochigi.jp","kuroiso.tochigi.jp","mashiko.tochigi.jp","mibu.tochigi.jp","moka.tochigi.jp","motegi.tochigi.jp","nasu.tochigi.jp","nasushiobara.tochigi.jp","nikko.tochigi.jp","nishikata.tochigi.jp","nogi.tochigi.jp","ohira.tochigi.jp","ohtawara.tochigi.jp","oyama.tochigi.jp","sakura.tochigi.jp","sano.tochigi.jp","shimotsuke.tochigi.jp","shioya.tochigi.jp","takanezawa.tochigi.jp","tochigi.tochigi.jp","tsuga.tochigi.jp","ujiie.tochigi.jp","utsunomiya.tochigi.jp","yaita.tochigi.jp","aizumi.tokushima.jp","anan.tokushima.jp","ichiba.tokushima.jp","itano.tokushima.jp","kainan.tokushima.jp","komatsushima.tokushima.jp","matsushige.tokushima.jp","mima.tokushima.jp","minami.tokushima.jp","miyoshi.tokushima.jp","mugi.tokushima.jp","nakagawa.tokushima.jp","naruto.tokushima.jp","sanagochi.tokushima.jp","shishikui.tokushima.jp","tokushima.tokushima.jp","wajiki.tokushima.jp","adachi.tokyo.jp","akiruno.tokyo.jp","akishima.tokyo.jp","aogashima.tokyo.jp","arakawa.tokyo.jp","bunkyo.tokyo.jp","chiyoda.tokyo.jp","chofu.tokyo.jp","chuo.tokyo.jp","edogawa.tokyo.jp","fuchu.tokyo.jp","fussa.tokyo.jp","hachijo.tokyo.jp","hachioji.tokyo.jp","hamura.tokyo.jp","higashikurume.tokyo.jp","higashimurayama.tokyo.jp","higashiyamato.tokyo.jp","hino.tokyo.jp","hinode.tokyo.jp","hinohara.tokyo.jp","inagi.tokyo.jp","itabashi.tokyo.jp","katsushika.tokyo.jp","kita.tokyo.jp","kiyose.tokyo.jp","kodaira.tokyo.jp","koganei.tokyo.jp","kokubunji.tokyo.jp","komae.tokyo.jp","koto.tokyo.jp","kouzushima.tokyo.jp","kunitachi.tokyo.jp","machida.tokyo.jp","meguro.tokyo.jp","minato.tokyo.jp","mitaka.tokyo.jp","mizuho.tokyo.jp","musashimurayama.tokyo.jp","musashino.tokyo.jp","nakano.tokyo.jp","nerima.tokyo.jp","ogasawara.tokyo.jp","okutama.tokyo.jp","ome.tokyo.jp","oshima.tokyo.jp","ota.tokyo.jp","setagaya.tokyo.jp","shibuya.tokyo.jp","shinagawa.tokyo.jp","shinjuku.tokyo.jp","suginami.tokyo.jp","sumida.tokyo.jp","tachikawa.tokyo.jp","taito.tokyo.jp","tama.tokyo.jp","toshima.tokyo.jp","chizu.tottori.jp","hino.tottori.jp","kawahara.tottori.jp","koge.tottori.jp","kotoura.tottori.jp","misasa.tottori.jp","nanbu.tottori.jp","nichinan.tottori.jp","sakaiminato.tottori.jp","tottori.tottori.jp","wakasa.tottori.jp","yazu.tottori.jp","yonago.tottori.jp","asahi.toyama.jp","fuchu.toyama.jp","fukumitsu.toyama.jp","funahashi.toyama.jp","himi.toyama.jp","imizu.toyama.jp","inami.toyama.jp","johana.toyama.jp","kamiichi.toyama.jp","kurobe.toyama.jp","nakaniikawa.toyama.jp","namerikawa.toyama.jp","nanto.toyama.jp","nyuzen.toyama.jp","oyabe.toyama.jp","taira.toyama.jp","takaoka.toyama.jp","tateyama.toyama.jp","toga.toyama.jp","tonami.toyama.jp","toyama.toyama.jp","unazuki.toyama.jp","uozu.toyama.jp","yamada.toyama.jp","arida.wakayama.jp","aridagawa.wakayama.jp","gobo.wakayama.jp","hashimoto.wakayama.jp","hidaka.wakayama.jp","hirogawa.wakayama.jp","inami.wakayama.jp","iwade.wakayama.jp","kainan.wakayama.jp","kamitonda.wakayama.jp","katsuragi.wakayama.jp","kimino.wakayama.jp","kinokawa.wakayama.jp","kitayama.wakayama.jp","koya.wakayama.jp","koza.wakayama.jp","kozagawa.wakayama.jp","kudoyama.wakayama.jp","kushimoto.wakayama.jp","mihama.wakayama.jp","misato.wakayama.jp","nachikatsuura.wakayama.jp","shingu.wakayama.jp","shirahama.wakayama.jp","taiji.wakayama.jp","tanabe.wakayama.jp","wakayama.wakayama.jp","yuasa.wakayama.jp","yura.wakayama.jp","asahi.yamagata.jp","funagata.yamagata.jp","higashine.yamagata.jp","iide.yamagata.jp","kahoku.yamagata.jp","kaminoyama.yamagata.jp","kaneyama.yamagata.jp","kawanishi.yamagata.jp","mamurogawa.yamagata.jp","mikawa.yamagata.jp","murayama.yamagata.jp","nagai.yamagata.jp","nakayama.yamagata.jp","nanyo.yamagata.jp","nishikawa.yamagata.jp","obanazawa.yamagata.jp","oe.yamagata.jp","oguni.yamagata.jp","ohkura.yamagata.jp","oishida.yamagata.jp","sagae.yamagata.jp","sakata.yamagata.jp","sakegawa.yamagata.jp","shinjo.yamagata.jp","shirataka.yamagata.jp","shonai.yamagata.jp","takahata.yamagata.jp","tendo.yamagata.jp","tozawa.yamagata.jp","tsuruoka.yamagata.jp","yamagata.yamagata.jp","yamanobe.yamagata.jp","yonezawa.yamagata.jp","yuza.yamagata.jp","abu.yamaguchi.jp","hagi.yamaguchi.jp","hikari.yamaguchi.jp","hofu.yamaguchi.jp","iwakuni.yamaguchi.jp","kudamatsu.yamaguchi.jp","mitou.yamaguchi.jp","nagato.yamaguchi.jp","oshima.yamaguchi.jp","shimonoseki.yamaguchi.jp","shunan.yamaguchi.jp","tabuse.yamaguchi.jp","tokuyama.yamaguchi.jp","toyota.yamaguchi.jp","ube.yamaguchi.jp","yuu.yamaguchi.jp","chuo.yamanashi.jp","doshi.yamanashi.jp","fuefuki.yamanashi.jp","fujikawa.yamanashi.jp","fujikawaguchiko.yamanashi.jp","fujiyoshida.yamanashi.jp","hayakawa.yamanashi.jp","hokuto.yamanashi.jp","ichikawamisato.yamanashi.jp","kai.yamanashi.jp","kofu.yamanashi.jp","koshu.yamanashi.jp","kosuge.yamanashi.jp","minami-alps.yamanashi.jp","minobu.yamanashi.jp","nakamichi.yamanashi.jp","nanbu.yamanashi.jp","narusawa.yamanashi.jp","nirasaki.yamanashi.jp","nishikatsura.yamanashi.jp","oshino.yamanashi.jp","otsuki.yamanashi.jp","showa.yamanashi.jp","tabayama.yamanashi.jp","tsuru.yamanashi.jp","uenohara.yamanashi.jp","yamanakako.yamanashi.jp","yamanashi.yamanashi.jp","ke","ac.ke","co.ke","go.ke","info.ke","me.ke","mobi.ke","ne.ke","or.ke","sc.ke","kg","org.kg","net.kg","com.kg","edu.kg","gov.kg","mil.kg","*.kh","ki","edu.ki","biz.ki","net.ki","org.ki","gov.ki","info.ki","com.ki","km","org.km","nom.km","gov.km","prd.km","tm.km","edu.km","mil.km","ass.km","com.km","coop.km","asso.km","presse.km","medecin.km","notaires.km","pharmaciens.km","veterinaire.km","gouv.km","kn","net.kn","org.kn","edu.kn","gov.kn","kp","com.kp","edu.kp","gov.kp","org.kp","rep.kp","tra.kp","kr","ac.kr","co.kr","es.kr","go.kr","hs.kr","kg.kr","mil.kr","ms.kr","ne.kr","or.kr","pe.kr","re.kr","sc.kr","busan.kr","chungbuk.kr","chungnam.kr","daegu.kr","daejeon.kr","gangwon.kr","gwangju.kr","gyeongbuk.kr","gyeonggi.kr","gyeongnam.kr","incheon.kr","jeju.kr","jeonbuk.kr","jeonnam.kr","seoul.kr","ulsan.kr","kw","com.kw","edu.kw","emb.kw","gov.kw","ind.kw","net.kw","org.kw","ky","com.ky","edu.ky","net.ky","org.ky","kz","org.kz","edu.kz","net.kz","gov.kz","mil.kz","com.kz","la","int.la","net.la","info.la","edu.la","gov.la","per.la","com.la","org.la","lb","com.lb","edu.lb","gov.lb","net.lb","org.lb","lc","com.lc","net.lc","co.lc","org.lc","edu.lc","gov.lc","li","lk","gov.lk","sch.lk","net.lk","int.lk","com.lk","org.lk","edu.lk","ngo.lk","soc.lk","web.lk","ltd.lk","assn.lk","grp.lk","hotel.lk","ac.lk","lr","com.lr","edu.lr","gov.lr","org.lr","net.lr","ls","ac.ls","biz.ls","co.ls","edu.ls","gov.ls","info.ls","net.ls","org.ls","sc.ls","lt","gov.lt","lu","lv","com.lv","edu.lv","gov.lv","org.lv","mil.lv","id.lv","net.lv","asn.lv","conf.lv","ly","com.ly","net.ly","gov.ly","plc.ly","edu.ly","sch.ly","med.ly","org.ly","id.ly","ma","co.ma","net.ma","gov.ma","org.ma","ac.ma","press.ma","mc","tm.mc","asso.mc","md","me","co.me","net.me","org.me","edu.me","ac.me","gov.me","its.me","priv.me","mg","org.mg","nom.mg","gov.mg","prd.mg","tm.mg","edu.mg","mil.mg","com.mg","co.mg","mh","mil","mk","com.mk","org.mk","net.mk","edu.mk","gov.mk","inf.mk","name.mk","ml","com.ml","edu.ml","gouv.ml","gov.ml","net.ml","org.ml","presse.ml","*.mm","mn","gov.mn","edu.mn","org.mn","mo","com.mo","net.mo","org.mo","edu.mo","gov.mo","mobi","mp","mq","mr","gov.mr","ms","com.ms","edu.ms","gov.ms","net.ms","org.ms","mt","com.mt","edu.mt","net.mt","org.mt","mu","com.mu","net.mu","org.mu","gov.mu","ac.mu","co.mu","or.mu","museum","academy.museum","agriculture.museum","air.museum","airguard.museum","alabama.museum","alaska.museum","amber.museum","ambulance.museum","american.museum","americana.museum","americanantiques.museum","americanart.museum","amsterdam.museum","and.museum","annefrank.museum","anthro.museum","anthropology.museum","antiques.museum","aquarium.museum","arboretum.museum","archaeological.museum","archaeology.museum","architecture.museum","art.museum","artanddesign.museum","artcenter.museum","artdeco.museum","arteducation.museum","artgallery.museum","arts.museum","artsandcrafts.museum","asmatart.museum","assassination.museum","assisi.museum","association.museum","astronomy.museum","atlanta.museum","austin.museum","australia.museum","automotive.museum","aviation.museum","axis.museum","badajoz.museum","baghdad.museum","bahn.museum","bale.museum","baltimore.museum","barcelona.museum","baseball.museum","basel.museum","baths.museum","bauern.museum","beauxarts.museum","beeldengeluid.museum","bellevue.museum","bergbau.museum","berkeley.museum","berlin.museum","bern.museum","bible.museum","bilbao.museum","bill.museum","birdart.museum","birthplace.museum","bonn.museum","boston.museum","botanical.museum","botanicalgarden.museum","botanicgarden.museum","botany.museum","brandywinevalley.museum","brasil.museum","bristol.museum","british.museum","britishcolumbia.museum","broadcast.museum","brunel.museum","brussel.museum","brussels.museum","bruxelles.museum","building.museum","burghof.museum","bus.museum","bushey.museum","cadaques.museum","california.museum","cambridge.museum","can.museum","canada.museum","capebreton.museum","carrier.museum","cartoonart.museum","casadelamoneda.museum","castle.museum","castres.museum","celtic.museum","center.museum","chattanooga.museum","cheltenham.museum","chesapeakebay.museum","chicago.museum","children.museum","childrens.museum","childrensgarden.museum","chiropractic.museum","chocolate.museum","christiansburg.museum","cincinnati.museum","cinema.museum","circus.museum","civilisation.museum","civilization.museum","civilwar.museum","clinton.museum","clock.museum","coal.museum","coastaldefence.museum","cody.museum","coldwar.museum","collection.museum","colonialwilliamsburg.museum","coloradoplateau.museum","columbia.museum","columbus.museum","communication.museum","communications.museum","community.museum","computer.museum","computerhistory.museum","comunica\xe7\xf5es.museum","contemporary.museum","contemporaryart.museum","convent.museum","copenhagen.museum","corporation.museum","correios-e-telecomunica\xe7\xf5es.museum","corvette.museum","costume.museum","countryestate.museum","county.museum","crafts.museum","cranbrook.museum","creation.museum","cultural.museum","culturalcenter.museum","culture.museum","cyber.museum","cymru.museum","dali.museum","dallas.museum","database.museum","ddr.museum","decorativearts.museum","delaware.museum","delmenhorst.museum","denmark.museum","depot.museum","design.museum","detroit.museum","dinosaur.museum","discovery.museum","dolls.museum","donostia.museum","durham.museum","eastafrica.museum","eastcoast.museum","education.museum","educational.museum","egyptian.museum","eisenbahn.museum","elburg.museum","elvendrell.museum","embroidery.museum","encyclopedic.museum","england.museum","entomology.museum","environment.museum","environmentalconservation.museum","epilepsy.museum","essex.museum","estate.museum","ethnology.museum","exeter.museum","exhibition.museum","family.museum","farm.museum","farmequipment.museum","farmers.museum","farmstead.museum","field.museum","figueres.museum","filatelia.museum","film.museum","fineart.museum","finearts.museum","finland.museum","flanders.museum","florida.museum","force.museum","fortmissoula.museum","fortworth.museum","foundation.museum","francaise.museum","frankfurt.museum","franziskaner.museum","freemasonry.museum","freiburg.museum","fribourg.museum","frog.museum","fundacio.museum","furniture.museum","gallery.museum","garden.museum","gateway.museum","geelvinck.museum","gemological.museum","geology.museum","georgia.museum","giessen.museum","glas.museum","glass.museum","gorge.museum","grandrapids.museum","graz.museum","guernsey.museum","halloffame.museum","hamburg.museum","handson.museum","harvestcelebration.museum","hawaii.museum","health.museum","heimatunduhren.museum","hellas.museum","helsinki.museum","hembygdsforbund.museum","heritage.museum","histoire.museum","historical.museum","historicalsociety.museum","historichouses.museum","historisch.museum","historisches.museum","history.museum","historyofscience.museum","horology.museum","house.museum","humanities.museum","illustration.museum","imageandsound.museum","indian.museum","indiana.museum","indianapolis.museum","indianmarket.museum","intelligence.museum","interactive.museum","iraq.museum","iron.museum","isleofman.museum","jamison.museum","jefferson.museum","jerusalem.museum","jewelry.museum","jewish.museum","jewishart.museum","jfk.museum","journalism.museum","judaica.museum","judygarland.museum","juedisches.museum","juif.museum","karate.museum","karikatur.museum","kids.museum","koebenhavn.museum","koeln.museum","kunst.museum","kunstsammlung.museum","kunstunddesign.museum","labor.museum","labour.museum","lajolla.museum","lancashire.museum","landes.museum","lans.museum","l\xe4ns.museum","larsson.museum","lewismiller.museum","lincoln.museum","linz.museum","living.museum","livinghistory.museum","localhistory.museum","london.museum","losangeles.museum","louvre.museum","loyalist.museum","lucerne.museum","luxembourg.museum","luzern.museum","mad.museum","madrid.museum","mallorca.museum","manchester.museum","mansion.museum","mansions.museum","manx.museum","marburg.museum","maritime.museum","maritimo.museum","maryland.museum","marylhurst.museum","media.museum","medical.museum","medizinhistorisches.museum","meeres.museum","memorial.museum","mesaverde.museum","michigan.museum","midatlantic.museum","military.museum","mill.museum","miners.museum","mining.museum","minnesota.museum","missile.museum","missoula.museum","modern.museum","moma.museum","money.museum","monmouth.museum","monticello.museum","montreal.museum","moscow.museum","motorcycle.museum","muenchen.museum","muenster.museum","mulhouse.museum","muncie.museum","museet.museum","museumcenter.museum","museumvereniging.museum","music.museum","national.museum","nationalfirearms.museum","nationalheritage.museum","nativeamerican.museum","naturalhistory.museum","naturalhistorymuseum.museum","naturalsciences.museum","nature.museum","naturhistorisches.museum","natuurwetenschappen.museum","naumburg.museum","naval.museum","nebraska.museum","neues.museum","newhampshire.museum","newjersey.museum","newmexico.museum","newport.museum","newspaper.museum","newyork.museum","niepce.museum","norfolk.museum","north.museum","nrw.museum","nyc.museum","nyny.museum","oceanographic.museum","oceanographique.museum","omaha.museum","online.museum","ontario.museum","openair.museum","oregon.museum","oregontrail.museum","otago.museum","oxford.museum","pacific.museum","paderborn.museum","palace.museum","paleo.museum","palmsprings.museum","panama.museum","paris.museum","pasadena.museum","pharmacy.museum","philadelphia.museum","philadelphiaarea.museum","philately.museum","phoenix.museum","photography.museum","pilots.museum","pittsburgh.museum","planetarium.museum","plantation.museum","plants.museum","plaza.museum","portal.museum","portland.museum","portlligat.museum","posts-and-telecommunications.museum","preservation.museum","presidio.museum","press.museum","project.museum","public.museum","pubol.museum","quebec.museum","railroad.museum","railway.museum","research.museum","resistance.museum","riodejaneiro.museum","rochester.museum","rockart.museum","roma.museum","russia.museum","saintlouis.museum","salem.museum","salvadordali.museum","salzburg.museum","sandiego.museum","sanfrancisco.museum","santabarbara.museum","santacruz.museum","santafe.museum","saskatchewan.museum","satx.museum","savannahga.museum","schlesisches.museum","schoenbrunn.museum","schokoladen.museum","school.museum","schweiz.museum","science.museum","scienceandhistory.museum","scienceandindustry.museum","sciencecenter.museum","sciencecenters.museum","science-fiction.museum","sciencehistory.museum","sciences.museum","sciencesnaturelles.museum","scotland.museum","seaport.museum","settlement.museum","settlers.museum","shell.museum","sherbrooke.museum","sibenik.museum","silk.museum","ski.museum","skole.museum","society.museum","sologne.museum","soundandvision.museum","southcarolina.museum","southwest.museum","space.museum","spy.museum","square.museum","stadt.museum","stalbans.museum","starnberg.museum","state.museum","stateofdelaware.museum","station.museum","steam.museum","steiermark.museum","stjohn.museum","stockholm.museum","stpetersburg.museum","stuttgart.museum","suisse.museum","surgeonshall.museum","surrey.museum","svizzera.museum","sweden.museum","sydney.museum","tank.museum","tcm.museum","technology.museum","telekommunikation.museum","television.museum","texas.museum","textile.museum","theater.museum","time.museum","timekeeping.museum","topology.museum","torino.museum","touch.museum","town.museum","transport.museum","tree.museum","trolley.museum","trust.museum","trustee.museum","uhren.museum","ulm.museum","undersea.museum","university.museum","usa.museum","usantiques.museum","usarts.museum","uscountryestate.museum","usculture.museum","usdecorativearts.museum","usgarden.museum","ushistory.museum","ushuaia.museum","uslivinghistory.museum","utah.museum","uvic.museum","valley.museum","vantaa.museum","versailles.museum","viking.museum","village.museum","virginia.museum","virtual.museum","virtuel.museum","vlaanderen.museum","volkenkunde.museum","wales.museum","wallonie.museum","war.museum","washingtondc.museum","watchandclock.museum","watch-and-clock.museum","western.museum","westfalen.museum","whaling.museum","wildlife.museum","williamsburg.museum","windmill.museum","workshop.museum","york.museum","yorkshire.museum","yosemite.museum","youth.museum","zoological.museum","zoology.museum","\u05D9\u05E8\u05D5\u05E9\u05DC\u05D9\u05DD.museum","\u0438\u043A\u043E\u043C.museum","mv","aero.mv","biz.mv","com.mv","coop.mv","edu.mv","gov.mv","info.mv","int.mv","mil.mv","museum.mv","name.mv","net.mv","org.mv","pro.mv","mw","ac.mw","biz.mw","co.mw","com.mw","coop.mw","edu.mw","gov.mw","int.mw","museum.mw","net.mw","org.mw","mx","com.mx","org.mx","gob.mx","edu.mx","net.mx","my","biz.my","com.my","edu.my","gov.my","mil.my","name.my","net.my","org.my","mz","ac.mz","adv.mz","co.mz","edu.mz","gov.mz","mil.mz","net.mz","org.mz","na","info.na","pro.na","name.na","school.na","or.na","dr.na","us.na","mx.na","ca.na","in.na","cc.na","tv.na","ws.na","mobi.na","co.na","com.na","org.na","name","nc","asso.nc","nom.nc","ne","net","nf","com.nf","net.nf","per.nf","rec.nf","web.nf","arts.nf","firm.nf","info.nf","other.nf","store.nf","ng","com.ng","edu.ng","gov.ng","i.ng","mil.ng","mobi.ng","name.ng","net.ng","org.ng","sch.ng","ni","ac.ni","biz.ni","co.ni","com.ni","edu.ni","gob.ni","in.ni","info.ni","int.ni","mil.ni","net.ni","nom.ni","org.ni","web.ni","nl","no","fhs.no","vgs.no","fylkesbibl.no","folkebibl.no","museum.no","idrett.no","priv.no","mil.no","stat.no","dep.no","kommune.no","herad.no","aa.no","ah.no","bu.no","fm.no","hl.no","hm.no","jan-mayen.no","mr.no","nl.no","nt.no","of.no","ol.no","oslo.no","rl.no","sf.no","st.no","svalbard.no","tm.no","tr.no","va.no","vf.no","gs.aa.no","gs.ah.no","gs.bu.no","gs.fm.no","gs.hl.no","gs.hm.no","gs.jan-mayen.no","gs.mr.no","gs.nl.no","gs.nt.no","gs.of.no","gs.ol.no","gs.oslo.no","gs.rl.no","gs.sf.no","gs.st.no","gs.svalbard.no","gs.tm.no","gs.tr.no","gs.va.no","gs.vf.no","akrehamn.no","\xe5krehamn.no","algard.no","\xe5lg\xe5rd.no","arna.no","brumunddal.no","bryne.no","bronnoysund.no","br\xf8nn\xf8ysund.no","drobak.no","dr\xf8bak.no","egersund.no","fetsund.no","floro.no","flor\xf8.no","fredrikstad.no","hokksund.no","honefoss.no","h\xf8nefoss.no","jessheim.no","jorpeland.no","j\xf8rpeland.no","kirkenes.no","kopervik.no","krokstadelva.no","langevag.no","langev\xe5g.no","leirvik.no","mjondalen.no","mj\xf8ndalen.no","mo-i-rana.no","mosjoen.no","mosj\xf8en.no","nesoddtangen.no","orkanger.no","osoyro.no","os\xf8yro.no","raholt.no","r\xe5holt.no","sandnessjoen.no","sandnessj\xf8en.no","skedsmokorset.no","slattum.no","spjelkavik.no","stathelle.no","stavern.no","stjordalshalsen.no","stj\xf8rdalshalsen.no","tananger.no","tranby.no","vossevangen.no","afjord.no","\xe5fjord.no","agdenes.no","al.no","\xe5l.no","alesund.no","\xe5lesund.no","alstahaug.no","alta.no","\xe1lt\xe1.no","alaheadju.no","\xe1laheadju.no","alvdal.no","amli.no","\xe5mli.no","amot.no","\xe5mot.no","andebu.no","andoy.no","and\xf8y.no","andasuolo.no","ardal.no","\xe5rdal.no","aremark.no","arendal.no","\xe5s.no","aseral.no","\xe5seral.no","asker.no","askim.no","askvoll.no","askoy.no","ask\xf8y.no","asnes.no","\xe5snes.no","audnedaln.no","aukra.no","aure.no","aurland.no","aurskog-holand.no","aurskog-h\xf8land.no","austevoll.no","austrheim.no","averoy.no","aver\xf8y.no","balestrand.no","ballangen.no","balat.no","b\xe1l\xe1t.no","balsfjord.no","bahccavuotna.no","b\xe1hccavuotna.no","bamble.no","bardu.no","beardu.no","beiarn.no","bajddar.no","b\xe1jddar.no","baidar.no","b\xe1id\xe1r.no","berg.no","bergen.no","berlevag.no","berlev\xe5g.no","bearalvahki.no","bearalv\xe1hki.no","bindal.no","birkenes.no","bjarkoy.no","bjark\xf8y.no","bjerkreim.no","bjugn.no","bodo.no","bod\xf8.no","badaddja.no","b\xe5d\xe5ddj\xe5.no","budejju.no","bokn.no","bremanger.no","bronnoy.no","br\xf8nn\xf8y.no","bygland.no","bykle.no","barum.no","b\xe6rum.no","bo.telemark.no","b\xf8.telemark.no","bo.nordland.no","b\xf8.nordland.no","bievat.no","biev\xe1t.no","bomlo.no","b\xf8mlo.no","batsfjord.no","b\xe5tsfjord.no","bahcavuotna.no","b\xe1hcavuotna.no","dovre.no","drammen.no","drangedal.no","dyroy.no","dyr\xf8y.no","donna.no","d\xf8nna.no","eid.no","eidfjord.no","eidsberg.no","eidskog.no","eidsvoll.no","eigersund.no","elverum.no","enebakk.no","engerdal.no","etne.no","etnedal.no","evenes.no","evenassi.no","even\xe1\u0161\u0161i.no","evje-og-hornnes.no","farsund.no","fauske.no","fuossko.no","fuoisku.no","fedje.no","fet.no","finnoy.no","finn\xf8y.no","fitjar.no","fjaler.no","fjell.no","flakstad.no","flatanger.no","flekkefjord.no","flesberg.no","flora.no","fla.no","fl\xe5.no","folldal.no","forsand.no","fosnes.no","frei.no","frogn.no","froland.no","frosta.no","frana.no","fr\xe6na.no","froya.no","fr\xf8ya.no","fusa.no","fyresdal.no","forde.no","f\xf8rde.no","gamvik.no","gangaviika.no","g\xe1\u014Bgaviika.no","gaular.no","gausdal.no","gildeskal.no","gildesk\xe5l.no","giske.no","gjemnes.no","gjerdrum.no","gjerstad.no","gjesdal.no","gjovik.no","gj\xf8vik.no","gloppen.no","gol.no","gran.no","grane.no","granvin.no","gratangen.no","grimstad.no","grong.no","kraanghke.no","kr\xe5anghke.no","grue.no","gulen.no","hadsel.no","halden.no","halsa.no","hamar.no","hamaroy.no","habmer.no","h\xe1bmer.no","hapmir.no","h\xe1pmir.no","hammerfest.no","hammarfeasta.no","h\xe1mm\xe1rfeasta.no","haram.no","hareid.no","harstad.no","hasvik.no","aknoluokta.no","\xe1k\u014Boluokta.no","hattfjelldal.no","aarborte.no","haugesund.no","hemne.no","hemnes.no","hemsedal.no","heroy.more-og-romsdal.no","her\xf8y.m\xf8re-og-romsdal.no","heroy.nordland.no","her\xf8y.nordland.no","hitra.no","hjartdal.no","hjelmeland.no","hobol.no","hob\xf8l.no","hof.no","hol.no","hole.no","holmestrand.no","holtalen.no","holt\xe5len.no","hornindal.no","horten.no","hurdal.no","hurum.no","hvaler.no","hyllestad.no","hagebostad.no","h\xe6gebostad.no","hoyanger.no","h\xf8yanger.no","hoylandet.no","h\xf8ylandet.no","ha.no","h\xe5.no","ibestad.no","inderoy.no","inder\xf8y.no","iveland.no","jevnaker.no","jondal.no","jolster.no","j\xf8lster.no","karasjok.no","karasjohka.no","k\xe1r\xe1\u0161johka.no","karlsoy.no","galsa.no","g\xe1ls\xe1.no","karmoy.no","karm\xf8y.no","kautokeino.no","guovdageaidnu.no","klepp.no","klabu.no","kl\xe6bu.no","kongsberg.no","kongsvinger.no","kragero.no","krager\xf8.no","kristiansand.no","kristiansund.no","krodsherad.no","kr\xf8dsherad.no","kvalsund.no","rahkkeravju.no","r\xe1hkker\xe1vju.no","kvam.no","kvinesdal.no","kvinnherad.no","kviteseid.no","kvitsoy.no","kvits\xf8y.no","kvafjord.no","kv\xe6fjord.no","giehtavuoatna.no","kvanangen.no","kv\xe6nangen.no","navuotna.no","n\xe1vuotna.no","kafjord.no","k\xe5fjord.no","gaivuotna.no","g\xe1ivuotna.no","larvik.no","lavangen.no","lavagis.no","loabat.no","loab\xe1t.no","lebesby.no","davvesiida.no","leikanger.no","leirfjord.no","leka.no","leksvik.no","lenvik.no","leangaviika.no","lea\u014Bgaviika.no","lesja.no","levanger.no","lier.no","lierne.no","lillehammer.no","lillesand.no","lindesnes.no","lindas.no","lind\xe5s.no","lom.no","loppa.no","lahppi.no","l\xe1hppi.no","lund.no","lunner.no","luroy.no","lur\xf8y.no","luster.no","lyngdal.no","lyngen.no","ivgu.no","lardal.no","lerdal.no","l\xe6rdal.no","lodingen.no","l\xf8dingen.no","lorenskog.no","l\xf8renskog.no","loten.no","l\xf8ten.no","malvik.no","masoy.no","m\xe5s\xf8y.no","muosat.no","muos\xe1t.no","mandal.no","marker.no","marnardal.no","masfjorden.no","meland.no","meldal.no","melhus.no","meloy.no","mel\xf8y.no","meraker.no","mer\xe5ker.no","moareke.no","mo\xe5reke.no","midsund.no","midtre-gauldal.no","modalen.no","modum.no","molde.no","moskenes.no","moss.no","mosvik.no","malselv.no","m\xe5lselv.no","malatvuopmi.no","m\xe1latvuopmi.no","namdalseid.no","aejrie.no","namsos.no","namsskogan.no","naamesjevuemie.no","n\xe5\xe5mesjevuemie.no","laakesvuemie.no","nannestad.no","narvik.no","narviika.no","naustdal.no","nedre-eiker.no","nes.akershus.no","nes.buskerud.no","nesna.no","nesodden.no","nesseby.no","unjarga.no","unj\xe1rga.no","nesset.no","nissedal.no","nittedal.no","nord-aurdal.no","nord-fron.no","nord-odal.no","norddal.no","nordkapp.no","davvenjarga.no","davvenj\xe1rga.no","nordre-land.no","nordreisa.no","raisa.no","r\xe1isa.no","nore-og-uvdal.no","notodden.no","naroy.no","n\xe6r\xf8y.no","notteroy.no","n\xf8tter\xf8y.no","odda.no","oksnes.no","\xf8ksnes.no","oppdal.no","oppegard.no","oppeg\xe5rd.no","orkdal.no","orland.no","\xf8rland.no","orskog.no","\xf8rskog.no","orsta.no","\xf8rsta.no","os.hedmark.no","os.hordaland.no","osen.no","osteroy.no","oster\xf8y.no","ostre-toten.no","\xf8stre-toten.no","overhalla.no","ovre-eiker.no","\xf8vre-eiker.no","oyer.no","\xf8yer.no","oygarden.no","\xf8ygarden.no","oystre-slidre.no","\xf8ystre-slidre.no","porsanger.no","porsangu.no","pors\xe1\u014Bgu.no","porsgrunn.no","radoy.no","rad\xf8y.no","rakkestad.no","rana.no","ruovat.no","randaberg.no","rauma.no","rendalen.no","rennebu.no","rennesoy.no","rennes\xf8y.no","rindal.no","ringebu.no","ringerike.no","ringsaker.no","rissa.no","risor.no","ris\xf8r.no","roan.no","rollag.no","rygge.no","ralingen.no","r\xe6lingen.no","rodoy.no","r\xf8d\xf8y.no","romskog.no","r\xf8mskog.no","roros.no","r\xf8ros.no","rost.no","r\xf8st.no","royken.no","r\xf8yken.no","royrvik.no","r\xf8yrvik.no","rade.no","r\xe5de.no","salangen.no","siellak.no","saltdal.no","salat.no","s\xe1l\xe1t.no","s\xe1lat.no","samnanger.no","sande.more-og-romsdal.no","sande.m\xf8re-og-romsdal.no","sande.vestfold.no","sandefjord.no","sandnes.no","sandoy.no","sand\xf8y.no","sarpsborg.no","sauda.no","sauherad.no","sel.no","selbu.no","selje.no","seljord.no","sigdal.no","siljan.no","sirdal.no","skaun.no","skedsmo.no","ski.no","skien.no","skiptvet.no","skjervoy.no","skjerv\xf8y.no","skierva.no","skierv\xe1.no","skjak.no","skj\xe5k.no","skodje.no","skanland.no","sk\xe5nland.no","skanit.no","sk\xe1nit.no","smola.no","sm\xf8la.no","snillfjord.no","snasa.no","sn\xe5sa.no","snoasa.no","snaase.no","sn\xe5ase.no","sogndal.no","sokndal.no","sola.no","solund.no","songdalen.no","sortland.no","spydeberg.no","stange.no","stavanger.no","steigen.no","steinkjer.no","stjordal.no","stj\xf8rdal.no","stokke.no","stor-elvdal.no","stord.no","stordal.no","storfjord.no","omasvuotna.no","strand.no","stranda.no","stryn.no","sula.no","suldal.no","sund.no","sunndal.no","surnadal.no","sveio.no","svelvik.no","sykkylven.no","sogne.no","s\xf8gne.no","somna.no","s\xf8mna.no","sondre-land.no","s\xf8ndre-land.no","sor-aurdal.no","s\xf8r-aurdal.no","sor-fron.no","s\xf8r-fron.no","sor-odal.no","s\xf8r-odal.no","sor-varanger.no","s\xf8r-varanger.no","matta-varjjat.no","m\xe1tta-v\xe1rjjat.no","sorfold.no","s\xf8rfold.no","sorreisa.no","s\xf8rreisa.no","sorum.no","s\xf8rum.no","tana.no","deatnu.no","time.no","tingvoll.no","tinn.no","tjeldsund.no","dielddanuorri.no","tjome.no","tj\xf8me.no","tokke.no","tolga.no","torsken.no","tranoy.no","tran\xf8y.no","tromso.no","troms\xf8.no","tromsa.no","romsa.no","trondheim.no","troandin.no","trysil.no","trana.no","tr\xe6na.no","trogstad.no","tr\xf8gstad.no","tvedestrand.no","tydal.no","tynset.no","tysfjord.no","divtasvuodna.no","divttasvuotna.no","tysnes.no","tysvar.no","tysv\xe6r.no","tonsberg.no","t\xf8nsberg.no","ullensaker.no","ullensvang.no","ulvik.no","utsira.no","vadso.no","vads\xf8.no","cahcesuolo.no","\u010D\xe1hcesuolo.no","vaksdal.no","valle.no","vang.no","vanylven.no","vardo.no","vard\xf8.no","varggat.no","v\xe1rgg\xe1t.no","vefsn.no","vaapste.no","vega.no","vegarshei.no","veg\xe5rshei.no","vennesla.no","verdal.no","verran.no","vestby.no","vestnes.no","vestre-slidre.no","vestre-toten.no","vestvagoy.no","vestv\xe5g\xf8y.no","vevelstad.no","vik.no","vikna.no","vindafjord.no","volda.no","voss.no","varoy.no","v\xe6r\xf8y.no","vagan.no","v\xe5gan.no","voagat.no","vagsoy.no","v\xe5gs\xf8y.no","vaga.no","v\xe5g\xe5.no","valer.ostfold.no","v\xe5ler.\xf8stfold.no","valer.hedmark.no","v\xe5ler.hedmark.no","*.np","nr","biz.nr","info.nr","gov.nr","edu.nr","org.nr","net.nr","com.nr","nu","nz","ac.nz","co.nz","cri.nz","geek.nz","gen.nz","govt.nz","health.nz","iwi.nz","kiwi.nz","maori.nz","mil.nz","m\u0101ori.nz","net.nz","org.nz","parliament.nz","school.nz","om","co.om","com.om","edu.om","gov.om","med.om","museum.om","net.om","org.om","pro.om","onion","org","pa","ac.pa","gob.pa","com.pa","org.pa","sld.pa","edu.pa","net.pa","ing.pa","abo.pa","med.pa","nom.pa","pe","edu.pe","gob.pe","nom.pe","mil.pe","org.pe","com.pe","net.pe","pf","com.pf","org.pf","edu.pf","*.pg","ph","com.ph","net.ph","org.ph","gov.ph","edu.ph","ngo.ph","mil.ph","i.ph","pk","com.pk","net.pk","edu.pk","org.pk","fam.pk","biz.pk","web.pk","gov.pk","gob.pk","gok.pk","gon.pk","gop.pk","gos.pk","info.pk","pl","com.pl","net.pl","org.pl","aid.pl","agro.pl","atm.pl","auto.pl","biz.pl","edu.pl","gmina.pl","gsm.pl","info.pl","mail.pl","miasta.pl","media.pl","mil.pl","nieruchomosci.pl","nom.pl","pc.pl","powiat.pl","priv.pl","realestate.pl","rel.pl","sex.pl","shop.pl","sklep.pl","sos.pl","szkola.pl","targi.pl","tm.pl","tourism.pl","travel.pl","turystyka.pl","gov.pl","ap.gov.pl","ic.gov.pl","is.gov.pl","us.gov.pl","kmpsp.gov.pl","kppsp.gov.pl","kwpsp.gov.pl","psp.gov.pl","wskr.gov.pl","kwp.gov.pl","mw.gov.pl","ug.gov.pl","um.gov.pl","umig.gov.pl","ugim.gov.pl","upow.gov.pl","uw.gov.pl","starostwo.gov.pl","pa.gov.pl","po.gov.pl","psse.gov.pl","pup.gov.pl","rzgw.gov.pl","sa.gov.pl","so.gov.pl","sr.gov.pl","wsa.gov.pl","sko.gov.pl","uzs.gov.pl","wiih.gov.pl","winb.gov.pl","pinb.gov.pl","wios.gov.pl","witd.gov.pl","wzmiuw.gov.pl","piw.gov.pl","wiw.gov.pl","griw.gov.pl","wif.gov.pl","oum.gov.pl","sdn.gov.pl","zp.gov.pl","uppo.gov.pl","mup.gov.pl","wuoz.gov.pl","konsulat.gov.pl","oirm.gov.pl","augustow.pl","babia-gora.pl","bedzin.pl","beskidy.pl","bialowieza.pl","bialystok.pl","bielawa.pl","bieszczady.pl","boleslawiec.pl","bydgoszcz.pl","bytom.pl","cieszyn.pl","czeladz.pl","czest.pl","dlugoleka.pl","elblag.pl","elk.pl","glogow.pl","gniezno.pl","gorlice.pl","grajewo.pl","ilawa.pl","jaworzno.pl","jelenia-gora.pl","jgora.pl","kalisz.pl","kazimierz-dolny.pl","karpacz.pl","kartuzy.pl","kaszuby.pl","katowice.pl","kepno.pl","ketrzyn.pl","klodzko.pl","kobierzyce.pl","kolobrzeg.pl","konin.pl","konskowola.pl","kutno.pl","lapy.pl","lebork.pl","legnica.pl","lezajsk.pl","limanowa.pl","lomza.pl","lowicz.pl","lubin.pl","lukow.pl","malbork.pl","malopolska.pl","mazowsze.pl","mazury.pl","mielec.pl","mielno.pl","mragowo.pl","naklo.pl","nowaruda.pl","nysa.pl","olawa.pl","olecko.pl","olkusz.pl","olsztyn.pl","opoczno.pl","opole.pl","ostroda.pl","ostroleka.pl","ostrowiec.pl","ostrowwlkp.pl","pila.pl","pisz.pl","podhale.pl","podlasie.pl","polkowice.pl","pomorze.pl","pomorskie.pl","prochowice.pl","pruszkow.pl","przeworsk.pl","pulawy.pl","radom.pl","rawa-maz.pl","rybnik.pl","rzeszow.pl","sanok.pl","sejny.pl","slask.pl","slupsk.pl","sosnowiec.pl","stalowa-wola.pl","skoczow.pl","starachowice.pl","stargard.pl","suwalki.pl","swidnica.pl","swiebodzin.pl","swinoujscie.pl","szczecin.pl","szczytno.pl","tarnobrzeg.pl","tgory.pl","turek.pl","tychy.pl","ustka.pl","walbrzych.pl","warmia.pl","warszawa.pl","waw.pl","wegrow.pl","wielun.pl","wlocl.pl","wloclawek.pl","wodzislaw.pl","wolomin.pl","wroclaw.pl","zachpomor.pl","zagan.pl","zarow.pl","zgora.pl","zgorzelec.pl","pm","pn","gov.pn","co.pn","org.pn","edu.pn","net.pn","post","pr","com.pr","net.pr","org.pr","gov.pr","edu.pr","isla.pr","pro.pr","biz.pr","info.pr","name.pr","est.pr","prof.pr","ac.pr","pro","aaa.pro","aca.pro","acct.pro","avocat.pro","bar.pro","cpa.pro","eng.pro","jur.pro","law.pro","med.pro","recht.pro","ps","edu.ps","gov.ps","sec.ps","plo.ps","com.ps","org.ps","net.ps","pt","net.pt","gov.pt","org.pt","edu.pt","int.pt","publ.pt","com.pt","nome.pt","pw","co.pw","ne.pw","or.pw","ed.pw","go.pw","belau.pw","py","com.py","coop.py","edu.py","gov.py","mil.py","net.py","org.py","qa","com.qa","edu.qa","gov.qa","mil.qa","name.qa","net.qa","org.qa","sch.qa","re","asso.re","com.re","nom.re","ro","arts.ro","com.ro","firm.ro","info.ro","nom.ro","nt.ro","org.ro","rec.ro","store.ro","tm.ro","www.ro","rs","ac.rs","co.rs","edu.rs","gov.rs","in.rs","org.rs","ru","rw","ac.rw","co.rw","coop.rw","gov.rw","mil.rw","net.rw","org.rw","sa","com.sa","net.sa","org.sa","gov.sa","med.sa","pub.sa","edu.sa","sch.sa","sb","com.sb","edu.sb","gov.sb","net.sb","org.sb","sc","com.sc","gov.sc","net.sc","org.sc","edu.sc","sd","com.sd","net.sd","org.sd","edu.sd","med.sd","tv.sd","gov.sd","info.sd","se","a.se","ac.se","b.se","bd.se","brand.se","c.se","d.se","e.se","f.se","fh.se","fhsk.se","fhv.se","g.se","h.se","i.se","k.se","komforb.se","kommunalforbund.se","komvux.se","l.se","lanbib.se","m.se","n.se","naturbruksgymn.se","o.se","org.se","p.se","parti.se","pp.se","press.se","r.se","s.se","t.se","tm.se","u.se","w.se","x.se","y.se","z.se","sg","com.sg","net.sg","org.sg","gov.sg","edu.sg","per.sg","sh","com.sh","net.sh","gov.sh","org.sh","mil.sh","si","sj","sk","sl","com.sl","net.sl","edu.sl","gov.sl","org.sl","sm","sn","art.sn","com.sn","edu.sn","gouv.sn","org.sn","perso.sn","univ.sn","so","com.so","edu.so","gov.so","me.so","net.so","org.so","sr","ss","biz.ss","com.ss","edu.ss","gov.ss","me.ss","net.ss","org.ss","sch.ss","st","co.st","com.st","consulado.st","edu.st","embaixada.st","mil.st","net.st","org.st","principe.st","saotome.st","store.st","su","sv","com.sv","edu.sv","gob.sv","org.sv","red.sv","sx","gov.sx","sy","edu.sy","gov.sy","net.sy","mil.sy","com.sy","org.sy","sz","co.sz","ac.sz","org.sz","tc","td","tel","tf","tg","th","ac.th","co.th","go.th","in.th","mi.th","net.th","or.th","tj","ac.tj","biz.tj","co.tj","com.tj","edu.tj","go.tj","gov.tj","int.tj","mil.tj","name.tj","net.tj","nic.tj","org.tj","test.tj","web.tj","tk","tl","gov.tl","tm","com.tm","co.tm","org.tm","net.tm","nom.tm","gov.tm","mil.tm","edu.tm","tn","com.tn","ens.tn","fin.tn","gov.tn","ind.tn","info.tn","intl.tn","mincom.tn","nat.tn","net.tn","org.tn","perso.tn","tourism.tn","to","com.to","gov.to","net.to","org.to","edu.to","mil.to","tr","av.tr","bbs.tr","bel.tr","biz.tr","com.tr","dr.tr","edu.tr","gen.tr","gov.tr","info.tr","mil.tr","k12.tr","kep.tr","name.tr","net.tr","org.tr","pol.tr","tel.tr","tsk.tr","tv.tr","web.tr","nc.tr","gov.nc.tr","tt","co.tt","com.tt","org.tt","net.tt","biz.tt","info.tt","pro.tt","int.tt","coop.tt","jobs.tt","mobi.tt","travel.tt","museum.tt","aero.tt","name.tt","gov.tt","edu.tt","tv","tw","edu.tw","gov.tw","mil.tw","com.tw","net.tw","org.tw","idv.tw","game.tw","ebiz.tw","club.tw","\u7DB2\u8DEF.tw","\u7D44\u7E54.tw","\u5546\u696D.tw","tz","ac.tz","co.tz","go.tz","hotel.tz","info.tz","me.tz","mil.tz","mobi.tz","ne.tz","or.tz","sc.tz","tv.tz","ua","com.ua","edu.ua","gov.ua","in.ua","net.ua","org.ua","cherkassy.ua","cherkasy.ua","chernigov.ua","chernihiv.ua","chernivtsi.ua","chernovtsy.ua","ck.ua","cn.ua","cr.ua","crimea.ua","cv.ua","dn.ua","dnepropetrovsk.ua","dnipropetrovsk.ua","donetsk.ua","dp.ua","if.ua","ivano-frankivsk.ua","kh.ua","kharkiv.ua","kharkov.ua","kherson.ua","khmelnitskiy.ua","khmelnytskyi.ua","kiev.ua","kirovograd.ua","km.ua","kr.ua","krym.ua","ks.ua","kv.ua","kyiv.ua","lg.ua","lt.ua","lugansk.ua","lutsk.ua","lv.ua","lviv.ua","mk.ua","mykolaiv.ua","nikolaev.ua","od.ua","odesa.ua","odessa.ua","pl.ua","poltava.ua","rivne.ua","rovno.ua","rv.ua","sb.ua","sebastopol.ua","sevastopol.ua","sm.ua","sumy.ua","te.ua","ternopil.ua","uz.ua","uzhgorod.ua","vinnica.ua","vinnytsia.ua","vn.ua","volyn.ua","yalta.ua","zaporizhzhe.ua","zaporizhzhia.ua","zhitomir.ua","zhytomyr.ua","zp.ua","zt.ua","ug","co.ug","or.ug","ac.ug","sc.ug","go.ug","ne.ug","com.ug","org.ug","uk","ac.uk","co.uk","gov.uk","ltd.uk","me.uk","net.uk","nhs.uk","org.uk","plc.uk","police.uk","*.sch.uk","us","dni.us","fed.us","isa.us","kids.us","nsn.us","ak.us","al.us","ar.us","as.us","az.us","ca.us","co.us","ct.us","dc.us","de.us","fl.us","ga.us","gu.us","hi.us","ia.us","id.us","il.us","in.us","ks.us","ky.us","la.us","ma.us","md.us","me.us","mi.us","mn.us","mo.us","ms.us","mt.us","nc.us","nd.us","ne.us","nh.us","nj.us","nm.us","nv.us","ny.us","oh.us","ok.us","or.us","pa.us","pr.us","ri.us","sc.us","sd.us","tn.us","tx.us","ut.us","vi.us","vt.us","va.us","wa.us","wi.us","wv.us","wy.us","k12.ak.us","k12.al.us","k12.ar.us","k12.as.us","k12.az.us","k12.ca.us","k12.co.us","k12.ct.us","k12.dc.us","k12.de.us","k12.fl.us","k12.ga.us","k12.gu.us","k12.ia.us","k12.id.us","k12.il.us","k12.in.us","k12.ks.us","k12.ky.us","k12.la.us","k12.ma.us","k12.md.us","k12.me.us","k12.mi.us","k12.mn.us","k12.mo.us","k12.ms.us","k12.mt.us","k12.nc.us","k12.ne.us","k12.nh.us","k12.nj.us","k12.nm.us","k12.nv.us","k12.ny.us","k12.oh.us","k12.ok.us","k12.or.us","k12.pa.us","k12.pr.us","k12.sc.us","k12.tn.us","k12.tx.us","k12.ut.us","k12.vi.us","k12.vt.us","k12.va.us","k12.wa.us","k12.wi.us","k12.wy.us","cc.ak.us","cc.al.us","cc.ar.us","cc.as.us","cc.az.us","cc.ca.us","cc.co.us","cc.ct.us","cc.dc.us","cc.de.us","cc.fl.us","cc.ga.us","cc.gu.us","cc.hi.us","cc.ia.us","cc.id.us","cc.il.us","cc.in.us","cc.ks.us","cc.ky.us","cc.la.us","cc.ma.us","cc.md.us","cc.me.us","cc.mi.us","cc.mn.us","cc.mo.us","cc.ms.us","cc.mt.us","cc.nc.us","cc.nd.us","cc.ne.us","cc.nh.us","cc.nj.us","cc.nm.us","cc.nv.us","cc.ny.us","cc.oh.us","cc.ok.us","cc.or.us","cc.pa.us","cc.pr.us","cc.ri.us","cc.sc.us","cc.sd.us","cc.tn.us","cc.tx.us","cc.ut.us","cc.vi.us","cc.vt.us","cc.va.us","cc.wa.us","cc.wi.us","cc.wv.us","cc.wy.us","lib.ak.us","lib.al.us","lib.ar.us","lib.as.us","lib.az.us","lib.ca.us","lib.co.us","lib.ct.us","lib.dc.us","lib.fl.us","lib.ga.us","lib.gu.us","lib.hi.us","lib.ia.us","lib.id.us","lib.il.us","lib.in.us","lib.ks.us","lib.ky.us","lib.la.us","lib.ma.us","lib.md.us","lib.me.us","lib.mi.us","lib.mn.us","lib.mo.us","lib.ms.us","lib.mt.us","lib.nc.us","lib.nd.us","lib.ne.us","lib.nh.us","lib.nj.us","lib.nm.us","lib.nv.us","lib.ny.us","lib.oh.us","lib.ok.us","lib.or.us","lib.pa.us","lib.pr.us","lib.ri.us","lib.sc.us","lib.sd.us","lib.tn.us","lib.tx.us","lib.ut.us","lib.vi.us","lib.vt.us","lib.va.us","lib.wa.us","lib.wi.us","lib.wy.us","pvt.k12.ma.us","chtr.k12.ma.us","paroch.k12.ma.us","ann-arbor.mi.us","cog.mi.us","dst.mi.us","eaton.mi.us","gen.mi.us","mus.mi.us","tec.mi.us","washtenaw.mi.us","uy","com.uy","edu.uy","gub.uy","mil.uy","net.uy","org.uy","uz","co.uz","com.uz","net.uz","org.uz","va","vc","com.vc","net.vc","org.vc","gov.vc","mil.vc","edu.vc","ve","arts.ve","bib.ve","co.ve","com.ve","e12.ve","edu.ve","firm.ve","gob.ve","gov.ve","info.ve","int.ve","mil.ve","net.ve","nom.ve","org.ve","rar.ve","rec.ve","store.ve","tec.ve","web.ve","vg","vi","co.vi","com.vi","k12.vi","net.vi","org.vi","vn","com.vn","net.vn","org.vn","edu.vn","gov.vn","int.vn","ac.vn","biz.vn","info.vn","name.vn","pro.vn","health.vn","vu","com.vu","edu.vu","net.vu","org.vu","wf","ws","com.ws","net.ws","org.ws","gov.ws","edu.ws","yt","\u0627\u0645\u0627\u0631\u0627\u062A","\u0570\u0561\u0575","\u09AC\u09BE\u0982\u09B2\u09BE","\u0431\u0433","\u0627\u0644\u0628\u062D\u0631\u064A\u0646","\u0431\u0435\u043B","\u4E2D\u56FD","\u4E2D\u570B","\u0627\u0644\u062C\u0632\u0627\u0626\u0631","\u0645\u0635\u0631","\u0435\u044E","\u03B5\u03C5","\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","\u10D2\u10D4","\u03B5\u03BB","\u9999\u6E2F","\u516C\u53F8.\u9999\u6E2F","\u6559\u80B2.\u9999\u6E2F","\u653F\u5E9C.\u9999\u6E2F","\u500B\u4EBA.\u9999\u6E2F","\u7DB2\u7D61.\u9999\u6E2F","\u7D44\u7E54.\u9999\u6E2F","\u0CAD\u0CBE\u0CB0\u0CA4","\u0B2D\u0B3E\u0B30\u0B24","\u09AD\u09BE\u09F0\u09A4","\u092D\u093E\u0930\u0924\u092E\u094D","\u092D\u093E\u0930\u094B\u0924","\u0680\u0627\u0631\u062A","\u0D2D\u0D3E\u0D30\u0D24\u0D02","\u092D\u093E\u0930\u0924","\u0628\u0627\u0631\u062A","\u0628\u06BE\u0627\u0631\u062A","\u0C2D\u0C3E\u0C30\u0C24\u0C4D","\u0AAD\u0ABE\u0AB0\u0AA4","\u0A2D\u0A3E\u0A30\u0A24","\u09AD\u09BE\u09B0\u09A4","\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE","\u0627\u06CC\u0631\u0627\u0646","\u0627\u064A\u0631\u0627\u0646","\u0639\u0631\u0627\u0642","\u0627\u0644\u0627\u0631\u062F\u0646","\uD55C\uAD6D","\u049B\u0430\u0437","\u0EA5\u0EB2\u0EA7","\u0DBD\u0D82\u0D9A\u0DCF","\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8","\u0627\u0644\u0645\u063A\u0631\u0628","\u043C\u043A\u0434","\u043C\u043E\u043D","\u6FB3\u9580","\u6FB3\u95E8","\u0645\u0644\u064A\u0633\u064A\u0627","\u0639\u0645\u0627\u0646","\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","\u067E\u0627\u0643\u0633\u062A\u0627\u0646","\u0641\u0644\u0633\u0637\u064A\u0646","\u0441\u0440\u0431","\u043F\u0440.\u0441\u0440\u0431","\u043E\u0440\u0433.\u0441\u0440\u0431","\u043E\u0431\u0440.\u0441\u0440\u0431","\u043E\u0434.\u0441\u0440\u0431","\u0443\u043F\u0440.\u0441\u0440\u0431","\u0430\u043A.\u0441\u0440\u0431","\u0440\u0444","\u0642\u0637\u0631","\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","\u0627\u0644\u0633\u0639\u0648\u062F\u06CC\u0629","\u0627\u0644\u0633\u0639\u0648\u062F\u06CC\u06C3","\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0647","\u0633\u0648\u062F\u0627\u0646","\u65B0\u52A0\u5761","\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD","\u0633\u0648\u0631\u064A\u0629","\u0633\u0648\u0631\u064A\u0627","\u0E44\u0E17\u0E22","\u0E28\u0E36\u0E01\u0E29\u0E32.\u0E44\u0E17\u0E22","\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08.\u0E44\u0E17\u0E22","\u0E23\u0E31\u0E10\u0E1A\u0E32\u0E25.\u0E44\u0E17\u0E22","\u0E17\u0E2B\u0E32\u0E23.\u0E44\u0E17\u0E22","\u0E40\u0E19\u0E47\u0E15.\u0E44\u0E17\u0E22","\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23.\u0E44\u0E17\u0E22","\u062A\u0648\u0646\u0633","\u53F0\u7063","\u53F0\u6E7E","\u81FA\u7063","\u0443\u043A\u0440","\u0627\u0644\u064A\u0645\u0646","xxx","ye","com.ye","edu.ye","gov.ye","net.ye","mil.ye","org.ye","ac.za","agric.za","alt.za","co.za","edu.za","gov.za","grondar.za","law.za","mil.za","net.za","ngo.za","nic.za","nis.za","nom.za","org.za","school.za","tm.za","web.za","zm","ac.zm","biz.zm","co.zm","com.zm","edu.zm","gov.zm","info.zm","mil.zm","net.zm","org.zm","sch.zm","zw","ac.zw","co.zw","gov.zw","mil.zw","org.zw","aaa","aarp","abarth","abb","abbott","abbvie","abc","able","abogado","abudhabi","academy","accenture","accountant","accountants","aco","actor","adac","ads","adult","aeg","aetna","afl","africa","agakhan","agency","aig","airbus","airforce","airtel","akdn","alfaromeo","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","aol","apartments","app","apple","aquarelle","arab","aramco","archi","army","art","arte","asda","associates","athleta","attorney","auction","audi","audible","audio","auspost","author","auto","autos","avianca","aws","axa","azure","baby","baidu","banamex","bananarepublic","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bbc","bbt","bbva","bcg","bcn","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bharti","bible","bid","bike","bing","bingo","bio","black","blackfriday","blockbuster","blog","bloomberg","blue","bms","bmw","bnpparibas","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","bradesco","bridgestone","broadway","broker","brother","brussels","bugatti","build","builders","business","buy","buzz","bzh","cab","cafe","cal","call","calvinklein","cam","camera","camp","cancerresearch","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","catering","catholic","cba","cbn","cbre","cbs","center","ceo","cern","cfa","cfd","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","cipriani","circle","cisco","citadel","citi","citic","city","cityeats","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","coach","codes","coffee","college","cologne","comcast","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cookingchannel","cool","corsica","country","coupon","coupons","courses","cpa","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cuisinella","cymru","cyou","dabur","dad","dance","data","date","dating","datsun","day","dclk","dds","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dnp","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","earth","eat","eco","edeka","education","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","ericsson","erni","esq","estate","etisalat","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fiat","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","flickr","flights","flir","florist","flowers","fly","foo","food","foodnetwork","football","ford","forex","forsale","forum","foundation","fox","free","fresenius","frl","frogans","frontdoor","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gbiz","gdn","gea","gent","genting","george","ggee","gift","gifts","gives","giving","glass","gle","global","globo","gmail","gmbh","gmo","gmx","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","grainger","graphics","gratis","green","gripe","grocery","group","guardian","gucci","guge","guide","guitars","guru","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hgtv","hiphop","hisamitsu","hitachi","hiv","hkt","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hoteles","hotels","hotmail","house","how","hsbc","hughes","hyatt","hyundai","ibm","icbc","ice","icu","ieee","ifm","ikano","imamat","imdb","immo","immobilien","inc","industries","infiniti","ing","ink","institute","insurance","insure","international","intuit","investments","ipiranga","irish","ismaili","ist","istanbul","itau","itv","jaguar","java","jcb","jeep","jetzt","jewelry","jio","jll","jmp","jnj","joburg","jot","joy","jpmorgan","jprs","juegos","juniper","kaufen","kddi","kerryhotels","kerrylogistics","kerryproperties","kfh","kia","kids","kim","kinder","kindle","kitchen","kiwi","koeln","komatsu","kosher","kpmg","kpn","krd","kred","kuokgroup","kyoto","lacaixa","lamborghini","lamer","lancaster","lancia","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","linde","link","lipsy","live","living","llc","llp","loan","loans","locker","locus","loft","lol","london","lotte","lotto","love","lpl","lplfinancial","ltd","ltda","lundbeck","luxe","luxury","macys","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","maserati","mattel","mba","mckinsey","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","miami","microsoft","mini","mint","mit","mitsubishi","mlb","mls","mma","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","msd","mtn","mtr","music","mutual","nab","nagoya","natura","navy","nba","nec","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nfl","ngo","nhk","nico","nike","nikon","ninja","nissan","nissay","nokia","northwesternmutual","norton","now","nowruz","nowtv","nra","nrw","ntt","nyc","obi","observer","office","okinawa","olayan","olayangroup","oldnavy","ollo","omega","one","ong","onl","online","ooo","open","oracle","orange","organic","origins","osaka","otsuka","ott","ovh","page","panasonic","paris","pars","partners","parts","party","passagens","pay","pccw","pet","pfizer","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","place","play","playstation","plumbing","plus","pnc","pohl","poker","politie","porn","pramerica","praxi","press","prime","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","pub","pwc","qpon","quebec","quest","racing","radio","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","rocher","rocks","rodeo","rogers","room","rsvp","rugby","ruhr","run","rwe","ryukyu","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sbi","sbs","sca","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","search","seat","secure","security","seek","select","sener","services","ses","seven","sew","sex","sexy","sfr","shangrila","sharp","shaw","shell","shia","shiksha","shoes","shop","shopping","shouji","show","showtime","silk","sina","singles","site","ski","skin","sky","skype","sling","smart","smile","sncf","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","srl","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","sucks","supplies","supply","support","surf","surgery","suzuki","swatch","swiss","sydney","systems","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tci","tdk","team","tech","technology","temasek","tennis","teva","thd","theater","theatre","tiaa","tickets","tienda","tiffany","tips","tires","tirol","tjmaxx","tjx","tkmaxx","tmall","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","trade","trading","training","travel","travelchannel","travelers","travelersinsurance","trust","trv","tube","tui","tunes","tushu","tvs","ubank","ubs","unicom","university","uno","uol","ups","vacations","vana","vanguard","vegas","ventures","verisign","versicherung","vet","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vodka","volkswagen","volvo","vote","voting","voto","voyage","vuelos","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wedding","weibo","weir","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","wtc","wtf","xbox","xerox","xfinity","xihuan","xin","\u0915\u0949\u092E","\u30BB\u30FC\u30EB","\u4F5B\u5C71","\u6148\u5584","\u96C6\u56E2","\u5728\u7EBF","\u70B9\u770B","\u0E04\u0E2D\u0E21","\u516B\u5366","\u0645\u0648\u0642\u0639","\u516C\u76CA","\u516C\u53F8","\u9999\u683C\u91CC\u62C9","\u7F51\u7AD9","\u79FB\u52A8","\u6211\u7231\u4F60","\u043C\u043E\u0441\u043A\u0432\u0430","\u043A\u0430\u0442\u043E\u043B\u0438\u043A","\u043E\u043D\u043B\u0430\u0439\u043D","\u0441\u0430\u0439\u0442","\u8054\u901A","\u05E7\u05D5\u05DD","\u65F6\u5C1A","\u5FAE\u535A","\u6DE1\u9A6C\u9521","\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","\u043E\u0440\u0433","\u0928\u0947\u091F","\u30B9\u30C8\u30A2","\u30A2\u30DE\u30BE\u30F3","\uC0BC\uC131","\u5546\u6807","\u5546\u5E97","\u5546\u57CE","\u0434\u0435\u0442\u0438","\u30DD\u30A4\u30F3\u30C8","\u65B0\u95FB","\u5BB6\u96FB","\u0643\u0648\u0645","\u4E2D\u6587\u7F51","\u4E2D\u4FE1","\u5A31\u4E50","\u8C37\u6B4C","\u96FB\u8A0A\u76C8\u79D1","\u8D2D\u7269","\u30AF\u30E9\u30A6\u30C9","\u901A\u8CA9","\u7F51\u5E97","\u0938\u0902\u0917\u0920\u0928","\u9910\u5385","\u7F51\u7EDC","\u043A\u043E\u043C","\u4E9A\u9A6C\u900A","\u8BFA\u57FA\u4E9A","\u98DF\u54C1","\u98DE\u5229\u6D66","\u624B\u673A","\u0627\u0631\u0627\u0645\u0643\u0648","\u0627\u0644\u0639\u0644\u064A\u0627\u0646","\u0627\u062A\u0635\u0627\u0644\u0627\u062A","\u0628\u0627\u0632\u0627\u0631","\u0627\u0628\u0648\u0638\u0628\u064A","\u0643\u0627\u062B\u0648\u0644\u064A\u0643","\u0647\u0645\u0631\u0627\u0647","\uB2F7\uCEF4","\u653F\u5E9C","\u0634\u0628\u0643\u0629","\u0628\u064A\u062A\u0643","\u0639\u0631\u0628","\u673A\u6784","\u7EC4\u7EC7\u673A\u6784","\u5065\u5EB7","\u62DB\u8058","\u0440\u0443\u0441","\u5927\u62FF","\u307F\u3093\u306A","\u30B0\u30FC\u30B0\u30EB","\u4E16\u754C","\u66F8\u7C4D","\u7F51\u5740","\uB2F7\uB137","\u30B3\u30E0","\u5929\u4E3B\u6559","\u6E38\u620F","verm\xf6gensberater","verm\xf6gensberatung","\u4F01\u4E1A","\u4FE1\u606F","\u5609\u91CC\u5927\u9152\u5E97","\u5609\u91CC","\u5E7F\u4E1C","\u653F\u52A1","xyz","yachts","yahoo","yamaxun","yandex","yodobashi","yoga","yokohama","you","youtube","yun","zappos","zara","zero","zip","zone","zuerich","cc.ua","inf.ua","ltd.ua","611.to","graphox.us","*.devcdnaccesso.com","adobeaemcloud.com","*.dev.adobeaemcloud.com","hlx.live","adobeaemcloud.net","hlx.page","hlx3.page","beep.pl","airkitapps.com","airkitapps-au.com","airkitapps.eu","aivencloud.com","barsy.ca","*.compute.estate","*.alces.network","kasserver.com","altervista.org","alwaysdata.net","cloudfront.net","*.compute.amazonaws.com","*.compute-1.amazonaws.com","*.compute.amazonaws.com.cn","us-east-1.amazonaws.com","cn-north-1.eb.amazonaws.com.cn","cn-northwest-1.eb.amazonaws.com.cn","elasticbeanstalk.com","ap-northeast-1.elasticbeanstalk.com","ap-northeast-2.elasticbeanstalk.com","ap-northeast-3.elasticbeanstalk.com","ap-south-1.elasticbeanstalk.com","ap-southeast-1.elasticbeanstalk.com","ap-southeast-2.elasticbeanstalk.com","ca-central-1.elasticbeanstalk.com","eu-central-1.elasticbeanstalk.com","eu-west-1.elasticbeanstalk.com","eu-west-2.elasticbeanstalk.com","eu-west-3.elasticbeanstalk.com","sa-east-1.elasticbeanstalk.com","us-east-1.elasticbeanstalk.com","us-east-2.elasticbeanstalk.com","us-gov-west-1.elasticbeanstalk.com","us-west-1.elasticbeanstalk.com","us-west-2.elasticbeanstalk.com","*.elb.amazonaws.com","*.elb.amazonaws.com.cn","awsglobalaccelerator.com","s3.amazonaws.com","s3-ap-northeast-1.amazonaws.com","s3-ap-northeast-2.amazonaws.com","s3-ap-south-1.amazonaws.com","s3-ap-southeast-1.amazonaws.com","s3-ap-southeast-2.amazonaws.com","s3-ca-central-1.amazonaws.com","s3-eu-central-1.amazonaws.com","s3-eu-west-1.amazonaws.com","s3-eu-west-2.amazonaws.com","s3-eu-west-3.amazonaws.com","s3-external-1.amazonaws.com","s3-fips-us-gov-west-1.amazonaws.com","s3-sa-east-1.amazonaws.com","s3-us-gov-west-1.amazonaws.com","s3-us-east-2.amazonaws.com","s3-us-west-1.amazonaws.com","s3-us-west-2.amazonaws.com","s3.ap-northeast-2.amazonaws.com","s3.ap-south-1.amazonaws.com","s3.cn-north-1.amazonaws.com.cn","s3.ca-central-1.amazonaws.com","s3.eu-central-1.amazonaws.com","s3.eu-west-2.amazonaws.com","s3.eu-west-3.amazonaws.com","s3.us-east-2.amazonaws.com","s3.dualstack.ap-northeast-1.amazonaws.com","s3.dualstack.ap-northeast-2.amazonaws.com","s3.dualstack.ap-south-1.amazonaws.com","s3.dualstack.ap-southeast-1.amazonaws.com","s3.dualstack.ap-southeast-2.amazonaws.com","s3.dualstack.ca-central-1.amazonaws.com","s3.dualstack.eu-central-1.amazonaws.com","s3.dualstack.eu-west-1.amazonaws.com","s3.dualstack.eu-west-2.amazonaws.com","s3.dualstack.eu-west-3.amazonaws.com","s3.dualstack.sa-east-1.amazonaws.com","s3.dualstack.us-east-1.amazonaws.com","s3.dualstack.us-east-2.amazonaws.com","s3-website-us-east-1.amazonaws.com","s3-website-us-west-1.amazonaws.com","s3-website-us-west-2.amazonaws.com","s3-website-ap-northeast-1.amazonaws.com","s3-website-ap-southeast-1.amazonaws.com","s3-website-ap-southeast-2.amazonaws.com","s3-website-eu-west-1.amazonaws.com","s3-website-sa-east-1.amazonaws.com","s3-website.ap-northeast-2.amazonaws.com","s3-website.ap-south-1.amazonaws.com","s3-website.ca-central-1.amazonaws.com","s3-website.eu-central-1.amazonaws.com","s3-website.eu-west-2.amazonaws.com","s3-website.eu-west-3.amazonaws.com","s3-website.us-east-2.amazonaws.com","t3l3p0rt.net","tele.amune.org","apigee.io","siiites.com","appspacehosted.com","appspaceusercontent.com","appudo.net","on-aptible.com","user.aseinet.ne.jp","gv.vc","d.gv.vc","user.party.eus","pimienta.org","poivron.org","potager.org","sweetpepper.org","myasustor.com","cdn.prod.atlassian-dev.net","translated.page","myfritz.net","onavstack.net","*.awdev.ca","*.advisor.ws","ecommerce-shop.pl","b-data.io","backplaneapp.io","balena-devices.com","rs.ba","*.banzai.cloud","app.banzaicloud.io","*.backyards.banzaicloud.io","base.ec","official.ec","buyshop.jp","fashionstore.jp","handcrafted.jp","kawaiishop.jp","supersale.jp","theshop.jp","shopselect.net","base.shop","*.beget.app","betainabox.com","bnr.la","bitbucket.io","blackbaudcdn.net","of.je","bluebite.io","boomla.net","boutir.com","boxfuse.io","square7.ch","bplaced.com","bplaced.de","square7.de","bplaced.net","square7.net","shop.brendly.rs","browsersafetymark.io","uk0.bigv.io","dh.bytemark.co.uk","vm.bytemark.co.uk","cafjs.com","mycd.eu","drr.ac","uwu.ai","carrd.co","crd.co","ju.mp","ae.org","br.com","cn.com","com.de","com.se","de.com","eu.com","gb.net","hu.net","jp.net","jpn.com","mex.com","ru.com","sa.com","se.net","uk.com","uk.net","us.com","za.bz","za.com","ar.com","hu.com","kr.com","no.com","qc.com","uy.com","africa.com","gr.com","in.net","web.in","us.org","co.com","aus.basketball","nz.basketball","radio.am","radio.fm","c.la","certmgr.org","cx.ua","discourse.group","discourse.team","cleverapps.io","clerk.app","clerkstage.app","*.lcl.dev","*.lclstage.dev","*.stg.dev","*.stgstage.dev","clickrising.net","c66.me","cloud66.ws","cloud66.zone","jdevcloud.com","wpdevcloud.com","cloudaccess.host","freesite.host","cloudaccess.net","cloudcontrolled.com","cloudcontrolapp.com","*.cloudera.site","pages.dev","trycloudflare.com","workers.dev","wnext.app","co.ca","*.otap.co","co.cz","c.cdn77.org","cdn77-ssl.net","r.cdn77.net","rsc.cdn77.org","ssl.origin.cdn77-secure.org","cloudns.asia","cloudns.biz","cloudns.club","cloudns.cc","cloudns.eu","cloudns.in","cloudns.info","cloudns.org","cloudns.pro","cloudns.pw","cloudns.us","cnpy.gdn","codeberg.page","co.nl","co.no","webhosting.be","hosting-cluster.nl","ac.ru","edu.ru","gov.ru","int.ru","mil.ru","test.ru","dyn.cosidns.de","dynamisches-dns.de","dnsupdater.de","internet-dns.de","l-o-g-i-n.de","dynamic-dns.info","feste-ip.net","knx-server.net","static-access.net","realm.cz","*.cryptonomic.net","cupcake.is","curv.dev","*.customer-oci.com","*.oci.customer-oci.com","*.ocp.customer-oci.com","*.ocs.customer-oci.com","cyon.link","cyon.site","fnwk.site","folionetwork.site","platform0.app","daplie.me","localhost.daplie.me","dattolocal.com","dattorelay.com","dattoweb.com","mydatto.com","dattolocal.net","mydatto.net","biz.dk","co.dk","firm.dk","reg.dk","store.dk","dyndns.dappnode.io","*.dapps.earth","*.bzz.dapps.earth","builtwithdark.com","demo.datadetect.com","instance.datadetect.com","edgestack.me","ddns5.com","debian.net","deno.dev","deno-staging.dev","dedyn.io","deta.app","deta.dev","*.rss.my.id","*.diher.solutions","discordsays.com","discordsez.com","jozi.biz","dnshome.de","online.th","shop.th","drayddns.com","shoparena.pl","dreamhosters.com","mydrobo.com","drud.io","drud.us","duckdns.org","bip.sh","bitbridge.net","dy.fi","tunk.org","dyndns-at-home.com","dyndns-at-work.com","dyndns-blog.com","dyndns-free.com","dyndns-home.com","dyndns-ip.com","dyndns-mail.com","dyndns-office.com","dyndns-pics.com","dyndns-remote.com","dyndns-server.com","dyndns-web.com","dyndns-wiki.com","dyndns-work.com","dyndns.biz","dyndns.info","dyndns.org","dyndns.tv","at-band-camp.net","ath.cx","barrel-of-knowledge.info","barrell-of-knowledge.info","better-than.tv","blogdns.com","blogdns.net","blogdns.org","blogsite.org","boldlygoingnowhere.org","broke-it.net","buyshouses.net","cechire.com","dnsalias.com","dnsalias.net","dnsalias.org","dnsdojo.com","dnsdojo.net","dnsdojo.org","does-it.net","doesntexist.com","doesntexist.org","dontexist.com","dontexist.net","dontexist.org","doomdns.com","doomdns.org","dvrdns.org","dyn-o-saur.com","dynalias.com","dynalias.net","dynalias.org","dynathome.net","dyndns.ws","endofinternet.net","endofinternet.org","endoftheinternet.org","est-a-la-maison.com","est-a-la-masion.com","est-le-patron.com","est-mon-blogueur.com","for-better.biz","for-more.biz","for-our.info","for-some.biz","for-the.biz","forgot.her.name","forgot.his.name","from-ak.com","from-al.com","from-ar.com","from-az.net","from-ca.com","from-co.net","from-ct.com","from-dc.com","from-de.com","from-fl.com","from-ga.com","from-hi.com","from-ia.com","from-id.com","from-il.com","from-in.com","from-ks.com","from-ky.com","from-la.net","from-ma.com","from-md.com","from-me.org","from-mi.com","from-mn.com","from-mo.com","from-ms.com","from-mt.com","from-nc.com","from-nd.com","from-ne.com","from-nh.com","from-nj.com","from-nm.com","from-nv.com","from-ny.net","from-oh.com","from-ok.com","from-or.com","from-pa.com","from-pr.com","from-ri.com","from-sc.com","from-sd.com","from-tn.com","from-tx.com","from-ut.com","from-va.com","from-vt.com","from-wa.com","from-wi.com","from-wv.com","from-wy.com","ftpaccess.cc","fuettertdasnetz.de","game-host.org","game-server.cc","getmyip.com","gets-it.net","go.dyndns.org","gotdns.com","gotdns.org","groks-the.info","groks-this.info","ham-radio-op.net","here-for-more.info","hobby-site.com","hobby-site.org","home.dyndns.org","homedns.org","homeftp.net","homeftp.org","homeip.net","homelinux.com","homelinux.net","homelinux.org","homeunix.com","homeunix.net","homeunix.org","iamallama.com","in-the-band.net","is-a-anarchist.com","is-a-blogger.com","is-a-bookkeeper.com","is-a-bruinsfan.org","is-a-bulls-fan.com","is-a-candidate.org","is-a-caterer.com","is-a-celticsfan.org","is-a-chef.com","is-a-chef.net","is-a-chef.org","is-a-conservative.com","is-a-cpa.com","is-a-cubicle-slave.com","is-a-democrat.com","is-a-designer.com","is-a-doctor.com","is-a-financialadvisor.com","is-a-geek.com","is-a-geek.net","is-a-geek.org","is-a-green.com","is-a-guru.com","is-a-hard-worker.com","is-a-hunter.com","is-a-knight.org","is-a-landscaper.com","is-a-lawyer.com","is-a-liberal.com","is-a-libertarian.com","is-a-linux-user.org","is-a-llama.com","is-a-musician.com","is-a-nascarfan.com","is-a-nurse.com","is-a-painter.com","is-a-patsfan.org","is-a-personaltrainer.com","is-a-photographer.com","is-a-player.com","is-a-republican.com","is-a-rockstar.com","is-a-socialist.com","is-a-soxfan.org","is-a-student.com","is-a-teacher.com","is-a-techie.com","is-a-therapist.com","is-an-accountant.com","is-an-actor.com","is-an-actress.com","is-an-anarchist.com","is-an-artist.com","is-an-engineer.com","is-an-entertainer.com","is-by.us","is-certified.com","is-found.org","is-gone.com","is-into-anime.com","is-into-cars.com","is-into-cartoons.com","is-into-games.com","is-leet.com","is-lost.org","is-not-certified.com","is-saved.org","is-slick.com","is-uberleet.com","is-very-bad.org","is-very-evil.org","is-very-good.org","is-very-nice.org","is-very-sweet.org","is-with-theband.com","isa-geek.com","isa-geek.net","isa-geek.org","isa-hockeynut.com","issmarterthanyou.com","isteingeek.de","istmein.de","kicks-ass.net","kicks-ass.org","knowsitall.info","land-4-sale.us","lebtimnetz.de","leitungsen.de","likes-pie.com","likescandy.com","merseine.nu","mine.nu","misconfused.org","mypets.ws","myphotos.cc","neat-url.com","office-on-the.net","on-the-web.tv","podzone.net","podzone.org","readmyblog.org","saves-the-whales.com","scrapper-site.net","scrapping.cc","selfip.biz","selfip.com","selfip.info","selfip.net","selfip.org","sells-for-less.com","sells-for-u.com","sells-it.net","sellsyourhome.org","servebbs.com","servebbs.net","servebbs.org","serveftp.net","serveftp.org","servegame.org","shacknet.nu","simple-url.com","space-to-rent.com","stuff-4-sale.org","stuff-4-sale.us","teaches-yoga.com","thruhere.net","traeumtgerade.de","webhop.biz","webhop.info","webhop.net","webhop.org","worse-than.tv","writesthisblog.com","ddnss.de","dyn.ddnss.de","dyndns.ddnss.de","dyndns1.de","dyn-ip24.de","home-webserver.de","dyn.home-webserver.de","myhome-server.de","ddnss.org","definima.net","definima.io","ondigitalocean.app","*.digitaloceanspaces.com","bci.dnstrace.pro","ddnsfree.com","ddnsgeek.com","giize.com","gleeze.com","kozow.com","loseyourip.com","ooguy.com","theworkpc.com","casacam.net","dynu.net","accesscam.org","camdvr.org","freeddns.org","mywire.org","webredirect.org","myddns.rocks","blogsite.xyz","dynv6.net","e4.cz","eero.online","eero-stage.online","elementor.cloud","elementor.cool","en-root.fr","mytuleap.com","tuleap-partners.com","encr.app","encoreapi.com","onred.one","staging.onred.one","eu.encoway.cloud","eu.org","al.eu.org","asso.eu.org","at.eu.org","au.eu.org","be.eu.org","bg.eu.org","ca.eu.org","cd.eu.org","ch.eu.org","cn.eu.org","cy.eu.org","cz.eu.org","de.eu.org","dk.eu.org","edu.eu.org","ee.eu.org","es.eu.org","fi.eu.org","fr.eu.org","gr.eu.org","hr.eu.org","hu.eu.org","ie.eu.org","il.eu.org","in.eu.org","int.eu.org","is.eu.org","it.eu.org","jp.eu.org","kr.eu.org","lt.eu.org","lu.eu.org","lv.eu.org","mc.eu.org","me.eu.org","mk.eu.org","mt.eu.org","my.eu.org","net.eu.org","ng.eu.org","nl.eu.org","no.eu.org","nz.eu.org","paris.eu.org","pl.eu.org","pt.eu.org","q-a.eu.org","ro.eu.org","ru.eu.org","se.eu.org","si.eu.org","sk.eu.org","tr.eu.org","uk.eu.org","us.eu.org","eurodir.ru","eu-1.evennode.com","eu-2.evennode.com","eu-3.evennode.com","eu-4.evennode.com","us-1.evennode.com","us-2.evennode.com","us-3.evennode.com","us-4.evennode.com","twmail.cc","twmail.net","twmail.org","mymailer.com.tw","url.tw","onfabrica.com","apps.fbsbx.com","ru.net","adygeya.ru","bashkiria.ru","bir.ru","cbg.ru","com.ru","dagestan.ru","grozny.ru","kalmykia.ru","kustanai.ru","marine.ru","mordovia.ru","msk.ru","mytis.ru","nalchik.ru","nov.ru","pyatigorsk.ru","spb.ru","vladikavkaz.ru","vladimir.ru","abkhazia.su","adygeya.su","aktyubinsk.su","arkhangelsk.su","armenia.su","ashgabad.su","azerbaijan.su","balashov.su","bashkiria.su","bryansk.su","bukhara.su","chimkent.su","dagestan.su","east-kazakhstan.su","exnet.su","georgia.su","grozny.su","ivanovo.su","jambyl.su","kalmykia.su","kaluga.su","karacol.su","karaganda.su","karelia.su","khakassia.su","krasnodar.su","kurgan.su","kustanai.su","lenug.su","mangyshlak.su","mordovia.su","msk.su","murmansk.su","nalchik.su","navoi.su","north-kazakhstan.su","nov.su","obninsk.su","penza.su","pokrovsk.su","sochi.su","spb.su","tashkent.su","termez.su","togliatti.su","troitsk.su","tselinograd.su","tula.su","tuva.su","vladikavkaz.su","vladimir.su","vologda.su","channelsdvr.net","u.channelsdvr.net","edgecompute.app","fastly-terrarium.com","fastlylb.net","map.fastlylb.net","freetls.fastly.net","map.fastly.net","a.prod.fastly.net","global.prod.fastly.net","a.ssl.fastly.net","b.ssl.fastly.net","global.ssl.fastly.net","fastvps-server.com","fastvps.host","myfast.host","fastvps.site","myfast.space","fedorainfracloud.org","fedorapeople.org","cloud.fedoraproject.org","app.os.fedoraproject.org","app.os.stg.fedoraproject.org","conn.uk","copro.uk","hosp.uk","mydobiss.com","fh-muenster.io","filegear.me","filegear-au.me","filegear-de.me","filegear-gb.me","filegear-ie.me","filegear-jp.me","filegear-sg.me","firebaseapp.com","fireweb.app","flap.id","onflashdrive.app","fldrv.com","fly.dev","edgeapp.net","shw.io","flynnhosting.net","forgeblocks.com","id.forgerock.io","framer.app","framercanvas.com","*.frusky.de","ravpage.co.il","0e.vc","freebox-os.com","freeboxos.com","fbx-os.fr","fbxos.fr","freebox-os.fr","freeboxos.fr","freedesktop.org","freemyip.com","wien.funkfeuer.at","*.futurecms.at","*.ex.futurecms.at","*.in.futurecms.at","futurehosting.at","futuremailing.at","*.ex.ortsinfo.at","*.kunden.ortsinfo.at","*.statics.cloud","independent-commission.uk","independent-inquest.uk","independent-inquiry.uk","independent-panel.uk","independent-review.uk","public-inquiry.uk","royal-commission.uk","campaign.gov.uk","service.gov.uk","api.gov.uk","gehirn.ne.jp","usercontent.jp","gentapps.com","gentlentapis.com","lab.ms","cdn-edges.net","ghost.io","gsj.bz","githubusercontent.com","githubpreview.dev","github.io","gitlab.io","gitapp.si","gitpage.si","glitch.me","nog.community","co.ro","shop.ro","lolipop.io","angry.jp","babyblue.jp","babymilk.jp","backdrop.jp","bambina.jp","bitter.jp","blush.jp","boo.jp","boy.jp","boyfriend.jp","but.jp","candypop.jp","capoo.jp","catfood.jp","cheap.jp","chicappa.jp","chillout.jp","chips.jp","chowder.jp","chu.jp","ciao.jp","cocotte.jp","coolblog.jp","cranky.jp","cutegirl.jp","daa.jp","deca.jp","deci.jp","digick.jp","egoism.jp","fakefur.jp","fem.jp","flier.jp","floppy.jp","fool.jp","frenchkiss.jp","girlfriend.jp","girly.jp","gloomy.jp","gonna.jp","greater.jp","hacca.jp","heavy.jp","her.jp","hiho.jp","hippy.jp","holy.jp","hungry.jp","icurus.jp","itigo.jp","jellybean.jp","kikirara.jp","kill.jp","kilo.jp","kuron.jp","littlestar.jp","lolipopmc.jp","lolitapunk.jp","lomo.jp","lovepop.jp","lovesick.jp","main.jp","mods.jp","mond.jp","mongolian.jp","moo.jp","namaste.jp","nikita.jp","nobushi.jp","noor.jp","oops.jp","parallel.jp","parasite.jp","pecori.jp","peewee.jp","penne.jp","pepper.jp","perma.jp","pigboat.jp","pinoko.jp","punyu.jp","pupu.jp","pussycat.jp","pya.jp","raindrop.jp","readymade.jp","sadist.jp","schoolbus.jp","secret.jp","staba.jp","stripper.jp","sub.jp","sunnyday.jp","thick.jp","tonkotsu.jp","under.jp","upper.jp","velvet.jp","verse.jp","versus.jp","vivian.jp","watson.jp","weblike.jp","whitesnow.jp","zombie.jp","heteml.net","cloudapps.digital","london.cloudapps.digital","pymnt.uk","homeoffice.gov.uk","ro.im","goip.de","run.app","a.run.app","web.app","*.0emm.com","appspot.com","*.r.appspot.com","codespot.com","googleapis.com","googlecode.com","pagespeedmobilizer.com","publishproxy.com","withgoogle.com","withyoutube.com","*.gateway.dev","cloud.goog","translate.goog","*.usercontent.goog","cloudfunctions.net","blogspot.ae","blogspot.al","blogspot.am","blogspot.ba","blogspot.be","blogspot.bg","blogspot.bj","blogspot.ca","blogspot.cf","blogspot.ch","blogspot.cl","blogspot.co.at","blogspot.co.id","blogspot.co.il","blogspot.co.ke","blogspot.co.nz","blogspot.co.uk","blogspot.co.za","blogspot.com","blogspot.com.ar","blogspot.com.au","blogspot.com.br","blogspot.com.by","blogspot.com.co","blogspot.com.cy","blogspot.com.ee","blogspot.com.eg","blogspot.com.es","blogspot.com.mt","blogspot.com.ng","blogspot.com.tr","blogspot.com.uy","blogspot.cv","blogspot.cz","blogspot.de","blogspot.dk","blogspot.fi","blogspot.fr","blogspot.gr","blogspot.hk","blogspot.hr","blogspot.hu","blogspot.ie","blogspot.in","blogspot.is","blogspot.it","blogspot.jp","blogspot.kr","blogspot.li","blogspot.lt","blogspot.lu","blogspot.md","blogspot.mk","blogspot.mr","blogspot.mx","blogspot.my","blogspot.nl","blogspot.no","blogspot.pe","blogspot.pt","blogspot.qa","blogspot.re","blogspot.ro","blogspot.rs","blogspot.ru","blogspot.se","blogspot.sg","blogspot.si","blogspot.sk","blogspot.sn","blogspot.td","blogspot.tw","blogspot.ug","blogspot.vn","goupile.fr","gov.nl","awsmppl.com","g\xfcnstigbestellen.de","g\xfcnstigliefern.de","fin.ci","free.hr","caa.li","ua.rs","conf.se","hs.zone","hs.run","hashbang.sh","hasura.app","hasura-app.io","pages.it.hs-heilbronn.de","hepforge.org","herokuapp.com","herokussl.com","ravendb.cloud","myravendb.com","ravendb.community","ravendb.me","development.run","ravendb.run","homesklep.pl","secaas.hk","hoplix.shop","orx.biz","biz.gl","col.ng","firm.ng","gen.ng","ltd.ng","ngo.ng","edu.scot","sch.so","hostyhosting.io","h\xe4kkinen.fi","*.moonscale.io","moonscale.net","iki.fi","ibxos.it","iliadboxos.it","impertrixcdn.com","impertrix.com","smushcdn.com","wphostedmail.com","wpmucdn.com","tempurl.host","wpmudev.host","dyn-berlin.de","in-berlin.de","in-brb.de","in-butter.de","in-dsl.de","in-dsl.net","in-dsl.org","in-vpn.de","in-vpn.net","in-vpn.org","biz.at","info.at","info.cx","ac.leg.br","al.leg.br","am.leg.br","ap.leg.br","ba.leg.br","ce.leg.br","df.leg.br","es.leg.br","go.leg.br","ma.leg.br","mg.leg.br","ms.leg.br","mt.leg.br","pa.leg.br","pb.leg.br","pe.leg.br","pi.leg.br","pr.leg.br","rj.leg.br","rn.leg.br","ro.leg.br","rr.leg.br","rs.leg.br","sc.leg.br","se.leg.br","sp.leg.br","to.leg.br","pixolino.com","na4u.ru","iopsys.se","ipifony.net","iservschule.de","mein-iserv.de","schulplattform.de","schulserver.de","test-iserv.de","iserv.dev","iobb.net","mel.cloudlets.com.au","cloud.interhostsolutions.be","users.scale.virtualcloud.com.br","mycloud.by","alp1.ae.flow.ch","appengine.flow.ch","es-1.axarnet.cloud","diadem.cloud","vip.jelastic.cloud","jele.cloud","it1.eur.aruba.jenv-aruba.cloud","it1.jenv-aruba.cloud","keliweb.cloud","cs.keliweb.cloud","oxa.cloud","tn.oxa.cloud","uk.oxa.cloud","primetel.cloud","uk.primetel.cloud","ca.reclaim.cloud","uk.reclaim.cloud","us.reclaim.cloud","ch.trendhosting.cloud","de.trendhosting.cloud","jele.club","amscompute.com","clicketcloud.com","dopaas.com","hidora.com","paas.hosted-by-previder.com","rag-cloud.hosteur.com","rag-cloud-ch.hosteur.com","jcloud.ik-server.com","jcloud-ver-jpc.ik-server.com","demo.jelastic.com","kilatiron.com","paas.massivegrid.com","jed.wafaicloud.com","lon.wafaicloud.com","ryd.wafaicloud.com","j.scaleforce.com.cy","jelastic.dogado.eu","fi.cloudplatform.fi","demo.datacenter.fi","paas.datacenter.fi","jele.host","mircloud.host","paas.beebyte.io","sekd1.beebyteapp.io","jele.io","cloud-fr1.unispace.io","jc.neen.it","cloud.jelastic.open.tim.it","jcloud.kz","upaas.kazteleport.kz","cloudjiffy.net","fra1-de.cloudjiffy.net","west1-us.cloudjiffy.net","jls-sto1.elastx.net","jls-sto2.elastx.net","jls-sto3.elastx.net","faststacks.net","fr-1.paas.massivegrid.net","lon-1.paas.massivegrid.net","lon-2.paas.massivegrid.net","ny-1.paas.massivegrid.net","ny-2.paas.massivegrid.net","sg-1.paas.massivegrid.net","jelastic.saveincloud.net","nordeste-idc.saveincloud.net","j.scaleforce.net","jelastic.tsukaeru.net","sdscloud.pl","unicloud.pl","mircloud.ru","jelastic.regruhosting.ru","enscaled.sg","jele.site","jelastic.team","orangecloud.tn","j.layershift.co.uk","phx.enscaled.us","mircloud.us","myjino.ru","*.hosting.myjino.ru","*.landing.myjino.ru","*.spectrum.myjino.ru","*.vps.myjino.ru","jotelulu.cloud","*.triton.zone","*.cns.joyent.com","js.org","kaas.gg","khplay.nl","ktistory.com","kapsi.fi","keymachine.de","kinghost.net","uni5.net","knightpoint.systems","koobin.events","oya.to","kuleuven.cloud","ezproxy.kuleuven.be","co.krd","edu.krd","krellian.net","webthings.io","git-repos.de","lcube-server.de","svn-repos.de","leadpages.co","lpages.co","lpusercontent.com","lelux.site","co.business","co.education","co.events","co.financial","co.network","co.place","co.technology","app.lmpm.com","linkyard.cloud","linkyard-cloud.ch","members.linode.com","*.nodebalancer.linode.com","*.linodeobjects.com","ip.linodeusercontent.com","we.bs","*.user.localcert.dev","localzone.xyz","loginline.app","loginline.dev","loginline.io","loginline.services","loginline.site","servers.run","lohmus.me","krasnik.pl","leczna.pl","lubartow.pl","lublin.pl","poniatowa.pl","swidnik.pl","glug.org.uk","lug.org.uk","lugs.org.uk","barsy.bg","barsy.co.uk","barsyonline.co.uk","barsycenter.com","barsyonline.com","barsy.club","barsy.de","barsy.eu","barsy.in","barsy.info","barsy.io","barsy.me","barsy.menu","barsy.mobi","barsy.net","barsy.online","barsy.org","barsy.pro","barsy.pub","barsy.ro","barsy.shop","barsy.site","barsy.support","barsy.uk","*.magentosite.cloud","mayfirst.info","mayfirst.org","hb.cldmail.ru","cn.vu","mazeplay.com","mcpe.me","mcdir.me","mcdir.ru","mcpre.ru","vps.mcdir.ru","mediatech.by","mediatech.dev","hra.health","miniserver.com","memset.net","messerli.app","*.cloud.metacentrum.cz","custom.metacentrum.cz","flt.cloud.muni.cz","usr.cloud.muni.cz","meteorapp.com","eu.meteorapp.com","co.pl","*.azurecontainer.io","azurewebsites.net","azure-mobile.net","cloudapp.net","azurestaticapps.net","1.azurestaticapps.net","centralus.azurestaticapps.net","eastasia.azurestaticapps.net","eastus2.azurestaticapps.net","westeurope.azurestaticapps.net","westus2.azurestaticapps.net","csx.cc","mintere.site","forte.id","mozilla-iot.org","bmoattachments.org","net.ru","org.ru","pp.ru","hostedpi.com","customer.mythic-beasts.com","caracal.mythic-beasts.com","fentiger.mythic-beasts.com","lynx.mythic-beasts.com","ocelot.mythic-beasts.com","oncilla.mythic-beasts.com","onza.mythic-beasts.com","sphinx.mythic-beasts.com","vs.mythic-beasts.com","x.mythic-beasts.com","yali.mythic-beasts.com","cust.retrosnub.co.uk","ui.nabu.casa","pony.club","of.fashion","in.london","of.london","from.marketing","with.marketing","for.men","repair.men","and.mom","for.mom","for.one","under.one","for.sale","that.win","from.work","to.work","cloud.nospamproxy.com","netlify.app","4u.com","ngrok.io","nh-serv.co.uk","nfshost.com","*.developer.app","noop.app","*.northflank.app","*.build.run","*.code.run","*.database.run","*.migration.run","noticeable.news","dnsking.ch","mypi.co","n4t.co","001www.com","ddnslive.com","myiphost.com","forumz.info","16-b.it","32-b.it","64-b.it","soundcast.me","tcp4.me","dnsup.net","hicam.net","now-dns.net","ownip.net","vpndns.net","dynserv.org","now-dns.org","x443.pw","now-dns.top","ntdll.top","freeddns.us","crafting.xyz","zapto.xyz","nsupdate.info","nerdpol.ovh","blogsyte.com","brasilia.me","cable-modem.org","ciscofreak.com","collegefan.org","couchpotatofries.org","damnserver.com","ddns.me","ditchyourip.com","dnsfor.me","dnsiskinky.com","dvrcam.info","dynns.com","eating-organic.net","fantasyleague.cc","geekgalaxy.com","golffan.us","health-carereform.com","homesecuritymac.com","homesecuritypc.com","hopto.me","ilovecollege.info","loginto.me","mlbfan.org","mmafan.biz","myactivedirectory.com","mydissent.net","myeffect.net","mymediapc.net","mypsx.net","mysecuritycamera.com","mysecuritycamera.net","mysecuritycamera.org","net-freaks.com","nflfan.org","nhlfan.net","no-ip.ca","no-ip.co.uk","no-ip.net","noip.us","onthewifi.com","pgafan.net","point2this.com","pointto.us","privatizehealthinsurance.net","quicksytes.com","read-books.org","securitytactics.com","serveexchange.com","servehumour.com","servep2p.com","servesarcasm.com","stufftoread.com","ufcfan.org","unusualperson.com","workisboring.com","3utilities.com","bounceme.net","ddns.net","ddnsking.com","gotdns.ch","hopto.org","myftp.biz","myftp.org","myvnc.com","no-ip.biz","no-ip.info","no-ip.org","noip.me","redirectme.net","servebeer.com","serveblog.net","servecounterstrike.com","serveftp.com","servegame.com","servehalflife.com","servehttp.com","serveirc.com","serveminecraft.net","servemp3.com","servepics.com","servequake.com","sytes.net","webhop.me","zapto.org","stage.nodeart.io","pcloud.host","nyc.mn","static.observableusercontent.com","cya.gg","omg.lol","cloudycluster.net","omniwe.site","service.one","nid.io","opensocial.site","opencraft.hosting","orsites.com","operaunite.com","tech.orange","authgear-staging.com","authgearapps.com","skygearapp.com","outsystemscloud.com","*.webpaas.ovh.net","*.hosting.ovh.net","ownprovider.com","own.pm","*.owo.codes","ox.rs","oy.lc","pgfog.com","pagefrontapp.com","pagexl.com","*.paywhirl.com","bar0.net","bar1.net","bar2.net","rdv.to","art.pl","gliwice.pl","krakow.pl","poznan.pl","wroc.pl","zakopane.pl","pantheonsite.io","gotpantheon.com","mypep.link","perspecta.cloud","lk3.ru","on-web.fr","bc.platform.sh","ent.platform.sh","eu.platform.sh","us.platform.sh","*.platformsh.site","*.tst.site","platter-app.com","platter-app.dev","platterp.us","pdns.page","plesk.page","pleskns.com","dyn53.io","onporter.run","co.bn","postman-echo.com","pstmn.io","mock.pstmn.io","httpbin.org","prequalifyme.today","xen.prgmr.com","priv.at","prvcy.page","*.dweb.link","protonet.io","chirurgiens-dentistes-en-france.fr","byen.site","pubtls.org","pythonanywhere.com","eu.pythonanywhere.com","qoto.io","qualifioapp.com","qbuser.com","cloudsite.builders","instances.spawn.cc","instantcloud.cn","ras.ru","qa2.com","qcx.io","*.sys.qcx.io","dev-myqnapcloud.com","alpha-myqnapcloud.com","myqnapcloud.com","*.quipelements.com","vapor.cloud","vaporcloud.io","rackmaze.com","rackmaze.net","g.vbrplsbx.io","*.on-k3s.io","*.on-rancher.cloud","*.on-rio.io","readthedocs.io","rhcloud.com","app.render.com","onrender.com","repl.co","id.repl.co","repl.run","resindevice.io","devices.resinstaging.io","hzc.io","wellbeingzone.eu","wellbeingzone.co.uk","adimo.co.uk","itcouldbewor.se","git-pages.rit.edu","rocky.page","\u0431\u0438\u0437.\u0440\u0443\u0441","\u043A\u043E\u043C.\u0440\u0443\u0441","\u043A\u0440\u044B\u043C.\u0440\u0443\u0441","\u043C\u0438\u0440.\u0440\u0443\u0441","\u043C\u0441\u043A.\u0440\u0443\u0441","\u043E\u0440\u0433.\u0440\u0443\u0441","\u0441\u0430\u043C\u0430\u0440\u0430.\u0440\u0443\u0441","\u0441\u043E\u0447\u0438.\u0440\u0443\u0441","\u0441\u043F\u0431.\u0440\u0443\u0441","\u044F.\u0440\u0443\u0441","*.builder.code.com","*.dev-builder.code.com","*.stg-builder.code.com","sandcats.io","logoip.de","logoip.com","fr-par-1.baremetal.scw.cloud","fr-par-2.baremetal.scw.cloud","nl-ams-1.baremetal.scw.cloud","fnc.fr-par.scw.cloud","functions.fnc.fr-par.scw.cloud","k8s.fr-par.scw.cloud","nodes.k8s.fr-par.scw.cloud","s3.fr-par.scw.cloud","s3-website.fr-par.scw.cloud","whm.fr-par.scw.cloud","priv.instances.scw.cloud","pub.instances.scw.cloud","k8s.scw.cloud","k8s.nl-ams.scw.cloud","nodes.k8s.nl-ams.scw.cloud","s3.nl-ams.scw.cloud","s3-website.nl-ams.scw.cloud","whm.nl-ams.scw.cloud","k8s.pl-waw.scw.cloud","nodes.k8s.pl-waw.scw.cloud","s3.pl-waw.scw.cloud","s3-website.pl-waw.scw.cloud","scalebook.scw.cloud","smartlabeling.scw.cloud","dedibox.fr","schokokeks.net","gov.scot","service.gov.scot","scrysec.com","firewall-gateway.com","firewall-gateway.de","my-gateway.de","my-router.de","spdns.de","spdns.eu","firewall-gateway.net","my-firewall.org","myfirewall.org","spdns.org","seidat.net","sellfy.store","senseering.net","minisite.ms","magnet.page","biz.ua","co.ua","pp.ua","shiftcrypto.dev","shiftcrypto.io","shiftedit.io","myshopblocks.com","myshopify.com","shopitsite.com","shopware.store","mo-siemens.io","1kapp.com","appchizi.com","applinzi.com","sinaapp.com","vipsinaapp.com","siteleaf.net","bounty-full.com","alpha.bounty-full.com","beta.bounty-full.com","small-web.org","vp4.me","try-snowplow.com","srht.site","stackhero-network.com","musician.io","novecore.site","static.land","dev.static.land","sites.static.land","storebase.store","vps-host.net","atl.jelastic.vps-host.net","njs.jelastic.vps-host.net","ric.jelastic.vps-host.net","playstation-cloud.com","apps.lair.io","*.stolos.io","spacekit.io","customer.speedpartner.de","myspreadshop.at","myspreadshop.com.au","myspreadshop.be","myspreadshop.ca","myspreadshop.ch","myspreadshop.com","myspreadshop.de","myspreadshop.dk","myspreadshop.es","myspreadshop.fi","myspreadshop.fr","myspreadshop.ie","myspreadshop.it","myspreadshop.net","myspreadshop.nl","myspreadshop.no","myspreadshop.pl","myspreadshop.se","myspreadshop.co.uk","api.stdlib.com","storj.farm","utwente.io","soc.srcf.net","user.srcf.net","temp-dns.com","supabase.co","supabase.in","supabase.net","su.paba.se","*.s5y.io","*.sensiosite.cloud","syncloud.it","dscloud.biz","direct.quickconnect.cn","dsmynas.com","familyds.com","diskstation.me","dscloud.me","i234.me","myds.me","synology.me","dscloud.mobi","dsmynas.net","familyds.net","dsmynas.org","familyds.org","vpnplus.to","direct.quickconnect.to","tabitorder.co.il","taifun-dns.de","beta.tailscale.net","ts.net","gda.pl","gdansk.pl","gdynia.pl","med.pl","sopot.pl","site.tb-hosting.com","edugit.io","s3.teckids.org","telebit.app","telebit.io","*.telebit.xyz","gwiddle.co.uk","*.firenet.ch","*.svc.firenet.ch","reservd.com","thingdustdata.com","cust.dev.thingdust.io","cust.disrec.thingdust.io","cust.prod.thingdust.io","cust.testing.thingdust.io","reservd.dev.thingdust.io","reservd.disrec.thingdust.io","reservd.testing.thingdust.io","tickets.io","arvo.network","azimuth.network","tlon.network","torproject.net","pages.torproject.net","bloxcms.com","townnews-staging.com","tbits.me","12hp.at","2ix.at","4lima.at","lima-city.at","12hp.ch","2ix.ch","4lima.ch","lima-city.ch","trafficplex.cloud","de.cool","12hp.de","2ix.de","4lima.de","lima-city.de","1337.pictures","clan.rip","lima-city.rocks","webspace.rocks","lima.zone","*.transurl.be","*.transurl.eu","*.transurl.nl","site.transip.me","tuxfamily.org","dd-dns.de","diskstation.eu","diskstation.org","dray-dns.de","draydns.de","dyn-vpn.de","dynvpn.de","mein-vigor.de","my-vigor.de","my-wan.de","syno-ds.de","synology-diskstation.de","synology-ds.de","typedream.app","pro.typeform.com","uber.space","*.uberspace.de","hk.com","hk.org","ltd.hk","inc.hk","name.pm","sch.tf","biz.wf","sch.wf","org.yt","virtualuser.de","virtual-user.de","upli.io","urown.cloud","dnsupdate.info","lib.de.us","2038.io","vercel.app","vercel.dev","now.sh","router.management","v-info.info","voorloper.cloud","neko.am","nyaa.am","be.ax","cat.ax","es.ax","eu.ax","gg.ax","mc.ax","us.ax","xy.ax","nl.ci","xx.gl","app.gp","blog.gt","de.gt","to.gt","be.gy","cc.hn","blog.kg","io.kg","jp.kg","tv.kg","uk.kg","us.kg","de.ls","at.md","de.md","jp.md","to.md","indie.porn","vxl.sh","ch.tc","me.tc","we.tc","nyan.to","at.vg","blog.vu","dev.vu","me.vu","v.ua","*.vultrobjects.com","wafflecell.com","*.webhare.dev","reserve-online.net","reserve-online.com","bookonline.app","hotelwithflight.com","wedeploy.io","wedeploy.me","wedeploy.sh","remotewd.com","pages.wiardweb.com","wmflabs.org","toolforge.org","wmcloud.org","panel.gg","daemon.panel.gg","messwithdns.com","woltlab-demo.com","myforum.community","community-pro.de","diskussionsbereich.de","community-pro.net","meinforum.net","affinitylottery.org.uk","raffleentry.org.uk","weeklylottery.org.uk","wpenginepowered.com","js.wpenginepowered.com","wixsite.com","editorx.io","half.host","xnbay.com","u2.xnbay.com","u2-local.xnbay.com","cistron.nl","demon.nl","xs4all.space","yandexcloud.net","storage.yandexcloud.net","website.yandexcloud.net","official.academy","yolasite.com","ybo.faith","yombo.me","homelink.one","ybo.party","ybo.review","ybo.science","ybo.trade","ynh.fr","nohost.me","noho.st","za.net","za.org","bss.design","basicserver.io","virtualserver.io","enterprisecloud.nu"]');

},{}],"cgCOH":[function(require,module,exports) {
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ "use strict";
/*jshint unused:false */ function Store() {}
exports.Store = Store;
// Stores may be synchronous, but are still required to use a
// Continuation-Passing Style API.  The CookieJar itself will expose a "*Sync"
// API that converts from synchronous-callbacks to imperative style.
Store.prototype.synchronous = false;
Store.prototype.findCookie = function(domain, path, key, cb) {
    throw new Error("findCookie is not implemented");
};
Store.prototype.findCookies = function(domain, path, cb) {
    throw new Error("findCookies is not implemented");
};
Store.prototype.putCookie = function(cookie, cb) {
    throw new Error("putCookie is not implemented");
};
Store.prototype.updateCookie = function(oldCookie, newCookie, cb) {
    // recommended default implementation:
    // return this.putCookie(newCookie, cb);
    throw new Error("updateCookie is not implemented");
};
Store.prototype.removeCookie = function(domain, path, key, cb) {
    throw new Error("removeCookie is not implemented");
};
Store.prototype.removeCookies = function(domain, path, cb) {
    throw new Error("removeCookies is not implemented");
};
Store.prototype.removeAllCookies = function(cb) {
    throw new Error("removeAllCookies is not implemented");
};
Store.prototype.getAllCookies = function(cb) {
    throw new Error("getAllCookies is not implemented (therefore jar cannot be serialized)");
};

},{}],"gJCsj":[function(require,module,exports) {
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ "use strict";
var Store = require("6c1baa97b08bd7df").Store;
var permuteDomain = require("4cad52a2d9826e").permuteDomain;
var pathMatch = require("2a038baf1559f723").pathMatch;
var util = require("9006ffa9fea958c9");
function MemoryCookieStore() {
    Store.call(this);
    this.idx = {};
}
util.inherits(MemoryCookieStore, Store);
exports.MemoryCookieStore = MemoryCookieStore;
MemoryCookieStore.prototype.idx = null;
// Since it's just a struct in RAM, this Store is synchronous
MemoryCookieStore.prototype.synchronous = true;
// force a default depth:
MemoryCookieStore.prototype.inspect = function() {
    return "{ idx: " + util.inspect(this.idx, false, 2) + " }";
};
// Use the new custom inspection symbol to add the custom inspect function if
// available.
if (util.inspect.custom) MemoryCookieStore.prototype[util.inspect.custom] = MemoryCookieStore.prototype.inspect;
MemoryCookieStore.prototype.findCookie = function(domain, path, key, cb) {
    if (!this.idx[domain]) return cb(null, undefined);
    if (!this.idx[domain][path]) return cb(null, undefined);
    return cb(null, this.idx[domain][path][key] || null);
};
MemoryCookieStore.prototype.findCookies = function(domain, path, cb) {
    var results = [];
    if (!domain) return cb(null, []);
    var pathMatcher;
    if (!path) // null means "all paths"
    pathMatcher = function matchAll(domainIndex) {
        for(var curPath in domainIndex){
            var pathIndex = domainIndex[curPath];
            for(var key in pathIndex)results.push(pathIndex[key]);
        }
    };
    else pathMatcher = function matchRFC(domainIndex) {
        //NOTE: we should use path-match algorithm from S5.1.4 here
        //(see : https://github.com/ChromiumWebApps/chromium/blob/b3d3b4da8bb94c1b2e061600df106d590fda3620/net/cookies/canonical_cookie.cc#L299)
        Object.keys(domainIndex).forEach(function(cookiePath) {
            if (pathMatch(path, cookiePath)) {
                var pathIndex = domainIndex[cookiePath];
                for(var key in pathIndex)results.push(pathIndex[key]);
            }
        });
    };
    var domains = permuteDomain(domain) || [
        domain
    ];
    var idx = this.idx;
    domains.forEach(function(curDomain) {
        var domainIndex = idx[curDomain];
        if (!domainIndex) return;
        pathMatcher(domainIndex);
    });
    cb(null, results);
};
MemoryCookieStore.prototype.putCookie = function(cookie, cb) {
    if (!this.idx[cookie.domain]) this.idx[cookie.domain] = {};
    if (!this.idx[cookie.domain][cookie.path]) this.idx[cookie.domain][cookie.path] = {};
    this.idx[cookie.domain][cookie.path][cookie.key] = cookie;
    cb(null);
};
MemoryCookieStore.prototype.updateCookie = function(oldCookie, newCookie, cb) {
    // updateCookie() may avoid updating cookies that are identical.  For example,
    // lastAccessed may not be important to some stores and an equality
    // comparison could exclude that field.
    this.putCookie(newCookie, cb);
};
MemoryCookieStore.prototype.removeCookie = function(domain, path, key, cb) {
    if (this.idx[domain] && this.idx[domain][path] && this.idx[domain][path][key]) delete this.idx[domain][path][key];
    cb(null);
};
MemoryCookieStore.prototype.removeCookies = function(domain, path, cb) {
    if (this.idx[domain]) {
        if (path) delete this.idx[domain][path];
        else delete this.idx[domain];
    }
    return cb(null);
};
MemoryCookieStore.prototype.removeAllCookies = function(cb) {
    this.idx = {};
    return cb(null);
};
MemoryCookieStore.prototype.getAllCookies = function(cb) {
    var cookies = [];
    var idx = this.idx;
    var domains = Object.keys(idx);
    domains.forEach(function(domain) {
        var paths = Object.keys(idx[domain]);
        paths.forEach(function(path) {
            var keys = Object.keys(idx[domain][path]);
            keys.forEach(function(key) {
                if (key !== null) cookies.push(idx[domain][path][key]);
            });
        });
    });
    // Sort by creationIndex so deserializing retains the creation order.
    // When implementing your own store, this SHOULD retain the order too
    cookies.sort(function(a, b) {
        return (a.creationIndex || 0) - (b.creationIndex || 0);
    });
    cb(null, cookies);
};

},{"6c1baa97b08bd7df":"cgCOH","4cad52a2d9826e":"9sdUx","2a038baf1559f723":"6PDj2","9006ffa9fea958c9":"dJawj"}],"9sdUx":[function(require,module,exports) {
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ "use strict";
var pubsuffix = require("6ee955b6d0acf6be");
// Gives the permutation of all possible domainMatch()es of a given domain. The
// array is in shortest-to-longest order.  Handy for indexing.
function permuteDomain(domain) {
    var pubSuf = pubsuffix.getPublicSuffix(domain);
    if (!pubSuf) return null;
    if (pubSuf == domain) return [
        domain
    ];
    var prefix = domain.slice(0, -(pubSuf.length + 1)); // ".example.com"
    var parts = prefix.split(".").reverse();
    var cur = pubSuf;
    var permutations = [
        cur
    ];
    while(parts.length){
        cur = parts.shift() + "." + cur;
        permutations.push(cur);
    }
    return permutations;
}
exports.permuteDomain = permuteDomain;

},{"6ee955b6d0acf6be":"iIpMI"}],"6PDj2":[function(require,module,exports) {
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ "use strict";
/*
 * "A request-path path-matches a given cookie-path if at least one of the
 * following conditions holds:"
 */ function pathMatch(reqPath, cookiePath) {
    // "o  The cookie-path and the request-path are identical."
    if (cookiePath === reqPath) return true;
    var idx = reqPath.indexOf(cookiePath);
    if (idx === 0) {
        // "o  The cookie-path is a prefix of the request-path, and the last
        // character of the cookie-path is %x2F ("/")."
        if (cookiePath.substr(-1) === "/") return true;
        // " o  The cookie-path is a prefix of the request-path, and the first
        // character of the request-path that is not included in the cookie- path
        // is a %x2F ("/") character."
        if (reqPath.substr(cookiePath.length, 1) === "/") return true;
    }
    return false;
}
exports.pathMatch = pathMatch;

},{}],"pSqMQ":[function(require,module,exports) {
// generated by genversion
module.exports = "2.5.0";

},{}],"8YYDt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ucs2decode", ()=>ucs2decode);
parcelHelpers.export(exports, "ucs2encode", ()=>ucs2encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "toASCII", ()=>toASCII);
parcelHelpers.export(exports, "toUnicode", ()=>toUnicode);
"use strict";
/** Highest positive signed 32-bit float value */ const maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const base = 36;
const tMin = 1;
const tMax = 26;
const skew = 38;
const damp = 700;
const initialBias = 72;
const initialN = 128; // 0x80
const delimiter = "-"; // '\x2D'
/** Regular expressions */ const regexPunycode = /^xn--/;
const regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const baseMinusTMin = base - tMin;
const floor = Math.floor;
const stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error(type) {
    throw new RangeError(errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace(regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = initialN;
    let bias = initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf(delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = base;; k += base){
            if (index >= inputLength) error("invalid-input");
            const digit = basicToDigit(input.charCodeAt(index++));
            if (digit >= base) error("invalid-input");
            if (digit > floor((maxInt - i) / w)) error("overflow");
            i += digit * w;
            const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = base - t;
            if (w > floor(maxInt / baseMinusT)) error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (floor(i / out) > maxInt - n) error("overflow");
        n += floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = initialN;
    let delta = 0;
    let bias = initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push(delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > maxInt) error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = base;; k += base){
                    const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = base - t;
                    output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = floor(qMinusT / baseMinusT);
                }
                output.push(stringFromCharCode(digitToBasic(q, 0)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const toUnicode = function(input) {
    return mapDomain(input, function(string) {
        return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const toASCII = function(input) {
    return mapDomain(input, function(string) {
        return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": ucs2decode,
        "encode": ucs2encode
    },
    "decode": decode,
    "encode": encode,
    "toASCII": toASCII,
    "toUnicode": toUnicode
};
exports.default = punycode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"gGFzH"}],"37SAC":[function(require,module,exports) {
var process = require("37e795493fa6a01e");
"use strict";
var jsonSafeStringify = require("980c674b28641542");
var crypto = require("3c9775cfdd9998a9");
var Buffer = require("a1c9602544db65de").Buffer;
var defer = typeof setImmediate === "undefined" ? process.nextTick : setImmediate;
function paramsHaveRequestBody(params) {
    return params.body || params.requestBodyStream || params.json && typeof params.json !== "boolean" || params.multipart;
}
function safeStringify(obj, replacer) {
    var ret;
    try {
        ret = JSON.stringify(obj, replacer);
    } catch (e) {
        ret = jsonSafeStringify(obj, replacer);
    }
    return ret;
}
function md5(str) {
    return crypto.createHash("md5").update(str).digest("hex");
}
function isReadStream(rs) {
    return rs.readable && rs.path && rs.mode;
}
function toBase64(str) {
    return Buffer.from(str || "", "utf8").toString("base64");
}
function copy(obj) {
    var o = {};
    Object.keys(obj).forEach(function(i) {
        o[i] = obj[i];
    });
    return o;
}
function version() {
    var numbers = process.version.replace("v", "").split(".");
    return {
        major: parseInt(numbers[0], 10),
        minor: parseInt(numbers[1], 10),
        patch: parseInt(numbers[2], 10)
    };
}
exports.paramsHaveRequestBody = paramsHaveRequestBody;
exports.safeStringify = safeStringify;
exports.md5 = md5;
exports.isReadStream = isReadStream;
exports.toBase64 = toBase64;
exports.copy = copy;
exports.version = version;
exports.defer = defer;

},{"37e795493fa6a01e":"g1F5c","980c674b28641542":"S2ouo","3c9775cfdd9998a9":"8Nkdo","a1c9602544db65de":"fFdLZ"}],"S2ouo":[function(require,module,exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

},{}],"8Nkdo":[function(require,module,exports) {
"use strict";
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require("9f84b01a6f751e2b");
exports.createHash = exports.Hash = require("6215218888164bf3");
exports.createHmac = exports.Hmac = require("41dc42cb22bbf5f8");
var algos = require("acce2639fd57a8ee");
var algoKeys = Object.keys(algos);
var hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat(algoKeys);
exports.getHashes = function() {
    return hashes;
};
var p = require("b26231bc996405c3");
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;
var aes = require("cd296f7efacbf3dd");
exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;
var dh = require("f35f6f689077fd07");
exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;
var sign = require("e955328ff9b7dd32");
exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;
exports.createECDH = require("84e3bfaa4f6c843e");
var publicEncrypt = require("eeb59405cf029b93");
exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;
// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })
var rf = require("327f527258516f60");
exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;
exports.createCredentials = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
exports.constants = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

},{"9f84b01a6f751e2b":"8WDPj","6215218888164bf3":"91an7","41dc42cb22bbf5f8":"lbjMj","acce2639fd57a8ee":"3nN6f","b26231bc996405c3":"2TSZp","cd296f7efacbf3dd":"m85ag","f35f6f689077fd07":"fiiCJ","e955328ff9b7dd32":"ixLS8","84e3bfaa4f6c843e":"7DrEx","eeb59405cf029b93":"hbYmR","327f527258516f60":"3ueHf"}],"8WDPj":[function(require,module,exports) {
var global = arguments[3];
var process = require("9f5c61be6bd9c67a");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295;
function oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}
var Buffer = require("caff9346743c214e").Buffer;
var crypto = global.crypto || global.msCrypto;
if (crypto && crypto.getRandomValues) module.exports = randomBytes;
else module.exports = oldBrowser;
function randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
        else crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return process.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

},{"9f5c61be6bd9c67a":"g1F5c","caff9346743c214e":"fFdLZ"}],"fFdLZ":[function(require,module,exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"8EcTH"}],"91an7":[function(require,module,exports) {
"use strict";
var inherits = require("45ce174cec337471");
var MD5 = require("4170b0039f3b4aab");
var RIPEMD160 = require("efcc6ede1fda4d98");
var sha = require("65b1a51ddac82548");
var Base = require("ac5a46c0f3b4d769");
function Hash(hash) {
    Base.call(this, "digest");
    this._hash = hash;
}
inherits(Hash, Base);
Hash.prototype._update = function(data) {
    this._hash.update(data);
};
Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new MD5();
    if (alg === "rmd160" || alg === "ripemd160") return new RIPEMD160();
    return new Hash(sha(alg));
};

},{"45ce174cec337471":"crNcs","4170b0039f3b4aab":"hfFmT","efcc6ede1fda4d98":"1oEgh","65b1a51ddac82548":"bM49V","ac5a46c0f3b4d769":"6Vxyz"}],"hfFmT":[function(require,module,exports) {
"use strict";
var inherits = require("634114d48656c754");
var HashBase = require("4b170874b4cb8d4e");
var Buffer = require("72d4e45c6a42a2da").Buffer;
var ARRAY16 = new Array(16);
function MD5() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
inherits(MD5, HashBase);
MD5.prototype._update = function() {
    var M = ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fnF(a, b, c, d, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function fnG(a, b, c, d, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function fnH(a, b, c, d, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function fnI(a, b, c, d, m, k, s) {
    return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = MD5;

},{"634114d48656c754":"crNcs","4b170874b4cb8d4e":"81YVG","72d4e45c6a42a2da":"fFdLZ"}],"81YVG":[function(require,module,exports) {
"use strict";
var Buffer = require("27eaec8a721206a5").Buffer;
var Transform = require("c9c4fcebe200e6bf").Transform;
var inherits = require("91e9fa68d440541e");
function throwIfNotStringOrBuffer(val, prefix) {
    if (!Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function HashBase(blockSize) {
    Transform.call(this);
    this._block = Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
inherits(HashBase, Transform);
HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype.update = function(data, encoding) {
    throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = HashBase;

},{"27eaec8a721206a5":"fFdLZ","c9c4fcebe200e6bf":"4ooMZ","91e9fa68d440541e":"crNcs"}],"4ooMZ":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"gB3zd","4a6ee9586f51c38d":"crNcs","e6206e1f4d20abc7":"70evq","a3f1405f37e1dfb1":"hOs1f","6691a72c5fc222fd":"gIBnJ","43a905ce7ec6ac9e":"dxfTN","dd715550d7783885":"6sJhB","d90a3520974ec96e":"crBYF","eb2779cfd287c5c9":"6Vf8B"}],"70evq":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("5cd4b65a2667f30e");
"use strict";
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("c152f2119aca4689").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("ee1c46a25703890d");
/*</replacement>*/ var Buffer = require("efffad1605c95e76").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("f6690d8cb5f89003");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("f8c4515e8234bd59");
var destroyImpl = require("2b842a435cfab72e");
var _require = require("6f90938893f80e4b"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("daceb54799edbc39").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("6b2730f2f68f00ce")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("d53c82af0b49f760");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("d53c82af0b49f760");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("746c700ae68bf97c");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7770a768738aeba9");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"5cd4b65a2667f30e":"g1F5c","c152f2119aca4689":"gB3zd","ee1c46a25703890d":"2N3Rs","efffad1605c95e76":"8EcTH","f6690d8cb5f89003":"49Rpi","f8c4515e8234bd59":"hQALF","2b842a435cfab72e":"ihMWV","6f90938893f80e4b":"4OJ2q","daceb54799edbc39":"hQnav","6b2730f2f68f00ce":"crNcs","d53c82af0b49f760":"gIBnJ","e7e497563ff3b269":"kuGw1","746c700ae68bf97c":"1aq5Q","7770a768738aeba9":"UzqhR"}],"2N3Rs":[function(require,module,exports) {
module.exports = require("256d09989820a7e9").EventEmitter;

},{"256d09989820a7e9":"gB3zd"}],"hQALF":[function(require,module,exports) {
"use strict";
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("56f983784a0fab6f"), Buffer = _require.Buffer;
var _require2 = require("95cdcc9e77389728"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || "inspect";
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"56f983784a0fab6f":"8EcTH","95cdcc9e77389728":"49Rpi"}],"ihMWV":[function(require,module,exports) {
var process = require("688ab6a28ddb436d");
"use strict";
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"688ab6a28ddb436d":"g1F5c"}],"4OJ2q":[function(require,module,exports) {
"use strict";
var ERR_INVALID_OPT_VALUE = require("4543c6055fd8382c").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4543c6055fd8382c":"hQnav"}],"hQnav":[function(require,module,exports) {
"use strict";
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
module.exports.codes = codes;

},{}],"gIBnJ":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("34d2aeaf352b4512");
"use strict";
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("7b75ce1e482a8dfb");
var Writable = require("fd2e3b6f36c506e9");
require("7dcb079aaf2f7ac6")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"34d2aeaf352b4512":"g1F5c","7b75ce1e482a8dfb":"70evq","fd2e3b6f36c506e9":"hOs1f","7dcb079aaf2f7ac6":"crNcs"}],"hOs1f":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("960325341c691095");
"use strict";
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("7d0952b2aab2880f")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("d4a8b8f0181be806");
/*</replacement>*/ var Buffer = require("329aa7fef0ab6df1").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("6a39a8b28b6e8ab4");
var _require = require("4b9079029d7ad85f"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("4d4d95a33057eaa").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("df23fd9c6d29b882")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("a02e72411207d1a6");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("a02e72411207d1a6");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"960325341c691095":"g1F5c","7d0952b2aab2880f":"75uxo","d4a8b8f0181be806":"2N3Rs","329aa7fef0ab6df1":"8EcTH","6a39a8b28b6e8ab4":"ihMWV","4b9079029d7ad85f":"4OJ2q","4d4d95a33057eaa":"hQnav","df23fd9c6d29b882":"crNcs","a02e72411207d1a6":"gIBnJ"}],"75uxo":[function(require,module,exports) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

},{}],"kuGw1":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

},{"2a29807c689a070a":"fFdLZ"}],"1aq5Q":[function(require,module,exports) {
var process = require("cc8bd4d851c0d480");
"use strict";
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("c70af6a403549764");
var kLastResolve = Symbol("lastResolve");
var kLastReject = Symbol("lastReject");
var kError = Symbol("error");
var kEnded = Symbol("ended");
var kLastPromise = Symbol("lastPromise");
var kHandlePromise = Symbol("handlePromise");
var kStream = Symbol("stream");
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on("readable", onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"cc8bd4d851c0d480":"g1F5c","c70af6a403549764":"crBYF"}],"crBYF":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var ERR_STREAM_PREMATURE_CLOSE = require("260b8c2ccb6493b7").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos(stream, opts, callback) {
    if (typeof opts === "function") return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = eos;

},{"260b8c2ccb6493b7":"hQnav"}],"UzqhR":[function(require,module,exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

},{}],"dxfTN":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var _require$codes = require("181e3ac8da6bd561").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("74feb8f76dae610a");
require("7382ff9fb3538488")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"181e3ac8da6bd561":"hQnav","74feb8f76dae610a":"gIBnJ","7382ff9fb3538488":"crNcs"}],"6sJhB":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("ef151ac5a8afeb5c");
require("ad2dd1617f55ad62")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"ef151ac5a8afeb5c":"dxfTN","ad2dd1617f55ad62":"crNcs"}],"6Vf8B":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("e9d469d31ac56495").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = require("96a756f22061fd7");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"e9d469d31ac56495":"hQnav","96a756f22061fd7":"crBYF"}],"1oEgh":[function(require,module,exports) {
"use strict";
var Buffer = require("c813c8075bcf823e").Buffer;
var inherits = require("84928993e7c3934b");
var HashBase = require("4b3519823770a56d");
var ARRAY16 = new Array(16);
var zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function RIPEMD160() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
inherits(RIPEMD160, HashBase);
RIPEMD160.prototype._update = function() {
    var words = ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
            tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
        } else if (i < 32) {
            tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
            tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
        } else if (i < 48) {
            tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
            tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
        } else if (i < 64) {
            tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
            tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
        } else {
            tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
            tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
        }
        al = el;
        el = dl;
        dl = rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fn1(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function fn2(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function fn3(a, b, c, d, e, m, k, s) {
    return rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function fn4(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function fn5(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = RIPEMD160;

},{"c813c8075bcf823e":"8EcTH","84928993e7c3934b":"crNcs","4b3519823770a56d":"81YVG"}],"bM49V":[function(require,module,exports) {
var exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};
exports.sha = require("54c9313943368ce2");
exports.sha1 = require("6e6f42e0b6fe29ef");
exports.sha224 = require("cefe70c6f9f68940");
exports.sha256 = require("3b4e2aa73bc3fef5");
exports.sha384 = require("be7da8b8e5a0fd78");
exports.sha512 = require("25610a4ba83316a4");

},{"54c9313943368ce2":"jkdQb","6e6f42e0b6fe29ef":"gr0QE","cefe70c6f9f68940":"c60zS","3b4e2aa73bc3fef5":"jt4oc","be7da8b8e5a0fd78":"kDWrk","25610a4ba83316a4":"j4DdY"}],"jkdQb":[function(require,module,exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ var inherits = require("55404b425acd1c6f");
var Hash = require("457bc9c7737d761f");
var Buffer = require("44759e57eb2992a").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha, Hash);
Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha;

},{"55404b425acd1c6f":"crNcs","457bc9c7737d761f":"7Ng37","44759e57eb2992a":"fFdLZ"}],"7Ng37":[function(require,module,exports) {
var Buffer = require("fe67468afd3c1b91").Buffer;
// prototype class for hash functions
function Hash(blockSize, finalSize) {
    this._block = Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = Hash;

},{"fe67468afd3c1b91":"fFdLZ"}],"gr0QE":[function(require,module,exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ var inherits = require("bf0dcaa2121c06d3");
var Hash = require("788f05b1f9753762");
var Buffer = require("ee7c2a3e649d259f").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha1() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha1, Hash);
Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl1(num) {
    return num << 1 | num >>> 31;
}
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha1.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha1;

},{"bf0dcaa2121c06d3":"crNcs","788f05b1f9753762":"7Ng37","ee7c2a3e649d259f":"fFdLZ"}],"c60zS":[function(require,module,exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("1759318dd61b32af");
var Sha256 = require("5a24a8ff4dc414f6");
var Hash = require("377596dd27739a66");
var Buffer = require("381289f917f16a20").Buffer;
var W = new Array(64);
function Sha224() {
    this.init();
    this._w = W // new Array(64)
    ;
    Hash.call(this, 64, 56);
}
inherits(Sha224, Sha256);
Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
Sha224.prototype._hash = function() {
    var H = Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = Sha224;

},{"1759318dd61b32af":"crNcs","5a24a8ff4dc414f6":"jt4oc","377596dd27739a66":"7Ng37","381289f917f16a20":"fFdLZ"}],"jt4oc":[function(require,module,exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("682a6716eeab42dd");
var Hash = require("f062bd789841a9ce");
var Buffer = require("1d47643a8adb8c1b").Buffer;
var K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var W = new Array(64);
function Sha256() {
    this.init();
    this._w = W // new Array(64)
    ;
    Hash.call(this, 64, 56);
}
inherits(Sha256, Hash);
Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + W[j] | 0;
        var T2 = sigma0(a) + maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
Sha256.prototype._hash = function() {
    var H = Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = Sha256;

},{"682a6716eeab42dd":"crNcs","f062bd789841a9ce":"7Ng37","1d47643a8adb8c1b":"fFdLZ"}],"kDWrk":[function(require,module,exports) {
var inherits = require("2a5cbb73fedd61b");
var SHA512 = require("fdb4d0946b31cdb5");
var Hash = require("50aa04d4bd2df0e1");
var Buffer = require("3d3bcc84ec383b74").Buffer;
var W = new Array(160);
function Sha384() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha384, SHA512);
Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
Sha384.prototype._hash = function() {
    var H = Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = Sha384;

},{"2a5cbb73fedd61b":"crNcs","fdb4d0946b31cdb5":"j4DdY","50aa04d4bd2df0e1":"7Ng37","3d3bcc84ec383b74":"fFdLZ"}],"j4DdY":[function(require,module,exports) {
var inherits = require("8d87c82d5ce5743");
var Hash = require("27d0146c4419ba93");
var Buffer = require("602d9c7256ca6bf7").Buffer;
var K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var W = new Array(160);
function Sha512() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha512, Hash);
Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = Gamma0(xh, xl);
        var gamma0l = Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = Gamma1(xh, xl);
        var gamma1l = Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = maj(ah, bh, ch);
        var majl = maj(al, bl, cl);
        var sigma0h = sigma0(ah, al);
        var sigma0l = sigma0(al, ah);
        var sigma1h = sigma1(eh, el);
        var sigma1l = sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = K[j];
        var Kil = K[j + 1];
        var chh = Ch(eh, fh, gh);
        var chl = Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
};
Sha512.prototype._hash = function() {
    var H = Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = Sha512;

},{"8d87c82d5ce5743":"crNcs","27d0146c4419ba93":"7Ng37","602d9c7256ca6bf7":"fFdLZ"}],"6Vxyz":[function(require,module,exports) {
var Buffer = require("631f7eb12d35b579").Buffer;
var Transform = require("5b378a2a05398c5").Transform;
var StringDecoder = require("d42da7de127e1c4b").StringDecoder;
var inherits = require("7a0f2f27fe0a389b");
function CipherBase(hashMode) {
    Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
inherits(CipherBase, Transform);
CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
CipherBase.prototype.setAutoPadding = function() {};
CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = CipherBase;

},{"631f7eb12d35b579":"fFdLZ","5b378a2a05398c5":"4ooMZ","d42da7de127e1c4b":"kuGw1","7a0f2f27fe0a389b":"crNcs"}],"lbjMj":[function(require,module,exports) {
"use strict";
var inherits = require("6a73c7c8ca6b61fa");
var Legacy = require("e1b443c27c833bc0");
var Base = require("7571755cc57fd60e");
var Buffer = require("b8ba1339feab1938").Buffer;
var md5 = require("c00fb3fd28cadeb2");
var RIPEMD160 = require("b7f8eae556813ec1");
var sha = require("40c5a912778271f7");
var ZEROS = Buffer.alloc(128);
function Hmac(alg, key) {
    Base.call(this, "digest");
    if (typeof key === "string") key = Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new RIPEMD160() : sha(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
    var opad = this._opad = Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new RIPEMD160() : sha(alg);
    this._hash.update(ipad);
}
inherits(Hmac, Base);
Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new RIPEMD160() : sha(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new Hmac("rmd160", key);
    if (alg === "md5") return new Legacy(md5, key);
    return new Hmac(alg, key);
};

},{"6a73c7c8ca6b61fa":"crNcs","e1b443c27c833bc0":"lnbQO","7571755cc57fd60e":"6Vxyz","b8ba1339feab1938":"fFdLZ","c00fb3fd28cadeb2":"cnbBp","b7f8eae556813ec1":"1oEgh","40c5a912778271f7":"bM49V"}],"lnbQO":[function(require,module,exports) {
"use strict";
var inherits = require("2baf2864ece10f11");
var Buffer = require("c7fb5e22d675c53c").Buffer;
var Base = require("8fdec7d6b96329ea");
var ZEROS = Buffer.alloc(128);
var blocksize = 64;
function Hmac(alg, key) {
    Base.call(this, "digest");
    if (typeof key === "string") key = Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) key = alg(key);
    else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
    var opad = this._opad = Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
inherits(Hmac, Base);
Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
Hmac.prototype._final = function() {
    var h = this._alg(Buffer.concat(this._hash));
    return this._alg(Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = Hmac;

},{"2baf2864ece10f11":"crNcs","c7fb5e22d675c53c":"fFdLZ","8fdec7d6b96329ea":"6Vxyz"}],"cnbBp":[function(require,module,exports) {
var MD5 = require("f07cc93582c49804");
module.exports = function(buffer) {
    return new MD5().update(buffer).digest();
};

},{"f07cc93582c49804":"hfFmT"}],"3nN6f":[function(require,module,exports) {
"use strict";
module.exports = require("b6a65ebe2480cb5a");

},{"b6a65ebe2480cb5a":"fS94Z"}],"fS94Z":[function(require,module,exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

},{}],"2TSZp":[function(require,module,exports) {
exports.pbkdf2 = require("50310b85983e4f32");
exports.pbkdf2Sync = require("5f7b0df9c2ef196d");

},{"50310b85983e4f32":"2Nqxw","5f7b0df9c2ef196d":"5KL6V"}],"2Nqxw":[function(require,module,exports) {
var global = arguments[3];
var Buffer = require("a1f6b66eddae53e0").Buffer;
var checkParameters = require("a915fb954a5b62ac");
var defaultEncoding = require("76b8747fb257c65c");
var sync = require("f6f43e3eaadd9ae9");
var toBuffer = require("d12cab846fc3f945");
var ZERO_BUF;
var subtle = global.crypto && global.crypto.subtle;
var toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var checks = [];
function checkNative(algo) {
    if (global.process && !global.process.browser) return Promise.resolve(false);
    if (!subtle || !subtle.importKey || !subtle.deriveBits) return Promise.resolve(false);
    if (checks[algo] !== undefined) return checks[algo];
    ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
    var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    checks[algo] = prom;
    return prom;
}
var nextTick;
function getNextTick() {
    if (nextTick) return nextTick;
    if (global.process && global.process.nextTick) nextTick = global.process.nextTick;
    else if (global.queueMicrotask) nextTick = global.queueMicrotask;
    else if (global.setImmediate) nextTick = global.setImmediate;
    else nextTick = global.setTimeout;
    return nextTick;
}
function browserPbkdf2(password, salt, iterations, length, algo) {
    return subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return Buffer.from(res);
    });
}
function resolvePromise(promise, callback) {
    promise.then(function(out) {
        getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = toBrowser[digest.toLowerCase()];
    if (!algo || typeof global.Promise !== "function") {
        getNextTick()(function() {
            var out;
            try {
                out = sync(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    checkParameters(iterations, keylen);
    password = toBuffer(password, defaultEncoding, "Password");
    salt = toBuffer(salt, defaultEncoding, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    resolvePromise(checkNative(algo).then(function(resp) {
        if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo);
        return sync(password, salt, iterations, keylen, digest);
    }), callback);
};

},{"a1f6b66eddae53e0":"fFdLZ","a915fb954a5b62ac":"kqqAC","76b8747fb257c65c":"er9uq","f6f43e3eaadd9ae9":"5KL6V","d12cab846fc3f945":"fDB9X"}],"kqqAC":[function(require,module,exports) {
var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

},{}],"er9uq":[function(require,module,exports) {
var global = arguments[3];
var process = require("6b9fe6b7a0bbf941");
var defaultEncoding;
/* istanbul ignore next */ if (global.process && global.process.browser) defaultEncoding = "utf-8";
else if (global.process && global.process.version) {
    var pVersionMajor = parseInt(process.version.split(".")[0].slice(1), 10);
    defaultEncoding = pVersionMajor >= 6 ? "utf-8" : "binary";
} else defaultEncoding = "utf-8";
module.exports = defaultEncoding;

},{"6b9fe6b7a0bbf941":"g1F5c"}],"5KL6V":[function(require,module,exports) {
var md5 = require("1e04e1c2d51cd13d");
var RIPEMD160 = require("42015ac33af139f8");
var sha = require("a7eb8e83614997ca");
var Buffer = require("290c92d9373f664d").Buffer;
var checkParameters = require("1b04775c4713da3d");
var defaultEncoding = require("b290a762e8475e9f");
var toBuffer = require("82c0eccfe5526b2c");
var ZEROS = Buffer.alloc(128);
var sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function Hmac(alg, key, saltLen) {
    var hash = getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = sizes[alg];
}
Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function getDigest(alg) {
    function shaFunc(data) {
        return sha(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new RIPEMD160().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return md5;
    return shaFunc;
}
function pbkdf2(password, salt, iterations, keylen, digest) {
    checkParameters(iterations, keylen);
    password = toBuffer(password, defaultEncoding, "Password");
    salt = toBuffer(salt, defaultEncoding, "Salt");
    digest = digest || "sha1";
    var hmac = new Hmac(digest, password, salt.length);
    var DK = Buffer.allocUnsafe(keylen);
    var block1 = Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = pbkdf2;

},{"1e04e1c2d51cd13d":"cnbBp","42015ac33af139f8":"1oEgh","a7eb8e83614997ca":"bM49V","290c92d9373f664d":"fFdLZ","1b04775c4713da3d":"kqqAC","b290a762e8475e9f":"er9uq","82c0eccfe5526b2c":"fDB9X"}],"fDB9X":[function(require,module,exports) {
var Buffer = require("cc6579c2e1506b6d").Buffer;
module.exports = function(thing, encoding, name) {
    if (Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

},{"cc6579c2e1506b6d":"fFdLZ"}],"m85ag":[function(require,module,exports) {
var DES = require("9fddd06e02c9f65f");
var aes = require("c080e0e074a10616");
var aesModes = require("deca4106fa6cf801");
var desModes = require("7141e0762da15af0");
var ebtk = require("ca278cb2f2d32ea3");
function createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if (aesModes[suite]) {
        keyLen = aesModes[suite].key;
        ivLen = aesModes[suite].iv;
    } else if (desModes[suite]) {
        keyLen = desModes[suite].key * 8;
        ivLen = desModes[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, keyLen, ivLen);
    return createCipheriv(suite, keys.key, keys.iv);
}
function createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if (aesModes[suite]) {
        keyLen = aesModes[suite].key;
        ivLen = aesModes[suite].iv;
    } else if (desModes[suite]) {
        keyLen = desModes[suite].key * 8;
        ivLen = desModes[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, keyLen, ivLen);
    return createDecipheriv(suite, keys.key, keys.iv);
}
function createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if (aesModes[suite]) return aes.createCipheriv(suite, key, iv);
    if (desModes[suite]) return new DES({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv);
    if (desModes[suite]) return new DES({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function getCiphers() {
    return Object.keys(desModes).concat(aes.getCiphers());
}
exports.createCipher = exports.Cipher = createCipher;
exports.createCipheriv = exports.Cipheriv = createCipheriv;
exports.createDecipher = exports.Decipher = createDecipher;
exports.createDecipheriv = exports.Decipheriv = createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

},{"9fddd06e02c9f65f":"1pAVR","c080e0e074a10616":"lgVfn","deca4106fa6cf801":"4SvXn","7141e0762da15af0":"cyDFf","ca278cb2f2d32ea3":"6Vk8I"}],"1pAVR":[function(require,module,exports) {
var CipherBase = require("4df025afd5a20f9f");
var des = require("8ea0942e2f125a3");
var inherits = require("8a7d640fedcdd788");
var Buffer = require("c9c674d2a2a092c4").Buffer;
var modes = {
    "des-ede3-cbc": des.CBC.instantiate(des.EDE),
    "des-ede3": des.EDE,
    "des-ede-cbc": des.CBC.instantiate(des.EDE),
    "des-ede": des.EDE,
    "des-cbc": des.CBC.instantiate(des.DES),
    "des-ecb": des.DES
};
modes.des = modes["des-cbc"];
modes.des3 = modes["des-ede3-cbc"];
module.exports = DES;
inherits(DES, CipherBase);
function DES(opts) {
    CipherBase.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!Buffer.isBuffer(key)) key = Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!Buffer.isBuffer(iv)) iv = Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
DES.prototype._update = function(data) {
    return Buffer.from(this._des.update(data));
};
DES.prototype._final = function() {
    return Buffer.from(this._des.final());
};

},{"4df025afd5a20f9f":"6Vxyz","8ea0942e2f125a3":"lcQQZ","8a7d640fedcdd788":"crNcs","c9c674d2a2a092c4":"fFdLZ"}],"lcQQZ":[function(require,module,exports) {
"use strict";
exports.utils = require("c56851640eb0e265");
exports.Cipher = require("22f0b7ac3b9c9316");
exports.DES = require("d0445787359f92a0");
exports.CBC = require("203ada8fdbbff440");
exports.EDE = require("736756ddbc573f7");

},{"c56851640eb0e265":"djP37","22f0b7ac3b9c9316":"60rtb","d0445787359f92a0":"bT1ri","203ada8fdbbff440":"4e5AW","736756ddbc573f7":"a7e1E"}],"djP37":[function(require,module,exports) {
"use strict";
exports.readUInt32BE = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
exports.ip = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.rip = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.pc1 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.r28shl = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
exports.pc2 = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> pc2table[i] & 0x1;
    }
    for(var i = len; i < pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.expand = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
exports.substitute = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
exports.permute = function permute(num) {
    var out = 0;
    for(var i = 0; i < permuteTable.length; i++){
        out <<= 1;
        out |= num >>> permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
exports.padSplit = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

},{}],"60rtb":[function(require,module,exports) {
"use strict";
var assert = require("85cfb697294fd1d8");
function Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = Cipher;
Cipher.prototype._init = function _init() {
// Might be overrided
};
Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    assert.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

},{"85cfb697294fd1d8":"gjnBW"}],"gjnBW":[function(require,module,exports) {
module.exports = assert;
function assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

},{}],"bT1ri":[function(require,module,exports) {
"use strict";
var assert = require("2e43e10aa2de50ed");
var inherits = require("551480b8aa09d318");
var utils = require("b6dc5b7926f5a82f");
var Cipher = require("38547d2f1967e2cd");
function DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function DES(options) {
    Cipher.call(this, options);
    var state = new DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;
DES.create = function create(options) {
    return new DES(options);
};
var shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    assert.equal(key.length, this.blockSize, "Invalid key length");
    var kL = utils.readUInt32BE(key, 0);
    var kR = utils.readUInt32BE(key, 4);
    utils.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = shiftTable[i >>> 1];
        kL = utils.r28shl(kL, shift);
        kR = utils.r28shl(kR, shift);
        utils.pc2(kL, kR, state.keys, i);
    }
};
DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = utils.readUInt32BE(inp, inOff);
    var r = utils.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    utils.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    utils.writeUInt32BE(out, l, outOff);
    utils.writeUInt32BE(out, r, outOff + 4);
};
DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)assert.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        utils.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = utils.substitute(keyL, keyR);
        var f = utils.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    utils.rip(r, l, out, off);
};
DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        utils.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = utils.substitute(keyL, keyR);
        var f = utils.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    utils.rip(l, r, out, off);
};

},{"2e43e10aa2de50ed":"gjnBW","551480b8aa09d318":"crNcs","b6dc5b7926f5a82f":"djP37","38547d2f1967e2cd":"60rtb"}],"4e5AW":[function(require,module,exports) {
"use strict";
var assert = require("63ac301527fc117b");
var inherits = require("7d48f4d3d39d3b86");
var proto = {};
function CBCState(iv) {
    assert.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    inherits(CBC, Base);
    var keys = Object.keys(proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
exports.instantiate = instantiate;
proto._cbcInit = function _cbcInit() {
    var state = new CBCState(this.options.iv);
    this._cbcState = state;
};
proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

},{"63ac301527fc117b":"gjnBW","7d48f4d3d39d3b86":"crNcs"}],"a7e1E":[function(require,module,exports) {
"use strict";
var assert = require("d5bfc55b5aa12c8d");
var inherits = require("39ce41101e752862");
var Cipher = require("ba2db61b5607fad4");
var DES = require("f13080dd5389ba87");
function EDEState(type, key) {
    assert.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        DES.create({
            type: "encrypt",
            key: k1
        }),
        DES.create({
            type: "decrypt",
            key: k2
        }),
        DES.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        DES.create({
            type: "decrypt",
            key: k3
        }),
        DES.create({
            type: "encrypt",
            key: k2
        }),
        DES.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function EDE(options) {
    Cipher.call(this, options);
    var state = new EDEState(this.type, this.options.key);
    this._edeState = state;
}
inherits(EDE, Cipher);
module.exports = EDE;
EDE.create = function create(options) {
    return new EDE(options);
};
EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"d5bfc55b5aa12c8d":"gjnBW","39ce41101e752862":"crNcs","ba2db61b5607fad4":"60rtb","f13080dd5389ba87":"bT1ri"}],"lgVfn":[function(require,module,exports) {
var ciphers = require("852cf53431a1f811");
var deciphers = require("cf65999dbb4c5e15");
var modes = require("deceb76ffb34f58f");
function getCiphers() {
    return Object.keys(modes);
}
exports.createCipher = exports.Cipher = ciphers.createCipher;
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv;
exports.createDecipher = exports.Decipher = deciphers.createDecipher;
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

},{"852cf53431a1f811":"22UYy","cf65999dbb4c5e15":"3vv7w","deceb76ffb34f58f":"ftL3G"}],"22UYy":[function(require,module,exports) {
var MODES = require("634015cf40a677fe");
var AuthCipher = require("ca7c032525082be8");
var Buffer = require("2bd35013f47d4062").Buffer;
var StreamCipher = require("2b03aae3a1335af6");
var Transform = require("138a78277ccfd16f");
var aes = require("cc8a1e2b2934f08f");
var ebtk = require("b149eab8b94068d4");
var inherits = require("ebc328fc178264d2");
function Cipher(mode, key, iv) {
    Transform.call(this);
    this._cache = new Splitter();
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
inherits(Cipher, Transform);
Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return Buffer.concat(out);
};
var PADDING = Buffer.alloc(16, 0x10);
Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals(PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function Splitter() {
    this.cache = Buffer.allocUnsafe(0);
}
Splitter.prototype.add = function(data) {
    this.cache = Buffer.concat([
        this.cache,
        data
    ]);
};
Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function createCipheriv(suite, password, iv) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new StreamCipher(config.module, password, iv);
    else if (config.type === "auth") return new AuthCipher(config.module, password, iv);
    return new Cipher(config.module, password, iv);
}
function createCipher(suite, password) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, config.key, config.iv);
    return createCipheriv(suite, keys.key, keys.iv);
}
exports.createCipheriv = createCipheriv;
exports.createCipher = createCipher;

},{"634015cf40a677fe":"4SvXn","ca7c032525082be8":"6SZW8","2bd35013f47d4062":"fFdLZ","2b03aae3a1335af6":"bBxN4","138a78277ccfd16f":"6Vxyz","cc8a1e2b2934f08f":"7MIpr","b149eab8b94068d4":"6Vk8I","ebc328fc178264d2":"crNcs"}],"4SvXn":[function(require,module,exports) {
var modeModules = {
    ECB: require("c49ddaf3154fac1e"),
    CBC: require("7c781e2d9206f623"),
    CFB: require("12dfbd130b5827a1"),
    CFB8: require("ae02434166690767"),
    CFB1: require("15ddc45cf76ec123"),
    OFB: require("62e3e290f0879f98"),
    CTR: require("1e6578fa70b860a7"),
    GCM: require("1e6578fa70b860a7")
};
var modes = require("b313067770c9aed2");
for(var key in modes)modes[key].module = modeModules[modes[key].mode];
module.exports = modes;

},{"c49ddaf3154fac1e":"fYDAh","7c781e2d9206f623":"imp5c","12dfbd130b5827a1":"9kttc","ae02434166690767":"a2oyo","15ddc45cf76ec123":"cy2cp","62e3e290f0879f98":"fuSu9","1e6578fa70b860a7":"9I58r","b313067770c9aed2":"ftL3G"}],"fYDAh":[function(require,module,exports) {
exports.encrypt = function(self, block) {
    return self._cipher.encryptBlock(block);
};
exports.decrypt = function(self, block) {
    return self._cipher.decryptBlock(block);
};

},{}],"imp5c":[function(require,module,exports) {
var xor = require("587e692127ea2c31");
exports.encrypt = function(self, block) {
    var data = xor(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
exports.decrypt = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return xor(out, pad);
};

},{"587e692127ea2c31":"ecPdu"}],"ecPdu":[function(require,module,exports) {
var Buffer = require("ccae1b11eb3a9ec8").Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

},{"ccae1b11eb3a9ec8":"8EcTH"}],"9kttc":[function(require,module,exports) {
var Buffer = require("7747ec7a535c746a").Buffer;
var xor = require("fe4415d84c8f2a05");
function encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = xor(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
exports.encrypt = function(self, data, decrypt) {
    var out = Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = Buffer.concat([
                out,
                encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = Buffer.concat([
                out,
                encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

},{"7747ec7a535c746a":"fFdLZ","fe4415d84c8f2a05":"ecPdu"}],"a2oyo":[function(require,module,exports) {
var Buffer = require("36c8b61b54eac90b").Buffer;
function encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = Buffer.concat([
        self._prev.slice(1),
        Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
exports.encrypt = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = encryptByte(self, chunk[i], decrypt);
    return out;
};

},{"36c8b61b54eac90b":"fFdLZ"}],"cy2cp":[function(require,module,exports) {
var Buffer = require("5eb46e1eefd15734").Buffer;
function encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = Buffer.allocUnsafe(buffer.length);
    buffer = Buffer.concat([
        buffer,
        Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
exports.encrypt = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = encryptByte(self, chunk[i], decrypt);
    return out;
};

},{"5eb46e1eefd15734":"fFdLZ"}],"fuSu9":[function(require,module,exports) {
var Buffer = require("b3ff65e516d49ef1").Buffer;
var xor = require("7f0c2ff10cf58835");
function getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
exports.encrypt = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = Buffer.concat([
        self._cache,
        getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return xor(chunk, pad);
};

},{"b3ff65e516d49ef1":"8EcTH","7f0c2ff10cf58835":"ecPdu"}],"9I58r":[function(require,module,exports) {
var xor = require("9e40d7dfdb715c7");
var Buffer = require("53cb1eb6f102a1c9").Buffer;
var incr32 = require("57780b841d591d93");
function getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    incr32(self._prev);
    return out;
}
var blockSize = 16;
exports.encrypt = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / blockSize);
    var start = self._cache.length;
    self._cache = Buffer.concat([
        self._cache,
        Buffer.allocUnsafe(chunkNum * blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = getBlock(self);
        var offset = start + i * blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return xor(chunk, pad);
};

},{"9e40d7dfdb715c7":"ecPdu","53cb1eb6f102a1c9":"fFdLZ","57780b841d591d93":"gGOLi"}],"gGOLi":[function(require,module,exports) {
function incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = incr32;

},{}],"ftL3G":[function(require,module,exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

},{}],"6SZW8":[function(require,module,exports) {
var aes = require("b0edcf3ce18ae4ef");
var Buffer = require("2c8f7ba691c38788").Buffer;
var Transform = require("1432783a1879aa01");
var inherits = require("60e0d0bfceaaf739");
var GHASH = require("f76de0f4100ad13f");
var xor = require("a9c82903acf3978e");
var incr32 = require("4e429278132497a7");
function xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = Buffer.concat([
            iv,
            Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return Buffer.concat([
            iv,
            Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new GHASH(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update(Buffer.alloc(toPad, 0));
    }
    ghash.update(Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = Buffer.from(self._finID);
    incr32(out);
    return out;
}
function StreamCipher(mode, key, iv, decrypt) {
    Transform.call(this);
    var h = Buffer.alloc(4, 0);
    this._cipher = new aes.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new GHASH(ck);
    iv = calcIv(this, iv, ck);
    this._prev = Buffer.from(iv);
    this._cache = Buffer.allocUnsafe(0);
    this._secCache = Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
inherits(StreamCipher, Transform);
StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = StreamCipher;

},{"b0edcf3ce18ae4ef":"7MIpr","2c8f7ba691c38788":"fFdLZ","1432783a1879aa01":"6Vxyz","60e0d0bfceaaf739":"crNcs","f76de0f4100ad13f":"8qZMZ","a9c82903acf3978e":"ecPdu","4e429278132497a7":"gGOLi"}],"7MIpr":[function(require,module,exports) {
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var Buffer = require("9c4f04f75f375be").Buffer;
function asUInt32Array(buf) {
    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function AES(key) {
    this._key = asUInt32Array(key);
    this._reset();
}
AES.blockSize = 16;
AES.keySize = 32;
AES.prototype.blockSize = AES.blockSize;
AES.prototype.keySize = AES.keySize;
AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
            t ^= RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[tt >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[tt >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
AES.prototype.encryptBlockRaw = function(M) {
    M = asUInt32Array(M);
    return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds);
};
AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
AES.prototype.decryptBlock = function(M) {
    M = asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds);
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
AES.prototype.scrub = function() {
    scrubVec(this._keySchedule);
    scrubVec(this._invKeySchedule);
    scrubVec(this._key);
};
module.exports.AES = AES;

},{"9c4f04f75f375be":"fFdLZ"}],"8qZMZ":[function(require,module,exports) {
var Buffer = require("815beeecbe039d1a").Buffer;
var ZEROES = Buffer.alloc(16, 0);
function toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function fromArray(out) {
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function GHASH(key) {
    this.h = key;
    this.state = Buffer.alloc(16, 0);
    this.cache = Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
GHASH.prototype._multiply = function() {
    var Vi = toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = fromArray(Zi);
};
GHASH.prototype.update = function(buf) {
    this.cache = Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash(Buffer.concat([
        this.cache,
        ZEROES
    ], 16));
    this.ghash(fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = GHASH;

},{"815beeecbe039d1a":"fFdLZ"}],"bBxN4":[function(require,module,exports) {
var aes = require("499d62308d7dac40");
var Buffer = require("bc4a1f7113303d58").Buffer;
var Transform = require("e701745abb80bc49");
var inherits = require("3765f10ec3d7a831");
function StreamCipher(mode, key, iv, decrypt) {
    Transform.call(this);
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._cache = Buffer.allocUnsafe(0);
    this._secCache = Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
inherits(StreamCipher, Transform);
StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = StreamCipher;

},{"499d62308d7dac40":"7MIpr","bc4a1f7113303d58":"fFdLZ","e701745abb80bc49":"6Vxyz","3765f10ec3d7a831":"crNcs"}],"6Vk8I":[function(require,module,exports) {
var Buffer = require("adb33291e0f9c65a").Buffer;
var MD5 = require("15f984dc9e3797d9");
/* eslint-disable camelcase */ function EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!Buffer.isBuffer(password)) password = Buffer.from(password, "binary");
    if (salt) {
        if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = Buffer.alloc(keyLen);
    var iv = Buffer.alloc(ivLen || 0);
    var tmp = Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new MD5();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = EVP_BytesToKey;

},{"adb33291e0f9c65a":"fFdLZ","15f984dc9e3797d9":"hfFmT"}],"3vv7w":[function(require,module,exports) {
var AuthCipher = require("2f5914bdcee0aab2");
var Buffer = require("2eedc5cbfd1eafeb").Buffer;
var MODES = require("2b861a45e2a2d1fe");
var StreamCipher = require("54b6d333d74ae9c8");
var Transform = require("4b438dd1327af64e");
var aes = require("928aea47daff81dc");
var ebtk = require("25542df8da1646fe");
var inherits = require("153b885d89d2089e");
function Decipher(mode, key, iv) {
    Transform.call(this);
    this._cache = new Splitter();
    this._last = void 0;
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
inherits(Decipher, Transform);
Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return Buffer.concat(out);
};
Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function Splitter() {
    this.cache = Buffer.allocUnsafe(0);
}
Splitter.prototype.add = function(data) {
    this.cache = Buffer.concat([
        this.cache,
        data
    ]);
};
Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function createDecipheriv(suite, password, iv) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new StreamCipher(config.module, password, iv, true);
    else if (config.type === "auth") return new AuthCipher(config.module, password, iv, true);
    return new Decipher(config.module, password, iv);
}
function createDecipher(suite, password) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, config.key, config.iv);
    return createDecipheriv(suite, keys.key, keys.iv);
}
exports.createDecipher = createDecipher;
exports.createDecipheriv = createDecipheriv;

},{"2f5914bdcee0aab2":"6SZW8","2eedc5cbfd1eafeb":"fFdLZ","2b861a45e2a2d1fe":"4SvXn","54b6d333d74ae9c8":"bBxN4","4b438dd1327af64e":"6Vxyz","928aea47daff81dc":"7MIpr","25542df8da1646fe":"6Vk8I","153b885d89d2089e":"crNcs"}],"cyDFf":[function(require,module,exports) {
exports["des-ecb"] = {
    key: 8,
    iv: 0
};
exports["des-cbc"] = exports.des = {
    key: 8,
    iv: 8
};
exports["des-ede3-cbc"] = exports.des3 = {
    key: 24,
    iv: 8
};
exports["des-ede3"] = {
    key: 24,
    iv: 0
};
exports["des-ede-cbc"] = {
    key: 16,
    iv: 8
};
exports["des-ede"] = {
    key: 16,
    iv: 0
};

},{}],"fiiCJ":[function(require,module,exports) {
var Buffer = require("55a084ce1a29baa3").Buffer;
var generatePrime = require("5ed99cf028c947ad");
var primes = require("8da23ed5d7edf952");
var DH = require("981b8db942febaf3");
function getDiffieHellman(mod) {
    var prime = new Buffer(primes[mod].prime, "hex");
    var gen = new Buffer(primes[mod].gen, "hex");
    return new DH(prime, gen);
}
var ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function createDiffieHellman(prime, enc, generator, genc) {
    if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) return createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new Buffer([
        2
    ]);
    if (!Buffer.isBuffer(generator)) generator = new Buffer(generator, genc);
    if (typeof prime === "number") return new DH(generatePrime(prime, generator), generator, true);
    if (!Buffer.isBuffer(prime)) prime = new Buffer(prime, enc);
    return new DH(prime, generator, true);
}
exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman;
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman;

},{"55a084ce1a29baa3":"8EcTH","5ed99cf028c947ad":"kY6oB","8da23ed5d7edf952":"b8UN2","981b8db942febaf3":"jZwiH"}],"kY6oB":[function(require,module,exports) {
var randomBytes = require("e11b752ebf414e01");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require("6139735ee181267b");
var TWENTYFOUR = new BN(24);
var MillerRabin = require("7b3f73f9ab7b2b6a");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;
function _getPrimes() {
    if (primes !== null) return primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    primes = res;
    return res;
}
function simpleSieve(p) {
    var primes = _getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function fermatTest(p) {
    var red = BN.mont(p);
    return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new BN([
            0x8c,
            0x7b
        ]);
        else return new BN([
            0x8c,
            0x27
        ]);
    }
    gen = new BN(gen);
    var num, n2;
    while(true){
        num = new BN(randomBytes(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd(ONE);
        if (!num.testn(1)) num.iadd(TWO);
        if (!gen.cmp(TWO)) while(num.mod(TWENTYFOUR).cmp(ELEVEN))num.iadd(FOUR);
        else if (!gen.cmp(FIVE)) while(num.mod(TEN).cmp(THREE))num.iadd(FOUR);
        n2 = num.shrn(1);
        if (simpleSieve(n2) && simpleSieve(num) && fermatTest(n2) && fermatTest(num) && millerRabin.test(n2) && millerRabin.test(num)) return num;
    }
}

},{"e11b752ebf414e01":"8WDPj","6139735ee181267b":"3Q6jJ","7b3f73f9ab7b2b6a":"gfiGl"}],"3Q6jJ":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("a4b3a214327293bc").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"a4b3a214327293bc":"49Rpi"}],"gfiGl":[function(require,module,exports) {
var bn = require("31d279a7646d17e9");
var brorand = require("1ed277e13aa258c6");
function MillerRabin(rand) {
    this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;
MillerRabin.create = function create(rand) {
    return new MillerRabin(rand);
};
MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new bn(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = bn.mont(n);
    var rone = new bn(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new bn(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = bn.mont(n);
    var rone = new bn(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new bn(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

},{"31d279a7646d17e9":"2XCAP","1ed277e13aa258c6":"fInqZ"}],"2XCAP":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1a01f12e7676c433").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1a01f12e7676c433":"49Rpi"}],"fInqZ":[function(require,module,exports) {
var r;
module.exports = function rand(len) {
    if (!r) r = new Rand(null);
    return r.generate(len);
};
function Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = Rand;
Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};
if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var crypto = require("e8ad0674730919a8");
    if (typeof crypto.randomBytes !== "function") throw new Error("Not supported");
    Rand.prototype._rand = function _rand(n) {
        return crypto.randomBytes(n);
    };
} catch (e) {}

},{"e8ad0674730919a8":"49Rpi"}],"b8UN2":[function(require,module,exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}}');

},{}],"jZwiH":[function(require,module,exports) {
var Buffer = require("18c258c24cda4205").Buffer;
var BN = require("6cfaed55db270425");
var MillerRabin = require("8bc0d9823ee74460");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require("dd39d03f4b3404fc");
var randomBytes = require("e2757e55299a3ebc");
module.exports = DH;
function setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(pub)) pub = new Buffer(pub, enc);
    this._pub = new BN(pub);
    return this;
}
function setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(priv)) priv = new Buffer(priv, enc);
    this._priv = new BN(priv);
    return this;
}
var primeCache = {};
function checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in primeCache) return primeCache[hex];
    var error = 0;
    if (prime.isEven() || !primes.simpleSieve || !primes.fermatTest(prime) || !millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        primeCache[hex] = error;
        return error;
    }
    if (!millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod(TEN);
            if (rem.cmp(THREE) && rem.cmp(SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    primeCache[hex] = error;
    return error;
}
function DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new BN(prime);
    this._prime = BN.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = setPublicKey;
        this.setPrivateKey = setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty(DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new BN(randomBytes(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
DH.prototype.computeSecret = function(other) {
    other = new BN(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new Buffer(prime.length - out.length);
        front.fill(0);
        out = Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
DH.prototype.getPublicKey = function getPublicKey(enc) {
    return formatReturnValue(this._pub, enc);
};
DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return formatReturnValue(this._priv, enc);
};
DH.prototype.getPrime = function(enc) {
    return formatReturnValue(this.__prime, enc);
};
DH.prototype.getGenerator = function(enc) {
    return formatReturnValue(this._gen, enc);
};
DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(gen)) gen = new Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new BN(gen);
    return this;
};
function formatReturnValue(bn, enc) {
    var buf = new Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

},{"18c258c24cda4205":"8EcTH","6cfaed55db270425":"3Q6jJ","8bc0d9823ee74460":"gfiGl","dd39d03f4b3404fc":"kY6oB","e2757e55299a3ebc":"8WDPj"}],"ixLS8":[function(require,module,exports) {
"use strict";
var Buffer = require("9c72b70d69889676").Buffer;
var createHash = require("efe64c48bedfa38e");
var stream = require("6a5343e9b2081ca8");
var inherits = require("f95e32eac8325984");
var sign = require("6e9f6edb752a2c10");
var verify = require("c2f6e4379d1db430");
var algorithms = require("2d93707c75adaee");
Object.keys(algorithms).forEach(function(key) {
    algorithms[key].id = Buffer.from(algorithms[key].id, "hex");
    algorithms[key.toLowerCase()] = algorithms[key];
});
function Sign(algorithm) {
    stream.Writable.call(this);
    var data = algorithms[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = createHash(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
inherits(Sign, stream.Writable);
Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? Buffer.from(data, enc) : data);
    return this;
};
Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = sign(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function Verify(algorithm) {
    stream.Writable.call(this);
    var data = algorithms[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = createHash(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
inherits(Verify, stream.Writable);
Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? Buffer.from(data, enc) : data);
    return this;
};
Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return verify(sigBuffer, hash, key, this._signType, this._tag);
};
function createSign(algorithm) {
    return new Sign(algorithm);
}
function createVerify(algorithm) {
    return new Verify(algorithm);
}
module.exports = {
    Sign: createSign,
    Verify: createVerify,
    createSign: createSign,
    createVerify: createVerify
};

},{"9c72b70d69889676":"fFdLZ","efe64c48bedfa38e":"91an7","6a5343e9b2081ca8":"a1uYf","f95e32eac8325984":"crNcs","6e9f6edb752a2c10":"dpqqF","c2f6e4379d1db430":"dyXmX","2d93707c75adaee":"fS94Z"}],"a1uYf":[function(require,module,exports) {
exports = module.exports = require("68bb3bdae87803ec");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require("74167f79b688eaf7");
exports.Duplex = require("84600f6783428a47");
exports.Transform = require("23bee5f697448a0");
exports.PassThrough = require("e0ec4b8e438dbbd");

},{"68bb3bdae87803ec":"ku3w3","74167f79b688eaf7":"6LUkS","84600f6783428a47":"kMxmK","23bee5f697448a0":"cxuro","e0ec4b8e438dbbd":"k6lIu"}],"ku3w3":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("896ff8d56553f7a");
"use strict";
/*<replacement>*/ var pna = require("6a3257a5fd38b090");
/*</replacement>*/ module.exports = Readable;
/*<replacement>*/ var isArray = require("e90e9a84ea2f1bd2");
/*</replacement>*/ /*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("16782d660ac22e0c").EventEmitter;
var EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("9a34f23fa53f83f7");
/*</replacement>*/ /*<replacement>*/ var Buffer = require("1711a8218ab7e640").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/ /*<replacement>*/ var util = Object.create(require("aec0c91a1241db87"));
util.inherits = require("19affa8ce41f090d");
/*</replacement>*/ /*<replacement>*/ var debugUtil = require("a4a723b7297c7152");
var debug = void 0;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function() {};
/*</replacement>*/ var BufferList = require("ce0c5a097ab7ecd0");
var destroyImpl = require("efa8155386cc4283");
var StringDecoder;
util.inherits(Readable, Stream);
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    if (!(this instanceof Readable)) return new Readable(options);
    this._readableState = new ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return needMoreData(state);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
    this._readableState.decoder = new StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) pna.nextTick(emitReadable_, stream);
        else emitReadable_(stream);
    }
}
function emitReadable_(stream) {
    debug("emit readable");
    stream.emit("readable");
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        pna.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) pna.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) pna.nextTick(nReadingNextTick, this);
            else if (state.length) emitReadable(this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        state.flowing = true;
        resume(this, state);
    }
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        pna.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    if (!state.reading) {
        debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
    var ret = Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        pna.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"896ff8d56553f7a":"g1F5c","6a3257a5fd38b090":"gpKUw","e90e9a84ea2f1bd2":"hgP6N","16782d660ac22e0c":"gB3zd","9a34f23fa53f83f7":"jhdfX","1711a8218ab7e640":"jV4GU","aec0c91a1241db87":"e4h8R","19affa8ce41f090d":"crNcs","a4a723b7297c7152":"49Rpi","ce0c5a097ab7ecd0":"fXzzo","efa8155386cc4283":"fPNir","f1c95f846e94e4eb":"kMxmK","6392acd10886f115":"cUEwR"}],"gpKUw":[function(require,module,exports) {
var process = require("36724de317ab1d63");
"use strict";
if (typeof process === "undefined" || !process.version || process.version.indexOf("v0.") === 0 || process.version.indexOf("v1.") === 0 && process.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: nextTick
};
else module.exports = process;
function nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return process.nextTick(fn);
        case 2:
            return process.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return process.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return process.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return process.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

},{"36724de317ab1d63":"g1F5c"}],"hgP6N":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"jhdfX":[function(require,module,exports) {
module.exports = require("ed88fc9aa73f911").EventEmitter;

},{"ed88fc9aa73f911":"gB3zd"}],"jV4GU":[function(require,module,exports) {
/* eslint-disable node/no-deprecated-api */ var buffer = require("56b5c8483611624a");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"56b5c8483611624a":"8EcTH"}],"e4h8R":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return objectToString(arg) === "[object Array]";
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === "boolean";
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === "number";
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === "string";
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === "symbol";
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return objectToString(re) === "[object RegExp]";
}
exports.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return objectToString(d) === "[object Date]";
}
exports.isDate = isDate;
function isError(e) {
    return objectToString(e) === "[object Error]" || e instanceof Error;
}
exports.isError = isError;
function isFunction(arg) {
    return typeof arg === "function";
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("552a2cbe55fe12b9").Buffer.isBuffer;
function objectToString(o) {
    return Object.prototype.toString.call(o);
}

},{"552a2cbe55fe12b9":"8EcTH"}],"fXzzo":[function(require,module,exports) {
"use strict";
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var Buffer = require("af88c2f3f038c5e4").Buffer;
var util = require("33fc21125524aa4d");
function copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return Buffer.alloc(0);
        var ret = Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if (util && util.inspect && util.inspect.custom) module.exports.prototype[util.inspect.custom] = function() {
    var obj = util.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

},{"af88c2f3f038c5e4":"jV4GU","33fc21125524aa4d":"49Rpi"}],"fPNir":[function(require,module,exports) {
"use strict";
/*<replacement>*/ var pna = require("9f0440d9375d6fc0");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) pna.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                pna.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) pna.nextTick(emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                pna.nextTick(emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy
};

},{"9f0440d9375d6fc0":"gpKUw"}],"kMxmK":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";
/*<replacement>*/ var pna = require("20e11028560825d2");
/*</replacement>*/ /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
/*<replacement>*/ var util = Object.create(require("e230ec8f8c439672"));
util.inherits = require("aa7b11ba5bf4defc");
/*</replacement>*/ var Readable = require("68a7582259cd5865");
var Writable = require("93d042f8bb80078e");
util.inherits(Duplex, Readable);
// avoid scope creep, the keys array can then be collected
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", onend);
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    pna.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    pna.nextTick(cb, err);
};

},{"20e11028560825d2":"gpKUw","e230ec8f8c439672":"e4h8R","aa7b11ba5bf4defc":"crNcs","68a7582259cd5865":"ku3w3","93d042f8bb80078e":"6LUkS"}],"6LUkS":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
"use strict";
/*<replacement>*/ var pna = require("6c800b281e0a9a0");
/*</replacement>*/ module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var asyncWrite = (0, pna.nextTick);
/*</replacement>*/ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var util = Object.create(require("e7c005d8f0ba1903"));
util.inherits = require("10dad555ffe77dde");
/*</replacement>*/ /*<replacement>*/ var internalUtil = {
    deprecate: require("dc51171b07b54af1")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("44a3cc22ec64fcd3");
/*</replacement>*/ /*<replacement>*/ var Buffer = require("b11d62463b2702d9").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/ var destroyImpl = require("acf48fb5d9dc6204");
util.inherits(Writable, Stream);
function nop() {}
function WritableState(options, stream) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) return new Writable(options);
    this._writableState = new WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    pna.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        pna.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ended) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        pna.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        pna.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) /*<replacement>*/ asyncWrite(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
};
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            pna.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) pna.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

},{"6c800b281e0a9a0":"gpKUw","e7c005d8f0ba1903":"e4h8R","10dad555ffe77dde":"crNcs","dc51171b07b54af1":"75uxo","44a3cc22ec64fcd3":"jhdfX","b11d62463b2702d9":"jV4GU","acf48fb5d9dc6204":"fPNir","c5e7171d6f58d3c0":"kMxmK"}],"cUEwR":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
/*<replacement>*/ var Buffer = require("da459cfeb4b18f6c").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

},{"da459cfeb4b18f6c":"jV4GU"}],"cxuro":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var Duplex = require("db11ebf938e536ed");
/*<replacement>*/ var util = Object.create(require("11a2a5d5defdcffa"));
util.inherits = require("82049677fa603d40");
/*</replacement>*/ util.inherits(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

},{"db11ebf938e536ed":"kMxmK","11a2a5d5defdcffa":"e4h8R","82049677fa603d40":"crNcs"}],"k6lIu":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("7ab21291895ec3d2");
/*<replacement>*/ var util = Object.create(require("b9f805fab8ec0508"));
util.inherits = require("f24ec1883eef5e9b");
/*</replacement>*/ util.inherits(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"7ab21291895ec3d2":"cxuro","b9f805fab8ec0508":"e4h8R","f24ec1883eef5e9b":"crNcs"}],"dpqqF":[function(require,module,exports) {
"use strict";
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require("6ae1d89b9934a98d").Buffer;
var createHmac = require("a8da94153ecfc34b");
var crt = require("51cccb2c4d98daac");
var EC = require("94cc3a287d70a03d").ec;
var BN = require("e83ac2526d8afeba");
var parseKeys = require("892f1603b4523d84");
var curves = require("d22eecc2600c2d97");
var RSA_PKCS1_PADDING = 1;
function sign(hash, key, hashType, signType, tag) {
    var priv = parseKeys(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = crt(pad, priv);
    return out;
}
function ecSign(hash, priv) {
    var curveId = curves[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return Buffer.from(out.toDER());
}
function dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new BN(0);
    var k;
    var H = bits2int(hash, q).mod(q);
    var s = false;
    var kv = getKey(x, q, hash, algo);
    while(s === false){
        k = makeKey(q, kv, algo);
        r = makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new BN(0);
        }
    }
    return toDER(r, s);
}
function toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return Buffer.from(res);
}
function getKey(x, q, hash, algo) {
    x = Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = Buffer.alloc(q.byteLength() - x.length);
        x = Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = bits2octets(hash, q);
    var v = Buffer.alloc(hlen);
    v.fill(1);
    var k = Buffer.alloc(hlen);
    k = createHmac(algo, k).update(v).update(Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = createHmac(algo, k).update(v).digest();
    k = createHmac(algo, k).update(v).update(Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = createHmac(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function bits2int(obits, q) {
    var bits = new BN(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function bits2octets(bits, q) {
    bits = bits2int(bits, q);
    bits = bits.mod(q);
    var out = Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = Buffer.alloc(q.byteLength() - out.length);
        out = Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = createHmac(algo, kv.k).update(kv.v).digest();
            t = Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = bits2int(t, q);
        kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([
            0
        ])).digest();
        kv.v = createHmac(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function makeR(g, k, p, q) {
    return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;

},{"6ae1d89b9934a98d":"fFdLZ","a8da94153ecfc34b":"lbjMj","51cccb2c4d98daac":"chxew","94cc3a287d70a03d":"ho6PV","e83ac2526d8afeba":"2ok5i","892f1603b4523d84":"8M1qp","d22eecc2600c2d97":"c7AmY"}],"chxew":[function(require,module,exports) {
var Buffer = require("a54d4e6dcf549cd6").Buffer;
var BN = require("5d911a7c773081c");
var randomBytes = require("cfe4d67488897360");
function blind(priv) {
    var r = getr(priv);
    var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new BN(randomBytes(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function crt(msg, priv) {
    var blinds = blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed(BN.mont(priv.prime1));
    var c2 = blinded.toRed(BN.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, "be", len);
}
crt.getr = getr;
module.exports = crt;

},{"a54d4e6dcf549cd6":"8EcTH","5d911a7c773081c":"2ok5i","cfe4d67488897360":"8WDPj"}],"2ok5i":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("bd440367abe2ded7").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"bd440367abe2ded7":"49Rpi"}],"ho6PV":[function(require,module,exports) {
"use strict";
var elliptic = exports;
elliptic.version = require("e6672bc3ba1c9961").version;
elliptic.utils = require("5bc72f89931ad0f5");
elliptic.rand = require("7f90d752a36f35cf");
elliptic.curve = require("d11da69c91421223");
elliptic.curves = require("6845bad4ed92c3e4");
// Protocols
elliptic.ec = require("b5f2e1f615acc4b");
elliptic.eddsa = require("79ae761761517980");

},{"e6672bc3ba1c9961":"lppTL","5bc72f89931ad0f5":"8iHSZ","7f90d752a36f35cf":"fInqZ","d11da69c91421223":"4jTW0","6845bad4ed92c3e4":"7cNRM","b5f2e1f615acc4b":"eapau","79ae761761517980":"9jSBY"}],"lppTL":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

},{}],"8iHSZ":[function(require,module,exports) {
"use strict";
var utils = exports;
var BN = require("f4cbcf6f6eb25ca0");
var minAssert = require("d8ee30463f95a0fd");
var minUtils = require("997429d6bbd82d59");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, "hex", "le");
}
utils.intFromLE = intFromLE;

},{"f4cbcf6f6eb25ca0":"iWPpc","d8ee30463f95a0fd":"gjnBW","997429d6bbd82d59":"9mGko"}],"iWPpc":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1cf9b8cfa268aab5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1cf9b8cfa268aab5":"49Rpi"}],"9mGko":[function(require,module,exports) {
"use strict";
var utils = exports;
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
utils.toArray = toArray;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
utils.zero2 = zero2;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
utils.toHex = toHex;
utils.encode = function encode(arr, enc) {
    if (enc === "hex") return toHex(arr);
    else return arr;
};

},{}],"4jTW0":[function(require,module,exports) {
"use strict";
var curve = exports;
curve.base = require("59d486bd2037506a");
curve.short = require("eb37617ef6927580");
curve.mont = require("be9c662572da2183");
curve.edwards = require("60763dd06fe64e8d");

},{"59d486bd2037506a":"i598b","eb37617ef6927580":"bIAsO","be9c662572da2183":"gjlfF","60763dd06fe64e8d":"izYv1"}],"i598b":[function(require,module,exports) {
"use strict";
var BN = require("70865a568c61cc60");
var utils = require("fb5111a3810a8235");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"70865a568c61cc60":"iWPpc","fb5111a3810a8235":"8iHSZ"}],"bIAsO":[function(require,module,exports) {
"use strict";
var utils = require("89f794ef417dc31c");
var BN = require("c314b0ac30b69c4a");
var inherits = require("6ac4d7c73f24ab9c");
var Base = require("6e622edb7498c94");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, "short", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"89f794ef417dc31c":"8iHSZ","c314b0ac30b69c4a":"iWPpc","6ac4d7c73f24ab9c":"crNcs","6e622edb7498c94":"i598b"}],"gjlfF":[function(require,module,exports) {
"use strict";
var BN = require("ebdf19f04f3ed250");
var inherits = require("cb5bb4841a749f68");
var Base = require("51280941230b3f98");
var utils = require("ea7949a80be00261");
function MontCurve(conf) {
    Base.call(this, "mont", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"ebdf19f04f3ed250":"iWPpc","cb5bb4841a749f68":"crNcs","51280941230b3f98":"i598b","ea7949a80be00261":"8iHSZ"}],"izYv1":[function(require,module,exports) {
"use strict";
var utils = require("7bd66a4710450b08");
var BN = require("ccef46dcf03d45c6");
var inherits = require("19937272cbe23c92");
var Base = require("108c8ead5f54502b");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, "edwards", conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"7bd66a4710450b08":"8iHSZ","ccef46dcf03d45c6":"iWPpc","19937272cbe23c92":"crNcs","108c8ead5f54502b":"i598b"}],"7cNRM":[function(require,module,exports) {
"use strict";
var curves = exports;
var hash = require("1c9db357c0845afa");
var curve = require("47ec78745540f875");
var utils = require("e30b16e4a47a5405");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === "short") this.curve = new curve.short(options);
    else if (options.type === "edwards") this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), "Invalid curve");
    assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var pre;
try {
    pre = require("9eada5f7049e7dfd");
} catch (e) {
    pre = undefined;
}
defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        pre
    ]
});

},{"1c9db357c0845afa":"2FJPf","47ec78745540f875":"4jTW0","e30b16e4a47a5405":"8iHSZ","9eada5f7049e7dfd":"6ENwL"}],"2FJPf":[function(require,module,exports) {
var hash = exports;
hash.utils = require("38593959f18bd562");
hash.common = require("31a457752237e8ad");
hash.sha = require("3e37816d2a2fd68d");
hash.ripemd = require("ce5a13b5bd10f171");
hash.hmac = require("c32fbac97a361580");
// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"38593959f18bd562":"gz68z","31a457752237e8ad":"ePx83","3e37816d2a2fd68d":"f0fFo","ce5a13b5bd10f171":"9Qsrv","c32fbac97a361580":"9mEfc"}],"gz68z":[function(require,module,exports) {
"use strict";
var assert = require("6002b0feade022a4");
var inherits = require("d4826c9d0ff1b1f");
exports.inherits = inherits;
function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if (isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
exports.toArray = toArray;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
exports.toHex = toHex;
function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
exports.htonl = htonl;
function toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = htonl(w);
        res += zero8(w.toString(16));
    }
    return res;
}
exports.toHex32 = toHex32;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
exports.zero2 = zero2;
function zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
exports.zero8 = zero8;
function join32(msg, start, end, endian) {
    var len = end - start;
    assert(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
exports.join32 = join32;
function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
exports.split32 = split32;
function rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;
function rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;
function sum32(a, b) {
    return a + b >>> 0;
}
exports.sum32 = sum32;
function sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;
function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;
function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;
function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
exports.sum64 = sum64;
function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
exports.sum64_hi = sum64_hi;
function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
exports.sum64_lo = sum64_lo;
function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;
function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;
function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;
function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;
function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;
function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;
function shr64_hi(ah, al, num) {
    return ah >>> num;
}
exports.shr64_hi = shr64_hi;
function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"6002b0feade022a4":"gjnBW","d4826c9d0ff1b1f":"crNcs"}],"ePx83":[function(require,module,exports) {
"use strict";
var utils = require("e9291abdfb47ee4f");
var assert = require("ea8841b701712638");
function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;
BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert(this.pending === null);
    return this._digest(enc);
};
BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

},{"e9291abdfb47ee4f":"gz68z","ea8841b701712638":"gjnBW"}],"f0fFo":[function(require,module,exports) {
"use strict";
exports.sha1 = require("3835379564860fd7");
exports.sha224 = require("bb9f72f042233648");
exports.sha256 = require("20a3b0fa42e37dfe");
exports.sha384 = require("ad4827efa7d953c2");
exports.sha512 = require("301292595a944c1d");

},{"3835379564860fd7":"32LYh","bb9f72f042233648":"dtUag","20a3b0fa42e37dfe":"4cuf2","ad4827efa7d953c2":"jvdDR","301292595a944c1d":"gvK8X"}],"32LYh":[function(require,module,exports) {
"use strict";
var utils = require("b75f3c1442bf9100");
var common = require("a29e68029e4c48f8");
var shaCommon = require("1be62f90a237cba5");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;
var sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
utils.inherits(SHA1, BlockHash);
module.exports = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
};
SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"b75f3c1442bf9100":"gz68z","a29e68029e4c48f8":"ePx83","1be62f90a237cba5":"lF9uc"}],"lF9uc":[function(require,module,exports) {
"use strict";
var utils = require("f0fb61f828bacd0f");
var rotr32 = utils.rotr32;
function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;
function ch32(x, y, z) {
    return x & y ^ ~x & z;
}
exports.ch32 = ch32;
function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;
function p32(x, y, z) {
    return x ^ y ^ z;
}
exports.p32 = p32;
function s0_256(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;
function s1_256(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;
function g0_256(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;
function g1_256(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

},{"f0fb61f828bacd0f":"gz68z"}],"dtUag":[function(require,module,exports) {
"use strict";
var utils = require("fe5acd040463c159");
var SHA256 = require("fa3503eda3738d05");
function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 7), "big");
    else return utils.split32(this.h.slice(0, 7), "big");
};

},{"fe5acd040463c159":"gz68z","fa3503eda3738d05":"4cuf2"}],"4cuf2":[function(require,module,exports) {
"use strict";
var utils = require("32ad3e510bd41f2a");
var common = require("469ad88ad505772a");
var shaCommon = require("fffa7d1ddf1f0b43");
var assert = require("126369f57b5225ed");
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;
var BlockHash = common.BlockHash;
var sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = sha256_K;
    this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;
SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;
SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
    this.h[5] = sum32(this.h[5], f);
    this.h[6] = sum32(this.h[6], g);
    this.h[7] = sum32(this.h[7], h);
};
SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"32ad3e510bd41f2a":"gz68z","469ad88ad505772a":"ePx83","fffa7d1ddf1f0b43":"lF9uc","126369f57b5225ed":"gjnBW"}],"jvdDR":[function(require,module,exports) {
"use strict";
var utils = require("a696ee34c45713da");
var SHA512 = require("fff95253fdaa49ea");
function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 12), "big");
    else return utils.split32(this.h.slice(0, 12), "big");
};

},{"a696ee34c45713da":"gz68z","fff95253fdaa49ea":"gvK8X"}],"gvK8X":[function(require,module,exports) {
"use strict";
var utils = require("7753b1fa702fbb54");
var common = require("81b6970d75627ce1");
var assert = require("f660976cede694e2");
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = common.BlockHash;
var sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function SHA512() {
    if (!(this instanceof SHA512)) return new SHA512();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = sha512_K;
    this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;
SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;
SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
};
SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};
function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2); // 34
    var c2_hi = rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2); // 34
    var c2_lo = rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29); // 61
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29); // 61
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

},{"7753b1fa702fbb54":"gz68z","81b6970d75627ce1":"ePx83","f660976cede694e2":"gjnBW"}],"9Qsrv":[function(require,module,exports) {
"use strict";
var utils = require("36495272d446418f");
var common = require("ad8cf0490e28e8d7");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;
function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "little");
    else return utils.split32(this.h, "little");
};
function f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

},{"36495272d446418f":"gz68z","ad8cf0490e28e8d7":"ePx83"}],"9mEfc":[function(require,module,exports) {
"use strict";
var utils = require("596c08b6835a6e2d");
var assert = require("be527907d4f06808");
function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils.toArray(key, enc));
}
module.exports = Hmac;
Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

},{"596c08b6835a6e2d":"gz68z","be527907d4f06808":"gjnBW"}],"6ENwL":[function(require,module,exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

},{}],"eapau":[function(require,module,exports) {
"use strict";
var BN = require("2e69183faf5285a1");
var HmacDRBG = require("b0cb641292e4911d");
var utils = require("eab3e45147b180ba");
var curves = require("a5ce61d26ce01c4c");
var rand = require("f6342f89ac472937");
var assert = utils.assert;
var KeyPair = require("eb5ba559e423f6e9");
var Signature = require("7c5e2c76c574ce41");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert(Object.prototype.hasOwnProperty.call(curves, options), "Unknown curve " + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

},{"2e69183faf5285a1":"iWPpc","b0cb641292e4911d":"4EMlx","eab3e45147b180ba":"8iHSZ","a5ce61d26ce01c4c":"7cNRM","f6342f89ac472937":"fInqZ","eb5ba559e423f6e9":"7rxAC","7c5e2c76c574ce41":"lHCel"}],"4EMlx":[function(require,module,exports) {
"use strict";
var hash = require("629972fec592198f");
var utils = require("c20531edfb274a2c");
var assert = require("43ff1863ab3fce20");
function HmacDRBG(options) {
    if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = utils.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = utils.toArray(options.pers, options.persEnc || "hex");
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;
HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
HmacDRBG.prototype._hmac = function hmac() {
    return new hash.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = utils.toArray(entropy, entropyEnc);
    add = utils.toArray(add, addEnc);
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = utils.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils.encode(res, enc);
};

},{"629972fec592198f":"2FJPf","c20531edfb274a2c":"9mGko","43ff1863ab3fce20":"gjnBW"}],"7rxAC":[function(require,module,exports) {
"use strict";
var BN = require("55cc33a33cda153d");
var utils = require("bda8b1ff480a7f3");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

},{"55cc33a33cda153d":"iWPpc","bda8b1ff480a7f3":"8iHSZ"}],"lHCel":[function(require,module,exports) {
"use strict";
var BN = require("a7ae8f0fe39990e7");
var utils = require("5df7da4811374387");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, "Signature without r or s");
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"a7ae8f0fe39990e7":"iWPpc","5df7da4811374387":"8iHSZ"}],"9jSBY":[function(require,module,exports) {
"use strict";
var hash = require("50f9bfa8a484d5d8");
var curves = require("68956d27442d6321");
var utils = require("99ec52641eff141d");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("2ad2982d76b37f15");
var Signature = require("76c25a1d63d10c1b");
function EDDSA(curve) {
    assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"50f9bfa8a484d5d8":"2FJPf","68956d27442d6321":"7cNRM","99ec52641eff141d":"8iHSZ","2ad2982d76b37f15":"graVN","76c25a1d63d10c1b":"amslX"}],"graVN":[function(require,module,exports) {
"use strict";
var utils = require("387ffb9c0bf065ab");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, "KeyPair is public only");
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"387ffb9c0bf065ab":"8iHSZ"}],"amslX":[function(require,module,exports) {
"use strict";
var BN = require("696e2c87f819d166");
var utils = require("51b94bcac1dcb2b2");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = Signature;

},{"696e2c87f819d166":"iWPpc","51b94bcac1dcb2b2":"8iHSZ"}],"8M1qp":[function(require,module,exports) {
"use strict";
var asn1 = require("a33d2f68b0ffe26d");
var aesid = require("c39bbd52d12adb70");
var fixProc = require("7247fe0465255c67");
var ciphers = require("ea725b5eadc96106");
var compat = require("aa2a622927353f9f");
var Buffer = require("11d61e4bc73f5fdc").Buffer;
function decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = aesid[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = compat.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = ciphers.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher["final"]());
    return Buffer.concat(out);
}
function parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = Buffer.from(buffer);
    var stripped = fixProc(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = asn1.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = asn1.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = asn1.EncryptedPrivateKey.decode(data, "der");
            data = decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = asn1.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return asn1.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return asn1.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: asn1.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = asn1.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
parseKeys.signature = asn1.signature;
module.exports = parseKeys;

},{"a33d2f68b0ffe26d":"1ZVki","c39bbd52d12adb70":"gPtVe","7247fe0465255c67":"AxhX4","ea725b5eadc96106":"lgVfn","aa2a622927353f9f":"2TSZp","11d61e4bc73f5fdc":"fFdLZ"}],"1ZVki":[function(require,module,exports) {
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
"use strict";
var asn1 = require("821e6411e0aeb10a");
exports.certificate = require("6bb4fbbd6e2d2384");
var RSAPrivateKey = asn1.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("modulus")["int"](), this.key("publicExponent")["int"](), this.key("privateExponent")["int"](), this.key("prime1")["int"](), this.key("prime2")["int"](), this.key("exponent1")["int"](), this.key("exponent2")["int"](), this.key("coefficient")["int"]());
});
exports.RSAPrivateKey = RSAPrivateKey;
var RSAPublicKey = asn1.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus")["int"](), this.key("publicExponent")["int"]());
});
exports.RSAPublicKey = RSAPublicKey;
var AlgorithmIdentifier = asn1.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"]()).optional());
});
var PublicKey = asn1.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use(AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
exports.PublicKey = PublicKey;
var PrivateKeyInfo = asn1.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version")["int"](), this.key("algorithm").use(AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters")["int"]())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;
var DSAPrivateKey = asn1.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"](), this.key("pub_key")["int"](), this.key("priv_key")["int"]());
});
exports.DSAPrivateKey = DSAPrivateKey;
exports.DSAparam = asn1.define("DSAparam", function() {
    this["int"]();
});
var ECParameters = asn1.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var ECPrivateKey = asn1.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
exports.ECPrivateKey = ECPrivateKey;
exports.signature = asn1.define("signature", function() {
    this.seq().obj(this.key("r")["int"](), this.key("s")["int"]());
});

},{"821e6411e0aeb10a":"gao2R","6bb4fbbd6e2d2384":"fUiUJ"}],"gao2R":[function(require,module,exports) {
var asn1 = exports;
asn1.bignum = require("b4f67f473458f037");
asn1.define = require("3a96ab8454f69498").define;
asn1.base = require("82a96f1d67e1a13d");
asn1.constants = require("f666a445bd64a777");
asn1.decoders = require("e200f1dc591d286b");
asn1.encoders = require("5ea4ddb7d1e6fcb9");

},{"b4f67f473458f037":"lx4Py","3a96ab8454f69498":"ie1pA","82a96f1d67e1a13d":"gvBuB","f666a445bd64a777":"hyIXf","e200f1dc591d286b":"g4Skv","5ea4ddb7d1e6fcb9":"6eUoJ"}],"lx4Py":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("7f1ee543ef73731a").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"7f1ee543ef73731a":"49Rpi"}],"ie1pA":[function(require,module,exports) {
var asn1 = require("ab532762dbbdc666");
var inherits = require("64c493c8ea32f1a7");
var api = exports;
api.define = function define(name, body) {
    return new Entity(name, body);
};
function Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = require("62c08f34eab7465f").runInThisContext("(function " + this.name + "(entity) {\n" + "  this._initNamed(entity);\n" + "})");
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    inherits(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
    return this.decoders[enc];
};
Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
    return this.encoders[enc];
};
Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

},{"ab532762dbbdc666":"gao2R","64c493c8ea32f1a7":"crNcs","62c08f34eab7465f":"goJeL"}],"goJeL":[function(require,module,exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

},{}],"gvBuB":[function(require,module,exports) {
var base = exports;
base.Reporter = require("59a43dc644aa14a1").Reporter;
base.DecoderBuffer = require("bb5e01939a3ed5de").DecoderBuffer;
base.EncoderBuffer = require("bb5e01939a3ed5de").EncoderBuffer;
base.Node = require("97802675bd1acef");

},{"59a43dc644aa14a1":"h9r4h","bb5e01939a3ed5de":"5yldD","97802675bd1acef":"gHUBX"}],"h9r4h":[function(require,module,exports) {
var inherits = require("cca99c6acf69321b");
function Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
exports.Reporter = Reporter;
Reporter.prototype.isError = function isError(obj) {
    return obj instanceof ReporterError;
};
Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof ReporterError;
    if (inherited) err = msg;
    else err = new ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
inherits(ReporterError, Error);
ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

},{"cca99c6acf69321b":"crNcs"}],"5yldD":[function(require,module,exports) {
var inherits = require("ff35534ecc380ed3");
var Reporter = require("5e377fc82488d72a").Reporter;
var Buffer = require("e61f132f215e12f9").Buffer;
function DecoderBuffer(base, options) {
    Reporter.call(this, options);
    if (!Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;
DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: Reporter.prototype.save.call(this)
    };
};
DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof EncoderBuffer)) item = new EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = Buffer.byteLength(value);
    } else if (Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
exports.EncoderBuffer = EncoderBuffer;
EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if (Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

},{"ff35534ecc380ed3":"crNcs","5e377fc82488d72a":"gvBuB","e61f132f215e12f9":"8EcTH"}],"gHUBX":[function(require,module,exports) {
var Reporter = require("b93dc035fd1a2dd2").Reporter;
var EncoderBuffer = require("b93dc035fd1a2dd2").EncoderBuffer;
var DecoderBuffer = require("b93dc035fd1a2dd2").DecoderBuffer;
var assert = require("1bf7ce79b1c01d8b");
// Supported tags
var tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat(tags);
// Overrided methods list
var overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = Node;
var stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
Node.prototype._init = function init(body) {
    var state = this._baseState;
    assert(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    assert.equal(state.children.length, 1, "Root node can have only one child");
};
Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        assert(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        assert(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
overrided.forEach(function(method) {
    Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
tags.forEach(function(tag) {
    Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        assert(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
Node.prototype.use = function use(item) {
    assert(item);
    var state = this._baseState;
    assert(state.use === null);
    state.use = item;
    return this;
};
Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
Node.prototype.def = function def(val) {
    var state = this._baseState;
    assert(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    assert(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    assert(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    assert(state.key === null);
    state.key = newKey;
    return this;
};
Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    assert(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    assert(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    assert(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new EncoderBuffer(data, this.reporter);
};
Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) assert(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"b93dc035fd1a2dd2":"gvBuB","1bf7ce79b1c01d8b":"gjnBW"}],"hyIXf":[function(require,module,exports) {
var constants = exports;
// Helper
constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};
constants.der = require("cd34b6c5ba00554c");

},{"cd34b6c5ba00554c":"6hY4w"}],"6hY4w":[function(require,module,exports) {
var constants = require("c9de207563729b47");
exports.tagClass = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
exports.tagClassByName = constants._reverse(exports.tagClass);
exports.tag = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
exports.tagByName = constants._reverse(exports.tag);

},{"c9de207563729b47":"hyIXf"}],"g4Skv":[function(require,module,exports) {
var decoders = exports;
decoders.der = require("abb46f93da4a6a9");
decoders.pem = require("f1e062afeaaaac02");

},{"abb46f93da4a6a9":"bGVkR","f1e062afeaaaac02":"8mkVF"}],"bGVkR":[function(require,module,exports) {
var inherits = require("7c238308bb002386");
var asn1 = require("2acbc866baed26c6");
var base = asn1.base;
var bignum = asn1.bignum;
// Import DER constants
var der = asn1.constants.der;
function DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new DERNode();
    this.tree._init(entity.body);
}
module.exports = DERDecoder;
DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof base.DecoderBuffer)) data = new base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function DERNode(parent) {
    base.Node.call(this, "der", parent);
}
inherits(DERNode, base.Node);
DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === "gentime") {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

},{"7c238308bb002386":"crNcs","2acbc866baed26c6":"gao2R"}],"8mkVF":[function(require,module,exports) {
var inherits = require("c2d50a9d5a6f334a");
var Buffer = require("883f76082a59dd03").Buffer;
var DERDecoder = require("dc9bd6cca8dafd6");
function PEMDecoder(entity) {
    DERDecoder.call(this, entity);
    this.enc = "pem";
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;
PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, "");
    var input = new Buffer(base64, "base64");
    return DERDecoder.prototype.decode.call(this, input, options);
};

},{"c2d50a9d5a6f334a":"crNcs","883f76082a59dd03":"8EcTH","dc9bd6cca8dafd6":"bGVkR"}],"6eUoJ":[function(require,module,exports) {
var encoders = exports;
encoders.der = require("6153180e09514e51");
encoders.pem = require("babaf0c4b3d9210a");

},{"6153180e09514e51":"8FHQw","babaf0c4b3d9210a":"6TkBG"}],"8FHQw":[function(require,module,exports) {
var inherits = require("94789e1422bf21a1");
var Buffer = require("41574641d7de4531").Buffer;
var asn1 = require("9d8c942bce7973a8");
var base = asn1.base;
// Import DER constants
var der = asn1.constants.der;
function DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new DERNode();
    this.tree._init(entity.body);
}
module.exports = DEREncoder;
DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function DERNode(parent) {
    base.Node.call(this, "der", parent);
}
inherits(DERNode, base.Node);
DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = new Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        two(date.getFullYear()),
        two(date.getUTCMonth() + 1),
        two(date.getUTCDate()),
        two(date.getUTCHours()),
        two(date.getUTCMinutes()),
        two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        two(date.getFullYear() % 100),
        two(date.getUTCMonth() + 1),
        two(date.getUTCDate()),
        two(date.getUTCHours()),
        two(date.getUTCMinutes()),
        two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new Buffer(numArray);
    }
    if (Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new Buffer(out));
};
DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if (der.tagByName.hasOwnProperty(tag)) res = der.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= der.tagClassByName[cls || "universal"] << 6;
    return res;
}

},{"94789e1422bf21a1":"crNcs","41574641d7de4531":"8EcTH","9d8c942bce7973a8":"gao2R"}],"6TkBG":[function(require,module,exports) {
var inherits = require("bc3c7930ded74eee");
var DEREncoder = require("cf885a4234262436");
function PEMEncoder(entity) {
    DEREncoder.call(this, entity);
    this.enc = "pem";
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;
PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = DEREncoder.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

},{"bc3c7930ded74eee":"crNcs","cf885a4234262436":"8FHQw"}],"fUiUJ":[function(require,module,exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";
var asn = require("373dc11d39ac511a");
var Time = asn.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var AttributeTypeValue = asn.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var AlgorithmIdentifier = asn.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var SubjectPublicKeyInfo = asn.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use(AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var RelativeDistinguishedName = asn.define("RelativeDistinguishedName", function() {
    this.setof(AttributeTypeValue);
});
var RDNSequence = asn.define("RDNSequence", function() {
    this.seqof(RelativeDistinguishedName);
});
var Name = asn.define("Name", function() {
    this.choice({
        rdnSequence: this.use(RDNSequence)
    });
});
var Validity = asn.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use(Time), this.key("notAfter").use(Time));
});
var Extension = asn.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var TBSCertificate = asn.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0)["int"]().optional(), this.key("serialNumber")["int"](), this.key("signature").use(AlgorithmIdentifier), this.key("issuer").use(Name), this.key("validity").use(Validity), this.key("subject").use(Name), this.key("subjectPublicKeyInfo").use(SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(Extension).optional());
});
var X509Certificate = asn.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use(TBSCertificate), this.key("signatureAlgorithm").use(AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = X509Certificate;

},{"373dc11d39ac511a":"gao2R"}],"gPtVe":[function(require,module,exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

},{}],"AxhX4":[function(require,module,exports) {
"use strict";
// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = require("482ca5fecee84bd1");
var ciphers = require("5e77b1b6b79a5d20");
var Buffer = require("fcf1038e6a690508").Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match(findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match(fullRegex);
        decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = Buffer.from(match[2], "hex");
        var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher["final"]());
        decrypted = Buffer.concat(out);
    }
    var tag = key.match(startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

},{"482ca5fecee84bd1":"6Vk8I","5e77b1b6b79a5d20":"lgVfn","fcf1038e6a690508":"fFdLZ"}],"c7AmY":[function(require,module,exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

},{}],"dyXmX":[function(require,module,exports) {
"use strict";
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require("c893e8283afd176a").Buffer;
var BN = require("18576d045784617e");
var EC = require("9429de8047bf329a").ec;
var parseKeys = require("88de5f3d7e6f8c00");
var curves = require("69d69f2e18a199ce");
function verify(sig, hash, key, signType, tag) {
    var pub = parseKeys(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = Buffer.from(pad);
    var red = BN.mont(pub.modulus);
    sig = new BN(sig).toRed(red);
    sig = sig.redPow(new BN(pub.publicExponent));
    sig = Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function ecVerify(sig, hash, pub) {
    var curveId = curves[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = parseKeys.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    checkValue(s, q);
    checkValue(r, q);
    var montp = BN.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new BN(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = verify;

},{"c893e8283afd176a":"fFdLZ","18576d045784617e":"2ok5i","9429de8047bf329a":"ho6PV","88de5f3d7e6f8c00":"8M1qp","69d69f2e18a199ce":"c7AmY"}],"7DrEx":[function(require,module,exports) {
var Buffer = require("59d8fd0d64d5aa42").Buffer;
var elliptic = require("a6b1ec3b8e72335c");
var BN = require("8c5a992927812eef");
module.exports = function createECDH(curve) {
    return new ECDH(curve);
};
var aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
aliases.p224 = aliases.secp224r1;
aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
aliases.p384 = aliases.secp384r1;
aliases.p521 = aliases.secp521r1;
function ECDH(curve) {
    this.curveType = aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!Buffer.isBuffer(other)) other = new Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return formatReturnValue(out, enc, this.curveType.byteLength);
};
ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return formatReturnValue(key, enc);
};
ECDH.prototype.getPrivateKey = function(enc) {
    return formatReturnValue(this.keys.getPrivate(), enc);
};
ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(pub)) pub = new Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(priv)) priv = new Buffer(priv, enc);
    var _priv = new BN(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new Buffer(len - buf.length);
        zeros.fill(0);
        buf = Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

},{"59d8fd0d64d5aa42":"8EcTH","a6b1ec3b8e72335c":"ho6PV","8c5a992927812eef":"elXq5"}],"elXq5":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1b9e2dcc2d1e58c5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1b9e2dcc2d1e58c5":"49Rpi"}],"hbYmR":[function(require,module,exports) {
exports.publicEncrypt = require("d84cba4f52311cc8");
exports.privateDecrypt = require("f9c6d8fbe09b61c");
exports.privateEncrypt = function privateEncrypt(key, buf) {
    return exports.publicEncrypt(key, buf, true);
};
exports.publicDecrypt = function publicDecrypt(key, buf) {
    return exports.privateDecrypt(key, buf, true);
};

},{"d84cba4f52311cc8":"bU3vx","f9c6d8fbe09b61c":"jLbh6"}],"bU3vx":[function(require,module,exports) {
var parseKeys = require("ca2697dbde558d1");
var randomBytes = require("4704ad09aa96a56b");
var createHash = require("b8a92fd1d9e43252");
var mgf = require("469be15a31031bba");
var xor = require("f9f3694c0f7388b6");
var BN = require("cb7a38ec1a0039d7");
var withPublic = require("969e1e2dd90e2fbe");
var crt = require("9022efe01867a612");
var Buffer = require("d610bb618706f42f").Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = parseKeys(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = oaep(key, msg);
    else if (padding === 1) paddedMsg = pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new BN(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return crt(paddedMsg, key);
    else return withPublic(paddedMsg, key);
};
function oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = createHash("sha1").update(Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = randomBytes(hLen);
    var maskedDb = xor(Buffer.concat([
        iHash,
        ps,
        Buffer.alloc(1, 1),
        msg
    ], dblen), mgf(seed, dblen));
    var maskedSeed = xor(seed, mgf(maskedDb, hLen));
    return new BN(Buffer.concat([
        Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = Buffer.alloc(k - mLen - 3, 0xff);
    else ps = nonZero(k - mLen - 3);
    return new BN(Buffer.concat([
        Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        Buffer.alloc(1),
        msg
    ], k));
}
function nonZero(len) {
    var out = Buffer.allocUnsafe(len);
    var i = 0;
    var cache = randomBytes(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = randomBytes(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

},{"ca2697dbde558d1":"8M1qp","4704ad09aa96a56b":"8WDPj","b8a92fd1d9e43252":"91an7","469be15a31031bba":"1UVat","f9f3694c0f7388b6":"3wnwo","cb7a38ec1a0039d7":"frVhE","969e1e2dd90e2fbe":"5H7fP","9022efe01867a612":"chxew","d610bb618706f42f":"fFdLZ"}],"1UVat":[function(require,module,exports) {
var createHash = require("b36bb21196daa39");
var Buffer = require("cfa1ea60eac1ebfa").Buffer;
module.exports = function(seed, len) {
    var t = Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = i2ops(i++);
        t = Buffer.concat([
            t,
            createHash("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function i2ops(c) {
    var out = Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

},{"b36bb21196daa39":"91an7","cfa1ea60eac1ebfa":"fFdLZ"}],"3wnwo":[function(require,module,exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

},{}],"frVhE":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("64c9d23ade4c9eaa").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"64c9d23ade4c9eaa":"49Rpi"}],"5H7fP":[function(require,module,exports) {
var BN = require("94162e508c4195c3");
var Buffer = require("1bab2adfd8072b94").Buffer;
function withPublic(paddedMsg, key) {
    return Buffer.from(paddedMsg.toRed(BN.mont(key.modulus)).redPow(new BN(key.publicExponent)).fromRed().toArray());
}
module.exports = withPublic;

},{"94162e508c4195c3":"frVhE","1bab2adfd8072b94":"fFdLZ"}],"jLbh6":[function(require,module,exports) {
var parseKeys = require("6c46b1d8bb7eae7b");
var mgf = require("9e51003323ea065d");
var xor = require("637b57d34a8dda25");
var BN = require("3927561f39566b29");
var crt = require("521cbc4ce6042d5b");
var createHash = require("95282d7c0e66f364");
var withPublic = require("1bc2f92e3c398dbe");
var Buffer = require("802d086fb6d63368").Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = parseKeys(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = withPublic(new BN(enc), key);
    else msg = crt(enc, key);
    var zBuffer = Buffer.alloc(k - msg.length);
    msg = Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return oaep(key, msg);
    else if (padding === 1) return pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = createHash("sha1").update(Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = xor(maskedSeed, mgf(maskedDb, hLen));
    var db = xor(maskedDb, mgf(seed, k - hLen - 1));
    if (compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function compare(a, b) {
    a = Buffer.from(a);
    b = Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

},{"6c46b1d8bb7eae7b":"8M1qp","9e51003323ea065d":"1UVat","637b57d34a8dda25":"3wnwo","3927561f39566b29":"frVhE","521cbc4ce6042d5b":"chxew","95282d7c0e66f364":"91an7","1bc2f92e3c398dbe":"5H7fP","802d086fb6d63368":"fFdLZ"}],"3ueHf":[function(require,module,exports) {
var global = arguments[3];
var process = require("e52c82591caff1d7");
"use strict";
function oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}
var safeBuffer = require("954d667c0302f12c");
var randombytes = require("7041a0e993c249ef");
var Buffer = safeBuffer.Buffer;
var kBufferMaxLength = safeBuffer.kMaxLength;
var crypto = global.crypto || global.msCrypto;
var kMaxUint32 = Math.pow(2, 32) - 1;
function assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > kBufferMaxLength) throw new RangeError("buffer too small");
}
if (crypto && crypto.getRandomValues || false) {
    exports.randomFill = randomFill;
    exports.randomFillSync = randomFillSync;
} else {
    exports.randomFill = oldBrowser;
    exports.randomFillSync = oldBrowser;
}
function randomFill(buf, offset, size, cb) {
    if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    assertOffset(offset, buf.length);
    assertSize(size, offset, buf.length);
    return actualFill(buf, offset, size, cb);
}
function actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    crypto.getRandomValues(uint);
    if (cb) {
        process.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        randombytes(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = randombytes(size);
    bytes.copy(buf, offset);
    return buf;
}
function randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    assertSize(size, offset, buf.length);
    return actualFill(buf, offset, size);
}

},{"e52c82591caff1d7":"g1F5c","954d667c0302f12c":"fFdLZ","7041a0e993c249ef":"8WDPj"}],"cMLzO":[function(require,module,exports) {
"use strict";
var http = require("d979b16233e081c4");
var https = require("3f79bc13a691ab97");
var url = require("738bda9f257316fd");
var util = require("6e449b3c39ca221d");
var stream = require("a17b9582363bd5b8");
var zlib = require("15779b1c30716e3b");
var aws2 = require("affff3f4c59e7066");
var aws4 = require("3d2458cc535a5dab");
var httpSignature = require("9704c84bd84e259a");
var mime = require("8adc7bc65a9e9af5");
var caseless = require("fa8be9166031f505");
var ForeverAgent = require("4a143b5f036e147c");
var FormData = require("3dd1ce1011d3a7b4");
var extend = require("41f47de97d52aebb");
var isstream = require("14763535ed82d2ed");
var isTypedArray = require("d3c8e72ec9e3c261").strict;
var helpers = require("67e403c0190cbea9");
var cookies = require("9697145101411ed9");
var getProxyFromURI = require("2e9049162cbe7d64");
var Querystring = require("3824ea3a12e5d938").Querystring;
var Har = require("7301313a3b01e791").Har;
var Auth = require("538bd392c402dc76").Auth;
var OAuth = require("e4657f91274e3930").OAuth;
var hawk = require("8cdcfcea60ddd2a6");
var Multipart = require("847def4faeb4a2cc").Multipart;
var Redirect = require("4b29cb5cfa9c8383").Redirect;
var Tunnel = require("bab9ab3fc01bd572").Tunnel;
var now = require("cd3a2a0185d27c7e");
var Buffer = require("79fd6d2a630a066d").Buffer;
var safeStringify = helpers.safeStringify;
var isReadStream = helpers.isReadStream;
var toBase64 = helpers.toBase64;
var defer = helpers.defer;
var copy = helpers.copy;
var version = helpers.version;
var globalCookieJar = cookies.jar();
var globalPool = {};
function filterForNonReserved(reserved, options) {
    // Filter out properties that are not reserved.
    // Reserved values are passed in at call site.
    var object = {};
    for(var i in options){
        var notReserved = reserved.indexOf(i) === -1;
        if (notReserved) object[i] = options[i];
    }
    return object;
}
function filterOutReservedFunctions(reserved, options) {
    // Filter out properties that are functions and are reserved.
    // Reserved values are passed in at call site.
    var object = {};
    for(var i in options){
        var isReserved = !(reserved.indexOf(i) === -1);
        var isFunction = typeof options[i] === "function";
        if (!(isReserved && isFunction)) object[i] = options[i];
    }
    return object;
}
// Return a simpler request object to allow serialization
function requestToJSON() {
    var self = this;
    return {
        uri: self.uri,
        method: self.method,
        headers: self.headers
    };
}
// Return a simpler response object to allow serialization
function responseToJSON() {
    var self = this;
    return {
        statusCode: self.statusCode,
        body: self.body,
        headers: self.headers,
        request: requestToJSON.call(self.request)
    };
}
function Request(options) {
    // if given the method property in options, set property explicitMethod to true
    // extend the Request instance with any non-reserved properties
    // remove any reserved functions from the options object
    // set Request instance to be readable and writable
    // call init
    var self = this;
    // start with HAR, then override with additional options
    if (options.har) {
        self._har = new Har(self);
        options = self._har.options(options);
    }
    stream.Stream.call(self);
    var reserved = Object.keys(Request.prototype);
    var nonReserved = filterForNonReserved(reserved, options);
    extend(self, nonReserved);
    options = filterOutReservedFunctions(reserved, options);
    self.readable = true;
    self.writable = true;
    if (options.method) self.explicitMethod = true;
    self._qs = new Querystring(self);
    self._auth = new Auth(self);
    self._oauth = new OAuth(self);
    self._multipart = new Multipart(self);
    self._redirect = new Redirect(self);
    self._tunnel = new Tunnel(self);
    self.init(options);
}
util.inherits(Request, stream.Stream);
// Debugging
Request.debug = undefined;
function debug() {
    if (Request.debug) console.error("REQUEST %s", util.format.apply(util, arguments));
}
Request.prototype.debug = debug;
Request.prototype.init = function(options) {
    // init() contains all the code to setup the request object.
    // the actual outgoing request is not started until start() is called
    // this function is called from both the constructor and on redirect.
    var self = this;
    if (!options) options = {};
    self.headers = self.headers ? copy(self.headers) : {};
    // Delete headers with value undefined since they break
    // ClientRequest.OutgoingMessage.setHeader in node 0.12
    for(var headerName in self.headers)if (typeof self.headers[headerName] === "undefined") delete self.headers[headerName];
    caseless.httpify(self, self.headers);
    if (!self.method) self.method = options.method || "GET";
    if (!self.localAddress) self.localAddress = options.localAddress;
    self._qs.init(options);
    debug(options);
    if (!self.pool && self.pool !== false) self.pool = globalPool;
    self.dests = self.dests || [];
    self.__isRequestRequest = true;
    // Protect against double callback
    if (!self._callback && self.callback) {
        self._callback = self.callback;
        self.callback = function() {
            if (self._callbackCalled) return; // Print a warning maybe?
            self._callbackCalled = true;
            self._callback.apply(self, arguments);
        };
        self.on("error", self.callback.bind());
        self.on("complete", self.callback.bind(self, null));
    }
    // People use this property instead all the time, so support it
    if (!self.uri && self.url) {
        self.uri = self.url;
        delete self.url;
    }
    // If there's a baseUrl, then use it as the base URL (i.e. uri must be
    // specified as a relative path and is appended to baseUrl).
    if (self.baseUrl) {
        if (typeof self.baseUrl !== "string") return self.emit("error", new Error("options.baseUrl must be a string"));
        if (typeof self.uri !== "string") return self.emit("error", new Error("options.uri must be a string when using options.baseUrl"));
        if (self.uri.indexOf("//") === 0 || self.uri.indexOf("://") !== -1) return self.emit("error", new Error("options.uri must be a path when using options.baseUrl"));
        // Handle all cases to make sure that there's only one slash between
        // baseUrl and uri.
        var baseUrlEndsWithSlash = self.baseUrl.lastIndexOf("/") === self.baseUrl.length - 1;
        var uriStartsWithSlash = self.uri.indexOf("/") === 0;
        if (baseUrlEndsWithSlash && uriStartsWithSlash) self.uri = self.baseUrl + self.uri.slice(1);
        else if (baseUrlEndsWithSlash || uriStartsWithSlash) self.uri = self.baseUrl + self.uri;
        else if (self.uri === "") self.uri = self.baseUrl;
        else self.uri = self.baseUrl + "/" + self.uri;
        delete self.baseUrl;
    }
    // A URI is needed by this point, emit error if we haven't been able to get one
    if (!self.uri) return self.emit("error", new Error("options.uri is a required argument"));
    // If a string URI/URL was given, parse it into a URL object
    if (typeof self.uri === "string") self.uri = url.parse(self.uri);
    // Some URL objects are not from a URL parsed string and need href added
    if (!self.uri.href) self.uri.href = url.format(self.uri);
    // DEPRECATED: Warning for users of the old Unix Sockets URL Scheme
    if (self.uri.protocol === "unix:") return self.emit("error", new Error("`unix://` URL scheme is no longer supported. Please use the format `http://unix:SOCKET:PATH`"));
    // Support Unix Sockets
    if (self.uri.host === "unix") self.enableUnixSocket();
    if (self.strictSSL === false) self.rejectUnauthorized = false;
    if (!self.uri.pathname) self.uri.pathname = "/";
    if (!(self.uri.host || self.uri.hostname && self.uri.port) && !self.uri.isUnix) {
        // Invalid URI: it may generate lot of bad errors, like 'TypeError: Cannot call method `indexOf` of undefined' in CookieJar
        // Detect and reject it as soon as possible
        var faultyUri = url.format(self.uri);
        var message = 'Invalid URI "' + faultyUri + '"';
        if (Object.keys(options).length === 0) // No option ? This can be the sign of a redirect
        // As this is a case where the user cannot do anything (they didn't call request directly with this URL)
        // they should be warned that it can be caused by a redirection (can save some hair)
        message += ". This can be caused by a crappy redirection.";
        // This error was fatal
        self.abort();
        return self.emit("error", new Error(message));
    }
    if (!self.hasOwnProperty("proxy")) self.proxy = getProxyFromURI(self.uri);
    self.tunnel = self._tunnel.isEnabled();
    if (self.proxy) self._tunnel.setup(options);
    self._redirect.onRequest(options);
    self.setHost = false;
    if (!self.hasHeader("host")) {
        var hostHeaderName = self.originalHostHeaderName || "host";
        self.setHeader(hostHeaderName, self.uri.host);
        // Drop :port suffix from Host header if known protocol.
        if (self.uri.port) {
            if (self.uri.port === "80" && self.uri.protocol === "http:" || self.uri.port === "443" && self.uri.protocol === "https:") self.setHeader(hostHeaderName, self.uri.hostname);
        }
        self.setHost = true;
    }
    self.jar(self._jar || options.jar);
    if (!self.uri.port) {
        if (self.uri.protocol === "http:") self.uri.port = 80;
        else if (self.uri.protocol === "https:") self.uri.port = 443;
    }
    if (self.proxy && !self.tunnel) {
        self.port = self.proxy.port;
        self.host = self.proxy.hostname;
    } else {
        self.port = self.uri.port;
        self.host = self.uri.hostname;
    }
    if (options.form) self.form(options.form);
    if (options.formData) {
        var formData = options.formData;
        var requestForm = self.form();
        var appendFormValue = function(key, value) {
            if (value && value.hasOwnProperty("value") && value.hasOwnProperty("options")) requestForm.append(key, value.value, value.options);
            else requestForm.append(key, value);
        };
        for(var formKey in formData)if (formData.hasOwnProperty(formKey)) {
            var formValue = formData[formKey];
            if (formValue instanceof Array) for(var j = 0; j < formValue.length; j++)appendFormValue(formKey, formValue[j]);
            else appendFormValue(formKey, formValue);
        }
    }
    if (options.qs) self.qs(options.qs);
    if (self.uri.path) self.path = self.uri.path;
    else self.path = self.uri.pathname + (self.uri.search || "");
    if (self.path.length === 0) self.path = "/";
    // Auth must happen last in case signing is dependent on other headers
    if (options.aws) self.aws(options.aws);
    if (options.hawk) self.hawk(options.hawk);
    if (options.httpSignature) self.httpSignature(options.httpSignature);
    if (options.auth) {
        if (Object.prototype.hasOwnProperty.call(options.auth, "username")) options.auth.user = options.auth.username;
        if (Object.prototype.hasOwnProperty.call(options.auth, "password")) options.auth.pass = options.auth.password;
        self.auth(options.auth.user, options.auth.pass, options.auth.sendImmediately, options.auth.bearer);
    }
    if (self.gzip && !self.hasHeader("accept-encoding")) self.setHeader("accept-encoding", "gzip, deflate");
    if (self.uri.auth && !self.hasHeader("authorization")) {
        var uriAuthPieces = self.uri.auth.split(":").map(function(item) {
            return self._qs.unescape(item);
        });
        self.auth(uriAuthPieces[0], uriAuthPieces.slice(1).join(":"), true);
    }
    if (!self.tunnel && self.proxy && self.proxy.auth && !self.hasHeader("proxy-authorization")) {
        var proxyAuthPieces = self.proxy.auth.split(":").map(function(item) {
            return self._qs.unescape(item);
        });
        var authHeader = "Basic " + toBase64(proxyAuthPieces.join(":"));
        self.setHeader("proxy-authorization", authHeader);
    }
    if (self.proxy && !self.tunnel) self.path = self.uri.protocol + "//" + self.uri.host + self.path;
    if (options.json) self.json(options.json);
    if (options.multipart) self.multipart(options.multipart);
    if (options.time) {
        self.timing = true;
        // NOTE: elapsedTime is deprecated in favor of .timings
        self.elapsedTime = self.elapsedTime || 0;
    }
    function setContentLength() {
        if (isTypedArray(self.body)) self.body = Buffer.from(self.body);
        if (!self.hasHeader("content-length")) {
            var length;
            if (typeof self.body === "string") length = Buffer.byteLength(self.body);
            else if (Array.isArray(self.body)) length = self.body.reduce(function(a, b) {
                return a + b.length;
            }, 0);
            else length = self.body.length;
            if (length) self.setHeader("content-length", length);
            else self.emit("error", new Error("Argument error, options.body."));
        }
    }
    if (self.body && !isstream(self.body)) setContentLength();
    if (options.oauth) self.oauth(options.oauth);
    else if (self._oauth.params && self.hasHeader("authorization")) self.oauth(self._oauth.params);
    var protocol = self.proxy && !self.tunnel ? self.proxy.protocol : self.uri.protocol;
    var defaultModules = {
        "http:": http,
        "https:": https
    };
    var httpModules = self.httpModules || {};
    self.httpModule = httpModules[protocol] || defaultModules[protocol];
    if (!self.httpModule) return self.emit("error", new Error("Invalid protocol: " + protocol));
    if (options.ca) self.ca = options.ca;
    if (!self.agent) {
        if (options.agentOptions) self.agentOptions = options.agentOptions;
        if (options.agentClass) self.agentClass = options.agentClass;
        else if (options.forever) {
            var v = version();
            // use ForeverAgent in node 0.10- only
            if (v.major === 0 && v.minor <= 10) self.agentClass = protocol === "http:" ? ForeverAgent : ForeverAgent.SSL;
            else {
                self.agentClass = self.httpModule.Agent;
                self.agentOptions = self.agentOptions || {};
                self.agentOptions.keepAlive = true;
            }
        } else self.agentClass = self.httpModule.Agent;
    }
    if (self.pool === false) self.agent = false;
    else self.agent = self.agent || self.getNewAgent();
    self.on("pipe", function(src) {
        if (self.ntick && self._started) self.emit("error", new Error("You cannot pipe to this stream after the outbound request has started."));
        self.src = src;
        if (isReadStream(src)) {
            if (!self.hasHeader("content-type")) self.setHeader("content-type", mime.lookup(src.path));
        } else {
            if (src.headers) {
                for(var i in src.headers)if (!self.hasHeader(i)) self.setHeader(i, src.headers[i]);
            }
            if (self._json && !self.hasHeader("content-type")) self.setHeader("content-type", "application/json");
            if (src.method && !self.explicitMethod) self.method = src.method;
        }
    // self.on('pipe', function () {
    //   console.error('You have already piped to this stream. Pipeing twice is likely to break the request.')
    // })
    });
    defer(function() {
        if (self._aborted) return;
        var end = function() {
            if (self._form) {
                if (!self._auth.hasAuth) self._form.pipe(self);
                else if (self._auth.hasAuth && self._auth.sentAuth) self._form.pipe(self);
            }
            if (self._multipart && self._multipart.chunked) self._multipart.body.pipe(self);
            if (self.body) {
                if (isstream(self.body)) self.body.pipe(self);
                else {
                    setContentLength();
                    if (Array.isArray(self.body)) self.body.forEach(function(part) {
                        self.write(part);
                    });
                    else self.write(self.body);
                    self.end();
                }
            } else if (self.requestBodyStream) {
                console.warn("options.requestBodyStream is deprecated, please pass the request object to stream.pipe.");
                self.requestBodyStream.pipe(self);
            } else if (!self.src) {
                if (self._auth.hasAuth && !self._auth.sentAuth) {
                    self.end();
                    return;
                }
                if (self.method !== "GET" && typeof self.method !== "undefined") self.setHeader("content-length", 0);
                self.end();
            }
        };
        if (self._form && !self.hasHeader("content-length")) {
            // Before ending the request, we had to compute the length of the whole form, asyncly
            self.setHeader(self._form.getHeaders(), true);
            self._form.getLength(function(err, length) {
                if (!err && !isNaN(length)) self.setHeader("content-length", length);
                end();
            });
        } else end();
        self.ntick = true;
    });
};
Request.prototype.getNewAgent = function() {
    var self = this;
    var Agent = self.agentClass;
    var options = {};
    if (self.agentOptions) for(var i in self.agentOptions)options[i] = self.agentOptions[i];
    if (self.ca) options.ca = self.ca;
    if (self.ciphers) options.ciphers = self.ciphers;
    if (self.secureProtocol) options.secureProtocol = self.secureProtocol;
    if (self.secureOptions) options.secureOptions = self.secureOptions;
    if (typeof self.rejectUnauthorized !== "undefined") options.rejectUnauthorized = self.rejectUnauthorized;
    if (self.cert && self.key) {
        options.key = self.key;
        options.cert = self.cert;
    }
    if (self.pfx) options.pfx = self.pfx;
    if (self.passphrase) options.passphrase = self.passphrase;
    var poolKey = "";
    // different types of agents are in different pools
    if (Agent !== self.httpModule.Agent) poolKey += Agent.name;
    // ca option is only relevant if proxy or destination are https
    var proxy = self.proxy;
    if (typeof proxy === "string") proxy = url.parse(proxy);
    var isHttps = proxy && proxy.protocol === "https:" || this.uri.protocol === "https:";
    if (isHttps) {
        if (options.ca) {
            if (poolKey) poolKey += ":";
            poolKey += options.ca;
        }
        if (typeof options.rejectUnauthorized !== "undefined") {
            if (poolKey) poolKey += ":";
            poolKey += options.rejectUnauthorized;
        }
        if (options.cert) {
            if (poolKey) poolKey += ":";
            poolKey += options.cert.toString("ascii") + options.key.toString("ascii");
        }
        if (options.pfx) {
            if (poolKey) poolKey += ":";
            poolKey += options.pfx.toString("ascii");
        }
        if (options.ciphers) {
            if (poolKey) poolKey += ":";
            poolKey += options.ciphers;
        }
        if (options.secureProtocol) {
            if (poolKey) poolKey += ":";
            poolKey += options.secureProtocol;
        }
        if (options.secureOptions) {
            if (poolKey) poolKey += ":";
            poolKey += options.secureOptions;
        }
    }
    if (self.pool === globalPool && !poolKey && Object.keys(options).length === 0 && self.httpModule.globalAgent) // not doing anything special.  Use the globalAgent
    return self.httpModule.globalAgent;
    // we're using a stored agent.  Make sure it's protocol-specific
    poolKey = self.uri.protocol + poolKey;
    // generate a new agent for this setting if none yet exists
    if (!self.pool[poolKey]) {
        self.pool[poolKey] = new Agent(options);
        // properly set maxSockets on new agents
        if (self.pool.maxSockets) self.pool[poolKey].maxSockets = self.pool.maxSockets;
    }
    return self.pool[poolKey];
};
Request.prototype.start = function() {
    // start() is called once we are ready to send the outgoing HTTP request.
    // this is usually called on the first write(), end() or on nextTick()
    var self = this;
    if (self.timing) {
        // All timings will be relative to this request's startTime.  In order to do this,
        // we need to capture the wall-clock start time (via Date), immediately followed
        // by the high-resolution timer (via now()).  While these two won't be set
        // at the _exact_ same time, they should be close enough to be able to calculate
        // high-resolution, monotonically non-decreasing timestamps relative to startTime.
        var startTime = new Date().getTime();
        var startTimeNow = now();
    }
    if (self._aborted) return;
    self._started = true;
    self.method = self.method || "GET";
    self.href = self.uri.href;
    if (self.src && self.src.stat && self.src.stat.size && !self.hasHeader("content-length")) self.setHeader("content-length", self.src.stat.size);
    if (self._aws) self.aws(self._aws, true);
    // We have a method named auth, which is completely different from the http.request
    // auth option.  If we don't remove it, we're gonna have a bad time.
    var reqOptions = copy(self);
    delete reqOptions.auth;
    debug("make request", self.uri.href);
    // node v6.8.0 now supports a `timeout` value in `http.request()`, but we
    // should delete it for now since we handle timeouts manually for better
    // consistency with node versions before v6.8.0
    delete reqOptions.timeout;
    try {
        self.req = self.httpModule.request(reqOptions);
    } catch (err) {
        self.emit("error", err);
        return;
    }
    if (self.timing) {
        self.startTime = startTime;
        self.startTimeNow = startTimeNow;
        // Timing values will all be relative to startTime (by comparing to startTimeNow
        // so we have an accurate clock)
        self.timings = {};
    }
    var timeout;
    if (self.timeout && !self.timeoutTimer) {
        if (self.timeout < 0) timeout = 0;
        else if (typeof self.timeout === "number" && isFinite(self.timeout)) timeout = self.timeout;
    }
    self.req.on("response", self.onRequestResponse.bind(self));
    self.req.on("error", self.onRequestError.bind(self));
    self.req.on("drain", function() {
        self.emit("drain");
    });
    self.req.on("socket", function(socket) {
        // `._connecting` was the old property which was made public in node v6.1.0
        var isConnecting = socket._connecting || socket.connecting;
        if (self.timing) {
            self.timings.socket = now() - self.startTimeNow;
            if (isConnecting) {
                var onLookupTiming = function() {
                    self.timings.lookup = now() - self.startTimeNow;
                };
                var onConnectTiming = function() {
                    self.timings.connect = now() - self.startTimeNow;
                };
                socket.once("lookup", onLookupTiming);
                socket.once("connect", onConnectTiming);
                // clean up timing event listeners if needed on error
                self.req.once("error", function() {
                    socket.removeListener("lookup", onLookupTiming);
                    socket.removeListener("connect", onConnectTiming);
                });
            }
        }
        var setReqTimeout = function() {
            // This timeout sets the amount of time to wait *between* bytes sent
            // from the server once connected.
            //
            // In particular, it's useful for erroring if the server fails to send
            // data halfway through streaming a response.
            self.req.setTimeout(timeout, function() {
                if (self.req) {
                    self.abort();
                    var e = new Error("ESOCKETTIMEDOUT");
                    e.code = "ESOCKETTIMEDOUT";
                    e.connect = false;
                    self.emit("error", e);
                }
            });
        };
        if (timeout !== undefined) {
            // Only start the connection timer if we're actually connecting a new
            // socket, otherwise if we're already connected (because this is a
            // keep-alive connection) do not bother. This is important since we won't
            // get a 'connect' event for an already connected socket.
            if (isConnecting) {
                var onReqSockConnect = function() {
                    socket.removeListener("connect", onReqSockConnect);
                    self.clearTimeout();
                    setReqTimeout();
                };
                socket.on("connect", onReqSockConnect);
                self.req.on("error", function(err) {
                    socket.removeListener("connect", onReqSockConnect);
                });
                // Set a timeout in memory - this block will throw if the server takes more
                // than `timeout` to write the HTTP status and headers (corresponding to
                // the on('response') event on the client). NB: this measures wall-clock
                // time, not the time between bytes sent by the server.
                self.timeoutTimer = setTimeout(function() {
                    socket.removeListener("connect", onReqSockConnect);
                    self.abort();
                    var e = new Error("ETIMEDOUT");
                    e.code = "ETIMEDOUT";
                    e.connect = true;
                    self.emit("error", e);
                }, timeout);
            } else // We're already connected
            setReqTimeout();
        }
        self.emit("socket", socket);
    });
    self.emit("request", self.req);
};
Request.prototype.onRequestError = function(error) {
    var self = this;
    if (self._aborted) return;
    if (self.req && self.req._reusedSocket && error.code === "ECONNRESET" && self.agent.addRequestNoreuse) {
        self.agent = {
            addRequest: self.agent.addRequestNoreuse.bind(self.agent)
        };
        self.start();
        self.req.end();
        return;
    }
    self.clearTimeout();
    self.emit("error", error);
};
Request.prototype.onRequestResponse = function(response) {
    var self = this;
    if (self.timing) self.timings.response = now() - self.startTimeNow;
    debug("onRequestResponse", self.uri.href, response.statusCode, response.headers);
    response.on("end", function() {
        if (self.timing) {
            self.timings.end = now() - self.startTimeNow;
            response.timingStart = self.startTime;
            // fill in the blanks for any periods that didn't trigger, such as
            // no lookup or connect due to keep alive
            if (!self.timings.socket) self.timings.socket = 0;
            if (!self.timings.lookup) self.timings.lookup = self.timings.socket;
            if (!self.timings.connect) self.timings.connect = self.timings.lookup;
            if (!self.timings.response) self.timings.response = self.timings.connect;
            debug("elapsed time", self.timings.end);
            // elapsedTime includes all redirects
            self.elapsedTime += Math.round(self.timings.end);
            // NOTE: elapsedTime is deprecated in favor of .timings
            response.elapsedTime = self.elapsedTime;
            // timings is just for the final fetch
            response.timings = self.timings;
            // pre-calculate phase timings as well
            response.timingPhases = {
                wait: self.timings.socket,
                dns: self.timings.lookup - self.timings.socket,
                tcp: self.timings.connect - self.timings.lookup,
                firstByte: self.timings.response - self.timings.connect,
                download: self.timings.end - self.timings.response,
                total: self.timings.end
            };
        }
        debug("response end", self.uri.href, response.statusCode, response.headers);
    });
    if (self._aborted) {
        debug("aborted", self.uri.href);
        response.resume();
        return;
    }
    self.response = response;
    response.request = self;
    response.toJSON = responseToJSON;
    // XXX This is different on 0.10, because SSL is strict by default
    if (self.httpModule === https && self.strictSSL && (!response.hasOwnProperty("socket") || !response.socket.authorized)) {
        debug("strict ssl error", self.uri.href);
        var sslErr = response.hasOwnProperty("socket") ? response.socket.authorizationError : self.uri.href + " does not support SSL";
        self.emit("error", new Error("SSL Error: " + sslErr));
        return;
    }
    // Save the original host before any redirect (if it changes, we need to
    // remove any authorization headers).  Also remember the case of the header
    // name because lots of broken servers expect Host instead of host and we
    // want the caller to be able to specify this.
    self.originalHost = self.getHeader("host");
    if (!self.originalHostHeaderName) self.originalHostHeaderName = self.hasHeader("host");
    if (self.setHost) self.removeHeader("host");
    self.clearTimeout();
    var targetCookieJar = self._jar && self._jar.setCookie ? self._jar : globalCookieJar;
    var addCookie = function(cookie) {
        // set the cookie if it's domain in the href's domain.
        try {
            targetCookieJar.setCookie(cookie, self.uri.href, {
                ignoreError: true
            });
        } catch (e) {
            self.emit("error", e);
        }
    };
    response.caseless = caseless(response.headers);
    if (response.caseless.has("set-cookie") && !self._disableCookies) {
        var headerName = response.caseless.has("set-cookie");
        if (Array.isArray(response.headers[headerName])) response.headers[headerName].forEach(addCookie);
        else addCookie(response.headers[headerName]);
    }
    if (self._redirect.onResponse(response)) return; // Ignore the rest of the response
    else {
        // Be a good stream and emit end when the response is finished.
        // Hack to emit end on close because of a core bug that never fires end
        response.on("close", function() {
            if (!self._ended) self.response.emit("end");
        });
        response.once("end", function() {
            self._ended = true;
        });
        var noBody = function(code) {
            return self.method === "HEAD" || // Informational
            code >= 100 && code < 200 || // No Content
            code === 204 || // Not Modified
            code === 304;
        };
        var responseContent;
        if (self.gzip && !noBody(response.statusCode)) {
            var contentEncoding = response.headers["content-encoding"] || "identity";
            contentEncoding = contentEncoding.trim().toLowerCase();
            // Be more lenient with decoding compressed responses, since (very rarely)
            // servers send slightly invalid gzip responses that are still accepted
            // by common browsers.
            // Always using Z_SYNC_FLUSH is what cURL does.
            var zlibOptions = {
                flush: zlib.Z_SYNC_FLUSH,
                finishFlush: zlib.Z_SYNC_FLUSH
            };
            if (contentEncoding === "gzip") {
                responseContent = zlib.createGunzip(zlibOptions);
                response.pipe(responseContent);
            } else if (contentEncoding === "deflate") {
                responseContent = zlib.createInflate(zlibOptions);
                response.pipe(responseContent);
            } else {
                // Since previous versions didn't check for Content-Encoding header,
                // ignore any invalid values to preserve backwards-compatibility
                if (contentEncoding !== "identity") debug("ignoring unrecognized Content-Encoding " + contentEncoding);
                responseContent = response;
            }
        } else responseContent = response;
        if (self.encoding) {
            if (self.dests.length !== 0) console.error("Ignoring encoding parameter as this stream is being piped to another stream which makes the encoding option invalid.");
            else responseContent.setEncoding(self.encoding);
        }
        if (self._paused) responseContent.pause();
        self.responseContent = responseContent;
        self.emit("response", response);
        self.dests.forEach(function(dest) {
            self.pipeDest(dest);
        });
        responseContent.on("data", function(chunk) {
            if (self.timing && !self.responseStarted) {
                self.responseStartTime = new Date().getTime();
                // NOTE: responseStartTime is deprecated in favor of .timings
                response.responseStartTime = self.responseStartTime;
            }
            self._destdata = true;
            self.emit("data", chunk);
        });
        responseContent.once("end", function(chunk) {
            self.emit("end", chunk);
        });
        responseContent.on("error", function(error) {
            self.emit("error", error);
        });
        responseContent.on("close", function() {
            self.emit("close");
        });
        if (self.callback) self.readResponseBody(response);
        else self.on("end", function() {
            if (self._aborted) {
                debug("aborted", self.uri.href);
                return;
            }
            self.emit("complete", response);
        });
    }
    debug("finish init function", self.uri.href);
};
Request.prototype.readResponseBody = function(response) {
    var self = this;
    debug("reading response's body");
    var buffers = [];
    var bufferLength = 0;
    var strings = [];
    self.on("data", function(chunk) {
        if (!Buffer.isBuffer(chunk)) strings.push(chunk);
        else if (chunk.length) {
            bufferLength += chunk.length;
            buffers.push(chunk);
        }
    });
    self.on("end", function() {
        debug("end event", self.uri.href);
        if (self._aborted) {
            debug("aborted", self.uri.href);
            // `buffer` is defined in the parent scope and used in a closure it exists for the life of the request.
            // This can lead to leaky behavior if the user retains a reference to the request object.
            buffers = [];
            bufferLength = 0;
            return;
        }
        if (bufferLength) {
            debug("has body", self.uri.href, bufferLength);
            response.body = Buffer.concat(buffers, bufferLength);
            if (self.encoding !== null) response.body = response.body.toString(self.encoding);
            // `buffer` is defined in the parent scope and used in a closure it exists for the life of the Request.
            // This can lead to leaky behavior if the user retains a reference to the request object.
            buffers = [];
            bufferLength = 0;
        } else if (strings.length) {
            // The UTF8 BOM [0xEF,0xBB,0xBF] is converted to [0xFE,0xFF] in the JS UTC16/UCS2 representation.
            // Strip this value out when the encoding is set to 'utf8', as upstream consumers won't expect it and it breaks JSON.parse().
            if (self.encoding === "utf8" && strings[0].length > 0 && strings[0][0] === "\uFEFF") strings[0] = strings[0].substring(1);
            response.body = strings.join("");
        }
        if (self._json) try {
            response.body = JSON.parse(response.body, self._jsonReviver);
        } catch (e) {
            debug("invalid JSON received", self.uri.href);
        }
        debug("emitting complete", self.uri.href);
        if (typeof response.body === "undefined" && !self._json) response.body = self.encoding === null ? Buffer.alloc(0) : "";
        self.emit("complete", response, response.body);
    });
};
Request.prototype.abort = function() {
    var self = this;
    self._aborted = true;
    if (self.req) self.req.abort();
    else if (self.response) self.response.destroy();
    self.clearTimeout();
    self.emit("abort");
};
Request.prototype.pipeDest = function(dest) {
    var self = this;
    var response = self.response;
    // Called after the response is received
    if (dest.headers && !dest.headersSent) {
        if (response.caseless.has("content-type")) {
            var ctname = response.caseless.has("content-type");
            if (dest.setHeader) dest.setHeader(ctname, response.headers[ctname]);
            else dest.headers[ctname] = response.headers[ctname];
        }
        if (response.caseless.has("content-length")) {
            var clname = response.caseless.has("content-length");
            if (dest.setHeader) dest.setHeader(clname, response.headers[clname]);
            else dest.headers[clname] = response.headers[clname];
        }
    }
    if (dest.setHeader && !dest.headersSent) {
        for(var i in response.headers)// If the response content is being decoded, the Content-Encoding header
        // of the response doesn't represent the piped content, so don't pass it.
        if (!self.gzip || i !== "content-encoding") dest.setHeader(i, response.headers[i]);
        dest.statusCode = response.statusCode;
    }
    if (self.pipefilter) self.pipefilter(response, dest);
};
Request.prototype.qs = function(q, clobber) {
    var self = this;
    var base;
    if (!clobber && self.uri.query) base = self._qs.parse(self.uri.query);
    else base = {};
    for(var i in q)base[i] = q[i];
    var qs = self._qs.stringify(base);
    if (qs === "") return self;
    self.uri = url.parse(self.uri.href.split("?")[0] + "?" + qs);
    self.url = self.uri;
    self.path = self.uri.path;
    if (self.uri.host === "unix") self.enableUnixSocket();
    return self;
};
Request.prototype.form = function(form) {
    var self = this;
    if (form) {
        if (!/^application\/x-www-form-urlencoded\b/.test(self.getHeader("content-type"))) self.setHeader("content-type", "application/x-www-form-urlencoded");
        self.body = typeof form === "string" ? self._qs.rfc3986(form.toString("utf8")) : self._qs.stringify(form).toString("utf8");
        return self;
    }
    // create form-data object
    self._form = new FormData();
    self._form.on("error", function(err) {
        err.message = "form-data: " + err.message;
        self.emit("error", err);
        self.abort();
    });
    return self._form;
};
Request.prototype.multipart = function(multipart) {
    var self = this;
    self._multipart.onRequest(multipart);
    if (!self._multipart.chunked) self.body = self._multipart.body;
    return self;
};
Request.prototype.json = function(val) {
    var self = this;
    if (!self.hasHeader("accept")) self.setHeader("accept", "application/json");
    if (typeof self.jsonReplacer === "function") self._jsonReplacer = self.jsonReplacer;
    self._json = true;
    if (typeof val === "boolean") {
        if (self.body !== undefined) {
            if (!/^application\/x-www-form-urlencoded\b/.test(self.getHeader("content-type"))) self.body = safeStringify(self.body, self._jsonReplacer);
            else self.body = self._qs.rfc3986(self.body);
            if (!self.hasHeader("content-type")) self.setHeader("content-type", "application/json");
        }
    } else {
        self.body = safeStringify(val, self._jsonReplacer);
        if (!self.hasHeader("content-type")) self.setHeader("content-type", "application/json");
    }
    if (typeof self.jsonReviver === "function") self._jsonReviver = self.jsonReviver;
    return self;
};
Request.prototype.getHeader = function(name, headers) {
    var self = this;
    var result, re, match;
    if (!headers) headers = self.headers;
    Object.keys(headers).forEach(function(key) {
        if (key.length !== name.length) return;
        re = new RegExp(name, "i");
        match = key.match(re);
        if (match) result = headers[key];
    });
    return result;
};
Request.prototype.enableUnixSocket = function() {
    // Get the socket & request paths from the URL
    var unixParts = this.uri.path.split(":");
    var host = unixParts[0];
    var path = unixParts[1];
    // Apply unix properties to request
    this.socketPath = host;
    this.uri.pathname = path;
    this.uri.path = path;
    this.uri.host = host;
    this.uri.hostname = host;
    this.uri.isUnix = true;
};
Request.prototype.auth = function(user, pass, sendImmediately, bearer) {
    var self = this;
    self._auth.onRequest(user, pass, sendImmediately, bearer);
    return self;
};
Request.prototype.aws = function(opts, now) {
    var self = this;
    if (!now) {
        self._aws = opts;
        return self;
    }
    if (opts.sign_version === 4 || opts.sign_version === "4") {
        // use aws4
        var options = {
            host: self.uri.host,
            path: self.uri.path,
            method: self.method,
            headers: self.headers,
            body: self.body
        };
        if (opts.service) options.service = opts.service;
        var signRes = aws4.sign(options, {
            accessKeyId: opts.key,
            secretAccessKey: opts.secret,
            sessionToken: opts.session
        });
        self.setHeader("authorization", signRes.headers.Authorization);
        self.setHeader("x-amz-date", signRes.headers["X-Amz-Date"]);
        if (signRes.headers["X-Amz-Security-Token"]) self.setHeader("x-amz-security-token", signRes.headers["X-Amz-Security-Token"]);
    } else {
        // default: use aws-sign2
        var date = new Date();
        self.setHeader("date", date.toUTCString());
        var auth = {
            key: opts.key,
            secret: opts.secret,
            verb: self.method.toUpperCase(),
            date: date,
            contentType: self.getHeader("content-type") || "",
            md5: self.getHeader("content-md5") || "",
            amazonHeaders: aws2.canonicalizeHeaders(self.headers)
        };
        var path = self.uri.path;
        if (opts.bucket && path) auth.resource = "/" + opts.bucket + path;
        else if (opts.bucket && !path) auth.resource = "/" + opts.bucket;
        else if (!opts.bucket && path) auth.resource = path;
        else if (!opts.bucket && !path) auth.resource = "/";
        auth.resource = aws2.canonicalizeResource(auth.resource);
        self.setHeader("authorization", aws2.authorization(auth));
    }
    return self;
};
Request.prototype.httpSignature = function(opts) {
    var self = this;
    httpSignature.signRequest({
        getHeader: function(header) {
            return self.getHeader(header, self.headers);
        },
        setHeader: function(header, value) {
            self.setHeader(header, value);
        },
        method: self.method,
        path: self.path
    }, opts);
    debug("httpSignature authorization", self.getHeader("authorization"));
    return self;
};
Request.prototype.hawk = function(opts) {
    var self = this;
    self.setHeader("Authorization", hawk.header(self.uri, self.method, opts));
};
Request.prototype.oauth = function(_oauth) {
    var self = this;
    self._oauth.onRequest(_oauth);
    return self;
};
Request.prototype.jar = function(jar) {
    var self = this;
    var cookies;
    if (self._redirect.redirectsFollowed === 0) self.originalCookieHeader = self.getHeader("cookie");
    if (!jar) {
        // disable cookies
        cookies = false;
        self._disableCookies = true;
    } else {
        var targetCookieJar = jar.getCookieString ? jar : globalCookieJar;
        var urihref = self.uri.href;
        // fetch cookie in the Specified host
        if (targetCookieJar) cookies = targetCookieJar.getCookieString(urihref);
    }
    // if need cookie and cookie is not empty
    if (cookies && cookies.length) {
        if (self.originalCookieHeader) // Don't overwrite existing Cookie header
        self.setHeader("cookie", self.originalCookieHeader + "; " + cookies);
        else self.setHeader("cookie", cookies);
    }
    self._jar = jar;
    return self;
};
// Stream API
Request.prototype.pipe = function(dest, opts) {
    var self = this;
    if (self.response) {
        if (self._destdata) self.emit("error", new Error("You cannot pipe after data has been emitted from the response."));
        else if (self._ended) self.emit("error", new Error("You cannot pipe after the response has been ended."));
        else {
            stream.Stream.prototype.pipe.call(self, dest, opts);
            self.pipeDest(dest);
            return dest;
        }
    } else {
        self.dests.push(dest);
        stream.Stream.prototype.pipe.call(self, dest, opts);
        return dest;
    }
};
Request.prototype.write = function() {
    var self = this;
    if (self._aborted) return;
    if (!self._started) self.start();
    if (self.req) return self.req.write.apply(self.req, arguments);
};
Request.prototype.end = function(chunk) {
    var self = this;
    if (self._aborted) return;
    if (chunk) self.write(chunk);
    if (!self._started) self.start();
    if (self.req) self.req.end();
};
Request.prototype.pause = function() {
    var self = this;
    if (!self.responseContent) self._paused = true;
    else self.responseContent.pause.apply(self.responseContent, arguments);
};
Request.prototype.resume = function() {
    var self = this;
    if (!self.responseContent) self._paused = false;
    else self.responseContent.resume.apply(self.responseContent, arguments);
};
Request.prototype.destroy = function() {
    var self = this;
    this.clearTimeout();
    if (!self._ended) self.end();
    else if (self.response) self.response.destroy();
};
Request.prototype.clearTimeout = function() {
    if (this.timeoutTimer) {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
};
Request.defaultProxyHeaderWhiteList = Tunnel.defaultProxyHeaderWhiteList.slice();
Request.defaultProxyHeaderExclusiveList = Tunnel.defaultProxyHeaderExclusiveList.slice();
// Exports
Request.prototype.toJSON = requestToJSON;
module.exports = Request;

},{"d979b16233e081c4":"cbdR9","3f79bc13a691ab97":"8PzwZ","738bda9f257316fd":"eSLai","6e449b3c39ca221d":"dJawj","a17b9582363bd5b8":"4ooMZ","15779b1c30716e3b":"jfqXR","affff3f4c59e7066":"1BCSp","3d2458cc535a5dab":"7JMCE","9704c84bd84e259a":"62xpX","8adc7bc65a9e9af5":"brM3d","fa8be9166031f505":"bFaGJ","4a143b5f036e147c":"3bEaC","3dd1ce1011d3a7b4":"65ggs","41f47de97d52aebb":"3ZGTo","14763535ed82d2ed":"gQPoJ","d3c8e72ec9e3c261":"cjuX2","67e403c0190cbea9":"37SAC","9697145101411ed9":"fWA8Q","2e9049162cbe7d64":"rJJlY","3824ea3a12e5d938":"gpgkX","7301313a3b01e791":"aBs4M","538bd392c402dc76":"lrQRC","e4657f91274e3930":"3JiAi","8cdcfcea60ddd2a6":"cHBOz","847def4faeb4a2cc":"lAyLo","4b29cb5cfa9c8383":"i5geS","bab9ab3fc01bd572":"uwodf","cd3a2a0185d27c7e":"63eDT","79fd6d2a630a066d":"fFdLZ"}],"cbdR9":[function(require,module,exports) {
var global = arguments[3];
var ClientRequest = require("83d28c734ca853c7");
var response = require("48c6aa21794e4a2c");
var extend = require("cc32961fe07c8fa5");
var statusCodes = require("381164753d333ab6");
var url = require("6039c69b7d2da501");
var http = exports;
http.request = function(opts, cb) {
    if (typeof opts === "string") opts = url.parse(opts);
    else opts = extend(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? "http:" : "";
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || "/";
    // Necessary for IPv6 addresses
    if (host && host.indexOf(":") !== -1) host = "[" + host + "]";
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + "//" + host : "") + (port ? ":" + port : "") + path;
    opts.method = (opts.method || "GET").toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new ClientRequest(opts);
    if (cb) req.on("response", cb);
    return req;
};
http.get = function get(opts, cb) {
    var req = http.request(opts, cb);
    req.end();
    return req;
};
http.ClientRequest = ClientRequest;
http.IncomingMessage = response.IncomingMessage;
http.Agent = function() {};
http.Agent.defaultMaxSockets = 4;
http.globalAgent = new http.Agent();
http.STATUS_CODES = statusCodes;
http.METHODS = [
    "CHECKOUT",
    "CONNECT",
    "COPY",
    "DELETE",
    "GET",
    "HEAD",
    "LOCK",
    "M-SEARCH",
    "MERGE",
    "MKACTIVITY",
    "MKCOL",
    "MOVE",
    "NOTIFY",
    "OPTIONS",
    "PATCH",
    "POST",
    "PROPFIND",
    "PROPPATCH",
    "PURGE",
    "PUT",
    "REPORT",
    "SEARCH",
    "SUBSCRIBE",
    "TRACE",
    "UNLOCK",
    "UNSUBSCRIBE"
];

},{"83d28c734ca853c7":"5hx3R","48c6aa21794e4a2c":"4D3vR","cc32961fe07c8fa5":"4ptdQ","381164753d333ab6":"hnQzq","6039c69b7d2da501":"eSLai"}],"5hx3R":[function(require,module,exports) {
var Buffer = require("171a808a93d7935a").Buffer;
var global = arguments[3];
var process = require("a9ea3f73cd8e4ec0");
var capability = require("47a5b3351a25523b");
var inherits = require("33d332b21b1041");
var response = require("90881d49dd53d428");
var stream = require("c817ce87e1330fb2");
var IncomingMessage = response.IncomingMessage;
var rStates = response.readyStates;
function decideMode(preferBinary, useFetch) {
    if (capability.fetch && useFetch) return "fetch";
    else if (capability.mozchunkedarraybuffer) return "moz-chunked-arraybuffer";
    else if (capability.msstream) return "ms-stream";
    else if (capability.arraybuffer && preferBinary) return "arraybuffer";
    else return "text";
}
var ClientRequest = module.exports = function(opts) {
    var self = this;
    stream.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader("Authorization", "Basic " + Buffer.from(opts.auth).toString("base64"));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === "disable-fetch" || "requestTimeout" in opts && !capability.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === "prefer-streaming") // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === "allow-wrong-content-type") // If streaming is more important than preserving the 'content-type' header
    preferBinary = !capability.overrideMimeType;
    else if (!opts.mode || opts.mode === "default" || opts.mode === "prefer-fast") // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error("Invalid value for opts.mode");
    self._mode = decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on("finish", function() {
        self._onFinish();
    });
};
inherits(ClientRequest, stream.Writable);
ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if (unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ("timeout" in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== "GET" && opts.method !== "HEAD") body = new Blob(self._body, {
        type: (headersObj["content-type"] || {}).value || ""
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === "fetch") {
        var signal = null;
        if (capability.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ("requestTimeout" in opts && opts.requestTimeout !== 0) self._fetchTimer = global.setTimeout(function() {
                self.emit("requestTimeout");
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: "cors",
            credentials: opts.withCredentials ? "include" : "same-origin",
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit("error", reason);
        });
    } else {
        var xhr = self._xhr = new global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            process.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ("responseType" in xhr) xhr.responseType = self._mode;
        if ("withCredentials" in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === "text" && "overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        if ("requestTimeout" in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit("requestTimeout");
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case rStates.LOADING:
                case rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === "moz-chunked-arraybuffer") xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit("error", new Error("XHR error"));
        };
        try {
            xhr.send(body);
        } catch (err) {
            process.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on("error", function(err) {
        self.emit("error", err);
    });
    self.emit("response", self._response);
};
ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = global.setTimeout(function() {
        self.emit("timeout");
    }, self._socketTimeout);
};
ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit("error", err);
};
ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === "function") {
        cb = data;
        data = undefined;
    }
    stream.Writable.prototype.end.call(self, data, encoding, cb);
};
ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once("timeout", cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
ClientRequest.prototype.flushHeaders = function() {};
ClientRequest.prototype.setNoDelay = function() {};
ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
    "accept-charset",
    "accept-encoding",
    "access-control-request-headers",
    "access-control-request-method",
    "connection",
    "content-length",
    "cookie",
    "cookie2",
    "date",
    "dnt",
    "expect",
    "host",
    "keep-alive",
    "origin",
    "referer",
    "te",
    "trailer",
    "transfer-encoding",
    "upgrade",
    "via"
];

},{"171a808a93d7935a":"8EcTH","a9ea3f73cd8e4ec0":"g1F5c","47a5b3351a25523b":"gLQX4","33d332b21b1041":"crNcs","90881d49dd53d428":"4D3vR","c817ce87e1330fb2":"2uFsi"}],"gLQX4":[function(require,module,exports) {
var global = arguments[3];
exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream);
exports.writableStream = isFunction(global.WritableStream);
exports.abortController = isFunction(global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr;
function getXHR() {
    // Cache the xhr value
    if (xhr !== undefined) return xhr;
    if (global.XMLHttpRequest) {
        xhr = new global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            xhr.open("GET", global.XDomainRequest ? "/" : "https://example.com");
        } catch (e) {
            xhr = null;
        }
    } else // Service workers don't have XHR
    xhr = null;
    return xhr;
}
function checkTypeSupport(type) {
    var xhr = getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || checkTypeSupport("arraybuffer");
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && checkTypeSupport("ms-stream");
exports.mozchunkedarraybuffer = !exports.fetch && checkTypeSupport("moz-chunked-arraybuffer");
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false);
function isFunction(value) {
    return typeof value === "function";
}
xhr = null // Help gc
;

},{}],"4D3vR":[function(require,module,exports) {
var process = require("d1269065c33ee7fe");
var Buffer = require("77d4ce6cf763caca").Buffer;
var global = arguments[3];
var capability = require("7dcf7aadbb533bfb");
var inherits = require("57b1383434ef92a1");
var stream = require("fa2873d490014c0a");
var rStates = exports.readyStates = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var IncomingMessage = exports.IncomingMessage = function(xhr, response, mode, resetTimers) {
    var self = this;
    stream.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on("end", function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        process.nextTick(function() {
            self.emit("close");
        });
    });
    if (mode === "fetch") {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if (capability.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push(Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push(Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit("error", err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === "set-cookie") {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ", " + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = "x-user-defined";
        if (!capability.overrideMimeType) {
            var mimeType = self.rawHeaders["mime-type"];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = "utf-8" // best guess
            ;
        }
    }
};
inherits(IncomingMessage, stream.Readable);
IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case "text":
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === "x-user-defined") {
                    var buffer = Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case "arraybuffer":
            if (xhr.readyState !== rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push(Buffer.from(new Uint8Array(response)));
            break;
        case "moz-chunked-arraybuffer":
            response = xhr.response;
            if (xhr.readyState !== rStates.LOADING || !response) break;
            self.push(Buffer.from(new Uint8Array(response)));
            break;
        case "ms-stream":
            response = xhr.response;
            if (xhr.readyState !== rStates.LOADING) break;
            var reader = new global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push(Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === rStates.DONE && self._mode !== "ms-stream") {
        resetTimers(true);
        self.push(null);
    }
};

},{"d1269065c33ee7fe":"g1F5c","77d4ce6cf763caca":"8EcTH","7dcf7aadbb533bfb":"gLQX4","57b1383434ef92a1":"crNcs","fa2873d490014c0a":"2uFsi"}],"2uFsi":[function(require,module,exports) {
exports = module.exports = require("c74e5de41ca826");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require("bf0f0d14a40f11a7");
exports.Duplex = require("995bdd3096227fca");
exports.Transform = require("b848b428897d939e");
exports.PassThrough = require("449f96903554bc8c");
exports.finished = require("6c1f5cf9929b6076");
exports.pipeline = require("1766b9eeff8e97a7");

},{"c74e5de41ca826":"bYBxV","bf0f0d14a40f11a7":"82D20","995bdd3096227fca":"6kzEQ","b848b428897d939e":"563Oz","449f96903554bc8c":"iioZM","6c1f5cf9929b6076":"3vC9P","1766b9eeff8e97a7":"b2Owr"}],"bYBxV":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("3c73226e5520f7c2");
"use strict";
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("95de27315df2b991").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("f12953d9430fb78c");
/*</replacement>*/ var Buffer = require("8eecdd0f2a105365").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("72f3cd4297a5225f");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("18e3f9467ff3ad81");
var destroyImpl = require("1e096f3aa2039e45");
var _require = require("cdcc34e04f92805"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("e5a9b89953fd335d").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("a72247f719872664")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("305098b77017891c");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("a346b6bdd247bae8").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("305098b77017891c");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("a346b6bdd247bae8").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("8d90b8ab1a11c283");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("503d5578125d44bf");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"3c73226e5520f7c2":"g1F5c","95de27315df2b991":"gB3zd","f12953d9430fb78c":"8CZJK","8eecdd0f2a105365":"8EcTH","72f3cd4297a5225f":"49Rpi","18e3f9467ff3ad81":"cWZIb","1e096f3aa2039e45":"jrqMb","cdcc34e04f92805":"FUy9P","e5a9b89953fd335d":"8hZFT","a72247f719872664":"crNcs","305098b77017891c":"6kzEQ","a346b6bdd247bae8":"kuGw1","8d90b8ab1a11c283":"fiVCc","503d5578125d44bf":"ioqcb"}],"8CZJK":[function(require,module,exports) {
module.exports = require("86f629823b63c792").EventEmitter;

},{"86f629823b63c792":"gB3zd"}],"cWZIb":[function(require,module,exports) {
"use strict";
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("17803bd5fec02b5c"), Buffer = _require.Buffer;
var _require2 = require("5ddcfb11ad1e4bbd"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || "inspect";
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"17803bd5fec02b5c":"8EcTH","5ddcfb11ad1e4bbd":"49Rpi"}],"jrqMb":[function(require,module,exports) {
var process = require("6a8980c10848df21");
"use strict";
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"6a8980c10848df21":"g1F5c"}],"FUy9P":[function(require,module,exports) {
"use strict";
var ERR_INVALID_OPT_VALUE = require("b6b8d60182fe9495").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"b6b8d60182fe9495":"8hZFT"}],"8hZFT":[function(require,module,exports) {
"use strict";
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
module.exports.codes = codes;

},{}],"6kzEQ":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("ad775308843013bf");
"use strict";
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("4a13d5b01b42774b");
var Writable = require("ef06c82956c22965");
require("34f04e8abfee88c2")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"ad775308843013bf":"g1F5c","4a13d5b01b42774b":"bYBxV","ef06c82956c22965":"82D20","34f04e8abfee88c2":"crNcs"}],"82D20":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("7f276b09e75c7f05");
"use strict";
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("fdf5fe44cf88f64c")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("dd7024a3b06fd6ca");
/*</replacement>*/ var Buffer = require("cd9ec95af26033ea").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("3ccb44ecec086460");
var _require = require("ff634725c95e63dc"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("143833924d4c9637").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("b6e4cf8c6c3f8afd")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("6add22a3405da30f");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("6add22a3405da30f");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"7f276b09e75c7f05":"g1F5c","fdf5fe44cf88f64c":"75uxo","dd7024a3b06fd6ca":"8CZJK","cd9ec95af26033ea":"8EcTH","3ccb44ecec086460":"jrqMb","ff634725c95e63dc":"FUy9P","143833924d4c9637":"8hZFT","b6e4cf8c6c3f8afd":"crNcs","6add22a3405da30f":"6kzEQ"}],"fiVCc":[function(require,module,exports) {
var process = require("8574dcfec0339259");
"use strict";
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("1e0423235b33b35e");
var kLastResolve = Symbol("lastResolve");
var kLastReject = Symbol("lastReject");
var kError = Symbol("error");
var kEnded = Symbol("ended");
var kLastPromise = Symbol("lastPromise");
var kHandlePromise = Symbol("handlePromise");
var kStream = Symbol("stream");
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on("readable", onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"8574dcfec0339259":"g1F5c","1e0423235b33b35e":"3vC9P"}],"3vC9P":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var ERR_STREAM_PREMATURE_CLOSE = require("3d64c9f807431cd1").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos(stream, opts, callback) {
    if (typeof opts === "function") return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = eos;

},{"3d64c9f807431cd1":"8hZFT"}],"ioqcb":[function(require,module,exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

},{}],"563Oz":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var _require$codes = require("77422d6b056f22d1").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("efc5f4fe2e7ff8a1");
require("c40ef4ba0e8fd673")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"77422d6b056f22d1":"8hZFT","efc5f4fe2e7ff8a1":"6kzEQ","c40ef4ba0e8fd673":"crNcs"}],"iioZM":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("f16b780ad0aa2651");
require("898071f4ba229c31")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"f16b780ad0aa2651":"563Oz","898071f4ba229c31":"crNcs"}],"b2Owr":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("6d787c6203a38a93").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = require("4789b277a8df993d");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"6d787c6203a38a93":"8hZFT","4789b277a8df993d":"3vC9P"}],"4ptdQ":[function(require,module,exports) {
module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

},{}],"hnQzq":[function(require,module,exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

},{}],"8PzwZ":[function(require,module,exports) {
var http = require("c0383d0f5be55d6b");
var url = require("23c94c23cc2fc416");
var https = module.exports;
for(var key in http)if (http.hasOwnProperty(key)) https[key] = http[key];
https.request = function(params, cb) {
    params = validateParams(params);
    return http.request.call(this, params, cb);
};
https.get = function(params, cb) {
    params = validateParams(params);
    return http.get.call(this, params, cb);
};
function validateParams(params) {
    if (typeof params === "string") params = url.parse(params);
    if (!params.protocol) params.protocol = "https:";
    if (params.protocol !== "https:") throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

},{"c0383d0f5be55d6b":"cbdR9","23c94c23cc2fc416":"eSLai"}],"jfqXR":[function(require,module,exports) {
var process = require("85b5e5b1fe9ac2d6");
"use strict";
var Buffer = require("b45d57ded3095448").Buffer;
var Transform = require("302f6ba8c9b288cd").Transform;
var binding = require("18c3507b0ec1fd53");
var util = require("eb7830382781fd77");
var assert = require("6d05aa73f6370f9e").ok;
var kMaxLength = require("b45d57ded3095448").kMaxLength;
var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes";
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16384;
binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;
binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var bkeys = Object.keys(binding);
for(var bk = 0; bk < bkeys.length; bk++){
    var bkey = bkeys[bk];
    if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
        enumerable: true,
        value: binding[bkey],
        writable: false
    });
}
// translation table for return codes.
var codes = {
    Z_OK: binding.Z_OK,
    Z_STREAM_END: binding.Z_STREAM_END,
    Z_NEED_DICT: binding.Z_NEED_DICT,
    Z_ERRNO: binding.Z_ERRNO,
    Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
    Z_DATA_ERROR: binding.Z_DATA_ERROR,
    Z_MEM_ERROR: binding.Z_MEM_ERROR,
    Z_BUF_ERROR: binding.Z_BUF_ERROR,
    Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};
var ckeys = Object.keys(codes);
for(var ck = 0; ck < ckeys.length; ck++){
    var ckey = ckeys[ck];
    codes[codes[ckey]] = ckey;
}
Object.defineProperty(exports, "codes", {
    enumerable: true,
    value: Object.freeze(codes),
    writable: false
});
exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;
exports.createDeflate = function(o) {
    return new Deflate(o);
};
exports.createInflate = function(o) {
    return new Inflate(o);
};
exports.createDeflateRaw = function(o) {
    return new DeflateRaw(o);
};
exports.createInflateRaw = function(o) {
    return new InflateRaw(o);
};
exports.createGzip = function(o) {
    return new Gzip(o);
};
exports.createGunzip = function(o) {
    return new Gunzip(o);
};
exports.createUnzip = function(o) {
    return new Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Deflate(opts), buffer, callback);
};
exports.deflateSync = function(buffer, opts) {
    return zlibBufferSync(new Deflate(opts), buffer);
};
exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Gzip(opts), buffer, callback);
};
exports.gzipSync = function(buffer, opts) {
    return zlibBufferSync(new Gzip(opts), buffer);
};
exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};
exports.deflateRawSync = function(buffer, opts) {
    return zlibBufferSync(new DeflateRaw(opts), buffer);
};
exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Unzip(opts), buffer, callback);
};
exports.unzipSync = function(buffer, opts) {
    return zlibBufferSync(new Unzip(opts), buffer);
};
exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Inflate(opts), buffer, callback);
};
exports.inflateSync = function(buffer, opts) {
    return zlibBufferSync(new Inflate(opts), buffer);
};
exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Gunzip(opts), buffer, callback);
};
exports.gunzipSync = function(buffer, opts) {
    return zlibBufferSync(new Gunzip(opts), buffer);
};
exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new InflateRaw(opts), buffer, callback);
};
exports.inflateRawSync = function(buffer, opts) {
    return zlibBufferSync(new InflateRaw(opts), buffer);
};
function zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on("error", onError);
    engine.on("end", onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once("readable", flow);
    }
    function onError(err) {
        engine.removeListener("end", onEnd);
        engine.removeListener("readable", flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
        else buf = Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function zlibBufferSync(engine, buffer) {
    if (typeof buffer === "string") buffer = Buffer.from(buffer);
    if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function Deflate(opts) {
    if (!(this instanceof Deflate)) return new Deflate(opts);
    Zlib.call(this, opts, binding.DEFLATE);
}
function Inflate(opts) {
    if (!(this instanceof Inflate)) return new Inflate(opts);
    Zlib.call(this, opts, binding.INFLATE);
}
// gzip - bigger header, same deflate compression
function Gzip(opts) {
    if (!(this instanceof Gzip)) return new Gzip(opts);
    Zlib.call(this, opts, binding.GZIP);
}
function Gunzip(opts) {
    if (!(this instanceof Gunzip)) return new Gunzip(opts);
    Zlib.call(this, opts, binding.GUNZIP);
}
// raw - no header
function DeflateRaw(opts) {
    if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
    Zlib.call(this, opts, binding.DEFLATERAW);
}
function InflateRaw(opts) {
    if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
    Zlib.call(this, opts, binding.INFLATERAW);
}
// auto-detect header.
function Unzip(opts) {
    if (!(this instanceof Unzip)) return new Unzip(opts);
    Zlib.call(this, opts, binding.UNZIP);
}
function isValidFlushFlag(flag) {
    return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
    Transform.call(this, opts);
    if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
    if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
    this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
    }
    if (opts.dictionary) {
        if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
    }
    this._handle = new binding.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        _close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = exports.codes[errno];
        self.emit("error", error);
    };
    var level = exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === "number") level = opts.level;
    var strategy = exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === "number") strategy = opts.strategy;
    this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once("end", this.close);
    Object.defineProperty(this, "_closed", {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
util.inherits(Zlib, Transform);
Zlib.prototype.params = function(level, strategy, callback) {
    if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
    if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush(binding.Z_SYNC_FLUSH, function() {
            assert(self._handle, "zlib binding closed");
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else process.nextTick(callback);
};
Zlib.prototype.reset = function() {
    assert(this._handle, "zlib binding closed");
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function(callback) {
    this._transform(Buffer.alloc(0), "", callback);
};
Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === "function" || kind === undefined && !callback) {
        callback = kind;
        kind = binding.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) process.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once("end", callback);
    } else if (ws.needDrain) {
        if (callback) this.once("drain", function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write(Buffer.alloc(0), "", callback);
    }
};
Zlib.prototype.close = function(callback) {
    _close(this, callback);
    process.nextTick(emitCloseNT, this);
};
function _close(engine, callback) {
    if (callback) process.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function emitCloseNT(self) {
    self.emit("close");
}
Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
    if (!this._handle) return cb(new Error("zlib binding closed"));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === "function";
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on("error", function(er) {
            error = er;
        });
        assert(this._handle, "zlib binding closed");
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= kMaxLength) {
            _close(this);
            throw new RangeError(kRangeErrorMessage);
        }
        var buf = Buffer.concat(buffers, nread);
        _close(this);
        return buf;
    }
    assert(this._handle, "zlib binding closed");
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        assert(have >= 0, "have should not go down");
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);

},{"85b5e5b1fe9ac2d6":"g1F5c","b45d57ded3095448":"8EcTH","302f6ba8c9b288cd":"4ooMZ","18c3507b0ec1fd53":"ggnMv","eb7830382781fd77":"dJawj","6d05aa73f6370f9e":"fsq0Y"}],"ggnMv":[function(require,module,exports) {
var Buffer = require("c0875ec23d3f711b").Buffer;
var process = require("275b523c6d34b701");
"use strict";
/* eslint camelcase: "off" */ var assert = require("77b161f030b665c6");
var Zstream = require("fd1f09d11ac7dfac");
var zlib_deflate = require("df246bd555afd20e");
var zlib_inflate = require("38e8b32c21318329");
var constants = require("5b80d7a6197bcc1e");
for(var key in constants)exports[key] = constants[key];
// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;
var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function Zlib(mode) {
    if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    assert(this.init_done, "close before init");
    assert(this.mode <= exports.UNZIP);
    if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
    else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
    this.mode = exports.NONE;
    this.dictionary = null;
};
Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    assert.equal(arguments.length, 8);
    assert(this.init_done, "write before init");
    assert(this.mode !== exports.NONE, "already finalized");
    assert.equal(false, this.write_in_progress, "write already in progress");
    assert.equal(false, this.pending_close, "close is pending");
    this.write_in_progress = true;
    assert.equal(false, flush === undefined, "must provide flush value");
    this.write_in_progress = true;
    if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
    if (input == null) {
        input = Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    process.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflate(this.strm, this.flush);
            break;
        case exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = exports.INFLATE;
                    break;
                default:
                    throw new Error("invalid number of gzip magic number bytes read");
            }
        // fallthrough
        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
            this.err = zlib_inflate.inflate(this.strm, this.flush);
            if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === exports.Z_OK) // And try to decode again
                this.err = zlib_inflate.inflate(this.strm, this.flush);
                else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = zlib_inflate.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
};
Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case exports.Z_OK:
        case exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                this._error("unexpected end of file");
                return false;
            }
            break;
        case exports.Z_STREAM_END:
            break;
        case exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error("Missing dictionary");
            else this._error("Bad dictionary");
            return false;
        default:
            // something else.
            this._error("Zlib error");
            return false;
    }
    return true;
};
Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
    assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
    assert(level >= -1 && level <= 9, "invalid compression level");
    assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
    assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
Zlib.prototype.params = function() {
    throw new Error("deflateParams Not supported");
};
Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = exports.Z_NO_FLUSH;
    this.err = exports.Z_OK;
    if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
    if (this.mode === exports.UNZIP) this.windowBits += 32;
    if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new Zstream();
    switch(this.mode){
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
        case exports.UNZIP:
            this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
    if (this.err !== exports.Z_OK) this._error("Init error");
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = exports.Z_OK;
    switch(this.mode){
        case exports.DEFLATE:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
};
Zlib.prototype._reset = function() {
    this.err = exports.Z_OK;
    switch(this.mode){
        case exports.DEFLATE:
        case exports.DEFLATERAW:
        case exports.GZIP:
            this.err = zlib_deflate.deflateReset(this.strm);
            break;
        case exports.INFLATE:
        case exports.INFLATERAW:
        case exports.GUNZIP:
            this.err = zlib_inflate.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
};
exports.Zlib = Zlib;

},{"c0875ec23d3f711b":"8EcTH","275b523c6d34b701":"g1F5c","77b161f030b665c6":"fsq0Y","fd1f09d11ac7dfac":"3vkoF","df246bd555afd20e":"apBnm","38e8b32c21318329":"4oVGd","5b80d7a6197bcc1e":"6iPdo"}],"fsq0Y":[function(require,module,exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("17530e9a8e9dd8de");
"use strict";
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var _require = require("67930e3bebc18ea9"), _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
var AssertionError = require("11bdd262fb706a54");
var _require2 = require("d61a3396666721b6"), inspect = _require2.inspect;
var _require$types = require("d61a3396666721b6").types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
var objectAssign = require("fe81af847d362e93")();
var objectIs = require("4ad4507c8e372c71")();
var RegExpPrototypeTest = require("11f208d8f2e10b17")("RegExp.prototype.test");
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;
function lazyLoadComparison() {
    var comparison = require("131e25d2408617a4");
    isDeepEqual = comparison.isDeepEqual;
    isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var escapeFn = function escapeFn(str) {
    return meta[str.charCodeAt(0)];
};
var warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new AssertionError(obj);
}
function fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if (warned === false) {
            warned = true;
            var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new AssertionError(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
assert.fail = fail;
// The AssertionError is defined in internal/error.
assert.AssertionError = AssertionError;
function innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    innerOk.apply(void 0, [
        ok,
        args.length
    ].concat(args));
}
assert.ok = ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: notDeepStrictEqual
    });
}
assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (!objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var Comparison = /*#__PURE__*/ _createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    _classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new Comparison(actual, keys);
            var b = new Comparison(expected, keys, actual);
            var err = new AssertionError({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if (_typeof(actual) !== "object" || actual === null) {
            var err = new AssertionError({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if (isDeepEqual === undefined) lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key])) return;
            compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function getActual(fn) {
    if (typeof fn !== "function") throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return NO_EXCEPTION_SENTINEL;
}
function checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return isPromise(obj) || obj !== null && _typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if (_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && _typeof(error) !== "object" && typeof error !== "function") throw new ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
}
function expectsNoError(stackStartFn, actual, error, message) {
    if (actual === NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    expectsError.apply(void 0, [
        throws,
        getActual(promiseFn)
    ].concat(args));
};
assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return waitForActual(promiseFn).then(function(result) {
        return expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    expectsNoError.apply(void 0, [
        doesNotThrow,
        getActual(fn)
    ].concat(args));
};
assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return waitForActual(fn).then(function(result) {
        return expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if (_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += inspect(err);
        var newErr = new AssertionError({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function internalMatch(string, regexp, message, fn, fnName) {
    if (!isRegExp(regexp)) throw new ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(_typeof(string), " (").concat(inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(inspect(regexp), ". Input:\n\n").concat(inspect(string), "\n"));
        var err = new AssertionError({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
assert.match = function match(string, regexp, message) {
    internalMatch(string, regexp, message, match, "match");
};
assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    innerOk.apply(void 0, [
        strict,
        args.length
    ].concat(args));
}
assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

},{"17530e9a8e9dd8de":"g1F5c","67930e3bebc18ea9":"gZD22","11bdd262fb706a54":"efvJQ","d61a3396666721b6":"dJawj","fe81af847d362e93":"4XV3C","4ad4507c8e372c71":"l9ZdH","11f208d8f2e10b17":"5RJ3y","131e25d2408617a4":"8AV7e"}],"gZD22":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ "use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var codes = {};
// Lazy loaded
var assert;
var util;
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inherits(NodeError, _Base);
        var _super = _createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            _classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return _createClass(NodeError);
    }(Base);
    codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if (assert === undefined) assert = require("f73a3052b95b9ed");
    assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat(_typeof(actual));
    return msg;
}, TypeError);
createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if (util === undefined) util = require("1fd472100fa8826f");
    var inspected = util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat(_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (assert === undefined) assert = require("f73a3052b95b9ed");
    assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
module.exports.codes = codes;

},{"f73a3052b95b9ed":"fsq0Y","1fd472100fa8826f":"dJawj"}],"efvJQ":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c
var process = require("228da2c254a5e871");
"use strict";
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _require = require("9984e91d63ed614c"), inspect = _require.inspect;
var _require2 = require("1670766d7c5cef96"), ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var blue = "";
var green = "";
var red = "";
var white = "";
var kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var kMaxShortLength = 10;
function copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && _typeof(actual) === "object" && _typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= kMaxShortLength) {
            if ((_typeof(actual) !== "object" || actual === null) && (_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat(repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat(blue, "...").concat(white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat(blue, "...").concat(white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat(blue, "...").concat(white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    _inherits(AssertionError, _Error);
    var _super = _createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        _classCallCheck(this, AssertionError);
        if (_typeof(options) !== "object" || options === null) throw new ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if (process.stderr && process.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
                    blue = "\x1b[34m";
                    green = "\x1b[32m";
                    white = "\x1b[39m";
                    red = "\x1b[31m";
                } else {
                    blue = "";
                    green = "";
                    white = "";
                    red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if (_typeof(actual) === "object" && actual !== null && _typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = copyError(actual);
                expected = copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = kReadableOperator[operator];
                var res = inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && _typeof(actual) === "object" && actual !== null) base = kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat(blue, "...").concat(white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = inspectValue(actual);
                var other = "";
                var knownOperators = kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat(inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty(_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return _possibleConstructorReturn(_this);
    }
    _createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return inspect(this, _objectSpread(_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ _wrapNativeSuper(Error), inspect.custom);
module.exports = AssertionError;

},{"228da2c254a5e871":"g1F5c","9984e91d63ed614c":"dJawj","1670766d7c5cef96":"gZD22"}],"4XV3C":[function(require,module,exports) {
"use strict";
var implementation = require("b7e83063a8ec29e5");
var lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return implementation;
    if (lacksProperEnumerationOrder()) return implementation;
    if (assignHasPendingExceptions()) return implementation;
    return Object.assign;
};

},{"b7e83063a8ec29e5":"8fpUn"}],"8fpUn":[function(require,module,exports) {
"use strict";
// modified from https://github.com/es-shims/es6-shim
var objectKeys = require("334c0bea01e613e6");
var hasSymbols = require("1964e25feb5e87a1")();
var callBound = require("6fb85b5b56dcab21");
var toObject = Object;
var $push = callBound("Array.prototype.push");
var $propIsEnumerable = callBound("Object.prototype.propertyIsEnumerable");
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = objectKeys(from);
        var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($propIsEnumerable(from, key)) $push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

},{"334c0bea01e613e6":"5fDoL","1964e25feb5e87a1":"5Gfra","6fb85b5b56dcab21":"5RJ3y"}],"5fDoL":[function(require,module,exports) {
"use strict";
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"eQG0H","344bb0d7b2568e03":"i05MU"}],"eQG0H":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

},{}],"i05MU":[function(require,module,exports) {
"use strict";
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
    var dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = toStr.call(object) === "[object Function]";
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"b0d8c8b84be91ffd":"eQG0H"}],"l9ZdH":[function(require,module,exports) {
"use strict";
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"57PIc"}],"57PIc":[function(require,module,exports) {
"use strict";
var numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"8AV7e":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var regexFlagsSupported = /a/g.flags !== undefined;
var arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};
var objectIs = Object.is ? Object.is : require("3addb16fbdd05c1c");
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : require("a27e57a3fd2e2e23");
function uncurryThis(f) {
    return f.call.bind(f);
}
var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);
var _require$types = require("4940125679601087").types, isAnyArrayBuffer = _require$types.isAnyArrayBuffer, isArrayBufferView = _require$types.isArrayBufferView, isDate = _require$types.isDate, isMap = _require$types.isMap, isRegExp = _require$types.isRegExp, isSet = _require$types.isSet, isNativeError = _require$types.isNativeError, isBoxedPrimitive = _require$types.isBoxedPrimitive, isNumberObject = _require$types.isNumberObject, isStringObject = _require$types.isStringObject, isBooleanObject = _require$types.isBooleanObject, isBigIntObject = _require$types.isBigIntObject, isSymbolObject = _require$types.isSymbolObject, isFloat32Array = _require$types.isFloat32Array, isFloat64Array = _require$types.isFloat64Array;
function isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function getOwnNonIndexProperties(value) {
    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var ONLY_ENUMERABLE = undefined;
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3;
// Check if they have the same source and flags
function areSimilarRegExps(a, b) {
    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function isEqualBoxedPrimitive(val1, val2) {
    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if (_typeof(val1) !== "object") return typeof val1 === "number" && numberIsNaN(val1) && numberIsNaN(val2);
        if (_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || _typeof(val1) !== "object") {
            if (val2 === null || _typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || _typeof(val2) !== "object") return false;
    }
    var val1Tag = objectToString(val1);
    var val2Tag = objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
        var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
    }
    if (isDate(val1)) {
        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if (isRegExp(val1)) {
        if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) return false;
    } else if (isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if (isArrayBufferView(val1)) {
        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
            if (!areSimilarFloatArrays(val1, val2)) return false;
        } else if (!areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
        var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
    } else if (isSet(val1)) {
        if (!isSet(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsSet);
    } else if (isMap(val1)) {
        if (!isMap(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsMap);
    } else if (isAnyArrayBuffer(val1)) {
        if (!areEqualArrayBuffers(val1, val2)) return false;
    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
    return keyCheck(val1, val2, strict, memos, kNoIterator);
}
function getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return propertyIsEnumerable(val, k);
    });
}
function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if (propertyIsEnumerable(val1, key)) {
                    if (!propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if (propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if (innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function findLooseMatchingPrimitives(prim) {
    switch(_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if (numberIsNaN(prim)) return false;
    }
    return true;
}
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}
function setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if (_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if (_typeof(_val) === "object" && _val !== null) {
                if (!setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if (_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if (_typeof(_key) === "object" && _key !== null) {
                if (!mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !innerDeepEqual(a.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === kIsSet) {
        if (!setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsMap) {
        if (!mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsArray) for(; i < a.length; i++){
        if (hasOwnProperty(a, i)) {
            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if (hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function isDeepEqual(val1, val2) {
    return innerDeepEqual(val1, val2, kLoose);
}
function isDeepStrictEqual(val1, val2) {
    return innerDeepEqual(val1, val2, kStrict);
}
module.exports = {
    isDeepEqual: isDeepEqual,
    isDeepStrictEqual: isDeepStrictEqual
};

},{"3addb16fbdd05c1c":"c643u","a27e57a3fd2e2e23":"aXmlN","4940125679601087":"dJawj"}],"c643u":[function(require,module,exports) {
"use strict";
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"16gnp","794ce1103c4a65ba":"WZ13z","f52a71fcf365d3bd":"57PIc","59addbaef079e040":"l9ZdH","c0e8b0f7342ba484":"4JMAf"}],"16gnp":[function(require,module,exports) {
"use strict";
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = require("84ca194f5a28ce70");
var isFunction = function(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var supportsDescriptors = require("c52d62086511583f")();
var defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) defineDataProperty(object, name, value, true);
    else defineDataProperty(object, name, value);
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"7ff177585d1618f0":"5fDoL","84ca194f5a28ce70":"8XcZz","c52d62086511583f":"k1QDR"}],"4JMAf":[function(require,module,exports) {
"use strict";
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"l9ZdH","155865cffc557cd":"16gnp"}],"aXmlN":[function(require,module,exports) {
"use strict";
var callBind = require("8bc778ead6edc2b");
var define = require("1e9a111647ec40d6");
var implementation = require("db9e8266e38a0a1c");
var getPolyfill = require("37ae20d268339d21");
var shim = require("9fe13ad91d3d9c68");
var polyfill = callBind(getPolyfill(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"8bc778ead6edc2b":"WZ13z","1e9a111647ec40d6":"16gnp","db9e8266e38a0a1c":"kymNs","37ae20d268339d21":"2yvWI","9fe13ad91d3d9c68":"j2JoS"}],"kymNs":[function(require,module,exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

},{}],"2yvWI":[function(require,module,exports) {
"use strict";
var implementation = require("e25466f067cfd8fc");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return implementation;
};

},{"e25466f067cfd8fc":"kymNs"}],"j2JoS":[function(require,module,exports) {
"use strict";
var define = require("6e613ddb8bace1c6");
var getPolyfill = require("f2ce5ac0488eb372");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = getPolyfill();
    define(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

},{"6e613ddb8bace1c6":"16gnp","f2ce5ac0488eb372":"2yvWI"}],"3vkoF":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = ZStream;

},{}],"apBnm":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("6ecd050ab5cf9e92");
var trees = require("b17b4660c9a756a1");
var adler32 = require("8a0173ce93724f81");
var crc32 = require("9fe740ea87b93669");
var msg = require("86729d90d4373c72");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/* The deflate compression method */ var Z_DEFLATED = 8;
/*============================================================================*/ var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var BS_BLOCK_DONE = 2; /* block flush performed */ 
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
}
function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
}
function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    utils.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var configuration_table;
configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new utils.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    trees._tr_init(s);
    return Z_OK;
}
function deflateReset(strm) {
    var ret = deflateResetKeep(strm);
    if (ret === Z_OK) lm_init(strm.state);
    return ret;
}
function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return Z_OK;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return Z_STREAM_ERROR;
    var wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils.Buf8(s.w_size * 2);
    s.head = new utils.Buf16(s.hash_size);
    s.prev = new utils.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new utils.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
}
function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else {
            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
            else if (flush !== Z_BLOCK) {
                trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH) return Z_OK;
    if (s.wrap <= 0) return Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}
function deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new utils.Buf8(s.w_size);
        utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK;
}
exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

},{"6ecd050ab5cf9e92":"4WuQp","b17b4660c9a756a1":"3dcYb","8a0173ce93724f81":"7u9Cs","9fe740ea87b93669":"euuxk","86729d90d4373c72":"bR5k2"}],"4WuQp":[function(require,module,exports) {
"use strict";
var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if (_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function(on) {
    if (on) {
        exports.Buf8 = Uint8Array;
        exports.Buf16 = Uint16Array;
        exports.Buf32 = Int32Array;
        exports.assign(exports, fnTyped);
    } else {
        exports.Buf8 = Array;
        exports.Buf16 = Array;
        exports.Buf32 = Array;
        exports.assign(exports, fnUntyped);
    }
};
exports.setTyped(TYPED_OK);

},{}],"3dcYb":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var utils = require("f7e73d4e313a2bb7");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
var Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/*============================================================================*/ function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
/* The three kinds of block type */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
/* end of block literal code */ var REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function send_code(s, c, tree) {
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s); /* align on byte boundary */ 
    if (header) {
        put_short(s, len);
        put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
}
var static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
exports._tr_init = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"f7e73d4e313a2bb7":"4WuQp"}],"7u9Cs":[function(require,module,exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = adler32;

},{}],"euuxk":[function(require,module,exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();
function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = crc32;

},{}],"bR5k2":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

},{}],"4oVGd":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("3693fcbb98dc8df0");
var adler32 = require("6ebe24dff7c86ec6");
var crc32 = require("733ae5de3dad536a");
var inflate_fast = require("d6c5d4935fa23026");
var inflate_table = require("f4fe87fcccdc3597");
var CODES = 0;
var LENS = 1;
var DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var TIME = 3; /* i: waiting for modification time (gzip) */ 
var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var NAME = 7; /* i: waiting for end of file name (gzip) */ 
var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var HCRC = 9; /* i: waiting for header crc (gzip) */ 
var DICTID = 10; /* i: waiting for dictionary check value */ 
var DICT = 11; /* waiting for inflateSetDictionary() call */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var STORED = 14; /* i: waiting for stored size (length and complement) */ 
var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var LENLENS = 18; /* i: waiting for code length code lengths */ 
var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var LEN = 21; /* i: waiting for length/lit/eob code */ 
var LENEXT = 22; /* i: waiting for length extra bits */ 
var DIST = 23; /* i: waiting for distance code */ 
var DISTEXT = 24; /* i: waiting for distance extra bits */ 
var MATCH = 25; /* o: waiting for output space to copy string */ 
var LIT = 26; /* o: waiting for output space to write literal */ 
var CHECK = 27; /* i: waiting for 32-bit check value */ 
var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var DONE = 29; /* finished check, done -- remain here until reset */ 
var BAD = 30; /* got a data error -- remain here until reset */ 
var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new utils.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
}
function inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
var lenfix, distfix; // We have no pointers in JS, so keep tables separate
function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        var sym;
        lenfix = new utils.Buf32(512);
        distfix = new utils.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
}
function inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
}
function inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
}
exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

},{"3693fcbb98dc8df0":"4WuQp","6ebe24dff7c86ec6":"7u9Cs","733ae5de3dad536a":"euuxk","d6c5d4935fa23026":"C2owT","f4fe87fcccdc3597":"beKH5"}],"C2owT":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var BAD = 30; /* got a data error -- remain here until reset */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

},{}],"beKH5":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("11b3fa99ba8f3902");
var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var CODES = 0;
var LENS = 1;
var DISTS = 2;
var lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === LENS) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

},{"11b3fa99ba8f3902":"4WuQp"}],"6iPdo":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

},{}],"1BCSp":[function(require,module,exports) {
/*!
 *  Copyright 2010 LearnBoost <dev@learnboost.com>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Module dependencies.
 */ var crypto = require("68a0a24d194da6c9"), parse = require("e390769fe91bf4eb").parse;
/**
 * Valid keys.
 */ var keys = [
    "acl",
    "location",
    "logging",
    "notification",
    "partNumber",
    "policy",
    "requestPayment",
    "torrent",
    "uploadId",
    "uploads",
    "versionId",
    "versioning",
    "versions",
    "website"
];
/**
 * Return an "Authorization" header value with the given `options`
 * in the form of "AWS <key>:<signature>"
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */ function authorization(options) {
    return "AWS " + options.key + ":" + sign(options);
}
module.exports = authorization;
module.exports.authorization = authorization;
/**
 * Simple HMAC-SHA1 Wrapper
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */ function hmacSha1(options) {
    return crypto.createHmac("sha1", options.secret).update(options.message).digest("base64");
}
module.exports.hmacSha1 = hmacSha1;
/**
 * Create a base64 sha1 HMAC for `options`. 
 * 
 * @param {Object} options
 * @return {String}
 * @api private
 */ function sign(options) {
    options.message = stringToSign(options);
    return hmacSha1(options);
}
module.exports.sign = sign;
/**
 * Create a base64 sha1 HMAC for `options`. 
 *
 * Specifically to be used with S3 presigned URLs
 * 
 * @param {Object} options
 * @return {String}
 * @api private
 */ function signQuery(options) {
    options.message = queryStringToSign(options);
    return hmacSha1(options);
}
module.exports.signQuery = signQuery;
/**
 * Return a string for sign() with the given `options`.
 *
 * Spec:
 * 
 *    <verb>\n
 *    <md5>\n
 *    <content-type>\n
 *    <date>\n
 *    [headers\n]
 *    <resource>
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */ function stringToSign(options) {
    var headers = options.amazonHeaders || "";
    if (headers) headers += "\n";
    var r = [
        options.verb,
        options.md5,
        options.contentType,
        options.date ? options.date.toUTCString() : "",
        headers + options.resource
    ];
    return r.join("\n");
}
module.exports.stringToSign = stringToSign;
/**
 * Return a string for sign() with the given `options`, but is meant exclusively
 * for S3 presigned URLs
 *
 * Spec:
 * 
 *    <date>\n
 *    <resource>
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */ function queryStringToSign(options) {
    return "GET\n\n\n" + options.date + "\n" + options.resource;
}
module.exports.queryStringToSign = queryStringToSign;
/**
 * Perform the following:
 *
 *  - ignore non-amazon headers
 *  - lowercase fields
 *  - sort lexicographically
 *  - trim whitespace between ":"
 *  - join with newline
 *
 * @param {Object} headers
 * @return {String}
 * @api private
 */ function canonicalizeHeaders(headers) {
    var buf = [], fields = Object.keys(headers);
    for(var i = 0, len = fields.length; i < len; ++i){
        var field = fields[i], val = headers[field], field = field.toLowerCase();
        if (0 !== field.indexOf("x-amz")) continue;
        buf.push(field + ":" + val);
    }
    return buf.sort().join("\n");
}
module.exports.canonicalizeHeaders = canonicalizeHeaders;
/**
 * Perform the following:
 *
 *  - ignore non sub-resources
 *  - sort lexicographically
 *
 * @param {String} resource
 * @return {String}
 * @api private
 */ function canonicalizeResource(resource) {
    var url = parse(resource, true), path = url.pathname, buf = [];
    Object.keys(url.query).forEach(function(key) {
        if (!~keys.indexOf(key)) return;
        var val = "" == url.query[key] ? "" : "=" + encodeURIComponent(url.query[key]);
        buf.push(key + val);
    });
    return path + (buf.length ? "?" + buf.sort().join("&") : "");
}
module.exports.canonicalizeResource = canonicalizeResource;

},{"68a0a24d194da6c9":"8Nkdo","e390769fe91bf4eb":"eSLai"}],"7JMCE":[function(require,module,exports) {
var Buffer = require("110c0bcfab2d0f8e").Buffer;
var aws4 = exports, url = require("a505a1e082840c44"), querystring = require("16bd2d1cd7bb70c5"), crypto = require("a820ed08122a7ac1"), lru = require("c81acca632217b09"), credentialsCache = lru(1000);
// http://docs.amazonwebservices.com/general/latest/gr/signature-version-4.html
function hmac(key, string, encoding) {
    return crypto.createHmac("sha256", key).update(string, "utf8").digest(encoding);
}
function hash(string, encoding) {
    return crypto.createHash("sha256").update(string, "utf8").digest(encoding);
}
// This function assumes the string has already been percent encoded
function encodeRfc3986(urlEncodedString) {
    return urlEncodedString.replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
function encodeRfc3986Full(str) {
    return encodeRfc3986(encodeURIComponent(str));
}
// A bit of a combination of:
// https://github.com/aws/aws-sdk-java-v2/blob/dc695de6ab49ad03934e1b02e7263abbd2354be0/core/auth/src/main/java/software/amazon/awssdk/auth/signer/internal/AbstractAws4Signer.java#L59
// https://github.com/aws/aws-sdk-js/blob/18cb7e5b463b46239f9fdd4a65e2ff8c81831e8f/lib/signers/v4.js#L191-L199
// https://github.com/mhart/aws4fetch/blob/b3aed16b6f17384cf36ea33bcba3c1e9f3bdfefd/src/main.js#L25-L34
var HEADERS_TO_IGNORE = {
    "authorization": true,
    "connection": true,
    "x-amzn-trace-id": true,
    "user-agent": true,
    "expect": true,
    "presigned-expires": true,
    "range": true
};
// request: { path | body, [host], [method], [headers], [service], [region] }
// credentials: { accessKeyId, secretAccessKey, [sessionToken] }
function RequestSigner(request, credentials) {
    if (typeof request === "string") request = url.parse(request);
    var headers = request.headers = request.headers || {}, hostParts = (!this.service || !this.region) && this.matchHost(request.hostname || request.host || headers.Host || headers.host);
    this.request = request;
    this.credentials = credentials || this.defaultCredentials();
    this.service = request.service || hostParts[0] || "";
    this.region = request.region || hostParts[1] || "us-east-1";
    // SES uses a different domain from the service name
    if (this.service === "email") this.service = "ses";
    if (!request.method && request.body) request.method = "POST";
    if (!headers.Host && !headers.host) {
        headers.Host = request.hostname || request.host || this.createHost();
        // If a port is specified explicitly, use it as is
        if (request.port) headers.Host += ":" + request.port;
    }
    if (!request.hostname && !request.host) request.hostname = headers.Host || headers.host;
    this.isCodeCommitGit = this.service === "codecommit" && request.method === "GIT";
    this.extraHeadersToIgnore = request.extraHeadersToIgnore || Object.create(null);
    this.extraHeadersToInclude = request.extraHeadersToInclude || Object.create(null);
}
RequestSigner.prototype.matchHost = function(host) {
    var match = (host || "").match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(\.cn)?$/);
    var hostParts = (match || []).slice(1, 3);
    // ES's hostParts are sometimes the other way round, if the value that is expected
    // to be region equals ‘es’ switch them back
    // e.g. search-cluster-name-aaaa00aaaa0aaa0aaaaaaa0aaa.us-east-1.es.amazonaws.com
    if (hostParts[1] === "es" || hostParts[1] === "aoss") hostParts = hostParts.reverse();
    if (hostParts[1] == "s3") {
        hostParts[0] = "s3";
        hostParts[1] = "us-east-1";
    } else {
        for(var i = 0; i < 2; i++)if (/^s3-/.test(hostParts[i])) {
            hostParts[1] = hostParts[i].slice(3);
            hostParts[0] = "s3";
            break;
        }
    }
    return hostParts;
};
// http://docs.aws.amazon.com/general/latest/gr/rande.html
RequestSigner.prototype.isSingleRegion = function() {
    // Special case for S3 and SimpleDB in us-east-1
    if ([
        "s3",
        "sdb"
    ].indexOf(this.service) >= 0 && this.region === "us-east-1") return true;
    return [
        "cloudfront",
        "ls",
        "route53",
        "iam",
        "importexport",
        "sts"
    ].indexOf(this.service) >= 0;
};
RequestSigner.prototype.createHost = function() {
    var region = this.isSingleRegion() ? "" : "." + this.region, subdomain = this.service === "ses" ? "email" : this.service;
    return subdomain + region + ".amazonaws.com";
};
RequestSigner.prototype.prepareRequest = function() {
    this.parsePath();
    var request = this.request, headers = request.headers, query;
    if (request.signQuery) {
        this.parsedPath.query = query = this.parsedPath.query || {};
        if (this.credentials.sessionToken) query["X-Amz-Security-Token"] = this.credentials.sessionToken;
        if (this.service === "s3" && !query["X-Amz-Expires"]) query["X-Amz-Expires"] = 86400;
        if (query["X-Amz-Date"]) this.datetime = query["X-Amz-Date"];
        else query["X-Amz-Date"] = this.getDateTime();
        query["X-Amz-Algorithm"] = "AWS4-HMAC-SHA256";
        query["X-Amz-Credential"] = this.credentials.accessKeyId + "/" + this.credentialString();
        query["X-Amz-SignedHeaders"] = this.signedHeaders();
    } else {
        if (!request.doNotModifyHeaders && !this.isCodeCommitGit) {
            if (request.body && !headers["Content-Type"] && !headers["content-type"]) headers["Content-Type"] = "application/x-www-form-urlencoded; charset=utf-8";
            if (request.body && !headers["Content-Length"] && !headers["content-length"]) headers["Content-Length"] = Buffer.byteLength(request.body);
            if (this.credentials.sessionToken && !headers["X-Amz-Security-Token"] && !headers["x-amz-security-token"]) headers["X-Amz-Security-Token"] = this.credentials.sessionToken;
            if (this.service === "s3" && !headers["X-Amz-Content-Sha256"] && !headers["x-amz-content-sha256"]) headers["X-Amz-Content-Sha256"] = hash(this.request.body || "", "hex");
            if (headers["X-Amz-Date"] || headers["x-amz-date"]) this.datetime = headers["X-Amz-Date"] || headers["x-amz-date"];
            else headers["X-Amz-Date"] = this.getDateTime();
        }
        delete headers.Authorization;
        delete headers.authorization;
    }
};
RequestSigner.prototype.sign = function() {
    if (!this.parsedPath) this.prepareRequest();
    if (this.request.signQuery) this.parsedPath.query["X-Amz-Signature"] = this.signature();
    else this.request.headers.Authorization = this.authHeader();
    this.request.path = this.formatPath();
    return this.request;
};
RequestSigner.prototype.getDateTime = function() {
    if (!this.datetime) {
        var headers = this.request.headers, date = new Date(headers.Date || headers.date || new Date);
        this.datetime = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
        // Remove the trailing 'Z' on the timestamp string for CodeCommit git access
        if (this.isCodeCommitGit) this.datetime = this.datetime.slice(0, -1);
    }
    return this.datetime;
};
RequestSigner.prototype.getDate = function() {
    return this.getDateTime().substr(0, 8);
};
RequestSigner.prototype.authHeader = function() {
    return [
        "AWS4-HMAC-SHA256 Credential=" + this.credentials.accessKeyId + "/" + this.credentialString(),
        "SignedHeaders=" + this.signedHeaders(),
        "Signature=" + this.signature()
    ].join(", ");
};
RequestSigner.prototype.signature = function() {
    var date = this.getDate(), cacheKey = [
        this.credentials.secretAccessKey,
        date,
        this.region,
        this.service
    ].join(), kDate, kRegion, kService, kCredentials = credentialsCache.get(cacheKey);
    if (!kCredentials) {
        kDate = hmac("AWS4" + this.credentials.secretAccessKey, date);
        kRegion = hmac(kDate, this.region);
        kService = hmac(kRegion, this.service);
        kCredentials = hmac(kService, "aws4_request");
        credentialsCache.set(cacheKey, kCredentials);
    }
    return hmac(kCredentials, this.stringToSign(), "hex");
};
RequestSigner.prototype.stringToSign = function() {
    return [
        "AWS4-HMAC-SHA256",
        this.getDateTime(),
        this.credentialString(),
        hash(this.canonicalString(), "hex")
    ].join("\n");
};
RequestSigner.prototype.canonicalString = function() {
    if (!this.parsedPath) this.prepareRequest();
    var pathStr = this.parsedPath.path, query = this.parsedPath.query, headers = this.request.headers, queryStr = "", normalizePath = this.service !== "s3", decodePath = this.service === "s3" || this.request.doNotEncodePath, decodeSlashesInPath = this.service === "s3", firstValOnly = this.service === "s3", bodyHash;
    if (this.service === "s3" && this.request.signQuery) bodyHash = "UNSIGNED-PAYLOAD";
    else if (this.isCodeCommitGit) bodyHash = "";
    else bodyHash = headers["X-Amz-Content-Sha256"] || headers["x-amz-content-sha256"] || hash(this.request.body || "", "hex");
    if (query) {
        var reducedQuery = Object.keys(query).reduce(function(obj, key) {
            if (!key) return obj;
            obj[encodeRfc3986Full(key)] = !Array.isArray(query[key]) ? query[key] : firstValOnly ? query[key][0] : query[key];
            return obj;
        }, {});
        var encodedQueryPieces = [];
        Object.keys(reducedQuery).sort().forEach(function(key) {
            if (!Array.isArray(reducedQuery[key])) encodedQueryPieces.push(key + "=" + encodeRfc3986Full(reducedQuery[key]));
            else reducedQuery[key].map(encodeRfc3986Full).sort().forEach(function(val) {
                encodedQueryPieces.push(key + "=" + val);
            });
        });
        queryStr = encodedQueryPieces.join("&");
    }
    if (pathStr !== "/") {
        if (normalizePath) pathStr = pathStr.replace(/\/{2,}/g, "/");
        pathStr = pathStr.split("/").reduce(function(path, piece) {
            if (normalizePath && piece === "..") path.pop();
            else if (!normalizePath || piece !== ".") {
                if (decodePath) piece = decodeURIComponent(piece.replace(/\+/g, " "));
                path.push(encodeRfc3986Full(piece));
            }
            return path;
        }, []).join("/");
        if (pathStr[0] !== "/") pathStr = "/" + pathStr;
        if (decodeSlashesInPath) pathStr = pathStr.replace(/%2F/g, "/");
    }
    return [
        this.request.method || "GET",
        pathStr,
        queryStr,
        this.canonicalHeaders() + "\n",
        this.signedHeaders(),
        bodyHash
    ].join("\n");
};
RequestSigner.prototype.canonicalHeaders = function() {
    var headers = this.request.headers;
    function trimAll(header) {
        return header.toString().trim().replace(/\s+/g, " ");
    }
    return Object.keys(headers).filter(function(key) {
        return HEADERS_TO_IGNORE[key.toLowerCase()] == null;
    }).sort(function(a, b) {
        return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    }).map(function(key) {
        return key.toLowerCase() + ":" + trimAll(headers[key]);
    }).join("\n");
};
RequestSigner.prototype.signedHeaders = function() {
    var extraHeadersToInclude = this.extraHeadersToInclude, extraHeadersToIgnore = this.extraHeadersToIgnore;
    return Object.keys(this.request.headers).map(function(key) {
        return key.toLowerCase();
    }).filter(function(key) {
        return extraHeadersToInclude[key] || HEADERS_TO_IGNORE[key] == null && !extraHeadersToIgnore[key];
    }).sort().join(";");
};
RequestSigner.prototype.credentialString = function() {
    return [
        this.getDate(),
        this.region,
        this.service,
        "aws4_request"
    ].join("/");
};
RequestSigner.prototype.defaultCredentials = function() {
    var env = {};
    return {
        accessKeyId: env.AWS_ACCESS_KEY_ID || env.AWS_ACCESS_KEY,
        secretAccessKey: env.AWS_SECRET_ACCESS_KEY || env.AWS_SECRET_KEY,
        sessionToken: env.AWS_SESSION_TOKEN
    };
};
RequestSigner.prototype.parsePath = function() {
    var path = this.request.path || "/";
    // S3 doesn't always encode characters > 127 correctly and
    // all services don't encode characters > 255 correctly
    // So if there are non-reserved chars (and it's not already all % encoded), just encode them all
    if (/[^0-9A-Za-z;,/?:@&=+$\-_.!~*'()#%]/.test(path)) path = encodeURI(decodeURI(path));
    var queryIx = path.indexOf("?"), query = null;
    if (queryIx >= 0) {
        query = querystring.parse(path.slice(queryIx + 1));
        path = path.slice(0, queryIx);
    }
    this.parsedPath = {
        path: path,
        query: query
    };
};
RequestSigner.prototype.formatPath = function() {
    var path = this.parsedPath.path, query = this.parsedPath.query;
    if (!query) return path;
    // Services don't support empty query string keys
    if (query[""] != null) delete query[""];
    return path + "?" + encodeRfc3986(querystring.stringify(query));
};
aws4.RequestSigner = RequestSigner;
aws4.sign = function(request, credentials) {
    return new RequestSigner(request, credentials).sign();
};

},{"110c0bcfab2d0f8e":"8EcTH","a505a1e082840c44":"eSLai","16bd2d1cd7bb70c5":"29QgD","a820ed08122a7ac1":"8Nkdo","c81acca632217b09":"lk22O"}],"lk22O":[function(require,module,exports) {
module.exports = function(size) {
    return new LruCache(size);
};
function LruCache(size) {
    this.capacity = size | 0;
    this.map = Object.create(null);
    this.list = new DoublyLinkedList();
}
LruCache.prototype.get = function(key) {
    var node = this.map[key];
    if (node == null) return undefined;
    this.used(node);
    return node.val;
};
LruCache.prototype.set = function(key, val) {
    var node = this.map[key];
    if (node != null) node.val = val;
    else {
        if (!this.capacity) this.prune();
        if (!this.capacity) return false;
        node = new DoublyLinkedNode(key, val);
        this.map[key] = node;
        this.capacity--;
    }
    this.used(node);
    return true;
};
LruCache.prototype.used = function(node) {
    this.list.moveToFront(node);
};
LruCache.prototype.prune = function() {
    var node = this.list.pop();
    if (node != null) {
        delete this.map[node.key];
        this.capacity++;
    }
};
function DoublyLinkedList() {
    this.firstNode = null;
    this.lastNode = null;
}
DoublyLinkedList.prototype.moveToFront = function(node) {
    if (this.firstNode == node) return;
    this.remove(node);
    if (this.firstNode == null) {
        this.firstNode = node;
        this.lastNode = node;
        node.prev = null;
        node.next = null;
    } else {
        node.prev = null;
        node.next = this.firstNode;
        node.next.prev = node;
        this.firstNode = node;
    }
};
DoublyLinkedList.prototype.pop = function() {
    var lastNode = this.lastNode;
    if (lastNode != null) this.remove(lastNode);
    return lastNode;
};
DoublyLinkedList.prototype.remove = function(node) {
    if (this.firstNode == node) this.firstNode = node.next;
    else if (node.prev != null) node.prev.next = node.next;
    if (this.lastNode == node) this.lastNode = node.prev;
    else if (node.next != null) node.next.prev = node.prev;
};
function DoublyLinkedNode(key, val) {
    this.key = key;
    this.val = val;
    this.prev = null;
    this.next = null;
}

},{}],"62xpX":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
var parser = require("95f3f3a1598376ed");
var signer = require("143ce47b59ae5060");
var verify = require("e71d54898b867195");
var utils = require("98db49d7208a056f");
///--- API
module.exports = {
    parse: parser.parseRequest,
    parseRequest: parser.parseRequest,
    sign: signer.signRequest,
    signRequest: signer.signRequest,
    createSigner: signer.createSigner,
    isSigner: signer.isSigner,
    sshKeyToPEM: utils.sshKeyToPEM,
    sshKeyFingerprint: utils.fingerprint,
    pemToRsaSSHKey: utils.pemToRsaSSHKey,
    verify: verify.verifySignature,
    verifySignature: verify.verifySignature,
    verifyHMAC: verify.verifyHMAC
};

},{"95f3f3a1598376ed":"8LQRB","143ce47b59ae5060":"jOG5s","e71d54898b867195":"9n3Pq","98db49d7208a056f":"g8tYW"}],"8LQRB":[function(require,module,exports) {
// Copyright 2012 Joyent, Inc.  All rights reserved.
var assert = require("a1f7924559dc83c4");
var util = require("8569ef1f86c33ca3");
var utils = require("49ea9856d4557830");
///--- Globals
var HASH_ALGOS = utils.HASH_ALGOS;
var PK_ALGOS = utils.PK_ALGOS;
var HttpSignatureError = utils.HttpSignatureError;
var InvalidAlgorithmError = utils.InvalidAlgorithmError;
var validateAlgorithm = utils.validateAlgorithm;
var State = {
    New: 0,
    Params: 1
};
var ParamsState = {
    Name: 0,
    Quote: 1,
    Value: 2,
    Comma: 3
};
///--- Specific Errors
function ExpiredRequestError(message) {
    HttpSignatureError.call(this, message, ExpiredRequestError);
}
util.inherits(ExpiredRequestError, HttpSignatureError);
function InvalidHeaderError(message) {
    HttpSignatureError.call(this, message, InvalidHeaderError);
}
util.inherits(InvalidHeaderError, HttpSignatureError);
function InvalidParamsError(message) {
    HttpSignatureError.call(this, message, InvalidParamsError);
}
util.inherits(InvalidParamsError, HttpSignatureError);
function MissingHeaderError(message) {
    HttpSignatureError.call(this, message, MissingHeaderError);
}
util.inherits(MissingHeaderError, HttpSignatureError);
function StrictParsingError(message) {
    HttpSignatureError.call(this, message, StrictParsingError);
}
util.inherits(StrictParsingError, HttpSignatureError);
///--- Exported API
module.exports = {
    /**
   * Parses the 'Authorization' header out of an http.ServerRequest object.
   *
   * Note that this API will fully validate the Authorization header, and throw
   * on any error.  It will not however check the signature, or the keyId format
   * as those are specific to your environment.  You can use the options object
   * to pass in extra constraints.
   *
   * As a response object you can expect this:
   *
   *     {
   *       "scheme": "Signature",
   *       "params": {
   *         "keyId": "foo",
   *         "algorithm": "rsa-sha256",
   *         "headers": [
   *           "date" or "x-date",
   *           "digest"
   *         ],
   *         "signature": "base64"
   *       },
   *       "signingString": "ready to be passed to crypto.verify()"
   *     }
   *
   * @param {Object} request an http.ServerRequest.
   * @param {Object} options an optional options object with:
   *                   - clockSkew: allowed clock skew in seconds (default 300).
   *                   - headers: required header names (def: date or x-date)
   *                   - algorithms: algorithms to support (default: all).
   *                   - strict: should enforce latest spec parsing
   *                             (default: false).
   * @return {Object} parsed out object (see above).
   * @throws {TypeError} on invalid input.
   * @throws {InvalidHeaderError} on an invalid Authorization header error.
   * @throws {InvalidParamsError} if the params in the scheme are invalid.
   * @throws {MissingHeaderError} if the params indicate a header not present,
   *                              either in the request headers from the params,
   *                              or not in the params from a required header
   *                              in options.
   * @throws {StrictParsingError} if old attributes are used in strict parsing
   *                              mode.
   * @throws {ExpiredRequestError} if the value of date or x-date exceeds skew.
   */ parseRequest: function parseRequest(request, options) {
        assert.object(request, "request");
        assert.object(request.headers, "request.headers");
        if (options === undefined) options = {};
        if (options.headers === undefined) options.headers = [
            request.headers["x-date"] ? "x-date" : "date"
        ];
        assert.object(options, "options");
        assert.arrayOfString(options.headers, "options.headers");
        assert.optionalFinite(options.clockSkew, "options.clockSkew");
        var authzHeaderName = options.authorizationHeaderName || "authorization";
        if (!request.headers[authzHeaderName]) throw new MissingHeaderError("no " + authzHeaderName + " header " + "present in the request");
        options.clockSkew = options.clockSkew || 300;
        var i = 0;
        var state = State.New;
        var substate = ParamsState.Name;
        var tmpName = "";
        var tmpValue = "";
        var parsed = {
            scheme: "",
            params: {},
            signingString: ""
        };
        var authz = request.headers[authzHeaderName];
        for(i = 0; i < authz.length; i++){
            var c = authz.charAt(i);
            switch(Number(state)){
                case State.New:
                    if (c !== " ") parsed.scheme += c;
                    else state = State.Params;
                    break;
                case State.Params:
                    switch(Number(substate)){
                        case ParamsState.Name:
                            var code = c.charCodeAt(0);
                            // restricted name of A-Z / a-z
                            if (code >= 0x41 && code <= 0x5a || // A-Z
                            code >= 0x61 && code <= 0x7a) tmpName += c;
                            else if (c === "=") {
                                if (tmpName.length === 0) throw new InvalidHeaderError("bad param format");
                                substate = ParamsState.Quote;
                            } else throw new InvalidHeaderError("bad param format");
                            break;
                        case ParamsState.Quote:
                            if (c === '"') {
                                tmpValue = "";
                                substate = ParamsState.Value;
                            } else throw new InvalidHeaderError("bad param format");
                            break;
                        case ParamsState.Value:
                            if (c === '"') {
                                parsed.params[tmpName] = tmpValue;
                                substate = ParamsState.Comma;
                            } else tmpValue += c;
                            break;
                        case ParamsState.Comma:
                            if (c === ",") {
                                tmpName = "";
                                substate = ParamsState.Name;
                            } else throw new InvalidHeaderError("bad param format");
                            break;
                        default:
                            throw new Error("Invalid substate");
                    }
                    break;
                default:
                    throw new Error("Invalid substate");
            }
        }
        if (!parsed.params.headers || parsed.params.headers === "") {
            if (request.headers["x-date"]) parsed.params.headers = [
                "x-date"
            ];
            else parsed.params.headers = [
                "date"
            ];
        } else parsed.params.headers = parsed.params.headers.split(" ");
        // Minimally validate the parsed object
        if (!parsed.scheme || parsed.scheme !== "Signature") throw new InvalidHeaderError('scheme was not "Signature"');
        if (!parsed.params.keyId) throw new InvalidHeaderError("keyId was not specified");
        if (!parsed.params.algorithm) throw new InvalidHeaderError("algorithm was not specified");
        if (!parsed.params.signature) throw new InvalidHeaderError("signature was not specified");
        // Check the algorithm against the official list
        parsed.params.algorithm = parsed.params.algorithm.toLowerCase();
        try {
            validateAlgorithm(parsed.params.algorithm);
        } catch (e) {
            if (e instanceof InvalidAlgorithmError) throw new InvalidParamsError(parsed.params.algorithm + " is not " + "supported");
            else throw e;
        }
        // Build the signingString
        for(i = 0; i < parsed.params.headers.length; i++){
            var h = parsed.params.headers[i].toLowerCase();
            parsed.params.headers[i] = h;
            if (h === "request-line") {
                if (!options.strict) /*
           * We allow headers from the older spec drafts if strict parsing isn't
           * specified in options.
           */ parsed.signingString += request.method + " " + request.url + " HTTP/" + request.httpVersion;
                else /* Strict parsing doesn't allow older draft headers. */ throw new StrictParsingError("request-line is not a valid header with strict parsing enabled.");
            } else if (h === "(request-target)") parsed.signingString += "(request-target): " + request.method.toLowerCase() + " " + request.url;
            else {
                var value = request.headers[h];
                if (value === undefined) throw new MissingHeaderError(h + " was not in the request");
                parsed.signingString += h + ": " + value;
            }
            if (i + 1 < parsed.params.headers.length) parsed.signingString += "\n";
        }
        // Check against the constraints
        var date;
        if (request.headers.date || request.headers["x-date"]) {
            if (request.headers["x-date"]) date = new Date(request.headers["x-date"]);
            else date = new Date(request.headers.date);
            var now = new Date();
            var skew = Math.abs(now.getTime() - date.getTime());
            if (skew > options.clockSkew * 1000) throw new ExpiredRequestError("clock skew of " + skew / 1000 + "s was greater than " + options.clockSkew + "s");
        }
        options.headers.forEach(function(hdr) {
            // Remember that we already checked any headers in the params
            // were in the request, so if this passes we're good.
            if (parsed.params.headers.indexOf(hdr.toLowerCase()) < 0) throw new MissingHeaderError(hdr + " was not a signed header");
        });
        if (options.algorithms) {
            if (options.algorithms.indexOf(parsed.params.algorithm) === -1) throw new InvalidParamsError(parsed.params.algorithm + " is not a supported algorithm");
        }
        parsed.algorithm = parsed.params.algorithm.toUpperCase();
        parsed.keyId = parsed.params.keyId;
        return parsed;
    }
};

},{"a1f7924559dc83c4":"eQsu4","8569ef1f86c33ca3":"dJawj","49ea9856d4557830":"g8tYW"}],"eQsu4":[function(require,module,exports) {
// Copyright (c) 2012, Mark Cavage. All rights reserved.
// Copyright 2015 Joyent, Inc.
var Buffer = require("88df327d751c6d4b").Buffer;
var assert = require("60474a8b9bb163ee");
var Stream = require("19925b3376ffc4b2").Stream;
var util = require("85329a9e947e4ea3");
///--- Globals
/* JSSTYLED */ var UUID_REGEXP = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
///--- Internal
function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function _toss(name, expected, oper, arg, actual) {
    throw new assert.AssertionError({
        message: util.format("%s (%s) is required", name, expected),
        actual: actual === undefined ? typeof arg : actual(arg),
        expected: expected,
        operator: oper || "===",
        stackStartFunction: _toss.caller
    });
}
function _getClass(arg) {
    return Object.prototype.toString.call(arg).slice(8, -1);
}
function noop() {
// Why even bother with asserts?
}
///--- Exports
var types = {
    bool: {
        check: function(arg) {
            return typeof arg === "boolean";
        }
    },
    func: {
        check: function(arg) {
            return typeof arg === "function";
        }
    },
    string: {
        check: function(arg) {
            return typeof arg === "string";
        }
    },
    object: {
        check: function(arg) {
            return typeof arg === "object" && arg !== null;
        }
    },
    number: {
        check: function(arg) {
            return typeof arg === "number" && !isNaN(arg);
        }
    },
    finite: {
        check: function(arg) {
            return typeof arg === "number" && !isNaN(arg) && isFinite(arg);
        }
    },
    buffer: {
        check: function(arg) {
            return Buffer.isBuffer(arg);
        },
        operator: "Buffer.isBuffer"
    },
    array: {
        check: function(arg) {
            return Array.isArray(arg);
        },
        operator: "Array.isArray"
    },
    stream: {
        check: function(arg) {
            return arg instanceof Stream;
        },
        operator: "instanceof",
        actual: _getClass
    },
    date: {
        check: function(arg) {
            return arg instanceof Date;
        },
        operator: "instanceof",
        actual: _getClass
    },
    regexp: {
        check: function(arg) {
            return arg instanceof RegExp;
        },
        operator: "instanceof",
        actual: _getClass
    },
    uuid: {
        check: function(arg) {
            return typeof arg === "string" && UUID_REGEXP.test(arg);
        },
        operator: "isUUID"
    }
};
function _setExports(ndebug) {
    var keys = Object.keys(types);
    var out;
    out = function(arg, msg) {
        if (!arg) _toss(msg, "true", arg);
    };
    /* standard checks */ keys.forEach(function(k) {
        if (ndebug) {
            out[k] = noop;
            return;
        }
        var type = types[k];
        out[k] = function(arg, msg) {
            if (!type.check(arg)) _toss(msg, k, type.operator, arg, type.actual);
        };
    });
    /* optional checks */ keys.forEach(function(k) {
        var name = "optional" + _capitalize(k);
        if (ndebug) {
            out[name] = noop;
            return;
        }
        var type = types[k];
        out[name] = function(arg, msg) {
            if (arg === undefined || arg === null) return;
            if (!type.check(arg)) _toss(msg, k, type.operator, arg, type.actual);
        };
    });
    /* arrayOf checks */ keys.forEach(function(k) {
        var name = "arrayOf" + _capitalize(k);
        if (ndebug) {
            out[name] = noop;
            return;
        }
        var type = types[k];
        var expected = "[" + k + "]";
        out[name] = function(arg, msg) {
            if (!Array.isArray(arg)) _toss(msg, expected, type.operator, arg, type.actual);
            var i;
            for(i = 0; i < arg.length; i++)if (!type.check(arg[i])) _toss(msg, expected, type.operator, arg, type.actual);
        };
    });
    /* optionalArrayOf checks */ keys.forEach(function(k) {
        var name = "optionalArrayOf" + _capitalize(k);
        if (ndebug) {
            out[name] = noop;
            return;
        }
        var type = types[k];
        var expected = "[" + k + "]";
        out[name] = function(arg, msg) {
            if (arg === undefined || arg === null) return;
            if (!Array.isArray(arg)) _toss(msg, expected, type.operator, arg, type.actual);
            var i;
            for(i = 0; i < arg.length; i++)if (!type.check(arg[i])) _toss(msg, expected, type.operator, arg, type.actual);
        };
    });
    /* re-export built-in assertions */ Object.keys(assert).forEach(function(k) {
        if (k === "AssertionError") {
            out[k] = assert[k];
            return;
        }
        if (ndebug) {
            out[k] = noop;
            return;
        }
        out[k] = assert[k];
    });
    /* export ourselves (for unit tests _only_) */ out._setExports = _setExports;
    return out;
}
module.exports = _setExports(undefined);

},{"88df327d751c6d4b":"8EcTH","60474a8b9bb163ee":"fsq0Y","19925b3376ffc4b2":"4ooMZ","85329a9e947e4ea3":"dJawj"}],"g8tYW":[function(require,module,exports) {
// Copyright 2012 Joyent, Inc.  All rights reserved.
var assert = require("b4acf8d4f4953c45");
var sshpk = require("79533324f82ee6dc");
var util = require("9ea4c869bd98e248");
var HASH_ALGOS = {
    "sha1": true,
    "sha256": true,
    "sha512": true
};
var PK_ALGOS = {
    "rsa": true,
    "dsa": true,
    "ecdsa": true
};
function HttpSignatureError(message, caller) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, caller || HttpSignatureError);
    this.message = message;
    this.name = caller.name;
}
util.inherits(HttpSignatureError, Error);
function InvalidAlgorithmError(message) {
    HttpSignatureError.call(this, message, InvalidAlgorithmError);
}
util.inherits(InvalidAlgorithmError, HttpSignatureError);
function validateAlgorithm(algorithm) {
    var alg = algorithm.toLowerCase().split("-");
    if (alg.length !== 2) throw new InvalidAlgorithmError(alg[0].toUpperCase() + " is not a " + "valid algorithm");
    if (alg[0] !== "hmac" && !PK_ALGOS[alg[0]]) throw new InvalidAlgorithmError(alg[0].toUpperCase() + " type keys " + "are not supported");
    if (!HASH_ALGOS[alg[1]]) throw new InvalidAlgorithmError(alg[1].toUpperCase() + " is not a " + "supported hash algorithm");
    return alg;
}
///--- API
module.exports = {
    HASH_ALGOS: HASH_ALGOS,
    PK_ALGOS: PK_ALGOS,
    HttpSignatureError: HttpSignatureError,
    InvalidAlgorithmError: InvalidAlgorithmError,
    validateAlgorithm: validateAlgorithm,
    /**
   * Converts an OpenSSH public key (rsa only) to a PKCS#8 PEM file.
   *
   * The intent of this module is to interoperate with OpenSSL only,
   * specifically the node crypto module's `verify` method.
   *
   * @param {String} key an OpenSSH public key.
   * @return {String} PEM encoded form of the RSA public key.
   * @throws {TypeError} on bad input.
   * @throws {Error} on invalid ssh key formatted data.
   */ sshKeyToPEM: function sshKeyToPEM(key) {
        assert.string(key, "ssh_key");
        var k = sshpk.parseKey(key, "ssh");
        return k.toString("pem");
    },
    /**
   * Generates an OpenSSH fingerprint from an ssh public key.
   *
   * @param {String} key an OpenSSH public key.
   * @return {String} key fingerprint.
   * @throws {TypeError} on bad input.
   * @throws {Error} if what you passed doesn't look like an ssh public key.
   */ fingerprint: function fingerprint(key) {
        assert.string(key, "ssh_key");
        var k = sshpk.parseKey(key, "ssh");
        return k.fingerprint("md5").toString("hex");
    },
    /**
   * Converts a PKGCS#8 PEM file to an OpenSSH public key (rsa)
   *
   * The reverse of the above function.
   */ pemToRsaSSHKey: function pemToRsaSSHKey(pem, comment) {
        assert.equal("string", typeof pem, "typeof pem");
        var k = sshpk.parseKey(pem, "pem");
        k.comment = comment;
        return k.toString("ssh");
    }
};

},{"b4acf8d4f4953c45":"eQsu4","79533324f82ee6dc":"hjXTA","9ea4c869bd98e248":"dJawj"}],"hjXTA":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
var Key = require("5bb0e142d4599bde");
var Fingerprint = require("c993d36f74aa88a");
var Signature = require("1f316605aa877b28");
var PrivateKey = require("2214a7b3b2bec588");
var Certificate = require("908038b4f8b53b90");
var Identity = require("d2177f1e52c61bd0");
var errs = require("f3e314d72bd4290a");
module.exports = {
    /* top-level classes */ Key: Key,
    parseKey: Key.parse,
    Fingerprint: Fingerprint,
    parseFingerprint: Fingerprint.parse,
    Signature: Signature,
    parseSignature: Signature.parse,
    PrivateKey: PrivateKey,
    parsePrivateKey: PrivateKey.parse,
    generatePrivateKey: PrivateKey.generate,
    Certificate: Certificate,
    parseCertificate: Certificate.parse,
    createSelfSignedCertificate: Certificate.createSelfSigned,
    createCertificate: Certificate.create,
    Identity: Identity,
    identityFromDN: Identity.parseDN,
    identityForHost: Identity.forHost,
    identityForUser: Identity.forUser,
    identityForEmail: Identity.forEmail,
    identityFromArray: Identity.fromArray,
    /* errors */ FingerprintFormatError: errs.FingerprintFormatError,
    InvalidAlgorithmError: errs.InvalidAlgorithmError,
    KeyParseError: errs.KeyParseError,
    SignatureParseError: errs.SignatureParseError,
    KeyEncryptedError: errs.KeyEncryptedError,
    CertificateParseError: errs.CertificateParseError
};

},{"5bb0e142d4599bde":"fAyE1","c993d36f74aa88a":"lKsIK","1f316605aa877b28":"cxjr0","2214a7b3b2bec588":"4674F","908038b4f8b53b90":"4Zfxv","d2177f1e52c61bd0":"3JOrI","f3e314d72bd4290a":"6DKEY"}],"fAyE1":[function(require,module,exports) {
// Copyright 2018 Joyent, Inc.
var Buffer = require("c4a02d5fff45c411").Buffer;
module.exports = Key;
var assert = require("33dea028640be1c");
var algs = require("1dd0154d082b49f0");
var crypto = require("e04ebf6d423da51e");
var Fingerprint = require("27e08d841c17451f");
var Signature = require("e7d28a2e56d11f7f");
var DiffieHellman = require("8f7aca89a617435c").DiffieHellman;
var errs = require("89ccd6e3531997a8");
var utils = require("ac4b2a593c3b0b5d");
var PrivateKey = require("d1ce76c0be929eb");
var edCompat;
try {
    edCompat = require("ea3f166cd539a74c");
} catch (e) {
/* Just continue through, and bail out if we try to use it. */ }
var InvalidAlgorithmError = errs.InvalidAlgorithmError;
var KeyParseError = errs.KeyParseError;
var formats = {};
formats["auto"] = require("adb20500614fea72");
formats["pem"] = require("a53b0482d0bfc2d7");
formats["pkcs1"] = require("a4e204be7b66973");
formats["pkcs8"] = require("5818a5ef958a8831");
formats["rfc4253"] = require("fa212525eca17ce6");
formats["ssh"] = require("529cc45f8ce483a");
formats["ssh-private"] = require("fa9de075ce876475");
formats["openssh"] = formats["ssh-private"];
formats["dnssec"] = require("b60047b5955bcd38");
formats["putty"] = require("76168dc9e3b588f3");
formats["ppk"] = formats["putty"];
function Key(opts) {
    assert.object(opts, "options");
    assert.arrayOfObject(opts.parts, "options.parts");
    assert.string(opts.type, "options.type");
    assert.optionalString(opts.comment, "options.comment");
    var algInfo = algs.info[opts.type];
    if (typeof algInfo !== "object") throw new InvalidAlgorithmError(opts.type);
    var partLookup = {};
    for(var i = 0; i < opts.parts.length; ++i){
        var part = opts.parts[i];
        partLookup[part.name] = part;
    }
    this.type = opts.type;
    this.parts = opts.parts;
    this.part = partLookup;
    this.comment = undefined;
    this.source = opts.source;
    /* for speeding up hashing/fingerprint operations */ this._rfc4253Cache = opts._rfc4253Cache;
    this._hashCache = {};
    var sz;
    this.curve = undefined;
    if (this.type === "ecdsa") {
        var curve = this.part.curve.data.toString();
        this.curve = curve;
        sz = algs.curves[curve].size;
    } else if (this.type === "ed25519" || this.type === "curve25519") {
        sz = 256;
        this.curve = "curve25519";
    } else {
        var szPart = this.part[algInfo.sizePart];
        sz = szPart.data.length;
        sz = sz * 8 - utils.countZeros(szPart.data);
    }
    this.size = sz;
}
Key.formats = formats;
Key.prototype.toBuffer = function(format, options) {
    if (format === undefined) format = "ssh";
    assert.string(format, "format");
    assert.object(formats[format], "formats[format]");
    assert.optionalObject(options, "options");
    if (format === "rfc4253") {
        if (this._rfc4253Cache === undefined) this._rfc4253Cache = formats["rfc4253"].write(this);
        return this._rfc4253Cache;
    }
    return formats[format].write(this, options);
};
Key.prototype.toString = function(format, options) {
    return this.toBuffer(format, options).toString();
};
Key.prototype.hash = function(algo, type) {
    assert.string(algo, "algorithm");
    assert.optionalString(type, "type");
    if (type === undefined) type = "ssh";
    algo = algo.toLowerCase();
    if (algs.hashAlgs[algo] === undefined) throw new InvalidAlgorithmError(algo);
    var cacheKey = algo + "||" + type;
    if (this._hashCache[cacheKey]) return this._hashCache[cacheKey];
    var buf;
    if (type === "ssh") buf = this.toBuffer("rfc4253");
    else if (type === "spki") buf = formats.pkcs8.pkcs8ToBuffer(this);
    else throw new Error("Hash type " + type + " not supported");
    var hash = crypto.createHash(algo).update(buf).digest();
    this._hashCache[cacheKey] = hash;
    return hash;
};
Key.prototype.fingerprint = function(algo, type) {
    if (algo === undefined) algo = "sha256";
    if (type === undefined) type = "ssh";
    assert.string(algo, "algorithm");
    assert.string(type, "type");
    var opts = {
        type: "key",
        hash: this.hash(algo, type),
        algorithm: algo,
        hashType: type
    };
    return new Fingerprint(opts);
};
Key.prototype.defaultHashAlgorithm = function() {
    var hashAlgo = "sha1";
    if (this.type === "rsa") hashAlgo = "sha256";
    if (this.type === "dsa" && this.size > 1024) hashAlgo = "sha256";
    if (this.type === "ed25519") hashAlgo = "sha512";
    if (this.type === "ecdsa") {
        if (this.size <= 256) hashAlgo = "sha256";
        else if (this.size <= 384) hashAlgo = "sha384";
        else hashAlgo = "sha512";
    }
    return hashAlgo;
};
Key.prototype.createVerify = function(hashAlgo) {
    if (hashAlgo === undefined) hashAlgo = this.defaultHashAlgorithm();
    assert.string(hashAlgo, "hash algorithm");
    /* ED25519 is not supported by OpenSSL, use a javascript impl. */ if (this.type === "ed25519" && edCompat !== undefined) return new edCompat.Verifier(this, hashAlgo);
    if (this.type === "curve25519") throw new Error("Curve25519 keys are not suitable for signing or verification");
    var v, nm, err;
    try {
        nm = hashAlgo.toUpperCase();
        v = crypto.createVerify(nm);
    } catch (e) {
        err = e;
    }
    if (v === undefined || err instanceof Error && err.message.match(/Unknown message digest/)) {
        nm = "RSA-";
        nm += hashAlgo.toUpperCase();
        v = crypto.createVerify(nm);
    }
    assert.ok(v, "failed to create verifier");
    var oldVerify = v.verify.bind(v);
    var key = this.toBuffer("pkcs8");
    var curve = this.curve;
    var self = this;
    v.verify = function(signature, fmt) {
        if (Signature.isSignature(signature, [
            2,
            0
        ])) {
            if (signature.type !== self.type) return false;
            if (signature.hashAlgorithm && signature.hashAlgorithm !== hashAlgo) return false;
            if (signature.curve && self.type === "ecdsa" && signature.curve !== curve) return false;
            return oldVerify(key, signature.toBuffer("asn1"));
        } else if (typeof signature === "string" || Buffer.isBuffer(signature)) return oldVerify(key, signature, fmt);
        else if (Signature.isSignature(signature, [
            1,
            0
        ])) throw new Error("signature was created by too old a version of sshpk and cannot be verified");
        else throw new TypeError("signature must be a string, Buffer, or Signature object");
    };
    return v;
};
Key.prototype.createDiffieHellman = function() {
    if (this.type === "rsa") throw new Error("RSA keys do not support Diffie-Hellman");
    return new DiffieHellman(this);
};
Key.prototype.createDH = Key.prototype.createDiffieHellman;
Key.parse = function(data, format, options) {
    if (typeof data !== "string") assert.buffer(data, "data");
    if (format === undefined) format = "auto";
    assert.string(format, "format");
    if (typeof options === "string") options = {
        filename: options
    };
    assert.optionalObject(options, "options");
    if (options === undefined) options = {};
    assert.optionalString(options.filename, "options.filename");
    if (options.filename === undefined) options.filename = "(unnamed)";
    assert.object(formats[format], "formats[format]");
    try {
        var k = formats[format].read(data, options);
        if (k instanceof PrivateKey) k = k.toPublic();
        if (!k.comment) k.comment = options.filename;
        return k;
    } catch (e) {
        if (e.name === "KeyEncryptedError") throw e;
        throw new KeyParseError(options.filename, format, e);
    }
};
Key.isKey = function(obj, ver) {
    return utils.isCompatible(obj, Key, ver);
};
/*
 * API versions for Key:
 * [1,0] -- initial ver, may take Signature for createVerify or may not
 * [1,1] -- added pkcs1, pkcs8 formats
 * [1,2] -- added auto, ssh-private, openssh formats
 * [1,3] -- added defaultHashAlgorithm
 * [1,4] -- added ed support, createDH
 * [1,5] -- first explicitly tagged version
 * [1,6] -- changed ed25519 part names
 * [1,7] -- spki hash types
 */ Key.prototype._sshpkApiVersion = [
    1,
    7
];
Key._oldVersionDetect = function(obj) {
    assert.func(obj.toBuffer);
    assert.func(obj.fingerprint);
    if (obj.createDH) return [
        1,
        4
    ];
    if (obj.defaultHashAlgorithm) return [
        1,
        3
    ];
    if (obj.formats["auto"]) return [
        1,
        2
    ];
    if (obj.formats["pkcs1"]) return [
        1,
        1
    ];
    return [
        1,
        0
    ];
};

},{"c4a02d5fff45c411":"8EcTH","33dea028640be1c":"eQsu4","1dd0154d082b49f0":"23cSW","e04ebf6d423da51e":"8Nkdo","27e08d841c17451f":"lKsIK","e7d28a2e56d11f7f":"cxjr0","8f7aca89a617435c":"4V4AY","89ccd6e3531997a8":"6DKEY","ac4b2a593c3b0b5d":"icPN2","d1ce76c0be929eb":"4674F","ea3f166cd539a74c":"c01LN","adb20500614fea72":"kF0lg","a53b0482d0bfc2d7":"fUNos","a4e204be7b66973":"aGcIc","5818a5ef958a8831":"iNFUG","fa212525eca17ce6":"btAO6","529cc45f8ce483a":"apfcv","fa9de075ce876475":"2pfcf","b60047b5955bcd38":"bfK2i","76168dc9e3b588f3":"fNdMF"}],"23cSW":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
var Buffer = require("bf37b514fbe2fb49").Buffer;
var algInfo = {
    "dsa": {
        parts: [
            "p",
            "q",
            "g",
            "y"
        ],
        sizePart: "p"
    },
    "rsa": {
        parts: [
            "e",
            "n"
        ],
        sizePart: "n"
    },
    "ecdsa": {
        parts: [
            "curve",
            "Q"
        ],
        sizePart: "Q"
    },
    "ed25519": {
        parts: [
            "A"
        ],
        sizePart: "A"
    }
};
algInfo["curve25519"] = algInfo["ed25519"];
var algPrivInfo = {
    "dsa": {
        parts: [
            "p",
            "q",
            "g",
            "y",
            "x"
        ]
    },
    "rsa": {
        parts: [
            "n",
            "e",
            "d",
            "iqmp",
            "p",
            "q"
        ]
    },
    "ecdsa": {
        parts: [
            "curve",
            "Q",
            "d"
        ]
    },
    "ed25519": {
        parts: [
            "A",
            "k"
        ]
    }
};
algPrivInfo["curve25519"] = algPrivInfo["ed25519"];
var hashAlgs = {
    "md5": true,
    "sha1": true,
    "sha256": true,
    "sha384": true,
    "sha512": true
};
/*
 * Taken from
 * http://csrc.nist.gov/groups/ST/toolkit/documents/dss/NISTReCur.pdf
 */ var curves = {
    "nistp256": {
        size: 256,
        pkcs8oid: "1.2.840.10045.3.1.7",
        p: Buffer.from("00ffffffff 00000001 00000000 0000000000000000 ffffffff ffffffff ffffffff".replace(/ /g, ""), "hex"),
        a: Buffer.from("00FFFFFFFF 00000001 00000000 0000000000000000 FFFFFFFF FFFFFFFF FFFFFFFC".replace(/ /g, ""), "hex"),
        b: Buffer.from("5ac635d8 aa3a93e7 b3ebbd55 769886bc651d06b0 cc53b0f6 3bce3c3e 27d2604b".replace(/ /g, ""), "hex"),
        s: Buffer.from("00c49d3608 86e70493 6a6678e1 139d26b7819f7e90".replace(/ /g, ""), "hex"),
        n: Buffer.from("00ffffffff 00000000 ffffffff ffffffffbce6faad a7179e84 f3b9cac2 fc632551".replace(/ /g, ""), "hex"),
        G: Buffer.from("046b17d1f2 e12c4247 f8bce6e5 63a440f277037d81 2deb33a0 f4a13945 d898c2964fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e162bce3357 6b315ece cbb64068 37bf51f5".replace(/ /g, ""), "hex")
    },
    "nistp384": {
        size: 384,
        pkcs8oid: "1.3.132.0.34",
        p: Buffer.from("00ffffffff ffffffff ffffffff ffffffffffffffff ffffffff ffffffff fffffffeffffffff 00000000 00000000 ffffffff".replace(/ /g, ""), "hex"),
        a: Buffer.from("00FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFFFFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFEFFFFFFFF 00000000 00000000 FFFFFFFC".replace(/ /g, ""), "hex"),
        b: Buffer.from("b3312fa7 e23ee7e4 988e056b e3f82d19181d9c6e fe814112 0314088f 5013875ac656398d 8a2ed19d 2a85c8ed d3ec2aef".replace(/ /g, ""), "hex"),
        s: Buffer.from("00a335926a a319a27a 1d00896a 6773a4827acdac73".replace(/ /g, ""), "hex"),
        n: Buffer.from("00ffffffff ffffffff ffffffff ffffffffffffffff ffffffff c7634d81 f4372ddf581a0db2 48b0a77a ecec196a ccc52973".replace(/ /g, ""), "hex"),
        G: Buffer.from("04aa87ca22 be8b0537 8eb1c71e f320ad746e1d3b62 8ba79b98 59f741e0 82542a385502f25d bf55296c 3a545e38 72760ab73617de4a 96262c6f 5d9e98bf 9292dc29f8f41dbd 289a147c e9da3113 b5f0b8c00a60b1ce 1d7e819d 7a431d7c 90ea0e5f".replace(/ /g, ""), "hex")
    },
    "nistp521": {
        size: 521,
        pkcs8oid: "1.3.132.0.35",
        p: Buffer.from("01ffffff ffffffff ffffffff ffffffffffffffff ffffffff ffffffff ffffffffffffffff ffffffff ffffffff ffffffffffffffff ffffffff ffffffff ffffffffffff".replace(/ /g, ""), "hex"),
        a: Buffer.from("01FFFFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFFFFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFFFFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFFFFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFC".replace(/ /g, ""), "hex"),
        b: Buffer.from("51953eb961 8e1c9a1f 929a21a0 b68540eea2da725b 99b315f3 b8b48991 8ef109e156193951 ec7e937b 1652c0bd 3bb1bf073573df88 3d2c34f1 ef451fd4 6b503f00".replace(/ /g, ""), "hex"),
        s: Buffer.from("00d09e8800 291cb853 96cc6717 393284aaa0da64ba".replace(/ /g, ""), "hex"),
        n: Buffer.from("01ffffffffff ffffffff ffffffff ffffffffffffffff ffffffff ffffffff fffffffa51868783 bf2f966b 7fcc0148 f709a5d03bb5c9b8 899c47ae bb6fb71e 91386409".replace(/ /g, ""), "hex"),
        G: Buffer.from("0400c6 858e06b7 0404e9cd 9e3ecb66 2395b4429c648139 053fb521 f828af60 6b4d3dbaa14b5e77 efe75928 fe1dc127 a2ffa8de3348b3c1 856a429b f97e7e31 c2e5bd660118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd998f54449 579b4468 17afbd17 273e662c97ee7299 5ef42640 c550b901 3fad0761353c7086 a272c240 88be9476 9fd16650".replace(/ /g, ""), "hex")
    }
};
module.exports = {
    info: algInfo,
    privInfo: algPrivInfo,
    hashAlgs: hashAlgs,
    curves: curves
};

},{"bf37b514fbe2fb49":"b2XZ0"}],"b2XZ0":[function(require,module,exports) {
/* eslint-disable node/no-deprecated-api */ var process = require("e7af3484edf6bee9");
"use strict";
var buffer = require("9b1fd4bf3515d7a6");
var Buffer = buffer.Buffer;
var safer = {};
var key;
for(key in buffer){
    if (!buffer.hasOwnProperty(key)) continue;
    if (key === "SlowBuffer" || key === "Buffer") continue;
    safer[key] = buffer[key];
}
var Safer = safer.Buffer = {};
for(key in Buffer){
    if (!Buffer.hasOwnProperty(key)) continue;
    if (key === "allocUnsafe" || key === "allocUnsafeSlow") continue;
    Safer[key] = Buffer[key];
}
safer.Buffer.prototype = Buffer.prototype;
if (!Safer.from || Safer.from === Uint8Array.from) Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return Buffer(value, encodingOrOffset, length);
};
if (!Safer.alloc) Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!safer.kStringMaxLength) try {
    safer.kStringMaxLength = process.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!safer.constants) {
    safer.constants = {
        MAX_LENGTH: safer.kMaxLength
    };
    if (safer.kStringMaxLength) safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength;
}
module.exports = safer;

},{"e7af3484edf6bee9":"g1F5c","9b1fd4bf3515d7a6":"8EcTH"}],"lKsIK":[function(require,module,exports) {
// Copyright 2018 Joyent, Inc.
module.exports = Fingerprint;
var assert = require("f8ed0b241eddbaa4");
var Buffer = require("72390162b67c035a").Buffer;
var algs = require("319bc4a57818c9d");
var crypto = require("c03481b4bad9d2a6");
var errs = require("fbbe54fb5cf2959e");
var Key = require("fb6aa2c3f23fdc4d");
var PrivateKey = require("5c8e4f0411890924");
var Certificate = require("69b8000a5d752bfd");
var utils = require("4caae50eee6615");
var FingerprintFormatError = errs.FingerprintFormatError;
var InvalidAlgorithmError = errs.InvalidAlgorithmError;
function Fingerprint(opts) {
    assert.object(opts, "options");
    assert.string(opts.type, "options.type");
    assert.buffer(opts.hash, "options.hash");
    assert.string(opts.algorithm, "options.algorithm");
    this.algorithm = opts.algorithm.toLowerCase();
    if (algs.hashAlgs[this.algorithm] !== true) throw new InvalidAlgorithmError(this.algorithm);
    this.hash = opts.hash;
    this.type = opts.type;
    this.hashType = opts.hashType;
}
Fingerprint.prototype.toString = function(format) {
    if (format === undefined) {
        if (this.algorithm === "md5" || this.hashType === "spki") format = "hex";
        else format = "base64";
    }
    assert.string(format);
    switch(format){
        case "hex":
            if (this.hashType === "spki") return this.hash.toString("hex");
            return addColons(this.hash.toString("hex"));
        case "base64":
            if (this.hashType === "spki") return this.hash.toString("base64");
            return sshBase64Format(this.algorithm, this.hash.toString("base64"));
        default:
            throw new FingerprintFormatError(undefined, format);
    }
};
Fingerprint.prototype.matches = function(other) {
    assert.object(other, "key or certificate");
    if (this.type === "key" && this.hashType !== "ssh") {
        utils.assertCompatible(other, Key, [
            1,
            7
        ], "key with spki");
        if (PrivateKey.isPrivateKey(other)) utils.assertCompatible(other, PrivateKey, [
            1,
            6
        ], "privatekey with spki support");
    } else if (this.type === "key") utils.assertCompatible(other, Key, [
        1,
        0
    ], "key");
    else utils.assertCompatible(other, Certificate, [
        1,
        0
    ], "certificate");
    var theirHash = other.hash(this.algorithm, this.hashType);
    var theirHash2 = crypto.createHash(this.algorithm).update(theirHash).digest("base64");
    if (this.hash2 === undefined) this.hash2 = crypto.createHash(this.algorithm).update(this.hash).digest("base64");
    return this.hash2 === theirHash2;
};
/*JSSTYLED*/ var base64RE = /^[A-Za-z0-9+\/=]+$/;
/*JSSTYLED*/ var hexRE = /^[a-fA-F0-9]+$/;
Fingerprint.parse = function(fp, options) {
    assert.string(fp, "fingerprint");
    var alg, hash, enAlgs;
    if (Array.isArray(options)) {
        enAlgs = options;
        options = {};
    }
    assert.optionalObject(options, "options");
    if (options === undefined) options = {};
    if (options.enAlgs !== undefined) enAlgs = options.enAlgs;
    if (options.algorithms !== undefined) enAlgs = options.algorithms;
    assert.optionalArrayOfString(enAlgs, "algorithms");
    var hashType = "ssh";
    if (options.hashType !== undefined) hashType = options.hashType;
    assert.string(hashType, "options.hashType");
    var parts = fp.split(":");
    if (parts.length == 2) {
        alg = parts[0].toLowerCase();
        if (!base64RE.test(parts[1])) throw new FingerprintFormatError(fp);
        try {
            hash = Buffer.from(parts[1], "base64");
        } catch (e) {
            throw new FingerprintFormatError(fp);
        }
    } else if (parts.length > 2) {
        alg = "md5";
        if (parts[0].toLowerCase() === "md5") parts = parts.slice(1);
        parts = parts.map(function(p) {
            while(p.length < 2)p = "0" + p;
            if (p.length > 2) throw new FingerprintFormatError(fp);
            return p;
        });
        parts = parts.join("");
        if (!hexRE.test(parts) || parts.length % 2 !== 0) throw new FingerprintFormatError(fp);
        try {
            hash = Buffer.from(parts, "hex");
        } catch (e) {
            throw new FingerprintFormatError(fp);
        }
    } else {
        if (hexRE.test(fp)) hash = Buffer.from(fp, "hex");
        else if (base64RE.test(fp)) hash = Buffer.from(fp, "base64");
        else throw new FingerprintFormatError(fp);
        switch(hash.length){
            case 32:
                alg = "sha256";
                break;
            case 16:
                alg = "md5";
                break;
            case 20:
                alg = "sha1";
                break;
            case 64:
                alg = "sha512";
                break;
            default:
                throw new FingerprintFormatError(fp);
        }
        /* Plain hex/base64: guess it's probably SPKI unless told. */ if (options.hashType === undefined) hashType = "spki";
    }
    if (alg === undefined) throw new FingerprintFormatError(fp);
    if (algs.hashAlgs[alg] === undefined) throw new InvalidAlgorithmError(alg);
    if (enAlgs !== undefined) {
        enAlgs = enAlgs.map(function(a) {
            return a.toLowerCase();
        });
        if (enAlgs.indexOf(alg) === -1) throw new InvalidAlgorithmError(alg);
    }
    return new Fingerprint({
        algorithm: alg,
        hash: hash,
        type: options.type || "key",
        hashType: hashType
    });
};
function addColons(s) {
    /*JSSTYLED*/ return s.replace(/(.{2})(?=.)/g, "$1:");
}
function base64Strip(s) {
    /*JSSTYLED*/ return s.replace(/=*$/, "");
}
function sshBase64Format(alg, h) {
    return alg.toUpperCase() + ":" + base64Strip(h);
}
Fingerprint.isFingerprint = function(obj, ver) {
    return utils.isCompatible(obj, Fingerprint, ver);
};
/*
 * API versions for Fingerprint:
 * [1,0] -- initial ver
 * [1,1] -- first tagged ver
 * [1,2] -- hashType and spki support
 */ Fingerprint.prototype._sshpkApiVersion = [
    1,
    2
];
Fingerprint._oldVersionDetect = function(obj) {
    assert.func(obj.toString);
    assert.func(obj.matches);
    return [
        1,
        0
    ];
};

},{"f8ed0b241eddbaa4":"eQsu4","72390162b67c035a":"b2XZ0","319bc4a57818c9d":"23cSW","c03481b4bad9d2a6":"8Nkdo","fbbe54fb5cf2959e":"6DKEY","fb6aa2c3f23fdc4d":"fAyE1","5c8e4f0411890924":"4674F","69b8000a5d752bfd":"4Zfxv","4caae50eee6615":"icPN2"}],"6DKEY":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
var assert = require("e993ace411397fda");
var util = require("b498bb2303554a11");
function FingerprintFormatError(fp, format) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, FingerprintFormatError);
    this.name = "FingerprintFormatError";
    this.fingerprint = fp;
    this.format = format;
    this.message = "Fingerprint format is not supported, or is invalid: ";
    if (fp !== undefined) this.message += " fingerprint = " + fp;
    if (format !== undefined) this.message += " format = " + format;
}
util.inherits(FingerprintFormatError, Error);
function InvalidAlgorithmError(alg) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, InvalidAlgorithmError);
    this.name = "InvalidAlgorithmError";
    this.algorithm = alg;
    this.message = 'Algorithm "' + alg + '" is not supported';
}
util.inherits(InvalidAlgorithmError, Error);
function KeyParseError(name, format, innerErr) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, KeyParseError);
    this.name = "KeyParseError";
    this.format = format;
    this.keyName = name;
    this.innerErr = innerErr;
    this.message = "Failed to parse " + name + " as a valid " + format + " format key: " + innerErr.message;
}
util.inherits(KeyParseError, Error);
function SignatureParseError(type, format, innerErr) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, SignatureParseError);
    this.name = "SignatureParseError";
    this.type = type;
    this.format = format;
    this.innerErr = innerErr;
    this.message = "Failed to parse the given data as a " + type + " signature in " + format + " format: " + innerErr.message;
}
util.inherits(SignatureParseError, Error);
function CertificateParseError(name, format, innerErr) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, CertificateParseError);
    this.name = "CertificateParseError";
    this.format = format;
    this.certName = name;
    this.innerErr = innerErr;
    this.message = "Failed to parse " + name + " as a valid " + format + " format certificate: " + innerErr.message;
}
util.inherits(CertificateParseError, Error);
function KeyEncryptedError(name, format) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, KeyEncryptedError);
    this.name = "KeyEncryptedError";
    this.format = format;
    this.keyName = name;
    this.message = "The " + format + " format key " + name + " is " + "encrypted (password-protected), and no passphrase was " + "provided in `options`";
}
util.inherits(KeyEncryptedError, Error);
module.exports = {
    FingerprintFormatError: FingerprintFormatError,
    InvalidAlgorithmError: InvalidAlgorithmError,
    KeyParseError: KeyParseError,
    SignatureParseError: SignatureParseError,
    KeyEncryptedError: KeyEncryptedError,
    CertificateParseError: CertificateParseError
};

},{"e993ace411397fda":"eQsu4","b498bb2303554a11":"dJawj"}],"4674F":[function(require,module,exports) {
// Copyright 2017 Joyent, Inc.
module.exports = PrivateKey;
var assert = require("92ef6565e94d08ac");
var Buffer = require("8eefdbf9bebfbd70").Buffer;
var algs = require("cf38526b3168eeaa");
var crypto = require("fdfee2a44c41f878");
var Fingerprint = require("b018a42011cfd68");
var Signature = require("24aea7531e5a9c32");
var errs = require("47c4e4c2fa5a82e2");
var util = require("67fe16638b85b509");
var utils = require("4b77d20cdc359b13");
var dhe = require("f0517fe15a74079c");
var generateECDSA = dhe.generateECDSA;
var generateED25519 = dhe.generateED25519;
var edCompat = require("3bdcdbd5cb2a9873");
var nacl = require("c809db6a5e29cba8");
var Key = require("157a3ecabd3d3ac3");
var InvalidAlgorithmError = errs.InvalidAlgorithmError;
var KeyParseError = errs.KeyParseError;
var KeyEncryptedError = errs.KeyEncryptedError;
var formats = {};
formats["auto"] = require("97311b936a2efb71");
formats["pem"] = require("9681daeb6057033a");
formats["pkcs1"] = require("545a657e4c49345");
formats["pkcs8"] = require("609c3c57b0f28594");
formats["rfc4253"] = require("75f0b37cdcf86b6d");
formats["ssh-private"] = require("e0b095f520933664");
formats["openssh"] = formats["ssh-private"];
formats["ssh"] = formats["ssh-private"];
formats["dnssec"] = require("415d769e79fa7660");
formats["putty"] = require("68f6ac1b498b9a35");
function PrivateKey(opts) {
    assert.object(opts, "options");
    Key.call(this, opts);
    this._pubCache = undefined;
}
util.inherits(PrivateKey, Key);
PrivateKey.formats = formats;
PrivateKey.prototype.toBuffer = function(format, options) {
    if (format === undefined) format = "pkcs1";
    assert.string(format, "format");
    assert.object(formats[format], "formats[format]");
    assert.optionalObject(options, "options");
    return formats[format].write(this, options);
};
PrivateKey.prototype.hash = function(algo, type) {
    return this.toPublic().hash(algo, type);
};
PrivateKey.prototype.fingerprint = function(algo, type) {
    return this.toPublic().fingerprint(algo, type);
};
PrivateKey.prototype.toPublic = function() {
    if (this._pubCache) return this._pubCache;
    var algInfo = algs.info[this.type];
    var pubParts = [];
    for(var i = 0; i < algInfo.parts.length; ++i){
        var p = algInfo.parts[i];
        pubParts.push(this.part[p]);
    }
    this._pubCache = new Key({
        type: this.type,
        source: this,
        parts: pubParts
    });
    if (this.comment) this._pubCache.comment = this.comment;
    return this._pubCache;
};
PrivateKey.prototype.derive = function(newType) {
    assert.string(newType, "type");
    var priv, pub, pair;
    if (this.type === "ed25519" && newType === "curve25519") {
        priv = this.part.k.data;
        if (priv[0] === 0x00) priv = priv.slice(1);
        pair = nacl.box.keyPair.fromSecretKey(new Uint8Array(priv));
        pub = Buffer.from(pair.publicKey);
        return new PrivateKey({
            type: "curve25519",
            parts: [
                {
                    name: "A",
                    data: utils.mpNormalize(pub)
                },
                {
                    name: "k",
                    data: utils.mpNormalize(priv)
                }
            ]
        });
    } else if (this.type === "curve25519" && newType === "ed25519") {
        priv = this.part.k.data;
        if (priv[0] === 0x00) priv = priv.slice(1);
        pair = nacl.sign.keyPair.fromSeed(new Uint8Array(priv));
        pub = Buffer.from(pair.publicKey);
        return new PrivateKey({
            type: "ed25519",
            parts: [
                {
                    name: "A",
                    data: utils.mpNormalize(pub)
                },
                {
                    name: "k",
                    data: utils.mpNormalize(priv)
                }
            ]
        });
    }
    throw new Error("Key derivation not supported from " + this.type + " to " + newType);
};
PrivateKey.prototype.createVerify = function(hashAlgo) {
    return this.toPublic().createVerify(hashAlgo);
};
PrivateKey.prototype.createSign = function(hashAlgo) {
    if (hashAlgo === undefined) hashAlgo = this.defaultHashAlgorithm();
    assert.string(hashAlgo, "hash algorithm");
    /* ED25519 is not supported by OpenSSL, use a javascript impl. */ if (this.type === "ed25519" && edCompat !== undefined) return new edCompat.Signer(this, hashAlgo);
    if (this.type === "curve25519") throw new Error("Curve25519 keys are not suitable for signing or verification");
    var v, nm, err;
    try {
        nm = hashAlgo.toUpperCase();
        v = crypto.createSign(nm);
    } catch (e) {
        err = e;
    }
    if (v === undefined || err instanceof Error && err.message.match(/Unknown message digest/)) {
        nm = "RSA-";
        nm += hashAlgo.toUpperCase();
        v = crypto.createSign(nm);
    }
    assert.ok(v, "failed to create verifier");
    var oldSign = v.sign.bind(v);
    var key = this.toBuffer("pkcs1");
    var type = this.type;
    var curve = this.curve;
    v.sign = function() {
        var sig = oldSign(key);
        if (typeof sig === "string") sig = Buffer.from(sig, "binary");
        sig = Signature.parse(sig, type, "asn1");
        sig.hashAlgorithm = hashAlgo;
        sig.curve = curve;
        return sig;
    };
    return v;
};
PrivateKey.parse = function(data, format, options) {
    if (typeof data !== "string") assert.buffer(data, "data");
    if (format === undefined) format = "auto";
    assert.string(format, "format");
    if (typeof options === "string") options = {
        filename: options
    };
    assert.optionalObject(options, "options");
    if (options === undefined) options = {};
    assert.optionalString(options.filename, "options.filename");
    if (options.filename === undefined) options.filename = "(unnamed)";
    assert.object(formats[format], "formats[format]");
    try {
        var k = formats[format].read(data, options);
        assert.ok(k instanceof PrivateKey, "key is not a private key");
        if (!k.comment) k.comment = options.filename;
        return k;
    } catch (e) {
        if (e.name === "KeyEncryptedError") throw e;
        throw new KeyParseError(options.filename, format, e);
    }
};
PrivateKey.isPrivateKey = function(obj, ver) {
    return utils.isCompatible(obj, PrivateKey, ver);
};
PrivateKey.generate = function(type, options) {
    if (options === undefined) options = {};
    assert.object(options, "options");
    switch(type){
        case "ecdsa":
            if (options.curve === undefined) options.curve = "nistp256";
            assert.string(options.curve, "options.curve");
            return generateECDSA(options.curve);
        case "ed25519":
            return generateED25519();
        default:
            throw new Error('Key generation not supported with key type "' + type + '"');
    }
};
/*
 * API versions for PrivateKey:
 * [1,0] -- initial ver
 * [1,1] -- added auto, pkcs[18], openssh/ssh-private formats
 * [1,2] -- added defaultHashAlgorithm
 * [1,3] -- added derive, ed, createDH
 * [1,4] -- first tagged version
 * [1,5] -- changed ed25519 part names and format
 * [1,6] -- type arguments for hash() and fingerprint()
 */ PrivateKey.prototype._sshpkApiVersion = [
    1,
    6
];
PrivateKey._oldVersionDetect = function(obj) {
    assert.func(obj.toPublic);
    assert.func(obj.createSign);
    if (obj.derive) return [
        1,
        3
    ];
    if (obj.defaultHashAlgorithm) return [
        1,
        2
    ];
    if (obj.formats["auto"]) return [
        1,
        1
    ];
    return [
        1,
        0
    ];
};

},{"92ef6565e94d08ac":"eQsu4","8eefdbf9bebfbd70":"b2XZ0","cf38526b3168eeaa":"23cSW","fdfee2a44c41f878":"8Nkdo","b018a42011cfd68":"lKsIK","24aea7531e5a9c32":"cxjr0","47c4e4c2fa5a82e2":"6DKEY","67fe16638b85b509":"dJawj","4b77d20cdc359b13":"icPN2","f0517fe15a74079c":"4V4AY","3bdcdbd5cb2a9873":"c01LN","c809db6a5e29cba8":"exIc8","157a3ecabd3d3ac3":"fAyE1","97311b936a2efb71":"kF0lg","9681daeb6057033a":"fUNos","545a657e4c49345":"aGcIc","609c3c57b0f28594":"iNFUG","75f0b37cdcf86b6d":"btAO6","e0b095f520933664":"2pfcf","415d769e79fa7660":"bfK2i","68f6ac1b498b9a35":"fNdMF"}],"cxjr0":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = Signature;
var assert = require("da871dceb1caf4a3");
var Buffer = require("9ce59561fa10bd3c").Buffer;
var algs = require("77820d8fb2949de2");
var crypto = require("3fab49467e95d61e");
var errs = require("4d9d0d31b153886a");
var utils = require("9af9f663b307724f");
var asn1 = require("7418c47b8effd6c6");
var SSHBuffer = require("51a17bbb7938c55b");
var InvalidAlgorithmError = errs.InvalidAlgorithmError;
var SignatureParseError = errs.SignatureParseError;
function Signature(opts) {
    assert.object(opts, "options");
    assert.arrayOfObject(opts.parts, "options.parts");
    assert.string(opts.type, "options.type");
    var partLookup = {};
    for(var i = 0; i < opts.parts.length; ++i){
        var part = opts.parts[i];
        partLookup[part.name] = part;
    }
    this.type = opts.type;
    this.hashAlgorithm = opts.hashAlgo;
    this.curve = opts.curve;
    this.parts = opts.parts;
    this.part = partLookup;
}
Signature.prototype.toBuffer = function(format) {
    if (format === undefined) format = "asn1";
    assert.string(format, "format");
    var buf;
    var stype = "ssh-" + this.type;
    switch(this.type){
        case "rsa":
            switch(this.hashAlgorithm){
                case "sha256":
                    stype = "rsa-sha2-256";
                    break;
                case "sha512":
                    stype = "rsa-sha2-512";
                    break;
                case "sha1":
                case undefined:
                    break;
                default:
                    throw new Error("SSH signature format does not support hash algorithm " + this.hashAlgorithm);
            }
            if (format === "ssh") {
                buf = new SSHBuffer({});
                buf.writeString(stype);
                buf.writePart(this.part.sig);
                return buf.toBuffer();
            } else return this.part.sig.data;
            break;
        case "ed25519":
            if (format === "ssh") {
                buf = new SSHBuffer({});
                buf.writeString(stype);
                buf.writePart(this.part.sig);
                return buf.toBuffer();
            } else return this.part.sig.data;
            break;
        case "dsa":
        case "ecdsa":
            var r, s;
            if (format === "asn1") {
                var der = new asn1.BerWriter();
                der.startSequence();
                r = utils.mpNormalize(this.part.r.data);
                s = utils.mpNormalize(this.part.s.data);
                der.writeBuffer(r, asn1.Ber.Integer);
                der.writeBuffer(s, asn1.Ber.Integer);
                der.endSequence();
                return der.buffer;
            } else if (format === "ssh" && this.type === "dsa") {
                buf = new SSHBuffer({});
                buf.writeString("ssh-dss");
                r = this.part.r.data;
                if (r.length > 20 && r[0] === 0x00) r = r.slice(1);
                s = this.part.s.data;
                if (s.length > 20 && s[0] === 0x00) s = s.slice(1);
                if (this.hashAlgorithm && this.hashAlgorithm !== "sha1" || r.length + s.length !== 40) throw new Error("OpenSSH only supports DSA signatures with SHA1 hash");
                buf.writeBuffer(Buffer.concat([
                    r,
                    s
                ]));
                return buf.toBuffer();
            } else if (format === "ssh" && this.type === "ecdsa") {
                var inner = new SSHBuffer({});
                r = this.part.r.data;
                inner.writeBuffer(r);
                inner.writePart(this.part.s);
                buf = new SSHBuffer({});
                /* XXX: find a more proper way to do this? */ var curve;
                if (r[0] === 0x00) r = r.slice(1);
                var sz = r.length * 8;
                if (sz === 256) curve = "nistp256";
                else if (sz === 384) curve = "nistp384";
                else if (sz === 528) curve = "nistp521";
                buf.writeString("ecdsa-sha2-" + curve);
                buf.writeBuffer(inner.toBuffer());
                return buf.toBuffer();
            }
            throw new Error("Invalid signature format");
        default:
            throw new Error("Invalid signature data");
    }
};
Signature.prototype.toString = function(format) {
    assert.optionalString(format, "format");
    return this.toBuffer(format).toString("base64");
};
Signature.parse = function(data, type, format) {
    if (typeof data === "string") data = Buffer.from(data, "base64");
    assert.buffer(data, "data");
    assert.string(format, "format");
    assert.string(type, "type");
    var opts = {};
    opts.type = type.toLowerCase();
    opts.parts = [];
    try {
        assert.ok(data.length > 0, "signature must not be empty");
        switch(opts.type){
            case "rsa":
                return parseOneNum(data, type, format, opts);
            case "ed25519":
                return parseOneNum(data, type, format, opts);
            case "dsa":
            case "ecdsa":
                if (format === "asn1") return parseDSAasn1(data, type, format, opts);
                else if (opts.type === "dsa") return parseDSA(data, type, format, opts);
                else return parseECDSA(data, type, format, opts);
            default:
                throw new InvalidAlgorithmError(type);
        }
    } catch (e) {
        if (e instanceof InvalidAlgorithmError) throw e;
        throw new SignatureParseError(type, format, e);
    }
};
function parseOneNum(data, type, format, opts) {
    if (format === "ssh") {
        try {
            var buf = new SSHBuffer({
                buffer: data
            });
            var head = buf.readString();
        } catch (e) {
        /* fall through */ }
        if (buf !== undefined) {
            var msg = "SSH signature does not match expected type (expected " + type + ", got " + head + ")";
            switch(head){
                case "ssh-rsa":
                    assert.strictEqual(type, "rsa", msg);
                    opts.hashAlgo = "sha1";
                    break;
                case "rsa-sha2-256":
                    assert.strictEqual(type, "rsa", msg);
                    opts.hashAlgo = "sha256";
                    break;
                case "rsa-sha2-512":
                    assert.strictEqual(type, "rsa", msg);
                    opts.hashAlgo = "sha512";
                    break;
                case "ssh-ed25519":
                    assert.strictEqual(type, "ed25519", msg);
                    opts.hashAlgo = "sha512";
                    break;
                default:
                    throw new Error("Unknown SSH signature type: " + head);
            }
            var sig = buf.readPart();
            assert.ok(buf.atEnd(), "extra trailing bytes");
            sig.name = "sig";
            opts.parts.push(sig);
            return new Signature(opts);
        }
    }
    opts.parts.push({
        name: "sig",
        data: data
    });
    return new Signature(opts);
}
function parseDSAasn1(data, type, format, opts) {
    var der = new asn1.BerReader(data);
    der.readSequence();
    var r = der.readString(asn1.Ber.Integer, true);
    var s = der.readString(asn1.Ber.Integer, true);
    opts.parts.push({
        name: "r",
        data: utils.mpNormalize(r)
    });
    opts.parts.push({
        name: "s",
        data: utils.mpNormalize(s)
    });
    return new Signature(opts);
}
function parseDSA(data, type, format, opts) {
    if (data.length != 40) {
        var buf = new SSHBuffer({
            buffer: data
        });
        var d = buf.readBuffer();
        if (d.toString("ascii") === "ssh-dss") d = buf.readBuffer();
        assert.ok(buf.atEnd(), "extra trailing bytes");
        assert.strictEqual(d.length, 40, "invalid inner length");
        data = d;
    }
    opts.parts.push({
        name: "r",
        data: data.slice(0, 20)
    });
    opts.parts.push({
        name: "s",
        data: data.slice(20, 40)
    });
    return new Signature(opts);
}
function parseECDSA(data, type, format, opts) {
    var buf = new SSHBuffer({
        buffer: data
    });
    var r, s;
    var inner = buf.readBuffer();
    var stype = inner.toString("ascii");
    if (stype.slice(0, 6) === "ecdsa-") {
        var parts = stype.split("-");
        assert.strictEqual(parts[0], "ecdsa");
        assert.strictEqual(parts[1], "sha2");
        opts.curve = parts[2];
        switch(opts.curve){
            case "nistp256":
                opts.hashAlgo = "sha256";
                break;
            case "nistp384":
                opts.hashAlgo = "sha384";
                break;
            case "nistp521":
                opts.hashAlgo = "sha512";
                break;
            default:
                throw new Error("Unsupported ECDSA curve: " + opts.curve);
        }
        inner = buf.readBuffer();
        assert.ok(buf.atEnd(), "extra trailing bytes on outer");
        buf = new SSHBuffer({
            buffer: inner
        });
        r = buf.readPart();
    } else r = {
        data: inner
    };
    s = buf.readPart();
    assert.ok(buf.atEnd(), "extra trailing bytes");
    r.name = "r";
    s.name = "s";
    opts.parts.push(r);
    opts.parts.push(s);
    return new Signature(opts);
}
Signature.isSignature = function(obj, ver) {
    return utils.isCompatible(obj, Signature, ver);
};
/*
 * API versions for Signature:
 * [1,0] -- initial ver
 * [2,0] -- support for rsa in full ssh format, compat with sshpk-agent
 *          hashAlgorithm property
 * [2,1] -- first tagged version
 */ Signature.prototype._sshpkApiVersion = [
    2,
    1
];
Signature._oldVersionDetect = function(obj) {
    assert.func(obj.toBuffer);
    if (obj.hasOwnProperty("hashAlgorithm")) return [
        2,
        0
    ];
    return [
        1,
        0
    ];
};

},{"da871dceb1caf4a3":"eQsu4","9ce59561fa10bd3c":"b2XZ0","77820d8fb2949de2":"23cSW","3fab49467e95d61e":"8Nkdo","4d9d0d31b153886a":"6DKEY","9af9f663b307724f":"icPN2","7418c47b8effd6c6":"jC0hS","51a17bbb7938c55b":"OXMVy"}],"icPN2":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = {
    bufferSplit: bufferSplit,
    addRSAMissing: addRSAMissing,
    calculateDSAPublic: calculateDSAPublic,
    calculateED25519Public: calculateED25519Public,
    calculateX25519Public: calculateX25519Public,
    mpNormalize: mpNormalize,
    mpDenormalize: mpDenormalize,
    ecNormalize: ecNormalize,
    countZeros: countZeros,
    assertCompatible: assertCompatible,
    isCompatible: isCompatible,
    opensslKeyDeriv: opensslKeyDeriv,
    opensshCipherInfo: opensshCipherInfo,
    publicFromPrivateECDSA: publicFromPrivateECDSA,
    zeroPadToLength: zeroPadToLength,
    writeBitString: writeBitString,
    readBitString: readBitString,
    pbkdf2: pbkdf2
};
var assert = require("dd7d295b18b4e00f");
var Buffer = require("7a7bb630ebe5a29e").Buffer;
var PrivateKey = require("5099d9efc847a18e");
var Key = require("9670db2f2b5b7cf7");
var crypto = require("9e124268705c7aea");
var algs = require("c8e5c952f8c511c5");
var asn1 = require("ccd4f8f870acddee");
var ec = require("4a2ae4d70a539955");
var jsbn = require("30fdc4beec8c1bc8").BigInteger;
var nacl = require("ddeb28e73d35530b");
var MAX_CLASS_DEPTH = 3;
function isCompatible(obj, klass, needVer) {
    if (obj === null || typeof obj !== "object") return false;
    if (needVer === undefined) needVer = klass.prototype._sshpkApiVersion;
    if (obj instanceof klass && klass.prototype._sshpkApiVersion[0] == needVer[0]) return true;
    var proto = Object.getPrototypeOf(obj);
    var depth = 0;
    while(proto.constructor.name !== klass.name){
        proto = Object.getPrototypeOf(proto);
        if (!proto || ++depth > MAX_CLASS_DEPTH) return false;
    }
    if (proto.constructor.name !== klass.name) return false;
    var ver = proto._sshpkApiVersion;
    if (ver === undefined) ver = klass._oldVersionDetect(obj);
    if (ver[0] != needVer[0] || ver[1] < needVer[1]) return false;
    return true;
}
function assertCompatible(obj, klass, needVer, name) {
    if (name === undefined) name = "object";
    assert.ok(obj, name + " must not be null");
    assert.object(obj, name + " must be an object");
    if (needVer === undefined) needVer = klass.prototype._sshpkApiVersion;
    if (obj instanceof klass && klass.prototype._sshpkApiVersion[0] == needVer[0]) return;
    var proto = Object.getPrototypeOf(obj);
    var depth = 0;
    while(proto.constructor.name !== klass.name){
        proto = Object.getPrototypeOf(proto);
        assert.ok(proto && ++depth <= MAX_CLASS_DEPTH, name + " must be a " + klass.name + " instance");
    }
    assert.strictEqual(proto.constructor.name, klass.name, name + " must be a " + klass.name + " instance");
    var ver = proto._sshpkApiVersion;
    if (ver === undefined) ver = klass._oldVersionDetect(obj);
    assert.ok(ver[0] == needVer[0] && ver[1] >= needVer[1], name + " must be compatible with " + klass.name + " klass " + "version " + needVer[0] + "." + needVer[1]);
}
var CIPHER_LEN = {
    "des-ede3-cbc": {
        key: 24,
        iv: 8
    },
    "aes-128-cbc": {
        key: 16,
        iv: 16
    },
    "aes-256-cbc": {
        key: 32,
        iv: 16
    }
};
var PKCS5_SALT_LEN = 8;
function opensslKeyDeriv(cipher, salt, passphrase, count) {
    assert.buffer(salt, "salt");
    assert.buffer(passphrase, "passphrase");
    assert.number(count, "iteration count");
    var clen = CIPHER_LEN[cipher];
    assert.object(clen, "supported cipher");
    salt = salt.slice(0, PKCS5_SALT_LEN);
    var D, D_prev, bufs;
    var material = Buffer.alloc(0);
    while(material.length < clen.key + clen.iv){
        bufs = [];
        if (D_prev) bufs.push(D_prev);
        bufs.push(passphrase);
        bufs.push(salt);
        D = Buffer.concat(bufs);
        for(var j = 0; j < count; ++j)D = crypto.createHash("md5").update(D).digest();
        material = Buffer.concat([
            material,
            D
        ]);
        D_prev = D;
    }
    return {
        key: material.slice(0, clen.key),
        iv: material.slice(clen.key, clen.key + clen.iv)
    };
}
/* See: RFC2898 */ function pbkdf2(hashAlg, salt, iterations, size, passphrase) {
    var hkey = Buffer.alloc(salt.length + 4);
    salt.copy(hkey);
    var gen = 0, ts = [];
    var i = 1;
    while(gen < size){
        var t = T(i++);
        gen += t.length;
        ts.push(t);
    }
    return Buffer.concat(ts).slice(0, size);
    function T(I) {
        hkey.writeUInt32BE(I, hkey.length - 4);
        var hmac = crypto.createHmac(hashAlg, passphrase);
        hmac.update(hkey);
        var Ti = hmac.digest();
        var Uc = Ti;
        var c = 1;
        while(c++ < iterations){
            hmac = crypto.createHmac(hashAlg, passphrase);
            hmac.update(Uc);
            Uc = hmac.digest();
            for(var x = 0; x < Ti.length; ++x)Ti[x] ^= Uc[x];
        }
        return Ti;
    }
}
/* Count leading zero bits on a buffer */ function countZeros(buf) {
    var o = 0, obit = 8;
    while(o < buf.length){
        var mask = 1 << obit;
        if ((buf[o] & mask) === mask) break;
        obit--;
        if (obit < 0) {
            o++;
            obit = 8;
        }
    }
    return o * 8 + (8 - obit) - 1;
}
function bufferSplit(buf, chr) {
    assert.buffer(buf);
    assert.string(chr);
    var parts = [];
    var lastPart = 0;
    var matches = 0;
    for(var i = 0; i < buf.length; ++i){
        if (buf[i] === chr.charCodeAt(matches)) ++matches;
        else if (buf[i] === chr.charCodeAt(0)) matches = 1;
        else matches = 0;
        if (matches >= chr.length) {
            var newPart = i + 1;
            parts.push(buf.slice(lastPart, newPart - matches));
            lastPart = newPart;
            matches = 0;
        }
    }
    if (lastPart <= buf.length) parts.push(buf.slice(lastPart, buf.length));
    return parts;
}
function ecNormalize(buf, addZero) {
    assert.buffer(buf);
    if (buf[0] === 0x00 && buf[1] === 0x04) {
        if (addZero) return buf;
        return buf.slice(1);
    } else if (buf[0] === 0x04) {
        if (!addZero) return buf;
    } else {
        while(buf[0] === 0x00)buf = buf.slice(1);
        if (buf[0] === 0x02 || buf[0] === 0x03) throw new Error("Compressed elliptic curve points are not supported");
        if (buf[0] !== 0x04) throw new Error("Not a valid elliptic curve point");
        if (!addZero) return buf;
    }
    var b = Buffer.alloc(buf.length + 1);
    b[0] = 0x0;
    buf.copy(b, 1);
    return b;
}
function readBitString(der, tag) {
    if (tag === undefined) tag = asn1.Ber.BitString;
    var buf = der.readString(tag, true);
    assert.strictEqual(buf[0], 0x00, "bit strings with unused bits are not supported (0x" + buf[0].toString(16) + ")");
    return buf.slice(1);
}
function writeBitString(der, buf, tag) {
    if (tag === undefined) tag = asn1.Ber.BitString;
    var b = Buffer.alloc(buf.length + 1);
    b[0] = 0x00;
    buf.copy(b, 1);
    der.writeBuffer(b, tag);
}
function mpNormalize(buf) {
    assert.buffer(buf);
    while(buf.length > 1 && buf[0] === 0x00 && (buf[1] & 0x80) === 0x00)buf = buf.slice(1);
    if ((buf[0] & 0x80) === 0x80) {
        var b = Buffer.alloc(buf.length + 1);
        b[0] = 0x00;
        buf.copy(b, 1);
        buf = b;
    }
    return buf;
}
function mpDenormalize(buf) {
    assert.buffer(buf);
    while(buf.length > 1 && buf[0] === 0x00)buf = buf.slice(1);
    return buf;
}
function zeroPadToLength(buf, len) {
    assert.buffer(buf);
    assert.number(len);
    while(buf.length > len){
        assert.equal(buf[0], 0x00);
        buf = buf.slice(1);
    }
    while(buf.length < len){
        var b = Buffer.alloc(buf.length + 1);
        b[0] = 0x00;
        buf.copy(b, 1);
        buf = b;
    }
    return buf;
}
function bigintToMpBuf(bigint) {
    var buf = Buffer.from(bigint.toByteArray());
    buf = mpNormalize(buf);
    return buf;
}
function calculateDSAPublic(g, p, x) {
    assert.buffer(g);
    assert.buffer(p);
    assert.buffer(x);
    g = new jsbn(g);
    p = new jsbn(p);
    x = new jsbn(x);
    var y = g.modPow(x, p);
    var ybuf = bigintToMpBuf(y);
    return ybuf;
}
function calculateED25519Public(k) {
    assert.buffer(k);
    var kp = nacl.sign.keyPair.fromSeed(new Uint8Array(k));
    return Buffer.from(kp.publicKey);
}
function calculateX25519Public(k) {
    assert.buffer(k);
    var kp = nacl.box.keyPair.fromSeed(new Uint8Array(k));
    return Buffer.from(kp.publicKey);
}
function addRSAMissing(key) {
    assert.object(key);
    assertCompatible(key, PrivateKey, [
        1,
        1
    ]);
    var d = new jsbn(key.part.d.data);
    var buf;
    if (!key.part.dmodp) {
        var p = new jsbn(key.part.p.data);
        var dmodp = d.mod(p.subtract(1));
        buf = bigintToMpBuf(dmodp);
        key.part.dmodp = {
            name: "dmodp",
            data: buf
        };
        key.parts.push(key.part.dmodp);
    }
    if (!key.part.dmodq) {
        var q = new jsbn(key.part.q.data);
        var dmodq = d.mod(q.subtract(1));
        buf = bigintToMpBuf(dmodq);
        key.part.dmodq = {
            name: "dmodq",
            data: buf
        };
        key.parts.push(key.part.dmodq);
    }
}
function publicFromPrivateECDSA(curveName, priv) {
    assert.string(curveName, "curveName");
    assert.buffer(priv);
    var params = algs.curves[curveName];
    var p = new jsbn(params.p);
    var a = new jsbn(params.a);
    var b = new jsbn(params.b);
    var curve = new ec.ECCurveFp(p, a, b);
    var G = curve.decodePointHex(params.G.toString("hex"));
    var d = new jsbn(mpNormalize(priv));
    var pub = G.multiply(d);
    pub = Buffer.from(curve.encodePointHex(pub), "hex");
    var parts = [];
    parts.push({
        name: "curve",
        data: Buffer.from(curveName)
    });
    parts.push({
        name: "Q",
        data: pub
    });
    var key = new Key({
        type: "ecdsa",
        curve: curve,
        parts: parts
    });
    return key;
}
function opensshCipherInfo(cipher) {
    var inf = {};
    switch(cipher){
        case "3des-cbc":
            inf.keySize = 24;
            inf.blockSize = 8;
            inf.opensslName = "des-ede3-cbc";
            break;
        case "blowfish-cbc":
            inf.keySize = 16;
            inf.blockSize = 8;
            inf.opensslName = "bf-cbc";
            break;
        case "aes128-cbc":
        case "aes128-ctr":
        case "aes128-gcm@openssh.com":
            inf.keySize = 16;
            inf.blockSize = 16;
            inf.opensslName = "aes-128-" + cipher.slice(7, 10);
            break;
        case "aes192-cbc":
        case "aes192-ctr":
        case "aes192-gcm@openssh.com":
            inf.keySize = 24;
            inf.blockSize = 16;
            inf.opensslName = "aes-192-" + cipher.slice(7, 10);
            break;
        case "aes256-cbc":
        case "aes256-ctr":
        case "aes256-gcm@openssh.com":
            inf.keySize = 32;
            inf.blockSize = 16;
            inf.opensslName = "aes-256-" + cipher.slice(7, 10);
            break;
        default:
            throw new Error('Unsupported openssl cipher "' + cipher + '"');
    }
    return inf;
}

},{"dd7d295b18b4e00f":"eQsu4","7a7bb630ebe5a29e":"b2XZ0","5099d9efc847a18e":"4674F","9670db2f2b5b7cf7":"fAyE1","9e124268705c7aea":"8Nkdo","c8e5c952f8c511c5":"23cSW","ccd4f8f870acddee":"jC0hS","4a2ae4d70a539955":"juN6Q","30fdc4beec8c1bc8":"jfOmW","ddeb28e73d35530b":"exIc8"}],"jC0hS":[function(require,module,exports) {
// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
// If you have no idea what ASN.1 or BER is, see this:
// ftp://ftp.rsa.com/pub/pkcs/ascii/layman.asc
var Ber = require("e6f8587fbb3be376");
// --- Exported API
module.exports = {
    Ber: Ber,
    BerReader: Ber.Reader,
    BerWriter: Ber.Writer
};

},{"e6f8587fbb3be376":"ibXIu"}],"ibXIu":[function(require,module,exports) {
// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
var errors = require("512fbb076a66b293");
var types = require("ef1354c2027b329b");
var Reader = require("13cc7a5b2ebbb861");
var Writer = require("c213ae713c55307b");
// --- Exports
module.exports = {
    Reader: Reader,
    Writer: Writer
};
for(var t in types)if (types.hasOwnProperty(t)) module.exports[t] = types[t];
for(var e in errors)if (errors.hasOwnProperty(e)) module.exports[e] = errors[e];

},{"512fbb076a66b293":"5XBJn","ef1354c2027b329b":"1gh51","13cc7a5b2ebbb861":"7LvnT","c213ae713c55307b":"l1X18"}],"5XBJn":[function(require,module,exports) {
// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
module.exports = {
    newInvalidAsn1Error: function(msg) {
        var e = new Error();
        e.name = "InvalidAsn1Error";
        e.message = msg || "";
        return e;
    }
};

},{}],"1gh51":[function(require,module,exports) {
// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
module.exports = {
    EOC: 0,
    Boolean: 1,
    Integer: 2,
    BitString: 3,
    OctetString: 4,
    Null: 5,
    OID: 6,
    ObjectDescriptor: 7,
    External: 8,
    Real: 9,
    Enumeration: 10,
    PDV: 11,
    Utf8String: 12,
    RelativeOID: 13,
    Sequence: 16,
    Set: 17,
    NumericString: 18,
    PrintableString: 19,
    T61String: 20,
    VideotexString: 21,
    IA5String: 22,
    UTCTime: 23,
    GeneralizedTime: 24,
    GraphicString: 25,
    VisibleString: 26,
    GeneralString: 28,
    UniversalString: 29,
    CharacterString: 30,
    BMPString: 31,
    Constructor: 32,
    Context: 128
};

},{}],"7LvnT":[function(require,module,exports) {
// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
var assert = require("e050d07273a5eb39");
var Buffer = require("57a5bf3692121fa8").Buffer;
var ASN1 = require("799f03b062f3134b");
var errors = require("93c99172a6f55d6a");
// --- Globals
var newInvalidAsn1Error = errors.newInvalidAsn1Error;
// --- API
function Reader(data) {
    if (!data || !Buffer.isBuffer(data)) throw new TypeError("data must be a node Buffer");
    this._buf = data;
    this._size = data.length;
    // These hold the "current" state
    this._len = 0;
    this._offset = 0;
}
Object.defineProperty(Reader.prototype, "length", {
    enumerable: true,
    get: function() {
        return this._len;
    }
});
Object.defineProperty(Reader.prototype, "offset", {
    enumerable: true,
    get: function() {
        return this._offset;
    }
});
Object.defineProperty(Reader.prototype, "remain", {
    get: function() {
        return this._size - this._offset;
    }
});
Object.defineProperty(Reader.prototype, "buffer", {
    get: function() {
        return this._buf.slice(this._offset);
    }
});
/**
 * Reads a single byte and advances offset; you can pass in `true` to make this
 * a "peek" operation (i.e., get the byte, but don't advance the offset).
 *
 * @param {Boolean} peek true means don't move offset.
 * @return {Number} the next byte, null if not enough data.
 */ Reader.prototype.readByte = function(peek) {
    if (this._size - this._offset < 1) return null;
    var b = this._buf[this._offset] & 0xff;
    if (!peek) this._offset += 1;
    return b;
};
Reader.prototype.peek = function() {
    return this.readByte(true);
};
/**
 * Reads a (potentially) variable length off the BER buffer.  This call is
 * not really meant to be called directly, as callers have to manipulate
 * the internal buffer afterwards.
 *
 * As a result of this call, you can call `Reader.length`, until the
 * next thing called that does a readLength.
 *
 * @return {Number} the amount of offset to advance the buffer.
 * @throws {InvalidAsn1Error} on bad ASN.1
 */ Reader.prototype.readLength = function(offset) {
    if (offset === undefined) offset = this._offset;
    if (offset >= this._size) return null;
    var lenB = this._buf[offset++] & 0xff;
    if (lenB === null) return null;
    if ((lenB & 0x80) === 0x80) {
        lenB &= 0x7f;
        if (lenB === 0) throw newInvalidAsn1Error("Indefinite length not supported");
        if (lenB > 4) throw newInvalidAsn1Error("encoding too long");
        if (this._size - offset < lenB) return null;
        this._len = 0;
        for(var i = 0; i < lenB; i++)this._len = (this._len << 8) + (this._buf[offset++] & 0xff);
    } else // Wasn't a variable length
    this._len = lenB;
    return offset;
};
/**
 * Parses the next sequence in this BER buffer.
 *
 * To get the length of the sequence, call `Reader.length`.
 *
 * @return {Number} the sequence's tag.
 */ Reader.prototype.readSequence = function(tag) {
    var seq = this.peek();
    if (seq === null) return null;
    if (tag !== undefined && tag !== seq) throw newInvalidAsn1Error("Expected 0x" + tag.toString(16) + ": got 0x" + seq.toString(16));
    var o = this.readLength(this._offset + 1); // stored in `length`
    if (o === null) return null;
    this._offset = o;
    return seq;
};
Reader.prototype.readInt = function() {
    return this._readTag(ASN1.Integer);
};
Reader.prototype.readBoolean = function() {
    return this._readTag(ASN1.Boolean) === 0 ? false : true;
};
Reader.prototype.readEnumeration = function() {
    return this._readTag(ASN1.Enumeration);
};
Reader.prototype.readString = function(tag, retbuf) {
    if (!tag) tag = ASN1.OctetString;
    var b = this.peek();
    if (b === null) return null;
    if (b !== tag) throw newInvalidAsn1Error("Expected 0x" + tag.toString(16) + ": got 0x" + b.toString(16));
    var o = this.readLength(this._offset + 1); // stored in `length`
    if (o === null) return null;
    if (this.length > this._size - o) return null;
    this._offset = o;
    if (this.length === 0) return retbuf ? Buffer.alloc(0) : "";
    var str = this._buf.slice(this._offset, this._offset + this.length);
    this._offset += this.length;
    return retbuf ? str : str.toString("utf8");
};
Reader.prototype.readOID = function(tag) {
    if (!tag) tag = ASN1.OID;
    var b = this.readString(tag, true);
    if (b === null) return null;
    var values = [];
    var value = 0;
    for(var i = 0; i < b.length; i++){
        var byte = b[i] & 0xff;
        value <<= 7;
        value += byte & 0x7f;
        if ((byte & 0x80) === 0) {
            values.push(value);
            value = 0;
        }
    }
    value = values.shift();
    values.unshift(value % 40);
    values.unshift(value / 40 >> 0);
    return values.join(".");
};
Reader.prototype._readTag = function(tag) {
    assert.ok(tag !== undefined);
    var b = this.peek();
    if (b === null) return null;
    if (b !== tag) throw newInvalidAsn1Error("Expected 0x" + tag.toString(16) + ": got 0x" + b.toString(16));
    var o = this.readLength(this._offset + 1); // stored in `length`
    if (o === null) return null;
    if (this.length > 4) throw newInvalidAsn1Error("Integer too long: " + this.length);
    if (this.length > this._size - o) return null;
    this._offset = o;
    var fb = this._buf[this._offset];
    var value = 0;
    for(var i = 0; i < this.length; i++){
        value <<= 8;
        value |= this._buf[this._offset++] & 0xff;
    }
    if ((fb & 0x80) === 0x80 && i !== 4) value -= 1 << i * 8;
    return value >> 0;
};
// --- Exported API
module.exports = Reader;

},{"e050d07273a5eb39":"fsq0Y","57a5bf3692121fa8":"b2XZ0","799f03b062f3134b":"1gh51","93c99172a6f55d6a":"5XBJn"}],"l1X18":[function(require,module,exports) {
// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
var assert = require("7cb32f47542c6508");
var Buffer = require("9b363e68c4f13c17").Buffer;
var ASN1 = require("ca42bea54cfc3454");
var errors = require("2c08fec72ff81718");
// --- Globals
var newInvalidAsn1Error = errors.newInvalidAsn1Error;
var DEFAULT_OPTS = {
    size: 1024,
    growthFactor: 8
};
// --- Helpers
function merge(from, to) {
    assert.ok(from);
    assert.equal(typeof from, "object");
    assert.ok(to);
    assert.equal(typeof to, "object");
    var keys = Object.getOwnPropertyNames(from);
    keys.forEach(function(key) {
        if (to[key]) return;
        var value = Object.getOwnPropertyDescriptor(from, key);
        Object.defineProperty(to, key, value);
    });
    return to;
}
// --- API
function Writer(options) {
    options = merge(DEFAULT_OPTS, options || {});
    this._buf = Buffer.alloc(options.size || 1024);
    this._size = this._buf.length;
    this._offset = 0;
    this._options = options;
    // A list of offsets in the buffer where we need to insert
    // sequence tag/len pairs.
    this._seq = [];
}
Object.defineProperty(Writer.prototype, "buffer", {
    get: function() {
        if (this._seq.length) throw newInvalidAsn1Error(this._seq.length + " unended sequence(s)");
        return this._buf.slice(0, this._offset);
    }
});
Writer.prototype.writeByte = function(b) {
    if (typeof b !== "number") throw new TypeError("argument must be a Number");
    this._ensure(1);
    this._buf[this._offset++] = b;
};
Writer.prototype.writeInt = function(i, tag) {
    if (typeof i !== "number") throw new TypeError("argument must be a Number");
    if (typeof tag !== "number") tag = ASN1.Integer;
    var sz = 4;
    while(((i & 0xff800000) === 0 || (i & 0xff800000) === -8388608) && sz > 1){
        sz--;
        i <<= 8;
    }
    if (sz > 4) throw newInvalidAsn1Error("BER ints cannot be > 0xffffffff");
    this._ensure(2 + sz);
    this._buf[this._offset++] = tag;
    this._buf[this._offset++] = sz;
    while(sz-- > 0){
        this._buf[this._offset++] = (i & 0xff000000) >>> 24;
        i <<= 8;
    }
};
Writer.prototype.writeNull = function() {
    this.writeByte(ASN1.Null);
    this.writeByte(0x00);
};
Writer.prototype.writeEnumeration = function(i, tag) {
    if (typeof i !== "number") throw new TypeError("argument must be a Number");
    if (typeof tag !== "number") tag = ASN1.Enumeration;
    return this.writeInt(i, tag);
};
Writer.prototype.writeBoolean = function(b, tag) {
    if (typeof b !== "boolean") throw new TypeError("argument must be a Boolean");
    if (typeof tag !== "number") tag = ASN1.Boolean;
    this._ensure(3);
    this._buf[this._offset++] = tag;
    this._buf[this._offset++] = 0x01;
    this._buf[this._offset++] = b ? 0xff : 0x00;
};
Writer.prototype.writeString = function(s, tag) {
    if (typeof s !== "string") throw new TypeError("argument must be a string (was: " + typeof s + ")");
    if (typeof tag !== "number") tag = ASN1.OctetString;
    var len = Buffer.byteLength(s);
    this.writeByte(tag);
    this.writeLength(len);
    if (len) {
        this._ensure(len);
        this._buf.write(s, this._offset);
        this._offset += len;
    }
};
Writer.prototype.writeBuffer = function(buf, tag) {
    if (typeof tag !== "number") throw new TypeError("tag must be a number");
    if (!Buffer.isBuffer(buf)) throw new TypeError("argument must be a buffer");
    this.writeByte(tag);
    this.writeLength(buf.length);
    this._ensure(buf.length);
    buf.copy(this._buf, this._offset, 0, buf.length);
    this._offset += buf.length;
};
Writer.prototype.writeStringArray = function(strings) {
    if (!strings instanceof Array) throw new TypeError("argument must be an Array[String]");
    var self = this;
    strings.forEach(function(s) {
        self.writeString(s);
    });
};
// This is really to solve DER cases, but whatever for now
Writer.prototype.writeOID = function(s, tag) {
    if (typeof s !== "string") throw new TypeError("argument must be a string");
    if (typeof tag !== "number") tag = ASN1.OID;
    if (!/^([0-9]+\.){3,}[0-9]+$/.test(s)) throw new Error("argument is not a valid OID string");
    function encodeOctet(bytes, octet) {
        if (octet < 128) bytes.push(octet);
        else if (octet < 16384) {
            bytes.push(octet >>> 7 | 0x80);
            bytes.push(octet & 0x7F);
        } else if (octet < 2097152) {
            bytes.push(octet >>> 14 | 0x80);
            bytes.push((octet >>> 7 | 0x80) & 0xFF);
            bytes.push(octet & 0x7F);
        } else if (octet < 268435456) {
            bytes.push(octet >>> 21 | 0x80);
            bytes.push((octet >>> 14 | 0x80) & 0xFF);
            bytes.push((octet >>> 7 | 0x80) & 0xFF);
            bytes.push(octet & 0x7F);
        } else {
            bytes.push((octet >>> 28 | 0x80) & 0xFF);
            bytes.push((octet >>> 21 | 0x80) & 0xFF);
            bytes.push((octet >>> 14 | 0x80) & 0xFF);
            bytes.push((octet >>> 7 | 0x80) & 0xFF);
            bytes.push(octet & 0x7F);
        }
    }
    var tmp = s.split(".");
    var bytes = [];
    bytes.push(parseInt(tmp[0], 10) * 40 + parseInt(tmp[1], 10));
    tmp.slice(2).forEach(function(b) {
        encodeOctet(bytes, parseInt(b, 10));
    });
    var self = this;
    this._ensure(2 + bytes.length);
    this.writeByte(tag);
    this.writeLength(bytes.length);
    bytes.forEach(function(b) {
        self.writeByte(b);
    });
};
Writer.prototype.writeLength = function(len) {
    if (typeof len !== "number") throw new TypeError("argument must be a Number");
    this._ensure(4);
    if (len <= 0x7f) this._buf[this._offset++] = len;
    else if (len <= 0xff) {
        this._buf[this._offset++] = 0x81;
        this._buf[this._offset++] = len;
    } else if (len <= 0xffff) {
        this._buf[this._offset++] = 0x82;
        this._buf[this._offset++] = len >> 8;
        this._buf[this._offset++] = len;
    } else if (len <= 0xffffff) {
        this._buf[this._offset++] = 0x83;
        this._buf[this._offset++] = len >> 16;
        this._buf[this._offset++] = len >> 8;
        this._buf[this._offset++] = len;
    } else throw newInvalidAsn1Error("Length too long (> 4 bytes)");
};
Writer.prototype.startSequence = function(tag) {
    if (typeof tag !== "number") tag = ASN1.Sequence | ASN1.Constructor;
    this.writeByte(tag);
    this._seq.push(this._offset);
    this._ensure(3);
    this._offset += 3;
};
Writer.prototype.endSequence = function() {
    var seq = this._seq.pop();
    var start = seq + 3;
    var len = this._offset - start;
    if (len <= 0x7f) {
        this._shift(start, len, -2);
        this._buf[seq] = len;
    } else if (len <= 0xff) {
        this._shift(start, len, -1);
        this._buf[seq] = 0x81;
        this._buf[seq + 1] = len;
    } else if (len <= 0xffff) {
        this._buf[seq] = 0x82;
        this._buf[seq + 1] = len >> 8;
        this._buf[seq + 2] = len;
    } else if (len <= 0xffffff) {
        this._shift(start, len, 1);
        this._buf[seq] = 0x83;
        this._buf[seq + 1] = len >> 16;
        this._buf[seq + 2] = len >> 8;
        this._buf[seq + 3] = len;
    } else throw newInvalidAsn1Error("Sequence too long");
};
Writer.prototype._shift = function(start, len, shift) {
    assert.ok(start !== undefined);
    assert.ok(len !== undefined);
    assert.ok(shift);
    this._buf.copy(this._buf, start + shift, start, start + len);
    this._offset += shift;
};
Writer.prototype._ensure = function(len) {
    assert.ok(len);
    if (this._size - this._offset < len) {
        var sz = this._size * this._options.growthFactor;
        if (sz - this._offset < len) sz += len;
        var buf = Buffer.alloc(sz);
        this._buf.copy(buf, 0, 0, this._offset);
        this._buf = buf;
        this._size = sz;
    }
};
// --- Exported API
module.exports = Writer;

},{"7cb32f47542c6508":"fsq0Y","9b363e68c4f13c17":"b2XZ0","ca42bea54cfc3454":"1gh51","2c08fec72ff81718":"5XBJn"}],"juN6Q":[function(require,module,exports) {
// Basic Javascript Elliptic Curve implementation
// Ported loosely from BouncyCastle's Java EC code
// Only Fp curves implemented for now
// Requires jsbn.js and jsbn2.js
var BigInteger = require("a2edd0d51b1f1830").BigInteger;
var Barrett = BigInteger.prototype.Barrett;
// ----------------
// ECFieldElementFp
// constructor
function ECFieldElementFp(q1, x) {
    this.x = x;
    // TODO if(x.compareTo(q) >= 0) error
    this.q = q1;
}
function feFpEquals(other) {
    if (other == this) return true;
    return this.q.equals(other.q) && this.x.equals(other.x);
}
function feFpToBigInteger() {
    return this.x;
}
function feFpNegate() {
    return new ECFieldElementFp(this.q, this.x.negate().mod(this.q));
}
function feFpAdd(b) {
    return new ECFieldElementFp(this.q, this.x.add(b.toBigInteger()).mod(this.q));
}
function feFpSubtract(b) {
    return new ECFieldElementFp(this.q, this.x.subtract(b.toBigInteger()).mod(this.q));
}
function feFpMultiply(b) {
    return new ECFieldElementFp(this.q, this.x.multiply(b.toBigInteger()).mod(this.q));
}
function feFpSquare() {
    return new ECFieldElementFp(this.q, this.x.square().mod(this.q));
}
function feFpDivide(b) {
    return new ECFieldElementFp(this.q, this.x.multiply(b.toBigInteger().modInverse(this.q)).mod(this.q));
}
ECFieldElementFp.prototype.equals = feFpEquals;
ECFieldElementFp.prototype.toBigInteger = feFpToBigInteger;
ECFieldElementFp.prototype.negate = feFpNegate;
ECFieldElementFp.prototype.add = feFpAdd;
ECFieldElementFp.prototype.subtract = feFpSubtract;
ECFieldElementFp.prototype.multiply = feFpMultiply;
ECFieldElementFp.prototype.square = feFpSquare;
ECFieldElementFp.prototype.divide = feFpDivide;
// ----------------
// ECPointFp
// constructor
function ECPointFp(curve, x, y, z) {
    this.curve = curve;
    this.x = x;
    this.y = y;
    // Projective coordinates: either zinv == null or z * zinv == 1
    // z and zinv are just BigIntegers, not fieldElements
    if (z == null) this.z = BigInteger.ONE;
    else this.z = z;
    this.zinv = null;
//TODO: compression flag
}
function pointFpGetX() {
    if (this.zinv == null) this.zinv = this.z.modInverse(this.curve.q);
    var r = this.x.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
}
function pointFpGetY() {
    if (this.zinv == null) this.zinv = this.z.modInverse(this.curve.q);
    var r = this.y.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
}
function pointFpEquals(other) {
    if (other == this) return true;
    if (this.isInfinity()) return other.isInfinity();
    if (other.isInfinity()) return this.isInfinity();
    var u, v;
    // u = Y2 * Z1 - Y1 * Z2
    u = other.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(other.z)).mod(this.curve.q);
    if (!u.equals(BigInteger.ZERO)) return false;
    // v = X2 * Z1 - X1 * Z2
    v = other.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(other.z)).mod(this.curve.q);
    return v.equals(BigInteger.ZERO);
}
function pointFpIsInfinity() {
    if (this.x == null && this.y == null) return true;
    return this.z.equals(BigInteger.ZERO) && !this.y.toBigInteger().equals(BigInteger.ZERO);
}
function pointFpNegate() {
    return new ECPointFp(this.curve, this.x, this.y.negate(), this.z);
}
function pointFpAdd(b) {
    if (this.isInfinity()) return b;
    if (b.isInfinity()) return this;
    // u = Y2 * Z1 - Y1 * Z2
    var u = b.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(b.z)).mod(this.curve.q);
    // v = X2 * Z1 - X1 * Z2
    var v = b.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(b.z)).mod(this.curve.q);
    if (BigInteger.ZERO.equals(v)) {
        if (BigInteger.ZERO.equals(u)) return this.twice(); // this == b, so double
        return this.curve.getInfinity(); // this = -b, so infinity
    }
    var THREE = new BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var x2 = b.x.toBigInteger();
    var y2 = b.y.toBigInteger();
    var v2 = v.square();
    var v3 = v2.multiply(v);
    var x1v2 = x1.multiply(v2);
    var zu2 = u.square().multiply(this.z);
    // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)
    var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.q);
    // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3
    var y3 = x1v2.multiply(THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.q);
    // z3 = v^3 * z1 * z2
    var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.q);
    return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
}
function pointFpTwice() {
    if (this.isInfinity()) return this;
    if (this.y.toBigInteger().signum() == 0) return this.curve.getInfinity();
    // TODO: optimized handling of constants
    var THREE = new BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var y1z1 = y1.multiply(this.z);
    var y1sqz1 = y1z1.multiply(y1).mod(this.curve.q);
    var a = this.curve.a.toBigInteger();
    // w = 3 * x1^2 + a * z1^2
    var w = x1.square().multiply(THREE);
    if (!BigInteger.ZERO.equals(a)) w = w.add(this.z.square().multiply(a));
    w = w.mod(this.curve.q);
    //this.curve.reduce(w);
    // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)
    var x3 = w.square().subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.q);
    // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3
    var y3 = w.multiply(THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.square().multiply(w)).mod(this.curve.q);
    // z3 = 8 * (y1 * z1)^3
    var z3 = y1z1.square().multiply(y1z1).shiftLeft(3).mod(this.curve.q);
    return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
}
// Simple NAF (Non-Adjacent Form) multiplication algorithm
// TODO: modularize the multiplication algorithm
function pointFpMultiply(k) {
    if (this.isInfinity()) return this;
    if (k.signum() == 0) return this.curve.getInfinity();
    var e = k;
    var h = e.multiply(new BigInteger("3"));
    var neg = this.negate();
    var R = this;
    var i;
    for(i = h.bitLength() - 2; i > 0; --i){
        R = R.twice();
        var hBit = h.testBit(i);
        var eBit = e.testBit(i);
        if (hBit != eBit) R = R.add(hBit ? this : neg);
    }
    return R;
}
// Compute this*j + x*k (simultaneous multiplication)
function pointFpMultiplyTwo(j, x, k) {
    var i;
    if (j.bitLength() > k.bitLength()) i = j.bitLength() - 1;
    else i = k.bitLength() - 1;
    var R = this.curve.getInfinity();
    var both = this.add(x);
    while(i >= 0){
        R = R.twice();
        if (j.testBit(i)) {
            if (k.testBit(i)) R = R.add(both);
            else R = R.add(this);
        } else if (k.testBit(i)) R = R.add(x);
        --i;
    }
    return R;
}
ECPointFp.prototype.getX = pointFpGetX;
ECPointFp.prototype.getY = pointFpGetY;
ECPointFp.prototype.equals = pointFpEquals;
ECPointFp.prototype.isInfinity = pointFpIsInfinity;
ECPointFp.prototype.negate = pointFpNegate;
ECPointFp.prototype.add = pointFpAdd;
ECPointFp.prototype.twice = pointFpTwice;
ECPointFp.prototype.multiply = pointFpMultiply;
ECPointFp.prototype.multiplyTwo = pointFpMultiplyTwo;
// ----------------
// ECCurveFp
// constructor
function ECCurveFp(q1, a, b) {
    this.q = q1;
    this.a = this.fromBigInteger(a);
    this.b = this.fromBigInteger(b);
    this.infinity = new ECPointFp(this, null, null);
    this.reducer = new Barrett(this.q);
}
function curveFpGetQ() {
    return this.q;
}
function curveFpGetA() {
    return this.a;
}
function curveFpGetB() {
    return this.b;
}
function curveFpEquals(other) {
    if (other == this) return true;
    return this.q.equals(other.q) && this.a.equals(other.a) && this.b.equals(other.b);
}
function curveFpGetInfinity() {
    return this.infinity;
}
function curveFpFromBigInteger(x) {
    return new ECFieldElementFp(this.q, x);
}
function curveReduce(x) {
    this.reducer.reduce(x);
}
// for now, work with hex strings because they're easier in JS
function curveFpDecodePointHex(s) {
    switch(parseInt(s.substr(0, 2), 16)){
        case 0:
            return this.infinity;
        case 2:
        case 3:
            // point compression not supported yet
            return null;
        case 4:
        case 6:
        case 7:
            var len = (s.length - 2) / 2;
            var xHex = s.substr(2, len);
            var yHex = s.substr(len + 2, len);
            return new ECPointFp(this, this.fromBigInteger(new BigInteger(xHex, 16)), this.fromBigInteger(new BigInteger(yHex, 16)));
        default:
            return null;
    }
}
function curveFpEncodePointHex(p) {
    if (p.isInfinity()) return "00";
    var xHex = p.getX().toBigInteger().toString(16);
    var yHex = p.getY().toBigInteger().toString(16);
    var oLen = this.getQ().toString(16).length;
    if (oLen % 2 != 0) oLen++;
    while(xHex.length < oLen)xHex = "0" + xHex;
    while(yHex.length < oLen)yHex = "0" + yHex;
    return "04" + xHex + yHex;
}
ECCurveFp.prototype.getQ = curveFpGetQ;
ECCurveFp.prototype.getA = curveFpGetA;
ECCurveFp.prototype.getB = curveFpGetB;
ECCurveFp.prototype.equals = curveFpEquals;
ECCurveFp.prototype.getInfinity = curveFpGetInfinity;
ECCurveFp.prototype.fromBigInteger = curveFpFromBigInteger;
ECCurveFp.prototype.reduce = curveReduce;
//ECCurveFp.prototype.decodePointHex = curveFpDecodePointHex;
ECCurveFp.prototype.encodePointHex = curveFpEncodePointHex;
// from: https://github.com/kaielvin/jsbn-ec-point-compression
ECCurveFp.prototype.decodePointHex = function(s) {
    var yIsEven;
    switch(parseInt(s.substr(0, 2), 16)){
        case 0:
            return this.infinity;
        case 2:
            yIsEven = false;
        case 3:
            if (yIsEven == undefined) yIsEven = true;
            var len = s.length - 2;
            var xHex = s.substr(2, len);
            var x = this.fromBigInteger(new BigInteger(xHex, 16));
            var alpha = x.multiply(x.square().add(this.getA())).add(this.getB());
            var beta = alpha.sqrt();
            if (beta == null) throw "Invalid point compression";
            var betaValue = beta.toBigInteger();
            if (betaValue.testBit(0) != yIsEven) // Use the other root
            beta = this.fromBigInteger(this.getQ().subtract(betaValue));
            return new ECPointFp(this, x, beta);
        case 4:
        case 6:
        case 7:
            var len = (s.length - 2) / 2;
            var xHex = s.substr(2, len);
            var yHex = s.substr(len + 2, len);
            return new ECPointFp(this, this.fromBigInteger(new BigInteger(xHex, 16)), this.fromBigInteger(new BigInteger(yHex, 16)));
        default:
            return null;
    }
};
ECCurveFp.prototype.encodeCompressedPointHex = function(p) {
    if (p.isInfinity()) return "00";
    var xHex = p.getX().toBigInteger().toString(16);
    var oLen = this.getQ().toString(16).length;
    if (oLen % 2 != 0) oLen++;
    while(xHex.length < oLen)xHex = "0" + xHex;
    var yPrefix;
    if (p.getY().toBigInteger().isEven()) yPrefix = "02";
    else yPrefix = "03";
    return yPrefix + xHex;
};
ECFieldElementFp.prototype.getR = function() {
    if (this.r != undefined) return this.r;
    this.r = null;
    var bitLength = this.q.bitLength();
    if (bitLength > 128) {
        var firstWord = this.q.shiftRight(bitLength - 64);
        if (firstWord.intValue() == -1) this.r = BigInteger.ONE.shiftLeft(bitLength).subtract(this.q);
    }
    return this.r;
};
ECFieldElementFp.prototype.modMult = function(x1, x2) {
    return this.modReduce(x1.multiply(x2));
};
ECFieldElementFp.prototype.modReduce = function(x) {
    if (this.getR() != null) {
        var qLen = q.bitLength();
        while(x.bitLength() > qLen + 1){
            var u = x.shiftRight(qLen);
            var v = x.subtract(u.shiftLeft(qLen));
            if (!this.getR().equals(BigInteger.ONE)) u = u.multiply(this.getR());
            x = u.add(v);
        }
        while(x.compareTo(q) >= 0)x = x.subtract(q);
    } else x = x.mod(q);
    return x;
};
ECFieldElementFp.prototype.sqrt = function() {
    if (!this.q.testBit(0)) throw "unsupported";
    // p mod 4 == 3
    if (this.q.testBit(1)) {
        var z = new ECFieldElementFp(this.q, this.x.modPow(this.q.shiftRight(2).add(BigInteger.ONE), this.q));
        return z.square().equals(this) ? z : null;
    }
    // p mod 4 == 1
    var qMinusOne = this.q.subtract(BigInteger.ONE);
    var legendreExponent = qMinusOne.shiftRight(1);
    if (!this.x.modPow(legendreExponent, this.q).equals(BigInteger.ONE)) return null;
    var u = qMinusOne.shiftRight(2);
    var k = u.shiftLeft(1).add(BigInteger.ONE);
    var Q = this.x;
    var fourQ = modDouble(modDouble(Q));
    var U, V;
    do {
        var P;
        do P = new BigInteger(this.q.bitLength(), new SecureRandom());
        while (P.compareTo(this.q) >= 0 || !P.multiply(P).subtract(fourQ).modPow(legendreExponent, this.q).equals(qMinusOne));
        var result = this.lucasSequence(P, Q, k);
        U = result[0];
        V = result[1];
        if (this.modMult(V, V).equals(fourQ)) {
            // Integer division by 2, mod q
            if (V.testBit(0)) V = V.add(q);
            V = V.shiftRight(1);
            return new ECFieldElementFp(q, V);
        }
    }while (U.equals(BigInteger.ONE) || U.equals(qMinusOne));
    return null;
};
ECFieldElementFp.prototype.lucasSequence = function(P, Q, k) {
    var n = k.bitLength();
    var s = k.getLowestSetBit();
    var Uh = BigInteger.ONE;
    var Vl = BigInteger.TWO;
    var Vh = P;
    var Ql = BigInteger.ONE;
    var Qh = BigInteger.ONE;
    for(var j = n - 1; j >= s + 1; --j){
        Ql = this.modMult(Ql, Qh);
        if (k.testBit(j)) {
            Qh = this.modMult(Ql, Q);
            Uh = this.modMult(Uh, Vh);
            Vl = this.modReduce(Vh.multiply(Vl).subtract(P.multiply(Ql)));
            Vh = this.modReduce(Vh.multiply(Vh).subtract(Qh.shiftLeft(1)));
        } else {
            Qh = Ql;
            Uh = this.modReduce(Uh.multiply(Vl).subtract(Ql));
            Vh = this.modReduce(Vh.multiply(Vl).subtract(P.multiply(Ql)));
            Vl = this.modReduce(Vl.multiply(Vl).subtract(Ql.shiftLeft(1)));
        }
    }
    Ql = this.modMult(Ql, Qh);
    Qh = this.modMult(Ql, Q);
    Uh = this.modReduce(Uh.multiply(Vl).subtract(Ql));
    Vl = this.modReduce(Vh.multiply(Vl).subtract(P.multiply(Ql)));
    Ql = this.modMult(Ql, Qh);
    for(var j = 1; j <= s; ++j){
        Uh = this.modMult(Uh, Vl);
        Vl = this.modReduce(Vl.multiply(Vl).subtract(Ql.shiftLeft(1)));
        Ql = this.modMult(Ql, Ql);
    }
    return [
        Uh,
        Vl
    ];
};
var exports = {
    ECCurveFp: ECCurveFp,
    ECPointFp: ECPointFp,
    ECFieldElementFp: ECFieldElementFp
};
module.exports = exports;

},{"a2edd0d51b1f1830":"jfOmW"}],"jfOmW":[function(require,module,exports) {
(function() {
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (inBrowser && j_lm && navigator.appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Random number generator - requires a PRNG backend, e.g. prng4.js
    // For best results, put code like
    // <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
    // in your main HTML document.
    var rng_state;
    var rng_pool;
    var rng_pptr;
    // Mix in a 32-bit integer into the pool
    function rng_seed_int(x) {
        rng_pool[rng_pptr++] ^= x & 255;
        rng_pool[rng_pptr++] ^= x >> 8 & 255;
        rng_pool[rng_pptr++] ^= x >> 16 & 255;
        rng_pool[rng_pptr++] ^= x >> 24 & 255;
        if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
    }
    // Mix in the current time (w/milliseconds) into the pool
    function rng_seed_time() {
        rng_seed_int(new Date().getTime());
    }
    // Initialize the pool with junk if needed.
    if (rng_pool == null) {
        rng_pool = new Array();
        rng_pptr = 0;
        var t;
        if (typeof window !== "undefined" && window.crypto) {
            if (window.crypto.getRandomValues) {
                // Use webcrypto if available
                var ua = new Uint8Array(32);
                window.crypto.getRandomValues(ua);
                for(t = 0; t < 32; ++t)rng_pool[rng_pptr++] = ua[t];
            } else if (navigator.appName == "Netscape" && navigator.appVersion < "5") {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
        }
        while(rng_pptr < rng_psize){
            t = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = t >>> 8;
            rng_pool[rng_pptr++] = t & 255;
        }
        rng_pptr = 0;
        rng_seed_time();
    //rng_seed_int(window.screenX);
    //rng_seed_int(window.screenY);
    }
    function rng_get_byte() {
        if (rng_state == null) {
            rng_seed_time();
            rng_state = prng_newstate();
            rng_state.init(rng_pool);
            for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)rng_pool[rng_pptr] = 0;
            rng_pptr = 0;
        //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return rng_state.next();
    }
    function rng_get_bytes(ba) {
        var i;
        for(i = 0; i < ba.length; ++i)ba[i] = rng_get_byte();
    }
    function SecureRandom() {}
    SecureRandom.prototype.nextBytes = rng_get_bytes;
    // prng4.js - uses Arcfour as a PRNG
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = new Array();
    }
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    function ARC4init(key) {
        var i, j, t;
        for(i = 0; i < 256; ++i)this.S[i] = i;
        j = 0;
        for(i = 0; i < 256; ++i){
            j = j + this.S[i] + key[i % key.length] & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    }
    function ARC4next() {
        var t;
        this.i = this.i + 1 & 255;
        this.j = this.j + this.S[this.i] & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[t + this.S[this.i] & 255];
    }
    Arcfour.prototype.init = ARC4init;
    Arcfour.prototype.next = ARC4next;
    // Plug in your RNG constructor here
    function prng_newstate() {
        return new Arcfour();
    }
    // Pool size must be a multiple of 4 and greater than 32.
    // An array of bytes the size of the pool will be passed to init()
    var rng_psize = 256;
    BigInteger.SecureRandom = SecureRandom;
    BigInteger.BigInteger = BigInteger;
    exports = module.exports = BigInteger;
}).call(this);

},{}],"exIc8":[function(require,module,exports) {
(function(nacl) {
    "use strict";
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = x[j] + 128 >> 8;
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i, mlen;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        mlen = -1;
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        mlen = n;
        return mlen;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
        var t, i;
        for(i = 0; i < arguments.length; i++){
            if ((t = Object.prototype.toString.call(arguments[i])) !== "[object Uint8Array]") throw new TypeError("unexpected type " + t + ", use Uint8Array");
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    // TODO: Completely remove this in v0.15.
    if (!nacl.util) {
        nacl.util = {};
        nacl.util.decodeUTF8 = nacl.util.encodeUTF8 = nacl.util.encodeBase64 = nacl.util.decodeBase64 = function() {
            throw new Error("nacl.util moved into separate package: https://github.com/dchest/tweetnacl-util-js");
        };
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return false;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return false;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        if (arguments.length !== 2) throw new Error("nacl.sign.open accepts 2 arguments; did you mean to use nacl.sign.detached.verify?");
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = require("64deaebb838d47b8");
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

},{"64deaebb838d47b8":"49Rpi"}],"OXMVy":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = SSHBuffer;
var assert = require("34d0f86a9e6ebe96");
var Buffer = require("fe4492a347491264").Buffer;
function SSHBuffer(opts) {
    assert.object(opts, "options");
    if (opts.buffer !== undefined) assert.buffer(opts.buffer, "options.buffer");
    this._size = opts.buffer ? opts.buffer.length : 1024;
    this._buffer = opts.buffer || Buffer.alloc(this._size);
    this._offset = 0;
}
SSHBuffer.prototype.toBuffer = function() {
    return this._buffer.slice(0, this._offset);
};
SSHBuffer.prototype.atEnd = function() {
    return this._offset >= this._buffer.length;
};
SSHBuffer.prototype.remainder = function() {
    return this._buffer.slice(this._offset);
};
SSHBuffer.prototype.skip = function(n) {
    this._offset += n;
};
SSHBuffer.prototype.expand = function() {
    this._size *= 2;
    var buf = Buffer.alloc(this._size);
    this._buffer.copy(buf, 0);
    this._buffer = buf;
};
SSHBuffer.prototype.readPart = function() {
    return {
        data: this.readBuffer()
    };
};
SSHBuffer.prototype.readBuffer = function() {
    var len = this._buffer.readUInt32BE(this._offset);
    this._offset += 4;
    assert.ok(this._offset + len <= this._buffer.length, "length out of bounds at +0x" + this._offset.toString(16) + " (data truncated?)");
    var buf = this._buffer.slice(this._offset, this._offset + len);
    this._offset += len;
    return buf;
};
SSHBuffer.prototype.readString = function() {
    return this.readBuffer().toString();
};
SSHBuffer.prototype.readCString = function() {
    var offset = this._offset;
    while(offset < this._buffer.length && this._buffer[offset] !== 0x00)offset++;
    assert.ok(offset < this._buffer.length, "c string does not terminate");
    var str = this._buffer.slice(this._offset, offset).toString();
    this._offset = offset + 1;
    return str;
};
SSHBuffer.prototype.readInt = function() {
    var v = this._buffer.readUInt32BE(this._offset);
    this._offset += 4;
    return v;
};
SSHBuffer.prototype.readInt64 = function() {
    assert.ok(this._offset + 8 < this._buffer.length, "buffer not long enough to read Int64");
    var v = this._buffer.slice(this._offset, this._offset + 8);
    this._offset += 8;
    return v;
};
SSHBuffer.prototype.readChar = function() {
    var v = this._buffer[this._offset++];
    return v;
};
SSHBuffer.prototype.writeBuffer = function(buf) {
    while(this._offset + 4 + buf.length > this._size)this.expand();
    this._buffer.writeUInt32BE(buf.length, this._offset);
    this._offset += 4;
    buf.copy(this._buffer, this._offset);
    this._offset += buf.length;
};
SSHBuffer.prototype.writeString = function(str) {
    this.writeBuffer(Buffer.from(str, "utf8"));
};
SSHBuffer.prototype.writeCString = function(str) {
    while(this._offset + 1 + str.length > this._size)this.expand();
    this._buffer.write(str, this._offset);
    this._offset += str.length;
    this._buffer[this._offset++] = 0;
};
SSHBuffer.prototype.writeInt = function(v) {
    while(this._offset + 4 > this._size)this.expand();
    this._buffer.writeUInt32BE(v, this._offset);
    this._offset += 4;
};
SSHBuffer.prototype.writeInt64 = function(v) {
    assert.buffer(v, "value");
    if (v.length > 8) {
        var lead = v.slice(0, v.length - 8);
        for(var i = 0; i < lead.length; ++i)assert.strictEqual(lead[i], 0, "must fit in 64 bits of precision");
        v = v.slice(v.length - 8, v.length);
    }
    while(this._offset + 8 > this._size)this.expand();
    v.copy(this._buffer, this._offset);
    this._offset += 8;
};
SSHBuffer.prototype.writeChar = function(v) {
    while(this._offset + 1 > this._size)this.expand();
    this._buffer[this._offset++] = v;
};
SSHBuffer.prototype.writePart = function(p) {
    this.writeBuffer(p.data);
};
SSHBuffer.prototype.write = function(buf) {
    while(this._offset + buf.length > this._size)this.expand();
    buf.copy(this._buffer, this._offset);
    this._offset += buf.length;
};

},{"34d0f86a9e6ebe96":"eQsu4","fe4492a347491264":"b2XZ0"}],"4V4AY":[function(require,module,exports) {
// Copyright 2017 Joyent, Inc.
module.exports = {
    DiffieHellman: DiffieHellman,
    generateECDSA: generateECDSA,
    generateED25519: generateED25519
};
var assert = require("2de3bcdb36d35929");
var crypto = require("104dcd8e739ca387");
var Buffer = require("7bfa75162d05e883").Buffer;
var algs = require("fcb737888c30671d");
var utils = require("c5daa168c7146d78");
var nacl = require("e389be21c439a361");
var Key = require("ea5169acd8b0d38");
var PrivateKey = require("89601a1514acd40");
var CRYPTO_HAVE_ECDH = crypto.createECDH !== undefined;
var ecdh = require("3fa44eb8d91eaf08");
var ec = require("a4277c7fa18572ec");
var jsbn = require("28da13c2fe6e4c14").BigInteger;
function DiffieHellman(key) {
    utils.assertCompatible(key, Key, [
        1,
        4
    ], "key");
    this._isPriv = PrivateKey.isPrivateKey(key, [
        1,
        3
    ]);
    this._algo = key.type;
    this._curve = key.curve;
    this._key = key;
    if (key.type === "dsa") {
        if (!CRYPTO_HAVE_ECDH) throw new Error("Due to bugs in the node 0.10 crypto API, node 0.12.x or later is required to use DH");
        this._dh = crypto.createDiffieHellman(key.part.p.data, undefined, key.part.g.data, undefined);
        this._p = key.part.p;
        this._g = key.part.g;
        if (this._isPriv) this._dh.setPrivateKey(key.part.x.data);
        this._dh.setPublicKey(key.part.y.data);
    } else if (key.type === "ecdsa") {
        if (!CRYPTO_HAVE_ECDH) {
            this._ecParams = new X9ECParameters(this._curve);
            if (this._isPriv) this._priv = new ECPrivate(this._ecParams, key.part.d.data);
            return;
        }
        var curve = {
            "nistp256": "prime256v1",
            "nistp384": "secp384r1",
            "nistp521": "secp521r1"
        }[key.curve];
        this._dh = crypto.createECDH(curve);
        if (typeof this._dh !== "object" || typeof this._dh.setPrivateKey !== "function") {
            CRYPTO_HAVE_ECDH = false;
            DiffieHellman.call(this, key);
            return;
        }
        if (this._isPriv) this._dh.setPrivateKey(key.part.d.data);
        this._dh.setPublicKey(key.part.Q.data);
    } else if (key.type === "curve25519") {
        if (this._isPriv) {
            utils.assertCompatible(key, PrivateKey, [
                1,
                5
            ], "key");
            this._priv = key.part.k.data;
        }
    } else throw new Error("DH not supported for " + key.type + " keys");
}
DiffieHellman.prototype.getPublicKey = function() {
    if (this._isPriv) return this._key.toPublic();
    return this._key;
};
DiffieHellman.prototype.getPrivateKey = function() {
    if (this._isPriv) return this._key;
    else return undefined;
};
DiffieHellman.prototype.getKey = DiffieHellman.prototype.getPrivateKey;
DiffieHellman.prototype._keyCheck = function(pk, isPub) {
    assert.object(pk, "key");
    if (!isPub) utils.assertCompatible(pk, PrivateKey, [
        1,
        3
    ], "key");
    utils.assertCompatible(pk, Key, [
        1,
        4
    ], "key");
    if (pk.type !== this._algo) throw new Error("A " + pk.type + " key cannot be used in " + this._algo + " Diffie-Hellman");
    if (pk.curve !== this._curve) throw new Error("A key from the " + pk.curve + " curve " + "cannot be used with a " + this._curve + " Diffie-Hellman");
    if (pk.type === "dsa") {
        assert.deepEqual(pk.part.p, this._p, "DSA key prime does not match");
        assert.deepEqual(pk.part.g, this._g, "DSA key generator does not match");
    }
};
DiffieHellman.prototype.setKey = function(pk) {
    this._keyCheck(pk);
    if (pk.type === "dsa") {
        this._dh.setPrivateKey(pk.part.x.data);
        this._dh.setPublicKey(pk.part.y.data);
    } else if (pk.type === "ecdsa") {
        if (CRYPTO_HAVE_ECDH) {
            this._dh.setPrivateKey(pk.part.d.data);
            this._dh.setPublicKey(pk.part.Q.data);
        } else this._priv = new ECPrivate(this._ecParams, pk.part.d.data);
    } else if (pk.type === "curve25519") {
        var k = pk.part.k;
        if (!pk.part.k) k = pk.part.r;
        this._priv = k.data;
        if (this._priv[0] === 0x00) this._priv = this._priv.slice(1);
        this._priv = this._priv.slice(0, 32);
    }
    this._key = pk;
    this._isPriv = true;
};
DiffieHellman.prototype.setPrivateKey = DiffieHellman.prototype.setKey;
DiffieHellman.prototype.computeSecret = function(otherpk) {
    this._keyCheck(otherpk, true);
    if (!this._isPriv) throw new Error("DH exchange has not been initialized with a private key yet");
    var pub;
    if (this._algo === "dsa") return this._dh.computeSecret(otherpk.part.y.data);
    else if (this._algo === "ecdsa") {
        if (CRYPTO_HAVE_ECDH) return this._dh.computeSecret(otherpk.part.Q.data);
        else {
            pub = new ECPublic(this._ecParams, otherpk.part.Q.data);
            return this._priv.deriveSharedSecret(pub);
        }
    } else if (this._algo === "curve25519") {
        pub = otherpk.part.A.data;
        while(pub[0] === 0x00 && pub.length > 32)pub = pub.slice(1);
        var priv = this._priv;
        assert.strictEqual(pub.length, 32);
        assert.strictEqual(priv.length, 32);
        var secret = nacl.box.before(new Uint8Array(pub), new Uint8Array(priv));
        return Buffer.from(secret);
    }
    throw new Error("Invalid algorithm: " + this._algo);
};
DiffieHellman.prototype.generateKey = function() {
    var parts = [];
    var priv, pub;
    if (this._algo === "dsa") {
        this._dh.generateKeys();
        parts.push({
            name: "p",
            data: this._p.data
        });
        parts.push({
            name: "q",
            data: this._key.part.q.data
        });
        parts.push({
            name: "g",
            data: this._g.data
        });
        parts.push({
            name: "y",
            data: this._dh.getPublicKey()
        });
        parts.push({
            name: "x",
            data: this._dh.getPrivateKey()
        });
        this._key = new PrivateKey({
            type: "dsa",
            parts: parts
        });
        this._isPriv = true;
        return this._key;
    } else if (this._algo === "ecdsa") {
        if (CRYPTO_HAVE_ECDH) {
            this._dh.generateKeys();
            parts.push({
                name: "curve",
                data: Buffer.from(this._curve)
            });
            parts.push({
                name: "Q",
                data: this._dh.getPublicKey()
            });
            parts.push({
                name: "d",
                data: this._dh.getPrivateKey()
            });
            this._key = new PrivateKey({
                type: "ecdsa",
                curve: this._curve,
                parts: parts
            });
            this._isPriv = true;
            return this._key;
        } else {
            var n = this._ecParams.getN();
            var r = new jsbn(crypto.randomBytes(n.bitLength()));
            var n1 = n.subtract(jsbn.ONE);
            priv = r.mod(n1).add(jsbn.ONE);
            pub = this._ecParams.getG().multiply(priv);
            priv = Buffer.from(priv.toByteArray());
            pub = Buffer.from(this._ecParams.getCurve().encodePointHex(pub), "hex");
            this._priv = new ECPrivate(this._ecParams, priv);
            parts.push({
                name: "curve",
                data: Buffer.from(this._curve)
            });
            parts.push({
                name: "Q",
                data: pub
            });
            parts.push({
                name: "d",
                data: priv
            });
            this._key = new PrivateKey({
                type: "ecdsa",
                curve: this._curve,
                parts: parts
            });
            this._isPriv = true;
            return this._key;
        }
    } else if (this._algo === "curve25519") {
        var pair = nacl.box.keyPair();
        priv = Buffer.from(pair.secretKey);
        pub = Buffer.from(pair.publicKey);
        priv = Buffer.concat([
            priv,
            pub
        ]);
        assert.strictEqual(priv.length, 64);
        assert.strictEqual(pub.length, 32);
        parts.push({
            name: "A",
            data: pub
        });
        parts.push({
            name: "k",
            data: priv
        });
        this._key = new PrivateKey({
            type: "curve25519",
            parts: parts
        });
        this._isPriv = true;
        return this._key;
    }
    throw new Error("Invalid algorithm: " + this._algo);
};
DiffieHellman.prototype.generateKeys = DiffieHellman.prototype.generateKey;
/* These are helpers for using ecc-jsbn (for node 0.10 compatibility). */ function X9ECParameters(name) {
    var params = algs.curves[name];
    assert.object(params);
    var p = new jsbn(params.p);
    var a = new jsbn(params.a);
    var b = new jsbn(params.b);
    var n = new jsbn(params.n);
    var h = jsbn.ONE;
    var curve = new ec.ECCurveFp(p, a, b);
    var G = curve.decodePointHex(params.G.toString("hex"));
    this.curve = curve;
    this.g = G;
    this.n = n;
    this.h = h;
}
X9ECParameters.prototype.getCurve = function() {
    return this.curve;
};
X9ECParameters.prototype.getG = function() {
    return this.g;
};
X9ECParameters.prototype.getN = function() {
    return this.n;
};
X9ECParameters.prototype.getH = function() {
    return this.h;
};
function ECPublic(params, buffer) {
    this._params = params;
    if (buffer[0] === 0x00) buffer = buffer.slice(1);
    this._pub = params.getCurve().decodePointHex(buffer.toString("hex"));
}
function ECPrivate(params, buffer) {
    this._params = params;
    this._priv = new jsbn(utils.mpNormalize(buffer));
}
ECPrivate.prototype.deriveSharedSecret = function(pubKey) {
    assert.ok(pubKey instanceof ECPublic);
    var S = pubKey._pub.multiply(this._priv);
    return Buffer.from(S.getX().toBigInteger().toByteArray());
};
function generateED25519() {
    var pair = nacl.sign.keyPair();
    var priv = Buffer.from(pair.secretKey);
    var pub = Buffer.from(pair.publicKey);
    assert.strictEqual(priv.length, 64);
    assert.strictEqual(pub.length, 32);
    var parts = [];
    parts.push({
        name: "A",
        data: pub
    });
    parts.push({
        name: "k",
        data: priv.slice(0, 32)
    });
    var key = new PrivateKey({
        type: "ed25519",
        parts: parts
    });
    return key;
}
/* Generates a new ECDSA private key on a given curve. */ function generateECDSA(curve) {
    var parts = [];
    var key;
    if (CRYPTO_HAVE_ECDH) {
        /*
		 * Node crypto doesn't expose key generation directly, but the
		 * ECDH instances can generate keys. It turns out this just
		 * calls into the OpenSSL generic key generator, and we can
		 * read its output happily without doing an actual DH. So we
		 * use that here.
		 */ var osCurve = {
            "nistp256": "prime256v1",
            "nistp384": "secp384r1",
            "nistp521": "secp521r1"
        }[curve];
        var dh = crypto.createECDH(osCurve);
        dh.generateKeys();
        parts.push({
            name: "curve",
            data: Buffer.from(curve)
        });
        parts.push({
            name: "Q",
            data: dh.getPublicKey()
        });
        parts.push({
            name: "d",
            data: dh.getPrivateKey()
        });
        key = new PrivateKey({
            type: "ecdsa",
            curve: curve,
            parts: parts
        });
        return key;
    } else {
        var ecParams = new X9ECParameters(curve);
        /* This algorithm taken from FIPS PUB 186-4 (section B.4.1) */ var n = ecParams.getN();
        /*
		 * The crypto.randomBytes() function can only give us whole
		 * bytes, so taking a nod from X9.62, we round up.
		 */ var cByteLen = Math.ceil((n.bitLength() + 64) / 8);
        var c = new jsbn(crypto.randomBytes(cByteLen));
        var n1 = n.subtract(jsbn.ONE);
        var priv = c.mod(n1).add(jsbn.ONE);
        var pub = ecParams.getG().multiply(priv);
        priv = Buffer.from(priv.toByteArray());
        pub = Buffer.from(ecParams.getCurve().encodePointHex(pub), "hex");
        parts.push({
            name: "curve",
            data: Buffer.from(curve)
        });
        parts.push({
            name: "Q",
            data: pub
        });
        parts.push({
            name: "d",
            data: priv
        });
        key = new PrivateKey({
            type: "ecdsa",
            curve: curve,
            parts: parts
        });
        return key;
    }
}

},{"2de3bcdb36d35929":"eQsu4","104dcd8e739ca387":"8Nkdo","7bfa75162d05e883":"b2XZ0","fcb737888c30671d":"23cSW","c5daa168c7146d78":"icPN2","e389be21c439a361":"exIc8","ea5169acd8b0d38":"fAyE1","89601a1514acd40":"4674F","3fa44eb8d91eaf08":"8JLXJ","a4277c7fa18572ec":"juN6Q","28da13c2fe6e4c14":"jfOmW"}],"8JLXJ":[function(require,module,exports) {
var crypto = require("5df5f4a59eada55f");
var BigInteger = require("e6aab615d552d508").BigInteger;
var ECPointFp = require("af59dcd3087ac963").ECPointFp;
var Buffer = require("795649142cde04b8").Buffer;
exports.ECCurves = require("8ede8ed57152cd77");
// zero prepad
function unstupid(hex, len) {
    return hex.length >= len ? hex : unstupid("0" + hex, len);
}
exports.ECKey = function(curve, key, isPublic) {
    var priv;
    var c = curve();
    var n = c.getN();
    var bytes = Math.floor(n.bitLength() / 8);
    if (key) {
        if (isPublic) {
            var curve = c.getCurve();
            //      var x = key.slice(1,bytes+1); // skip the 04 for uncompressed format
            //      var y = key.slice(bytes+1);
            //      this.P = new ECPointFp(curve,
            //        curve.fromBigInteger(new BigInteger(x.toString("hex"), 16)),
            //        curve.fromBigInteger(new BigInteger(y.toString("hex"), 16)));      
            this.P = curve.decodePointHex(key.toString("hex"));
        } else {
            if (key.length != bytes) return false;
            priv = new BigInteger(key.toString("hex"), 16);
        }
    } else {
        var n1 = n.subtract(BigInteger.ONE);
        var r = new BigInteger(crypto.randomBytes(n.bitLength()));
        priv = r.mod(n1).add(BigInteger.ONE);
        this.P = c.getG().multiply(priv);
    }
    if (this.P) //  var pubhex = unstupid(this.P.getX().toBigInteger().toString(16),bytes*2)+unstupid(this.P.getY().toBigInteger().toString(16),bytes*2);
    //  this.PublicKey = Buffer.from("04"+pubhex,"hex");
    this.PublicKey = Buffer.from(c.getCurve().encodeCompressedPointHex(this.P), "hex");
    if (priv) {
        this.PrivateKey = Buffer.from(unstupid(priv.toString(16), bytes * 2), "hex");
        this.deriveSharedSecret = function(key) {
            if (!key || !key.P) return false;
            var S = key.P.multiply(priv);
            return Buffer.from(unstupid(S.getX().toBigInteger().toString(16), bytes * 2), "hex");
        };
    }
};

},{"5df5f4a59eada55f":"8Nkdo","e6aab615d552d508":"jfOmW","af59dcd3087ac963":"juN6Q","795649142cde04b8":"b2XZ0","8ede8ed57152cd77":"cqDhN"}],"cqDhN":[function(require,module,exports) {
// Named EC curves
// Requires ec.js, jsbn.js, and jsbn2.js
var BigInteger = require("e7f45e27734a41c0").BigInteger;
var ECCurveFp = require("d063cdfaa2aef236").ECCurveFp;
// ----------------
// X9ECParameters
// constructor
function X9ECParameters(curve, g, n, h) {
    this.curve = curve;
    this.g = g;
    this.n = n;
    this.h = h;
}
function x9getCurve() {
    return this.curve;
}
function x9getG() {
    return this.g;
}
function x9getN() {
    return this.n;
}
function x9getH() {
    return this.h;
}
X9ECParameters.prototype.getCurve = x9getCurve;
X9ECParameters.prototype.getG = x9getG;
X9ECParameters.prototype.getN = x9getN;
X9ECParameters.prototype.getH = x9getH;
// ----------------
// SECNamedCurves
function fromHex(s) {
    return new BigInteger(s, 16);
}
function secp128r1() {
    // p = 2^128 - 2^97 - 1
    var p = fromHex("FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC");
    var b = fromHex("E87579C11079F43DD824993C2CEE5ED3");
    //byte[] S = Hex.decode("000E0D4D696E6768756151750CC03A4473D03679");
    var n = fromHex("FFFFFFFE0000000075A30D1B9038A115");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04161FF7528B899B2D0C28607CA52C5B86CF5AC8395BAFEB13C02DA292DDED7A83");
    return new X9ECParameters(curve, G, n, h);
}
function secp160k1() {
    // p = 2^160 - 2^32 - 2^14 - 2^12 - 2^9 - 2^8 - 2^7 - 2^3 - 2^2 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73");
    var a = BigInteger.ZERO;
    var b = fromHex("7");
    //byte[] S = null;
    var n = fromHex("0100000000000000000001B8FA16DFAB9ACA16B6B3");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("043B4C382CE37AA192A4019E763036F4F5DD4D7EBB938CF935318FDCED6BC28286531733C3F03C4FEE");
    return new X9ECParameters(curve, G, n, h);
}
function secp160r1() {
    // p = 2^160 - 2^31 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC");
    var b = fromHex("1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45");
    //byte[] S = Hex.decode("1053CDE42C14D696E67687561517533BF3F83345");
    var n = fromHex("0100000000000000000001F4C8F927AED3CA752257");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("044A96B5688EF573284664698968C38BB913CBFC8223A628553168947D59DCC912042351377AC5FB32");
    return new X9ECParameters(curve, G, n, h);
}
function secp192k1() {
    // p = 2^192 - 2^32 - 2^12 - 2^8 - 2^7 - 2^6 - 2^3 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37");
    var a = BigInteger.ZERO;
    var b = fromHex("3");
    //byte[] S = null;
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D");
    return new X9ECParameters(curve, G, n, h);
}
function secp192r1() {
    // p = 2^192 - 2^64 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC");
    var b = fromHex("64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1");
    //byte[] S = Hex.decode("3045AE6FC8422F64ED579528D38120EAE12196D5");
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF101207192B95FFC8DA78631011ED6B24CDD573F977A11E794811");
    return new X9ECParameters(curve, G, n, h);
}
function secp224r1() {
    // p = 2^224 - 2^96 + 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE");
    var b = fromHex("B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4");
    //byte[] S = Hex.decode("BD71344799D5C7FCDC45B59FA3B9AB8F6A948BC5");
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34");
    return new X9ECParameters(curve, G, n, h);
}
function secp256r1() {
    // p = 2^224 (2^32 - 1) + 2^192 + 2^96 - 1
    var p = fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC");
    var b = fromHex("5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B");
    //byte[] S = Hex.decode("C49D360886E704936A6678E1139D26B7819F7E90");
    var n = fromHex("FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("046B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C2964FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5");
    return new X9ECParameters(curve, G, n, h);
}
// TODO: make this into a proper hashtable
function getSECCurveByName(name) {
    if (name == "secp128r1") return secp128r1();
    if (name == "secp160k1") return secp160k1();
    if (name == "secp160r1") return secp160r1();
    if (name == "secp192k1") return secp192k1();
    if (name == "secp192r1") return secp192r1();
    if (name == "secp224r1") return secp224r1();
    if (name == "secp256r1") return secp256r1();
    return null;
}
module.exports = {
    "secp128r1": secp128r1,
    "secp160k1": secp160k1,
    "secp160r1": secp160r1,
    "secp192k1": secp192k1,
    "secp192r1": secp192r1,
    "secp224r1": secp224r1,
    "secp256r1": secp256r1
};

},{"e7f45e27734a41c0":"jfOmW","d063cdfaa2aef236":"juN6Q"}],"c01LN":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = {
    Verifier: Verifier,
    Signer: Signer
};
var nacl = require("bc2852607dcf864d");
var stream = require("210c92904498ef40");
var util = require("60c9c6bbae6606e8");
var assert = require("b8b1d698f99832f8");
var Buffer = require("5f0e84591f6cc1d4").Buffer;
var Signature = require("f92e5560fec4f08b");
function Verifier(key, hashAlgo) {
    if (hashAlgo.toLowerCase() !== "sha512") throw new Error("ED25519 only supports the use of SHA-512 hashes");
    this.key = key;
    this.chunks = [];
    stream.Writable.call(this, {});
}
util.inherits(Verifier, stream.Writable);
Verifier.prototype._write = function(chunk, enc, cb) {
    this.chunks.push(chunk);
    cb();
};
Verifier.prototype.update = function(chunk) {
    if (typeof chunk === "string") chunk = Buffer.from(chunk, "binary");
    this.chunks.push(chunk);
};
Verifier.prototype.verify = function(signature, fmt) {
    var sig;
    if (Signature.isSignature(signature, [
        2,
        0
    ])) {
        if (signature.type !== "ed25519") return false;
        sig = signature.toBuffer("raw");
    } else if (typeof signature === "string") sig = Buffer.from(signature, "base64");
    else if (Signature.isSignature(signature, [
        1,
        0
    ])) throw new Error("signature was created by too old a version of sshpk and cannot be verified");
    assert.buffer(sig);
    return nacl.sign.detached.verify(new Uint8Array(Buffer.concat(this.chunks)), new Uint8Array(sig), new Uint8Array(this.key.part.A.data));
};
function Signer(key, hashAlgo) {
    if (hashAlgo.toLowerCase() !== "sha512") throw new Error("ED25519 only supports the use of SHA-512 hashes");
    this.key = key;
    this.chunks = [];
    stream.Writable.call(this, {});
}
util.inherits(Signer, stream.Writable);
Signer.prototype._write = function(chunk, enc, cb) {
    this.chunks.push(chunk);
    cb();
};
Signer.prototype.update = function(chunk) {
    if (typeof chunk === "string") chunk = Buffer.from(chunk, "binary");
    this.chunks.push(chunk);
};
Signer.prototype.sign = function() {
    var sig = nacl.sign.detached(new Uint8Array(Buffer.concat(this.chunks)), new Uint8Array(Buffer.concat([
        this.key.part.k.data,
        this.key.part.A.data
    ])));
    var sigBuf = Buffer.from(sig);
    var sigObj = Signature.parse(sigBuf, "ed25519", "raw");
    sigObj.hashAlgorithm = "sha512";
    return sigObj;
};

},{"bc2852607dcf864d":"exIc8","210c92904498ef40":"4ooMZ","60c9c6bbae6606e8":"dJawj","b8b1d698f99832f8":"eQsu4","5f0e84591f6cc1d4":"b2XZ0","f92e5560fec4f08b":"cxjr0"}],"kF0lg":[function(require,module,exports) {
// Copyright 2018 Joyent, Inc.
module.exports = {
    read: read,
    write: write
};
var assert = require("463c98cd721c96d9");
var Buffer = require("fc7bad0340c19ca").Buffer;
var utils = require("1794de3dfa3115bd");
var Key = require("c9cd58e6b1105349");
var PrivateKey = require("dc5f06d2de052821");
var pem = require("9813c48b6fb2bbb9");
var ssh = require("ee8d1e51c26b8c90");
var rfc4253 = require("10d8e700fb93d51");
var dnssec = require("559d77664d95bb9d");
var putty = require("ee39b591299dd840");
var DNSSEC_PRIVKEY_HEADER_PREFIX = "Private-key-format: v1";
function read(buf, options) {
    if (typeof buf === "string") {
        if (buf.trim().match(/^[-]+[ ]*BEGIN/)) return pem.read(buf, options);
        if (buf.match(/^\s*ssh-[a-z]/)) return ssh.read(buf, options);
        if (buf.match(/^\s*ecdsa-/)) return ssh.read(buf, options);
        if (buf.match(/^putty-user-key-file-2:/i)) return putty.read(buf, options);
        if (findDNSSECHeader(buf)) return dnssec.read(buf, options);
        buf = Buffer.from(buf, "binary");
    } else {
        assert.buffer(buf);
        if (findPEMHeader(buf)) return pem.read(buf, options);
        if (findSSHHeader(buf)) return ssh.read(buf, options);
        if (findPuTTYHeader(buf)) return putty.read(buf, options);
        if (findDNSSECHeader(buf)) return dnssec.read(buf, options);
    }
    if (buf.readUInt32BE(0) < buf.length) return rfc4253.read(buf, options);
    throw new Error("Failed to auto-detect format of key");
}
function findPuTTYHeader(buf) {
    var offset = 0;
    while(offset < buf.length && (buf[offset] === 32 || buf[offset] === 10 || buf[offset] === 9))++offset;
    if (offset + 22 <= buf.length && buf.slice(offset, offset + 22).toString("ascii").toLowerCase() === "putty-user-key-file-2:") return true;
    return false;
}
function findSSHHeader(buf) {
    var offset = 0;
    while(offset < buf.length && (buf[offset] === 32 || buf[offset] === 10 || buf[offset] === 9))++offset;
    if (offset + 4 <= buf.length && buf.slice(offset, offset + 4).toString("ascii") === "ssh-") return true;
    if (offset + 6 <= buf.length && buf.slice(offset, offset + 6).toString("ascii") === "ecdsa-") return true;
    return false;
}
function findPEMHeader(buf) {
    var offset = 0;
    while(offset < buf.length && (buf[offset] === 32 || buf[offset] === 10))++offset;
    if (buf[offset] !== 45) return false;
    while(offset < buf.length && buf[offset] === 45)++offset;
    while(offset < buf.length && buf[offset] === 32)++offset;
    if (offset + 5 > buf.length || buf.slice(offset, offset + 5).toString("ascii") !== "BEGIN") return false;
    return true;
}
function findDNSSECHeader(buf) {
    // private case first
    if (buf.length <= DNSSEC_PRIVKEY_HEADER_PREFIX.length) return false;
    var headerCheck = buf.slice(0, DNSSEC_PRIVKEY_HEADER_PREFIX.length);
    if (headerCheck.toString("ascii") === DNSSEC_PRIVKEY_HEADER_PREFIX) return true;
    // public-key RFC3110 ?
    // 'domain.com. IN KEY ...' or 'domain.com. IN DNSKEY ...'
    // skip any comment-lines
    if (typeof buf !== "string") buf = buf.toString("ascii");
    var lines = buf.split("\n");
    var line = 0;
    /* JSSTYLED */ while(lines[line].match(/^\;/))line++;
    if (lines[line].toString("ascii").match(/\. IN KEY /)) return true;
    if (lines[line].toString("ascii").match(/\. IN DNSKEY /)) return true;
    return false;
}
function write(key, options) {
    throw new Error('"auto" format cannot be used for writing');
}

},{"463c98cd721c96d9":"eQsu4","fc7bad0340c19ca":"b2XZ0","1794de3dfa3115bd":"icPN2","c9cd58e6b1105349":"fAyE1","dc5f06d2de052821":"4674F","9813c48b6fb2bbb9":"fUNos","ee8d1e51c26b8c90":"apfcv","10d8e700fb93d51":"btAO6","559d77664d95bb9d":"bfK2i","ee39b591299dd840":"fNdMF"}],"fUNos":[function(require,module,exports) {
// Copyright 2018 Joyent, Inc.
module.exports = {
    read: read,
    write: write
};
var assert = require("e26dd6dbb61597da");
var asn1 = require("e48a5bcb283c80b3");
var crypto = require("1e93b4ff31ad7437");
var Buffer = require("c534cfede75bc67").Buffer;
var algs = require("7605482af1764e62");
var utils = require("8fa1fb4db0af5577");
var Key = require("fb3c3f82da233eca");
var PrivateKey = require("dfb9b896a98988af");
var pkcs1 = require("a2eaa24f9d5b1169");
var pkcs8 = require("1d42e71499707fca");
var sshpriv = require("841e1b129b3bde9a");
var rfc4253 = require("dca52476ca80afc4");
var errors = require("f8ee1e39e00db828");
var OID_PBES2 = "1.2.840.113549.1.5.13";
var OID_PBKDF2 = "1.2.840.113549.1.5.12";
var OID_TO_CIPHER = {
    "1.2.840.113549.3.7": "3des-cbc",
    "2.16.840.1.101.3.4.1.2": "aes128-cbc",
    "2.16.840.1.101.3.4.1.42": "aes256-cbc"
};
var CIPHER_TO_OID = {};
Object.keys(OID_TO_CIPHER).forEach(function(k) {
    CIPHER_TO_OID[OID_TO_CIPHER[k]] = k;
});
var OID_TO_HASH = {
    "1.2.840.113549.2.7": "sha1",
    "1.2.840.113549.2.9": "sha256",
    "1.2.840.113549.2.11": "sha512"
};
var HASH_TO_OID = {};
Object.keys(OID_TO_HASH).forEach(function(k) {
    HASH_TO_OID[OID_TO_HASH[k]] = k;
});
/*
 * For reading we support both PKCS#1 and PKCS#8. If we find a private key,
 * we just take the public component of it and use that.
 */ function read(buf, options, forceType) {
    var input = buf;
    if (typeof buf !== "string") {
        assert.buffer(buf, "buf");
        buf = buf.toString("ascii");
    }
    var lines = buf.trim().split(/[\r\n]+/g);
    var m;
    var si = -1;
    while(!m && si < lines.length)m = lines[++si].match(/*JSSTYLED*/ /[-]+[ ]*BEGIN ([A-Z0-9][A-Za-z0-9]+ )?(PUBLIC|PRIVATE) KEY[ ]*[-]+/);
    assert.ok(m, "invalid PEM header");
    var m2;
    var ei = lines.length;
    while(!m2 && ei > 0)m2 = lines[--ei].match(/*JSSTYLED*/ /[-]+[ ]*END ([A-Z0-9][A-Za-z0-9]+ )?(PUBLIC|PRIVATE) KEY[ ]*[-]+/);
    assert.ok(m2, "invalid PEM footer");
    /* Begin and end banners must match key type */ assert.equal(m[2], m2[2]);
    var type = m[2].toLowerCase();
    var alg;
    if (m[1]) {
        /* They also must match algorithms, if given */ assert.equal(m[1], m2[1], "PEM header and footer mismatch");
        alg = m[1].trim();
    }
    lines = lines.slice(si, ei + 1);
    var headers = {};
    while(true){
        lines = lines.slice(1);
        m = lines[0].match(/*JSSTYLED*/ /^([A-Za-z0-9-]+): (.+)$/);
        if (!m) break;
        headers[m[1].toLowerCase()] = m[2];
    }
    /* Chop off the first and last lines */ lines = lines.slice(0, -1).join("");
    buf = Buffer.from(lines, "base64");
    var cipher, key, iv;
    if (headers["proc-type"]) {
        var parts = headers["proc-type"].split(",");
        if (parts[0] === "4" && parts[1] === "ENCRYPTED") {
            if (typeof options.passphrase === "string") options.passphrase = Buffer.from(options.passphrase, "utf-8");
            if (!Buffer.isBuffer(options.passphrase)) throw new errors.KeyEncryptedError(options.filename, "PEM");
            else {
                parts = headers["dek-info"].split(",");
                assert.ok(parts.length === 2);
                cipher = parts[0].toLowerCase();
                iv = Buffer.from(parts[1], "hex");
                key = utils.opensslKeyDeriv(cipher, iv, options.passphrase, 1).key;
            }
        }
    }
    if (alg && alg.toLowerCase() === "encrypted") {
        var eder = new asn1.BerReader(buf);
        var pbesEnd;
        eder.readSequence();
        eder.readSequence();
        pbesEnd = eder.offset + eder.length;
        var method = eder.readOID();
        if (method !== OID_PBES2) throw new Error("Unsupported PEM/PKCS8 encryption scheme: " + method);
        eder.readSequence(); /* PBES2-params */ 
        eder.readSequence(); /* keyDerivationFunc */ 
        var kdfEnd = eder.offset + eder.length;
        var kdfOid = eder.readOID();
        if (kdfOid !== OID_PBKDF2) throw new Error("Unsupported PBES2 KDF: " + kdfOid);
        eder.readSequence();
        var salt = eder.readString(asn1.Ber.OctetString, true);
        var iterations = eder.readInt();
        var hashAlg = "sha1";
        if (eder.offset < kdfEnd) {
            eder.readSequence();
            var hashAlgOid = eder.readOID();
            hashAlg = OID_TO_HASH[hashAlgOid];
            if (hashAlg === undefined) throw new Error("Unsupported PBKDF2 hash: " + hashAlgOid);
        }
        eder._offset = kdfEnd;
        eder.readSequence(); /* encryptionScheme */ 
        var cipherOid = eder.readOID();
        cipher = OID_TO_CIPHER[cipherOid];
        if (cipher === undefined) throw new Error("Unsupported PBES2 cipher: " + cipherOid);
        iv = eder.readString(asn1.Ber.OctetString, true);
        eder._offset = pbesEnd;
        buf = eder.readString(asn1.Ber.OctetString, true);
        if (typeof options.passphrase === "string") options.passphrase = Buffer.from(options.passphrase, "utf-8");
        if (!Buffer.isBuffer(options.passphrase)) throw new errors.KeyEncryptedError(options.filename, "PEM");
        var cinfo = utils.opensshCipherInfo(cipher);
        cipher = cinfo.opensslName;
        key = utils.pbkdf2(hashAlg, salt, iterations, cinfo.keySize, options.passphrase);
        alg = undefined;
    }
    if (cipher && key && iv) {
        var cipherStream = crypto.createDecipheriv(cipher, key, iv);
        var chunk, chunks = [];
        cipherStream.once("error", function(e) {
            if (e.toString().indexOf("bad decrypt") !== -1) throw new Error("Incorrect passphrase supplied, could not decrypt key");
            throw e;
        });
        cipherStream.write(buf);
        cipherStream.end();
        while((chunk = cipherStream.read()) !== null)chunks.push(chunk);
        buf = Buffer.concat(chunks);
    }
    /* The new OpenSSH internal format abuses PEM headers */ if (alg && alg.toLowerCase() === "openssh") return sshpriv.readSSHPrivate(type, buf, options);
    if (alg && alg.toLowerCase() === "ssh2") return rfc4253.readType(type, buf, options);
    var der = new asn1.BerReader(buf);
    der.originalInput = input;
    /*
	 * All of the PEM file types start with a sequence tag, so chop it
	 * off here
	 */ der.readSequence();
    /* PKCS#1 type keys name an algorithm in the banner explicitly */ if (alg) {
        if (forceType) assert.strictEqual(forceType, "pkcs1");
        return pkcs1.readPkcs1(alg, type, der);
    } else {
        if (forceType) assert.strictEqual(forceType, "pkcs8");
        return pkcs8.readPkcs8(alg, type, der);
    }
}
function write(key, options, type) {
    assert.object(key);
    var alg = {
        "ecdsa": "EC",
        "rsa": "RSA",
        "dsa": "DSA",
        "ed25519": "EdDSA"
    }[key.type];
    var header;
    var der = new asn1.BerWriter();
    if (PrivateKey.isPrivateKey(key)) {
        if (type && type === "pkcs8") {
            header = "PRIVATE KEY";
            pkcs8.writePkcs8(der, key);
        } else {
            if (type) assert.strictEqual(type, "pkcs1");
            header = alg + " PRIVATE KEY";
            pkcs1.writePkcs1(der, key);
        }
    } else if (Key.isKey(key)) {
        if (type && type === "pkcs1") {
            header = alg + " PUBLIC KEY";
            pkcs1.writePkcs1(der, key);
        } else {
            if (type) assert.strictEqual(type, "pkcs8");
            header = "PUBLIC KEY";
            pkcs8.writePkcs8(der, key);
        }
    } else throw new Error("key is not a Key or PrivateKey");
    var tmp = der.buffer.toString("base64");
    var len = tmp.length + tmp.length / 64 + 18 + 16 + header.length * 2 + 10;
    var buf = Buffer.alloc(len);
    var o = 0;
    o += buf.write("-----BEGIN " + header + "-----\n", o);
    for(var i = 0; i < tmp.length;){
        var limit = i + 64;
        if (limit > tmp.length) limit = tmp.length;
        o += buf.write(tmp.slice(i, limit), o);
        buf[o++] = 10;
        i = limit;
    }
    o += buf.write("-----END " + header + "-----\n", o);
    return buf.slice(0, o);
}

},{"e26dd6dbb61597da":"eQsu4","e48a5bcb283c80b3":"jC0hS","1e93b4ff31ad7437":"8Nkdo","c534cfede75bc67":"b2XZ0","7605482af1764e62":"23cSW","8fa1fb4db0af5577":"icPN2","fb3c3f82da233eca":"fAyE1","dfb9b896a98988af":"4674F","a2eaa24f9d5b1169":"aGcIc","1d42e71499707fca":"iNFUG","841e1b129b3bde9a":"2pfcf","dca52476ca80afc4":"btAO6","f8ee1e39e00db828":"6DKEY"}],"aGcIc":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = {
    read: read,
    readPkcs1: readPkcs1,
    write: write,
    writePkcs1: writePkcs1
};
var assert = require("c29bd0554c6f2ee7");
var asn1 = require("b066099739a7e0da");
var Buffer = require("d1c435af0a5d3c4f").Buffer;
var algs = require("26280ac05e78b2b4");
var utils = require("bee21eedf6306318");
var Key = require("8e073b393d191269");
var PrivateKey = require("3971444feffafa9");
var pem = require("ffd5014eeb4d48c");
var pkcs8 = require("8fae450826f243ee");
var readECDSACurve = pkcs8.readECDSACurve;
function read(buf, options) {
    return pem.read(buf, options, "pkcs1");
}
function write(key, options) {
    return pem.write(key, options, "pkcs1");
}
/* Helper to read in a single mpint */ function readMPInt(der, nm) {
    assert.strictEqual(der.peek(), asn1.Ber.Integer, nm + " is not an Integer");
    return utils.mpNormalize(der.readString(asn1.Ber.Integer, true));
}
function readPkcs1(alg, type, der) {
    switch(alg){
        case "RSA":
            if (type === "public") return readPkcs1RSAPublic(der);
            else if (type === "private") return readPkcs1RSAPrivate(der);
            throw new Error("Unknown key type: " + type);
        case "DSA":
            if (type === "public") return readPkcs1DSAPublic(der);
            else if (type === "private") return readPkcs1DSAPrivate(der);
            throw new Error("Unknown key type: " + type);
        case "EC":
        case "ECDSA":
            if (type === "private") return readPkcs1ECDSAPrivate(der);
            else if (type === "public") return readPkcs1ECDSAPublic(der);
            throw new Error("Unknown key type: " + type);
        case "EDDSA":
        case "EdDSA":
            if (type === "private") return readPkcs1EdDSAPrivate(der);
            throw new Error(type + " keys not supported with EdDSA");
        default:
            throw new Error("Unknown key algo: " + alg);
    }
}
function readPkcs1RSAPublic(der) {
    // modulus and exponent
    var n = readMPInt(der, "modulus");
    var e = readMPInt(der, "exponent");
    // now, make the key
    var key = {
        type: "rsa",
        parts: [
            {
                name: "e",
                data: e
            },
            {
                name: "n",
                data: n
            }
        ]
    };
    return new Key(key);
}
function readPkcs1RSAPrivate(der) {
    var version = readMPInt(der, "version");
    assert.strictEqual(version[0], 0);
    // modulus then public exponent
    var n = readMPInt(der, "modulus");
    var e = readMPInt(der, "public exponent");
    var d = readMPInt(der, "private exponent");
    var p = readMPInt(der, "prime1");
    var q = readMPInt(der, "prime2");
    var dmodp = readMPInt(der, "exponent1");
    var dmodq = readMPInt(der, "exponent2");
    var iqmp = readMPInt(der, "iqmp");
    // now, make the key
    var key = {
        type: "rsa",
        parts: [
            {
                name: "n",
                data: n
            },
            {
                name: "e",
                data: e
            },
            {
                name: "d",
                data: d
            },
            {
                name: "iqmp",
                data: iqmp
            },
            {
                name: "p",
                data: p
            },
            {
                name: "q",
                data: q
            },
            {
                name: "dmodp",
                data: dmodp
            },
            {
                name: "dmodq",
                data: dmodq
            }
        ]
    };
    return new PrivateKey(key);
}
function readPkcs1DSAPrivate(der) {
    var version = readMPInt(der, "version");
    assert.strictEqual(version.readUInt8(0), 0);
    var p = readMPInt(der, "p");
    var q = readMPInt(der, "q");
    var g = readMPInt(der, "g");
    var y = readMPInt(der, "y");
    var x = readMPInt(der, "x");
    // now, make the key
    var key = {
        type: "dsa",
        parts: [
            {
                name: "p",
                data: p
            },
            {
                name: "q",
                data: q
            },
            {
                name: "g",
                data: g
            },
            {
                name: "y",
                data: y
            },
            {
                name: "x",
                data: x
            }
        ]
    };
    return new PrivateKey(key);
}
function readPkcs1EdDSAPrivate(der) {
    var version = readMPInt(der, "version");
    assert.strictEqual(version.readUInt8(0), 1);
    // private key
    var k = der.readString(asn1.Ber.OctetString, true);
    der.readSequence(0xa0);
    var oid = der.readOID();
    assert.strictEqual(oid, "1.3.101.112", "the ed25519 curve identifier");
    der.readSequence(0xa1);
    var A = utils.readBitString(der);
    var key = {
        type: "ed25519",
        parts: [
            {
                name: "A",
                data: utils.zeroPadToLength(A, 32)
            },
            {
                name: "k",
                data: k
            }
        ]
    };
    return new PrivateKey(key);
}
function readPkcs1DSAPublic(der) {
    var y = readMPInt(der, "y");
    var p = readMPInt(der, "p");
    var q = readMPInt(der, "q");
    var g = readMPInt(der, "g");
    var key = {
        type: "dsa",
        parts: [
            {
                name: "y",
                data: y
            },
            {
                name: "p",
                data: p
            },
            {
                name: "q",
                data: q
            },
            {
                name: "g",
                data: g
            }
        ]
    };
    return new Key(key);
}
function readPkcs1ECDSAPublic(der) {
    der.readSequence();
    var oid = der.readOID();
    assert.strictEqual(oid, "1.2.840.10045.2.1", "must be ecPublicKey");
    var curveOid = der.readOID();
    var curve;
    var curves = Object.keys(algs.curves);
    for(var j = 0; j < curves.length; ++j){
        var c = curves[j];
        var cd = algs.curves[c];
        if (cd.pkcs8oid === curveOid) {
            curve = c;
            break;
        }
    }
    assert.string(curve, "a known ECDSA named curve");
    var Q = der.readString(asn1.Ber.BitString, true);
    Q = utils.ecNormalize(Q);
    var key = {
        type: "ecdsa",
        parts: [
            {
                name: "curve",
                data: Buffer.from(curve)
            },
            {
                name: "Q",
                data: Q
            }
        ]
    };
    return new Key(key);
}
function readPkcs1ECDSAPrivate(der) {
    var version = readMPInt(der, "version");
    assert.strictEqual(version.readUInt8(0), 1);
    // private key
    var d = der.readString(asn1.Ber.OctetString, true);
    der.readSequence(0xa0);
    var curve = readECDSACurve(der);
    assert.string(curve, "a known elliptic curve");
    der.readSequence(0xa1);
    var Q = der.readString(asn1.Ber.BitString, true);
    Q = utils.ecNormalize(Q);
    var key = {
        type: "ecdsa",
        parts: [
            {
                name: "curve",
                data: Buffer.from(curve)
            },
            {
                name: "Q",
                data: Q
            },
            {
                name: "d",
                data: d
            }
        ]
    };
    return new PrivateKey(key);
}
function writePkcs1(der, key) {
    der.startSequence();
    switch(key.type){
        case "rsa":
            if (PrivateKey.isPrivateKey(key)) writePkcs1RSAPrivate(der, key);
            else writePkcs1RSAPublic(der, key);
            break;
        case "dsa":
            if (PrivateKey.isPrivateKey(key)) writePkcs1DSAPrivate(der, key);
            else writePkcs1DSAPublic(der, key);
            break;
        case "ecdsa":
            if (PrivateKey.isPrivateKey(key)) writePkcs1ECDSAPrivate(der, key);
            else writePkcs1ECDSAPublic(der, key);
            break;
        case "ed25519":
            if (PrivateKey.isPrivateKey(key)) writePkcs1EdDSAPrivate(der, key);
            else writePkcs1EdDSAPublic(der, key);
            break;
        default:
            throw new Error("Unknown key algo: " + key.type);
    }
    der.endSequence();
}
function writePkcs1RSAPublic(der, key) {
    der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
}
function writePkcs1RSAPrivate(der, key) {
    var ver = Buffer.from([
        0
    ]);
    der.writeBuffer(ver, asn1.Ber.Integer);
    der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.d.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
    if (!key.part.dmodp || !key.part.dmodq) utils.addRSAMissing(key);
    der.writeBuffer(key.part.dmodp.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.dmodq.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.iqmp.data, asn1.Ber.Integer);
}
function writePkcs1DSAPrivate(der, key) {
    var ver = Buffer.from([
        0
    ]);
    der.writeBuffer(ver, asn1.Ber.Integer);
    der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.y.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.x.data, asn1.Ber.Integer);
}
function writePkcs1DSAPublic(der, key) {
    der.writeBuffer(key.part.y.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
}
function writePkcs1ECDSAPublic(der, key) {
    der.startSequence();
    der.writeOID("1.2.840.10045.2.1"); /* ecPublicKey */ 
    var curve = key.part.curve.data.toString();
    var curveOid = algs.curves[curve].pkcs8oid;
    assert.string(curveOid, "a known ECDSA named curve");
    der.writeOID(curveOid);
    der.endSequence();
    var Q = utils.ecNormalize(key.part.Q.data, true);
    der.writeBuffer(Q, asn1.Ber.BitString);
}
function writePkcs1ECDSAPrivate(der, key) {
    var ver = Buffer.from([
        1
    ]);
    der.writeBuffer(ver, asn1.Ber.Integer);
    der.writeBuffer(key.part.d.data, asn1.Ber.OctetString);
    der.startSequence(0xa0);
    var curve = key.part.curve.data.toString();
    var curveOid = algs.curves[curve].pkcs8oid;
    assert.string(curveOid, "a known ECDSA named curve");
    der.writeOID(curveOid);
    der.endSequence();
    der.startSequence(0xa1);
    var Q = utils.ecNormalize(key.part.Q.data, true);
    der.writeBuffer(Q, asn1.Ber.BitString);
    der.endSequence();
}
function writePkcs1EdDSAPrivate(der, key) {
    var ver = Buffer.from([
        1
    ]);
    der.writeBuffer(ver, asn1.Ber.Integer);
    der.writeBuffer(key.part.k.data, asn1.Ber.OctetString);
    der.startSequence(0xa0);
    der.writeOID("1.3.101.112");
    der.endSequence();
    der.startSequence(0xa1);
    utils.writeBitString(der, key.part.A.data);
    der.endSequence();
}
function writePkcs1EdDSAPublic(der, key) {
    throw new Error("Public keys are not supported for EdDSA PKCS#1");
}

},{"c29bd0554c6f2ee7":"eQsu4","b066099739a7e0da":"jC0hS","d1c435af0a5d3c4f":"b2XZ0","26280ac05e78b2b4":"23cSW","bee21eedf6306318":"icPN2","8e073b393d191269":"fAyE1","3971444feffafa9":"4674F","ffd5014eeb4d48c":"fUNos","8fae450826f243ee":"iNFUG"}],"iNFUG":[function(require,module,exports) {
// Copyright 2018 Joyent, Inc.
module.exports = {
    read: read,
    readPkcs8: readPkcs8,
    write: write,
    writePkcs8: writePkcs8,
    pkcs8ToBuffer: pkcs8ToBuffer,
    readECDSACurve: readECDSACurve,
    writeECDSACurve: writeECDSACurve
};
var assert = require("4330c5baee261f2c");
var asn1 = require("ab68c6a50fc8a8ef");
var Buffer = require("3b2931701fab437a").Buffer;
var algs = require("c13ae78a0836e509");
var utils = require("50228d0e9f5bea9");
var Key = require("af90caf3cf6ea096");
var PrivateKey = require("cffa8b788fbcf041");
var pem = require("49606a645f8637a8");
function read(buf, options) {
    return pem.read(buf, options, "pkcs8");
}
function write(key, options) {
    return pem.write(key, options, "pkcs8");
}
/* Helper to read in a single mpint */ function readMPInt(der, nm) {
    assert.strictEqual(der.peek(), asn1.Ber.Integer, nm + " is not an Integer");
    return utils.mpNormalize(der.readString(asn1.Ber.Integer, true));
}
function readPkcs8(alg, type, der) {
    /* Private keys in pkcs#8 format have a weird extra int */ if (der.peek() === asn1.Ber.Integer) {
        assert.strictEqual(type, "private", "unexpected Integer at start of public key");
        der.readString(asn1.Ber.Integer, true);
    }
    der.readSequence();
    var next = der.offset + der.length;
    var oid = der.readOID();
    switch(oid){
        case "1.2.840.113549.1.1.1":
            der._offset = next;
            if (type === "public") return readPkcs8RSAPublic(der);
            else return readPkcs8RSAPrivate(der);
        case "1.2.840.10040.4.1":
            if (type === "public") return readPkcs8DSAPublic(der);
            else return readPkcs8DSAPrivate(der);
        case "1.2.840.10045.2.1":
            if (type === "public") return readPkcs8ECDSAPublic(der);
            else return readPkcs8ECDSAPrivate(der);
        case "1.3.101.112":
            if (type === "public") return readPkcs8EdDSAPublic(der);
            else return readPkcs8EdDSAPrivate(der);
        case "1.3.101.110":
            if (type === "public") return readPkcs8X25519Public(der);
            else return readPkcs8X25519Private(der);
        default:
            throw new Error("Unknown key type OID " + oid);
    }
}
function readPkcs8RSAPublic(der) {
    // bit string sequence
    der.readSequence(asn1.Ber.BitString);
    der.readByte();
    der.readSequence();
    // modulus
    var n = readMPInt(der, "modulus");
    var e = readMPInt(der, "exponent");
    // now, make the key
    var key = {
        type: "rsa",
        source: der.originalInput,
        parts: [
            {
                name: "e",
                data: e
            },
            {
                name: "n",
                data: n
            }
        ]
    };
    return new Key(key);
}
function readPkcs8RSAPrivate(der) {
    der.readSequence(asn1.Ber.OctetString);
    der.readSequence();
    var ver = readMPInt(der, "version");
    assert.equal(ver[0], 0x0, "unknown RSA private key version");
    // modulus then public exponent
    var n = readMPInt(der, "modulus");
    var e = readMPInt(der, "public exponent");
    var d = readMPInt(der, "private exponent");
    var p = readMPInt(der, "prime1");
    var q = readMPInt(der, "prime2");
    var dmodp = readMPInt(der, "exponent1");
    var dmodq = readMPInt(der, "exponent2");
    var iqmp = readMPInt(der, "iqmp");
    // now, make the key
    var key = {
        type: "rsa",
        parts: [
            {
                name: "n",
                data: n
            },
            {
                name: "e",
                data: e
            },
            {
                name: "d",
                data: d
            },
            {
                name: "iqmp",
                data: iqmp
            },
            {
                name: "p",
                data: p
            },
            {
                name: "q",
                data: q
            },
            {
                name: "dmodp",
                data: dmodp
            },
            {
                name: "dmodq",
                data: dmodq
            }
        ]
    };
    return new PrivateKey(key);
}
function readPkcs8DSAPublic(der) {
    der.readSequence();
    var p = readMPInt(der, "p");
    var q = readMPInt(der, "q");
    var g = readMPInt(der, "g");
    // bit string sequence
    der.readSequence(asn1.Ber.BitString);
    der.readByte();
    var y = readMPInt(der, "y");
    // now, make the key
    var key = {
        type: "dsa",
        parts: [
            {
                name: "p",
                data: p
            },
            {
                name: "q",
                data: q
            },
            {
                name: "g",
                data: g
            },
            {
                name: "y",
                data: y
            }
        ]
    };
    return new Key(key);
}
function readPkcs8DSAPrivate(der) {
    der.readSequence();
    var p = readMPInt(der, "p");
    var q = readMPInt(der, "q");
    var g = readMPInt(der, "g");
    der.readSequence(asn1.Ber.OctetString);
    var x = readMPInt(der, "x");
    /* The pkcs#8 format does not include the public key */ var y = utils.calculateDSAPublic(g, p, x);
    var key = {
        type: "dsa",
        parts: [
            {
                name: "p",
                data: p
            },
            {
                name: "q",
                data: q
            },
            {
                name: "g",
                data: g
            },
            {
                name: "y",
                data: y
            },
            {
                name: "x",
                data: x
            }
        ]
    };
    return new PrivateKey(key);
}
function readECDSACurve(der) {
    var curveName, curveNames;
    var j, c, cd;
    if (der.peek() === asn1.Ber.OID) {
        var oid = der.readOID();
        curveNames = Object.keys(algs.curves);
        for(j = 0; j < curveNames.length; ++j){
            c = curveNames[j];
            cd = algs.curves[c];
            if (cd.pkcs8oid === oid) {
                curveName = c;
                break;
            }
        }
    } else {
        // ECParameters sequence
        der.readSequence();
        var version = der.readString(asn1.Ber.Integer, true);
        assert.strictEqual(version[0], 1, "ECDSA key not version 1");
        var curve = {};
        // FieldID sequence
        der.readSequence();
        var fieldTypeOid = der.readOID();
        assert.strictEqual(fieldTypeOid, "1.2.840.10045.1.1", "ECDSA key is not from a prime-field");
        var p = curve.p = utils.mpNormalize(der.readString(asn1.Ber.Integer, true));
        /*
		 * p always starts with a 1 bit, so count the zeros to get its
		 * real size.
		 */ curve.size = p.length * 8 - utils.countZeros(p);
        // Curve sequence
        der.readSequence();
        curve.a = utils.mpNormalize(der.readString(asn1.Ber.OctetString, true));
        curve.b = utils.mpNormalize(der.readString(asn1.Ber.OctetString, true));
        if (der.peek() === asn1.Ber.BitString) curve.s = der.readString(asn1.Ber.BitString, true);
        // Combined Gx and Gy
        curve.G = der.readString(asn1.Ber.OctetString, true);
        assert.strictEqual(curve.G[0], 0x4, "uncompressed G is required");
        curve.n = utils.mpNormalize(der.readString(asn1.Ber.Integer, true));
        curve.h = utils.mpNormalize(der.readString(asn1.Ber.Integer, true));
        assert.strictEqual(curve.h[0], 0x1, "a cofactor=1 curve is required");
        curveNames = Object.keys(algs.curves);
        var ks = Object.keys(curve);
        for(j = 0; j < curveNames.length; ++j){
            c = curveNames[j];
            cd = algs.curves[c];
            var equal = true;
            for(var i = 0; i < ks.length; ++i){
                var k = ks[i];
                if (cd[k] === undefined) continue;
                if (typeof cd[k] === "object" && cd[k].equals !== undefined) {
                    if (!cd[k].equals(curve[k])) {
                        equal = false;
                        break;
                    }
                } else if (Buffer.isBuffer(cd[k])) {
                    if (cd[k].toString("binary") !== curve[k].toString("binary")) {
                        equal = false;
                        break;
                    }
                } else if (cd[k] !== curve[k]) {
                    equal = false;
                    break;
                }
            }
            if (equal) {
                curveName = c;
                break;
            }
        }
    }
    return curveName;
}
function readPkcs8ECDSAPrivate(der) {
    var curveName = readECDSACurve(der);
    assert.string(curveName, "a known elliptic curve");
    der.readSequence(asn1.Ber.OctetString);
    der.readSequence();
    var version = readMPInt(der, "version");
    assert.equal(version[0], 1, "unknown version of ECDSA key");
    var d = der.readString(asn1.Ber.OctetString, true);
    var Q;
    if (der.peek() == 0xa0) {
        der.readSequence(0xa0);
        der._offset += der.length;
    }
    if (der.peek() == 0xa1) {
        der.readSequence(0xa1);
        Q = der.readString(asn1.Ber.BitString, true);
        Q = utils.ecNormalize(Q);
    }
    if (Q === undefined) {
        var pub = utils.publicFromPrivateECDSA(curveName, d);
        Q = pub.part.Q.data;
    }
    var key = {
        type: "ecdsa",
        parts: [
            {
                name: "curve",
                data: Buffer.from(curveName)
            },
            {
                name: "Q",
                data: Q
            },
            {
                name: "d",
                data: d
            }
        ]
    };
    return new PrivateKey(key);
}
function readPkcs8ECDSAPublic(der) {
    var curveName = readECDSACurve(der);
    assert.string(curveName, "a known elliptic curve");
    var Q = der.readString(asn1.Ber.BitString, true);
    Q = utils.ecNormalize(Q);
    var key = {
        type: "ecdsa",
        parts: [
            {
                name: "curve",
                data: Buffer.from(curveName)
            },
            {
                name: "Q",
                data: Q
            }
        ]
    };
    return new Key(key);
}
function readPkcs8EdDSAPublic(der) {
    if (der.peek() === 0x00) der.readByte();
    var A = utils.readBitString(der);
    var key = {
        type: "ed25519",
        parts: [
            {
                name: "A",
                data: utils.zeroPadToLength(A, 32)
            }
        ]
    };
    return new Key(key);
}
function readPkcs8X25519Public(der) {
    var A = utils.readBitString(der);
    var key = {
        type: "curve25519",
        parts: [
            {
                name: "A",
                data: utils.zeroPadToLength(A, 32)
            }
        ]
    };
    return new Key(key);
}
function readPkcs8EdDSAPrivate(der) {
    if (der.peek() === 0x00) der.readByte();
    der.readSequence(asn1.Ber.OctetString);
    var k = der.readString(asn1.Ber.OctetString, true);
    k = utils.zeroPadToLength(k, 32);
    var A, tag;
    while((tag = der.peek()) !== null)if (tag === (asn1.Ber.Context | 1)) A = utils.readBitString(der, tag);
    else {
        der.readSequence(tag);
        der._offset += der.length;
    }
    if (A === undefined) A = utils.calculateED25519Public(k);
    var key = {
        type: "ed25519",
        parts: [
            {
                name: "A",
                data: utils.zeroPadToLength(A, 32)
            },
            {
                name: "k",
                data: utils.zeroPadToLength(k, 32)
            }
        ]
    };
    return new PrivateKey(key);
}
function readPkcs8X25519Private(der) {
    if (der.peek() === 0x00) der.readByte();
    der.readSequence(asn1.Ber.OctetString);
    var k = der.readString(asn1.Ber.OctetString, true);
    k = utils.zeroPadToLength(k, 32);
    var A = utils.calculateX25519Public(k);
    var key = {
        type: "curve25519",
        parts: [
            {
                name: "A",
                data: utils.zeroPadToLength(A, 32)
            },
            {
                name: "k",
                data: utils.zeroPadToLength(k, 32)
            }
        ]
    };
    return new PrivateKey(key);
}
function pkcs8ToBuffer(key) {
    var der = new asn1.BerWriter();
    writePkcs8(der, key);
    return der.buffer;
}
function writePkcs8(der, key) {
    der.startSequence();
    if (PrivateKey.isPrivateKey(key)) {
        var version = 0;
        if (key.type === "ed25519") version = 1;
        var vbuf = Buffer.from([
            version
        ]);
        der.writeBuffer(vbuf, asn1.Ber.Integer);
    }
    der.startSequence();
    switch(key.type){
        case "rsa":
            der.writeOID("1.2.840.113549.1.1.1");
            if (PrivateKey.isPrivateKey(key)) writePkcs8RSAPrivate(key, der);
            else writePkcs8RSAPublic(key, der);
            break;
        case "dsa":
            der.writeOID("1.2.840.10040.4.1");
            if (PrivateKey.isPrivateKey(key)) writePkcs8DSAPrivate(key, der);
            else writePkcs8DSAPublic(key, der);
            break;
        case "ecdsa":
            der.writeOID("1.2.840.10045.2.1");
            if (PrivateKey.isPrivateKey(key)) writePkcs8ECDSAPrivate(key, der);
            else writePkcs8ECDSAPublic(key, der);
            break;
        case "ed25519":
            der.writeOID("1.3.101.112");
            if (PrivateKey.isPrivateKey(key)) writePkcs8EdDSAPrivate(key, der);
            else writePkcs8EdDSAPublic(key, der);
            break;
        default:
            throw new Error("Unsupported key type: " + key.type);
    }
    der.endSequence();
}
function writePkcs8RSAPrivate(key, der) {
    der.writeNull();
    der.endSequence();
    der.startSequence(asn1.Ber.OctetString);
    der.startSequence();
    var version = Buffer.from([
        0
    ]);
    der.writeBuffer(version, asn1.Ber.Integer);
    der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.d.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
    if (!key.part.dmodp || !key.part.dmodq) utils.addRSAMissing(key);
    der.writeBuffer(key.part.dmodp.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.dmodq.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.iqmp.data, asn1.Ber.Integer);
    der.endSequence();
    der.endSequence();
}
function writePkcs8RSAPublic(key, der) {
    der.writeNull();
    der.endSequence();
    der.startSequence(asn1.Ber.BitString);
    der.writeByte(0x00);
    der.startSequence();
    der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
    der.endSequence();
    der.endSequence();
}
function writePkcs8DSAPrivate(key, der) {
    der.startSequence();
    der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
    der.endSequence();
    der.endSequence();
    der.startSequence(asn1.Ber.OctetString);
    der.writeBuffer(key.part.x.data, asn1.Ber.Integer);
    der.endSequence();
}
function writePkcs8DSAPublic(key, der) {
    der.startSequence();
    der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
    der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
    der.endSequence();
    der.endSequence();
    der.startSequence(asn1.Ber.BitString);
    der.writeByte(0x00);
    der.writeBuffer(key.part.y.data, asn1.Ber.Integer);
    der.endSequence();
}
function writeECDSACurve(key, der) {
    var curve = algs.curves[key.curve];
    if (curve.pkcs8oid) /* This one has a name in pkcs#8, so just write the oid */ der.writeOID(curve.pkcs8oid);
    else {
        // ECParameters sequence
        der.startSequence();
        var version = Buffer.from([
            1
        ]);
        der.writeBuffer(version, asn1.Ber.Integer);
        // FieldID sequence
        der.startSequence();
        der.writeOID("1.2.840.10045.1.1"); // prime-field
        der.writeBuffer(curve.p, asn1.Ber.Integer);
        der.endSequence();
        // Curve sequence
        der.startSequence();
        var a = curve.p;
        if (a[0] === 0x0) a = a.slice(1);
        der.writeBuffer(a, asn1.Ber.OctetString);
        der.writeBuffer(curve.b, asn1.Ber.OctetString);
        der.writeBuffer(curve.s, asn1.Ber.BitString);
        der.endSequence();
        der.writeBuffer(curve.G, asn1.Ber.OctetString);
        der.writeBuffer(curve.n, asn1.Ber.Integer);
        var h = curve.h;
        if (!h) h = Buffer.from([
            1
        ]);
        der.writeBuffer(h, asn1.Ber.Integer);
        // ECParameters
        der.endSequence();
    }
}
function writePkcs8ECDSAPublic(key, der) {
    writeECDSACurve(key, der);
    der.endSequence();
    var Q = utils.ecNormalize(key.part.Q.data, true);
    der.writeBuffer(Q, asn1.Ber.BitString);
}
function writePkcs8ECDSAPrivate(key, der) {
    writeECDSACurve(key, der);
    der.endSequence();
    der.startSequence(asn1.Ber.OctetString);
    der.startSequence();
    var version = Buffer.from([
        1
    ]);
    der.writeBuffer(version, asn1.Ber.Integer);
    der.writeBuffer(key.part.d.data, asn1.Ber.OctetString);
    der.startSequence(0xa1);
    var Q = utils.ecNormalize(key.part.Q.data, true);
    der.writeBuffer(Q, asn1.Ber.BitString);
    der.endSequence();
    der.endSequence();
    der.endSequence();
}
function writePkcs8EdDSAPublic(key, der) {
    der.endSequence();
    utils.writeBitString(der, key.part.A.data);
}
function writePkcs8EdDSAPrivate(key, der) {
    der.endSequence();
    der.startSequence(asn1.Ber.OctetString);
    var k = utils.mpNormalize(key.part.k.data);
    /* RFCs call for storing exactly 32 bytes, so strip any leading zeros */ while(k.length > 32 && k[0] === 0x00)k = k.slice(1);
    der.writeBuffer(k, asn1.Ber.OctetString);
    der.endSequence();
    utils.writeBitString(der, key.part.A.data, asn1.Ber.Context | 1);
}

},{"4330c5baee261f2c":"eQsu4","ab68c6a50fc8a8ef":"jC0hS","3b2931701fab437a":"b2XZ0","c13ae78a0836e509":"23cSW","50228d0e9f5bea9":"icPN2","af90caf3cf6ea096":"fAyE1","cffa8b788fbcf041":"4674F","49606a645f8637a8":"fUNos"}],"2pfcf":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = {
    read: read,
    readSSHPrivate: readSSHPrivate,
    write: write
};
var assert = require("3dda3c822a4c11f");
var asn1 = require("e9df28c026211c9f");
var Buffer = require("20675af781a93ae0").Buffer;
var algs = require("bb5412a2dd8679a2");
var utils = require("357d0d7989e8100a");
var crypto = require("3664847bd46bb67b");
var Key = require("f15e48eaf61a0ab9");
var PrivateKey = require("cea6db32f675bea2");
var pem = require("f6ecd559dc24f91b");
var rfc4253 = require("be9b911aaaa4fad0");
var SSHBuffer = require("893524875c7de6b");
var errors = require("d040ebb78cc3474");
var bcrypt;
function read(buf, options) {
    return pem.read(buf, options);
}
var MAGIC = "openssh-key-v1";
function readSSHPrivate(type, buf, options) {
    buf = new SSHBuffer({
        buffer: buf
    });
    var magic = buf.readCString();
    assert.strictEqual(magic, MAGIC, "bad magic string");
    var cipher = buf.readString();
    var kdf = buf.readString();
    var kdfOpts = buf.readBuffer();
    var nkeys = buf.readInt();
    if (nkeys !== 1) throw new Error("OpenSSH-format key file contains multiple keys: this is unsupported.");
    var pubKey = buf.readBuffer();
    if (type === "public") {
        assert.ok(buf.atEnd(), "excess bytes left after key");
        return rfc4253.read(pubKey);
    }
    var privKeyBlob = buf.readBuffer();
    assert.ok(buf.atEnd(), "excess bytes left after key");
    var kdfOptsBuf = new SSHBuffer({
        buffer: kdfOpts
    });
    switch(kdf){
        case "none":
            if (cipher !== "none") throw new Error('OpenSSH-format key uses KDF "none" but specifies a cipher other than "none"');
            break;
        case "bcrypt":
            var salt = kdfOptsBuf.readBuffer();
            var rounds = kdfOptsBuf.readInt();
            var cinf = utils.opensshCipherInfo(cipher);
            if (bcrypt === undefined) bcrypt = require("3905bff84161b702");
            if (typeof options.passphrase === "string") options.passphrase = Buffer.from(options.passphrase, "utf-8");
            if (!Buffer.isBuffer(options.passphrase)) throw new errors.KeyEncryptedError(options.filename, "OpenSSH");
            var pass = new Uint8Array(options.passphrase);
            var salti = new Uint8Array(salt);
            /* Use the pbkdf to derive both the key and the IV. */ var out = new Uint8Array(cinf.keySize + cinf.blockSize);
            var res = bcrypt.pbkdf(pass, pass.length, salti, salti.length, out, out.length, rounds);
            if (res !== 0) throw new Error("bcrypt_pbkdf function returned failure, parameters invalid");
            out = Buffer.from(out);
            var ckey = out.slice(0, cinf.keySize);
            var iv = out.slice(cinf.keySize, cinf.keySize + cinf.blockSize);
            var cipherStream = crypto.createDecipheriv(cinf.opensslName, ckey, iv);
            cipherStream.setAutoPadding(false);
            var chunk, chunks = [];
            cipherStream.once("error", function(e) {
                if (e.toString().indexOf("bad decrypt") !== -1) throw new Error("Incorrect passphrase supplied, could not decrypt key");
                throw e;
            });
            cipherStream.write(privKeyBlob);
            cipherStream.end();
            while((chunk = cipherStream.read()) !== null)chunks.push(chunk);
            privKeyBlob = Buffer.concat(chunks);
            break;
        default:
            throw new Error('OpenSSH-format key uses unknown KDF "' + kdf + '"');
    }
    buf = new SSHBuffer({
        buffer: privKeyBlob
    });
    var checkInt1 = buf.readInt();
    var checkInt2 = buf.readInt();
    if (checkInt1 !== checkInt2) throw new Error("Incorrect passphrase supplied, could not decrypt key");
    var ret = {};
    var key = rfc4253.readInternal(ret, "private", buf.remainder());
    buf.skip(ret.consumed);
    var comment = buf.readString();
    key.comment = comment;
    return key;
}
function write(key, options) {
    var pubKey;
    if (PrivateKey.isPrivateKey(key)) pubKey = key.toPublic();
    else pubKey = key;
    var cipher = "none";
    var kdf = "none";
    var kdfopts = Buffer.alloc(0);
    var cinf = {
        blockSize: 8
    };
    var passphrase;
    if (options !== undefined) {
        passphrase = options.passphrase;
        if (typeof passphrase === "string") passphrase = Buffer.from(passphrase, "utf-8");
        if (passphrase !== undefined) {
            assert.buffer(passphrase, "options.passphrase");
            assert.optionalString(options.cipher, "options.cipher");
            cipher = options.cipher;
            if (cipher === undefined) cipher = "aes128-ctr";
            cinf = utils.opensshCipherInfo(cipher);
            kdf = "bcrypt";
        }
    }
    var privBuf;
    if (PrivateKey.isPrivateKey(key)) {
        privBuf = new SSHBuffer({});
        var checkInt = crypto.randomBytes(4).readUInt32BE(0);
        privBuf.writeInt(checkInt);
        privBuf.writeInt(checkInt);
        privBuf.write(key.toBuffer("rfc4253"));
        privBuf.writeString(key.comment || "");
        var n = 1;
        while(privBuf._offset % cinf.blockSize !== 0)privBuf.writeChar(n++);
        privBuf = privBuf.toBuffer();
    }
    switch(kdf){
        case "none":
            break;
        case "bcrypt":
            var salt = crypto.randomBytes(16);
            var rounds = 16;
            var kdfssh = new SSHBuffer({});
            kdfssh.writeBuffer(salt);
            kdfssh.writeInt(rounds);
            kdfopts = kdfssh.toBuffer();
            if (bcrypt === undefined) bcrypt = require("3905bff84161b702");
            var pass = new Uint8Array(passphrase);
            var salti = new Uint8Array(salt);
            /* Use the pbkdf to derive both the key and the IV. */ var out = new Uint8Array(cinf.keySize + cinf.blockSize);
            var res = bcrypt.pbkdf(pass, pass.length, salti, salti.length, out, out.length, rounds);
            if (res !== 0) throw new Error("bcrypt_pbkdf function returned failure, parameters invalid");
            out = Buffer.from(out);
            var ckey = out.slice(0, cinf.keySize);
            var iv = out.slice(cinf.keySize, cinf.keySize + cinf.blockSize);
            var cipherStream = crypto.createCipheriv(cinf.opensslName, ckey, iv);
            cipherStream.setAutoPadding(false);
            var chunk, chunks = [];
            cipherStream.once("error", function(e) {
                throw e;
            });
            cipherStream.write(privBuf);
            cipherStream.end();
            while((chunk = cipherStream.read()) !== null)chunks.push(chunk);
            privBuf = Buffer.concat(chunks);
            break;
        default:
            throw new Error("Unsupported kdf " + kdf);
    }
    var buf = new SSHBuffer({});
    buf.writeCString(MAGIC);
    buf.writeString(cipher); /* cipher */ 
    buf.writeString(kdf); /* kdf */ 
    buf.writeBuffer(kdfopts); /* kdfoptions */ 
    buf.writeInt(1); /* nkeys */ 
    buf.writeBuffer(pubKey.toBuffer("rfc4253"));
    if (privBuf) buf.writeBuffer(privBuf);
    buf = buf.toBuffer();
    var header;
    if (PrivateKey.isPrivateKey(key)) header = "OPENSSH PRIVATE KEY";
    else header = "OPENSSH PUBLIC KEY";
    var tmp = buf.toString("base64");
    var len = tmp.length + tmp.length / 70 + 18 + 16 + header.length * 2 + 10;
    buf = Buffer.alloc(len);
    var o = 0;
    o += buf.write("-----BEGIN " + header + "-----\n", o);
    for(var i = 0; i < tmp.length;){
        var limit = i + 70;
        if (limit > tmp.length) limit = tmp.length;
        o += buf.write(tmp.slice(i, limit), o);
        buf[o++] = 10;
        i = limit;
    }
    o += buf.write("-----END " + header + "-----\n", o);
    return buf.slice(0, o);
}

},{"3dda3c822a4c11f":"eQsu4","e9df28c026211c9f":"jC0hS","20675af781a93ae0":"b2XZ0","bb5412a2dd8679a2":"23cSW","357d0d7989e8100a":"icPN2","3664847bd46bb67b":"8Nkdo","f15e48eaf61a0ab9":"fAyE1","cea6db32f675bea2":"4674F","f6ecd559dc24f91b":"fUNos","be9b911aaaa4fad0":"btAO6","893524875c7de6b":"OXMVy","d040ebb78cc3474":"6DKEY","3905bff84161b702":"8mfwH"}],"btAO6":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = {
    read: read.bind(undefined, false, undefined),
    readType: read.bind(undefined, false),
    write: write,
    /* semi-private api, used by sshpk-agent */ readPartial: read.bind(undefined, true),
    /* shared with ssh format */ readInternal: read,
    keyTypeToAlg: keyTypeToAlg,
    algToKeyType: algToKeyType
};
var assert = require("8144be75b1305f10");
var Buffer = require("b74e5673c94105e0").Buffer;
var algs = require("f7599385d8ff76c8");
var utils = require("5e6ff7a56720c5a8");
var Key = require("b4bf4823f85cdadd");
var PrivateKey = require("f6025beb5822af7b");
var SSHBuffer = require("f82e52f26de992cb");
function algToKeyType(alg) {
    assert.string(alg);
    if (alg === "ssh-dss") return "dsa";
    else if (alg === "ssh-rsa") return "rsa";
    else if (alg === "ssh-ed25519") return "ed25519";
    else if (alg === "ssh-curve25519") return "curve25519";
    else if (alg.match(/^ecdsa-sha2-/)) return "ecdsa";
    else throw new Error("Unknown algorithm " + alg);
}
function keyTypeToAlg(key) {
    assert.object(key);
    if (key.type === "dsa") return "ssh-dss";
    else if (key.type === "rsa") return "ssh-rsa";
    else if (key.type === "ed25519") return "ssh-ed25519";
    else if (key.type === "curve25519") return "ssh-curve25519";
    else if (key.type === "ecdsa") return "ecdsa-sha2-" + key.part.curve.data.toString();
    else throw new Error("Unknown key type " + key.type);
}
function read(partial, type, buf, options) {
    if (typeof buf === "string") buf = Buffer.from(buf);
    assert.buffer(buf, "buf");
    var key = {};
    var parts = key.parts = [];
    var sshbuf = new SSHBuffer({
        buffer: buf
    });
    var alg = sshbuf.readString();
    assert.ok(!sshbuf.atEnd(), "key must have at least one part");
    key.type = algToKeyType(alg);
    var partCount = algs.info[key.type].parts.length;
    if (type && type === "private") partCount = algs.privInfo[key.type].parts.length;
    while(!sshbuf.atEnd() && parts.length < partCount)parts.push(sshbuf.readPart());
    while(!partial && !sshbuf.atEnd())parts.push(sshbuf.readPart());
    assert.ok(parts.length >= 1, "key must have at least one part");
    assert.ok(partial || sshbuf.atEnd(), "leftover bytes at end of key");
    var Constructor = Key;
    var algInfo = algs.info[key.type];
    if (type === "private" || algInfo.parts.length !== parts.length) {
        algInfo = algs.privInfo[key.type];
        Constructor = PrivateKey;
    }
    assert.strictEqual(algInfo.parts.length, parts.length);
    if (key.type === "ecdsa") {
        var res = /^ecdsa-sha2-(.+)$/.exec(alg);
        assert.ok(res !== null);
        assert.strictEqual(res[1], parts[0].data.toString());
    }
    var normalized = true;
    for(var i = 0; i < algInfo.parts.length; ++i){
        var p = parts[i];
        p.name = algInfo.parts[i];
        /*
		 * OpenSSH stores ed25519 "private" keys as seed + public key
		 * concat'd together (k followed by A). We want to keep them
		 * separate for other formats that don't do this.
		 */ if (key.type === "ed25519" && p.name === "k") p.data = p.data.slice(0, 32);
        if (p.name !== "curve" && algInfo.normalize !== false) {
            var nd;
            if (key.type === "ed25519") nd = utils.zeroPadToLength(p.data, 32);
            else nd = utils.mpNormalize(p.data);
            if (nd.toString("binary") !== p.data.toString("binary")) {
                p.data = nd;
                normalized = false;
            }
        }
    }
    if (normalized) key._rfc4253Cache = sshbuf.toBuffer();
    if (partial && typeof partial === "object") {
        partial.remainder = sshbuf.remainder();
        partial.consumed = sshbuf._offset;
    }
    return new Constructor(key);
}
function write(key, options) {
    assert.object(key);
    var alg = keyTypeToAlg(key);
    var i;
    var algInfo = algs.info[key.type];
    if (PrivateKey.isPrivateKey(key)) algInfo = algs.privInfo[key.type];
    var parts = algInfo.parts;
    var buf = new SSHBuffer({});
    buf.writeString(alg);
    for(i = 0; i < parts.length; ++i){
        var data = key.part[parts[i]].data;
        if (algInfo.normalize !== false) {
            if (key.type === "ed25519") data = utils.zeroPadToLength(data, 32);
            else data = utils.mpNormalize(data);
        }
        if (key.type === "ed25519" && parts[i] === "k") data = Buffer.concat([
            data,
            key.part.A.data
        ]);
        buf.writeBuffer(data);
    }
    return buf.toBuffer();
}

},{"8144be75b1305f10":"eQsu4","b74e5673c94105e0":"b2XZ0","f7599385d8ff76c8":"23cSW","5e6ff7a56720c5a8":"icPN2","b4bf4823f85cdadd":"fAyE1","f6025beb5822af7b":"4674F","f82e52f26de992cb":"OXMVy"}],"8mfwH":[function(require,module,exports) {
"use strict";
var crypto_hash_sha512 = require("3e451905d10c9e58").lowlevel.crypto_hash;
/*
 * This file is a 1:1 port from the OpenBSD blowfish.c and bcrypt_pbkdf.c. As a
 * result, it retains the original copyright and license. The two files are
 * under slightly different (but compatible) licenses, and are here combined in
 * one file.
 *
 * Credit for the actual porting work goes to:
 *  Devi Mandiri <me@devi.web.id>
 */ /*
 * The Blowfish portions are under the following license:
 *
 * Blowfish block cipher for OpenBSD
 * Copyright 1997 Niels Provos <provos@physnet.uni-hamburg.de>
 * All rights reserved.
 *
 * Implementation advice by David Mazieres <dm@lcs.mit.edu>.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 3. The name of the author may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR ``AS IS'' AND ANY EXPRESS OR
 * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
 * OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 * NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * The bcrypt_pbkdf portions are under the following license:
 *
 * Copyright (c) 2013 Ted Unangst <tedu@openbsd.org>
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */ /*
 * Performance improvements (Javascript-specific):
 *
 * Copyright 2016, Joyent Inc
 * Author: Alex Wilson <alex.wilson@joyent.com>
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */ // Ported from OpenBSD bcrypt_pbkdf.c v1.9
var BLF_J = 0;
var Blowfish = function() {
    this.S = [
        new Uint32Array([
            0xd1310ba6,
            0x98dfb5ac,
            0x2ffd72db,
            0xd01adfb7,
            0xb8e1afed,
            0x6a267e96,
            0xba7c9045,
            0xf12c7f99,
            0x24a19947,
            0xb3916cf7,
            0x0801f2e2,
            0x858efc16,
            0x636920d8,
            0x71574e69,
            0xa458fea3,
            0xf4933d7e,
            0x0d95748f,
            0x728eb658,
            0x718bcd58,
            0x82154aee,
            0x7b54a41d,
            0xc25a59b5,
            0x9c30d539,
            0x2af26013,
            0xc5d1b023,
            0x286085f0,
            0xca417918,
            0xb8db38ef,
            0x8e79dcb0,
            0x603a180e,
            0x6c9e0e8b,
            0xb01e8a3e,
            0xd71577c1,
            0xbd314b27,
            0x78af2fda,
            0x55605c60,
            0xe65525f3,
            0xaa55ab94,
            0x57489862,
            0x63e81440,
            0x55ca396a,
            0x2aab10b6,
            0xb4cc5c34,
            0x1141e8ce,
            0xa15486af,
            0x7c72e993,
            0xb3ee1411,
            0x636fbc2a,
            0x2ba9c55d,
            0x741831f6,
            0xce5c3e16,
            0x9b87931e,
            0xafd6ba33,
            0x6c24cf5c,
            0x7a325381,
            0x28958677,
            0x3b8f4898,
            0x6b4bb9af,
            0xc4bfe81b,
            0x66282193,
            0x61d809cc,
            0xfb21a991,
            0x487cac60,
            0x5dec8032,
            0xef845d5d,
            0xe98575b1,
            0xdc262302,
            0xeb651b88,
            0x23893e81,
            0xd396acc5,
            0x0f6d6ff3,
            0x83f44239,
            0x2e0b4482,
            0xa4842004,
            0x69c8f04a,
            0x9e1f9b5e,
            0x21c66842,
            0xf6e96c9a,
            0x670c9c61,
            0xabd388f0,
            0x6a51a0d2,
            0xd8542f68,
            0x960fa728,
            0xab5133a3,
            0x6eef0b6c,
            0x137a3be4,
            0xba3bf050,
            0x7efb2a98,
            0xa1f1651d,
            0x39af0176,
            0x66ca593e,
            0x82430e88,
            0x8cee8619,
            0x456f9fb4,
            0x7d84a5c3,
            0x3b8b5ebe,
            0xe06f75d8,
            0x85c12073,
            0x401a449f,
            0x56c16aa6,
            0x4ed3aa62,
            0x363f7706,
            0x1bfedf72,
            0x429b023d,
            0x37d0d724,
            0xd00a1248,
            0xdb0fead3,
            0x49f1c09b,
            0x075372c9,
            0x80991b7b,
            0x25d479d8,
            0xf6e8def7,
            0xe3fe501a,
            0xb6794c3b,
            0x976ce0bd,
            0x04c006ba,
            0xc1a94fb6,
            0x409f60c4,
            0x5e5c9ec2,
            0x196a2463,
            0x68fb6faf,
            0x3e6c53b5,
            0x1339b2eb,
            0x3b52ec6f,
            0x6dfc511f,
            0x9b30952c,
            0xcc814544,
            0xaf5ebd09,
            0xbee3d004,
            0xde334afd,
            0x660f2807,
            0x192e4bb3,
            0xc0cba857,
            0x45c8740f,
            0xd20b5f39,
            0xb9d3fbdb,
            0x5579c0bd,
            0x1a60320a,
            0xd6a100c6,
            0x402c7279,
            0x679f25fe,
            0xfb1fa3cc,
            0x8ea5e9f8,
            0xdb3222f8,
            0x3c7516df,
            0xfd616b15,
            0x2f501ec8,
            0xad0552ab,
            0x323db5fa,
            0xfd238760,
            0x53317b48,
            0x3e00df82,
            0x9e5c57bb,
            0xca6f8ca0,
            0x1a87562e,
            0xdf1769db,
            0xd542a8f6,
            0x287effc3,
            0xac6732c6,
            0x8c4f5573,
            0x695b27b0,
            0xbbca58c8,
            0xe1ffa35d,
            0xb8f011a0,
            0x10fa3d98,
            0xfd2183b8,
            0x4afcb56c,
            0x2dd1d35b,
            0x9a53e479,
            0xb6f84565,
            0xd28e49bc,
            0x4bfb9790,
            0xe1ddf2da,
            0xa4cb7e33,
            0x62fb1341,
            0xcee4c6e8,
            0xef20cada,
            0x36774c01,
            0xd07e9efe,
            0x2bf11fb4,
            0x95dbda4d,
            0xae909198,
            0xeaad8e71,
            0x6b93d5a0,
            0xd08ed1d0,
            0xafc725e0,
            0x8e3c5b2f,
            0x8e7594b7,
            0x8ff6e2fb,
            0xf2122b64,
            0x8888b812,
            0x900df01c,
            0x4fad5ea0,
            0x688fc31c,
            0xd1cff191,
            0xb3a8c1ad,
            0x2f2f2218,
            0xbe0e1777,
            0xea752dfe,
            0x8b021fa1,
            0xe5a0cc0f,
            0xb56f74e8,
            0x18acf3d6,
            0xce89e299,
            0xb4a84fe0,
            0xfd13e0b7,
            0x7cc43b81,
            0xd2ada8d9,
            0x165fa266,
            0x80957705,
            0x93cc7314,
            0x211a1477,
            0xe6ad2065,
            0x77b5fa86,
            0xc75442f5,
            0xfb9d35cf,
            0xebcdaf0c,
            0x7b3e89a0,
            0xd6411bd3,
            0xae1e7e49,
            0x00250e2d,
            0x2071b35e,
            0x226800bb,
            0x57b8e0af,
            0x2464369b,
            0xf009b91e,
            0x5563911d,
            0x59dfa6aa,
            0x78c14389,
            0xd95a537f,
            0x207d5ba2,
            0x02e5b9c5,
            0x83260376,
            0x6295cfa9,
            0x11c81968,
            0x4e734a41,
            0xb3472dca,
            0x7b14a94a,
            0x1b510052,
            0x9a532915,
            0xd60f573f,
            0xbc9bc6e4,
            0x2b60a476,
            0x81e67400,
            0x08ba6fb5,
            0x571be91f,
            0xf296ec6b,
            0x2a0dd915,
            0xb6636521,
            0xe7b9f9b6,
            0xff34052e,
            0xc5855664,
            0x53b02d5d,
            0xa99f8fa1,
            0x08ba4799,
            0x6e85076a
        ]),
        new Uint32Array([
            0x4b7a70e9,
            0xb5b32944,
            0xdb75092e,
            0xc4192623,
            0xad6ea6b0,
            0x49a7df7d,
            0x9cee60b8,
            0x8fedb266,
            0xecaa8c71,
            0x699a17ff,
            0x5664526c,
            0xc2b19ee1,
            0x193602a5,
            0x75094c29,
            0xa0591340,
            0xe4183a3e,
            0x3f54989a,
            0x5b429d65,
            0x6b8fe4d6,
            0x99f73fd6,
            0xa1d29c07,
            0xefe830f5,
            0x4d2d38e6,
            0xf0255dc1,
            0x4cdd2086,
            0x8470eb26,
            0x6382e9c6,
            0x021ecc5e,
            0x09686b3f,
            0x3ebaefc9,
            0x3c971814,
            0x6b6a70a1,
            0x687f3584,
            0x52a0e286,
            0xb79c5305,
            0xaa500737,
            0x3e07841c,
            0x7fdeae5c,
            0x8e7d44ec,
            0x5716f2b8,
            0xb03ada37,
            0xf0500c0d,
            0xf01c1f04,
            0x0200b3ff,
            0xae0cf51a,
            0x3cb574b2,
            0x25837a58,
            0xdc0921bd,
            0xd19113f9,
            0x7ca92ff6,
            0x94324773,
            0x22f54701,
            0x3ae5e581,
            0x37c2dadc,
            0xc8b57634,
            0x9af3dda7,
            0xa9446146,
            0x0fd0030e,
            0xecc8c73e,
            0xa4751e41,
            0xe238cd99,
            0x3bea0e2f,
            0x3280bba1,
            0x183eb331,
            0x4e548b38,
            0x4f6db908,
            0x6f420d03,
            0xf60a04bf,
            0x2cb81290,
            0x24977c79,
            0x5679b072,
            0xbcaf89af,
            0xde9a771f,
            0xd9930810,
            0xb38bae12,
            0xdccf3f2e,
            0x5512721f,
            0x2e6b7124,
            0x501adde6,
            0x9f84cd87,
            0x7a584718,
            0x7408da17,
            0xbc9f9abc,
            0xe94b7d8c,
            0xec7aec3a,
            0xdb851dfa,
            0x63094366,
            0xc464c3d2,
            0xef1c1847,
            0x3215d908,
            0xdd433b37,
            0x24c2ba16,
            0x12a14d43,
            0x2a65c451,
            0x50940002,
            0x133ae4dd,
            0x71dff89e,
            0x10314e55,
            0x81ac77d6,
            0x5f11199b,
            0x043556f1,
            0xd7a3c76b,
            0x3c11183b,
            0x5924a509,
            0xf28fe6ed,
            0x97f1fbfa,
            0x9ebabf2c,
            0x1e153c6e,
            0x86e34570,
            0xeae96fb1,
            0x860e5e0a,
            0x5a3e2ab3,
            0x771fe71c,
            0x4e3d06fa,
            0x2965dcb9,
            0x99e71d0f,
            0x803e89d6,
            0x5266c825,
            0x2e4cc978,
            0x9c10b36a,
            0xc6150eba,
            0x94e2ea78,
            0xa5fc3c53,
            0x1e0a2df4,
            0xf2f74ea7,
            0x361d2b3d,
            0x1939260f,
            0x19c27960,
            0x5223a708,
            0xf71312b6,
            0xebadfe6e,
            0xeac31f66,
            0xe3bc4595,
            0xa67bc883,
            0xb17f37d1,
            0x018cff28,
            0xc332ddef,
            0xbe6c5aa5,
            0x65582185,
            0x68ab9802,
            0xeecea50f,
            0xdb2f953b,
            0x2aef7dad,
            0x5b6e2f84,
            0x1521b628,
            0x29076170,
            0xecdd4775,
            0x619f1510,
            0x13cca830,
            0xeb61bd96,
            0x0334fe1e,
            0xaa0363cf,
            0xb5735c90,
            0x4c70a239,
            0xd59e9e0b,
            0xcbaade14,
            0xeecc86bc,
            0x60622ca7,
            0x9cab5cab,
            0xb2f3846e,
            0x648b1eaf,
            0x19bdf0ca,
            0xa02369b9,
            0x655abb50,
            0x40685a32,
            0x3c2ab4b3,
            0x319ee9d5,
            0xc021b8f7,
            0x9b540b19,
            0x875fa099,
            0x95f7997e,
            0x623d7da8,
            0xf837889a,
            0x97e32d77,
            0x11ed935f,
            0x16681281,
            0x0e358829,
            0xc7e61fd6,
            0x96dedfa1,
            0x7858ba99,
            0x57f584a5,
            0x1b227263,
            0x9b83c3ff,
            0x1ac24696,
            0xcdb30aeb,
            0x532e3054,
            0x8fd948e4,
            0x6dbc3128,
            0x58ebf2ef,
            0x34c6ffea,
            0xfe28ed61,
            0xee7c3c73,
            0x5d4a14d9,
            0xe864b7e3,
            0x42105d14,
            0x203e13e0,
            0x45eee2b6,
            0xa3aaabea,
            0xdb6c4f15,
            0xfacb4fd0,
            0xc742f442,
            0xef6abbb5,
            0x654f3b1d,
            0x41cd2105,
            0xd81e799e,
            0x86854dc7,
            0xe44b476a,
            0x3d816250,
            0xcf62a1f2,
            0x5b8d2646,
            0xfc8883a0,
            0xc1c7b6a3,
            0x7f1524c3,
            0x69cb7492,
            0x47848a0b,
            0x5692b285,
            0x095bbf00,
            0xad19489d,
            0x1462b174,
            0x23820e00,
            0x58428d2a,
            0x0c55f5ea,
            0x1dadf43e,
            0x233f7061,
            0x3372f092,
            0x8d937e41,
            0xd65fecf1,
            0x6c223bdb,
            0x7cde3759,
            0xcbee7460,
            0x4085f2a7,
            0xce77326e,
            0xa6078084,
            0x19f8509e,
            0xe8efd855,
            0x61d99735,
            0xa969a7aa,
            0xc50c06c2,
            0x5a04abfc,
            0x800bcadc,
            0x9e447a2e,
            0xc3453484,
            0xfdd56705,
            0x0e1e9ec9,
            0xdb73dbd3,
            0x105588cd,
            0x675fda79,
            0xe3674340,
            0xc5c43465,
            0x713e38d8,
            0x3d28f89e,
            0xf16dff20,
            0x153e21e7,
            0x8fb03d4a,
            0xe6e39f2b,
            0xdb83adf7
        ]),
        new Uint32Array([
            0xe93d5a68,
            0x948140f7,
            0xf64c261c,
            0x94692934,
            0x411520f7,
            0x7602d4f7,
            0xbcf46b2e,
            0xd4a20068,
            0xd4082471,
            0x3320f46a,
            0x43b7d4b7,
            0x500061af,
            0x1e39f62e,
            0x97244546,
            0x14214f74,
            0xbf8b8840,
            0x4d95fc1d,
            0x96b591af,
            0x70f4ddd3,
            0x66a02f45,
            0xbfbc09ec,
            0x03bd9785,
            0x7fac6dd0,
            0x31cb8504,
            0x96eb27b3,
            0x55fd3941,
            0xda2547e6,
            0xabca0a9a,
            0x28507825,
            0x530429f4,
            0x0a2c86da,
            0xe9b66dfb,
            0x68dc1462,
            0xd7486900,
            0x680ec0a4,
            0x27a18dee,
            0x4f3ffea2,
            0xe887ad8c,
            0xb58ce006,
            0x7af4d6b6,
            0xaace1e7c,
            0xd3375fec,
            0xce78a399,
            0x406b2a42,
            0x20fe9e35,
            0xd9f385b9,
            0xee39d7ab,
            0x3b124e8b,
            0x1dc9faf7,
            0x4b6d1856,
            0x26a36631,
            0xeae397b2,
            0x3a6efa74,
            0xdd5b4332,
            0x6841e7f7,
            0xca7820fb,
            0xfb0af54e,
            0xd8feb397,
            0x454056ac,
            0xba489527,
            0x55533a3a,
            0x20838d87,
            0xfe6ba9b7,
            0xd096954b,
            0x55a867bc,
            0xa1159a58,
            0xcca92963,
            0x99e1db33,
            0xa62a4a56,
            0x3f3125f9,
            0x5ef47e1c,
            0x9029317c,
            0xfdf8e802,
            0x04272f70,
            0x80bb155c,
            0x05282ce3,
            0x95c11548,
            0xe4c66d22,
            0x48c1133f,
            0xc70f86dc,
            0x07f9c9ee,
            0x41041f0f,
            0x404779a4,
            0x5d886e17,
            0x325f51eb,
            0xd59bc0d1,
            0xf2bcc18f,
            0x41113564,
            0x257b7834,
            0x602a9c60,
            0xdff8e8a3,
            0x1f636c1b,
            0x0e12b4c2,
            0x02e1329e,
            0xaf664fd1,
            0xcad18115,
            0x6b2395e0,
            0x333e92e1,
            0x3b240b62,
            0xeebeb922,
            0x85b2a20e,
            0xe6ba0d99,
            0xde720c8c,
            0x2da2f728,
            0xd0127845,
            0x95b794fd,
            0x647d0862,
            0xe7ccf5f0,
            0x5449a36f,
            0x877d48fa,
            0xc39dfd27,
            0xf33e8d1e,
            0x0a476341,
            0x992eff74,
            0x3a6f6eab,
            0xf4f8fd37,
            0xa812dc60,
            0xa1ebddf8,
            0x991be14c,
            0xdb6e6b0d,
            0xc67b5510,
            0x6d672c37,
            0x2765d43b,
            0xdcd0e804,
            0xf1290dc7,
            0xcc00ffa3,
            0xb5390f92,
            0x690fed0b,
            0x667b9ffb,
            0xcedb7d9c,
            0xa091cf0b,
            0xd9155ea3,
            0xbb132f88,
            0x515bad24,
            0x7b9479bf,
            0x763bd6eb,
            0x37392eb3,
            0xcc115979,
            0x8026e297,
            0xf42e312d,
            0x6842ada7,
            0xc66a2b3b,
            0x12754ccc,
            0x782ef11c,
            0x6a124237,
            0xb79251e7,
            0x06a1bbe6,
            0x4bfb6350,
            0x1a6b1018,
            0x11caedfa,
            0x3d25bdd8,
            0xe2e1c3c9,
            0x44421659,
            0x0a121386,
            0xd90cec6e,
            0xd5abea2a,
            0x64af674e,
            0xda86a85f,
            0xbebfe988,
            0x64e4c3fe,
            0x9dbc8057,
            0xf0f7c086,
            0x60787bf8,
            0x6003604d,
            0xd1fd8346,
            0xf6381fb0,
            0x7745ae04,
            0xd736fccc,
            0x83426b33,
            0xf01eab71,
            0xb0804187,
            0x3c005e5f,
            0x77a057be,
            0xbde8ae24,
            0x55464299,
            0xbf582e61,
            0x4e58f48f,
            0xf2ddfda2,
            0xf474ef38,
            0x8789bdc2,
            0x5366f9c3,
            0xc8b38e74,
            0xb475f255,
            0x46fcd9b9,
            0x7aeb2661,
            0x8b1ddf84,
            0x846a0e79,
            0x915f95e2,
            0x466e598e,
            0x20b45770,
            0x8cd55591,
            0xc902de4c,
            0xb90bace1,
            0xbb8205d0,
            0x11a86248,
            0x7574a99e,
            0xb77f19b6,
            0xe0a9dc09,
            0x662d09a1,
            0xc4324633,
            0xe85a1f02,
            0x09f0be8c,
            0x4a99a025,
            0x1d6efe10,
            0x1ab93d1d,
            0x0ba5a4df,
            0xa186f20f,
            0x2868f169,
            0xdcb7da83,
            0x573906fe,
            0xa1e2ce9b,
            0x4fcd7f52,
            0x50115e01,
            0xa70683fa,
            0xa002b5c4,
            0x0de6d027,
            0x9af88c27,
            0x773f8641,
            0xc3604c06,
            0x61a806b5,
            0xf0177a28,
            0xc0f586e0,
            0x006058aa,
            0x30dc7d62,
            0x11e69ed7,
            0x2338ea63,
            0x53c2dd94,
            0xc2c21634,
            0xbbcbee56,
            0x90bcb6de,
            0xebfc7da1,
            0xce591d76,
            0x6f05e409,
            0x4b7c0188,
            0x39720a3d,
            0x7c927c24,
            0x86e3725f,
            0x724d9db9,
            0x1ac15bb4,
            0xd39eb8fc,
            0xed545578,
            0x08fca5b5,
            0xd83d7cd3,
            0x4dad0fc4,
            0x1e50ef5e,
            0xb161e6f8,
            0xa28514d9,
            0x6c51133c,
            0x6fd5c7e7,
            0x56e14ec4,
            0x362abfce,
            0xddc6c837,
            0xd79a3234,
            0x92638212,
            0x670efa8e,
            0x406000e0
        ]),
        new Uint32Array([
            0x3a39ce37,
            0xd3faf5cf,
            0xabc27737,
            0x5ac52d1b,
            0x5cb0679e,
            0x4fa33742,
            0xd3822740,
            0x99bc9bbe,
            0xd5118e9d,
            0xbf0f7315,
            0xd62d1c7e,
            0xc700c47b,
            0xb78c1b6b,
            0x21a19045,
            0xb26eb1be,
            0x6a366eb4,
            0x5748ab2f,
            0xbc946e79,
            0xc6a376d2,
            0x6549c2c8,
            0x530ff8ee,
            0x468dde7d,
            0xd5730a1d,
            0x4cd04dc6,
            0x2939bbdb,
            0xa9ba4650,
            0xac9526e8,
            0xbe5ee304,
            0xa1fad5f0,
            0x6a2d519a,
            0x63ef8ce2,
            0x9a86ee22,
            0xc089c2b8,
            0x43242ef6,
            0xa51e03aa,
            0x9cf2d0a4,
            0x83c061ba,
            0x9be96a4d,
            0x8fe51550,
            0xba645bd6,
            0x2826a2f9,
            0xa73a3ae1,
            0x4ba99586,
            0xef5562e9,
            0xc72fefd3,
            0xf752f7da,
            0x3f046f69,
            0x77fa0a59,
            0x80e4a915,
            0x87b08601,
            0x9b09e6ad,
            0x3b3ee593,
            0xe990fd5a,
            0x9e34d797,
            0x2cf0b7d9,
            0x022b8b51,
            0x96d5ac3a,
            0x017da67d,
            0xd1cf3ed6,
            0x7c7d2d28,
            0x1f9f25cf,
            0xadf2b89b,
            0x5ad6b472,
            0x5a88f54c,
            0xe029ac71,
            0xe019a5e6,
            0x47b0acfd,
            0xed93fa9b,
            0xe8d3c48d,
            0x283b57cc,
            0xf8d56629,
            0x79132e28,
            0x785f0191,
            0xed756055,
            0xf7960e44,
            0xe3d35e8c,
            0x15056dd4,
            0x88f46dba,
            0x03a16125,
            0x0564f0bd,
            0xc3eb9e15,
            0x3c9057a2,
            0x97271aec,
            0xa93a072a,
            0x1b3f6d9b,
            0x1e6321f5,
            0xf59c66fb,
            0x26dcf319,
            0x7533d928,
            0xb155fdf5,
            0x03563482,
            0x8aba3cbb,
            0x28517711,
            0xc20ad9f8,
            0xabcc5167,
            0xccad925f,
            0x4de81751,
            0x3830dc8e,
            0x379d5862,
            0x9320f991,
            0xea7a90c2,
            0xfb3e7bce,
            0x5121ce64,
            0x774fbe32,
            0xa8b6e37e,
            0xc3293d46,
            0x48de5369,
            0x6413e680,
            0xa2ae0810,
            0xdd6db224,
            0x69852dfd,
            0x09072166,
            0xb39a460a,
            0x6445c0dd,
            0x586cdecf,
            0x1c20c8ae,
            0x5bbef7dd,
            0x1b588d40,
            0xccd2017f,
            0x6bb4e3bb,
            0xdda26a7e,
            0x3a59ff45,
            0x3e350a44,
            0xbcb4cdd5,
            0x72eacea8,
            0xfa6484bb,
            0x8d6612ae,
            0xbf3c6f47,
            0xd29be463,
            0x542f5d9e,
            0xaec2771b,
            0xf64e6370,
            0x740e0d8d,
            0xe75b1357,
            0xf8721671,
            0xaf537d5d,
            0x4040cb08,
            0x4eb4e2cc,
            0x34d2466a,
            0x0115af84,
            0xe1b00428,
            0x95983a1d,
            0x06b89fb4,
            0xce6ea048,
            0x6f3f3b82,
            0x3520ab82,
            0x011a1d4b,
            0x277227f8,
            0x611560b1,
            0xe7933fdc,
            0xbb3a792b,
            0x344525bd,
            0xa08839e1,
            0x51ce794b,
            0x2f32c9b7,
            0xa01fbac9,
            0xe01cc87e,
            0xbcc7d1f6,
            0xcf0111c3,
            0xa1e8aac7,
            0x1a908749,
            0xd44fbd9a,
            0xd0dadecb,
            0xd50ada38,
            0x0339c32a,
            0xc6913667,
            0x8df9317c,
            0xe0b12b4f,
            0xf79e59b7,
            0x43f5bb3a,
            0xf2d519ff,
            0x27d9459c,
            0xbf97222c,
            0x15e6fc2a,
            0x0f91fc71,
            0x9b941525,
            0xfae59361,
            0xceb69ceb,
            0xc2a86459,
            0x12baa8d1,
            0xb6c1075e,
            0xe3056a0c,
            0x10d25065,
            0xcb03a442,
            0xe0ec6e0e,
            0x1698db3b,
            0x4c98a0be,
            0x3278e964,
            0x9f1f9532,
            0xe0d392df,
            0xd3a0342b,
            0x8971f21e,
            0x1b0a7441,
            0x4ba3348c,
            0xc5be7120,
            0xc37632d8,
            0xdf359f8d,
            0x9b992f2e,
            0xe60b6f47,
            0x0fe3f11d,
            0xe54cda54,
            0x1edad891,
            0xce6279cf,
            0xcd3e7e6f,
            0x1618b166,
            0xfd2c1d05,
            0x848fd2c5,
            0xf6fb2299,
            0xf523f357,
            0xa6327623,
            0x93a83531,
            0x56cccd02,
            0xacf08162,
            0x5a75ebb5,
            0x6e163697,
            0x88d273cc,
            0xde966292,
            0x81b949d0,
            0x4c50901b,
            0x71c65614,
            0xe6c6c7bd,
            0x327a140a,
            0x45e1d006,
            0xc3f27b9a,
            0xc9aa53fd,
            0x62a80f00,
            0xbb25bfe2,
            0x35bdd2f6,
            0x71126905,
            0xb2040222,
            0xb6cbcf7c,
            0xcd769c2b,
            0x53113ec0,
            0x1640e3d3,
            0x38abbd60,
            0x2547adf0,
            0xba38209c,
            0xf746ce76,
            0x77afa1c5,
            0x20756060,
            0x85cbfe4e,
            0x8ae88dd8,
            0x7aaaf9b0,
            0x4cf9aa7e,
            0x1948c25c,
            0x02fb8a8c,
            0x01c36ae4,
            0xd6ebe1f9,
            0x90d4f869,
            0xa65cdea0,
            0x3f09252d,
            0xc208e69f,
            0xb74e6132,
            0xce77e25b,
            0x578fdfe3,
            0x3ac372e6
        ])
    ];
    this.P = new Uint32Array([
        0x243f6a88,
        0x85a308d3,
        0x13198a2e,
        0x03707344,
        0xa4093822,
        0x299f31d0,
        0x082efa98,
        0xec4e6c89,
        0x452821e6,
        0x38d01377,
        0xbe5466cf,
        0x34e90c6c,
        0xc0ac29b7,
        0xc97c50dd,
        0x3f84d5b5,
        0xb5470917,
        0x9216d5d9,
        0x8979fb1b
    ]);
};
function F(S, x8, i) {
    return (S[0][x8[i + 3]] + S[1][x8[i + 2]] ^ S[2][x8[i + 1]]) + S[3][x8[i]];
}
Blowfish.prototype.encipher = function(x, x8) {
    if (x8 === undefined) {
        x8 = new Uint8Array(x.buffer);
        if (x.byteOffset !== 0) x8 = x8.subarray(x.byteOffset);
    }
    x[0] ^= this.P[0];
    for(var i = 1; i < 16; i += 2){
        x[1] ^= F(this.S, x8, 0) ^ this.P[i];
        x[0] ^= F(this.S, x8, 4) ^ this.P[i + 1];
    }
    var t = x[0];
    x[0] = x[1] ^ this.P[17];
    x[1] = t;
};
Blowfish.prototype.decipher = function(x) {
    var x8 = new Uint8Array(x.buffer);
    if (x.byteOffset !== 0) x8 = x8.subarray(x.byteOffset);
    x[0] ^= this.P[17];
    for(var i = 16; i > 0; i -= 2){
        x[1] ^= F(this.S, x8, 0) ^ this.P[i];
        x[0] ^= F(this.S, x8, 4) ^ this.P[i - 1];
    }
    var t = x[0];
    x[0] = x[1] ^ this.P[0];
    x[1] = t;
};
function stream2word(data, databytes) {
    var i, temp = 0;
    for(i = 0; i < 4; i++, BLF_J++){
        if (BLF_J >= databytes) BLF_J = 0;
        temp = temp << 8 | data[BLF_J];
    }
    return temp;
}
Blowfish.prototype.expand0state = function(key, keybytes) {
    var d = new Uint32Array(2), i, k;
    var d8 = new Uint8Array(d.buffer);
    for(i = 0, BLF_J = 0; i < 18; i++)this.P[i] ^= stream2word(key, keybytes);
    BLF_J = 0;
    for(i = 0; i < 18; i += 2){
        this.encipher(d, d8);
        this.P[i] = d[0];
        this.P[i + 1] = d[1];
    }
    for(i = 0; i < 4; i++)for(k = 0; k < 256; k += 2){
        this.encipher(d, d8);
        this.S[i][k] = d[0];
        this.S[i][k + 1] = d[1];
    }
};
Blowfish.prototype.expandstate = function(data, databytes, key, keybytes) {
    var d = new Uint32Array(2), i, k;
    for(i = 0, BLF_J = 0; i < 18; i++)this.P[i] ^= stream2word(key, keybytes);
    for(i = 0, BLF_J = 0; i < 18; i += 2){
        d[0] ^= stream2word(data, databytes);
        d[1] ^= stream2word(data, databytes);
        this.encipher(d);
        this.P[i] = d[0];
        this.P[i + 1] = d[1];
    }
    for(i = 0; i < 4; i++)for(k = 0; k < 256; k += 2){
        d[0] ^= stream2word(data, databytes);
        d[1] ^= stream2word(data, databytes);
        this.encipher(d);
        this.S[i][k] = d[0];
        this.S[i][k + 1] = d[1];
    }
    BLF_J = 0;
};
Blowfish.prototype.enc = function(data, blocks) {
    for(var i = 0; i < blocks; i++)this.encipher(data.subarray(i * 2));
};
Blowfish.prototype.dec = function(data, blocks) {
    for(var i = 0; i < blocks; i++)this.decipher(data.subarray(i * 2));
};
var BCRYPT_BLOCKS = 8, BCRYPT_HASHSIZE = 32;
function bcrypt_hash(sha2pass, sha2salt, out) {
    var state = new Blowfish(), cdata = new Uint32Array(BCRYPT_BLOCKS), i, ciphertext = new Uint8Array([
        79,
        120,
        121,
        99,
        104,
        114,
        111,
        109,
        97,
        116,
        105,
        99,
        66,
        108,
        111,
        119,
        102,
        105,
        115,
        104,
        83,
        119,
        97,
        116,
        68,
        121,
        110,
        97,
        109,
        105,
        116,
        101
    ]); //"OxychromaticBlowfishSwatDynamite"
    state.expandstate(sha2salt, 64, sha2pass, 64);
    for(i = 0; i < 64; i++){
        state.expand0state(sha2salt, 64);
        state.expand0state(sha2pass, 64);
    }
    for(i = 0; i < BCRYPT_BLOCKS; i++)cdata[i] = stream2word(ciphertext, ciphertext.byteLength);
    for(i = 0; i < 64; i++)state.enc(cdata, cdata.byteLength / 8);
    for(i = 0; i < BCRYPT_BLOCKS; i++){
        out[4 * i + 3] = cdata[i] >>> 24;
        out[4 * i + 2] = cdata[i] >>> 16;
        out[4 * i + 1] = cdata[i] >>> 8;
        out[4 * i + 0] = cdata[i];
    }
}
function bcrypt_pbkdf(pass, passlen, salt, saltlen, key, keylen, rounds) {
    var sha2pass = new Uint8Array(64), sha2salt = new Uint8Array(64), out = new Uint8Array(BCRYPT_HASHSIZE), tmpout = new Uint8Array(BCRYPT_HASHSIZE), countsalt = new Uint8Array(saltlen + 4), i, j, amt, stride, dest, count, origkeylen = keylen;
    if (rounds < 1) return -1;
    if (passlen === 0 || saltlen === 0 || keylen === 0 || keylen > out.byteLength * out.byteLength || saltlen > 1048576) return -1;
    stride = Math.floor((keylen + out.byteLength - 1) / out.byteLength);
    amt = Math.floor((keylen + stride - 1) / stride);
    for(i = 0; i < saltlen; i++)countsalt[i] = salt[i];
    crypto_hash_sha512(sha2pass, pass, passlen);
    for(count = 1; keylen > 0; count++){
        countsalt[saltlen + 0] = count >>> 24;
        countsalt[saltlen + 1] = count >>> 16;
        countsalt[saltlen + 2] = count >>> 8;
        countsalt[saltlen + 3] = count;
        crypto_hash_sha512(sha2salt, countsalt, saltlen + 4);
        bcrypt_hash(sha2pass, sha2salt, tmpout);
        for(i = out.byteLength; i--;)out[i] = tmpout[i];
        for(i = 1; i < rounds; i++){
            crypto_hash_sha512(sha2salt, tmpout, tmpout.byteLength);
            bcrypt_hash(sha2pass, sha2salt, tmpout);
            for(j = 0; j < out.byteLength; j++)out[j] ^= tmpout[j];
        }
        amt = Math.min(amt, keylen);
        for(i = 0; i < amt; i++){
            dest = i * stride + (count - 1);
            if (dest >= origkeylen) break;
            key[dest] = out[i];
        }
        keylen -= i;
    }
    return 0;
}
module.exports = {
    BLOCKS: BCRYPT_BLOCKS,
    HASHSIZE: BCRYPT_HASHSIZE,
    hash: bcrypt_hash,
    pbkdf: bcrypt_pbkdf
};

},{"3e451905d10c9e58":"exIc8"}],"apfcv":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
module.exports = {
    read: read,
    write: write
};
var assert = require("84454013e30af4c");
var Buffer = require("e859462a3b8bdca5").Buffer;
var rfc4253 = require("82faeb1bb5259de9");
var utils = require("97386f47d9f0c13c");
var Key = require("be5a541e74f897d4");
var PrivateKey = require("56f22eb60115c7d");
var sshpriv = require("67330acb1c706b9d");
/*JSSTYLED*/ var SSHKEY_RE = /^([a-z0-9-]+)[ \t]+([a-zA-Z0-9+\/]+[=]*)([ \t]+([^ \t][^\n]*[\n]*)?)?$/;
/*JSSTYLED*/ var SSHKEY_RE2 = /^([a-z0-9-]+)[ \t\n]+([a-zA-Z0-9+\/][a-zA-Z0-9+\/ \t\n=]*)([^a-zA-Z0-9+\/ \t\n=].*)?$/;
function read(buf, options) {
    if (typeof buf !== "string") {
        assert.buffer(buf, "buf");
        buf = buf.toString("ascii");
    }
    var trimmed = buf.trim().replace(/[\\\r]/g, "");
    var m = trimmed.match(SSHKEY_RE);
    if (!m) m = trimmed.match(SSHKEY_RE2);
    assert.ok(m, "key must match regex");
    var type = rfc4253.algToKeyType(m[1]);
    var kbuf = Buffer.from(m[2], "base64");
    /*
	 * This is a bit tricky. If we managed to parse the key and locate the
	 * key comment with the regex, then do a non-partial read and assert
	 * that we have consumed all bytes. If we couldn't locate the key
	 * comment, though, there may be whitespace shenanigans going on that
	 * have conjoined the comment to the rest of the key. We do a partial
	 * read in this case to try to make the best out of a sorry situation.
	 */ var key;
    var ret = {};
    if (m[4]) try {
        key = rfc4253.read(kbuf);
    } catch (e) {
        m = trimmed.match(SSHKEY_RE2);
        assert.ok(m, "key must match regex");
        kbuf = Buffer.from(m[2], "base64");
        key = rfc4253.readInternal(ret, "public", kbuf);
    }
    else key = rfc4253.readInternal(ret, "public", kbuf);
    assert.strictEqual(type, key.type);
    if (m[4] && m[4].length > 0) key.comment = m[4];
    else if (ret.consumed) {
        /*
		 * Now the magic: trying to recover the key comment when it's
		 * gotten conjoined to the key or otherwise shenanigan'd.
		 *
		 * Work out how much base64 we used, then drop all non-base64
		 * chars from the beginning up to this point in the the string.
		 * Then offset in this and try to make up for missing = chars.
		 */ var data = m[2] + (m[3] ? m[3] : "");
        var realOffset = Math.ceil(ret.consumed / 3) * 4;
        data = data.slice(0, realOffset - 2)./*JSSTYLED*/ replace(/[^a-zA-Z0-9+\/=]/g, "") + data.slice(realOffset - 2);
        var padding = ret.consumed % 3;
        if (padding > 0 && data.slice(realOffset - 1, realOffset) !== "=") realOffset--;
        while(data.slice(realOffset, realOffset + 1) === "=")realOffset++;
        /* Finally, grab what we think is the comment & clean it up. */ var trailer = data.slice(realOffset);
        trailer = trailer.replace(/[\r\n]/g, " ").replace(/^\s+/, "");
        if (trailer.match(/^[a-zA-Z0-9]/)) key.comment = trailer;
    }
    return key;
}
function write(key, options) {
    assert.object(key);
    if (!Key.isKey(key)) throw new Error("Must be a public key");
    var parts = [];
    var alg = rfc4253.keyTypeToAlg(key);
    parts.push(alg);
    var buf = rfc4253.write(key);
    parts.push(buf.toString("base64"));
    if (key.comment) parts.push(key.comment);
    return Buffer.from(parts.join(" "));
}

},{"84454013e30af4c":"eQsu4","e859462a3b8bdca5":"b2XZ0","82faeb1bb5259de9":"btAO6","97386f47d9f0c13c":"icPN2","be5a541e74f897d4":"fAyE1","56f22eb60115c7d":"4674F","67330acb1c706b9d":"2pfcf"}],"bfK2i":[function(require,module,exports) {
// Copyright 2017 Joyent, Inc.
module.exports = {
    read: read,
    write: write
};
var assert = require("dd67e2f332bd8747");
var Buffer = require("1a2c2992e1972451").Buffer;
var Key = require("64e98140bf3c635");
var PrivateKey = require("d12c34c8c50257f8");
var utils = require("84c8a729699a37bc");
var SSHBuffer = require("fbfd744d914668b2");
var Dhe = require("622cbdbeffe0e425");
var supportedAlgos = {
    "rsa-sha1": 5,
    "rsa-sha256": 8,
    "rsa-sha512": 10,
    "ecdsa-p256-sha256": 13,
    "ecdsa-p384-sha384": 14
};
var supportedAlgosById = {};
Object.keys(supportedAlgos).forEach(function(k) {
    supportedAlgosById[supportedAlgos[k]] = k.toUpperCase();
});
function read(buf, options) {
    if (typeof buf !== "string") {
        assert.buffer(buf, "buf");
        buf = buf.toString("ascii");
    }
    var lines = buf.split("\n");
    if (lines[0].match(/^Private-key-format\: v1/)) {
        var algElems = lines[1].split(" ");
        var algoNum = parseInt(algElems[1], 10);
        var algoName = algElems[2];
        if (!supportedAlgosById[algoNum]) throw new Error("Unsupported algorithm: " + algoName);
        return readDNSSECPrivateKey(algoNum, lines.slice(2));
    }
    // skip any comment-lines
    var line = 0;
    /* JSSTYLED */ while(lines[line].match(/^\;/))line++;
    // we should now have *one single* line left with our KEY on it.
    if ((lines[line].match(/\. IN KEY /) || lines[line].match(/\. IN DNSKEY /)) && lines[line + 1].length === 0) return readRFC3110(lines[line]);
    throw new Error("Cannot parse dnssec key");
}
function readRFC3110(keyString) {
    var elems = keyString.split(" ");
    //unused var flags = parseInt(elems[3], 10);
    //unused var protocol = parseInt(elems[4], 10);
    var algorithm = parseInt(elems[5], 10);
    if (!supportedAlgosById[algorithm]) throw new Error("Unsupported algorithm: " + algorithm);
    var base64key = elems.slice(6, elems.length).join();
    var keyBuffer = Buffer.from(base64key, "base64");
    if (supportedAlgosById[algorithm].match(/^RSA-/)) {
        // join the rest of the body into a single base64-blob
        var publicExponentLen = keyBuffer.readUInt8(0);
        if (publicExponentLen != 3 && publicExponentLen != 1) throw new Error("Cannot parse dnssec key: unsupported exponent length");
        var publicExponent = keyBuffer.slice(1, publicExponentLen + 1);
        publicExponent = utils.mpNormalize(publicExponent);
        var modulus = keyBuffer.slice(1 + publicExponentLen);
        modulus = utils.mpNormalize(modulus);
        // now, make the key
        var rsaKey = {
            type: "rsa",
            parts: []
        };
        rsaKey.parts.push({
            name: "e",
            data: publicExponent
        });
        rsaKey.parts.push({
            name: "n",
            data: modulus
        });
        return new Key(rsaKey);
    }
    if (supportedAlgosById[algorithm] === "ECDSA-P384-SHA384" || supportedAlgosById[algorithm] === "ECDSA-P256-SHA256") {
        var curve = "nistp384";
        var size = 384;
        if (supportedAlgosById[algorithm].match(/^ECDSA-P256-SHA256/)) {
            curve = "nistp256";
            size = 256;
        }
        var ecdsaKey = {
            type: "ecdsa",
            curve: curve,
            size: size,
            parts: [
                {
                    name: "curve",
                    data: Buffer.from(curve)
                },
                {
                    name: "Q",
                    data: utils.ecNormalize(keyBuffer)
                }
            ]
        };
        return new Key(ecdsaKey);
    }
    throw new Error("Unsupported algorithm: " + supportedAlgosById[algorithm]);
}
function elementToBuf(e) {
    return Buffer.from(e.split(" ")[1], "base64");
}
function readDNSSECRSAPrivateKey(elements) {
    var rsaParams = {};
    elements.forEach(function(element) {
        if (element.split(" ")[0] === "Modulus:") rsaParams["n"] = elementToBuf(element);
        else if (element.split(" ")[0] === "PublicExponent:") rsaParams["e"] = elementToBuf(element);
        else if (element.split(" ")[0] === "PrivateExponent:") rsaParams["d"] = elementToBuf(element);
        else if (element.split(" ")[0] === "Prime1:") rsaParams["p"] = elementToBuf(element);
        else if (element.split(" ")[0] === "Prime2:") rsaParams["q"] = elementToBuf(element);
        else if (element.split(" ")[0] === "Exponent1:") rsaParams["dmodp"] = elementToBuf(element);
        else if (element.split(" ")[0] === "Exponent2:") rsaParams["dmodq"] = elementToBuf(element);
        else if (element.split(" ")[0] === "Coefficient:") rsaParams["iqmp"] = elementToBuf(element);
    });
    // now, make the key
    var key = {
        type: "rsa",
        parts: [
            {
                name: "e",
                data: utils.mpNormalize(rsaParams["e"])
            },
            {
                name: "n",
                data: utils.mpNormalize(rsaParams["n"])
            },
            {
                name: "d",
                data: utils.mpNormalize(rsaParams["d"])
            },
            {
                name: "p",
                data: utils.mpNormalize(rsaParams["p"])
            },
            {
                name: "q",
                data: utils.mpNormalize(rsaParams["q"])
            },
            {
                name: "dmodp",
                data: utils.mpNormalize(rsaParams["dmodp"])
            },
            {
                name: "dmodq",
                data: utils.mpNormalize(rsaParams["dmodq"])
            },
            {
                name: "iqmp",
                data: utils.mpNormalize(rsaParams["iqmp"])
            }
        ]
    };
    return new PrivateKey(key);
}
function readDNSSECPrivateKey(alg, elements) {
    if (supportedAlgosById[alg].match(/^RSA-/)) return readDNSSECRSAPrivateKey(elements);
    if (supportedAlgosById[alg] === "ECDSA-P384-SHA384" || supportedAlgosById[alg] === "ECDSA-P256-SHA256") {
        var d = Buffer.from(elements[0].split(" ")[1], "base64");
        var curve = "nistp384";
        var size = 384;
        if (supportedAlgosById[alg] === "ECDSA-P256-SHA256") {
            curve = "nistp256";
            size = 256;
        }
        // DNSSEC generates the public-key on the fly (go calculate it)
        var publicKey = utils.publicFromPrivateECDSA(curve, d);
        var Q = publicKey.part["Q"].data;
        var ecdsaKey = {
            type: "ecdsa",
            curve: curve,
            size: size,
            parts: [
                {
                    name: "curve",
                    data: Buffer.from(curve)
                },
                {
                    name: "d",
                    data: d
                },
                {
                    name: "Q",
                    data: Q
                }
            ]
        };
        return new PrivateKey(ecdsaKey);
    }
    throw new Error("Unsupported algorithm: " + supportedAlgosById[alg]);
}
function dnssecTimestamp(date) {
    var year = date.getFullYear() + ""; //stringify
    var month = date.getMonth() + 1;
    var timestampStr = year + month + date.getUTCDate();
    timestampStr += "" + date.getUTCHours() + date.getUTCMinutes();
    timestampStr += date.getUTCSeconds();
    return timestampStr;
}
function rsaAlgFromOptions(opts) {
    if (!opts || !opts.hashAlgo || opts.hashAlgo === "sha1") return "5 (RSASHA1)";
    else if (opts.hashAlgo === "sha256") return "8 (RSASHA256)";
    else if (opts.hashAlgo === "sha512") return "10 (RSASHA512)";
    else throw new Error("Unknown or unsupported hash: " + opts.hashAlgo);
}
function writeRSA(key, options) {
    // if we're missing parts, add them.
    if (!key.part.dmodp || !key.part.dmodq) utils.addRSAMissing(key);
    var out = "";
    out += "Private-key-format: v1.3\n";
    out += "Algorithm: " + rsaAlgFromOptions(options) + "\n";
    var n = utils.mpDenormalize(key.part["n"].data);
    out += "Modulus: " + n.toString("base64") + "\n";
    var e = utils.mpDenormalize(key.part["e"].data);
    out += "PublicExponent: " + e.toString("base64") + "\n";
    var d = utils.mpDenormalize(key.part["d"].data);
    out += "PrivateExponent: " + d.toString("base64") + "\n";
    var p = utils.mpDenormalize(key.part["p"].data);
    out += "Prime1: " + p.toString("base64") + "\n";
    var q = utils.mpDenormalize(key.part["q"].data);
    out += "Prime2: " + q.toString("base64") + "\n";
    var dmodp = utils.mpDenormalize(key.part["dmodp"].data);
    out += "Exponent1: " + dmodp.toString("base64") + "\n";
    var dmodq = utils.mpDenormalize(key.part["dmodq"].data);
    out += "Exponent2: " + dmodq.toString("base64") + "\n";
    var iqmp = utils.mpDenormalize(key.part["iqmp"].data);
    out += "Coefficient: " + iqmp.toString("base64") + "\n";
    // Assume that we're valid as-of now
    var timestamp = new Date();
    out += "Created: " + dnssecTimestamp(timestamp) + "\n";
    out += "Publish: " + dnssecTimestamp(timestamp) + "\n";
    out += "Activate: " + dnssecTimestamp(timestamp) + "\n";
    return Buffer.from(out, "ascii");
}
function writeECDSA(key, options) {
    var out = "";
    out += "Private-key-format: v1.3\n";
    if (key.curve === "nistp256") out += "Algorithm: 13 (ECDSAP256SHA256)\n";
    else if (key.curve === "nistp384") out += "Algorithm: 14 (ECDSAP384SHA384)\n";
    else throw new Error("Unsupported curve");
    var base64Key = key.part["d"].data.toString("base64");
    out += "PrivateKey: " + base64Key + "\n";
    // Assume that we're valid as-of now
    var timestamp = new Date();
    out += "Created: " + dnssecTimestamp(timestamp) + "\n";
    out += "Publish: " + dnssecTimestamp(timestamp) + "\n";
    out += "Activate: " + dnssecTimestamp(timestamp) + "\n";
    return Buffer.from(out, "ascii");
}
function write(key, options) {
    if (PrivateKey.isPrivateKey(key)) {
        if (key.type === "rsa") return writeRSA(key, options);
        else if (key.type === "ecdsa") return writeECDSA(key, options);
        else throw new Error("Unsupported algorithm: " + key.type);
    } else if (Key.isKey(key)) /*
		 * RFC3110 requires a keyname, and a keytype, which we
		 * don't really have a mechanism for specifying such
		 * additional metadata.
		 */ throw new Error('Format "dnssec" only supports writing private keys');
    else throw new Error("key is not a Key or PrivateKey");
}

},{"dd67e2f332bd8747":"eQsu4","1a2c2992e1972451":"b2XZ0","64e98140bf3c635":"fAyE1","d12c34c8c50257f8":"4674F","84c8a729699a37bc":"icPN2","fbfd744d914668b2":"OXMVy","622cbdbeffe0e425":"4V4AY"}],"fNdMF":[function(require,module,exports) {
// Copyright 2018 Joyent, Inc.
module.exports = {
    read: read,
    write: write
};
var assert = require("c95a97531e72e0b5");
var Buffer = require("402316376e8304bd").Buffer;
var rfc4253 = require("6fb41322b946d076");
var Key = require("b67e1d09b6f12662");
var SSHBuffer = require("30982a6ec90b9aec");
var crypto = require("6f95f5de639ac8dd");
var PrivateKey = require("e5a302aaa9fef848");
var errors = require("ff60a2f3bec4d12b");
// https://tartarus.org/~simon/putty-prerel-snapshots/htmldoc/AppendixC.html
function read(buf, options) {
    var lines = buf.toString("ascii").split(/[\r\n]+/);
    var found = false;
    var parts;
    var si = 0;
    var formatVersion;
    while(si < lines.length){
        parts = splitHeader(lines[si++]);
        if (parts) {
            formatVersion = ({
                "putty-user-key-file-2": 2,
                "putty-user-key-file-3": 3
            })[parts[0].toLowerCase()];
            if (formatVersion) {
                found = true;
                break;
            }
        }
    }
    if (!found) throw new Error("No PuTTY format first line found");
    var alg = parts[1];
    parts = splitHeader(lines[si++]);
    assert.equal(parts[0].toLowerCase(), "encryption");
    var encryption = parts[1];
    parts = splitHeader(lines[si++]);
    assert.equal(parts[0].toLowerCase(), "comment");
    var comment = parts[1];
    parts = splitHeader(lines[si++]);
    assert.equal(parts[0].toLowerCase(), "public-lines");
    var publicLines = parseInt(parts[1], 10);
    if (!isFinite(publicLines) || publicLines < 0 || publicLines > lines.length) throw new Error("Invalid public-lines count");
    var publicBuf = Buffer.from(lines.slice(si, si + publicLines).join(""), "base64");
    var keyType = rfc4253.algToKeyType(alg);
    var key = rfc4253.read(publicBuf);
    if (key.type !== keyType) throw new Error("Outer key algorithm mismatch");
    si += publicLines;
    if (lines[si]) {
        parts = splitHeader(lines[si++]);
        assert.equal(parts[0].toLowerCase(), "private-lines");
        var privateLines = parseInt(parts[1], 10);
        if (!isFinite(privateLines) || privateLines < 0 || privateLines > lines.length) throw new Error("Invalid private-lines count");
        var privateBuf = Buffer.from(lines.slice(si, si + privateLines).join(""), "base64");
        if (encryption !== "none" && formatVersion === 3) throw new Error("Encrypted keys arenot supported for PuTTY format version 3");
        if (encryption === "aes256-cbc") {
            if (!options.passphrase) throw new errors.KeyEncryptedError(options.filename, "PEM");
            var iv = Buffer.alloc(16, 0);
            var decipher = crypto.createDecipheriv("aes-256-cbc", derivePPK2EncryptionKey(options.passphrase), iv);
            decipher.setAutoPadding(false);
            privateBuf = Buffer.concat([
                decipher.update(privateBuf),
                decipher.final()
            ]);
        }
        key = new PrivateKey(key);
        if (key.type !== keyType) throw new Error("Outer key algorithm mismatch");
        var sshbuf = new SSHBuffer({
            buffer: privateBuf
        });
        var privateKeyParts;
        if (alg === "ssh-dss") privateKeyParts = [
            {
                name: "x",
                data: sshbuf.readBuffer()
            }
        ];
        else if (alg === "ssh-rsa") privateKeyParts = [
            {
                name: "d",
                data: sshbuf.readBuffer()
            },
            {
                name: "p",
                data: sshbuf.readBuffer()
            },
            {
                name: "q",
                data: sshbuf.readBuffer()
            },
            {
                name: "iqmp",
                data: sshbuf.readBuffer()
            }
        ];
        else if (alg.match(/^ecdsa-sha2-nistp/)) privateKeyParts = [
            {
                name: "d",
                data: sshbuf.readBuffer()
            }
        ];
        else if (alg === "ssh-ed25519") privateKeyParts = [
            {
                name: "k",
                data: sshbuf.readBuffer()
            }
        ];
        else throw new Error("Unsupported PPK key type: " + alg);
        key = new PrivateKey({
            type: key.type,
            parts: key.parts.concat(privateKeyParts)
        });
    }
    key.comment = comment;
    return key;
}
function derivePPK2EncryptionKey(passphrase) {
    var hash1 = crypto.createHash("sha1").update(Buffer.concat([
        Buffer.from([
            0,
            0,
            0,
            0
        ]),
        Buffer.from(passphrase)
    ])).digest();
    var hash2 = crypto.createHash("sha1").update(Buffer.concat([
        Buffer.from([
            0,
            0,
            0,
            1
        ]),
        Buffer.from(passphrase)
    ])).digest();
    return Buffer.concat([
        hash1,
        hash2
    ]).slice(0, 32);
}
function splitHeader(line) {
    var idx = line.indexOf(":");
    if (idx === -1) return null;
    var header = line.slice(0, idx);
    ++idx;
    while(line[idx] === " ")++idx;
    var rest = line.slice(idx);
    return [
        header,
        rest
    ];
}
function write(key, options) {
    assert.object(key);
    if (!Key.isKey(key)) throw new Error("Must be a public key");
    var alg = rfc4253.keyTypeToAlg(key);
    var buf = rfc4253.write(key);
    var comment = key.comment || "";
    var b64 = buf.toString("base64");
    var lines = wrap(b64, 64);
    lines.unshift("Public-Lines: " + lines.length);
    lines.unshift("Comment: " + comment);
    lines.unshift("Encryption: none");
    lines.unshift("PuTTY-User-Key-File-2: " + alg);
    return Buffer.from(lines.join("\n") + "\n");
}
function wrap(txt, len) {
    var lines = [];
    var pos = 0;
    while(pos < txt.length){
        lines.push(txt.slice(pos, pos + 64));
        pos += 64;
    }
    return lines;
}

},{"c95a97531e72e0b5":"eQsu4","402316376e8304bd":"b2XZ0","6fb41322b946d076":"btAO6","b67e1d09b6f12662":"fAyE1","30982a6ec90b9aec":"OXMVy","6f95f5de639ac8dd":"8Nkdo","e5a302aaa9fef848":"4674F","ff60a2f3bec4d12b":"6DKEY"}],"4Zfxv":[function(require,module,exports) {
// Copyright 2016 Joyent, Inc.
module.exports = Certificate;
var assert = require("d17a5e77a411be99");
var Buffer = require("1cca840dc65d765b").Buffer;
var algs = require("56b8a4f650a5e653");
var crypto = require("a99b7dfab4c821ed");
var Fingerprint = require("f22dde5fb3da5a91");
var Signature = require("2c6e5e0120dd0864");
var errs = require("5d76099d392e58ff");
var util = require("46eac9e6ef7f26f1");
var utils = require("51d67a4c58b6adfd");
var Key = require("f630a73b41bf7166");
var PrivateKey = require("4efedf6c60c9d1d6");
var Identity = require("83e221f4172c4ec2");
var formats = {};
formats["openssh"] = require("fd53a608520111b5");
formats["x509"] = require("de82cbae59487584");
formats["pem"] = require("c6314fc06fffc851");
var CertificateParseError = errs.CertificateParseError;
var InvalidAlgorithmError = errs.InvalidAlgorithmError;
function Certificate(opts) {
    assert.object(opts, "options");
    assert.arrayOfObject(opts.subjects, "options.subjects");
    utils.assertCompatible(opts.subjects[0], Identity, [
        1,
        0
    ], "options.subjects");
    utils.assertCompatible(opts.subjectKey, Key, [
        1,
        0
    ], "options.subjectKey");
    utils.assertCompatible(opts.issuer, Identity, [
        1,
        0
    ], "options.issuer");
    if (opts.issuerKey !== undefined) utils.assertCompatible(opts.issuerKey, Key, [
        1,
        0
    ], "options.issuerKey");
    assert.object(opts.signatures, "options.signatures");
    assert.buffer(opts.serial, "options.serial");
    assert.date(opts.validFrom, "options.validFrom");
    assert.date(opts.validUntil, "optons.validUntil");
    assert.optionalArrayOfString(opts.purposes, "options.purposes");
    this._hashCache = {};
    this.subjects = opts.subjects;
    this.issuer = opts.issuer;
    this.subjectKey = opts.subjectKey;
    this.issuerKey = opts.issuerKey;
    this.signatures = opts.signatures;
    this.serial = opts.serial;
    this.validFrom = opts.validFrom;
    this.validUntil = opts.validUntil;
    this.purposes = opts.purposes;
}
Certificate.formats = formats;
Certificate.prototype.toBuffer = function(format, options) {
    if (format === undefined) format = "x509";
    assert.string(format, "format");
    assert.object(formats[format], "formats[format]");
    assert.optionalObject(options, "options");
    return formats[format].write(this, options);
};
Certificate.prototype.toString = function(format, options) {
    if (format === undefined) format = "pem";
    return this.toBuffer(format, options).toString();
};
Certificate.prototype.fingerprint = function(algo) {
    if (algo === undefined) algo = "sha256";
    assert.string(algo, "algorithm");
    var opts = {
        type: "certificate",
        hash: this.hash(algo),
        algorithm: algo
    };
    return new Fingerprint(opts);
};
Certificate.prototype.hash = function(algo) {
    assert.string(algo, "algorithm");
    algo = algo.toLowerCase();
    if (algs.hashAlgs[algo] === undefined) throw new InvalidAlgorithmError(algo);
    if (this._hashCache[algo]) return this._hashCache[algo];
    var hash = crypto.createHash(algo).update(this.toBuffer("x509")).digest();
    this._hashCache[algo] = hash;
    return hash;
};
Certificate.prototype.isExpired = function(when) {
    if (when === undefined) when = new Date();
    return !(when.getTime() >= this.validFrom.getTime() && when.getTime() < this.validUntil.getTime());
};
Certificate.prototype.isSignedBy = function(issuerCert) {
    utils.assertCompatible(issuerCert, Certificate, [
        1,
        0
    ], "issuer");
    if (!this.issuer.equals(issuerCert.subjects[0])) return false;
    if (this.issuer.purposes && this.issuer.purposes.length > 0 && this.issuer.purposes.indexOf("ca") === -1) return false;
    return this.isSignedByKey(issuerCert.subjectKey);
};
Certificate.prototype.getExtension = function(keyOrOid) {
    assert.string(keyOrOid, "keyOrOid");
    var ext = this.getExtensions().filter(function(maybeExt) {
        if (maybeExt.format === "x509") return maybeExt.oid === keyOrOid;
        if (maybeExt.format === "openssh") return maybeExt.name === keyOrOid;
        return false;
    })[0];
    return ext;
};
Certificate.prototype.getExtensions = function() {
    var exts = [];
    var x509 = this.signatures.x509;
    if (x509 && x509.extras && x509.extras.exts) x509.extras.exts.forEach(function(ext) {
        ext.format = "x509";
        exts.push(ext);
    });
    var openssh = this.signatures.openssh;
    if (openssh && openssh.exts) openssh.exts.forEach(function(ext) {
        ext.format = "openssh";
        exts.push(ext);
    });
    return exts;
};
Certificate.prototype.isSignedByKey = function(issuerKey) {
    utils.assertCompatible(issuerKey, Key, [
        1,
        2
    ], "issuerKey");
    if (this.issuerKey !== undefined) return this.issuerKey.fingerprint("sha512").matches(issuerKey);
    var fmt = Object.keys(this.signatures)[0];
    var valid = formats[fmt].verify(this, issuerKey);
    if (valid) this.issuerKey = issuerKey;
    return valid;
};
Certificate.prototype.signWith = function(key) {
    utils.assertCompatible(key, PrivateKey, [
        1,
        2
    ], "key");
    var fmts = Object.keys(formats);
    var didOne = false;
    for(var i = 0; i < fmts.length; ++i)if (fmts[i] !== "pem") {
        var ret = formats[fmts[i]].sign(this, key);
        if (ret === true) didOne = true;
    }
    if (!didOne) throw new Error("Failed to sign the certificate for any available certificate formats");
};
Certificate.createSelfSigned = function(subjectOrSubjects, key, options) {
    var subjects;
    if (Array.isArray(subjectOrSubjects)) subjects = subjectOrSubjects;
    else subjects = [
        subjectOrSubjects
    ];
    assert.arrayOfObject(subjects);
    subjects.forEach(function(subject) {
        utils.assertCompatible(subject, Identity, [
            1,
            0
        ], "subject");
    });
    utils.assertCompatible(key, PrivateKey, [
        1,
        2
    ], "private key");
    assert.optionalObject(options, "options");
    if (options === undefined) options = {};
    assert.optionalObject(options.validFrom, "options.validFrom");
    assert.optionalObject(options.validUntil, "options.validUntil");
    var validFrom = options.validFrom;
    var validUntil = options.validUntil;
    if (validFrom === undefined) validFrom = new Date();
    if (validUntil === undefined) {
        assert.optionalNumber(options.lifetime, "options.lifetime");
        var lifetime = options.lifetime;
        if (lifetime === undefined) lifetime = 315360000;
        validUntil = new Date();
        validUntil.setTime(validUntil.getTime() + lifetime * 1000);
    }
    assert.optionalBuffer(options.serial, "options.serial");
    var serial = options.serial;
    if (serial === undefined) serial = Buffer.from("0000000000000001", "hex");
    var purposes = options.purposes;
    if (purposes === undefined) purposes = [];
    if (purposes.indexOf("signature") === -1) purposes.push("signature");
    /* Self-signed certs are always CAs. */ if (purposes.indexOf("ca") === -1) purposes.push("ca");
    if (purposes.indexOf("crl") === -1) purposes.push("crl");
    /*
	 * If we weren't explicitly given any other purposes, do the sensible
	 * thing and add some basic ones depending on the subject type.
	 */ if (purposes.length <= 3) {
        var hostSubjects = subjects.filter(function(subject) {
            return subject.type === "host";
        });
        var userSubjects = subjects.filter(function(subject) {
            return subject.type === "user";
        });
        if (hostSubjects.length > 0) {
            if (purposes.indexOf("serverAuth") === -1) purposes.push("serverAuth");
        }
        if (userSubjects.length > 0) {
            if (purposes.indexOf("clientAuth") === -1) purposes.push("clientAuth");
        }
        if (userSubjects.length > 0 || hostSubjects.length > 0) {
            if (purposes.indexOf("keyAgreement") === -1) purposes.push("keyAgreement");
            if (key.type === "rsa" && purposes.indexOf("encryption") === -1) purposes.push("encryption");
        }
    }
    var cert = new Certificate({
        subjects: subjects,
        issuer: subjects[0],
        subjectKey: key.toPublic(),
        issuerKey: key.toPublic(),
        signatures: {},
        serial: serial,
        validFrom: validFrom,
        validUntil: validUntil,
        purposes: purposes
    });
    cert.signWith(key);
    return cert;
};
Certificate.create = function(subjectOrSubjects, key, issuer, issuerKey, options) {
    var subjects;
    if (Array.isArray(subjectOrSubjects)) subjects = subjectOrSubjects;
    else subjects = [
        subjectOrSubjects
    ];
    assert.arrayOfObject(subjects);
    subjects.forEach(function(subject) {
        utils.assertCompatible(subject, Identity, [
            1,
            0
        ], "subject");
    });
    utils.assertCompatible(key, Key, [
        1,
        0
    ], "key");
    if (PrivateKey.isPrivateKey(key)) key = key.toPublic();
    utils.assertCompatible(issuer, Identity, [
        1,
        0
    ], "issuer");
    utils.assertCompatible(issuerKey, PrivateKey, [
        1,
        2
    ], "issuer key");
    assert.optionalObject(options, "options");
    if (options === undefined) options = {};
    assert.optionalObject(options.validFrom, "options.validFrom");
    assert.optionalObject(options.validUntil, "options.validUntil");
    var validFrom = options.validFrom;
    var validUntil = options.validUntil;
    if (validFrom === undefined) validFrom = new Date();
    if (validUntil === undefined) {
        assert.optionalNumber(options.lifetime, "options.lifetime");
        var lifetime = options.lifetime;
        if (lifetime === undefined) lifetime = 315360000;
        validUntil = new Date();
        validUntil.setTime(validUntil.getTime() + lifetime * 1000);
    }
    assert.optionalBuffer(options.serial, "options.serial");
    var serial = options.serial;
    if (serial === undefined) serial = Buffer.from("0000000000000001", "hex");
    var purposes = options.purposes;
    if (purposes === undefined) purposes = [];
    if (purposes.indexOf("signature") === -1) purposes.push("signature");
    if (options.ca === true) {
        if (purposes.indexOf("ca") === -1) purposes.push("ca");
        if (purposes.indexOf("crl") === -1) purposes.push("crl");
    }
    var hostSubjects = subjects.filter(function(subject) {
        return subject.type === "host";
    });
    var userSubjects = subjects.filter(function(subject) {
        return subject.type === "user";
    });
    if (hostSubjects.length > 0) {
        if (purposes.indexOf("serverAuth") === -1) purposes.push("serverAuth");
    }
    if (userSubjects.length > 0) {
        if (purposes.indexOf("clientAuth") === -1) purposes.push("clientAuth");
    }
    if (userSubjects.length > 0 || hostSubjects.length > 0) {
        if (purposes.indexOf("keyAgreement") === -1) purposes.push("keyAgreement");
        if (key.type === "rsa" && purposes.indexOf("encryption") === -1) purposes.push("encryption");
    }
    var cert = new Certificate({
        subjects: subjects,
        issuer: issuer,
        subjectKey: key,
        issuerKey: issuerKey.toPublic(),
        signatures: {},
        serial: serial,
        validFrom: validFrom,
        validUntil: validUntil,
        purposes: purposes
    });
    cert.signWith(issuerKey);
    return cert;
};
Certificate.parse = function(data, format, options) {
    if (typeof data !== "string") assert.buffer(data, "data");
    if (format === undefined) format = "auto";
    assert.string(format, "format");
    if (typeof options === "string") options = {
        filename: options
    };
    assert.optionalObject(options, "options");
    if (options === undefined) options = {};
    assert.optionalString(options.filename, "options.filename");
    if (options.filename === undefined) options.filename = "(unnamed)";
    assert.object(formats[format], "formats[format]");
    try {
        var k = formats[format].read(data, options);
        return k;
    } catch (e) {
        throw new CertificateParseError(options.filename, format, e);
    }
};
Certificate.isCertificate = function(obj, ver) {
    return utils.isCompatible(obj, Certificate, ver);
};
/*
 * API versions for Certificate:
 * [1,0] -- initial ver
 * [1,1] -- openssh format now unpacks extensions
 */ Certificate.prototype._sshpkApiVersion = [
    1,
    1
];
Certificate._oldVersionDetect = function(obj) {
    return [
        1,
        0
    ];
};

},{"d17a5e77a411be99":"eQsu4","1cca840dc65d765b":"b2XZ0","56b8a4f650a5e653":"23cSW","a99b7dfab4c821ed":"8Nkdo","f22dde5fb3da5a91":"lKsIK","2c6e5e0120dd0864":"cxjr0","5d76099d392e58ff":"6DKEY","46eac9e6ef7f26f1":"dJawj","51d67a4c58b6adfd":"icPN2","f630a73b41bf7166":"fAyE1","4efedf6c60c9d1d6":"4674F","83e221f4172c4ec2":"3JOrI","fd53a608520111b5":"7THsn","de82cbae59487584":"9lYE8","c6314fc06fffc851":"ci4qT"}],"3JOrI":[function(require,module,exports) {
// Copyright 2017 Joyent, Inc.
module.exports = Identity;
var assert = require("59e4814a75a95fd4");
var algs = require("11b03bc1894e10ce");
var crypto = require("69eb347b56cb7263");
var Fingerprint = require("54e8c32e5035aa5");
var Signature = require("8267848f4466b412");
var errs = require("b1bc0432eecce83a");
var util = require("733ef4c5c2728b11");
var utils = require("b783d03684ba2800");
var asn1 = require("e1f72356f069f776");
var Buffer = require("50cffd0932ce98e3").Buffer;
/*JSSTYLED*/ var DNS_NAME_RE = /^([*]|[a-z0-9][a-z0-9\-]{0,62})(?:\.([*]|[a-z0-9][a-z0-9\-]{0,62}))*$/i;
var oids = {};
oids.cn = "2.5.4.3";
oids.o = "2.5.4.10";
oids.ou = "2.5.4.11";
oids.l = "2.5.4.7";
oids.s = "2.5.4.8";
oids.c = "2.5.4.6";
oids.sn = "2.5.4.4";
oids.postalCode = "2.5.4.17";
oids.serialNumber = "2.5.4.5";
oids.street = "2.5.4.9";
oids.x500UniqueIdentifier = "2.5.4.45";
oids.role = "2.5.4.72";
oids.telephoneNumber = "2.5.4.20";
oids.description = "2.5.4.13";
oids.dc = "0.9.2342.19200300.100.1.25";
oids.uid = "0.9.2342.19200300.100.1.1";
oids.mail = "0.9.2342.19200300.100.1.3";
oids.title = "2.5.4.12";
oids.gn = "2.5.4.42";
oids.initials = "2.5.4.43";
oids.pseudonym = "2.5.4.65";
oids.emailAddress = "1.2.840.113549.1.9.1";
var unoids = {};
Object.keys(oids).forEach(function(k) {
    unoids[oids[k]] = k;
});
function Identity(opts) {
    var self = this;
    assert.object(opts, "options");
    assert.arrayOfObject(opts.components, "options.components");
    this.components = opts.components;
    this.componentLookup = {};
    this.components.forEach(function(c) {
        if (c.name && !c.oid) c.oid = oids[c.name];
        if (c.oid && !c.name) c.name = unoids[c.oid];
        if (self.componentLookup[c.name] === undefined) self.componentLookup[c.name] = [];
        self.componentLookup[c.name].push(c);
    });
    if (this.componentLookup.cn && this.componentLookup.cn.length > 0) this.cn = this.componentLookup.cn[0].value;
    assert.optionalString(opts.type, "options.type");
    if (opts.type === undefined) {
        if (this.components.length === 1 && this.componentLookup.cn && this.componentLookup.cn.length === 1 && this.componentLookup.cn[0].value.match(DNS_NAME_RE)) {
            this.type = "host";
            this.hostname = this.componentLookup.cn[0].value;
        } else if (this.componentLookup.dc && this.components.length === this.componentLookup.dc.length) {
            this.type = "host";
            this.hostname = this.componentLookup.dc.map(function(c) {
                return c.value;
            }).join(".");
        } else if (this.componentLookup.uid && this.components.length === this.componentLookup.uid.length) {
            this.type = "user";
            this.uid = this.componentLookup.uid[0].value;
        } else if (this.componentLookup.cn && this.componentLookup.cn.length === 1 && this.componentLookup.cn[0].value.match(DNS_NAME_RE)) {
            this.type = "host";
            this.hostname = this.componentLookup.cn[0].value;
        } else if (this.componentLookup.uid && this.componentLookup.uid.length === 1) {
            this.type = "user";
            this.uid = this.componentLookup.uid[0].value;
        } else if (this.componentLookup.mail && this.componentLookup.mail.length === 1) {
            this.type = "email";
            this.email = this.componentLookup.mail[0].value;
        } else if (this.componentLookup.cn && this.componentLookup.cn.length === 1) {
            this.type = "user";
            this.uid = this.componentLookup.cn[0].value;
        } else this.type = "unknown";
    } else {
        this.type = opts.type;
        if (this.type === "host") this.hostname = opts.hostname;
        else if (this.type === "user") this.uid = opts.uid;
        else if (this.type === "email") this.email = opts.email;
        else throw new Error("Unknown type " + this.type);
    }
}
Identity.prototype.toString = function() {
    return this.components.map(function(c) {
        var n = c.name.toUpperCase();
        /*JSSTYLED*/ n = n.replace(/=/g, "\\=");
        var v = c.value;
        /*JSSTYLED*/ v = v.replace(/,/g, "\\,");
        return n + "=" + v;
    }).join(", ");
};
Identity.prototype.get = function(name, asArray) {
    assert.string(name, "name");
    var arr = this.componentLookup[name];
    if (arr === undefined || arr.length === 0) return undefined;
    if (!asArray && arr.length > 1) throw new Error("Multiple values for attribute " + name);
    if (!asArray) return arr[0].value;
    return arr.map(function(c) {
        return c.value;
    });
};
Identity.prototype.toArray = function(idx) {
    return this.components.map(function(c) {
        return {
            name: c.name,
            value: c.value
        };
    });
};
/*
 * These are from X.680 -- PrintableString allowed chars are in section 37.4
 * table 8. Spec for IA5Strings is "1,6 + SPACE + DEL" where 1 refers to
 * ISO IR #001 (standard ASCII control characters) and 6 refers to ISO IR #006
 * (the basic ASCII character set).
 */ /* JSSTYLED */ var NOT_PRINTABLE = /[^a-zA-Z0-9 '(),+.\/:=?-]/;
/* JSSTYLED */ var NOT_IA5 = /[^\x00-\x7f]/;
Identity.prototype.toAsn1 = function(der, tag) {
    der.startSequence(tag);
    this.components.forEach(function(c) {
        der.startSequence(asn1.Ber.Constructor | asn1.Ber.Set);
        der.startSequence();
        der.writeOID(c.oid);
        /*
		 * If we fit in a PrintableString, use that. Otherwise use an
		 * IA5String or UTF8String.
		 *
		 * If this identity was parsed from a DN, use the ASN.1 types
		 * from the original representation (otherwise this might not
		 * be a full match for the original in some validators).
		 */ if (c.asn1type === asn1.Ber.Utf8String || c.value.match(NOT_IA5)) {
            var v = Buffer.from(c.value, "utf8");
            der.writeBuffer(v, asn1.Ber.Utf8String);
        } else if (c.asn1type === asn1.Ber.IA5String || c.value.match(NOT_PRINTABLE)) der.writeString(c.value, asn1.Ber.IA5String);
        else {
            var type = asn1.Ber.PrintableString;
            if (c.asn1type !== undefined) type = c.asn1type;
            der.writeString(c.value, type);
        }
        der.endSequence();
        der.endSequence();
    });
    der.endSequence();
};
function globMatch(a, b) {
    if (a === "**" || b === "**") return true;
    var aParts = a.split(".");
    var bParts = b.split(".");
    if (aParts.length !== bParts.length) return false;
    for(var i = 0; i < aParts.length; ++i){
        if (aParts[i] === "*" || bParts[i] === "*") continue;
        if (aParts[i] !== bParts[i]) return false;
    }
    return true;
}
Identity.prototype.equals = function(other) {
    if (!Identity.isIdentity(other, [
        1,
        0
    ])) return false;
    if (other.components.length !== this.components.length) return false;
    for(var i = 0; i < this.components.length; ++i){
        if (this.components[i].oid !== other.components[i].oid) return false;
        if (!globMatch(this.components[i].value, other.components[i].value)) return false;
    }
    return true;
};
Identity.forHost = function(hostname) {
    assert.string(hostname, "hostname");
    return new Identity({
        type: "host",
        hostname: hostname,
        components: [
            {
                name: "cn",
                value: hostname
            }
        ]
    });
};
Identity.forUser = function(uid) {
    assert.string(uid, "uid");
    return new Identity({
        type: "user",
        uid: uid,
        components: [
            {
                name: "uid",
                value: uid
            }
        ]
    });
};
Identity.forEmail = function(email) {
    assert.string(email, "email");
    return new Identity({
        type: "email",
        email: email,
        components: [
            {
                name: "mail",
                value: email
            }
        ]
    });
};
Identity.parseDN = function(dn) {
    assert.string(dn, "dn");
    var parts = [
        ""
    ];
    var idx = 0;
    var rem = dn;
    while(rem.length > 0){
        var m;
        /*JSSTYLED*/ if ((m = /^,/.exec(rem)) !== null) {
            parts[++idx] = "";
            rem = rem.slice(m[0].length);
        /*JSSTYLED*/ } else if ((m = /^\\,/.exec(rem)) !== null) {
            parts[idx] += ",";
            rem = rem.slice(m[0].length);
        /*JSSTYLED*/ } else if ((m = /^\\./.exec(rem)) !== null) {
            parts[idx] += m[0];
            rem = rem.slice(m[0].length);
        /*JSSTYLED*/ } else if ((m = /^[^\\,]+/.exec(rem)) !== null) {
            parts[idx] += m[0];
            rem = rem.slice(m[0].length);
        } else throw new Error("Failed to parse DN");
    }
    var cmps = parts.map(function(c) {
        c = c.trim();
        var eqPos = c.indexOf("=");
        while(eqPos > 0 && c.charAt(eqPos - 1) === "\\")eqPos = c.indexOf("=", eqPos + 1);
        if (eqPos === -1) throw new Error("Failed to parse DN");
        /*JSSTYLED*/ var name = c.slice(0, eqPos).toLowerCase().replace(/\\=/g, "=");
        var value = c.slice(eqPos + 1);
        return {
            name: name,
            value: value
        };
    });
    return new Identity({
        components: cmps
    });
};
Identity.fromArray = function(components) {
    assert.arrayOfObject(components, "components");
    components.forEach(function(cmp) {
        assert.object(cmp, "component");
        assert.string(cmp.name, "component.name");
        if (!Buffer.isBuffer(cmp.value) && !(typeof cmp.value === "string")) throw new Error("Invalid component value");
    });
    return new Identity({
        components: components
    });
};
Identity.parseAsn1 = function(der, top) {
    var components = [];
    der.readSequence(top);
    var end = der.offset + der.length;
    while(der.offset < end){
        der.readSequence(asn1.Ber.Constructor | asn1.Ber.Set);
        var after = der.offset + der.length;
        der.readSequence();
        var oid = der.readOID();
        var type = der.peek();
        var value;
        switch(type){
            case asn1.Ber.PrintableString:
            case asn1.Ber.IA5String:
            case asn1.Ber.OctetString:
            case asn1.Ber.T61String:
                value = der.readString(type);
                break;
            case asn1.Ber.Utf8String:
                value = der.readString(type, true);
                value = value.toString("utf8");
                break;
            case asn1.Ber.CharacterString:
            case asn1.Ber.BMPString:
                value = der.readString(type, true);
                value = value.toString("utf16le");
                break;
            default:
                throw new Error("Unknown asn1 type " + type);
        }
        components.push({
            oid: oid,
            asn1type: type,
            value: value
        });
        der._offset = after;
    }
    der._offset = end;
    return new Identity({
        components: components
    });
};
Identity.isIdentity = function(obj, ver) {
    return utils.isCompatible(obj, Identity, ver);
};
/*
 * API versions for Identity:
 * [1,0] -- initial ver
 */ Identity.prototype._sshpkApiVersion = [
    1,
    0
];
Identity._oldVersionDetect = function(obj) {
    return [
        1,
        0
    ];
};

},{"59e4814a75a95fd4":"eQsu4","11b03bc1894e10ce":"23cSW","69eb347b56cb7263":"8Nkdo","54e8c32e5035aa5":"lKsIK","8267848f4466b412":"cxjr0","b1bc0432eecce83a":"6DKEY","733ef4c5c2728b11":"dJawj","b783d03684ba2800":"icPN2","e1f72356f069f776":"jC0hS","50cffd0932ce98e3":"b2XZ0"}],"7THsn":[function(require,module,exports) {
// Copyright 2017 Joyent, Inc.
module.exports = {
    read: read,
    verify: verify,
    sign: sign,
    signAsync: signAsync,
    write: write,
    /* Internal private API */ fromBuffer: fromBuffer,
    toBuffer: toBuffer
};
var assert = require("cf876307c6375a8d");
var SSHBuffer = require("a7d2d91353b7848d");
var crypto = require("e75fa43e8e807d4d");
var Buffer = require("84968f78c783fef4").Buffer;
var algs = require("870c3103b0f63c54");
var Key = require("cc33462e804afcea");
var PrivateKey = require("59be5d9a1af31aff");
var Identity = require("9d5342eae2354c79");
var rfc4253 = require("c5ed79d84f18abe1");
var Signature = require("2710dbd92ef7467e");
var utils = require("1e4bc68fc9d8cbf");
var Certificate = require("ca4d30beeeea3efb");
function verify(cert, key) {
    /*
	 * We always give an issuerKey, so if our verify() is being called then
	 * there was no signature. Return false.
	 */ return false;
}
var TYPES = {
    "user": 1,
    "host": 2
};
Object.keys(TYPES).forEach(function(k) {
    TYPES[TYPES[k]] = k;
});
var ECDSA_ALGO = /^ecdsa-sha2-([^@-]+)-cert-v01@openssh.com$/;
function read(buf, options) {
    if (Buffer.isBuffer(buf)) buf = buf.toString("ascii");
    var parts = buf.trim().split(/[ \t\n]+/g);
    if (parts.length < 2 || parts.length > 3) throw new Error("Not a valid SSH certificate line");
    var algo = parts[0];
    var data = parts[1];
    data = Buffer.from(data, "base64");
    return fromBuffer(data, algo);
}
function fromBuffer(data, algo, partial) {
    var sshbuf = new SSHBuffer({
        buffer: data
    });
    var innerAlgo = sshbuf.readString();
    if (algo !== undefined && innerAlgo !== algo) throw new Error("SSH certificate algorithm mismatch");
    if (algo === undefined) algo = innerAlgo;
    var cert = {};
    cert.signatures = {};
    cert.signatures.openssh = {};
    cert.signatures.openssh.nonce = sshbuf.readBuffer();
    var key = {};
    var parts = key.parts = [];
    key.type = getAlg(algo);
    var partCount = algs.info[key.type].parts.length;
    while(parts.length < partCount)parts.push(sshbuf.readPart());
    assert.ok(parts.length >= 1, "key must have at least one part");
    var algInfo = algs.info[key.type];
    if (key.type === "ecdsa") {
        var res = ECDSA_ALGO.exec(algo);
        assert.ok(res !== null);
        assert.strictEqual(res[1], parts[0].data.toString());
    }
    for(var i = 0; i < algInfo.parts.length; ++i){
        parts[i].name = algInfo.parts[i];
        if (parts[i].name !== "curve" && algInfo.normalize !== false) {
            var p = parts[i];
            p.data = utils.mpNormalize(p.data);
        }
    }
    cert.subjectKey = new Key(key);
    cert.serial = sshbuf.readInt64();
    var type = TYPES[sshbuf.readInt()];
    assert.string(type, "valid cert type");
    cert.signatures.openssh.keyId = sshbuf.readString();
    var principals = [];
    var pbuf = sshbuf.readBuffer();
    var psshbuf = new SSHBuffer({
        buffer: pbuf
    });
    while(!psshbuf.atEnd())principals.push(psshbuf.readString());
    if (principals.length === 0) principals = [
        "*"
    ];
    cert.subjects = principals.map(function(pr) {
        if (type === "user") return Identity.forUser(pr);
        else if (type === "host") return Identity.forHost(pr);
        throw new Error("Unknown identity type " + type);
    });
    cert.validFrom = int64ToDate(sshbuf.readInt64());
    cert.validUntil = int64ToDate(sshbuf.readInt64());
    var exts = [];
    var extbuf = new SSHBuffer({
        buffer: sshbuf.readBuffer()
    });
    var ext;
    while(!extbuf.atEnd()){
        ext = {
            critical: true
        };
        ext.name = extbuf.readString();
        ext.data = extbuf.readBuffer();
        exts.push(ext);
    }
    extbuf = new SSHBuffer({
        buffer: sshbuf.readBuffer()
    });
    while(!extbuf.atEnd()){
        ext = {
            critical: false
        };
        ext.name = extbuf.readString();
        ext.data = extbuf.readBuffer();
        exts.push(ext);
    }
    cert.signatures.openssh.exts = exts;
    /* reserved */ sshbuf.readBuffer();
    var signingKeyBuf = sshbuf.readBuffer();
    cert.issuerKey = rfc4253.read(signingKeyBuf);
    /*
	 * OpenSSH certs don't give the identity of the issuer, just their
	 * public key. So, we use an Identity that matches anything. The
	 * isSignedBy() function will later tell you if the key matches.
	 */ cert.issuer = Identity.forHost("**");
    var sigBuf = sshbuf.readBuffer();
    cert.signatures.openssh.signature = Signature.parse(sigBuf, cert.issuerKey.type, "ssh");
    if (partial !== undefined) {
        partial.remainder = sshbuf.remainder();
        partial.consumed = sshbuf._offset;
    }
    return new Certificate(cert);
}
function int64ToDate(buf) {
    var i = buf.readUInt32BE(0) * 4294967296;
    i += buf.readUInt32BE(4);
    var d = new Date();
    d.setTime(i * 1000);
    d.sourceInt64 = buf;
    return d;
}
function dateToInt64(date) {
    if (date.sourceInt64 !== undefined) return date.sourceInt64;
    var i = Math.round(date.getTime() / 1000);
    var upper = Math.floor(i / 4294967296);
    var lower = Math.floor(i % 4294967296);
    var buf = Buffer.alloc(8);
    buf.writeUInt32BE(upper, 0);
    buf.writeUInt32BE(lower, 4);
    return buf;
}
function sign(cert, key) {
    if (cert.signatures.openssh === undefined) cert.signatures.openssh = {};
    try {
        var blob = toBuffer(cert, true);
    } catch (e) {
        delete cert.signatures.openssh;
        return false;
    }
    var sig = cert.signatures.openssh;
    var hashAlgo = undefined;
    if (key.type === "rsa" || key.type === "dsa") hashAlgo = "sha1";
    var signer = key.createSign(hashAlgo);
    signer.write(blob);
    sig.signature = signer.sign();
    return true;
}
function signAsync(cert, signer, done) {
    if (cert.signatures.openssh === undefined) cert.signatures.openssh = {};
    try {
        var blob = toBuffer(cert, true);
    } catch (e) {
        delete cert.signatures.openssh;
        done(e);
        return;
    }
    var sig = cert.signatures.openssh;
    signer(blob, function(err, signature) {
        if (err) {
            done(err);
            return;
        }
        try {
            /*
			 * This will throw if the signature isn't of a
			 * type/algo that can be used for SSH.
			 */ signature.toBuffer("ssh");
        } catch (e) {
            done(e);
            return;
        }
        sig.signature = signature;
        done();
    });
}
function write(cert, options) {
    if (options === undefined) options = {};
    var blob = toBuffer(cert);
    var out = getCertType(cert.subjectKey) + " " + blob.toString("base64");
    if (options.comment) out = out + " " + options.comment;
    return out;
}
function toBuffer(cert, noSig) {
    assert.object(cert.signatures.openssh, "signature for openssh format");
    var sig = cert.signatures.openssh;
    if (sig.nonce === undefined) sig.nonce = crypto.randomBytes(16);
    var buf = new SSHBuffer({});
    buf.writeString(getCertType(cert.subjectKey));
    buf.writeBuffer(sig.nonce);
    var key = cert.subjectKey;
    var algInfo = algs.info[key.type];
    algInfo.parts.forEach(function(part) {
        buf.writePart(key.part[part]);
    });
    buf.writeInt64(cert.serial);
    var type = cert.subjects[0].type;
    assert.notStrictEqual(type, "unknown");
    cert.subjects.forEach(function(id) {
        assert.strictEqual(id.type, type);
    });
    type = TYPES[type];
    buf.writeInt(type);
    if (sig.keyId === undefined) sig.keyId = cert.subjects[0].type + "_" + (cert.subjects[0].uid || cert.subjects[0].hostname);
    buf.writeString(sig.keyId);
    var sub = new SSHBuffer({});
    cert.subjects.forEach(function(id) {
        if (type === TYPES.host) sub.writeString(id.hostname);
        else if (type === TYPES.user) sub.writeString(id.uid);
    });
    buf.writeBuffer(sub.toBuffer());
    buf.writeInt64(dateToInt64(cert.validFrom));
    buf.writeInt64(dateToInt64(cert.validUntil));
    var exts = sig.exts;
    if (exts === undefined) exts = [];
    var extbuf = new SSHBuffer({});
    exts.forEach(function(ext) {
        if (ext.critical !== true) return;
        extbuf.writeString(ext.name);
        extbuf.writeBuffer(ext.data);
    });
    buf.writeBuffer(extbuf.toBuffer());
    extbuf = new SSHBuffer({});
    exts.forEach(function(ext) {
        if (ext.critical === true) return;
        extbuf.writeString(ext.name);
        extbuf.writeBuffer(ext.data);
    });
    buf.writeBuffer(extbuf.toBuffer());
    /* reserved */ buf.writeBuffer(Buffer.alloc(0));
    sub = rfc4253.write(cert.issuerKey);
    buf.writeBuffer(sub);
    if (!noSig) buf.writeBuffer(sig.signature.toBuffer("ssh"));
    return buf.toBuffer();
}
function getAlg(certType) {
    if (certType === "ssh-rsa-cert-v01@openssh.com") return "rsa";
    if (certType === "ssh-dss-cert-v01@openssh.com") return "dsa";
    if (certType.match(ECDSA_ALGO)) return "ecdsa";
    if (certType === "ssh-ed25519-cert-v01@openssh.com") return "ed25519";
    throw new Error("Unsupported cert type " + certType);
}
function getCertType(key) {
    if (key.type === "rsa") return "ssh-rsa-cert-v01@openssh.com";
    if (key.type === "dsa") return "ssh-dss-cert-v01@openssh.com";
    if (key.type === "ecdsa") return "ecdsa-sha2-" + key.curve + "-cert-v01@openssh.com";
    if (key.type === "ed25519") return "ssh-ed25519-cert-v01@openssh.com";
    throw new Error("Unsupported key type " + key.type);
}

},{"cf876307c6375a8d":"eQsu4","a7d2d91353b7848d":"OXMVy","e75fa43e8e807d4d":"8Nkdo","84968f78c783fef4":"b2XZ0","870c3103b0f63c54":"23cSW","cc33462e804afcea":"fAyE1","59be5d9a1af31aff":"4674F","9d5342eae2354c79":"3JOrI","c5ed79d84f18abe1":"btAO6","2710dbd92ef7467e":"cxjr0","1e4bc68fc9d8cbf":"icPN2","ca4d30beeeea3efb":"4Zfxv"}],"9lYE8":[function(require,module,exports) {
// Copyright 2017 Joyent, Inc.
module.exports = {
    read: read,
    verify: verify,
    sign: sign,
    signAsync: signAsync,
    write: write
};
var assert = require("9286d09143be2e60");
var asn1 = require("8804c58c4b2b1744");
var Buffer = require("71e8daa341cc1b6c").Buffer;
var algs = require("842106490b9da495");
var utils = require("54d258a601f2ea11");
var Key = require("2243d96a438a9b12");
var PrivateKey = require("3e004ce551ded4e8");
var pem = require("6d5e2d4a836eeac8");
var Identity = require("d4bc39190d67accf");
var Signature = require("acaa846b333b1ef4");
var Certificate = require("d2b79a0e1f186a1e");
var pkcs8 = require("6cd56e5c28487784");
/*
 * This file is based on RFC5280 (X.509).
 */ /* Helper to read in a single mpint */ function readMPInt(der, nm) {
    assert.strictEqual(der.peek(), asn1.Ber.Integer, nm + " is not an Integer");
    return utils.mpNormalize(der.readString(asn1.Ber.Integer, true));
}
function verify(cert, key) {
    var sig = cert.signatures.x509;
    assert.object(sig, "x509 signature");
    var algParts = sig.algo.split("-");
    if (algParts[0] !== key.type) return false;
    var blob = sig.cache;
    if (blob === undefined) {
        var der = new asn1.BerWriter();
        writeTBSCert(cert, der);
        blob = der.buffer;
    }
    var verifier = key.createVerify(algParts[1]);
    verifier.write(blob);
    return verifier.verify(sig.signature);
}
function Local(i) {
    return asn1.Ber.Context | asn1.Ber.Constructor | i;
}
function Context(i) {
    return asn1.Ber.Context | i;
}
var SIGN_ALGS = {
    "rsa-md5": "1.2.840.113549.1.1.4",
    "rsa-sha1": "1.2.840.113549.1.1.5",
    "rsa-sha256": "1.2.840.113549.1.1.11",
    "rsa-sha384": "1.2.840.113549.1.1.12",
    "rsa-sha512": "1.2.840.113549.1.1.13",
    "dsa-sha1": "1.2.840.10040.4.3",
    "dsa-sha256": "2.16.840.1.101.3.4.3.2",
    "ecdsa-sha1": "1.2.840.10045.4.1",
    "ecdsa-sha256": "1.2.840.10045.4.3.2",
    "ecdsa-sha384": "1.2.840.10045.4.3.3",
    "ecdsa-sha512": "1.2.840.10045.4.3.4",
    "ed25519-sha512": "1.3.101.112"
};
Object.keys(SIGN_ALGS).forEach(function(k) {
    SIGN_ALGS[SIGN_ALGS[k]] = k;
});
SIGN_ALGS["1.3.14.3.2.3"] = "rsa-md5";
SIGN_ALGS["1.3.14.3.2.29"] = "rsa-sha1";
var EXTS = {
    "issuerKeyId": "2.5.29.35",
    "altName": "2.5.29.17",
    "basicConstraints": "2.5.29.19",
    "keyUsage": "2.5.29.15",
    "extKeyUsage": "2.5.29.37"
};
function read(buf, options) {
    if (typeof buf === "string") buf = Buffer.from(buf, "binary");
    assert.buffer(buf, "buf");
    var der = new asn1.BerReader(buf);
    der.readSequence();
    if (Math.abs(der.length - der.remain) > 1) throw new Error("DER sequence does not contain whole byte stream");
    var tbsStart = der.offset;
    der.readSequence();
    var sigOffset = der.offset + der.length;
    var tbsEnd = sigOffset;
    if (der.peek() === Local(0)) {
        der.readSequence(Local(0));
        var version = der.readInt();
        assert.ok(version <= 3, "only x.509 versions up to v3 supported");
    }
    var cert = {};
    cert.signatures = {};
    var sig = cert.signatures.x509 = {};
    sig.extras = {};
    cert.serial = readMPInt(der, "serial");
    der.readSequence();
    var after = der.offset + der.length;
    var certAlgOid = der.readOID();
    var certAlg = SIGN_ALGS[certAlgOid];
    if (certAlg === undefined) throw new Error("unknown signature algorithm " + certAlgOid);
    der._offset = after;
    cert.issuer = Identity.parseAsn1(der);
    der.readSequence();
    cert.validFrom = readDate(der);
    cert.validUntil = readDate(der);
    cert.subjects = [
        Identity.parseAsn1(der)
    ];
    der.readSequence();
    after = der.offset + der.length;
    cert.subjectKey = pkcs8.readPkcs8(undefined, "public", der);
    der._offset = after;
    /* issuerUniqueID */ if (der.peek() === Local(1)) {
        der.readSequence(Local(1));
        sig.extras.issuerUniqueID = buf.slice(der.offset, der.offset + der.length);
        der._offset += der.length;
    }
    /* subjectUniqueID */ if (der.peek() === Local(2)) {
        der.readSequence(Local(2));
        sig.extras.subjectUniqueID = buf.slice(der.offset, der.offset + der.length);
        der._offset += der.length;
    }
    /* extensions */ if (der.peek() === Local(3)) {
        der.readSequence(Local(3));
        var extEnd = der.offset + der.length;
        der.readSequence();
        while(der.offset < extEnd)readExtension(cert, buf, der);
        assert.strictEqual(der.offset, extEnd);
    }
    assert.strictEqual(der.offset, sigOffset);
    der.readSequence();
    after = der.offset + der.length;
    var sigAlgOid = der.readOID();
    var sigAlg = SIGN_ALGS[sigAlgOid];
    if (sigAlg === undefined) throw new Error("unknown signature algorithm " + sigAlgOid);
    der._offset = after;
    var sigData = der.readString(asn1.Ber.BitString, true);
    if (sigData[0] === 0) sigData = sigData.slice(1);
    var algParts = sigAlg.split("-");
    sig.signature = Signature.parse(sigData, algParts[0], "asn1");
    sig.signature.hashAlgorithm = algParts[1];
    sig.algo = sigAlg;
    sig.cache = buf.slice(tbsStart, tbsEnd);
    return new Certificate(cert);
}
function readDate(der) {
    if (der.peek() === asn1.Ber.UTCTime) return utcTimeToDate(der.readString(asn1.Ber.UTCTime));
    else if (der.peek() === asn1.Ber.GeneralizedTime) return gTimeToDate(der.readString(asn1.Ber.GeneralizedTime));
    else throw new Error("Unsupported date format");
}
function writeDate(der, date) {
    if (date.getUTCFullYear() >= 2050 || date.getUTCFullYear() < 1950) der.writeString(dateToGTime(date), asn1.Ber.GeneralizedTime);
    else der.writeString(dateToUTCTime(date), asn1.Ber.UTCTime);
}
/* RFC5280, section 4.2.1.6 (GeneralName type) */ var ALTNAME = {
    OtherName: Local(0),
    RFC822Name: Context(1),
    DNSName: Context(2),
    X400Address: Local(3),
    DirectoryName: Local(4),
    EDIPartyName: Local(5),
    URI: Context(6),
    IPAddress: Context(7),
    OID: Context(8)
};
/* RFC5280, section 4.2.1.12 (KeyPurposeId) */ var EXTPURPOSE = {
    "serverAuth": "1.3.6.1.5.5.7.3.1",
    "clientAuth": "1.3.6.1.5.5.7.3.2",
    "codeSigning": "1.3.6.1.5.5.7.3.3",
    /* See https://github.com/joyent/oid-docs/blob/master/root.md */ "joyentDocker": "1.3.6.1.4.1.38678.1.4.1",
    "joyentCmon": "1.3.6.1.4.1.38678.1.4.2"
};
var EXTPURPOSE_REV = {};
Object.keys(EXTPURPOSE).forEach(function(k) {
    EXTPURPOSE_REV[EXTPURPOSE[k]] = k;
});
var KEYUSEBITS = [
    "signature",
    "identity",
    "keyEncryption",
    "encryption",
    "keyAgreement",
    "ca",
    "crl"
];
function readExtension(cert, buf, der) {
    der.readSequence();
    var after = der.offset + der.length;
    var extId = der.readOID();
    var id;
    var sig = cert.signatures.x509;
    if (!sig.extras.exts) sig.extras.exts = [];
    var critical;
    if (der.peek() === asn1.Ber.Boolean) critical = der.readBoolean();
    switch(extId){
        case EXTS.basicConstraints:
            der.readSequence(asn1.Ber.OctetString);
            der.readSequence();
            var bcEnd = der.offset + der.length;
            var ca = false;
            if (der.peek() === asn1.Ber.Boolean) ca = der.readBoolean();
            if (cert.purposes === undefined) cert.purposes = [];
            if (ca === true) cert.purposes.push("ca");
            var bc = {
                oid: extId,
                critical: critical
            };
            if (der.offset < bcEnd && der.peek() === asn1.Ber.Integer) bc.pathLen = der.readInt();
            sig.extras.exts.push(bc);
            break;
        case EXTS.extKeyUsage:
            der.readSequence(asn1.Ber.OctetString);
            der.readSequence();
            if (cert.purposes === undefined) cert.purposes = [];
            var ekEnd = der.offset + der.length;
            while(der.offset < ekEnd){
                var oid = der.readOID();
                cert.purposes.push(EXTPURPOSE_REV[oid] || oid);
            }
            /*
		 * This is a bit of a hack: in the case where we have a cert
		 * that's only allowed to do serverAuth or clientAuth (and not
		 * the other), we want to make sure all our Subjects are of
		 * the right type. But we already parsed our Subjects and
		 * decided if they were hosts or users earlier (since it appears
		 * first in the cert).
		 *
		 * So we go through and mutate them into the right kind here if
		 * it doesn't match. This might not be hugely beneficial, as it
		 * seems that single-purpose certs are not often seen in the
		 * wild.
		 */ if (cert.purposes.indexOf("serverAuth") !== -1 && cert.purposes.indexOf("clientAuth") === -1) cert.subjects.forEach(function(ide) {
                if (ide.type !== "host") {
                    ide.type = "host";
                    ide.hostname = ide.uid || ide.email || ide.components[0].value;
                }
            });
            else if (cert.purposes.indexOf("clientAuth") !== -1 && cert.purposes.indexOf("serverAuth") === -1) cert.subjects.forEach(function(ide) {
                if (ide.type !== "user") {
                    ide.type = "user";
                    ide.uid = ide.hostname || ide.email || ide.components[0].value;
                }
            });
            sig.extras.exts.push({
                oid: extId,
                critical: critical
            });
            break;
        case EXTS.keyUsage:
            der.readSequence(asn1.Ber.OctetString);
            var bits = der.readString(asn1.Ber.BitString, true);
            var setBits = readBitField(bits, KEYUSEBITS);
            setBits.forEach(function(bit) {
                if (cert.purposes === undefined) cert.purposes = [];
                if (cert.purposes.indexOf(bit) === -1) cert.purposes.push(bit);
            });
            sig.extras.exts.push({
                oid: extId,
                critical: critical,
                bits: bits
            });
            break;
        case EXTS.altName:
            der.readSequence(asn1.Ber.OctetString);
            der.readSequence();
            var aeEnd = der.offset + der.length;
            while(der.offset < aeEnd)switch(der.peek()){
                case ALTNAME.OtherName:
                case ALTNAME.EDIPartyName:
                    der.readSequence();
                    der._offset += der.length;
                    break;
                case ALTNAME.OID:
                    der.readOID(ALTNAME.OID);
                    break;
                case ALTNAME.RFC822Name:
                    /* RFC822 specifies email addresses */ var email = der.readString(ALTNAME.RFC822Name);
                    id = Identity.forEmail(email);
                    if (!cert.subjects[0].equals(id)) cert.subjects.push(id);
                    break;
                case ALTNAME.DirectoryName:
                    der.readSequence(ALTNAME.DirectoryName);
                    id = Identity.parseAsn1(der);
                    if (!cert.subjects[0].equals(id)) cert.subjects.push(id);
                    break;
                case ALTNAME.DNSName:
                    var host = der.readString(ALTNAME.DNSName);
                    id = Identity.forHost(host);
                    if (!cert.subjects[0].equals(id)) cert.subjects.push(id);
                    break;
                default:
                    der.readString(der.peek());
                    break;
            }
            sig.extras.exts.push({
                oid: extId,
                critical: critical
            });
            break;
        default:
            sig.extras.exts.push({
                oid: extId,
                critical: critical,
                data: der.readString(asn1.Ber.OctetString, true)
            });
            break;
    }
    der._offset = after;
}
var UTCTIME_RE = /^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})?Z$/;
function utcTimeToDate(t) {
    var m = t.match(UTCTIME_RE);
    assert.ok(m, "timestamps must be in UTC");
    var d = new Date();
    var thisYear = d.getUTCFullYear();
    var century = Math.floor(thisYear / 100) * 100;
    var year = parseInt(m[1], 10);
    if (thisYear % 100 < 50 && year >= 60) year += century - 1;
    else year += century;
    d.setUTCFullYear(year, parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    d.setUTCHours(parseInt(m[4], 10), parseInt(m[5], 10));
    if (m[6] && m[6].length > 0) d.setUTCSeconds(parseInt(m[6], 10));
    return d;
}
var GTIME_RE = /^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})?Z$/;
function gTimeToDate(t) {
    var m = t.match(GTIME_RE);
    assert.ok(m);
    var d = new Date();
    d.setUTCFullYear(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    d.setUTCHours(parseInt(m[4], 10), parseInt(m[5], 10));
    if (m[6] && m[6].length > 0) d.setUTCSeconds(parseInt(m[6], 10));
    return d;
}
function zeroPad(n, m) {
    if (m === undefined) m = 2;
    var s = "" + n;
    while(s.length < m)s = "0" + s;
    return s;
}
function dateToUTCTime(d) {
    var s = "";
    s += zeroPad(d.getUTCFullYear() % 100);
    s += zeroPad(d.getUTCMonth() + 1);
    s += zeroPad(d.getUTCDate());
    s += zeroPad(d.getUTCHours());
    s += zeroPad(d.getUTCMinutes());
    s += zeroPad(d.getUTCSeconds());
    s += "Z";
    return s;
}
function dateToGTime(d) {
    var s = "";
    s += zeroPad(d.getUTCFullYear(), 4);
    s += zeroPad(d.getUTCMonth() + 1);
    s += zeroPad(d.getUTCDate());
    s += zeroPad(d.getUTCHours());
    s += zeroPad(d.getUTCMinutes());
    s += zeroPad(d.getUTCSeconds());
    s += "Z";
    return s;
}
function sign(cert, key) {
    if (cert.signatures.x509 === undefined) cert.signatures.x509 = {};
    var sig = cert.signatures.x509;
    sig.algo = key.type + "-" + key.defaultHashAlgorithm();
    if (SIGN_ALGS[sig.algo] === undefined) return false;
    var der = new asn1.BerWriter();
    writeTBSCert(cert, der);
    var blob = der.buffer;
    sig.cache = blob;
    var signer = key.createSign();
    signer.write(blob);
    cert.signatures.x509.signature = signer.sign();
    return true;
}
function signAsync(cert, signer, done) {
    if (cert.signatures.x509 === undefined) cert.signatures.x509 = {};
    var sig = cert.signatures.x509;
    var der = new asn1.BerWriter();
    writeTBSCert(cert, der);
    var blob = der.buffer;
    sig.cache = blob;
    signer(blob, function(err, signature) {
        if (err) {
            done(err);
            return;
        }
        sig.algo = signature.type + "-" + signature.hashAlgorithm;
        if (SIGN_ALGS[sig.algo] === undefined) {
            done(new Error('Invalid signing algorithm "' + sig.algo + '"'));
            return;
        }
        sig.signature = signature;
        done();
    });
}
function write(cert, options) {
    var sig = cert.signatures.x509;
    assert.object(sig, "x509 signature");
    var der = new asn1.BerWriter();
    der.startSequence();
    if (sig.cache) {
        der._ensure(sig.cache.length);
        sig.cache.copy(der._buf, der._offset);
        der._offset += sig.cache.length;
    } else writeTBSCert(cert, der);
    der.startSequence();
    der.writeOID(SIGN_ALGS[sig.algo]);
    if (sig.algo.match(/^rsa-/)) der.writeNull();
    der.endSequence();
    var sigData = sig.signature.toBuffer("asn1");
    var data = Buffer.alloc(sigData.length + 1);
    data[0] = 0;
    sigData.copy(data, 1);
    der.writeBuffer(data, asn1.Ber.BitString);
    der.endSequence();
    return der.buffer;
}
function writeTBSCert(cert, der) {
    var sig = cert.signatures.x509;
    assert.object(sig, "x509 signature");
    der.startSequence();
    der.startSequence(Local(0));
    der.writeInt(2);
    der.endSequence();
    der.writeBuffer(utils.mpNormalize(cert.serial), asn1.Ber.Integer);
    der.startSequence();
    der.writeOID(SIGN_ALGS[sig.algo]);
    if (sig.algo.match(/^rsa-/)) der.writeNull();
    der.endSequence();
    cert.issuer.toAsn1(der);
    der.startSequence();
    writeDate(der, cert.validFrom);
    writeDate(der, cert.validUntil);
    der.endSequence();
    var subject = cert.subjects[0];
    var altNames = cert.subjects.slice(1);
    subject.toAsn1(der);
    pkcs8.writePkcs8(der, cert.subjectKey);
    if (sig.extras && sig.extras.issuerUniqueID) der.writeBuffer(sig.extras.issuerUniqueID, Local(1));
    if (sig.extras && sig.extras.subjectUniqueID) der.writeBuffer(sig.extras.subjectUniqueID, Local(2));
    if (altNames.length > 0 || subject.type === "host" || cert.purposes !== undefined && cert.purposes.length > 0 || sig.extras && sig.extras.exts) {
        der.startSequence(Local(3));
        der.startSequence();
        var exts = [];
        if (cert.purposes !== undefined && cert.purposes.length > 0) {
            exts.push({
                oid: EXTS.basicConstraints,
                critical: true
            });
            exts.push({
                oid: EXTS.keyUsage,
                critical: true
            });
            exts.push({
                oid: EXTS.extKeyUsage,
                critical: true
            });
        }
        exts.push({
            oid: EXTS.altName
        });
        if (sig.extras && sig.extras.exts) exts = sig.extras.exts;
        for(var i = 0; i < exts.length; ++i){
            der.startSequence();
            der.writeOID(exts[i].oid);
            if (exts[i].critical !== undefined) der.writeBoolean(exts[i].critical);
            if (exts[i].oid === EXTS.altName) {
                der.startSequence(asn1.Ber.OctetString);
                der.startSequence();
                if (subject.type === "host") der.writeString(subject.hostname, Context(2));
                for(var j = 0; j < altNames.length; ++j){
                    if (altNames[j].type === "host") der.writeString(altNames[j].hostname, ALTNAME.DNSName);
                    else if (altNames[j].type === "email") der.writeString(altNames[j].email, ALTNAME.RFC822Name);
                    else {
                        /*
						 * Encode anything else as a
						 * DN style name for now.
						 */ der.startSequence(ALTNAME.DirectoryName);
                        altNames[j].toAsn1(der);
                        der.endSequence();
                    }
                }
                der.endSequence();
                der.endSequence();
            } else if (exts[i].oid === EXTS.basicConstraints) {
                der.startSequence(asn1.Ber.OctetString);
                der.startSequence();
                var ca = cert.purposes.indexOf("ca") !== -1;
                var pathLen = exts[i].pathLen;
                der.writeBoolean(ca);
                if (pathLen !== undefined) der.writeInt(pathLen);
                der.endSequence();
                der.endSequence();
            } else if (exts[i].oid === EXTS.extKeyUsage) {
                der.startSequence(asn1.Ber.OctetString);
                der.startSequence();
                cert.purposes.forEach(function(purpose) {
                    if (purpose === "ca") return;
                    if (KEYUSEBITS.indexOf(purpose) !== -1) return;
                    var oid = purpose;
                    if (EXTPURPOSE[purpose] !== undefined) oid = EXTPURPOSE[purpose];
                    der.writeOID(oid);
                });
                der.endSequence();
                der.endSequence();
            } else if (exts[i].oid === EXTS.keyUsage) {
                der.startSequence(asn1.Ber.OctetString);
                /*
				 * If we parsed this certificate from a byte
				 * stream (i.e. we didn't generate it in sshpk)
				 * then we'll have a ".bits" property on the
				 * ext with the original raw byte contents.
				 *
				 * If we have this, use it here instead of
				 * regenerating it. This guarantees we output
				 * the same data we parsed, so signatures still
				 * validate.
				 */ if (exts[i].bits !== undefined) der.writeBuffer(exts[i].bits, asn1.Ber.BitString);
                else {
                    var bits = writeBitField(cert.purposes, KEYUSEBITS);
                    der.writeBuffer(bits, asn1.Ber.BitString);
                }
                der.endSequence();
            } else der.writeBuffer(exts[i].data, asn1.Ber.OctetString);
            der.endSequence();
        }
        der.endSequence();
        der.endSequence();
    }
    der.endSequence();
}
/*
 * Reads an ASN.1 BER bitfield out of the Buffer produced by doing
 * `BerReader#readString(asn1.Ber.BitString)`. That function gives us the raw
 * contents of the BitString tag, which is a count of unused bits followed by
 * the bits as a right-padded byte string.
 *
 * `bits` is the Buffer, `bitIndex` should contain an array of string names
 * for the bits in the string, ordered starting with bit #0 in the ASN.1 spec.
 *
 * Returns an array of Strings, the names of the bits that were set to 1.
 */ function readBitField(bits, bitIndex) {
    var bitLen = 8 * (bits.length - 1) - bits[0];
    var setBits = {};
    for(var i = 0; i < bitLen; ++i){
        var byteN = 1 + Math.floor(i / 8);
        var bit = 7 - i % 8;
        var mask = 1 << bit;
        var bitVal = (bits[byteN] & mask) !== 0;
        var name = bitIndex[i];
        if (bitVal && typeof name === "string") setBits[name] = true;
    }
    return Object.keys(setBits);
}
/*
 * `setBits` is an array of strings, containing the names for each bit that
 * sould be set to 1. `bitIndex` is same as in `readBitField()`.
 *
 * Returns a Buffer, ready to be written out with `BerWriter#writeString()`.
 */ function writeBitField(setBits, bitIndex) {
    var bitLen = bitIndex.length;
    var blen = Math.ceil(bitLen / 8);
    var unused = blen * 8 - bitLen;
    var bits = Buffer.alloc(1 + blen); // zero-filled
    bits[0] = unused;
    for(var i = 0; i < bitLen; ++i){
        var byteN = 1 + Math.floor(i / 8);
        var bit = 7 - i % 8;
        var mask = 1 << bit;
        var name = bitIndex[i];
        if (name === undefined) continue;
        var bitVal = setBits.indexOf(name) !== -1;
        if (bitVal) bits[byteN] |= mask;
    }
    return bits;
}

},{"9286d09143be2e60":"eQsu4","8804c58c4b2b1744":"jC0hS","71e8daa341cc1b6c":"b2XZ0","842106490b9da495":"23cSW","54d258a601f2ea11":"icPN2","2243d96a438a9b12":"fAyE1","3e004ce551ded4e8":"4674F","6d5e2d4a836eeac8":"fUNos","d4bc39190d67accf":"3JOrI","acaa846b333b1ef4":"cxjr0","d2b79a0e1f186a1e":"4Zfxv","6cd56e5c28487784":"iNFUG"}],"ci4qT":[function(require,module,exports) {
// Copyright 2016 Joyent, Inc.
var x509 = require("e082022d8aba61b8");
module.exports = {
    read: read,
    verify: x509.verify,
    sign: x509.sign,
    write: write
};
var assert = require("a8e5de8c23f550f8");
var asn1 = require("4d8c1f4cd73afeb1");
var Buffer = require("9302cb3403288071").Buffer;
var algs = require("c6143e7f7c3c8d31");
var utils = require("4b96bf29f798cd28");
var Key = require("d15d4dd1fc49a3d9");
var PrivateKey = require("72f65dc9ab429c78");
var pem = require("260e6cdc763ed1e4");
var Identity = require("3608e86a5f17c941");
var Signature = require("327e066ada2f0d20");
var Certificate = require("f9ba05fa85907a2c");
function read(buf, options) {
    if (typeof buf !== "string") {
        assert.buffer(buf, "buf");
        buf = buf.toString("ascii");
    }
    var lines = buf.trim().split(/[\r\n]+/g);
    var m;
    var si = -1;
    while(!m && si < lines.length)m = lines[++si].match(/*JSSTYLED*/ /[-]+[ ]*BEGIN CERTIFICATE[ ]*[-]+/);
    assert.ok(m, "invalid PEM header");
    var m2;
    var ei = lines.length;
    while(!m2 && ei > 0)m2 = lines[--ei].match(/*JSSTYLED*/ /[-]+[ ]*END CERTIFICATE[ ]*[-]+/);
    assert.ok(m2, "invalid PEM footer");
    lines = lines.slice(si, ei + 1);
    var headers = {};
    while(true){
        lines = lines.slice(1);
        m = lines[0].match(/*JSSTYLED*/ /^([A-Za-z0-9-]+): (.+)$/);
        if (!m) break;
        headers[m[1].toLowerCase()] = m[2];
    }
    /* Chop off the first and last lines */ lines = lines.slice(0, -1).join("");
    buf = Buffer.from(lines, "base64");
    return x509.read(buf, options);
}
function write(cert, options) {
    var dbuf = x509.write(cert, options);
    var header = "CERTIFICATE";
    var tmp = dbuf.toString("base64");
    var len = tmp.length + tmp.length / 64 + 18 + 16 + header.length * 2 + 10;
    var buf = Buffer.alloc(len);
    var o = 0;
    o += buf.write("-----BEGIN " + header + "-----\n", o);
    for(var i = 0; i < tmp.length;){
        var limit = i + 64;
        if (limit > tmp.length) limit = tmp.length;
        o += buf.write(tmp.slice(i, limit), o);
        buf[o++] = 10;
        i = limit;
    }
    o += buf.write("-----END " + header + "-----\n", o);
    return buf.slice(0, o);
}

},{"e082022d8aba61b8":"9lYE8","a8e5de8c23f550f8":"eQsu4","4d8c1f4cd73afeb1":"jC0hS","9302cb3403288071":"b2XZ0","c6143e7f7c3c8d31":"23cSW","4b96bf29f798cd28":"icPN2","d15d4dd1fc49a3d9":"fAyE1","72f65dc9ab429c78":"4674F","260e6cdc763ed1e4":"fUNos","3608e86a5f17c941":"3JOrI","327e066ada2f0d20":"cxjr0","f9ba05fa85907a2c":"4Zfxv"}],"jOG5s":[function(require,module,exports) {
// Copyright 2012 Joyent, Inc.  All rights reserved.
var Buffer = require("40a42343ef0c87d5").Buffer;
var assert = require("da9e7f102d49e2a4");
var crypto = require("5e22c1b5795c8e02");
var http = require("b1d1b3c7018144e3");
var util = require("9a6524f654f371e9");
var sshpk = require("44df4a889a8e68ee");
var jsprim = require("cc703ddba737d97c");
var utils = require("5314d1715ecb4859");
var sprintf = require("9a6524f654f371e9").format;
var HASH_ALGOS = utils.HASH_ALGOS;
var PK_ALGOS = utils.PK_ALGOS;
var InvalidAlgorithmError = utils.InvalidAlgorithmError;
var HttpSignatureError = utils.HttpSignatureError;
var validateAlgorithm = utils.validateAlgorithm;
///--- Globals
var AUTHZ_FMT = 'Signature keyId="%s",algorithm="%s",headers="%s",signature="%s"';
///--- Specific Errors
function MissingHeaderError(message) {
    HttpSignatureError.call(this, message, MissingHeaderError);
}
util.inherits(MissingHeaderError, HttpSignatureError);
function StrictParsingError(message) {
    HttpSignatureError.call(this, message, StrictParsingError);
}
util.inherits(StrictParsingError, HttpSignatureError);
/* See createSigner() */ function RequestSigner(options) {
    assert.object(options, "options");
    var alg = [];
    if (options.algorithm !== undefined) {
        assert.string(options.algorithm, "options.algorithm");
        alg = validateAlgorithm(options.algorithm);
    }
    this.rs_alg = alg;
    /*
   * RequestSigners come in two varieties: ones with an rs_signFunc, and ones
   * with an rs_signer.
   *
   * rs_signFunc-based RequestSigners have to build up their entire signing
   * string within the rs_lines array and give it to rs_signFunc as a single
   * concat'd blob. rs_signer-based RequestSigners can add a line at a time to
   * their signing state by using rs_signer.update(), thus only needing to
   * buffer the hash function state and one line at a time.
   */ if (options.sign !== undefined) {
        assert.func(options.sign, "options.sign");
        this.rs_signFunc = options.sign;
    } else if (alg[0] === "hmac" && options.key !== undefined) {
        assert.string(options.keyId, "options.keyId");
        this.rs_keyId = options.keyId;
        if (typeof options.key !== "string" && !Buffer.isBuffer(options.key)) throw new TypeError("options.key for HMAC must be a string or Buffer");
        /*
     * Make an rs_signer for HMACs, not a rs_signFunc -- HMACs digest their
     * data in chunks rather than requiring it all to be given in one go
     * at the end, so they are more similar to signers than signFuncs.
     */ this.rs_signer = crypto.createHmac(alg[1].toUpperCase(), options.key);
        this.rs_signer.sign = function() {
            var digest = this.digest("base64");
            return {
                hashAlgorithm: alg[1],
                toString: function() {
                    return digest;
                }
            };
        };
    } else if (options.key !== undefined) {
        var key = options.key;
        if (typeof key === "string" || Buffer.isBuffer(key)) key = sshpk.parsePrivateKey(key);
        assert.ok(sshpk.PrivateKey.isPrivateKey(key, [
            1,
            2
        ]), "options.key must be a sshpk.PrivateKey");
        this.rs_key = key;
        assert.string(options.keyId, "options.keyId");
        this.rs_keyId = options.keyId;
        if (!PK_ALGOS[key.type]) throw new InvalidAlgorithmError(key.type.toUpperCase() + " type " + "keys are not supported");
        if (alg[0] !== undefined && key.type !== alg[0]) throw new InvalidAlgorithmError("options.key must be a " + alg[0].toUpperCase() + " key, was given a " + key.type.toUpperCase() + " key instead");
        this.rs_signer = key.createSign(alg[1]);
    } else throw new TypeError("options.sign (func) or options.key is required");
    this.rs_headers = [];
    this.rs_lines = [];
}
/**
 * Adds a header to be signed, with its value, into this signer.
 *
 * @param {String} header
 * @param {String} value
 * @return {String} value written
 */ RequestSigner.prototype.writeHeader = function(header, value) {
    assert.string(header, "header");
    header = header.toLowerCase();
    assert.string(value, "value");
    this.rs_headers.push(header);
    if (this.rs_signFunc) this.rs_lines.push(header + ": " + value);
    else {
        var line = header + ": " + value;
        if (this.rs_headers.length > 0) line = "\n" + line;
        this.rs_signer.update(line);
    }
    return value;
};
/**
 * Adds a default Date header, returning its value.
 *
 * @return {String}
 */ RequestSigner.prototype.writeDateHeader = function() {
    return this.writeHeader("date", jsprim.rfc1123(new Date()));
};
/**
 * Adds the request target line to be signed.
 *
 * @param {String} method, HTTP method (e.g. 'get', 'post', 'put')
 * @param {String} path
 */ RequestSigner.prototype.writeTarget = function(method, path) {
    assert.string(method, "method");
    assert.string(path, "path");
    method = method.toLowerCase();
    this.writeHeader("(request-target)", method + " " + path);
};
/**
 * Calculate the value for the Authorization header on this request
 * asynchronously.
 *
 * @param {Func} callback (err, authz)
 */ RequestSigner.prototype.sign = function(cb) {
    assert.func(cb, "callback");
    if (this.rs_headers.length < 1) throw new Error("At least one header must be signed");
    var alg, authz;
    if (this.rs_signFunc) {
        var data = this.rs_lines.join("\n");
        var self = this;
        this.rs_signFunc(data, function(err, sig) {
            if (err) {
                cb(err);
                return;
            }
            try {
                assert.object(sig, "signature");
                assert.string(sig.keyId, "signature.keyId");
                assert.string(sig.algorithm, "signature.algorithm");
                assert.string(sig.signature, "signature.signature");
                alg = validateAlgorithm(sig.algorithm);
                authz = sprintf(AUTHZ_FMT, sig.keyId, sig.algorithm, self.rs_headers.join(" "), sig.signature);
            } catch (e) {
                cb(e);
                return;
            }
            cb(null, authz);
        });
    } else {
        try {
            var sigObj = this.rs_signer.sign();
        } catch (e) {
            cb(e);
            return;
        }
        alg = (this.rs_alg[0] || this.rs_key.type) + "-" + sigObj.hashAlgorithm;
        var signature = sigObj.toString();
        authz = sprintf(AUTHZ_FMT, this.rs_keyId, alg, this.rs_headers.join(" "), signature);
        cb(null, authz);
    }
};
///--- Exported API
module.exports = {
    /**
   * Identifies whether a given object is a request signer or not.
   *
   * @param {Object} object, the object to identify
   * @returns {Boolean}
   */ isSigner: function(obj) {
        if (typeof obj === "object" && obj instanceof RequestSigner) return true;
        return false;
    },
    /**
   * Creates a request signer, used to asynchronously build a signature
   * for a request (does not have to be an http.ClientRequest).
   *
   * @param {Object} options, either:
   *                   - {String} keyId
   *                   - {String|Buffer} key
   *                   - {String} algorithm (optional, required for HMAC)
   *                 or:
   *                   - {Func} sign (data, cb)
   * @return {RequestSigner}
   */ createSigner: function createSigner(options) {
        return new RequestSigner(options);
    },
    /**
   * Adds an 'Authorization' header to an http.ClientRequest object.
   *
   * Note that this API will add a Date header if it's not already set. Any
   * other headers in the options.headers array MUST be present, or this
   * will throw.
   *
   * You shouldn't need to check the return type; it's just there if you want
   * to be pedantic.
   *
   * The optional flag indicates whether parsing should use strict enforcement
   * of the version draft-cavage-http-signatures-04 of the spec or beyond.
   * The default is to be loose and support
   * older versions for compatibility.
   *
   * @param {Object} request an instance of http.ClientRequest.
   * @param {Object} options signing parameters object:
   *                   - {String} keyId required.
   *                   - {String} key required (either a PEM or HMAC key).
   *                   - {Array} headers optional; defaults to ['date'].
   *                   - {String} algorithm optional (unless key is HMAC);
   *                              default is the same as the sshpk default
   *                              signing algorithm for the type of key given
   *                   - {String} httpVersion optional; defaults to '1.1'.
   *                   - {Boolean} strict optional; defaults to 'false'.
   * @return {Boolean} true if Authorization (and optionally Date) were added.
   * @throws {TypeError} on bad parameter types (input).
   * @throws {InvalidAlgorithmError} if algorithm was bad or incompatible with
   *                                 the given key.
   * @throws {sshpk.KeyParseError} if key was bad.
   * @throws {MissingHeaderError} if a header to be signed was specified but
   *                              was not present.
   */ signRequest: function signRequest(request, options) {
        assert.object(request, "request");
        assert.object(options, "options");
        assert.optionalString(options.algorithm, "options.algorithm");
        assert.string(options.keyId, "options.keyId");
        assert.optionalArrayOfString(options.headers, "options.headers");
        assert.optionalString(options.httpVersion, "options.httpVersion");
        if (!request.getHeader("Date")) request.setHeader("Date", jsprim.rfc1123(new Date()));
        if (!options.headers) options.headers = [
            "date"
        ];
        if (!options.httpVersion) options.httpVersion = "1.1";
        var alg = [];
        if (options.algorithm) {
            options.algorithm = options.algorithm.toLowerCase();
            alg = validateAlgorithm(options.algorithm);
        }
        var i;
        var stringToSign = "";
        for(i = 0; i < options.headers.length; i++){
            if (typeof options.headers[i] !== "string") throw new TypeError("options.headers must be an array of Strings");
            var h = options.headers[i].toLowerCase();
            if (h === "request-line") {
                if (!options.strict) /**
           * We allow headers from the older spec drafts if strict parsing isn't
           * specified in options.
           */ stringToSign += request.method + " " + request.path + " HTTP/" + options.httpVersion;
                else /* Strict parsing doesn't allow older draft headers. */ throw new StrictParsingError("request-line is not a valid header with strict parsing enabled.");
            } else if (h === "(request-target)") stringToSign += "(request-target): " + request.method.toLowerCase() + " " + request.path;
            else {
                var value = request.getHeader(h);
                if (value === undefined || value === "") throw new MissingHeaderError(h + " was not in the request");
                stringToSign += h + ": " + value;
            }
            if (i + 1 < options.headers.length) stringToSign += "\n";
        }
        /* This is just for unit tests. */ if (request.hasOwnProperty("_stringToSign")) request._stringToSign = stringToSign;
        var signature;
        if (alg[0] === "hmac") {
            if (typeof options.key !== "string" && !Buffer.isBuffer(options.key)) throw new TypeError("options.key must be a string or Buffer");
            var hmac = crypto.createHmac(alg[1].toUpperCase(), options.key);
            hmac.update(stringToSign);
            signature = hmac.digest("base64");
        } else {
            var key = options.key;
            if (typeof key === "string" || Buffer.isBuffer(key)) key = sshpk.parsePrivateKey(options.key);
            assert.ok(sshpk.PrivateKey.isPrivateKey(key, [
                1,
                2
            ]), "options.key must be a sshpk.PrivateKey");
            if (!PK_ALGOS[key.type]) throw new InvalidAlgorithmError(key.type.toUpperCase() + " type " + "keys are not supported");
            if (alg[0] !== undefined && key.type !== alg[0]) throw new InvalidAlgorithmError("options.key must be a " + alg[0].toUpperCase() + " key, was given a " + key.type.toUpperCase() + " key instead");
            var signer = key.createSign(alg[1]);
            signer.update(stringToSign);
            var sigObj = signer.sign();
            if (!HASH_ALGOS[sigObj.hashAlgorithm]) throw new InvalidAlgorithmError(sigObj.hashAlgorithm.toUpperCase() + " is not a supported hash algorithm");
            options.algorithm = key.type + "-" + sigObj.hashAlgorithm;
            signature = sigObj.toString();
            assert.notStrictEqual(signature, "", "empty signature produced");
        }
        var authzHeaderName = options.authorizationHeaderName || "Authorization";
        request.setHeader(authzHeaderName, sprintf(AUTHZ_FMT, options.keyId, options.algorithm, options.headers.join(" "), signature));
        return true;
    }
};

},{"40a42343ef0c87d5":"8EcTH","da9e7f102d49e2a4":"eQsu4","5e22c1b5795c8e02":"8Nkdo","b1d1b3c7018144e3":"cbdR9","9a6524f654f371e9":"dJawj","44df4a889a8e68ee":"hjXTA","cc703ddba737d97c":"jxY8C","5314d1715ecb4859":"g8tYW"}],"jxY8C":[function(require,module,exports) {
/*
 * lib/jsprim.js: utilities for primitive JavaScript types
 */ var mod_assert = require("4c95ae6c1626eb7e");
var mod_util = require("cd0a34c8e2a0d5e");
var mod_extsprintf = require("c68abac7c8786aac");
var mod_verror = require("d0e3a4d5c49fcbe2");
var mod_jsonschema = require("567be4c16e5e08aa");
/*
 * Public interface
 */ exports.deepCopy = deepCopy;
exports.deepEqual = deepEqual;
exports.isEmpty = isEmpty;
exports.hasKey = hasKey;
exports.forEachKey = forEachKey;
exports.pluck = pluck;
exports.flattenObject = flattenObject;
exports.flattenIter = flattenIter;
exports.validateJsonObject = validateJsonObjectJS;
exports.validateJsonObjectJS = validateJsonObjectJS;
exports.randElt = randElt;
exports.extraProperties = extraProperties;
exports.mergeObjects = mergeObjects;
exports.startsWith = startsWith;
exports.endsWith = endsWith;
exports.parseInteger = parseInteger;
exports.iso8601 = iso8601;
exports.rfc1123 = rfc1123;
exports.parseDateTime = parseDateTime;
exports.hrtimediff = hrtimeDiff;
exports.hrtimeDiff = hrtimeDiff;
exports.hrtimeAccum = hrtimeAccum;
exports.hrtimeAdd = hrtimeAdd;
exports.hrtimeNanosec = hrtimeNanosec;
exports.hrtimeMicrosec = hrtimeMicrosec;
exports.hrtimeMillisec = hrtimeMillisec;
/*
 * Deep copy an acyclic *basic* Javascript object.  This only handles basic
 * scalars (strings, numbers, booleans) and arbitrarily deep arrays and objects
 * containing these.  This does *not* handle instances of other classes.
 */ function deepCopy(obj) {
    var ret, key;
    var marker = "__deepCopy";
    if (obj && obj[marker]) throw new Error("attempted deep copy of cyclic object");
    if (obj && obj.constructor == Object) {
        ret = {};
        obj[marker] = true;
        for(key in obj){
            if (key == marker) continue;
            ret[key] = deepCopy(obj[key]);
        }
        delete obj[marker];
        return ret;
    }
    if (obj && obj.constructor == Array) {
        ret = [];
        obj[marker] = true;
        for(key = 0; key < obj.length; key++)ret.push(deepCopy(obj[key]));
        delete obj[marker];
        return ret;
    }
    /*
	 * It must be a primitive type -- just return it.
	 */ return obj;
}
function deepEqual(obj1, obj2) {
    if (typeof obj1 != typeof obj2) return false;
    if (obj1 === null || obj2 === null || typeof obj1 != "object") return obj1 === obj2;
    if (obj1.constructor != obj2.constructor) return false;
    var k;
    for(k in obj1){
        if (!obj2.hasOwnProperty(k)) return false;
        if (!deepEqual(obj1[k], obj2[k])) return false;
    }
    for(k in obj2){
        if (!obj1.hasOwnProperty(k)) return false;
    }
    return true;
}
function isEmpty(obj) {
    var key;
    for(key in obj)return false;
    return true;
}
function hasKey(obj, key) {
    mod_assert.equal(typeof key, "string");
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function forEachKey(obj, callback) {
    for(var key in obj)if (hasKey(obj, key)) callback(key, obj[key]);
}
function pluck(obj, key) {
    mod_assert.equal(typeof key, "string");
    return pluckv(obj, key);
}
function pluckv(obj, key) {
    if (obj === null || typeof obj !== "object") return undefined;
    if (obj.hasOwnProperty(key)) return obj[key];
    var i = key.indexOf(".");
    if (i == -1) return undefined;
    var key1 = key.substr(0, i);
    if (!obj.hasOwnProperty(key1)) return undefined;
    return pluckv(obj[key1], key.substr(i + 1));
}
/*
 * Invoke callback(row) for each entry in the array that would be returned by
 * flattenObject(data, depth).  This is just like flattenObject(data,
 * depth).forEach(callback), except that the intermediate array is never
 * created.
 */ function flattenIter(data, depth, callback) {
    doFlattenIter(data, depth, [], callback);
}
function doFlattenIter(data, depth, accum, callback) {
    var each;
    var key;
    if (depth === 0) {
        each = accum.slice(0);
        each.push(data);
        callback(each);
        return;
    }
    mod_assert.ok(data !== null);
    mod_assert.equal(typeof data, "object");
    mod_assert.equal(typeof depth, "number");
    mod_assert.ok(depth >= 0);
    for(key in data){
        each = accum.slice(0);
        each.push(key);
        doFlattenIter(data[key], depth - 1, each, callback);
    }
}
function flattenObject(data, depth) {
    if (depth === 0) return [
        data
    ];
    mod_assert.ok(data !== null);
    mod_assert.equal(typeof data, "object");
    mod_assert.equal(typeof depth, "number");
    mod_assert.ok(depth >= 0);
    var rv = [];
    var key;
    for(key in data)flattenObject(data[key], depth - 1).forEach(function(p) {
        rv.push([
            key
        ].concat(p));
    });
    return rv;
}
function startsWith(str, prefix) {
    return str.substr(0, prefix.length) == prefix;
}
function endsWith(str, suffix) {
    return str.substr(str.length - suffix.length, suffix.length) == suffix;
}
function iso8601(d) {
    if (typeof d == "number") d = new Date(d);
    mod_assert.ok(d.constructor === Date);
    return mod_extsprintf.sprintf("%4d-%02d-%02dT%02d:%02d:%02d.%03dZ", d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
}
var RFC1123_MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var RFC1123_DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
function rfc1123(date) {
    return mod_extsprintf.sprintf("%s, %02d %s %04d %02d:%02d:%02d GMT", RFC1123_DAYS[date.getUTCDay()], date.getUTCDate(), RFC1123_MONTHS[date.getUTCMonth()], date.getUTCFullYear(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}
/*
 * Parses a date expressed as a string, as either a number of milliseconds since
 * the epoch or any string format that Date accepts, giving preference to the
 * former where these two sets overlap (e.g., small numbers).
 */ function parseDateTime(str) {
    /*
	 * This is irritatingly implicit, but significantly more concise than
	 * alternatives.  The "+str" will convert a string containing only a
	 * number directly to a Number, or NaN for other strings.  Thus, if the
	 * conversion succeeds, we use it (this is the milliseconds-since-epoch
	 * case).  Otherwise, we pass the string directly to the Date
	 * constructor to parse.
	 */ var numeric = +str;
    if (!isNaN(numeric)) return new Date(numeric);
    else return new Date(str);
}
/*
 * Number.*_SAFE_INTEGER isn't present before node v0.12, so we hardcode
 * the ES6 definitions here, while allowing for them to someday be higher.
 */ var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
var MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
/*
 * Default options for parseInteger().
 */ var PI_DEFAULTS = {
    base: 10,
    allowSign: true,
    allowPrefix: false,
    allowTrailing: false,
    allowImprecise: false,
    trimWhitespace: false,
    leadingZeroIsOctal: false
};
var CP_0 = 0x30;
var CP_9 = 0x39;
var CP_A = 0x41;
var CP_B = 0x42;
var CP_O = 0x4f;
var CP_T = 0x54;
var CP_X = 0x58;
var CP_Z = 0x5a;
var CP_a = 0x61;
var CP_b = 0x62;
var CP_o = 0x6f;
var CP_t = 0x74;
var CP_x = 0x78;
var CP_z = 0x7a;
var PI_CONV_DEC = 0x30;
var PI_CONV_UC = 0x37;
var PI_CONV_LC = 0x57;
/*
 * A stricter version of parseInt() that provides options for changing what
 * is an acceptable string (for example, disallowing trailing characters).
 */ function parseInteger(str, uopts) {
    mod_assert.string(str, "str");
    mod_assert.optionalObject(uopts, "options");
    var baseOverride = false;
    var options = PI_DEFAULTS;
    if (uopts) {
        baseOverride = hasKey(uopts, "base");
        options = mergeObjects(options, uopts);
        mod_assert.number(options.base, "options.base");
        mod_assert.ok(options.base >= 2, "options.base >= 2");
        mod_assert.ok(options.base <= 36, "options.base <= 36");
        mod_assert.bool(options.allowSign, "options.allowSign");
        mod_assert.bool(options.allowPrefix, "options.allowPrefix");
        mod_assert.bool(options.allowTrailing, "options.allowTrailing");
        mod_assert.bool(options.allowImprecise, "options.allowImprecise");
        mod_assert.bool(options.trimWhitespace, "options.trimWhitespace");
        mod_assert.bool(options.leadingZeroIsOctal, "options.leadingZeroIsOctal");
        if (options.leadingZeroIsOctal) mod_assert.ok(!baseOverride, '"base" and "leadingZeroIsOctal" are mutually exclusive');
    }
    var c;
    var pbase = -1;
    var base = options.base;
    var start;
    var mult = 1;
    var value = 0;
    var idx = 0;
    var len = str.length;
    /* Trim any whitespace on the left side. */ if (options.trimWhitespace) while(idx < len && isSpace(str.charCodeAt(idx)))++idx;
    /* Check the number for a leading sign. */ if (options.allowSign) {
        if (str[idx] === "-") {
            idx += 1;
            mult = -1;
        } else if (str[idx] === "+") idx += 1;
    }
    /* Parse the base-indicating prefix if there is one. */ if (str[idx] === "0") {
        if (options.allowPrefix) {
            pbase = prefixToBase(str.charCodeAt(idx + 1));
            if (pbase !== -1 && (!baseOverride || pbase === base)) {
                base = pbase;
                idx += 2;
            }
        }
        if (pbase === -1 && options.leadingZeroIsOctal) base = 8;
    }
    /* Parse the actual digits. */ for(start = idx; idx < len; ++idx){
        c = translateDigit(str.charCodeAt(idx));
        if (c !== -1 && c < base) {
            value *= base;
            value += c;
        } else break;
    }
    /* If we didn't parse any digits, we have an invalid number. */ if (start === idx) return new Error("invalid number: " + JSON.stringify(str));
    /* Trim any whitespace on the right side. */ if (options.trimWhitespace) while(idx < len && isSpace(str.charCodeAt(idx)))++idx;
    /* Check for trailing characters. */ if (idx < len && !options.allowTrailing) return new Error("trailing characters after number: " + JSON.stringify(str.slice(idx)));
    /* If our value is 0, we return now, to avoid returning -0. */ if (value === 0) return 0;
    /* Calculate our final value. */ var result = value * mult;
    /*
	 * If the string represents a value that cannot be precisely represented
	 * by JavaScript, then we want to check that:
	 *
	 * - We never increased the value past MAX_SAFE_INTEGER
	 * - We don't make the result negative and below MIN_SAFE_INTEGER
	 *
	 * Because we only ever increment the value during parsing, there's no
	 * chance of moving past MAX_SAFE_INTEGER and then dropping below it
	 * again, losing precision in the process. This means that we only need
	 * to do our checks here, at the end.
	 */ if (!options.allowImprecise && (value > MAX_SAFE_INTEGER || result < MIN_SAFE_INTEGER)) return new Error("number is outside of the supported range: " + JSON.stringify(str.slice(start, idx)));
    return result;
}
/*
 * Interpret a character code as a base-36 digit.
 */ function translateDigit(d) {
    if (d >= CP_0 && d <= CP_9) /* '0' to '9' -> 0 to 9 */ return d - PI_CONV_DEC;
    else if (d >= CP_A && d <= CP_Z) /* 'A' - 'Z' -> 10 to 35 */ return d - PI_CONV_UC;
    else if (d >= CP_a && d <= CP_z) /* 'a' - 'z' -> 10 to 35 */ return d - PI_CONV_LC;
    else /* Invalid character code */ return -1;
}
/*
 * Test if a value matches the ECMAScript definition of trimmable whitespace.
 */ function isSpace(c) {
    return c === 0x20 || c >= 0x0009 && c <= 0x000d || c === 0x00a0 || c === 0x1680 || c === 0x180e || c >= 0x2000 && c <= 0x200a || c === 0x2028 || c === 0x2029 || c === 0x202f || c === 0x205f || c === 0x3000 || c === 0xfeff;
}
/*
 * Determine which base a character indicates (e.g., 'x' indicates hex).
 */ function prefixToBase(c) {
    if (c === CP_b || c === CP_B) /* 0b/0B (binary) */ return 2;
    else if (c === CP_o || c === CP_O) /* 0o/0O (octal) */ return 8;
    else if (c === CP_t || c === CP_T) /* 0t/0T (decimal) */ return 10;
    else if (c === CP_x || c === CP_X) /* 0x/0X (hexadecimal) */ return 16;
    else /* Not a meaningful character */ return -1;
}
function validateJsonObjectJS(schema, input) {
    var report = mod_jsonschema.validate(input, schema);
    if (report.errors.length === 0) return null;
    /* Currently, we only do anything useful with the first error. */ var error = report.errors[0];
    /* The failed property is given by a URI with an irrelevant prefix. */ var propname = error["property"];
    var reason = error["message"].toLowerCase();
    var i, j;
    /*
	 * There's at least one case where the property error message is
	 * confusing at best.  We work around this here.
	 */ if ((i = reason.indexOf("the property ")) != -1 && (j = reason.indexOf(" is not defined in the schema and the schema does not allow additional properties")) != -1) {
        i += 13;
        if (propname === "") propname = reason.substr(i, j - i);
        else propname = propname + "." + reason.substr(i, j - i);
        reason = "unsupported property";
    }
    var rv = new mod_verror.VError('property "%s": %s', propname, reason);
    rv.jsv_details = error;
    return rv;
}
function randElt(arr) {
    mod_assert.ok(Array.isArray(arr) && arr.length > 0, "randElt argument must be a non-empty array");
    return arr[Math.floor(Math.random() * arr.length)];
}
function assertHrtime(a) {
    mod_assert.ok(a[0] >= 0 && a[1] >= 0, "negative numbers not allowed in hrtimes");
    mod_assert.ok(a[1] < 1e9, "nanoseconds column overflow");
}
/*
 * Compute the time elapsed between hrtime readings A and B, where A is later
 * than B.  hrtime readings come from Node's process.hrtime().  There is no
 * defined way to represent negative deltas, so it's illegal to diff B from A
 * where the time denoted by B is later than the time denoted by A.  If this
 * becomes valuable, we can define a representation and extend the
 * implementation to support it.
 */ function hrtimeDiff(a, b) {
    assertHrtime(a);
    assertHrtime(b);
    mod_assert.ok(a[0] > b[0] || a[0] == b[0] && a[1] >= b[1], "negative differences not allowed");
    var rv = [
        a[0] - b[0],
        0
    ];
    if (a[1] >= b[1]) rv[1] = a[1] - b[1];
    else {
        rv[0]--;
        rv[1] = 1e9 - (b[1] - a[1]);
    }
    return rv;
}
/*
 * Convert a hrtime reading from the array format returned by Node's
 * process.hrtime() into a scalar number of nanoseconds.
 */ function hrtimeNanosec(a) {
    assertHrtime(a);
    return Math.floor(a[0] * 1e9 + a[1]);
}
/*
 * Convert a hrtime reading from the array format returned by Node's
 * process.hrtime() into a scalar number of microseconds.
 */ function hrtimeMicrosec(a) {
    assertHrtime(a);
    return Math.floor(a[0] * 1e6 + a[1] / 1e3);
}
/*
 * Convert a hrtime reading from the array format returned by Node's
 * process.hrtime() into a scalar number of milliseconds.
 */ function hrtimeMillisec(a) {
    assertHrtime(a);
    return Math.floor(a[0] * 1e3 + a[1] / 1e6);
}
/*
 * Add two hrtime readings A and B, overwriting A with the result of the
 * addition.  This function is useful for accumulating several hrtime intervals
 * into a counter.  Returns A.
 */ function hrtimeAccum(a, b) {
    assertHrtime(a);
    assertHrtime(b);
    /*
	 * Accumulate the nanosecond component.
	 */ a[1] += b[1];
    if (a[1] >= 1e9) {
        /*
		 * The nanosecond component overflowed, so carry to the seconds
		 * field.
		 */ a[0]++;
        a[1] -= 1e9;
    }
    /*
	 * Accumulate the seconds component.
	 */ a[0] += b[0];
    return a;
}
/*
 * Add two hrtime readings A and B, returning the result as a new hrtime array.
 * Does not modify either input argument.
 */ function hrtimeAdd(a, b) {
    assertHrtime(a);
    var rv = [
        a[0],
        a[1]
    ];
    return hrtimeAccum(rv, b);
}
/*
 * Check an object for unexpected properties.  Accepts the object to check, and
 * an array of allowed property names (strings).  Returns an array of key names
 * that were found on the object, but did not appear in the list of allowed
 * properties.  If no properties were found, the returned array will be of
 * zero length.
 */ function extraProperties(obj, allowed) {
    mod_assert.ok(typeof obj === "object" && obj !== null, "obj argument must be a non-null object");
    mod_assert.ok(Array.isArray(allowed), "allowed argument must be an array of strings");
    for(var i = 0; i < allowed.length; i++)mod_assert.ok(typeof allowed[i] === "string", "allowed argument must be an array of strings");
    return Object.keys(obj).filter(function(key) {
        return allowed.indexOf(key) === -1;
    });
}
/*
 * Given three sets of properties "provided" (may be undefined), "overrides"
 * (required), and "defaults" (may be undefined), construct an object containing
 * the union of these sets with "overrides" overriding "provided", and
 * "provided" overriding "defaults".  None of the input objects are modified.
 */ function mergeObjects(provided, overrides, defaults) {
    var rv, k;
    rv = {};
    if (defaults) for(k in defaults)rv[k] = defaults[k];
    if (provided) for(k in provided)rv[k] = provided[k];
    if (overrides) for(k in overrides)rv[k] = overrides[k];
    return rv;
}

},{"4c95ae6c1626eb7e":"eQsu4","cd0a34c8e2a0d5e":"dJawj","c68abac7c8786aac":"gJ2oh","d0e3a4d5c49fcbe2":"h9nfX","567be4c16e5e08aa":"g38xr"}],"gJ2oh":[function(require,module,exports) {
/*
 * extsprintf.js: extended POSIX-style sprintf
 */ var process = require("ddd9d377c25778ba");
var mod_assert = require("78fbe0afa3613b3b");
var mod_util = require("ff526ac27e34f474");
/*
 * Public interface
 */ exports.sprintf = jsSprintf;
exports.printf = jsPrintf;
exports.fprintf = jsFprintf;
/*
 * Stripped down version of s[n]printf(3c).  We make a best effort to throw an
 * exception when given a format string we don't understand, rather than
 * ignoring it, so that we won't break existing programs if/when we go implement
 * the rest of this.
 *
 * This implementation currently supports specifying
 *	- field alignment ('-' flag),
 * 	- zero-pad ('0' flag)
 *	- always show numeric sign ('+' flag),
 *	- field width
 *	- conversions for strings, decimal integers, and floats (numbers).
 *	- argument size specifiers.  These are all accepted but ignored, since
 *	  Javascript has no notion of the physical size of an argument.
 *
 * Everything else is currently unsupported, most notably precision, unsigned
 * numbers, non-decimal numbers, and characters.
 */ function jsSprintf(fmt) {
    var regex = [
        "([^%]*)",
        /* normal text */ "%",
        /* start of format */ "(['\\-+ #0]*?)",
        /* flags (optional) */ "([1-9]\\d*)?",
        /* width (optional) */ "(\\.([1-9]\\d*))?",
        /* precision (optional) */ "[lhjztL]*?",
        /* length mods (ignored) */ "([diouxXfFeEgGaAcCsSp%jr])" /* conversion */ 
    ].join("");
    var re = new RegExp(regex);
    var args = Array.prototype.slice.call(arguments, 1);
    var flags, width, precision, conversion;
    var left, pad, sign, arg, match;
    var ret = "";
    var argn = 1;
    mod_assert.equal("string", typeof fmt);
    while((match = re.exec(fmt)) !== null){
        ret += match[1];
        fmt = fmt.substring(match[0].length);
        flags = match[2] || "";
        width = match[3] || 0;
        precision = match[4] || "";
        conversion = match[6];
        left = false;
        sign = false;
        pad = " ";
        if (conversion == "%") {
            ret += "%";
            continue;
        }
        if (args.length === 0) throw new Error("too few args to sprintf");
        arg = args.shift();
        argn++;
        if (flags.match(/[\' #]/)) throw new Error("unsupported flags: " + flags);
        if (precision.length > 0) throw new Error("non-zero precision not supported");
        if (flags.match(/-/)) left = true;
        if (flags.match(/0/)) pad = "0";
        if (flags.match(/\+/)) sign = true;
        switch(conversion){
            case "s":
                if (arg === undefined || arg === null) throw new Error("argument " + argn + ": attempted to print undefined or null " + "as a string");
                ret += doPad(pad, width, left, arg.toString());
                break;
            case "d":
                arg = Math.floor(arg);
            /*jsl:fallthru*/ case "f":
                sign = sign && arg > 0 ? "+" : "";
                ret += sign + doPad(pad, width, left, arg.toString());
                break;
            case "x":
                ret += doPad(pad, width, left, arg.toString(16));
                break;
            case "j":
                /* non-standard */ if (width === 0) width = 10;
                ret += mod_util.inspect(arg, false, width);
                break;
            case "r":
                /* non-standard */ ret += dumpException(arg);
                break;
            default:
                throw new Error("unsupported conversion: " + conversion);
        }
    }
    ret += fmt;
    return ret;
}
function jsPrintf() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(process.stdout);
    jsFprintf.apply(null, args);
}
function jsFprintf(stream) {
    var args = Array.prototype.slice.call(arguments, 1);
    return stream.write(jsSprintf.apply(this, args));
}
function doPad(chr, width, left, str) {
    var ret = str;
    while(ret.length < width)if (left) ret += chr;
    else ret = chr + ret;
    return ret;
}
/*
 * This function dumps long stack traces for exceptions having a cause() method.
 * See node-verror for an example.
 */ function dumpException(ex) {
    var ret;
    if (!(ex instanceof Error)) throw new Error(jsSprintf("invalid type for %%r: %j", ex));
    /* Note that V8 prepends "ex.stack" with ex.toString(). */ ret = "EXCEPTION: " + ex.constructor.name + ": " + ex.stack;
    if (ex.cause && typeof ex.cause === "function") {
        var cex = ex.cause();
        if (cex) ret += "\nCaused by: " + dumpException(cex);
    }
    return ret;
}

},{"ddd9d377c25778ba":"g1F5c","78fbe0afa3613b3b":"fsq0Y","ff526ac27e34f474":"dJawj"}],"h9nfX":[function(require,module,exports) {
/*
 * verror.js: richer JavaScript errors
 */ var mod_assertplus = require("f362294f9a4d3eb");
var mod_util = require("4ae6e3d1cc937a66");
var mod_extsprintf = require("2465de02351d6bf1");
var mod_isError = require("8d89ec5307a0f358").isError;
var sprintf = mod_extsprintf.sprintf;
/*
 * Public interface
 */ /* So you can 'var VError = require('verror')' */ module.exports = VError;
/* For compatibility */ VError.VError = VError;
/* Other exported classes */ VError.SError = SError;
VError.WError = WError;
VError.MultiError = MultiError;
/*
 * Common function used to parse constructor arguments for VError, WError, and
 * SError.  Named arguments to this function:
 *
 *     strict		force strict interpretation of sprintf arguments, even
 *     			if the options in "argv" don't say so
 *
 *     argv		error's constructor arguments, which are to be
 *     			interpreted as described in README.md.  For quick
 *     			reference, "argv" has one of the following forms:
 *
 *          [ sprintf_args... ]           (argv[0] is a string)
 *          [ cause, sprintf_args... ]    (argv[0] is an Error)
 *          [ options, sprintf_args... ]  (argv[0] is an object)
 *
 * This function normalizes these forms, producing an object with the following
 * properties:
 *
 *    options           equivalent to "options" in third form.  This will never
 *    			be a direct reference to what the caller passed in
 *    			(i.e., it may be a shallow copy), so it can be freely
 *    			modified.
 *
 *    shortmessage      result of sprintf(sprintf_args), taking options.strict
 *    			into account as described in README.md.
 */ function parseConstructorArguments(args) {
    var argv, options, sprintf_args, shortmessage, k;
    mod_assertplus.object(args, "args");
    mod_assertplus.bool(args.strict, "args.strict");
    mod_assertplus.array(args.argv, "args.argv");
    argv = args.argv;
    /*
	 * First, figure out which form of invocation we've been given.
	 */ if (argv.length === 0) {
        options = {};
        sprintf_args = [];
    } else if (mod_isError(argv[0])) {
        options = {
            "cause": argv[0]
        };
        sprintf_args = argv.slice(1);
    } else if (typeof argv[0] === "object") {
        options = {};
        for(k in argv[0])options[k] = argv[0][k];
        sprintf_args = argv.slice(1);
    } else {
        mod_assertplus.string(argv[0], "first argument to VError, SError, or WError constructor must be a string, object, or Error");
        options = {};
        sprintf_args = argv;
    }
    /*
	 * Now construct the error's message.
	 *
	 * extsprintf (which we invoke here with our caller's arguments in order
	 * to construct this Error's message) is strict in its interpretation of
	 * values to be processed by the "%s" specifier.  The value passed to
	 * extsprintf must actually be a string or something convertible to a
	 * String using .toString().  Passing other values (notably "null" and
	 * "undefined") is considered a programmer error.  The assumption is
	 * that if you actually want to print the string "null" or "undefined",
	 * then that's easy to do that when you're calling extsprintf; on the
	 * other hand, if you did NOT want that (i.e., there's actually a bug
	 * where the program assumes some variable is non-null and tries to
	 * print it, which might happen when constructing a packet or file in
	 * some specific format), then it's better to stop immediately than
	 * produce bogus output.
	 *
	 * However, sometimes the bug is only in the code calling VError, and a
	 * programmer might prefer to have the error message contain "null" or
	 * "undefined" rather than have the bug in the error path crash the
	 * program (making the first bug harder to identify).  For that reason,
	 * by default VError converts "null" or "undefined" arguments to their
	 * string representations and passes those to extsprintf.  Programmers
	 * desiring the strict behavior can use the SError class or pass the
	 * "strict" option to the VError constructor.
	 */ mod_assertplus.object(options);
    if (!options.strict && !args.strict) sprintf_args = sprintf_args.map(function(a) {
        return a === null ? "null" : a === undefined ? "undefined" : a;
    });
    if (sprintf_args.length === 0) shortmessage = "";
    else shortmessage = sprintf.apply(null, sprintf_args);
    return {
        "options": options,
        "shortmessage": shortmessage
    };
}
/*
 * See README.md for reference documentation.
 */ function VError() {
    var args, obj, parsed, cause, ctor, message, k;
    args = Array.prototype.slice.call(arguments, 0);
    /*
	 * This is a regrettable pattern, but JavaScript's built-in Error class
	 * is defined to work this way, so we allow the constructor to be called
	 * without "new".
	 */ if (!(this instanceof VError)) {
        obj = Object.create(VError.prototype);
        VError.apply(obj, arguments);
        return obj;
    }
    /*
	 * For convenience and backwards compatibility, we support several
	 * different calling forms.  Normalize them here.
	 */ parsed = parseConstructorArguments({
        "argv": args,
        "strict": false
    });
    /*
	 * If we've been given a name, apply it now.
	 */ if (parsed.options.name) {
        mod_assertplus.string(parsed.options.name, 'error\'s "name" must be a string');
        this.name = parsed.options.name;
    }
    /*
	 * For debugging, we keep track of the original short message (attached
	 * this Error particularly) separately from the complete message (which
	 * includes the messages of our cause chain).
	 */ this.jse_shortmsg = parsed.shortmessage;
    message = parsed.shortmessage;
    /*
	 * If we've been given a cause, record a reference to it and update our
	 * message appropriately.
	 */ cause = parsed.options.cause;
    if (cause) {
        mod_assertplus.ok(mod_isError(cause), "cause is not an Error");
        this.jse_cause = cause;
        if (!parsed.options.skipCauseMessage) message += ": " + cause.message;
    }
    /*
	 * If we've been given an object with properties, shallow-copy that
	 * here.  We don't want to use a deep copy in case there are non-plain
	 * objects here, but we don't want to use the original object in case
	 * the caller modifies it later.
	 */ this.jse_info = {};
    if (parsed.options.info) for(k in parsed.options.info)this.jse_info[k] = parsed.options.info[k];
    this.message = message;
    Error.call(this, message);
    if (Error.captureStackTrace) {
        ctor = parsed.options.constructorOpt || this.constructor;
        Error.captureStackTrace(this, ctor);
    }
    return this;
}
mod_util.inherits(VError, Error);
VError.prototype.name = "VError";
VError.prototype.toString = function ve_toString() {
    var str = this.hasOwnProperty("name") && this.name || this.constructor.name || this.constructor.prototype.name;
    if (this.message) str += ": " + this.message;
    return str;
};
/*
 * This method is provided for compatibility.  New callers should use
 * VError.cause() instead.  That method also uses the saner `null` return value
 * when there is no cause.
 */ VError.prototype.cause = function ve_cause() {
    var cause = VError.cause(this);
    return cause === null ? undefined : cause;
};
/*
 * Static methods
 *
 * These class-level methods are provided so that callers can use them on
 * instances of Errors that are not VErrors.  New interfaces should be provided
 * only using static methods to eliminate the class of programming mistake where
 * people fail to check whether the Error object has the corresponding methods.
 */ VError.cause = function(err) {
    mod_assertplus.ok(mod_isError(err), "err must be an Error");
    return mod_isError(err.jse_cause) ? err.jse_cause : null;
};
VError.info = function(err) {
    var rv, cause, k;
    mod_assertplus.ok(mod_isError(err), "err must be an Error");
    cause = VError.cause(err);
    if (cause !== null) rv = VError.info(cause);
    else rv = {};
    if (typeof err.jse_info == "object" && err.jse_info !== null) for(k in err.jse_info)rv[k] = err.jse_info[k];
    return rv;
};
VError.findCauseByName = function(err, name) {
    var cause;
    mod_assertplus.ok(mod_isError(err), "err must be an Error");
    mod_assertplus.string(name, "name");
    mod_assertplus.ok(name.length > 0, "name cannot be empty");
    for(cause = err; cause !== null; cause = VError.cause(cause)){
        mod_assertplus.ok(mod_isError(cause));
        if (cause.name == name) return cause;
    }
    return null;
};
VError.hasCauseWithName = function(err, name) {
    return VError.findCauseByName(err, name) !== null;
};
VError.fullStack = function(err) {
    mod_assertplus.ok(mod_isError(err), "err must be an Error");
    var cause = VError.cause(err);
    if (cause) return err.stack + "\ncaused by: " + VError.fullStack(cause);
    return err.stack;
};
VError.errorFromList = function(errors) {
    mod_assertplus.arrayOfObject(errors, "errors");
    if (errors.length === 0) return null;
    errors.forEach(function(e) {
        mod_assertplus.ok(mod_isError(e));
    });
    if (errors.length == 1) return errors[0];
    return new MultiError(errors);
};
VError.errorForEach = function(err, func) {
    mod_assertplus.ok(mod_isError(err), "err must be an Error");
    mod_assertplus.func(func, "func");
    if (err instanceof MultiError) err.errors().forEach(function iterError(e) {
        func(e);
    });
    else func(err);
};
/*
 * SError is like VError, but stricter about types.  You cannot pass "null" or
 * "undefined" as string arguments to the formatter.
 */ function SError() {
    var args, obj, parsed, options;
    args = Array.prototype.slice.call(arguments, 0);
    if (!(this instanceof SError)) {
        obj = Object.create(SError.prototype);
        SError.apply(obj, arguments);
        return obj;
    }
    parsed = parseConstructorArguments({
        "argv": args,
        "strict": true
    });
    options = parsed.options;
    VError.call(this, options, "%s", parsed.shortmessage);
    return this;
}
/*
 * We don't bother setting SError.prototype.name because once constructed,
 * SErrors are just like VErrors.
 */ mod_util.inherits(SError, VError);
/*
 * Represents a collection of errors for the purpose of consumers that generally
 * only deal with one error.  Callers can extract the individual errors
 * contained in this object, but may also just treat it as a normal single
 * error, in which case a summary message will be printed.
 */ function MultiError(errors) {
    mod_assertplus.array(errors, "list of errors");
    mod_assertplus.ok(errors.length > 0, "must be at least one error");
    this.ase_errors = errors;
    VError.call(this, {
        "cause": errors[0]
    }, "first of %d error%s", errors.length, errors.length == 1 ? "" : "s");
}
mod_util.inherits(MultiError, VError);
MultiError.prototype.name = "MultiError";
MultiError.prototype.errors = function me_errors() {
    return this.ase_errors.slice(0);
};
/*
 * See README.md for reference details.
 */ function WError() {
    var args, obj, parsed, options;
    args = Array.prototype.slice.call(arguments, 0);
    if (!(this instanceof WError)) {
        obj = Object.create(WError.prototype);
        WError.apply(obj, args);
        return obj;
    }
    parsed = parseConstructorArguments({
        "argv": args,
        "strict": false
    });
    options = parsed.options;
    options["skipCauseMessage"] = true;
    VError.call(this, options, "%s", parsed.shortmessage);
    return this;
}
mod_util.inherits(WError, VError);
WError.prototype.name = "WError";
WError.prototype.toString = function we_toString() {
    var str = this.hasOwnProperty("name") && this.name || this.constructor.name || this.constructor.prototype.name;
    if (this.message) str += ": " + this.message;
    if (this.jse_cause && this.jse_cause.message) str += "; caused by " + this.jse_cause.toString();
    return str;
};
/*
 * For purely historical reasons, WError's cause() function allows you to set
 * the cause.
 */ WError.prototype.cause = function we_cause(c) {
    if (mod_isError(c)) this.jse_cause = c;
    return this.jse_cause;
};

},{"f362294f9a4d3eb":"eQsu4","4ae6e3d1cc937a66":"dJawj","2465de02351d6bf1":"gJ2oh","8d89ec5307a0f358":"kplqf"}],"kplqf":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var Buffer = require("a99a0c498124c3ab").Buffer;
function isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return objectToString(arg) === "[object Array]";
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === "boolean";
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === "number";
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === "string";
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === "symbol";
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return objectToString(re) === "[object RegExp]";
}
exports.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return objectToString(d) === "[object Date]";
}
exports.isDate = isDate;
function isError(e) {
    return objectToString(e) === "[object Error]" || e instanceof Error;
}
exports.isError = isError;
function isFunction(arg) {
    return typeof arg === "function";
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = Buffer.isBuffer;
function objectToString(o) {
    return Object.prototype.toString.call(o);
}

},{"a99a0c498124c3ab":"8EcTH"}],"g38xr":[function(require,module,exports) {
/**
 * JSONSchema Validator - Validates JavaScript objects using JSON Schemas
 *	(http://www.json.com/json-schema-proposal/)
 * Licensed under AFL-2.1 OR BSD-3-Clause
To use the validator call the validate function with an instance object and an optional schema object.
If a schema is provided, it will be used to validate. If the instance object refers to a schema (self-validating),
that schema will be used to validate and the schema parameter is not necessary (if both exist,
both validations will occur).
The validate method will return an array of validation errors. If there are no errors, then an
empty list will be returned. A validation error will have two properties:
"property" which indicates which property had the error
"message" which indicates what the error was
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return factory();
    });
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals
    root.jsonSchema = factory();
})(this, function() {
    var exports = validate;
    exports.Integer = {
        type: "integer"
    };
    var primitiveConstructors = {
        String: String,
        Boolean: Boolean,
        Number: Number,
        Object: Object,
        Array: Array,
        Date: Date
    };
    exports.validate = validate;
    function validate(/*Any*/ instance, /*Object*/ schema) {
        // Summary:
        //  	To use the validator call JSONSchema.validate with an instance object and an optional schema object.
        // 		If a schema is provided, it will be used to validate. If the instance object refers to a schema (self-validating),
        // 		that schema will be used to validate and the schema parameter is not necessary (if both exist,
        // 		both validations will occur).
        // 		The validate method will return an object with two properties:
        // 			valid: A boolean indicating if the instance is valid by the schema
        // 			errors: An array of validation errors. If there are no errors, then an
        // 					empty list will be returned. A validation error will have two properties:
        // 						property: which indicates which property had the error
        // 						message: which indicates what the error was
        //
        return validate(instance, schema, {
            changing: false
        }); //, coerce: false, existingOnly: false});
    }
    exports.checkPropertyChange = function(/*Any*/ value, /*Object*/ schema, /*String*/ property) {
        // Summary:
        // 		The checkPropertyChange method will check to see if an value can legally be in property with the given schema
        // 		This is slightly different than the validate method in that it will fail if the schema is readonly and it will
        // 		not check for self-validation, it is assumed that the passed in value is already internally valid.
        // 		The checkPropertyChange method will return the same object type as validate, see JSONSchema.validate for
        // 		information.
        //
        return validate(value, schema, {
            changing: property || "property"
        });
    };
    var validate = exports._validate = function(/*Any*/ instance, /*Object*/ schema, /*Object*/ options) {
        if (!options) options = {};
        var _changing = options.changing;
        function getType(schema) {
            return schema.type || primitiveConstructors[schema.name] == schema && schema.name.toLowerCase();
        }
        var errors = [];
        // validate a value against a property definition
        function checkProp(value, schema, path, i) {
            var l;
            path += path ? typeof i == "number" ? "[" + i + "]" : typeof i == "undefined" ? "" : "." + i : i;
            function addError(message) {
                errors.push({
                    property: path,
                    message: message
                });
            }
            if ((typeof schema != "object" || schema instanceof Array) && (path || typeof schema != "function") && !(schema && getType(schema))) {
                if (typeof schema == "function") {
                    if (!(value instanceof schema)) addError("is not an instance of the class/constructor " + schema.name);
                } else if (schema) addError("Invalid schema/property definition " + schema);
                return null;
            }
            if (_changing && schema.readonly) addError("is a readonly field, it can not be changed");
            if (schema["extends"]) checkProp(value, schema["extends"], path, i);
            // validate a value against a type definition
            function checkType(type, value) {
                if (type) {
                    if (typeof type == "string" && type != "any" && (type == "null" ? value !== null : typeof value != type) && !(value instanceof Array && type == "array") && !(value instanceof Date && type == "date") && !(type == "integer" && value % 1 === 0)) return [
                        {
                            property: path,
                            message: value + " - " + typeof value + " value found, but a " + type + " is required"
                        }
                    ];
                    if (type instanceof Array) {
                        var unionErrors = [];
                        for(var j = 0; j < type.length; j++){
                            if (!(unionErrors = checkType(type[j], value)).length) break;
                        }
                        if (unionErrors.length) return unionErrors;
                    } else if (typeof type == "object") {
                        var priorErrors = errors;
                        errors = [];
                        checkProp(value, type, path);
                        var theseErrors = errors;
                        errors = priorErrors;
                        return theseErrors;
                    }
                }
                return [];
            }
            if (value === undefined) {
                if (schema.required) addError("is missing and it is required");
            } else {
                errors = errors.concat(checkType(getType(schema), value));
                if (schema.disallow && !checkType(schema.disallow, value).length) addError(" disallowed value was matched");
                if (value !== null) {
                    if (value instanceof Array) {
                        if (schema.items) {
                            var itemsIsArray = schema.items instanceof Array;
                            var propDef = schema.items;
                            for(i = 0, l = value.length; i < l; i += 1){
                                if (itemsIsArray) propDef = schema.items[i];
                                if (options.coerce) value[i] = options.coerce(value[i], propDef);
                                errors.concat(checkProp(value[i], propDef, path, i));
                            }
                        }
                        if (schema.minItems && value.length < schema.minItems) addError("There must be a minimum of " + schema.minItems + " in the array");
                        if (schema.maxItems && value.length > schema.maxItems) addError("There must be a maximum of " + schema.maxItems + " in the array");
                    } else if (schema.properties || schema.additionalProperties) errors.concat(checkObj(value, schema.properties, path, schema.additionalProperties));
                    if (schema.pattern && typeof value == "string" && !value.match(schema.pattern)) addError("does not match the regex pattern " + schema.pattern);
                    if (schema.maxLength && typeof value == "string" && value.length > schema.maxLength) addError("may only be " + schema.maxLength + " characters long");
                    if (schema.minLength && typeof value == "string" && value.length < schema.minLength) addError("must be at least " + schema.minLength + " characters long");
                    if (typeof schema.minimum !== "undefined" && typeof value == typeof schema.minimum && schema.minimum > value) addError("must have a minimum value of " + schema.minimum);
                    if (typeof schema.maximum !== "undefined" && typeof value == typeof schema.maximum && schema.maximum < value) addError("must have a maximum value of " + schema.maximum);
                    if (schema["enum"]) {
                        var enumer = schema["enum"];
                        l = enumer.length;
                        var found;
                        for(var j = 0; j < l; j++)if (enumer[j] === value) {
                            found = 1;
                            break;
                        }
                        if (!found) addError("does not have a value in the enumeration " + enumer.join(", "));
                    }
                    if (typeof schema.maxDecimal == "number" && value.toString().match(new RegExp("\\.[0-9]{" + (schema.maxDecimal + 1) + ",}"))) addError("may only have " + schema.maxDecimal + " digits of decimal places");
                }
            }
            return null;
        }
        // validate an object against a schema
        function checkObj(instance, objTypeDef, path, additionalProp) {
            if (typeof objTypeDef == "object") {
                if (typeof instance != "object" || instance instanceof Array) errors.push({
                    property: path,
                    message: "an object is required"
                });
                for(var i in objTypeDef)if (objTypeDef.hasOwnProperty(i) && i != "__proto__" && i != "constructor") {
                    var value = instance.hasOwnProperty(i) ? instance[i] : undefined;
                    // skip _not_ specified properties
                    if (value === undefined && options.existingOnly) continue;
                    var propDef = objTypeDef[i];
                    // set default
                    if (value === undefined && propDef["default"]) value = instance[i] = propDef["default"];
                    if (options.coerce && i in instance) value = instance[i] = options.coerce(value, propDef);
                    checkProp(value, propDef, path, i);
                }
            }
            for(i in instance){
                if (instance.hasOwnProperty(i) && !(i.charAt(0) == "_" && i.charAt(1) == "_") && objTypeDef && !objTypeDef[i] && additionalProp === false) {
                    if (options.filter) {
                        delete instance[i];
                        continue;
                    } else errors.push({
                        property: path,
                        message: "The property " + i + " is not defined in the schema and the schema does not allow additional properties"
                    });
                }
                var requires = objTypeDef && objTypeDef[i] && objTypeDef[i].requires;
                if (requires && !(requires in instance)) errors.push({
                    property: path,
                    message: "the presence of the property " + i + " requires that " + requires + " also be present"
                });
                value = instance[i];
                if (additionalProp && (!(objTypeDef && typeof objTypeDef == "object") || !(i in objTypeDef))) {
                    if (options.coerce) value = instance[i] = options.coerce(value, additionalProp);
                    checkProp(value, additionalProp, path, i);
                }
                if (!_changing && value && value.$schema) errors = errors.concat(checkProp(value, value.$schema, path, i));
            }
            return errors;
        }
        if (schema) checkProp(instance, schema, "", _changing || "");
        if (!_changing && instance && instance.$schema) checkProp(instance, instance.$schema, "", "");
        return {
            valid: !errors.length,
            errors: errors
        };
    };
    exports.mustBeValid = function(result) {
        //	summary:
        //		This checks to ensure that the result is valid and will throw an appropriate error message if it is not
        // result: the result returned from checkPropertyChange or validate
        if (!result.valid) throw new TypeError(result.errors.map(function(error) {
            return "for property " + error.property + ": " + error.message;
        }).join(", \n"));
    };
    return exports;
});

},{}],"9n3Pq":[function(require,module,exports) {
// Copyright 2015 Joyent, Inc.
var Buffer = require("e1d125044efdd4a1").Buffer;
var assert = require("52ac09d90117e139");
var crypto = require("9c520dc0c05a421a");
var sshpk = require("a743031db3da4f2c");
var utils = require("661306ec7069f086");
var HASH_ALGOS = utils.HASH_ALGOS;
var PK_ALGOS = utils.PK_ALGOS;
var InvalidAlgorithmError = utils.InvalidAlgorithmError;
var HttpSignatureError = utils.HttpSignatureError;
var validateAlgorithm = utils.validateAlgorithm;
///--- Exported API
module.exports = {
    /**
   * Verify RSA/DSA signature against public key.  You are expected to pass in
   * an object that was returned from `parse()`.
   *
   * @param {Object} parsedSignature the object you got from `parse`.
   * @param {String} pubkey RSA/DSA private key PEM.
   * @return {Boolean} true if valid, false otherwise.
   * @throws {TypeError} if you pass in bad arguments.
   * @throws {InvalidAlgorithmError}
   */ verifySignature: function verifySignature(parsedSignature, pubkey) {
        assert.object(parsedSignature, "parsedSignature");
        if (typeof pubkey === "string" || Buffer.isBuffer(pubkey)) pubkey = sshpk.parseKey(pubkey);
        assert.ok(sshpk.Key.isKey(pubkey, [
            1,
            1
        ]), "pubkey must be a sshpk.Key");
        var alg = validateAlgorithm(parsedSignature.algorithm);
        if (alg[0] === "hmac" || alg[0] !== pubkey.type) return false;
        var v = pubkey.createVerify(alg[1]);
        v.update(parsedSignature.signingString);
        return v.verify(parsedSignature.params.signature, "base64");
    },
    /**
   * Verify HMAC against shared secret.  You are expected to pass in an object
   * that was returned from `parse()`.
   *
   * @param {Object} parsedSignature the object you got from `parse`.
   * @param {String} secret HMAC shared secret.
   * @return {Boolean} true if valid, false otherwise.
   * @throws {TypeError} if you pass in bad arguments.
   * @throws {InvalidAlgorithmError}
   */ verifyHMAC: function verifyHMAC(parsedSignature, secret) {
        assert.object(parsedSignature, "parsedHMAC");
        assert.string(secret, "secret");
        var alg = validateAlgorithm(parsedSignature.algorithm);
        if (alg[0] !== "hmac") return false;
        var hashAlg = alg[1].toUpperCase();
        var hmac = crypto.createHmac(hashAlg, secret);
        hmac.update(parsedSignature.signingString);
        /*
     * Now double-hash to avoid leaking timing information - there's
     * no easy constant-time compare in JS, so we use this approach
     * instead. See for more info:
     * https://www.isecpartners.com/blog/2011/february/double-hmac-
     * verification.aspx
     */ var h1 = crypto.createHmac(hashAlg, secret);
        h1.update(hmac.digest());
        h1 = h1.digest();
        var h2 = crypto.createHmac(hashAlg, secret);
        h2.update(new Buffer(parsedSignature.params.signature, "base64"));
        h2 = h2.digest();
        /* Node 0.8 returns strings from .digest(). */ if (typeof h1 === "string") return h1 === h2;
        /* And node 0.10 lacks the .equals() method on Buffers. */ if (Buffer.isBuffer(h1) && !h1.equals) return h1.toString("binary") === h2.toString("binary");
        return h1.equals(h2);
    }
};

},{"e1d125044efdd4a1":"8EcTH","52ac09d90117e139":"eQsu4","9c520dc0c05a421a":"8Nkdo","a743031db3da4f2c":"hjXTA","661306ec7069f086":"g8tYW"}],"brM3d":[function(require,module,exports) {
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module dependencies.
 * @private
 */ var db = require("ace739025dfd8cbe");
var extname = require("78bb9d9d5bf0d5fb").extname;
/**
 * Module variables.
 * @private
 */ var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var TEXT_TYPE_REGEXP = /^text\//i;
/**
 * Module exports.
 * @public
 */ exports.charset = charset;
exports.charsets = {
    lookup: charset
};
exports.contentType = contentType;
exports.extension = extension;
exports.extensions = Object.create(null);
exports.lookup = lookup;
exports.types = Object.create(null);
// Populate the extensions/types maps
populateMaps(exports.extensions, exports.types);
/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function charset(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = EXTRACT_TYPE_REGEXP.exec(type);
    var mime = match && db[match[1].toLowerCase()];
    if (mime && mime.charset) return mime.charset;
    // default text/* to utf-8
    if (match && TEXT_TYPE_REGEXP.test(match[1])) return "UTF-8";
    return false;
}
/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */ function contentType(str) {
    // TODO: should this even be in this module?
    if (!str || typeof str !== "string") return false;
    var mime = str.indexOf("/") === -1 ? exports.lookup(str) : str;
    if (!mime) return false;
    // TODO: use content-type or other module
    if (mime.indexOf("charset") === -1) {
        var charset = exports.charset(mime);
        if (charset) mime += "; charset=" + charset.toLowerCase();
    }
    return mime;
}
/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function extension(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = EXTRACT_TYPE_REGEXP.exec(type);
    // get extensions
    var exts = match && exports.extensions[match[1].toLowerCase()];
    if (!exts || !exts.length) return false;
    return exts[0];
}
/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */ function lookup(path) {
    if (!path || typeof path !== "string") return false;
    // get the extension ("ext" or ".ext" or full path)
    var extension = extname("x." + path).toLowerCase().substr(1);
    if (!extension) return false;
    return exports.types[extension] || false;
}
/**
 * Populate the extensions and types maps.
 * @private
 */ function populateMaps(extensions, types) {
    // source preference (least -> most)
    var preference = [
        "nginx",
        "apache",
        undefined,
        "iana"
    ];
    Object.keys(db).forEach(function forEachMimeType(type) {
        var mime = db[type];
        var exts = mime.extensions;
        if (!exts || !exts.length) return;
        // mime -> extensions
        extensions[type] = exts;
        // extension -> mime
        for(var i = 0; i < exts.length; i++){
            var extension = exts[i];
            if (types[extension]) {
                var from = preference.indexOf(db[types[extension]].source);
                var to = preference.indexOf(mime.source);
                if (types[extension] !== "application/octet-stream" && (from > to || from === to && types[extension].substr(0, 12) === "application/")) continue;
            }
            // set the extension -> mime
            types[extension] = type;
        }
    });
}

},{"ace739025dfd8cbe":"7721O","78bb9d9d5bf0d5fb":"8Rtcy"}],"7721O":[function(require,module,exports) {
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 */ module.exports = require("a51592ae0ec681a8");

},{"a51592ae0ec681a8":"1tspt"}],"1tspt":[function(require,module,exports) {
module.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

},{}],"8Rtcy":[function(require,module,exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("c0743715070b1b8a");
"use strict";
function assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function _format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = process.cwd();
                path = cwd;
            }
            assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return posix.normalize(joined);
    },
    relative: function relative(from, to) {
        assertPath(from);
        assertPath(to);
        if (from === to) return "";
        from = posix.resolve(from);
        to = posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return _format("/", pathObject);
    },
    parse: function parse(path) {
        assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
posix.posix = posix;
module.exports = posix;

},{"c0743715070b1b8a":"g1F5c"}],"bFaGJ":[function(require,module,exports) {
function Caseless(dict) {
    this.dict = dict || {};
}
Caseless.prototype.set = function(name, value, clobber) {
    if (typeof name === "object") for(var i in name)this.set(i, name[i], value);
    else {
        if (typeof clobber === "undefined") clobber = true;
        var has = this.has(name);
        if (!clobber && has) this.dict[has] = this.dict[has] + "," + value;
        else this.dict[has || name] = value;
        return has;
    }
};
Caseless.prototype.has = function(name) {
    var keys = Object.keys(this.dict), name = name.toLowerCase();
    for(var i = 0; i < keys.length; i++){
        if (keys[i].toLowerCase() === name) return keys[i];
    }
    return false;
};
Caseless.prototype.get = function(name) {
    name = name.toLowerCase();
    var result, _key;
    var headers = this.dict;
    Object.keys(headers).forEach(function(key) {
        _key = key.toLowerCase();
        if (name === _key) result = headers[key];
    });
    return result;
};
Caseless.prototype.swap = function(name) {
    var has = this.has(name);
    if (has === name) return;
    if (!has) throw new Error('There is no header than matches "' + name + '"');
    this.dict[name] = this.dict[has];
    delete this.dict[has];
};
Caseless.prototype.del = function(name) {
    var has = this.has(name);
    return delete this.dict[has || name];
};
module.exports = function(dict) {
    return new Caseless(dict);
};
module.exports.httpify = function(resp, headers) {
    var c = new Caseless(headers);
    resp.setHeader = function(key, value, clobber) {
        if (typeof value === "undefined") return;
        return c.set(key, value, clobber);
    };
    resp.hasHeader = function(key) {
        return c.has(key);
    };
    resp.getHeader = function(key) {
        return c.get(key);
    };
    resp.removeHeader = function(key) {
        return c.del(key);
    };
    resp.headers = c.dict;
    return c;
};

},{}],"3bEaC":[function(require,module,exports) {
module.exports = ForeverAgent;
ForeverAgent.SSL = ForeverAgentSSL;
var util = require("4fbba935c998d209"), Agent = require("fe95ca3ba7ca416f").Agent, net = require("c226c6a300856db1"), tls = require("5e61155ec41541af"), AgentSSL = require("805fe884a5071f35").Agent;
function getConnectionName(host, port) {
    var name = "";
    if (typeof host === "string") name = host + ":" + port;
    else // For node.js v012.0 and iojs-v1.5.1, host is an object. And any existing localAddress is part of the connection name.
    name = host.host + ":" + host.port + ":" + (host.localAddress ? host.localAddress + ":" : ":");
    return name;
}
function ForeverAgent(options) {
    var self = this;
    self.options = options || {};
    self.requests = {};
    self.sockets = {};
    self.freeSockets = {};
    self.maxSockets = self.options.maxSockets || Agent.defaultMaxSockets;
    self.minSockets = self.options.minSockets || ForeverAgent.defaultMinSockets;
    self.on("free", function(socket, host, port) {
        var name = getConnectionName(host, port);
        if (self.requests[name] && self.requests[name].length) self.requests[name].shift().onSocket(socket);
        else if (self.sockets[name].length < self.minSockets) {
            if (!self.freeSockets[name]) self.freeSockets[name] = [];
            self.freeSockets[name].push(socket);
            // if an error happens while we don't use the socket anyway, meh, throw the socket away
            var onIdleError = function() {
                socket.destroy();
            };
            socket._onIdleError = onIdleError;
            socket.on("error", onIdleError);
        } else // If there are no pending requests just destroy the
        // socket and it will get removed from the pool. This
        // gets us out of timeout issues and allows us to
        // default to Connection:keep-alive.
        socket.destroy();
    });
}
util.inherits(ForeverAgent, Agent);
ForeverAgent.defaultMinSockets = 5;
ForeverAgent.prototype.createConnection = net.createConnection;
ForeverAgent.prototype.addRequestNoreuse = Agent.prototype.addRequest;
ForeverAgent.prototype.addRequest = function(req, host, port) {
    var name = getConnectionName(host, port);
    if (typeof host !== "string") {
        var options = host;
        port = options.port;
        host = options.host;
    }
    if (this.freeSockets[name] && this.freeSockets[name].length > 0 && !req.useChunkedEncodingByDefault) {
        var idleSocket = this.freeSockets[name].pop();
        idleSocket.removeListener("error", idleSocket._onIdleError);
        delete idleSocket._onIdleError;
        req._reusedSocket = true;
        req.onSocket(idleSocket);
    } else this.addRequestNoreuse(req, host, port);
};
ForeverAgent.prototype.removeSocket = function(s, name, host, port) {
    if (this.sockets[name]) {
        var index = this.sockets[name].indexOf(s);
        if (index !== -1) this.sockets[name].splice(index, 1);
    } else if (this.sockets[name] && this.sockets[name].length === 0) {
        // don't leak
        delete this.sockets[name];
        delete this.requests[name];
    }
    if (this.freeSockets[name]) {
        var index = this.freeSockets[name].indexOf(s);
        if (index !== -1) {
            this.freeSockets[name].splice(index, 1);
            if (this.freeSockets[name].length === 0) delete this.freeSockets[name];
        }
    }
    if (this.requests[name] && this.requests[name].length) // If we have pending requests and a socket gets closed a new one
    // needs to be created to take over in the pool for the one that closed.
    this.createSocket(name, host, port).emit("free");
};
function ForeverAgentSSL(options) {
    ForeverAgent.call(this, options);
}
util.inherits(ForeverAgentSSL, ForeverAgent);
ForeverAgentSSL.prototype.createConnection = createConnectionSSL;
ForeverAgentSSL.prototype.addRequestNoreuse = AgentSSL.prototype.addRequest;
function createConnectionSSL(port, host, options) {
    if (typeof port === "object") options = port;
    else if (typeof host === "object") options = host;
    else if (typeof options === "object") options;
    else options = {};
    if (typeof port === "number") options.port = port;
    if (typeof host === "string") options.host = host;
    return tls.connect(options);
}

},{"4fbba935c998d209":"dJawj","fe95ca3ba7ca416f":"cbdR9","c226c6a300856db1":"49Rpi","5e61155ec41541af":"49Rpi","805fe884a5071f35":"8PzwZ"}],"65ggs":[function(require,module,exports) {
/* eslint-env browser */ module.exports = typeof self == "object" ? self.FormData : window.FormData;

},{}],"gQPoJ":[function(require,module,exports) {
var stream = require("f4e22ac9482f9d59");
function isStream(obj) {
    return obj instanceof stream.Stream;
}
function isReadable(obj) {
    return isStream(obj) && typeof obj._read == "function" && typeof obj._readableState == "object";
}
function isWritable(obj) {
    return isStream(obj) && typeof obj._write == "function" && typeof obj._writableState == "object";
}
function isDuplex(obj) {
    return isReadable(obj) && isWritable(obj);
}
module.exports = isStream;
module.exports.isReadable = isReadable;
module.exports.isWritable = isWritable;
module.exports.isDuplex = isDuplex;

},{"f4e22ac9482f9d59":"4ooMZ"}],"cjuX2":[function(require,module,exports) {
module.exports = isTypedArray;
isTypedArray.strict = isStrictTypedArray;
isTypedArray.loose = isLooseTypedArray;
var toString = Object.prototype.toString;
var names = {
    "[object Int8Array]": true,
    "[object Int16Array]": true,
    "[object Int32Array]": true,
    "[object Uint8Array]": true,
    "[object Uint8ClampedArray]": true,
    "[object Uint16Array]": true,
    "[object Uint32Array]": true,
    "[object Float32Array]": true,
    "[object Float64Array]": true
};
function isTypedArray(arr) {
    return isStrictTypedArray(arr) || isLooseTypedArray(arr);
}
function isStrictTypedArray(arr) {
    return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
}
function isLooseTypedArray(arr) {
    return names[toString.call(arr)];
}

},{}],"rJJlY":[function(require,module,exports) {
"use strict";
function formatHostname(hostname) {
    // canonicalize the hostname, so that 'oogle.com' won't match 'google.com'
    return hostname.replace(/^\.*/, ".").toLowerCase();
}
function parseNoProxyZone(zone) {
    zone = zone.trim().toLowerCase();
    var zoneParts = zone.split(":", 2);
    var zoneHost = formatHostname(zoneParts[0]);
    var zonePort = zoneParts[1];
    var hasPort = zone.indexOf(":") > -1;
    return {
        hostname: zoneHost,
        port: zonePort,
        hasPort: hasPort
    };
}
function uriInNoProxy(uri, noProxy) {
    var port = uri.port || (uri.protocol === "https:" ? "443" : "80");
    var hostname = formatHostname(uri.hostname);
    var noProxyList = noProxy.split(",");
    // iterate through the noProxyList until it finds a match.
    return noProxyList.map(parseNoProxyZone).some(function(noProxyZone) {
        var isMatchedAt = hostname.indexOf(noProxyZone.hostname);
        var hostnameMatched = isMatchedAt > -1 && isMatchedAt === hostname.length - noProxyZone.hostname.length;
        if (noProxyZone.hasPort) return port === noProxyZone.port && hostnameMatched;
        return hostnameMatched;
    });
}
function getProxyFromURI(uri) {
    // Decide the proper request proxy to use based on the request URI object and the
    // environmental variables (NO_PROXY, HTTP_PROXY, etc.)
    // respect NO_PROXY environment variables (see: https://lynx.invisible-island.net/lynx2.8.7/breakout/lynx_help/keystrokes/environments.html)
    var noProxy = "";
    // if the noProxy is a wildcard then return null
    if (noProxy === "*") return null;
    // if the noProxy is not empty and the uri is found return null
    if (noProxy !== "" && uriInNoProxy(uri, noProxy)) return null;
    // Check for HTTP or HTTPS Proxy in environment Else default to null
    if (uri.protocol === "http:") return null;
    if (uri.protocol === "https:") return null;
    // if none of that works, return null
    // (What uri protocol are you using then?)
    return null;
}
module.exports = getProxyFromURI;

},{}],"gpgkX":[function(require,module,exports) {
"use strict";
var qs = require("9548992d8ad29725");
var querystring = require("f66877b7647a7378");
function Querystring(request) {
    this.request = request;
    this.lib = null;
    this.useQuerystring = null;
    this.parseOptions = null;
    this.stringifyOptions = null;
}
Querystring.prototype.init = function(options) {
    if (this.lib) return;
    this.useQuerystring = options.useQuerystring;
    this.lib = this.useQuerystring ? querystring : qs;
    this.parseOptions = options.qsParseOptions || {};
    this.stringifyOptions = options.qsStringifyOptions || {};
};
Querystring.prototype.stringify = function(obj) {
    return this.useQuerystring ? this.rfc3986(this.lib.stringify(obj, this.stringifyOptions.sep || null, this.stringifyOptions.eq || null, this.stringifyOptions)) : this.lib.stringify(obj, this.stringifyOptions);
};
Querystring.prototype.parse = function(str) {
    return this.useQuerystring ? this.lib.parse(str, this.parseOptions.sep || null, this.parseOptions.eq || null, this.parseOptions) : this.lib.parse(str, this.parseOptions);
};
Querystring.prototype.rfc3986 = function(str) {
    return str.replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
Querystring.prototype.unescape = querystring.unescape;
exports.Querystring = Querystring;

},{"9548992d8ad29725":"k5Twq","f66877b7647a7378":"29QgD"}],"k5Twq":[function(require,module,exports) {
"use strict";
var stringify = require("a472ccaa2f2351e9");
var parse = require("7ffa4249597bf32b");
var formats = require("454df9476704f887");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"a472ccaa2f2351e9":"4Jd2B","7ffa4249597bf32b":"1B2eL","454df9476704f887":"i6tWH"}],"4Jd2B":[function(require,module,exports) {
"use strict";
var utils = require("44263cc7b702ebf");
var formats = require("929f8531a94a537c");
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaults = {
    delimiter: "&",
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        obj = "";
    }
    if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean" || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (skipNulls && obj[key] === null) continue;
        if (isArray(obj)) pushToArray(values, stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
        else pushToArray(values, stringify(obj[key], prefix + (allowDots ? "." + key : "[" + key + "]"), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
    }
    return values;
};
module.exports = function(object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};
    if (options.encoder !== null && typeof options.encoder !== "undefined" && typeof options.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var delimiter = typeof options.delimiter === "undefined" ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === "boolean" ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === "boolean" ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === "boolean" ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === "function" ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === "function" ? options.sort : null;
    var allowDots = typeof options.allowDots === "undefined" ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === "function" ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === "boolean" ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === "undefined") options.format = formats["default"];
    else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) throw new TypeError("Unknown format option provided.");
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) arrayFormat = options.arrayFormat;
    else if ("indices" in options) arrayFormat = options.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (sort) objKeys.sort(sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (skipNulls && obj[key] === null) continue;
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode ? encoder : null, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
    }
    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    return joined.length > 0 ? prefix + joined : "";
};

},{"44263cc7b702ebf":"7cJgd","929f8531a94a537c":"i6tWH"}],"7cJgd":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty;
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var compactQueue = function compactQueue(queue) {
    var obj;
    while(queue.length){
        var item = queue.pop();
        obj = item.obj[item.prop];
        if (Array.isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
    return obj;
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    if (!source) return target;
    if (typeof source !== "object") {
        if (Array.isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) mergeTarget = arrayToObject(target, options);
    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, " "));
    } catch (e) {
        return str;
    }
};
var encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = typeof str === "string" ? str : String(str);
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    return compactQueue(queue);
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === "undefined") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};

},{}],"i6tWH":[function(require,module,exports) {
"use strict";
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
module.exports = {
    "default": "RFC3986",
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};

},{}],"1B2eL":[function(require,module,exports) {
"use strict";
var utils = require("e76649c95dd0e736");
var has = Object.prototype.hasOwnProperty;
var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    for(var i = 0; i < parts.length; ++i){
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) obj[key] = [].concat(obj[key]).concat(val);
        else obj[key] = val;
    }
    return obj;
};
var parseObject = function(chain, val, options) {
    var leaf = val;
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return parseObject(keys, val, options);
};
module.exports = function(str, opts) {
    var options = opts ? utils.assign({}, opts) : {};
    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === "string" || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === "number" ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === "number" ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === "function" ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === "boolean" ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === "boolean" ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === "boolean" ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === "number" ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === "boolean" ? options.strictNullHandling : defaults.strictNullHandling;
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }
    return utils.compact(obj);
};

},{"e76649c95dd0e736":"7cJgd"}],"aBs4M":[function(require,module,exports) {
"use strict";
var fs = require("53ef3902c30f605");
var qs = require("ee6217ed506d3ea");
var validate = require("9cc1a8dd4a127f57");
var extend = require("8792946b8dea58f7");
function Har(request) {
    this.request = request;
}
Har.prototype.reducer = function(obj, pair) {
    // new property ?
    if (obj[pair.name] === undefined) {
        obj[pair.name] = pair.value;
        return obj;
    }
    // existing? convert to array
    var arr = [
        obj[pair.name],
        pair.value
    ];
    obj[pair.name] = arr;
    return obj;
};
Har.prototype.prep = function(data) {
    // construct utility properties
    data.queryObj = {};
    data.headersObj = {};
    data.postData.jsonObj = false;
    data.postData.paramsObj = false;
    // construct query objects
    if (data.queryString && data.queryString.length) data.queryObj = data.queryString.reduce(this.reducer, {});
    // construct headers objects
    if (data.headers && data.headers.length) // loweCase header keys
    data.headersObj = data.headers.reduceRight(function(headers, header) {
        headers[header.name] = header.value;
        return headers;
    }, {});
    // construct Cookie header
    if (data.cookies && data.cookies.length) {
        var cookies = data.cookies.map(function(cookie) {
            return cookie.name + "=" + cookie.value;
        });
        if (cookies.length) data.headersObj.cookie = cookies.join("; ");
    }
    // prep body
    function some(arr) {
        return arr.some(function(type) {
            return data.postData.mimeType.indexOf(type) === 0;
        });
    }
    if (some([
        "multipart/mixed",
        "multipart/related",
        "multipart/form-data",
        "multipart/alternative"
    ])) // reset values
    data.postData.mimeType = "multipart/form-data";
    else if (some([
        "application/x-www-form-urlencoded"
    ])) {
        if (!data.postData.params) data.postData.text = "";
        else {
            data.postData.paramsObj = data.postData.params.reduce(this.reducer, {});
            // always overwrite
            data.postData.text = qs.stringify(data.postData.paramsObj);
        }
    } else if (some([
        "text/json",
        "text/x-json",
        "application/json",
        "application/x-json"
    ])) {
        data.postData.mimeType = "application/json";
        if (data.postData.text) try {
            data.postData.jsonObj = JSON.parse(data.postData.text);
        } catch (e) {
            this.request.debug(e);
            // force back to text/plain
            data.postData.mimeType = "text/plain";
        }
    }
    return data;
};
Har.prototype.options = function(options) {
    // skip if no har property defined
    if (!options.har) return options;
    var har = {};
    extend(har, options.har);
    // only process the first entry
    if (har.log && har.log.entries) har = har.log.entries[0];
    // add optional properties to make validation successful
    har.url = har.url || options.url || options.uri || options.baseUrl || "/";
    har.httpVersion = har.httpVersion || "HTTP/1.1";
    har.queryString = har.queryString || [];
    har.headers = har.headers || [];
    har.cookies = har.cookies || [];
    har.postData = har.postData || {};
    har.postData.mimeType = har.postData.mimeType || "application/octet-stream";
    har.bodySize = 0;
    har.headersSize = 0;
    har.postData.size = 0;
    if (!validate.request(har)) return options;
    // clean up and get some utility properties
    var req = this.prep(har);
    // construct new options
    if (req.url) options.url = req.url;
    if (req.method) options.method = req.method;
    if (Object.keys(req.queryObj).length) options.qs = req.queryObj;
    if (Object.keys(req.headersObj).length) options.headers = req.headersObj;
    function test(type) {
        return req.postData.mimeType.indexOf(type) === 0;
    }
    if (test("application/x-www-form-urlencoded")) options.form = req.postData.paramsObj;
    else if (test("application/json")) {
        if (req.postData.jsonObj) {
            options.body = req.postData.jsonObj;
            options.json = true;
        }
    } else if (test("multipart/form-data")) {
        options.formData = {};
        req.postData.params.forEach(function(param) {
            var attachment = {};
            if (!param.fileName && !param.contentType) {
                options.formData[param.name] = param.value;
                return;
            }
            // attempt to read from disk!
            if (param.fileName && !param.value) attachment.value = fs.createReadStream(param.fileName);
            else if (param.value) attachment.value = param.value;
            if (param.fileName) attachment.options = {
                filename: param.fileName,
                contentType: param.contentType ? param.contentType : null
            };
            options.formData[param.name] = attachment;
        });
    } else if (req.postData.text) options.body = req.postData.text;
    return options;
};
exports.Har = Har;

},{"53ef3902c30f605":"49Rpi","ee6217ed506d3ea":"29QgD","9cc1a8dd4a127f57":"5lkz0","8792946b8dea58f7":"3ZGTo"}],"5lkz0":[function(require,module,exports) {
var Ajv = require("13a9498ba5c07019");
var HARError = require("f17020b95ff36227");
var schemas = require("845e64e454587674");
var ajv;
function createAjvInstance() {
    var ajv = new Ajv({
        allErrors: true
    });
    ajv.addMetaSchema(require("14996538e9a4de9e"));
    ajv.addSchema(schemas);
    return ajv;
}
function validate(name, data) {
    data = data || {};
    // validator config
    ajv = ajv || createAjvInstance();
    var validate = ajv.getSchema(name + ".json");
    return new Promise(function(resolve, reject) {
        var valid = validate(data);
        !valid ? reject(new HARError(validate.errors)) : resolve(data);
    });
}
exports.afterRequest = function(data) {
    return validate("afterRequest", data);
};
exports.beforeRequest = function(data) {
    return validate("beforeRequest", data);
};
exports.browser = function(data) {
    return validate("browser", data);
};
exports.cache = function(data) {
    return validate("cache", data);
};
exports.content = function(data) {
    return validate("content", data);
};
exports.cookie = function(data) {
    return validate("cookie", data);
};
exports.creator = function(data) {
    return validate("creator", data);
};
exports.entry = function(data) {
    return validate("entry", data);
};
exports.har = function(data) {
    return validate("har", data);
};
exports.header = function(data) {
    return validate("header", data);
};
exports.log = function(data) {
    return validate("log", data);
};
exports.page = function(data) {
    return validate("page", data);
};
exports.pageTimings = function(data) {
    return validate("pageTimings", data);
};
exports.postData = function(data) {
    return validate("postData", data);
};
exports.query = function(data) {
    return validate("query", data);
};
exports.request = function(data) {
    return validate("request", data);
};
exports.response = function(data) {
    return validate("response", data);
};
exports.timings = function(data) {
    return validate("timings", data);
};

},{"13a9498ba5c07019":"jZDJu","f17020b95ff36227":"jfi7v","845e64e454587674":"aIii4","14996538e9a4de9e":"kU3i9"}],"jZDJu":[function(require,module,exports) {
"use strict";
var compileSchema = require("47271b52ec342bf3"), resolve = require("684106ec39aac66a"), Cache = require("3f3318afa03c8cc2"), SchemaObject = require("133fca307f8b378d"), stableStringify = require("54dbf843afa2e098"), formats = require("5ce0154e30b5123b"), rules = require("bea7616b978ebab2"), $dataMetaSchema = require("c74d527a6834c50e"), util = require("2d3523db2b6bf504");
module.exports = Ajv;
Ajv.prototype.validate = validate;
Ajv.prototype.compile = compile;
Ajv.prototype.addSchema = addSchema;
Ajv.prototype.addMetaSchema = addMetaSchema;
Ajv.prototype.validateSchema = validateSchema;
Ajv.prototype.getSchema = getSchema;
Ajv.prototype.removeSchema = removeSchema;
Ajv.prototype.addFormat = addFormat;
Ajv.prototype.errorsText = errorsText;
Ajv.prototype._addSchema = _addSchema;
Ajv.prototype._compile = _compile;
Ajv.prototype.compileAsync = require("5ca6e2fd2da88e3b");
var customKeyword = require("6aa39a2dce2e2179");
Ajv.prototype.addKeyword = customKeyword.add;
Ajv.prototype.getKeyword = customKeyword.get;
Ajv.prototype.removeKeyword = customKeyword.remove;
Ajv.prototype.validateKeyword = customKeyword.validate;
var errorClasses = require("ee10d90085b3cd1a");
Ajv.ValidationError = errorClasses.Validation;
Ajv.MissingRefError = errorClasses.MissingRef;
Ajv.$dataMetaSchema = $dataMetaSchema;
var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
var META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes",
    "strictDefaults"
];
var META_SUPPORT_DATA = [
    "/properties"
];
/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */ function Ajv(opts) {
    if (!(this instanceof Ajv)) return new Ajv(opts);
    opts = this._opts = util.copy(opts) || {};
    setLogger(this);
    this._schemas = {};
    this._refs = {};
    this._fragments = {};
    this._formats = formats(opts.format);
    this._cache = opts.cache || new Cache;
    this._loadingSchemas = {};
    this._compilations = [];
    this.RULES = rules();
    this._getId = chooseGetId(opts);
    opts.loopRequired = opts.loopRequired || Infinity;
    if (opts.errorDataPath == "property") opts._errorDataPathProperty = true;
    if (opts.serialize === undefined) opts.serialize = stableStringify;
    this._metaOpts = getMetaSchemaOptions(this);
    if (opts.formats) addInitialFormats(this);
    if (opts.keywords) addInitialKeywords(this);
    addDefaultMetaSchema(this);
    if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
    if (opts.nullable) this.addKeyword("nullable", {
        metaSchema: {
            type: "boolean"
        }
    });
    addInitialSchemas(this);
}
/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */ function validate(schemaKeyRef, data) {
    var v;
    if (typeof schemaKeyRef == "string") {
        v = this.getSchema(schemaKeyRef);
        if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
    } else {
        var schemaObj = this._addSchema(schemaKeyRef);
        v = schemaObj.validate || this._compile(schemaObj);
    }
    var valid = v(data);
    if (v.$async !== true) this.errors = v.errors;
    return valid;
}
/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */ function compile(schema, _meta) {
    var schemaObj = this._addSchema(schema, undefined, _meta);
    return schemaObj.validate || this._compile(schemaObj);
}
/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */ function addSchema(schema, key, _skipValidation, _meta) {
    if (Array.isArray(schema)) {
        for(var i = 0; i < schema.length; i++)this.addSchema(schema[i], undefined, _skipValidation, _meta);
        return this;
    }
    var id = this._getId(schema);
    if (id !== undefined && typeof id != "string") throw new Error("schema id must be string");
    key = resolve.normalizeId(key || id);
    checkUnique(this, key);
    this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
    return this;
}
/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */ function addMetaSchema(schema, key, skipValidation) {
    this.addSchema(schema, key, skipValidation, true);
    return this;
}
/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */ function validateSchema(schema, throwOrLogError) {
    var $schema = schema.$schema;
    if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
    $schema = $schema || this._opts.defaultMeta || defaultMeta(this);
    if (!$schema) {
        this.logger.warn("meta-schema not available");
        this.errors = null;
        return true;
    }
    var valid = this.validate($schema, schema);
    if (!valid && throwOrLogError) {
        var message = "schema is invalid: " + this.errorsText();
        if (this._opts.validateSchema == "log") this.logger.error(message);
        else throw new Error(message);
    }
    return valid;
}
function defaultMeta(self) {
    var meta = self._opts.meta;
    self._opts.defaultMeta = typeof meta == "object" ? self._getId(meta) || meta : self.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined;
    return self._opts.defaultMeta;
}
/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */ function getSchema(keyRef) {
    var schemaObj = _getSchemaObj(this, keyRef);
    switch(typeof schemaObj){
        case "object":
            return schemaObj.validate || this._compile(schemaObj);
        case "string":
            return this.getSchema(schemaObj);
        case "undefined":
            return _getSchemaFragment(this, keyRef);
    }
}
function _getSchemaFragment(self, ref) {
    var res = resolve.schema.call(self, {
        schema: {}
    }, ref);
    if (res) {
        var schema = res.schema, root = res.root, baseId = res.baseId;
        var v = compileSchema.call(self, schema, root, undefined, baseId);
        self._fragments[ref] = new SchemaObject({
            ref: ref,
            fragment: true,
            schema: schema,
            root: root,
            baseId: baseId,
            validate: v
        });
        return v;
    }
}
function _getSchemaObj(self, keyRef) {
    keyRef = resolve.normalizeId(keyRef);
    return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}
/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */ function removeSchema(schemaKeyRef) {
    if (schemaKeyRef instanceof RegExp) {
        _removeAllSchemas(this, this._schemas, schemaKeyRef);
        _removeAllSchemas(this, this._refs, schemaKeyRef);
        return this;
    }
    switch(typeof schemaKeyRef){
        case "undefined":
            _removeAllSchemas(this, this._schemas);
            _removeAllSchemas(this, this._refs);
            this._cache.clear();
            return this;
        case "string":
            var schemaObj = _getSchemaObj(this, schemaKeyRef);
            if (schemaObj) this._cache.del(schemaObj.cacheKey);
            delete this._schemas[schemaKeyRef];
            delete this._refs[schemaKeyRef];
            return this;
        case "object":
            var serialize = this._opts.serialize;
            var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
            this._cache.del(cacheKey);
            var id = this._getId(schemaKeyRef);
            if (id) {
                id = resolve.normalizeId(id);
                delete this._schemas[id];
                delete this._refs[id];
            }
    }
    return this;
}
function _removeAllSchemas(self, schemas, regex) {
    for(var keyRef in schemas){
        var schemaObj = schemas[keyRef];
        if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
            self._cache.del(schemaObj.cacheKey);
            delete schemas[keyRef];
        }
    }
}
/* @this   Ajv */ function _addSchema(schema, skipValidation, meta, shouldAddSchema) {
    if (typeof schema != "object" && typeof schema != "boolean") throw new Error("schema should be object or boolean");
    var serialize = this._opts.serialize;
    var cacheKey = serialize ? serialize(schema) : schema;
    var cached = this._cache.get(cacheKey);
    if (cached) return cached;
    shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
    var id = resolve.normalizeId(this._getId(schema));
    if (id && shouldAddSchema) checkUnique(this, id);
    var willValidate = this._opts.validateSchema !== false && !skipValidation;
    var recursiveMeta;
    if (willValidate && !(recursiveMeta = id && id == resolve.normalizeId(schema.$schema))) this.validateSchema(schema, true);
    var localRefs = resolve.ids.call(this, schema);
    var schemaObj = new SchemaObject({
        id: id,
        schema: schema,
        localRefs: localRefs,
        cacheKey: cacheKey,
        meta: meta
    });
    if (id[0] != "#" && shouldAddSchema) this._refs[id] = schemaObj;
    this._cache.put(cacheKey, schemaObj);
    if (willValidate && recursiveMeta) this.validateSchema(schema, true);
    return schemaObj;
}
/* @this   Ajv */ function _compile(schemaObj, root) {
    if (schemaObj.compiling) {
        schemaObj.validate = callValidate;
        callValidate.schema = schemaObj.schema;
        callValidate.errors = null;
        callValidate.root = root ? root : callValidate;
        if (schemaObj.schema.$async === true) callValidate.$async = true;
        return callValidate;
    }
    schemaObj.compiling = true;
    var currentOpts;
    if (schemaObj.meta) {
        currentOpts = this._opts;
        this._opts = this._metaOpts;
    }
    var v;
    try {
        v = compileSchema.call(this, schemaObj.schema, root, schemaObj.localRefs);
    } catch (e) {
        delete schemaObj.validate;
        throw e;
    } finally{
        schemaObj.compiling = false;
        if (schemaObj.meta) this._opts = currentOpts;
    }
    schemaObj.validate = v;
    schemaObj.refs = v.refs;
    schemaObj.refVal = v.refVal;
    schemaObj.root = v.root;
    return v;
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var _validate = schemaObj.validate;
        var result = _validate.apply(this, arguments);
        callValidate.errors = _validate.errors;
        return result;
    }
}
function chooseGetId(opts) {
    switch(opts.schemaId){
        case "auto":
            return _get$IdOrId;
        case "id":
            return _getId;
        default:
            return _get$Id;
    }
}
/* @this   Ajv */ function _getId(schema) {
    if (schema.$id) this.logger.warn("schema $id ignored", schema.$id);
    return schema.id;
}
/* @this   Ajv */ function _get$Id(schema) {
    if (schema.id) this.logger.warn("schema id ignored", schema.id);
    return schema.$id;
}
function _get$IdOrId(schema) {
    if (schema.$id && schema.id && schema.$id != schema.id) throw new Error("schema $id is different from id");
    return schema.$id || schema.id;
}
/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */ function errorsText(errors, options) {
    errors = errors || this.errors;
    if (!errors) return "No errors";
    options = options || {};
    var separator = options.separator === undefined ? ", " : options.separator;
    var dataVar = options.dataVar === undefined ? "data" : options.dataVar;
    var text = "";
    for(var i = 0; i < errors.length; i++){
        var e = errors[i];
        if (e) text += dataVar + e.dataPath + " " + e.message + separator;
    }
    return text.slice(0, -separator.length);
}
/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */ function addFormat(name, format) {
    if (typeof format == "string") format = new RegExp(format);
    this._formats[name] = format;
    return this;
}
function addDefaultMetaSchema(self) {
    var $dataSchema;
    if (self._opts.$data) {
        $dataSchema = require("3518a04482282234");
        self.addMetaSchema($dataSchema, $dataSchema.$id, true);
    }
    if (self._opts.meta === false) return;
    var metaSchema = require("7f247ac44c6b66da");
    if (self._opts.$data) metaSchema = $dataMetaSchema(metaSchema, META_SUPPORT_DATA);
    self.addMetaSchema(metaSchema, META_SCHEMA_ID, true);
    self._refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
}
function addInitialSchemas(self) {
    var optsSchemas = self._opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
    else for(var key in optsSchemas)self.addSchema(optsSchemas[key], key);
}
function addInitialFormats(self) {
    for(var name in self._opts.formats){
        var format = self._opts.formats[name];
        self.addFormat(name, format);
    }
}
function addInitialKeywords(self) {
    for(var name in self._opts.keywords){
        var keyword = self._opts.keywords[name];
        self.addKeyword(name, keyword);
    }
}
function checkUnique(self, id) {
    if (self._schemas[id] || self._refs[id]) throw new Error('schema with key or id "' + id + '" already exists');
}
function getMetaSchemaOptions(self) {
    var metaOpts = util.copy(self._opts);
    for(var i = 0; i < META_IGNORE_OPTIONS.length; i++)delete metaOpts[META_IGNORE_OPTIONS[i]];
    return metaOpts;
}
function setLogger(self) {
    var logger = self._opts.logger;
    if (logger === false) self.logger = {
        log: noop,
        warn: noop,
        error: noop
    };
    else {
        if (logger === undefined) logger = console;
        if (!(typeof logger == "object" && logger.log && logger.warn && logger.error)) throw new Error("logger must implement log, warn and error methods");
        self.logger = logger;
    }
}
function noop() {}

},{"47271b52ec342bf3":"b0OUN","684106ec39aac66a":"fGRsG","3f3318afa03c8cc2":"jzevK","133fca307f8b378d":"fNZE6","54dbf843afa2e098":"fxrL7","5ce0154e30b5123b":"jNWvB","bea7616b978ebab2":"iEYLA","c74d527a6834c50e":"8bYnS","2d3523db2b6bf504":"iQV3L","5ca6e2fd2da88e3b":"9wB6u","6aa39a2dce2e2179":"PgZlM","ee10d90085b3cd1a":"5xZsW","3518a04482282234":"1BqCn","7f247ac44c6b66da":"hfwfy"}],"b0OUN":[function(require,module,exports) {
"use strict";
var resolve = require("44b229c98b4d5b63"), util = require("9467f3c949529429"), errorClasses = require("1cdee0828f78bd93"), stableStringify = require("2b68e3fe7d7af729");
var validateGenerator = require("81ec6edf36319376");
/**
 * Functions below are used inside compiled validations function
 */ var ucs2length = util.ucs2length;
var equal = require("ebb68185ee3d617c");
// this error is thrown by async schemas to return validation errors via exception
var ValidationError = errorClasses.Validation;
module.exports = compile;
/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */ function compile(schema, root, localRefs, baseId) {
    /* jshint validthis: true, evil: true */ /* eslint no-shadow: 0 */ var self = this, opts = this._opts, refVal = [
        undefined
    ], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
    root = root || {
        schema: schema,
        refVal: refVal,
        refs: refs
    };
    var c = checkCompiling.call(this, schema, root, baseId);
    var compilation = this._compilations[c.index];
    if (c.compiling) return compilation.callValidate = callValidate;
    var formats = this._formats;
    var RULES = this.RULES;
    try {
        var v = localCompile(schema, root, localRefs, baseId);
        compilation.validate = v;
        var cv = compilation.callValidate;
        if (cv) {
            cv.schema = v.schema;
            cv.errors = null;
            cv.refs = v.refs;
            cv.refVal = v.refVal;
            cv.root = v.root;
            cv.$async = v.$async;
            if (opts.sourceCode) cv.source = v.source;
        }
        return v;
    } finally{
        endCompiling.call(this, schema, root, baseId);
    }
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var validate = compilation.validate;
        var result = validate.apply(this, arguments);
        callValidate.errors = validate.errors;
        return result;
    }
    function localCompile(_schema, _root, localRefs, baseId) {
        var isRoot = !_root || _root && _root.schema == _schema;
        if (_root.schema != root.schema) return compile.call(self, _schema, _root, localRefs, baseId);
        var $async = _schema.$async === true;
        var sourceCode = validateGenerator({
            isTop: true,
            schema: _schema,
            isRoot: isRoot,
            baseId: baseId,
            root: _root,
            schemaPath: "",
            errSchemaPath: "#",
            errorPath: '""',
            MissingRefError: errorClasses.MissingRef,
            RULES: RULES,
            validate: validateGenerator,
            util: util,
            resolve: resolve,
            resolveRef: resolveRef,
            usePattern: usePattern,
            useDefault: useDefault,
            useCustomRule: useCustomRule,
            opts: opts,
            formats: formats,
            logger: self.logger,
            self: self
        });
        sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode) + vars(defaults, defaultCode) + vars(customRules, customRuleCode) + sourceCode;
        if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
        // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
        var validate;
        try {
            var makeValidate = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", sourceCode);
            validate = makeValidate(self, RULES, formats, root, refVal, defaults, customRules, equal, ucs2length, ValidationError);
            refVal[0] = validate;
        } catch (e) {
            self.logger.error("Error compiling schema, function code:", sourceCode);
            throw e;
        }
        validate.schema = _schema;
        validate.errors = null;
        validate.refs = refs;
        validate.refVal = refVal;
        validate.root = isRoot ? validate : _root;
        if ($async) validate.$async = true;
        if (opts.sourceCode === true) validate.source = {
            code: sourceCode,
            patterns: patterns,
            defaults: defaults
        };
        return validate;
    }
    function resolveRef(baseId, ref, isRoot) {
        ref = resolve.url(baseId, ref);
        var refIndex = refs[ref];
        var _refVal, refCode;
        if (refIndex !== undefined) {
            _refVal = refVal[refIndex];
            refCode = "refVal[" + refIndex + "]";
            return resolvedRef(_refVal, refCode);
        }
        if (!isRoot && root.refs) {
            var rootRefId = root.refs[ref];
            if (rootRefId !== undefined) {
                _refVal = root.refVal[rootRefId];
                refCode = addLocalRef(ref, _refVal);
                return resolvedRef(_refVal, refCode);
            }
        }
        refCode = addLocalRef(ref);
        var v = resolve.call(self, localCompile, root, ref);
        if (v === undefined) {
            var localSchema = localRefs && localRefs[ref];
            if (localSchema) v = resolve.inlineRef(localSchema, opts.inlineRefs) ? localSchema : compile.call(self, localSchema, root, localRefs, baseId);
        }
        if (v === undefined) removeLocalRef(ref);
        else {
            replaceLocalRef(ref, v);
            return resolvedRef(v, refCode);
        }
    }
    function addLocalRef(ref, v) {
        var refId = refVal.length;
        refVal[refId] = v;
        refs[ref] = refId;
        return "refVal" + refId;
    }
    function removeLocalRef(ref) {
        delete refs[ref];
    }
    function replaceLocalRef(ref, v) {
        var refId = refs[ref];
        refVal[refId] = v;
    }
    function resolvedRef(refVal, code) {
        return typeof refVal == "object" || typeof refVal == "boolean" ? {
            code: code,
            schema: refVal,
            inline: true
        } : {
            code: code,
            $async: refVal && !!refVal.$async
        };
    }
    function usePattern(regexStr) {
        var index = patternsHash[regexStr];
        if (index === undefined) {
            index = patternsHash[regexStr] = patterns.length;
            patterns[index] = regexStr;
        }
        return "pattern" + index;
    }
    function useDefault(value) {
        switch(typeof value){
            case "boolean":
            case "number":
                return "" + value;
            case "string":
                return util.toQuotedString(value);
            case "object":
                if (value === null) return "null";
                var valueStr = stableStringify(value);
                var index = defaultsHash[valueStr];
                if (index === undefined) {
                    index = defaultsHash[valueStr] = defaults.length;
                    defaults[index] = value;
                }
                return "default" + index;
        }
    }
    function useCustomRule(rule, schema, parentSchema, it) {
        if (self._opts.validateSchema !== false) {
            var deps = rule.definition.dependencies;
            if (deps && !deps.every(function(keyword) {
                return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
            })) throw new Error("parent schema must have all required keywords: " + deps.join(","));
            var validateSchema = rule.definition.validateSchema;
            if (validateSchema) {
                var valid = validateSchema(schema);
                if (!valid) {
                    var message = "keyword schema is invalid: " + self.errorsText(validateSchema.errors);
                    if (self._opts.validateSchema == "log") self.logger.error(message);
                    else throw new Error(message);
                }
            }
        }
        var compile = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
        var validate;
        if (compile) validate = compile.call(self, schema, parentSchema, it);
        else if (macro) {
            validate = macro.call(self, schema, parentSchema, it);
            if (opts.validateSchema !== false) self.validateSchema(validate, true);
        } else if (inline) validate = inline.call(self, it, rule.keyword, schema, parentSchema);
        else {
            validate = rule.definition.validate;
            if (!validate) return;
        }
        if (validate === undefined) throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
        var index = customRules.length;
        customRules[index] = validate;
        return {
            code: "customRule" + index,
            validate: validate
        };
    }
}
/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */ function checkCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var index = compIndex.call(this, schema, root, baseId);
    if (index >= 0) return {
        index: index,
        compiling: true
    };
    index = this._compilations.length;
    this._compilations[index] = {
        schema: schema,
        root: root,
        baseId: baseId
    };
    return {
        index: index,
        compiling: false
    };
}
/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */ function endCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var i = compIndex.call(this, schema, root, baseId);
    if (i >= 0) this._compilations.splice(i, 1);
}
/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */ function compIndex(schema, root, baseId) {
    /* jshint validthis: true */ for(var i = 0; i < this._compilations.length; i++){
        var c = this._compilations[i];
        if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
    }
    return -1;
}
function patternCode(i, patterns) {
    return "var pattern" + i + " = new RegExp(" + util.toQuotedString(patterns[i]) + ");";
}
function defaultCode(i) {
    return "var default" + i + " = defaults[" + i + "];";
}
function refValCode(i, refVal) {
    return refVal[i] === undefined ? "" : "var refVal" + i + " = refVal[" + i + "];";
}
function customRuleCode(i) {
    return "var customRule" + i + " = customRules[" + i + "];";
}
function vars(arr, statement) {
    if (!arr.length) return "";
    var code = "";
    for(var i = 0; i < arr.length; i++)code += statement(i, arr);
    return code;
}

},{"44b229c98b4d5b63":"fGRsG","9467f3c949529429":"iQV3L","1cdee0828f78bd93":"5xZsW","2b68e3fe7d7af729":"fxrL7","81ec6edf36319376":"gE8Xo","ebb68185ee3d617c":"fnaor"}],"fGRsG":[function(require,module,exports) {
"use strict";
var URI = require("f233679021735d3f"), equal = require("a6881f3a3f358316"), util = require("7397ab7fe99aa39a"), SchemaObject = require("9f10e0439906c7f4"), traverse = require("df0e2a7c17852bd6");
module.exports = resolve;
resolve.normalizeId = normalizeId;
resolve.fullPath = getFullPath;
resolve.url = resolveUrl;
resolve.ids = resolveIds;
resolve.inlineRef = inlineRef;
resolve.schema = resolveSchema;
/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */ function resolve(compile, root, ref) {
    /* jshint validthis: true */ var refVal = this._refs[ref];
    if (typeof refVal == "string") {
        if (this._refs[refVal]) refVal = this._refs[refVal];
        else return resolve.call(this, compile, root, refVal);
    }
    refVal = refVal || this._schemas[ref];
    if (refVal instanceof SchemaObject) return inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
    var res = resolveSchema.call(this, root, ref);
    var schema, v, baseId;
    if (res) {
        schema = res.schema;
        root = res.root;
        baseId = res.baseId;
    }
    if (schema instanceof SchemaObject) v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
    else if (schema !== undefined) v = inlineRef(schema, this._opts.inlineRefs) ? schema : compile.call(this, schema, root, undefined, baseId);
    return v;
}
/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */ function resolveSchema(root, ref) {
    /* jshint validthis: true */ var p = URI.parse(ref), refPath = _getFullPath(p), baseId = getFullPath(this._getId(root.schema));
    if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
        var id = normalizeId(refPath);
        var refVal = this._refs[id];
        if (typeof refVal == "string") return resolveRecursive.call(this, root, refVal, p);
        else if (refVal instanceof SchemaObject) {
            if (!refVal.validate) this._compile(refVal);
            root = refVal;
        } else {
            refVal = this._schemas[id];
            if (refVal instanceof SchemaObject) {
                if (!refVal.validate) this._compile(refVal);
                if (id == normalizeId(ref)) return {
                    schema: refVal,
                    root: root,
                    baseId: baseId
                };
                root = refVal;
            } else return;
        }
        if (!root.schema) return;
        baseId = getFullPath(this._getId(root.schema));
    }
    return getJsonPointer.call(this, p, baseId, root.schema, root);
}
/* @this Ajv */ function resolveRecursive(root, ref, parsedRef) {
    /* jshint validthis: true */ var res = resolveSchema.call(this, root, ref);
    if (res) {
        var schema = res.schema;
        var baseId = res.baseId;
        root = res.root;
        var id = this._getId(schema);
        if (id) baseId = resolveUrl(baseId, id);
        return getJsonPointer.call(this, parsedRef, baseId, schema, root);
    }
}
var PREVENT_SCOPE_CHANGE = util.toHash([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
/* @this Ajv */ function getJsonPointer(parsedRef, baseId, schema, root) {
    /* jshint validthis: true */ parsedRef.fragment = parsedRef.fragment || "";
    if (parsedRef.fragment.slice(0, 1) != "/") return;
    var parts = parsedRef.fragment.split("/");
    for(var i = 1; i < parts.length; i++){
        var part = parts[i];
        if (part) {
            part = util.unescapeFragment(part);
            schema = schema[part];
            if (schema === undefined) break;
            var id;
            if (!PREVENT_SCOPE_CHANGE[part]) {
                id = this._getId(schema);
                if (id) baseId = resolveUrl(baseId, id);
                if (schema.$ref) {
                    var $ref = resolveUrl(baseId, schema.$ref);
                    var res = resolveSchema.call(this, root, $ref);
                    if (res) {
                        schema = res.schema;
                        root = res.root;
                        baseId = res.baseId;
                    }
                }
            }
        }
    }
    if (schema !== undefined && schema !== root.schema) return {
        schema: schema,
        root: root,
        baseId: baseId
    };
}
var SIMPLE_INLINED = util.toHash([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum"
]);
function inlineRef(schema, limit) {
    if (limit === false) return false;
    if (limit === undefined || limit === true) return checkNoRef(schema);
    else if (limit) return countKeys(schema) <= limit;
}
function checkNoRef(schema) {
    var item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == "object" && !checkNoRef(item)) return false;
    }
    else for(var key in schema){
        if (key == "$ref") return false;
        item = schema[key];
        if (typeof item == "object" && !checkNoRef(item)) return false;
    }
    return true;
}
function countKeys(schema) {
    var count = 0, item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == "object") count += countKeys(item);
        if (count == Infinity) return Infinity;
    }
    else for(var key in schema){
        if (key == "$ref") return Infinity;
        if (SIMPLE_INLINED[key]) count++;
        else {
            item = schema[key];
            if (typeof item == "object") count += countKeys(item) + 1;
            if (count == Infinity) return Infinity;
        }
    }
    return count;
}
function getFullPath(id, normalize) {
    if (normalize !== false) id = normalizeId(id);
    var p = URI.parse(id);
    return _getFullPath(p);
}
function _getFullPath(p) {
    return URI.serialize(p).split("#")[0] + "#";
}
var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
    return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
}
function resolveUrl(baseId, id) {
    id = normalizeId(id);
    return URI.resolve(baseId, id);
}
/* @this Ajv */ function resolveIds(schema) {
    var schemaId = normalizeId(this._getId(schema));
    var baseIds = {
        "": schemaId
    };
    var fullPaths = {
        "": getFullPath(schemaId, false)
    };
    var localRefs = {};
    var self = this;
    traverse(schema, {
        allKeys: true
    }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
        if (jsonPtr === "") return;
        var id = self._getId(sch);
        var baseId = baseIds[parentJsonPtr];
        var fullPath = fullPaths[parentJsonPtr] + "/" + parentKeyword;
        if (keyIndex !== undefined) fullPath += "/" + (typeof keyIndex == "number" ? keyIndex : util.escapeFragment(keyIndex));
        if (typeof id == "string") {
            id = baseId = normalizeId(baseId ? URI.resolve(baseId, id) : id);
            var refVal = self._refs[id];
            if (typeof refVal == "string") refVal = self._refs[refVal];
            if (refVal && refVal.schema) {
                if (!equal(sch, refVal.schema)) throw new Error('id "' + id + '" resolves to more than one schema');
            } else if (id != normalizeId(fullPath)) {
                if (id[0] == "#") {
                    if (localRefs[id] && !equal(sch, localRefs[id])) throw new Error('id "' + id + '" resolves to more than one schema');
                    localRefs[id] = sch;
                } else self._refs[id] = fullPath;
            }
        }
        baseIds[jsonPtr] = baseId;
        fullPaths[jsonPtr] = fullPath;
    });
    return localRefs;
}

},{"f233679021735d3f":"1uLsI","a6881f3a3f358316":"fnaor","7397ab7fe99aa39a":"iQV3L","9f10e0439906c7f4":"fNZE6","df0e2a7c17852bd6":"8E2op"}],"1uLsI":[function(require,module,exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{}],"fnaor":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"iQV3L":[function(require,module,exports) {
"use strict";
module.exports = {
    copy: copy,
    checkDataType: checkDataType,
    checkDataTypes: checkDataTypes,
    coerceToTypes: coerceToTypes,
    toHash: toHash,
    getProperty: getProperty,
    escapeQuotes: escapeQuotes,
    equal: require("ee1f654adc58a230"),
    ucs2length: require("7b179adc93366156"),
    varOccurences: varOccurences,
    varReplace: varReplace,
    schemaHasRules: schemaHasRules,
    schemaHasRulesExcept: schemaHasRulesExcept,
    schemaUnknownRules: schemaUnknownRules,
    toQuotedString: toQuotedString,
    getPathExpr: getPathExpr,
    getPath: getPath,
    getData: getData,
    unescapeFragment: unescapeFragment,
    unescapeJsonPointer: unescapeJsonPointer,
    escapeFragment: escapeFragment,
    escapeJsonPointer: escapeJsonPointer
};
function copy(o, to) {
    to = to || {};
    for(var key in o)to[key] = o[key];
    return to;
}
function checkDataType(dataType, data, strictNumbers, negate) {
    var EQUAL = negate ? " !== " : " === ", AND = negate ? " || " : " && ", OK = negate ? "!" : "", NOT = negate ? "" : "!";
    switch(dataType){
        case "null":
            return data + EQUAL + "null";
        case "array":
            return OK + "Array.isArray(" + data + ")";
        case "object":
            return "(" + OK + data + AND + "typeof " + data + EQUAL + '"object"' + AND + NOT + "Array.isArray(" + data + "))";
        case "integer":
            return "(typeof " + data + EQUAL + '"number"' + AND + NOT + "(" + data + " % 1)" + AND + data + EQUAL + data + (strictNumbers ? AND + OK + "isFinite(" + data + ")" : "") + ")";
        case "number":
            return "(typeof " + data + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + "isFinite(" + data + ")" : "") + ")";
        default:
            return "typeof " + data + EQUAL + '"' + dataType + '"';
    }
}
function checkDataTypes(dataTypes, data, strictNumbers) {
    switch(dataTypes.length){
        case 1:
            return checkDataType(dataTypes[0], data, strictNumbers, true);
        default:
            var code = "";
            var types = toHash(dataTypes);
            if (types.array && types.object) {
                code = types.null ? "(" : "(!" + data + " || ";
                code += "typeof " + data + ' !== "object")';
                delete types.null;
                delete types.array;
                delete types.object;
            }
            if (types.number) delete types.integer;
            for(var t in types)code += (code ? " && " : "") + checkDataType(t, data, strictNumbers, true);
            return code;
    }
}
var COERCE_TO_TYPES = toHash([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function coerceToTypes(optionCoerceTypes, dataTypes) {
    if (Array.isArray(dataTypes)) {
        var types = [];
        for(var i = 0; i < dataTypes.length; i++){
            var t = dataTypes[i];
            if (COERCE_TO_TYPES[t]) types[types.length] = t;
            else if (optionCoerceTypes === "array" && t === "array") types[types.length] = t;
        }
        if (types.length) return types;
    } else if (COERCE_TO_TYPES[dataTypes]) return [
        dataTypes
    ];
    else if (optionCoerceTypes === "array" && dataTypes === "array") return [
        "array"
    ];
}
function toHash(arr) {
    var hash = {};
    for(var i = 0; i < arr.length; i++)hash[arr[i]] = true;
    return hash;
}
var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
    return typeof key == "number" ? "[" + key + "]" : IDENTIFIER.test(key) ? "." + key : "['" + escapeQuotes(key) + "']";
}
function escapeQuotes(str) {
    return str.replace(SINGLE_QUOTE, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
function varOccurences(str, dataVar) {
    dataVar += "[^0-9]";
    var matches = str.match(new RegExp(dataVar, "g"));
    return matches ? matches.length : 0;
}
function varReplace(str, dataVar, expr) {
    dataVar += "([^0-9])";
    expr = expr.replace(/\$/g, "$$$$");
    return str.replace(new RegExp(dataVar, "g"), expr + "$1");
}
function schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(var key in schema)if (rules[key]) return true;
}
function schemaHasRulesExcept(schema, rules, exceptKeyword) {
    if (typeof schema == "boolean") return !schema && exceptKeyword != "not";
    for(var key in schema)if (key != exceptKeyword && rules[key]) return true;
}
function schemaUnknownRules(schema, rules) {
    if (typeof schema == "boolean") return;
    for(var key in schema)if (!rules[key]) return key;
}
function toQuotedString(str) {
    return "'" + escapeQuotes(str) + "'";
}
function getPathExpr(currentPath, expr, jsonPointers, isNumber) {
    var path = jsonPointers // false by default
     ? "'/' + " + expr + (isNumber ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : isNumber ? "'[' + " + expr + " + ']'" : "'[\\'' + " + expr + " + '\\']'";
    return joinPaths(currentPath, path);
}
function getPath(currentPath, prop, jsonPointers) {
    var path = jsonPointers // false by default
     ? toQuotedString("/" + escapeJsonPointer(prop)) : toQuotedString(getProperty(prop));
    return joinPaths(currentPath, path);
}
var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, lvl, paths) {
    var up, jsonPointer, data, matches;
    if ($data === "") return "rootData";
    if ($data[0] == "/") {
        if (!JSON_POINTER.test($data)) throw new Error("Invalid JSON-pointer: " + $data);
        jsonPointer = $data;
        data = "rootData";
    } else {
        matches = $data.match(RELATIVE_JSON_POINTER);
        if (!matches) throw new Error("Invalid JSON-pointer: " + $data);
        up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer == "#") {
            if (up >= lvl) throw new Error("Cannot access property/index " + up + " levels up, current level is " + lvl);
            return paths[lvl - up];
        }
        if (up > lvl) throw new Error("Cannot access data " + up + " levels up, current level is " + lvl);
        data = "data" + (lvl - up || "");
        if (!jsonPointer) return data;
    }
    var expr = data;
    var segments = jsonPointer.split("/");
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        if (segment) {
            data += getProperty(unescapeJsonPointer(segment));
            expr += " && " + data;
        }
    }
    return expr;
}
function joinPaths(a, b) {
    if (a == '""') return b;
    return (a + " + " + b).replace(/([^\\])' \+ '/g, "$1");
}
function unescapeFragment(str) {
    return unescapeJsonPointer(decodeURIComponent(str));
}
function escapeFragment(str) {
    return encodeURIComponent(escapeJsonPointer(str));
}
function escapeJsonPointer(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}

},{"ee1f654adc58a230":"fnaor","7b179adc93366156":"lHTta"}],"lHTta":[function(require,module,exports) {
"use strict";
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
    var length = 0, len = str.length, pos = 0, value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
        }
    }
    return length;
};

},{}],"fNZE6":[function(require,module,exports) {
"use strict";
var util = require("82008194224c11c0");
module.exports = SchemaObject;
function SchemaObject(obj) {
    util.copy(obj, this);
}

},{"82008194224c11c0":"iQV3L"}],"8E2op":[function(require,module,exports) {
"use strict";
var traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    _traverse(opts, pre, post, schema, "", schema);
};
traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true
};
traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
traverse.propsKeywords = {
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in traverse.keywords || opts.allKeys && !(key in traverse.skipKeywords)) _traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

},{}],"5xZsW":[function(require,module,exports) {
"use strict";
var resolve = require("4fc75ca2cc38f6b8");
module.exports = {
    Validation: errorSubclass(ValidationError),
    MissingRef: errorSubclass(MissingRefError)
};
function ValidationError(errors) {
    this.message = "validation failed";
    this.errors = errors;
    this.ajv = this.validation = true;
}
MissingRefError.message = function(baseId, ref) {
    return "can't resolve reference " + ref + " from id " + baseId;
};
function MissingRefError(baseId, ref, message) {
    this.message = message || MissingRefError.message(baseId, ref);
    this.missingRef = resolve.url(baseId, ref);
    this.missingSchema = resolve.normalizeId(resolve.fullPath(this.missingRef));
}
function errorSubclass(Subclass) {
    Subclass.prototype = Object.create(Error.prototype);
    Subclass.prototype.constructor = Subclass;
    return Subclass;
}

},{"4fc75ca2cc38f6b8":"fGRsG"}],"fxrL7":[function(require,module,exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

},{}],"gE8Xo":[function(require,module,exports) {
"use strict";
module.exports = function generate_validate(it, $keyword, $ruleType) {
    var out = "";
    var $async = it.schema.$async === true, $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, "$ref"), $id = it.self._getId(it.schema);
    if (it.opts.strictKeywords) {
        var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
        if ($unknownKwd) {
            var $keywordsMsg = "unknown keyword: " + $unknownKwd;
            if (it.opts.strictKeywords === "log") it.logger.warn($keywordsMsg);
            else throw new Error($keywordsMsg);
        }
    }
    if (it.isTop) {
        out += " var validate = ";
        if ($async) {
            it.async = true;
            out += "async ";
        }
        out += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ";
        if ($id && (it.opts.sourceCode || it.opts.processCode)) out += " " + ("/*# sourceURL=" + $id + " */") + " ";
    }
    if (typeof it.schema == "boolean" || !($refKeywords || it.schema.$ref)) {
        var $keyword = "false schema";
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = "data" + ($dataLvl || "");
        var $valid = "valid" + $lvl;
        if (it.schema === false) {
            if (it.isTop) $breakOnError = true;
            else out += " var " + $valid + " = false; ";
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ""; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: '" + ($errorKeyword || "false schema") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
                if (it.opts.messages !== false) out += " , message: 'boolean schema is false' ";
                if (it.opts.verbose) out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                else out += " validate.errors = [" + __err + "]; return false; ";
            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        } else if (it.isTop) {
            if ($async) out += " return data; ";
            else out += " validate.errors = null; return true; ";
        } else out += " var " + $valid + " = true; ";
        if (it.isTop) out += " }; return validate; ";
        return out;
    }
    if (it.isTop) {
        var $top = it.isTop, $lvl = it.level = 0, $dataLvl = it.dataLevel = 0, $data = "data";
        it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
        it.baseId = it.baseId || it.rootId;
        delete it.isTop;
        it.dataPathArr = [
            ""
        ];
        if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
            var $defaultMsg = "default is ignored in the schema root";
            if (it.opts.strictDefaults === "log") it.logger.warn($defaultMsg);
            else throw new Error($defaultMsg);
        }
        out += " var vErrors = null; ";
        out += " var errors = 0;     ";
        out += " if (rootData === undefined) rootData = data; ";
    } else {
        var $lvl = it.level, $dataLvl = it.dataLevel, $data = "data" + ($dataLvl || "");
        if ($id) it.baseId = it.resolve.url(it.baseId, $id);
        if ($async && !it.async) throw new Error("async schema in sync schema");
        out += " var errs_" + $lvl + " = errors;";
    }
    var $valid = "valid" + $lvl, $breakOnError = !it.opts.allErrors, $closingBraces1 = "", $closingBraces2 = "";
    var $errorKeyword;
    var $typeSchema = it.schema.type, $typeIsArray = Array.isArray($typeSchema);
    if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
        if ($typeIsArray) {
            if ($typeSchema.indexOf("null") == -1) $typeSchema = $typeSchema.concat("null");
        } else if ($typeSchema != "null") {
            $typeSchema = [
                $typeSchema,
                "null"
            ];
            $typeIsArray = true;
        }
    }
    if ($typeIsArray && $typeSchema.length == 1) {
        $typeSchema = $typeSchema[0];
        $typeIsArray = false;
    }
    if (it.schema.$ref && $refKeywords) {
        if (it.opts.extendRefs == "fail") throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
        else if (it.opts.extendRefs !== true) {
            $refKeywords = false;
            it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
        }
    }
    if (it.schema.$comment && it.opts.$comment) out += " " + it.RULES.all.$comment.code(it, "$comment");
    if ($typeSchema) {
        if (it.opts.coerceTypes) var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
        var $rulesGroup = it.RULES.types[$typeSchema];
        if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
            var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type";
            var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type", $method = $typeIsArray ? "checkDataTypes" : "checkDataType";
            out += " if (" + it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true) + ") { ";
            if ($coerceToTypes) {
                var $dataType = "dataType" + $lvl, $coerced = "coerced" + $lvl;
                out += " var " + $dataType + " = typeof " + $data + "; var " + $coerced + " = undefined; ";
                if (it.opts.coerceTypes == "array") out += " if (" + $dataType + " == 'object' && Array.isArray(" + $data + ") && " + $data + ".length == 1) { " + $data + " = " + $data + "[0]; " + $dataType + " = typeof " + $data + "; if (" + it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers) + ") " + $coerced + " = " + $data + "; } ";
                out += " if (" + $coerced + " !== undefined) ; ";
                var arr1 = $coerceToTypes;
                if (arr1) {
                    var $type, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $type = arr1[$i += 1];
                        if ($type == "string") out += " else if (" + $dataType + " == 'number' || " + $dataType + " == 'boolean') " + $coerced + " = '' + " + $data + "; else if (" + $data + " === null) " + $coerced + " = ''; ";
                        else if ($type == "number" || $type == "integer") {
                            out += " else if (" + $dataType + " == 'boolean' || " + $data + " === null || (" + $dataType + " == 'string' && " + $data + " && " + $data + " == +" + $data + " ";
                            if ($type == "integer") out += " && !(" + $data + " % 1)";
                            out += ")) " + $coerced + " = +" + $data + "; ";
                        } else if ($type == "boolean") out += " else if (" + $data + " === 'false' || " + $data + " === 0 || " + $data + " === null) " + $coerced + " = false; else if (" + $data + " === 'true' || " + $data + " === 1) " + $coerced + " = true; ";
                        else if ($type == "null") out += " else if (" + $data + " === '' || " + $data + " === 0 || " + $data + " === false) " + $coerced + " = null; ";
                        else if (it.opts.coerceTypes == "array" && $type == "array") out += " else if (" + $dataType + " == 'string' || " + $dataType + " == 'number' || " + $dataType + " == 'boolean' || " + $data + " == null) " + $coerced + " = [" + $data + "]; ";
                    }
                }
                out += " else {   ";
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                    if ($typeIsArray) out += "" + $typeSchema.join(",");
                    else out += "" + $typeSchema;
                    out += "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: 'should be ";
                        if ($typeIsArray) out += "" + $typeSchema.join(",");
                        else out += "" + $typeSchema;
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                out += " } if (" + $coerced + " !== undefined) {  ";
                var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
                out += " " + $data + " = " + $coerced + "; ";
                if (!$dataLvl) out += "if (" + $parentData + " !== undefined)";
                out += " " + $parentData + "[" + $parentDataProperty + "] = " + $coerced + "; } ";
            } else {
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                    if ($typeIsArray) out += "" + $typeSchema.join(",");
                    else out += "" + $typeSchema;
                    out += "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: 'should be ";
                        if ($typeIsArray) out += "" + $typeSchema.join(",");
                        else out += "" + $typeSchema;
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            }
            out += " } ";
        }
    }
    if (it.schema.$ref && !$refKeywords) {
        out += " " + it.RULES.all.$ref.code(it, "$ref") + " ";
        if ($breakOnError) {
            out += " } if (errors === ";
            if ($top) out += "0";
            else out += "errs_" + $lvl;
            out += ") { ";
            $closingBraces2 += "}";
        }
    } else {
        var arr2 = it.RULES;
        if (arr2) {
            var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
            while(i2 < l2){
                $rulesGroup = arr2[i2 += 1];
                if ($shouldUseGroup($rulesGroup)) {
                    if ($rulesGroup.type) out += " if (" + it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers) + ") { ";
                    if (it.opts.useDefaults) {
                        if ($rulesGroup.type == "object" && it.schema.properties) {
                            var $schema = it.schema.properties, $schemaKeys = Object.keys($schema);
                            var arr3 = $schemaKeys;
                            if (arr3) {
                                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                                while(i3 < l3){
                                    $propertyKey = arr3[i3 += 1];
                                    var $sch = $schema[$propertyKey];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + it.util.getProperty($propertyKey);
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = "default is ignored for: " + $passData;
                                                if (it.opts.strictDefaults === "log") it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += " if (" + $passData + " === undefined ";
                                            if (it.opts.useDefaults == "empty") out += " || " + $passData + " === null || " + $passData + " === '' ";
                                            out += " ) " + $passData + " = ";
                                            if (it.opts.useDefaults == "shared") out += " " + it.useDefault($sch.default) + " ";
                                            else out += " " + JSON.stringify($sch.default) + " ";
                                            out += "; ";
                                        }
                                    }
                                }
                            }
                        } else if ($rulesGroup.type == "array" && Array.isArray(it.schema.items)) {
                            var arr4 = it.schema.items;
                            if (arr4) {
                                var $sch, $i = -1, l4 = arr4.length - 1;
                                while($i < l4){
                                    $sch = arr4[$i += 1];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + "[" + $i + "]";
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = "default is ignored for: " + $passData;
                                                if (it.opts.strictDefaults === "log") it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += " if (" + $passData + " === undefined ";
                                            if (it.opts.useDefaults == "empty") out += " || " + $passData + " === null || " + $passData + " === '' ";
                                            out += " ) " + $passData + " = ";
                                            if (it.opts.useDefaults == "shared") out += " " + it.useDefault($sch.default) + " ";
                                            else out += " " + JSON.stringify($sch.default) + " ";
                                            out += "; ";
                                        }
                                    }
                                }
                            }
                        }
                    }
                    var arr5 = $rulesGroup.rules;
                    if (arr5) {
                        var $rule, i5 = -1, l5 = arr5.length - 1;
                        while(i5 < l5){
                            $rule = arr5[i5 += 1];
                            if ($shouldUseRule($rule)) {
                                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                                if ($code) {
                                    out += " " + $code + " ";
                                    if ($breakOnError) $closingBraces1 += "}";
                                }
                            }
                        }
                    }
                    if ($breakOnError) {
                        out += " " + $closingBraces1 + " ";
                        $closingBraces1 = "";
                    }
                    if ($rulesGroup.type) {
                        out += " } ";
                        if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
                            out += " else { ";
                            var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type";
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ""; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                                if ($typeIsArray) out += "" + $typeSchema.join(",");
                                else out += "" + $typeSchema;
                                out += "' } ";
                                if (it.opts.messages !== false) {
                                    out += " , message: 'should be ";
                                    if ($typeIsArray) out += "" + $typeSchema.join(",");
                                    else out += "" + $typeSchema;
                                    out += "' ";
                                }
                                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                                out += " } ";
                            } else out += " {} ";
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                                else out += " validate.errors = [" + __err + "]; return false; ";
                            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            out += " } ";
                        }
                    }
                    if ($breakOnError) {
                        out += " if (errors === ";
                        if ($top) out += "0";
                        else out += "errs_" + $lvl;
                        out += ") { ";
                        $closingBraces2 += "}";
                    }
                }
            }
        }
    }
    if ($breakOnError) out += " " + $closingBraces2 + " ";
    if ($top) {
        if ($async) {
            out += " if (errors === 0) return data;           ";
            out += " else throw new ValidationError(vErrors); ";
        } else {
            out += " validate.errors = vErrors; ";
            out += " return errors === 0;       ";
        }
        out += " }; return validate;";
    } else out += " var " + $valid + " = errors === errs_" + $lvl + ";";
    function $shouldUseGroup($rulesGroup) {
        var rules = $rulesGroup.rules;
        for(var i = 0; i < rules.length; i++)if ($shouldUseRule(rules[i])) return true;
    }
    function $shouldUseRule($rule) {
        return it.schema[$rule.keyword] !== undefined || $rule.implements && $ruleImplementsSomeKeyword($rule);
    }
    function $ruleImplementsSomeKeyword($rule) {
        var impl = $rule.implements;
        for(var i = 0; i < impl.length; i++)if (it.schema[impl[i]] !== undefined) return true;
    }
    return out;
};

},{}],"jzevK":[function(require,module,exports) {
"use strict";
var Cache = module.exports = function Cache() {
    this._cache = {};
};
Cache.prototype.put = function Cache_put(key, value) {
    this._cache[key] = value;
};
Cache.prototype.get = function Cache_get(key) {
    return this._cache[key];
};
Cache.prototype.del = function Cache_del(key) {
    delete this._cache[key];
};
Cache.prototype.clear = function Cache_clear() {
    this._cache = {};
};

},{}],"jNWvB":[function(require,module,exports) {
"use strict";
var util = require("a3530a9c116b8e66");
var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
module.exports = formats;
function formats(mode) {
    mode = mode == "full" ? "full" : "fast";
    return util.copy(formats[mode]);
}
formats.fast = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
    "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    "uri-template": URITEMPLATE,
    url: URL,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    hostname: HOSTNAME,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: UUID,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": JSON_POINTER,
    "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": RELATIVE_JSON_POINTER
};
formats.full = {
    date: date,
    time: time,
    "date-time": date_time,
    uri: uri,
    "uri-reference": URIREF,
    "uri-template": URITEMPLATE,
    url: URL,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: HOSTNAME,
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: regex,
    uuid: UUID,
    "json-pointer": JSON_POINTER,
    "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
    "relative-json-pointer": RELATIVE_JSON_POINTER
};
function isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    var matches = str.match(DATE);
    if (!matches) return false;
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}
function time(str, full) {
    var matches = str.match(TIME);
    if (!matches) return false;
    var hour = matches[1];
    var minute = matches[2];
    var second = matches[3];
    var timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    var dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && date(dateTime[0]) && time(dateTime[1], true);
}
var NOT_URI_FRAGMENT = /\/|:/;
function uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}
var Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
    if (Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

},{"a3530a9c116b8e66":"iQV3L"}],"iEYLA":[function(require,module,exports) {
"use strict";
var ruleModules = require("d70d14363c66143a"), toHash = require("c155741dbdda6c41").toHash;
module.exports = function rules() {
    var RULES = [
        {
            type: "number",
            rules: [
                {
                    "maximum": [
                        "exclusiveMaximum"
                    ]
                },
                {
                    "minimum": [
                        "exclusiveMinimum"
                    ]
                },
                "multipleOf",
                "format"
            ]
        },
        {
            type: "string",
            rules: [
                "maxLength",
                "minLength",
                "pattern",
                "format"
            ]
        },
        {
            type: "array",
            rules: [
                "maxItems",
                "minItems",
                "items",
                "contains",
                "uniqueItems"
            ]
        },
        {
            type: "object",
            rules: [
                "maxProperties",
                "minProperties",
                "required",
                "dependencies",
                "propertyNames",
                {
                    "properties": [
                        "additionalProperties",
                        "patternProperties"
                    ]
                }
            ]
        },
        {
            rules: [
                "$ref",
                "const",
                "enum",
                "not",
                "anyOf",
                "oneOf",
                "allOf",
                "if"
            ]
        }
    ];
    var ALL = [
        "type",
        "$comment"
    ];
    var KEYWORDS = [
        "$schema",
        "$id",
        "id",
        "$data",
        "$async",
        "title",
        "description",
        "default",
        "definitions",
        "examples",
        "readOnly",
        "writeOnly",
        "contentMediaType",
        "contentEncoding",
        "additionalItems",
        "then",
        "else"
    ];
    var TYPES = [
        "number",
        "integer",
        "string",
        "array",
        "object",
        "boolean",
        "null"
    ];
    RULES.all = toHash(ALL);
    RULES.types = toHash(TYPES);
    RULES.forEach(function(group) {
        group.rules = group.rules.map(function(keyword) {
            var implKeywords;
            if (typeof keyword == "object") {
                var key = Object.keys(keyword)[0];
                implKeywords = keyword[key];
                keyword = key;
                implKeywords.forEach(function(k) {
                    ALL.push(k);
                    RULES.all[k] = true;
                });
            }
            ALL.push(keyword);
            var rule = RULES.all[keyword] = {
                keyword: keyword,
                code: ruleModules[keyword],
                implements: implKeywords
            };
            return rule;
        });
        RULES.all.$comment = {
            keyword: "$comment",
            code: ruleModules.$comment
        };
        if (group.type) RULES.types[group.type] = group;
    });
    RULES.keywords = toHash(ALL.concat(KEYWORDS));
    RULES.custom = {};
    return RULES;
};

},{"d70d14363c66143a":"8Pdn3","c155741dbdda6c41":"iQV3L"}],"8Pdn3":[function(require,module,exports) {
"use strict";
//all requires must be explicit because browserify won't work with dynamic requires
module.exports = {
    "$ref": require("79bdf7ca1db34c24"),
    allOf: require("1c41b00f0ba83ca1"),
    anyOf: require("bcb47920481c42a6"),
    "$comment": require("7e78faeaa869db5b"),
    const: require("fffb80e866014848"),
    contains: require("748e023daa00350"),
    dependencies: require("84f6e84b4e84852e"),
    "enum": require("db4f1d3aaa911e09"),
    format: require("c32e011d2fe4d605"),
    "if": require("34d3b7b7e82e83c7"),
    items: require("6df1c2c72e25d1e9"),
    maximum: require("cd3bee69926d039f"),
    minimum: require("cd3bee69926d039f"),
    maxItems: require("f469678f964f0bd9"),
    minItems: require("f469678f964f0bd9"),
    maxLength: require("7305e6c61645718e"),
    minLength: require("7305e6c61645718e"),
    maxProperties: require("4ef96089a29a632a"),
    minProperties: require("4ef96089a29a632a"),
    multipleOf: require("2676c44854ecd1c"),
    not: require("4f90af146ebea39e"),
    oneOf: require("4fdc992f47efbb74"),
    pattern: require("8df8c72296fb9d0f"),
    properties: require("80f65ecdd37c6ed0"),
    propertyNames: require("aef0152265dcde02"),
    required: require("cd1e272a3a872f78"),
    uniqueItems: require("3af23801a6007554"),
    validate: require("731a8067bed63c64")
};

},{"79bdf7ca1db34c24":"2KSJr","1c41b00f0ba83ca1":"97ozr","bcb47920481c42a6":"l4vuD","7e78faeaa869db5b":"cBi3Q","fffb80e866014848":"1sXgu","748e023daa00350":"bw3rZ","84f6e84b4e84852e":"cDJQ5","db4f1d3aaa911e09":"cpLEq","c32e011d2fe4d605":"cV4do","34d3b7b7e82e83c7":"422eX","6df1c2c72e25d1e9":"jrZFt","cd3bee69926d039f":"gBC7I","f469678f964f0bd9":"4w0al","7305e6c61645718e":"7yCfE","4ef96089a29a632a":"cwfpE","2676c44854ecd1c":"jBGOO","4f90af146ebea39e":"diq5K","4fdc992f47efbb74":"2freJ","8df8c72296fb9d0f":"3toVg","80f65ecdd37c6ed0":"59TSn","aef0152265dcde02":"kbecC","cd1e272a3a872f78":"208m0","3af23801a6007554":"aKik7","731a8067bed63c64":"gE8Xo"}],"2KSJr":[function(require,module,exports) {
"use strict";
module.exports = function generate_ref(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $async, $refCode;
    if ($schema == "#" || $schema == "#/") {
        if (it.isRoot) {
            $async = it.async;
            $refCode = "validate";
        } else {
            $async = it.root.schema.$async === true;
            $refCode = "root.refVal[0]";
        }
    } else {
        var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
        if ($refVal === undefined) {
            var $message = it.MissingRefError.message(it.baseId, $schema);
            if (it.opts.missingRefs == "fail") {
                it.logger.error($message);
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { ref: '" + it.util.escapeQuotes($schema) + "' } ";
                    if (it.opts.messages !== false) out += " , message: 'can\\'t resolve reference " + it.util.escapeQuotes($schema) + "' ";
                    if (it.opts.verbose) out += " , schema: " + it.util.toQuotedString($schema) + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                if ($breakOnError) out += " if (false) { ";
            } else if (it.opts.missingRefs == "ignore") {
                it.logger.warn($message);
                if ($breakOnError) out += " if (true) { ";
            } else throw new it.MissingRefError(it.baseId, $schema, $message);
        } else if ($refVal.inline) {
            var $it = it.util.copy(it);
            $it.level++;
            var $nextValid = "valid" + $it.level;
            $it.schema = $refVal.schema;
            $it.schemaPath = "";
            $it.errSchemaPath = $schema;
            var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
            out += " " + $code + " ";
            if ($breakOnError) out += " if (" + $nextValid + ") { ";
        } else {
            $async = $refVal.$async === true || it.async && $refVal.$async !== false;
            $refCode = $refVal.code;
        }
    }
    if ($refCode) {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.opts.passContext) out += " " + $refCode + ".call(this, ";
        else out += " " + $refCode + "( ";
        out += " " + $data + ", (dataPath || '')";
        if (it.errorPath != '""') out += " + " + it.errorPath;
        var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
        out += " , " + $parentData + " , " + $parentDataProperty + ", rootData)  ";
        var __callValidate = out;
        out = $$outStack.pop();
        if ($async) {
            if (!it.async) throw new Error("async schema referenced by sync schema");
            if ($breakOnError) out += " var " + $valid + "; ";
            out += " try { await " + __callValidate + "; ";
            if ($breakOnError) out += " " + $valid + " = true; ";
            out += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ";
            if ($breakOnError) out += " " + $valid + " = false; ";
            out += " } ";
            if ($breakOnError) out += " if (" + $valid + ") { ";
        } else {
            out += " if (!" + __callValidate + ") { if (vErrors === null) vErrors = " + $refCode + ".errors; else vErrors = vErrors.concat(" + $refCode + ".errors); errors = vErrors.length; } ";
            if ($breakOnError) out += " else { ";
        }
    }
    return out;
};

},{}],"97ozr":[function(require,module,exports) {
"use strict";
module.exports = function generate_allOf(it, $keyword, $ruleType) {
    var out = " ";
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $allSchemasEmpty = false;
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + "[" + $i + "]";
                $it.errSchemaPath = $errSchemaPath + "/" + $i;
                out += "  " + it.validate($it) + " ";
                $it.baseId = $currentBaseId;
                if ($breakOnError) {
                    out += " if (" + $nextValid + ") { ";
                    $closingBraces += "}";
                }
            }
        }
    }
    if ($breakOnError) {
        if ($allSchemasEmpty) out += " if (true) { ";
        else out += " " + $closingBraces.slice(0, -1) + " ";
    }
    return out;
};

},{}],"l4vuD":[function(require,module,exports) {
"use strict";
module.exports = function generate_anyOf(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $noEmptySchema = $schema.every(function($sch) {
        return it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all);
    });
    if ($noEmptySchema) {
        var $currentBaseId = $it.baseId;
        out += " var " + $errs + " = errors; var " + $valid + " = false;  ";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + "[" + $i + "]";
                $it.errSchemaPath = $errSchemaPath + "/" + $i;
                out += "  " + it.validate($it) + " ";
                $it.baseId = $currentBaseId;
                out += " " + $valid + " = " + $valid + " || " + $nextValid + "; if (!" + $valid + ") { ";
                $closingBraces += "}";
            }
        }
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " " + $closingBraces + " if (!" + $valid + ") {   var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: 'should match some schema in anyOf' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
            else out += " validate.errors = vErrors; return false; ";
        }
        out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
        if (it.opts.allErrors) out += " } ";
    } else if ($breakOnError) out += " if (true) { ";
    return out;
};

},{}],"cBi3Q":[function(require,module,exports) {
"use strict";
module.exports = function generate_comment(it, $keyword, $ruleType) {
    var out = " ";
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $comment = it.util.toQuotedString($schema);
    if (it.opts.$comment === true) out += " console.log(" + $comment + ");";
    else if (typeof it.opts.$comment == "function") out += " self._opts.$comment(" + $comment + ", " + it.util.toQuotedString($errSchemaPath) + ", validate.root.schema);";
    return out;
};

},{}],"1sXgu":[function(require,module,exports) {
"use strict";
module.exports = function generate_const(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!$isData) out += " var schema" + $lvl + " = validate.schema" + $schemaPath + ";";
    out += "var " + $valid + " = equal(" + $data + ", schema" + $lvl + "); if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { allowedValue: schema" + $lvl + " } ";
        if (it.opts.messages !== false) out += " , message: 'should be equal to constant' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " }";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"bw3rZ":[function(require,module,exports) {
"use strict";
module.exports = function generate_contains(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it.baseId, $nonEmptySchema = it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all);
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if ($nonEmptySchema) {
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += " var " + $nextValid + " = false; for (var " + $idx + " = 0; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + "[" + $idx + "]";
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
        else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        out += " if (" + $nextValid + ") break; }  ";
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " " + $closingBraces + " if (!" + $nextValid + ") {";
    } else out += " if (" + $data + ".length == 0) {";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it.opts.messages !== false) out += " , message: 'should contain a valid item' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " } else { ";
    if ($nonEmptySchema) out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
    if (it.opts.allErrors) out += " } ";
    return out;
};

},{}],"cDJQ5":[function(require,module,exports) {
"use strict";
module.exports = function generate_dependencies(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it.opts.ownProperties;
    for($property in $schema){
        if ($property == "__proto__") continue;
        var $sch = $schema[$property];
        var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
        $deps[$property] = $sch;
    }
    out += "var " + $errs + " = errors;";
    var $currentErrorPath = it.errorPath;
    out += "var missing" + $lvl + ";";
    for(var $property in $propertyDeps){
        $deps = $propertyDeps[$property];
        if ($deps.length) {
            out += " if ( " + $data + it.util.getProperty($property) + " !== undefined ";
            if ($ownProperties) out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($property) + "') ";
            if ($breakOnError) {
                out += " && ( ";
                var arr1 = $deps;
                if (arr1) {
                    var $propertyKey, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $propertyKey = arr1[$i += 1];
                        if ($i) out += " || ";
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += " ( ( " + $useData + " === undefined ";
                        if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                        out += ") && (missing" + $lvl + " = " + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
                    }
                }
                out += ")) {  ";
                var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: 'should have ";
                        if ($deps.length == 1) out += "property " + it.util.escapeQuotes($deps[0]);
                        else out += "properties " + it.util.escapeQuotes($deps.join(", "));
                        out += " when property " + it.util.escapeQuotes($property) + " is present' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            } else {
                out += " ) { ";
                var arr2 = $deps;
                if (arr2) {
                    var $propertyKey, i2 = -1, l2 = arr2.length - 1;
                    while(i2 < l2){
                        $propertyKey = arr2[i2 += 1];
                        var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                        if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                        out += " if ( " + $useData + " === undefined ";
                        if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                        out += ") {  var err =   "; /* istanbul ignore else */ 
                        if (it.createErrors !== false) {
                            out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
                            if (it.opts.messages !== false) {
                                out += " , message: 'should have ";
                                if ($deps.length == 1) out += "property " + it.util.escapeQuotes($deps[0]);
                                else out += "properties " + it.util.escapeQuotes($deps.join(", "));
                                out += " when property " + it.util.escapeQuotes($property) + " is present' ";
                            }
                            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                            out += " } ";
                        } else out += " {} ";
                        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                    }
                }
            }
            out += " }   ";
            if ($breakOnError) {
                $closingBraces += "}";
                out += " else { ";
            }
        }
    }
    it.errorPath = $currentErrorPath;
    var $currentBaseId = $it.baseId;
    for(var $property in $schemaDeps){
        var $sch = $schemaDeps[$property];
        if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
            out += " " + $nextValid + " = true; if ( " + $data + it.util.getProperty($property) + " !== undefined ";
            if ($ownProperties) out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($property) + "') ";
            out += ") { ";
            $it.schema = $sch;
            $it.schemaPath = $schemaPath + it.util.getProperty($property);
            $it.errSchemaPath = $errSchemaPath + "/" + it.util.escapeFragment($property);
            out += "  " + it.validate($it) + " ";
            $it.baseId = $currentBaseId;
            out += " }  ";
            if ($breakOnError) {
                out += " if (" + $nextValid + ") { ";
                $closingBraces += "}";
            }
        }
    }
    if ($breakOnError) out += "   " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

},{}],"cpLEq":[function(require,module,exports) {
"use strict";
module.exports = function generate_enum(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $i = "i" + $lvl, $vSchema = "schema" + $lvl;
    if (!$isData) out += " var " + $vSchema + " = validate.schema" + $schemaPath + ";";
    out += "var " + $valid + ";";
    if ($isData) out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
    out += "" + $valid + " = false;for (var " + $i + "=0; " + $i + "<" + $vSchema + ".length; " + $i + "++) if (equal(" + $data + ", " + $vSchema + "[" + $i + "])) { " + $valid + " = true; break; }";
    if ($isData) out += "  }  ";
    out += " if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { allowedValues: schema" + $lvl + " } ";
        if (it.opts.messages !== false) out += " , message: 'should be equal to one of the allowed values' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " }";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"cV4do":[function(require,module,exports) {
"use strict";
module.exports = function generate_format(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    if (it.opts.format === false) {
        if ($breakOnError) out += " if (true) { ";
        return out;
    }
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $unknownFormats = it.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
    if ($isData) {
        var $format = "format" + $lvl, $isObject = "isObject" + $lvl, $formatType = "formatType" + $lvl;
        out += " var " + $format + " = formats[" + $schemaValue + "]; var " + $isObject + " = typeof " + $format + " == 'object' && !(" + $format + " instanceof RegExp) && " + $format + ".validate; var " + $formatType + " = " + $isObject + " && " + $format + ".type || 'string'; if (" + $isObject + ") { ";
        if (it.async) out += " var async" + $lvl + " = " + $format + ".async; ";
        out += " " + $format + " = " + $format + ".validate; } if (  ";
        if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
        out += " (";
        if ($unknownFormats != "ignore") {
            out += " (" + $schemaValue + " && !" + $format + " ";
            if ($allowUnknown) out += " && self._opts.unknownFormats.indexOf(" + $schemaValue + ") == -1 ";
            out += ") || ";
        }
        out += " (" + $format + " && " + $formatType + " == '" + $ruleType + "' && !(typeof " + $format + " == 'function' ? ";
        if (it.async) out += " (async" + $lvl + " ? await " + $format + "(" + $data + ") : " + $format + "(" + $data + ")) ";
        else out += " " + $format + "(" + $data + ") ";
        out += " : " + $format + ".test(" + $data + "))))) {";
    } else {
        var $format = it.formats[$schema];
        if (!$format) {
            if ($unknownFormats == "ignore") {
                it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
                if ($breakOnError) out += " if (true) { ";
                return out;
            } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
                if ($breakOnError) out += " if (true) { ";
                return out;
            } else throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
        }
        var $isObject = typeof $format == "object" && !($format instanceof RegExp) && $format.validate;
        var $formatType = $isObject && $format.type || "string";
        if ($isObject) {
            var $async = $format.async === true;
            $format = $format.validate;
        }
        if ($formatType != $ruleType) {
            if ($breakOnError) out += " if (true) { ";
            return out;
        }
        if ($async) {
            if (!it.async) throw new Error("async format in sync schema");
            var $formatRef = "formats" + it.util.getProperty($schema) + ".validate";
            out += " if (!(await " + $formatRef + "(" + $data + "))) { ";
        } else {
            out += " if (! ";
            var $formatRef = "formats" + it.util.getProperty($schema);
            if ($isObject) $formatRef += ".validate";
            if (typeof $format == "function") out += " " + $formatRef + "(" + $data + ") ";
            else out += " " + $formatRef + ".test(" + $data + ") ";
            out += ") { ";
        }
    }
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { format:  ";
        if ($isData) out += "" + $schemaValue;
        else out += "" + it.util.toQuotedString($schema);
        out += "  } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should match format \"";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + it.util.escapeQuotes($schema);
            out += "\"' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + it.util.toQuotedString($schema);
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " } ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"422eX":[function(require,module,exports) {
"use strict";
module.exports = function generate_if(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $thenSch = it.schema["then"], $elseSch = it.schema["else"], $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? typeof $thenSch == "object" && Object.keys($thenSch).length > 0 || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)), $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? typeof $elseSch == "object" && Object.keys($elseSch).length > 0 || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)), $currentBaseId = $it.baseId;
    if ($thenPresent || $elsePresent) {
        var $ifClause;
        $it.createErrors = false;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += " var " + $errs + " = errors; var " + $valid + " = true;  ";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        out += "  " + it.validate($it) + " ";
        $it.baseId = $currentBaseId;
        $it.createErrors = true;
        out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }  ";
        it.compositeRule = $it.compositeRule = $wasComposite;
        if ($thenPresent) {
            out += " if (" + $nextValid + ") {  ";
            $it.schema = it.schema["then"];
            $it.schemaPath = it.schemaPath + ".then";
            $it.errSchemaPath = it.errSchemaPath + "/then";
            out += "  " + it.validate($it) + " ";
            $it.baseId = $currentBaseId;
            out += " " + $valid + " = " + $nextValid + "; ";
            if ($thenPresent && $elsePresent) {
                $ifClause = "ifClause" + $lvl;
                out += " var " + $ifClause + " = 'then'; ";
            } else $ifClause = "'then'";
            out += " } ";
            if ($elsePresent) out += " else { ";
        } else out += " if (!" + $nextValid + ") { ";
        if ($elsePresent) {
            $it.schema = it.schema["else"];
            $it.schemaPath = it.schemaPath + ".else";
            $it.errSchemaPath = it.errSchemaPath + "/else";
            out += "  " + it.validate($it) + " ";
            $it.baseId = $currentBaseId;
            out += " " + $valid + " = " + $nextValid + "; ";
            if ($thenPresent && $elsePresent) {
                $ifClause = "ifClause" + $lvl;
                out += " var " + $ifClause + " = 'else'; ";
            } else $ifClause = "'else'";
            out += " } ";
        }
        out += " if (!" + $valid + ") {   var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { failingKeyword: " + $ifClause + " } ";
            if (it.opts.messages !== false) out += " , message: 'should match \"' + " + $ifClause + " + '\" schema' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
            else out += " validate.errors = vErrors; return false; ";
        }
        out += " }   ";
        if ($breakOnError) out += " else { ";
    } else if ($breakOnError) out += " if (true) { ";
    return out;
};

},{}],"jrZFt":[function(require,module,exports) {
"use strict";
module.exports = function generate_items(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it.baseId;
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if (Array.isArray($schema)) {
        var $additionalItems = it.schema.additionalItems;
        if ($additionalItems === false) {
            out += " " + $valid + " = " + $data + ".length <= " + $schema.length + "; ";
            var $currErrSchemaPath = $errSchemaPath;
            $errSchemaPath = it.errSchemaPath + "/additionalItems";
            out += "  if (!" + $valid + ") {   ";
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ""; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schema.length + " } ";
                if (it.opts.messages !== false) out += " , message: 'should NOT have more than " + $schema.length + " items' ";
                if (it.opts.verbose) out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                else out += " validate.errors = [" + __err + "]; return false; ";
            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            out += " } ";
            $errSchemaPath = $currErrSchemaPath;
            if ($breakOnError) {
                $closingBraces += "}";
                out += " else { ";
            }
        }
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    out += " " + $nextValid + " = true; if (" + $data + ".length > " + $i + ") { ";
                    var $passData = $data + "[" + $i + "]";
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + "[" + $i + "]";
                    $it.errSchemaPath = $errSchemaPath + "/" + $i;
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
                    $it.dataPathArr[$dataNxt] = $i;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    out += " }  ";
                    if ($breakOnError) {
                        out += " if (" + $nextValid + ") { ";
                        $closingBraces += "}";
                    }
                }
            }
        }
        if (typeof $additionalItems == "object" && (it.opts.strictKeywords ? typeof $additionalItems == "object" && Object.keys($additionalItems).length > 0 || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
            $it.schema = $additionalItems;
            $it.schemaPath = it.schemaPath + ".additionalItems";
            $it.errSchemaPath = it.errSchemaPath + "/additionalItems";
            out += " " + $nextValid + " = true; if (" + $data + ".length > " + $schema.length + ") {  for (var " + $idx + " = " + $schema.length + "; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
            $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
            var $passData = $data + "[" + $idx + "]";
            $it.dataPathArr[$dataNxt] = $idx;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
            else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
            if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
            out += " } }  ";
            if ($breakOnError) {
                out += " if (" + $nextValid + ") { ";
                $closingBraces += "}";
            }
        }
    } else if (it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += "  for (var " + $idx + " = " + 0 + "; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + "[" + $idx + "]";
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
        else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
        out += " }";
    }
    if ($breakOnError) out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

},{}],"gBC7I":[function(require,module,exports) {
"use strict";
module.exports = function generate__limit(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $isMax = $keyword == "maximum", $exclusiveKeyword = $isMax ? "exclusiveMaximum" : "exclusiveMinimum", $schemaExcl = it.schema[$exclusiveKeyword], $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? "<" : ">", $notOp = $isMax ? ">" : "<", $errorKeyword = undefined;
    if (!($isData || typeof $schema == "number" || $schema === undefined)) throw new Error($keyword + " must be number");
    if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == "number" || typeof $schemaExcl == "boolean")) throw new Error($exclusiveKeyword + " must be number or boolean");
    if ($isDataExcl) {
        var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr), $exclusive = "exclusive" + $lvl, $exclType = "exclType" + $lvl, $exclIsNumber = "exclIsNumber" + $lvl, $opExpr = "op" + $lvl, $opStr = "' + " + $opExpr + " + '";
        out += " var schemaExcl" + $lvl + " = " + $schemaValueExcl + "; ";
        $schemaValueExcl = "schemaExcl" + $lvl;
        out += " var " + $exclusive + "; var " + $exclType + " = typeof " + $schemaValueExcl + "; if (" + $exclType + " != 'boolean' && " + $exclType + " != 'undefined' && " + $exclType + " != 'number') { ";
        var $errorKeyword = $exclusiveKeyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: '" + ($errorKeyword || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: '" + $exclusiveKeyword + " should be boolean' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        out += " } else if ( ";
        if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
        out += " " + $exclType + " == 'number' ? ( (" + $exclusive + " = " + $schemaValue + " === undefined || " + $schemaValueExcl + " " + $op + "= " + $schemaValue + ") ? " + $data + " " + $notOp + "= " + $schemaValueExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) : ( (" + $exclusive + " = " + $schemaValueExcl + " === true) ? " + $data + " " + $notOp + "= " + $schemaValue + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { var op" + $lvl + " = " + $exclusive + " ? '" + $op + "' : '" + $op + "='; ";
        if ($schema === undefined) {
            $errorKeyword = $exclusiveKeyword;
            $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
            $schemaValue = $schemaValueExcl;
            $isData = $isDataExcl;
        }
    } else {
        var $exclIsNumber = typeof $schemaExcl == "number", $opStr = $op;
        if ($exclIsNumber && $isData) {
            var $opExpr = "'" + $opStr + "'";
            out += " if ( ";
            if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
            out += " ( " + $schemaValue + " === undefined || " + $schemaExcl + " " + $op + "= " + $schemaValue + " ? " + $data + " " + $notOp + "= " + $schemaExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { ";
        } else {
            if ($exclIsNumber && $schema === undefined) {
                $exclusive = true;
                $errorKeyword = $exclusiveKeyword;
                $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
                $schemaValue = $schemaExcl;
                $notOp += "=";
            } else {
                if ($exclIsNumber) $schemaValue = Math[$isMax ? "min" : "max"]($schemaExcl, $schema);
                if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
                    $exclusive = true;
                    $errorKeyword = $exclusiveKeyword;
                    $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
                    $notOp += "=";
                } else {
                    $exclusive = false;
                    $opStr += "=";
                }
            }
            var $opExpr = "'" + $opStr + "'";
            out += " if ( ";
            if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
            out += " " + $data + " " + $notOp + " " + $schemaValue + " || " + $data + " !== " + $data + ") { ";
        }
    }
    $errorKeyword = $errorKeyword || $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limit") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { comparison: " + $opExpr + ", limit: " + $schemaValue + ", exclusive: " + $exclusive + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should be " + $opStr + " ";
            if ($isData) out += "' + " + $schemaValue;
            else out += "" + $schemaValue + "'";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " } ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"4w0al":[function(require,module,exports) {
"use strict";
module.exports = function generate__limitItems(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    var $op = $keyword == "maxItems" ? ">" : "<";
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    out += " " + $data + ".length " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limitItems") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should NOT have ";
            if ($keyword == "maxItems") out += "more";
            else out += "fewer";
            out += " than ";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + $schema;
            out += " items' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"7yCfE":[function(require,module,exports) {
"use strict";
module.exports = function generate__limitLength(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    var $op = $keyword == "maxLength" ? ">" : "<";
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    if (it.opts.unicode === false) out += " " + $data + ".length ";
    else out += " ucs2length(" + $data + ") ";
    out += " " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limitLength") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should NOT be ";
            if ($keyword == "maxLength") out += "longer";
            else out += "shorter";
            out += " than ";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + $schema;
            out += " characters' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"cwfpE":[function(require,module,exports) {
"use strict";
module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    var $op = $keyword == "maxProperties" ? ">" : "<";
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    out += " Object.keys(" + $data + ").length " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limitProperties") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should NOT have ";
            if ($keyword == "maxProperties") out += "more";
            else out += "fewer";
            out += " than ";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + $schema;
            out += " properties' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"jBGOO":[function(require,module,exports) {
"use strict";
module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    out += "var division" + $lvl + ";if (";
    if ($isData) out += " " + $schemaValue + " !== undefined && ( typeof " + $schemaValue + " != 'number' || ";
    out += " (division" + $lvl + " = " + $data + " / " + $schemaValue + ", ";
    if (it.opts.multipleOfPrecision) out += " Math.abs(Math.round(division" + $lvl + ") - division" + $lvl + ") > 1e-" + it.opts.multipleOfPrecision + " ";
    else out += " division" + $lvl + " !== parseInt(division" + $lvl + ") ";
    out += " ) ";
    if ($isData) out += "  )  ";
    out += " ) {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { multipleOf: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should be multiple of ";
            if ($isData) out += "' + " + $schemaValue;
            else out += "" + $schemaValue + "'";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"diq5K":[function(require,module,exports) {
"use strict";
module.exports = function generate_not(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = "valid" + $it.level;
    if (it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += " var " + $errs + " = errors;  ";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.createErrors = false;
        var $allErrorsOption;
        if ($it.opts.allErrors) {
            $allErrorsOption = $it.opts.allErrors;
            $it.opts.allErrors = false;
        }
        out += " " + it.validate($it) + " ";
        $it.createErrors = true;
        if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " if (" + $nextValid + ") {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: 'should NOT be valid' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
        if (it.opts.allErrors) out += " } ";
    } else {
        out += "  var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: 'should NOT be valid' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if ($breakOnError) out += " if (false) { ";
    }
    return out;
};

},{}],"2freJ":[function(require,module,exports) {
"use strict";
module.exports = function generate_oneOf(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $currentBaseId = $it.baseId, $prevValid = "prevValid" + $lvl, $passingSchemas = "passingSchemas" + $lvl;
    out += "var " + $errs + " = errors , " + $prevValid + " = false , " + $valid + " = false , " + $passingSchemas + " = null; ";
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + "[" + $i + "]";
                $it.errSchemaPath = $errSchemaPath + "/" + $i;
                out += "  " + it.validate($it) + " ";
                $it.baseId = $currentBaseId;
            } else out += " var " + $nextValid + " = true; ";
            if ($i) {
                out += " if (" + $nextValid + " && " + $prevValid + ") { " + $valid + " = false; " + $passingSchemas + " = [" + $passingSchemas + ", " + $i + "]; } else { ";
                $closingBraces += "}";
            }
            out += " if (" + $nextValid + ") { " + $valid + " = " + $prevValid + " = true; " + $passingSchemas + " = " + $i + "; }";
        }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += "" + $closingBraces + "if (!" + $valid + ") {   var err =   "; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { passingSchemas: " + $passingSchemas + " } ";
        if (it.opts.messages !== false) out += " , message: 'should match exactly one schema in oneOf' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
        else out += " validate.errors = vErrors; return false; ";
    }
    out += "} else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }";
    if (it.opts.allErrors) out += " } ";
    return out;
};

},{}],"3toVg":[function(require,module,exports) {
"use strict";
module.exports = function generate_pattern(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $regexp = $isData ? "(new RegExp(" + $schemaValue + "))" : it.usePattern($schema);
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
    out += " !" + $regexp + ".test(" + $data + ") ) {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { pattern:  ";
        if ($isData) out += "" + $schemaValue;
        else out += "" + it.util.toQuotedString($schema);
        out += "  } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should match pattern \"";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + it.util.escapeQuotes($schema);
            out += "\"' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + it.util.toQuotedString($schema);
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

},{}],"59TSn":[function(require,module,exports) {
"use strict";
module.exports = function generate_properties(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $key = "key" + $lvl, $idx = "idx" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl;
    var $schemaKeys = Object.keys($schema || {}).filter(notProto), $pProperties = it.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == "object" && Object.keys($aProperties).length, $removeAdditional = it.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
    var $required = it.schema.required;
    if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) var $requiredHash = it.util.toHash($required);
    function notProto(p) {
        return p !== "__proto__";
    }
    out += "var " + $errs + " = errors;var " + $nextValid + " = true;";
    if ($ownProperties) out += " var " + $dataProperties + " = undefined;";
    if ($checkAdditional) {
        if ($ownProperties) out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
        else out += " for (var " + $key + " in " + $data + ") { ";
        if ($someProperties) {
            out += " var isAdditional" + $lvl + " = !(false ";
            if ($schemaKeys.length) {
                if ($schemaKeys.length > 8) out += " || validate.schema" + $schemaPath + ".hasOwnProperty(" + $key + ") ";
                else {
                    var arr1 = $schemaKeys;
                    if (arr1) {
                        var $propertyKey, i1 = -1, l1 = arr1.length - 1;
                        while(i1 < l1){
                            $propertyKey = arr1[i1 += 1];
                            out += " || " + $key + " == " + it.util.toQuotedString($propertyKey) + " ";
                        }
                    }
                }
            }
            if ($pPropertyKeys.length) {
                var arr2 = $pPropertyKeys;
                if (arr2) {
                    var $pProperty, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $pProperty = arr2[$i += 1];
                        out += " || " + it.usePattern($pProperty) + ".test(" + $key + ") ";
                    }
                }
            }
            out += " ); if (isAdditional" + $lvl + ") { ";
        }
        if ($removeAdditional == "all") out += " delete " + $data + "[" + $key + "]; ";
        else {
            var $currentErrorPath = it.errorPath;
            var $additionalProperty = "' + " + $key + " + '";
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
            if ($noAdditional) {
                if ($removeAdditional) out += " delete " + $data + "[" + $key + "]; ";
                else {
                    out += " " + $nextValid + " = false; ";
                    var $currErrSchemaPath = $errSchemaPath;
                    $errSchemaPath = it.errSchemaPath + "/additionalProperties";
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = ""; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { additionalProperty: '" + $additionalProperty + "' } ";
                        if (it.opts.messages !== false) {
                            out += " , message: '";
                            if (it.opts._errorDataPathProperty) out += "is an invalid additional property";
                            else out += "should NOT have additional properties";
                            out += "' ";
                        }
                        if (it.opts.verbose) out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                        out += " } ";
                    } else out += " {} ";
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                        else out += " validate.errors = [" + __err + "]; return false; ";
                    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    $errSchemaPath = $currErrSchemaPath;
                    if ($breakOnError) out += " break; ";
                }
            } else if ($additionalIsSchema) {
                if ($removeAdditional == "failing") {
                    out += " var " + $errs + " = errors;  ";
                    var $wasComposite = it.compositeRule;
                    it.compositeRule = $it.compositeRule = true;
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + ".additionalProperties";
                    $it.errSchemaPath = it.errSchemaPath + "/additionalProperties";
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + "[" + $key + "]";
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    out += " if (!" + $nextValid + ") { errors = " + $errs + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + $data + "[" + $key + "]; }  ";
                    it.compositeRule = $it.compositeRule = $wasComposite;
                } else {
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + ".additionalProperties";
                    $it.errSchemaPath = it.errSchemaPath + "/additionalProperties";
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + "[" + $key + "]";
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
                }
            }
            it.errorPath = $currentErrorPath;
        }
        if ($someProperties) out += " } ";
        out += " }  ";
        if ($breakOnError) {
            out += " if (" + $nextValid + ") { ";
            $closingBraces += "}";
        }
    }
    var $useDefaults = it.opts.useDefaults && !it.compositeRule;
    if ($schemaKeys.length) {
        var arr3 = $schemaKeys;
        if (arr3) {
            var $propertyKey, i3 = -1, l3 = arr3.length - 1;
            while(i3 < l3){
                $propertyKey = arr3[i3 += 1];
                var $sch = $schema[$propertyKey];
                if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    var $prop = it.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== undefined;
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + $prop;
                    $it.errSchemaPath = $errSchemaPath + "/" + it.util.escapeFragment($propertyKey);
                    $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
                    $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) {
                        $code = it.util.varReplace($code, $nextData, $passData);
                        var $useData = $passData;
                    } else {
                        var $useData = $nextData;
                        out += " var " + $nextData + " = " + $passData + "; ";
                    }
                    if ($hasDefault) out += " " + $code + " ";
                    else {
                        if ($requiredHash && $requiredHash[$propertyKey]) {
                            out += " if ( " + $useData + " === undefined ";
                            if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                            out += ") { " + $nextValid + " = false; ";
                            var $currentErrorPath = it.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it.util.escapeQuotes($propertyKey);
                            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                            $errSchemaPath = it.errSchemaPath + "/required";
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ""; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                                if (it.opts.messages !== false) {
                                    out += " , message: '";
                                    if (it.opts._errorDataPathProperty) out += "is a required property";
                                    else out += "should have required property \\'" + $missingProperty + "\\'";
                                    out += "' ";
                                }
                                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                                out += " } ";
                            } else out += " {} ";
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                                else out += " validate.errors = [" + __err + "]; return false; ";
                            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            $errSchemaPath = $currErrSchemaPath;
                            it.errorPath = $currentErrorPath;
                            out += " } else { ";
                        } else if ($breakOnError) {
                            out += " if ( " + $useData + " === undefined ";
                            if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                            out += ") { " + $nextValid + " = true; } else { ";
                        } else {
                            out += " if (" + $useData + " !== undefined ";
                            if ($ownProperties) out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                            out += " ) { ";
                        }
                        out += " " + $code + " } ";
                    }
                }
                if ($breakOnError) {
                    out += " if (" + $nextValid + ") { ";
                    $closingBraces += "}";
                }
            }
        }
    }
    if ($pPropertyKeys.length) {
        var arr4 = $pPropertyKeys;
        if (arr4) {
            var $pProperty, i4 = -1, l4 = arr4.length - 1;
            while(i4 < l4){
                $pProperty = arr4[i4 += 1];
                var $sch = $pProperties[$pProperty];
                if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    $it.schema = $sch;
                    $it.schemaPath = it.schemaPath + ".patternProperties" + it.util.getProperty($pProperty);
                    $it.errSchemaPath = it.errSchemaPath + "/patternProperties/" + it.util.escapeFragment($pProperty);
                    if ($ownProperties) out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
                    else out += " for (var " + $key + " in " + $data + ") { ";
                    out += " if (" + it.usePattern($pProperty) + ".test(" + $key + ")) { ";
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + "[" + $key + "]";
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
                    out += " } ";
                    if ($breakOnError) out += " else " + $nextValid + " = true; ";
                    out += " }  ";
                    if ($breakOnError) {
                        out += " if (" + $nextValid + ") { ";
                        $closingBraces += "}";
                    }
                }
            }
        }
    }
    if ($breakOnError) out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

},{}],"kbecC":[function(require,module,exports) {
"use strict";
module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    out += "var " + $errs + " = errors;";
    if (it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        var $key = "key" + $lvl, $idx = "idx" + $lvl, $i = "i" + $lvl, $invalidName = "' + " + $key + " + '", $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
        if ($ownProperties) out += " var " + $dataProperties + " = undefined; ";
        if ($ownProperties) out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
        else out += " for (var " + $key + " in " + $data + ") { ";
        out += " var startErrs" + $lvl + " = errors; ";
        var $passData = $key;
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
        else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " if (!" + $nextValid + ") { for (var " + $i + "=startErrs" + $lvl + "; " + $i + "<errors; " + $i + "++) { vErrors[" + $i + "].propertyName = " + $key + "; }   var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { propertyName: '" + $invalidName + "' } ";
            if (it.opts.messages !== false) out += " , message: 'property name \\'" + $invalidName + "\\' is invalid' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
            else out += " validate.errors = vErrors; return false; ";
        }
        if ($breakOnError) out += " break; ";
        out += " } }";
    }
    if ($breakOnError) out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

},{}],"208m0":[function(require,module,exports) {
"use strict";
module.exports = function generate_required(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $vSchema = "schema" + $lvl;
    if (!$isData) {
        if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
            var $required = [];
            var arr1 = $schema;
            if (arr1) {
                var $property, i1 = -1, l1 = arr1.length - 1;
                while(i1 < l1){
                    $property = arr1[i1 += 1];
                    var $propertySch = it.schema.properties[$property];
                    if (!($propertySch && (it.opts.strictKeywords ? typeof $propertySch == "object" && Object.keys($propertySch).length > 0 || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) $required[$required.length] = $property;
                }
            }
        } else var $required = $schema;
    }
    if ($isData || $required.length) {
        var $currentErrorPath = it.errorPath, $loopRequired = $isData || $required.length >= it.opts.loopRequired, $ownProperties = it.opts.ownProperties;
        if ($breakOnError) {
            out += " var missing" + $lvl + "; ";
            if ($loopRequired) {
                if (!$isData) out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
                var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
                out += " var " + $valid + " = true; ";
                if ($isData) out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
                out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { " + $valid + " = " + $data + "[" + $vSchema + "[" + $i + "]] !== undefined ";
                if ($ownProperties) out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
                out += "; if (!" + $valid + ") break; } ";
                if ($isData) out += "  }  ";
                out += "  if (!" + $valid + ") {   ";
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: '";
                        if (it.opts._errorDataPathProperty) out += "is a required property";
                        else out += "should have required property \\'" + $missingProperty + "\\'";
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                out += " } else { ";
            } else {
                out += " if ( ";
                var arr2 = $required;
                if (arr2) {
                    var $propertyKey, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $propertyKey = arr2[$i += 1];
                        if ($i) out += " || ";
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += " ( ( " + $useData + " === undefined ";
                        if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                        out += ") && (missing" + $lvl + " = " + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
                    }
                }
                out += ") {  ";
                var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: '";
                        if (it.opts._errorDataPathProperty) out += "is a required property";
                        else out += "should have required property \\'" + $missingProperty + "\\'";
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                out += " } else { ";
            }
        } else if ($loopRequired) {
            if (!$isData) out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
            var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
            if ($isData) {
                out += " if (" + $vSchema + " && !Array.isArray(" + $vSchema + ")) {  var err =   "; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: '";
                        if (it.opts._errorDataPathProperty) out += "is a required property";
                        else out += "should have required property \\'" + $missingProperty + "\\'";
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + $vSchema + " !== undefined) { ";
            }
            out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { if (" + $data + "[" + $vSchema + "[" + $i + "]] === undefined ";
            if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
            out += ") {  var err =   "; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                if (it.opts.messages !== false) {
                    out += " , message: '";
                    if (it.opts._errorDataPathProperty) out += "is a required property";
                    else out += "should have required property \\'" + $missingProperty + "\\'";
                    out += "' ";
                }
                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ";
            if ($isData) out += "  }  ";
        } else {
            var arr3 = $required;
            if (arr3) {
                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                while(i3 < l3){
                    $propertyKey = arr3[i3 += 1];
                    var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                    if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                    out += " if ( " + $useData + " === undefined ";
                    if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                    out += ") {  var err =   "; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                        if (it.opts.messages !== false) {
                            out += " , message: '";
                            if (it.opts._errorDataPathProperty) out += "is a required property";
                            else out += "should have required property \\'" + $missingProperty + "\\'";
                            out += "' ";
                        }
                        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                        out += " } ";
                    } else out += " {} ";
                    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                }
            }
        }
        it.errorPath = $currentErrorPath;
    } else if ($breakOnError) out += " if (true) {";
    return out;
};

},{}],"aKik7":[function(require,module,exports) {
"use strict";
module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (($schema || $isData) && it.opts.uniqueItems !== false) {
        if ($isData) out += " var " + $valid + "; if (" + $schemaValue + " === false || " + $schemaValue + " === undefined) " + $valid + " = true; else if (typeof " + $schemaValue + " != 'boolean') " + $valid + " = false; else { ";
        out += " var i = " + $data + ".length , " + $valid + " = true , j; if (i > 1) { ";
        var $itemType = it.schema.items && it.schema.items.type, $typeIsArray = Array.isArray($itemType);
        if (!$itemType || $itemType == "object" || $itemType == "array" || $typeIsArray && ($itemType.indexOf("object") >= 0 || $itemType.indexOf("array") >= 0)) out += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + $data + "[i], " + $data + "[j])) { " + $valid + " = false; break outer; } } } ";
        else {
            out += " var itemIndices = {}, item; for (;i--;) { var item = " + $data + "[i]; ";
            var $method = "checkDataType" + ($typeIsArray ? "s" : "");
            out += " if (" + it.util[$method]($itemType, "item", it.opts.strictNumbers, true) + ") continue; ";
            if ($typeIsArray) out += " if (typeof item == 'string') item = '\"' + item; ";
            out += " if (typeof itemIndices[item] == 'number') { " + $valid + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
        }
        out += " } ";
        if ($isData) out += "  }  ";
        out += " if (!" + $valid + ") {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { i: i, j: j } ";
            if (it.opts.messages !== false) out += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' ";
            if (it.opts.verbose) {
                out += " , schema:  ";
                if ($isData) out += "validate.schema" + $schemaPath;
                else out += "" + $schema;
                out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        out += " } ";
        if ($breakOnError) out += " else { ";
    } else if ($breakOnError) out += " if (true) { ";
    return out;
};

},{}],"8bYnS":[function(require,module,exports) {
"use strict";
var KEYWORDS = [
    "multipleOf",
    "maximum",
    "exclusiveMaximum",
    "minimum",
    "exclusiveMinimum",
    "maxLength",
    "minLength",
    "pattern",
    "additionalItems",
    "maxItems",
    "minItems",
    "uniqueItems",
    "maxProperties",
    "minProperties",
    "required",
    "additionalProperties",
    "enum",
    "format",
    "const"
];
module.exports = function(metaSchema, keywordsJsonPointers) {
    for(var i = 0; i < keywordsJsonPointers.length; i++){
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        var segments = keywordsJsonPointers[i].split("/");
        var keywords = metaSchema;
        var j;
        for(j = 1; j < segments.length; j++)keywords = keywords[segments[j]];
        for(j = 0; j < KEYWORDS.length; j++){
            var key = KEYWORDS[j];
            var schema = keywords[key];
            if (schema) keywords[key] = {
                anyOf: [
                    schema,
                    {
                        $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                    }
                ]
            };
        }
    }
    return metaSchema;
};

},{}],"9wB6u":[function(require,module,exports) {
"use strict";
var MissingRefError = require("ae4c4bcefcc71c0").MissingRef;
module.exports = compileAsync;
/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */ function compileAsync(schema, meta, callback) {
    /* eslint no-shadow: 0 */ /* global Promise */ /* jshint validthis: true */ var self = this;
    if (typeof this._opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
    if (typeof meta == "function") {
        callback = meta;
        meta = undefined;
    }
    var p = loadMetaSchemaOf(schema).then(function() {
        var schemaObj = self._addSchema(schema, undefined, meta);
        return schemaObj.validate || _compileAsync(schemaObj);
    });
    if (callback) p.then(function(v) {
        callback(null, v);
    }, callback);
    return p;
    function loadMetaSchemaOf(sch) {
        var $schema = sch.$schema;
        return $schema && !self.getSchema($schema) ? compileAsync.call(self, {
            $ref: $schema
        }, true) : Promise.resolve();
    }
    function _compileAsync(schemaObj) {
        try {
            return self._compile(schemaObj);
        } catch (e) {
            if (e instanceof MissingRefError) return loadMissingSchema(e);
            throw e;
        }
        function loadMissingSchema(e) {
            var ref = e.missingSchema;
            if (added(ref)) throw new Error("Schema " + ref + " is loaded but " + e.missingRef + " cannot be resolved");
            var schemaPromise = self._loadingSchemas[ref];
            if (!schemaPromise) {
                schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
                schemaPromise.then(removePromise, removePromise);
            }
            return schemaPromise.then(function(sch) {
                if (!added(ref)) return loadMetaSchemaOf(sch).then(function() {
                    if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
                });
            }).then(function() {
                return _compileAsync(schemaObj);
            });
            function removePromise() {
                delete self._loadingSchemas[ref];
            }
            function added(ref) {
                return self._refs[ref] || self._schemas[ref];
            }
        }
    }
}

},{"ae4c4bcefcc71c0":"5xZsW"}],"PgZlM":[function(require,module,exports) {
"use strict";
var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var customRuleCode = require("670ff973d1ebe3db");
var definitionSchema = require("44c641b636d92dd9");
module.exports = {
    add: addKeyword,
    get: getKeyword,
    remove: removeKeyword,
    validate: validateKeyword
};
/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */ function addKeyword(keyword, definition) {
    /* jshint validthis: true */ /* eslint no-shadow: 0 */ var RULES = this.RULES;
    if (RULES.keywords[keyword]) throw new Error("Keyword " + keyword + " is already defined");
    if (!IDENTIFIER.test(keyword)) throw new Error("Keyword " + keyword + " is not a valid identifier");
    if (definition) {
        this.validateKeyword(definition, true);
        var dataType = definition.type;
        if (Array.isArray(dataType)) for(var i = 0; i < dataType.length; i++)_addRule(keyword, dataType[i], definition);
        else _addRule(keyword, dataType, definition);
        var metaSchema = definition.metaSchema;
        if (metaSchema) {
            if (definition.$data && this._opts.$data) metaSchema = {
                anyOf: [
                    metaSchema,
                    {
                        "$ref": "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                    }
                ]
            };
            definition.validateSchema = this.compile(metaSchema, true);
        }
    }
    RULES.keywords[keyword] = RULES.all[keyword] = true;
    function _addRule(keyword, dataType, definition) {
        var ruleGroup;
        for(var i = 0; i < RULES.length; i++){
            var rg = RULES[i];
            if (rg.type == dataType) {
                ruleGroup = rg;
                break;
            }
        }
        if (!ruleGroup) {
            ruleGroup = {
                type: dataType,
                rules: []
            };
            RULES.push(ruleGroup);
        }
        var rule = {
            keyword: keyword,
            definition: definition,
            custom: true,
            code: customRuleCode,
            implements: definition.implements
        };
        ruleGroup.rules.push(rule);
        RULES.custom[keyword] = rule;
    }
    return this;
}
/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */ function getKeyword(keyword) {
    /* jshint validthis: true */ var rule = this.RULES.custom[keyword];
    return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}
/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */ function removeKeyword(keyword) {
    /* jshint validthis: true */ var RULES = this.RULES;
    delete RULES.keywords[keyword];
    delete RULES.all[keyword];
    delete RULES.custom[keyword];
    for(var i = 0; i < RULES.length; i++){
        var rules = RULES[i].rules;
        for(var j = 0; j < rules.length; j++)if (rules[j].keyword == keyword) {
            rules.splice(j, 1);
            break;
        }
    }
    return this;
}
/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */ function validateKeyword(definition, throwError) {
    validateKeyword.errors = null;
    var v = this._validateKeyword = this._validateKeyword || this.compile(definitionSchema, true);
    if (v(definition)) return true;
    validateKeyword.errors = v.errors;
    if (throwError) throw new Error("custom keyword definition is invalid: " + this.errorsText(v.errors));
    else return false;
}

},{"670ff973d1ebe3db":"ey4RW","44c641b636d92dd9":"dJIwN"}],"ey4RW":[function(require,module,exports) {
"use strict";
module.exports = function generate_custom(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $rule = this, $definition = "definition" + $lvl, $rDef = $rule.definition, $closingBraces = "";
    var $compile, $inline, $macro, $ruleValidate, $validateCode;
    if ($isData && $rDef.$data) {
        $validateCode = "keywordValidate" + $lvl;
        var $validateSchema = $rDef.validateSchema;
        out += " var " + $definition + " = RULES.custom['" + $keyword + "'].definition; var " + $validateCode + " = " + $definition + ".validate;";
    } else {
        $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
        if (!$ruleValidate) return;
        $schemaValue = "validate.schema" + $schemaPath;
        $validateCode = $ruleValidate.code;
        $compile = $rDef.compile;
        $inline = $rDef.inline;
        $macro = $rDef.macro;
    }
    var $ruleErrs = $validateCode + ".errors", $i = "i" + $lvl, $ruleErr = "ruleErr" + $lvl, $asyncKeyword = $rDef.async;
    if ($asyncKeyword && !it.async) throw new Error("async keyword in sync schema");
    if (!($inline || $macro)) out += "" + $ruleErrs + " = null;";
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if ($isData && $rDef.$data) {
        $closingBraces += "}";
        out += " if (" + $schemaValue + " === undefined) { " + $valid + " = true; } else { ";
        if ($validateSchema) {
            $closingBraces += "}";
            out += " " + $valid + " = " + $definition + ".validateSchema(" + $schemaValue + "); if (" + $valid + ") { ";
        }
    }
    if ($inline) {
        if ($rDef.statements) out += " " + $ruleValidate.validate + " ";
        else out += " " + $valid + " = " + $ruleValidate.validate + "; ";
    } else if ($macro) {
        var $it = it.util.copy(it);
        var $closingBraces = "";
        $it.level++;
        var $nextValid = "valid" + $it.level;
        $it.schema = $ruleValidate.validate;
        $it.schemaPath = "";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " " + $code;
    } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        out += "  " + $validateCode + ".call( ";
        if (it.opts.passContext) out += "this";
        else out += "self";
        if ($compile || $rDef.schema === false) out += " , " + $data + " ";
        else out += " , " + $schemaValue + " , " + $data + " , validate.schema" + it.schemaPath + " ";
        out += " , (dataPath || '')";
        if (it.errorPath != '""') out += " + " + it.errorPath;
        var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
        out += " , " + $parentData + " , " + $parentDataProperty + " , rootData )  ";
        var def_callRuleValidate = out;
        out = $$outStack.pop();
        if ($rDef.errors === false) {
            out += " " + $valid + " = ";
            if ($asyncKeyword) out += "await ";
            out += "" + def_callRuleValidate + "; ";
        } else if ($asyncKeyword) {
            $ruleErrs = "customErrors" + $lvl;
            out += " var " + $ruleErrs + " = null; try { " + $valid + " = await " + def_callRuleValidate + "; } catch (e) { " + $valid + " = false; if (e instanceof ValidationError) " + $ruleErrs + " = e.errors; else throw e; } ";
        } else out += " " + $ruleErrs + " = null; " + $valid + " = " + def_callRuleValidate + "; ";
    }
    if ($rDef.modifying) out += " if (" + $parentData + ") " + $data + " = " + $parentData + "[" + $parentDataProperty + "];";
    out += "" + $closingBraces;
    if ($rDef.valid) {
        if ($breakOnError) out += " if (true) { ";
    } else {
        out += " if ( ";
        if ($rDef.valid === undefined) {
            out += " !";
            if ($macro) out += "" + $nextValid;
            else out += "" + $valid;
        } else out += " " + !$rDef.valid + " ";
        out += ") { ";
        $errorKeyword = $rule.keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
            if (it.opts.messages !== false) out += " , message: 'should pass \"" + $rule.keyword + "\" keyword validation' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        var def_customError = out;
        out = $$outStack.pop();
        if ($inline) {
            if ($rDef.errors) {
                if ($rDef.errors != "full") {
                    out += "  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                    if (it.opts.verbose) out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
                    out += " } ";
                }
            } else if ($rDef.errors === false) out += " " + def_customError + " ";
            else {
                out += " if (" + $errs + " == errors) { " + def_customError + " } else {  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                if (it.opts.verbose) out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
                out += " } } ";
            }
        } else if ($macro) {
            out += "   var err =   "; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
                if (it.opts.messages !== false) out += " , message: 'should pass \"" + $rule.keyword + "\" keyword validation' ";
                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
                else out += " validate.errors = vErrors; return false; ";
            }
        } else if ($rDef.errors === false) out += " " + def_customError + " ";
        else {
            out += " if (Array.isArray(" + $ruleErrs + ")) { if (vErrors === null) vErrors = " + $ruleErrs + "; else vErrors = vErrors.concat(" + $ruleErrs + "); errors = vErrors.length;  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + ";  " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
            if (it.opts.verbose) out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
            out += " } } else { " + def_customError + " } ";
        }
        out += " } ";
        if ($breakOnError) out += " else { ";
    }
    return out;
};

},{}],"dJIwN":[function(require,module,exports) {
"use strict";
var metaSchema = require("a0801eb66557ad17");
module.exports = {
    $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
    definitions: {
        simpleTypes: metaSchema.definitions.simpleTypes
    },
    type: "object",
    dependencies: {
        schema: [
            "validate"
        ],
        $data: [
            "validate"
        ],
        statements: [
            "inline"
        ],
        valid: {
            not: {
                required: [
                    "macro"
                ]
            }
        }
    },
    properties: {
        type: metaSchema.properties.type,
        schema: {
            type: "boolean"
        },
        statements: {
            type: "boolean"
        },
        dependencies: {
            type: "array",
            items: {
                type: "string"
            }
        },
        metaSchema: {
            type: "object"
        },
        modifying: {
            type: "boolean"
        },
        valid: {
            type: "boolean"
        },
        $data: {
            type: "boolean"
        },
        async: {
            type: "boolean"
        },
        errors: {
            anyOf: [
                {
                    type: "boolean"
                },
                {
                    const: "full"
                }
            ]
        }
    }
};

},{"a0801eb66557ad17":"hfwfy"}],"hfwfy":[function(require,module,exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

},{}],"1BqCn":[function(require,module,exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

},{}],"jfi7v":[function(require,module,exports) {
function HARError(errors) {
    var message = "validation failed";
    this.name = "HARError";
    this.message = message;
    this.errors = errors;
    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error(message).stack;
}
HARError.prototype = Error.prototype;
module.exports = HARError;

},{}],"aIii4":[function(require,module,exports) {
"use strict";
module.exports = {
    afterRequest: require("dfecd30c5b558d47"),
    beforeRequest: require("d6a7a284df3e2e5b"),
    browser: require("b87b3db1b255b582"),
    cache: require("f05ff313d1b670d2"),
    content: require("655962984d705f73"),
    cookie: require("745b3d2ced9e2282"),
    creator: require("3457c1f9af98ad4b"),
    entry: require("73cdfd3124427093"),
    har: require("b7affe3c8d46910"),
    header: require("e222a384efdbff98"),
    log: require("d8dddf022c85dc83"),
    page: require("13990aa02c951d3f"),
    pageTimings: require("407432be337ba2d6"),
    postData: require("24daba41d614d347"),
    query: require("c44a3842348b6c3c"),
    request: require("caf7f17a3128c97c"),
    response: require("37c6c7b359980f46"),
    timings: require("cdad0311e75c2d20")
};

},{"dfecd30c5b558d47":"3g8zB","d6a7a284df3e2e5b":"dUajV","b87b3db1b255b582":"dOtJv","f05ff313d1b670d2":"72Pwb","655962984d705f73":"k5zvf","745b3d2ced9e2282":"4cfkX","3457c1f9af98ad4b":"fOmDa","73cdfd3124427093":"f6lBy","b7affe3c8d46910":"9elIU","e222a384efdbff98":"FomA8","d8dddf022c85dc83":"3zJej","13990aa02c951d3f":"3aw9j","407432be337ba2d6":"9X9CK","24daba41d614d347":"6XT9B","c44a3842348b6c3c":"8efyw","caf7f17a3128c97c":"6B8zH","37c6c7b359980f46":"gb8ea","cdad0311e75c2d20":"9VUTF"}],"3g8zB":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"afterRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\\\d{4})(-)?(\\\\d\\\\d)(-)?(\\\\d\\\\d)(T)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(\\\\.\\\\d+)?(Z|([+-])(\\\\d\\\\d)(:)?(\\\\d\\\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\\\d{4})(-)?(\\\\d\\\\d)(-)?(\\\\d\\\\d)(T)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(\\\\.\\\\d+)?(Z|([+-])(\\\\d\\\\d)(:)?(\\\\d\\\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}');

},{}],"dUajV":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"beforeRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\\\d{4})(-)?(\\\\d\\\\d)(-)?(\\\\d\\\\d)(T)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(\\\\.\\\\d+)?(Z|([+-])(\\\\d\\\\d)(:)?(\\\\d\\\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\\\d{4})(-)?(\\\\d\\\\d)(-)?(\\\\d\\\\d)(T)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(\\\\.\\\\d+)?(Z|([+-])(\\\\d\\\\d)(:)?(\\\\d\\\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}');

},{}],"dOtJv":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"browser.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}');

},{}],"72Pwb":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"cache.json#","$schema":"http://json-schema.org/draft-06/schema#","properties":{"beforeRequest":{"oneOf":[{"type":"null"},{"$ref":"beforeRequest.json#"}]},"afterRequest":{"oneOf":[{"type":"null"},{"$ref":"afterRequest.json#"}]},"comment":{"type":"string"}}}');

},{}],"k5zvf":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"content.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["size","mimeType"],"properties":{"size":{"type":"integer"},"compression":{"type":"integer"},"mimeType":{"type":"string"},"text":{"type":"string"},"encoding":{"type":"string"},"comment":{"type":"string"}}}');

},{}],"4cfkX":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"cookie.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"path":{"type":"string"},"domain":{"type":"string"},"expires":{"type":["string","null"],"format":"date-time"},"httpOnly":{"type":"boolean"},"secure":{"type":"boolean"},"comment":{"type":"string"}}}');

},{}],"fOmDa":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"creator.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}');

},{}],"f6lBy":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"entry.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","time","request","response","cache","timings"],"properties":{"pageref":{"type":"string"},"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\\\d{4})(-)?(\\\\d\\\\d)(-)?(\\\\d\\\\d)(T)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(\\\\.\\\\d+)?(Z|([+-])(\\\\d\\\\d)(:)?(\\\\d\\\\d))"},"time":{"type":"number","min":0},"request":{"$ref":"request.json#"},"response":{"$ref":"response.json#"},"cache":{"$ref":"cache.json#"},"timings":{"$ref":"timings.json#"},"serverIPAddress":{"type":"string","oneOf":[{"format":"ipv4"},{"format":"ipv6"}]},"connection":{"type":"string"},"comment":{"type":"string"}}}');

},{}],"9elIU":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"har.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["log"],"properties":{"log":{"$ref":"log.json#"}}}');

},{}],"FomA8":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"header.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}');

},{}],"3zJej":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"log.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["version","creator","entries"],"properties":{"version":{"type":"string"},"creator":{"$ref":"creator.json#"},"browser":{"$ref":"browser.json#"},"pages":{"type":"array","items":{"$ref":"page.json#"}},"entries":{"type":"array","items":{"$ref":"entry.json#"}},"comment":{"type":"string"}}}');

},{}],"3aw9j":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"page.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","id","title","pageTimings"],"properties":{"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\\\d{4})(-)?(\\\\d\\\\d)(-)?(\\\\d\\\\d)(T)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(:)?(\\\\d\\\\d)(\\\\.\\\\d+)?(Z|([+-])(\\\\d\\\\d)(:)?(\\\\d\\\\d))"},"id":{"type":"string","unique":true},"title":{"type":"string"},"pageTimings":{"$ref":"pageTimings.json#"},"comment":{"type":"string"}}}');

},{}],"9X9CK":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"pageTimings.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","properties":{"onContentLoad":{"type":"number","min":-1},"onLoad":{"type":"number","min":-1},"comment":{"type":"string"}}}');

},{}],"6XT9B":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"postData.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["mimeType"],"properties":{"mimeType":{"type":"string"},"text":{"type":"string"},"params":{"type":"array","required":["name"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"fileName":{"type":"string"},"contentType":{"type":"string"},"comment":{"type":"string"}}},"comment":{"type":"string"}}}');

},{}],"8efyw":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"query.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}');

},{}],"6B8zH":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"request.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["method","url","httpVersion","cookies","headers","queryString","headersSize","bodySize"],"properties":{"method":{"type":"string"},"url":{"type":"string","format":"uri"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"queryString":{"type":"array","items":{"$ref":"query.json#"}},"postData":{"$ref":"postData.json#"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}');

},{}],"gb8ea":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"response.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["status","statusText","httpVersion","cookies","headers","content","redirectURL","headersSize","bodySize"],"properties":{"status":{"type":"integer"},"statusText":{"type":"string"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"content":{"$ref":"content.json#"},"redirectURL":{"type":"string"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}');

},{}],"9VUTF":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"timings.json#","$schema":"http://json-schema.org/draft-06/schema#","required":["send","wait","receive"],"properties":{"dns":{"type":"number","min":-1},"connect":{"type":"number","min":-1},"blocked":{"type":"number","min":-1},"send":{"type":"number","min":-1},"wait":{"type":"number","min":-1},"receive":{"type":"number","min":-1},"ssl":{"type":"number","min":-1},"comment":{"type":"string"}}}');

},{}],"kU3i9":[function(require,module,exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}');

},{}],"lrQRC":[function(require,module,exports) {
"use strict";
var caseless = require("99c27a7639fa356a");
var uuid = require("b49f788711d963cb");
var helpers = require("6045576b918ed3e6");
var md5 = helpers.md5;
var toBase64 = helpers.toBase64;
function Auth(request) {
    // define all public properties here
    this.request = request;
    this.hasAuth = false;
    this.sentAuth = false;
    this.bearerToken = null;
    this.user = null;
    this.pass = null;
}
Auth.prototype.basic = function(user, pass, sendImmediately) {
    var self = this;
    if (typeof user !== "string" || pass !== undefined && typeof pass !== "string") self.request.emit("error", new Error("auth() received invalid user or password"));
    self.user = user;
    self.pass = pass;
    self.hasAuth = true;
    var header = user + ":" + (pass || "");
    if (sendImmediately || typeof sendImmediately === "undefined") {
        var authHeader = "Basic " + toBase64(header);
        self.sentAuth = true;
        return authHeader;
    }
};
Auth.prototype.bearer = function(bearer, sendImmediately) {
    var self = this;
    self.bearerToken = bearer;
    self.hasAuth = true;
    if (sendImmediately || typeof sendImmediately === "undefined") {
        if (typeof bearer === "function") bearer = bearer();
        var authHeader = "Bearer " + (bearer || "");
        self.sentAuth = true;
        return authHeader;
    }
};
Auth.prototype.digest = function(method, path, authHeader) {
    // TODO: More complete implementation of RFC 2617.
    //   - handle challenge.domain
    //   - support qop="auth-int" only
    //   - handle Authentication-Info (not necessarily?)
    //   - check challenge.stale (not necessarily?)
    //   - increase nc (not necessarily?)
    // For reference:
    // http://tools.ietf.org/html/rfc2617#section-3
    // https://github.com/bagder/curl/blob/master/lib/http_digest.c
    var self = this;
    var challenge = {};
    var re = /([a-z0-9_-]+)=(?:"([^"]+)"|([a-z0-9_-]+))/gi;
    while(true){
        var match = re.exec(authHeader);
        if (!match) break;
        challenge[match[1]] = match[2] || match[3];
    }
    /**
   * RFC 2617: handle both MD5 and MD5-sess algorithms.
   *
   * If the algorithm directive's value is "MD5" or unspecified, then HA1 is
   *   HA1=MD5(username:realm:password)
   * If the algorithm directive's value is "MD5-sess", then HA1 is
   *   HA1=MD5(MD5(username:realm:password):nonce:cnonce)
   */ var ha1Compute = function(algorithm, user, realm, pass, nonce, cnonce) {
        var ha1 = md5(user + ":" + realm + ":" + pass);
        if (algorithm && algorithm.toLowerCase() === "md5-sess") return md5(ha1 + ":" + nonce + ":" + cnonce);
        else return ha1;
    };
    var qop = /(^|,)\s*auth\s*($|,)/.test(challenge.qop) && "auth";
    var nc = qop && "00000001";
    var cnonce = qop && uuid().replace(/-/g, "");
    var ha1 = ha1Compute(challenge.algorithm, self.user, challenge.realm, self.pass, challenge.nonce, cnonce);
    var ha2 = md5(method + ":" + path);
    var digestResponse = qop ? md5(ha1 + ":" + challenge.nonce + ":" + nc + ":" + cnonce + ":" + qop + ":" + ha2) : md5(ha1 + ":" + challenge.nonce + ":" + ha2);
    var authValues = {
        username: self.user,
        realm: challenge.realm,
        nonce: challenge.nonce,
        uri: path,
        qop: qop,
        response: digestResponse,
        nc: nc,
        cnonce: cnonce,
        algorithm: challenge.algorithm,
        opaque: challenge.opaque
    };
    authHeader = [];
    for(var k in authValues)if (authValues[k]) {
        if (k === "qop" || k === "nc" || k === "algorithm") authHeader.push(k + "=" + authValues[k]);
        else authHeader.push(k + '="' + authValues[k] + '"');
    }
    authHeader = "Digest " + authHeader.join(", ");
    self.sentAuth = true;
    return authHeader;
};
Auth.prototype.onRequest = function(user, pass, sendImmediately, bearer) {
    var self = this;
    var request = self.request;
    var authHeader;
    if (bearer === undefined && user === undefined) self.request.emit("error", new Error("no auth mechanism defined"));
    else if (bearer !== undefined) authHeader = self.bearer(bearer, sendImmediately);
    else authHeader = self.basic(user, pass, sendImmediately);
    if (authHeader) request.setHeader("authorization", authHeader);
};
Auth.prototype.onResponse = function(response) {
    var self = this;
    var request = self.request;
    if (!self.hasAuth || self.sentAuth) return null;
    var c = caseless(response.headers);
    var authHeader = c.get("www-authenticate");
    var authVerb = authHeader && authHeader.split(" ")[0].toLowerCase();
    request.debug("reauth", authVerb);
    switch(authVerb){
        case "basic":
            return self.basic(self.user, self.pass, true);
        case "bearer":
            return self.bearer(self.bearerToken, true);
        case "digest":
            return self.digest(request.method, request.path, authHeader);
    }
};
exports.Auth = Auth;

},{"99c27a7639fa356a":"bFaGJ","b49f788711d963cb":"1Bmhi","6045576b918ed3e6":"37SAC"}],"3JiAi":[function(require,module,exports) {
"use strict";
var url = require("42423338e4073995");
var qs = require("8f72a6d21f0e542");
var caseless = require("b06aeafd670f6518");
var uuid = require("c73a078420472cd6");
var oauth = require("6000d1c4456e4219");
var crypto = require("91c953d2944e4699");
var Buffer = require("753753993d538465").Buffer;
function OAuth(request) {
    this.request = request;
    this.params = null;
}
OAuth.prototype.buildParams = function(_oauth, uri, method, query, form, qsLib) {
    var oa = {};
    for(var i in _oauth)oa["oauth_" + i] = _oauth[i];
    if (!oa.oauth_version) oa.oauth_version = "1.0";
    if (!oa.oauth_timestamp) oa.oauth_timestamp = Math.floor(Date.now() / 1000).toString();
    if (!oa.oauth_nonce) oa.oauth_nonce = uuid().replace(/-/g, "");
    if (!oa.oauth_signature_method) oa.oauth_signature_method = "HMAC-SHA1";
    var consumer_secret_or_private_key = oa.oauth_consumer_secret || oa.oauth_private_key // eslint-disable-line camelcase
    ;
    delete oa.oauth_consumer_secret;
    delete oa.oauth_private_key;
    var token_secret = oa.oauth_token_secret // eslint-disable-line camelcase
    ;
    delete oa.oauth_token_secret;
    var realm = oa.oauth_realm;
    delete oa.oauth_realm;
    delete oa.oauth_transport_method;
    var baseurl = uri.protocol + "//" + uri.host + uri.pathname;
    var params = qsLib.parse([].concat(query, form, qsLib.stringify(oa)).join("&"));
    oa.oauth_signature = oauth.sign(oa.oauth_signature_method, method, baseurl, params, consumer_secret_or_private_key, token_secret // eslint-disable-line camelcase
    );
    if (realm) oa.realm = realm;
    return oa;
};
OAuth.prototype.buildBodyHash = function(_oauth, body) {
    if ([
        "HMAC-SHA1",
        "RSA-SHA1"
    ].indexOf(_oauth.signature_method || "HMAC-SHA1") < 0) this.request.emit("error", new Error("oauth: " + _oauth.signature_method + " signature_method not supported with body_hash signing."));
    var shasum = crypto.createHash("sha1");
    shasum.update(body || "");
    var sha1 = shasum.digest("hex");
    return Buffer.from(sha1, "hex").toString("base64");
};
OAuth.prototype.concatParams = function(oa, sep, wrap) {
    wrap = wrap || "";
    var params = Object.keys(oa).filter(function(i) {
        return i !== "realm" && i !== "oauth_signature";
    }).sort();
    if (oa.realm) params.splice(0, 0, "realm");
    params.push("oauth_signature");
    return params.map(function(i) {
        return i + "=" + wrap + oauth.rfc3986(oa[i]) + wrap;
    }).join(sep);
};
OAuth.prototype.onRequest = function(_oauth) {
    var self = this;
    self.params = _oauth;
    var uri = self.request.uri || {};
    var method = self.request.method || "";
    var headers = caseless(self.request.headers);
    var body = self.request.body || "";
    var qsLib = self.request.qsLib || qs;
    var form;
    var query;
    var contentType = headers.get("content-type") || "";
    var formContentType = "application/x-www-form-urlencoded";
    var transport = _oauth.transport_method || "header";
    if (contentType.slice(0, formContentType.length) === formContentType) {
        contentType = formContentType;
        form = body;
    }
    if (uri.query) query = uri.query;
    if (transport === "body" && (method !== "POST" || contentType !== formContentType)) self.request.emit("error", new Error("oauth: transport_method of body requires POST and content-type " + formContentType));
    if (!form && typeof _oauth.body_hash === "boolean") _oauth.body_hash = self.buildBodyHash(_oauth, self.request.body.toString());
    var oa = self.buildParams(_oauth, uri, method, query, form, qsLib);
    switch(transport){
        case "header":
            self.request.setHeader("Authorization", "OAuth " + self.concatParams(oa, ",", '"'));
            break;
        case "query":
            var href = self.request.uri.href += (query ? "&" : "?") + self.concatParams(oa, "&");
            self.request.uri = url.parse(href);
            self.request.path = self.request.uri.path;
            break;
        case "body":
            self.request.body = (form ? form + "&" : "") + self.concatParams(oa, "&");
            break;
        default:
            self.request.emit("error", new Error("oauth: transport_method invalid"));
    }
};
exports.OAuth = OAuth;

},{"42423338e4073995":"eSLai","8f72a6d21f0e542":"k5Twq","b06aeafd670f6518":"bFaGJ","c73a078420472cd6":"1Bmhi","6000d1c4456e4219":"b31S9","91c953d2944e4699":"8Nkdo","753753993d538465":"fFdLZ"}],"b31S9":[function(require,module,exports) {
var crypto = require("4c0bf7b4e0e8532e");
function sha(key, body, algorithm) {
    return crypto.createHmac(algorithm, key).update(body).digest("base64");
}
function rsa(key, body) {
    return crypto.createSign("RSA-SHA1").update(body).sign(key, "base64");
}
function rfc3986(str) {
    return encodeURIComponent(str).replace(/!/g, "%21").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/'/g, "%27");
}
// Maps object to bi-dimensional array
// Converts { foo: 'A', bar: [ 'b', 'B' ]} to
// [ ['foo', 'A'], ['bar', 'b'], ['bar', 'B'] ]
function map(obj) {
    var key, val, arr = [];
    for(key in obj){
        val = obj[key];
        if (Array.isArray(val)) for(var i = 0; i < val.length; i++)arr.push([
            key,
            val[i]
        ]);
        else if (typeof val === "object") for(var prop in val)arr.push([
            key + "[" + prop + "]",
            val[prop]
        ]);
        else arr.push([
            key,
            val
        ]);
    }
    return arr;
}
// Compare function for sort
function compare(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function generateBase(httpMethod, base_uri, params) {
    // adapted from https://dev.twitter.com/docs/auth/oauth and 
    // https://dev.twitter.com/docs/auth/creating-signature
    // Parameter normalization
    // http://tools.ietf.org/html/rfc5849#section-3.4.1.3.2
    var normalized = map(params)// 1.  First, the name and value of each parameter are encoded
    .map(function(p) {
        return [
            rfc3986(p[0]),
            rfc3986(p[1] || "")
        ];
    })// 2.  The parameters are sorted by name, using ascending byte value
    //     ordering.  If two or more parameters share the same name, they
    //     are sorted by their value.
    .sort(function(a, b) {
        return compare(a[0], b[0]) || compare(a[1], b[1]);
    })// 3.  The name of each parameter is concatenated to its corresponding
    //     value using an "=" character (ASCII code 61) as a separator, even
    //     if the value is empty.
    .map(function(p) {
        return p.join("=");
    })// 4.  The sorted name/value pairs are concatenated together into a
    //     single string by using an "&" character (ASCII code 38) as
    //     separator.
    .join("&");
    var base = [
        rfc3986(httpMethod ? httpMethod.toUpperCase() : "GET"),
        rfc3986(base_uri),
        rfc3986(normalized)
    ].join("&");
    return base;
}
function hmacsign(httpMethod, base_uri, params, consumer_secret, token_secret) {
    var base = generateBase(httpMethod, base_uri, params);
    var key = [
        consumer_secret || "",
        token_secret || ""
    ].map(rfc3986).join("&");
    return sha(key, base, "sha1");
}
function hmacsign256(httpMethod, base_uri, params, consumer_secret, token_secret) {
    var base = generateBase(httpMethod, base_uri, params);
    var key = [
        consumer_secret || "",
        token_secret || ""
    ].map(rfc3986).join("&");
    return sha(key, base, "sha256");
}
function rsasign(httpMethod, base_uri, params, private_key, token_secret) {
    var base = generateBase(httpMethod, base_uri, params);
    var key = private_key || "";
    return rsa(key, base);
}
function plaintext(consumer_secret, token_secret) {
    var key = [
        consumer_secret || "",
        token_secret || ""
    ].map(rfc3986).join("&");
    return key;
}
function sign(signMethod, httpMethod, base_uri, params, consumer_secret, token_secret) {
    var method;
    var skipArgs = 1;
    switch(signMethod){
        case "RSA-SHA1":
            method = rsasign;
            break;
        case "HMAC-SHA1":
            method = hmacsign;
            break;
        case "HMAC-SHA256":
            method = hmacsign256;
            break;
        case "PLAINTEXT":
            method = plaintext;
            skipArgs = 4;
            break;
        default:
            throw new Error("Signature method not supported: " + signMethod);
    }
    return method.apply(null, [].slice.call(arguments, skipArgs));
}
exports.hmacsign = hmacsign;
exports.hmacsign256 = hmacsign256;
exports.rsasign = rsasign;
exports.plaintext = plaintext;
exports.sign = sign;
exports.rfc3986 = rfc3986;
exports.generateBase = generateBase;

},{"4c0bf7b4e0e8532e":"8Nkdo"}],"cHBOz":[function(require,module,exports) {
"use strict";
var crypto = require("cbd213f178c98210");
function randomString(size) {
    var bits = (size + 1) * 6;
    var buffer = crypto.randomBytes(Math.ceil(bits / 8));
    var string = buffer.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    return string.slice(0, size);
}
function calculatePayloadHash(payload, algorithm, contentType) {
    var hash = crypto.createHash(algorithm);
    hash.update("hawk.1.payload\n");
    hash.update((contentType ? contentType.split(";")[0].trim().toLowerCase() : "") + "\n");
    hash.update(payload || "");
    hash.update("\n");
    return hash.digest("base64");
}
exports.calculateMac = function(credentials, opts) {
    var normalized = "hawk.1.header\n" + opts.ts + "\n" + opts.nonce + "\n" + (opts.method || "").toUpperCase() + "\n" + opts.resource + "\n" + opts.host.toLowerCase() + "\n" + opts.port + "\n" + (opts.hash || "") + "\n";
    if (opts.ext) normalized = normalized + opts.ext.replace("\\", "\\\\").replace("\n", "\\n");
    normalized = normalized + "\n";
    if (opts.app) normalized = normalized + opts.app + "\n" + (opts.dlg || "") + "\n";
    var hmac = crypto.createHmac(credentials.algorithm, credentials.key).update(normalized);
    var digest = hmac.digest("base64");
    return digest;
};
exports.header = function(uri, method, opts) {
    var timestamp = opts.timestamp || Math.floor((Date.now() + (opts.localtimeOffsetMsec || 0)) / 1000);
    var credentials = opts.credentials;
    if (!credentials || !credentials.id || !credentials.key || !credentials.algorithm) return "";
    if ([
        "sha1",
        "sha256"
    ].indexOf(credentials.algorithm) === -1) return "";
    var artifacts = {
        ts: timestamp,
        nonce: opts.nonce || randomString(6),
        method: method,
        resource: uri.pathname + (uri.search || ""),
        host: uri.hostname,
        port: uri.port || (uri.protocol === "http:" ? 80 : 443),
        hash: opts.hash,
        ext: opts.ext,
        app: opts.app,
        dlg: opts.dlg
    };
    if (!artifacts.hash && (opts.payload || opts.payload === "")) artifacts.hash = calculatePayloadHash(opts.payload, credentials.algorithm, opts.contentType);
    var mac = exports.calculateMac(credentials, artifacts);
    var hasExt = artifacts.ext !== null && artifacts.ext !== undefined && artifacts.ext !== "";
    var header = 'Hawk id="' + credentials.id + '", ts="' + artifacts.ts + '", nonce="' + artifacts.nonce + (artifacts.hash ? '", hash="' + artifacts.hash : "") + (hasExt ? '", ext="' + artifacts.ext.replace(/\\/g, "\\\\").replace(/"/g, '\\"') : "") + '", mac="' + mac + '"';
    if (artifacts.app) header = header + ', app="' + artifacts.app + (artifacts.dlg ? '", dlg="' + artifacts.dlg : "") + '"';
    return header;
};

},{"cbd213f178c98210":"8Nkdo"}],"lAyLo":[function(require,module,exports) {
"use strict";
var uuid = require("b54179c1345a957c");
var CombinedStream = require("ddfd264c4b8db86f");
var isstream = require("2b563cbcf83f162a");
var Buffer = require("91996b154eceb56b").Buffer;
function Multipart(request) {
    this.request = request;
    this.boundary = uuid();
    this.chunked = false;
    this.body = null;
}
Multipart.prototype.isChunked = function(options) {
    var self = this;
    var chunked = false;
    var parts = options.data || options;
    if (!parts.forEach) self.request.emit("error", new Error("Argument error, options.multipart."));
    if (options.chunked !== undefined) chunked = options.chunked;
    if (self.request.getHeader("transfer-encoding") === "chunked") chunked = true;
    if (!chunked) parts.forEach(function(part) {
        if (typeof part.body === "undefined") self.request.emit("error", new Error("Body attribute missing in multipart."));
        if (isstream(part.body)) chunked = true;
    });
    return chunked;
};
Multipart.prototype.setHeaders = function(chunked) {
    var self = this;
    if (chunked && !self.request.hasHeader("transfer-encoding")) self.request.setHeader("transfer-encoding", "chunked");
    var header = self.request.getHeader("content-type");
    if (!header || header.indexOf("multipart") === -1) self.request.setHeader("content-type", "multipart/related; boundary=" + self.boundary);
    else if (header.indexOf("boundary") !== -1) self.boundary = header.replace(/.*boundary=([^\s;]+).*/, "$1");
    else self.request.setHeader("content-type", header + "; boundary=" + self.boundary);
};
Multipart.prototype.build = function(parts, chunked) {
    var self = this;
    var body = chunked ? new CombinedStream() : [];
    function add(part) {
        if (typeof part === "number") part = part.toString();
        return chunked ? body.append(part) : body.push(Buffer.from(part));
    }
    if (self.request.preambleCRLF) add("\r\n");
    parts.forEach(function(part) {
        var preamble = "--" + self.boundary + "\r\n";
        Object.keys(part).forEach(function(key) {
            if (key === "body") return;
            preamble += key + ": " + part[key] + "\r\n";
        });
        preamble += "\r\n";
        add(preamble);
        add(part.body);
        add("\r\n");
    });
    add("--" + self.boundary + "--");
    if (self.request.postambleCRLF) add("\r\n");
    return body;
};
Multipart.prototype.onRequest = function(options) {
    var self = this;
    var chunked = self.isChunked(options);
    var parts = options.data || options;
    self.setHeaders(chunked);
    self.chunked = chunked;
    self.body = self.build(parts, chunked);
};
exports.Multipart = Multipart;

},{"b54179c1345a957c":"1Bmhi","ddfd264c4b8db86f":"9Dk5p","2b563cbcf83f162a":"gQPoJ","91996b154eceb56b":"fFdLZ"}],"9Dk5p":[function(require,module,exports) {
var Buffer = require("11e581196c885707").Buffer;
var util = require("f6e2af6595be8bf4");
var Stream = require("97e107eea2f5fe9e").Stream;
var DelayedStream = require("8007fd6a9dc38c89");
module.exports = CombinedStream;
function CombinedStream() {
    this.writable = false;
    this.readable = true;
    this.dataSize = 0;
    this.maxDataSize = 2097152;
    this.pauseStreams = true;
    this._released = false;
    this._streams = [];
    this._currentStream = null;
    this._insideLoop = false;
    this._pendingNext = false;
}
util.inherits(CombinedStream, Stream);
CombinedStream.create = function(options) {
    var combinedStream = new this();
    options = options || {};
    for(var option in options)combinedStream[option] = options[option];
    return combinedStream;
};
CombinedStream.isStreamLike = function(stream) {
    return typeof stream !== "function" && typeof stream !== "string" && typeof stream !== "boolean" && typeof stream !== "number" && !Buffer.isBuffer(stream);
};
CombinedStream.prototype.append = function(stream) {
    var isStreamLike = CombinedStream.isStreamLike(stream);
    if (isStreamLike) {
        if (!(stream instanceof DelayedStream)) {
            var newStream = DelayedStream.create(stream, {
                maxDataSize: Infinity,
                pauseStream: this.pauseStreams
            });
            stream.on("data", this._checkDataSize.bind(this));
            stream = newStream;
        }
        this._handleErrors(stream);
        if (this.pauseStreams) stream.pause();
    }
    this._streams.push(stream);
    return this;
};
CombinedStream.prototype.pipe = function(dest, options) {
    Stream.prototype.pipe.call(this, dest, options);
    this.resume();
    return dest;
};
CombinedStream.prototype._getNext = function() {
    this._currentStream = null;
    if (this._insideLoop) {
        this._pendingNext = true;
        return; // defer call
    }
    this._insideLoop = true;
    try {
        do {
            this._pendingNext = false;
            this._realGetNext();
        }while (this._pendingNext);
    } finally{
        this._insideLoop = false;
    }
};
CombinedStream.prototype._realGetNext = function() {
    var stream = this._streams.shift();
    if (typeof stream == "undefined") {
        this.end();
        return;
    }
    if (typeof stream !== "function") {
        this._pipeNext(stream);
        return;
    }
    var getStream = stream;
    getStream((function(stream) {
        var isStreamLike = CombinedStream.isStreamLike(stream);
        if (isStreamLike) {
            stream.on("data", this._checkDataSize.bind(this));
            this._handleErrors(stream);
        }
        this._pipeNext(stream);
    }).bind(this));
};
CombinedStream.prototype._pipeNext = function(stream) {
    this._currentStream = stream;
    var isStreamLike = CombinedStream.isStreamLike(stream);
    if (isStreamLike) {
        stream.on("end", this._getNext.bind(this));
        stream.pipe(this, {
            end: false
        });
        return;
    }
    var value = stream;
    this.write(value);
    this._getNext();
};
CombinedStream.prototype._handleErrors = function(stream) {
    var self = this;
    stream.on("error", function(err) {
        self._emitError(err);
    });
};
CombinedStream.prototype.write = function(data) {
    this.emit("data", data);
};
CombinedStream.prototype.pause = function() {
    if (!this.pauseStreams) return;
    if (this.pauseStreams && this._currentStream && typeof this._currentStream.pause == "function") this._currentStream.pause();
    this.emit("pause");
};
CombinedStream.prototype.resume = function() {
    if (!this._released) {
        this._released = true;
        this.writable = true;
        this._getNext();
    }
    if (this.pauseStreams && this._currentStream && typeof this._currentStream.resume == "function") this._currentStream.resume();
    this.emit("resume");
};
CombinedStream.prototype.end = function() {
    this._reset();
    this.emit("end");
};
CombinedStream.prototype.destroy = function() {
    this._reset();
    this.emit("close");
};
CombinedStream.prototype._reset = function() {
    this.writable = false;
    this._streams = [];
    this._currentStream = null;
};
CombinedStream.prototype._checkDataSize = function() {
    this._updateDataSize();
    if (this.dataSize <= this.maxDataSize) return;
    var message = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
    this._emitError(new Error(message));
};
CombinedStream.prototype._updateDataSize = function() {
    this.dataSize = 0;
    var self = this;
    this._streams.forEach(function(stream) {
        if (!stream.dataSize) return;
        self.dataSize += stream.dataSize;
    });
    if (this._currentStream && this._currentStream.dataSize) this.dataSize += this._currentStream.dataSize;
};
CombinedStream.prototype._emitError = function(err) {
    this._reset();
    this.emit("error", err);
};

},{"11e581196c885707":"8EcTH","f6e2af6595be8bf4":"dJawj","97e107eea2f5fe9e":"4ooMZ","8007fd6a9dc38c89":"lU0ga"}],"lU0ga":[function(require,module,exports) {
var Stream = require("da94dca2b60f3c0").Stream;
var util = require("5e2ba8c338a0b153");
module.exports = DelayedStream;
function DelayedStream() {
    this.source = null;
    this.dataSize = 0;
    this.maxDataSize = 1048576;
    this.pauseStream = true;
    this._maxDataSizeExceeded = false;
    this._released = false;
    this._bufferedEvents = [];
}
util.inherits(DelayedStream, Stream);
DelayedStream.create = function(source, options) {
    var delayedStream = new this();
    options = options || {};
    for(var option in options)delayedStream[option] = options[option];
    delayedStream.source = source;
    var realEmit = source.emit;
    source.emit = function() {
        delayedStream._handleEmit(arguments);
        return realEmit.apply(source, arguments);
    };
    source.on("error", function() {});
    if (delayedStream.pauseStream) source.pause();
    return delayedStream;
};
Object.defineProperty(DelayedStream.prototype, "readable", {
    configurable: true,
    enumerable: true,
    get: function() {
        return this.source.readable;
    }
});
DelayedStream.prototype.setEncoding = function() {
    return this.source.setEncoding.apply(this.source, arguments);
};
DelayedStream.prototype.resume = function() {
    if (!this._released) this.release();
    this.source.resume();
};
DelayedStream.prototype.pause = function() {
    this.source.pause();
};
DelayedStream.prototype.release = function() {
    this._released = true;
    this._bufferedEvents.forEach((function(args) {
        this.emit.apply(this, args);
    }).bind(this));
    this._bufferedEvents = [];
};
DelayedStream.prototype.pipe = function() {
    var r = Stream.prototype.pipe.apply(this, arguments);
    this.resume();
    return r;
};
DelayedStream.prototype._handleEmit = function(args) {
    if (this._released) {
        this.emit.apply(this, args);
        return;
    }
    if (args[0] === "data") {
        this.dataSize += args[1].length;
        this._checkIfMaxDataSizeExceeded();
    }
    this._bufferedEvents.push(args);
};
DelayedStream.prototype._checkIfMaxDataSizeExceeded = function() {
    if (this._maxDataSizeExceeded) return;
    if (this.dataSize <= this.maxDataSize) return;
    this._maxDataSizeExceeded = true;
    var message = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
    this.emit("error", new Error(message));
};

},{"da94dca2b60f3c0":"4ooMZ","5e2ba8c338a0b153":"dJawj"}],"i5geS":[function(require,module,exports) {
"use strict";
var url = require("28c7fb5918a17771");
var isUrl = /^https?:/;
function Redirect(request) {
    this.request = request;
    this.followRedirect = true;
    this.followRedirects = true;
    this.followAllRedirects = false;
    this.followOriginalHttpMethod = false;
    this.allowRedirect = function() {
        return true;
    };
    this.maxRedirects = 10;
    this.redirects = [];
    this.redirectsFollowed = 0;
    this.removeRefererHeader = false;
}
Redirect.prototype.onRequest = function(options) {
    var self = this;
    if (options.maxRedirects !== undefined) self.maxRedirects = options.maxRedirects;
    if (typeof options.followRedirect === "function") self.allowRedirect = options.followRedirect;
    if (options.followRedirect !== undefined) self.followRedirects = !!options.followRedirect;
    if (options.followAllRedirects !== undefined) self.followAllRedirects = options.followAllRedirects;
    if (self.followRedirects || self.followAllRedirects) self.redirects = self.redirects || [];
    if (options.removeRefererHeader !== undefined) self.removeRefererHeader = options.removeRefererHeader;
    if (options.followOriginalHttpMethod !== undefined) self.followOriginalHttpMethod = options.followOriginalHttpMethod;
};
Redirect.prototype.redirectTo = function(response) {
    var self = this;
    var request = self.request;
    var redirectTo = null;
    if (response.statusCode >= 300 && response.statusCode < 400 && response.caseless.has("location")) {
        var location = response.caseless.get("location");
        request.debug("redirect", location);
        if (self.followAllRedirects) redirectTo = location;
        else if (self.followRedirects) switch(request.method){
            case "PATCH":
            case "PUT":
            case "POST":
            case "DELETE":
                break;
            default:
                redirectTo = location;
                break;
        }
    } else if (response.statusCode === 401) {
        var authHeader = request._auth.onResponse(response);
        if (authHeader) {
            request.setHeader("authorization", authHeader);
            redirectTo = request.uri;
        }
    }
    return redirectTo;
};
Redirect.prototype.onResponse = function(response) {
    var self = this;
    var request = self.request;
    var redirectTo = self.redirectTo(response);
    if (!redirectTo || !self.allowRedirect.call(request, response)) return false;
    request.debug("redirect to", redirectTo);
    // ignore any potential response body.  it cannot possibly be useful
    // to us at this point.
    // response.resume should be defined, but check anyway before calling. Workaround for browserify.
    if (response.resume) response.resume();
    if (self.redirectsFollowed >= self.maxRedirects) {
        request.emit("error", new Error("Exceeded maxRedirects. Probably stuck in a redirect loop " + request.uri.href));
        return false;
    }
    self.redirectsFollowed += 1;
    if (!isUrl.test(redirectTo)) redirectTo = url.resolve(request.uri.href, redirectTo);
    var uriPrev = request.uri;
    request.uri = url.parse(redirectTo);
    // handle the case where we change protocol from https to http or vice versa
    if (request.uri.protocol !== uriPrev.protocol) delete request.agent;
    self.redirects.push({
        statusCode: response.statusCode,
        redirectUri: redirectTo
    });
    if (self.followAllRedirects && request.method !== "HEAD" && response.statusCode !== 401 && response.statusCode !== 307) request.method = self.followOriginalHttpMethod ? request.method : "GET";
    // request.method = 'GET' // Force all redirects to use GET || commented out fixes #215
    delete request.src;
    delete request.req;
    delete request._started;
    if (response.statusCode !== 401 && response.statusCode !== 307) {
        // Remove parameters from the previous response, unless this is the second request
        // for a server that requires digest authentication.
        delete request.body;
        delete request._form;
        if (request.headers) {
            request.removeHeader("host");
            request.removeHeader("content-type");
            request.removeHeader("content-length");
            if (request.uri.hostname !== request.originalHost.split(":")[0]) // Remove authorization if changing hostnames (but not if just
            // changing ports or protocols).  This matches the behavior of curl:
            // https://github.com/bagder/curl/blob/6beb0eee/lib/http.c#L710
            request.removeHeader("authorization");
        }
    }
    if (!self.removeRefererHeader) request.setHeader("referer", uriPrev.href);
    request.emit("redirect");
    request.init();
    return true;
};
exports.Redirect = Redirect;

},{"28c7fb5918a17771":"eSLai"}],"uwodf":[function(require,module,exports) {
"use strict";
var url = require("54c16dd8e6b06476");
var tunnel = require("90f3470131977d3e");
var defaultProxyHeaderWhiteList = [
    "accept",
    "accept-charset",
    "accept-encoding",
    "accept-language",
    "accept-ranges",
    "cache-control",
    "content-encoding",
    "content-language",
    "content-location",
    "content-md5",
    "content-range",
    "content-type",
    "connection",
    "date",
    "expect",
    "max-forwards",
    "pragma",
    "referer",
    "te",
    "user-agent",
    "via"
];
var defaultProxyHeaderExclusiveList = [
    "proxy-authorization"
];
function constructProxyHost(uriObject) {
    var port = uriObject.port;
    var protocol = uriObject.protocol;
    var proxyHost = uriObject.hostname + ":";
    if (port) proxyHost += port;
    else if (protocol === "https:") proxyHost += "443";
    else proxyHost += "80";
    return proxyHost;
}
function constructProxyHeaderWhiteList(headers, proxyHeaderWhiteList) {
    var whiteList = proxyHeaderWhiteList.reduce(function(set, header) {
        set[header.toLowerCase()] = true;
        return set;
    }, {});
    return Object.keys(headers).filter(function(header) {
        return whiteList[header.toLowerCase()];
    }).reduce(function(set, header) {
        set[header] = headers[header];
        return set;
    }, {});
}
function constructTunnelOptions(request, proxyHeaders) {
    var proxy = request.proxy;
    var tunnelOptions = {
        proxy: {
            host: proxy.hostname,
            port: +proxy.port,
            proxyAuth: proxy.auth,
            headers: proxyHeaders
        },
        headers: request.headers,
        ca: request.ca,
        cert: request.cert,
        key: request.key,
        passphrase: request.passphrase,
        pfx: request.pfx,
        ciphers: request.ciphers,
        rejectUnauthorized: request.rejectUnauthorized,
        secureOptions: request.secureOptions,
        secureProtocol: request.secureProtocol
    };
    return tunnelOptions;
}
function constructTunnelFnName(uri, proxy) {
    var uriProtocol = uri.protocol === "https:" ? "https" : "http";
    var proxyProtocol = proxy.protocol === "https:" ? "Https" : "Http";
    return [
        uriProtocol,
        proxyProtocol
    ].join("Over");
}
function getTunnelFn(request) {
    var uri = request.uri;
    var proxy = request.proxy;
    var tunnelFnName = constructTunnelFnName(uri, proxy);
    return tunnel[tunnelFnName];
}
function Tunnel(request) {
    this.request = request;
    this.proxyHeaderWhiteList = defaultProxyHeaderWhiteList;
    this.proxyHeaderExclusiveList = [];
    if (typeof request.tunnel !== "undefined") this.tunnelOverride = request.tunnel;
}
Tunnel.prototype.isEnabled = function() {
    var self = this;
    var request = self.request;
    // Tunnel HTTPS by default. Allow the user to override this setting.
    // If self.tunnelOverride is set (the user specified a value), use it.
    if (typeof self.tunnelOverride !== "undefined") return self.tunnelOverride;
    // If the destination is HTTPS, tunnel.
    if (request.uri.protocol === "https:") return true;
    // Otherwise, do not use tunnel.
    return false;
};
Tunnel.prototype.setup = function(options) {
    var self = this;
    var request = self.request;
    options = options || {};
    if (typeof request.proxy === "string") request.proxy = url.parse(request.proxy);
    if (!request.proxy || !request.tunnel) return false;
    // Setup Proxy Header Exclusive List and White List
    if (options.proxyHeaderWhiteList) self.proxyHeaderWhiteList = options.proxyHeaderWhiteList;
    if (options.proxyHeaderExclusiveList) self.proxyHeaderExclusiveList = options.proxyHeaderExclusiveList;
    var proxyHeaderExclusiveList = self.proxyHeaderExclusiveList.concat(defaultProxyHeaderExclusiveList);
    var proxyHeaderWhiteList = self.proxyHeaderWhiteList.concat(proxyHeaderExclusiveList);
    // Setup Proxy Headers and Proxy Headers Host
    // Only send the Proxy White Listed Header names
    var proxyHeaders = constructProxyHeaderWhiteList(request.headers, proxyHeaderWhiteList);
    proxyHeaders.host = constructProxyHost(request.uri);
    proxyHeaderExclusiveList.forEach(request.removeHeader, request);
    // Set Agent from Tunnel Data
    var tunnelFn = getTunnelFn(request);
    var tunnelOptions = constructTunnelOptions(request, proxyHeaders);
    request.agent = tunnelFn(tunnelOptions);
    return true;
};
Tunnel.defaultProxyHeaderWhiteList = defaultProxyHeaderWhiteList;
Tunnel.defaultProxyHeaderExclusiveList = defaultProxyHeaderExclusiveList;
exports.Tunnel = Tunnel;

},{"54c16dd8e6b06476":"eSLai","90f3470131977d3e":"3wjQz"}],"3wjQz":[function(require,module,exports) {
var process = require("1540a59a7b2d3a4f");
"use strict";
var net = require("5cc3ae7eb1c886b5"), tls = require("514f492d0aa8428c"), http = require("f7ab41fcab294145"), https = require("a0a42250bfeff57b"), events = require("5cf4617386ac1726"), assert = require("92df91cb3eee35a9"), util = require("7415db5247d9251a"), Buffer = require("30fa6f2bc25750d8").Buffer;
exports.httpOverHttp = httpOverHttp;
exports.httpsOverHttp = httpsOverHttp;
exports.httpOverHttps = httpOverHttps;
exports.httpsOverHttps = httpsOverHttps;
function httpOverHttp(options) {
    var agent = new TunnelingAgent(options);
    agent.request = http.request;
    return agent;
}
function httpsOverHttp(options) {
    var agent = new TunnelingAgent(options);
    agent.request = http.request;
    agent.createSocket = createSecureSocket;
    agent.defaultPort = 443;
    return agent;
}
function httpOverHttps(options) {
    var agent = new TunnelingAgent(options);
    agent.request = https.request;
    return agent;
}
function httpsOverHttps(options) {
    var agent = new TunnelingAgent(options);
    agent.request = https.request;
    agent.createSocket = createSecureSocket;
    agent.defaultPort = 443;
    return agent;
}
function TunnelingAgent(options) {
    var self = this;
    self.options = options || {};
    self.proxyOptions = self.options.proxy || {};
    self.maxSockets = self.options.maxSockets || http.Agent.defaultMaxSockets;
    self.requests = [];
    self.sockets = [];
    self.on("free", function onFree(socket, host, port) {
        for(var i = 0, len = self.requests.length; i < len; ++i){
            var pending = self.requests[i];
            if (pending.host === host && pending.port === port) {
                // Detect the request to connect same origin server,
                // reuse the connection.
                self.requests.splice(i, 1);
                pending.request.onSocket(socket);
                return;
            }
        }
        socket.destroy();
        self.removeSocket(socket);
    });
}
util.inherits(TunnelingAgent, events.EventEmitter);
TunnelingAgent.prototype.addRequest = function addRequest(req, options) {
    var self = this;
    // Legacy API: addRequest(req, host, port, path)
    if (typeof options === "string") options = {
        host: options,
        port: arguments[2],
        path: arguments[3]
    };
    if (self.sockets.length >= this.maxSockets) {
        // We are over limit so we'll add it to the queue.
        self.requests.push({
            host: options.host,
            port: options.port,
            request: req
        });
        return;
    }
    // If we are under maxSockets create a new one.
    self.createConnection({
        host: options.host,
        port: options.port,
        request: req
    });
};
TunnelingAgent.prototype.createConnection = function createConnection(pending) {
    var self = this;
    self.createSocket(pending, function(socket) {
        socket.on("free", onFree);
        socket.on("close", onCloseOrRemove);
        socket.on("agentRemove", onCloseOrRemove);
        pending.request.onSocket(socket);
        function onFree() {
            self.emit("free", socket, pending.host, pending.port);
        }
        function onCloseOrRemove(err) {
            self.removeSocket(socket);
            socket.removeListener("free", onFree);
            socket.removeListener("close", onCloseOrRemove);
            socket.removeListener("agentRemove", onCloseOrRemove);
        }
    });
};
TunnelingAgent.prototype.createSocket = function createSocket(options, cb) {
    var self = this;
    var placeholder = {};
    self.sockets.push(placeholder);
    var connectOptions = mergeOptions({}, self.proxyOptions, {
        method: "CONNECT",
        path: options.host + ":" + options.port,
        agent: false
    });
    if (connectOptions.proxyAuth) {
        connectOptions.headers = connectOptions.headers || {};
        connectOptions.headers["Proxy-Authorization"] = "Basic " + Buffer.from(connectOptions.proxyAuth).toString("base64");
    }
    debug("making CONNECT request");
    var connectReq = self.request(connectOptions);
    connectReq.useChunkedEncodingByDefault = false // for v0.6
    ;
    connectReq.once("response", onResponse) // for v0.6
    ;
    connectReq.once("upgrade", onUpgrade) // for v0.6
    ;
    connectReq.once("connect", onConnect) // for v0.7 or later
    ;
    connectReq.once("error", onError);
    connectReq.end();
    function onResponse(res) {
        // Very hacky. This is necessary to avoid http-parser leaks.
        res.upgrade = true;
    }
    function onUpgrade(res, socket, head) {
        // Hacky.
        process.nextTick(function() {
            onConnect(res, socket, head);
        });
    }
    function onConnect(res, socket, head) {
        connectReq.removeAllListeners();
        socket.removeAllListeners();
        if (res.statusCode === 200) {
            assert.equal(head.length, 0);
            debug("tunneling connection has established");
            self.sockets[self.sockets.indexOf(placeholder)] = socket;
            cb(socket);
        } else {
            debug("tunneling socket could not be established, statusCode=%d", res.statusCode);
            var error = new Error("tunneling socket could not be established, statusCode=" + res.statusCode);
            error.code = "ECONNRESET";
            options.request.emit("error", error);
            self.removeSocket(placeholder);
        }
    }
    function onError(cause) {
        connectReq.removeAllListeners();
        debug("tunneling socket could not be established, cause=%s\n", cause.message, cause.stack);
        var error = new Error("tunneling socket could not be established, cause=" + cause.message);
        error.code = "ECONNRESET";
        options.request.emit("error", error);
        self.removeSocket(placeholder);
    }
};
TunnelingAgent.prototype.removeSocket = function removeSocket(socket) {
    var pos = this.sockets.indexOf(socket);
    if (pos === -1) return;
    this.sockets.splice(pos, 1);
    var pending = this.requests.shift();
    if (pending) // If we have pending requests and a socket gets closed a new one
    // needs to be created to take over in the pool for the one that closed.
    this.createConnection(pending);
};
function createSecureSocket(options, cb) {
    var self = this;
    TunnelingAgent.prototype.createSocket.call(self, options, function(socket) {
        // 0 is dummy port for v0.6
        var secureSocket = tls.connect(0, mergeOptions({}, self.options, {
            servername: options.host,
            socket: socket
        }));
        self.sockets[self.sockets.indexOf(socket)] = secureSocket;
        cb(secureSocket);
    });
}
function mergeOptions(target) {
    for(var i = 1, len = arguments.length; i < len; ++i){
        var overrides = arguments[i];
        if (typeof overrides === "object") {
            var keys = Object.keys(overrides);
            for(var j = 0, keyLen = keys.length; j < keyLen; ++j){
                var k = keys[j];
                if (overrides[k] !== undefined) target[k] = overrides[k];
            }
        }
    }
    return target;
}
var debug;
debug = function() {};
exports.debug = debug // for test
;

},{"1540a59a7b2d3a4f":"g1F5c","5cc3ae7eb1c886b5":"49Rpi","514f492d0aa8428c":"49Rpi","f7ab41fcab294145":"cbdR9","a0a42250bfeff57b":"8PzwZ","5cf4617386ac1726":"gB3zd","92df91cb3eee35a9":"fsq0Y","7415db5247d9251a":"dJawj","30fa6f2bc25750d8":"fFdLZ"}],"63eDT":[function(require,module,exports) {
var process = require("1ad1fb3b65def9ed");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof process !== "undefined" && process !== null && process.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(this);

},{"1ad1fb3b65def9ed":"g1F5c"}],"6pne9":[function(require,module,exports) {
exports.endianness = function() {
    return "LE";
};
exports.hostname = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
exports.loadavg = function() {
    return [];
};
exports.uptime = function() {
    return 0;
};
exports.freemem = function() {
    return Number.MAX_VALUE;
};
exports.totalmem = function() {
    return Number.MAX_VALUE;
};
exports.cpus = function() {
    return [];
};
exports.type = function() {
    return "Browser";
};
exports.release = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
exports.networkInterfaces = exports.getNetworkInterfaces = function() {
    return {};
};
exports.arch = function() {
    return "javascript";
};
exports.platform = function() {
    return "browser";
};
exports.tmpdir = exports.tmpDir = function() {
    return "/tmp";
};
exports.EOL = "\n";
exports.homedir = function() {
    return "/";
};

},{}],"dEhb4":[function() {},{}]},["ccjB4"], "ccjB4", "parcelRequire2521")

//# sourceMappingURL=index.fa365c67.js.map
